/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 396);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(403);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(413)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(170);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(498);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(502);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(170);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(231);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["f"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = splitBsPropsAndOmit;
/* unused harmony export addStyle */
/* unused harmony export _curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(33);


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.






function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return bsClass + (variant ? '-' + variant : '');
}

var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing);

  // expose the values on the propType function for documentation
  Component.STYLES = existing;
  propType._values = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});

var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  Component.SIZES = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }
    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });

  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var header={'Accept':'application/json, text/plain, */*','Content-Type':'application/json; charset=utf-8'};var headerWithToken={'Accept':'application/json, text/plain, */*','Content-Type':'application/json; charset=utf-8'};var REST=function(){function REST(){_classCallCheck(this,REST);}_createClass(REST,null,[{key:'login',value:function login(username,password){var body={'username':username,'password':password};return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LOGIN,{method:'post',headers:header,body:JSON.stringify(body)}).then(function(res){return res.json();});}},{key:'logout',value:function logout(){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LOGOUT,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'authWithToken',value:function authWithToken(){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.TOKEN,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'getVersion',value:function getVersion(){return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.VERSION,{method:'get'}).then(function(res){return res.json();});}},{key:'requestAccount',value:function requestAccount(object){return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.REQUEST_ACCOUNT,{method:'post',headers:header,body:JSON.stringify(object)}).then(function(res){return res.json();});}},{key:'requestHelp',value:function requestHelp(object){return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.REQUEST_HELP,{method:'post',headers:header,body:JSON.stringify(object)}).then(function(res){return res.json();});}},{key:'classList',value:function classList(){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_CLASS_LIST,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'teacherClassList',value:function teacherClassList(teacherId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_TEACHER_CLASS_LIST+'?teacherId='+teacherId,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listExternalTeacher',value:function listExternalTeacher(body){headerWithToken['token']=localStorage.getItem('token');var url=__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_EXTERNAL_TEACHER+'?userId='+body.teacherId+'&firstname='+body.firstName+'&lastname='+body.lastName;return fetch(url,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'addNewClass',value:function addNewClass(data){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_NEW_CLASS,{method:'post',headers:headerWithToken,body:JSON.stringify(data)}).then(function(res){return res.json();});}},{key:'deleteClass',value:function deleteClass(object){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_CLASS+'?classId='+object,{method:'delete',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'updateClass',value:function updateClass(body){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_CLASS,{method:'put',headers:headerWithToken,body:JSON.stringify(body)}).then(function(res){return res.json();});}},{key:'listStudents',value:function listStudents(id){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_STUDENTS+'?classId='+id,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'addNewStudent',value:function addNewStudent(classId,object){var students=[];students.push(object);var body={classId:classId,students:students};headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_NEW_STUDENT,{method:'post',headers:headerWithToken,body:JSON.stringify(body)}).then(function(res){return res.json();});}},{key:'updateStudent',value:function updateStudent(student){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_STUDENT,{method:'put',headers:headerWithToken,body:JSON.stringify(student)}).then(function(res){return res;});}},{key:'transferStudent',value:function transferStudent(body){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.TRANSFER_STUDENT,{method:'post',headers:headerWithToken,body:JSON.stringify(body)}).then(function(res){return res.json;});}},{key:'transferMultipleStudents',value:function transferMultipleStudents(body){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.TRANSFER_MULTIPLE_STUDENT,{method:'post',headers:headerWithToken,body:JSON.stringify(body)}).then(function(res){return res.json;});}},{key:'deleteStudent',value:function deleteStudent(id,classId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_STUDENT+'?userId='+id+"&classId="+classId,{method:'delete',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listTeachers',value:function listTeachers(){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_TEACHERS,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listTeachersInSchool',value:function listTeachersInSchool(schoolId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_TEACHERS_IN_SCHOOL+'?schoolId='+schoolId,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'createTeacher',value:function createTeacher(body){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CREATE_TEACHER,{method:'post',headers:headerWithToken,body:JSON.stringify(body)}).then(function(res){return res.json();});}},{key:'updateTeacher',value:function updateTeacher(body){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_TEACHER,{method:'put',headers:headerWithToken,body:JSON.stringify(body)}).then(function(res){return res.json();});}},{key:'deleteTeacher',value:function deleteTeacher(id){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_TEACHER+'?userId='+id,{method:'delete',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listSchoolAdmins',value:function listSchoolAdmins(){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_SCHOOLADMINS,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'createSchoolAdmin',value:function createSchoolAdmin(body){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CREATE_SCHOOLADMIN,{method:'post',headers:headerWithToken,body:JSON.stringify(body)}).then(function(res){return res.json();});}},{key:'updateSchoolAdmin',value:function updateSchoolAdmin(body){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_SCHOOLADMIN,{method:'put',headers:headerWithToken,body:JSON.stringify(body)}).then(function(res){return res.json();});}},{key:'deleteSchoolAdmin',value:function deleteSchoolAdmin(id){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_SCHOOLADMIN+'?userId='+id,{method:'delete',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listWordMarkScore',value:function listWordMarkScore(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_WORDMARK_SCORE+'?userId='+userId,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listWordMark2Score',value:function listWordMark2Score(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_WORDMARK2_SCORE+'?userId='+userId,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listKidSpeakScore',value:function listKidSpeakScore(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_KIDSPEAK_SCORE_LIST+'?userId='+userId,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listPictureNamingScores',value:function listPictureNamingScores(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_PICTURENAMING_SCORE_LIST+'?userId='+userId,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listWordSignSayScores',value:function listWordSignSayScores(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_WORDSIGNSAY_SCORE_LIST+'?userId='+userId,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listCopyRightScores',value:function listCopyRightScores(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_COPYRIGHT_SCORE_LIST+'?userId='+userId,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listKidSignScores',value:function listKidSignScores(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_KIDSIGN_SCORE_LIST+'?userId='+userId,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listMazeScoreData',value:function listMazeScoreData(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_MAZE_SCORE_DATA+'?userId='+userId,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'getMazeScoreCount',value:function getMazeScoreCount(){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_MAZE_SCORE_COUNT,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'getMazeRandom',value:function getMazeRandom(){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_RANDOM_MAZE,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listSlashTestScoreData',value:function listSlashTestScoreData(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_SLASH_SCORE_DATA+'?userId='+userId,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'getSlashScoreCount',value:function getSlashScoreCount(){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_SLASH_SCORE_COUNT,{method:'get',headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listWorkMarkScoreData',value:function listWorkMarkScoreData(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_WORDMARK_SCORE_DATA+'?userId='+userId,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listWorkMark2ScoreData',value:function listWorkMark2ScoreData(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_WORDMARK2_SCORE_DATA+'?userId='+userId,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listKidSpeakScoreData',value:function listKidSpeakScoreData(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_KIDSPEAK_DATA+'?userId='+userId,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listPictureNamingData',value:function listPictureNamingData(userId,PNModel){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_PICTURENAMING_DATA+'?userId='+userId+'&PNModel='+PNModel,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listCopyRightData',value:function listCopyRightData(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_COPYRIGHT_DATA+'?userId='+userId,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listWordSignSayData',value:function listWordSignSayData(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_WORDSIGNSAY_DATA+'?userId='+userId,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listKidSignData',value:function listKidSignData(userId){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_KIDSIGN_DATA+'?userId='+userId,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'listRandomPNPictures',value:function listRandomPNPictures(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_PICTURENAMING_RANDOM).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'uploadPNVideo',value:function uploadPNVideo(fileStream,data,blob){if(blob){var jBlob=new Blob([JSON.stringify(data)],{type:'application/json'});return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_PICTURENAMING_FILE).attach("file",blob).attach("file2",jBlob).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}else if(fileStream&&!blob){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_PICTURENAMING_FILE).attach("file",data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}else{return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_PICTURENAMING_FILE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}}},{key:'insertPNSession',value:function insertPNSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_PICTURENAMING_SESSION).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getBestScores',value:function getBestScores(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_STUDENT_BEST_SCORE).set("token",localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'updateMazeScore',value:function updateMazeScore(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_MAZE_SCORE).send(data).set("token",localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'postMazeSession',value:function postMazeSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.POST_MAZE_SESSION).send(data).set("token",localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'createMazeContent',value:function createMazeContent(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CREATE_MAZE_CONTENT).send(data).set("token",localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'getStudentBestScores',value:function getStudentBestScores(userId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_USER_BESTSCORES+"?userId="+userId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'createPN1On1Session',value:function createPN1On1Session(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_PICTURENAMING_1ON1).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getPNManualSession',value:function getPNManualSession(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_PICTURENAMING_SESSION+"?testId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'gradePNSession',value:function gradePNSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_PICTURENAMING_GRADE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'gradePNManualSession',value:function gradePNManualSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.PICTURENAMING_MANUAL_GRADE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getPNManualScore',value:function getPNManualScore(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_PICTURENAMING_MANUAL_SCORE+"?testId="+testId).set('token',localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'getSlashTestRandom',value:function getSlashTestRandom(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_RANDOM_SLASH).set('token',localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'postSlashSession',value:function postSlashSession(body){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.POST_SLASH_SESSION).send(body).set('token',localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'updateSlashScores',value:function updateSlashScores(body){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_SLASH_SCORE).send(body).set('token',localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'getKSRandom',value:function getKSRandom(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_KIDSPEAK_RANDOM).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'uploadKSAudio',value:function uploadKSAudio(blob){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_KIDSPEAK_FILE).attach("file",blob).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'insertKSSession',value:function insertKSSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_KIDSPEAK_SESSION).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getKSSession',value:function getKSSession(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_KIDSPEAK_SESSION+"?testId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'gradeKSSession',value:function gradeKSSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_KIDSPEAK_GRADE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateKSBestScore',value:function updateKSBestScore(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_KIDSPEAK_BEST_SCORE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getWordMarkRandom',value:function getWordMarkRandom(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_RANDOM_WORDMARK).set('token',localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'getWordMark2Random1',value:function getWordMark2Random1(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_RANDOM1_WORDMARK2).set('token',localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'getWordMark2Random2',value:function getWordMark2Random2(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_RANDOM2_WORDMARK2).set('token',localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'postWordMarkSession',value:function postWordMarkSession(body){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.POST_WORDMARK_SESSION).set('token',localStorage.getItem('token')).send(body).then(function(res){return res.body;});}},{key:'postWordMark2Session',value:function postWordMark2Session(body){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.POST_WORDMARK2_SESSION).set('token',localStorage.getItem('token')).send(body).then(function(res){return res.body;});}},{key:'getWordMarkSession',value:function getWordMarkSession(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_WORDMARK_SESSION+'?testId='+testId).set('token',localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'getWordMark2Session',value:function getWordMark2Session(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_WORDMARK2_SESSION+'?testId='+testId).set('token',localStorage.getItem('token')).then(function(res){return res.body;});}},{key:'gradeWordMarkSession',value:function gradeWordMarkSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_WORDMARK_GRADE).set('token',localStorage.getItem('token')).send(data).then(function(res){return res.body;});}},{key:'gradeWordMark2Session',value:function gradeWordMark2Session(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_WORDMARK2_GRADE).set('token',localStorage.getItem('token')).send(data).then(function(res){return res.body;});}},{key:'updateMazeNote',value:function updateMazeNote(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_MAZE_SCORE_NOTE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateSlashNote',value:function updateSlashNote(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_SLASH_SCORE_NOTE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updatePNNote',value:function updatePNNote(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_PICTURENAMING_SCORE_NOTE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updatePNBestScore',value:function updatePNBestScore(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_PICTURENAMING_BEST_SCORE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateWordMarkNote',value:function updateWordMarkNote(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_WORDMARK_SCORE_NOTE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateWordMark2Note',value:function updateWordMark2Note(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_WORDMARK2_SCORE_NOTE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateKidSpeakNote',value:function updateKidSpeakNote(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_KIDSPEAK_SCORE_NOTE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getCRRandom',value:function getCRRandom(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_COPYRIGHT_RANDOM).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'uploadCRVideo',value:function uploadCRVideo(fileStream,data){if(fileStream){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_COPYRIGHT_FILE).attach("file",data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}else{return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_COPYRIGHT_FILE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}}},{key:'insertCRSession',value:function insertCRSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_COPYRIGHT_SESSION).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getCRSession',value:function getCRSession(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_COPYRIGHT_SESSION+"?testId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'gradeCRSession',value:function gradeCRSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_COPYRIGHT_GRADE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateCRBestScore',value:function updateCRBestScore(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_COPYRIGHT_BEST_SCORE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateCopyRightNote',value:function updateCopyRightNote(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_COPYRIGHT_SCORE_NOTE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getWSSRandom',value:function getWSSRandom(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_WORDSIGNSAY_RANDOM).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'uploadWSSVideo',value:function uploadWSSVideo(fileStream,data,blob){if(blob){var jBlob=new Blob([JSON.stringify(data)],{type:'application/json'});return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_WORDSIGNSAY_FILE).attach("file",blob).attach("file2",jBlob).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}else if(fileStream&&!blob){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_WORDSIGNSAY_FILE).attach("file",data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}else{return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_WORDSIGNSAY_FILE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}}},{key:'insertWSSSession',value:function insertWSSSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_WORDSIGNSAY_SESSION).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getWSSSession',value:function getWSSSession(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_WORDSIGNSAY_SESSION+"?testId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'gradeWSSSession',value:function gradeWSSSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_WORDSIGNSAY_GRADE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateWSSBestScore',value:function updateWSSBestScore(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_WORDSIGNSAY_BEST_SCORE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateWordSignSayNote',value:function updateWordSignSayNote(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_WORDSIGNSAY_SCORE_NOTE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getKSSRandom',value:function getKSSRandom(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_KIDSIGN_RANDOM).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'uploadKSSVideo',value:function uploadKSSVideo(fileStream,data,blob){if(blob){var jBlob=new Blob([JSON.stringify(data)],{type:'application/json'});return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_KIDSIGN_FILE).attach("file",blob).attach("file2",jBlob).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}else if(fileStream&&!blob){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_KIDSIGN_FILE).attach("file",data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}else{return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPLOAD_KIDSIGN_FILE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}}},{key:'insertKSSSession',value:function insertKSSSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_KIDSIGN_SESSION).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getKSSSession',value:function getKSSSession(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_KIDSIGN_SESSION+"?testId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'gradeKSSSession',value:function gradeKSSSession(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_KIDSIGN_GRADE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateKSSBestScore',value:function updateKSSBestScore(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_KIDSIGN_BEST_SCORE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateKidSignNote',value:function updateKidSignNote(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_KIDSIGN_SCORE_NOTE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'resetUsername',value:function resetUsername(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.RESET_USERNAME).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'resetPassword',value:function resetPassword(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.RESET_PASSWORD).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'changePassword',value:function changePassword(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CHANGE_PASSWORD).send(data).then(function(res){return res.body;});}},{key:'accountRequest',value:function accountRequest(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.REQUEST_ACCOUNT).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'helpRequest',value:function helpRequest(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.REQUEST_HELP).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getStudentAppStatus',value:function getStudentAppStatus(studentId){if(studentId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_STUDENT_APPS_STATUS+"?studentId="+studentId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}else{return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_STUDENT_APPS_STATUS).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}}},{key:'getUngradedTasks',value:function getUngradedTasks(appName){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_UNGRADED_TASKS+"?aveAppName="+appName).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getParentStudents',value:function getParentStudents(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_PARENT_STUDENTS).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deleteParent',value:function deleteParent(studentId){__WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_PARENT+"?studentId="+studentId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'checkStudentData',value:function checkStudentData(userId,appName){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CHECK_STUDENT_DATA+"?userId="+userId+"&appName="+appName).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getSurveyAmount',value:function getSurveyAmount(userId,appName){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.GET_SURVEY_AMOUNT+"?userId="+userId+"&appName="+appName).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'checkSurveyHomePage',value:function checkSurveyHomePage(userId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CHECK_SURVEY_HOMEPAGE+"?userId="+userId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'checkTeacherLogin',value:function checkTeacherLogin(userId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CHECK_TEACHER_LOGIN+"?userId="+userId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'checkTeacherResources',value:function checkTeacherResources(userId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CHECK_TEACHER_RESOURCES+"?userId="+userId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'checkTeacherDataChart',value:function checkTeacherDataChart(userId,appName){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CHECK_TEACHER_DATA_CHART+"?userId="+userId+'&appName='+appName).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'checkTeacherGrading',value:function checkTeacherGrading(userId,appName){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CHECK_TEACHER_GRADING+"?userId="+userId+'&appName='+appName).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'getStudentNotifications',value:function getStudentNotifications(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.STUDENT_NOTIFICATIONS).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deletePictureNamingScore',value:function deletePictureNamingScore(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_PICTURENAMING_SCORE+"?assessmentId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deleteWordMarkScore',value:function deleteWordMarkScore(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_WORDMARK_SCORE+"?assessmentId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deleteWordMark2Score',value:function deleteWordMark2Score(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_WORDMARK2_SCORE+"?assessmentId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deleteWordSignSayScore',value:function deleteWordSignSayScore(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_WORDSIGNSAY_SCORE+"?assessmentId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deleteKidSpeakScore',value:function deleteKidSpeakScore(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_KIDSPEAK_SCORE+"?assessmentId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deleteKidSignScore',value:function deleteKidSignScore(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_KIDSIGN_SCORE+"?assessmentId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deleteCopyRightScore',value:function deleteCopyRightScore(testId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_COPYRIGHT_SCORE+"?assessmentId="+testId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'listMazePassages',value:function listMazePassages(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.List_MAZE_PASSAGE).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'addMazePassage',value:function addMazePassage(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_MAZE_PASSAGE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deleteMazePassage',value:function deleteMazePassage(passageId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_MAZE_PASSAGE+"?passageId="+passageId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateMazePassage',value:function updateMazePassage(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_MAZE_PASSAGE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'activateMazePassage',value:function activateMazePassage(passageId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ACTIVEATE_MAZE_PASSAGE+"?passageId="+passageId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'listKidSpeakPassages',value:function listKidSpeakPassages(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.List_KIDSPEAK_PASSAGE).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'listKidSpeakPassagesByUId',value:function listKidSpeakPassagesByUId(uId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.List_KIDSPEAK_PASSAGE_BY_UID+"?uId="+uId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'addKidSpeakPassage',value:function addKidSpeakPassage(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_KIDSPEAK_PASSAGE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'deleteKidSpeakPassage',value:function deleteKidSpeakPassage(passageId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.delete(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.DELETE_KIDSPEAK_PASSAGE+"?passageId="+passageId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'updateKidSpeakPassage',value:function updateKidSpeakPassage(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.put(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.UPDATE_KIDSPEAK_PASSAGE).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'activateKidSpeakPassage',value:function activateKidSpeakPassage(passageId){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ACTIVEATE_KIDSPEAK_PASSAGE+"?passageId="+passageId).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'reportBug',value:function reportBug(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.REPORT_BUG).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'teacherConsent',value:function teacherConsent(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.TEACHER_CONSENT).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}},{key:'addAnalytics',value:function addAnalytics(data){if(localStorage.getItem("token")){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_ANALYTICS).send(data).set("token",localStorage.getItem("token")).then(function(res){return res.body;});}else{return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.ADD_ANALYTICS_NONUSER).send(data).then(function(res){return res.body;});}}},{key:'listSchools',value:function listSchools(){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_SCHOOLS).then(function(res){return res.body;});}},{key:'listAdminSchools',value:function listAdminSchools(id){headerWithToken['token']=localStorage.getItem('token');return fetch(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.LIST_ADMIN_SCHOOLS+'?userId='+id,{headers:headerWithToken}).then(function(res){return res.json();});}},{key:'createSchool',value:function createSchool(data){return __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0__Consts__["c" /* MAIN */].API.CREATE_SCHOOL).send(data).then(function(res){return res.body;});}}]);return REST;}();/* harmony default export */ __webpack_exports__["a"] = (REST);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(415);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(215);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(417);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(420);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(423);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(154);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(431);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(435);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(448);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_survey_survey1_png__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_survey_survey1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_survey_survey1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_survey_survey2_png__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_survey_survey2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_survey_survey2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_survey_survey3_png__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_survey_survey3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_survey_survey3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_survey_survey4_png__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_survey_survey4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_survey_survey4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_survey_survey5_png__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_survey_survey5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_survey_survey5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_logo_wordmark_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_logo_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_logo_wordmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_StopSign_png__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_StopSign_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_StopSign_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_rotate_device_fff_bg_png__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_rotate_device_fff_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_rotate_device_fff_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StudentsComponent_actions__ = __webpack_require__(30);
var _this4=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DialogBox=function(_Component){_inherits(DialogBoxComponent,_Component);function DialogBoxComponent(props){_classCallCheck(this,DialogBoxComponent);var _this=_possibleConstructorReturn(this,(DialogBoxComponent.__proto__||Object.getPrototypeOf(DialogBoxComponent)).call(this,props));_this.state={surveyFinished:false,surveyContent:null,surveyLogo:null,surveyInitialFrequency:null,surveyFrequency:null,surveyResult:null,isModalOpen:_this.props.modalOpen?_this.props.modalOpen:false,analytics:{type:null,metadata:null}};_this.closeModal=_this.closeModal.bind(_this);_this.handleYes=_this.handleYes.bind(_this);_this.handleNo=_this.handleNo.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.setupSurveyModal=_this.setupSurveyModal.bind(_this);return _this;}_createClass(DialogBoxComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!this.props.surveyModal){_context.next=6;break;}if(!this.props.active){_context.next=4;break;}_context.next=4;return this.setupSurveyModal();case 4:_context.next=8;break;case 6:_context.next=8;return this.setState({isModalOpen:this.props.modalOpen?this.props.modalOpen:false});case 8:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'setupSurveyModal',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var _this2=this;var appName;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(!(this.props.app==='Homepage'&&this.props.role!=='teacher')){_context9.next=5;break;}_context9.next=3;return this.setState({surveyContent:'I like AvePM.'});case 3:_context9.next=87;break;case 5:if(!(this.props.app==='Homepage')){_context9.next=10;break;}_context9.next=8;return this.setState({surveyContent:'AvenuePM is easy to use.'});case 8:_context9.next=87;break;case 10:if(!(this.props.app==='PNGrading')){_context9.next=15;break;}_context9.next=13;return this.setState({surveyContent:'Scoring PictureNaming in AvePM is easy.'});case 13:_context9.next=87;break;case 15:if(!(this.props.app==='WMGrading')){_context9.next=20;break;}_context9.next=18;return this.setState({surveyContent:'Scoring WordMark in AvePM is easy.'});case 18:_context9.next=87;break;case 20:if(!(this.props.app==='CRGrading')){_context9.next=25;break;}_context9.next=23;return this.setState({surveyContent:'Scoring CopyRight in AvePM is easy.'});case 23:_context9.next=87;break;case 25:if(!(this.props.app==='KidSignGrading')){_context9.next=30;break;}_context9.next=28;return this.setState({surveyContent:'Scoring Kid Sign/Say in AvePM is easy.'});case 28:_context9.next=87;break;case 30:if(!(this.props.app==='KSGrading')){_context9.next=35;break;}_context9.next=33;return this.setState({surveyContent:'Scoring KidSpeak in AvePM is easy.'});case 33:_context9.next=87;break;case 35:if(!(this.props.app==='WSSGrading')){_context9.next=40;break;}_context9.next=38;return this.setState({surveyContent:'Scoring Word Sign/Say in AvePM is easy.'});case 38:_context9.next=87;break;case 40:if(!(this.props.app==='MazeDataChart')){_context9.next=45;break;}_context9.next=43;return this.setState({surveyContent:'AvePM provides useful information.'});case 43:_context9.next=87;break;case 45:if(!(this.props.app==='SlashDataChart')){_context9.next=50;break;}_context9.next=48;return this.setState({surveyContent:'AvePM provides useful information.'});case 48:_context9.next=87;break;case 50:if(!(this.props.app==='WMDataChart')){_context9.next=55;break;}_context9.next=53;return this.setState({surveyContent:'AvePM provides useful information.'});case 53:_context9.next=87;break;case 55:if(!(this.props.app==='KSDataChart')){_context9.next=60;break;}_context9.next=58;return this.setState({surveyContent:'AvePM provides useful information.'});case 58:_context9.next=87;break;case 60:if(!(this.props.app==='PNDataChart')){_context9.next=65;break;}_context9.next=63;return this.setState({surveyContent:'AvePM provides useful information.'});case 63:_context9.next=87;break;case 65:if(!(this.props.app==='WSSDataChart')){_context9.next=70;break;}_context9.next=68;return this.setState({surveyContent:'AvePM provides useful information.'});case 68:_context9.next=87;break;case 70:if(!(this.props.app==='KSSDataChart')){_context9.next=75;break;}_context9.next=73;return this.setState({surveyContent:'AvePM provides useful information.'});case 73:_context9.next=87;break;case 75:if(!(this.props.app==='CRDataChart')){_context9.next=80;break;}_context9.next=78;return this.setState({surveyContent:'AvePM provides useful information.'});case 78:_context9.next=87;break;case 80:if(!(this.props.app==='ResourceLink')){_context9.next=85;break;}_context9.next=83;return this.setState({surveyContent:'AvePM resources are high quality.'});case 83:_context9.next=87;break;case 85:_context9.next=87;return this.setState({surveyContent:'I like '+this.props.app+'.'});case 87:appName=this.props.app;_context9.t0=this.props.app;_context9.next=_context9.t0==='Homepage'?91:_context9.t0==='Maze'?99:_context9.t0==='Slash'?102:_context9.t0==='WordMark'?105:_context9.t0==='KidSpeak'?108:_context9.t0==='Picture Naming'?111:_context9.t0==='Picture Naming (Computer Task)'?115:_context9.t0==='Picture Naming (1-1 Computer Task)'?118:_context9.t0==='Word Sign/Say'?121:_context9.t0==='CopyRight'?125:_context9.t0==='KidSign'?128:_context9.t0==='PNGrading'?131:_context9.t0==='WMGrading'?134:_context9.t0==='CRGrading'?137:_context9.t0==='KidSignGrading'?140:_context9.t0==='KSGrading'?143:_context9.t0==='WSSGrading'?146:_context9.t0==='MazeDataChart'?149:_context9.t0==='SlashDataChart'?152:_context9.t0==='WMDataChart'?155:_context9.t0==='KSDataChart'?158:_context9.t0==='PNDataChart'?161:_context9.t0==='WSSDataChart'?164:_context9.t0==='KSSDataChart'?167:_context9.t0==='CRDataChart'?170:_context9.t0==='ResourceLink'?173:176;break;case 91:if(!(this.props.role==='teacher')){_context9.next=96;break;}_context9.next=94;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 94:_context9.next=98;break;case 96:_context9.next=98;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a});case 98:return _context9.abrupt('break',176);case 99:_context9.next=101;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png___default.a,surveyInitialFrequency:5,surveyFrequency:20});case 101:return _context9.abrupt('break',176);case 102:_context9.next=104;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png___default.a,surveyInitialFrequency:5,surveyFrequency:50});case 104:return _context9.abrupt('break',176);case 105:_context9.next=107;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_19__assets_images_logo_wordmark_png___default.a,surveyInitialFrequency:5,surveyFrequency:10});case 107:return _context9.abrupt('break',176);case 108:_context9.next=110;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png___default.a,surveyInitialFrequency:5,surveyFrequency:10});case 110:return _context9.abrupt('break',176);case 111:_context9.next=113;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png___default.a,surveyInitialFrequency:5,surveyFrequency:9999});case 113://5, 9999
appName='PictureNaming/Computer';return _context9.abrupt('break',176);case 115:_context9.next=117;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png___default.a,surveyInitialFrequency:5,surveyFrequency:9999});case 117:return _context9.abrupt('break',176);case 118:_context9.next=120;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png___default.a,surveyInitialFrequency:5,surveyFrequency:9999});case 120:return _context9.abrupt('break',176);case 121:_context9.next=123;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png___default.a,surveyInitialFrequency:3,surveyFrequency:9999});case 123://3, 9999
appName='WordSign/Say';return _context9.abrupt('break',176);case 125:_context9.next=127;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png___default.a,surveyInitialFrequency:5,surveyFrequency:15});case 127:return _context9.abrupt('break',176);case 128:_context9.next=130;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png___default.a,surveyInitialFrequency:5,surveyFrequency:10});case 130:return _context9.abrupt('break',176);case 131:_context9.next=133;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 133:return _context9.abrupt('break',176);case 134:_context9.next=136;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 136:return _context9.abrupt('break',176);case 137:_context9.next=139;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 139:return _context9.abrupt('break',176);case 140:_context9.next=142;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 142:return _context9.abrupt('break',176);case 143:_context9.next=145;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 145:return _context9.abrupt('break',176);case 146:_context9.next=148;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 148:return _context9.abrupt('break',176);case 149:_context9.next=151;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 151:return _context9.abrupt('break',176);case 152:_context9.next=154;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 154:return _context9.abrupt('break',176);case 155:_context9.next=157;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 157:return _context9.abrupt('break',176);case 158:_context9.next=160;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 160:return _context9.abrupt('break',176);case 161:_context9.next=163;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 163:return _context9.abrupt('break',176);case 164:_context9.next=166;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 166:return _context9.abrupt('break',176);case 167:_context9.next=169;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 169:return _context9.abrupt('break',176);case 170:_context9.next=172;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 172:return _context9.abrupt('break',176);case 173:_context9.next=175;return this.setState({surveyLogo:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_avenuepm_png___default.a,surveyInitialFrequency:1,surveyFrequency:9999});case 175:return _context9.abrupt('break',176);case 176:if(!(this.props.role==='teacher'&&this.props.userId)){_context9.next=194;break;}_context9.t1=this.props.app;_context9.next=_context9.t1==='Homepage'?180:_context9.t1==='ResourceLink'?183:_context9.t1==='MazeDataChart'?186:_context9.t1==='SlashDataChart'?186:_context9.t1==='WMDataChart'?186:_context9.t1==='KSDataChart'?186:_context9.t1==='PNDataChart'?186:_context9.t1==='WSSDataChart'?186:_context9.t1==='KSSDataChart'?186:_context9.t1==='CRDataChart'?186:_context9.t1==='PNGrading'?189:_context9.t1==='WMGrading'?189:_context9.t1==='CRGrading'?189:_context9.t1==='KSGrading'?189:_context9.t1==='KidSignGrading'?189:_context9.t1==='WSSGrading'?189:192;break;case 180:_context9.next=182;return __WEBPACK_IMPORTED_MODULE_23__REST__["a" /* default */].checkTeacherLogin(this.props.userId).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:result=res.body;if(!(result=="True")){_context2.next=6;break;}_context2.next=4;return _this2.setState({isModalOpen:true});case 4:_context2.next=7;break;case 6:_this2.props.surveyBack();case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}());case 182:return _context9.abrupt('break',192);case 183:_context9.next=185;return __WEBPACK_IMPORTED_MODULE_23__REST__["a" /* default */].checkTeacherResources(this.props.userId).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:result=res.body;if(!(result=="True")){_context3.next=6;break;}_context3.next=4;return _this2.setState({isModalOpen:true});case 4:_context3.next=7;break;case 6:_this2.props.surveyBack();case 7:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}());case 185:return _context9.abrupt('break',192);case 186:_context9.next=188;return __WEBPACK_IMPORTED_MODULE_23__REST__["a" /* default */].checkTeacherDataChart(this.props.userId,this.props.app).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(res){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:result=res.body;if(!(result=="True")){_context4.next=6;break;}_context4.next=4;return _this2.setState({isModalOpen:true});case 4:_context4.next=7;break;case 6:_this2.props.surveyBack();case 7:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}());case 188:return _context9.abrupt('break',192);case 189:_context9.next=191;return __WEBPACK_IMPORTED_MODULE_23__REST__["a" /* default */].checkTeacherGrading(this.props.userId,this.props.app).then(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(res){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:result=res.body;if(!(result=="True")){_context5.next=6;break;}_context5.next=4;return _this2.setState({isModalOpen:true});case 4:_context5.next=7;break;case 6:_this2.props.surveyBack();case 7:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x4){return _ref6.apply(this,arguments);};}());case 191:return _context9.abrupt('break',192);case 192:_context9.next=196;break;case 194:_context9.next=196;return __WEBPACK_IMPORTED_MODULE_23__REST__["a" /* default */].checkStudentData(this.props.userId,appName).then(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(res){var lastLogins,lastLogin,currentLogin;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:if(!(_this2.props.app==='Homepage')){_context8.next=13;break;}lastLogins=res.body;if(!(lastLogins[0]&&lastLogins[1])){_context8.next=11;break;}lastLogin=new Date(lastLogins[1].createdAt);currentLogin=new Date(lastLogins[0].createdAt);if(!(lastLogin.getFullYear()!==currentLogin.getFullYear()||lastLogin.getMonth()!==currentLogin.getMonth())){_context8.next=10;break;}_context8.next=8;return __WEBPACK_IMPORTED_MODULE_23__REST__["a" /* default */].checkSurveyHomePage(_this2.props.userId).then(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(res){var lastSurvey,lastSurveyTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:lastSurvey=res.body;lastSurveyTime=new Date(lastSurvey.createdAt);if(!(lastSurveyTime.getFullYear()!==currentLogin.getFullYear()||lastSurveyTime.getMonth()!==currentLogin.getMonth())){_context6.next=7;break;}_context6.next=5;return _this2.setState({isModalOpen:true});case 5:_context6.next=8;break;case 7:_this2.props.surveyBack();case 8:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x6){return _ref8.apply(this,arguments);};}());case 8:_context8.next=11;break;case 10://doesn't meet the rules
_this2.props.surveyBack();case 11:_context8.next=28;break;case 13:if(!(res.body===_this2.state.surveyInitialFrequency||(res.body-_this2.state.surveyInitialFrequency)%_this2.state.surveyFrequency===0)){_context8.next=27;break;}if(!(_this2.props.app==='Picture Naming'||_this2.props.app==='Word Sign/Say')){_context8.next=19;break;}_context8.next=17;return __WEBPACK_IMPORTED_MODULE_23__REST__["a" /* default */].getSurveyAmount(_this2.props.userId,_this2.props.app).then(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(res){var surveyAmount;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:surveyAmount=res.body;if(!(surveyAmount>=1)){_context7.next=5;break;}_this2.props.surveyBack();_context7.next=7;break;case 5:_context7.next=7;return _this2.setState({isModalOpen:true});case 7:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x7){return _ref9.apply(this,arguments);};}());case 17:_context8.next=25;break;case 19:if(!(_this2.props.app==='KidSign')){_context8.next=23;break;}_this2.props.surveyBack();_context8.next=25;break;case 23:_context8.next=25;return _this2.setState({isModalOpen:true});case 25:_context8.next=28;break;case 27://doesn't meet the rules
_this2.props.surveyBack();case 28:case'end':return _context8.stop();}}},_callee8,_this2);}));return function(_x5){return _ref7.apply(this,arguments);};}());case 196:case'end':return _context9.stop();}}},_callee9,this);}));function setupSurveyModal(){return _ref2.apply(this,arguments);}return setupSurveyModal;}()},{key:'componentDidUpdate',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(prevProps){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(!(prevProps!==this.props)){_context10.next=4;break;}if(!(this.props.surveyModal&&this.props.active)){_context10.next=4;break;}_context10.next=4;return this.setupSurveyModal();case 4:case'end':return _context10.stop();}}},_callee10,this);}));function componentDidUpdate(_x8){return _ref10.apply(this,arguments);}return componentDidUpdate;}()},{key:'openModal',value:function openModal(){this.setState({isModalOpen:true});}},{key:'closeModal',value:function closeModal(){this.props.closeClick(false);this.setState({isModalOpen:false});}},{key:'handleYes',value:function handleYes(event){this.props.confirmDelete(true);this.setState({isModalOpen:false});this.closeModal();}},{key:'handleNo',value:function handleNo(event){this.props.confirmDelete(false);this.setState({isModalOpen:false});this.closeModal();}},{key:'handleChange',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(result){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:if(this.state.surveyFinished){_context11.next=7;break;}this.state.surveyFinished=true;this.setState({isModalOpen:false});_context11.next=5;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__["b" /* default */].POPUP_SURVEY,metadata:{app:this.props.app,result:result}}});case 5:this.handleAnalytics();this.props.surveyBack();case 7:case'end':return _context11.stop();}}},_callee11,this);}));function handleChange(_x9){return _ref11.apply(this,arguments);}return handleChange;}()},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_23__REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["a" /* Modal */],{id:'dialogBox',show:this.props.modalOpen?this.props.modalOpen:this.state.isModalOpen},this.props.notificationModal?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},this.props.warning?this.props.slash?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_21__assets_images_rotate_device_fff_bg_png___default.a,style:{width:'100%'}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_StopSign_png___default.a,style:{width:'100%'}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},!this.props.infoWarning?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,this.props.sectionContent):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content',style:{textAlign:'left'},dangerouslySetInnerHTML:{__html:this.props.infoWarning}}))),this.props.noClose?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.closeModal,className:'handBtn pull-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close')))):this.props.surveyModal?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},this.props.role=="teacher"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body",style:{marginTop:20,marginBottom:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Survey'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{margin:'auto',fontSize:20}},this.state.surveyContent)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body",style:{marginTop:20,marginBottom:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,this.state.surveyContent),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{margin:'auto'}},this.props.app==='Homepage'||this.props.role==='teacher'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.state.surveyLogo,style:{width:'auto',height:45,marginTop:20}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.state.surveyLogo,style:{width:75,height:75,border:'0.1em dashed #000',borderRadius:'25%'}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body",style:{marginTop:20,marginBottom:50}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-1"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',name:'site_name',value:"1",onChange:function onChange(){_this3.handleChange(1);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{onClick:function onClick(){_this3.handleChange(1);},src:__WEBPACK_IMPORTED_MODULE_6__assets_images_survey_survey1_png___default.a,style:{width:'100%',marginTop:10,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',name:'site_name',value:"2",onChange:function onChange(){_this3.handleChange(2);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{onClick:function onClick(){_this3.handleChange(2);},src:__WEBPACK_IMPORTED_MODULE_7__assets_images_survey_survey2_png___default.a,style:{width:'100%',marginTop:10,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',name:'site_name',value:"3",onChange:function onChange(){_this3.handleChange(3);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{onClick:function onClick(){_this3.handleChange(3);},src:__WEBPACK_IMPORTED_MODULE_8__assets_images_survey_survey3_png___default.a,style:{width:'100%',marginTop:10,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',name:'site_name',value:"4",onChange:function onChange(){_this3.handleChange(4);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{onClick:function onClick(){_this3.handleChange(4);},src:__WEBPACK_IMPORTED_MODULE_9__assets_images_survey_survey4_png___default.a,style:{width:'100%',marginTop:10,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',name:'site_name',value:"5",onChange:function onChange(){_this3.handleChange(5);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{onClick:function onClick(){_this3.handleChange(5);},src:__WEBPACK_IMPORTED_MODULE_10__assets_images_survey_survey5_png___default.a,style:{width:'100%',marginTop:10,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-1"})),this.props.role=="teacher"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body",style:{marginTop:-20,marginBottom:20,marginLeft:'auto',marginRight:'auto',fontSize:12}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this3.handleChange(6);}},'Dismiss')):null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png___default.a,alt:"Warning",style:{width:40,height:40,position:'relative'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{paddingTop:15}},this.props.sectionContent),this.props.backFunction?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{fontFamily:'Open Sans',fontStyle:'sans-serif',fontSize:15,paddingTop:15,paddingBottom:15}},'After deleting, you will not be able to access the student\'s data.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'right'},onClick:this.handleYes,className:'handBtn'},this.props.backFunction?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Leave'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Yes'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.handleNo,className:'handBtn'},this.props.backFunction?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'No')))))));}}]);return DialogBoxComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateFirstLogin:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__StudentsComponent_actions__["b" /* updateFirstLogin */])(results));case 2:return _context12.abrupt('return',_context12.sent);case 3:case'end':return _context12.stop();}}},_callee12,_this4);}));function updateFirstLogin(_x10){return _ref12.apply(this,arguments);}return updateFirstLogin;}()};};var mapStateToProps=function mapStateToProps(state){return{firstLogin:state.studentReducer.firstLogin};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(DialogBox));

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_device_detect__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_network_speed__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_network_speed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_network_speed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Consts__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Helpers=function(){function Helpers(){_classCallCheck(this,Helpers);}_createClass(Helpers,null,[{key:'getNetworkUploadSpeed',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var testNetworkSpeed,url,options,speed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:testNetworkSpeed=new __WEBPACK_IMPORTED_MODULE_3_network_speed___default.a();url=new URL(__WEBPACK_IMPORTED_MODULE_4__Consts__["a" /* API_URL */]);options={hostname:url.hostname,port:url.port,path:'/uploadTestEndpoint',method:'POST',headers:{'Content-Type':'application/json'}};_context.next=5;return testNetworkSpeed.checkUploadSpeed(options);case 5:speed=_context.sent;console.log(speed);return _context.abrupt('return',speed);case 8:case'end':return _context.stop();}}},_callee,this);}));function getNetworkUploadSpeed(){return _ref.apply(this,arguments);}return getNetworkUploadSpeed;}()},{key:'calculateETA',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(arr,blob){var fileSize,arrSize,totalSize,currentSpeed,etaCalc;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:fileSize=blob.size;arrSize=JSON.stringify(arr).length;totalSize=fileSize+arrSize;_context2.next=5;return this.getNetworkUploadSpeed();case 5:currentSpeed=_context2.sent;if(!(currentSpeed.bps==="Infinity")){_context2.next=10;break;}_context2.next=9;return this.getNetworkUploadSpeed();case 9:currentSpeed=_context2.sent;case 10:etaCalc=15;if(totalSize<100000){etaCalc=(arrSize+fileSize)/currentSpeed.bps/8+2;}else{etaCalc=(arrSize+fileSize)/currentSpeed.bps/8+10;}if(isNaN(etaCalc)){etaCalc=10;}return _context2.abrupt('return',etaCalc);case 14:case'end':return _context2.stop();}}},_callee2,this);}));function calculateETA(_x,_x2){return _ref2.apply(this,arguments);}return calculateETA;}()},{key:'getVideoSizes',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:return _context3.abrupt('return',{width:__WEBPACK_IMPORTED_MODULE_2_react_device_detect__["isIOS"]?320:{ideal:320},height:__WEBPACK_IMPORTED_MODULE_2_react_device_detect__["isIOS"]?240:{ideal:240}});case 1:case'end':return _context3.stop();}}},_callee3,this);}));function getVideoSizes(){return _ref3.apply(this,arguments);}return getVideoSizes;}()},{key:'authorize',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(context){var token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return localStorage.getItem('token');case 2:token=_context4.sent;if(!token){_context4.next=8;break;}_context4.next=6;return __WEBPACK_IMPORTED_MODULE_1__REST__["a" /* default */].authWithToken().then(function(response){if(!response.success){context.props.history.push('/login');}},function(error){context.props.history.push('/login');});case 6:_context4.next=9;break;case 8:context.props.history.push('/login');case 9:case'end':return _context4.stop();}}},_callee4,this);}));function authorize(_x3){return _ref4.apply(this,arguments);}return authorize;}()},{key:'filterApps',value:function filterApps(studentUser,appStates){var allowedApps=[];var filteredApps=[];var standardAppsLevel={0:["picturenaming"],1:["wordsignsay","slash"],2:["maze"],3:["copyright","kidspeak","kidsign"],4:["wordmark"],5:[],6:[]};var expectedAppsLevel={0:[],1:[],2:[],3:[],4:[],5:[],6:[]};var finishedAppsLevel={0:[],1:[],2:[],3:[],4:[],5:[],6:[]};if(studentUser&&studentUser.student){allowedApps=studentUser.student.apps.split(",");if(appStates&&appStates.bestScores){var bestScores=appStates.bestScores;var readingLevel=studentUser.student.screeningLevel;for(var i=0;i<7;i++){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=standardAppsLevel[i][Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var fa=_step.value;if(allowedApps.includes(fa)){expectedAppsLevel[i].push(fa);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=allowedApps[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var app=_step2.value;if(app==="picturenaming"){if(bestScores.pnLevel>3){finishedAppsLevel[0].push(app);}if(readingLevel>=0){filteredApps.push(app);}}else if(app==="wordsignsay"){if(bestScores.wssLevel>1){finishedAppsLevel[1].push(app);}if(readingLevel>=1){filteredApps.push(app);}}else if(app==="copyright"){if(bestScores.crLevel>6){finishedAppsLevel[3].push(app);}if(readingLevel>=3){filteredApps.push(app);}}else if(app==="slash"){if(bestScores.slashLevel>8){finishedAppsLevel[1].push(app);}if(readingLevel>=1){filteredApps.push(app);}}else if(app==="kidsign"){if(bestScores.kssLevel>12){finishedAppsLevel[3].push(app);}if(readingLevel>=3){filteredApps.push(app);}}else if(app==="kidspeak"){if(bestScores.ksLevel>12){finishedAppsLevel[3].push(app);}if(readingLevel>=3){filteredApps.push(app);}}else if(app==="maze"){if(bestScores.mazeLevel>12){finishedAppsLevel[2].push(app);}if(readingLevel>=2){filteredApps.push(app);}}else if(app==="wordmark"){if(readingLevel>=4){filteredApps.push(app);}}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=allowedApps[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var _app=_step3.value;if(!filteredApps.includes(_app)){filteredApps.push(_app);}// if(app === "picturenaming"){
//     if(!filteredApps.includes(app)){
//         filteredApps.push(app);
//     }
// }else if(app === "wordsignsay"){
//     if(!filteredApps.includes(app) && finishedAppsLevel[0].length === expectedAppsLevel[0].length ){
//         filteredApps.push(app);
//     }
// }else if(app === "copyright"){
//     if(!filteredApps.includes(app) && finishedAppsLevel[2].length === expectedAppsLevel[2].length ){
//         filteredApps.push(app);
//     }
// }else if (app === "slash"){
//     if(!filteredApps.includes(app) && finishedAppsLevel[0].length === expectedAppsLevel[0].length ){
//         filteredApps.push(app);
//     }
// }else if (app === "kidsign"){
//     if(!filteredApps.includes(app) && finishedAppsLevel[2].length === expectedAppsLevel[2].length ){
//         filteredApps.push(app);
//     }
// }else if (app === "kidspeak"){
//     if(!filteredApps.includes(app) && finishedAppsLevel[2].length === expectedAppsLevel[2].length ){
//         filteredApps.push(app);
//     }
// }else if (app === "maze"){
//     if(!filteredApps.includes(app) && finishedAppsLevel[1].length === expectedAppsLevel[1].length ){
//         filteredApps.push(app);
//     }
// }else if (app === "wordmark"){
//     if(!filteredApps.includes(app) && finishedAppsLevel[3].length === expectedAppsLevel[3].length ){
//         filteredApps.push(app);
//     }
// }
}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}var finishedApps=finishedAppsLevel[0].concat(finishedAppsLevel[1],finishedAppsLevel[2],finishedAppsLevel[3],finishedAppsLevel[4],finishedAppsLevel[5],finishedAppsLevel[6]);return{filteredApps:filteredApps,finishedApps:finishedApps,allowedApps:allowedApps};}}]);return Helpers;}();/* harmony default export */ __webpack_exports__["a"] = (Helpers);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(117);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING; });
var TRACKING={TECH_CHECK:"TECH_CHECK",HOW_TO_USE_DATA:"HOW_TO_USE_DATA",HOW_TO_SCORE:"HOW_TO_SCORE",RESOURCES_DOWNLOAD:"RESOURCES_DOWNLOAD",VIDEO_PLAY:"VIDEO_PLAY",STUDENT_LOGIN:"STUDENT_LOGIN",TEACHER_LOGIN:"TEACHER_LOGIN",PARENT_LOGIN:"PARENT_LOGIN",SCHOOL_ADMIN_LOGIN:"SCHOOL_ADMIN_LOGIN",TEACHER_STUDENT_DETAILS_VIEW:"TEACHER_STUDENT_DETAILS_VIEW",TEACHER_STUDENT_DETAILS_SAVE_CHANGES:"TEACHER_STUDENT_DETAILS_SAVE_CHANGES",TEACHER_STUDENT_DETAILS_CHANGE_TEACHER_CLICK:"TEACHER_STUDENT_DETAILS_CHANGE_TEACHER_CLICK",TEACHER_SELECT_CLASS:"TEACHER_SELECT_CLASS",TEACHER_ADDED_CLASS:"TEACHER_ADDED_CLASS",TEACHER_UPDATED_CLASS:"TEACHER_UPDATED_CLASS",TEACHER_DELETED_CLASS:"TEACHER_DELETED_CLASS",TEACHER_STUDENT_DELETE:"TEACHER_STUDENT_DELETE",TEACHER_ADD_STUDENT:"TEACHER_ADD_STUDENT",STUDENT_PN_START:"STUDENT_PN_START",STUDENT_WSS_START:"STUDENT_WSS_START",STUDENT_CR_START:"STUDENT_CR_START",STUDENT_CR_UPLOAD_START:"STUDENT_CR_UPLOAD_START",STUDENT_CR_UPLOAD_STOP:"STUDENT_CR_UPLOAD_STOP",STUDENT_SLASH_START:"STUDENT_SLASH_START",STUDENT_KS_START:"STUDENT_KS_START",STUDENT_MAZE_START:"STUDENT_MAZE_START",STUDENT_KSS_START:"STUDENT_KSS_START",STUDENT_WM_START:"STUDENT_WM_START",CR_SCORE_VIEW:"CR_SCORE_VIEW",PN_SCORE_VIEW:"PN_SCORE_VIEW",WSS_SCORE_VIEW:"WSS_SCORE_VIEW",KS_SCORE_VIEW:"KS_SCORE_VIEW",KSS_SCORE_VIEW:"KSS_SCORE_VIEW",WM_SCORE_VIEW:"WM_SCORE_VIEW",PN_SCORE_SAVE:"PN_SCORE_SAVE",PN_SCORE_PLAY:"PN_SCORE_PLAY",PN_SCORE_EXIT:"PN_SCORE_EXIT",PN_SCORE_DELETE:"PN_SCORE_DELETE",WSS_SCORE_PLAY:"WSS_SCORE_PLAY",WSS_SCORE_SAVE:"WSS_SCORE_SAVE",WSS_SCORE_EXIT:"WSS_SCORE_EXIT",WSS_SCORE_DELETE:"WSS_SCORE_DELETE",CR_SCORE_PLAY:"CR_SCORE_PLAY",CR_SCORE_EXIT:"CR_SCORE_EXIT",CR_SCORE_DELETE:"CR_SCORE_DELETE",CR_SCORE_SAVE:"CR_SCORE_SAVE",KS_SCORE_PLAY:"KS_SCORE_PLAY",KS_SCORE_SAVE:"KS_SCORE_SAVE",KS_SCORE_DELETE:"KS_SCORE_DELETE",KS_SCORE_EXIT:"KS_SCORE_EXIT",KSS_SCORE_PLAY:"KSS_SCORE_PLAY",KSS_SCORE_SAVE:"KSS_SCORE_SAVE",KSS_SCORE_EXIT:"KSS_SCORE_EXIT",KSS_SCORE_DELETE:"KSS_SCORE_DELETE",WM_SCORE_EXIT:"WM_SCORE_EXIT",WM_SCORE_SAVE:"WM_SCORE_SAVE",WM_SCORE_DELETE:"WM_SCORE_DELETE",MAZE_DATACHART_VIEW:"MAZE_DATACHART_VIEW",KSS_DATACHART_VIEW:"KSS_DATACHART_VIEW",KS_DATACHART_VIEW:"KS_DATACHART_VIEW",WM_DATACHART_VIEW:"WM_DATACHART_VIEW",WSS_DATACHART_VIEW:"WSS_DATACHART_VIEW",SLASH_DATACHART_VIEW:"SLASH_DATACHART_VIEW",CR_DATACHART_VIEW:"CR_DATACHART_VIEW",PN_DATACHART_VIEW:"PN_DATACHART_VIEW",MAZE_DATACHART_VIEW_MICRO:"MAZE_DATACHART_VIEW_MICRO",KSS_DATACHART_VIEW_MICRO:"KSS_DATACHART_VIEW_MICRO",KS_DATACHART_VIEW_MICRO:"KS_DATACHART_VIEW_MICRO",COPYRIGHT_DATACHART_VIEW_MICRO:"COPYRIGHT_DATACHART_VIEW_MICRO",PN_DATACHART_VIEW_MICRO:"PN_DATACHART_VIEW_MICRO",WSS_DATACHART_VIEW_MICRO:"WSS_DATACHART_VIEW_MICRO",SLASH_DATACHART_VIEW_MICRO:"SLASH_DATACHART_VIEW_MICRO",WORDMARK_DATACHART_VIEW_MICRO:"WORDMARK_DATACHART_VIEW_MICRO",MAZE_DATACHART_VIEW_MACRO:"MAZE_DATACHART_VIEW_MACRO",KSS_DATACHART_VIEW_MACRO:"KSS_DATACHART_VIEW_MACRO",KS_DATACHART_VIEW_MACRO:"KS_DATACHART_VIEW_MACRO",COPYRIGHT_DATACHART_VIEW_MACRO:"COPYRIGHT_DATACHART_VIEW_MACRO",PN_DATACHART_VIEW_MACRO:"PN_DATACHART_VIEW_MACRO",WSS_DATACHART_VIEW_MACRO:"WSS_DATACHART_VIEW_MACRO",SLASH_DATACHART_VIEW_MACRO:"SLASH_DATACHART_VIEW_MACRO",WORDMARK_DATACHART_VIEW_MACRO:"WORDMARK_DATACHART_VIEW_MACRO",POPUP_SURVEY:"POPUP_SURVEY"};/* harmony default export */ __webpack_exports__["b"] = (TRACKING);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(404);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 19 */
/***/ (function(module, exports) {

function new_byte(count) {
    return new Int8Array(count);
}

function new_short(count) {
    return new Int16Array(count);
}

function new_int(count) {
    return new Int32Array(count);
}

function new_float(count) {
    return new Float32Array(count);
}

function new_double(count) {
    return new Float64Array(count);
}

function new_float_n(args) {
    if (args.length == 1) {
        return new_float(args[0]);
    }
    var sz = args[0];
    args = args.slice(1);
    var A = [];
    for (var i = 0; i < sz; i++) {
        A.push(new_float_n(args));
    }
    return A;
}
function new_int_n(args) {
    if (args.length == 1) {
        return new_int(args[0]);
    }
    var sz = args[0];
    args = args.slice(1);
    var A = [];
    for (var i = 0; i < sz; i++) {
        A.push(new_int_n(args));
    }
    return A;
}

function new_short_n(args) {
    if (args.length == 1) {
        return new_short(args[0]);
    }
    var sz = args[0];
    args = args.slice(1);
    var A = [];
    for (var i = 0; i < sz; i++) {
        A.push(new_short_n(args));
    }
    return A;
}

function new_array_n(args) {
    if (args.length == 1) {
        return new Array(args[0]);
    }
    var sz = args[0];
    args = args.slice(1);
    var A = [];
    for (var i = 0; i < sz; i++) {
        A.push(new_array_n(args));
    }
    return A;
}


var Arrays = {};

Arrays.fill = function (a, fromIndex, toIndex, val) {
    if (arguments.length == 2) {
        for (var i = 0; i < a.length; i++) {
            a[i] = arguments[1];
        }
    } else {
        for (var i = fromIndex; i < toIndex; i++) {
            a[i] = val;
        }
    }
};

var System = {};

System.arraycopy = function (src, srcPos, dest, destPos, length) {
    var srcEnd = srcPos + length;
    while (srcPos < srcEnd)
        dest[destPos++] = src[srcPos++];
};


var Util = {};
Util.SQRT2 = 1.41421356237309504880;
Util.FAST_LOG10 = function (x) {
    return Math.log10(x);
};

Util.FAST_LOG10_X = function (x, y) {
    return Math.log10(x) * y;
};

function ShortBlock(ordinal) {
    this.ordinal = ordinal;
}
/**
 * LAME may use them, even different block types for L/R.
 */
ShortBlock.short_block_allowed = new ShortBlock(0);
/**
 * LAME may use them, but always same block types in L/R.
 */
ShortBlock.short_block_coupled = new ShortBlock(1);
/**
 * LAME will not use short blocks, long blocks only.
 */
ShortBlock.short_block_dispensed = new ShortBlock(2);
/**
 * LAME will not use long blocks, short blocks only.
 */
ShortBlock.short_block_forced = new ShortBlock(3);

var Float = {};
Float.MAX_VALUE = 3.4028235e+38;

function VbrMode(ordinal) {
    this.ordinal = ordinal;
}
VbrMode.vbr_off = new VbrMode(0);
VbrMode.vbr_mt = new VbrMode(1);
VbrMode.vbr_rh = new VbrMode(2);
VbrMode.vbr_abr = new VbrMode(3);
VbrMode.vbr_mtrh = new VbrMode(4);
VbrMode.vbr_default = VbrMode.vbr_mtrh;

var assert = function (x) {
    //console.assert(x);
};

module.exports = {
    "System": System,
    "VbrMode": VbrMode,
    "Float": Float,
    "ShortBlock": ShortBlock,
    "Util": Util,
    "Arrays": Arrays,
    "new_array_n": new_array_n,
    "new_byte": new_byte,
    "new_double": new_double,
    "new_float": new_float,
    "new_float_n": new_float_n,
    "new_int": new_int,
    "new_int_n": new_int_n,
    "new_short": new_short,
    "new_short_n": new_short_n,
    "assert": assert
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(470);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(509);
/* unused harmony reexport Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(512);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(513);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(246);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(104);
/* unused harmony reexport Button */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(177);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(514);
/* unused harmony reexport ButtonToolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(515);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(247);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(525);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(526);
/* unused harmony reexport Clearfix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloseButton__ = __webpack_require__(176);
/* unused harmony reexport CloseButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ControlLabel__ = __webpack_require__(527);
/* unused harmony reexport ControlLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Col__ = __webpack_require__(528);
/* unused harmony reexport Col */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Collapse__ = __webpack_require__(180);
/* unused harmony reexport Collapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(119);
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownButton__ = __webpack_require__(543);
/* unused harmony reexport DropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Fade__ = __webpack_require__(122);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form__ = __webpack_require__(544);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormControl__ = __webpack_require__(545);
/* unused harmony reexport FormControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormGroup__ = __webpack_require__(548);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Glyphicon__ = __webpack_require__(179);
/* unused harmony reexport Glyphicon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Grid__ = __webpack_require__(256);
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HelpBlock__ = __webpack_require__(549);
/* unused harmony reexport HelpBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Image__ = __webpack_require__(550);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InputGroup__ = __webpack_require__(551);
/* unused harmony reexport InputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Jumbotron__ = __webpack_require__(554);
/* unused harmony reexport Jumbotron */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Label__ = __webpack_require__(555);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroup__ = __webpack_require__(556);
/* unused harmony reexport ListGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__ = __webpack_require__(257);
/* unused harmony reexport ListGroupItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Media__ = __webpack_require__(123);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(563);
/* unused harmony reexport MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Modal__ = __webpack_require__(564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_33__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalBody__ = __webpack_require__(262);
/* unused harmony reexport ModalBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalFooter__ = __webpack_require__(263);
/* unused harmony reexport ModalFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalHeader__ = __webpack_require__(264);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalTitle__ = __webpack_require__(265);
/* unused harmony reexport ModalTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Nav__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_38__Nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Navbar__ = __webpack_require__(580);
/* unused harmony reexport Navbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__NavbarBrand__ = __webpack_require__(267);
/* unused harmony reexport NavbarBrand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavDropdown__ = __webpack_require__(584);
/* unused harmony reexport NavDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NavItem__ = __webpack_require__(268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_42__NavItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Overlay__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_43__Overlay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__OverlayTrigger__ = __webpack_require__(591);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_44__OverlayTrigger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__PageHeader__ = __webpack_require__(592);
/* unused harmony reexport PageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__PageItem__ = __webpack_require__(593);
/* unused harmony reexport PageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Pager__ = __webpack_require__(595);
/* unused harmony reexport Pager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Pagination__ = __webpack_require__(596);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Panel__ = __webpack_require__(598);
/* unused harmony reexport Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__PanelGroup__ = __webpack_require__(242);
/* unused harmony reexport PanelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Popover__ = __webpack_require__(604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_51__Popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ProgressBar__ = __webpack_require__(605);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Radio__ = __webpack_require__(606);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ResponsiveEmbed__ = __webpack_require__(607);
/* unused harmony reexport ResponsiveEmbed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Row__ = __webpack_require__(608);
/* unused harmony reexport Row */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__SafeAnchor__ = __webpack_require__(41);
/* unused harmony reexport SafeAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SplitButton__ = __webpack_require__(609);
/* unused harmony reexport SplitButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Tab__ = __webpack_require__(611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_58__Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__TabContainer__ = __webpack_require__(185);
/* unused harmony reexport TabContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContent__ = __webpack_require__(186);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Table__ = __webpack_require__(612);
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__TabPane__ = __webpack_require__(276);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Tabs__ = __webpack_require__(613);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_63__Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Thumbnail__ = __webpack_require__(614);
/* unused harmony reexport Thumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__ToggleButton__ = __webpack_require__(277);
/* unused harmony reexport ToggleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ToggleButtonGroup__ = __webpack_require__(615);
/* unused harmony reexport ToggleButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Tooltip__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_67__Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Well__ = __webpack_require__(617);
/* unused harmony reexport Well */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__utils__ = __webpack_require__(618);
/* unused harmony reexport utils */













































































































































/***/ }),
/* 21 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logo_avenuepm_png__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logo_avenuepm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_logo_avenuepm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TeachersComponent_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DropDownNotifications__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ModalFormComponents_ReportBugForm__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_select__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_logo_wordmark_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_logo_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_logo_wordmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__RequestAccountComponent_RequestAccount__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DialogBox__ = __webpack_require__(12);
var _this8=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var appIcon="";var addClassInstruction=null;var addStudentInstruction=null;var PNInstruction=null;var WSSInstruction=null;var CopyrightInstruction=null;var KidsignInstruction=null;var KidspeakInstruction=null;var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'45%'}};var getValue=function getValue(opts,val){return opts.find(function(o){return o.value===val;});};var ResourcesLinkComponent=function(_Component){_inherits(ResourcesLinkComponent,_Component);function ResourcesLinkComponent(props){_classCallCheck(this,ResourcesLinkComponent);var _this=_possibleConstructorReturn(this,(ResourcesLinkComponent.__proto__||Object.getPrototypeOf(ResourcesLinkComponent)).call(this,props));_this.state={openSurvey:false,analytics:{type:null,metadata:null}};_this.handleClick=_this.handleClick.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(ResourcesLinkComponent,[{key:'handleSurveyBack',value:function handleSurveyBack(){}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_5__REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleClick',value:function handleClick(){var _this2=this;this.setState({openSurvey:true,analytics:{type:__WEBPACK_IMPORTED_MODULE_21__DataTrackingPoints__["b" /* default */].RESOURCES_DOWNLOAD,metadata:{resourceId:this.props.value}}},function(){return _this2.handleAnalytics();});}},{key:'render',value:function render(){var sameTab=this.props.sameTab;var target=void 0;if(sameTab){target="";}else{target="_blank";}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:'ResourceLink',userId:this.props.teacherId,active:this.state.openSurvey,surveyBack:this.handleSurveyBack}),this.props.download==="No"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleClick,href:this.props.url,target:target},this.props.title):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleClick,href:this.props.url,target:target,download:true},this.props.title));}}]);return ResourcesLinkComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var VideoTutorialComponent=function(_Component2){_inherits(VideoTutorialComponent,_Component2);function VideoTutorialComponent(props){_classCallCheck(this,VideoTutorialComponent);var _this3=_possibleConstructorReturn(this,(VideoTutorialComponent.__proto__||Object.getPrototypeOf(VideoTutorialComponent)).call(this,props));_this3.state={analytics:{type:null,metadata:null}};_this3.handleClick=_this3.handleClick.bind(_this3);_this3.handleAnalytics=_this3.handleAnalytics.bind(_this3);return _this3;}_createClass(VideoTutorialComponent,[{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_5__REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleClick',value:function handleClick(){var _this4=this;this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_21__DataTrackingPoints__["b" /* default */].VIDEO_PLAY,metadata:{videoId:this.props.id}}},function(){return _this4.handleAnalytics();});this.props.handleOpenVideo(this.props.id,this.props.title,this.props.url);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleClick},this.props.title));}}]);return VideoTutorialComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Header=function(_Component3){_inherits(HeaderComponent,_Component3);function HeaderComponent(props){var _this6=this;_classCallCheck(this,HeaderComponent);var _this5=_possibleConstructorReturn(this,(HeaderComponent.__proto__||Object.getPrototypeOf(HeaderComponent)).call(this,props));_this5.handleSchoolChange=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(newValue){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this5.setState({schoolValue:newValue.value});case 2:_context.next=4;return _this5.props.selectSchool(newValue.value);case 4:console.log('school select:'+_this5.props.lastSchool);_this5.props.changeSchool(newValue.value);case 6:case'end':return _context.stop();}}},_callee,_this6);}));return function(_x){return _ref.apply(this,arguments);};}();_this5.handleLogout=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_5__REST__["a" /* default */].logout().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!response.success){_context2.next=13;break;}if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_context2.next=8;return _this5.props.persistor.purge();case 8:_context2.next=10;return _this5.props.userLogout();case 10:_this5.props.history.push("/");_context2.next=14;break;case 13:alert(response.msg);case 14:case'end':return _context2.stop();}}},_callee2,_this6);}));return function(_x2){return _ref3.apply(this,arguments);};}(),function(error){alert(error.msg);});case 2:case'end':return _context3.stop();}}},_callee3,_this6);}));_this5.state={getStarted:false,schoolOptions:[],schoolValue:'',showVideo:false,videoURL:null,videoId:null,videoTitle:null};_this5.handleOpenVideo=_this5.handleOpenVideo.bind(_this5);_this5.handleCloseVideo=_this5.handleCloseVideo.bind(_this5);_this5.handleLogout=_this5.handleLogout.bind(_this5);_this5.handleTeachers=_this5.handleTeachers.bind(_this5);_this5.handleSchools=_this5.handleSchools.bind(_this5);_this5.handleContent=_this5.handleContent.bind(_this5);_this5.handleGetStarted=_this5.handleGetStarted.bind(_this5);_this5.closeGetStarted=_this5.closeGetStarted.bind(_this5);_this5.handleSurveyBack=_this5.handleSurveyBack.bind(_this5);return _this5;}_createClass(HeaderComponent,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!this.props.schoolAdmin){_context5.next=3;break;}_context5.next=3;return __WEBPACK_IMPORTED_MODULE_5__REST__["a" /* default */].listAdminSchools(this.props.schoolAdmin.id).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(response){var data,schools,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,school;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!response.success){_context4.next=31;break;}data=response.body;schools=[];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context4.prev=6;for(_iterator=data[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){school=_step.value;schools.push({value:school.id,label:school.name});}_context4.next=14;break;case 10:_context4.prev=10;_context4.t0=_context4['catch'](6);_didIteratorError=true;_iteratorError=_context4.t0;case 14:_context4.prev=14;_context4.prev=15;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 17:_context4.prev=17;if(!_didIteratorError){_context4.next=20;break;}throw _iteratorError;case 20:return _context4.finish(17);case 21:return _context4.finish(14);case 22:_context4.next=24;return _this7.setState({schoolOptions:schools});case 24:_context4.next=26;return _this7.props.schoolLoaded(schools);case 26:if(!_this7.props.lastSchool){_context4.next=29;break;}_context4.next=29;return _this7.setState({schoolValue:_this7.props.lastSchool});case 29:_context4.next=32;break;case 31:console.log('Error',response.msg);case 32:case'end':return _context4.stop();}}},_callee4,_this7,[[6,10,14,22],[15,,17,21]]);}));return function(_x3){return _ref5.apply(this,arguments);};}(),function(error){console.log('Error',error.msg);});case 3:case'end':return _context5.stop();}}},_callee5,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'handleSurveyBack',value:function handleSurveyBack(){}},{key:'handleOpenVideo',value:function handleOpenVideo(id,title,url){this.setState({showVideo:true,videoURL:url,videoId:id,videoTitle:title});}},{key:'handleCloseVideo',value:function handleCloseVideo(){this.setState({showVideo:false,videoURL:null,videoId:null,videoTitle:null});}},{key:'handleTeachers',value:function handleTeachers(event){this.props.history.push("/admin");}},{key:'handleContent',value:function handleContent(event){this.props.history.push("/content");}},{key:'handleSchools',value:function handleSchools(event){this.props.history.push("/school-management");}},{key:'handleGetStarted',value:function handleGetStarted(event){this.setState({getStarted:true});}},{key:'closeGetStarted',value:function closeGetStarted(event){this.setState({getStarted:false});}},{key:'render',value:function render(){var PNModel=void 0;if(this.props.appName==='Picture Naming'){appIcon=__WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png___default.a;if(this.props.PNModel==="computer"){PNModel="(Computer Tasks)";}else if(this.props.PNModel==="manual"){PNModel="(Picture Cards)";}else{PNModel="(1-1 Computer Tasks)";}}if(this.props.appName==='CopyRight'){appIcon=__WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png___default.a;}if(this.props.appName==='Word Sign/Say'){appIcon=__WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png___default.a;}if(this.props.appName==='Slash'){appIcon=__WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png___default.a;}if(this.props.appName==='KidSpeak'){appIcon=__WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png___default.a;}if(this.props.appName==='Maze'){appIcon=__WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png___default.a;}if(this.props.appName==='KidSign'){appIcon=__WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png___default.a;}if(this.props.appName==='WordMark'){appIcon=__WEBPACK_IMPORTED_MODULE_19__assets_images_logo_wordmark_png___default.a;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('nav',{id:'header',className:'navbar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'header-container',className:'container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar-header fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'brand',className:'navbar-brand',href:'/'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_logo_avenuepm_png___default.a,alt:'AvenuePM Home',border:'0'}))),this.props.admin||this.props.contentManagement||this.props.schoolManagement?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'navbar',className:'navbar fr',onClick:this.handleContent},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.props.contentManagement?"handBtn active":"handBtn "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Content'))),this.props.userId==100?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'navbar',className:'navbar fr',onClick:this.handleTeachers},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.props.admin?"handBtn active":"handBtn "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Teachers'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'navbar',className:'navbar fr',onClick:this.handleSchools},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.props.schoolManagement?"handBtn active":"handBtn "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Schools')))):null):null,this.props.schoolAdmin?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-5 "},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{marginLeft:50}},'School:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-7",style:{marginLeft:-80}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{onChange:this.handleSchoolChange,options:this.state.schoolOptions,placeholder:"Select a school...",value:getValue(this.state.schoolOptions,this.state.schoolValue)})))):null,this.props.dataCharts?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar col-md-6"},this.props.imageSrc?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{style:{fontSize:25,position:'relative',fontWeight:'normal',top:-10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:appIcon,alt:this.props.appName,style:{position:'relative',top:-4,width:45,borderRadius:'25%',border:'1px dashed #000'}}),' ',this.props.sName.user.firstname,' ',this.props.sName.user.lastname,' ',PNModel):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{style:{fontSize:25,position:'relative',top:5,fontWeight:'normal'}},this.props.appName,' : ',this.props.sName.user.firstname,' ',this.props.sName.user.lastname,' ',PNModel)):null,this.props.gradingApps?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar col-md-6"},this.props.imageSrc?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{style:{fontSize:25,position:'relative',fontWeight:'normal'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.props.imageSrc,style:{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}),' ',this.props.sName.user.firstname,' ',this.props.sName.user.lastname):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{style:{fontSize:25,position:'relative',top:5,fontWeight:'normal'}},this.props.appName,' : ',this.props.sName.user.firstname,' ',this.props.sName.user.lastname,' ',this.PNModel)):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'navbar',className:'navbar fr',onClick:this.props.logout?this.props.logout:this.handleLogout},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Log Out'))),this.props.bugReport?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ModalFormComponents_ReportBugForm__["a" /* default */],this.props):null,this.props.notifications?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DropDownNotifications__["a" /* default */],this.props):null,this.props.dataCharts||this.props.admin||this.props.contentManagement||this.props.schoolManagement?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'navbar',className:'navbar fr',onClick:this.handleGetStarted,style:{marginLeft:-30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'handBtn  active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Getting Started'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.state.getStarted,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Getting Started'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:104,teacherId:this.props.teacherId,url:"https://docs.google.com/document/d/1tq1YlUUnuJJ7rkRWac7W1-nL-GyxujEnchIGj5YfQAE/",title:"How to Log in, Create a Class and Add a Student"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:102,teacherId:this.props.teacherId,url:"https://youtu.be/MJV2hAipd5c",title:"VIDEO: How to Log in, Create a Class and Add a Student"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:103,teacherId:this.props.teacherId,url:"https://docs.google.com/document/d/1A88PHzgLpOFqDNfT2WSxRDCCrMf-objT1J0sgS67b94/edit?usp=sharing",title:"Selecting apps for a student"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:105,teacherId:this.props.teacherId,url:"https://docs.google.com/document/d/1nZqoGGYdv3Ba7CkvdbYSoYAboWa3bvwN-_NzLPysdQM/edit?usp=sharing",title:"Add a Parent Account"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:108,teacherId:this.props.teacherId,url:"https://docs.google.com/document/d/1bq4Oxxgtvdu0IrFwV-5Y41Ayt6z1mLIR5lGxGneV1PI/edit?usp=sharing",title:"Share a Student"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:109,teacherId:this.props.teacherId,url:"https://docs.google.com/document/d/1Et2sZWpNL_tZJzgvhI7LENaHIASxia9r/edit",title:"Technical documentation for each of the apps"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'When You\u2019re Ready'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:106,teacherId:this.props.teacherId,url:"https://docs.google.com/document/d/1Sx4IklA7n5YlxPyGHTPwb1GKIp4nR5lWBdvfCZEYzq8/edit?usp=sharing",title:"Scoring"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:107,teacherId:this.props.teacherId,url:"https://docs.google.com/document/d/1SU81DQjcqJkfexNCO3oVU_UpBRt13LD0EKSk3Wul-qo/edit?usp=sharing",title:"Accessing the Data Charts: Overview"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:40,teacherId:this.props.teacherId,url:"https://docs.google.com/document/d/1Et2sZWpNL_tZJzgvhI7LENaHIASxia9r/edit",title:"App Info"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.closeGetStarted,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))))));}}]);return HeaderComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{selectSchool:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(selectedSchool){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__TeachersComponent_actions__["c" /* selectSchool */])(selectedSchool));case 2:return _context6.abrupt('return',_context6.sent);case 3:case'end':return _context6.stop();}}},_callee6,_this8);}));function selectSchool(_x4){return _ref6.apply(this,arguments);}return selectSchool;}(),userLogout:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__TeachersComponent_actions__["j" /* userLogout */])());case 2:return _context7.abrupt('return',_context7.sent);case 3:case'end':return _context7.stop();}}},_callee7,_this8);}));function userLogout(){return _ref7.apply(this,arguments);}return userLogout;}()};};var mapStateToProps=function mapStateToProps(state){return{lastSchool:state.teacherReducer.lastSchool};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Header)));

/***/ }),
/* 25 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = updateStudent;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateTeacher;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateSchoolAdmin;
/* unused harmony export updateChartData */
/* unused harmony export updateFunctionUpdateNote */
/* unused harmony export updateAppName */
/* harmony export (immutable) */ __webpack_exports__["b"] = selectClass;
/* harmony export (immutable) */ __webpack_exports__["f"] = selectTeacher;
/* harmony export (immutable) */ __webpack_exports__["c"] = selectSchool;
/* harmony export (immutable) */ __webpack_exports__["e"] = selectStudentTab;
/* harmony export (immutable) */ __webpack_exports__["d"] = selectStudentScoreListTab;
/* harmony export (immutable) */ __webpack_exports__["j"] = userLogout;
/* harmony export (immutable) */ __webpack_exports__["a"] = prepareChartData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function updateStudent(data){return{type:"UPDATE_STUDENT",student:data};}function updateTeacher(data){return{type:"UPDATE_TEACHER",teacher:data};}function updateSchoolAdmin(data){return{type:"UPDATE_SCHOOL_ADMIN",schoolAdmin:data};}function updateChartData(data,rules,xLabel,yLabel){return{type:"UPDATE_CHART_DATA",chartData:data,chartRules:rules,xLabel:xLabel,yLabel:yLabel};}function updateFunctionUpdateNote(data){return{type:"UPDATE_FUNCTION_UPDATE_NOTE",updateNote:data};}function updateAppName(data){return{type:"UPDATE_APPNAME",appName:data};}function selectClass(data){return{type:"SELECT_CLASS",lastClass:data};}function selectTeacher(data){return{type:"SELECT_TEACHER",lastTeacher:data};}function selectSchool(data){return{type:"SELECT_SCHOOL",lastSchool:data};}function selectStudentTab(data){return{type:"SELECT_STUDENT_TAB",studentTab:data};}function selectStudentScoreListTab(data){return{type:"SELECT_SCORELIST_TAB",studentScoreListTab:data};}function userLogout(){return{type:"LOGOUT"};}function prepareChartData(data){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Promise.all([dispatch(updateAppName(data.appName)),dispatch(updateStudent(data.student)),dispatch(updateFunctionUpdateNote(data.updateNote)),//dispatch(updateTeacher(data.teacher)),
dispatch(updateChartData(data.chartData,data.chartRules,data.xLabel,data.yLabel))]);case 2:case"end":return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(468);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUCKET_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAIN; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
//export const API_URL = 'http://localhost:3000/';
//export const API_URL = 'http://Avepmdev2025-env-1.eba-ww3xnmvu.us-east-2.elasticbeanstalk.com/';
//export const API_URL = 'https://Avepmdev2025-env-1.eba-ww3xnmvu.us-east-2.elasticbeanstalk.com/';
//export const API_URL = 'https://api-dev.avepm.com/';
//export const API_URL = 'https://avepm2025-env-1.eba-mqvqu5yz.us-east-2.elasticbeanstalk.com/';
var API_URL='https://api-beta.avepm.com/';//export const BUCKET_URL = "https://us-east-2.console.aws.amazon.com/s3/buckets/uploaddev2025/";
//export const BUCKET_URL = "https://us-east-2.console.aws.amazon.com/s3/buckets/uploadbeta2025/";
var BUCKET_URL="https://uploadbeta2025.s3.us-east-2.amazonaws.com/";//export const BUCKET_URL = "https://s3.us-east-2.amazonaws.com/uploadbeta/";
//export const BUCKET_URL = "https://s3.us-east-2.amazonaws.com/uploadbeta2025/";
var VERSION=__WEBPACK_IMPORTED_MODULE_0__package_json__["version"];var MAIN={API:{LOGIN:API_URL+'sessions/login',LOGOUT:API_URL+'sessions/logout',TOKEN:API_URL+'token',VERSION:API_URL+'version',LIST_USERS:API_URL+'users/list',LIST_SCHOOLS:API_URL+'users/list-schools',LIST_ADMIN_SCHOOLS:API_URL+'users/list-admin-schools',CREATE_SCHOOL:API_URL+'users/create-school',CREATE_USERS:API_URL+'users/create',UPDATE_USERS:API_URL+'users/update',DELETE_PARENT:API_URL+'teacher/students/delete-parent',RESET_PASSWORD:API_URL+'users/password-reset',CHANGE_PASSWORD:API_URL+'users/newpassword',RESET_USERNAME:API_URL+'users/username-request',TEACHER_CONSENT:API_URL+'users/teacher-consent',REQUEST_ACCOUNT:API_URL+'account-request',REQUEST_HELP:API_URL+'help',REPORT_BUG:API_URL+'report-bug',GET_CLASS_LIST:API_URL+'teacher/classes/list',GET_TEACHER_CLASS_LIST:API_URL+'teacher/classes/list-teacher-class',ADD_NEW_CLASS:API_URL+'teacher/classes/create',UPDATE_CLASS:API_URL+'teacher/classes/update',DELETE_CLASS:API_URL+'teacher/classes/delete',LIST_EXTERNAL_TEACHER:API_URL+'teacher/classes/external-list',LIST_STUDENTS:API_URL+'teacher/students/list',ADD_NEW_STUDENT:API_URL+'teacher/students/create',UPDATE_STUDENT:API_URL+'teacher/students/update',TRANSFER_STUDENT:API_URL+'teacher/students/transfer',TRANSFER_MULTIPLE_STUDENT:API_URL+'teacher/students/transfer-multiple',DELETE_STUDENT:API_URL+'teacher/students/delete',STUDENT_NOTIFICATIONS:API_URL+'teacher/students/notifications',LIST_TEACHERS:API_URL+'admin/teachers/list',LIST_TEACHERS_IN_SCHOOL:API_URL+'admin/teachers/list-teachers-in-school',CREATE_TEACHER:API_URL+'admin/teachers/create',UPDATE_TEACHER:API_URL+'admin/teachers/update',DELETE_TEACHER:API_URL+'admin/teachers/delete',LIST_SCHOOLADMINS:API_URL+'admin/schooladmins/list',CREATE_SCHOOLADMIN:API_URL+'admin/schooladmins/create',UPDATE_SCHOOLADMIN:API_URL+'admin/schooladmins/update',DELETE_SCHOOLADMIN:API_URL+'admin/schooladmins/delete',GET_STUDENT_BEST_SCORE:API_URL+'student/bestscores/view',CHECK_STUDENT_DATA:API_URL+'teacher/students/checkStudentData',GET_SURVEY_AMOUNT:API_URL+'teacher/students/getSurveyAmount',CHECK_SURVEY_HOMEPAGE:API_URL+'teacher/students/get-survey-homepage',CHECK_TEACHER_LOGIN:API_URL+'teacher/survey/check-homepage',CHECK_TEACHER_RESOURCES:API_URL+'teacher/survey/check-resources',CHECK_TEACHER_DATA_CHART:API_URL+'teacher/survey/check-data-chart',CHECK_TEACHER_GRADING:API_URL+'teacher/survey/check-grading',GET_MAZE_CONTENT:API_URL+'apps/maze/mazecontent',GET_MAZE_SCORE_COUNT:API_URL+'apps/maze/countscores',GET_MAZE_DISTRACTORS:API_URL+'apps/maze/distractors',LIST_RANDOM_MAZE:API_URL+'apps/maze/mazerandom',LIST_MAZE_SCORE_DATA:API_URL+'apps/maze/score-data',UPDATE_MAZE_SCORE:API_URL+'apps/maze/mazebestscore',UPDATE_MAZE_SCORE_NOTE:API_URL+'apps/maze/score-note',POST_MAZE_SESSION:API_URL+'apps/maze/maze-session',CREATE_MAZE_CONTENT:API_URL+'apps/maze/create',GET_SLASH_CONTENT:API_URL+'apps/slash/slashcontent',GET_SLASH_SCORE_COUNT:API_URL+'apps/slash/countscores',LIST_RANDOM_SLASH:API_URL+'apps/slash/slashrandom',LIST_SLASH_SCORE_DATA:API_URL+'apps/slash/score-data',UPDATE_SLASH_SCORE:API_URL+'apps/slash/slashbestscore',UPDATE_SLASH_SCORE_NOTE:API_URL+'apps/slash/score-note',POST_SLASH_SESSION:API_URL+'apps/slash/slash-session',ADD_WORDMARK_SESSION:API_URL+'apps/wordmark/wordmark-session',LIST_WORDMARK_SCORE:API_URL+'apps/wordmark/score-list',UPDATE_WORDMARK_GRADE:API_URL+'apps/wordmark/wordmark-grade',LIST_RANDOM_WORDMARK:API_URL+'apps/wordmark/wordmarkrandom',GET_WORDMARK_SCORE_DATA:API_URL+'apps/wordmark/score-data',UPDATE_WORDMARK_SCORE_NOTE:API_URL+'apps/wordmark/score-note',POST_WORDMARK_SESSION:API_URL+'apps/wordmark/wordmark-session',DELETE_WORDMARK_SCORE:API_URL+'apps/wordmark/delete',GET_WORDMARK_SESSION:API_URL+'apps/wordmark/wordmark-session',ADD_WORDMARK2_SESSION:API_URL+'apps/wordmark2/wordmark-session',LIST_WORDMARK2_SCORE:API_URL+'apps/wordmark2/score-list',UPDATE_WORDMARK2_GRADE:API_URL+'apps/wordmark2/wordmark-grade',LIST_RANDOM1_WORDMARK2:API_URL+'apps/wordmark2/wordmark2random1',LIST_RANDOM2_WORDMARK2:API_URL+'apps/wordmark2/wordmark2random2',GET_WORDMARK2_SCORE_DATA:API_URL+'apps/wordmark2/score-data',UPDATE_WORDMARK2_SCORE_NOTE:API_URL+'apps/wordmark2/score-note',POST_WORDMARK2_SESSION:API_URL+'apps/wordmark2/wordmark-session',DELETE_WORDMARK2_SCORE:API_URL+'apps/wordmark2/delete',GET_WORDMARK2_SESSION:API_URL+'apps/wordmark2/wordmark-session',UPLOAD_KIDSPEAK_FILE:API_URL+'apps/kidspeak/upload',DELETE_KIDSPEAK_FILE:API_URL+'apps/kidspeak/delete-audio',ADD_KIDSPEAK_SESSION:API_URL+'apps/kidspeak/ks-session',GET_KIDSPEAK_SESSION:API_URL+'apps/kidspeak/ks-session',GET_KIDSPEAK_SCORE_LIST:API_URL+'apps/kidspeak/score-list',UPDATE_KIDSPEAK_GRADE:API_URL+'apps/kidspeak/ks-grade',GET_KIDSPEAK_RANDOM:API_URL+'apps/kidspeak/ksrandom',GET_KIDSPEAK_DATA:API_URL+'apps/kidspeak/score-data',UPDATE_KIDSPEAK_SCORE_NOTE:API_URL+'apps/kidspeak/score-note',DELETE_KIDSPEAK_SCORE:API_URL+'apps/kidspeak/delete',UPDATE_KIDSPEAK_BEST_SCORE:API_URL+"apps/kidspeak/ksbestscore",List_MAZE_PASSAGE:API_URL+"apps/maze/list-passage",ADD_MAZE_PASSAGE:API_URL+"apps/maze/add-passage",DELETE_MAZE_PASSAGE:API_URL+"apps/maze/delete-passage",UPDATE_MAZE_PASSAGE:API_URL+"apps/maze/update-passage",ACTIVEATE_MAZE_PASSAGE:API_URL+"apps/maze/activate-passage",List_KIDSPEAK_PASSAGE:API_URL+"apps/kidspeak/list-passage",List_KIDSPEAK_PASSAGE_BY_UID:API_URL+"apps/kidspeak/list-passage-by-uid",ADD_KIDSPEAK_PASSAGE:API_URL+"apps/kidspeak/add-passage",DELETE_KIDSPEAK_PASSAGE:API_URL+"apps/kidspeak/delete-passage",UPDATE_KIDSPEAK_PASSAGE:API_URL+"apps/kidspeak/update-passage",ACTIVEATE_KIDSPEAK_PASSAGE:API_URL+"apps/kidspeak/activate-passage",UPLOAD_PICTURENAMING_FILE:API_URL+'apps/picturenaming/upload',DELETE_PICTURENAMING_FILE:API_URL+'apps/picturenaming/delete-video',ADD_PICTURENAMING_SESSION:API_URL+'apps/picturenaming/pn-session',GET_PICTURENAMING_SESSION:API_URL+'apps/picturenaming/pn-session',GET_PICTURENAMING_SCORE_LIST:API_URL+'apps/picturenaming/score-list',UPDATE_PICTURENAMING_GRADE:API_URL+'apps/picturenaming/pn-grade',PICTURENAMING_MANUAL_GRADE:API_URL+'apps/picturenaming/pn-manual-grade',GET_PICTURENAMING_MANUAL_SCORE:API_URL+'apps/picturenaming/pn-manual-score',GET_PICTURENAMING_RANDOM:API_URL+'apps/picturenaming/pnrandom',GET_PICTURENAMING_DATA:API_URL+'apps/picturenaming/score-data',UPDATE_PICTURENAMING_SCORE_NOTE:API_URL+'apps/picturenaming/score-note',ADD_PICTURENAMING_1ON1:API_URL+'apps/picturenaming/pn-1On1',DELETE_PICTURENAMING_SCORE:API_URL+'apps/picturenaming/delete',START_PICTURENAMING_WEBSOCKET:API_URL.replace("http","ws")+'apps/picturenaming/session-join',UPDATE_PICTURENAMING_BEST_SCORE:API_URL+"apps/picturenaming/pnbestscore",UPLOAD_COPYRIGHT_FILE:API_URL+'apps/copyright/upload',DELETE_COPYRIGHT_FILE:API_URL+'apps/copyright/delete-audio',ADD_COPYRIGHT_SESSION:API_URL+'apps/copyright/cr-session',GET_COPYRIGHT_SESSION:API_URL+'apps/copyright/cr-session',GET_COPYRIGHT_SCORE_LIST:API_URL+'apps/copyright/score-list',UPDATE_COPYRIGHT_GRADE:API_URL+'apps/copyright/cr-grade',GET_COPYRIGHT_RANDOM:API_URL+'apps/copyright/crrandom',GET_COPYRIGHT_DATA:API_URL+'apps/copyright/score-data',UPDATE_COPYRIGHT_SCORE_NOTE:API_URL+'apps/copyright/score-note',DELETE_COPYRIGHT_SCORE:API_URL+'apps/copyright/delete',UPDATE_COPYRIGHT_BEST_SCORE:API_URL+"apps/copyright/crbestscore",UPLOAD_WORDSIGNSAY_FILE:API_URL+'apps/wordsignsay/upload',DELETE_WORDSIGNSAY_FILE:API_URL+'apps/wordsignsay/delete-video',ADD_WORDSIGNSAY_SESSION:API_URL+'apps/wordsignsay/wss-session',GET_WORDSIGNSAY_SESSION:API_URL+'apps/wordsignsay/wss-session',GET_WORDSIGNSAY_SCORE_LIST:API_URL+'apps/wordsignsay/score-list',UPDATE_WORDSIGNSAY_GRADE:API_URL+'apps/wordsignsay/wss-grade',GET_WORDSIGNSAY_RANDOM:API_URL+'apps/wordsignsay/wssrandom',GET_WORDSIGNSAY_DATA:API_URL+'apps/wordsignsay/score-data',UPDATE_WORDSIGNSAY_SCORE_NOTE:API_URL+'apps/wordsignsay/score-note',UPDATE_WORDSIGNSAY_BEST_SCORE:API_URL+"apps/wordsignsay/wssbestscore",DELETE_WORDSIGNSAY_SCORE:API_URL+'apps/wordsignsay/delete',UPLOAD_KIDSIGN_FILE:API_URL+'apps/kidsign/upload',DELETE_KIDSIGN_FILE:API_URL+'apps/kidsign/delete-audio',ADD_KIDSIGN_SESSION:API_URL+'apps/kidsign/kss-session',GET_KIDSIGN_SESSION:API_URL+'apps/kidsign/kss-session',GET_KIDSIGN_SCORE_LIST:API_URL+'apps/kidsign/score-list',UPDATE_KIDSIGN_GRADE:API_URL+'apps/kidsign/kss-grade',GET_KIDSIGN_RANDOM:API_URL+'apps/kidsign/kssrandom',GET_KIDSIGN_DATA:API_URL+'apps/kidsign/score-data',UPDATE_KIDSIGN_SCORE_NOTE:API_URL+'apps/kidsign/score-note',DELETE_KIDSIGN_SCORE:API_URL+'apps/kidsign/delete',UPDATE_KIDSIGN_BEST_SCORE:API_URL+"apps/kidsign/kssbestscore",GET_USER_BESTSCORES:API_URL+"student/bestscores/grade-view",GET_STUDENT_APPS_STATUS:API_URL+"student/apps/status",GET_UNGRADED_TASKS:API_URL+"student/apps/ungraded-tasks",GET_PARENT_STUDENTS:API_URL+"student/apps/getParentStudents",ADD_ANALYTICS:API_URL+"analytics/add",ADD_ANALYTICS_NONUSER:API_URL+"analytics/add-nonuser"}};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export updateStudent */
/* harmony export (immutable) */ __webpack_exports__["c"] = updateParent;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateStudentUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateFirstLogin;
/* unused harmony export updateTeacher */
/* unused harmony export updateChartData */
/* unused harmony export updateFunctionUpdateNote */
/* unused harmony export updateAppName */
/* unused harmony export selectClass */
/* unused harmony export studentLogout */
/* harmony export (immutable) */ __webpack_exports__["e"] = updateStudentAppsStatus;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateStudentAccountTab;
/* harmony export (immutable) */ __webpack_exports__["a"] = updateAppStates;
function updateStudent(data){return{type:"UPDATE_STUDENT",student:data};}function updateParent(data){return{type:"UPDATE_PARENT",student:data};}function updateStudentUser(data){return{type:"UPDATE_STUDENT_USER",studentUser:data};}function updateFirstLogin(data){return{type:"UPDATE_FIRST_LOGIN",firstLogin:data};}function updateTeacher(data){return{type:"UPDATE_TEACHER",teacher:data};}function updateChartData(data,rules,xLabel,yLabel){return{type:"UPDATE_CHART_DATA",chartData:data,chartRules:rules,xLabel:xLabel,yLabel:yLabel};}function updateFunctionUpdateNote(data){return{type:"UPDATE_FUNCTION_UPDATE_NOTE",updateNote:data};}function updateAppName(data){return{type:"UPDATE_APPNAME",appName:data};}function selectClass(data){return{type:"SELECT_CLASS",lastClass:data};}function studentLogout(){return{type:"LOGOUT"};}function updateStudentAppsStatus(apps){return{type:"UPDATE_STUDENT_APPS_STATUS",apps:apps};}function updateStudentAccountTab(tabNum){return{type:"UPDATE_STUDENT_ACCOUNT_TAB",tabNum:tabNum};}function updateAppStates(appStates){return{type:"UPDATE_STUDENT_APP_STATES",appStates:appStates};}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_logo_avenuepm_png__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_logo_avenuepm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_logo_avenuepm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_Twitter_Social_Icon_png__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_Twitter_Social_Icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_Twitter_Social_Icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Facebook_logo_png__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Facebook_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_Facebook_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(FooterComponent,_Component);function FooterComponent(){_classCallCheck(this,FooterComponent);return _possibleConstructorReturn(this,(FooterComponent.__proto__||Object.getPrototypeOf(FooterComponent)).apply(this,arguments));}_createClass(FooterComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:25}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6',style:{textAlign:'right',paddingRight:80}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Follow us: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:-1,marginLeft:-60}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://twitter.com/AvenuePM",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_Twitter_Social_Icon_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Twitter')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:55,marginTop:-28}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://www.facebook.com/profile.php?id=100009224578527&lst=100006500830477%3A100009224578527%3A1587693428&sk=timeline",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_Facebook_logo_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Facebook')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xA9',new Date().getFullYear()>2010&&new Date().getFullYear(),' ','Designed and developed by researchers at the University of Minnesota and Penn State University.'))));}}]);return FooterComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};

var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};

var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];

var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LevelAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LevelTrackerComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LevelTrackerMainComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VideoComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return YouTubeVideoComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CountDownComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Buttons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Buttons1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_apps_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_apps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_apps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_player__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_animated_css__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_animated_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_animated_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_levels_level0_png__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_levels_level0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_levels_level0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_levels_level1_png__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_levels_level1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_levels_level1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_levels_level2_png__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_levels_level2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_levels_level2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_levels_level3_png__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_levels_level3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_levels_level3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_levels_level4_png__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_levels_level4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_levels_level4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_levels_level5_png__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_levels_level5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_levels_level5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_levels_level6_png__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_levels_level6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_levels_level6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_levels_level7_png__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_levels_level7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_levels_level7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_levels_level8_png__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_levels_level8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_levels_level8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_levels_level9_png__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_levels_level9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_levels_level9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_levels_level10_png__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_levels_level10_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_levels_level10_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_levels_level11_png__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_levels_level11_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_levels_level11_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_levels_medal_level0_png__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_levels_medal_level0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_levels_medal_level0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_levels_medal_level1_png__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_levels_medal_level1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_levels_medal_level1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_levels_medal_level2_png__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_levels_medal_level2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_images_levels_medal_level2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_levels_medal_level3_png__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_levels_medal_level3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_images_levels_medal_level3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_levels_medal_level4_png__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_levels_medal_level4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_images_levels_medal_level4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_levels_medal_level5_png__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_levels_medal_level5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_images_levels_medal_level5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_images_levels_medal_level6_png__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_images_levels_medal_level6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_images_levels_medal_level6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_levels_medal_level7_png__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_levels_medal_level7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_images_levels_medal_level7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_images_levels_medal_level8_png__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_images_levels_medal_level8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_images_levels_medal_level8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_images_levels_medal_level9_png__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_images_levels_medal_level9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_images_levels_medal_level9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_images_levels_medal_level10_png__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_images_levels_medal_level10_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_images_levels_medal_level10_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_images_levels_medal_level11_png__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_images_levels_medal_level11_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_images_levels_medal_level11_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_images_activeStepBar_png__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_images_activeStepBar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_images_activeStepBar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_images_inactiveStepBar_png__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_images_inactiveStepBar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__assets_images_inactiveStepBar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_images_badge_1_png__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_images_badge_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__assets_images_badge_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_images_badge_2_png__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_images_badge_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__assets_images_badge_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_images_badge_3_png__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_images_badge_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__assets_images_badge_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__assets_images_badge_4_png__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__assets_images_badge_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__assets_images_badge_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__assets_images_badge_5_png__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__assets_images_badge_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__assets_images_badge_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__assets_images_badge_6_png__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__assets_images_badge_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__assets_images_badge_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__assets_images_badge_7_png__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__assets_images_badge_7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__assets_images_badge_7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__assets_images_data_chart_png__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__assets_images_data_chart_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__assets_images_data_chart_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__TeachersComponent_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_lottie_react__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_lottie_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_lottie_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__assets_images_words_excellent_json__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__assets_images_words_excellent_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__assets_images_words_excellent_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__assets_images_words_fantastic_json__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__assets_images_words_fantastic_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__assets_images_words_fantastic_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__assets_images_words_good_work_json__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__assets_images_words_good_work_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__assets_images_words_good_work_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__assets_images_words_great_job_json__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__assets_images_words_great_job_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__assets_images_words_great_job_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__assets_images_words_great_json__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__assets_images_words_great_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__assets_images_words_great_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__assets_images_words_hooray_json__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__assets_images_words_hooray_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__assets_images_words_hooray_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__assets_images_words_well_done_json__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__assets_images_words_well_done_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__assets_images_words_well_done_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__assets_images_words_wow_json__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__assets_images_words_wow_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__assets_images_words_wow_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__assets_images_words_you_did_it_json__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__assets_images_words_you_did_it_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__assets_images_words_you_did_it_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Shared_Helpers__ = __webpack_require__(15);
var _this13=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'45%'}};var LevelAnimation=function(_Component){_inherits(LevelAnimation,_Component);function LevelAnimation(props){_classCallCheck(this,LevelAnimation);var _this=_possibleConstructorReturn(this,(LevelAnimation.__proto__||Object.getPrototypeOf(LevelAnimation)).call(this,props));_this.state={randomTitleNo:Math.floor(Math.random()*9)// 9 animation words
};return _this;}_createClass(LevelAnimation,[{key:'level',value:function level(_level){switch(_level){case 1:return __WEBPACK_IMPORTED_MODULE_8__assets_images_levels_level0_png___default.a;case 2:return __WEBPACK_IMPORTED_MODULE_9__assets_images_levels_level1_png___default.a;case 3:return __WEBPACK_IMPORTED_MODULE_10__assets_images_levels_level2_png___default.a;case 4:return __WEBPACK_IMPORTED_MODULE_11__assets_images_levels_level3_png___default.a;case 5:return __WEBPACK_IMPORTED_MODULE_12__assets_images_levels_level4_png___default.a;case 6:return __WEBPACK_IMPORTED_MODULE_13__assets_images_levels_level5_png___default.a;case 7:return __WEBPACK_IMPORTED_MODULE_14__assets_images_levels_level6_png___default.a;case 8:return __WEBPACK_IMPORTED_MODULE_15__assets_images_levels_level7_png___default.a;case 9:return __WEBPACK_IMPORTED_MODULE_16__assets_images_levels_level8_png___default.a;case 10:return __WEBPACK_IMPORTED_MODULE_17__assets_images_levels_level9_png___default.a;case 11:return __WEBPACK_IMPORTED_MODULE_18__assets_images_levels_level10_png___default.a;case 12:return __WEBPACK_IMPORTED_MODULE_19__assets_images_levels_level11_png___default.a;}}},{key:'render',value:function render(){var level=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{position:'absolute',margin:'auto',top:0,bottom:0,left:0,right:0,maxWidth:70},src:this.props.level<=this.props.maxLevel?this.level(this.props.level):this.props.appName==="slash"?__WEBPACK_IMPORTED_MODULE_36__assets_images_badge_3_png___default.a:__WEBPACK_IMPORTED_MODULE_38__assets_images_badge_5_png___default.a,alt:'animal'});var wordAnimation=null;switch(this.state.randomTitleNo){case 0:wordAnimation=__WEBPACK_IMPORTED_MODULE_49__assets_images_words_excellent_json___default.a;break;case 1:wordAnimation=__WEBPACK_IMPORTED_MODULE_50__assets_images_words_fantastic_json___default.a;break;case 2:wordAnimation=__WEBPACK_IMPORTED_MODULE_51__assets_images_words_good_work_json___default.a;break;case 3:wordAnimation=__WEBPACK_IMPORTED_MODULE_52__assets_images_words_great_job_json___default.a;break;case 4:wordAnimation=__WEBPACK_IMPORTED_MODULE_53__assets_images_words_great_json___default.a;break;case 5:wordAnimation=__WEBPACK_IMPORTED_MODULE_54__assets_images_words_hooray_json___default.a;break;case 6:wordAnimation=__WEBPACK_IMPORTED_MODULE_55__assets_images_words_well_done_json___default.a;break;case 7:wordAnimation=__WEBPACK_IMPORTED_MODULE_56__assets_images_words_wow_json___default.a;break;case 8:wordAnimation=__WEBPACK_IMPORTED_MODULE_57__assets_images_words_you_did_it_json___default.a;break;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_animated_css__["Animated"],{animationIn:'fadeIn',isVisible:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'fixed',top:0,left:0,width:'100%',height:'100%',background:'#fff'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"centeredMiddle"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_animated_css__["Animated"],{animationIn:'zoomIn',isVisible:true,style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_lottie_react___default.a,{style:{width:'50%',height:'50%',marginLeft:'auto',marginRight:'auto',marginBottom:20},animationData:wordAnimation}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'center-block',style:{width:'100%',height:48,position:'relative'}},level),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontFamily:'Neucha',fontSize:40}},this.props.typeLevel),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:80}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.props.closeAnimation,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Continue')))))));}}]);return LevelAnimation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var LevelTrackerComponent=function(_Component2){_inherits(LevelTrackerComponent,_Component2);function LevelTrackerComponent(){_classCallCheck(this,LevelTrackerComponent);return _possibleConstructorReturn(this,(LevelTrackerComponent.__proto__||Object.getPrototypeOf(LevelTrackerComponent)).apply(this,arguments));}_createClass(LevelTrackerComponent,[{key:'level',value:function level(_level2){switch(_level2){case 1:return __WEBPACK_IMPORTED_MODULE_8__assets_images_levels_level0_png___default.a;case 2:return __WEBPACK_IMPORTED_MODULE_9__assets_images_levels_level1_png___default.a;case 3:return __WEBPACK_IMPORTED_MODULE_10__assets_images_levels_level2_png___default.a;case 4:return __WEBPACK_IMPORTED_MODULE_11__assets_images_levels_level3_png___default.a;case 5:return __WEBPACK_IMPORTED_MODULE_12__assets_images_levels_level4_png___default.a;case 6:return __WEBPACK_IMPORTED_MODULE_13__assets_images_levels_level5_png___default.a;case 7:return __WEBPACK_IMPORTED_MODULE_14__assets_images_levels_level6_png___default.a;case 8:return __WEBPACK_IMPORTED_MODULE_15__assets_images_levels_level7_png___default.a;case 9:return __WEBPACK_IMPORTED_MODULE_16__assets_images_levels_level8_png___default.a;case 10:return __WEBPACK_IMPORTED_MODULE_17__assets_images_levels_level9_png___default.a;case 11:return __WEBPACK_IMPORTED_MODULE_18__assets_images_levels_level10_png___default.a;case 12:return __WEBPACK_IMPORTED_MODULE_19__assets_images_levels_level11_png___default.a;}}},{key:'appName',value:function appName(_appName){switch(_appName){case"maze":return __WEBPACK_IMPORTED_MODULE_38__assets_images_badge_5_png___default.a;case"slash":return __WEBPACK_IMPORTED_MODULE_36__assets_images_badge_3_png___default.a;case"copyright":return __WEBPACK_IMPORTED_MODULE_34__assets_images_badge_1_png___default.a;case"picturenaming":return __WEBPACK_IMPORTED_MODULE_40__assets_images_badge_7_png___default.a;case"wordsignsay":return __WEBPACK_IMPORTED_MODULE_37__assets_images_badge_4_png___default.a;case"kidsign":return __WEBPACK_IMPORTED_MODULE_39__assets_images_badge_6_png___default.a;case"kidspeak":return __WEBPACK_IMPORTED_MODULE_35__assets_images_badge_2_png___default.a;}}},{key:'render',value:function render(){var level=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.level(this.props.level),alt:'animal',style:{width:48}});var levelPlus=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.level(this.props.level+1),alt:'another animal',style:{width:48}});var steps=[];var stepCount=this.props.steps||6;if(this.props.stepDir==="UP"||this.props.stepDir===null){for(var i=1;i<=stepCount;i++){if(i<=this.props.step-1){if(i!==this.props.step-1){steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square squareOn "+"greenBox"+i})));}else{steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square squareOn animate-flicker "+"greenBox"+i})));}}else{steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square "+"greenBox"+i})));}}}else if(this.props.stepDir==='DOWN'){steps=[];for(var _i=1;_i<=stepCount;_i++){if(_i<=this.props.step-1){steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:_i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square squareOn "+"greenBox"+_i})));}else if(_i===this.props.step){steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:_i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square animate-flickerDown "+"greenBox"+_i})));}else{steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:_i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square "+"greenBox"+_i})));}}}if(this.props.firstScore){steps=[];for(var _i2=0;_i2<=stepCount;_i2++){steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:_i2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square "+"greenBox"+_i2})));}}if(this.props.lastScore){steps=[];for(var _i3=1;_i3<=stepCount;_i3++){if(_i3<=6){if(_i3!==6){steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:_i3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square squareOn "+"greenBox"+_i3})));}else{steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:_i3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square squareOn animate-flicker "+"greenBox"+_i3})));}}else{steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:_i3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"square "+"greenBox"+_i3})));}}}if(this.props.level===this.props.maxLevel){levelPlus=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.appName(this.props.appName),alt:'animal',style:{width:48}});}if(this.props.level===this.props.maxLevel+1){steps=[];level=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.props.appName==="slash"?__WEBPACK_IMPORTED_MODULE_36__assets_images_badge_3_png___default.a:__WEBPACK_IMPORTED_MODULE_38__assets_images_badge_5_png___default.a,alt:'animal',style:{width:48}});levelPlus='';}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:'left'}},level,steps,levelPlus);}}]);return LevelTrackerComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var LevelTrackerMainComponent=function(_Component3){_inherits(LevelTrackerMainComponent,_Component3);function LevelTrackerMainComponent(){_classCallCheck(this,LevelTrackerMainComponent);return _possibleConstructorReturn(this,(LevelTrackerMainComponent.__proto__||Object.getPrototypeOf(LevelTrackerMainComponent)).apply(this,arguments));}_createClass(LevelTrackerMainComponent,[{key:'level',value:function level(_level3){switch(_level3){case 1:return __WEBPACK_IMPORTED_MODULE_8__assets_images_levels_level0_png___default.a;case 2:return __WEBPACK_IMPORTED_MODULE_9__assets_images_levels_level1_png___default.a;case 3:return __WEBPACK_IMPORTED_MODULE_10__assets_images_levels_level2_png___default.a;case 4:return __WEBPACK_IMPORTED_MODULE_11__assets_images_levels_level3_png___default.a;case 5:return __WEBPACK_IMPORTED_MODULE_12__assets_images_levels_level4_png___default.a;case 6:return __WEBPACK_IMPORTED_MODULE_13__assets_images_levels_level5_png___default.a;case 7:return __WEBPACK_IMPORTED_MODULE_14__assets_images_levels_level6_png___default.a;case 8:return __WEBPACK_IMPORTED_MODULE_15__assets_images_levels_level7_png___default.a;case 9:return __WEBPACK_IMPORTED_MODULE_16__assets_images_levels_level8_png___default.a;case 10:return __WEBPACK_IMPORTED_MODULE_17__assets_images_levels_level9_png___default.a;case 11:return __WEBPACK_IMPORTED_MODULE_18__assets_images_levels_level10_png___default.a;case 12:return __WEBPACK_IMPORTED_MODULE_19__assets_images_levels_level11_png___default.a;}}},{key:'appName',value:function appName(_appName2){switch(_appName2){case"maze":return __WEBPACK_IMPORTED_MODULE_38__assets_images_badge_5_png___default.a;case"slash":return __WEBPACK_IMPORTED_MODULE_36__assets_images_badge_3_png___default.a;case"copyright":return __WEBPACK_IMPORTED_MODULE_34__assets_images_badge_1_png___default.a;case"picturenaming":return __WEBPACK_IMPORTED_MODULE_40__assets_images_badge_7_png___default.a;case"wordsignsay":return __WEBPACK_IMPORTED_MODULE_37__assets_images_badge_4_png___default.a;case"kidsign":return __WEBPACK_IMPORTED_MODULE_39__assets_images_badge_6_png___default.a;case"kidspeak":return __WEBPACK_IMPORTED_MODULE_35__assets_images_badge_2_png___default.a;}}},{key:'render',value:function render(){var level=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.level(this.props.level),alt:'Level',style:{height:60}});var levelPlus=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.level(this.props.level+1),alt:'Level',style:{height:60}});var steps=[];var stepCount=this.props.steps||6;if(this.props.level>this.props.maxlevel){level='';levelPlus='';steps=null;}else{for(var i=1;i<=stepCount;i++){if(i<=this.props.step-1){steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'square squareOn'})));}else{steps.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'square'})));}}}if(this.props.level===this.props.maxlevel&&this.props.level!==1){levelPlus=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.appName(this.props.appName),alt:'Level',style:{height:60}});}if(this.props.level===this.props.maxlevel+1&&this.props.level!==1){steps=[];level=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative',display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.appName(this.props.appName),alt:'Medal',style:{display:"inline-block",position:'relative',height:60}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative',display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{style:{position:'relative',display:"inline-block"}},'ALL LEVELS FINISHED')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative',display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.appName(this.props.appName),alt:'Medal',style:{position:'relative',display:"inline-block",height:60}})));levelPlus='';}if(this.props.level===this.props.maxlevel&&this.props.appName==="wordsignsay"){levelPlus=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:this.appName(this.props.appName),alt:'Level',style:{height:60}});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,level,steps,levelPlus);}}]);return LevelTrackerMainComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var VideoComponent=function(_Component4){_inherits(VideoComponent,_Component4);function VideoComponent(props){_classCallCheck(this,VideoComponent);var _this4=_possibleConstructorReturn(this,(VideoComponent.__proto__||Object.getPrototypeOf(VideoComponent)).call(this,props));_this4.state={play:false};_this4.handlePlay=_this4.handlePlay.bind(_this4);return _this4;}_createClass(VideoComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Typical usage (don't forget to compare props):
if(this.props.url!==prevProps.url&&this.props.appName==='intro'&&prevProps.appName==='intro'){this.setState({play:false});}}},{key:'handlePlay',value:function handlePlay(){if(this.state.play){this.video.pause();this.setState({play:false});}else{this.video.play();this.setState({play:true});}}},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"demoVidPlay",ref:function ref(video){_this5.video=video;},playsInline:true,src:this.props.url,style:{position:'relative'},width:'100%',autoPlay:false,controls:true,muted:this.props.appName==="kidspeak"||this.props.appName==="intro"?false:true,onClick:this.handlePlay}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.state.play?"playpause":"",style:{cursor:'pointer'},onClick:this.handlePlay})));}}]);return VideoComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var YouTubeVideoComponent=function(_Component5){_inherits(YouTubeVideoComponent,_Component5);function YouTubeVideoComponent(props){_classCallCheck(this,YouTubeVideoComponent);return _possibleConstructorReturn(this,(YouTubeVideoComponent.__proto__||Object.getPrototypeOf(YouTubeVideoComponent)).call(this,props));}_createClass(YouTubeVideoComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Typical usage (don't forget to compare props):
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('iframe',{width:this.props.width?this.props.width:510,height:this.props.height?this.props.height:292,src:this.props.url,frameBorder:'0',allow:'accelerometer; encrypted-media; gyroscope; picture-in-picture',allowFullScreen:true})));}}]);return YouTubeVideoComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var CountDownComponent=function(_Component6){_inherits(CountDownComponent,_Component6);function CountDownComponent(){_classCallCheck(this,CountDownComponent);return _possibleConstructorReturn(this,(CountDownComponent.__proto__||Object.getPrototypeOf(CountDownComponent)).apply(this,arguments));}_createClass(CountDownComponent,[{key:'calculate',value:function calculate(){var time=this.props.time,sessionTime=this.props.sessionTime;var showTime=this.props.showTime;var report=time/sessionTime;if(report===1){return 24;}else if(report<1&&report>=11/12){return 1;}else if(report<11/12&&report>=10/12){return 2;}else if(report<10/12&&report>=9/12){return 3;}else if(report<9/12&&report>=8/12){return 4;}else if(report<8/12&&report>=7/12){return 5;}else if(report<7/12&&report>=6/12){return 6;}else if(report<6/12&&report>=5/12){return 7;}else if(report<5/12&&report>=4/12){return 8;}else if(report<4/12&&report>=3/12){return 9;}else if(report<3/12&&report>=2/12){return 10;}else if(report<2/12&&report>=1/12){return 11;}else if(report<=1/12&&report>0){return 12;}else{return 0;}}},{key:'render',value:function render(){var calc=this.calculate();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:this.props.time>this.props.showTime?{display:'none'}:{display:'inline-block'}},calc===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer24 timerBoxSize'}):null,calc===24?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer0 timerBoxSize'}):null,calc===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer2 timerBoxSize'}):null,calc===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer4 timerBoxSize'}):null,calc===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer6 timerBoxSize'}):null,calc===4?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer8 timerBoxSize'}):null,calc===5?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer10 timerBoxSize'}):null,calc===6?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer12 timerBoxSize'}):null,calc===7?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer14 timerBoxSize'}):null,calc===8?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer16 timerBoxSize'}):null,calc===9?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer18 timerBoxSize'}):null,calc===10?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer20 timerBoxSize'}):null,calc===11?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer22 timerBoxSize'}):null,calc===12?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'timer23 timerBoxSize'}):null);}}]);return CountDownComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ButtonContainerComponent=function(_Component7){_inherits(ButtonContainerComponent,_Component7);function ButtonContainerComponent(props){_classCallCheck(this,ButtonContainerComponent);var _this8=_possibleConstructorReturn(this,(ButtonContainerComponent.__proto__||Object.getPrototypeOf(ButtonContainerComponent)).call(this,props));_this8.state={mode:1,noDataModel:false,currentActive:_this8.props.currentTabActive};_this8.handleBackToMenu=_this8.handleBackToMenu.bind(_this8);_this8.handlePlayVideo=_this8.handlePlayVideo.bind(_this8);_this8.handleDataChart=_this8.handleDataChart.bind(_this8);_this8.handlePractice=_this8.handlePractice.bind(_this8);_this8.handleStartTask=_this8.handleStartTask.bind(_this8);_this8.handleShowScores=_this8.handleShowScores.bind(_this8);_this8.handleBackToPage=_this8.handleBackToPage.bind(_this8);_this8.handlePNManual=_this8.handlePNManual.bind(_this8);_this8.handlePNStart=_this8.handlePNStart.bind(_this8);_this8.handleNoDataClose=_this8.handleNoDataClose.bind(_this8);_this8.convertAppName=_this8.convertAppName.bind(_this8);_this8.getAppPath=_this8.getAppPath.bind(_this8);return _this8;}_createClass(ButtonContainerComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this9=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_46__Shared_REST__["a" /* default */].getUngradedTasks(this.props.appName).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log(res);if(res.body>=3){_this9.props.history.push('/student');}case 2:case'end':return _context.stop();}}},_callee,_this9);}));return function(_x){return _ref2.apply(this,arguments);};}());case 2:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'handleBackToMenu',value:function handleBackToMenu(event){this.props.history.goBack();}},{key:'handlePlayVideo',value:function handlePlayVideo(event){this.props.buttonClick(1);this.setState({mode:1,currentActive:1});}},{key:'handleShowScores',value:function handleShowScores(event){this.props.buttonClick(0);this.setState({mode:1,currentActive:0});}},{key:'convertAppName',value:function convertAppName(lowercaseName,model){var capitalName=void 0;switch(lowercaseName){case'maze':capitalName='Maze';break;case'slash':capitalName='Slash';break;case'wordmark':capitalName='WordMark';break;case'kidspeak':capitalName='KidSpeak';break;case'picturenaming':if(!model){capitalName='PictureNaming/Computer';}break;case'wordsignsay':capitalName='WordSign/Say';break;case'copyright':capitalName='CopyRight';break;case'kidsign':capitalName='KidSign';break;}return capitalName;}},{key:'getAppPath',value:function getAppPath(appName){if(appName==='slash'){return'slashtest';}else if(appName==='picturenaming'){return'picturenaming/computer';}else{return appName;}}},{key:'handleDataChart',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var _this10=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return __WEBPACK_IMPORTED_MODULE_46__Shared_REST__["a" /* default */].authWithToken().then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res){var student;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:student=void 0;if(_this10.props.userRole==="parent"){student=_this10.props.currentStudent;}else{student=res.body;student.userId=res.body.id;student.user=Object.assign({},res.body);student.personalUse=true;}if(!student){_context3.next=5;break;}_context3.next=5;return _this10.props.updateStudent(student);case 5:case'end':return _context3.stop();}}},_callee3,_this10);}));return function(_x3){return _ref4.apply(this,arguments);};}());case 2:_context4.next=4;return __WEBPACK_IMPORTED_MODULE_46__Shared_REST__["a" /* default */].checkStudentData(this.props.studentUser.student.userId,this.convertAppName(this.props.appName,this.props.model)).then(function(res){if(res.body===0){_this10.setState({noDataModel:true});}else{_this10.props.history.push('/teacher/student/data/'+_this10.getAppPath(_this10.props.appName));}});case 4:case'end':return _context4.stop();}}},_callee4,this);}));function handleDataChart(_x2){return _ref3.apply(this,arguments);}return handleDataChart;}()},{key:'handleNoDataClose',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:this.setState({noDataModel:false});case 1:case'end':return _context5.stop();}}},_callee5,this);}));function handleNoDataClose(_x4){return _ref5.apply(this,arguments);}return handleNoDataClose;}()},{key:'handlePractice',value:function handlePractice(event){this.props.buttonClick(2);this.setState({mode:2});}},{key:'handleStartTask',value:function handleStartTask(event){this.props.buttonClick(3);this.setState({mode:3});}},{key:'handlePNManual',value:function handlePNManual(event){this.props.buttonClick(4);this.setState({mode:4});}},{key:'handlePNStart',value:function handlePNStart(event){this.props.buttonClick(3);this.setState({mode:3});}},{key:'handleBackToPage',value:function handleBackToPage(event){this.handleShowScores(event);}},{key:'render',value:function render(){var appFinished=this.props.appStates.finishedApps.includes(this.props.appName);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},this.state.mode===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tc'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4 col-sm-4"},this.state.currentActive<1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleBackToMenu,className:'backArrow fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Back to Home Page')):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4 col-sm-4"},this.state.currentActive!==3&&this.state.currentActive<2&&!this.props.pnManual&&!appFinished?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.currentActive===1||this.props.maxLevel&&this.props.level===this.props.maxLevel+1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleStartTask,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Start')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleDataChart},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_45__assets_images_data_chart_png___default.a,style:{width:25,position:'relative',marginTop:-15,marginLeft:-15}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.state.noDataModel,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'No tasks completed yet.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNoDataClose,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close')))))):null,(this.state.currentActive===1||this.state.currentActive!==3)&&this.state.currentActive<2&&this.props.pnManual&&!appFinished?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handlePNStart,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Start')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleDataChart},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_45__assets_images_data_chart_png___default.a,alt:'Student Data',style:{width:25,position:'relative',marginTop:-15,marginLeft:-15}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.state.noDataModel,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'No tasks completed yet.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNoDataClose,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close')))))):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4 col-sm-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"pull-right",style:{marginRight:15}},this.state.currentActive<1?this.props.appName==="maze"||this.props.appName==="slash"||this.props.appName==="wordmark"||this.props.appName==="picturenaming"||this.props.appName==="wordsignsay"||this.props.appName==="copyright"||this.props.appName==="kidspeak"||this.props.appName==="kidsign"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handlePlayVideo,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Show Me')):null:null,!this.props.demo&&this.state.currentActive<2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handlePractice,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Practice')):null))))):null)));}}]);return ButtonContainerComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ButtonContainerComponent1=function(_Component8){_inherits(ButtonContainerComponent1,_Component8);function ButtonContainerComponent1(props){_classCallCheck(this,ButtonContainerComponent1);var _this11=_possibleConstructorReturn(this,(ButtonContainerComponent1.__proto__||Object.getPrototypeOf(ButtonContainerComponent1)).call(this,props));_this11.handleBackToPageConditional=function(active){window.removeEventListener("beforeunload",_this11.onUnload);_this11.setState({modalDialog:true});if(active===true){_this11.handleBackToPage();}};_this11.state={mode:1,currentActive:_this11.props.currentTabActive,modalDialog:false,responseContent:'Data for this task will not be saved if you go back now.'};_this11.handleBackToMenu=_this11.handleBackToMenu.bind(_this11);_this11.handleShowScores=_this11.handleShowScores.bind(_this11);_this11.handleBackToPage=_this11.handleBackToPage.bind(_this11);_this11.handleBackToPageConditional=_this11.handleBackToPageConditional.bind(_this11);_this11.onUnload=_this11.onUnload.bind(_this11);return _this11;}_createClass(ButtonContainerComponent1,[{key:'onUnload',value:function onUnload(event){// the method that will be used for both add and remove event
event.returnValue="By leaving or reloading the page you will lose your app progress";}},{key:'handleBackToMenu',value:function handleBackToMenu(event){this.props.history.goBack();}},{key:'handleShowScores',value:function handleShowScores(event){this.props.buttonClick(0);window.location.reload();this.setState({mode:1,currentActive:0});}},{key:'handleBackToPage',value:function handleBackToPage(event){this.handleShowScores(event);}},{key:'render',value:function render(){var _this12=this;var appFinished=this.props.appStates.finishedApps.includes(this.props.appName);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{paddingTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},this.state.mode===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tc'},this.state.currentActive<2?!this.props.demo?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleBackToMenu,className:'backArrow fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Back to Home Page')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleShowScores,className:'backArrow bck fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Back'))):this.state.currentActive===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.recordedSession?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleBackToPage,className:'backArrow bck fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'BACK'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__Shared_DialogBox__["a" /* default */],{backFunction:true,confirmDelete:this.handleBackToPageConditional,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this12.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleBackToPageConditional,className:'backArrow bck fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'BACK'))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2 col-sm-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleBackToPage,className:'backArrow bck fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'BACK')))),this.props.practice?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-10 col-sm-8"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:'right'}},'PRACTICE')):null)))):null)));}}]);return ButtonContainerComponent1;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudent:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_47__TeachersComponent_actions__["h" /* updateStudent */])(student));case 2:return _context6.abrupt('return',_context6.sent);case 3:case'end':return _context6.stop();}}},_callee6,_this13);}));function updateStudent(_x5){return _ref6.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{appStates:state.studentReducer.appStates,student:state.teacherReducer.student,studentUser:state.studentReducer.studentUser};};var Buttons=Object(__WEBPACK_IMPORTED_MODULE_42_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_41_react_router_dom__["e" /* withRouter */])(ButtonContainerComponent));var Buttons1=Object(__WEBPACK_IMPORTED_MODULE_42_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_41_react_router_dom__["e" /* withRouter */])(ButtonContainerComponent1));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

/**
 * ENCDELAY The encoder delay.
 *
 * Minimum allowed is MDCTDELAY (see below)
 *
 * The first 96 samples will be attenuated, so using a value less than 96
 * will result in corrupt data for the first 96-ENCDELAY samples.
 *
 * suggested: 576 set to 1160 to sync with FhG.
 */
Encoder.ENCDELAY = 576;
/**
 * make sure there is at least one complete frame after the last frame
 * containing real data
 *
 * Using a value of 288 would be sufficient for a a very sophisticated
 * decoder that can decode granule-by-granule instead of frame by frame. But
 * lets not assume this, and assume the decoder will not decode frame N
 * unless it also has data for frame N+1
 */
Encoder.POSTDELAY = 1152;

/**
 * delay of the MDCT used in mdct.c original ISO routines had a delay of
 * 528! Takehiro's routines:
 */
Encoder.MDCTDELAY = 48;
Encoder.FFTOFFSET = (224 + Encoder.MDCTDELAY);

/**
 * Most decoders, including the one we use, have a delay of 528 samples.
 */
Encoder.DECDELAY = 528;

/**
 * number of subbands
 */
Encoder.SBLIMIT = 32;

/**
 * parition bands bands
 */
Encoder.CBANDS = 64;

/**
 * number of critical bands/scale factor bands where masking is computed
 */
Encoder.SBPSY_l = 21;
Encoder.SBPSY_s = 12;

/**
 * total number of scalefactor bands encoded
 */
Encoder.SBMAX_l = 22;
Encoder.SBMAX_s = 13;
Encoder.PSFB21 = 6;
Encoder.PSFB12 = 6;

/**
 * FFT sizes
 */
Encoder.BLKSIZE = 1024;
Encoder.HBLKSIZE = (Encoder.BLKSIZE / 2 + 1);
Encoder.BLKSIZE_s = 256;
Encoder.HBLKSIZE_s = (Encoder.BLKSIZE_s / 2 + 1);

Encoder.NORM_TYPE = 0;
Encoder.START_TYPE = 1;
Encoder.SHORT_TYPE = 2;
Encoder.STOP_TYPE = 3;

/**
 * <PRE>
 * Mode Extention:
 * When we are in stereo mode, there are 4 possible methods to store these
 * two channels. The stereo modes -m? are using a subset of them.
 *
 *  -ms: MPG_MD_LR_LR
 *  -mj: MPG_MD_LR_LR and MPG_MD_MS_LR
 *  -mf: MPG_MD_MS_LR
 *  -mi: all
 * </PRE>
 */
Encoder.MPG_MD_LR_LR = 0;
Encoder.MPG_MD_LR_I = 1;
Encoder.MPG_MD_MS_LR = 2;
Encoder.MPG_MD_MS_I = 3;

Encoder.fircoef = [-0.0207887 * 5, -0.0378413 * 5,
    -0.0432472 * 5, -0.031183 * 5, 7.79609e-18 * 5, 0.0467745 * 5,
    0.10091 * 5, 0.151365 * 5, 0.187098 * 5];

function Encoder() {
    var NewMDCT = __webpack_require__(806);
    var III_psy_ratio = __webpack_require__(807);

    var FFTOFFSET = Encoder.FFTOFFSET;
    var MPG_MD_MS_LR = Encoder.MPG_MD_MS_LR;
    //BitStream bs;
    //PsyModel psy;
    //VBRTag vbr;
    //QuantizePVT qupvt;
    var bs = null;
    this.psy = null;
    var psy = null;
    var vbr = null;
    var qupvt = null;

    //public final void setModules(BitStream bs, PsyModel psy, QuantizePVT qupvt,
    //    VBRTag vbr) {
    this.setModules = function (_bs, _psy, _qupvt, _vbr) {
        bs = _bs;
        this.psy = _psy;
        psy = _psy;
        vbr = _vbr;
        qupvt = _qupvt;
    };

    var newMDCT = new NewMDCT();

    /***********************************************************************
     *
     * encoder and decoder delays
     *
     ***********************************************************************/

    /**
     * <PRE>
     * layer III enc->dec delay:  1056 (1057?)   (observed)
     * layer  II enc->dec delay:   480  (481?)   (observed)
     *
     * polyphase 256-16             (dec or enc)        = 240
     * mdct      256+32  (9*32)     (dec or enc)        = 288
     * total:    512+16
     *
     * My guess is that delay of polyphase filterbank is actualy 240.5
     * (there are technical reasons for this, see postings in mp3encoder).
     * So total Encode+Decode delay = ENCDELAY + 528 + 1
     * </PRE>
     */


    /**
     * auto-adjust of ATH, useful for low volume Gabriel Bouvigne 3 feb 2001
     *
     * modifies some values in gfp.internal_flags.ATH (gfc.ATH)
     */
//private void adjust_ATH(final LameInternalFlags gfc) {
    function adjust_ATH(gfc) {
        var gr2_max, max_pow;

        if (gfc.ATH.useAdjust == 0) {
            gfc.ATH.adjust = 1.0;
            /* no adjustment */
            return;
        }

        /* jd - 2001 mar 12, 27, jun 30 */
        /* loudness based on equal loudness curve; */
        /* use granule with maximum combined loudness */
        max_pow = gfc.loudness_sq[0][0];
        gr2_max = gfc.loudness_sq[1][0];
        if (gfc.channels_out == 2) {
            max_pow += gfc.loudness_sq[0][1];
            gr2_max += gfc.loudness_sq[1][1];
        } else {
            max_pow += max_pow;
            gr2_max += gr2_max;
        }
        if (gfc.mode_gr == 2) {
            max_pow = Math.max(max_pow, gr2_max);
        }
        max_pow *= 0.5;
        /* max_pow approaches 1.0 for full band noise */

        /* jd - 2001 mar 31, jun 30 */
        /* user tuning of ATH adjustment region */
        max_pow *= gfc.ATH.aaSensitivityP;

        /*
         * adjust ATH depending on range of maximum value
         */

        /* jd - 2001 feb27, mar12,20, jun30, jul22 */
        /* continuous curves based on approximation */
        /* to GB's original values. */
        /* For an increase in approximate loudness, */
        /* set ATH adjust to adjust_limit immediately */
        /* after a delay of one frame. */
        /* For a loudness decrease, reduce ATH adjust */
        /* towards adjust_limit gradually. */
        /* max_pow is a loudness squared or a power. */
        if (max_pow > 0.03125) { /* ((1 - 0.000625)/ 31.98) from curve below */
            if (gfc.ATH.adjust >= 1.0) {
                gfc.ATH.adjust = 1.0;
            } else {
                /* preceding frame has lower ATH adjust; */
                /* ascend only to the preceding adjust_limit */
                /* in case there is leading low volume */
                if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
                    gfc.ATH.adjust = gfc.ATH.adjustLimit;
                }
            }
            gfc.ATH.adjustLimit = 1.0;
        } else { /* adjustment curve */
            /* about 32 dB maximum adjust (0.000625) */
            var adj_lim_new = 31.98 * max_pow + 0.000625;
            if (gfc.ATH.adjust >= adj_lim_new) { /* descend gradually */
                gfc.ATH.adjust *= adj_lim_new * 0.075 + 0.925;
                if (gfc.ATH.adjust < adj_lim_new) { /* stop descent */
                    gfc.ATH.adjust = adj_lim_new;
                }
            } else { /* ascend */
                if (gfc.ATH.adjustLimit >= adj_lim_new) {
                    gfc.ATH.adjust = adj_lim_new;
                } else {
                    /* preceding frame has lower ATH adjust; */
                    /* ascend only to the preceding adjust_limit */
                    if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
                        gfc.ATH.adjust = gfc.ATH.adjustLimit;
                    }
                }
            }
            gfc.ATH.adjustLimit = adj_lim_new;
        }
    }

    /**
     * <PRE>
     *  some simple statistics
     *
     *  bitrate index 0: free bitrate . not allowed in VBR mode
     *  : bitrates, kbps depending on MPEG version
     *  bitrate index 15: forbidden
     *
     *  mode_ext:
     *  0:  LR
     *  1:  LR-i
     *  2:  MS
     *  3:  MS-i
     * </PRE>
     */
    function updateStats(gfc) {
        var gr, ch;
        assert(0 <= gfc.bitrate_index && gfc.bitrate_index < 16);
        assert(0 <= gfc.mode_ext && gfc.mode_ext < 4);

        /* count bitrate indices */
        gfc.bitrate_stereoMode_Hist[gfc.bitrate_index][4]++;
        gfc.bitrate_stereoMode_Hist[15][4]++;

        /* count 'em for every mode extension in case of 2 channel encoding */
        if (gfc.channels_out == 2) {
            gfc.bitrate_stereoMode_Hist[gfc.bitrate_index][gfc.mode_ext]++;
            gfc.bitrate_stereoMode_Hist[15][gfc.mode_ext]++;
        }
        for (gr = 0; gr < gfc.mode_gr; ++gr) {
            for (ch = 0; ch < gfc.channels_out; ++ch) {
                var bt = gfc.l3_side.tt[gr][ch].block_type | 0;
                if (gfc.l3_side.tt[gr][ch].mixed_block_flag != 0)
                    bt = 4;
                gfc.bitrate_blockType_Hist[gfc.bitrate_index][bt]++;
                gfc.bitrate_blockType_Hist[gfc.bitrate_index][5]++;
                gfc.bitrate_blockType_Hist[15][bt]++;
                gfc.bitrate_blockType_Hist[15][5]++;
            }
        }
    }

    function lame_encode_frame_init(gfp, inbuf) {
        var gfc = gfp.internal_flags;

        var ch, gr;

        if (gfc.lame_encode_frame_init == 0) {
            /* prime the MDCT/polyphase filterbank with a short block */
            var i, j;
            var primebuff0 = new_float(286 + 1152 + 576);
            var primebuff1 = new_float(286 + 1152 + 576);
            gfc.lame_encode_frame_init = 1;
            for (i = 0, j = 0; i < 286 + 576 * (1 + gfc.mode_gr); ++i) {
                if (i < 576 * gfc.mode_gr) {
                    primebuff0[i] = 0;
                    if (gfc.channels_out == 2)
                        primebuff1[i] = 0;
                } else {
                    primebuff0[i] = inbuf[0][j];
                    if (gfc.channels_out == 2)
                        primebuff1[i] = inbuf[1][j];
                    ++j;
                }
            }
            /* polyphase filtering / mdct */
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    gfc.l3_side.tt[gr][ch].block_type = Encoder.SHORT_TYPE;
                }
            }
            newMDCT.mdct_sub48(gfc, primebuff0, primebuff1);

            /* check FFT will not use a negative starting offset */
            assert(576 >= Encoder.FFTOFFSET);
            /* check if we have enough data for FFT */
            assert(gfc.mf_size >= (Encoder.BLKSIZE + gfp.framesize - Encoder.FFTOFFSET));
            /* check if we have enough data for polyphase filterbank */
            assert(gfc.mf_size >= (512 + gfp.framesize - 32));
        }

    }

    /**
     * <PRE>
     * encodeframe()           Layer 3
     *
     * encode a single frame
     *
     *
     *    lame_encode_frame()
     *
     *
     *                           gr 0            gr 1
     *    inbuf:           |--------------|--------------|--------------|
     *
     *
     *    Polyphase (18 windows, each shifted 32)
     *    gr 0:
     *    window1          <----512---.
     *    window18                 <----512---.
     *
     *    gr 1:
     *    window1                         <----512---.
     *    window18                                <----512---.
     *
     *
     *
     *    MDCT output:  |--------------|--------------|--------------|
     *
     *    FFT's                    <---------1024---------.
     *                                             <---------1024-------.
     *
     *
     *
     *        inbuf = buffer of PCM data size=MP3 framesize
     *        encoder acts on inbuf[ch][0], but output is delayed by MDCTDELAY
     *        so the MDCT coefficints are from inbuf[ch][-MDCTDELAY]
     *
     *        psy-model FFT has a 1 granule delay, so we feed it data for the
     *        next granule.
     *        FFT is centered over granule:  224+576+224
     *        So FFT starts at:   576-224-MDCTDELAY
     *
     *        MPEG2:  FFT ends at:  BLKSIZE+576-224-MDCTDELAY      (1328)
     *        MPEG1:  FFT ends at:  BLKSIZE+2*576-224-MDCTDELAY    (1904)
     *
     *        MPEG2:  polyphase first window:  [0..511]
     *                          18th window:   [544..1055]          (1056)
     *        MPEG1:            36th window:   [1120..1631]         (1632)
     *                data needed:  512+framesize-32
     *
     *        A close look newmdct.c shows that the polyphase filterbank
     *        only uses data from [0..510] for each window.  Perhaps because the window
     *        used by the filterbank is zero for the last point, so Takehiro's
     *        code doesn't bother to compute with it.
     *
     *        FFT starts at 576-224-MDCTDELAY (304)  = 576-FFTOFFSET
     *
     * </PRE>
     */


    this.lame_encode_mp3_frame = function (gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
        var mp3count;
        var masking_LR = new_array_n([2, 2]);
        /*
         * LR masking &
         * energy
         */
        masking_LR[0][0] = new III_psy_ratio();
        masking_LR[0][1] = new III_psy_ratio();
        masking_LR[1][0] = new III_psy_ratio();
        masking_LR[1][1] = new III_psy_ratio();
        var masking_MS = new_array_n([2, 2]);
        /* MS masking & energy */
        masking_MS[0][0] = new III_psy_ratio();
        masking_MS[0][1] = new III_psy_ratio();
        masking_MS[1][0] = new III_psy_ratio();
        masking_MS[1][1] = new III_psy_ratio();
        //III_psy_ratio masking[][];
        var masking;
        /* pointer to selected maskings */
        var inbuf = [null, null];
        var gfc = gfp.internal_flags;

        var tot_ener = new_float_n([2, 4]);
        var ms_ener_ratio = [.5, .5];
        var pe = [[0., 0.], [0., 0.]];
        var pe_MS = [[0., 0.], [0., 0.]];

//float[][] pe_use;
        var pe_use;

        var ch, gr;

        inbuf[0] = inbuf_l;
        inbuf[1] = inbuf_r;

        if (gfc.lame_encode_frame_init == 0) {
            /* first run? */
            lame_encode_frame_init(gfp, inbuf);

        }

        /********************** padding *****************************/
        /**
         * <PRE>
         * padding method as described in
         * "MPEG-Layer3 / Bitstream Syntax and Decoding"
         * by Martin Sieler, Ralph Sperschneider
         *
         * note: there is no padding for the very first frame
         *
         * Robert Hegemann 2000-06-22
         * </PRE>
         */
        gfc.padding = 0;
        if ((gfc.slot_lag -= gfc.frac_SpF) < 0) {
            gfc.slot_lag += gfp.out_samplerate;
            gfc.padding = 1;
        }

        /****************************************
         * Stage 1: psychoacoustic model *
         ****************************************/

        if (gfc.psymodel != 0) {
            /*
             * psychoacoustic model psy model has a 1 granule (576) delay that
             * we must compensate for (mt 6/99).
             */
            var ret;
            var bufp = [null, null];
            /* address of beginning of left & right granule */
            var bufpPos = 0;
            /* address of beginning of left & right granule */
            var blocktype = new_int(2);

            for (gr = 0; gr < gfc.mode_gr; gr++) {

                for (ch = 0; ch < gfc.channels_out; ch++) {
                    bufp[ch] = inbuf[ch];
                    bufpPos = 576 + gr * 576 - Encoder.FFTOFFSET;
                }
                if (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
                    ret = psy.L3psycho_anal_vbr(gfp, bufp, bufpPos, gr,
                        masking_LR, masking_MS, pe[gr], pe_MS[gr],
                        tot_ener[gr], blocktype);
                } else {
                    ret = psy.L3psycho_anal_ns(gfp, bufp, bufpPos, gr,
                        masking_LR, masking_MS, pe[gr], pe_MS[gr],
                        tot_ener[gr], blocktype);
                }
                if (ret != 0)
                    return -4;

                if (gfp.mode == MPEGMode.JOINT_STEREO) {
                    ms_ener_ratio[gr] = tot_ener[gr][2] + tot_ener[gr][3];
                    if (ms_ener_ratio[gr] > 0)
                        ms_ener_ratio[gr] = tot_ener[gr][3] / ms_ener_ratio[gr];
                }

                /* block type flags */
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    var cod_info = gfc.l3_side.tt[gr][ch];
                    cod_info.block_type = blocktype[ch];
                    cod_info.mixed_block_flag = 0;
                }
            }
        } else {
            /* no psy model */
            for (gr = 0; gr < gfc.mode_gr; gr++)
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    gfc.l3_side.tt[gr][ch].block_type = Encoder.NORM_TYPE;
                    gfc.l3_side.tt[gr][ch].mixed_block_flag = 0;
                    pe_MS[gr][ch] = pe[gr][ch] = 700;
                }
        }

        /* auto-adjust of ATH, useful for low volume */
        adjust_ATH(gfc);

        /****************************************
         * Stage 2: MDCT *
         ****************************************/

        /* polyphase filtering / mdct */
        newMDCT.mdct_sub48(gfc, inbuf[0], inbuf[1]);

        /****************************************
         * Stage 3: MS/LR decision *
         ****************************************/

        /* Here will be selected MS or LR coding of the 2 stereo channels */
        gfc.mode_ext = Encoder.MPG_MD_LR_LR;

        if (gfp.force_ms) {
            gfc.mode_ext = Encoder.MPG_MD_MS_LR;
        } else if (gfp.mode == MPEGMode.JOINT_STEREO) {
            /*
             * ms_ratio = is scaled, for historical reasons, to look like a
             * ratio of side_channel / total. 0 = signal is 100% mono .5 = L & R
             * uncorrelated
             */

            /**
             * <PRE>
             * [0] and [1] are the results for the two granules in MPEG-1,
             * in MPEG-2 it's only a faked averaging of the same value
             * _prev is the value of the last granule of the previous frame
             * _next is the value of the first granule of the next frame
             * </PRE>
             */

            var sum_pe_MS = 0.;
            var sum_pe_LR = 0.;
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    sum_pe_MS += pe_MS[gr][ch];
                    sum_pe_LR += pe[gr][ch];
                }
            }

            /* based on PE: M/S coding would not use much more bits than L/R */
            if (sum_pe_MS <= 1.00 * sum_pe_LR) {

                var gi0 = gfc.l3_side.tt[0];
                var gi1 = gfc.l3_side.tt[gfc.mode_gr - 1];

                if (gi0[0].block_type == gi0[1].block_type
                    && gi1[0].block_type == gi1[1].block_type) {

                    gfc.mode_ext = Encoder.MPG_MD_MS_LR;
                }
            }
        }

        /* bit and noise allocation */
        if (gfc.mode_ext == MPG_MD_MS_LR) {
            masking = masking_MS;
            /* use MS masking */
            pe_use = pe_MS;
        } else {
            masking = masking_LR;
            /* use LR masking */
            pe_use = pe;
        }

        /* copy data for MP3 frame analyzer */
        if (gfp.analysis && gfc.pinfo != null) {
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    gfc.pinfo.ms_ratio[gr] = gfc.ms_ratio[gr];
                    gfc.pinfo.ms_ener_ratio[gr] = ms_ener_ratio[gr];
                    gfc.pinfo.blocktype[gr][ch] = gfc.l3_side.tt[gr][ch].block_type;
                    gfc.pinfo.pe[gr][ch] = pe_use[gr][ch];
                    System.arraycopy(gfc.l3_side.tt[gr][ch].xr, 0,
                        gfc.pinfo.xr[gr][ch], 0, 576);
                    /*
                     * in psymodel, LR and MS data was stored in pinfo. switch
                     * to MS data:
                     */
                    if (gfc.mode_ext == MPG_MD_MS_LR) {
                        gfc.pinfo.ers[gr][ch] = gfc.pinfo.ers[gr][ch + 2];
                        System.arraycopy(gfc.pinfo.energy[gr][ch + 2], 0,
                            gfc.pinfo.energy[gr][ch], 0,
                            gfc.pinfo.energy[gr][ch].length);
                    }
                }
            }
        }

        /****************************************
         * Stage 4: quantization loop *
         ****************************************/

        if (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_abr) {

            var i;
            var f;

            for (i = 0; i < 18; i++)
                gfc.nsPsy.pefirbuf[i] = gfc.nsPsy.pefirbuf[i + 1];

            f = 0.0;
            for (gr = 0; gr < gfc.mode_gr; gr++)
                for (ch = 0; ch < gfc.channels_out; ch++)
                    f += pe_use[gr][ch];
            gfc.nsPsy.pefirbuf[18] = f;

            f = gfc.nsPsy.pefirbuf[9];
            for (i = 0; i < 9; i++)
                f += (gfc.nsPsy.pefirbuf[i] + gfc.nsPsy.pefirbuf[18 - i])
                    * Encoder.fircoef[i];

            f = (670 * 5 * gfc.mode_gr * gfc.channels_out) / f;
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    pe_use[gr][ch] *= f;
                }
            }
        }
        gfc.iteration_loop.iteration_loop(gfp, pe_use, ms_ener_ratio, masking);

        /****************************************
         * Stage 5: bitstream formatting *
         ****************************************/

        /* write the frame to the bitstream */
        bs.format_bitstream(gfp);

        /* copy mp3 bit buffer into array */
        mp3count = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 1);

        if (gfp.bWriteVbrTag)
            vbr.addVbrFrame(gfp);

        if (gfp.analysis && gfc.pinfo != null) {
            for (ch = 0; ch < gfc.channels_out; ch++) {
                var j;
                for (j = 0; j < FFTOFFSET; j++)
                    gfc.pinfo.pcmdata[ch][j] = gfc.pinfo.pcmdata[ch][j
                    + gfp.framesize];
                for (j = FFTOFFSET; j < 1600; j++) {
                    gfc.pinfo.pcmdata[ch][j] = inbuf[ch][j - FFTOFFSET];
                }
            }
            qupvt.set_frame_pinfo(gfp, masking);
        }

        updateStats(gfc);

        return mp3count;
    }
}


module.exports = Encoder;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.



/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
function forEach(children, func, context) {
  var index = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function count(children) {
  var result = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
  var index = 0;
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result = void 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/app-kidsignsay.955db14e.png";

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_ico_close_png__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_ico_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_ico_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteDialogBox=function(_Component){_inherits(DeleteDialogBoxComponent,_Component);function DeleteDialogBoxComponent(props){_classCallCheck(this,DeleteDialogBoxComponent);var _this=_possibleConstructorReturn(this,(DeleteDialogBoxComponent.__proto__||Object.getPrototypeOf(DeleteDialogBoxComponent)).call(this,props));_this.state={isModalOpen:_this.props.modalOpen?_this.props.modalOpen:false};_this.closeModal=_this.closeModal.bind(_this);_this.handleYes=_this.handleYes.bind(_this);_this.handleNo=_this.handleNo.bind(_this);return _this;}_createClass(DeleteDialogBoxComponent,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'openModal',value:function openModal(){this.setState({isModalOpen:true});}},{key:'closeModal',value:function closeModal(){this.props.closeClick(false);this.setState({isModalOpen:false});}},{key:'handleYes',value:function handleYes(event){this.props.confirmDelete(true);this.setState({isModalOpen:false});this.closeModal();}},{key:'handleNo',value:function handleNo(event){this.props.confirmDelete(false);this.setState({isModalOpen:false});this.closeModal();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["a" /* Modal */],{id:'dialogBox',show:this.props.modalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png___default.a,style:{width:40,height:40,position:'relative'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{style:{paddingTop:15}},this.props.sectionContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{float:'right'},onClick:this.handleYes,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Yes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{float:'left'},onClick:this.handleNo,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No')))))));}}]);return DeleteDialogBoxComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{};};var mapStateToProps=function mapStateToProps(state){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(DeleteDialogBox));

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseStartTime = parseStartTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isObject = isObject;
exports.isEqual = isEqual;

var _loadScript = __webpack_require__(643);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _deepmerge = __webpack_require__(644);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _props = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/;

// Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds
function parseStartTime(url) {
  var match = url.match(MATCH_START_QUERY);
  if (match) {
    var stamp = match[1];
    if (stamp.match(MATCH_START_STAMP)) {
      return parseStartStamp(stamp);
    }
    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp, 10);
    }
  }
  return 0;
}

function parseStartStamp(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);
  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }
  return seconds;
}

// http://stackoverflow.com/a/38622545
function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return key + '=' + object[key];
  }).join('&');
}

// Util function to load an external SDK
// or return the SDK if it is already loaded
var resolves = {};
function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };

  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
    return Promise.resolve(window[sdkGlobal]);
  }
  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve
    // function to the existing array of resolve functions
    if (resolves[url]) {
      resolves[url].push(resolve);
      return;
    }
    resolves[url] = [resolve];
    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending promises
      resolves[url].forEach(function (resolve) {
        return resolve(sdk);
      });
    };
    if (sdkReady) {
      var previousOnReady = window[sdkReady];
      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(window[sdkGlobal]);
      };
    }
    (0, _loadScript2['default'])(url, function (err) {
      if (err) reject(err);
      if (!sdkReady) {
        onLoaded(window[sdkGlobal]);
      }
    });
  });
}

function getConfig(props, defaultProps, showWarning) {
  var config = (0, _deepmerge2['default'])(defaultProps.config, props.config);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _props.DEPRECATED_CONFIG_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var p = _step.value;

      if (props[p]) {
        var key = p.replace(/Config$/, '');
        config = (0, _deepmerge2['default'])(config, _defineProperty({}, key, props[p]));
        if (showWarning) {
          var link = 'https://github.com/CookPete/react-player#config-prop';
          var message = 'ReactPlayer: %c' + p + ' %cis deprecated, please use the config prop instead \u2013 ' + link;
          console.warn(message, 'font-weight: bold', '');
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return config;
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);
  var output = {};
  var keys = Object.keys(object);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      if (omitKeys.indexOf(key) === -1) {
        output[key] = object[key];
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
        _iterator2['return']();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return output;
}

function callPlayer(method) {
  var _player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = 'ReactPlayer: ' + this.constructor.displayName + ' player could not call %c' + method + '%c \u2013 ';
    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }
    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_player = this.player)[method].apply(_player, args);
}

function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

// Deep comparison of two objects but ignoring
// functions, for use in shouldComponentUpdate
function isEqual(a, b) {
  if (typeof a === 'function' && typeof b === 'function') {
    return true;
  }
  if (a instanceof Array && b instanceof Array) {
    if (a.length !== b.length) {
      return false;
    }
    for (var i = 0; i !== a.length; i++) {
      if (!isEqual(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }
  if (isObject(a) && isObject(b)) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = Object.keys(a)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var key = _step3.value;

        if (!isEqual(a[key], b[key])) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
          _iterator3['return']();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return true;
  }
  return a === b;
}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(703);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(26);











var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SafeAnchor);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  SafeAnchor.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;


    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  SafeAnchor.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        onKeyDown = _props2.onKeyDown,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'disabled', 'onKeyDown']);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button';
      // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')
      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ pointerEvents: 'none' }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.handleClick,
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_kidspeak.4f215ebc.png";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/app-picturenaming.539bd178.png";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/app-wordsignsay.45460298.png";

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/app-copyright.37b61383.png";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_wordmark.f7d5f2a9.png";

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StudentsComponent_Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_label_yellow_png__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_label_yellow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_label_yellow_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mazeCriteria=[1,1,2,3,4,5,5,6,6,7,7,8];var ProgressBox=function(_Component){_inherits(ProgressBox,_Component);function ProgressBox(props){_classCallCheck(this,ProgressBox);return _possibleConstructorReturn(this,(ProgressBox.__proto__||Object.getPrototypeOf(ProgressBox)).call(this,props));}_createClass(ProgressBox,[{key:'render',value:function render(){var animalMap=[];var maxlevel=this.props.maxLevel||12;var animationDelay=0.1;for(var i=1;i<=maxlevel;i++){animalMap.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:this.props.level>=i?"img-responsive levelAnimation":"img-responsive noAnimation",src:__webpack_require__(747)("./medal_level"+(i-1)+'.png'),title:'Level '+i/*alt={`Level ${i}`} // only title or alt required; alt disabled */,style:{opacity:this.props.level>=i?1:0.3,filter:this.props.level>=i?'none':'grayscale(100%)',width:70,marginRight:5,animationDelay:this.props.level>=i?(animationDelay+i-1)/2+'s':(this.props.level+0.8)/2+'s'}})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"container",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"ribbonWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ribbonYellow'},'Level ',this.props.level>this.props.maxLevel?this.props.maxLevel:this.props.level)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:20}},animalMap),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),!this.props.noDescription&&this.props.appName!=="maze"&&!this.props.slashProgress&&this.props.level!==this.props.maxLevel+1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:15}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'I need to score ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.level+2),' correct.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))):null,!this.props.noDescription&&this.props.appName==="maze"&&!this.props.slashProgress&&this.props.level!==this.props.maxLevel+1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:15}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'I need to score ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,mazeCriteria[this.props.level-1]),' correct.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))):null,!this.props.noDescription&&this.props.slashProgress?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:15}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StudentsComponent_Common__["f" /* LevelTrackerMainComponent */],{level:this.props.level||1,step:this.props.step||1,steps:this.props.steps||6,maxlevel:this.props.maxLevel,appName:this.props.appName})));}}]);return ProgressBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProgressBox);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(166)('wks');
var uid = __webpack_require__(116);
var Symbol = __webpack_require__(60).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_maze.cfdfdc33.png";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_slashtest.b30d4add.png";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(636);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = createSinglePlayer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(128);

var _utils = __webpack_require__(39);

var _Player = __webpack_require__(189);

var _Player2 = _interopRequireDefault(_Player);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SUPPORTED_PROPS = Object.keys(_props2.propTypes);

function createSinglePlayer(activePlayer) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(SinglePlayer, _Component);

    function SinglePlayer() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, SinglePlayer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SinglePlayer.__proto__ || Object.getPrototypeOf(SinglePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.getDuration = function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      }, _this.getCurrentTime = function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      }, _this.getSecondsLoaded = function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      }, _this.getInternalPlayer = function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';

        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      }, _this.seekTo = function (fraction) {
        if (!_this.player) return null;
        _this.player.seekTo(fraction);
      }, _this.ref = function (player) {
        _this.player = player;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SinglePlayer, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return !(0, _utils.isEqual)(this.props, nextProps);
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps) {
        this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
      }
    }, {
      key: 'render',
      value: function render() {
        if (!activePlayer.canPlay(this.props.url)) {
          return null;
        }
        var _props = this.props,
            style = _props.style,
            width = _props.width,
            height = _props.height,
            Wrapper = _props.wrapper;

        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
        return _react2['default'].createElement(
          Wrapper,
          _extends({ style: _extends({}, style, { width: width, height: height }) }, otherProps),
          _react2['default'].createElement(_Player2['default'], _extends({}, this.props, {
            ref: this.ref,
            activePlayer: activePlayer,
            config: (0, _utils.getConfig)(this.props, _props2.defaultProps)
          }))
        );
      }
    }]);

    return SinglePlayer;
  }(_react.Component), _class.displayName = activePlayer.displayName + 'Player', _class.propTypes = _props2.propTypes, _class.defaultProps = _props2.defaultProps, _class.canPlay = activePlayer.canPlay, _temp2;
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(694);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

exports.AndroidView = AndroidView;
exports.BrowserTypes = BrowserTypes;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.OsTypes = OsTypes;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getSelectorsByUserAgent = getSelectorsByUserAgent;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isDesktop = isDesktop;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isEmbedded = isEmbedded;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSamsungBrowser = isSamsungBrowser;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.parseUserAgent = parseUserAgent;
exports.setUserAgent = setUserAgent;
exports.useDeviceData = useDeviceData;
exports.useDeviceSelectors = useDeviceSelectors;
exports.useMobileOrientation = useMobileOrientation;
exports.withOrientationChange = withOrientationChange;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(718);
var objectAssign = __webpack_require__(56);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)]$/.exec(key);

				key = key.replace(/\[\d*]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[])$/.exec(key);

				key = key.replace(/\[]$/, '');

				if (!result || accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var core = __webpack_require__(48);
var ctx = __webpack_require__(160);
var hide = __webpack_require__(79);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_avenuepm.da5ce63f.png";

/***/ }),
/* 63 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NonceProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useStateManager_68425271_esm_js__ = __webpack_require__(191);
/* unused harmony reexport useStateManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select_54ac8379_esm_js__ = __webpack_require__(142);
/* unused harmony reexport createFilter */
/* unused harmony reexport defaultTheme */
/* unused harmony reexport mergeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_a7690a33_esm_js__ = __webpack_require__(89);
/* unused harmony reexport components */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emotion_react__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__emotion_cache__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_memoize_one__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_slicedToArray__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__babel_runtime_helpers_typeof__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_defineProperty__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_dom__);























var StateManagedSelect = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (props, ref) {
  var baseSelectProps = Object(__WEBPACK_IMPORTED_MODULE_0__useStateManager_68425271_esm_js__["a" /* u */])(props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Select_54ac8379_esm_js__["a" /* S */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, baseSelectProps));
});

var NonceProvider = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(NonceProvider, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_7__index_a7690a33_esm_js__["n" /* _ */])(NonceProvider);

  function NonceProvider(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NonceProvider);

    _this = _super.call(this, props);

    _this.createEmotionCache = function (nonce, key) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_cache__["a" /* default */])({
        nonce: nonce,
        key: key
      });
    };

    _this.createEmotionCache = Object(__WEBPACK_IMPORTED_MODULE_10_memoize_one__["a" /* default */])(_this.createEmotionCache);
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(NonceProvider, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__emotion_react__["a" /* CacheProvider */], {
        value: emotionCache
      }, this.props.children);
    }
  }]);

  return NonceProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StateManagedSelect);



/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_logo_avenuepm_png__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_logo_avenuepm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_logo_avenuepm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TeachersComponent_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(10);
var _this4=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DropDownNotifications=function(_Component){_inherits(DropDownNotificationsComponent,_Component);function DropDownNotificationsComponent(props){_classCallCheck(this,DropDownNotificationsComponent);var _this=_possibleConstructorReturn(this,(DropDownNotificationsComponent.__proto__||Object.getPrototypeOf(DropDownNotificationsComponent)).call(this,props));_this.toggleOpenFirst=_this.toggleOpenFirst.bind(_this);_this.handleTasksClick=_this.handleTasksClick.bind(_this);_this.state={isOpen:false,totalTasks:0,notifications:[]};return _this;}_createClass(DropDownNotificationsComponent,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_4__REST__["a" /* default */].getStudentNotifications().then(function(res){var totalTasks=0;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=res.body[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var not=_step.value;totalTasks=totalTasks+not.apps.kidSignScores.length+not.apps.kidSpeakScores.length+not.apps.wordMarkScores.length+not.apps.copyRightScores.length+not.apps.pictureNamingScores.length+not.apps.wordSignSayScores.length;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}_this2.setState({notifications:res.body,totalTasks:totalTasks});});}},{key:'handleTasksClick',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(notification,scoreTaskTab,e){var theClass;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();theClass=notification.student.classes.filter(function(v){return v.classes_student.active;});if(theClass.length>0){theClass=theClass[0];}else{theClass=null;}_context.next=5;return this.props.selectStudentTab(3);case 5:_context.next=7;return this.props.selectStudentScoreListTab(scoreTaskTab);case 7:_context.next=9;return this.props.studentClick(notification.student,theClass);case 9:case'end':return _context.stop();}}},_callee,this);}));function handleTasksClick(_x,_x2,_x3){return _ref.apply(this,arguments);}return handleTasksClick;}()},{key:'toggleOpenFirst',value:function toggleOpenFirst(e){this.setState({isOpen:!this.state.isOpen});e.preventDefault();}},{key:'render',value:function render(){var _this3=this;var menuClass=this.state.isOpen?" open":"";var notificationBlocks=this.state.notifications.map(function(not,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:index,style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row noMarginLR'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,not.student.user.firstname,' ',not.student.user.lastname)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-8"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:"list-group"},not.apps.copyRightScores.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{width:"100%",cursor:"pointer"},className:'list-group-item d-flex justify-content-between align-items-center',onClick:function onClick(e){return _this3.handleTasksClick(not,4,e);}},'CopyRight Tasks',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'badge badge-primary badge-pill'},not.apps.copyRightScores.length)):null,not.apps.kidSignScores.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{width:"100%",cursor:"pointer"},className:'list-group-item d-flex justify-content-between align-items-center',onClick:function onClick(e){return _this3.handleTasksClick(not,6,e);}},'Kid Sign/Say Tasks',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'badge badge-primary badge-pill'},not.apps.kidSignScores.length)):null,not.apps.kidSpeakScores.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{width:"100%",cursor:"pointer"},className:'list-group-item d-flex justify-content-between align-items-center',onClick:function onClick(e){return _this3.handleTasksClick(not,2,e);}},'KidSpeak Tasks',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'badge badge-primary badge-pill'},not.apps.kidSpeakScores.length)):null,not.apps.pictureNamingScores.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{width:"100%",cursor:"pointer"},className:'list-group-item d-flex justify-content-between align-items-center',onClick:function onClick(e){return _this3.handleTasksClick(not,3,e);}},'PictureNaming Tasks',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'badge badge-primary badge-pill'},not.apps.pictureNamingScores.length)):null,not.apps.wordMarkScores.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{width:"100%",cursor:"pointer"},className:'list-group-item d-flex justify-content-between align-items-center',onClick:function onClick(e){return _this3.handleTasksClick(not,1,e);}},'WordMark Tasks',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'badge badge-primary badge-pill'},not.apps.wordMarkScores.length)):null,not.apps.wordSignSayScores.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{width:"100%",cursor:"pointer"},className:'list-group-item d-flex justify-content-between align-items-center',onClick:function onClick(e){return _this3.handleTasksClick(not,5,e);}},'Word Sign/Say Tasks',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'badge badge-primary badge-pill'},not.apps.wordSignSayScores.length)):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{style:{width:"100%"}}));});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav navbar-nav pull-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:"dropdown"+menuClass,style:{marginTop:1}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.notifications.length>0?"dropdown-toggle handBtn notificationsOn":"dropdown-toggle handBtn",'data-toggle':'dropdown',role:'button','aria-haspopup':'true','aria-expanded':'false',onClick:this.toggleOpenFirst},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'To Do List (',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,this.state.totalTasks),')')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-menu notify-drop'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'notify-drop-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12'},'Unscored Tasks'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'drop-content'},notificationBlocks),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'notify-drop-footer text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){return _this3.setState({isOpen:false});}},'Close')))));}}]);return DropDownNotificationsComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{selectStudentTab:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(selectedTab){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__TeachersComponent_actions__["e" /* selectStudentTab */])(selectedTab));case 2:return _context2.abrupt('return',_context2.sent);case 3:case'end':return _context2.stop();}}},_callee2,_this4);}));function selectStudentTab(_x4){return _ref2.apply(this,arguments);}return selectStudentTab;}(),selectStudentScoreListTab:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(selectedScoreListTab){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__TeachersComponent_actions__["d" /* selectStudentScoreListTab */])(selectedScoreListTab));case 2:return _context3.abrupt('return',_context3.sent);case 3:case'end':return _context3.stop();}}},_callee3,_this4);}));function selectStudentScoreListTab(_x5){return _ref3.apply(this,arguments);}return selectStudentScoreListTab;}()};};var mapStateToProps=function mapStateToProps(state){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(DropDownNotifications));

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DialogBox__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a.setAppElement('body');var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'45%'}};var ReportBugForm=function(_Component){_inherits(ReportBugForm,_Component);function ReportBugForm(props){_classCallCheck(this,ReportBugForm);var _this=_possibleConstructorReturn(this,(ReportBugForm.__proto__||Object.getPrototypeOf(ReportBugForm)).call(this,props));_this.state={done:false,submitting:false,name:"",email:"",type:"Teacher management",description:"",isOpen:false,modalDialog:false,responseContent:''};_this.submitForm=_this.submitForm.bind(_this);_this.handleDescription=_this.handleDescription.bind(_this);_this.handleEmailChange=_this.handleEmailChange.bind(_this);_this.handleNameChange=_this.handleNameChange.bind(_this);_this.handleTypeChange=_this.handleTypeChange.bind(_this);_this.bugReportOpen=_this.bugReportOpen.bind(_this);return _this;}_createClass(ReportBugForm,[{key:'bugReportOpen',value:function bugReportOpen(){this.setState({isOpen:!this.state.isOpen,name:"",email:"",type:"Teacher management",description:"",done:false,submitting:false});}},{key:'handleNameChange',value:function handleNameChange(v){this.setState({name:v.target.value});}},{key:'handleTypeChange',value:function handleTypeChange(e){this.setState({type:e.target.value});}},{key:'handleEmailChange',value:function handleEmailChange(v){this.setState({email:v.target.value});}},{key:'handleDescription',value:function handleDescription(v){this.setState({description:v.target.value});}},{key:'submitForm',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({submitting:true});data={name:this.state.name,description:this.state.description,eMail:this.state.email,type:this.state.type};_context.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].reportBug(data).then(function(res){_this2.setState({done:true,submitting:false});_this2.setState({modalDialog:true,responseContent:"The bug report has been successfully sent."});setTimeout(function(){_this2.setState({modalDialog:false});_this2.bugReportOpen();},3500);}).catch(function(err){console.log(err);_this2.setState({done:true,submitting:false});_this2.setState({modalDialog:true,responseContent:"An error occurred, please try again."});setTimeout(function(){_this2.setState({modalDialog:false});},3500);});case 4:case'end':return _context.stop();}}},_callee,this);}));function submitForm(){return _ref.apply(this,arguments);}return submitForm;}()},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar fr',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.bugReportOpen,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Bug Report')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.state.isOpen,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Report Bug Form')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this3.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12 bgGrey roundCorners'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'If you leave your email address we will get back to you.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'form'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onChange:this.handleNameChange,type:'text',className:'form-control',placeholder:'Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Email Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onChange:this.handleEmailChange,type:'email',className:'form-control',placeholder:'Email Address',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Where is the bug:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{value:this.state.type,className:"form-control",onChange:this.handleTypeChange},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'Teacher management',title:'Teacher Management'},'Teacher management'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'Data visualization chart',title:'Data Visualisation'},'Data visualization chart'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'Teacher scoring tool',title:'Teacher Scoring'},'Teacher scoring tool'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'Student assessment',title:'Student assessment'},'Student assessment')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Describe the bug (and name the student assessment if relevant).'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{rows:5,onChange:this.handleDescription,placeholder:'Bug description.',required:true,className:'form-control'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.bugReportOpen,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{disabled:this.submitting||this.state.done,onClick:this.submitForm,className:'handBtn',type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Submit'))))));}}]);return ReportBugForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReportBugForm);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NS = exports.NAMESPACES = {
    HTML: 'http://www.w3.org/1999/xhtml',
    MATHML: 'http://www.w3.org/1998/Math/MathML',
    SVG: 'http://www.w3.org/2000/svg',
    XLINK: 'http://www.w3.org/1999/xlink',
    XML: 'http://www.w3.org/XML/1998/namespace',
    XMLNS: 'http://www.w3.org/2000/xmlns/'
};

exports.ATTRS = {
    TYPE: 'type',
    ACTION: 'action',
    ENCODING: 'encoding',
    PROMPT: 'prompt',
    NAME: 'name',
    COLOR: 'color',
    FACE: 'face',
    SIZE: 'size'
};

exports.DOCUMENT_MODE = {
    NO_QUIRKS: 'no-quirks',
    QUIRKS: 'quirks',
    LIMITED_QUIRKS: 'limited-quirks'
};

var $ = exports.TAG_NAMES = {
    A: 'a',
    ADDRESS: 'address',
    ANNOTATION_XML: 'annotation-xml',
    APPLET: 'applet',
    AREA: 'area',
    ARTICLE: 'article',
    ASIDE: 'aside',

    B: 'b',
    BASE: 'base',
    BASEFONT: 'basefont',
    BGSOUND: 'bgsound',
    BIG: 'big',
    BLOCKQUOTE: 'blockquote',
    BODY: 'body',
    BR: 'br',
    BUTTON: 'button',

    CAPTION: 'caption',
    CENTER: 'center',
    CODE: 'code',
    COL: 'col',
    COLGROUP: 'colgroup',

    DD: 'dd',
    DESC: 'desc',
    DETAILS: 'details',
    DIALOG: 'dialog',
    DIR: 'dir',
    DIV: 'div',
    DL: 'dl',
    DT: 'dt',

    EM: 'em',
    EMBED: 'embed',

    FIELDSET: 'fieldset',
    FIGCAPTION: 'figcaption',
    FIGURE: 'figure',
    FONT: 'font',
    FOOTER: 'footer',
    FOREIGN_OBJECT: 'foreignObject',
    FORM: 'form',
    FRAME: 'frame',
    FRAMESET: 'frameset',

    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
    HEAD: 'head',
    HEADER: 'header',
    HGROUP: 'hgroup',
    HR: 'hr',
    HTML: 'html',

    I: 'i',
    IMG: 'img',
    IMAGE: 'image',
    INPUT: 'input',
    IFRAME: 'iframe',

    KEYGEN: 'keygen',

    LABEL: 'label',
    LI: 'li',
    LINK: 'link',
    LISTING: 'listing',

    MAIN: 'main',
    MALIGNMARK: 'malignmark',
    MARQUEE: 'marquee',
    MATH: 'math',
    MENU: 'menu',
    MENUITEM: 'menuitem',
    META: 'meta',
    MGLYPH: 'mglyph',
    MI: 'mi',
    MO: 'mo',
    MN: 'mn',
    MS: 'ms',
    MTEXT: 'mtext',

    NAV: 'nav',
    NOBR: 'nobr',
    NOFRAMES: 'noframes',
    NOEMBED: 'noembed',
    NOSCRIPT: 'noscript',

    OBJECT: 'object',
    OL: 'ol',
    OPTGROUP: 'optgroup',
    OPTION: 'option',

    P: 'p',
    PARAM: 'param',
    PLAINTEXT: 'plaintext',
    PRE: 'pre',

    RB: 'rb',
    RP: 'rp',
    RT: 'rt',
    RTC: 'rtc',
    RUBY: 'ruby',

    S: 's',
    SCRIPT: 'script',
    SECTION: 'section',
    SELECT: 'select',
    SOURCE: 'source',
    SMALL: 'small',
    SPAN: 'span',
    STRIKE: 'strike',
    STRONG: 'strong',
    STYLE: 'style',
    SUB: 'sub',
    SUMMARY: 'summary',
    SUP: 'sup',

    TABLE: 'table',
    TBODY: 'tbody',
    TEMPLATE: 'template',
    TEXTAREA: 'textarea',
    TFOOT: 'tfoot',
    TD: 'td',
    TH: 'th',
    THEAD: 'thead',
    TITLE: 'title',
    TR: 'tr',
    TRACK: 'track',
    TT: 'tt',

    U: 'u',
    UL: 'ul',

    SVG: 'svg',

    VAR: 'var',

    WBR: 'wbr',

    XMP: 'xmp'
};

var SPECIAL_ELEMENTS = exports.SPECIAL_ELEMENTS = Object.create(null);

SPECIAL_ELEMENTS[NS.HTML] = Object.create(null);
SPECIAL_ELEMENTS[NS.HTML][$.ADDRESS] = true;
SPECIAL_ELEMENTS[NS.HTML][$.APPLET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.AREA] = true;
SPECIAL_ELEMENTS[NS.HTML][$.ARTICLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.ASIDE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BASE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BASEFONT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BGSOUND] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BLOCKQUOTE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BODY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BUTTON] = true;
SPECIAL_ELEMENTS[NS.HTML][$.CAPTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.CENTER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.COL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.COLGROUP] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DETAILS] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DIR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DIV] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.EMBED] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIELDSET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIGCAPTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIGURE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FOOTER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FORM] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FRAME] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FRAMESET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H1] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H2] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H3] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H4] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H5] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H6] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HEAD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HEADER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HGROUP] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HTML] = true;
SPECIAL_ELEMENTS[NS.HTML][$.IFRAME] = true;
SPECIAL_ELEMENTS[NS.HTML][$.IMG] = true;
SPECIAL_ELEMENTS[NS.HTML][$.INPUT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LI] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LINK] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LISTING] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MAIN] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MARQUEE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MENU] = true;
SPECIAL_ELEMENTS[NS.HTML][$.META] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NAV] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOEMBED] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOFRAMES] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOSCRIPT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.OBJECT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.OL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.P] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PARAM] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PLAINTEXT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PRE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SCRIPT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SECTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SELECT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SOURCE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.STYLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SUMMARY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TABLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TBODY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TEMPLATE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TEXTAREA] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TFOOT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TH] = true;
SPECIAL_ELEMENTS[NS.HTML][$.THEAD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TITLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TRACK] = true;
SPECIAL_ELEMENTS[NS.HTML][$.UL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.WBR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.XMP] = true;

SPECIAL_ELEMENTS[NS.MATHML] = Object.create(null);
SPECIAL_ELEMENTS[NS.MATHML][$.MI] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MO] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MN] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MS] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MTEXT] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.ANNOTATION_XML] = true;

SPECIAL_ELEMENTS[NS.SVG] = Object.create(null);
SPECIAL_ELEMENTS[NS.SVG][$.TITLE] = true;
SPECIAL_ELEMENTS[NS.SVG][$.FOREIGN_OBJECT] = true;
SPECIAL_ELEMENTS[NS.SVG][$.DESC] = true;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(358);
var bytesToUuid = __webpack_require__(359);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video_instructions.9477a355.png";

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_ico_close_png__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_ico_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_ico_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_ico_warning_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_startButton_png__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_startButton_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_startButton_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_videoInstructionFull_png__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_videoInstructionFull_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_videoInstructionFull_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_playVideo_png__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_playVideo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_playVideo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_stopButton_png__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_stopButton_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_stopButton_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_redoButton_png__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_redoButton_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_redoButton_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_finishBtn_png__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_finishBtn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_finishBtn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_recordAudio_png__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_recordAudio_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_recordAudio_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_recordVideo_png__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_recordVideo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_recordVideo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_recordBtn1_png__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_recordBtn1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_recordBtn1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_beginBtn_png__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_beginBtn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_beginBtn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_changeBtn_png__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_changeBtn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_changeBtn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_saveBtn_png__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_saveBtn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_saveBtn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_read_instructions_png__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_read_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_read_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_sign_say_instructions_png__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_sign_say_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_sign_say_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_countdown_instructions_png__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_countdown_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_countdown_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_sign_instructions_png__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_sign_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_sign_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_rotate_device_fff_bg_png__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_rotate_device_fff_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_images_rotate_device_fff_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_wordMark2_Whiteboard_png__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_wordMark2_Whiteboard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_images_wordMark2_Whiteboard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__StudentsComponent_Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_App_Selection_Graphic_png__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_App_Selection_Graphic_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_images_App_Selection_Graphic_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var contentModal='';var InstructionModals=function(_Component){_inherits(DialogBoxComponent,_Component);function DialogBoxComponent(props){_classCallCheck(this,DialogBoxComponent);var _this=_possibleConstructorReturn(this,(DialogBoxComponent.__proto__||Object.getPrototypeOf(DialogBoxComponent)).call(this,props));_this.state={isModalOpen:_this.props.modalOpen?_this.props.modalOpen:false};_this.closeModal=_this.closeModal.bind(_this);_this.instructionToggle=_this.instructionToggle.bind(_this);return _this;}_createClass(DialogBoxComponent,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'openModal',value:function openModal(){this.setState({isModalOpen:true});}},{key:'instructionToggle',value:function instructionToggle(event){this.props.toggleInstruction(event.target.checked);}},{key:'closeModal',value:function closeModal(){this.props.closeClick(false);this.setState({isModalOpen:false});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["a" /* Modal */],{id:'InstructionBox',show:this.props.modalOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},this.props.WordMark?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{style:{marginBottom:25,fontSize:25}},'You have 3 minutes to write a story. Your work will be saved automatically.'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{style:{marginBottom:25,fontSize:35}},'How to Play'),this.props.Slash?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SlashInstruction,{instructionMask:__WEBPACK_IMPORTED_MODULE_22__assets_images_rotate_device_fff_bg_png___default.a}):null,this.props.PN?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PNInstruction,{instructionMask:__WEBPACK_IMPORTED_MODULE_7__assets_images_videoInstructionFull_png___default.a,startButton:__WEBPACK_IMPORTED_MODULE_6__assets_images_startButton_png___default.a}):null,this.props.WSS?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WSSInstruction,{instructionMask:__WEBPACK_IMPORTED_MODULE_7__assets_images_videoInstructionFull_png___default.a,startButton:__WEBPACK_IMPORTED_MODULE_6__assets_images_startButton_png___default.a}):null,this.props.Copyright?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CopyrightInstruction,{instructionMask:__WEBPACK_IMPORTED_MODULE_7__assets_images_videoInstructionFull_png___default.a,startButton:__WEBPACK_IMPORTED_MODULE_6__assets_images_startButton_png___default.a}):null,this.props.Kidspeak?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(KidspeakInstruction,{instructionMask:__WEBPACK_IMPORTED_MODULE_7__assets_images_videoInstructionFull_png___default.a,startButton:__WEBPACK_IMPORTED_MODULE_6__assets_images_startButton_png___default.a}):null,this.props.KidSign?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(KidSignInstruction,{instructionMask:__WEBPACK_IMPORTED_MODULE_7__assets_images_videoInstructionFull_png___default.a,startButton:__WEBPACK_IMPORTED_MODULE_6__assets_images_startButton_png___default.a}):null,this.props.WordMark?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WordmarkInstruction,{buttonClick:this.props.buttonClick,beginClick:this.props.beginClick,changeClick:this.props.changeClick,time:this.props.time,sessionTime:this.props.sessionTime,starterTitle:this.props.starterTitle,instructionMask:__WEBPACK_IMPORTED_MODULE_7__assets_images_videoInstructionFull_png___default.a,startButton:__WEBPACK_IMPORTED_MODULE_6__assets_images_startButton_png___default.a}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-12"},this.props.WordMark?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-2 col-xs-3"},this.props.Slash?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'instructionToggle',className:'cb',style:{paddingTop:7}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:this.instructionToggle,id:'instructionToggle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark',style:{top:5}}),' Hide')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-10 col-xs-9"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.closeModal,className:'handBtn pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Close')))))))));}}]);return DialogBoxComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SlashInstruction=function(_Component2){_inherits(SlashInstruction,_Component2);function SlashInstruction(props){_classCallCheck(this,SlashInstruction);var _this2=_possibleConstructorReturn(this,(SlashInstruction.__proto__||Object.getPrototypeOf(SlashInstruction)).call(this,props));_this2.state={key:1};_this2.handleSelect=_this2.handleSelect.bind(_this2);return _this2;}_createClass(SlashInstruction,[{key:'handleSelect',value:function handleSelect(key){this.setState({key:key});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-12",style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.instructionMask,style:{width:'100%'}}));}}]);return SlashInstruction;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PNInstruction=function(_Component3){_inherits(PNInstruction,_Component3);function PNInstruction(props){_classCallCheck(this,PNInstruction);var _this3=_possibleConstructorReturn(this,(PNInstruction.__proto__||Object.getPrototypeOf(PNInstruction)).call(this,props));_this3.state={key:1};_this3.handleSelect=_this3.handleSelect.bind(_this3);return _this3;}_createClass(PNInstruction,[{key:'handleSelect',value:function handleSelect(key){this.setState({key:key});}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-12",style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Tabs */],{activeKey:this.state.key,onSelect:this.handleSelect,id:'copyrightTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.instructionMask,style:{width:'100%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'2'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.startButton,style:{marginLeft:35,width:75}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_countdown_instructions_png___default.a,style:{width:200}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_21__assets_images_sign_instructions_png___default.a,style:{width:200}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'absolute',left:0,bottom:0,margin:'auto',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"center-block text-center"},this.state.key===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"handBtn handBtn active",onClick:function onClick(){return _this4.handleSelect(2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Next')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"handBtn handBtn active",onClick:function onClick(){return _this4.handleSelect(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Back')))));}}]);return PNInstruction;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var WSSInstruction=function(_Component4){_inherits(WSSInstruction,_Component4);function WSSInstruction(props){_classCallCheck(this,WSSInstruction);var _this5=_possibleConstructorReturn(this,(WSSInstruction.__proto__||Object.getPrototypeOf(WSSInstruction)).call(this,props));_this5.state={key:1};_this5.handleSelect=_this5.handleSelect.bind(_this5);return _this5;}_createClass(WSSInstruction,[{key:'handleSelect',value:function handleSelect(key){this.setState({key:key});}},{key:'render',value:function render(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-12",style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Tabs */],{activeKey:this.state.key,onSelect:this.handleSelect,id:'copyrightTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.instructionMask,style:{width:'100%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'2'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.startButton,style:{marginLeft:35,width:75}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_countdown_instructions_png___default.a,style:{width:200}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_images_sign_say_instructions_png___default.a,style:{width:200}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'absolute',left:0,bottom:0,margin:'auto',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"center-block text-center"},this.state.key===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"handBtn handBtn active",onClick:function onClick(){return _this6.handleSelect(2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Next')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"handBtn handBtn active",onClick:function onClick(){return _this6.handleSelect(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Back')))));}}]);return WSSInstruction;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CopyrightInstruction=function(_Component5){_inherits(CopyrightInstruction,_Component5);function CopyrightInstruction(props){_classCallCheck(this,CopyrightInstruction);var _this7=_possibleConstructorReturn(this,(CopyrightInstruction.__proto__||Object.getPrototypeOf(CopyrightInstruction)).call(this,props));_this7.state={key:1};_this7.handleSelect=_this7.handleSelect.bind(_this7);return _this7;}_createClass(CopyrightInstruction,[{key:'handleSelect',value:function handleSelect(key){this.setState({key:key});}},{key:'render',value:function render(){var _this8=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-12",style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Tabs */],{activeKey:this.state.key,onSelect:this.handleSelect,id:'copyrightTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.instructionMask,style:{width:'100%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'2'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_playVideo_png___default.a,style:{marginLeft:35,height:35}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'3'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.instructionMask,style:{width:'250px'}}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.startButton,style:{height:35}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'4'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_countdown_instructions_png___default.a,style:{width:200}}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'5'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_finishBtn_png___default.a,style:{marginLeft:35,height:35}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'absolute',left:0,bottom:0,margin:'auto',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"center-block text-center"},this.state.key===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"handBtn handBtn active",onClick:function onClick(){return _this8.handleSelect(2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Next')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"handBtn handBtn active",onClick:function onClick(){return _this8.handleSelect(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Back')))));}}]);return CopyrightInstruction;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var KidspeakInstruction=function(_Component6){_inherits(KidspeakInstruction,_Component6);function KidspeakInstruction(props){_classCallCheck(this,KidspeakInstruction);var _this9=_possibleConstructorReturn(this,(KidspeakInstruction.__proto__||Object.getPrototypeOf(KidspeakInstruction)).call(this,props));_this9.state={key:1};_this9.handleSelect=_this9.handleSelect.bind(_this9);return _this9;}_createClass(KidspeakInstruction,[{key:'handleSelect',value:function handleSelect(key){this.setState({key:key});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-12",style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Tabs */],{activeKey:this.state.key,onSelect:this.handleSelect,id:'copyrightTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'1'),' Read the title of the passage.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'2'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__assets_images_recordBtn1_png___default.a,style:{marginLeft:35,height:35}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'3'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_countdown_instructions_png___default.a,style:{width:200}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'4'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_finishBtn_png___default.a,style:{marginLeft:35,height:35}})))));}}]);return KidspeakInstruction;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var KidSignInstruction=function(_Component7){_inherits(KidSignInstruction,_Component7);function KidSignInstruction(props){_classCallCheck(this,KidSignInstruction);var _this10=_possibleConstructorReturn(this,(KidSignInstruction.__proto__||Object.getPrototypeOf(KidSignInstruction)).call(this,props));_this10.state={key:1};_this10.handleSelect=_this10.handleSelect.bind(_this10);return _this10;}_createClass(KidSignInstruction,[{key:'handleSelect',value:function handleSelect(key){this.setState({key:key});}},{key:'render',value:function render(){var _this11=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-12",style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Tabs */],{activeKey:this.state.key,onSelect:this.handleSelect,id:'copyrightTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'1'),'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18__assets_images_read_instructions_png___default.a,style:{width:250}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'2'),'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_21__assets_images_sign_instructions_png___default.a,style:{width:200}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'3'),'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_recordVideo_png___default.a,style:{marginLeft:35,height:35}}),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'4'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_countdown_instructions_png___default.a,style:{width:200}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'5'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_21__assets_images_sign_instructions_png___default.a,style:{width:200}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'6'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_stopButton_png___default.a,style:{marginLeft:35,height:35}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"circleBtn greenBtn"},'7'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_finishBtn_png___default.a,style:{marginLeft:35,height:35}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'absolute',left:0,bottom:0,margin:'auto',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"center-block text-center"},this.state.key===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"handBtn handBtn active",onClick:function onClick(){return _this11.handleSelect(2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Next')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"handBtn handBtn active",onClick:function onClick(){return _this11.handleSelect(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Back')))));}}]);return KidSignInstruction;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var WordmarkInstruction=function(_Component8){_inherits(WordmarkInstruction,_Component8);function WordmarkInstruction(props){_classCallCheck(this,WordmarkInstruction);var _this12=_possibleConstructorReturn(this,(WordmarkInstruction.__proto__||Object.getPrototypeOf(WordmarkInstruction)).call(this,props));_this12.state={key:1};_this12.handleSelect=_this12.handleSelect.bind(_this12);_this12.beginStory=_this12.beginStory.bind(_this12);_this12.changeStory=_this12.changeStory.bind(_this12);_this12.handleBack=_this12.handleBack.bind(_this12);return _this12;}_createClass(WordmarkInstruction,[{key:'handleSelect',value:function handleSelect(key){this.setState({key:key});}},{key:'beginStory',value:function beginStory(){this.props.beginClick(true);}},{key:'changeStory',value:function changeStory(){this.props.changeClick(true);}},{key:'handleBack',value:function handleBack(){this.props.buttonClick(0);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-12",style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Tabs */],{activeKey:this.state.key,onSelect:this.handleSelect,id:'wordmarkTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Tab */],{eventKey:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Your Story: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'"',this.props.starterTitle,'"')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__StudentsComponent_Common__["c" /* CountDownComponent */],{time:this.props.time,sessionTime:this.props.sessionTime,showTime:10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-12",style:{position:'relative',display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.changeStory,className:'handBtn',style:{marginRight:15}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Change')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.beginStory,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Begin'))))));}}]);return WordmarkInstruction;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{};};var mapStateToProps=function mapStateToProps(state){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(InstructionModals));

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(80);
var IE8_DOM_DEFINE = __webpack_require__(232);
var toPrimitive = __webpack_require__(161);
var dP = Object.defineProperty;

exports.f = __webpack_require__(82) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(235);
var defined = __webpack_require__(163);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(505);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiYmI1NDk1Ni03ZWIxLTRkYjMtYTIzOC01ZTcyMWMzMTU3MWYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzkzODJGNkMyRTVFMTFFOEJDMDA4MjM5MjMyQzkxRjMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzkzODJGNkIyRTVFMTFFOEJDMDA4MjM5MjMyQzkxRjMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxNjhhMzJhYi0xODk3LTQ4MjktODQ2NC1iNDc3YTkxYmI3YmIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6YmJiNTQ5NTYtN2ViMS00ZGIzLWEyMzgtNWU3MjFjMzE1NzFmIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+n8XNDQAAFCVJREFUeNrsnQmUVOWVx2+/7tqXLnqjm6DQBuOxEQbcMkHJGZcxoCeKxnhixpk5cRA5mklmsuhEM2aOE8aMjjOJjtEJOKMRY+SYCOYk4EqCSFSWyNrIYrpBaKBZbJqG3mu+W+9raElX1Vu+V++9qv+Pcy1sul69ut/9v2+/X1k6nSYAwMhocAEA2ang/9z8wDh4AgDJc99pRQ0CgOEaBCgnLmyCsDOFcfVcL6xWWI2wamkRYZXyIcXlkJDv7RTWL2xQWIewE8IOSTsorF3YPmH8mNslbIewY3A5BOJFwsImCpskbbL8/wYb10wM+3u1wfe0CdssbIOwTfKV/78bRQSBFBKuCT4j7BJhlwo7X1jAA/fVIO3KYT/rE7ZO2FvCVgr7vax5AASijKAUwgxpk3x07yzcT0v7hvzZRmHLpLFoelHEEIhZksI+L+xG+USOF9F3G2oKflv2W14T9oKwXwk7iqKHQLLBHebrhN0kbKbsW5TCQMIsadxXWSpskbAlcmAAQCA0VdhsYX9F+ohSKQ82XC+NR86eFbZA2B9KXSClOA8SkaJYIzuxd5S4OE6nUvpknfTRbdJnEEiRUydsHulzB/OFXQAt5IV99BPps3nShxBIkTFW2GOkT6zdQ/pkHTBHjfRdq/TlWAjE//CcxY+EbZdNhjDiXElfhX25Q/q2HgLxHylhDwrbKexrEIYjhKRvP5C+TkEg3qdCPt24xuBx/iji2HEi0tdDtXQFBOJN/kLYe7J9jD6GO30U9v16WRYQiIcK5hlhy0lfJAjcpUmWBZdJLQTiLjy5t0XYLYhLz8FlslmWEQRSYHjk5DfCFhbLU6pIqZVlxGXVAIEUhmtJ3+swE/HnG2bKvsm1EIhz8IjUE6QvpEOt4c/aZIkswygEopZPCXtH2O2IM9/DZbha2DkQiBqukw49D7FVNPBI17uybCEQi5STvjjuRdI3MIHiIinLdp4sawjEBDHSd7nx4rgyxFLRUibL+BeyzCEQA/AQ7huk73IDpQE3tZaTRxc+ekkg3DZdJexixEzJcZEs+yYIZGQuFLZCWCNipWRplDFwIQTycTitzutkPEkaKF6qZSxcCoHoXCXsZcJIFThFUsbEVaUukL8U9hJh3wb4UzgmfuUFkbglkOnCFpO+Mw2AkeCsli/KWCkpgVwknw6oOYDRmuTiUhEIp73kDH7IQwWMwrHyG3IpL3IhBVIrm1UYrQJmqZb91dpiFchQVXkWyhpYZLwbTfNCCIQXoz1Hehp+AOzwaRlL5cUkkH8hn+4mU8kVk2+n8xuvp3BgFMLcHhxL3y/Uhzmdx4gXot1b6iUaCqRo9jX3ZP4+MDhAbQd30R/3NtO2vetpc+tKavtoE8LeHHeTnnl+kZ8FwjsBnyYsWadk+FTO53KtnMbWNWZs+pSrMz872vURtbRtpZ17t9DWD9dQ84fLqW/gOGSQHY6pJ0k/MavZjwLhjtQvCcO5GeKR3AN3yViKJk/484wR3Uodxw7T3EenwnF53Er6XhJe3OjY08SpPsjDhERuJ4mFzaWuTQjBaGU4/MsA5wr7T7910rkTNRdlN1wg5ipSrUyj6sQn4Thj3E4ODgKpFggnCFuAMjtNICHzi5VrEmfAccZ5khxKTqc5cKPIW/UnNUjC9HuqEg1wnInniYw9TwuE87Ai4+EIRIJxCwKpg+PMMZMcyAWsKVTwD1FGIxMKmj8DszKGJWsW+CEpPv5C8+qNFROB8oDp96RicKcXHtQqBHIZFUGaeycJB8yvr0tEU3Cc9ab+5V4RCC8aewRlkqcGCZjfOJmKowaxAR8wWuEFgcwh5M11pIkVjyKPhQ04Jm9zWyDcBrgfZZGfSMh8Zk1efgJs8a+k4PRdOwK5Fx1zg+1QzXxtXyFqnUQYcyE2qCYFK8mtCoTzqN6BMjBGMGDtqPbaJBJN2uROspnz16pAeHMDspI4/QhMjoETbLZuZawWVCBjVXWASoWQxRokFcdsugLmyJgtmED+SVgYfjdOmWatoq6Kj4bzFDyfhH2nUALhTvmt8LlJgVjcVFkZw/51RXyFLA4omRXIXNmuAyYIB625DMtNlPZF5jotEP6Qr8LXhSMexY5lhfy9lYe7GYHwGhc0iq08hTRraZwq41Vwnjp4xOMWJwWCc8otEgxYS2Ifj6AGUcwcpwQyhTx2NFYpEA3HKFgRhyPUwTE81QmBzIFv3aEGyRtUc5tqgfCM+ZfhV5cEkhwLJ6iFYzmmUiB8Zjkawy5RlaiHE9TCsXytSoGg9nBTIHEkiXGAm1QJhKdyr4I/3WNUAiPrDjCDDJ6snE8gXBUF4E/3SESwccoBwkabWfkEMgu+tE9ZmfUE96k40v84xI12BcKzW1fCj/ZJp9PWaxAsWHSKK8jAMeS5BHIp6SnmgYtgb7pjcGxPtyMQpBH1ALFIgsq1IBzhXGfdskBmwH8e6L+IP9VxzKY7xEyrAuGxRRyA4xHqKsfBCc7QRHlWqGcTyCXwnXcYhdl0J7kEAvE51RAIBAKyUxnDxikvCYS3JeKIVQ+RwlkhTsKxHjYjEO64YFzRSzUItt46Ccf6RDMCmQSfqSWdHrT1/kQUs+kOMwkCcZGe3m7UIEUkkCnwl7fgU3LLysrhCOeYYkYg58JfqptYaVvv1zSNajCb7iTnGhUIj2DhUArFdPedsH2NmuSZcKRzNFCWpHKnn+wyHr7yJlWJwjy3eGFkMjKGEpFq0bSroni4UrwKCyUoKpp6kVCcoqEYRQIxKi8PUHfvcWrvaKPWA1tpfcsrdKL3kF9dzLHfDIH4lOpEnaHgTkQaKBGuFoEtgjuSEsGczAR2jF85sIPxzJFwkVCUwsFo5u/8yvmDQ6EIBStClu9xYHAevd+6nlZsfIlWbPmpaFoO+MnFZxkRyFkIRQeaWD3HbV/jwnMup/rq8SLAOciHAluYCOpMgNsMbjW1Tzk1NZ6fsVmXzKZnX/8vWrPzBT/VIHmbWJ9AOJsnVJEQT+zRoimSEjYq0yzhJ3eMmyPhpJJh2rPPOC9jfqG+eix986aH6c33rqAFr36bevuPef2WP2FEICWVYyZQHhXBXKc3R4RxgEdDejs7lmmGJPQndSA6rEkSp1AwojdJAuHMk9vKIZ2lwvQpV1NDzXh66IXZdPTEHi/faq0RgfhmRorb2w2piaKdXSWCujIT2NFMB1J/HR7YenNEBPRQW1sGeEU5ErYUggljm+i7Ny+k7y280cud+KqiEsjlk2fTrTPvRvT5hDNGn0XfumE+ff/5L3q18z7iitDT50F8c2rk/iOtiDqf0dR4AX1x2r1evb06IwLxTRaTrXt+R/0DfYg6n3HNtFuoLunJxRoxIwJJ+sXRPCqy50ALIs5n8FD0DdM8eZJf2IhAfLUP5IO2LYg4H3Jx02VUoXnuLNiQEYFE/eTobXvWI9p8CI8qThr3Oa/dVrkRgfiKza1vItp8SmN9k9duKV50Amnv3EaHj7Yj2nxIMuqPGQXN745uaXsf0eZDBgf7vXZLx4wI5LjfHL1z70ZEmw853Lnfa7c0YEQgvptYaN69BtHmM9Liz+rtL3vttnpG+uHpS006yGcHdm5rW0Er3vt1Zt82LyYMBcMUCgy9hk+uuwLeYcsHa2l/h+eG6LuNCOSY35w9MNhLjy+9I+/vxUJ1wqrlit1kZlEj75TL7JALxuWmoejHVu6eXNyYEVqYgrx6F2KzRV9/Lz3zxoNevLUuIwIp2iGhrp4DGaOj9q+VCDdktqNGQ6fElhGcXCo/XGwsqJrKBhrXcDaaVuk0PbXsIWptf8eLt3fAiEAOEchLZ3dbxowytXEW3fWlHyn57A073qajXUf0mi8cOynIoWX9wUDIkz470dNF/7v0B7Sy+adeLdZDRgRyGOHvQOO2V13LtXnXWlr8TvYmylDShWR0tKjpRlEsksrscIyHk5ndjfqemfjJPTMssAgLjftqQmSq98j09vXQu1uW0/Nv/gcd7Nzu5WI6XNJNrGJhVJ7kDdwnO9LVkjEr8PbhRKQ+04SMhTijSfJkXy3ThMzsg+esJtGTe+H1vfHcpNT7Zwc79lHboV20seVtWr1jCfX0feQH17YbEcgehKADHdOBHnUCiTm7K7qnv5N6OjvF077kimnE2D99HuQDhLO3m1jI0+sYLUYE0gI/eZtUogZOcIY/QiAu0dvfrexaOG3KXYFwEtk2+Epxu75PXYOeJyyjQdQiimmTsZ9XIEwz/OVt6kedAyeoJWvMjyQQbNNT3UlXnFWwrhKZ3hWz3oxANsBfqptYaucBqhOj4VS1bDAjEGyw8DhVSZybrpiNZgTC65B74TO19A+o20FXFa+FQ9XRK2PesEC4N/8e/KZaIOr2olXGcW66Qv5AWUawsgmEWQm/eZcUBKKSt3L9o2blTcBCDdKvrtWajOHcdAgEfZCsxCKJzKpboIRVVgSyP1fHBbjP6BQmCxXAMb7PikCYpfCfOvr61Q4M1laOg1PtkzfGcwlkGfynsImlOFFadQJzIQp42Y5AOPHtMfjQm9RWjoET7MGxvcKOQHgb3Ovwoxp4b7ZKUjEM9drkDcqSLM6oQJjF8KMaBgfVnsuXimPJu01+YeSX8glkCfkwHWkpgNl0W/QYffjnE8gRYa/An/YpK1ObSD+Fvel24NGroyoEwvwM/rQP7wRUSSyazOTAApZYZPQXjQiEm1md8Km30ESNVJOYAEeYh2P5JZUC4aS+P4dfvcfoVCOcYK326FIpEOZJ+NV7VCcxF2KBBaZqaoO/x+m4sUfEawLBbLpZOIbfdkIgzI/hX28xKoGdhSYxHcNmBLKQspyhAFwSCCYLzdAuY9gxgfC2xEfhZ+9QieUmZniEcmytVSEQ5gkrHwJI+bkbGYHEsbPQxMP9CStvNCuQg8L+D/42T8ABgSRiKTjWGE/J2HVcIMwDZGAVJHCeYEWIwgHUInnokTFLhRLIh8J+Ar+bDGaHzg6sSYyHc3PDsbq7kAJh/g19EZOO1soduW5VApOFefoeD9gqN4vv443uj8H/7pOMYqg3BxyjbW4IhJlHODbaMKpX856qQTBZmIVDsqVDbgmEU5b/M8rBGOl02qEaBPtCsnAf6fuZXBMIM1/YJpRFftradzly3UQEo1gjsIkUDSTZFQjnsvk6yiM/W1rXOlSDYC5kBP5RxqbrAmE4O8SzKJPcrNj0oiPXjUeTcO7H4b1Lr6m6mKqN0v9AFmcqS4Ud+96k7bvVn02UiKKJNYwjsvYgrwnkoBQJyMGiFY9RmtR21lWnNPU536Q8uXbdEgjJZhby+ebqOe5aSm+tf1npNddu+x0cq8OOfUr1RTXF1/s7wtxITha88i3ac6BFybX41KrX1yPpjIy5rwhLe10gPGt5K8orOz39nfSDRbPp8NF229datfFVaj/6PpyqP5jbnLiw5sA1OaUKFjPm6rB1bqf7nv4S7T1ofW6k49hhWrj8fjhTj7UlTl1cc+i6PJLQjLLL0SY4toO++/QsWtNsvg/R09tN/73kHursbit1N3KMfcPJD3BKIMeFfYFwfEJOTvQeoocX/w09tvg+av/I2OALN83+/fmvZjr8Jc4xGWNdTn5IhcPqni3sOWFlkEN2VjY/Tau2Pkufnfi3NK1pBk0Yex5FQtGT/85Dw/sOfUhvb36Vfr3mcerqKfncGWkZW463Uiocvv7zwqYKuxsyyM1gup9+u+nJjDG1yXNoVKye+gZ66UDHToji4zwoY4v8LhDmXmHnCrsW5WocHp3CCNWIvCRjqiBoBfgMPjnmZtKzMwJgh3dkLA0Uk0CGOu2fF9aKMgYW2S1j6HghP1Qr4Ge1yy94GGUNTMIxc42MISpWgTC8nHWmsA6UOTBIh4yZjW58uObCZ77rRlUJfMlQ0/xdt25Ac+lz+Qz2WYQEdCA7vI7/ehkrVGoCYV4lfegXNQnIVnO4foCs5vLnswM+RwZPHAUlAcfCDPLI6cqaB+5hpbArCKNbQI+BK91uVnlNIMwaYZ8V1oIYKVlaZAys9tJNaR66l83CPuM1B4GCsFqW/Wav3ZjmsfvhNd+XCVuMmCkZlsgy3+fFm9M8eE+8vv9G0vOqphE/RUtalrHjezqKTSAML0bjFZs8Do4RruKDy/QGWcYDXr5RzeOO5Or3ImFbEFNFA5flxX5pRms+uMdtUiT/g9jyPfNlWfpmo4vmk/vkmdW5pC9PQYpT/3FQNpfnkM9WTmg+czQ3uSYTMjj6iWWyzHw5Mqn58J45183Vwv6aXNgfAAzTLstoJjmU1A0Cyc1CYRPlK0DZQCA5nlI80YSRLvfhMri8mGp3rUgK5rfC/kzYnejEu9YJv1OWwfJi+mJaEX0XPnLrx8LOFvYQ4Rz3QnBC+vps6fv+YvuCWhEWGp++e5ewTwp7hLBr0QnYp49KH98lfV6UaEVciDxy8vVhTzfsXLTP8WG19NfIx6NTEMgpdsv28Thh3xOGHJ7mOSB9N076cnepfHGthAqZO5L3y0K+TdhaxH1e2EdzpM/upxIcANFKsNC7hS0QdqGwC4Q9TsjTNZwO6ZMLpI/mS5+VJFqJB8M6YXcIGyPsy6Qvh+gu0YfGEumDMdIn6/CsKEx2d790Pp+TlhR2Hen7FTiBQLxIvzMfQPOasF9KcWDfDQRiCA6UZ6QFhV1Kehoatkk+/26cvnOZNM4mg0PWIRBbcAC9IY3H++tJTy4wXdg0YecLC3j03vtkM2kV6Wl0fk8e3fcNgRQPHGAvSmPCws4jfTn38NfRBb6v/cI2Cdtw2ms3igwCcbtzu0bacLgfM0HYmdLGyNqnVliVsJSwkHwl+ffosP7Q0Ow/z1Dzco5D0niYtV0KdZe0Heg/QCB+7MesI4wE+R4NLgAgO2XpNFJPAYAaBAAL/L8AAwAVN/KpWoITQwAAAABJRU5ErkJggg=="

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REHYDRATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PERSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PURGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_VERSION; });
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(71);
var createDesc = __webpack_require__(100);
module.exports = __webpack_require__(82) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(81);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(99)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(510), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(61));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(84);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(56);

var ReactCurrentOwner = __webpack_require__(294);

var warning = __webpack_require__(130);
var canDefineProperty = __webpack_require__(292);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(295);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(138);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(63);
/*</replacement>*/

var Readable = __webpack_require__(315);
var Writable = __webpack_require__(319);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isTouchCapable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isMobileDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return multiValueAsValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return singleValueAsValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return valueTernary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return classNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return defaultComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return notNullish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isDocumentElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return cleanValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return scrollIntoView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MenuPlacer; });
/* unused harmony export N */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _createSuper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _objectSpread2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return clearIndicatorCSS; });
/* unused harmony export c */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return containerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return css$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return dropdownIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return groupCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return groupHeadingCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return indicatorsContainerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return indicatorSeparatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return inputCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return loadingIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return loadingMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return menuCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return menuListCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return menuPortalCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return multiValueCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return removeProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return supportsPassiveEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return multiValueLabelCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return multiValueRemoveCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return noOptionsMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return optionCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return placeholderCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return valueContainerCSS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_react__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_taggedTemplateLiteral__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_typeof__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createClass__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);













function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var _excluded$3 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_typeof__["a" /* default */])(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
      props.clearValue;
      props.cx;
      props.getStyles;
      props.getValue;
      props.hasValue;
      props.isMulti;
      props.isRtl;
      props.options;
      props.selectOption;
      props.selectProps;
      props.setValue;
      props.theme;
      var innerProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded$3);

  return _objectSpread2({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);

    if (typeof _newValue === 'string') return _newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }

  return el.clientHeight;
} // Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return document.documentElement;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36

var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }

}; // check for SSR

var w = typeof window !== 'undefined' ? window : {};

if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}

var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }

  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 1),
        key = _ref2[0];

    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];

    newProps[key] = val;
    return newProps;
  }, {});
};

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  }

  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, alignToControl(placement), '100%'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "backgroundColor", colors.neutral0), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "borderRadius", borderRadius), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginBottom", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginTop", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "position", 'absolute'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "width", '100%'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_10_react__["createContext"])({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPlacer, _Component);

  var _super = _createSuper(MenuPlacer);

  function MenuPlacer() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.context = void 0;

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread2(_objectSpread2({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);
MenuPlacer.contextType = PortalPlacementContext;

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      isMulti = props.isMulti;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /*#__PURE__*/function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPortal, _Component2);

  var _super2 = _createSuper(MenuPortal);

  function MenuPortal() {
    var _this2;

    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          className = _this$props2.className,
          controlElement = _this$props2.controlElement,
          cx = _this$props2.cx,
          innerProps = _this$props2.innerProps,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        css: getStyles('menuPortal', state),
        className: cx({
          'menu-portal': true
        }, className)
      }, innerProps), children);
      return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_11_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper);
    }
  }]);

  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing,
      isMulti = _ref2.isMulti,
      hasValue = _ref2.hasValue,
      controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return {
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      getStyles = props.getStyles;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};

var _templateObject;

var _excluded$2 = ["size"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2 =  true ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, _excluded$2);

  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("svg", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(Svg, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(Svg, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }, innerProps), children || Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }, innerProps), children || Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["e" /* keyframes */])(_templateObject || (_templateObject = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_taggedTemplateLiteral__["a" /* default */])(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("span", {
    css: /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["c" /* css */])({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : ";label:LoadingDot;",  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }, innerProps), Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(LoadingDot, {
    delay: 160,
    offset: true
  }), Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var _excluded$1 = ["data"];
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      innerProps = props.innerProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, innerProps), Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(Heading, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var getStyles = props.getStyles,
      cx = props.cx,
      className = props.className;

  var _cleanCommonProps = cleanCommonProps(props);
      _cleanCommonProps.data;
      var innerProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_cleanCommonProps, _excluded$1);

  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('groupHeading', props),
    className: cx({
      'group-heading': true
    }, className)
  }, innerProps));
};

var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      value = _ref.value,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80,
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle);
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};

var inputStyle = function inputStyle(isHidden) {
  return _objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};

var Input = function Input(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      value = props.value;

  var _cleanCommonProps = cleanCommonProps(props),
      innerRef = _cleanCommonProps.innerRef,
      isDisabled = _cleanCommonProps.isDisabled,
      isHidden = _cleanCommonProps.isHidden,
      inputClassName = _cleanCommonProps.inputClassName,
      innerProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_cleanCommonProps, _excluded);

  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", {
    className: cx({
      'input-container': true
    }, className),
    css: getStyles('input', props),
    "data-value": value || ''
  }, Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "button"
  }, innerProps), children || Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["b" /* ClassNames */], null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(Container, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }, innerProps),
      selectProps: selectProps
    }, Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])(Remove, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className)),
        'aria-label': "Remove ".concat(children || 'option')
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["d" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};




/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

// Last time updated: 2017-12-13 5:07:29 AM UTC

// ________________
// RecordRTC v5.4.6

// Open-Sourced: https://github.com/muaz-khan/RecordRTC

// --------------------------------------------------
// Muaz Khan     - www.MuazKhan.com
// MIT License   - www.WebRTC-Experiment.com/licence
// --------------------------------------------------

// ____________
// RecordRTC.js

/**
 * {@link https://github.com/muaz-khan/RecordRTC|RecordRTC} is a WebRTC JavaScript library for audio/video as well as screen activity recording. It supports Chrome, Firefox, Opera, Android, and Microsoft Edge. Platforms: Linux, Mac and Windows. 
 * @summary Record audio, video or screen inside the browser.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef RecordRTC
 * @class
 * @example
 * var recorder = RecordRTC(mediaStream or [arrayOfMediaStream], {
 *     type: 'video', // audio or video or gif or canvas
 *     recorderType: MediaStreamRecorder || CanvasRecorder || StereoAudioRecorder || Etc
 * });
 * recorder.startRecording();
 * @see For further information:
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - Single media-stream object, array of media-streams, html-canvas-element, etc.
 * @param {object} config - {type:"video", recorderType: MediaStreamRecorder, disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, desiredSampRate: 16000, video: HTMLVideoElement, etc.}
 */

function RecordRTC(mediaStream, config) {
    if (!mediaStream) {
        throw 'First parameter is required.';
    }

    config = config || {
        type: 'video'
    };

    config = new RecordRTCConfiguration(mediaStream, config);

    // a reference to user's recordRTC object
    var self = this;

    function startRecording(config2) {
        if (!!config2) {
            // allow users to set options using startRecording method
            // config2 is similar to main "config" object (second parameter over RecordRTC constructor)
            config = new RecordRTCConfiguration(mediaStream, config2);
        }

        if (!config.disableLogs) {
            console.log('started recording ' + config.type + ' stream.');
        }

        if (mediaRecorder) {
            mediaRecorder.clearRecordedData();
            mediaRecorder.record();

            setState('recording');

            if (self.recordingDuration) {
                handleRecordingDuration();
            }
            return self;
        }

        initRecorder(function() {
            if (self.recordingDuration) {
                handleRecordingDuration();
            }
        });

        return self;
    }

    function initRecorder(initCallback) {
        if (initCallback) {
            config.initCallback = function() {
                initCallback();
                initCallback = config.initCallback = null; // recorder.initRecorder should be call-backed once.
            };
        }

        var Recorder = new GetRecorderType(mediaStream, config);

        mediaRecorder = new Recorder(mediaStream, config);
        mediaRecorder.record();

        setState('recording');

        if (!config.disableLogs) {
            console.log('Initialized recorderType:', mediaRecorder.constructor.name, 'for output-type:', config.type);
        }
    }

    function stopRecording(callback) {
        callback = callback || function() {};

        if (!mediaRecorder) {
            warningLog();
            return;
        }

        if (self.state === 'paused') {
            self.resumeRecording();

            setTimeout(function() {
                stopRecording(callback);
            }, 1);
            return;
        }

        if (self.state !== 'recording' && !config.disableLogs) {
            console.warn('Recording state should be: "recording", however current state is: ', self.state);
        }

        if (!config.disableLogs) {
            console.log('Stopped recording ' + config.type + ' stream.');
        }

        if (config.type !== 'gif') {
            mediaRecorder.stop(_callback);
        } else {
            mediaRecorder.stop();
            _callback();
        }

        setState('stopped');

        function _callback(__blob) {
            if (!mediaRecorder) {
                if (typeof callback.call === 'function') {
                    callback.call(self, '');
                } else {
                    callback('');
                }
                return;
            }

            Object.keys(mediaRecorder).forEach(function(key) {
                if (typeof mediaRecorder[key] === 'function') {
                    return;
                }

                self[key] = mediaRecorder[key];
            });

            var blob = mediaRecorder.blob;

            if (!blob) {
                if (__blob) {
                    mediaRecorder.blob = blob = __blob;
                } else {
                    throw 'Recording failed.';
                }
            }

            if (blob && !config.disableLogs) {
                console.log(blob.type, '->', bytesToSize(blob.size));
            }

            if (callback) {
                var url = URL.createObjectURL(blob);

                if (typeof callback.call === 'function') {
                    callback.call(self, url);
                } else {
                    callback(url);
                }
            }

            if (!config.autoWriteToDisk) {
                return;
            }

            getDataURL(function(dataURL) {
                var parameter = {};
                parameter[config.type + 'Blob'] = dataURL;
                DiskStorage.Store(parameter);
            });
        }
    }

    function pauseRecording() {
        if (!mediaRecorder) {
            warningLog();
            return;
        }

        if (self.state !== 'recording') {
            if (!config.disableLogs) {
                console.warn('Unable to pause the recording. Recording state: ', self.state);
            }
            return;
        }

        setState('paused');

        mediaRecorder.pause();

        if (!config.disableLogs) {
            console.log('Paused recording.');
        }
    }

    function resumeRecording() {
        if (!mediaRecorder) {
            warningLog();
            return;
        }

        if (self.state !== 'paused') {
            if (!config.disableLogs) {
                console.warn('Unable to resume the recording. Recording state: ', self.state);
            }
            return;
        }

        setState('recording');

        // not all libs have this method yet
        mediaRecorder.resume();

        if (!config.disableLogs) {
            console.log('Resumed recording.');
        }
    }

    function readFile(_blob) {
        postMessage(new FileReaderSync().readAsDataURL(_blob));
    }

    function getDataURL(callback, _mediaRecorder) {
        if (!callback) {
            throw 'Pass a callback function over getDataURL.';
        }

        var blob = _mediaRecorder ? _mediaRecorder.blob : (mediaRecorder || {}).blob;

        if (!blob) {
            if (!config.disableLogs) {
                console.warn('Blob encoder did not finish its job yet.');
            }

            setTimeout(function() {
                getDataURL(callback, _mediaRecorder);
            }, 1000);
            return;
        }

        if (typeof Worker !== 'undefined' && !navigator.mozGetUserMedia) {
            var webWorker = processInWebWorker(readFile);

            webWorker.onmessage = function(event) {
                callback(event.data);
            };

            webWorker.postMessage(blob);
        } else {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function(event) {
                callback(event.target.result);
            };
        }

        function processInWebWorker(_function) {
            var blob = URL.createObjectURL(new Blob([_function.toString(),
                'this.onmessage =  function (e) {' + _function.name + '(e.data);}'
            ], {
                type: 'application/javascript'
            }));

            var worker = new Worker(blob);
            URL.revokeObjectURL(blob);
            return worker;
        }
    }

    function handleRecordingDuration(counter) {
        counter = counter || 0;

        if (self.state === 'paused') {
            setTimeout(function() {
                handleRecordingDuration(counter);
            }, 1000);
            return;
        }

        if (self.state === 'stopped') {
            return;
        }

        if (counter >= self.recordingDuration) {
            stopRecording(self.onRecordingStopped);
            return;
        }

        counter += 1000; // 1-second

        setTimeout(function() {
            handleRecordingDuration(counter);
        }, 1000);
    }

    function setState(state) {
        if (!self) {
            return;
        }

        self.state = state;

        if (typeof self.onStateChanged.call === 'function') {
            self.onStateChanged.call(self, state);
        } else {
            self.onStateChanged(state);
        }
    }

    var WARNING = 'It seems that recorder is destroyed or "startRecording" is not invoked for ' + config.type + ' recorder.';

    function warningLog() {
        if (config.disableLogs === true) {
            return;
        }

        console.warn(WARNING);
    }

    var mediaRecorder;

    var returnObject = {
        /**
         * This method starts the recording.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * var recorder = RecordRTC(mediaStream, {
         *     type: 'video'
         * });
         * recorder.startRecording();
         */
        startRecording: startRecording,

        /**
         * This method stops the recording. It is strongly recommended to get "blob" or "URI" inside the callback to make sure all recorders finished their job.
         * @param {function} callback - Callback to get the recorded blob.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     // use either "this" or "recorder" object; both are identical
         *     video.src = this.toURL();
         *     var blob = this.getBlob();
         * });
         */
        stopRecording: stopRecording,

        /**
         * This method pauses the recording. You can resume recording using "resumeRecording" method.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo Firefox is unable to pause the recording. Fix it.
         * @example
         * recorder.pauseRecording();  // pause the recording
         * recorder.resumeRecording(); // resume again
         */
        pauseRecording: pauseRecording,

        /**
         * This method resumes the recording.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.pauseRecording();  // first of all, pause the recording
         * recorder.resumeRecording(); // now resume it
         */
        resumeRecording: resumeRecording,

        /**
         * This method initializes the recording.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo This method should be deprecated.
         * @example
         * recorder.initRecorder();
         */
        initRecorder: initRecorder,

        /**
         * Ask RecordRTC to auto-stop the recording after 5 minutes.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * var fiveMinutes = 5 * 1000 * 60;
         * recorder.setRecordingDuration(fiveMinutes, function() {
         *    var blob = this.getBlob();
         *    video.src = this.toURL();
         * });
         * 
         * // or otherwise
         * recorder.setRecordingDuration(fiveMinutes).onRecordingStopped(function() {
         *    var blob = this.getBlob();
         *    video.src = this.toURL();
         * });
         */
        setRecordingDuration: function(recordingDuration, callback) {
            if (typeof recordingDuration === 'undefined') {
                throw 'recordingDuration is required.';
            }

            if (typeof recordingDuration !== 'number') {
                throw 'recordingDuration must be a number.';
            }

            self.recordingDuration = recordingDuration;
            self.onRecordingStopped = callback || function() {};

            return {
                onRecordingStopped: function(callback) {
                    self.onRecordingStopped = callback;
                }
            };
        },

        /**
         * This method can be used to clear/reset all the recorded data.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo Figure out the difference between "reset" and "clearRecordedData" methods.
         * @example
         * recorder.clearRecordedData();
         */
        clearRecordedData: function() {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            mediaRecorder.clearRecordedData();

            if (!config.disableLogs) {
                console.log('Cleared old recorded data.');
            }
        },

        /**
         * Get the recorded blob. Use this method inside the "stopRecording" callback.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     var blob = this.getBlob();
         *
         *     var file = new File([blob], 'filename.webm', {
         *         type: 'video/webm'
         *     });
         *
         *     var formData = new FormData();
         *     formData.append('file', file); // upload "File" object rather than a "Blob"
         *     uploadToServer(formData);
         * });
         * @returns {Blob} Returns recorded data as "Blob" object.
         */
        getBlob: function() {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            return mediaRecorder.blob;
        },

        /**
         * Get data-URI instead of Blob.
         * @param {function} callback - Callback to get the Data-URI.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     recorder.getDataURL(function(dataURI) {
         *         video.src = dataURI;
         *     });
         * });
         */
        getDataURL: getDataURL,

        /**
         * Get virtual/temporary URL. Usage of this URL is limited to current tab.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     video.src = this.toURL();
         * });
         * @returns {String} Returns a virtual/temporary URL for the recorded "Blob".
         */
        toURL: function() {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            return URL.createObjectURL(mediaRecorder.blob);
        },

        /**
         * Get internal recording object (i.e. internal module) e.g. MutliStreamRecorder, MediaStreamRecorder, StereoAudioRecorder or WhammyRecorder etc.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * var internal = recorder.getInternalRecorder();
         * if(internal instanceof MultiStreamRecorder) {
         *     internal.addStreams([newAudioStream]);
         *     internal.resetVideoStreams([screenStream]);
         * }
         * @returns {Object} Returns internal recording object.
         */
        getInternalRecorder: function() {
            return mediaRecorder;
        },

        /**
         * Invoke save-as dialog to save the recorded blob into your disk.
         * @param {string} fileName - Set your own file name.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     this.save('file-name');
         *
         *     // or manually:
         *     invokeSaveAsDialog(this.getBlob(), 'filename.webm');
         * });
         */
        save: function(fileName) {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            invokeSaveAsDialog(mediaRecorder.blob, fileName);
        },

        /**
         * This method gets a blob from indexed-DB storage.
         * @param {function} callback - Callback to get the recorded blob.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.getFromDisk(function(dataURL) {
         *     video.src = dataURL;
         * });
         */
        getFromDisk: function(callback) {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            RecordRTC.getFromDisk(config.type, callback);
        },

        /**
         * This method appends an array of webp images to the recorded video-blob. It takes an "array" object.
         * @type {Array.<Array>}
         * @param {Array} arrayOfWebPImages - Array of webp images.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo This method should be deprecated.
         * @example
         * var arrayOfWebPImages = [];
         * arrayOfWebPImages.push({
         *     duration: index,
         *     image: 'data:image/webp;base64,...'
         * });
         * recorder.setAdvertisementArray(arrayOfWebPImages);
         */
        setAdvertisementArray: function(arrayOfWebPImages) {
            config.advertisement = [];

            var length = arrayOfWebPImages.length;
            for (var i = 0; i < length; i++) {
                config.advertisement.push({
                    duration: i,
                    image: arrayOfWebPImages[i]
                });
            }
        },

        /**
         * It is equivalent to <code class="str">"recorder.getBlob()"</code> method. Usage of "getBlob" is recommended, though.
         * @property {Blob} blob - Recorded Blob can be accessed using this property.
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     var blob = this.blob;
         *
         *     // below one is recommended
         *     var blob = this.getBlob();
         * });
         */
        blob: null,

        /**
         * This works only with {recorderType:StereoAudioRecorder}. Use this property on "stopRecording" to verify the encoder's sample-rates.
         * @property {number} bufferSize - Buffer-size used to encode the WAV container
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     alert('Recorder used this buffer-size: ' + this.bufferSize);
         * });
         */
        bufferSize: 0,

        /**
         * This works only with {recorderType:StereoAudioRecorder}. Use this property on "stopRecording" to verify the encoder's sample-rates.
         * @property {number} sampleRate - Sample-rates used to encode the WAV container
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     alert('Recorder used these sample-rates: ' + this.sampleRate);
         * });
         */
        sampleRate: 0,

        /**
         * {recorderType:StereoAudioRecorder} returns ArrayBuffer object.
         * @property {ArrayBuffer} buffer - Audio ArrayBuffer, supported only in Chrome.
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     var arrayBuffer = this.buffer;
         *     alert(arrayBuffer.byteLength);
         * });
         */
        buffer: null,

        /**
         * This method resets the recorder. So that you can reuse single recorder instance many times.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.reset();
         * recorder.startRecording();
         */
        reset: function() {
            if (mediaRecorder && typeof mediaRecorder.clearRecordedData === 'function') {
                mediaRecorder.clearRecordedData();
            }
            mediaRecorder = null;
            setState('inactive');
            self.blob = null;
        },

        /**
         * This method is called whenever recorder's state changes. Use this as an "event".
         * @property {String} state - A recorder's state can be: recording, paused, stopped or inactive.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.onStateChanged = function(state) {
         *     console.log('Recorder state: ', state);
         * };
         */
        onStateChanged: function(state) {
            if (!config.disableLogs) {
                console.log('Recorder state changed:', state);
            }
        },

        /**
         * A recorder can have inactive, recording, paused or stopped states.
         * @property {String} state - A recorder's state can be: recording, paused, stopped or inactive.
         * @memberof RecordRTC
         * @static
         * @readonly
         * @example
         * // this looper function will keep you updated about the recorder's states.
         * (function looper() {
         *     document.querySelector('h1').innerHTML = 'Recorder's state is: ' + recorder.state;
         *     if(recorder.state === 'stopped') return; // ignore+stop
         *     setTimeout(looper, 1000); // update after every 3-seconds
         * })();
         * recorder.startRecording();
         */
        state: 'inactive',

        /**
         * Get recorder's readonly state.
         * @method
         * @memberof RecordRTC
         * @example
         * var state = recorder.getState();
         * @returns {String} Returns recording state.
         */
        getState: function() {
            return self.state;
        },

        /**
         * Destroy RecordRTC instance. Clear all recorders and objects.
         * @method
         * @memberof RecordRTC
         * @example
         * recorder.destroy();
         */
        destroy: function() {
            var disableLogs = config.disableLogs;

            config.disableLogs = true;
            self.reset();
            config = {};
            setState('destroyed');
            returnObject = self = null;

            if (Storage.AudioContextConstructor) {
                Storage.AudioContextConstructor.close();
                Storage.AudioContextConstructor = null;
            }

            if (!disableLogs) {
                console.warn('RecordRTC is destroyed.');
            }
        },

        /**
         * RecordRTC version number
         * @property {String} version - Release version number.
         * @memberof RecordRTC
         * @static
         * @readonly
         * @example
         * alert(recorder.version);
         */
        version: '5.4.6'
    };

    if (!this) {
        self = returnObject;
        return returnObject;
    }

    // if someone wants to use RecordRTC with the "new" keyword.
    for (var prop in returnObject) {
        this[prop] = returnObject[prop];
    }

    self = this;

    return returnObject;
}

RecordRTC.version = '5.4.6';

if (true /* && !!module.exports*/ ) {
    module.exports = RecordRTC;
}

if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return RecordRTC;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}

RecordRTC.getFromDisk = function(type, callback) {
    if (!callback) {
        throw 'callback is mandatory.';
    }

    console.log('Getting recorded ' + (type === 'all' ? 'blobs' : type + ' blob ') + ' from disk!');
    DiskStorage.Fetch(function(dataURL, _type) {
        if (type !== 'all' && _type === type + 'Blob' && callback) {
            callback(dataURL);
        }

        if (type === 'all' && callback) {
            callback(dataURL, _type.replace('Blob', ''));
        }
    });
};

/**
 * This method can be used to store recorded blobs into IndexedDB storage.
 * @param {object} options - {audio: Blob, video: Blob, gif: Blob}
 * @method
 * @memberof RecordRTC
 * @example
 * RecordRTC.writeToDisk({
 *     audio: audioBlob,
 *     video: videoBlob,
 *     gif  : gifBlob
 * });
 */
RecordRTC.writeToDisk = function(options) {
    console.log('Writing recorded blob(s) to disk!');
    options = options || {};
    if (options.audio && options.video && options.gif) {
        options.audio.getDataURL(function(audioDataURL) {
            options.video.getDataURL(function(videoDataURL) {
                options.gif.getDataURL(function(gifDataURL) {
                    DiskStorage.Store({
                        audioBlob: audioDataURL,
                        videoBlob: videoDataURL,
                        gifBlob: gifDataURL
                    });
                });
            });
        });
    } else if (options.audio && options.video) {
        options.audio.getDataURL(function(audioDataURL) {
            options.video.getDataURL(function(videoDataURL) {
                DiskStorage.Store({
                    audioBlob: audioDataURL,
                    videoBlob: videoDataURL
                });
            });
        });
    } else if (options.audio && options.gif) {
        options.audio.getDataURL(function(audioDataURL) {
            options.gif.getDataURL(function(gifDataURL) {
                DiskStorage.Store({
                    audioBlob: audioDataURL,
                    gifBlob: gifDataURL
                });
            });
        });
    } else if (options.video && options.gif) {
        options.video.getDataURL(function(videoDataURL) {
            options.gif.getDataURL(function(gifDataURL) {
                DiskStorage.Store({
                    videoBlob: videoDataURL,
                    gifBlob: gifDataURL
                });
            });
        });
    } else if (options.audio) {
        options.audio.getDataURL(function(audioDataURL) {
            DiskStorage.Store({
                audioBlob: audioDataURL
            });
        });
    } else if (options.video) {
        options.video.getDataURL(function(videoDataURL) {
            DiskStorage.Store({
                videoBlob: videoDataURL
            });
        });
    } else if (options.gif) {
        options.gif.getDataURL(function(gifDataURL) {
            DiskStorage.Store({
                gifBlob: gifDataURL
            });
        });
    }
};

// __________________________
// RecordRTC-Configuration.js

/**
 * {@link RecordRTCConfiguration} is an inner/private helper for {@link RecordRTC}.
 * @summary It configures the 2nd parameter passed over {@link RecordRTC} and returns a valid "config" object.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef RecordRTCConfiguration
 * @class
 * @example
 * var options = RecordRTCConfiguration(mediaStream, options);
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {type:"video", disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, video: HTMLVideoElement, getNativeBlob:true, etc.}
 */

function RecordRTCConfiguration(mediaStream, config) {
    if (!config.recorderType && !config.type) {
        if (!!config.audio && !!config.video) {
            config.type = 'video';
        } else if (!!config.audio && !config.video) {
            config.type = 'audio';
        }
    }

    if (config.recorderType && !config.type) {
        if (config.recorderType === WhammyRecorder || config.recorderType === CanvasRecorder) {
            config.type = 'video';
        } else if (config.recorderType === GifRecorder) {
            config.type = 'gif';
        } else if (config.recorderType === StereoAudioRecorder) {
            config.type = 'audio';
        } else if (config.recorderType === MediaStreamRecorder) {
            if (mediaStream.getAudioTracks().length && mediaStream.getVideoTracks().length) {
                config.type = 'video';
            } else if (mediaStream.getAudioTracks().length && !mediaStream.getVideoTracks().length) {
                config.type = 'audio';
            } else if (!mediaStream.getAudioTracks().length && mediaStream.getVideoTracks().length) {
                config.type = 'audio';
            } else {
                // config.type = 'UnKnown';
            }
        }
    }

    if (typeof MediaStreamRecorder !== 'undefined' && typeof MediaRecorder !== 'undefined' && 'requestData' in MediaRecorder.prototype) {
        if (!config.mimeType) {
            config.mimeType = 'video/webm';
        }

        if (!config.type) {
            config.type = config.mimeType.split('/')[0];
        }

        if (!config.bitsPerSecond) {
            // config.bitsPerSecond = 128000;
        }
    }

    // consider default type=audio
    if (!config.type) {
        if (config.mimeType) {
            config.type = config.mimeType.split('/')[0];
        }
        if (!config.type) {
            config.type = 'audio';
        }
    }

    return config;
}

// __________________
// GetRecorderType.js

/**
 * {@link GetRecorderType} is an inner/private helper for {@link RecordRTC}.
 * @summary It returns best recorder-type available for your browser.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef GetRecorderType
 * @class
 * @example
 * var RecorderType = GetRecorderType(options);
 * var recorder = new RecorderType(options);
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {type:"video", disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, video: HTMLVideoElement, etc.}
 */

function GetRecorderType(mediaStream, config) {
    var recorder;

    // StereoAudioRecorder can work with all three: Edge, Firefox and Chrome
    // todo: detect if it is Edge, then auto use: StereoAudioRecorder
    if (isChrome || isEdge || isOpera) {
        // Media Stream Recording API has not been implemented in chrome yet;
        // That's why using WebAudio API to record stereo audio in WAV format
        recorder = StereoAudioRecorder;
    }

    if (typeof MediaRecorder !== 'undefined' && 'requestData' in MediaRecorder.prototype && !isChrome) {
        recorder = MediaStreamRecorder;
    }

    // video recorder (in WebM format)
    if (config.type === 'video' && (isChrome || isOpera)) {
        recorder = WhammyRecorder;
    }

    // video recorder (in Gif format)
    if (config.type === 'gif') {
        recorder = GifRecorder;
    }

    // html2canvas recording!
    if (config.type === 'canvas') {
        recorder = CanvasRecorder;
    }

    if (isMediaRecorderCompatible() && recorder !== CanvasRecorder && recorder !== GifRecorder && typeof MediaRecorder !== 'undefined' && 'requestData' in MediaRecorder.prototype) {
        if ((mediaStream.getVideoTracks && mediaStream.getVideoTracks().length) || (mediaStream.getAudioTracks && mediaStream.getAudioTracks().length)) {
            // audio-only recording
            if (config.type === 'audio') {
                if (typeof MediaRecorder.isTypeSupported === 'function' && MediaRecorder.isTypeSupported('audio/webm')) {
                    recorder = MediaStreamRecorder;
                }
                // else recorder = StereoAudioRecorder;
            } else {
                // video or screen tracks
                if (typeof MediaRecorder.isTypeSupported === 'function' && MediaRecorder.isTypeSupported('video/webm')) {
                    recorder = MediaStreamRecorder;
                }
            }
        }
    }

    if (config.recorderType) {
        recorder = config.recorderType;
    }

    if (mediaStream instanceof Array && mediaStream.length) {
        recorder = MultiStreamRecorder;
    }

    if (!config.disableLogs && !!recorder && !!recorder.name) {
        console.log('Using recorderType:', recorder.name || recorder.constructor.name);
    }

    return recorder;
}

// _____________
// MRecordRTC.js

/**
 * MRecordRTC runs on top of {@link RecordRTC} to bring multiple recordings in a single place, by providing simple API.
 * @summary MRecordRTC stands for "Multiple-RecordRTC".
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef MRecordRTC
 * @class
 * @example
 * var recorder = new MRecordRTC();
 * recorder.addStream(MediaStream);
 * recorder.mediaType = {
 *     audio: true, // or StereoAudioRecorder or MediaStreamRecorder
 *     video: true, // or WhammyRecorder or MediaStreamRecorder
 *     gif: true    // or GifRecorder
 * };
 * // mimeType is optional and should be set only in advance cases.
 * recorder.mimeType = {
 *     audio: 'audio/wav',
 *     video: 'video/webm',
 *     gif:   'image/gif'
 * };
 * recorder.startRecording();
 * @see For further information:
 * @see {@link https://github.com/muaz-khan/RecordRTC/tree/master/MRecordRTC|MRecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @requires {@link RecordRTC}
 */

function MRecordRTC(mediaStream) {

    /**
     * This method attaches MediaStream object to {@link MRecordRTC}.
     * @param {MediaStream} mediaStream - A MediaStream object, either fetched using getUserMedia API, or generated using captureStreamUntilEnded or WebAudio API.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.addStream(MediaStream);
     */
    this.addStream = function(_mediaStream) {
        if (_mediaStream) {
            mediaStream = _mediaStream;
        }
    };

    /**
     * This property can be used to set the recording type e.g. audio, or video, or gif, or canvas.
     * @property {object} mediaType - {audio: true, video: true, gif: true}
     * @memberof MRecordRTC
     * @example
     * var recorder = new MRecordRTC();
     * recorder.mediaType = {
     *     audio: true, // TRUE or StereoAudioRecorder or MediaStreamRecorder
     *     video: true, // TRUE or WhammyRecorder or MediaStreamRecorder
     *     gif  : true  // TRUE or GifRecorder
     * };
     */
    this.mediaType = {
        audio: true,
        video: true
    };

    /**
     * This method starts recording.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.startRecording();
     */
    this.startRecording = function() {
        var mediaType = this.mediaType;
        var recorderType;
        var mimeType = this.mimeType || {
            audio: null,
            video: null,
            gif: null
        };

        if (typeof mediaType.audio !== 'function' && isMediaRecorderCompatible() && mediaStream.getAudioTracks && !mediaStream.getAudioTracks().length) {
            mediaType.audio = false;
        }

        if (typeof mediaType.video !== 'function' && isMediaRecorderCompatible() && mediaStream.getVideoTracks && !mediaStream.getVideoTracks().length) {
            mediaType.video = false;
        }

        if (typeof mediaType.gif !== 'function' && isMediaRecorderCompatible() && mediaStream.getVideoTracks && !mediaStream.getVideoTracks().length) {
            mediaType.gif = false;
        }

        if (!mediaType.audio && !mediaType.video && !mediaType.gif) {
            throw 'MediaStream must have either audio or video tracks.';
        }

        if (!!mediaType.audio) {
            recorderType = null;
            if (typeof mediaType.audio === 'function') {
                recorderType = mediaType.audio;
            }

            this.audioRecorder = new RecordRTC(mediaStream, {
                type: 'audio',
                bufferSize: this.bufferSize,
                sampleRate: this.sampleRate,
                numberOfAudioChannels: this.numberOfAudioChannels || 2,
                disableLogs: this.disableLogs,
                recorderType: recorderType,
                mimeType: mimeType.audio,
                timeSlice: this.timeSlice,
                onTimeStamp: this.onTimeStamp
            });

            if (!mediaType.video) {
                this.audioRecorder.startRecording();
            }
        }

        if (!!mediaType.video) {
            recorderType = null;
            if (typeof mediaType.video === 'function') {
                recorderType = mediaType.video;
            }

            var newStream = mediaStream;

            if (isMediaRecorderCompatible() && !!mediaType.audio && typeof mediaType.audio === 'function') {
                var videoTrack = mediaStream.getVideoTracks()[0];

                if (!!navigator.mozGetUserMedia) {
                    newStream = new MediaStream();
                    newStream.addTrack(videoTrack);

                    if (recorderType && recorderType === WhammyRecorder) {
                        // Firefox does NOT support webp-encoding yet
                        recorderType = MediaStreamRecorder;
                    }
                } else {
                    newStream = new MediaStream([videoTrack]);
                }
            }

            this.videoRecorder = new RecordRTC(newStream, {
                type: 'video',
                video: this.video,
                canvas: this.canvas,
                frameInterval: this.frameInterval || 10,
                disableLogs: this.disableLogs,
                recorderType: recorderType,
                mimeType: mimeType.video,
                timeSlice: this.timeSlice,
                onTimeStamp: this.onTimeStamp
            });

            if (!mediaType.audio) {
                this.videoRecorder.startRecording();
            }
        }

        if (!!mediaType.audio && !!mediaType.video) {
            var self = this;

            // this line prevents StereoAudioRecorder
            // todo: fix it
            if (isMediaRecorderCompatible() /* && !this.audioRecorder */ ) {
                self.audioRecorder = null;
                self.videoRecorder.startRecording();
            } else {
                self.videoRecorder.initRecorder(function() {
                    self.audioRecorder.initRecorder(function() {
                        // Both recorders are ready to record things accurately
                        self.videoRecorder.startRecording();
                        self.audioRecorder.startRecording();
                    });
                });
            }
        }

        if (!!mediaType.gif) {
            recorderType = null;
            if (typeof mediaType.gif === 'function') {
                recorderType = mediaType.gif;
            }
            this.gifRecorder = new RecordRTC(mediaStream, {
                type: 'gif',
                frameRate: this.frameRate || 200,
                quality: this.quality || 10,
                disableLogs: this.disableLogs,
                recorderType: recorderType,
                mimeType: mimeType.gif
            });
            this.gifRecorder.startRecording();
        }
    };

    /**
     * This method stops recording.
     * @param {function} callback - Callback function is invoked when all encoders finished their jobs.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.stopRecording(function(recording){
     *     var audioBlob = recording.audio;
     *     var videoBlob = recording.video;
     *     var gifBlob   = recording.gif;
     * });
     */
    this.stopRecording = function(callback) {
        callback = callback || function() {};

        if (this.audioRecorder) {
            this.audioRecorder.stopRecording(function(blobURL) {
                callback(blobURL, 'audio');
            });
        }

        if (this.videoRecorder) {
            this.videoRecorder.stopRecording(function(blobURL) {
                callback(blobURL, 'video');
            });
        }

        if (this.gifRecorder) {
            this.gifRecorder.stopRecording(function(blobURL) {
                callback(blobURL, 'gif');
            });
        }
    };

    /**
     * This method pauses recording.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.pauseRecording();
     */
    this.pauseRecording = function() {
        if (this.audioRecorder) {
            this.audioRecorder.pauseRecording();
        }

        if (this.videoRecorder) {
            this.videoRecorder.pauseRecording();
        }

        if (this.gifRecorder) {
            this.gifRecorder.pauseRecording();
        }
    };

    /**
     * This method resumes recording.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.resumeRecording();
     */
    this.resumeRecording = function() {
        if (this.audioRecorder) {
            this.audioRecorder.resumeRecording();
        }

        if (this.videoRecorder) {
            this.videoRecorder.resumeRecording();
        }

        if (this.gifRecorder) {
            this.gifRecorder.resumeRecording();
        }
    };

    /**
     * This method can be used to manually get all recorded blobs.
     * @param {function} callback - All recorded blobs are passed back to the "callback" function.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.getBlob(function(recording){
     *     var audioBlob = recording.audio;
     *     var videoBlob = recording.video;
     *     var gifBlob   = recording.gif;
     * });
     * // or
     * var audioBlob = recorder.getBlob().audio;
     * var videoBlob = recorder.getBlob().video;
     */
    this.getBlob = function(callback) {
        var output = {};

        if (this.audioRecorder) {
            output.audio = this.audioRecorder.getBlob();
        }

        if (this.videoRecorder) {
            output.video = this.videoRecorder.getBlob();
        }

        if (this.gifRecorder) {
            output.gif = this.gifRecorder.getBlob();
        }

        if (callback) {
            callback(output);
        }

        return output;
    };

    /**
     * Destroy all recorder instances.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.destroy();
     */
    this.destroy = function() {
        if (this.audioRecorder) {
            this.audioRecorder.destroy();
            this.audioRecorder = null;
        }

        if (this.videoRecorder) {
            this.videoRecorder.destroy();
            this.videoRecorder = null;
        }

        if (this.gifRecorder) {
            this.gifRecorder.destroy();
            this.gifRecorder = null;
        }
    };

    /**
     * This method can be used to manually get all recorded blobs' DataURLs.
     * @param {function} callback - All recorded blobs' DataURLs are passed back to the "callback" function.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.getDataURL(function(recording){
     *     var audioDataURL = recording.audio;
     *     var videoDataURL = recording.video;
     *     var gifDataURL   = recording.gif;
     * });
     */
    this.getDataURL = function(callback) {
        this.getBlob(function(blob) {
            if (blob.audio && blob.video) {
                getDataURL(blob.audio, function(_audioDataURL) {
                    getDataURL(blob.video, function(_videoDataURL) {
                        callback({
                            audio: _audioDataURL,
                            video: _videoDataURL
                        });
                    });
                });
            } else if (blob.audio) {
                getDataURL(blob.audio, function(_audioDataURL) {
                    callback({
                        audio: _audioDataURL
                    });
                });
            } else if (blob.video) {
                getDataURL(blob.video, function(_videoDataURL) {
                    callback({
                        video: _videoDataURL
                    });
                });
            }
        });

        function getDataURL(blob, callback00) {
            if (typeof Worker !== 'undefined') {
                var webWorker = processInWebWorker(function readFile(_blob) {
                    postMessage(new FileReaderSync().readAsDataURL(_blob));
                });

                webWorker.onmessage = function(event) {
                    callback00(event.data);
                };

                webWorker.postMessage(blob);
            } else {
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = function(event) {
                    callback00(event.target.result);
                };
            }
        }

        function processInWebWorker(_function) {
            var blob = URL.createObjectURL(new Blob([_function.toString(),
                'this.onmessage =  function (e) {' + _function.name + '(e.data);}'
            ], {
                type: 'application/javascript'
            }));

            var worker = new Worker(blob);
            var url;
            if (typeof URL !== 'undefined') {
                url = URL;
            } else if (typeof webkitURL !== 'undefined') {
                url = webkitURL;
            } else {
                throw 'Neither URL nor webkitURL detected.';
            }
            url.revokeObjectURL(blob);
            return worker;
        }
    };

    /**
     * This method can be used to ask {@link MRecordRTC} to write all recorded blobs into IndexedDB storage.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.writeToDisk();
     */
    this.writeToDisk = function() {
        RecordRTC.writeToDisk({
            audio: this.audioRecorder,
            video: this.videoRecorder,
            gif: this.gifRecorder
        });
    };

    /**
     * This method can be used to invoke a save-as dialog for all recorded blobs.
     * @param {object} args - {audio: 'audio-name', video: 'video-name', gif: 'gif-name'}
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.save({
     *     audio: 'audio-file-name',
     *     video: 'video-file-name',
     *     gif  : 'gif-file-name'
     * });
     */
    this.save = function(args) {
        args = args || {
            audio: true,
            video: true,
            gif: true
        };

        if (!!args.audio && this.audioRecorder) {
            this.audioRecorder.save(typeof args.audio === 'string' ? args.audio : '');
        }

        if (!!args.video && this.videoRecorder) {
            this.videoRecorder.save(typeof args.video === 'string' ? args.video : '');
        }
        if (!!args.gif && this.gifRecorder) {
            this.gifRecorder.save(typeof args.gif === 'string' ? args.gif : '');
        }
    };
}

/**
 * This method can be used to get all recorded blobs from IndexedDB storage.
 * @param {string} type - 'all' or 'audio' or 'video' or 'gif'
 * @param {function} callback - Callback function to get all stored blobs.
 * @method
 * @memberof MRecordRTC
 * @example
 * MRecordRTC.getFromDisk('all', function(dataURL, type){
 *     if(type === 'audio') { }
 *     if(type === 'video') { }
 *     if(type === 'gif')   { }
 * });
 */
MRecordRTC.getFromDisk = RecordRTC.getFromDisk;

/**
 * This method can be used to store recorded blobs into IndexedDB storage.
 * @param {object} options - {audio: Blob, video: Blob, gif: Blob}
 * @method
 * @memberof MRecordRTC
 * @example
 * MRecordRTC.writeToDisk({
 *     audio: audioBlob,
 *     video: videoBlob,
 *     gif  : gifBlob
 * });
 */
MRecordRTC.writeToDisk = RecordRTC.writeToDisk;

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.MRecordRTC = MRecordRTC;
}

var browserFakeUserAgent = 'Fake/5.0 (FakeOS) AppleWebKit/123 (KHTML, like Gecko) Fake/12.3.4567.89 Fake/123.45';

(function(that) {
    if (!that) {
        return;
    }

    if (typeof window !== 'undefined') {
        return;
    }

    if (typeof global === 'undefined') {
        return;
    }

    global.navigator = {
        userAgent: browserFakeUserAgent,
        getUserMedia: function() {}
    };

    if (!global.console) {
        global.console = {};
    }

    if (typeof global.console.log === 'undefined' || typeof global.console.error === 'undefined') {
        global.console.error = global.console.log = global.console.log || function() {
            console.log(arguments);
        };
    }

    if (typeof document === 'undefined') {
        /*global document:true */
        that.document = {};

        document.createElement = document.captureStream = document.mozCaptureStream = function() {
            var obj = {
                getContext: function() {
                    return obj;
                },
                play: function() {},
                pause: function() {},
                drawImage: function() {},
                toDataURL: function() {
                    return '';
                }
            };
            return obj;
        };

        that.HTMLVideoElement = function() {};
    }

    if (typeof location === 'undefined') {
        /*global location:true */
        that.location = {
            protocol: 'file:',
            href: '',
            hash: ''
        };
    }

    if (typeof screen === 'undefined') {
        /*global screen:true */
        that.screen = {
            width: 0,
            height: 0
        };
    }

    if (typeof URL === 'undefined') {
        /*global screen:true */
        that.URL = {
            createObjectURL: function() {
                return '';
            },
            revokeObjectURL: function() {
                return '';
            }
        };
    }

    /*global window:true */
    that.window = global;
})(typeof global !== 'undefined' ? global : null);

// _____________________________
// Cross-Browser-Declarations.js

// animation-frame used in WebM recording

/*jshint -W079 */
var requestAnimationFrame = window.requestAnimationFrame;
if (typeof requestAnimationFrame === 'undefined') {
    if (typeof webkitRequestAnimationFrame !== 'undefined') {
        /*global requestAnimationFrame:true */
        requestAnimationFrame = webkitRequestAnimationFrame;
    } else if (typeof mozRequestAnimationFrame !== 'undefined') {
        /*global requestAnimationFrame:true */
        requestAnimationFrame = mozRequestAnimationFrame;
    } else if (typeof msRequestAnimationFrame !== 'undefined') {
        /*global requestAnimationFrame:true */
        requestAnimationFrame = msRequestAnimationFrame;
    } else if (typeof requestAnimationFrame === 'undefined') {
        // via: https://gist.github.com/paulirish/1579671
        var lastTime = 0;

        /*global requestAnimationFrame:true */
        requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
}

/*jshint -W079 */
var cancelAnimationFrame = window.cancelAnimationFrame;
if (typeof cancelAnimationFrame === 'undefined') {
    if (typeof webkitCancelAnimationFrame !== 'undefined') {
        /*global cancelAnimationFrame:true */
        cancelAnimationFrame = webkitCancelAnimationFrame;
    } else if (typeof mozCancelAnimationFrame !== 'undefined') {
        /*global cancelAnimationFrame:true */
        cancelAnimationFrame = mozCancelAnimationFrame;
    } else if (typeof msCancelAnimationFrame !== 'undefined') {
        /*global cancelAnimationFrame:true */
        cancelAnimationFrame = msCancelAnimationFrame;
    } else if (typeof cancelAnimationFrame === 'undefined') {
        /*global cancelAnimationFrame:true */
        cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
    }
}

// WebAudio API representer
var AudioContext = window.AudioContext;

if (typeof AudioContext === 'undefined') {
    if (typeof webkitAudioContext !== 'undefined') {
        /*global AudioContext:true */
        AudioContext = webkitAudioContext;
    }

    if (typeof mozAudioContext !== 'undefined') {
        /*global AudioContext:true */
        AudioContext = mozAudioContext;
    }
}

/*jshint -W079 */
var URL = window.URL;

if (typeof URL === 'undefined' && typeof webkitURL !== 'undefined') {
    /*global URL:true */
    URL = webkitURL;
}

if (typeof navigator !== 'undefined' && typeof navigator.getUserMedia === 'undefined') { // maybe window.navigator?
    if (typeof navigator.webkitGetUserMedia !== 'undefined') {
        navigator.getUserMedia = navigator.webkitGetUserMedia;
    }

    if (typeof navigator.mozGetUserMedia !== 'undefined') {
        navigator.getUserMedia = navigator.mozGetUserMedia;
    }
}

var isEdge = navigator.userAgent.indexOf('Edge') !== -1 && (!!navigator.msSaveBlob || !!navigator.msSaveOrOpenBlob);
var isOpera = !!window.opera || navigator.userAgent.indexOf('OPR/') !== -1;
var isSafari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
var isChrome = (!isOpera && !isEdge && !!navigator.webkitGetUserMedia) || isElectron() || isSafari;

var MediaStream = window.MediaStream;

if (typeof MediaStream === 'undefined' && typeof webkitMediaStream !== 'undefined') {
    MediaStream = webkitMediaStream;
}

/*global MediaStream:true */
if (typeof MediaStream !== 'undefined') {
    if (!('getVideoTracks' in MediaStream.prototype)) {
        MediaStream.prototype.getVideoTracks = function() {
            if (!this.getTracks) {
                return [];
            }

            var tracks = [];
            this.getTracks().forEach(function(track) {
                if (track.kind.toString().indexOf('video') !== -1) {
                    tracks.push(track);
                }
            });
            return tracks;
        };

        MediaStream.prototype.getAudioTracks = function() {
            if (!this.getTracks) {
                return [];
            }

            var tracks = [];
            this.getTracks().forEach(function(track) {
                if (track.kind.toString().indexOf('audio') !== -1) {
                    tracks.push(track);
                }
            });
            return tracks;
        };
    }

    // override "stop" method for all browsers
    if (typeof MediaStream.prototype.stop === 'undefined') {
        MediaStream.prototype.stop = function() {
            this.getTracks().forEach(function(track) {
                track.stop();
            });
        };
    }
}

// below function via: http://goo.gl/B3ae8c
/**
 * @param {number} bytes - Pass bytes and get formafted string.
 * @returns {string} - formafted string
 * @example
 * bytesToSize(1024*1024*5) === '5 GB'
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */
function bytesToSize(bytes) {
    var k = 1000;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) {
        return '0 Bytes';
    }
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(k)), 10);
    return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
}

/**
 * @param {Blob} file - File or Blob object. This parameter is required.
 * @param {string} fileName - Optional file name e.g. "Recorded-Video.webm"
 * @example
 * invokeSaveAsDialog(blob or file, [optional] fileName);
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */
function invokeSaveAsDialog(file, fileName) {
    if (!file) {
        throw 'Blob object is required.';
    }

    if (!file.type) {
        try {
            file.type = 'video/webm';
        } catch (e) {}
    }

    var fileExtension = (file.type || 'video/webm').split('/')[1];

    if (fileName && fileName.indexOf('.') !== -1) {
        var splitted = fileName.split('.');
        fileName = splitted[0];
        fileExtension = splitted[1];
    }

    var fileFullName = (fileName || (Math.round(Math.random() * 9999999999) + 888888888)) + '.' + fileExtension;

    if (typeof navigator.msSaveOrOpenBlob !== 'undefined') {
        return navigator.msSaveOrOpenBlob(file, fileFullName);
    } else if (typeof navigator.msSaveBlob !== 'undefined') {
        return navigator.msSaveBlob(file, fileFullName);
    }

    var hyperlink = document.createElement('a');
    hyperlink.href = URL.createObjectURL(file);
    hyperlink.download = fileFullName;

    hyperlink.style = 'display:none;opacity:0;color:transparent;';
    (document.body || document.documentElement).appendChild(hyperlink);

    if (typeof hyperlink.click === 'function') {
        hyperlink.click();
    } else {
        hyperlink.target = '_blank';
        hyperlink.dispatchEvent(new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
        }));
    }

    URL.revokeObjectURL(hyperlink.href);
}

/**
 * from: https://github.com/cheton/is-electron/blob/master/index.js
 **/
function isElectron() {
    // Renderer process
    if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
        return true;
    }

    // Main process
    if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
        return true;
    }

    // Detect the user agent when the `nodeIntegration` option is set to true
    if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
        return true;
    }

    return false;
}

function setSrcObject(stream, element, ignoreCreateObjectURL) {
    if ('createObjectURL' in URL && !ignoreCreateObjectURL) {
        try {
            element.src = URL.createObjectURL(stream);
        } catch (e) {
            setSrcObject(stream, element, true);
            return;
        }
    } else if ('srcObject' in element) {
        element.srcObject = stream;
    } else if ('mozSrcObject' in element) {
        element.mozSrcObject = stream;
    } else {
        alert('createObjectURL/srcObject both are not supported.');
    }
}

// __________ (used to handle stuff like http://goo.gl/xmE5eg) issue #129
// Storage.js

/**
 * Storage is a standalone object used by {@link RecordRTC} to store reusable objects e.g. "new AudioContext".
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @example
 * Storage.AudioContext === webkitAudioContext
 * @property {webkitAudioContext} AudioContext - Keeps a reference to AudioContext object.
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */

var Storage = {};

if (typeof AudioContext !== 'undefined') {
    Storage.AudioContext = AudioContext;
} else if (typeof webkitAudioContext !== 'undefined') {
    Storage.AudioContext = webkitAudioContext;
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.Storage = Storage;
}

function isMediaRecorderCompatible() {
    var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isChrome = (!!window.chrome && !isOpera) || isElectron();
    var isFirefox = typeof window.InstallTrigger !== 'undefined';

    if (isFirefox) {
        return true;
    }

    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    if (isChrome || isOpera) {
        verOffset = nAgt.indexOf('Chrome');
        fullVersion = nAgt.substring(verOffset + 7);
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) !== -1) {
        fullVersion = fullVersion.substring(0, ix);
    }

    if ((ix = fullVersion.indexOf(' ')) !== -1) {
        fullVersion = fullVersion.substring(0, ix);
    }

    majorVersion = parseInt('' + fullVersion, 10);

    if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }

    return majorVersion >= 49;
}

// ______________________
// MediaStreamRecorder.js

/**
 * MediaStreamRecorder is an abstraction layer for {@link https://w3c.github.io/mediacapture-record/MediaRecorder.html|MediaRecorder API}. It is used by {@link RecordRTC} to record MediaStream(s) in both Chrome and Firefox.
 * @summary Runs top over {@link https://w3c.github.io/mediacapture-record/MediaRecorder.html|MediaRecorder API}.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link https://github.com/muaz-khan|Muaz Khan}
 * @typedef MediaStreamRecorder
 * @class
 * @example
 * var config = {
 *     mimeType: 'video/webm', // vp8, vp9, h264, mkv, opus/vorbis
 *     audioBitsPerSecond : 256 * 8 * 1024,
 *     videoBitsPerSecond : 256 * 8 * 1024,
 *     bitsPerSecond: 256 * 8 * 1024,  // if this is provided, skip above two
 *     checkForInactiveTracks: true,
 *     timeSlice: 1000, // concatenate intervals based blobs
 *     ondataavailable: function() {}, // get intervals based blobs
 *     ignoreMutedMedia: true
 * }
 * var recorder = new MediaStreamRecorder(mediaStream, config);
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 *
 *     // or
 *     var blob = recorder.blob;
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {disableLogs:true, initCallback: function, mimeType: "video/webm", timeSlice: 1000}
 * @throws Will throw an error if first argument "MediaStream" is missing. Also throws error if "MediaRecorder API" are not supported by the browser.
 */

function MediaStreamRecorder(mediaStream, config) {
    var self = this;

    if (typeof mediaStream === 'undefined') {
        throw 'First argument "MediaStream" is required.';
    }

    if (typeof MediaRecorder === 'undefined') {
        throw 'Your browser does not supports Media Recorder API. Please try other modules e.g. WhammyRecorder or StereoAudioRecorder.';
    }

    config = config || {
        // bitsPerSecond: 256 * 8 * 1024,
        mimeType: 'video/webm'
    };

    if (config.type === 'audio') {
        if (mediaStream.getVideoTracks().length && mediaStream.getAudioTracks().length) {
            var stream;
            if (!!navigator.mozGetUserMedia) {
                stream = new MediaStream();
                stream.addTrack(mediaStream.getAudioTracks()[0]);
            } else {
                // webkitMediaStream
                stream = new MediaStream(mediaStream.getAudioTracks());
            }
            mediaStream = stream;
        }

        if (!config.mimeType || config.mimeType.toString().toLowerCase().indexOf('audio') === -1) {
            config.mimeType = isChrome ? 'audio/webm' : 'audio/ogg';
        }

        if (config.mimeType && config.mimeType.toString().toLowerCase() !== 'audio/ogg' && !!navigator.mozGetUserMedia) {
            // forcing better codecs on Firefox (via #166)
            config.mimeType = 'audio/ogg';
        }
    }

    var arrayOfBlobs = [];

    /**
     * This method returns array of blobs. Use only with "timeSlice". Its useful to preview recording anytime, without using the "stop" method.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * var arrayOfBlobs = recorder.getArrayOfBlobs();
     * @returns {Array} Returns array of recorded blobs.
     */
    this.getArrayOfBlobs = function() {
        return arrayOfBlobs;
    };

    /**
     * This method records MediaStream.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        // set defaults
        self.blob = null;
        self.clearRecordedData();
        self.timestamps = [];
        allStates = [];
        arrayOfBlobs = [];

        var recorderHints = config;

        if (!config.disableLogs) {
            console.log('Passing following config over MediaRecorder API.', recorderHints);
        }

        if (mediaRecorder) {
            // mandatory to make sure Firefox doesn't fails to record streams 3-4 times without reloading the page.
            mediaRecorder = null;
        }

        if (isChrome && !isMediaRecorderCompatible()) {
            // to support video-only recording on stable
            recorderHints = 'video/vp8';
        }

        if (typeof MediaRecorder.isTypeSupported === 'function' && recorderHints.mimeType) {
            if (!MediaRecorder.isTypeSupported(recorderHints.mimeType)) {
                if (!config.disableLogs) {
                    console.warn('MediaRecorder API seems unable to record mimeType:', recorderHints.mimeType);
                }

                recorderHints.mimeType = config.type === 'audio' ? 'audio/webm' : 'video/webm';
            }
        }

        // using MediaRecorder API here
        try {
            mediaRecorder = new MediaRecorder(mediaStream, recorderHints);

            // reset
            config.mimeType = recorderHints.mimeType;
        } catch (e) {
            // chrome-based fallback
            mediaRecorder = new MediaRecorder(mediaStream);
        }

        // old hack?
        if (recorderHints.mimeType && !MediaRecorder.isTypeSupported && 'canRecordMimeType' in mediaRecorder && mediaRecorder.canRecordMimeType(recorderHints.mimeType) === false) {
            if (!config.disableLogs) {
                console.warn('MediaRecorder API seems unable to record mimeType:', recorderHints.mimeType);
            }
        }

        // ignore muted/disabled/inactive tracks
        mediaRecorder.ignoreMutedMedia = config.ignoreMutedMedia === true;

        // Dispatching OnDataAvailable Handler
        mediaRecorder.ondataavailable = function(e) {
            if (e.data) {
                allStates.push('ondataavailable: ' + bytesToSize(e.data.size));
            }

            if (typeof config.timeSlice === 'number') {
                if (e.data && e.data.size && e.data.size > 100) {
                    arrayOfBlobs.push(e.data);
                    updateTimeStamp();

                    if (typeof config.ondataavailable === 'function') {
                        // intervals based blobs
                        var blob = config.getNativeBlob ? e.data : new Blob([e.data], {
                            type: getMimeType(recorderHints)
                        });
                        config.ondataavailable(blob);
                    }
                }
                return;
            }

            if (!e.data || !e.data.size || e.data.size < 100 || self.blob) {
                // make sure that stopRecording always getting fired
                // even if there is invalid data
                if (self.recordingCallback) {
                    self.recordingCallback(new Blob([], {
                        type: getMimeType(recorderHints)
                    }));
                    self.recordingCallback = null;
                }
                return;
            }

            self.blob = config.getNativeBlob ? e.data : new Blob([e.data], {
                type: getMimeType(recorderHints)
            });

            if (self.recordingCallback) {
                self.recordingCallback(self.blob);
                self.recordingCallback = null;
            }
        };

        mediaRecorder.onstart = function() {
            allStates.push('started');
        };

        mediaRecorder.onpause = function() {
            allStates.push('paused');
        };

        mediaRecorder.onresume = function() {
            allStates.push('resumed');
        };

        mediaRecorder.onstop = function() {
            allStates.push('stopped');
        };

        mediaRecorder.onerror = function(error) {
            allStates.push('error: ' + error);

            if (!config.disableLogs) {
                // via: https://w3c.github.io/mediacapture-record/MediaRecorder.html#exception-summary
                if (error.name.toString().toLowerCase().indexOf('invalidstate') !== -1) {
                    console.error('The MediaRecorder is not in a state in which the proposed operation is allowed to be executed.', error);
                } else if (error.name.toString().toLowerCase().indexOf('notsupported') !== -1) {
                    console.error('MIME type (', recorderHints.mimeType, ') is not supported.', error);
                } else if (error.name.toString().toLowerCase().indexOf('security') !== -1) {
                    console.error('MediaRecorder security error', error);
                }

                // older code below
                else if (error.name === 'OutOfMemory') {
                    console.error('The UA has exhaused the available memory. User agents SHOULD provide as much additional information as possible in the message attribute.', error);
                } else if (error.name === 'IllegalStreamModification') {
                    console.error('A modification to the stream has occurred that makes it impossible to continue recording. An example would be the addition of a Track while recording is occurring. User agents SHOULD provide as much additional information as possible in the message attribute.', error);
                } else if (error.name === 'OtherRecordingError') {
                    console.error('Used for an fatal error other than those listed above. User agents SHOULD provide as much additional information as possible in the message attribute.', error);
                } else if (error.name === 'GenericError') {
                    console.error('The UA cannot provide the codec or recording option that has been requested.', error);
                } else {
                    console.error('MediaRecorder Error', error);
                }
            }

            (function(looper) {
                if (!self.manuallyStopped && mediaRecorder && mediaRecorder.state === 'inactive') {
                    delete config.timeslice;

                    // 10 minutes, enough?
                    mediaRecorder.start(10 * 60 * 1000);
                    return;
                }

                setTimeout(looper, 1000);
            })();

            if (mediaRecorder.state !== 'inactive' && mediaRecorder.state !== 'stopped') {
                mediaRecorder.stop();
            }
        };

        if (typeof config.timeSlice === 'number') {
            updateTimeStamp();
            mediaRecorder.start(config.timeSlice);
        } else {
            // default is 60 minutes; enough?
            // use config => {timeSlice: 1000} otherwise

            mediaRecorder.start(3.6e+6);
        }

        if (config.initCallback) {
            config.initCallback(); // old code
        }
    };

    /**
     * @property {Array} timestamps - Array of time stamps
     * @memberof MediaStreamRecorder
     * @example
     * console.log(recorder.timestamps);
     */
    this.timestamps = [];

    function updateTimeStamp() {
        self.timestamps.push(new Date().getTime());

        if (typeof config.onTimeStamp === 'function') {
            config.onTimeStamp(self.timestamps[self.timestamps.length - 1], self.timestamps);
        }
    }

    function getMimeType(secondObject) {
        if (mediaRecorder && mediaRecorder.mimeType) {
            return mediaRecorder.mimeType;
        }

        return secondObject.mimeType || 'video/webm';
    }

    /**
     * This method stops recording MediaStream.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        callback = callback || function() {};

        self.manuallyStopped = true; // used inside the mediaRecorder.onerror

        if (!mediaRecorder) {
            return;
        }

        this.recordingCallback = callback;

        if (mediaRecorder.state === 'recording') {
            mediaRecorder.stop();
        }

        if (typeof config.timeSlice === 'number') {
            setTimeout(function() {
                self.blob = new Blob(arrayOfBlobs, {
                    type: getMimeType(config)
                });

                self.recordingCallback(self.blob);
            }, 100);
        }
    };

    /**
     * This method pauses the recording process.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        if (!mediaRecorder) {
            return;
        }

        if (mediaRecorder.state === 'recording') {
            mediaRecorder.pause();
        }
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        if (!mediaRecorder) {
            return;
        }

        if (mediaRecorder.state === 'paused') {
            mediaRecorder.resume();
        }
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        if (mediaRecorder && mediaRecorder.state === 'recording') {
            self.stop(clearRecordedDataCB);
        }

        clearRecordedDataCB();
    };

    function clearRecordedDataCB() {
        arrayOfBlobs = [];
        mediaRecorder = null;
        self.timestamps = [];
    }

    // Reference to "MediaRecorder" object
    var mediaRecorder;

    /**
     * Access to native MediaRecorder API
     * @method
     * @memberof MediaStreamRecorder
     * @instance
     * @example
     * var internal = recorder.getInternalRecorder();
     * internal.ondataavailable = function() {}; // override
     * internal.stream, internal.onpause, internal.onstop, etc.
     * @returns {Object} Returns internal recording object.
     */
    this.getInternalRecorder = function() {
        return mediaRecorder;
    };

    function isMediaStreamActive() {
        if ('active' in mediaStream) {
            if (!mediaStream.active) {
                return false;
            }
        } else if ('ended' in mediaStream) { // old hack
            if (mediaStream.ended) {
                return false;
            }
        }
        return true;
    }

    /**
     * @property {Blob} blob - Recorded data as "Blob" object.
     * @memberof MediaStreamRecorder
     * @example
     * recorder.stop(function() {
     *     var blob = recorder.blob;
     * });
     */
    this.blob = null;


    /**
     * Get MediaRecorder readonly state.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * var state = recorder.getState();
     * @returns {String} Returns recording state.
     */
    this.getState = function() {
        if (!mediaRecorder) {
            return 'inactive';
        }

        return mediaRecorder.state || 'inactive';
    };

    // list of all recording states
    var allStates = [];

    /**
     * Get MediaRecorder all recording states.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * var state = recorder.getAllStates();
     * @returns {Array} Returns all recording states
     */
    this.getAllStates = function() {
        return allStates;
    };

    // if any Track within the MediaStream is muted or not enabled at any time, 
    // the browser will only record black frames 
    // or silence since that is the content produced by the Track
    // so we need to stopRecording as soon as any single track ends.
    if (typeof config.checkForInactiveTracks === 'undefined') {
        config.checkForInactiveTracks = false; // disable to minimize CPU usage
    }

    var self = this;

    // this method checks if media stream is stopped
    // or if any track is ended.
    (function looper() {
        if (!mediaRecorder || config.checkForInactiveTracks === false) {
            return;
        }

        if (isMediaStreamActive() === false) {
            if (!config.disableLogs) {
                console.log('MediaStream seems stopped.');
            }
            self.stop();
            return;
        }

        setTimeout(looper, 1000); // check every second
    })();

    // for debugging
    this.name = 'MediaStreamRecorder';
    this.toString = function() {
        return this.name;
    };
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.MediaStreamRecorder = MediaStreamRecorder;
}

// source code from: http://typedarray.org/wp-content/projects/WebAudioRecorder/script.js
// https://github.com/mattdiamond/Recorderjs#license-mit
// ______________________
// StereoAudioRecorder.js

/**
 * StereoAudioRecorder is a standalone class used by {@link RecordRTC} to bring "stereo" audio-recording in chrome.
 * @summary JavaScript standalone object for stereo audio recording.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef StereoAudioRecorder
 * @class
 * @example
 * var recorder = new StereoAudioRecorder(MediaStream, {
 *     sampleRate: 44100,
 *     bufferSize: 4096
 * });
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {sampleRate: 44100, bufferSize: 4096, numberOfAudioChannels: 1, etc.}
 */

function StereoAudioRecorder(mediaStream, config) {
    if (!mediaStream.getAudioTracks().length) {
        throw 'Your stream has no audio tracks.';
    }

    config = config || {};

    var self = this;

    // variables
    var leftchannel = [];
    var rightchannel = [];
    var recording = false;
    var recordingLength = 0;
    var jsAudioNode;

    var numberOfAudioChannels = 2;

    /**
     * Set sample rates such as 8K or 16K. Reference: http://stackoverflow.com/a/28977136/552182
     * @property {number} desiredSampRate - Desired Bits per sample * 1000
     * @memberof StereoAudioRecorder
     * @instance
     * @example
     * var recorder = StereoAudioRecorder(mediaStream, {
     *   desiredSampRate: 16 * 1000 // bits-per-sample * 1000
     * });
     */
    var desiredSampRate = config.desiredSampRate;

    // backward compatibility
    if (config.leftChannel === true) {
        numberOfAudioChannels = 1;
    }

    if (config.numberOfAudioChannels === 1) {
        numberOfAudioChannels = 1;
    }

    if (!numberOfAudioChannels || numberOfAudioChannels < 1) {
        numberOfAudioChannels = 2;
    }

    if (!config.disableLogs) {
        console.log('StereoAudioRecorder is set to record number of channels: ', numberOfAudioChannels);
    }

    // if any Track within the MediaStream is muted or not enabled at any time, 
    // the browser will only record black frames 
    // or silence since that is the content produced by the Track
    // so we need to stopRecording as soon as any single track ends.
    if (typeof config.checkForInactiveTracks === 'undefined') {
        config.checkForInactiveTracks = true;
    }

    function isMediaStreamActive() {
        if (config.checkForInactiveTracks === false) {
            // always return "true"
            return true;
        }

        if ('active' in mediaStream) {
            if (!mediaStream.active) {
                return false;
            }
        } else if ('ended' in mediaStream) { // old hack
            if (mediaStream.ended) {
                return false;
            }
        }
        return true;
    }

    /**
     * This method records MediaStream.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        if (isMediaStreamActive() === false) {
            throw 'Please make sure MediaStream is active.';
        }

        resetVariables();

        isAudioProcessStarted = isPaused = false;
        recording = true;

        if (typeof config.timeSlice !== 'undefined') {
            looper();
        }
    };

    function mergeLeftRightBuffers(config, callback) {
        function mergeAudioBuffers(config, cb) {
            var numberOfAudioChannels = config.numberOfAudioChannels;

            // todo: "slice(0)" --- is it causes loop? Should be removed?
            var leftBuffers = config.leftBuffers.slice(0);
            var rightBuffers = config.rightBuffers.slice(0);
            var sampleRate = config.sampleRate;
            var internalInterleavedLength = config.internalInterleavedLength;
            var desiredSampRate = config.desiredSampRate;

            if (numberOfAudioChannels === 2) {
                leftBuffers = mergeBuffers(leftBuffers, internalInterleavedLength);
                rightBuffers = mergeBuffers(rightBuffers, internalInterleavedLength);

                if (desiredSampRate) {
                    leftBuffers = interpolateArray(leftBuffers, desiredSampRate, sampleRate);
                    rightBuffers = interpolateArray(rightBuffers, desiredSampRate, sampleRate);
                }
            }

            if (numberOfAudioChannels === 1) {
                leftBuffers = mergeBuffers(leftBuffers, internalInterleavedLength);

                if (desiredSampRate) {
                    leftBuffers = interpolateArray(leftBuffers, desiredSampRate, sampleRate);
                }
            }

            // set sample rate as desired sample rate
            if (desiredSampRate) {
                sampleRate = desiredSampRate;
            }

            // for changing the sampling rate, reference:
            // http://stackoverflow.com/a/28977136/552182
            function interpolateArray(data, newSampleRate, oldSampleRate) {
                var fitCount = Math.round(data.length * (newSampleRate / oldSampleRate));
                var newData = [];
                var springFactor = Number((data.length - 1) / (fitCount - 1));
                newData[0] = data[0];
                for (var i = 1; i < fitCount - 1; i++) {
                    var tmp = i * springFactor;
                    var before = Number(Math.floor(tmp)).toFixed();
                    var after = Number(Math.ceil(tmp)).toFixed();
                    var atPoint = tmp - before;
                    newData[i] = linearInterpolate(data[before], data[after], atPoint);
                }
                newData[fitCount - 1] = data[data.length - 1];
                return newData;
            }

            function linearInterpolate(before, after, atPoint) {
                return before + (after - before) * atPoint;
            }

            function mergeBuffers(channelBuffer, rLength) {
                var result = new Float64Array(rLength);
                var offset = 0;
                var lng = channelBuffer.length;

                for (var i = 0; i < lng; i++) {
                    var buffer = channelBuffer[i];
                    result.set(buffer, offset);
                    offset += buffer.length;
                }

                return result;
            }

            function interleave(leftChannel, rightChannel) {
                var length = leftChannel.length + rightChannel.length;

                var result = new Float64Array(length);

                var inputIndex = 0;

                for (var index = 0; index < length;) {
                    result[index++] = leftChannel[inputIndex];
                    result[index++] = rightChannel[inputIndex];
                    inputIndex++;
                }
                return result;
            }

            function writeUTFBytes(view, offset, string) {
                var lng = string.length;
                for (var i = 0; i < lng; i++) {
                    view.setUint8(offset + i, string.charCodeAt(i));
                }
            }

            // interleave both channels together
            var interleaved;

            if (numberOfAudioChannels === 2) {
                interleaved = interleave(leftBuffers, rightBuffers);
            }

            if (numberOfAudioChannels === 1) {
                interleaved = leftBuffers;
            }

            var interleavedLength = interleaved.length;

            // create wav file
            var resultingBufferLength = 44 + interleavedLength * 2;

            var buffer = new ArrayBuffer(resultingBufferLength);

            var view = new DataView(buffer);

            // RIFF chunk descriptor/identifier 
            writeUTFBytes(view, 0, 'RIFF');

            // RIFF chunk length
            view.setUint32(4, 44 + interleavedLength * 2, true);

            // RIFF type 
            writeUTFBytes(view, 8, 'WAVE');

            // format chunk identifier 
            // FMT sub-chunk
            writeUTFBytes(view, 12, 'fmt ');

            // format chunk length 
            view.setUint32(16, 16, true);

            // sample format (raw)
            view.setUint16(20, 1, true);

            // stereo (2 channels)
            view.setUint16(22, numberOfAudioChannels, true);

            // sample rate 
            view.setUint32(24, sampleRate, true);

            // byte rate (sample rate * block align)
            view.setUint32(28, sampleRate * 2, true);

            // block align (channel count * bytes per sample) 
            view.setUint16(32, numberOfAudioChannels * 2, true);

            // bits per sample 
            view.setUint16(34, 16, true);

            // data sub-chunk
            // data chunk identifier 
            writeUTFBytes(view, 36, 'data');

            // data chunk length 
            view.setUint32(40, interleavedLength * 2, true);

            // write the PCM samples
            var lng = interleavedLength;
            var index = 44;
            var volume = 1;
            for (var i = 0; i < lng; i++) {
                view.setInt16(index, interleaved[i] * (0x7FFF * volume), true);
                index += 2;
            }

            if (cb) {
                return cb({
                    buffer: buffer,
                    view: view
                });
            }

            postMessage({
                buffer: buffer,
                view: view
            });
        }

        if (isEdge || isOpera || isSafari || config.noWorker) {
            mergeAudioBuffers(config, function(data) {
                callback(data.buffer, data.view);
            });
            return;
        }


        var webWorker = processInWebWorker(mergeAudioBuffers);

        webWorker.onmessage = function(event) {
            callback(event.data.buffer, event.data.view);

            // release memory
            URL.revokeObjectURL(webWorker.workerURL);
        };

        webWorker.postMessage(config);
    }

    function processInWebWorker(_function) {
        var workerURL = URL.createObjectURL(new Blob([_function.toString(),
            ';this.onmessage =  function (e) {' + _function.name + '(e.data);}'
        ], {
            type: 'application/javascript'
        }));

        var worker = new Worker(workerURL);
        worker.workerURL = workerURL;
        return worker;
    }

    /**
     * This method stops recording MediaStream.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        callback = callback || function() {};

        // stop recording
        recording = false;

        mergeLeftRightBuffers({
            desiredSampRate: desiredSampRate,
            sampleRate: sampleRate,
            numberOfAudioChannels: numberOfAudioChannels,
            internalInterleavedLength: recordingLength,
            leftBuffers: leftchannel,
            rightBuffers: numberOfAudioChannels === 1 ? [] : rightchannel
        }, function(buffer, view) {
            /**
             * @property {Blob} blob - The recorded blob object.
             * @memberof StereoAudioRecorder
             * @example
             * recorder.stop(function(){
             *     var blob = recorder.blob;
             * });
             */
            self.blob = new Blob([view], {
                type: 'audio/wav'
            });

            /**
             * @property {ArrayBuffer} buffer - The recorded buffer object.
             * @memberof StereoAudioRecorder
             * @example
             * recorder.stop(function(){
             *     var buffer = recorder.buffer;
             * });
             */
            self.buffer = new ArrayBuffer(view.buffer.byteLength);

            /**
             * @property {DataView} view - The recorded data-view object.
             * @memberof StereoAudioRecorder
             * @example
             * recorder.stop(function(){
             *     var view = recorder.view;
             * });
             */
            self.view = view;

            self.sampleRate = desiredSampRate || sampleRate;
            self.bufferSize = bufferSize;

            // recorded audio length
            self.length = recordingLength;

            isAudioProcessStarted = false;

            if (callback) {
                callback(self.blob);
            }
        });
    };

    if (!Storage.AudioContextConstructor) {
        Storage.AudioContextConstructor = new Storage.AudioContext();
    }

    var context = Storage.AudioContextConstructor;

    // creates an audio node from the microphone incoming stream
    var audioInput = context.createMediaStreamSource(mediaStream);

    var legalBufferValues = [0, 256, 512, 1024, 2048, 4096, 8192, 16384];

    /**
     * From the spec: This value controls how frequently the audioprocess event is
     * dispatched and how many sample-frames need to be processed each call.
     * Lower values for buffer size will result in a lower (better) latency.
     * Higher values will be necessary to avoid audio breakup and glitches
     * The size of the buffer (in sample-frames) which needs to
     * be processed each time onprocessaudio is called.
     * Legal values are (256, 512, 1024, 2048, 4096, 8192, 16384).
     * @property {number} bufferSize - Buffer-size for how frequently the audioprocess event is dispatched.
     * @memberof StereoAudioRecorder
     * @example
     * recorder = new StereoAudioRecorder(mediaStream, {
     *     bufferSize: 4096
     * });
     */

    // "0" means, let chrome decide the most accurate buffer-size for current platform.
    var bufferSize = typeof config.bufferSize === 'undefined' ? 4096 : config.bufferSize;

    if (legalBufferValues.indexOf(bufferSize) === -1) {
        if (!config.disableLogs) {
            console.warn('Legal values for buffer-size are ' + JSON.stringify(legalBufferValues, null, '\t'));
        }
    }

    if (context.createJavaScriptNode) {
        jsAudioNode = context.createJavaScriptNode(bufferSize, numberOfAudioChannels, numberOfAudioChannels);
    } else if (context.createScriptProcessor) {
        jsAudioNode = context.createScriptProcessor(bufferSize, numberOfAudioChannels, numberOfAudioChannels);
    } else {
        throw 'WebAudio API has no support on this browser.';
    }

    // connect the stream to the script processor
    audioInput.connect(jsAudioNode);

    if (!config.bufferSize) {
        bufferSize = jsAudioNode.bufferSize; // device buffer-size
    }

    /**
     * The sample rate (in sample-frames per second) at which the
     * AudioContext handles audio. It is assumed that all AudioNodes
     * in the context run at this rate. In making this assumption,
     * sample-rate converters or "varispeed" processors are not supported
     * in real-time processing.
     * The sampleRate parameter describes the sample-rate of the
     * linear PCM audio data in the buffer in sample-frames per second.
     * An implementation must support sample-rates in at least
     * the range 22050 to 96000.
     * @property {number} sampleRate - Buffer-size for how frequently the audioprocess event is dispatched.
     * @memberof StereoAudioRecorder
     * @example
     * recorder = new StereoAudioRecorder(mediaStream, {
     *     sampleRate: 44100
     * });
     */
    var sampleRate = typeof config.sampleRate !== 'undefined' ? config.sampleRate : context.sampleRate || 44100;

    if (sampleRate < 22050 || sampleRate > 96000) {
        // Ref: http://stackoverflow.com/a/26303918/552182
        if (!config.disableLogs) {
            console.warn('sample-rate must be under range 22050 and 96000.');
        }
    }

    if (!config.disableLogs) {
        console.log('sample-rate', sampleRate);
        console.log('buffer-size', bufferSize);

        if (config.desiredSampRate) {
            console.log('Desired sample-rate', config.desiredSampRate);
        }
    }

    var isPaused = false;
    /**
     * This method pauses the recording process.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        isPaused = true;
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        if (isMediaStreamActive() === false) {
            throw 'Please make sure MediaStream is active.';
        }

        if (!recording) {
            if (!config.disableLogs) {
                console.log('Seems recording has been restarted.');
            }
            this.record();
            return;
        }

        isPaused = false;
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        config.checkForInactiveTracks = false;

        if (recording) {
            this.stop(clearRecordedDataCB);
        }

        clearRecordedDataCB();
    };

    function resetVariables() {
        leftchannel = [];
        rightchannel = [];
        recordingLength = 0;
        isAudioProcessStarted = false;
        recording = false;
        isPaused = false;
        context = null;

        self.leftchannel = leftchannel;
        self.rightchannel = rightchannel;
        self.numberOfAudioChannels = numberOfAudioChannels;
        self.desiredSampRate = desiredSampRate;
        self.sampleRate = sampleRate;
        self.recordingLength = recordingLength;

        intervalsBasedBuffers = {
            left: [],
            right: [],
            recordingLength: 0
        };
    }

    function clearRecordedDataCB() {
        if (jsAudioNode) {
            jsAudioNode.onaudioprocess = null;
            jsAudioNode.disconnect();
            jsAudioNode = null;
        }

        if (audioInput) {
            audioInput.disconnect();
            audioInput = null;
        }

        resetVariables();
    }

    // for debugging
    this.name = 'StereoAudioRecorder';
    this.toString = function() {
        return this.name;
    };

    var isAudioProcessStarted = false;

    function onAudioProcessDataAvailable(e) {
        if (isPaused) {
            return;
        }

        if (isMediaStreamActive() === false) {
            if (!config.disableLogs) {
                console.log('MediaStream seems stopped.');
            }
            jsAudioNode.disconnect();
            recording = false;
        }

        if (!recording) {
            if (audioInput) {
                audioInput.disconnect();
                audioInput = null;
            }
            return;
        }

        /**
         * This method is called on "onaudioprocess" event's first invocation.
         * @method {function} onAudioProcessStarted
         * @memberof StereoAudioRecorder
         * @example
         * recorder.onAudioProcessStarted: function() { };
         */
        if (!isAudioProcessStarted) {
            isAudioProcessStarted = true;
            if (config.onAudioProcessStarted) {
                config.onAudioProcessStarted();
            }

            if (config.initCallback) {
                config.initCallback();
            }
        }

        var left = e.inputBuffer.getChannelData(0);

        // we clone the samples
        var chLeft = new Float32Array(left);
        leftchannel.push(chLeft);

        if (numberOfAudioChannels === 2) {
            var right = e.inputBuffer.getChannelData(1);
            var chRight = new Float32Array(right);
            rightchannel.push(chRight);
        }

        recordingLength += bufferSize;

        // export raw PCM
        self.recordingLength = recordingLength;

        if (typeof config.timeSlice !== 'undefined') {
            intervalsBasedBuffers.recordingLength += bufferSize;
            intervalsBasedBuffers.left.push(chLeft);

            if (numberOfAudioChannels === 2) {
                intervalsBasedBuffers.right.push(chRight);
            }
        }
    }

    jsAudioNode.onaudioprocess = onAudioProcessDataAvailable;

    // to prevent self audio to be connected with speakers
    jsAudioNode.connect(context.destination);

    // export raw PCM
    this.leftchannel = leftchannel;
    this.rightchannel = rightchannel;
    this.numberOfAudioChannels = numberOfAudioChannels;
    this.desiredSampRate = desiredSampRate;
    this.sampleRate = sampleRate;
    self.recordingLength = recordingLength;

    // helper for intervals based blobs
    var intervalsBasedBuffers = {
        left: [],
        right: [],
        recordingLength: 0
    };

    // this looper is used to support intervals based blobs (via timeSlice+ondataavailable)
    function looper() {
        if (!recording || typeof config.ondataavailable !== 'function' || typeof config.timeSlice === 'undefined') {
            return;
        }

        if (intervalsBasedBuffers.left.length) {
            mergeLeftRightBuffers({
                desiredSampRate: desiredSampRate,
                sampleRate: sampleRate,
                numberOfAudioChannels: numberOfAudioChannels,
                internalInterleavedLength: intervalsBasedBuffers.recordingLength,
                leftBuffers: intervalsBasedBuffers.left,
                rightBuffers: numberOfAudioChannels === 1 ? [] : intervalsBasedBuffers.right
            }, function(buffer, view) {
                var blob = new Blob([view], {
                    type: 'audio/wav'
                });
                config.ondataavailable(blob);

                setTimeout(looper, config.timeSlice);
            });

            intervalsBasedBuffers = {
                left: [],
                right: [],
                recordingLength: 0
            };
        } else {
            setTimeout(looper, config.timeSlice);
        }
    }
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.StereoAudioRecorder = StereoAudioRecorder;
}

// _________________
// CanvasRecorder.js

/**
 * CanvasRecorder is a standalone class used by {@link RecordRTC} to bring HTML5-Canvas recording into video WebM. It uses HTML2Canvas library and runs top over {@link Whammy}.
 * @summary HTML2Canvas recording into video WebM.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef CanvasRecorder
 * @class
 * @example
 * var recorder = new CanvasRecorder(htmlElement, { disableLogs: true, useWhammyRecorder: true });
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {HTMLElement} htmlElement - querySelector/getElementById/getElementsByTagName[0]/etc.
 * @param {object} config - {disableLogs:true, initCallback: function}
 */

function CanvasRecorder(htmlElement, config) {
    if (typeof html2canvas === 'undefined') {
        throw 'Please link: https://cdn.webrtc-experiment.com/screenshot.js';
    }

    config = config || {};
    if (!config.frameInterval) {
        config.frameInterval = 10;
    }

    // via DetectRTC.js
    var isCanvasSupportsStreamCapturing = false;
    ['captureStream', 'mozCaptureStream', 'webkitCaptureStream'].forEach(function(item) {
        if (item in document.createElement('canvas')) {
            isCanvasSupportsStreamCapturing = true;
        }
    });

    var _isChrome = (!!window.webkitRTCPeerConnection || !!window.webkitGetUserMedia) && !!window.chrome;

    var chromeVersion = 50;
    var matchArray = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (_isChrome && matchArray && matchArray[2]) {
        chromeVersion = parseInt(matchArray[2], 10);
    }

    if (_isChrome && chromeVersion < 52) {
        isCanvasSupportsStreamCapturing = false;
    }

    var globalCanvas, mediaStreamRecorder;

    if (isCanvasSupportsStreamCapturing) {
        if (!config.disableLogs) {
            console.log('Your browser supports both MediRecorder API and canvas.captureStream!');
        }

        if (htmlElement instanceof HTMLCanvasElement) {
            globalCanvas = htmlElement;
        } else if (htmlElement instanceof CanvasRenderingContext2D) {
            globalCanvas = htmlElement.canvas;
        } else {
            throw 'Please pass either HTMLCanvasElement or CanvasRenderingContext2D.';
        }
    } else if (!!navigator.mozGetUserMedia) {
        if (!config.disableLogs) {
            console.error('Canvas recording is NOT supported in Firefox.');
        }
    }

    var isRecording;

    /**
     * This method records Canvas.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        isRecording = true;

        if (isCanvasSupportsStreamCapturing && !config.useWhammyRecorder) {
            // CanvasCaptureMediaStream
            var canvasMediaStream;
            if ('captureStream' in globalCanvas) {
                canvasMediaStream = globalCanvas.captureStream(25); // 25 FPS
            } else if ('mozCaptureStream' in globalCanvas) {
                canvasMediaStream = globalCanvas.mozCaptureStream(25);
            } else if ('webkitCaptureStream' in globalCanvas) {
                canvasMediaStream = globalCanvas.webkitCaptureStream(25);
            }

            try {
                var mdStream = new MediaStream();
                mdStream.addTrack(canvasMediaStream.getVideoTracks()[0]);
                canvasMediaStream = mdStream;
            } catch (e) {}

            if (!canvasMediaStream) {
                throw 'captureStream API are NOT available.';
            }

            // Note: Jan 18, 2016 status is that, 
            // Firefox MediaRecorder API can't record CanvasCaptureMediaStream object.
            mediaStreamRecorder = new MediaStreamRecorder(canvasMediaStream, {
                mimeType: 'video/webm'
            });
            mediaStreamRecorder.record();
        } else {
            whammy.frames = [];
            lastTime = new Date().getTime();
            drawCanvasFrame();
        }

        if (config.initCallback) {
            config.initCallback();
        }
    };

    this.getWebPImages = function(callback) {
        if (htmlElement.nodeName.toLowerCase() !== 'canvas') {
            callback();
            return;
        }

        var framesLength = whammy.frames.length;
        whammy.frames.forEach(function(frame, idx) {
            var framesRemaining = framesLength - idx;
            if (!config.disableLogs) {
                console.log(framesRemaining + '/' + framesLength + ' frames remaining');
            }

            if (config.onEncodingCallback) {
                config.onEncodingCallback(framesRemaining, framesLength);
            }

            var webp = frame.image.toDataURL('image/webp', 1);
            whammy.frames[idx].image = webp;
        });

        if (!config.disableLogs) {
            console.log('Generating WebM');
        }

        callback();
    };

    /**
     * This method stops recording Canvas.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        isRecording = false;

        var that = this;

        if (isCanvasSupportsStreamCapturing && mediaStreamRecorder) {
            mediaStreamRecorder.stop(callback);
            return;
        }

        this.getWebPImages(function() {
            /**
             * @property {Blob} blob - Recorded frames in video/webm blob.
             * @memberof CanvasRecorder
             * @example
             * recorder.stop(function() {
             *     var blob = recorder.blob;
             * });
             */
            whammy.compile(function(blob) {
                if (!config.disableLogs) {
                    console.log('Recording finished!');
                }

                that.blob = blob;

                if (that.blob.forEach) {
                    that.blob = new Blob([], {
                        type: 'video/webm'
                    });
                }

                if (callback) {
                    callback(that.blob);
                }

                whammy.frames = [];
            });
        });
    };

    var isPausedRecording = false;

    /**
     * This method pauses the recording process.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        isPausedRecording = true;

        if (mediaStreamRecorder instanceof MediaStreamRecorder) {
            mediaStreamRecorder.pause();
            return;
        }
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        isPausedRecording = false;

        if (mediaStreamRecorder instanceof MediaStreamRecorder) {
            mediaStreamRecorder.resume();
            return;
        }

        if (!isRecording) {
            this.record();
        }
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        if (isRecording) {
            this.stop(clearRecordedDataCB);
        }
        clearRecordedDataCB();
    };

    function clearRecordedDataCB() {
        whammy.frames = [];
        isRecording = false;
        isPausedRecording = false;
    }

    // for debugging
    this.name = 'CanvasRecorder';
    this.toString = function() {
        return this.name;
    };

    function cloneCanvas() {
        //create a new canvas
        var newCanvas = document.createElement('canvas');
        var context = newCanvas.getContext('2d');

        //set dimensions
        newCanvas.width = htmlElement.width;
        newCanvas.height = htmlElement.height;

        //apply the old canvas to the new one
        context.drawImage(htmlElement, 0, 0);

        //return the new canvas
        return newCanvas;
    }

    function drawCanvasFrame() {
        if (isPausedRecording) {
            lastTime = new Date().getTime();
            return setTimeout(drawCanvasFrame, 500);
        }

        if (htmlElement.nodeName.toLowerCase() === 'canvas') {
            var duration = new Date().getTime() - lastTime;
            // via #206, by Jack i.e. @Seymourr
            lastTime = new Date().getTime();

            whammy.frames.push({
                image: cloneCanvas(),
                duration: duration
            });

            if (isRecording) {
                setTimeout(drawCanvasFrame, config.frameInterval);
            }
            return;
        }

        html2canvas(htmlElement, {
            grabMouse: typeof config.showMousePointer === 'undefined' || config.showMousePointer,
            onrendered: function(canvas) {
                var duration = new Date().getTime() - lastTime;
                if (!duration) {
                    return setTimeout(drawCanvasFrame, config.frameInterval);
                }

                // via #206, by Jack i.e. @Seymourr
                lastTime = new Date().getTime();

                whammy.frames.push({
                    image: canvas.toDataURL('image/webp', 1),
                    duration: duration
                });

                if (isRecording) {
                    setTimeout(drawCanvasFrame, config.frameInterval);
                }
            }
        });
    }

    var lastTime = new Date().getTime();

    var whammy = new Whammy.Video(100);
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.CanvasRecorder = CanvasRecorder;
}

// _________________
// WhammyRecorder.js

/**
 * WhammyRecorder is a standalone class used by {@link RecordRTC} to bring video recording in Chrome. It runs top over {@link Whammy}.
 * @summary Video recording feature in Chrome.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef WhammyRecorder
 * @class
 * @example
 * var recorder = new WhammyRecorder(mediaStream);
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {disableLogs: true, initCallback: function, video: HTMLVideoElement, etc.}
 */

function WhammyRecorder(mediaStream, config) {

    config = config || {};

    if (!config.frameInterval) {
        config.frameInterval = 10;
    }

    if (!config.disableLogs) {
        console.log('Using frames-interval:', config.frameInterval);
    }

    /**
     * This method records video.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        if (!config.width) {
            config.width = 320;
        }

        if (!config.height) {
            config.height = 240;
        }

        if (!config.video) {
            config.video = {
                width: config.width,
                height: config.height
            };
        }

        if (!config.canvas) {
            config.canvas = {
                width: config.width,
                height: config.height
            };
        }

        canvas.width = config.canvas.width || 320;
        canvas.height = config.canvas.height || 240;

        context = canvas.getContext('2d');

        // setting defaults
        if (config.video && config.video instanceof HTMLVideoElement) {
            video = config.video.cloneNode();

            if (config.initCallback) {
                config.initCallback();
            }
        } else {
            video = document.createElement('video');

            setSrcObject(mediaStream, video);

            video.onloadedmetadata = function() { // "onloadedmetadata" may NOT work in FF?
                if (config.initCallback) {
                    config.initCallback();
                }
            };

            video.width = config.video.width;
            video.height = config.video.height;
        }

        video.muted = true;
        video.play();

        lastTime = new Date().getTime();
        whammy = new Whammy.Video();

        if (!config.disableLogs) {
            console.log('canvas resolutions', canvas.width, '*', canvas.height);
            console.log('video width/height', video.width || canvas.width, '*', video.height || canvas.height);
        }

        drawFrames(config.frameInterval);
    };

    /**
     * Draw and push frames to Whammy
     * @param {integer} frameInterval - set minimum interval (in milliseconds) between each time we push a frame to Whammy
     */
    function drawFrames(frameInterval) {
        frameInterval = typeof frameInterval !== 'undefined' ? frameInterval : 10;

        var duration = new Date().getTime() - lastTime;
        if (!duration) {
            return setTimeout(drawFrames, frameInterval, frameInterval);
        }

        if (isPausedRecording) {
            lastTime = new Date().getTime();
            return setTimeout(drawFrames, 100);
        }

        // via #206, by Jack i.e. @Seymourr
        lastTime = new Date().getTime();

        if (video.paused) {
            // via: https://github.com/muaz-khan/WebRTC-Experiment/pull/316
            // Tweak for Android Chrome
            video.play();
        }

        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        whammy.frames.push({
            duration: duration,
            image: canvas.toDataURL('image/webp')
        });

        if (!isStopDrawing) {
            setTimeout(drawFrames, frameInterval, frameInterval);
        }
    }

    function asyncLoop(o) {
        var i = -1,
            length = o.length;

        (function loop() {
            i++;
            if (i === length) {
                o.callback();
                return;
            }

            // "setTimeout" added by Jim McLeod
            setTimeout(function() {
                o.functionToLoop(loop, i);
            }, 1);
        })();
    }


    /**
     * remove black frames from the beginning to the specified frame
     * @param {Array} _frames - array of frames to be checked
     * @param {number} _framesToCheck - number of frame until check will be executed (-1 - will drop all frames until frame not matched will be found)
     * @param {number} _pixTolerance - 0 - very strict (only black pixel color) ; 1 - all
     * @param {number} _frameTolerance - 0 - very strict (only black frame color) ; 1 - all
     * @returns {Array} - array of frames
     */
    // pull#293 by @volodalexey
    function dropBlackFrames(_frames, _framesToCheck, _pixTolerance, _frameTolerance, callback) {
        var localCanvas = document.createElement('canvas');
        localCanvas.width = canvas.width;
        localCanvas.height = canvas.height;
        var context2d = localCanvas.getContext('2d');
        var resultFrames = [];

        var checkUntilNotBlack = _framesToCheck === -1;
        var endCheckFrame = (_framesToCheck && _framesToCheck > 0 && _framesToCheck <= _frames.length) ?
            _framesToCheck : _frames.length;
        var sampleColor = {
            r: 0,
            g: 0,
            b: 0
        };
        var maxColorDifference = Math.sqrt(
            Math.pow(255, 2) +
            Math.pow(255, 2) +
            Math.pow(255, 2)
        );
        var pixTolerance = _pixTolerance && _pixTolerance >= 0 && _pixTolerance <= 1 ? _pixTolerance : 0;
        var frameTolerance = _frameTolerance && _frameTolerance >= 0 && _frameTolerance <= 1 ? _frameTolerance : 0;
        var doNotCheckNext = false;

        asyncLoop({
            length: endCheckFrame,
            functionToLoop: function(loop, f) {
                var matchPixCount, endPixCheck, maxPixCount;

                var finishImage = function() {
                    if (!doNotCheckNext && maxPixCount - matchPixCount <= maxPixCount * frameTolerance) {
                        // console.log('removed black frame : ' + f + ' ; frame duration ' + _frames[f].duration);
                    } else {
                        // console.log('frame is passed : ' + f);
                        if (checkUntilNotBlack) {
                            doNotCheckNext = true;
                        }
                        resultFrames.push(_frames[f]);
                    }
                    loop();
                };

                if (!doNotCheckNext) {
                    var image = new Image();
                    image.onload = function() {
                        context2d.drawImage(image, 0, 0, canvas.width, canvas.height);
                        var imageData = context2d.getImageData(0, 0, canvas.width, canvas.height);
                        matchPixCount = 0;
                        endPixCheck = imageData.data.length;
                        maxPixCount = imageData.data.length / 4;

                        for (var pix = 0; pix < endPixCheck; pix += 4) {
                            var currentColor = {
                                r: imageData.data[pix],
                                g: imageData.data[pix + 1],
                                b: imageData.data[pix + 2]
                            };
                            var colorDifference = Math.sqrt(
                                Math.pow(currentColor.r - sampleColor.r, 2) +
                                Math.pow(currentColor.g - sampleColor.g, 2) +
                                Math.pow(currentColor.b - sampleColor.b, 2)
                            );
                            // difference in color it is difference in color vectors (r1,g1,b1) <=> (r2,g2,b2)
                            if (colorDifference <= maxColorDifference * pixTolerance) {
                                matchPixCount++;
                            }
                        }
                        finishImage();
                    };
                    image.src = _frames[f].image;
                } else {
                    finishImage();
                }
            },
            callback: function() {
                resultFrames = resultFrames.concat(_frames.slice(endCheckFrame));

                if (resultFrames.length <= 0) {
                    // at least one last frame should be available for next manipulation
                    // if total duration of all frames will be < 1000 than ffmpeg doesn't work well...
                    resultFrames.push(_frames[_frames.length - 1]);
                }
                callback(resultFrames);
            }
        });
    }

    var isStopDrawing = false;

    /**
     * This method stops recording video.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        callback = callback || function() {};

        isStopDrawing = true;

        var _this = this;
        // analyse of all frames takes some time!
        setTimeout(function() {
            // e.g. dropBlackFrames(frames, 10, 1, 1) - will cut all 10 frames
            // e.g. dropBlackFrames(frames, 10, 0.5, 0.5) - will analyse 10 frames
            // e.g. dropBlackFrames(frames, 10) === dropBlackFrames(frames, 10, 0, 0) - will analyse 10 frames with strict black color
            dropBlackFrames(whammy.frames, -1, null, null, function(frames) {
                whammy.frames = frames;

                // to display advertisement images!
                if (config.advertisement && config.advertisement.length) {
                    whammy.frames = config.advertisement.concat(whammy.frames);
                }

                /**
                 * @property {Blob} blob - Recorded frames in video/webm blob.
                 * @memberof WhammyRecorder
                 * @example
                 * recorder.stop(function() {
                 *     var blob = recorder.blob;
                 * });
                 */
                whammy.compile(function(blob) {
                    _this.blob = blob;

                    if (_this.blob.forEach) {
                        _this.blob = new Blob([], {
                            type: 'video/webm'
                        });
                    }

                    if (callback) {
                        callback(_this.blob);
                    }
                });
            });
        }, 10);
    };

    var isPausedRecording = false;

    /**
     * This method pauses the recording process.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        isPausedRecording = true;
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        isPausedRecording = false;

        if (isStopDrawing) {
            this.record();
        }
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        if (!isStopDrawing) {
            this.stop(clearRecordedDataCB);
        }
        clearRecordedDataCB();
    };

    function clearRecordedDataCB() {
        whammy.frames = [];
        isStopDrawing = true;
        isPausedRecording = false;
    }

    // for debugging
    this.name = 'WhammyRecorder';
    this.toString = function() {
        return this.name;
    };

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    var video;
    var lastTime;
    var whammy;
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.WhammyRecorder = WhammyRecorder;
}

// https://github.com/antimatter15/whammy/blob/master/LICENSE
// _________
// Whammy.js

// todo: Firefox now supports webp for webm containers!
// their MediaRecorder implementation works well!
// should we provide an option to record via Whammy.js or MediaRecorder API is a better solution?

/**
 * Whammy is a standalone class used by {@link RecordRTC} to bring video recording in Chrome. It is written by {@link https://github.com/antimatter15|antimatter15}
 * @summary A real time javascript webm encoder based on a canvas hack.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef Whammy
 * @class
 * @example
 * var recorder = new Whammy().Video(15);
 * recorder.add(context || canvas || dataURL);
 * var output = recorder.compile();
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */

var Whammy = (function() {
    // a more abstract-ish API

    function WhammyVideo(duration) {
        this.frames = [];
        this.duration = duration || 1;
        this.quality = 0.8;
    }

    /**
     * Pass Canvas or Context or image/webp(string) to {@link Whammy} encoder.
     * @method
     * @memberof Whammy
     * @example
     * recorder = new Whammy().Video(0.8, 100);
     * recorder.add(canvas || context || 'image/webp');
     * @param {string} frame - Canvas || Context || image/webp
     * @param {number} duration - Stick a duration (in milliseconds)
     */
    WhammyVideo.prototype.add = function(frame, duration) {
        if ('canvas' in frame) { //CanvasRenderingContext2D
            frame = frame.canvas;
        }

        if ('toDataURL' in frame) {
            frame = frame.toDataURL('image/webp', this.quality);
        }

        if (!(/^data:image\/webp;base64,/ig).test(frame)) {
            throw 'Input must be formatted properly as a base64 encoded DataURI of type image/webp';
        }
        this.frames.push({
            image: frame,
            duration: duration || this.duration
        });
    };

    function processInWebWorker(_function) {
        var blob = URL.createObjectURL(new Blob([_function.toString(),
            'this.onmessage =  function (e) {' + _function.name + '(e.data);}'
        ], {
            type: 'application/javascript'
        }));

        var worker = new Worker(blob);
        URL.revokeObjectURL(blob);
        return worker;
    }

    function whammyInWebWorker(frames) {
        function ArrayToWebM(frames) {
            var info = checkFrames(frames);
            if (!info) {
                return [];
            }

            var clusterMaxDuration = 30000;

            var EBML = [{
                'id': 0x1a45dfa3, // EBML
                'data': [{
                    'data': 1,
                    'id': 0x4286 // EBMLVersion
                }, {
                    'data': 1,
                    'id': 0x42f7 // EBMLReadVersion
                }, {
                    'data': 4,
                    'id': 0x42f2 // EBMLMaxIDLength
                }, {
                    'data': 8,
                    'id': 0x42f3 // EBMLMaxSizeLength
                }, {
                    'data': 'webm',
                    'id': 0x4282 // DocType
                }, {
                    'data': 2,
                    'id': 0x4287 // DocTypeVersion
                }, {
                    'data': 2,
                    'id': 0x4285 // DocTypeReadVersion
                }]
            }, {
                'id': 0x18538067, // Segment
                'data': [{
                    'id': 0x1549a966, // Info
                    'data': [{
                        'data': 1e6, //do things in millisecs (num of nanosecs for duration scale)
                        'id': 0x2ad7b1 // TimecodeScale
                    }, {
                        'data': 'whammy',
                        'id': 0x4d80 // MuxingApp
                    }, {
                        'data': 'whammy',
                        'id': 0x5741 // WritingApp
                    }, {
                        'data': doubleToString(info.duration),
                        'id': 0x4489 // Duration
                    }]
                }, {
                    'id': 0x1654ae6b, // Tracks
                    'data': [{
                        'id': 0xae, // TrackEntry
                        'data': [{
                            'data': 1,
                            'id': 0xd7 // TrackNumber
                        }, {
                            'data': 1,
                            'id': 0x73c5 // TrackUID
                        }, {
                            'data': 0,
                            'id': 0x9c // FlagLacing
                        }, {
                            'data': 'und',
                            'id': 0x22b59c // Language
                        }, {
                            'data': 'V_VP8',
                            'id': 0x86 // CodecID
                        }, {
                            'data': 'VP8',
                            'id': 0x258688 // CodecName
                        }, {
                            'data': 1,
                            'id': 0x83 // TrackType
                        }, {
                            'id': 0xe0, // Video
                            'data': [{
                                'data': info.width,
                                'id': 0xb0 // PixelWidth
                            }, {
                                'data': info.height,
                                'id': 0xba // PixelHeight
                            }]
                        }]
                    }]
                }]
            }];

            //Generate clusters (max duration)
            var frameNumber = 0;
            var clusterTimecode = 0;
            while (frameNumber < frames.length) {

                var clusterFrames = [];
                var clusterDuration = 0;
                do {
                    clusterFrames.push(frames[frameNumber]);
                    clusterDuration += frames[frameNumber].duration;
                    frameNumber++;
                } while (frameNumber < frames.length && clusterDuration < clusterMaxDuration);

                var clusterCounter = 0;
                var cluster = {
                    'id': 0x1f43b675, // Cluster
                    'data': getClusterData(clusterTimecode, clusterCounter, clusterFrames)
                }; //Add cluster to segment
                EBML[1].data.push(cluster);
                clusterTimecode += clusterDuration;
            }

            return generateEBML(EBML);
        }

        function getClusterData(clusterTimecode, clusterCounter, clusterFrames) {
            return [{
                'data': clusterTimecode,
                'id': 0xe7 // Timecode
            }].concat(clusterFrames.map(function(webp) {
                var block = makeSimpleBlock({
                    discardable: 0,
                    frame: webp.data.slice(4),
                    invisible: 0,
                    keyframe: 1,
                    lacing: 0,
                    trackNum: 1,
                    timecode: Math.round(clusterCounter)
                });
                clusterCounter += webp.duration;
                return {
                    data: block,
                    id: 0xa3
                };
            }));
        }

        // sums the lengths of all the frames and gets the duration

        function checkFrames(frames) {
            if (!frames[0]) {
                postMessage({
                    error: 'Something went wrong. Maybe WebP format is not supported in the current browser.'
                });
                return;
            }

            var width = frames[0].width,
                height = frames[0].height,
                duration = frames[0].duration;

            for (var i = 1; i < frames.length; i++) {
                duration += frames[i].duration;
            }
            return {
                duration: duration,
                width: width,
                height: height
            };
        }

        function numToBuffer(num) {
            var parts = [];
            while (num > 0) {
                parts.push(num & 0xff);
                num = num >> 8;
            }
            return new Uint8Array(parts.reverse());
        }

        function strToBuffer(str) {
            return new Uint8Array(str.split('').map(function(e) {
                return e.charCodeAt(0);
            }));
        }

        function bitsToBuffer(bits) {
            var data = [];
            var pad = (bits.length % 8) ? (new Array(1 + 8 - (bits.length % 8))).join('0') : '';
            bits = pad + bits;
            for (var i = 0; i < bits.length; i += 8) {
                data.push(parseInt(bits.substr(i, 8), 2));
            }
            return new Uint8Array(data);
        }

        function generateEBML(json) {
            var ebml = [];
            for (var i = 0; i < json.length; i++) {
                var data = json[i].data;

                if (typeof data === 'object') {
                    data = generateEBML(data);
                }

                if (typeof data === 'number') {
                    data = bitsToBuffer(data.toString(2));
                }

                if (typeof data === 'string') {
                    data = strToBuffer(data);
                }

                var len = data.size || data.byteLength || data.length;
                var zeroes = Math.ceil(Math.ceil(Math.log(len) / Math.log(2)) / 8);
                var sizeToString = len.toString(2);
                var padded = (new Array((zeroes * 7 + 7 + 1) - sizeToString.length)).join('0') + sizeToString;
                var size = (new Array(zeroes)).join('0') + '1' + padded;

                ebml.push(numToBuffer(json[i].id));
                ebml.push(bitsToBuffer(size));
                ebml.push(data);
            }

            return new Blob(ebml, {
                type: 'video/webm'
            });
        }

        function toBinStrOld(bits) {
            var data = '';
            var pad = (bits.length % 8) ? (new Array(1 + 8 - (bits.length % 8))).join('0') : '';
            bits = pad + bits;
            for (var i = 0; i < bits.length; i += 8) {
                data += String.fromCharCode(parseInt(bits.substr(i, 8), 2));
            }
            return data;
        }

        function makeSimpleBlock(data) {
            var flags = 0;

            if (data.keyframe) {
                flags |= 128;
            }

            if (data.invisible) {
                flags |= 8;
            }

            if (data.lacing) {
                flags |= (data.lacing << 1);
            }

            if (data.discardable) {
                flags |= 1;
            }

            if (data.trackNum > 127) {
                throw 'TrackNumber > 127 not supported';
            }

            var out = [data.trackNum | 0x80, data.timecode >> 8, data.timecode & 0xff, flags].map(function(e) {
                return String.fromCharCode(e);
            }).join('') + data.frame;

            return out;
        }

        function parseWebP(riff) {
            var VP8 = riff.RIFF[0].WEBP[0];

            var frameStart = VP8.indexOf('\x9d\x01\x2a'); // A VP8 keyframe starts with the 0x9d012a header
            for (var i = 0, c = []; i < 4; i++) {
                c[i] = VP8.charCodeAt(frameStart + 3 + i);
            }

            var width, height, tmp;

            //the code below is literally copied verbatim from the bitstream spec
            tmp = (c[1] << 8) | c[0];
            width = tmp & 0x3FFF;
            tmp = (c[3] << 8) | c[2];
            height = tmp & 0x3FFF;
            return {
                width: width,
                height: height,
                data: VP8,
                riff: riff
            };
        }

        function getStrLength(string, offset) {
            return parseInt(string.substr(offset + 4, 4).split('').map(function(i) {
                var unpadded = i.charCodeAt(0).toString(2);
                return (new Array(8 - unpadded.length + 1)).join('0') + unpadded;
            }).join(''), 2);
        }

        function parseRIFF(string) {
            var offset = 0;
            var chunks = {};

            while (offset < string.length) {
                var id = string.substr(offset, 4);
                var len = getStrLength(string, offset);
                var data = string.substr(offset + 4 + 4, len);
                offset += 4 + 4 + len;
                chunks[id] = chunks[id] || [];

                if (id === 'RIFF' || id === 'LIST') {
                    chunks[id].push(parseRIFF(data));
                } else {
                    chunks[id].push(data);
                }
            }
            return chunks;
        }

        function doubleToString(num) {
            return [].slice.call(
                new Uint8Array((new Float64Array([num])).buffer), 0).map(function(e) {
                return String.fromCharCode(e);
            }).reverse().join('');
        }

        var webm = new ArrayToWebM(frames.map(function(frame) {
            var webp = parseWebP(parseRIFF(atob(frame.image.slice(23))));
            webp.duration = frame.duration;
            return webp;
        }));

        postMessage(webm);
    }

    /**
     * Encodes frames in WebM container. It uses WebWorkinvoke to invoke 'ArrayToWebM' method.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof Whammy
     * @example
     * recorder = new Whammy().Video(0.8, 100);
     * recorder.compile(function(blob) {
     *    // blob.size - blob.type
     * });
     */
    WhammyVideo.prototype.compile = function(callback) {
        var webWorker = processInWebWorker(whammyInWebWorker);

        webWorker.onmessage = function(event) {
            if (event.data.error) {
                console.error(event.data.error);
                return;
            }
            callback(event.data);
        };

        webWorker.postMessage(this.frames);
    };

    return {
        /**
         * A more abstract-ish API.
         * @method
         * @memberof Whammy
         * @example
         * recorder = new Whammy().Video(0.8, 100);
         * @param {?number} speed - 0.8
         * @param {?number} quality - 100
         */
        Video: WhammyVideo
    };
})();

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.Whammy = Whammy;
}

// ______________ (indexed-db)
// DiskStorage.js

/**
 * DiskStorage is a standalone object used by {@link RecordRTC} to store recorded blobs in IndexedDB storage.
 * @summary Writing blobs into IndexedDB.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @example
 * DiskStorage.Store({
 *     audioBlob: yourAudioBlob,
 *     videoBlob: yourVideoBlob,
 *     gifBlob  : yourGifBlob
 * });
 * DiskStorage.Fetch(function(dataURL, type) {
 *     if(type === 'audioBlob') { }
 *     if(type === 'videoBlob') { }
 *     if(type === 'gifBlob')   { }
 * });
 * // DiskStorage.dataStoreName = 'recordRTC';
 * // DiskStorage.onError = function(error) { };
 * @property {function} init - This method must be called once to initialize IndexedDB ObjectStore. Though, it is auto-used internally.
 * @property {function} Fetch - This method fetches stored blobs from IndexedDB.
 * @property {function} Store - This method stores blobs in IndexedDB.
 * @property {function} onError - This function is invoked for any known/unknown error.
 * @property {string} dataStoreName - Name of the ObjectStore created in IndexedDB storage.
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */


var DiskStorage = {
    /**
     * This method must be called once to initialize IndexedDB ObjectStore. Though, it is auto-used internally.
     * @method
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.init();
     */
    init: function() {
        var self = this;

        if (typeof indexedDB === 'undefined' || typeof indexedDB.open === 'undefined') {
            console.error('IndexedDB API are not available in this browser.');
            return;
        }

        var dbVersion = 1;
        var dbName = this.dbName || location.href.replace(/\/|:|#|%|\.|\[|\]/g, ''),
            db;
        var request = indexedDB.open(dbName, dbVersion);

        function createObjectStore(dataBase) {
            dataBase.createObjectStore(self.dataStoreName);
        }

        function putInDB() {
            var transaction = db.transaction([self.dataStoreName], 'readwrite');

            if (self.videoBlob) {
                transaction.objectStore(self.dataStoreName).put(self.videoBlob, 'videoBlob');
            }

            if (self.gifBlob) {
                transaction.objectStore(self.dataStoreName).put(self.gifBlob, 'gifBlob');
            }

            if (self.audioBlob) {
                transaction.objectStore(self.dataStoreName).put(self.audioBlob, 'audioBlob');
            }

            function getFromStore(portionName) {
                transaction.objectStore(self.dataStoreName).get(portionName).onsuccess = function(event) {
                    if (self.callback) {
                        self.callback(event.target.result, portionName);
                    }
                };
            }

            getFromStore('audioBlob');
            getFromStore('videoBlob');
            getFromStore('gifBlob');
        }

        request.onerror = self.onError;

        request.onsuccess = function() {
            db = request.result;
            db.onerror = self.onError;

            if (db.setVersion) {
                if (db.version !== dbVersion) {
                    var setVersion = db.setVersion(dbVersion);
                    setVersion.onsuccess = function() {
                        createObjectStore(db);
                        putInDB();
                    };
                } else {
                    putInDB();
                }
            } else {
                putInDB();
            }
        };
        request.onupgradeneeded = function(event) {
            createObjectStore(event.target.result);
        };
    },
    /**
     * This method fetches stored blobs from IndexedDB.
     * @method
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.Fetch(function(dataURL, type) {
     *     if(type === 'audioBlob') { }
     *     if(type === 'videoBlob') { }
     *     if(type === 'gifBlob')   { }
     * });
     */
    Fetch: function(callback) {
        this.callback = callback;
        this.init();

        return this;
    },
    /**
     * This method stores blobs in IndexedDB.
     * @method
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.Store({
     *     audioBlob: yourAudioBlob,
     *     videoBlob: yourVideoBlob,
     *     gifBlob  : yourGifBlob
     * });
     */
    Store: function(config) {
        this.audioBlob = config.audioBlob;
        this.videoBlob = config.videoBlob;
        this.gifBlob = config.gifBlob;

        this.init();

        return this;
    },
    /**
     * This function is invoked for any known/unknown error.
     * @method
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.onError = function(error){
     *     alerot( JSON.stringify(error) );
     * };
     */
    onError: function(error) {
        console.error(JSON.stringify(error, null, '\t'));
    },

    /**
     * @property {string} dataStoreName - Name of the ObjectStore created in IndexedDB storage.
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.dataStoreName = 'recordRTC';
     */
    dataStoreName: 'recordRTC',
    dbName: null
};

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.DiskStorage = DiskStorage;
}

// ______________
// GifRecorder.js

/**
 * GifRecorder is standalone calss used by {@link RecordRTC} to record video or canvas into animated gif.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef GifRecorder
 * @class
 * @example
 * var recorder = new GifRecorder(mediaStream || canvas || context, { onGifPreview: function, onGifRecordingStarted: function, width: 1280, height: 720, frameRate: 200, quality: 10 });
 * recorder.record();
 * recorder.stop(function(blob) {
 *     img.src = URL.createObjectURL(blob);
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object or HTMLCanvasElement or CanvasRenderingContext2D.
 * @param {object} config - {disableLogs:true, initCallback: function, width: 320, height: 240, frameRate: 200, quality: 10}
 */

function GifRecorder(mediaStream, config) {
    if (typeof GIFEncoder === 'undefined') {
        var script = document.createElement('script');
        script.src = 'https://cdn.webrtc-experiment.com/gif-recorder.js';
        (document.body || document.documentElement).appendChild(script);
    }

    config = config || {};

    var isHTMLObject = mediaStream instanceof CanvasRenderingContext2D || mediaStream instanceof HTMLCanvasElement;

    /**
     * This method records MediaStream.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        if (typeof GIFEncoder === 'undefined') {
            setTimeout(self.record, 1000);
            return;
        }

        if (!isLoadedMetaData) {
            setTimeout(self.record, 1000);
            return;
        }

        if (!isHTMLObject) {
            if (!config.width) {
                config.width = video.offsetWidth || 320;
            }

            if (!config.height) {
                config.height = video.offsetHeight || 240;
            }

            if (!config.video) {
                config.video = {
                    width: config.width,
                    height: config.height
                };
            }

            if (!config.canvas) {
                config.canvas = {
                    width: config.width,
                    height: config.height
                };
            }

            canvas.width = config.canvas.width || 320;
            canvas.height = config.canvas.height || 240;

            video.width = config.video.width || 320;
            video.height = config.video.height || 240;
        }

        // external library to record as GIF images
        gifEncoder = new GIFEncoder();

        // void setRepeat(int iter) 
        // Sets the number of times the set of GIF frames should be played. 
        // Default is 1; 0 means play indefinitely.
        gifEncoder.setRepeat(0);

        // void setFrameRate(Number fps) 
        // Sets frame rate in frames per second. 
        // Equivalent to setDelay(1000/fps).
        // Using "setDelay" instead of "setFrameRate"
        gifEncoder.setDelay(config.frameRate || 200);

        // void setQuality(int quality) 
        // Sets quality of color quantization (conversion of images to the 
        // maximum 256 colors allowed by the GIF specification). 
        // Lower values (minimum = 1) produce better colors, 
        // but slow processing significantly. 10 is the default, 
        // and produces good color mapping at reasonable speeds. 
        // Values greater than 20 do not yield significant improvements in speed.
        gifEncoder.setQuality(config.quality || 10);

        // Boolean start() 
        // This writes the GIF Header and returns false if it fails.
        gifEncoder.start();

        if (typeof config.onGifRecordingStarted === 'function') {
            config.onGifRecordingStarted();
        }

        startTime = Date.now();

        function drawVideoFrame(time) {
            if (self.clearedRecordedData === true) {
                return;
            }

            if (isPausedRecording) {
                return setTimeout(function() {
                    drawVideoFrame(time);
                }, 100);
            }

            lastAnimationFrame = requestAnimationFrame(drawVideoFrame);

            if (typeof lastFrameTime === undefined) {
                lastFrameTime = time;
            }

            // ~10 fps
            if (time - lastFrameTime < 90) {
                return;
            }

            if (!isHTMLObject && video.paused) {
                // via: https://github.com/muaz-khan/WebRTC-Experiment/pull/316
                // Tweak for Android Chrome
                video.play();
            }

            if (!isHTMLObject) {
                context.drawImage(video, 0, 0, canvas.width, canvas.height);
            }

            if (config.onGifPreview) {
                config.onGifPreview(canvas.toDataURL('image/png'));
            }

            gifEncoder.addFrame(context);
            lastFrameTime = time;
        }

        lastAnimationFrame = requestAnimationFrame(drawVideoFrame);

        if (config.initCallback) {
            config.initCallback();
        }
    };

    /**
     * This method stops recording MediaStream.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.stop(function(blob) {
     *     img.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        callback = callback || function() {};

        if (lastAnimationFrame) {
            cancelAnimationFrame(lastAnimationFrame);
        }

        endTime = Date.now();

        /**
         * @property {Blob} blob - The recorded blob object.
         * @memberof GifRecorder
         * @example
         * recorder.stop(function(){
         *     var blob = recorder.blob;
         * });
         */
        this.blob = new Blob([new Uint8Array(gifEncoder.stream().bin)], {
            type: 'image/gif'
        });

        callback(this.blob);

        // bug: find a way to clear old recorded blobs
        gifEncoder.stream().bin = [];
    };

    var isPausedRecording = false;

    /**
     * This method pauses the recording process.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        isPausedRecording = true;
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        isPausedRecording = false;
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        self.clearedRecordedData = true;
        clearRecordedDataCB();
    };

    function clearRecordedDataCB() {
        if (gifEncoder) {
            gifEncoder.stream().bin = [];
        }
    }

    // for debugging
    this.name = 'GifRecorder';
    this.toString = function() {
        return this.name;
    };

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    if (isHTMLObject) {
        if (mediaStream instanceof CanvasRenderingContext2D) {
            context = mediaStream;
            canvas = context.canvas;
        } else if (mediaStream instanceof HTMLCanvasElement) {
            context = mediaStream.getContext('2d');
            canvas = mediaStream;
        }
    }

    var isLoadedMetaData = true;

    if (!isHTMLObject) {
        var video = document.createElement('video');
        video.muted = true;
        video.autoplay = true;

        isLoadedMetaData = false;
        video.onloadedmetadata = function() {
            isLoadedMetaData = true;
        };

        setSrcObject(mediaStream, video);

        video.play();
    }

    var lastAnimationFrame = null;
    var startTime, endTime, lastFrameTime;

    var gifEncoder;

    var self = this;
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.GifRecorder = GifRecorder;
}

// Last time updated: 2017-09-26 7:19:00 AM UTC

// ________________________
// MultiStreamsMixer v1.0.3

// Open-Sourced: https://github.com/muaz-khan/MultiStreamsMixer

// --------------------------------------------------
// Muaz Khan     - www.MuazKhan.com
// MIT License   - www.WebRTC-Experiment.com/licence
// --------------------------------------------------

function MultiStreamsMixer(arrayOfMediaStreams) {

    // requires: chrome://flags/#enable-experimental-web-platform-features

    var videos = [];
    var isStopDrawingFrames = false;

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    canvas.style = 'opacity:0;position:absolute;z-index:-1;top: -100000000;left:-1000000000; margin-top:-1000000000;margin-left:-1000000000;';
    (document.body || document.documentElement).appendChild(canvas);

    this.disableLogs = false;
    this.frameInterval = 10;

    this.width = 360;
    this.height = 240;

    // use gain node to prevent echo
    this.useGainNode = true;

    var self = this;

    // _____________________________
    // Cross-Browser-Declarations.js

    // WebAudio API representer
    var AudioContext = window.AudioContext;

    if (typeof AudioContext === 'undefined') {
        if (typeof webkitAudioContext !== 'undefined') {
            /*global AudioContext:true */
            AudioContext = webkitAudioContext;
        }

        if (typeof mozAudioContext !== 'undefined') {
            /*global AudioContext:true */
            AudioContext = mozAudioContext;
        }
    }

    /*jshint -W079 */
    var URL = window.URL;

    if (typeof URL === 'undefined' && typeof webkitURL !== 'undefined') {
        /*global URL:true */
        URL = webkitURL;
    }

    if (typeof navigator !== 'undefined' && typeof navigator.getUserMedia === 'undefined') { // maybe window.navigator?
        if (typeof navigator.webkitGetUserMedia !== 'undefined') {
            navigator.getUserMedia = navigator.webkitGetUserMedia;
        }

        if (typeof navigator.mozGetUserMedia !== 'undefined') {
            navigator.getUserMedia = navigator.mozGetUserMedia;
        }
    }

    var MediaStream = window.MediaStream;

    if (typeof MediaStream === 'undefined' && typeof webkitMediaStream !== 'undefined') {
        MediaStream = webkitMediaStream;
    }

    /*global MediaStream:true */
    if (typeof MediaStream !== 'undefined') {
        if (!('getVideoTracks' in MediaStream.prototype)) {
            MediaStream.prototype.getVideoTracks = function() {
                if (!this.getTracks) {
                    return [];
                }

                var tracks = [];
                this.getTracks.forEach(function(track) {
                    if (track.kind.toString().indexOf('video') !== -1) {
                        tracks.push(track);
                    }
                });
                return tracks;
            };

            MediaStream.prototype.getAudioTracks = function() {
                if (!this.getTracks) {
                    return [];
                }

                var tracks = [];
                this.getTracks.forEach(function(track) {
                    if (track.kind.toString().indexOf('audio') !== -1) {
                        tracks.push(track);
                    }
                });
                return tracks;
            };
        }

        // override "stop" method for all browsers
        if (typeof MediaStream.prototype.stop === 'undefined') {
            MediaStream.prototype.stop = function() {
                this.getTracks().forEach(function(track) {
                    track.stop();
                });
            };
        }
    }

    var Storage = {};

    if (typeof AudioContext !== 'undefined') {
        Storage.AudioContext = AudioContext;
    } else if (typeof webkitAudioContext !== 'undefined') {
        Storage.AudioContext = webkitAudioContext;
    }

    function setSrcObject(stream, element, ignoreCreateObjectURL) {
        if ('createObjectURL' in URL && !ignoreCreateObjectURL) {
            try {
                element.src = URL.createObjectURL(stream);
            } catch (e) {
                setSrcObject(stream, element, true);
                return;
            }
        } else if ('srcObject' in element) {
            element.srcObject = stream;
        } else if ('mozSrcObject' in element) {
            element.mozSrcObject = stream;
        } else {
            alert('createObjectURL/srcObject both are not supported.');
        }
    }

    this.startDrawingFrames = function() {
        drawVideosToCanvas();
    };

    function drawVideosToCanvas() {
        if (isStopDrawingFrames) {
            return;
        }

        var videosLength = videos.length;

        var fullcanvas = false;
        var remaining = [];
        videos.forEach(function(video) {
            if (!video.stream) {
                video.stream = {};
            }

            if (video.stream.fullcanvas) {
                fullcanvas = video;
            } else {
                remaining.push(video);
            }
        });

        if (fullcanvas) {
            canvas.width = fullcanvas.stream.width;
            canvas.height = fullcanvas.stream.height;
        } else if (remaining.length) {
            canvas.width = videosLength > 1 ? remaining[0].width * 2 : remaining[0].width;

            var height = 1;
            if (videosLength === 3 || videosLength === 4) {
                height = 2;
            }
            if (videosLength === 5 || videosLength === 6) {
                height = 3;
            }
            if (videosLength === 7 || videosLength === 8) {
                height = 4;
            }
            if (videosLength === 9 || videosLength === 10) {
                height = 5;
            }
            canvas.height = remaining[0].height * height;
        } else {
            canvas.width = self.width || 360;
            canvas.height = self.height || 240;
        }

        if (fullcanvas && fullcanvas instanceof HTMLVideoElement) {
            drawImage(fullcanvas);
        }

        remaining.forEach(function(video, idx) {
            drawImage(video, idx);
        });

        setTimeout(drawVideosToCanvas, self.frameInterval);
    }

    function drawImage(video, idx) {
        if (isStopDrawingFrames) {
            return;
        }

        var x = 0;
        var y = 0;
        var width = video.width;
        var height = video.height;

        if (idx === 1) {
            x = video.width;
        }

        if (idx === 2) {
            y = video.height;
        }

        if (idx === 3) {
            x = video.width;
            y = video.height;
        }

        if (idx === 4) {
            y = video.height * 2;
        }

        if (idx === 5) {
            x = video.width;
            y = video.height * 2;
        }

        if (idx === 6) {
            y = video.height * 3;
        }

        if (idx === 7) {
            x = video.width;
            y = video.height * 3;
        }

        if (typeof video.stream.left !== 'undefined') {
            x = video.stream.left;
        }

        if (typeof video.stream.top !== 'undefined') {
            y = video.stream.top;
        }

        if (typeof video.stream.width !== 'undefined') {
            width = video.stream.width;
        }

        if (typeof video.stream.height !== 'undefined') {
            height = video.stream.height;
        }

        context.drawImage(video, x, y, width, height);

        if (typeof video.stream.onRender === 'function') {
            video.stream.onRender(context, x, y, width, height, idx);
        }
    }

    function getMixedStream() {
        isStopDrawingFrames = false;
        var mixedVideoStream = getMixedVideoStream();

        var mixedAudioStream = getMixedAudioStream();
        if (mixedAudioStream) {
            mixedAudioStream.getAudioTracks().forEach(function(track) {
                mixedVideoStream.addTrack(track);
            });
        }

        var fullcanvas;
        arrayOfMediaStreams.forEach(function(stream) {
            if (stream.fullcanvas) {
                fullcanvas = true;
            }
        });

        return mixedVideoStream;
    }

    function getMixedVideoStream() {
        resetVideoStreams();

        var capturedStream;

        if ('captureStream' in canvas) {
            capturedStream = canvas.captureStream();
        } else if ('mozCaptureStream' in canvas) {
            capturedStream = canvas.mozCaptureStream();
        } else if (!self.disableLogs) {
            console.error('Upgrade to latest Chrome or otherwise enable this flag: chrome://flags/#enable-experimental-web-platform-features');
        }

        var videoStream = new MediaStream();

        capturedStream.getVideoTracks().forEach(function(track) {
            videoStream.addTrack(track);
        });

        canvas.stream = videoStream;

        return videoStream;
    }

    function getMixedAudioStream() {
        // via: @pehrsons
        if (!Storage.AudioContextConstructor) {
            Storage.AudioContextConstructor = new Storage.AudioContext();
        }

        self.audioContext = Storage.AudioContextConstructor;

        self.audioSources = [];

        if (self.useGainNode === true) {
            self.gainNode = self.audioContext.createGain();
            self.gainNode.connect(self.audioContext.destination);
            self.gainNode.gain.value = 0; // don't hear self
        }

        var audioTracksLength = 0;
        arrayOfMediaStreams.forEach(function(stream) {
            if (!stream.getAudioTracks().length) {
                return;
            }

            audioTracksLength++;

            var audioSource = self.audioContext.createMediaStreamSource(stream);

            if (self.useGainNode === true) {
                audioSource.connect(self.gainNode);
            }

            self.audioSources.push(audioSource);
        });

        if (!audioTracksLength) {
            return;
        }

        self.audioDestination = self.audioContext.createMediaStreamDestination();
        self.audioSources.forEach(function(audioSource) {
            audioSource.connect(self.audioDestination);
        });
        return self.audioDestination.stream;
    }

    function getVideo(stream) {
        var video = document.createElement('video');

        setSrcObject(stream, video);

        video.muted = true;
        video.volume = 0;

        video.width = stream.width || self.width || 360;
        video.height = stream.height || self.height || 240;

        video.play();

        return video;
    }

    this.appendStreams = function(streams) {
        if (!streams) {
            throw 'First parameter is required.';
        }

        if (!(streams instanceof Array)) {
            streams = [streams];
        }

        arrayOfMediaStreams.concat(streams);

        streams.forEach(function(stream) {
            if (stream.getVideoTracks().length) {
                var video = getVideo(stream);
                video.stream = stream;
                videos.push(video);
            }

            if (stream.getAudioTracks().length && self.audioContext) {
                var audioSource = self.audioContext.createMediaStreamSource(stream);
                audioSource.connect(self.audioDestination);
                self.audioSources.push(audioSource);
            }
        });
    };

    this.releaseStreams = function() {
        videos = [];
        isStopDrawingFrames = true;

        if (self.gainNode) {
            self.gainNode.disconnect();
            self.gainNode = null;
        }

        if (self.audioSources.length) {
            self.audioSources.forEach(function(source) {
                source.disconnect();
            });
            self.audioSources = [];
        }

        if (self.audioDestination) {
            self.audioDestination.disconnect();
            self.audioDestination = null;
        }

        self.audioContext = null;

        context.clearRect(0, 0, canvas.width, canvas.height);

        if (canvas.stream) {
            canvas.stream.stop();
            canvas.stream = null;
        }
    };

    this.resetVideoStreams = function(streams) {
        if (streams && !(streams instanceof Array)) {
            streams = [streams];
        }

        resetVideoStreams(streams);
    };

    function resetVideoStreams(streams) {
        videos = [];
        streams = streams || arrayOfMediaStreams;

        // via: @adrian-ber
        streams.forEach(function(stream) {
            if (!stream.getVideoTracks().length) {
                return;
            }

            var video = getVideo(stream);
            video.stream = stream;
            videos.push(video);
        });
    }

    // for debugging
    this.name = 'MultiStreamsMixer';
    this.toString = function() {
        return this.name;
    };

    this.getMixedStream = getMixedStream;

}

// ______________________
// MultiStreamRecorder.js

/*
 * Video conference recording, using captureStream API along with WebAudio and Canvas2D API.
 */

/**
 * MultiStreamRecorder can record multiple videos in single container.
 * @summary Multi-videos recorder.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef MultiStreamRecorder
 * @class
 * @example
 * var options = {
 *     mimeType: 'video/webm'
 * }
 * var recorder = new MultiStreamRecorder(ArrayOfMediaStreams, options);
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 *
 *     // or
 *     var blob = recorder.blob;
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStreams} mediaStreams - Array of MediaStreams.
 * @param {object} config - {disableLogs:true, frameInterval: 1, mimeType: "video/webm"}
 */

function MultiStreamRecorder(arrayOfMediaStreams, options) {
    arrayOfMediaStreams = arrayOfMediaStreams || [];
    var self = this;

    var mixer;
    var mediaRecorder;

    options = options || {
        mimeType: 'video/webm',
        video: {
            width: 360,
            height: 240
        }
    };

    if (!options.frameInterval) {
        options.frameInterval = 10;
    }

    if (!options.video) {
        options.video = {};
    }

    if (!options.video.width) {
        options.video.width = 360;
    }

    if (!options.video.height) {
        options.video.height = 240;
    }

    /**
     * This method records all MediaStreams.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        // github/muaz-khan/MultiStreamsMixer
        mixer = new MultiStreamsMixer(arrayOfMediaStreams);

        if (getVideoTracks().length) {
            mixer.frameInterval = options.frameInterval || 10;
            mixer.width = options.video.width || 360;
            mixer.height = options.video.height || 240;
            mixer.startDrawingFrames();
        }

        if (options.previewStream && typeof options.previewStream === 'function') {
            options.previewStream(mixer.getMixedStream());
        }

        // record using MediaRecorder API
        mediaRecorder = new MediaStreamRecorder(mixer.getMixedStream(), options);
        mediaRecorder.record();
    };

    function getVideoTracks() {
        var tracks = [];
        arrayOfMediaStreams.forEach(function(stream) {
            stream.getVideoTracks().forEach(function(track) {
                tracks.push(track);
            });
        });
        return tracks;
    }

    /**
     * This method stops recording MediaStream.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        if (!mediaRecorder) {
            return;
        }

        mediaRecorder.stop(function(blob) {
            self.blob = blob;

            callback(blob);

            self.clearRecordedData();
        });
    };

    /**
     * This method pauses the recording process.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        if (mediaRecorder) {
            mediaRecorder.pause();
        }
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        if (mediaRecorder) {
            mediaRecorder.resume();
        }
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        if (mediaRecorder) {
            mediaRecorder.clearRecordedData();
            mediaRecorder = null;
        }

        if (mixer) {
            mixer.releaseStreams();
            mixer = null;
        }
    };

    /**
     * Add extra media-streams to existing recordings.
     * @method
     * @memberof MultiStreamRecorder
     * @param {MediaStreams} mediaStreams - Array of MediaStreams
     * @example
     * recorder.addStreams([newAudioStream, newVideoStream]);
     */
    this.addStreams = function(streams) {
        if (!streams) {
            throw 'First parameter is required.';
        }

        if (!(streams instanceof Array)) {
            streams = [streams];
        }

        arrayOfMediaStreams.concat(streams);

        if (!mediaRecorder || !mixer) {
            return;
        }

        mixer.appendStreams(streams);
    };

    /**
     * Reset videos during live recording. Replace old videos e.g. replace cameras with full-screen.
     * @method
     * @memberof MultiStreamRecorder
     * @param {MediaStreams} mediaStreams - Array of MediaStreams
     * @example
     * recorder.resetVideoStreams([newVideo1, newVideo2]);
     */
    this.resetVideoStreams = function(streams) {
        if (!mixer) {
            return;
        }

        if (streams && !(streams instanceof Array)) {
            streams = [streams];
        }

        mixer.resetVideoStreams(streams);
    };

    // for debugging
    this.name = 'MultiStreamRecorder';
    this.toString = function() {
        return this.name;
    };
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.MultiStreamRecorder = MultiStreamRecorder;
}

// _____________________
// RecordRTC.promises.js

/**
 * RecordRTCPromisesHandler adds promises support in {@link RecordRTC}. Try a {@link https://github.com/muaz-khan/RecordRTC/blob/master/simple-demos/RecordRTCPromisesHandler.html|demo here}
 * @summary Promises for {@link RecordRTC}
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef RecordRTCPromisesHandler
 * @class
 * @example
 * var recorder = new RecordRTCPromisesHandler(mediaStream, options);
 * recorder.startRecording()
 *         .then(successCB)
 *         .catch(errorCB);
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - Single media-stream object, array of media-streams, html-canvas-element, etc.
 * @param {object} config - {type:"video", recorderType: MediaStreamRecorder, disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, video: HTMLVideoElement, etc.}
 * @throws Will throw an error if "new" keyword is not used to initiate "RecordRTCPromisesHandler". Also throws error if first argument "MediaStream" is missing.
 * @requires {@link RecordRTC}
 */

function RecordRTCPromisesHandler(mediaStream, options) {
    if (!this) {
        throw 'Use "new RecordRTCPromisesHandler()"';
    }

    if (typeof mediaStream === 'undefined') {
        throw 'First argument "MediaStream" is required.';
    }

    var self = this;

    /**
     * @property {Blob} blob - Access/reach the native {@link RecordRTC} object.
     * @memberof RecordRTCPromisesHandler
     * @example
     * var internal = recorder.recordRTC.getInternalRecorder();
     * alert(internal instanceof MediaStreamRecorder);
     */
    self.recordRTC = new RecordRTC(mediaStream, options);

    /**
     * This method records MediaStream.
     * @method
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.startRecording()
     *         .then(successCB)
     *         .catch(errorCB);
     */
    this.startRecording = function() {
        return new Promise(function(resolve, reject) {
            try {
                self.recordRTC.startRecording();
                resolve();
            } catch (e) {
                reject(e);
            }
        });
    };

    /**
     * This method stops the recording.
     * @method
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.stopRecording().then(function() {
     *     var blob = recorder.getBlob();
     * }).catch(errorCB);
     */
    this.stopRecording = function() {
        return new Promise(function(resolve, reject) {
            try {
                self.recordRTC.stopRecording(function(url) {
                    self.blob = self.recordRTC.getBlob();
                    resolve(url);
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    /**
     * This method returns data-url for the recorded blob.
     * @method
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.stopRecording().then(function() {
     *     recorder.getDataURL().then(function(dataURL) {
     *         window.open(dataURL);
     *     }).catch(errorCB);;
     * }).catch(errorCB);
     */
    this.getDataURL = function(callback) {
        return new Promise(function(resolve, reject) {
            try {
                self.recordRTC.getDataURL(function(dataURL) {
                    resolve(dataURL);
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    /**
     * This method returns the recorded blob.
     * @method
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.stopRecording().then(function() {
     *     var blob = recorder.getBlob();
     * }).catch(errorCB);
     */
    this.getBlob = function() {
        return self.recordRTC.getBlob();
    };

    /**
     * @property {Blob} blob - Recorded data as "Blob" object.
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.stopRecording().then(function() {
     *     var blob = recorder.getBlob();
     * }).catch(errorCB);
     */
    this.blob = null;
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.RecordRTCPromisesHandler = RecordRTCPromisesHandler;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25), __webpack_require__(58)))

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAMAAADjyg5GAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiYmI1NDk1Ni03ZWIxLTRkYjMtYTIzOC01ZTcyMWMzMTU3MWYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTEwMDA2RkU5MThGMTFFQjgwNjdGMzhGM0MzNjI2MDciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTEwMDA2RkQ5MThGMTFFQjgwNjdGMzhGM0MzNjI2MDciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxMTQxMjU2RjQ0OTgxMUU4OEY1N0VEMkZDNTM3NUQ5QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxMTQxMjU3MDQ0OTgxMUU4OEY1N0VEMkZDNTM3NUQ5QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PupMBdgAAACNUExURVqGKYemYs/cwZu2fVyHK3icUOju4fn794amYWOMNNvk0J63gOvx5vj697zOqIenY6i/jbrMpcLSr+Lp2fX38WqRPdXgyZaxdvj69vz9/GGLMoCiWYyranqdUu3y51iEJpGucK7DleTr3MTTsmGLMZ+5gsLSsKO7h+Xs3fb48/39/FeDJPf59FmFJ////4BRH0UAAAAvdFJOU/////////////////////////////////////////////////////////////8AWqU49wAAAGxJREFUeNpi0EMBDEhsJm4xJC6zvDQXnCvHqsvHxg7jisjqMkki9HLoKiMZJaSrADWZWVBPj1eUgQfK1dUV1lPUVYXZK67LqMSiogPjajDoMuqqI1wlo6vLKYHgakppCyC7WY1fC5sXgAAgwAA6kyDHxmRBoQAAAABJRU5ErkJggg=="

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATlJREFUeNqM07FLAmEYx3FPLVFSIsWgPyCsoQaXloywqaYwrD+gEIqCoKWhpcagWqKGZpuiIBoDwabEaFAQgxxapCAIgrCi+j7wGC+HVx58jvfu3t+97/u8d9ZJ37SrzWMB3zjy6o0hvOHOIdCFLYSlr5vTInK4QcYhtIJeyCAJCXWiW992gB1bIIQ1bdcw5ZkNDlzTeMKwdhjBB/La8QKDeMckKjLSF/YRQwkWNjW8jKSGd1GQhmWrnkyxiH48Igi/jppodnLb5v+KCdQR1cCLGWgVkuMBl8Z1QMv9Z2gcM/jEla5ZqrfkFOpBFj6cYhQpNLCne+qSkpuhbR3pFmnjK2noC8ZQ9hqBdczjHnN4Np5Juc8QlzU3QxENebCKaou11tTvmmQ/OnCI8/8+d7MQx9ho5x/5EWAAEAg8zR7qXbAAAAAASUVORK5CYII="

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAMAAADjyg5GAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiYmI1NDk1Ni03ZWIxLTRkYjMtYTIzOC01ZTcyMWMzMTU3MWYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTEwMDA2RkU5MThGMTFFQjgwNjdGMzhGM0MzNjI2MDciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTEwMDA2RkQ5MThGMTFFQjgwNjdGMzhGM0MzNjI2MDciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxMTQxMjU2RjQ0OTgxMUU4OEY1N0VEMkZDNTM3NUQ5QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxMTQxMjU3MDQ0OTgxMUU4OEY1N0VEMkZDNTM3NUQ5QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PupMBdgAAACNUExURVqGKYemYs/cwZu2fVyHK3icUOju4fn794amYWOMNNvk0J63gOvx5vj697zOqIenY6i/jbrMpcLSr+Lp2fX38WqRPdXgyZaxdvj69vz9/GGLMoCiWYyranqdUu3y51iEJpGucK7DleTr3MTTsmGLMZ+5gsLSsKO7h+Xs3fb48/39/FeDJPf59FmFJ////4BRH0UAAAAvdFJOU/////////////////////////////////////////////////////////////8AWqU49wAAAGxJREFUeNpi0EMBDEhsJm4xJC6zvDQXnCvHqsvHxg7jisjqMkki9HLoKiMZJaSrADWZWVBPj1eUgQfK1dUV1lPUVYXZK67LqMSiogPjajDoMuqqI1wlo6vLKYHgakppCyC7WY1fC5sXgAAgwAA6kyDHxmRBoQAAAABJRU5ErkJggg=="

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(454);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(234);
var enumBugKeys = __webpack_require__(167);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SafeAnchor__ = __webpack_require__(41);
















var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};

var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Button, _React$Component);

  function Button() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Button);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  Button.prototype.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass']);

    var Component = componentClass || 'button';

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  Button.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'block', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'block')] = block, _extends2));
    var fullClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('btn', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].XSMALL], Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, Button))));

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(248));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(520));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(522));

var _removeStyle = _interopRequireDefault(__webpack_require__(523));

var _properties = __webpack_require__(178);

var _isTransform = _interopRequireDefault(__webpack_require__(524));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(698)
var ieee754 = __webpack_require__(699)
var isArray = __webpack_require__(311)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(106).Buffer))

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginFields_LoginFields__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomeHeader_css__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomeHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HomeHeader_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var logo=__webpack_require__(62);var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.state={currentItem:null,isLogin:false};_this.handleLogin=_this.handleLogin.bind(_this);_this.closeLogin=_this.closeLogin.bind(_this);_this.handleHome=_this.handleHome.bind(_this);_this.handleResources=_this.handleResources.bind(_this);_this.handleRequestAccount=_this.handleRequestAccount.bind(_this);_this.handleHelp=_this.handleHelp.bind(_this);return _this;}_createClass(Header,[{key:"componentDidMount",value:function componentDidMount(){this.setState({currentItem:this.props.currentItem});}},{key:"handleLogin",value:function handleLogin(){this.setState({isLogin:true});}},{key:"handleHome",value:function handleHome(){this.props.history.push("/login");}},{key:"handleResources",value:function handleResources(){this.props.history.push("/resources");}},{key:"handleRequestAccount",value:function handleRequestAccount(){this.props.history.push("/request-account");}},{key:"handleHelp",value:function handleHelp(){this.props.history.push("/help");}},{key:"closeLogin",value:function closeLogin(){this.setState({isLogin:false});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav",{id:"header",className:"navbar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"header-container",className:"container navbar-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{id:"brand",className:"navbar-brand",href:"/login"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:logo,alt:"AvenuePM Home",border:"0"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{id:"headerBox",className:"nav navbar-nav pull-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"headerItem",onClick:this.handleHome},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:this.props.currentItem==='Home'?"handBtn active":"handBtn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"HOME"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"headerItem",onClick:this.handleResources},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:this.props.currentItem==='Resources'?"handBtn active":"handBtn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Resources"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"headerItem",onClick:this.handleRequestAccount},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:this.props.currentItem==='RequestAccount'?"handBtn active":"handBtn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Create an Account"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"headerItem",onClick:this.handleHelp},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:this.props.currentItem==='Help'?"handBtn active":"handBtn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Help!"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Modal */],{id:"loginModal",show:this.state.isLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LoginFields_LoginFields__["a" /* default */],{callbackFromParent:this.setUser,closeLogin:this.closeLogin})));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* withRouter */])(Header));

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

Lame = __webpack_require__(803);
Presets = __webpack_require__(815);
GainAnalysis = __webpack_require__(365);
QuantizePVT = __webpack_require__(369);
Quantize = __webpack_require__(816);
Takehiro = __webpack_require__(368);
Reservoir = __webpack_require__(820);
MPEGMode = __webpack_require__(363);
BitStream = __webpack_require__(367);
var Encoder = __webpack_require__(35);
var Version = __webpack_require__(821);
var VBRTag = __webpack_require__(822);

function GetAudio() {
    var parse;
    var mpg;

    this.setModules = function (parse2, mpg2) {
        parse = parse2;
        mpg = mpg2;
    }
}


function Parse() {
    var ver;
    var id3;
    var pre;

    this.setModules = function (ver2, id32, pre2) {
        ver = ver2;
        id3 = id32;
        pre = pre2;
    }
}

function MPGLib() {
}

function ID3Tag() {
    var bits;
    var ver;

    this.setModules = function (_bits, _ver) {
        bits = _bits;
        ver = _ver;
    }
}

function Mp3Encoder(channels, samplerate, kbps) {
    if (arguments.length != 3) {
        console.error('WARN: Mp3Encoder(channels, samplerate, kbps) not specified');
        channels = 1;
        samplerate = 44100;
        kbps = 128;
    }
    var lame = new Lame();
    var gaud = new GetAudio();
    var ga = new GainAnalysis();
    var bs = new BitStream();
    var p = new Presets();
    var qupvt = new QuantizePVT();
    var qu = new Quantize();
    var vbr = new VBRTag();
    var ver = new Version();
    var id3 = new ID3Tag();
    var rv = new Reservoir();
    var tak = new Takehiro();
    var parse = new Parse();
    var mpg = new MPGLib();

    lame.setModules(ga, bs, p, qupvt, qu, vbr, ver, id3, mpg);
    bs.setModules(ga, mpg, ver, vbr);
    id3.setModules(bs, ver);
    p.setModules(lame);
    qu.setModules(bs, rv, qupvt, tak);
    qupvt.setModules(tak, rv, lame.enc.psy);
    rv.setModules(bs);
    tak.setModules(qupvt);
    vbr.setModules(lame, bs, ver);
    gaud.setModules(parse, mpg);
    parse.setModules(ver, id3, p);

    var gfp = lame.lame_init();

    gfp.num_channels = channels;
    gfp.in_samplerate = samplerate;
    gfp.brate = kbps;
    gfp.mode = MPEGMode.STEREO;
    gfp.quality = 3;
    gfp.bWriteVbrTag = false;
    gfp.disable_reservoir = true;
    gfp.write_id3tag_automatic = false;

    var retcode = lame.lame_init_params(gfp);
    assert(0 == retcode);
    var maxSamples = 1152;
    var mp3buf_size = 0 | (1.25 * maxSamples + 7200);
    var mp3buf = new_byte(mp3buf_size);

    this.encodeBuffer = function (left, right) {
        if (channels == 1) {
            right = left;
        }
        assert(left.length == right.length);
        if (left.length > maxSamples) {
            maxSamples = left.length;
            mp3buf_size = 0 | (1.25 * maxSamples + 7200);
            mp3buf = new_byte(mp3buf_size);
        }

        var _sz = lame.lame_encode_buffer(gfp, left, right, left.length, mp3buf, 0, mp3buf_size);
        return new Int8Array(mp3buf.subarray(0, _sz));
    };

    this.flush = function () {
        var _sz = lame.lame_encode_flush(gfp, mp3buf, 0, mp3buf_size);
        return new Int8Array(mp3buf.subarray(0, _sz));
    };
}

function WavHeader() {
    this.dataOffset = 0;
    this.dataLen = 0;
    this.channels = 0;
    this.sampleRate = 0;
}

function fourccToInt(fourcc) {
    return fourcc.charCodeAt(0) << 24 | fourcc.charCodeAt(1) << 16 | fourcc.charCodeAt(2) << 8 | fourcc.charCodeAt(3);
}

WavHeader.RIFF = fourccToInt("RIFF");
WavHeader.WAVE = fourccToInt("WAVE");
WavHeader.fmt_ = fourccToInt("fmt ");
WavHeader.data = fourccToInt("data");

WavHeader.readHeader = function (dataView) {
    var w = new WavHeader();

    var header = dataView.getUint32(0, false);
    if (WavHeader.RIFF != header) {
        return;
    }
    var fileLen = dataView.getUint32(4, true);
    if (WavHeader.WAVE != dataView.getUint32(8, false)) {
        return;
    }
    if (WavHeader.fmt_ != dataView.getUint32(12, false)) {
        return;
    }
    var fmtLen = dataView.getUint32(16, true);
    var pos = 16 + 4;
    switch (fmtLen) {
        case 16:
        case 18:
            w.channels = dataView.getUint16(pos + 2, true);
            w.sampleRate = dataView.getUint32(pos + 4, true);
            break;
        default:
            throw 'extended fmt chunk not implemented';
    }
    pos += fmtLen;
    var data = WavHeader.data;
    var len = 0;
    while (data != header) {
        header = dataView.getUint32(pos, false);
        len = dataView.getUint32(pos + 4, true);
        if (data == header) {
            break;
        }
        pos += (len + 8);
    }
    w.dataLen = len;
    w.dataOffset = pos + 8;
    return w;
};

module.exports.Mp3Encoder = Mp3Encoder;
module.exports.WavHeader = WavHeader;


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_loading_gif__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_loading_sandwatch_gif__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_loading_sandwatch_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_loading_sandwatch_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_timers__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a.setAppElement('body');var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'30%'}};var LoadingModal=function(_Component){_inherits(LoadingModal,_Component);function LoadingModal(props){_classCallCheck(this,LoadingModal);return _possibleConstructorReturn(this,(LoadingModal.__proto__||Object.getPrototypeOf(LoadingModal)).call(this,props));}_createClass(LoadingModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:this.props.isUploading,style:customStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_loading_sandwatch_gif___default.a,alt:'Loading',className:'ico-m'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'modal-title'},'Saving...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body'},this.props.timer&&this.props.upTime?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Done in ',this.props.upTime.toString().split(".")[0],' seconds'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-footer'})));}}]);return LoadingModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoadingModal);

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(96);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(117);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__ = __webpack_require__(36);


























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */].defaultProps.bsRole;

var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number])),

  componentClass: __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default()(Object(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["c" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), Object(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["a" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  defaultOpen: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   *
   * *Note: For custom dropdown components, you will have to pass the
   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__["a" /* default */]
};

var Dropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dropdown, _React$Component);

  function Dropdown(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);

    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  Dropdown.prototype.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default()(document));
    }
  };

  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;

    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  Dropdown.prototype.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  Dropdown.prototype.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, { source: 'click' });
  };

  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, { source: 'keydown' });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.tab:
        this.handleClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['id', 'onSelect', 'rootCloseEvent']);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["e" /* prefix */])(props, 'menu'),
      onClose: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, { source: 'select' });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["e" /* prefix */])(props, 'toggle'),
      onClick: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  Dropdown.prototype.render = function render() {
    var _classes,
        _this4 = this;

    var _props = this.props,
        Component = _props.componentClass,
        id = _props.id,
        dropup = _props.dropup,
        disabled = _props.disabled,
        pullRight = _props.pullRight,
        open = _props.open,
        onSelect = _props.onSelect,
        role = _props.role,
        bsClass = _props.bsClass,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);

    delete props.onToggle;

    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    }

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        switch (child.props.bsRole) {
          case TOGGLE_ROLE:
            return _this4.renderToggle(child, {
              id: id,
              disabled: disabled,
              open: open,
              role: role,
              bsClass: bsClass
            });
          case MENU_ROLE:
            return _this4.renderMenu(child, {
              id: id,
              open: open,
              pullRight: pullRight,
              bsClass: bsClass,
              onSelect: onSelect,
              rootCloseEvent: rootCloseEvent
            });
          default:
            return child;
        }
      })
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

Object(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', Dropdown);

var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default()(Dropdown, { open: 'onToggle' });

UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;

  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__);






var _fadeStyles;






var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};

var fadeStyles = (_fadeStyles = {}, _fadeStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERING"]] = 'in', _fadeStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERED"]] = 'in', _fadeStyles);

var Fade = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Fade, _React$Component);

  function Fade() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Fade);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Fade.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default.a,
      props,
      function (status, innerProps) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, innerProps, {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('fade', className, children.props.className, fadeStyles[status])
        }));
      }
    );
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaBody__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaHeading__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaLeft__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaList__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MediaListItem__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MediaRight__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(8);

















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Media = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Media, _React$Component);

  function Media() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Media);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Media.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;

Media.Heading = __WEBPACK_IMPORTED_MODULE_9__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_8__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_10__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_13__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_11__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_12__MediaListItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["a" /* bsClass */])('media', Media));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(117);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var string = _propTypes2['default'].string,
    bool = _propTypes2['default'].bool,
    number = _propTypes2['default'].number,
    array = _propTypes2['default'].array,
    oneOfType = _propTypes2['default'].oneOfType,
    shape = _propTypes2['default'].shape,
    object = _propTypes2['default'].object,
    func = _propTypes2['default'].func;
var propTypes = exports.propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  wrapper: oneOfType([string, func]),
  config: shape({
    soundcloud: shape({
      options: object
    }),
    youtube: shape({
      playerVars: object,
      preload: bool
    }),
    facebook: shape({
      appId: string
    }),
    dailymotion: shape({
      params: object,
      preload: bool
    }),
    vimeo: shape({
      playerOptions: object,
      preload: bool
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      hlsOptions: object
    }),
    wistia: shape({
      options: object
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func
};

var defaultProps = exports.defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  wrapper: 'div',
  config: {
    soundcloud: {
      options: {
        visual: true, // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      preload: false
    },
    facebook: {
      appId: '1309697205772819'
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      },
      preload: false
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      preload: false
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      hlsOptions: {}
    },
    wistia: {
      options: {}
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {}
    }
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {},
  onSeek: function onSeek() {},
  onProgress: function onProgress() {}
};

var DEPRECATED_CONFIG_PROPS = exports.DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(94);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/badge_1.5bcf28cc.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/badge_2.a9c7616f.png";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/badge_3.6fb86190.png";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/badge_4.86091b03.png";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/badge_5.416f6888.png";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/badge_6.981affed.png";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/badge_7.64a7806f.png";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(106)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClassNames; });
/* unused harmony export Global */
/* unused harmony export createElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return keyframes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_cache__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_element_6a883da9_browser_esm_js__ = __webpack_require__(327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__emotion_element_6a883da9_browser_esm_js__["a"]; });
/* unused harmony reexport ThemeContext */
/* unused harmony reexport ThemeProvider */
/* unused harmony reexport __unsafe_useEmotionCache */
/* unused harmony reexport useTheme */
/* unused harmony reexport withEmotionCache */
/* unused harmony reexport withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_extends__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_weak_memoize__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isolated_hnrs_dist_emotion_react_isolated_hnrs_browser_esm_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_utils__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emotion_serialize__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__emotion_use_insertion_effect_with_fallbacks__ = __webpack_require__(332);












var pkg = {
	name: "@emotion/react",
	version: "11.10.4",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.0",
		"@emotion/cache": "^11.10.0",
		"@emotion/serialize": "^1.1.0",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.18.5",
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.0",
		"@emotion/css-prettifier": "1.1.0",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.4",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !__WEBPACK_IMPORTED_MODULE_2__emotion_element_6a883da9_browser_esm_js__["e" /* h */].call(props, 'css')) {
    // $FlowFixMe
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"].apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = __WEBPACK_IMPORTED_MODULE_2__emotion_element_6a883da9_browser_esm_js__["b" /* E */];
  createElementArgArray[1] = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_element_6a883da9_browser_esm_js__["d" /* c */])(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"].apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_2__emotion_element_6a883da9_browser_esm_js__["f" /* w */])(function (props, cache) {
  if (false) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;
  var serialized = Object(__WEBPACK_IMPORTED_MODULE_8__emotion_serialize__["a" /* serializeStyles */])([styles], undefined, Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__emotion_element_6a883da9_browser_esm_js__["c" /* T */]));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  Object(__WEBPACK_IMPORTED_MODULE_9__emotion_use_insertion_effect_with_fallbacks__["b" /* useInsertionEffectWithLayoutFallback */])(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  Object(__WEBPACK_IMPORTED_MODULE_9__emotion_use_insertion_effect_with_fallbacks__["b" /* useInsertionEffectWithLayoutFallback */])(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      Object(__WEBPACK_IMPORTED_MODULE_7__emotion_utils__["b" /* insertStyles */])(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {
  Global.displayName = 'EmotionGlobal';
}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_8__emotion_serialize__["a" /* serializeStyles */])(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_7__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = Object(__WEBPACK_IMPORTED_MODULE_9__emotion_use_insertion_effect_with_fallbacks__["a" /* useInsertionEffectAlwaysWithSyncFallback */])(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = Object(__WEBPACK_IMPORTED_MODULE_7__emotion_utils__["b" /* insertStyles */])(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_2__emotion_element_6a883da9_browser_esm_js__["f" /* w */])(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_8__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    Object(__WEBPACK_IMPORTED_MODULE_7__emotion_utils__["c" /* registerStyles */])(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__emotion_element_6a883da9_browser_esm_js__["c" /* T */])
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

if (false) {
  ClassNames.displayName = 'EmotionClassNames';
}

if (false) {
  var isBrowser = "object" !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

  var isJest = typeof jest !== 'undefined';

  if (isBrowser && !isJest) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext = // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }

    globalContext[globalKey] = true;
  }
}




/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(727);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOptionLabel$1; });
/* unused harmony export b */
/* unused harmony export c */
/* unused harmony export d */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getOptionValue$1; });
/* unused harmony export m */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_react__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_memoize_one__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(141);












function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref =  true ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

var A11yText = function A11yText(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: _ref
  }, props));
};

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
        isMulti = props.isMulti,
        isDisabled = props.isDisabled,
        tabSelectsValue = props.tabSelectsValue,
        context = props.context;

    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");

      case 'input':
        return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';

      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
        _props$label = props.label,
        label = _props$label === void 0 ? '' : _props$label,
        labels = props.labels,
        isDisabled = props.isDisabled;

    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");

      case 'clear':
        return 'All selected options have been cleared.';

      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");

      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");

      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
        focused = props.focused,
        options = props.options,
        _props$label2 = props.label,
        label = _props$label2 === void 0 ? '' : _props$label2,
        selectValue = props.selectValue,
        isDisabled = props.isDisabled,
        isSelected = props.isSelected;

    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };

    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }

    if (context === 'menu') {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }

    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
        resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
      focusedOption = props.focusedOption,
      focusedValue = props.focusedValue,
      focusableOptions = props.focusableOptions,
      isFocused = props.isFocused,
      selectValue = props.selectValue,
      selectProps = props.selectProps,
      id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
      getOptionLabel = selectProps.getOptionLabel,
      inputValue = selectProps.inputValue,
      isMulti = selectProps.isMulti,
      isOptionDisabled = selectProps.isOptionDisabled,
      isSearchable = selectProps.isSearchable,
      menuIsOpen = selectProps.menuIsOpen,
      options = selectProps.options,
      screenReaderStatus = selectProps.screenReaderStatus,
      tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes

  var messages = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]); // Update aria live selected option when prop changes

  var ariaSelected = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useMemo"])(function () {
    var message = '';

    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
          selectedOptions = ariaSelection.options,
          removedValue = ariaSelection.removedValue,
          removedValues = ariaSelection.removedValues,
          value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value

      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      }; // If there is just one item from the action then get its label


      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : ''; // If there are multiple items from the action then return an array of labels

      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];

      var onChangeProps = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);

      message = messages.onChange(onChangeProps);
    }

    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useMemo"])(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));

    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: options,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }

    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, options, selectValue]);
  var ariaResults = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useMemo"])(function () {
    var resultsMsg = '';

    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }

    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
  var ariaGuidance = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useMemo"])(function () {
    var guidanceMsg = '';

    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }

    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])("span", {
    id: "aria-selection"
  }, ariaSelected), Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  return Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])(A11yText, {
    id: id
  }, isInitialFocus && ScreenReaderText), Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(stripDiacritics);

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;

    var _ignoreCase$ignoreAcc = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _excluded = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
      props = Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, _excluded);

  // Remove animation props not meant for HTML elements
  var filteredProps = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["E" /* r */])(props, 'onExited', 'in', 'enter', 'exit', 'appear');
  return Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: innerRef
  }, filteredProps, {
    css: /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["c" /* css */])({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    },  true ? "" : ";label:DummyInput;",  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}

var cancelScroll = function cancelScroll(event) {
  event.preventDefault();
  event.stopPropagation();
};

function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var isBottom = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(false);
  var isTop = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(false);
  var touchStart = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(0);
  var scrollTarget = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(null);
  var handleEventDelta = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useCallback"])(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
        scrollTop = _scrollTarget$current.scrollTop,
        scrollHeight = _scrollTarget$current.scrollHeight,
        clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false; // reset bottom/top flags

    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }

    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    } // bottom limit


    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }

      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true; // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }

      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    } // cancel scroll


    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useCallback"])(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useCallback"])(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useCallback"])(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useCallback"])(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["F" /* s */] ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useCallback"])(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface


function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
      _ref$accountForScroll = _ref.accountForScrollbars,
      accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])({});
  var scrollTarget = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(null);
  var addScrollLock = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useCallback"])(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    } // apply the lock styles and padding if this is the first scroll lock


    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });

      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    } // account for touch devices


    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions); // Allow scroll on provided target

      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    } // increment active scroll locks


    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useCallback"])(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style; // safely decrement active scroll locks

    activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    } // remove touch listeners


    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);

      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var blurSelectInput = function blurSelectInput() {
  return document.activeElement && document.activeElement.blur();
};

var _ref2 =  true ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function ScrollManager(_ref) {
  var children = _ref.children,
      lockEnabled = _ref.lockEnabled,
      _ref$captureEnabled = _ref.captureEnabled,
      captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });

  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, lockEnabled && Object(__WEBPACK_IMPORTED_MODULE_7__emotion_react__["d" /* jsx */])("div", {
    onClick: blurSelectInput,
    css: _ref2
  }), children(targetRef));
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["p" /* b */],
  container: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["q" /* d */],
  control: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["r" /* e */],
  dropdownIndicator: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["s" /* f */],
  group: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["t" /* g */],
  groupHeading: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["u" /* h */],
  indicatorsContainer: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["v" /* i */],
  indicatorSeparator: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["w" /* j */],
  input: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["x" /* k */],
  loadingIndicator: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["y" /* l */],
  loadingMessage: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["z" /* m */],
  menu: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["A" /* n */],
  menuList: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["B" /* o */],
  menuPortal: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["C" /* p */],
  multiValue: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["D" /* q */],
  multiValueLabel: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["G" /* t */],
  multiValueRemove: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["H" /* u */],
  noOptionsMessage: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["I" /* v */],
  option: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["J" /* w */],
  placeholder: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["K" /* x */],
  singleValue: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["L" /* y */],
  valueContainer: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["M" /* z */]
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])({}, source); // massage in target styles


  Object.keys(target).forEach(function (keyAsString) {
    var key = keyAsString;

    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["a" /* A */])(),
  captureMenuScroll: !Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["a" /* A */])(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["b" /* B */])(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};

function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);

  var isSelected = _isOptionSelected(props, option, selectValue);

  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}

function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }

    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["h" /* H */]);
}

function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }

    return optionsAccumulator;
  }, []);
}

function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}

function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
      inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
      isSelected = categorizedOption.isSelected,
      label = categorizedOption.label,
      value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}

function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
      lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }

  return null;
}

function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}

var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};

var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};

function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}

function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;

  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }

  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}

function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}

var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
      isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};

var instanceId = 1;

var Select = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Select, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["n" /* _ */])(Select);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Select);

    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      actionMeta.name = name;

      _this.ariaOnChange(newValue, actionMeta);

      onChange(newValue, actionMeta);
    };

    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti,
          inputValue = _this$props2.inputValue;

      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });

      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.setState({
        clearFocusValueOnUpdate: true
      });

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti,
          name = _this$props3.name;
      var selectValue = _this.state.selectValue;

      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);

      var isDisabled = _this.isOptionDisabled(newValue, selectValue);

      if (deselected) {
        var candidate = _this.getOptionValue(newValue);

        _this.setValue(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["c" /* C */])(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["c" /* C */])([].concat(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["d" /* D */])(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["d" /* D */])(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });

        return;
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["e" /* E */])(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;

      _this.onChange(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["e" /* E */])(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };

    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["e" /* E */])(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };

    _this.getValue = function () {
      return _this.state.selectValue;
    };

    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["f" /* F */].apply(void 0, [_this.props.classNamePrefix].concat(args));
    };

    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };

    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };

    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };

    _this.getComponents = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["g" /* G */])(_this.props);
    };

    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };

    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };

    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };

    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };

    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])({
          value: value
        }, actionMeta)
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      // Event captured by dropdown indicator
      if (event.defaultPrevented) {
        return;
      }

      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }

      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.preventDefault();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["i" /* I */])(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;

      _this.setState({
        inputIsHiddenAfterUpdate: false
      });

      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });

      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };

    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;

      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };

    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
          isMulti = _this$props5.isMulti,
          backspaceRemovesValue = _this$props5.backspaceRemovesValue,
          escapeClearsValue = _this$props5.escapeClearsValue,
          inputValue = _this$props5.inputValue,
          isClearable = _this$props5.isClearable,
          isDisabled = _this$props5.isDisabled,
          menuIsOpen = _this$props5.menuIsOpen,
          onKeyDown = _this$props5.onKeyDown,
          tabSelectsValue = _this$props5.tabSelectsValue,
          openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
          focusedOption = _this$state.focusedOption,
          focusedValue = _this$state.focusedValue,
          selectValue = _this$state.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });

            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["j" /* J */])(_props.value);
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
          isDisabled = _this$props6.isDisabled,
          menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["k" /* K */])(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    } // ==============================
    // Consumer Handlers
    // ==============================

  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;

      var _this$state2 = this.state,
          selectValue = _this$state2.selectValue,
          isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;

      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing

      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: // ==============================
    // Getters
    // ==============================
    function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getValue = this.getValue,
          selectOption = this.selectOption,
          setValue = this.setValue,
          props = this.props;
      var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
          isClearable = _this$props7.isClearable,
          isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    value: // ==============================
    // Composition Handlers
    // ==============================
    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: // ==============================
    // Touch Handlers
    // ==============================
    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
          isDisabled = _this$props8.isDisabled,
          isSearchable = _this$props8.isSearchable,
          inputId = _this$props8.inputId,
          inputValue = _this$props8.inputValue,
          tabIndex = _this$props8.tabIndex,
          form = _this$props8.form,
          menuIsOpen = _this$props8.menuIsOpen;

      var _this$getComponents = this.getComponents(),
          Input = _this$getComponents.Input;

      var _this$state4 = this.state,
          inputIsHidden = _this$state4.inputIsHidden,
          ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        role: 'combobox'
      }, menuIsOpen && {
        'aria-controls': this.getElementId('listbox'),
        'aria-owns': this.getElementId('listbox')
      }), !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](DummyInput, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: __WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["l" /* L */],
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](Input, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;

      var _this$getComponents2 = this.getComponents(),
          MultiValue = _this$getComponents2.MultiValue,
          MultiValueContainer = _this$getComponents2.MultiValueContainer,
          MultiValueLabel = _this$getComponents2.MultiValueLabel,
          MultiValueRemove = _this$getComponents2.MultiValueRemove,
          SingleValue = _this$getComponents2.SingleValue,
          Placeholder = _this$getComponents2.Placeholder;

      var commonProps = this.commonProps;
      var _this$props9 = this.props,
          controlShouldRenderValue = _this$props9.controlShouldRenderValue,
          isDisabled = _this$props9.isDisabled,
          isMulti = _this$props9.isMulti,
          inputValue = _this$props9.inputValue,
          placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
          selectValue = _this$state5.selectValue,
          focusedValue = _this$state5.focusedValue,
          isFocused = _this$state5.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](Placeholder, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }

      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](MultiValue, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](SingleValue, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
          ClearIndicator = _this$getComponents3.ClearIndicator;

      var commonProps = this.commonProps;
      var _this$props10 = this.props,
          isDisabled = _this$props10.isDisabled,
          isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](ClearIndicator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
          LoadingIndicator = _this$getComponents4.LoadingIndicator;

      var commonProps = this.commonProps;
      var _this$props11 = this.props,
          isDisabled = _this$props11.isDisabled,
          isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](LoadingIndicator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
          DropdownIndicator = _this$getComponents5.DropdownIndicator,
          IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator


      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](IndicatorSeparator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
          DropdownIndicator = _this$getComponents6.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](DropdownIndicator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;

      var _this$getComponents7 = this.getComponents(),
          Group = _this$getComponents7.Group,
          GroupHeading = _this$getComponents7.GroupHeading,
          Menu = _this$getComponents7.Menu,
          MenuList = _this$getComponents7.MenuList,
          MenuPortal = _this$getComponents7.MenuPortal,
          LoadingMessage = _this$getComponents7.LoadingMessage,
          NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
          Option = _this$getComponents7.Option;

      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
          captureMenuScroll = _this$props12.captureMenuScroll,
          inputValue = _this$props12.inputValue,
          isLoading = _this$props12.isLoading,
          loadingMessage = _this$props12.loadingMessage,
          minMenuHeight = _this$props12.minMenuHeight,
          maxMenuHeight = _this$props12.maxMenuHeight,
          menuIsOpen = _this$props12.menuIsOpen,
          menuPlacement = _this$props12.menuPlacement,
          menuPosition = _this$props12.menuPosition,
          menuPortalTarget = _this$props12.menuPortalTarget,
          menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
          noOptionsMessage = _this$props12.noOptionsMessage,
          onMenuScrollToTop = _this$props12.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props, id) {
        var type = props.type,
            data = props.data,
            isDisabled = props.isDisabled,
            isSelected = props.isSelected,
            label = props.label,
            value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](Option, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
                options = item.options,
                groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](Group, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["m" /* M */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
            _ref4$placerProps = _ref4.placerProps,
            placement = _ref4$placerProps.placement,
            maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](Menu, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId('listbox')
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](MenuList, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);

              scrollTargetRef(instance);
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](MenuPortal, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;

      var _this$props13 = this.props,
          delimiter = _this$props13.delimiter,
          isDisabled = _this$props13.isDisabled,
          isMulti = _this$props13.isMulti,
          name = _this$props13.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("input", {
            name: name,
            type: "hidden"
          });
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
          ariaSelection = _this$state6.ariaSelection,
          focusedOption = _this$state6.focusedOption,
          focusedValue = _this$state6.focusedValue,
          isFocused = _this$state6.isFocused,
          selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](LiveRegion, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
          Control = _this$getComponents8.Control,
          IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
          SelectContainer = _this$getComponents8.SelectContainer,
          ValueContainer = _this$getComponents8.ValueContainer;

      var _this$props14 = this.props,
          className = _this$props14.className,
          id = _this$props14.id,
          isDisabled = _this$props14.isDisabled,
          menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](SelectContainer, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](Control, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](ValueContainer, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](IndicatorsContainer, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
          clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
          inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
          ariaSelection = state.ariaSelection,
          isFocused = state.isFocused,
          prevWasFocused = state.prevWasFocused;
      var options = props.options,
          value = props.value,
          menuIsOpen = props.menuIsOpen,
          inputValue = props.inputValue,
          isMulti = props.isMulti;
      var selectValue = Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["j" /* J */])(value);
      var newMenuOptionsState = {};

      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      } // some updates should toggle the state of the input visibility


      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;

      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["e" /* E */])(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      } // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null


      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])(Object(__WEBPACK_IMPORTED_MODULE_1__index_a7690a33_esm_js__["o" /* a */])({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Select.defaultProps = defaultProps;




/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Preprocessor = __webpack_require__(782),
    UNICODE = __webpack_require__(144),
    neTree = __webpack_require__(783);

//Aliases
var $ = UNICODE.CODE_POINTS,
    $$ = UNICODE.CODE_POINT_SEQUENCES;

//Replacement code points for numeric entities
var NUMERIC_ENTITY_REPLACEMENTS = {
    0x00: 0xFFFD, 0x0D: 0x000D, 0x80: 0x20AC, 0x81: 0x0081, 0x82: 0x201A, 0x83: 0x0192, 0x84: 0x201E,
    0x85: 0x2026, 0x86: 0x2020, 0x87: 0x2021, 0x88: 0x02C6, 0x89: 0x2030, 0x8A: 0x0160, 0x8B: 0x2039,
    0x8C: 0x0152, 0x8D: 0x008D, 0x8E: 0x017D, 0x8F: 0x008F, 0x90: 0x0090, 0x91: 0x2018, 0x92: 0x2019,
    0x93: 0x201C, 0x94: 0x201D, 0x95: 0x2022, 0x96: 0x2013, 0x97: 0x2014, 0x98: 0x02DC, 0x99: 0x2122,
    0x9A: 0x0161, 0x9B: 0x203A, 0x9C: 0x0153, 0x9D: 0x009D, 0x9E: 0x017E, 0x9F: 0x0178
};

// Named entity tree flags
var HAS_DATA_FLAG = 1 << 0;
var DATA_DUPLET_FLAG = 1 << 1;
var HAS_BRANCHES_FLAG = 1 << 2;
var MAX_BRANCH_MARKER_VALUE = HAS_DATA_FLAG | DATA_DUPLET_FLAG | HAS_BRANCHES_FLAG;


//States
var DATA_STATE = 'DATA_STATE',
    CHARACTER_REFERENCE_IN_DATA_STATE = 'CHARACTER_REFERENCE_IN_DATA_STATE',
    RCDATA_STATE = 'RCDATA_STATE',
    CHARACTER_REFERENCE_IN_RCDATA_STATE = 'CHARACTER_REFERENCE_IN_RCDATA_STATE',
    RAWTEXT_STATE = 'RAWTEXT_STATE',
    SCRIPT_DATA_STATE = 'SCRIPT_DATA_STATE',
    PLAINTEXT_STATE = 'PLAINTEXT_STATE',
    TAG_OPEN_STATE = 'TAG_OPEN_STATE',
    END_TAG_OPEN_STATE = 'END_TAG_OPEN_STATE',
    TAG_NAME_STATE = 'TAG_NAME_STATE',
    RCDATA_LESS_THAN_SIGN_STATE = 'RCDATA_LESS_THAN_SIGN_STATE',
    RCDATA_END_TAG_OPEN_STATE = 'RCDATA_END_TAG_OPEN_STATE',
    RCDATA_END_TAG_NAME_STATE = 'RCDATA_END_TAG_NAME_STATE',
    RAWTEXT_LESS_THAN_SIGN_STATE = 'RAWTEXT_LESS_THAN_SIGN_STATE',
    RAWTEXT_END_TAG_OPEN_STATE = 'RAWTEXT_END_TAG_OPEN_STATE',
    RAWTEXT_END_TAG_NAME_STATE = 'RAWTEXT_END_TAG_NAME_STATE',
    SCRIPT_DATA_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_END_TAG_OPEN_STATE = 'SCRIPT_DATA_END_TAG_OPEN_STATE',
    SCRIPT_DATA_END_TAG_NAME_STATE = 'SCRIPT_DATA_END_TAG_NAME_STATE',
    SCRIPT_DATA_ESCAPE_START_STATE = 'SCRIPT_DATA_ESCAPE_START_STATE',
    SCRIPT_DATA_ESCAPE_START_DASH_STATE = 'SCRIPT_DATA_ESCAPE_START_DASH_STATE',
    SCRIPT_DATA_ESCAPED_STATE = 'SCRIPT_DATA_ESCAPED_STATE',
    SCRIPT_DATA_ESCAPED_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_STATE',
    SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_DASH_STATE',
    SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE',
    SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE',
    BEFORE_ATTRIBUTE_NAME_STATE = 'BEFORE_ATTRIBUTE_NAME_STATE',
    ATTRIBUTE_NAME_STATE = 'ATTRIBUTE_NAME_STATE',
    AFTER_ATTRIBUTE_NAME_STATE = 'AFTER_ATTRIBUTE_NAME_STATE',
    BEFORE_ATTRIBUTE_VALUE_STATE = 'BEFORE_ATTRIBUTE_VALUE_STATE',
    ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE',
    ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE',
    ATTRIBUTE_VALUE_UNQUOTED_STATE = 'ATTRIBUTE_VALUE_UNQUOTED_STATE',
    CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE = 'CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE',
    AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = 'AFTER_ATTRIBUTE_VALUE_QUOTED_STATE',
    SELF_CLOSING_START_TAG_STATE = 'SELF_CLOSING_START_TAG_STATE',
    BOGUS_COMMENT_STATE = 'BOGUS_COMMENT_STATE',
    BOGUS_COMMENT_STATE_CONTINUATION = 'BOGUS_COMMENT_STATE_CONTINUATION',
    MARKUP_DECLARATION_OPEN_STATE = 'MARKUP_DECLARATION_OPEN_STATE',
    COMMENT_START_STATE = 'COMMENT_START_STATE',
    COMMENT_START_DASH_STATE = 'COMMENT_START_DASH_STATE',
    COMMENT_STATE = 'COMMENT_STATE',
    COMMENT_END_DASH_STATE = 'COMMENT_END_DASH_STATE',
    COMMENT_END_STATE = 'COMMENT_END_STATE',
    COMMENT_END_BANG_STATE = 'COMMENT_END_BANG_STATE',
    DOCTYPE_STATE = 'DOCTYPE_STATE',
    DOCTYPE_NAME_STATE = 'DOCTYPE_NAME_STATE',
    AFTER_DOCTYPE_NAME_STATE = 'AFTER_DOCTYPE_NAME_STATE',
    BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE',
    DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE',
    DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE',
    BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = 'BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE',
    BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
    DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE',
    DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE',
    AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
    BOGUS_DOCTYPE_STATE = 'BOGUS_DOCTYPE_STATE',
    CDATA_SECTION_STATE = 'CDATA_SECTION_STATE';

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isWhitespace(cp) {
    return cp === $.SPACE || cp === $.LINE_FEED || cp === $.TABULATION || cp === $.FORM_FEED;
}

function isAsciiDigit(cp) {
    return cp >= $.DIGIT_0 && cp <= $.DIGIT_9;
}

function isAsciiUpper(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_Z;
}

function isAsciiLower(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_Z;
}

function isAsciiLetter(cp) {
    return isAsciiLower(cp) || isAsciiUpper(cp);
}

function isAsciiAlphaNumeric(cp) {
    return isAsciiLetter(cp) || isAsciiDigit(cp);
}

function isDigit(cp, isHex) {
    return isAsciiDigit(cp) || isHex && (cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_F ||
                                         cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_F);
}

function isReservedCodePoint(cp) {
    return cp >= 0xD800 && cp <= 0xDFFF || cp > 0x10FFFF;
}

function toAsciiLowerCodePoint(cp) {
    return cp + 0x0020;
}

//NOTE: String.fromCharCode() function can handle only characters from BMP subset.
//So, we need to workaround this manually.
//(see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/String/fromCharCode#Getting_it_to_work_with_higher_values)
function toChar(cp) {
    if (cp <= 0xFFFF)
        return String.fromCharCode(cp);

    cp -= 0x10000;
    return String.fromCharCode(cp >>> 10 & 0x3FF | 0xD800) + String.fromCharCode(0xDC00 | cp & 0x3FF);
}

function toAsciiLowerChar(cp) {
    return String.fromCharCode(toAsciiLowerCodePoint(cp));
}

function findNamedEntityTreeBranch(nodeIx, cp) {
    var branchCount = neTree[++nodeIx],
        lo = ++nodeIx,
        hi = lo + branchCount - 1;

    while (lo <= hi) {
        var mid = lo + hi >>> 1,
            midCp = neTree[mid];

        if (midCp < cp)
            lo = mid + 1;

        else if (midCp > cp)
            hi = mid - 1;

        else
            return neTree[mid + branchCount];
    }

    return -1;
}


//Tokenizer
var Tokenizer = module.exports = function () {
    this.preprocessor = new Preprocessor();

    this.tokenQueue = [];

    this.allowCDATA = false;

    this.state = DATA_STATE;
    this.returnState = '';

    this.tempBuff = [];
    this.additionalAllowedCp = void 0;
    this.lastStartTagName = '';

    this.consumedAfterSnapshot = -1;
    this.active = false;

    this.currentCharacterToken = null;
    this.currentToken = null;
    this.currentAttr = null;
};

//Token types
Tokenizer.CHARACTER_TOKEN = 'CHARACTER_TOKEN';
Tokenizer.NULL_CHARACTER_TOKEN = 'NULL_CHARACTER_TOKEN';
Tokenizer.WHITESPACE_CHARACTER_TOKEN = 'WHITESPACE_CHARACTER_TOKEN';
Tokenizer.START_TAG_TOKEN = 'START_TAG_TOKEN';
Tokenizer.END_TAG_TOKEN = 'END_TAG_TOKEN';
Tokenizer.COMMENT_TOKEN = 'COMMENT_TOKEN';
Tokenizer.DOCTYPE_TOKEN = 'DOCTYPE_TOKEN';
Tokenizer.EOF_TOKEN = 'EOF_TOKEN';
Tokenizer.HIBERNATION_TOKEN = 'HIBERNATION_TOKEN';

//Tokenizer initial states for different modes
Tokenizer.MODE = {
    DATA: DATA_STATE,
    RCDATA: RCDATA_STATE,
    RAWTEXT: RAWTEXT_STATE,
    SCRIPT_DATA: SCRIPT_DATA_STATE,
    PLAINTEXT: PLAINTEXT_STATE
};

//Static
Tokenizer.getTokenAttr = function (token, attrName) {
    for (var i = token.attrs.length - 1; i >= 0; i--) {
        if (token.attrs[i].name === attrName)
            return token.attrs[i].value;
    }

    return null;
};

//API
Tokenizer.prototype.getNextToken = function () {
    while (!this.tokenQueue.length && this.active) {
        this._hibernationSnapshot();

        var cp = this._consume();

        if (!this._ensureHibernation())
            this[this.state](cp);
    }

    return this.tokenQueue.shift();
};

Tokenizer.prototype.write = function (chunk, isLastChunk) {
    this.active = true;
    this.preprocessor.write(chunk, isLastChunk);
};

Tokenizer.prototype.insertHtmlAtCurrentPos = function (chunk) {
    this.active = true;
    this.preprocessor.insertHtmlAtCurrentPos(chunk);
};

//Hibernation
Tokenizer.prototype._hibernationSnapshot = function () {
    this.consumedAfterSnapshot = 0;
};

Tokenizer.prototype._ensureHibernation = function () {
    if (this.preprocessor.endOfChunkHit) {
        for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
            this.preprocessor.retreat();

        this.active = false;
        this.tokenQueue.push({type: Tokenizer.HIBERNATION_TOKEN});

        return true;
    }

    return false;
};


//Consumption
Tokenizer.prototype._consume = function () {
    this.consumedAfterSnapshot++;
    return this.preprocessor.advance();
};

Tokenizer.prototype._unconsume = function () {
    this.consumedAfterSnapshot--;
    this.preprocessor.retreat();
};

Tokenizer.prototype._unconsumeSeveral = function (count) {
    while (count--)
        this._unconsume();
};

Tokenizer.prototype._reconsumeInState = function (state) {
    this.state = state;
    this._unconsume();
};

Tokenizer.prototype._consumeSubsequentIfMatch = function (pattern, startCp, caseSensitive) {
    var consumedCount = 0,
        isMatch = true,
        patternLength = pattern.length,
        patternPos = 0,
        cp = startCp,
        patternCp = void 0;

    for (; patternPos < patternLength; patternPos++) {
        if (patternPos > 0) {
            cp = this._consume();
            consumedCount++;
        }

        if (cp === $.EOF) {
            isMatch = false;
            break;
        }

        patternCp = pattern[patternPos];

        if (cp !== patternCp && (caseSensitive || cp !== toAsciiLowerCodePoint(patternCp))) {
            isMatch = false;
            break;
        }
    }

    if (!isMatch)
        this._unconsumeSeveral(consumedCount);

    return isMatch;
};

//Lookahead
Tokenizer.prototype._lookahead = function () {
    var cp = this._consume();

    this._unconsume();

    return cp;
};

//Temp buffer
Tokenizer.prototype.isTempBufferEqualToScriptString = function () {
    if (this.tempBuff.length !== $$.SCRIPT_STRING.length)
        return false;

    for (var i = 0; i < this.tempBuff.length; i++) {
        if (this.tempBuff[i] !== $$.SCRIPT_STRING[i])
            return false;
    }

    return true;
};

//Token creation
Tokenizer.prototype._createStartTagToken = function () {
    this.currentToken = {
        type: Tokenizer.START_TAG_TOKEN,
        tagName: '',
        selfClosing: false,
        attrs: []
    };
};

Tokenizer.prototype._createEndTagToken = function () {
    this.currentToken = {
        type: Tokenizer.END_TAG_TOKEN,
        tagName: '',
        attrs: []
    };
};

Tokenizer.prototype._createCommentToken = function () {
    this.currentToken = {
        type: Tokenizer.COMMENT_TOKEN,
        data: ''
    };
};

Tokenizer.prototype._createDoctypeToken = function (initialName) {
    this.currentToken = {
        type: Tokenizer.DOCTYPE_TOKEN,
        name: initialName,
        forceQuirks: false,
        publicId: null,
        systemId: null
    };
};

Tokenizer.prototype._createCharacterToken = function (type, ch) {
    this.currentCharacterToken = {
        type: type,
        chars: ch
    };
};

//Tag attributes
Tokenizer.prototype._createAttr = function (attrNameFirstCh) {
    this.currentAttr = {
        name: attrNameFirstCh,
        value: ''
    };
};

Tokenizer.prototype._isDuplicateAttr = function () {
    return Tokenizer.getTokenAttr(this.currentToken, this.currentAttr.name) !== null;
};

Tokenizer.prototype._leaveAttrName = function (toState) {
    this.state = toState;

    if (!this._isDuplicateAttr())
        this.currentToken.attrs.push(this.currentAttr);
};

Tokenizer.prototype._leaveAttrValue = function (toState) {
    this.state = toState;
};

//Appropriate end tag token
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#appropriate-end-tag-token)
Tokenizer.prototype._isAppropriateEndTagToken = function () {
    return this.lastStartTagName === this.currentToken.tagName;
};

//Token emission
Tokenizer.prototype._emitCurrentToken = function () {
    this._emitCurrentCharacterToken();

    //NOTE: store emited start tag's tagName to determine is the following end tag token is appropriate.
    if (this.currentToken.type === Tokenizer.START_TAG_TOKEN)
        this.lastStartTagName = this.currentToken.tagName;

    this.tokenQueue.push(this.currentToken);
    this.currentToken = null;
};

Tokenizer.prototype._emitCurrentCharacterToken = function () {
    if (this.currentCharacterToken) {
        this.tokenQueue.push(this.currentCharacterToken);
        this.currentCharacterToken = null;
    }
};

Tokenizer.prototype._emitEOFToken = function () {
    this._emitCurrentCharacterToken();
    this.tokenQueue.push({type: Tokenizer.EOF_TOKEN});
};

//Characters emission

//OPTIMIZATION: specification uses only one type of character tokens (one token per character).
//This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
//If we have a sequence of characters that belong to the same group, parser can process it
//as a single solid character token.
//So, there are 3 types of character tokens in parse5:
//1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
//2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
//3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
Tokenizer.prototype._appendCharToCurrentCharacterToken = function (type, ch) {
    if (this.currentCharacterToken && this.currentCharacterToken.type !== type)
        this._emitCurrentCharacterToken();

    if (this.currentCharacterToken)
        this.currentCharacterToken.chars += ch;

    else
        this._createCharacterToken(type, ch);
};

Tokenizer.prototype._emitCodePoint = function (cp) {
    var type = Tokenizer.CHARACTER_TOKEN;

    if (isWhitespace(cp))
        type = Tokenizer.WHITESPACE_CHARACTER_TOKEN;

    else if (cp === $.NULL)
        type = Tokenizer.NULL_CHARACTER_TOKEN;

    this._appendCharToCurrentCharacterToken(type, toChar(cp));
};

Tokenizer.prototype._emitSeveralCodePoints = function (codePoints) {
    for (var i = 0; i < codePoints.length; i++)
        this._emitCodePoint(codePoints[i]);
};

//NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
//So we can avoid additional checks here.
Tokenizer.prototype._emitChar = function (ch) {
    this._appendCharToCurrentCharacterToken(Tokenizer.CHARACTER_TOKEN, ch);
};

//Character reference tokenization
Tokenizer.prototype._consumeNumericEntity = function (isHex) {
    var digits = '',
        nextCp = void 0;

    do {
        digits += toChar(this._consume());
        nextCp = this._lookahead();
    } while (nextCp !== $.EOF && isDigit(nextCp, isHex));

    if (this._lookahead() === $.SEMICOLON)
        this._consume();

    var referencedCp = parseInt(digits, isHex ? 16 : 10),
        replacement = NUMERIC_ENTITY_REPLACEMENTS[referencedCp];

    if (replacement)
        return replacement;

    if (isReservedCodePoint(referencedCp))
        return $.REPLACEMENT_CHARACTER;

    return referencedCp;
};

// NOTE: for the details on this algorithm see
// https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md
Tokenizer.prototype._consumeNamedEntity = function (inAttr) {
    var referencedCodePoints = null,
        referenceSize = 0,
        cp = null,
        consumedCount = 0,
        semicolonTerminated = false;

    for (var i = 0; i > -1;) {
        var current = neTree[i],
            inNode = current < MAX_BRANCH_MARKER_VALUE,
            nodeWithData = inNode && current & HAS_DATA_FLAG;

        if (nodeWithData) {
            referencedCodePoints = current & DATA_DUPLET_FLAG ? [neTree[++i], neTree[++i]] : [neTree[++i]];
            referenceSize = consumedCount;

            if (cp === $.SEMICOLON) {
                semicolonTerminated = true;
                break;
            }
        }

        cp = this._consume();
        consumedCount++;

        if (cp === $.EOF)
            break;

        if (inNode)
            i = current & HAS_BRANCHES_FLAG ? findNamedEntityTreeBranch(i, cp) : -1;

        else
            i = cp === current ? ++i : -1;
    }


    if (referencedCodePoints) {
        if (!semicolonTerminated) {
            //NOTE: unconsume excess (e.g. 'it' in '&notit')
            this._unconsumeSeveral(consumedCount - referenceSize);

            //NOTE: If the character reference is being consumed as part of an attribute and the next character
            //is either a U+003D EQUALS SIGN character (=) or an alphanumeric ASCII character, then, for historical
            //reasons, all the characters that were matched after the U+0026 AMPERSAND character (&) must be
            //unconsumed, and nothing is returned.
            //However, if this next character is in fact a U+003D EQUALS SIGN character (=), then this is a
            //parse error, because some legacy user agents will misinterpret the markup in those cases.
            //(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#tokenizing-character-references)
            if (inAttr) {
                var nextCp = this._lookahead();

                if (nextCp === $.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp)) {
                    this._unconsumeSeveral(referenceSize);
                    return null;
                }
            }
        }

        return referencedCodePoints;
    }

    this._unconsumeSeveral(consumedCount);

    return null;
};

Tokenizer.prototype._consumeCharacterReference = function (startCp, inAttr) {
    if (isWhitespace(startCp) || startCp === $.GREATER_THAN_SIGN ||
        startCp === $.AMPERSAND || startCp === this.additionalAllowedCp || startCp === $.EOF) {
        //NOTE: not a character reference. No characters are consumed, and nothing is returned.
        this._unconsume();
        return null;
    }

    if (startCp === $.NUMBER_SIGN) {
        //NOTE: we have a numeric entity candidate, now we should determine if it's hex or decimal
        var isHex = false,
            nextCp = this._lookahead();

        if (nextCp === $.LATIN_SMALL_X || nextCp === $.LATIN_CAPITAL_X) {
            this._consume();
            isHex = true;
        }

        nextCp = this._lookahead();

        //NOTE: if we have at least one digit this is a numeric entity for sure, so we consume it
        if (nextCp !== $.EOF && isDigit(nextCp, isHex))
            return [this._consumeNumericEntity(isHex)];

        //NOTE: otherwise this is a bogus number entity and a parse error. Unconsume the number sign
        //and the 'x'-character if appropriate.
        this._unconsumeSeveral(isHex ? 2 : 1);
        return null;
    }

    this._unconsume();

    return this._consumeNamedEntity(inAttr);
};

//State machine
var _ = Tokenizer.prototype;

//12.2.4.1 Data state
//------------------------------------------------------------------
_[DATA_STATE] = function dataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.AMPERSAND)
        this.state = CHARACTER_REFERENCE_IN_DATA_STATE;

    else if (cp === $.LESS_THAN_SIGN)
        this.state = TAG_OPEN_STATE;

    else if (cp === $.NULL)
        this._emitCodePoint(cp);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.2 Character reference in data state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_DATA_STATE] = function characterReferenceInDataState(cp) {
    this.additionalAllowedCp = void 0;

    var referencedCodePoints = this._consumeCharacterReference(cp, false);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints)
            this._emitSeveralCodePoints(referencedCodePoints);

        else
            this._emitChar('&');

        this.state = DATA_STATE;
    }
};


//12.2.4.3 RCDATA state
//------------------------------------------------------------------
_[RCDATA_STATE] = function rcdataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.AMPERSAND)
        this.state = CHARACTER_REFERENCE_IN_RCDATA_STATE;

    else if (cp === $.LESS_THAN_SIGN)
        this.state = RCDATA_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.4 Character reference in RCDATA state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_RCDATA_STATE] = function characterReferenceInRcdataState(cp) {
    this.additionalAllowedCp = void 0;

    var referencedCodePoints = this._consumeCharacterReference(cp, false);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints)
            this._emitSeveralCodePoints(referencedCodePoints);

        else
            this._emitChar('&');

        this.state = RCDATA_STATE;
    }
};


//12.2.4.5 RAWTEXT state
//------------------------------------------------------------------
_[RAWTEXT_STATE] = function rawtextState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.LESS_THAN_SIGN)
        this.state = RAWTEXT_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.6 Script data state
//------------------------------------------------------------------
_[SCRIPT_DATA_STATE] = function scriptDataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.7 PLAINTEXT state
//------------------------------------------------------------------
_[PLAINTEXT_STATE] = function plaintextState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.8 Tag open state
//------------------------------------------------------------------
_[TAG_OPEN_STATE] = function tagOpenState(cp) {
    if (cp === $.EXCLAMATION_MARK)
        this.state = MARKUP_DECLARATION_OPEN_STATE;

    else if (cp === $.SOLIDUS)
        this.state = END_TAG_OPEN_STATE;

    else if (isAsciiLetter(cp)) {
        this._createStartTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
    }

    else if (cp === $.QUESTION_MARK)
        this._reconsumeInState(BOGUS_COMMENT_STATE);

    else {
        this._emitChar('<');
        this._reconsumeInState(DATA_STATE);
    }
};


//12.2.4.9 End tag open state
//------------------------------------------------------------------
_[END_TAG_OPEN_STATE] = function endTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
    }

    else if (cp === $.GREATER_THAN_SIGN)
        this.state = DATA_STATE;

    else if (cp === $.EOF) {
        this._reconsumeInState(DATA_STATE);
        this._emitChar('<');
        this._emitChar('/');
    }

    else
        this._reconsumeInState(BOGUS_COMMENT_STATE);
};


//12.2.4.10 Tag name state
//------------------------------------------------------------------
_[TAG_NAME_STATE] = function tagNameState(cp) {
    if (isWhitespace(cp))
        this.state = BEFORE_ATTRIBUTE_NAME_STATE;

    else if (cp === $.SOLIDUS)
        this.state = SELF_CLOSING_START_TAG_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (isAsciiUpper(cp))
        this.currentToken.tagName += toAsciiLowerChar(cp);

    else if (cp === $.NULL)
        this.currentToken.tagName += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentToken.tagName += toChar(cp);
};


//12.2.4.11 RCDATA less-than sign state
//------------------------------------------------------------------
_[RCDATA_LESS_THAN_SIGN_STATE] = function rcdataLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RCDATA_END_TAG_OPEN_STATE;
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.12 RCDATA end tag open state
//------------------------------------------------------------------
_[RCDATA_END_TAG_OPEN_STATE] = function rcdataEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RCDATA_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.13 RCDATA end tag name state
//------------------------------------------------------------------
_[RCDATA_END_TAG_NAME_STATE] = function rcdataEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this.state = DATA_STATE;
                this._emitCurrentToken();
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.14 RAWTEXT less-than sign state
//------------------------------------------------------------------
_[RAWTEXT_LESS_THAN_SIGN_STATE] = function rawtextLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RAWTEXT_END_TAG_OPEN_STATE;
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.15 RAWTEXT end tag open state
//------------------------------------------------------------------
_[RAWTEXT_END_TAG_OPEN_STATE] = function rawtextEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RAWTEXT_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.16 RAWTEXT end tag name state
//------------------------------------------------------------------
_[RAWTEXT_END_TAG_NAME_STATE] = function rawtextEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.17 Script data less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_LESS_THAN_SIGN_STATE] = function scriptDataLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_END_TAG_OPEN_STATE;
    }

    else if (cp === $.EXCLAMATION_MARK) {
        this.state = SCRIPT_DATA_ESCAPE_START_STATE;
        this._emitChar('<');
        this._emitChar('!');
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.18 Script data end tag open state
//------------------------------------------------------------------
_[SCRIPT_DATA_END_TAG_OPEN_STATE] = function scriptDataEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.19 Script data end tag name state
//------------------------------------------------------------------
_[SCRIPT_DATA_END_TAG_NAME_STATE] = function scriptDataEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            else if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            else if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.20 Script data escape start state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPE_START_STATE] = function scriptDataEscapeStartState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPE_START_DASH_STATE;
        this._emitChar('-');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_STATE);
};


//12.2.4.21 Script data escape start dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPE_START_DASH_STATE] = function scriptDataEscapeStartDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_STATE);
};


//12.2.4.22 Script data escaped state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_STATE] = function scriptDataEscapedState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._emitCodePoint(cp);
};


//12.2.4.23 Script data escaped dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_DASH_STATE] = function scriptDataEscapedDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.24 Script data escaped dash dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_DASH_DASH_STATE] = function scriptDataEscapedDashDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this._emitChar('-');

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChar('>');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.25 Script data escaped less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataEscapedLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
    }

    else if (isAsciiLetter(cp)) {
        this.tempBuff = [];
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.26 Script data escaped end tag open state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE] = function scriptDataEscapedEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.27 Script data escaped end tag name state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE] = function scriptDataEscapedEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.28 Script data double escape start state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE] = function scriptDataDoubleEscapeStartState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_DOUBLE_ESCAPED_STATE : SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }

    else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
    }

    else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
    }

    else
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
};


//12.2.4.29 Script data double escaped state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_STATE] = function scriptDataDoubleEscapedState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._emitCodePoint(cp);
};


//12.2.4.30 Script data double escaped dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE] = function scriptDataDoubleEscapedDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.31 Script data double escaped dash dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE] = function scriptDataDoubleEscapedDashDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this._emitChar('-');

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChar('>');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.32 Script data double escaped less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataDoubleEscapedLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
        this._emitChar('/');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
};


//12.2.4.33 Script data double escape end state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE] = function scriptDataDoubleEscapeEndState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_ESCAPED_STATE : SCRIPT_DATA_DOUBLE_ESCAPED_STATE;

        this._emitCodePoint(cp);
    }

    else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
    }

    else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
    }

    else
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
};


//12.2.4.34 Before attribute name state
//------------------------------------------------------------------
_[BEFORE_ATTRIBUTE_NAME_STATE] = function beforeAttributeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
        this._reconsumeInState(AFTER_ATTRIBUTE_NAME_STATE);

    else if (cp === $.EQUALS_SIGN) {
        this._createAttr('=');
        this.state = ATTRIBUTE_NAME_STATE;
    }

    else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
    }
};


//12.2.4.35 Attribute name state
//------------------------------------------------------------------
_[ATTRIBUTE_NAME_STATE] = function attributeNameState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
        this._leaveAttrName(AFTER_ATTRIBUTE_NAME_STATE);
        this._unconsume();
    }

    else if (cp === $.EQUALS_SIGN)
        this._leaveAttrName(BEFORE_ATTRIBUTE_VALUE_STATE);

    else if (isAsciiUpper(cp))
        this.currentAttr.name += toAsciiLowerChar(cp);

    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN)
        this.currentAttr.name += toChar(cp);

    else if (cp === $.NULL)
        this.currentAttr.name += UNICODE.REPLACEMENT_CHARACTER;

    else
        this.currentAttr.name += toChar(cp);
};


//12.2.4.36 After attribute name state
//------------------------------------------------------------------
_[AFTER_ATTRIBUTE_NAME_STATE] = function afterAttributeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.SOLIDUS)
        this.state = SELF_CLOSING_START_TAG_STATE;

    else if (cp === $.EQUALS_SIGN)
        this.state = BEFORE_ATTRIBUTE_VALUE_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
    }
};


//12.2.4.37 Before attribute value state
//------------------------------------------------------------------
_[BEFORE_ATTRIBUTE_VALUE_STATE] = function beforeAttributeValueState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK)
        this.state = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;

    else if (cp === $.APOSTROPHE)
        this.state = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;

    else
        this._reconsumeInState(ATTRIBUTE_VALUE_UNQUOTED_STATE);
};


//12.2.4.38 Attribute value (double-quoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE] = function attributeValueDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.QUOTATION_MARK;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.39 Attribute value (single-quoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE] = function attributeValueSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.APOSTROPHE;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.40 Attribute value (unquoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_UNQUOTED_STATE] = function attributeValueUnquotedState(cp) {
    if (isWhitespace(cp))
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.GREATER_THAN_SIGN;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN ||
             cp === $.EQUALS_SIGN || cp === $.GRAVE_ACCENT)
        this.currentAttr.value += toChar(cp);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.41 Character reference in attribute value state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE] = function characterReferenceInAttributeValueState(cp) {
    var referencedCodePoints = this._consumeCharacterReference(cp, true);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints) {
            for (var i = 0; i < referencedCodePoints.length; i++)
                this.currentAttr.value += toChar(referencedCodePoints[i]);
        }
        else
            this.currentAttr.value += '&';

        this.state = this.returnState;
    }
};


//12.2.4.42 After attribute value (quoted) state
//------------------------------------------------------------------
_[AFTER_ATTRIBUTE_VALUE_QUOTED_STATE] = function afterAttributeValueQuotedState(cp) {
    if (isWhitespace(cp))
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);

    else if (cp === $.SOLIDUS)
        this._leaveAttrValue(SELF_CLOSING_START_TAG_STATE);

    else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
};


//12.2.4.43 Self-closing start tag state
//------------------------------------------------------------------
_[SELF_CLOSING_START_TAG_STATE] = function selfClosingStartTagState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.selfClosing = true;
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
};


//12.2.4.44 Bogus comment state
//------------------------------------------------------------------
_[BOGUS_COMMENT_STATE] = function bogusCommentState() {
    this._createCommentToken();
    this._reconsumeInState(BOGUS_COMMENT_STATE_CONTINUATION);
};

//HACK: to support streaming and make BOGUS_COMMENT_STATE reentrant we've
//introduced BOGUS_COMMENT_STATE_CONTINUATION state which will not produce
//comment token on each call.
_[BOGUS_COMMENT_STATE_CONTINUATION] = function bogusCommentStateContinuation(cp) {
    while (true) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            break;
        }

        else if (cp === $.EOF) {
            this._reconsumeInState(DATA_STATE);
            break;
        }

        else {
            this.currentToken.data += cp === $.NULL ? UNICODE.REPLACEMENT_CHARACTER : toChar(cp);

            this._hibernationSnapshot();
            cp = this._consume();

            if (this._ensureHibernation())
                return;
        }
    }

    this._emitCurrentToken();
};

//12.2.4.45 Markup declaration open state
//------------------------------------------------------------------
_[MARKUP_DECLARATION_OPEN_STATE] = function markupDeclarationOpenState(cp) {
    var dashDashMatch = this._consumeSubsequentIfMatch($$.DASH_DASH_STRING, cp, true),
        doctypeMatch = !dashDashMatch && this._consumeSubsequentIfMatch($$.DOCTYPE_STRING, cp, false),
        cdataMatch = !dashDashMatch && !doctypeMatch &&
                     this.allowCDATA &&
                     this._consumeSubsequentIfMatch($$.CDATA_START_STRING, cp, true);

    if (!this._ensureHibernation()) {
        if (dashDashMatch) {
            this._createCommentToken();
            this.state = COMMENT_START_STATE;
        }

        else if (doctypeMatch)
            this.state = DOCTYPE_STATE;

        else if (cdataMatch)
            this.state = CDATA_SECTION_STATE;

        else
            this._reconsumeInState(BOGUS_COMMENT_STATE);
    }
};


//12.2.4.46 Comment start state
//------------------------------------------------------------------
_[COMMENT_START_STATE] = function commentStartState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_START_DASH_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.47 Comment start dash state
//------------------------------------------------------------------
_[COMMENT_START_DASH_STATE] = function commentStartDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += '-';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '-';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.48 Comment state
//------------------------------------------------------------------
_[COMMENT_STATE] = function commentState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_DASH_STATE;

    else if (cp === $.NULL)
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.data += toChar(cp);
};


//12.2.4.49 Comment end dash state
//------------------------------------------------------------------
_[COMMENT_END_DASH_STATE] = function commentEndDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += '-';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '-';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.50 Comment end state
//------------------------------------------------------------------
_[COMMENT_END_STATE] = function commentEndState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EXCLAMATION_MARK)
        this.state = COMMENT_END_BANG_STATE;

    else if (cp === $.HYPHEN_MINUS)
        this.currentToken.data += '-';

    else if (cp === $.NULL) {
        this.currentToken.data += '--';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._reconsumeInState(DATA_STATE);
        this._emitCurrentToken();
    }

    else {
        this.currentToken.data += '--';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.51 Comment end bang state
//------------------------------------------------------------------
_[COMMENT_END_BANG_STATE] = function commentEndBangState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.currentToken.data += '--!';
        this.state = COMMENT_END_DASH_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.NULL) {
        this.currentToken.data += '--!';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '--!';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.52 DOCTYPE state
//------------------------------------------------------------------
_[DOCTYPE_STATE] = function doctypeState(cp) {
    if (isWhitespace(cp))
        return;

    else if (cp === $.GREATER_THAN_SIGN) {
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }
    else {
        this._createDoctypeToken('');
        this._reconsumeInState(DOCTYPE_NAME_STATE);
    }
};


//12.2.4.54 DOCTYPE name state
//------------------------------------------------------------------
_[DOCTYPE_NAME_STATE] = function doctypeNameState(cp) {
    if (isWhitespace(cp) || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
        this._reconsumeInState(AFTER_DOCTYPE_NAME_STATE);

    else if (isAsciiUpper(cp))
        this.currentToken.name += toAsciiLowerChar(cp);

    else if (cp === $.NULL)
        this.currentToken.name += UNICODE.REPLACEMENT_CHARACTER;

    else
        this.currentToken.name += toChar(cp);
};


//12.2.4.55 After DOCTYPE name state
//------------------------------------------------------------------
_[AFTER_DOCTYPE_NAME_STATE] = function afterDoctypeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else {
        var publicMatch = this._consumeSubsequentIfMatch($$.PUBLIC_STRING, cp, false),
            systemMatch = !publicMatch && this._consumeSubsequentIfMatch($$.SYSTEM_STRING, cp, false);

        if (!this._ensureHibernation()) {
            if (publicMatch)
                this.state = BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;

            else if (systemMatch)
                this.state = BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

            else {
                this.currentToken.forceQuirks = true;
                this.state = BOGUS_DOCTYPE_STATE;
            }
        }
    }
};


//12.2.4.57 Before DOCTYPE public identifier state
//------------------------------------------------------------------
_[BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE] = function beforeDoctypePublicIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }

    else if (cp === $.APOSTROPHE) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.58 DOCTYPE public identifier (double-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypePublicIdentifierDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;

    else if (cp === $.NULL)
        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.publicId += toChar(cp);
};


//12.2.4.59 DOCTYPE public identifier (single-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypePublicIdentifierSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;

    else if (cp === $.NULL)
        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.publicId += toChar(cp);
};


//12.2.4.61 Between DOCTYPE public and system identifiers state
//------------------------------------------------------------------
_[BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE] = function betweenDoctypePublicAndSystemIdentifiersState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }


    else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.63 Before DOCTYPE system identifier state
//------------------------------------------------------------------
_[BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function beforeDoctypeSystemIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }

    else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.64 DOCTYPE system identifier (double-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypeSystemIdentifierDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.NULL)
        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.systemId += toChar(cp);
};


//12.2.4.65 DOCTYPE system identifier (single-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypeSystemIdentifierSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.NULL)
        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.systemId += toChar(cp);
};


//12.2.4.66 After DOCTYPE system identifier state
//------------------------------------------------------------------
_[AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function afterDoctypeSystemIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.state = BOGUS_DOCTYPE_STATE;
};


//12.2.4.67 Bogus DOCTYPE state
//------------------------------------------------------------------
_[BOGUS_DOCTYPE_STATE] = function bogusDoctypeState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }
};


//12.2.4.68 CDATA section state
//------------------------------------------------------------------
_[CDATA_SECTION_STATE] = function cdataSectionState(cp) {
    while (true) {
        if (cp === $.EOF) {
            this._reconsumeInState(DATA_STATE);
            break;
        }

        else {
            var cdataEndMatch = this._consumeSubsequentIfMatch($$.CDATA_END_STRING, cp, true);

            if (this._ensureHibernation())
                break;

            if (cdataEndMatch) {
                this.state = DATA_STATE;
                break;
            }

            this._emitCodePoint(cp);

            this._hibernationSnapshot();
            cp = this._consume();

            if (this._ensureHibernation())
                break;
        }
    }
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.REPLACEMENT_CHARACTER = '\uFFFD';

exports.CODE_POINTS = {
    EOF: -1,
    NULL: 0x00,
    TABULATION: 0x09,
    CARRIAGE_RETURN: 0x0D,
    LINE_FEED: 0x0A,
    FORM_FEED: 0x0C,
    SPACE: 0x20,
    EXCLAMATION_MARK: 0x21,
    QUOTATION_MARK: 0x22,
    NUMBER_SIGN: 0x23,
    AMPERSAND: 0x26,
    APOSTROPHE: 0x27,
    HYPHEN_MINUS: 0x2D,
    SOLIDUS: 0x2F,
    DIGIT_0: 0x30,
    DIGIT_9: 0x39,
    SEMICOLON: 0x3B,
    LESS_THAN_SIGN: 0x3C,
    EQUALS_SIGN: 0x3D,
    GREATER_THAN_SIGN: 0x3E,
    QUESTION_MARK: 0x3F,
    LATIN_CAPITAL_A: 0x41,
    LATIN_CAPITAL_F: 0x46,
    LATIN_CAPITAL_X: 0x58,
    LATIN_CAPITAL_Z: 0x5A,
    GRAVE_ACCENT: 0x60,
    LATIN_SMALL_A: 0x61,
    LATIN_SMALL_F: 0x66,
    LATIN_SMALL_X: 0x78,
    LATIN_SMALL_Z: 0x7A,
    REPLACEMENT_CHARACTER: 0xFFFD
};

exports.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [0x2D, 0x2D], //--
    DOCTYPE_STRING: [0x44, 0x4F, 0x43, 0x54, 0x59, 0x50, 0x45], //DOCTYPE
    CDATA_START_STRING: [0x5B, 0x43, 0x44, 0x41, 0x54, 0x41, 0x5B], //[CDATA[
    CDATA_END_STRING: [0x5D, 0x5D, 0x3E], //]]>
    SCRIPT_STRING: [0x73, 0x63, 0x72, 0x69, 0x70, 0x74], //script
    PUBLIC_STRING: [0x50, 0x55, 0x42, 0x4C, 0x49, 0x43], //PUBLIC
    SYSTEM_STRING: [0x53, 0x59, 0x53, 0x54, 0x45, 0x4D] //SYSTEM
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = module.exports = function (host) {
    var originalMethods = {},
        overriddenMethods = this._getOverriddenMethods(this, originalMethods);

    Object.keys(overriddenMethods).forEach(function (key) {
        if (typeof overriddenMethods[key] === 'function') {
            originalMethods[key] = host[key];
            host[key] = overriddenMethods[key];
        }
    });
};

Mixin.prototype._getOverriddenMethods = function () {
    throw new Error('Not implemented');
};



/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(788);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(63);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25), __webpack_require__(58)))

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base_64__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function setSrcObject(stream,element,ignoreCreateObjectURL){if('createObjectURL'in URL&&!ignoreCreateObjectURL){try{element.src=URL.createObjectURL(stream);}catch(e){setSrcObject(stream,element,true);}}else if('srcObject'in element){element.srcObject=stream;}else if('mozSrcObject'in element){element.mozSrcObject=stream;}else{alert('createObjectURL/srcObject both are not supported.');}}var SafariWorker=function SafariWorker(){var _this2=this;_classCallCheck(this,SafariWorker);this.WhammyRecorder=function(mediaStream,config){config=config||{};if(!config.frameInterval){config.frameInterval=10;}if(!config.disableLogs){console.log('Using frames-interval:',config.frameInterval);}/**
         * This method records video.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.record();
         */_this2.record=function(){if(!config.width){config.width=320;}if(!config.height){config.height=240;}if(!config.video){config.video={width:config.width,height:config.height};}if(!config.canvas){config.canvas={width:config.width,height:config.height};}canvas.width=config.canvas.width||320;canvas.height=config.canvas.height||240;context=canvas.getContext('2d');// setting defaults
if(config.video&&config.video instanceof HTMLVideoElement){video=config.video.cloneNode();if(config.initCallback){config.initCallback();}}else{video=document.createElement('video');setSrcObject(mediaStream,video);video.onloadedmetadata=function(){// "onloadedmetadata" may NOT work in FF?
if(config.initCallback){config.initCallback();}};video.width=config.video.width;video.height=config.video.height;}video.muted=true;//video.play();
video=config.video;console.log(video);lastTime=new Date().getTime();whammy=new this.Whammy.Video();if(!config.disableLogs){console.log('canvas resolutions',canvas.width,'*',canvas.height);console.log('video width/height',video.width||canvas.width,'*',video.height||canvas.height);}drawFrames(config.frameInterval);};_this2.startRecording=_this2.record;/**
         * Draw and push frames to Whammy
         * @param {integer} frameInterval - set minimum interval (in milliseconds) between each time we push a frame to Whammy
         */function drawFrames(frameInterval){frameInterval=typeof frameInterval!=='undefined'?frameInterval:10;var duration=new Date().getTime()-lastTime;if(!duration){return setTimeout(drawFrames,frameInterval,frameInterval);}if(isPausedRecording){lastTime=new Date().getTime();return setTimeout(drawFrames,100);}// via #206, by Jack i.e. @Seymourr
lastTime=new Date().getTime();if(video.paused){// via: https://github.com/muaz-khan/WebRTC-Experiment/pull/316
// Tweak for Android Chrome
//video.play();
}context.drawImage(video,0,0,canvas.width,canvas.height);whammy.frames.push({duration:duration,image:canvas.toDataURL('image/jpeg')});if(!isStopDrawing){setTimeout(drawFrames,frameInterval,frameInterval);}}function asyncLoop(o){var i=-1,length=o.length;(function loop(){i++;if(i===length){o.callback();return;}// "setTimeout" added by Jim McLeod
setTimeout(function(){o.functionToLoop(loop,i);},1);})();}/**
         * remove black frames from the beginning to the specified frame
         * @param {Array} _frames - array of frames to be checked
         * @param {number} _framesToCheck - number of frame until check will be executed (-1 - will drop all frames until frame not matched will be found)
         * @param {number} _pixTolerance - 0 - very strict (only black pixel color) ; 1 - all
         * @param {number} _frameTolerance - 0 - very strict (only black frame color) ; 1 - all
         * @returns {Array} - array of frames
         */// pull#293 by @volodalexey
function dropBlackFrames(_frames,_framesToCheck,_pixTolerance,_frameTolerance,_callback){var localCanvas=document.createElement('canvas');localCanvas.width=canvas.width;localCanvas.height=canvas.height;var context2d=localCanvas.getContext('2d');var resultFrames=[];var checkUntilNotBlack=_framesToCheck===-1;var endCheckFrame=_framesToCheck&&_framesToCheck>0&&_framesToCheck<=_frames.length?_framesToCheck:_frames.length;var sampleColor={r:0,g:0,b:0};var maxColorDifference=Math.sqrt(Math.pow(255,2)+Math.pow(255,2)+Math.pow(255,2));var pixTolerance=_pixTolerance&&_pixTolerance>=0&&_pixTolerance<=1?_pixTolerance:0;var frameTolerance=_frameTolerance&&_frameTolerance>=0&&_frameTolerance<=1?_frameTolerance:0;var doNotCheckNext=false;asyncLoop({length:endCheckFrame,functionToLoop:function functionToLoop(loop,f){var matchPixCount,endPixCheck,maxPixCount;var finishImage=function finishImage(){if(!doNotCheckNext&&maxPixCount-matchPixCount<=maxPixCount*frameTolerance){// console.log('removed black frame : ' + f + ' ; frame duration ' + _frames[f].duration);
}else{// console.log('frame is passed : ' + f);
if(checkUntilNotBlack){doNotCheckNext=true;}resultFrames.push(_frames[f]);}loop();};if(!doNotCheckNext){var image=new Image();image.onload=function(){context2d.drawImage(image,0,0,canvas.width,canvas.height);var imageData=context2d.getImageData(0,0,canvas.width,canvas.height);matchPixCount=0;endPixCheck=imageData.data.length;maxPixCount=imageData.data.length/4;for(var pix=0;pix<endPixCheck;pix+=4){var currentColor={r:imageData.data[pix],g:imageData.data[pix+1],b:imageData.data[pix+2]};var colorDifference=Math.sqrt(Math.pow(currentColor.r-sampleColor.r,2)+Math.pow(currentColor.g-sampleColor.g,2)+Math.pow(currentColor.b-sampleColor.b,2));// difference in color it is difference in color vectors (r1,g1,b1) <=> (r2,g2,b2)
if(colorDifference<=maxColorDifference*pixTolerance){matchPixCount++;}}finishImage();};image.src=_frames[f].image;}else{finishImage();}},callback:function callback(){resultFrames=resultFrames.concat(_frames.slice(endCheckFrame));if(resultFrames.length<=0){// at least one last frame should be available for next manipulation
// if total duration of all frames will be < 1000 than ffmpeg doesn't work well...
resultFrames.push(_frames[_frames.length-1]);}_callback(resultFrames);}});}var isStopDrawing=false;/**
         * This method stops recording video.
         * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
         */_this2.stop=function(callback){callback=callback||function(){};isStopDrawing=true;var _this=this;whammy.compileSafari(function(blob){_this.blob=blob;if(callback){callback(_this.blob);}});// // analyse of all frames takes some time!
// setTimeout(function () {
//     // e.g. dropBlackFrames(frames, 10, 1, 1) - will cut all 10 frames
//     // e.g. dropBlackFrames(frames, 10, 0.5, 0.5) - will analyse 10 frames
//     // e.g. dropBlackFrames(frames, 10) === dropBlackFrames(frames, 10, 0, 0) - will analyse 10 frames with strict black color
//     dropBlackFrames(whammy.frames, -1, null, null, function (frames) {
//         whammy.frames = frames;
//
//         // to display advertisement images!
//         if (config.advertisement && config.advertisement.length) {
//             whammy.frames = config.advertisement.concat(whammy.frames);
//         }
//
//         /**
//          * @property {Blob} blob - Recorded frames in video/webm blob.
//          * @memberof WhammyRecorder
//          * @example
//          * recorder.stop(function() {
//      *     var blob = recorder.blob;
//      * });
//          */
//
//     });
// }, 10);
};_this2.stopRecording=_this2.stop;var isPausedRecording=false;/**
         * This method pauses the recording process.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.pause();
         */_this2.pause=function(){isPausedRecording=true;};/**
         * This method resumes the recording process.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.resume();
         */_this2.resume=function(){isPausedRecording=false;if(isStopDrawing){this.record();}};/**
         * This method resets currently recorded data.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.clearRecordedData();
         */_this2.clearRecordedData=function(){if(!isStopDrawing){this.stop(clearRecordedDataCB);}clearRecordedDataCB();};function clearRecordedDataCB(){whammy.frames=[];isStopDrawing=true;isPausedRecording=false;}var canvas=document.createElement('canvas');var context=canvas.getContext('2d');var video;var lastTime;var whammy;return _this2;};this.Whammy=function(){// a more abstract-ish API
function WhammyVideo(duration){this.frames=[];this.duration=duration||1;this.quality=0.8;}/**
         * Pass Canvas or Context or image/webp(string) to {@link Whammy} encoder.
         * @method
         * @memberof Whammy
         * @example
         * recorder = new Whammy().Video(0.8, 100);
         * recorder.add(canvas || context || 'image/webp');
         * @param {string} frame - Canvas || Context || image/webp
         * @param {number} duration - Stick a duration (in milliseconds)
         */WhammyVideo.prototype.add=function(frame,duration){if('canvas'in frame){//CanvasRenderingContext2D
frame=frame.canvas;}if('toDataURL'in frame){frame=frame.toDataURL('image/jpeg',this.quality);}if(!/^data:image\/jpeg;base64,/ig.test(frame)){throw'Input must be formatted properly as a base64 encoded DataURI of type image/jpeg';}this.frames.push({image:frame,duration:duration||this.duration});};function processInWebWorker(_function){var blob=URL.createObjectURL(new Blob([_function.toString(),'this.onmessage =  function (e) {'+_function.name+'(e.data);}'],{type:'application/javascript'}));var worker=new Worker(blob);URL.revokeObjectURL(blob);return worker;}function whammyInWebWorker(frames,noWorker){return frames;}/**
         * Encodes frames in WebM container. It uses WebWorkinvoke to invoke 'ArrayToWebM' method.
         * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
         * @method
         * @memberof Whammy
         * @example
         * recorder = new Whammy().Video(0.8, 100);
         * recorder.compile(function(blob) {
     *    // blob.size - blob.type
     * });
         */WhammyVideo.prototype.compileSafari=function(callback){callback(whammyInWebWorker(this.frames,true));};WhammyVideo.prototype.compile=function(callback){var webWorker=processInWebWorker(whammyInWebWorker);webWorker.onmessage=function(event){if(event.data.error){console.error(event.data.error);return;}callback(event.data);};webWorker.postMessage(this.frames);};return{/**
             * A more abstract-ish API.
             * @method
             * @memberof Whammy
             * @example
             * recorder = new Whammy().Video(0.8, 100);
             * @param {?number} speed - 0.8
             * @param {?number} quality - 100
             */Video:WhammyVideo};}();this.WhammyRecorder.bind(this);}// https://github.com/antimatter15/whammy/blob/master/LICENSE
// _________
// Whammy.js
// todo: Firefox now supports webp for webm containers!
// their MediaRecorder implementation works well!
// should we provide an option to record via Whammy.js or MediaRecorder API is a better solution?
/**
     * Whammy is a standalone class used by {@link RecordRTC} to bring video recording in Chrome. It is written by {@link https://github.com/antimatter15|antimatter15}
     * @summary A real time javascript webm encoder based on a canvas hack.
     * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
     * @author {@link http://www.MuazKhan.com|Muaz Khan}
     * @typedef Whammy
     * @class
     * @example
     * var recorder = new Whammy().Video(15);
     * recorder.add(context || canvas || dataURL);
     * var output = recorder.compile();
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     */;/* harmony default export */ __webpack_exports__["a"] = (SafariWorker);

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var IIISideInfo = __webpack_require__(809);
var ScaleFac = __webpack_require__(364);
var NsPsy = __webpack_require__(810);
var VBRSeekInfo = __webpack_require__(811);
var III_psy_xmin = __webpack_require__(362);
var Encoder = __webpack_require__(35);
var L3Side = __webpack_require__(149);


LameInternalFlags.MFSIZE = (3 * 1152 + Encoder.ENCDELAY - Encoder.MDCTDELAY);
LameInternalFlags.MAX_HEADER_BUF = 256;
LameInternalFlags.MAX_BITS_PER_CHANNEL = 4095;
LameInternalFlags.MAX_BITS_PER_GRANULE = 7680;
LameInternalFlags.BPC = 320;

function LameInternalFlags() {
    var MAX_HEADER_LEN = 40;


    /********************************************************************
     * internal variables NOT set by calling program, and should not be *
     * modified by the calling program *
     ********************************************************************/

    /**
     * Some remarks to the Class_ID field: The Class ID is an Identifier for a
     * pointer to this struct. It is very unlikely that a pointer to
     * lame_global_flags has the same 32 bits in it's structure (large and other
     * special properties, for instance prime).
     *
     * To test that the structure is right and initialized, use: if ( gfc .
     * Class_ID == LAME_ID ) ... Other remark: If you set a flag to 0 for uninit
     * data and 1 for init data, the right test should be "if (flag == 1)" and
     * NOT "if (flag)". Unintended modification of this element will be
     * otherwise misinterpreted as an init.
     */
    this.Class_ID = 0;

    this.lame_encode_frame_init = 0;
    this.iteration_init_init = 0;
    this.fill_buffer_resample_init = 0;

    //public float mfbuf[][] = new float[2][MFSIZE];
    this.mfbuf = new_float_n([2, LameInternalFlags.MFSIZE]);

    /**
     * granules per frame
     */
    this.mode_gr = 0;
    /**
     * number of channels in the input data stream (PCM or decoded PCM)
     */
    this.channels_in = 0;
    /**
     * number of channels in the output data stream (not used for decoding)
     */
    this.channels_out = 0;
    /**
     * input_samp_rate/output_samp_rate
     */
        //public double resample_ratio;
    this.resample_ratio = 0.;

    this.mf_samples_to_encode = 0;
    this.mf_size = 0;
    /**
     * min bitrate index
     */
    this.VBR_min_bitrate = 0;
    /**
     * max bitrate index
     */
    this.VBR_max_bitrate = 0;
    this.bitrate_index = 0;
    this.samplerate_index = 0;
    this.mode_ext = 0;

    /* lowpass and highpass filter control */
    /**
     * normalized frequency bounds of passband
     */
    this.lowpass1 = 0.;
    this.lowpass2 = 0.;
    /**
     * normalized frequency bounds of passband
     */
    this.highpass1 = 0.;
    this.highpass2 = 0.;

    /**
     * 0 = none 1 = ISO AAC model 2 = allow scalefac_select=1
     */
    this.noise_shaping = 0;

    /**
     * 0 = ISO model: amplify all distorted bands<BR>
     * 1 = amplify within 50% of max (on db scale)<BR>
     * 2 = amplify only most distorted band<BR>
     * 3 = method 1 and refine with method 2<BR>
     */
    this.noise_shaping_amp = 0;
    /**
     * 0 = no substep<BR>
     * 1 = use substep shaping at last step(VBR only)<BR>
     * (not implemented yet)<BR>
     * 2 = use substep inside loop<BR>
     * 3 = use substep inside loop and last step<BR>
     */
    this.substep_shaping = 0;

    /**
     * 1 = gpsycho. 0 = none
     */
    this.psymodel = 0;
    /**
     * 0 = stop at over=0, all scalefacs amplified or<BR>
     * a scalefac has reached max value<BR>
     * 1 = stop when all scalefacs amplified or a scalefac has reached max value<BR>
     * 2 = stop when all scalefacs amplified
     */
    this.noise_shaping_stop = 0;

    /**
     * 0 = no, 1 = yes
     */
    this.subblock_gain = 0;
    /**
     * 0 = no. 1=outside loop 2=inside loop(slow)
     */
    this.use_best_huffman = 0;

    /**
     * 0 = stop early after 0 distortion found. 1 = full search
     */
    this.full_outer_loop = 0;

    //public IIISideInfo l3_side = new IIISideInfo();
    this.l3_side = new IIISideInfo();
    this.ms_ratio = new_float(2);

    /* used for padding */
    /**
     * padding for the current frame?
     */
    this.padding = 0;
    this.frac_SpF = 0;
    this.slot_lag = 0;

    /**
     * optional ID3 tags
     */
        //public ID3TagSpec tag_spec;
    this.tag_spec = null;
    this.nMusicCRC = 0;

    /* variables used by Quantize */
    //public int OldValue[] = new int[2];
    this.OldValue = new_int(2);
    //public int CurrentStep[] = new int[2];
    this.CurrentStep = new_int(2);

    this.masking_lower = 0.;
    //public int bv_scf[] = new int[576];
    this.bv_scf = new_int(576);
    //public int pseudohalf[] = new int[L3Side.SFBMAX];
    this.pseudohalf = new_int(L3Side.SFBMAX);

    /**
     * will be set in lame_init_params
     */
    this.sfb21_extra = false;

    /* BPC = maximum number of filter convolution windows to precompute */
    //public float[][] inbuf_old = new float[2][];
    this.inbuf_old = new Array(2);
    //public float[][] blackfilt = new float[2 * BPC + 1][];
    this.blackfilt = new Array(2 * LameInternalFlags.BPC + 1);
    //public double itime[] = new double[2];
    this.itime = new_double(2);
    this.sideinfo_len = 0;

    /* variables for newmdct.c */
    //public float sb_sample[][][][] = new float[2][2][18][Encoder.SBLIMIT];
    this.sb_sample = new_float_n([2, 2, 18, Encoder.SBLIMIT]);
    this.amp_filter = new_float(32);

    /* variables for BitStream */

    /**
     * <PRE>
     * mpeg1: buffer=511 bytes  smallest frame: 96-38(sideinfo)=58
     * max number of frames in reservoir:  8
     * mpeg2: buffer=255 bytes.  smallest frame: 24-23bytes=1
     * with VBR, if you are encoding all silence, it is possible to
     * have 8kbs/24khz frames with 1byte of data each, which means we need
     * to buffer up to 255 headers!
     * </PRE>
     */
    /**
     * also, max_header_buf has to be a power of two
     */
    /**
     * max size of header is 38
     */

    function Header() {
        this.write_timing = 0;
        this.ptr = 0;
        //public byte buf[] = new byte[MAX_HEADER_LEN];
        this.buf = new_byte(MAX_HEADER_LEN);
    }

    this.header = new Array(LameInternalFlags.MAX_HEADER_BUF);

    this.h_ptr = 0;
    this.w_ptr = 0;
    this.ancillary_flag = 0;

    /* variables for Reservoir */
    /**
     * in bits
     */
    this.ResvSize = 0;
    /**
     * in bits
     */
    this.ResvMax = 0;

    //public ScaleFac scalefac_band = new ScaleFac();
    this.scalefac_band = new ScaleFac();

    /* daa from PsyModel */
    /* The static variables "r", "phi_sav", "new", "old" and "oldest" have */
    /* to be remembered for the unpredictability measure. For "r" and */
    /* "phi_sav", the first index from the left is the channel select and */
    /* the second index is the "age" of the data. */
    this.minval_l = new_float(Encoder.CBANDS);
    this.minval_s = new_float(Encoder.CBANDS);
    this.nb_1 = new_float_n([4, Encoder.CBANDS]);
    this.nb_2 = new_float_n([4, Encoder.CBANDS]);
    this.nb_s1 = new_float_n([4, Encoder.CBANDS]);
    this.nb_s2 = new_float_n([4, Encoder.CBANDS]);
    this.s3_ss = null;
    this.s3_ll = null;
    this.decay = 0.;

    //public III_psy_xmin[] thm = new III_psy_xmin[4];
    //public III_psy_xmin[] en = new III_psy_xmin[4];
    this.thm = new Array(4);
    this.en = new Array(4);

    /**
     * fft and energy calculation
     */
    this.tot_ener = new_float(4);

    /* loudness calculation (for adaptive threshold of hearing) */
    /**
     * loudness^2 approx. per granule and channel
     */
    this.loudness_sq = new_float_n([2, 2]);
    /**
     * account for granule delay of L3psycho_anal
     */
    this.loudness_sq_save = new_float(2);

    /**
     * Scale Factor Bands
     */
    this.mld_l = new_float(Encoder.SBMAX_l);
    this.mld_s = new_float(Encoder.SBMAX_s);
    this.bm_l = new_int(Encoder.SBMAX_l);
    this.bo_l = new_int(Encoder.SBMAX_l);
    this.bm_s = new_int(Encoder.SBMAX_s);
    this.bo_s = new_int(Encoder.SBMAX_s);
    this.npart_l = 0;
    this.npart_s = 0;

    this.s3ind = new_int_n([Encoder.CBANDS, 2]);
    this.s3ind_s = new_int_n([Encoder.CBANDS, 2]);

    this.numlines_s = new_int(Encoder.CBANDS);
    this.numlines_l = new_int(Encoder.CBANDS);
    this.rnumlines_l = new_float(Encoder.CBANDS);
    this.mld_cb_l = new_float(Encoder.CBANDS);
    this.mld_cb_s = new_float(Encoder.CBANDS);
    this.numlines_s_num1 = 0;
    this.numlines_l_num1 = 0;

    /* ratios */
    this.pe = new_float(4);
    this.ms_ratio_s_old = 0.;
    this.ms_ratio_l_old = 0.;
    this.ms_ener_ratio_old = 0.;

    /**
     * block type
     */
    this.blocktype_old = new_int(2);

    /**
     * variables used for --nspsytune
     */
    this.nsPsy = new NsPsy();

    /**
     * used for Xing VBR header
     */
    this.VBR_seek_table = new VBRSeekInfo();

    /**
     * all ATH related stuff
     */
        //public ATH ATH;
    this.ATH = null;

    this.PSY = null;

    this.nogap_total = 0;
    this.nogap_current = 0;

    /* ReplayGain */
    this.decode_on_the_fly = true;
    this.findReplayGain = true;
    this.findPeakSample = true;
    this.PeakSample = 0.;
    this.RadioGain = 0;
    this.AudiophileGain = 0;
    //public ReplayGain rgdata;
    this.rgdata = null;

    /**
     * gain change required for preventing clipping
     */
    this.noclipGainChange = 0;
    /**
     * user-specified scale factor required for preventing clipping
     */
    this.noclipScale = 0.;

    /* simple statistics */
    this.bitrate_stereoMode_Hist = new_int_n([16, 4 + 1]);
    /**
     * norm/start/short/stop/mixed(short)/sum
     */
    this.bitrate_blockType_Hist = new_int_n([16, 4 + 1 + 1]);

    //public PlottingData pinfo;
    //public MPGLib.mpstr_tag hip;
    this.pinfo = null;
    this.hip = null;

    this.in_buffer_nsamples = 0;
    //public float[] in_buffer_0;
    //public float[] in_buffer_1;
    this.in_buffer_0 = null;
    this.in_buffer_1 = null;

    //public IIterationLoop iteration_loop;
    this.iteration_loop = null;

    for (var i = 0; i < this.en.length; i++) {
        this.en[i] = new III_psy_xmin();
    }
    for (var i = 0; i < this.thm.length; i++) {
        this.thm[i] = new III_psy_xmin();
    }
    for (var i = 0; i < this.header.length; i++) {
        this.header[i] = new Header();
    }

}

module.exports = LameInternalFlags;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Encoder = __webpack_require__(35);

var L3Side = {};


	/**
	 * max scalefactor band, max(SBMAX_l, SBMAX_s*3, (SBMAX_s-3)*3+8)
	 */
L3Side.SFBMAX = (Encoder.SBMAX_s * 3);

module.exports = L3Side;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rec.52bb94b8.gif";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(212);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(213);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(155);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(443);

var iterableToArrayLimit = __webpack_require__(444);

var unsupportedIterableToArray = __webpack_require__(224);

var nonIterableRest = __webpack_require__(445);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(473);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(81);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(166)('keys');
var uid = __webpack_require__(116);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 168 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(163);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(477);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(488);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(80);
var dPs = __webpack_require__(481);
var enumBugKeys = __webpack_require__(167);
var IE_PROTO = __webpack_require__(165)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(233)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(482).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(71).f;
var has = __webpack_require__(72);
var TAG = __webpack_require__(49)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(49);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var core = __webpack_require__(48);
var LIBRARY = __webpack_require__(171);
var wksExt = __webpack_require__(174);
var defineProperty = __webpack_require__(71).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var defaultProps = {
  label: 'Close'
};

var CloseButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CloseButton, _React$Component);

  function CloseButton() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CloseButton);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CloseButton.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        onClick = _props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'button',
      { type: 'button', className: 'close', onClick: onClick },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      )
    );
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);













var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};

var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonGroup, _React$Component);

  function ButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        block = _props.block,
        justified = _props.justified,
        vertical = _props.vertical,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['block', 'justified', 'vertical', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps)] = !vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'vertical')] = vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('btn-group', ButtonGroup));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(61));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

var Glyphicon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Glyphicon, _React$Component);

  function Glyphicon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Glyphicon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Glyphicon.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        glyph = _props.glyph,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['glyph', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Glyphicon.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('glyphicon', Glyphicon));

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(26);






var _collapseStyles;










var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem['offset' + Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];

  return value + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[0]), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__["EXITED"]] = 'collapse', _collapseStyles[__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__["EXITING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__["ENTERING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__["ENTERED"]] = 'collapse in', _collapseStyles);

var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,

  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Collapse, _React$Component);

  function Collapse() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    }, _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();
      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    }, _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    }, _this.handleExit = function (elem) {
      var dimension = _this.getDimension();
      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + 'px';
      triggerBrowserReflow(elem);
    }, _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Collapse.prototype.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  };

  // for testing


  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem['scroll' + Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)] + 'px';
  };

  /* -- Expanding -- */


  /* -- Collapsing -- */


  Collapse.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className', 'children']);

    delete props.dimension;
    delete props.getDimensionValue;

    var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition___default.a,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        'aria-expanded': props.role ? props.in : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting
      }),
      function (state, innerProps) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, innerProps, {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
        }));
      }
    );
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(61));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(61));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(601);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);








var TAB = 'tab';
var PANE = 'pane';

var idPropType = __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]);

var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },


  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var TabContainer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TabContainer, _React$Component);

  function TabContainer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TabContainer);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  TabContainer.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        onSelect = _props.onSelect,
        generateChildId = _props.generateChildId,
        id = _props.id;


    var getId = generateChildId || function (key, type) {
      return id ? id + '-' + type + '-' + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  TabContainer.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children']);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(TabContainer, { activeKey: 'onSelect' }));

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
  })
};

var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
    _this.handlePaneExited = _this.handlePaneExited.bind(_this);

    // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.
    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  TabContent.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit;


    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();

    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;

    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({ activeKey: null, activeChild: null });
    }
  };

  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    }

    // It's possible that this child should be transitioning out.
    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });

    return true;
  };

  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  TabContent.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        className = _props2.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'className']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('tab', TabContent));

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rotate_device_fff_bg.34cca163.png";

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiYmI1NDk1Ni03ZWIxLTRkYjMtYTIzOC01ZTcyMWMzMTU3MWYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDY4MTY4OEU0NEQ0MTFFODhGNTdFRDJGQzUzNzVEOUIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDY4MTY4OEQ0NEQ0MTFFODhGNTdFRDJGQzUzNzVEOUIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyOWJjOGY4Zi0yMzc1LTRhNjAtOGY3MC0yNjk5MWFjOTNlOGQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6YmJiNTQ5NTYtN2ViMS00ZGIzLWEyMzgtNWU3MjFjMzE1NzFmIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+SnHStQAAFz1JREFUeNrsXQnYFcWVrZ8BR8eIcUnchbgFjRE17gvBRI0BVMSIEUZFQ4Q4TgY1ElFRcUGjo0wc5QNcMHGJgiA64IIGDREUFMeICzFqwCWLEnAJSlgk96QvM0/8eV1dVd1d/d4533e/Rv/uetVVdbqqbt2lZdWqVYYgiNbRhk1AECQIQZAgBEGCEAQJQhAkCEGQIARBghAECUIQJAhBECQIQZAgBEGCEAQJQhAkCEGQIARBghAECUIQJAhBkCAEQZAgBEGCEAQJQhAkCEGQIARBghAECUIQJAhBkCAEQZAgBEGCEAQJQhAkCEGQIARBghAECUIQJAhBkCAE0cRoG0tFWlpamrIDtu/QsZ1c/kn7oq1+tFr0/wGfrCErRVaILH9twfxPGr19yk5T3hJLnvRGJoiQ4Aty2U3kKyI7iewssq3KOh5FfyyyQOR1ld+KzBV5XsizmAQhQWIkw+fksp/KPiJ7imxVQlXmizwpMlPk10qaVSQICVI0ITaUS1eRQ0S+rjNFjHu7d0SmikwRmSxk+SsJQoLkQQhU9Gsi3US+rbNE1ZQdy5Qsd4jcK2T5GwlCgvgSY2+5fFfkOJFtGmiL9J7InSI3CFFeIkFIkCyk2EQuJ4ucqhvsRscjItcKUR4iQUiQesT4qlwGifQRWdc0H2aJXCpEmUKCkCC1xIDm6VyRow0BzBA5W4gyiwRpYoIIMXaVyxUiPciJVvELkbOEKH8iQZqIIEKMTZUY2GPQ7KY+3tfZdXSR5ykkSAkEUVXtAJHhIhvl9DNQnb4s8qLIGypviiwUWaoDDlfU5Q8VIso0kX5CkjdJkAYkiJDjS3K5xSSHe6EAm6g5IrNNcnKNf78qg2ilRX1ghvJOwc0NM5T1PBQQIPdAeb+7SJAGIogMxu/LZYTI+gGKw9d/kshEkUddbZ+kTjvKZV4JS7xfiTxvkrOdLziWMVLkTHn3ZSRIhQmi5iCjRY4PUBwMAv9L5E4ZGB8Eqh++5J1Mctayi16hONhOl2B57ivOEYFF8VCRzR3KwKzZU9rijyRIBQkig6+Tfum/7FnUcyLDRO4rapMqdf8XJcyuNbKXyCaBf2qcyFkmsRK4wKF87EeOknZ5jgSpEEFkgMFWCirKDT2Kma/am3GxWMPKe4HsB5jEQLJHIEUDFAV9dP/0Q5HBGdttiUgvaaOpJEgFCCKDCKrbMeb/HY+yAlooaLmukk5faiKFvCfer4tIb5G+Iht4Khswg1yps8hlIqdlWOYtRx2kvcaTIBETRAYNvvhXeG5g+0tHv2oqBHnv9XXT/e8inT2KelAH+mIpEzPVbbofsiXZSfLsHSRIhASRDsVX73yPWQPkuq7K7qx6zgNzmYtEdncs5hWUIe0wT8rDrATV+HcykKRvCDUwCRKQIJ7keFq/fPNMg0CJcoIuFTs4FAEtV2/sK7QsLL8uybDcOkKenUaCREAQ6cCz5fKfjo9DbTtYOnO5aUCoGvkMHeBZFRaf6HJzbM3e7kZjd26zSGRPeXYBCVIiQaTT+sllrMOjOMc4VTpwgmkCqO3ZxSIDHZQX50s7Dddy+ui+xIYkz4gc7KroIEE8CSKd1dUk7qPtMj6KKCDdpON+a5oMejaE2bZ7xkd/apKT81VSBjRmP7ckCQwcB5IgBRNEOmkHk5zkZj0HgH/DkdJp75omhrTfYTrod87w2CiR05UkMN0ZY/lcDxcHrLLHZ5sKdy5OmSc6kGOyyDeanRyAtAFcbHdXxYbtEggzwUhs2uX5G3XJZoOb1YW5UqiyDwS+ZF/N+AxMKo6Vjv3IEKtJskz3Fp11NrYlydX670t0P5KGzUSuJ0GKmT1OlMuJGR9D5I4+eVqeVpwoOPc4UGcEmzOgs3Egq+Y3/U0SnC4N35VnjqpSu1RuDyINjBNdGMVlMam4B51j459B/J8NGz4on7e4HVrAsbp8QiTHHVPuh83XLvLM+9yDhO84sOiWjOR41CSnuiSH/WwCUxPYd9mYsI+GJlGe+Yv8u6dJjBbrYUuT2HpxiZUDTjFJeE9bQAffk8sqJ5LMVZK8nXIr1OsT4PilgedOtSh+gNy/F5dYAZdY0qDt5fI7kS9aFgkf8H2k0/4ccAaD5gy+7KOk3I+bZLkFRcjjIhun3PqStvcSeQab8X9LuR8Kgf3TbN64xLLH4Azk+FCke0hyKHqJXCvyKkxbNJJ7lQb7HiK9RKw9B3UmOcYktlX1AMeuMTV9lWYJvY+DooUzyFo6FiYS842dLzleCN5tk3MYYNDUHFTzv7Du/pH81q2REwMbaNRxddwv7BNgSPhEhjJsDwUHSLlj5P79TRJ4rt7S4DWRTnL/Cs4gfhhi7AMtDMuJHJ3XIAeAgQcNzpkRk6OjSSKt1AbFQ1vekHFPgkNBGx+PEfB4lPuftCDU9iZREXOT7tHBW8jldMvbHzD25thZUW/zea3U8/gI266zkmOnVv68m/x9+4xFDtS9Rj1gn3a7lI10cjihT4v2cq7eS4I44sfGLn4TAgecmKPf+KEpf79NOvqQiMgBbd90kS3q3LZvxlkESXfgsZimFYSGarCqfoem3As/laNJELdO3tZy9sAZBw4CF+VYnY4pf4e6c5J+tctuN3j+wcK5vcVANhlJMtdi0AMXqtXwjfrxqof/IEHccLmxM2O/UDpuZs51sUm2iQH5gAyMrUskxw/kcrdlfV1DIV2jS7d6+GeTmLljthmecu/BMXxYKkUQqCRNEqUjDdAs/aSAKtkGRsNJ8f16ZlJ0m+HLPjJDv+7g8jtqldDPJFl266GL1AlLMlg/pMUfPokEyT57pBlofaD7jiLMSGZnuBfkvlVNY4ogRovICAcFxWauvyltjkPbCy1nG6wCRqXc10dDGJEgFh2OANNHWNx6pY+/c0ZMzHg/ohReVEBbYVDB3XiQw+Mbev78CIsPB2ZURG0cnbK539xCEUKCKI6xmD2gUbmhwDpNNNnTFFyUp/pXysY+Az4uJ5fRSTpzD1AlST3gZB3axUkW/U6CWMAm09PdoYJHWw6GpZZLijVxiwzk3XIgB1TfMOPv5VHMigDtAteD/065DSY5OBO5PeW+7iRIesejMQ+yuPXmEqqHzeb0jM9gs36vvNdGAdsIZeJQ9EjPouYGqhI+HGl2b5hpEPd3YZ17tpZ3250EqY+9Tbpq9001ZSh6SYFlwr+aJLd4FsDJC6fLbQKQA/uGh00SuNoXNwZqFxiHDku5DTMegmLfn3LfESRIOkHSML6symnqMRf7oW6OS7RacsDDb6rlDJuGecYtllg9sr2Scs/pFjNwVxLEnyCl5u/WQHMuCgKcLvdwJAeyQOHMZ58Ar4Av/gkho9arRW6apyA8QWFaUk+bdUBM6t4YCZJ2oorDqZkR1BOhTrMmjIFm7jaN55WFHDiZf9wkCXR8Ae1fzzyS3ZjE2jdtLwKjz1kpJNqDBGl9IKxj0sPsPxlDvg6pAyLB99YBlwVYJk3UVAVZyLFLgGrDePBQ34DSddoEM8PIlNswg6Q5mu1LgrQOmGWnTa+zYqmsniZ/3+FRuLGOsSAHZpqnTOI34Quc4Rwidc67/WxiZHVK+TtnkLVgR4t7no6pwpoDY4zDozCtGFSHHLvqzLFViGqKfF0tcfNuj9+bJPxPPaxHgrhhG4t7Xohw3zTIsV5XCxG6tEIOzDCPBSIH6tW14GxZvtmldpU2aEeCfBbbpvwd6/7XY2OHRjiB7dWSjI/Ck26cek2uJgfW31CFbhqgarN1WfVWwU3im04Ce9EdSJDsM8j8WAPAaWYqlxD/mylJ2onsZ5Jzjs8HqNJjuiFfWEJb/Eku/xtgP0qCtKLhqIc3TMSQgQFbo585PIqDP9hVQbvUPkBV7hX5tp5wl4UHCtiPcgZZA2+Z+IGAaS85PHeUxebVBrAXO07V0GXiYc/nv0yCfBZpAc0Wxs4ORBY0yflIGSkW4FnZP5JlKPY/PjkfO5AgNVDvu7T6LDIVgAzQF03xgQgQwO7cHKO6ZG0DzGA+p/VbkyDZ67LEVAQyQG4y/upOGyC27Snye9dE2AyzPZ79IgmSHR9WrL7QauWZJBTq5WMiDn3qo8nahAT57JewoVATaC2PDTO8KRFf9/6Im8DrcLKooBeVIEgsa+cc3gvr8EGBi4XFbBcpe3rkr/9q1cdnG0MUQRKEvLknVHEiB0mZv6nAeyP5jo/lNWeQVpYN9bBuFQmi/uidAhQFY8ODC7ar8sVij2dXkSCfRpqWqn0FyQHfh4eMv7MTvsSHCzn+WLEmWGwqjNgIknbOsWnFyIH4tNhEh3CTxex5fQwbVxIkXoJsUyFywPELQaRDpkQ41iShPKuEFSRIOKRFLvxShdoWwdTyyHtxppDvfNMc4B5kDaTlkehUhV6VAXyuXH6Q409cpmkOSJAmI0iaOfuGGtg6ZnIgvuwVBfzUyIqQZAPH55bHcDYWG0Fes7hn34jJgZBFtxX4k1UgyRY57UebkiAvW9zzjUjJAeO6+4x9Nt6QJPlRxARx1TwuIEFab5S0k9fDIyQHfKjhh12WDwOCP1wamwpYPxrtSJBQ66sF82GwmBYdpIM0/Nci4wiCpfnEy4UpyqWedbhA5KbIsjT5BLt7gwRpHXMs7ukT0VcSjlHf8yjiTpO46SIb1b2e1UFYzylSp1gsDr6S836UBFkLTtZT6rLJcZhcrvUoAnuWkzBzqsYGiSx9g7t9S+QJqVvHihPkBRKkddh4ocGZpm/J5EBQgXEebYjwPr1r/cfVfwTBG/7iWT0EnpsjdfxmyX25v8ezc2MYjC2rVsXhhtHS0rJ64GENDRVf2jIBU/BOum8pmhztlciukTeQxgDOTh+tpXzsZ35p7HKd1wPaZgg28UWfKWiin0WOH5C3pL7/MCsqe3xGN4PoF/UJmz4wSfSQoskBJt/uQQ7EFj5ybeTQNsD7nxKofxHp5C7baPKBZw/X8TU7lvEYq8OUrafceSWoNrGZds0NiHV1dyHA+xYfCmzeLwxUZ3xInirYCsEnpfMMEqQ+Hsmw1j66qEqpGYlr7nMsCeHP8W6G2RSq31DJSuGPMkPeoSh7tqNJkPyAaBjvWN47XDq9bQHkgE7/546Pw/X0UEdnJ2SH/Z9ArwGzj4c1nVuebQXtlWvwaSw9nyVB6n85sTOzDV25s3FLqpmlwxFMepJJz4zUGhAN8lvyTvM99mSIjBIqqy8i6I/MuQt99oaPyDsvJ0HSMTnDvcNkEG+QEzna6KbcJZjyh7rneNHzg/GR7ntCxdj6jrzXoTm1V1vPD9aDMQ3CmAmC6OC28aRg8zMkp3pchkHu8Bzy9SFZZhCNjJSDs5HDdLkWAnmFRsU5zpYez0+JaRBGdw6yxtcIa2/btMkgU2cZSMEiGcrvd884k60Gzh+OlbpMyuELvZNuYn3981HHjW00ahnqhk5ETkVXH/xnpD6fSgPOc5D6yGKbBNOTMaHUvnrQdYvj4wPyIIfOJK+YxOR/YYC+3ztw9Y4xfgEq7oxtAMZOkAkmW9hO5Ps7LdBvDzFuAZQv0cDVeSox5gYiScfAe4/LPYrAVHE3CZJtIGD6z6rivEo6ayvPzoa26gyHR28VubigtgFJvulJks8FrBJO/n3OWKbJO/2BBMmOrCkEYCc1ynOp1c1k9wx8XJdWqwr8gDwvlwM9Nu5/DTR7wGZsqGcxo2McfFUgCLRZ72Z8Bht7H1/tLhnvx76glwzYZSXMsvjtA4yb9ev8QNXoZ/xiliHp5yQSxG0ALNOlS1Zco/nGXbBdhnuhfu0h9VxcYhvB+w4WwA9lXPP7ZqI1ms98sGcxY2I6HKzaDAKMMtljJCFU53jdT2SFrZn56rOO30XwIflAZ87hlo88q2crvjjTJJbVrliq/WtIEPfOf90kDkZZAZP0mx32I7abxVPUND2WdlopgqiL3S027xMCzB5Q6V7iWcx1MQfkrlJ+ENeYtL0dlgA2br9D1SQ9xg8K9m0wrrxvLbe857spFnIgIzHOqXxcn7G3vDLmQVclgjxq3N0wYfHbI8P9cKWttyb+mQzCyyKfdd8V6Sn/PN58OgAC7MP6yt8WeZBjHSXHlp7VPK/MvVtDEUTVp1d7vCe86va0/C1M+Ws7Rce5zGkVajeQHeYpCJUE9XUHnWFcydGibbOfZ9WeMu6WCoUhalusVjoHp7XzPDaFGPgHygD5vcVvwSwcmZxWBz5DGH+4r14sz1c6pL/n0grxt3xjeKH99pB2TI1cQlusbF/DFZ6dA4ehR2wchlR1Olb/c5bInvL/LmhycvQNQA7gShtycInlBgSHftmnn0WmSWdvbHEvlnTn6awz1zQxpL0Oqflg+AAHm5dX5b0rtcSq6Sz4HNzn+ZPw0zg8pLl3A5MDLrQzTZgckV2lzX9lezOXWG5LLeT9+6VnMdDhT5XO35QUqEsOGH4+GIgcN2UhB5dYfjhLZGUAkjymUciJz5IDPjHw8AuRGxKHr+dUrQ0qSxC1ZP1pgKIQDmemDIbtSIlPkQNnHfeIdA5U5GnSZ++RIMUCgdVC5JHAxn1GhGkVyiLH+kqOUIEdsLSaUsW2qDRBpNGXyGVgoOJgOjFdFQDNTI6OJvF5PzJQkUjMenZV26OSWqxWOvUGuZweqCoIZgCDv5/EkESyYHJsbZIT7q0CFouYYFNdH6YWKwyw+ZsXsE2QpfYXjqbyVSXHeiaxrwpJjpt8yMElVrilFgKrIfrg0oDFwsjvGQ+nqyqRAyknbhXZK2CxlV5aNdoMApL8JuB+ZDXgTzJLBlC/BicHYg6HTiXRX524Ko2G2IPkuB+pxV0iZwTywouFHBvJZbxJoqOEAsKsDpN2Gh+iMO5BwmOQSXxHQgNLuOdlUHVrEHIgGsqcwORAux8YihycQXKYQbTzcQIM26Fdcqou/BjO8XE6KpEYMBkZJvLDwB9IGDIODB3Zpezx2ZAE0YEAlSUyVeWVVQlLLbjyjq2COlij1GMvBXP1LQMXPzQvD0sSJCeC6KBAEpfHTVjV5ZqYqbPJzIiJgQ04rA52Dlw83JIRuOKOvOpPguRIkAJJAsDCeIgMlpeagBgAfMkR8mh6nu9BguRMkBqSIGNV3gaJaEyE07lKBs7TJRGjrRLjgpyIAcBluZu847y834cEKYAgOnBg0o5gBUUZJMLv4TqRyUWEJFUDw1NNcjjXIcefgvvxUfJO7xTRiCRIQQSpGURIp9azwFdbqL8JeTb0hl4dvqCRwtnPJjm/Cyx8T66X450EqTBBdEC16PIDqs6ic6y/ZZKwQTD9nuHjH6GZpnDmg7QD6+Zcb8TSOivvvCckSAQEqRlgyPcHE4vNS3plNDxOnaH9ek7//UK9sxV1f0XinBNN4qtRRKMhZ31/jfJiSJAmIUjNvmSM8Ut6Hxo4X4GhH7REsGVCXC5EYOlYMJlRB1hJjyvznIcEKZEgNUQ5Ti7XG7eUa40G7C8QIO9qIcbHZVeGBImAIEoSmKdcbJLUa22bkBhL9CMxQojx51gqRYJEQpAaouxoEnOM3iVs4ssAIqyPBDmEGAtjqxwJEhlBaoiCaCc/NokVbyPOKNNMkgJhUhmp40iQihOkhiiICYVo7t8zSWzfqgId/aTIRJEJQor5lag0CRI3QWqIglnkcJETRBD5pH0Fxhcyc/3aJLZoU2NMs0yCNAhB1iALsiodbJJ8GziXgN96mc5nUAnjEBIBtv9xniIyRwjxtqk4SJAKEqQVwkADtr/I7iowEkQwuvUdi8SXHrlJXtN/Y6B/rPI3k2icoI5F+uS3hQhLTYOCBGkAgqQsy9rpJh/SojMN5BMVdMBKFWyWVzRbPC4ShCAqijZsAoIgQQiCBCEIEoQgSBCCIEEIggQhCBKEIEgQgiBBCIIgQQiCBCEIEoQgSBCCIEEIggQhCBKEIEgQgiBBCIIEIQiCBCEIEoQgSBCCIEEIggQhCBKEIEgQgiBBCKLJ8HcBBgCqOhBouKbNJgAAAABJRU5ErkJggg=="

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = function (_Component) {
  _inherits(Player, _Component);

  function Player() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Player.__proto__ || Object.getPrototypeOf(Player)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.isReady = false, _this.isPlaying = false, _this.isLoading = true, _this.loadOnReady = null, _this.startOnPlay = true, _this.seekOnPlay = null, _this.onDurationCalled = false, _this.getInternalPlayer = function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    }, _this.progress = function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;
        var loadedSeconds = _this.getSecondsLoaded();
        var duration = _this.getDuration();
        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };
          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          }
          // Only call onProgress if values have changed
          if (progress.played !== _this.prevPlayed || progress.loaded !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }
          _this.prevPlayed = progress.played;
          _this.prevLoaded = progress.loaded;
        }
      }
      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    }, _this.onReady = function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;

      onReady();
      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }
      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);
        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }
      _this.onDurationCheck();
    }, _this.onPlay = function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate) {
          _this.player.setPlaybackRate(playbackRate);
        }
        onStart();
        _this.startOnPlay = false;
      }
      onPlay();
      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);
        _this.seekOnPlay = null;
      }
      _this.onDurationCheck();
    }, _this.onPause = function (e) {
      _this.isPlaying = false;
      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    }, _this.onEnded = function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }
      if (!loop) {
        _this.isPlaying = false;
      }
      onEnded();
    }, _this.onDurationCheck = function () {
      clearTimeout(_this.durationCheckTimeout);
      var duration = _this.getDuration();
      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);
          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.onDurationCheck, 100);
      }
    }, _this.ref = function (player) {
      if (player) {
        _this.player = player;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // Track playing state internally to prevent bugs
  // Use isLoading to prevent onPause when switching URL


  _createClass(Player, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.player.load(this.props.url);
      this.progress();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);
      if (this.isReady) {
        this.player.stop();
      }
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // Invoke player methods based on incoming props
      var _props = this.props,
          url = _props.url,
          playing = _props.playing,
          volume = _props.volume,
          muted = _props.muted,
          playbackRate = _props.playbackRate;

      if (url !== nextProps.url) {
        if (this.isLoading) {
          console.warn('ReactPlayer: the attempt to load ' + nextProps.url + ' is being deferred until the player has loaded');
          this.loadOnReady = nextProps.url;
          return;
        }
        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(nextProps.url, this.isReady);
      }
      if (!playing && nextProps.playing && !this.isPlaying) {
        this.player.play();
      }
      if (playing && !nextProps.playing && this.isPlaying) {
        this.player.pause();
      }
      if (volume !== nextProps.volume && nextProps.volume !== null) {
        this.player.setVolume(nextProps.volume);
      }
      if (muted !== nextProps.muted) {
        if (nextProps.muted) {
          this.player.mute();
        } else {
          this.player.unmute();
          if (nextProps.volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(nextProps.volume);
            });
          }
        }
      }
      if (playbackRate !== nextProps.playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(nextProps.playbackRate);
      }
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: 'seekTo',
    value: function seekTo(amount) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(function () {
          _this3.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
        return;
      }
      if (amount > 0 && amount < 1) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();
        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }
        this.player.seekTo(duration * amount);
        return;
      }
      this.player.seekTo(amount);
    }
  }, {
    key: 'render',
    value: function render() {
      var Player = this.props.activePlayer;
      return _react2['default'].createElement(Player, _extends({}, this.props, {
        ref: this.ref,
        onReady: this.onReady,
        onPlay: this.onPlay,
        onPause: this.onPause,
        onEnded: this.onEnded
      }));
    }
  }]);

  return Player;
}(_react.Component);

Player.displayName = 'Player';
Player.propTypes = _props2.propTypes;
Player.defaultProps = _props2.defaultProps;
exports['default'] = Player;

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useStateManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_a7690a33_esm_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);





var _excluded = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
      defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
      _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
      defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
      propsInputValue = _ref.inputValue,
      propsMenuIsOpen = _ref.menuIsOpen,
      propsOnChange = _ref.onChange,
      propsOnInputChange = _ref.onInputChange,
      propsOnMenuClose = _ref.onMenuClose,
      propsOnMenuOpen = _ref.onMenuOpen,
      propsValue = _ref.value,
      restSelectProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, _excluded);

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      stateInputValue = _useState2[0],
      setStateInputValue = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      stateMenuIsOpen = _useState4[0],
      setStateMenuIsOpen = _useState4[1];

  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(propsValue !== undefined ? propsValue : defaultValue),
      _useState6 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState5, 2),
      stateValue = _useState6[0],
      setStateValue = _useState6[1];

  var onChange = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }

    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (value, actionMeta) {
    var newValue;

    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }

    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }

    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }

    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return Object(__WEBPACK_IMPORTED_MODULE_0__index_a7690a33_esm_js__["o" /* a */])(Object(__WEBPACK_IMPORTED_MODULE_0__index_a7690a33_esm_js__["o" /* a */])({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}




/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_memoize__ = __webpack_require__(326);





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["h" /* peek */])(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["o" /* token */])(character)) {
      break;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["g" /* next */])();
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["m" /* slice */])(begin, __WEBPACK_IMPORTED_MODULE_1_stylis__["i" /* position */]);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["o" /* token */])(character)) {
      case 0:
        // &\f
        if (character === 38 && Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["h" /* peek */])() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(__WEBPACK_IMPORTED_MODULE_1_stylis__["i" /* position */] - 1, points, index);
        break;

      case 2:
        parsed[index] += Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["d" /* delimit */])(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["h" /* peek */])() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["e" /* from */])(character);
    }
  } while (character = Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["g" /* next */])());

  return parsed;
};

var getRules = function getRules(value, points) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["c" /* dealloc */])(toRules(Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["a" /* alloc */])(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [__WEBPACK_IMPORTED_MODULE_1_stylis__["j" /* prefixer */]];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  {
    var currentSheet;
    var finalizingPlugins = [__WEBPACK_IMPORTED_MODULE_1_stylis__["n" /* stringify */],  false ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["k" /* rulesheet */])(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["f" /* middleware */])(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["l" /* serialize */])(Object(__WEBPACK_IMPORTED_MODULE_1_stylis__["b" /* compile */])(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (weakMemoize);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(732);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_ideasthatwork.ae3725db.png";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/App_Selection_Graphic.b6cd55a2.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_wordmark2.c4e2c407.png";

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOCUMENT_MODE = __webpack_require__(67).DOCUMENT_MODE;

//Node construction
exports.createDocument = function () {
    return {
        nodeName: '#document',
        mode: DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
    };
};

exports.createDocumentFragment = function () {
    return {
        nodeName: '#document-fragment',
        childNodes: []
    };
};

exports.createElement = function (tagName, namespaceURI, attrs) {
    return {
        nodeName: tagName,
        tagName: tagName,
        attrs: attrs,
        namespaceURI: namespaceURI,
        childNodes: [],
        parentNode: null
    };
};

exports.createCommentNode = function (data) {
    return {
        nodeName: '#comment',
        data: data,
        parentNode: null
    };
};

var createTextNode = function (value) {
    return {
        nodeName: '#text',
        value: value,
        parentNode: null
    };
};


//Tree mutation
var appendChild = exports.appendChild = function (parentNode, newNode) {
    parentNode.childNodes.push(newNode);
    newNode.parentNode = parentNode;
};

var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
    var insertionIdx = parentNode.childNodes.indexOf(referenceNode);

    parentNode.childNodes.splice(insertionIdx, 0, newNode);
    newNode.parentNode = parentNode;
};

exports.setTemplateContent = function (templateElement, contentElement) {
    templateElement.content = contentElement;
};

exports.getTemplateContent = function (templateElement) {
    return templateElement.content;
};

exports.setDocumentType = function (document, name, publicId, systemId) {
    var doctypeNode = null;

    for (var i = 0; i < document.childNodes.length; i++) {
        if (document.childNodes[i].nodeName === '#documentType') {
            doctypeNode = document.childNodes[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.name = name;
        doctypeNode.publicId = publicId;
        doctypeNode.systemId = systemId;
    }

    else {
        appendChild(document, {
            nodeName: '#documentType',
            name: name,
            publicId: publicId,
            systemId: systemId
        });
    }
};

exports.setDocumentMode = function (document, mode) {
    document.mode = mode;
};

exports.getDocumentMode = function (document) {
    return document.mode;
};

exports.detachNode = function (node) {
    if (node.parentNode) {
        var idx = node.parentNode.childNodes.indexOf(node);

        node.parentNode.childNodes.splice(idx, 1);
        node.parentNode = null;
    }
};

exports.insertText = function (parentNode, text) {
    if (parentNode.childNodes.length) {
        var prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];

        if (prevNode.nodeName === '#text') {
            prevNode.value += text;
            return;
        }
    }

    appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function (parentNode, text, referenceNode) {
    var prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.nodeName === '#text')
        prevNode.value += text;
    else
        insertBefore(parentNode, createTextNode(text), referenceNode);
};

exports.adoptAttributes = function (recipient, attrs) {
    var recipientAttrsMap = [];

    for (var i = 0; i < recipient.attrs.length; i++)
        recipientAttrsMap.push(recipient.attrs[i].name);

    for (var j = 0; j < attrs.length; j++) {
        if (recipientAttrsMap.indexOf(attrs[j].name) === -1)
            recipient.attrs.push(attrs[j]);
    }
};


//Tree traversing
exports.getFirstChild = function (node) {
    return node.childNodes[0];
};

exports.getChildNodes = function (node) {
    return node.childNodes;
};

exports.getParentNode = function (node) {
    return node.parentNode;
};

exports.getAttrList = function (element) {
    return element.attrs;
};

//Node data
exports.getTagName = function (element) {
    return element.tagName;
};

exports.getNamespaceURI = function (element) {
    return element.namespaceURI;
};

exports.getTextNodeContent = function (textNode) {
    return textNode.value;
};

exports.getCommentNodeContent = function (commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function (doctypeNode) {
    return doctypeNode.name;
};

exports.getDocumentTypeNodePublicId = function (doctypeNode) {
    return doctypeNode.publicId;
};

exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
    return doctypeNode.systemId;
};

//Node types
exports.isTextNode = function (node) {
    return node.nodeName === '#text';
};

exports.isCommentNode = function (node) {
    return node.nodeName === '#comment';
};

exports.isDocumentTypeNode = function (node) {
    return node.nodeName === '#documentType';
};

exports.isElementNode = function (node) {
    return !!node.tagName;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOCUMENT_MODE = __webpack_require__(67).DOCUMENT_MODE;

//Const
var VALID_DOCTYPE_NAME = 'html',
    QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd',
    QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
        '+//silmaril//dtd html pro v0r11 19970101//en',
        '-//advasoft ltd//dtd html 3.0 aswedit + extensions//en',
        '-//as//dtd html 3.0 aswedit + extensions//en',
        '-//ietf//dtd html 2.0 level 1//en',
        '-//ietf//dtd html 2.0 level 2//en',
        '-//ietf//dtd html 2.0 strict level 1//en',
        '-//ietf//dtd html 2.0 strict level 2//en',
        '-//ietf//dtd html 2.0 strict//en',
        '-//ietf//dtd html 2.0//en',
        '-//ietf//dtd html 2.1e//en',
        '-//ietf//dtd html 3.0//en',
        '-//ietf//dtd html 3.0//en//',
        '-//ietf//dtd html 3.2 final//en',
        '-//ietf//dtd html 3.2//en',
        '-//ietf//dtd html 3//en',
        '-//ietf//dtd html level 0//en',
        '-//ietf//dtd html level 0//en//2.0',
        '-//ietf//dtd html level 1//en',
        '-//ietf//dtd html level 1//en//2.0',
        '-//ietf//dtd html level 2//en',
        '-//ietf//dtd html level 2//en//2.0',
        '-//ietf//dtd html level 3//en',
        '-//ietf//dtd html level 3//en//3.0',
        '-//ietf//dtd html strict level 0//en',
        '-//ietf//dtd html strict level 0//en//2.0',
        '-//ietf//dtd html strict level 1//en',
        '-//ietf//dtd html strict level 1//en//2.0',
        '-//ietf//dtd html strict level 2//en',
        '-//ietf//dtd html strict level 2//en//2.0',
        '-//ietf//dtd html strict level 3//en',
        '-//ietf//dtd html strict level 3//en//3.0',
        '-//ietf//dtd html strict//en',
        '-//ietf//dtd html strict//en//2.0',
        '-//ietf//dtd html strict//en//3.0',
        '-//ietf//dtd html//en',
        '-//ietf//dtd html//en//2.0',
        '-//ietf//dtd html//en//3.0',
        '-//metrius//dtd metrius presentational//en',
        '-//microsoft//dtd internet explorer 2.0 html strict//en',
        '-//microsoft//dtd internet explorer 2.0 html//en',
        '-//microsoft//dtd internet explorer 2.0 tables//en',
        '-//microsoft//dtd internet explorer 3.0 html strict//en',
        '-//microsoft//dtd internet explorer 3.0 html//en',
        '-//microsoft//dtd internet explorer 3.0 tables//en',
        '-//netscape comm. corp.//dtd html//en',
        '-//netscape comm. corp.//dtd strict html//en',
        '-//o\'reilly and associates//dtd html 2.0//en',
        '-//o\'reilly and associates//dtd html extended 1.0//en',
        '-//spyglass//dtd html 2.0 extended//en',
        '-//sq//dtd html 2.0 hotmetal + extensions//en',
        '-//sun microsystems corp.//dtd hotjava html//en',
        '-//sun microsystems corp.//dtd hotjava strict html//en',
        '-//w3c//dtd html 3 1995-03-24//en',
        '-//w3c//dtd html 3.2 draft//en',
        '-//w3c//dtd html 3.2 final//en',
        '-//w3c//dtd html 3.2//en',
        '-//w3c//dtd html 3.2s draft//en',
        '-//w3c//dtd html 4.0 frameset//en',
        '-//w3c//dtd html 4.0 transitional//en',
        '-//w3c//dtd html experimental 19960712//en',
        '-//w3c//dtd html experimental 970421//en',
        '-//w3c//dtd w3 html//en',
        '-//w3o//dtd w3 html 3.0//en',
        '-//w3o//dtd w3 html 3.0//en//',
        '-//webtechs//dtd mozilla html 2.0//en',
        '-//webtechs//dtd mozilla html//en'
    ],
    QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat([
        '-//w3c//dtd html 4.01 frameset//',
        '-//w3c//dtd html 4.01 transitional//'
    ]),
    QUIRKS_MODE_PUBLIC_IDS = [
        '-//w3o//dtd w3 html strict 3.0//en//',
        '-/w3c/dtd html 4.0 transitional/en',
        'html'
    ],
    LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
        '-//W3C//DTD XHTML 1.0 Frameset//',
        '-//W3C//DTD XHTML 1.0 Transitional//'
    ],
    LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat([
        '-//W3C//DTD HTML 4.01 Frameset//',
        '-//W3C//DTD HTML 4.01 Transitional//'
    ]);


//Utils
function enquoteDoctypeId(id) {
    var quote = id.indexOf('"') !== -1 ? '\'' : '"';

    return quote + id + quote;
}

function hasPrefix(publicId, prefixes) {
    for (var i = 0; i < prefixes.length; i++) {
        if (publicId.indexOf(prefixes[i]) === 0)
            return true;
    }

    return false;
}


//API
exports.getDocumentMode = function (name, publicId, systemId) {
    if (name !== VALID_DOCTYPE_NAME)
        return DOCUMENT_MODE.QUIRKS;

    if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID)
        return DOCUMENT_MODE.QUIRKS;

    if (publicId !== null) {
        publicId = publicId.toLowerCase();

        if (QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1)
            return DOCUMENT_MODE.QUIRKS;

        var prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes))
            return DOCUMENT_MODE.QUIRKS;

        prefixes = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes))
            return DOCUMENT_MODE.LIMITED_QUIRKS;
    }

    return DOCUMENT_MODE.NO_QUIRKS;
};

exports.serializeContent = function (name, publicId, systemId) {
    var str = '!DOCTYPE ';

    if (name)
        str += name;

    if (publicId !== null)
        str += ' PUBLIC ' + enquoteDoctypeId(publicId);

    else if (systemId !== null)
        str += ' SYSTEM';

    if (systemId !== null)
        str += ' ' + enquoteDoctypeId(systemId);

    return str;
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

//package mp3;
var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var L3Side = __webpack_require__(149);

function GrInfo() {
    //float xr[] = new float[576];
    this.xr = new_float(576);
    //int l3_enc[] = new int[576];
    this.l3_enc = new_int(576);
    //int scalefac[] = new int[L3Side.SFBMAX];
    this.scalefac = new_int(L3Side.SFBMAX);
    this.xrpow_max = 0.;

    this.part2_3_length = 0;
    this.big_values = 0;
    this.count1 = 0;
    this.global_gain = 0;
    this.scalefac_compress = 0;
    this.block_type = 0;
    this.mixed_block_flag = 0;
    this.table_select = new_int(3);
    this.subblock_gain = new_int(3 + 1);
    this.region0_count = 0;
    this.region1_count = 0;
    this.preflag = 0;
    this.scalefac_scale = 0;
    this.count1table_select = 0;

    this.part2_length = 0;
    this.sfb_lmax = 0;
    this.sfb_smin = 0;
    this.psy_lmax = 0;
    this.sfbmax = 0;
    this.psymax = 0;
    this.sfbdivide = 0;
    this.width = new_int(L3Side.SFBMAX);
    this.window = new_int(L3Side.SFBMAX);
    this.count1bits = 0;
    /**
     * added for LSF
     */
    this.sfb_partition_table = null;
    this.slen = new_int(4);

    this.max_nonzero_coeff = 0;

    var self = this;
    function clone_int(array) {
        return new Int32Array(array);
    }
    function clone_float(array) {
        return new Float32Array(array);
    }
    this.assign = function (other) {
        self.xr = clone_float(other.xr); //.slice(0); //clone();
        self.l3_enc = clone_int(other.l3_enc); //.slice(0); //clone();
        self.scalefac = clone_int(other.scalefac);//.slice(0); //clone();
        self.xrpow_max = other.xrpow_max;

        self.part2_3_length = other.part2_3_length;
        self.big_values = other.big_values;
        self.count1 = other.count1;
        self.global_gain = other.global_gain;
        self.scalefac_compress = other.scalefac_compress;
        self.block_type = other.block_type;
        self.mixed_block_flag = other.mixed_block_flag;
        self.table_select = clone_int(other.table_select);//.slice(0); //clone();
        self.subblock_gain = clone_int(other.subblock_gain); //.slice(0); //.clone();
        self.region0_count = other.region0_count;
        self.region1_count = other.region1_count;
        self.preflag = other.preflag;
        self.scalefac_scale = other.scalefac_scale;
        self.count1table_select = other.count1table_select;

        self.part2_length = other.part2_length;
        self.sfb_lmax = other.sfb_lmax;
        self.sfb_smin = other.sfb_smin;
        self.psy_lmax = other.psy_lmax;
        self.sfbmax = other.sfbmax;
        self.psymax = other.psymax;
        self.sfbdivide = other.sfbdivide;
        self.width = clone_int(other.width); //.slice(0); //.clone();
        self.window = clone_int(other.window); //.slice(0); //.clone();
        self.count1bits = other.count1bits;

        self.sfb_partition_table = other.sfb_partition_table.slice(0); //.clone();
        self.slen = clone_int(other.slen); //.slice(0); //.clone();
        self.max_nonzero_coeff = other.max_nonzero_coeff;
    }
}

module.exports = GrInfo;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

function HuffCodeTab(len, max, tab, hl) {
    this.xlen = len;
    this.linmax = max;
    this.table = tab;
    this.hlen = hl;
}

var Tables = {};


Tables.t1HB = [
    1, 1,
    1, 0
];

Tables.t2HB = [
    1, 2, 1,
    3, 1, 1,
    3, 2, 0
];

Tables.t3HB = [
    3, 2, 1,
    1, 1, 1,
    3, 2, 0
];

Tables.t5HB = [
    1, 2, 6, 5,
    3, 1, 4, 4,
    7, 5, 7, 1,
    6, 1, 1, 0
];

Tables.t6HB = [
    7, 3, 5, 1,
    6, 2, 3, 2,
    5, 4, 4, 1,
    3, 3, 2, 0
];

Tables.t7HB = [
    1, 2, 10, 19, 16, 10,
    3, 3, 7, 10, 5, 3,
    11, 4, 13, 17, 8, 4,
    12, 11, 18, 15, 11, 2,
    7, 6, 9, 14, 3, 1,
    6, 4, 5, 3, 2, 0
];

Tables.t8HB = [
    3, 4, 6, 18, 12, 5,
    5, 1, 2, 16, 9, 3,
    7, 3, 5, 14, 7, 3,
    19, 17, 15, 13, 10, 4,
    13, 5, 8, 11, 5, 1,
    12, 4, 4, 1, 1, 0
];

Tables.t9HB = [
    7, 5, 9, 14, 15, 7,
    6, 4, 5, 5, 6, 7,
    7, 6, 8, 8, 8, 5,
    15, 6, 9, 10, 5, 1,
    11, 7, 9, 6, 4, 1,
    14, 4, 6, 2, 6, 0
];

Tables.t10HB = [
    1, 2, 10, 23, 35, 30, 12, 17,
    3, 3, 8, 12, 18, 21, 12, 7,
    11, 9, 15, 21, 32, 40, 19, 6,
    14, 13, 22, 34, 46, 23, 18, 7,
    20, 19, 33, 47, 27, 22, 9, 3,
    31, 22, 41, 26, 21, 20, 5, 3,
    14, 13, 10, 11, 16, 6, 5, 1,
    9, 8, 7, 8, 4, 4, 2, 0
];

Tables.t11HB = [
    3, 4, 10, 24, 34, 33, 21, 15,
    5, 3, 4, 10, 32, 17, 11, 10,
    11, 7, 13, 18, 30, 31, 20, 5,
    25, 11, 19, 59, 27, 18, 12, 5,
    35, 33, 31, 58, 30, 16, 7, 5,
    28, 26, 32, 19, 17, 15, 8, 14,
    14, 12, 9, 13, 14, 9, 4, 1,
    11, 4, 6, 6, 6, 3, 2, 0
];

Tables.t12HB = [
    9, 6, 16, 33, 41, 39, 38, 26,
    7, 5, 6, 9, 23, 16, 26, 11,
    17, 7, 11, 14, 21, 30, 10, 7,
    17, 10, 15, 12, 18, 28, 14, 5,
    32, 13, 22, 19, 18, 16, 9, 5,
    40, 17, 31, 29, 17, 13, 4, 2,
    27, 12, 11, 15, 10, 7, 4, 1,
    27, 12, 8, 12, 6, 3, 1, 0
];

Tables.t13HB = [
    1, 5, 14, 21, 34, 51, 46, 71, 42, 52, 68, 52, 67, 44, 43, 19,
    3, 4, 12, 19, 31, 26, 44, 33, 31, 24, 32, 24, 31, 35, 22, 14,
    15, 13, 23, 36, 59, 49, 77, 65, 29, 40, 30, 40, 27, 33, 42, 16,
    22, 20, 37, 61, 56, 79, 73, 64, 43, 76, 56, 37, 26, 31, 25, 14,
    35, 16, 60, 57, 97, 75, 114, 91, 54, 73, 55, 41, 48, 53, 23, 24,
    58, 27, 50, 96, 76, 70, 93, 84, 77, 58, 79, 29, 74, 49, 41, 17,
    47, 45, 78, 74, 115, 94, 90, 79, 69, 83, 71, 50, 59, 38, 36, 15,
    72, 34, 56, 95, 92, 85, 91, 90, 86, 73, 77, 65, 51, 44, 43, 42,
    43, 20, 30, 44, 55, 78, 72, 87, 78, 61, 46, 54, 37, 30, 20, 16,
    53, 25, 41, 37, 44, 59, 54, 81, 66, 76, 57, 54, 37, 18, 39, 11,
    35, 33, 31, 57, 42, 82, 72, 80, 47, 58, 55, 21, 22, 26, 38, 22,
    53, 25, 23, 38, 70, 60, 51, 36, 55, 26, 34, 23, 27, 14, 9, 7,
    34, 32, 28, 39, 49, 75, 30, 52, 48, 40, 52, 28, 18, 17, 9, 5,
    45, 21, 34, 64, 56, 50, 49, 45, 31, 19, 12, 15, 10, 7, 6, 3,
    48, 23, 20, 39, 36, 35, 53, 21, 16, 23, 13, 10, 6, 1, 4, 2,
    16, 15, 17, 27, 25, 20, 29, 11, 17, 12, 16, 8, 1, 1, 0, 1
];

Tables.t15HB = [
    7, 12, 18, 53, 47, 76, 124, 108, 89, 123, 108, 119, 107, 81, 122, 63,
    13, 5, 16, 27, 46, 36, 61, 51, 42, 70, 52, 83, 65, 41, 59, 36,
    19, 17, 15, 24, 41, 34, 59, 48, 40, 64, 50, 78, 62, 80, 56, 33,
    29, 28, 25, 43, 39, 63, 55, 93, 76, 59, 93, 72, 54, 75, 50, 29,
    52, 22, 42, 40, 67, 57, 95, 79, 72, 57, 89, 69, 49, 66, 46, 27,
    77, 37, 35, 66, 58, 52, 91, 74, 62, 48, 79, 63, 90, 62, 40, 38,
    125, 32, 60, 56, 50, 92, 78, 65, 55, 87, 71, 51, 73, 51, 70, 30,
    109, 53, 49, 94, 88, 75, 66, 122, 91, 73, 56, 42, 64, 44, 21, 25,
    90, 43, 41, 77, 73, 63, 56, 92, 77, 66, 47, 67, 48, 53, 36, 20,
    71, 34, 67, 60, 58, 49, 88, 76, 67, 106, 71, 54, 38, 39, 23, 15,
    109, 53, 51, 47, 90, 82, 58, 57, 48, 72, 57, 41, 23, 27, 62, 9,
    86, 42, 40, 37, 70, 64, 52, 43, 70, 55, 42, 25, 29, 18, 11, 11,
    118, 68, 30, 55, 50, 46, 74, 65, 49, 39, 24, 16, 22, 13, 14, 7,
    91, 44, 39, 38, 34, 63, 52, 45, 31, 52, 28, 19, 14, 8, 9, 3,
    123, 60, 58, 53, 47, 43, 32, 22, 37, 24, 17, 12, 15, 10, 2, 1,
    71, 37, 34, 30, 28, 20, 17, 26, 21, 16, 10, 6, 8, 6, 2, 0
];

Tables.t16HB = [
    1, 5, 14, 44, 74, 63, 110, 93, 172, 149, 138, 242, 225, 195, 376, 17,
    3, 4, 12, 20, 35, 62, 53, 47, 83, 75, 68, 119, 201, 107, 207, 9,
    15, 13, 23, 38, 67, 58, 103, 90, 161, 72, 127, 117, 110, 209, 206, 16,
    45, 21, 39, 69, 64, 114, 99, 87, 158, 140, 252, 212, 199, 387, 365, 26,
    75, 36, 68, 65, 115, 101, 179, 164, 155, 264, 246, 226, 395, 382, 362, 9,
    66, 30, 59, 56, 102, 185, 173, 265, 142, 253, 232, 400, 388, 378, 445, 16,
    111, 54, 52, 100, 184, 178, 160, 133, 257, 244, 228, 217, 385, 366, 715, 10,
    98, 48, 91, 88, 165, 157, 148, 261, 248, 407, 397, 372, 380, 889, 884, 8,
    85, 84, 81, 159, 156, 143, 260, 249, 427, 401, 392, 383, 727, 713, 708, 7,
    154, 76, 73, 141, 131, 256, 245, 426, 406, 394, 384, 735, 359, 710, 352, 11,
    139, 129, 67, 125, 247, 233, 229, 219, 393, 743, 737, 720, 885, 882, 439, 4,
    243, 120, 118, 115, 227, 223, 396, 746, 742, 736, 721, 712, 706, 223, 436, 6,
    202, 224, 222, 218, 216, 389, 386, 381, 364, 888, 443, 707, 440, 437, 1728, 4,
    747, 211, 210, 208, 370, 379, 734, 723, 714, 1735, 883, 877, 876, 3459, 865, 2,
    377, 369, 102, 187, 726, 722, 358, 711, 709, 866, 1734, 871, 3458, 870, 434, 0,
    12, 10, 7, 11, 10, 17, 11, 9, 13, 12, 10, 7, 5, 3, 1, 3
];

Tables.t24HB = [
    15, 13, 46, 80, 146, 262, 248, 434, 426, 669, 653, 649, 621, 517, 1032, 88,
    14, 12, 21, 38, 71, 130, 122, 216, 209, 198, 327, 345, 319, 297, 279, 42,
    47, 22, 41, 74, 68, 128, 120, 221, 207, 194, 182, 340, 315, 295, 541, 18,
    81, 39, 75, 70, 134, 125, 116, 220, 204, 190, 178, 325, 311, 293, 271, 16,
    147, 72, 69, 135, 127, 118, 112, 210, 200, 188, 352, 323, 306, 285, 540, 14,
    263, 66, 129, 126, 119, 114, 214, 202, 192, 180, 341, 317, 301, 281, 262, 12,
    249, 123, 121, 117, 113, 215, 206, 195, 185, 347, 330, 308, 291, 272, 520, 10,
    435, 115, 111, 109, 211, 203, 196, 187, 353, 332, 313, 298, 283, 531, 381, 17,
    427, 212, 208, 205, 201, 193, 186, 177, 169, 320, 303, 286, 268, 514, 377, 16,
    335, 199, 197, 191, 189, 181, 174, 333, 321, 305, 289, 275, 521, 379, 371, 11,
    668, 184, 183, 179, 175, 344, 331, 314, 304, 290, 277, 530, 383, 373, 366, 10,
    652, 346, 171, 168, 164, 318, 309, 299, 287, 276, 263, 513, 375, 368, 362, 6,
    648, 322, 316, 312, 307, 302, 292, 284, 269, 261, 512, 376, 370, 364, 359, 4,
    620, 300, 296, 294, 288, 282, 273, 266, 515, 380, 374, 369, 365, 361, 357, 2,
    1033, 280, 278, 274, 267, 264, 259, 382, 378, 372, 367, 363, 360, 358, 356, 0,
    43, 20, 19, 17, 15, 13, 11, 9, 7, 6, 4, 7, 5, 3, 1, 3
];

Tables.t32HB = [
    1 << 0, 5 << 1, 4 << 1, 5 << 2, 6 << 1, 5 << 2, 4 << 2, 4 << 3,
    7 << 1, 3 << 2, 6 << 2, 0 << 3, 7 << 2, 2 << 3, 3 << 3, 1 << 4
];

Tables.t33HB = [
    15 << 0, 14 << 1, 13 << 1, 12 << 2, 11 << 1, 10 << 2, 9 << 2, 8 << 3,
    7 << 1, 6 << 2, 5 << 2, 4 << 3, 3 << 2, 2 << 3, 1 << 3, 0 << 4
];

Tables.t1l = [
    1, 4,
    3, 5
];

Tables.t2l = [
    1, 4, 7,
    4, 5, 7,
    6, 7, 8
];

Tables.t3l = [
    2, 3, 7,
    4, 4, 7,
    6, 7, 8
];

Tables.t5l = [
    1, 4, 7, 8,
    4, 5, 8, 9,
    7, 8, 9, 10,
    8, 8, 9, 10
];

Tables.t6l = [
    3, 4, 6, 8,
    4, 4, 6, 7,
    5, 6, 7, 8,
    7, 7, 8, 9
];

Tables.t7l = [
    1, 4, 7, 9, 9, 10,
    4, 6, 8, 9, 9, 10,
    7, 7, 9, 10, 10, 11,
    8, 9, 10, 11, 11, 11,
    8, 9, 10, 11, 11, 12,
    9, 10, 11, 12, 12, 12
];

Tables.t8l = [
    2, 4, 7, 9, 9, 10,
    4, 4, 6, 10, 10, 10,
    7, 6, 8, 10, 10, 11,
    9, 10, 10, 11, 11, 12,
    9, 9, 10, 11, 12, 12,
    10, 10, 11, 11, 13, 13
];

Tables.t9l = [
    3, 4, 6, 7, 9, 10,
    4, 5, 6, 7, 8, 10,
    5, 6, 7, 8, 9, 10,
    7, 7, 8, 9, 9, 10,
    8, 8, 9, 9, 10, 11,
    9, 9, 10, 10, 11, 11
];

Tables.t10l = [
    1, 4, 7, 9, 10, 10, 10, 11,
    4, 6, 8, 9, 10, 11, 10, 10,
    7, 8, 9, 10, 11, 12, 11, 11,
    8, 9, 10, 11, 12, 12, 11, 12,
    9, 10, 11, 12, 12, 12, 12, 12,
    10, 11, 12, 12, 13, 13, 12, 13,
    9, 10, 11, 12, 12, 12, 13, 13,
    10, 10, 11, 12, 12, 13, 13, 13
];

Tables.t11l = [
    2, 4, 6, 8, 9, 10, 9, 10,
    4, 5, 6, 8, 10, 10, 9, 10,
    6, 7, 8, 9, 10, 11, 10, 10,
    8, 8, 9, 11, 10, 12, 10, 11,
    9, 10, 10, 11, 11, 12, 11, 12,
    9, 10, 11, 12, 12, 13, 12, 13,
    9, 9, 9, 10, 11, 12, 12, 12,
    9, 9, 10, 11, 12, 12, 12, 12
];

Tables.t12l = [
    4, 4, 6, 8, 9, 10, 10, 10,
    4, 5, 6, 7, 9, 9, 10, 10,
    6, 6, 7, 8, 9, 10, 9, 10,
    7, 7, 8, 8, 9, 10, 10, 10,
    8, 8, 9, 9, 10, 10, 10, 11,
    9, 9, 10, 10, 10, 11, 10, 11,
    9, 9, 9, 10, 10, 11, 11, 12,
    10, 10, 10, 11, 11, 11, 11, 12
];

Tables.t13l = [
    1, 5, 7, 8, 9, 10, 10, 11, 10, 11, 12, 12, 13, 13, 14, 14,
    4, 6, 8, 9, 10, 10, 11, 11, 11, 11, 12, 12, 13, 14, 14, 14,
    7, 8, 9, 10, 11, 11, 12, 12, 11, 12, 12, 13, 13, 14, 15, 15,
    8, 9, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 15,
    9, 9, 11, 11, 12, 12, 13, 13, 12, 13, 13, 14, 14, 15, 15, 16,
    10, 10, 11, 12, 12, 12, 13, 13, 13, 13, 14, 13, 15, 15, 16, 16,
    10, 11, 12, 12, 13, 13, 13, 13, 13, 14, 14, 14, 15, 15, 16, 16,
    11, 11, 12, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 16, 18, 18,
    10, 10, 11, 12, 12, 13, 13, 14, 14, 14, 14, 15, 15, 16, 17, 17,
    11, 11, 12, 12, 13, 13, 13, 15, 14, 15, 15, 16, 16, 16, 18, 17,
    11, 12, 12, 13, 13, 14, 14, 15, 14, 15, 16, 15, 16, 17, 18, 19,
    12, 12, 12, 13, 14, 14, 14, 14, 15, 15, 15, 16, 17, 17, 17, 18,
    12, 13, 13, 14, 14, 15, 14, 15, 16, 16, 17, 17, 17, 18, 18, 18,
    13, 13, 14, 15, 15, 15, 16, 16, 16, 16, 16, 17, 18, 17, 18, 18,
    14, 14, 14, 15, 15, 15, 17, 16, 16, 19, 17, 17, 17, 19, 18, 18,
    13, 14, 15, 16, 16, 16, 17, 16, 17, 17, 18, 18, 21, 20, 21, 18
];

Tables.t15l = [
    3, 5, 6, 8, 8, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 14,
    5, 5, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 13,
    6, 7, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 13, 13, 13,
    7, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 12, 13, 13, 13,
    8, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13,
    9, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 13, 13, 13, 14,
    10, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 14, 14,
    10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 14,
    10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 14, 14, 14,
    10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14,
    11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 14,
    11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15,
    12, 12, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 14, 14, 15, 15,
    12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15,
    13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 14, 15,
    13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 15, 15
];

Tables.t16_5l = [
    1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 11,
    4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 11,
    7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 12,
    9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 13,
    10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 12,
    10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 13,
    11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 13,
    11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 13,
    11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 13,
    12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 14,
    12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 13,
    13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 14,
    13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 14,
    15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 14,
    14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 14,
    11, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 12
];

Tables.t16l = [
    1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 10,
    4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 10,
    7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 11,
    9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 12,
    10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 11,
    10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 12,
    11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 12,
    11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 12,
    11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 12,
    12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 13,
    12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 12,
    13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 13,
    13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 13,
    15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 13,
    14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 13,
    10, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10
];

Tables.t24l = [
    4, 5, 7, 8, 9, 10, 10, 11, 11, 12, 12, 12, 12, 12, 13, 10,
    5, 6, 7, 8, 9, 10, 10, 11, 11, 11, 12, 12, 12, 12, 12, 10,
    7, 7, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 9,
    8, 8, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 9,
    9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 12, 12, 12, 12, 13, 9,
    10, 9, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 9,
    10, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 9,
    11, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 10,
    11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 10,
    11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 10,
    12, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10,
    12, 12, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10,
    12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 10,
    12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10,
    13, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 10,
    9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 6
];

Tables.t32l = [
    1 + 0, 4 + 1, 4 + 1, 5 + 2, 4 + 1, 6 + 2, 5 + 2, 6 + 3,
    4 + 1, 5 + 2, 5 + 2, 6 + 3, 5 + 2, 6 + 3, 6 + 3, 6 + 4
];

Tables.t33l = [
    4 + 0, 4 + 1, 4 + 1, 4 + 2, 4 + 1, 4 + 2, 4 + 2, 4 + 3,
    4 + 1, 4 + 2, 4 + 2, 4 + 3, 4 + 2, 4 + 3, 4 + 3, 4 + 4
];

Tables.ht = [
    /* xlen, linmax, table, hlen */
    new HuffCodeTab(0, 0, null, null),
    new HuffCodeTab(2, 0, Tables.t1HB, Tables.t1l),
    new HuffCodeTab(3, 0, Tables.t2HB, Tables.t2l),
    new HuffCodeTab(3, 0, Tables.t3HB, Tables.t3l),
    new HuffCodeTab(0, 0, null, null), /* Apparently not used */
    new HuffCodeTab(4, 0, Tables.t5HB, Tables.t5l),
    new HuffCodeTab(4, 0, Tables.t6HB, Tables.t6l),
    new HuffCodeTab(6, 0, Tables.t7HB, Tables.t7l),
    new HuffCodeTab(6, 0, Tables.t8HB, Tables.t8l),
    new HuffCodeTab(6, 0, Tables.t9HB, Tables.t9l),
    new HuffCodeTab(8, 0, Tables.t10HB, Tables.t10l),
    new HuffCodeTab(8, 0, Tables.t11HB, Tables.t11l),
    new HuffCodeTab(8, 0, Tables.t12HB, Tables.t12l),
    new HuffCodeTab(16, 0, Tables.t13HB, Tables.t13l),
    new HuffCodeTab(0, 0, null, Tables.t16_5l), /* Apparently not used */
    new HuffCodeTab(16, 0, Tables.t15HB, Tables.t15l),

    new HuffCodeTab(1, 1, Tables.t16HB, Tables.t16l),
    new HuffCodeTab(2, 3, Tables.t16HB, Tables.t16l),
    new HuffCodeTab(3, 7, Tables.t16HB, Tables.t16l),
    new HuffCodeTab(4, 15, Tables.t16HB, Tables.t16l),
    new HuffCodeTab(6, 63, Tables.t16HB, Tables.t16l),
    new HuffCodeTab(8, 255, Tables.t16HB, Tables.t16l),
    new HuffCodeTab(10, 1023, Tables.t16HB, Tables.t16l),
    new HuffCodeTab(13, 8191, Tables.t16HB, Tables.t16l),

    new HuffCodeTab(4, 15, Tables.t24HB, Tables.t24l),
    new HuffCodeTab(5, 31, Tables.t24HB, Tables.t24l),
    new HuffCodeTab(6, 63, Tables.t24HB, Tables.t24l),
    new HuffCodeTab(7, 127, Tables.t24HB, Tables.t24l),
    new HuffCodeTab(8, 255, Tables.t24HB, Tables.t24l),
    new HuffCodeTab(9, 511, Tables.t24HB, Tables.t24l),
    new HuffCodeTab(11, 2047, Tables.t24HB, Tables.t24l),
    new HuffCodeTab(13, 8191, Tables.t24HB, Tables.t24l),

    new HuffCodeTab(0, 0, Tables.t32HB, Tables.t32l),
    new HuffCodeTab(0, 0, Tables.t33HB, Tables.t33l),
];

/**
 * <CODE>
 *  for (i = 0; i < 16*16; i++) [
 *      largetbl[i] = ((ht[16].hlen[i]) << 16) + ht[24].hlen[i];
 *  ]
 * </CODE>
 *
 */
Tables.largetbl = [
    0x010004, 0x050005, 0x070007, 0x090008, 0x0a0009, 0x0a000a, 0x0b000a, 0x0b000b,
    0x0c000b, 0x0c000c, 0x0c000c, 0x0d000c, 0x0d000c, 0x0d000c, 0x0e000d, 0x0a000a,
    0x040005, 0x060006, 0x080007, 0x090008, 0x0a0009, 0x0b000a, 0x0b000a, 0x0b000b,
    0x0c000b, 0x0c000b, 0x0c000c, 0x0d000c, 0x0e000c, 0x0d000c, 0x0e000c, 0x0a000a,
    0x070007, 0x080007, 0x090008, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000b,
    0x0d000b, 0x0c000b, 0x0d000b, 0x0d000c, 0x0d000c, 0x0e000c, 0x0e000d, 0x0b0009,
    0x090008, 0x090008, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000a, 0x0c000b,
    0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0c0009,
    0x0a0009, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000a, 0x0d000a, 0x0d000b,
    0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000d, 0x0b0009,
    0x0a000a, 0x0a0009, 0x0b000a, 0x0b000a, 0x0c000a, 0x0d000a, 0x0d000b, 0x0e000b,
    0x0d000b, 0x0e000b, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x0c0009,
    0x0b000a, 0x0b000a, 0x0b000a, 0x0c000a, 0x0d000a, 0x0d000b, 0x0d000b, 0x0d000b,
    0x0e000b, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x10000d, 0x0c0009,
    0x0b000b, 0x0b000a, 0x0c000a, 0x0c000a, 0x0d000b, 0x0d000b, 0x0d000b, 0x0e000b,
    0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x11000d, 0x11000d, 0x0c000a,
    0x0b000b, 0x0c000b, 0x0c000b, 0x0d000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000b,
    0x0f000b, 0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x10000d, 0x10000d, 0x0c000a,
    0x0c000b, 0x0c000b, 0x0c000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000b, 0x0f000c,
    0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x0f000d, 0x10000d, 0x0f000d, 0x0d000a,
    0x0c000c, 0x0d000b, 0x0c000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0e000c,
    0x0f000c, 0x10000c, 0x10000c, 0x10000d, 0x11000d, 0x11000d, 0x10000d, 0x0c000a,
    0x0d000c, 0x0d000c, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0f000c, 0x10000c,
    0x10000c, 0x10000c, 0x10000c, 0x10000d, 0x10000d, 0x0f000d, 0x10000d, 0x0d000a,
    0x0d000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c,
    0x0f000c, 0x11000c, 0x10000d, 0x10000d, 0x10000d, 0x10000d, 0x12000d, 0x0d000a,
    0x0f000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x10000c, 0x10000c,
    0x10000d, 0x12000d, 0x11000d, 0x11000d, 0x11000d, 0x13000d, 0x11000d, 0x0d000a,
    0x0e000d, 0x0f000c, 0x0d000c, 0x0e000c, 0x10000c, 0x10000c, 0x0f000c, 0x10000d,
    0x10000d, 0x11000d, 0x12000d, 0x11000d, 0x13000d, 0x11000d, 0x10000d, 0x0d000a,
    0x0a0009, 0x0a0009, 0x0a0009, 0x0b0009, 0x0b0009, 0x0c0009, 0x0c0009, 0x0c0009,
    0x0d0009, 0x0d0009, 0x0d0009, 0x0d000a, 0x0d000a, 0x0d000a, 0x0d000a, 0x0a0006
];
/**
 * <CODE>
 *  for (i = 0; i < 3*3; i++) [
 *      table23[i] = ((ht[2].hlen[i]) << 16) + ht[3].hlen[i];
 *  ]
 * </CODE>
 *
 */
Tables.table23 = [
    0x010002, 0x040003, 0x070007,
    0x040004, 0x050004, 0x070007,
    0x060006, 0x070007, 0x080008
];

/**
 * <CODE>
 *  for (i = 0; i < 4*4; i++) [
 *       table56[i] = ((ht[5].hlen[i]) << 16) + ht[6].hlen[i];
 *   ]
 * </CODE>
 *
 */
Tables.table56 = [
    0x010003, 0x040004, 0x070006, 0x080008, 0x040004, 0x050004, 0x080006, 0x090007,
    0x070005, 0x080006, 0x090007, 0x0a0008, 0x080007, 0x080007, 0x090008, 0x0a0009
];

Tables.bitrate_table = [
    [0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, -1], /* MPEG 2 */
    [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, -1], /* MPEG 1 */
    [0, 8, 16, 24, 32, 40, 48, 56, 64, -1, -1, -1, -1, -1, -1, -1], /* MPEG 2.5 */
];

/**
 * MPEG 2, MPEG 1, MPEG 2.5.
 */
Tables.samplerate_table = [
    [22050, 24000, 16000, -1],
    [44100, 48000, 32000, -1],
    [11025, 12000, 8000, -1],
];

/**
 * This is the scfsi_band table from 2.4.2.7 of the IS.
 */
Tables.scfsi_band = [0, 6, 11, 16, 21];

module.exports = Tables;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAJZlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgExAAIAAAARAAAAWodpAAQAAAABAAAAbAAAAAAAAABIAAAAAQAAAEgAAAABQWRvYmUgSW1hZ2VSZWFkeQAAAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAA6gAwAEAAAAAQAAAA8AAAAABU56igAAAAlwSFlzAAALEwAACxMBAJqcGAAAActpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx4bXA6Q3JlYXRvclRvb2w+QWRvYmUgSW1hZ2VSZWFkeTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KKS7NPQAAAmNJREFUKBWNUktIlFEUPufcf6axxEKKmhmRIrCsKO2xiV60ikqZcZwpiR4rC6IH0TYS3ARhREGUBG5rxhkf0SJcVIvIhQUZZoSkUc0IFSaWMf/jns79c4po09nc+59zvsc590f4z0gvSy6xyD3KwFNN+bou6+HyY6HPxaktiokwxC/iE71fDRcDIPrHL2ZUznpkuix5Oxcd3klf7OlThDQQVOqRtuFmOhqrM60G1AZtZO79S5MrCOichWQILQReTIg4LrVxhzUsoOABi/FONtq0zwAEqIc2tQZschrLQO212XMFlBn+uGG/Ss+MvmopXz3IBD9s1qvmU6DKYW/zwfLasbvfXo/toerDYvq6y1oJ19MgeM2tM50OpiGpUpDxjEIuGj/CzO0LKVQ9re0HkhoE0I3ipP67dt4we4eaC/1Dc/MDGDCsBZUaydjd4VhC7LcHkGqlwQ+XvSEAOpvI556Yuc0I/vBG0YBuyTzNhd6srPyGwzzpMYMnswuoUBmseGZY1sCI7M1fnjn+hLHRE463M8IZyZaZCgEqDdwDATyZeJcrsKj6iqbo25UzG4mfF9BpoQ3Ji3TIY8YENCBPEUeHO2UPNShWfdm5YVmSu8VdZxDVSkd7VwLoXmjI35vtjiTqCfS1Cpq3bVoXn8uSjvtAo5gNN+0A1B1ibCMyX3XZupSazHwqkaYjDdUWW9vlz6iR9gEf2Aa7rHWRRY9l7VtntdNlg77Yku97Lw0l4tKC/ZGm4C35hXRVslJp96X0TSjyTsQ+9Mn97ygpl7KWfylCEANwH7W+Hcv/CzI9ovBb1Xz/BBXgAAgWrcwtAAAAAElFTkSuQmCC"

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATlJREFUeNqM07FLAmEYx3FPLVFSIsWgPyCsoQaXloywqaYwrD+gEIqCoKWhpcagWqKGZpuiIBoDwabEaFAQgxxapCAIgrCi+j7wGC+HVx58jvfu3t+97/u8d9ZJ37SrzWMB3zjy6o0hvOHOIdCFLYSlr5vTInK4QcYhtIJeyCAJCXWiW992gB1bIIQ1bdcw5ZkNDlzTeMKwdhjBB/La8QKDeMckKjLSF/YRQwkWNjW8jKSGd1GQhmWrnkyxiH48Igi/jppodnLb5v+KCdQR1cCLGWgVkuMBl8Z1QMv9Z2gcM/jEla5ZqrfkFOpBFj6cYhQpNLCne+qSkpuhbR3pFmnjK2noC8ZQ9hqBdczjHnN4Np5Juc8QlzU3QxENebCKaou11tTvmmQ/OnCI8/8+d7MQx9ho5x/5EWAAEAg8zR7qXbAAAAAASUVORK5CYII="

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistoid__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__purgeStoredState__ = __webpack_require__(395);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/
function persistReducer(config, baseReducer) {
  if (false) {
    if (!config) throw new Error('config is required for persistReducer');
    if (!config.key) throw new Error('key is required in persistor config');
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storage from 'redux-persist/lib/storage'`");
  }

  var version = config.version !== undefined ? config.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__["a" /* default */] : config.stateReconciler;
  var getStoredState = config.getStoredState || __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a" /* default */];
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;
  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ['_persist']);

    var restState = rest;

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PERSIST */]) {
      var _sealed = false;
      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) console.error('redux-persist: rehydrate for "' + config.key + '" called after timeout.', payload, err);

        // only rehydrate if we are not already sealed
        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };
      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "' + config.key + '"'));
      }, timeout);

      // @NOTE PERSIST resumes if paused.
      _paused = false;

      // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
      if (!_persistoid) _persistoid = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistoid__["a" /* default */])(config);

      // @NOTE PERSIST can be called multiple times, noop after the first
      if (_persist) return state;
      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');

      action.register(config.key);

      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };
        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) console.error('redux-persist: migration error', migrateErr);
          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });

      return _extends({}, baseReducer(restState, action), {
        _persist: { version: version, rehydrated: false }
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PURGE */]) {
      _purge = true;
      action.result(Object(__WEBPACK_IMPORTED_MODULE_4__purgeStoredState__["a" /* default */])(config));
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FLUSH */]) {
      action.result(_persistoid && _persistoid.flush());
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PAUSE */]) {
      _paused = true;
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* REHYDRATE */]) {
      // noop on restState if purging
      if (_purge) return _extends({}, restState, {
        _persist: _extends({}, _persist, { rehydrated: true })

        // @NOTE if key does not match, will continue to default else below
      });if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload;
        // only reconcile state if stateReconciler and inboundState are both defined
        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = _extends({}, reconciledRest, {
          _persist: _extends({}, _persist, { rehydrated: true })
        });
        return conditionalUpdate(_newState);
      }
    }

    // if we have not already handled PERSIST, straight passthrough
    if (!_persist) return baseReducer(state, action);

    // run base reducer:
    // is state modified ? return original : return updated
    var newState = baseReducer(restState, action);
    if (newState === restState) return state;else {
      newState._persist = _persist;
      return conditionalUpdate(newState);
    }
  };
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(399);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(217);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(156);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 220 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 221 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 222 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(439);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(225);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(226);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(229);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(159);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(459);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(471), __esModule: true };

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(82) && !__webpack_require__(99)(function () {
  return Object.defineProperty(__webpack_require__(233)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(81);
var document = __webpack_require__(60).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(72);
var toIObject = __webpack_require__(73);
var arrayIndexOf = __webpack_require__(475)(false);
var IE_PROTO = __webpack_require__(165)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(162);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(164);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(479)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(238)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(171);
var $export = __webpack_require__(59);
var redefine = __webpack_require__(239);
var hide = __webpack_require__(79);
var has = __webpack_require__(72);
var Iterators = __webpack_require__(103);
var $iterCreate = __webpack_require__(480);
var setToStringTag = __webpack_require__(173);
var getPrototypeOf = __webpack_require__(483);
var ITERATOR = __webpack_require__(49)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(79);


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(234);
var hiddenKeys = __webpack_require__(167).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(102);
var createDesc = __webpack_require__(100);
var toIObject = __webpack_require__(73);
var toPrimitive = __webpack_require__(161);
var has = __webpack_require__(72);
var IE8_DOM_DEFINE = __webpack_require__(232);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(82) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_PropTypes__ = __webpack_require__(245);














var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * An HTML role attribute
   */
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: Object(__WEBPACK_IMPORTED_MODULE_11__utils_PropTypes__["b" /* generatedId */])('PanelGroup')
};

var defaultProps = {
  accordion: false
};

var childContextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    headerRole: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    panelRole: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })
};

var PanelGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PanelGroup, _React$Component);

  function PanelGroup() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PanelGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  PanelGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        accordion = _props.accordion,
        generateChildId = _props.generateChildId,
        id = _props.id;

    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + '-' + type + '-' + key : null;
      };
    }

    return {
      $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  PanelGroup.prototype.render = function render() {
    var _props2 = this.props,
        accordion = _props2.accordion,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['accordion', 'className', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, {
          bsStyle: child.props.bsStyle || bsProps.bsStyle
        });
      })
    );
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;
PanelGroup.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('panel-group', PanelGroup), {
  activeKey: 'onSelect'
}));

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(507), __esModule: true };

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(101);
var toIObject = __webpack_require__(73);
var isEnum = __webpack_require__(102).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = generatedId;
/* harmony export (immutable) */ __webpack_exports__["c"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["a"] = exclusiveRoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(36);





var idPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]);

function generatedId(name) {
  return function (props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var error = null;

    if (!props.generateChildId) {
      error = idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize the ' + name + ' in a way that is accessible to assistive technologies ' + ('(such as screen readers) an `id` or a `generateChildId` prop to ' + name + ' is required'));
      }
    }
    return error;
  };
}

function requiredRoles() {
  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing = void 0;

    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate = void 0;

    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);











var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  active: false
};

var BreadcrumbItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BreadcrumbItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  BreadcrumbItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        href = _props.href,
        title = _props.title,
        target = _props.target,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'href', 'title', 'target', 'className']);

    // Don't try to render these props on non-active <span>.


    var linkProps = { href: href, title: title, target: target };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }) },
      active ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', props) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, linkProps))
    );
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_transition__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_transition__);











var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);

    _this.state = {
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({ direction: null });
    }
  };

  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;

    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_9_dom_helpers_transition___default.a.end(__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  CarouselItem.prototype.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  CarouselItem.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        active = _props.active,
        animateIn = _props.animateIn,
        animateOut = _props.animateOut,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);

    delete props.onAnimateOutEnd;
    delete props.index;

    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };
    if (direction && active && animateIn) {
      classes[direction] = true;
    }
    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(519));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(251));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(18));

var _reactLifecyclesCompat = __webpack_require__(531);

var _PropTypes = __webpack_require__(532);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(529)();
}


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(84));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(85);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(254);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(86);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(182);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(183);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);













var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownToggle, _React$Component);

  function DropdownToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownToggle.prototype.render = function render() {
    var _props = this.props,
        noCaret = _props.noCaret,
        open = _props.open,
        useAnchor = _props.useAnchor,
        bsClass = _props.bsClass,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);

    delete props.bsRole;

    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__Button__["a" /* default */];
    var useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        role: 'button',
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, bsClass),
        'aria-haspopup': true,
        'aria-expanded': open
      }),
      children || props.title,
      useCaret && ' ',
      useCaret && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'caret' })
    );
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Grid, _React$Component);

  function Grid() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Grid.prototype.render = function render() {
    var _props = this.props,
        fluid = _props.fluid,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['fluid', 'componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, fluid && 'fluid');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('container', Grid));

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(33);













var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  listItem: false
};

var ListGroupItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListGroupItem, _React$Component);

  function ListGroupItem() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ListGroupItem);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'h4',
      { className: headingClassName },
      header
    );
  };

  ListGroupItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        className = _props.className,
        header = _props.header,
        listItem = _props.listItem,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component = void 0;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    // TODO: Deprecate `header` prop.
    if (header) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        Component,
        elementProps,
        this.renderHeader(header, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading')),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'p',
          { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'text') },
          children
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      elementProps,
      children
    );
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('list-group-item', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]), ListGroupItem)));

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(61));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(125);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(84);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(124);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(126);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(86);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(576);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalBody, _React$Component);

  function ModalBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal-body', ModalBody));

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalFooter, _React$Component);

  function ModalFooter() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalFooter);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalFooter.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal-footer', ModalFooter));

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CloseButton__ = __webpack_require__(176);













// TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};

var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })
};

var ModalHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalHeader, _React$Component);

  function ModalHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalHeader.prototype.render = function render() {
    var _props = this.props,
        closeLabel = _props.closeLabel,
        closeButton = _props.closeButton,
        onHide = _props.onHide,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);

    var modal = this.context.$bs_modal;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      closeButton && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CloseButton__["a" /* default */], {
        label: closeLabel,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
      }),
      children
    );
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal-header', ModalHeader));

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalTitle, _React$Component);

  function ModalTitle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalTitle.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal-title', ModalTitle));

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(36);

















// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?

// TODO: This `bsStyle` is very unlike the others. Should we rename it?

// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  justified: __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }),

  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired
  })
};

var Nav = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Nav, _React$Component);

  function Nav() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Nav);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;

    var children = this.props.children;

    var _getActiveProps = this.getActiveProps(),
        activeKey = _getActiveProps.activeKey,
        activeHref = _getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    });

    var childrenArray = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);

    var childNodes = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  Nav.prototype.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;

      return tabContainer;
    }

    return this.props;
  };

  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
    var _this3 = this;

    var children = this.props.children;

    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _getActiveProps2 = this.getActiveProps(),
        activeKey = _getActiveProps2.activeKey,
        activeHref = _getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this3.isActive(child, activeKey, activeHref);
    });

    // This assumes the active child is not disabled.
    var activeChildIndex = validChildren.indexOf(activeChild);
    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this4 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;


    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this4.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild = void 0;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;
      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  Nav.prototype.render = function render() {
    var _extends2,
        _this5 = this;

    var _props = this.props,
        stacked = _props.stacked,
        justified = _props.justified,
        onSelect = _props.onSelect,
        propsRole = _props.role,
        propsNavbar = _props.navbar,
        pullRight = _props.pullRight,
        pullLeft = _props.pullLeft,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _getActiveProps3 = this.getActiveProps(),
        activeKey = _getActiveProps3.activeKey,
        activeHref = _getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().
    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'stacked')] = stacked, _extends2[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName = void 0;
    var pullRightClassName = void 0;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

      classes[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'nav')] = true;

      pullRightClassName = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right');
      pullLeftClassName = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: role,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var active = _this5.isActive(child, activeKey, activeHref);
        var childOnSelect = Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);

        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
          active: active,
          activeKey: activeKey,
          activeHref: activeHref,
          onSelect: childOnSelect
        }));
      })
    );
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('nav', Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsStyles */])(['tabs', 'pills'], Nav)));

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarBrand = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarBrand, _React$Component);

  function NavbarBrand() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarBrand);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarBrand.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }),
      children
    );
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(26);












var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  active: false,
  disabled: false
};

var NavItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavItem, _React$Component);

  function NavItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  NavItem.prototype.handleClick = function handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  };

  NavItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        onClick = _props.onClick,
        className = _props.className,
        style = _props.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(122);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Overlay, _React$Component);

  function Overlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Overlay);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Overlay.prototype.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['animation', 'children']);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */] : animation || null;

    var child = void 0;

    if (!transition) {
      child = Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, { transition: transition }),
      child
    );
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(85));

var _isWindow = _interopRequireDefault(__webpack_require__(125));

var _ownerDocument = _interopRequireDefault(__webpack_require__(84));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 271 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(125));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(26);












var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PagerItem, _React$Component);

  function PagerItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PagerItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }

  PagerItem.prototype.handleSelect = function handleSelect(e) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  PagerItem.prototype.render = function render() {
    var _props2 = this.props,
        disabled = _props2.disabled,
        previous = _props2.previous,
        next = _props2.next,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { disabled: disabled, previous: previous, next: next }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
      }))
    );
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapse__ = __webpack_require__(180);










var propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  })
};

var PanelCollapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PanelCollapse, _React$Component);

  function PanelCollapse() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PanelCollapse);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelCollapse.prototype.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'in': expanded }, props),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'collapse') },
        children
      )
    );
  };

  return PanelCollapse;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelCollapse.propTypes = propTypes;
PanelCollapse.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelCollapse));

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(26);











var propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */]
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bodyId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  })
};

var PanelToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PanelToggle, _React$Component);

  function PanelToggle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PanelToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args)));

    _this.handleToggle = _this.handleToggle.bind(_this);
    return _this;
  }

  PanelToggle.prototype.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  PanelToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        componentClass = _props.componentClass,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onClick', 'className', 'componentClass']);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;

    props.onClick = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleToggle);

    props['aria-expanded'] = expanded;
    props.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, props);
  };

  return PanelToggle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelToggle.propTypes = propTypes;
PanelToggle.defaultProps = defaultProps;
PanelToggle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (PanelToggle);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fade__ = __webpack_require__(122);
















var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /** @private * */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /** @private * */
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
};

var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);

    _this.in = false;
    return _this;
  }

  TabPane.prototype.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  TabPane.prototype.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  TabPane.prototype.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  TabPane.prototype.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  TabPane.prototype.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  TabPane.prototype.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;

    return this.props.eventKey === activeKey;
  };

  TabPane.prototype.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  TabPane.prototype.render = function render() {
    var _props = this.props,
        eventKey = _props.eventKey,
        className = _props.className,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        propsMountOnEnter = _props.mountOnEnter,
        propsUnmountOnExit = _props.unmountOnExit,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);

    var _context = this.context,
        tabContent = _context.$bs_tabContent,
        tabContainer = _context.$bs_tabContainer;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();

    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_12__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(tabContent, 'pane');
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'tabpanel',
      'aria-hidden': !active,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Transition,
        {
          'in': active && !exiting,
          onEnter: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
          onEntering: onEntering,
          onEntered: onEntered,
          onExit: onExit,
          onExiting: onExiting,
          onExited: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
          mountOnEnter: mountOnEnter,
          unmountOnExit: unmountOnExit
        },
        pane
      );
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('tab-pane', TabPane));

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(104);










var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * [onChange description]
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired
};

var ToggleButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButton, _React$Component);

  function ToggleButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButton.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        name = _props.name,
        checked = _props.checked,
        type = _props.type,
        onChange = _props.onChange,
        value = _props.value,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);

    var disabled = props.disabled;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { active: !!checked, componentClass: 'label' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
        name: name,
        type: type,
        autoComplete: 'off',
        value: value,
        checked: !!checked,
        disabled: !!disabled,
        onChange: onChange
      }),
      children
    );
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(626);
var RequestBase = __webpack_require__(627);
var isObject = __webpack_require__(279);
var ResponseBase = __webpack_require__(628);
var Agent = __webpack_require__(630);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoginFields_css__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoginFields_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LoginFields_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TeachersComponent_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StudentsComponent_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_ico_close_png__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_ico_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_ico_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_pin_png__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_pin_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_pin_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_DataTrackingPoints__ = __webpack_require__(17);
var _this7=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'30%'}};// Modal.setAppElement('body');
var LoginFields=function(_Component){_inherits(LoginFields,_Component);function LoginFields(props){_classCallCheck(this,LoginFields);var _this=_possibleConstructorReturn(this,(LoginFields.__proto__||Object.getPrototypeOf(LoginFields)).call(this,props));_this.handleLoginEnterKeyPress=function(event){if(event.key=='Enter'){_this.handleSubmit();}};_this.handleResetEnterKeyPress=function(event){if(event.key=='Enter'){_this.resetSubmit(_this.state.resetType);}};_this.state={username:'',password:'',rememberMe:_this.props.rememberMe,isModalOpen:false,resetEmail:'',resetType:"username",email:"",submitting:false,emailGUID:null,newpassword:"",confirmpassword:"",usernameEmailError:'',passwordEmailError:'',errorEmailNoteUsername:'',errorEmailNotePassword:'',modalDialog:false,responseContent:'',infoWarning:'',checked:false,analytics:{type:null,metadata:null}};_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handlePassword=_this.handlePassword.bind(_this);_this.handleReset=_this.handleReset.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.closeModalSelf=_this.closeModalSelf.bind(_this);_this.resetSubmit=_this.resetSubmit.bind(_this);_this.handleResetEmailChange=_this.handleResetEmailChange.bind(_this);_this.handleNewPasswordChange=_this.handleNewPasswordChange.bind(_this);_this.handleConfirmPasswordChange=_this.handleConfirmPasswordChange.bind(_this);_this.changePasswordSubmit=_this.changePasswordSubmit.bind(_this);_this.closePasswordModal=_this.closePasswordModal.bind(_this);_this.handleInfoWindow=_this.handleInfoWindow.bind(_this);_this.handleChecked=_this.handleChecked.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);return _this;}_createClass(LoginFields,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.setState({emailGUID:localStorage.getItem('emailGUID')});case 2:if(!localStorage.getItem('checked')){_context.next=5;break;}_context.next=5;return this.setState({username:localStorage.getItem('usr'),password:localStorage.getItem('psw'),checked:true});case 5:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleChecked',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.setState({checked:this.state.checked?false:true},function(){if(_this2.state.checked==true){localStorage.setItem('usr',_this2.state.username);localStorage.setItem('psw',_this2.state.password);localStorage.setItem('checked',_this2.state.checked);}else{localStorage.removeItem('usr');localStorage.removeItem('psw');localStorage.removeItem('checked');}});case 2:case'end':return _context2.stop();}}},_callee2,this);}));function handleChecked(){return _ref2.apply(this,arguments);}return handleChecked;}()},{key:'handleInfoWindow',value:function handleInfoWindow(){this.setState({modalDialog:true,infoWarning:'Important. This is a test version of the new software. Please help us to improve the software. <br/>Use the <div id="bugReport" ></div> button to report errors or to recommend changes.',responseContent:''});}},{key:'openModal',value:function openModal(){this.setState({isModalOpen:true});}},{key:'closeModal',value:function closeModal(){this.setState({isModalOpen:false,email:""});}},{key:'closeModalSelf',value:function closeModalSelf(e){e.stopPropagation();this.setState({showModal:false});}},{key:'handleChange',value:function handleChange(event){this.setState({username:event.target.value,password:this.state.password});}},{key:'handleResetEmailChange',value:function handleResetEmailChange(event){this.setState({email:event.target.value.toLowerCase()});}},{key:'handlePassword',value:function handlePassword(event){this.setState({username:this.state.username,password:event.target.value});}},{key:'handleSubmit',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.setState({username:this.state.username.toString().replace(/\D/g,'')});case 2:if(this.state.username){_context3.next=5;break;}this.setState({modalDialog:true,responseContent:'User number is required!',infoWarning:null});return _context3.abrupt('return');case 5:if(this.state.password){_context3.next=8;break;}this.setState({modalDialog:true,responseContent:'Password is required!',infoWarning:null});return _context3.abrupt('return');case 8:this.tryLogin();case 9:case'end':return _context3.stop();}}},_callee3,this);}));function handleSubmit(_x){return _ref3.apply(this,arguments);}return handleSubmit;}()},{key:'handleReset',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(type){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return this.setState({isModalOpen:true,resetType:type});case 2:case'end':return _context4.stop();}}},_callee4,this);}));function handleReset(_x2){return _ref4.apply(this,arguments);}return handleReset;}()},{key:'validate',value:function validate(){var valid=true;if(this.state.resetType==="username"){if(this.state.email===null||this.state.email.length===0){valid=false;this.setState({usernameEmailError:'validationRed'});}else{this.setState({usernameEmailError:''});}}else{if(this.state.email===null||this.state.email.length===0){valid=false;this.setState({passwordEmailError:'validationRed'});}else{this.setState({passwordEmailError:''});}}return valid;//TODO: check email for regex
}},{key:'validateEmail',value:function validateEmail(email){var re=/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;return re.test(email);}},{key:'resetSubmit',value:function resetSubmit(type){var _this3=this;this.setState({submitting:true});if(type==="password"){if(this.validate()){this.setState({errorEmailNotePassword:''});__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].resetPassword({email:this.state.email}).then(function(res){_this3.setState({errorEmailNotePassword:'',passwordEmailError:'',modalDialog:true,responseContent:'An email with the password has been sent to the email provided.',infoWarning:null});_this3.closeModal();setTimeout(function(){_this3.setState({modalDialog:false});},3500);_this3.setState({submitting:false});}).catch(function(e){_this3.setState({submitting:false,errorEmailNotePassword:'Invalid email provided.'});});}else{this.setState({submitting:false});this.setState({errorEmailNotePassword:'Email address format is invalid'});}}else{if(this.validate()){this.setState({errorEmailNoteUsername:''});__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].resetUsername({email:this.state.email}).then(function(res){_this3.setState({errorEmailNoteUsername:'',usernameEmailError:'',modalDialog:true,responseContent:'An email with the username has been sent to the email provided.',infoWarning:null});_this3.closeModal();setTimeout(function(){_this3.setState({modalDialog:false});},3500);_this3.setState({submitting:false});}).catch(function(e){_this3.setState({submitting:false,errorEmailNoteUsername:'Invalid email provided.'});});}else{this.setState({submitting:false});this.setState({errorEmailNoteUsername:'Email address format is invalid'});}}}},{key:'closePasswordModal',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return this.setState({emailGUID:null,confirmpassword:""});case 2:_context5.next=4;return localStorage.removeItem('emailGUID');case 4:_context5.next=6;return localStorage.clear();case 6:case'end':return _context5.stop();}}},_callee5,this);}));function closePasswordModal(){return _ref5.apply(this,arguments);}return closePasswordModal;}()},{key:'handleNewPasswordChange',value:function handleNewPasswordChange(event){this.setState({newpassword:event.target.value});}},{key:'handleConfirmPasswordChange',value:function handleConfirmPasswordChange(event){this.setState({confirmpassword:event.target.value});}},{key:'changePasswordSubmit',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!(this.state.newpassword.length>0&&this.state.newpassword===this.state.confirmpassword)){_context7.next=7;break;}_context7.next=3;return this.setState({submitting:true});case 3:_context7.next=5;return __WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].changePassword({emailGUID:this.state.emailGUID,password:this.state.newpassword}).then(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return _this4.closePasswordModal();case 2:_context6.next=4;return _this4.setState({submitting:false,username:res.body.id.toString(),password:_this4.state.newpassword,modalDialog:true,responseContent:'Password Changed Successfully.',infoWarning:null});case 4:setTimeout(function(){_this4.setState({modalDialog:false});_this4.tryLogin();},3500);case 5:case'end':return _context6.stop();}}},_callee6,_this4);}));return function(_x3){return _ref7.apply(this,arguments);};}()).catch(function(e){_this4.setState({submitting:false,modalDialog:true,responseContent:'Invalid data provided.',infoWarning:null});_this4.closePasswordModal();setTimeout(function(){_this4.setState({modalDialog:false});},3500);});case 5:_context7.next=9;break;case 7:this.setState({modalDialog:true,responseContent:'Please fill out all fields correctly.',infoWarning:null});setTimeout(function(){_this4.setState({modalDialog:false});},3500);case 9:case'end':return _context7.stop();}}},_callee7,this);}));function changePasswordSubmit(){return _ref6.apply(this,arguments);}return changePasswordSubmit;}()},{key:'tryLogin',value:function tryLogin(){var _this5=this;__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].login(this.state.username,this.state.password).then(function(result){if(result.success){localStorage.setItem('token',result.body.token);if(result.body.user.role==="teacher"){_this5.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_13__Shared_DataTrackingPoints__["b" /* default */].TEACHER_LOGIN,metadata:{userId:result.body.user.id,platform:navigator.platform,userAgent:navigator.userAgent}}},function(){return _this5.handleAnalytics();});_this5.props.updateTeacher(result.body.user);_this5.props.updateSchoolAdmin(null);}else if(result.body.user.role==="student"){_this5.props.updateStudentUser(result.body.user);_this5.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_13__Shared_DataTrackingPoints__["b" /* default */].STUDENT_LOGIN,metadata:{userId:result.body.user.id,platform:navigator.platform,userAgent:navigator.userAgent}}},function(){return _this5.handleAnalytics();});_this5.props.updateFirstLogin(true);}else if(result.body.user.role==="school-admin"){_this5.props.updateTeacher(null);_this5.props.updateSchoolAdmin(result.body.user);_this5.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_13__Shared_DataTrackingPoints__["b" /* default */].SCHOOL_ADMIN_LOGIN,metadata:{userId:result.body.user.id,platform:navigator.platform,userAgent:navigator.userAgent}}},function(){return _this5.handleAnalytics();});}else if(result.body.user.role==="parent"){_this5.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_13__Shared_DataTrackingPoints__["b" /* default */].PARENT_LOGIN,metadata:{userId:result.body.user.id,platform:navigator.platform,userAgent:navigator.userAgent}}},function(){return _this5.handleAnalytics();});}_this5.props.callbackFromParent(result.body.user);_this5.props.history.push('/'+result.body.user.role);}else{_this5.setState({modalDialog:true,responseContent:result.msg,infoWarning:null});setTimeout(function(){_this5.setState({modalDialog:false});},2500);}},function(error){console.log('Error',error.msg);_this5.setState({modalDialog:true,responseContent:error,infoWarning:null});setTimeout(function(){_this5.setState({modalDialog:false});},2500);});}},{key:'render',value:function render(){var _this6=this;if(this.user){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Redirect */],{to:{pathname:"/",state:{from:this.props.location}}});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'pinIcon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__assets_images_pin_png___default.a,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'formLogin'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Log in to AvenuePM'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-title'},'User Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.username,className:'form-control',onChange:this.handleChange,placeholder:'User Number',onKeyPress:this.handleLoginEnterKeyPress,required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-title'},'Password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'password',value:this.state.password,className:'form-control',onChange:this.handlePassword,placeholder:'Password',onKeyPress:this.handleLoginEnterKeyPress,required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'login-extra'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){return _this6.handleReset("username");},className:'login-other'},'Forgot User Number')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){return _this6.handleReset("password");},className:'login-other'},'Forgot Password'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'checkbox',style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',name:'rememberMe',defaultChecked:localStorage.getItem('checked'),onChange:this.handleChecked}),'Remember Me')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-10 col-xs-9"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:this.handleSubmit,name:'Login',className:'btn btn-primary loginButton'},'Log In')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'createAccountLabel',className:'fl'},'New here?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'createAccountLink',href:'/request-account',className:'fr'},'Create a new account'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["a" /* Modal */],{id:"getusernamepassword",show:this.state.isModalOpen},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body",style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{cursor:"pointer"},onClick:this.closeModal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{width:30,marginTop:25,float:'right'},src:__WEBPACK_IMPORTED_MODULE_11__assets_images_ico_close_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,this.state.resetType==="username"?"GET USER NUMBER":"RESET PASSWORD"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{color:'red'}},this.state.resetType==="password"?this.state.errorEmailNotePassword:this.state.errorEmailNoteUsername),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{style:{marginBottom:25},id:this.state.resetType==="password"?"inputResetPassword":"inputGetUsername",required:true,value:this.state.value,className:this.state.resetType==="password"?"form-control "+this.state.passwordEmailError:"form-control "+this.state.usernameEmailError,onChange:this.handleResetEmailChange,placeholder:this.state.resetType==="password"?"Email":"Email",onKeyPress:this.handleResetEnterKeyPress}),this.state.submitting?"Please Wait...":__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){return _this6.resetSubmit(_this6.state.resetType);},name:'Submit',className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Submit'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,infoWarning:this.state.infoWarning,sectionContent:this.state.responseContent,htmlSection:true,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["a" /* Modal */],{show:this.state.emailGUID!=null,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body",style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Change Password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:"password",required:true,className:'form-control',onChange:this.handleNewPasswordChange,placeholder:"Password"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:"password",required:true,className:'form-control',onChange:this.handleConfirmPasswordChange,placeholder:"Confirm Password"}),this.state.newpassword.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'The password must not be empty..')):null,this.state.confirmpassword!==this.state.newpassword?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Passwords must match')):null),this.state.submitting?"Please Wait...":__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){return _this6.changePasswordSubmit();},type:"submit",name:'Submit',className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Submit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.closePasswordModal,style:{marginLeft:5},name:'Close',className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))));}}]);return LoginFields;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateFirstLogin:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__StudentsComponent_actions__["b" /* updateFirstLogin */])(results));case 2:return _context8.abrupt('return',_context8.sent);case 3:case'end':return _context8.stop();}}},_callee8,_this7);}));function updateFirstLogin(_x4){return _ref8.apply(this,arguments);}return updateFirstLogin;}(),updateTeacher:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__TeachersComponent_actions__["i" /* updateTeacher */])(data));case 2:return _context9.abrupt('return',_context9.sent);case 3:case'end':return _context9.stop();}}},_callee9,_this7);}));function updateTeacher(_x5){return _ref9.apply(this,arguments);}return updateTeacher;}(),updateStudentUser:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__StudentsComponent_actions__["f" /* updateStudentUser */])(data));case 2:return _context10.abrupt('return',_context10.sent);case 3:case'end':return _context10.stop();}}},_callee10,_this7);}));function updateStudentUser(_x6){return _ref10.apply(this,arguments);}return updateStudentUser;}(),updateSchoolAdmin:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__TeachersComponent_actions__["g" /* updateSchoolAdmin */])(data));case 2:return _context11.abrupt('return',_context11.sent);case 3:case'end':return _context11.stop();}}},_callee11,_this7);}));function updateSchoolAdmin(_x7){return _ref11.apply(this,arguments);}return updateSchoolAdmin;}()};};var mapStateToProps=function mapStateToProps(state){return{firstLogin:state.studentReducer.firstLogin,teacher:state.teacherReducer.teacher,studentUser:state.studentReducer.studentUser,schoolAdmin:state.teacherReducer.schoolAdmin};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* withRouter */])(LoginFields)));

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string") {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(641);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YouTube = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})/;

var YouTube = exports.YouTube = function (_Component) {
  _inherits(YouTube, _Component);

  function YouTube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onStateChange = function (_ref2) {
      var data = _ref2.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) onPlay();
      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();
      if (data === ENDED) onEnded();
      if (data === CUED) onReady();
    }, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unMute');
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(YouTube, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          muted = _props.muted,
          playsinline = _props.playsinline,
          controls = _props.controls,
          config = _props.config,
          _onError = _props.onError;

      var id = url && url.match(MATCH_URL)[1];
      if (isReady) {
        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url)
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, {
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _extends({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin,
            playsinline: playsinline
          }, config.youtube.playerVars),
          events: {
            onReady: _this2.props.onReady,
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        });
      }, _onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%'
      }, this.props.style);
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }]);

  return YouTube;
}(_react.Component);

YouTube.displayName = 'YouTube';

YouTube.canPlay = function (url) {
  return MATCH_URL.test(url);
};

YouTube.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(YouTube);

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundCloud = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';
var MATCH_URL = /(soundcloud\.com|snd\.sc)\/.+$/;

var SoundCloud = exports.SoundCloud = function (_Component) {
  _inherits(SoundCloud, _Component);

  function SoundCloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.fractionLoaded = null, _this.mute = function () {
      _this.setVolume(0);
    }, _this.unmute = function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SoundCloud, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);
          _this2.player.bind(PLAY, _this2.props.onPlay);
          _this2.player.bind(PAUSE, _this2.props.onPause);
          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });
          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });
          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }
        _this2.player.load(url, _extends({}, _this2.props.config.soundcloud.options, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;
              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%'
      }, this.props.style);
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        src: 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(this.props.url),
        style: style,
        frameBorder: 0
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

SoundCloud.displayName = 'SoundCloud';

SoundCloud.canPlay = function (url) {
  return MATCH_URL.test(url);
};

SoundCloud.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(SoundCloud);

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vimeo = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';
var MATCH_URL = /vimeo\.com\/.+/;
var MATCH_FILE_URL = /vimeo\.com\/external\/.+\.mp4/;

var Vimeo = exports.Vimeo = function (_Component) {
  _inherits(Vimeo, _Component);

  function Vimeo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      _this.setVolume(0);
    }, _this.unmute = function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Vimeo, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        _this2.player = new Vimeo.Player(_this2.container, _extends({}, _this2.props.config.vimeo.playerOptions, {
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop
        }));
        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');
          iframe.style.width = '100%';
          iframe.style.height = '100%';
        })['catch'](_this2.props.onError);
        _this2.player.on('loaded', function () {
          _this2.props.onReady();
          _this2.player.getDuration().then(function (duration) {
            _this2.duration = duration;
          });
        });
        _this2.player.on('play', _this2.props.onPlay);
        _this2.player.on('pause', _this2.props.onPause);
        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });
        _this2.player.on('ended', _this2.props.onEnded);
        _this2.player.on('error', _this2.props.onError);
        _this2.player.on('timeupdate', function (_ref2) {
          var seconds = _ref2.seconds;

          _this2.currentTime = seconds;
        });
        _this2.player.on('progress', function (_ref3) {
          var seconds = _ref3.seconds;

          _this2.secondsLoaded = seconds;
        });
      }, this.props.onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: 'black'
      }, this.props.style);
      return _react2['default'].createElement('div', {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

Vimeo.displayName = 'Vimeo';

Vimeo.canPlay = function (url) {
  if (MATCH_FILE_URL.test(url)) {
    return false;
  }
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Vimeo);

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DailyMotion = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';
var MATCH_URL = /dailymotion\.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/;

var DailyMotion = exports.DailyMotion = function (_Component) {
  _inherits(DailyMotion, _Component);

  function DailyMotion() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DailyMotion.__proto__ || Object.getPrototypeOf(DailyMotion)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onDurationChange = function () {
      var duration = _this.getDuration();
      _this.props.onDuration(duration);
    }, _this.mute = function () {
      _this.callPlayer('setMuted', true);
    }, _this.unmute = function () {
      _this.callPlayer('setMuted', false);
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DailyMotion, [{
    key: 'parseId',
    value: function parseId(url) {
      var m = url.match(MATCH_URL);
      return m[4] || m[2];
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props = this.props,
          controls = _props.controls,
          config = _props.config,
          onError = _props.onError,
          playing = _props.playing;

      var id = this.parseId(url);
      if (this.player) {
        this.player.load(id, {
          start: (0, _utils.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _extends({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }, config.dailymotion.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%',
        backgroundColor: 'black'
      }, this.props.style);
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }]);

  return DailyMotion;
}(_react.Component);

DailyMotion.displayName = 'DailyMotion';

DailyMotion.canPlay = function (url) {
  return MATCH_URL.test(url);
};

DailyMotion.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(DailyMotion);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePlayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
var HLS_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/0.9.1/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/2.6.5/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;

function canPlay(url) {
  if (url instanceof Array) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = url[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        if (typeof item === 'string' && canPlay(item)) {
          return true;
        }
        if (canPlay(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  }
  if (url instanceof window.MediaStream) {
    return true;
  }
  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
}

var FilePlayer = exports.FilePlayer = function (_Component) {
  _inherits(FilePlayer, _Component);

  function FilePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.onSeek = function (e) {
      _this.props.onSeek(e.target.currentTime);
    }, _this.mute = function () {
      _this.player.muted = true;
    }, _this.unmute = function () {
      _this.player.muted = false;
    }, _this.renderSourceElement = function (source, index) {
      if (typeof source === 'string') {
        return _react2['default'].createElement('source', { key: index, src: source });
      }
      return _react2['default'].createElement('source', _extends({ key: index }, source));
    }, _this.renderTrack = function (track, index) {
      return _react2['default'].createElement('track', _extends({ key: index }, track));
    }, _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
      if (IOS) {
        this.player.load();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(nextProps)) {
        this.removeListeners();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.addListeners();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      var _props = this.props,
          onReady = _props.onReady,
          onPlay = _props.onPlay,
          onPause = _props.onPause,
          onEnded = _props.onEnded,
          onError = _props.onError,
          playsinline = _props.playsinline;

      this.player.addEventListener('canplay', onReady);
      this.player.addEventListener('play', onPlay);
      this.player.addEventListener('pause', onPause);
      this.player.addEventListener('seeked', this.onSeek);
      this.player.addEventListener('ended', onEnded);
      this.player.addEventListener('error', onError);
      if (playsinline) {
        this.player.setAttribute('playsinline', '');
        this.player.setAttribute('webkit-playsinline', '');
      }
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      var _props2 = this.props,
          onReady = _props2.onReady,
          onPlay = _props2.onPlay,
          onPause = _props2.onPause,
          onEnded = _props2.onEnded,
          onError = _props2.onError;

      this.player.removeEventListener('canplay', onReady);
      this.player.removeEventListener('play', onPlay);
      this.player.removeEventListener('pause', onPause);
      this.player.removeEventListener('seeked', this.onSeek);
      this.player.removeEventListener('ended', onEnded);
      this.player.removeEventListener('error', onError);
    }
  }, {
    key: 'shouldUseAudio',
    value: function shouldUseAudio(props) {
      if (props.config.file.forceVideo) {
        return false;
      }
      if (props.config.file.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }
      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
    }
  }, {
    key: 'shouldUseHLS',
    value: function shouldUseHLS(url) {
      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
    }
  }, {
    key: 'shouldUseDASH',
    value: function shouldUseDASH(url) {
      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      if (this.shouldUseHLS(url)) {
        (0, _utils.getSDK)(HLS_SDK_URL, HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);
          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });
          _this2.hls.loadSource(url);
          _this2.hls.attachMedia(_this2.player);
        });
      }
      if (this.shouldUseDASH(url)) {
        (0, _utils.getSDK)(DASH_SDK_URL, DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();
          _this2.dash.initialize(_this2.player, url, _this2.props.playing);
          _this2.dash.getDebug().setLogToBrowserConsole(false);
        });
      }
      if (url instanceof window.MediaStream) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var promise = this.player.play();
      if (promise) {
        promise['catch'](this.props.onError);
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.player.removeAttribute('src');
      if (this.hls) {
        this.hls.destroy();
      }
      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.player.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }
      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();
      if (end > duration) {
        return duration;
      }
      return end;
    }
  }, {
    key: 'getSource',
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);
      if (url instanceof Array || url instanceof window.MediaStream || useHLS || useDASH) {
        return undefined;
      }
      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }
      return url;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          url = _props3.url,
          playing = _props3.playing,
          loop = _props3.loop,
          controls = _props3.controls,
          muted = _props3.muted,
          config = _props3.config,
          width = _props3.width,
          height = _props3.height;

      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return _react2['default'].createElement(
        Element,
        _extends({
          ref: this.ref,
          src: this.getSource(url),
          style: style,
          preload: 'auto',
          autoPlay: playing,
          controls: controls,
          muted: muted,
          loop: loop
        }, config.file.attributes),
        url instanceof Array && url.map(this.renderSourceElement),
        config.file.tracks.map(this.renderTrack)
      );
    }
  }]);

  return FilePlayer;
}(_react.Component);

FilePlayer.displayName = 'FilePlayer';
FilePlayer.canPlay = canPlay;
exports['default'] = (0, _singlePlayer2['default'])(FilePlayer);

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Animated = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(652);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _browserOrNode = __webpack_require__(668);

var _propTypes = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isLteIE9 = function isLteIE9() {
  var ua = _browserOrNode.isBrowser ? window.navigator.userAgent : "";
  var ie = ua.indexOf("MSIE ");
  return ie > -1 && parseInt(ua.substring(ie + 5, ua.indexOf(".", ie)), 10) <= 9;
};

var Animated = exports.Animated = function (_React$Component) {
  _inherits(Animated, _React$Component);

  function Animated(props) {
    _classCallCheck(this, Animated);

    var _this = _possibleConstructorReturn(this, (Animated.__proto__ || Object.getPrototypeOf(Animated)).call(this, props));

    _this.state = props.animateOnMount ? {
      animation: props.isVisible ? props.animationIn : props.animationOut,
      delay: props.isVisible ? props.animationInDelay : props.animationOutDelay
    } : {};
    return _this;
  }

  _createClass(Animated, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var isVisible = nextProps.isVisible;

      if (isVisible !== this.props.isVisible) {
        var _props = this.props,
            animationIn = _props.animationIn,
            animationOut = _props.animationOut,
            animationInDelay = _props.animationInDelay,
            animationOutDelay = _props.animationOutDelay;

        this.setState({
          animation: isVisible ? animationIn : animationOut,
          delay: isVisible ? animationInDelay : animationOutDelay
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          style = _props2.style,
          isVisible = _props2.isVisible,
          innerRef = _props2.innerRef,
          className = _props2.className;
      var _state = this.state,
          animation = _state.animation,
          delay = _state.delay;


      var classes = (0, _classnames2.default)("animated", animation, className);

      if (isLteIE9() || !animation) {
        style.opacity = isVisible ? 1 : 0;
      }

      return _react2.default.createElement(
        "div",
        {
          className: classes,
          ref: innerRef,
          style: _extends({
            animationDelay: delay + "ms",
            pointerEvents: isVisible ? "all" : "none"
          }, style)
        },
        children
      );
    }
  }]);

  return Animated;
}(_react2.default.Component);

Animated.propTypes = {
  animationIn: _propTypes.string,
  animationOut: _propTypes.string,
  animationInDelay: _propTypes.number,
  animationOutDelay: _propTypes.number,
  style: _propTypes.object,
  isVisible: _propTypes.bool,
  innerRef: _propTypes.func,
  className: _propTypes.string,
  animateOnMount: _propTypes.bool
};

Animated.defaultProps = {
  animationIn: "fadeIn",
  animationOut: "fadeOut",
  className: "",
  animationInDelay: 0,
  animationOutDelay: 0,
  isVisible: true,
  style: {},
  animateOnMount: true
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(129),
    _assign = __webpack_require__(56);

var ReactNoopUpdateQueue = __webpack_require__(291);

var canDefineProperty = __webpack_require__(292);
var emptyObject = __webpack_require__(293);
var invariant = __webpack_require__(57);
var lowPriorityWarning = __webpack_require__(654);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(130);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(56);

var emptyObject = __webpack_require__(293);
var _invariant = __webpack_require__(57);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level0.f8aea238.png";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level1.552e6455.png";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level2.22a39bb7.png";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level3.da70af4e.png";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level4.998128bf.png";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level5.87ac6ba2.png";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level6.273e3c46.png";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level7.874b1d50.png";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level8.bc345a83.png";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level9.2dfb7747.png";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level10.c03e9320.png";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal_level11.24635dfd.png";

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var http = __webpack_require__(696);

var NetworkSpeedCheck = function() {};

NetworkSpeedCheck.prototype.checkDownloadSpeed = function(url, fileSize) {
  var startTime;
  var speedData;
  var baseUrl = url;
  var downloadSize = fileSize;
  return new Promise(function(resolve, reject) {
    return http.get(baseUrl, function(response) {
      response.once('data', function(data) {
        startTime = new Date().getTime();
      });

      response.once('end', function() {
        var endTime = new Date().getTime();
        var duration = (endTime - startTime) / 1000;
        var bitsLoaded = downloadSize * 8;
        var speedBps = (bitsLoaded / duration).toFixed(2);
        var speedKbps = (speedBps / 1024).toFixed(2);
        var speedMbps = (speedKbps / 1024).toFixed(2);
        speedData = {bps: speedBps, kbps: speedKbps, mbps: speedMbps};
        resolve(speedData);
      });
    });
  })
  .catch(function(error) {
    throw new Error (error);
  });
};

NetworkSpeedCheck.prototype.checkUploadSpeed = function(options) {
  var startTime;
  var speedData;
  var data = '{"data": "' + this.generateTestData(20) + '"}';
  return new Promise(function(resolve, reject) {
    var req = http.request(options, function(res) {
      res.setEncoding('utf8');
      res.on('data', function (body) {
        startTime = new Date().getTime();
      });
      res.on('end', function() {
        var endTime = new Date().getTime();
        var duration = (endTime - startTime) / 1000;
        var bitsLoaded = 20 * 8;
        var speedBps = (bitsLoaded / duration).toFixed(2);
        var speedKbps = (speedBps / 1024).toFixed(2);
        var speedMbps = (speedKbps / 1024).toFixed(2);
        speedData = {bps: speedBps, kbps: speedKbps, mbps: speedMbps};
        resolve(speedData);
      });
    });
    req.write(data);
    req.end();
  })
  .catch(function(error) {
    throw new Error (error);
  });
};

NetworkSpeedCheck.prototype.generateTestData = function(sizeInKmb) {
  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789~!@#$%^&*()_+`-=[]\{}|;':,./<>?";
  var iterations = sizeInKmb * 1024; //get byte count
  var result = '';
  for( var index = 0; index < iterations; index++ ) {
      result += chars.charAt( Math.floor( Math.random() * chars.length ) );
  }
  return result;
};

module.exports = NetworkSpeedCheck;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)

exports.writableStream = isFunction(global.WritableStream)

exports.abortController = isFunction(global.AbortController)

exports.blobConstructor = false
try {
	new Blob([new ArrayBuffer(1)])
	exports.blobConstructor = true
} catch (e) {}

// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr
function getXHR () {
	// Cache the xhr value
	if (xhr !== undefined) return xhr

	if (global.XMLHttpRequest) {
		xhr = new global.XMLHttpRequest()
		// If XDomainRequest is available (ie only, where xhr might not work
		// cross domain), use the page location. Otherwise use example.com
		// Note: this doesn't actually make an http request.
		try {
			xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
		} catch(e) {
			xhr = null
		}
	} else {
		// Service workers don't have XHR
		xhr = null
	}
	return xhr
}

function checkTypeSupport (type) {
	var xhr = getXHR()
	if (!xhr) return false
	try {
		xhr.responseType = type
		return xhr.responseType === type
	} catch (e) {}
	return false
}

// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
// Safari 7.1 appears to have fixed this bug.
var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined'
var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice)

// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || (haveArrayBuffer && checkTypeSupport('arraybuffer'))

// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream')
exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer &&
	checkTypeSupport('moz-chunked-arraybuffer')

// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)

exports.vbArray = isFunction(global.VBArray)

function isFunction (value) {
	return typeof value === 'function'
}

xhr = null // Help gc

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {var capability = __webpack_require__(312)
var inherits = __webpack_require__(63)
var stream = __webpack_require__(314)

var rStates = exports.readyStates = {
	UNSENT: 0,
	OPENED: 1,
	HEADERS_RECEIVED: 2,
	LOADING: 3,
	DONE: 4
}

var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, fetchTimer) {
	var self = this
	stream.Readable.call(self)

	self._mode = mode
	self.headers = {}
	self.rawHeaders = []
	self.trailers = {}
	self.rawTrailers = []

	// Fake the 'close' event, but only once 'end' fires
	self.on('end', function () {
		// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
		process.nextTick(function () {
			self.emit('close')
		})
	})

	if (mode === 'fetch') {
		self._fetchResponse = response

		self.url = response.url
		self.statusCode = response.status
		self.statusMessage = response.statusText
		
		response.headers.forEach(function (header, key){
			self.headers[key.toLowerCase()] = header
			self.rawHeaders.push(key, header)
		})

		if (capability.writableStream) {
			var writable = new WritableStream({
				write: function (chunk) {
					return new Promise(function (resolve, reject) {
						if (self._destroyed) {
							reject()
						} else if(self.push(new Buffer(chunk))) {
							resolve()
						} else {
							self._resumeFetch = resolve
						}
					})
				},
				close: function () {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.push(null)
				},
				abort: function (err) {
					if (!self._destroyed)
						self.emit('error', err)
				}
			})

			try {
				response.body.pipeTo(writable).catch(function (err) {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.emit('error', err)
				})
				return
			} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
		}
		// fallback for when writableStream or pipeTo aren't available
		var reader = response.body.getReader()
		function read () {
			reader.read().then(function (result) {
				if (self._destroyed)
					return
				if (result.done) {
					global.clearTimeout(fetchTimer)
					self.push(null)
					return
				}
				self.push(new Buffer(result.value))
				read()
			}).catch(function (err) {
				global.clearTimeout(fetchTimer)
				if (!self._destroyed)
					self.emit('error', err)
			})
		}
		read()
	} else {
		self._xhr = xhr
		self._pos = 0

		self.url = xhr.responseURL
		self.statusCode = xhr.status
		self.statusMessage = xhr.statusText
		var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
		headers.forEach(function (header) {
			var matches = header.match(/^([^:]+):\s*(.*)/)
			if (matches) {
				var key = matches[1].toLowerCase()
				if (key === 'set-cookie') {
					if (self.headers[key] === undefined) {
						self.headers[key] = []
					}
					self.headers[key].push(matches[2])
				} else if (self.headers[key] !== undefined) {
					self.headers[key] += ', ' + matches[2]
				} else {
					self.headers[key] = matches[2]
				}
				self.rawHeaders.push(matches[1], matches[2])
			}
		})

		self._charset = 'x-user-defined'
		if (!capability.overrideMimeType) {
			var mimeType = self.rawHeaders['mime-type']
			if (mimeType) {
				var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
				if (charsetMatch) {
					self._charset = charsetMatch[1].toLowerCase()
				}
			}
			if (!self._charset)
				self._charset = 'utf-8' // best guess
		}
	}
}

inherits(IncomingMessage, stream.Readable)

IncomingMessage.prototype._read = function () {
	var self = this

	var resolve = self._resumeFetch
	if (resolve) {
		self._resumeFetch = null
		resolve()
	}
}

IncomingMessage.prototype._onXHRProgress = function () {
	var self = this

	var xhr = self._xhr

	var response = null
	switch (self._mode) {
		case 'text:vbarray': // For IE9
			if (xhr.readyState !== rStates.DONE)
				break
			try {
				// This fails in IE8
				response = new global.VBArray(xhr.responseBody).toArray()
			} catch (e) {}
			if (response !== null) {
				self.push(new Buffer(response))
				break
			}
			// Falls through in IE8	
		case 'text':
			try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
				response = xhr.responseText
			} catch (e) {
				self._mode = 'text:vbarray'
				break
			}
			if (response.length > self._pos) {
				var newData = response.substr(self._pos)
				if (self._charset === 'x-user-defined') {
					var buffer = new Buffer(newData.length)
					for (var i = 0; i < newData.length; i++)
						buffer[i] = newData.charCodeAt(i) & 0xff

					self.push(buffer)
				} else {
					self.push(newData, self._charset)
				}
				self._pos = response.length
			}
			break
		case 'arraybuffer':
			if (xhr.readyState !== rStates.DONE || !xhr.response)
				break
			response = xhr.response
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'moz-chunked-arraybuffer': // take whole
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING || !response)
				break
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'ms-stream':
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING)
				break
			var reader = new global.MSStreamReader()
			reader.onprogress = function () {
				if (reader.result.byteLength > self._pos) {
					self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))))
					self._pos = reader.result.byteLength
				}
			}
			reader.onload = function () {
				self.push(null)
			}
			// reader.onerror = ??? // TODO: this
			reader.readAsArrayBuffer(response)
			break
	}

	// The ms-stream case handles end separately in reader.onload()
	if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
		self.push(null)
	}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(106).Buffer, __webpack_require__(25)))

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(315);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(319);
exports.Duplex = __webpack_require__(88);
exports.Transform = __webpack_require__(321);
exports.PassThrough = __webpack_require__(705);


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(138);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(311);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(316).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(317);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(139).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(63);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(700);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(701);
var destroyImpl = __webpack_require__(318);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(88);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(320).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(88);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(320).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25), __webpack_require__(58)))

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(316).EventEmitter;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(138);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(138);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(63);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(704)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(317);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(139).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(318);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(88);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(88);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(40).setImmediate, __webpack_require__(25)))

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(139).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(88);

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(63);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal1.c93bfc2b.png";

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal2.05f20712.png";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal3.a71ca673.png";

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Emotion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ThemeContext; });
/* unused harmony export _ */
/* unused harmony export a */
/* unused harmony export b */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createEmotionProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasOwnProperty; });
/* unused harmony export u */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return withEmotionCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_cache__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isolated_hnrs_dist_emotion_react_isolated_hnrs_browser_esm_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_utils__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emotion_serialize__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_use_insertion_effect_with_fallbacks__ = __webpack_require__(332);









var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_1__emotion_cache__["a" /* default */])({
  key: 'css'
}) : null);

if (false) {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
    // the cache will never be null in the browser
    var cache = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({});

if (false) {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var useTheme = function useTheme() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {
      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
    }

    return mergedTheme;
  }

  if (false) {
    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (outerTheme) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider(props) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ThemeContext);
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Component, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return Object(__WEBPACK_IMPORTED_MODULE_4__isolated_hnrs_dist_emotion_react_isolated_hnrs_browser_esm_js__["a" /* default */])(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  Object(__WEBPACK_IMPORTED_MODULE_5__emotion_utils__["c" /* registerStyles */])(cache, serialized, isStringTag);
  var rules = Object(__WEBPACK_IMPORTED_MODULE_7__emotion_use_insertion_effect_with_fallbacks__["a" /* useInsertionEffectAlwaysWithSyncFallback */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_5__emotion_utils__["b" /* insertStyles */])(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_utils__["a" /* getRegisteredStyles */])(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_6__emotion_serialize__["a" /* serializeStyles */])(registeredStyles, undefined, Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ThemeContext));

  if (false) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ("production" === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, newProps));
});

if (false) {
  Emotion.displayName = 'EmotionCssPropInternal';
}




/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks

var hoistNonReactStatics = (function (targetComponent, sourceComponent) {
  return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(targetComponent, sourceComponent);
});

/* harmony default export */ __webpack_exports__["a"] = (hoistNonReactStatics);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(722);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return registerStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(326);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(var|attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (false) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useInsertionEffectAlwaysWithSyncFallback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useInsertionEffectWithLayoutFallback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);



var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = __WEBPACK_IMPORTED_MODULE_0_react__['useInsertion' + 'Effect'] ? __WEBPACK_IMPORTED_MODULE_0_react__['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback =  useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"];




/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(730);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(335);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(736);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(737);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(738);

var iterableToArray = __webpack_require__(739);

var unsupportedIterableToArray = __webpack_require__(224);

var nonIterableSpread = __webpack_require__(740);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 339 */
/***/ (function(module, exports) {

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 340 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select_creatable__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomeHeaderComponent_HomeHeader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_ideasthatwork_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_ideasthatwork_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_ideasthatwork_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Facebook_logo_png__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Facebook_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_Facebook_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EduEmail=false;var RequestAccountComponent=function(_Component){_inherits(RequestAccountComponent,_Component);function RequestAccountComponent(props){_classCallCheck(this,RequestAccountComponent);var _this=_possibleConstructorReturn(this,(RequestAccountComponent.__proto__||Object.getPrototypeOf(RequestAccountComponent)).call(this,props));_this.handleSchoolChange=function(newValue){_this.setState({schoolValue:newValue});};_this.state={firstName:'',lastName:'',jobTitle:'',isTeacher:false,eMail:'',reason:'',done:false,warning:'',errorEmail:'',checkEmail:false,confirmEmail:'',errorConfirmEmail:'',emailMatch:false,validated:false,modalDialog:false,responseContent:'',isLoading:false,schoolOptions:'',schoolValue:''};_this.handleFirstNameChange=_this.handleFirstNameChange.bind(_this);_this.handleLastNameChange=_this.handleLastNameChange.bind(_this);_this.handleJobTitleChange=_this.handleJobTitleChange.bind(_this);_this.handleTeacher=_this.handleTeacher.bind(_this);_this.handleEmailChange=_this.handleEmailChange.bind(_this);_this.handleReasonChange=_this.handleReasonChange.bind(_this);_this.handleRequestAccount=_this.handleRequestAccount.bind(_this);_this.handleEmailConfirmChange=_this.handleEmailConfirmChange.bind(_this);_this.handleSchoolChange=_this.handleSchoolChange.bind(_this);_this.handleSchoolCreate=_this.handleSchoolCreate.bind(_this);return _this;}_createClass(RequestAccountComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].listSchools().then(function(response){if(response.success){var data=response.body;var schools=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=data[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var school=_step.value;schools.push({value:school.id,label:school.name});}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}_this2.setState({schoolOptions:schools});}else{console.log('Error',response.msg);}},function(error){console.log('Error',error.msg);});case 2:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'handleSchoolCreate',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(inputValue){var _this3=this;var body;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.setState({isLoading:true});body={name:inputValue};_context2.next=4;return __WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].createSchool(body).then(function(response){var options=_this3.state.schoolOptions;var newOption={value:response.body.id,label:inputValue};_this3.setState({isLoading:false,schoolOptions:[].concat(_toConsumableArray(options),[newOption]),schoolValue:newOption});},function(error){console.log('Fail to create a new school',error.msg);});case 4:case'end':return _context2.stop();}}},_callee2,this);}));function handleSchoolCreate(_x){return _ref2.apply(this,arguments);}return handleSchoolCreate;}()},{key:'validateEmail',value:function validateEmail(email){var re=/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var validateEdu=/^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(edu|edu\.|org|org\.+[a-zA-Z]{2})$/;EduEmail=false;if(validateEdu.test(email)){re=validateEdu;EduEmail=true;}var emailCheckResult=re.test(email);this.setState({checkEmail:emailCheckResult});return emailCheckResult;}},{key:'validate',value:function validate(){var valid=true;var fields=this.state;if(fields.firstName===''||fields.lastName===''||!this.validateEmail(this.state.eMail)||!fields.emailMatch){valid=false;}this.setState({validated:valid});return valid;}},{key:'handleFirstNameChange',value:function handleFirstNameChange(event){this.setState({firstName:event.target.value.replace(/\s+/g,'')});this.validate();}},{key:'handleLastNameChange',value:function handleLastNameChange(event){this.setState({lastName:event.target.value.replace(/\s+/g,'')});this.validate();}},{key:'handleJobTitleChange',value:function handleJobTitleChange(event){this.setState({jobTitle:event.target.value});this.validate();}},{key:'handleTeacher',value:function handleTeacher(event){if(event.target.value==false){this.setState({isTeacher:false});}else{this.setState({isTeacher:true});}}},{key:'handleEmailChange',value:function handleEmailChange(event){this.setState({eMail:event.target.value});if(!this.validateEmail(event.target.value)){this.setState({eMail:'',errorEmail:'validationRed',warning:'Email address format is invalid'});}else{this.setState({eMail:event.target.value,warning:'',errorEmail:''});}this.validate();}},{key:'handleEmailConfirmChange',value:function handleEmailConfirmChange(event){this.setState({confirmEmail:event.target.value});if(this.validateEmail(event.target.value)&&this.validateEmail(this.state.eMail)){if(event.target.value===this.state.eMail){this.setState({reason:'',confirmEmail:event.target.value,errorEmail:'',errorConfirmEmail:'',warning:'',emailMatch:true});}else{this.setState({confirmEmail:event.target.value,errorEmail:'validationRed',errorConfirmEmail:'validationRed',warning:'Emails Do Not Match!',emailMatch:false});}}else{this.setState({confirmEmail:'',errorEmail:'validationRed',errorConfirmEmail:'validationRed',warning:'Email address format is invalid',emailMatch:false});}this.validate();}},{key:'handleReasonChange',value:function handleReasonChange(event){this.setState({reason:event.target.value});this.validate();}},{key:'handleRequestAccount',value:function handleRequestAccount(event){var _this4=this;__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].accountRequest(this.state).then(function(response){_this4.setState({modalDialog:true,responseContent:'Your account will be added automatically.\n'+'Some school districts block emails from external sites which may prevent you from receiving your user number and password link. If this is the case, you  may need to contact your school district to ask about blocked email.'});_this4.setState({done:true});}).catch(function(error){console.log('Error Request Account',error);_this4.setState({modalDialog:true,responseContent:'You already have an account. Select \'Get User Number\' or \'Reset Password\' from the login screen.'});//setTimeout(()=>{this.setState({modalDialog:false})},3500);
});event.preventDefault();}},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__HomeHeaderComponent_HomeHeader__["a" /* default */],{currentItem:"RequestAccount"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGreen'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Take your teaching experience to the next level!'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6',style:{marginLeft:15}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6 bgGrey roundCorners'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{style:{marginTop:15}},'Request a free account'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Please note all inputs are required. Thanks.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'formRequestAccount'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:"validWarning",style:{color:'red'}},this.state.warning),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputEmail',className:'sr-only'},'Email Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'email',id:'inputEmail',className:this.state.errorEmail+' form-control w100',onBlur:this.handleEmailChange,placeholder:'Email Address',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputConfirmEmail',className:'sr-only'},'Confirm Email Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'email',id:'inputConfirmEmail',className:this.state.errorConfirmEmail+' form-control w100',onBlur:this.handleEmailConfirmChange,placeholder:'Confirm Email Address',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputFirstName',className:'sr-only'},'First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onChange:this.handleFirstNameChange,type:'text',id:'inputFirstName',className:'form-control w100',placeholder:'First Name',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputLastName',className:'sr-only'},'Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleLastNameChange,id:'inputLastName',className:'form-control w100',placeholder:'Last Name',required:true}),false?//EduMail ?
React.createElement(Creatable,{isClearable:true,isDisabled:this.state.isLoading,isLoading:this.state.isLoading,onChange:this.handleSchoolChange,onCreateOption:this.handleSchoolCreate,options:this.state.schoolOptions,placeholder:"Enter and create your school or select from the dropdown list.",value:this.state.schoolValue}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{disabled:!this.state.validated||this.state.done,onClick:this.handleRequestAccount,className:'btn btn-primary btn-block',type:'submit',style:{textAlign:'center'}},'Submit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this5.setState({modalDialog:active});}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-5',style:{marginTop:50}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' You should receive an email from avepm.com containing a user number and a link to create a password. However, you will not receive an email if your school district is blocking our email. If so, you could ask your district technology support staff to unblock our email. Alternatively, you can sign-up using a personal email address.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'If you continue to experience problems, send an email to Simon Hooper at: sxh12@psu.edu'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('footer',{className:'bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{marginBottom:25}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-2',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Follow us: ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-10',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:1,marginLeft:-30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://twitter.com/AvenuePM",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Twitter')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:95,marginTop:-28}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://www.facebook.com/profile.php?id=100009224578527&lst=100006500830477%3A100009224578527%3A1587693428&sk=timeline",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_Facebook_logo_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Facebook')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'This document was produced under U.S. Department of Education, Office of Special Education Programs Grant No. H327S170012. The views  expressed herein do not necessarily represent the positions or polices of the Department of Education. No official endorsement by the U.S. Department of Education of any product, commodity, service or enterprise mentioned in this publication is intended or should be inferred. This product is public domain.  Authorization to reproduce it in whole or in part is granted. While permission to reprint this publication is not necessary, the citation should be.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'\xA9 ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('script',null,'new Date().getFullYear()>2010&&document.write(new Date().getFullYear());'),' Designed and developed by researchers at the University of Minnesota and Penn State University.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_ideasthatwork_png___default.a,alt:'Logo - Ideas That Work. U.S. Office of Special Education Programs',border:'0'}))))));}}]);return RequestAccountComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RequestAccountComponent);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useCreatable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_a7690a33_esm_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_54ac8379_esm_js__ = __webpack_require__(142);






var _excluded = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];

var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var accessors = arguments.length > 2 ? arguments[2] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref) {
  var _ref$allowCreateWhile = _ref.allowCreateWhileLoading,
      allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile,
      _ref$createOptionPosi = _ref.createOptionPosition,
      createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi,
      _ref$formatCreateLabe = _ref.formatCreateLabel,
      formatCreateLabel = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe,
      _ref$isValidNewOption = _ref.isValidNewOption,
      isValidNewOption = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption,
      _ref$getNewOptionData = _ref.getNewOptionData,
      getNewOptionData = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData,
      onCreateOption = _ref.onCreateOption,
      _ref$options = _ref.options,
      propsOptions = _ref$options === void 0 ? [] : _ref$options,
      propsOnChange = _ref.onChange,
      restSelectProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, _excluded);

  var _restSelectProps$getO = restSelectProps.getOptionValue,
      getOptionValue$1 = _restSelectProps$getO === void 0 ? __WEBPACK_IMPORTED_MODULE_4__Select_54ac8379_esm_js__["c" /* g */] : _restSelectProps$getO,
      _restSelectProps$getO2 = restSelectProps.getOptionLabel,
      getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? __WEBPACK_IMPORTED_MODULE_4__Select_54ac8379_esm_js__["b" /* a */] : _restSelectProps$getO2,
      inputValue = restSelectProps.inputValue,
      isLoading = restSelectProps.isLoading,
      isMulti = restSelectProps.isMulti,
      value = restSelectProps.value,
      name = restSelectProps.name;
  var newOption = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return isValidNewOption(inputValue, Object(__WEBPACK_IMPORTED_MODULE_0__index_a7690a33_esm_js__["j" /* J */])(value), propsOptions, {
      getOptionValue: getOptionValue$1,
      getOptionLabel: getOptionLabel$1
    }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
  }, [formatCreateLabel, getNewOptionData, getOptionLabel$1, getOptionValue$1, inputValue, isValidNewOption, propsOptions, value]);
  var options = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(propsOptions)) : [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (newValue, actionMeta) {
    if (actionMeta.action !== 'select-option') {
      return propsOnChange(newValue, actionMeta);
    }

    var valueArray = Array.isArray(newValue) ? newValue : [newValue];

    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption) onCreateOption(inputValue);else {
        var newOptionData = getNewOptionData(inputValue, inputValue);
        var newActionMeta = {
          action: 'create-option',
          name: name,
          option: newOptionData
        };
        propsOnChange(Object(__WEBPACK_IMPORTED_MODULE_0__index_a7690a33_esm_js__["e" /* E */])(isMulti, [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__index_a7690a33_esm_js__["j" /* J */])(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }

    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return Object(__WEBPACK_IMPORTED_MODULE_0__index_a7690a33_esm_js__["o" /* a */])(Object(__WEBPACK_IMPORTED_MODULE_0__index_a7690a33_esm_js__["o" /* a */])({}, restSelectProps), {}, {
    options: options,
    onChange: onChange
  });
}




/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

/*! For license information please see index.js.LICENSE.txt */
!function(e,t){ true?module.exports=t(__webpack_require__(0),__webpack_require__(18)):"function"==typeof define&&define.amd?define("lib",["react","react-dom"],t):"object"==typeof exports?exports.lib=t(require("react"),require("react-dom")):e.lib=t(e.react,e["react-dom"])}("undefined"!=typeof self?self:this,(function(e,t){return function(){"use strict";var n={655:function(e,t,n){n.r(t),n.d(t,{__extends:function(){return o},__assign:function(){return i},__rest:function(){return a},__decorate:function(){return l},__param:function(){return c},__metadata:function(){return u},__awaiter:function(){return s},__generator:function(){return f},__createBinding:function(){return d},__exportStar:function(){return p},__values:function(){return h},__read:function(){return y},__spread:function(){return b},__spreadArrays:function(){return v},__spreadArray:function(){return g},__await:function(){return m},__asyncGenerator:function(){return w},__asyncDelegator:function(){return _},__asyncValues:function(){return P},__makeTemplateObject:function(){return O},__importStar:function(){return x},__importDefault:function(){return A},__classPrivateFieldGet:function(){return T},__classPrivateFieldSet:function(){return j}});var r=function(e,t){return r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},r(e,t)};function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}var i=function(){return i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},i.apply(this,arguments)};function a(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n}function l(e,t,n,r){var o,i=arguments.length,a=i<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,n):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,n,r);else for(var l=e.length-1;l>=0;l--)(o=e[l])&&(a=(i<3?o(a):i>3?o(t,n,a):o(t,n))||a);return i>3&&a&&Object.defineProperty(t,n,a),a}function c(e,t){return function(n,r){t(n,r,e)}}function u(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)}function s(e,t,n,r){return new(n||(n=Promise))((function(o,i){function a(e){try{c(r.next(e))}catch(e){i(e)}}function l(e){try{c(r.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,l)}c((r=r.apply(e,t||[])).next())}))}function f(e,t){var n,r,o,i,a={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:l(0),throw:l(1),return:l(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function l(i){return function(l){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,r=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!((o=(o=a.trys).length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){a=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){a.label=i[1];break}if(6===i[0]&&a.label<o[1]){a.label=o[1],o=i;break}if(o&&a.label<o[2]){a.label=o[2],a.ops.push(i);break}o[2]&&a.ops.pop(),a.trys.pop();continue}i=t.call(e,a)}catch(e){i=[6,e],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,l])}}}var d=Object.create?function(e,t,n,r){void 0===r&&(r=n),Object.defineProperty(e,r,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]};function p(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||d(t,e,n)}function h(e){var t="function"==typeof Symbol&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&"number"==typeof e.length)return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")}function y(e,t){var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n)return e;var r,o,i=n.call(e),a=[];try{for(;(void 0===t||t-- >0)&&!(r=i.next()).done;)a.push(r.value)}catch(e){o={error:e}}finally{try{r&&!r.done&&(n=i.return)&&n.call(i)}finally{if(o)throw o.error}}return a}function b(){for(var e=[],t=0;t<arguments.length;t++)e=e.concat(y(arguments[t]));return e}function v(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var r=Array(e),o=0;for(t=0;t<n;t++)for(var i=arguments[t],a=0,l=i.length;a<l;a++,o++)r[o]=i[a];return r}function g(e,t,n){if(n||2===arguments.length)for(var r,o=0,i=t.length;o<i;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))}function m(e){return this instanceof m?(this.v=e,this):new m(e)}function w(e,t,n){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var r,o=n.apply(e,t||[]),i=[];return r={},a("next"),a("throw"),a("return"),r[Symbol.asyncIterator]=function(){return this},r;function a(e){o[e]&&(r[e]=function(t){return new Promise((function(n,r){i.push([e,t,n,r])>1||l(e,t)}))})}function l(e,t){try{(n=o[e](t)).value instanceof m?Promise.resolve(n.value.v).then(c,u):s(i[0][2],n)}catch(e){s(i[0][3],e)}var n}function c(e){l("next",e)}function u(e){l("throw",e)}function s(e,t){e(t),i.shift(),i.length&&l(i[0][0],i[0][1])}}function _(e){var t,n;return t={},r("next"),r("throw",(function(e){throw e})),r("return"),t[Symbol.iterator]=function(){return this},t;function r(r,o){t[r]=e[r]?function(t){return(n=!n)?{value:m(e[r](t)),done:"return"===r}:o?o(t):t}:o}}function P(e){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var t,n=e[Symbol.asyncIterator];return n?n.call(e):(e=h(e),t={},r("next"),r("throw"),r("return"),t[Symbol.asyncIterator]=function(){return this},t);function r(n){t[n]=e[n]&&function(t){return new Promise((function(r,o){!function(e,t,n,r){Promise.resolve(r).then((function(t){e({value:t,done:n})}),t)}(r,o,(t=e[n](t)).done,t.value)}))}}}function O(e,t){return Object.defineProperty?Object.defineProperty(e,"raw",{value:t}):e.raw=t,e}var S=Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t};function x(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)"default"!==n&&Object.prototype.hasOwnProperty.call(e,n)&&d(t,e,n);return S(t,e),t}function A(e){return e&&e.__esModule?e:{default:e}}function T(e,t,n,r){if("a"===n&&!r)throw new TypeError("Private accessor was defined without a getter");if("function"==typeof t?e!==t||!r:!t.has(e))throw new TypeError("Cannot read private member from an object whose class did not declare it");return"m"===n?r:"a"===n?r.call(e):r?r.value:t.get(e)}function j(e,t,n,r,o){if("m"===r)throw new TypeError("Private method is not writable");if("a"===r&&!o)throw new TypeError("Private accessor was defined without a setter");if("function"==typeof t?e!==t||!o:!t.has(e))throw new TypeError("Cannot write private member to an object whose class did not declare it");return"a"===r?o.call(e,n):o?o.value=n:t.set(e,n),n}},156:function(t){t.exports=e},111:function(e){e.exports=t}},r={};function o(e){var t=r[e];if(void 0!==t)return t.exports;var i=r[e]={exports:{}};return n[e](i,i.exports,o),i.exports}o.d=function(e,t){for(var n in t)o.o(t,n)&&!o.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var i={};return function(){var e=i;Object.defineProperty(e,"__esModule",{value:!0}),e.useReactToPrint=e.PrintContextConsumer=void 0;var t=o(655),n=o(156),r=o(111),a=Object.prototype.hasOwnProperty.call(n,"createContext"),l=Object.prototype.hasOwnProperty.call(n,"useMemo")&&Object.prototype.hasOwnProperty.call(n,"useCallback"),c=a?n.createContext({}):null;e.PrintContextConsumer=c?c.Consumer:function(){return null};var u={copyStyles:!0,pageStyle:"@page { size: auto;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; } }",removeAfterPrint:!1,suppressErrors:!1},s=function(e){function o(){var n=null!==e&&e.apply(this,arguments)||this;return n.startPrint=function(e){var t=n.props,r=t.onAfterPrint,o=t.onPrintError,i=t.print,a=t.documentTitle;setTimeout((function(){var t,l;if(e.contentWindow){if(e.contentWindow.focus(),i)i(e).then(n.handleRemoveIframe).catch((function(e){o?o("print",e):n.logMessages(["An error was thrown by the specified `print` function"])}));else if(e.contentWindow.print){var c=null!==(l=null===(t=e.contentDocument)||void 0===t?void 0:t.title)&&void 0!==l?l:"",u=e.ownerDocument.title;a&&(e.ownerDocument.title=a,e.contentDocument&&(e.contentDocument.title=a)),e.contentWindow.print(),a&&(e.ownerDocument.title=u,e.contentDocument&&(e.contentDocument.title=c))}else n.logMessages(["Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."]);r&&r(),n.handleRemoveIframe()}else n.logMessages(["Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"])}),500)},n.triggerPrint=function(e){var t=n.props,r=t.onBeforePrint,o=t.onPrintError;if(r){var i=r();i&&"function"==typeof i.then?i.then((function(){n.startPrint(e)})).catch((function(e){o&&o("onBeforePrint",e)})):n.startPrint(e)}else n.startPrint(e)},n.handleClick=function(){var e=n.props,t=e.onBeforeGetContent,r=e.onPrintError;if(t){var o=t();o&&"function"==typeof o.then?o.then(n.handlePrint).catch((function(e){r&&r("onBeforeGetContent",e)})):n.handlePrint()}else n.handlePrint()},n.handlePrint=function(){var e=n.props,o=e.bodyClass,i=e.content,a=e.copyStyles,l=e.fonts,c=e.pageStyle,u=e.nonce,s=i();if(void 0!==s)if(null!==s){var f=document.createElement("iframe");f.style.position="absolute",f.style.top="-1000px",f.style.left="-1000px",f.id="printWindow",f.srcdoc="<!DOCTYPE html>";var d=(0,r.findDOMNode)(s);if(d){var p=d.cloneNode(!0),h=p instanceof Text,y=document.querySelectorAll("link[rel='stylesheet']"),b=h?[]:p.querySelectorAll("img"),v=h?[]:p.querySelectorAll("video");n.linkTotal=y.length+b.length+v.length,n.linksLoaded=[],n.linksErrored=[],n.fontsLoaded=[],n.fontsErrored=[];var g=function(e,t){t?n.linksLoaded.push(e):(n.logMessages(['"react-to-print" was unable to load a linked node. It may be invalid. "react-to-print" will continue attempting to print the page. The linked node that errored was:',e]),n.linksErrored.push(e)),n.linksLoaded.length+n.linksErrored.length+n.fontsLoaded.length+n.fontsErrored.length===n.linkTotal&&n.triggerPrint(f)};f.onload=function(){var e,r,i,s;f.onload=null;var y=f.contentDocument||(null===(r=f.contentWindow)||void 0===r?void 0:r.document);if(y){y.body.appendChild(p),l&&((null===(i=f.contentDocument)||void 0===i?void 0:i.fonts)&&(null===(s=f.contentWindow)||void 0===s?void 0:s.FontFace)?l.forEach((function(e){var t=new FontFace(e.family,e.source);f.contentDocument.fonts.add(t),t.loaded.then((function(e){n.fontsLoaded.push(e)})).catch((function(e){n.fontsErrored.push(t),n.logMessages(['"react-to-print" was unable to load a font. "react-to-print" will continue attempting to print the page. The font that failed to load is:',t,"The error from loading the font is:",e])}))})):n.logMessages(['"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API']));var m="function"==typeof c?c():c;if("string"!=typeof m)n.logMessages(['"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof m,'". Styles from `pageStyle` will not be applied.')]);else{var w=y.createElement("style");u&&(w.setAttribute("nonce",u),y.head.setAttribute("nonce",u)),w.appendChild(y.createTextNode(m)),y.head.appendChild(w)}if(o&&(e=y.body.classList).add.apply(e,(0,t.__spreadArray)([],(0,t.__read)(o.split(" ")),!1)),!h){for(var _=h?[]:d.querySelectorAll("canvas"),P=y.querySelectorAll("canvas"),O=0;O<_.length;++O){var S=_[O],x=P[O].getContext("2d");x&&x.drawImage(S,0,0)}for(O=0;O<b.length;O++){var A=b[O],T=A.getAttribute("src");T?((k=new Image).onload=g.bind(null,A,!0),k.onerror=g.bind(null,A,!1),k.src=T):(n.logMessages(['"react-to-print" encountered an <img> tag with an empty "src" attribute. It will not attempt to pre-load it. The <img> is:',A],"warning"),g(A,!1))}for(O=0;O<v.length;O++){var j=v[O];j.preload="auto";var k,E=j.getAttribute("poster");E?((k=new Image).onload=g.bind(null,j,!0),k.onerror=g.bind(null,j,!1),k.src=E):j.readyState>=2?g(j,!0):(j.onloadeddata=g.bind(null,j,!0),j.onerror=g.bind(null,j,!1),j.onstalled=g.bind(null,j,!1))}var C="input",M=d.querySelectorAll(C),R=y.querySelectorAll(C);for(O=0;O<M.length;O++)R[O].value=M[O].value;var I="input[type=checkbox],input[type=radio]",q=d.querySelectorAll(I),D=y.querySelectorAll(I);for(O=0;O<q.length;O++)D[O].checked=q[O].checked;var L="select",W=d.querySelectorAll(L),F=y.querySelectorAll(L);for(O=0;O<W.length;O++)F[O].value=W[O].value}if(a)for(var N=document.querySelectorAll("style, link[rel='stylesheet']"),B=(O=0,N.length);O<B;++O){var G=N[O];if("style"===G.tagName.toLowerCase()){var V=y.createElement(G.tagName),Y=G.sheet;if(Y){var z="";try{for(var H=Y.cssRules.length,J=0;J<H;++J)"string"==typeof Y.cssRules[J].cssText&&(z+="".concat(Y.cssRules[J].cssText,"\r\n"))}catch(e){n.logMessages(["A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",G],"warning")}V.setAttribute("id","react-to-print-".concat(O)),u&&V.setAttribute("nonce",u),V.appendChild(y.createTextNode(z)),y.head.appendChild(V)}}else if(G.getAttribute("href")){V=y.createElement(G.tagName),J=0;for(var K=G.attributes.length;J<K;++J){var Q=G.attributes[J];Q&&V.setAttribute(Q.nodeName,Q.nodeValue||"")}V.onload=g.bind(null,V,!0),V.onerror=g.bind(null,V,!1),u&&V.setAttribute("nonce",u),y.head.appendChild(V)}else n.logMessages(['"react-to-print" encountered a <link> tag with an empty "href" attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:',G],"warning"),g(G,!0)}}0!==n.linkTotal&&a||n.triggerPrint(f)},n.handleRemoveIframe(!0),document.body.appendChild(f)}else n.logMessages(['"react-to-print" could not locate the DOM node corresponding with the `content` prop'])}else n.logMessages(['There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.']);else n.logMessages(["To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"])},n.handleRemoveIframe=function(e){var t=n.props.removeAfterPrint;if(e||t){var r=document.getElementById("printWindow");r&&document.body.removeChild(r)}},n.logMessages=function(e,t){void 0===t&&(t="error"),n.props.suppressErrors||("error"===t?console.error(e):"warning"===t&&console.warn(e))},n}return(0,t.__extends)(o,e),o.prototype.render=function(){var e=this.props,t=e.children,r=e.trigger;if(r)return n.cloneElement(r(),{onClick:this.handleClick});if(!c)return this.logMessages(['"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"']),null;var o={handlePrint:this.handleClick};return n.createElement(c.Provider,{value:o},t)},o.defaultProps=u,o}(n.Component);e.default=s,e.useReactToPrint=function(e){if(!l)return e.suppressErrors||console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'),function(){throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"')};var r=n.useMemo((function(){return new s((0,t.__assign)((0,t.__assign)({},u),e))}),[e]);return n.useCallback((function(){return r.handleClick()}),[r])}}(),i}()}));

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_logo_kidspeak_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_logo_kidspeak_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_logo_kidspeak_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_maze_png__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_maze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_maze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_wordmark_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_logo_wordmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_slashtest_png__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_slashtest_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_slashtest_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(23);
var ComponentToPrint=__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:ref},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:-70}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontFamily:"mainFont",fontSize:40}},"A GUIDE TO SELECTING APPS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:110,float:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav nav-pills pill-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"data-toggle":"pill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_1__assets_images_app_picturenaming_png___default.a,style:{width:100,height:100},border:"0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-6",style:{marginTop:30,width:"calc(100% - 170px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:16}},"PICTURE NAMING"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:14}},"Student is developing signed and/or spoken language ")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:110,float:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav nav-pills pill-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"data-toggle":"pill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_app_copyright_png___default.a,style:{width:100,height:100},border:"0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-6",style:{marginTop:30,width:"calc(100% - 170px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:16}},"COPY RIGHT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:14}},"Student is developing sign skills and/or communicates using ASL")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:110,float:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav nav-pills pill-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"data-toggle":"pill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_logo_kidspeak_png___default.a,style:{width:100,height:100},border:"0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-6",style:{marginTop:30,width:"calc(100% - 170px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:16}},"KID SPEAK"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:14}},"Student reads English text (grades 1-6) AND has intelligible spoken language"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:110,float:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav nav-pills pill-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"data-toggle":"pill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_app_wordsignsay_png___default.a,style:{width:100,height:100},border:"0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-6",style:{marginTop:30,width:"calc(100% - 170px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:16}},"WORD SIGN/SAY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:14}},"Student has a signed and/or spoken language base and beginning to identify words in text ")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:110,float:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav nav-pills pill-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"data-toggle":"pill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_maze_png___default.a,style:{width:100,height:100},border:"0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-6",style:{marginTop:30,width:"calc(100% - 170px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:16}},"MAZE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:14}},"Student reads English text (grades 2-6)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:110,float:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav nav-pills pill-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"data-toggle":"pill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_logo_wordmark_png___default.a,style:{width:100,height:100},border:"0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-6",style:{marginTop:30,width:"calc(100% - 170px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:16}},"WORD MARK"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:14}},"Student produces written expression and narratives and uses the e-keyboard"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:110,float:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav nav-pills pill-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"data-toggle":"pill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_slashtest_png___default.a,style:{width:100,height:100},border:"0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-6",style:{marginTop:30,width:"calc(100% - 170px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:16}},"SLASH"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:14}},"Student is developing English language patterns \x0BOR reads isolated words")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-4",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:110,float:"left"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"nav nav-pills pill-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{"data-toggle":"pill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_app_kidsignsay_png___default.a,style:{width:100,height:100},border:"0"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-sm-6",style:{marginTop:30,width:"calc(100% - 170px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:16}},"KID SIGN/SAY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:14}},"Student reads English text (grades 2-6) and is fluent in ASL or spoken English"))))));});/* harmony default export */ __webpack_exports__["a"] = (ComponentToPrint);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_apps_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_apps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_apps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_animated_css__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_animated_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_animated_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ProgressModalComponent_ProgressModal__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_students_Maze_css__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_students_Maze_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_students_Maze_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProgressModalComponent_ScoreBox__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_modal_correct_png__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_modal_correct_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_modal_correct_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_modal_incorrect_png__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_modal_incorrect_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_modal_incorrect_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux_es_connect_connect__ = __webpack_require__(28);
var _this15=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var usedPassages=[];var windowHeight=window.innerHeight;var criteria=[1,1,2,3,4,5,5,6,6,7,7,8];var MazeComponent=function(_Component){_inherits(MazeComponent,_Component);function MazeComponent(props){var _this2=this;_classCallCheck(this,MazeComponent);var _this=_possibleConstructorReturn(this,(MazeComponent.__proto__||Object.getPrototypeOf(MazeComponent)).call(this,props));_this.handleModalBack=function(modalActive){_this.setState({modalActive:modalActive});};_this.handleBack=function(){console.log('HandleBack-Maze');window.location.reload();_this.setState({active:0});};_this.handleActive=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(active){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(active===3)){_context2.next=3;break;}_context2.next=3;return __WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getMazeRandom().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!response.success){_context.next=3;break;}_context.next=3;return this.setState({passages:response.body.passages});case 3:case'end':return _context.stop();}}},_callee,this);}));return function(_x2){return _ref2.apply(this,arguments);};}().bind(_this),function(error){console.log('Error',error);});case 3:_this.setState({active:active});case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleBeginTest=function(){_this.setState({active:3});};_this.changeLevelScore=function(newLevel,newScore){_this.state.bestScores.mazeLevel=newLevel;_this.state.bestScores.mazeScore=newScore;};_this.state={responseContent:'',active:0,passages:[],modalActive:true,loadedScores:false,initScore:2,bestScores:{mazeScore:1,mazeLevel:1}};return _this;}_createClass(MazeComponent,[{key:'componentDidMount',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return __WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__["a" /* default */].authorize(this);case 2:_context4.next=4;return __WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!response.success){_context3.next=3;break;}_context3.next=3;return _this3.setState({loadedScores:true,bestScores:response.body});case 3:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x3){return _ref4.apply(this,arguments);};}());case 4:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref3.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.state.active!==2?"bgGrey MazeContainer":"bgYellow MazeContainer"},this.state.active===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer maze'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'Maze'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 text-center"},this.state.loadedScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ProgressModalComponent_ProgressBox__["a" /* default */],{appName:"maze",level:this.state.bestScores.mazeLevel,step:this.state.bestScores.mazeScore,steps:6,maxLevel:12}):null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["a" /* Buttons */],{appName:"maze",maxLevel:12,level:this.state.bestScores.mazeLevel,buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["b" /* Buttons1 */],{demo:true,appName:"maze",buttonClick:this.handleActive,recordedSession:this.state.modalActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer maze'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'Maze: Show Me'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["g" /* VideoComponent */],{url:"https://s3.us-east-2.amazonaws.com/uploadbeta/video/maze/Maze_practice.mp4"})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["a" /* Buttons */],{demo:true,appName:"maze",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["b" /* Buttons1 */],{practice:true,appName:"maze",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tutorial,{studentUser:this.props.studentUser,buttonClick:this.handleActive,passage:this.state.passages[0],beginTest:this.handleBeginTest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["a" /* Buttons */],{appName:"maze",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["b" /* Buttons1 */],{appName:"maze",buttonClick:this.handleActive,clickBack:this.handleBack,recordedSession:this.state.modalActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Content,{studentUser:this.props.studentUser,backBtn:this.handleModalBack,changeLevelScore:this.changeLevelScore,passages:this.state.passages}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["a" /* Buttons */],{appName:"maze",buttonClick:this.handleActive,currentTabActive:this.state.active})):null);}}]);return MazeComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ContentComponent=function(_Component2){_inherits(ContentComponent,_Component2);function ContentComponent(props){_classCallCheck(this,ContentComponent);var _this4=_possibleConstructorReturn(this,(ContentComponent.__proto__||Object.getPrototypeOf(ContentComponent)).call(this,props));_this4.windowResizeListener=function(e){console.log(windowHeight);};_this4.handleSelection=function(selected,field){var selection=_this4.state.selection;selection[field]=selected;_this4.setState({selection:selection});};_this4.state={popupSurvey:false,passages:_this4.props.passages,passage:_this4.props.passages[0],selection:{},level:1,score:3,time:60,response:[],order:[],correct:0,error:0,skipped:0,isNewLevel:true,finished:false,showNext:false,errorType:'',isOpen:false,levelCal:null,scoreCalc:null,isNewLevelCalc:null,animateLevel:false,levelType:'',stepType:'',consecutiveScore:[],firstScore:false,lastScore:false,modalDialog:false,responseContent:'',randomCorrect:['Great Job','Well Done','Fantastic','You got it','Perfect','Way to go','Terrific','Excellent','Super','Nice work','Wonderful','Outstanding','Congratulations','That’s right'],randomTitle:'',responseArr:[],stepDir:'UP',stepDirNow:null,fullArr:[],tooFast:false,analytics:{type:null,metadata:null}};_this4.timer=0;_this4.handleSurveyBack=_this4.handleSurveyBack.bind(_this4);_this4.startTimer=_this4.startTimer.bind(_this4);_this4.countDown=_this4.countDown.bind(_this4);_this4.handleFinished=_this4.handleFinished.bind(_this4);_this4.handleNext=_this4.handleNext.bind(_this4);_this4.handleClose=_this4.handleClose.bind(_this4);_this4.handleLevelAnimationClose=_this4.handleLevelAnimationClose.bind(_this4);_this4.closeModal=_this4.closeModal.bind(_this4);_this4.theEventListener=_this4.windowResizeListener.bind(_this4);_this4.handleAnalytics=_this4.handleAnalytics.bind(_this4);return _this4;}_createClass(ContentComponent,[{key:'componentDidMount',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:window.addEventListener('resize',this.theEventListener,true);__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!response.success){_context5.next=6;break;}_context5.next=3;return _this5.setState({level:response.body.mazeLevel,score:response.body.mazeScore,order:_this5.fieldsOrder(),isOpen:false,randomTitle:_this5.state.randomCorrect[Math.floor(Math.random()*_this5.state.randomCorrect.length)]});case 3:_context5.next=5;return _this5.emptySelection();case 5:_this5.startTimer();case 6:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x4){return _ref6.apply(this,arguments);};}(),function(error){console.log('ResponseError',error);});_context6.next=4;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_19__Shared_DataTrackingPoints__["b" /* default */].STUDENT_MAZE_START,metadata:{}}});case 4:this.handleAnalytics();case 5:case'end':return _context6.stop();}}},_callee6,this);}));function componentDidMount(){return _ref5.apply(this,arguments);}return componentDidMount;}()},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'emptySelection',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var selection;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:selection={};this.state.order.forEach(function(o){selection[o]={};});_context7.next=4;return this.setState({selection:selection});case 4:case'end':return _context7.stop();}}},_callee7,this);}));function emptySelection(){return _ref7.apply(this,arguments);}return emptySelection;}()},{key:'fieldsOrder',value:function fieldsOrder(){var regExp=/\([0-9]{1,9}\)/g;var txt=this.state.passage.mazecontent;return txt.match(regExp);}},{key:'handleSurveyBack',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:case'end':return _context8.stop();}}},_callee8,this);}));function handleSurveyBack(){return _ref8.apply(this,arguments);}return handleSurveyBack;}()},{key:'startTimer',value:function startTimer(){if(!this.props.practice){this.props.backBtn(false);}this.timer=Object(__WEBPACK_IMPORTED_MODULE_10_timers__["setInterval"])(this.countDown,1000);}},{key:'countDown',value:function countDown(){var seconds=this.state.time-1;this.setState({time:seconds});if(seconds===0){Object(__WEBPACK_IMPORTED_MODULE_10_timers__["clearInterval"])(this.timer);this.handleFinished();}}},{key:'handleFinished',value:function handleFinished(event){var _this6=this;var timeStart=60;if(!this.props.practice){this.props.backBtn(true);}Object(__WEBPACK_IMPORTED_MODULE_10_timers__["clearInterval"])(this.timer);if(this.state.time>timeStart-5&&!this.props.practice){this.setState({tooFast:true,finished:true,showNext:true});}else{Object(__WEBPACK_IMPORTED_MODULE_10_timers__["clearInterval"])(this.timer);var _state=this.state,selection=_state.selection,correct=_state.correct,error=_state.error,skipped=_state.skipped,passage=_state.passage;var errorType='';Object.keys(selection).forEach(function(key){var studentResponse=selection[key];var correctResponse=passage.fields.filter(function(o){return o.hasOwnProperty(key);}).map(function(o){return o.correct;})[0];var resToSend=void 0;if(Object.keys(studentResponse).length===0){resToSend='S';skipped++;}else if(JSON.stringify(studentResponse)===JSON.stringify(correctResponse)){resToSend='C';correct++;}else{resToSend='E';errorType=errorType.concat(','+studentResponse.category);error++;}resToSend=resToSend.concat(correctResponse.category);var _state2=_this6.state,response=_state2.response,order=_state2.order;response.splice(order.indexOf(key),0,resToSend);_this6.setState({response:response,correct:correct,skipped:skipped,error:error,tooFast:false,errorType:errorType});});var errorLength=errorType.length;if(errorLength>0){this.setState({errorType:errorType.substring(1,errorLength)});}var response=this.state.response;var arrResp=response;var cleanArr=[];var fullArr=[];var countS=0;for(var i=0;i<arrResp.length;i++){if(arrResp[i].substring(0,1)==="S"){countS++;if(countS===3){cleanArr.push(null);cleanArr[i-1]=null;cleanArr[i-2]=null;}else{cleanArr.push(arrResp[i].substring(0,1));}}else{countS=0;cleanArr.push(arrResp[i].substring(0,1));}}for(var _i=0;_i<cleanArr.length;_i++){if(cleanArr[_i]===null){cleanArr.splice(_i);}}var cor1=0;var err1=0;var skp1=0;for(var _i2=0;_i2<cleanArr.length;_i2++){if(cleanArr[_i2]==="C"){cor1++;}if(cleanArr[_i2]==="E"){err1++;}if(cleanArr[_i2]==="S"){skp1++;}this.setState({response:cleanArr,correct:cor1,skipped:skp1,error:err1});}console.log(cleanArr.splice(1));for(var _i3=0;_i3<arrResp.length;_i3++){fullArr.push(arrResp[_i3].substring(0,1));}console.log(fullArr.splice(1));this.setState({fullArr:fullArr.splice(1)});this.setState({finished:true},function(){if(_this6.validateSession()){if(!_this6.props.practice){_this6.calculateAndUpdateScore();}}});}}},{key:'calculateAndUpdateScore',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var _this7=this;var _state3,score,level,correct,error,isNewLevel,skipped,i,testsAmount;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_state3=this.state,score=_state3.score,level=_state3.level,correct=_state3.correct,error=_state3.error,isNewLevel=_state3.isNewLevel,skipped=_state3.skipped;if(!(correct>=criteria[level-1])){_context9.next=8;break;}score=score+1;this.setState({stepDir:'UP'});if(skipped==1&&error==0){if(this.state.fullArr.every(function(val,i,arr){return val===arr[0];})){this.setState({consecutiveScore:this.state.consecutiveScore.concat(score)});}else{this.setState({consecutiveScore:[]});}console.log(this.state.consecutiveScore);if(score>=2){for(i=0;i<this.state.consecutiveScore.length-1;i++){if(this.state.consecutiveScore[i]>=this.state.consecutiveScore[i+1]||Number.isNaN(this.state.consecutiveScore[i])||Number.isNaN(this.state.consecutiveScore[i+1])){}else{/*
                            if (this.state.consecutiveScore.length === 2) {
                                this.setState({consecutiveScore: []});
                                this.setState({levelType: 'LEVEL UP! You Scored 3 times in a row with 100% correct!'});
                                level = level + 1;
                                score = 2;
                                isNewLevel = true;
                            }*/}}}}if(score>6){this.setState({consecutiveScore:[]});level=level+1;score=1;this.setState({levelType:'LEVEL UP'});this.setState({lastScore:true});if(level==13){this.setState({levelType:''});}isNewLevel=true;}_context9.next=23;break;case 8:score=score-1;this.setState({consecutiveScore:[]});if(!(score<1)){_context9.next=22;break;}if(!(level>=2)){_context9.next=17;break;}testsAmount=0;_context9.next=15;return __WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getMazeScoreCount().then(function(response){//only allow level up in the first 15 tests
if(response.success){testsAmount=response.body;if(testsAmount<20){//only allow level up in the first 20 tests
level=level-1;score=2;_this7.setState({stepDir:'DOWN'});_this7.setState({levelType:'LEVEL DOWN'});isNewLevel=true;}else{score=1;_this7.setState({stepDir:null});}console.log('Success',response);}else{console.log('Error',response.msg);}},function(error){console.log('Error',error.msg);});case 15:_context9.next=20;break;case 17:score=1;level=1;this.setState({stepDir:null});case 20:_context9.next=23;break;case 22:this.setState({stepDir:'DOWN'});case 23:this.props.changeLevelScore(level,score);this.setState({scoreCalc:score,levelCalc:level,isNewLevelCalc:isNewLevel},function(){_this7.updateScores();_this7.postSession();});case 25:case'end':return _context9.stop();}}},_callee9,this);}));function calculateAndUpdateScore(){return _ref9.apply(this,arguments);}return calculateAndUpdateScore;}()},{key:'validateSession',value:function validateSession(){if(this.state.time>55){return false;}var response=this.state.response;if(response.every(function(o){return Object.keys(o).length===0;})){return false;}for(var i=0;i<response.length-2;i++){if(response[i].includes('S')&&response[i+1].includes('S')&&response[i+2].includes('S')){return false;}}return true;}},{key:'updateScores',value:function updateScores(){var body={mazeLevel:this.state.levelCalc,mazeScore:this.state.scoreCalc};__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].updateMazeScore(body).then(function(response){if(response.success){console.log('Success',response);}else{console.log('Error',response.msg);}},function(error){console.log('Error',error.msg);});}},{key:'postSession',value:function postSession(){var body={passageId:this.state.passage.passageId,sessionTime:60-this.state.time,correctItems:this.state.correct,incorrectItems:this.state.error,errorType:this.state.errorType,studentData:this.state.response.toString(),passageLevel:this.state.level,duration:60,guid:'',startLevel:this.state.level,newLevel:this.state.newLevel?1:0};__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].postMazeSession(body).then(function(response){console.log('Success',response);},function(error){console.log('Error',error);});}},{key:'handleLevelAnimationClose',value:function handleLevelAnimationClose(){this.setState({animateLevel:false});this.state.level==13?window.location.reload():null;}},{key:'handleNext',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(e){var _this8=this;var myDiv;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:if(this.state.firstScore){this.setState({firstScore:false});}if(this.state.lastScore){this.setState({lastScore:false});}myDiv=document.getElementById('passageMazeID');myDiv.scrollTop=0;if(!(this.state.level>this.state.levelCalc)){_context11.next=7;break;}_context11.next=12;break;case 7:if(!(this.state.level<this.state.levelCalc)){_context11.next=10;break;}_context11.next=12;break;case 10:_context11.next=12;return this.setState({levelType:'STAY'});case 12:_context11.next=14;return this.setState({popupSurvey:false,score:this.state.scoreCalc!=null?this.state.scoreCalc:this.state.score,level:this.state.levelCalc!=null?this.state.levelCalc:this.state.level,isNewLevel:false,animateLevel:this.state.levelType==="STAY"?false:true});case 14:_context11.next=16;return __WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getMazeRandom().then(function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(!response.success){_context10.next=3;break;}_context10.next=3;return _this8.setState({passages:response.body.passages});case 3:case'end':return _context10.stop();}}},_callee10,_this8);}));return function(_x6){return _ref11.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 16:_context11.next=18;return this.setState({selection:{},response:[],correct:0,error:0,skipped:0,time:60,showNext:false,passage:this.state.passages[0]});case 18:_context11.next=20;return this.setState({order:this.fieldsOrder()});case 20:_context11.next=22;return this.emptySelection();case 22:_context11.next=24;return this.startTimer();case 24:case'end':return _context11.stop();}}},_callee11,this);}));function handleNext(_x5){return _ref10.apply(this,arguments);}return handleNext;}()},{key:'handleClose',value:function handleClose(e){var _this9=this;if(this.state.correct===0&&this.state.error===0){this.setState({finished:false,showNext:true});this.handleNext();}if(this.state.level===this.state.levelCalc){this.setState({score:this.state.scoreCalc!=null?this.state.scoreCalc:this.state.score,level:this.state.levelCalc!=null?this.state.levelCalc:this.state.level,stepDirNow:this.state.stepDir,isNewLevel:false},function(){_this9.updateScores();});}if(this.state.score==1&&!this.state.firstScore&&this.state.stepDir==="DOWN"&&!this.state.tooFast){this.setState({firstScore:true});}this.setState({finished:false,showNext:true,popupSurvey:true});console.log('activate popupSurvey');if(this.props.practice){this.props.buttonClick(0);}}},{key:'closeModal',value:function closeModal(){this.setState({isOpen:false});}},{key:'render',value:function render(){var _this10=this;var _state4=this.state,correct=_state4.correct,error=_state4.error,level=_state4.level;var score=correct;if(score<0){score=0;}var title=void 0;var iconSrc=void 0;if(this.props.practice){level=1;}if(correct===0&&error===0){if(this.state.tooFast){title='Try Again!';iconSrc=null;}else{title='Nothing to score!';iconSrc=null;}}else if(score===0||score<criteria[level-1]){title='Oops. You need to get '+criteria[level-1]+' correct to move up a step';iconSrc=__WEBPACK_IMPORTED_MODULE_18__assets_images_modal_incorrect_png___default.a;}else{title=this.state.randomTitle;iconSrc=__WEBPACK_IMPORTED_MODULE_17__assets_images_modal_correct_png___default.a;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.practice?"appSection bgGrey":"appSection bgYellow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Shared_DialogBox__["a" /* default */],{surveyModal:true,app:'Maze',userId:this.props.studentUser.id,active:this.state.popupSurvey,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ParentComponent,{passage:this.state.passage,feedback:this.state.showNext,handleSelection:this.handleSelection})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this10.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tc'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row tc"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-12 hidden-xs hidden-md hidden-lg"},this.state.showNext?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNext,className:'handBtn',style:{width:150}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Try Another')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleFinished,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Finished'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-5 col-sm-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.props.practice},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["e" /* LevelTrackerComponent */],{appName:"maze",firstScore:this.state.firstScore,lastScore:this.state.lastScore,stepDir:this.state.stepDirNow,level:this.state.level,maxLevel:12,step:this.state.score,steps:6}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2 hidden-sm"},this.state.showNext&&!this.props.practice?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNext,className:'handBtn',style:{width:150}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Try Another')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleFinished,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Finished'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-5 col-sm-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row pull-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["c" /* CountDownComponent */],{time:this.state.time,sessionTime:60,showTime:10})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["a" /* Modal */],{id:"resultBox",show:this.state.finished},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content',style:{minWidth:"530px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},iconSrc?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:iconSrc,style:{width:150}}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,title)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"modal-body"},title!=='Nothing to score!'&&!this.state.tooFast?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ProgressModalComponent_ScoreBox__["a" /* default */],{score:score,correct:this.state.correct,incorrect:this.state.error,skipped:this.state.skipped-1}):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'handBtn',onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["a" /* Modal */],{id:'animateModal',show:this.state.animateLevel},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["d" /* LevelAnimation */],{appName:"maze",level:this.state.level,maxLevel:12,typeLevel:this.state.levelType,closeAnimation:this.handleLevelAnimationClose})))));}}]);return ContentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Content=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(ContentComponent);var Tutorial=function(_Component3){_inherits(Tutorial,_Component3);function Tutorial(props){_classCallCheck(this,Tutorial);var _this11=_possibleConstructorReturn(this,(Tutorial.__proto__||Object.getPrototypeOf(Tutorial)).call(this,props));_this11.state={passage:_this11.props.passage,testPassage:'{\n\t"mazecontent": " \u201CLet\u2019 s make (0) cookies! The recipe (3) for flour, eggs, butter, milk, and (1)\u201D said Jan. Chad said, \u201CWe need (2) more egg.\u201D",\n\t"passageTitle": "Cookies",\n\t"passageId": 644,\n\t"passageType": "N",\n\t"version": 7,\n\t"fields": [{\n\t\t"(0)": [{\n\t\t\t"word": "coutout",\n\t\t\t"category": "0"\n\t\t}, {\n\t\t\t"word": "see",\n\t\t\t"category": 1\n\t\t}, {\n\t\t\t"word": "hear",\n\t\t\t"category": 1\n\t\t}],\n\t\t"correct": {\n\t\t\t"word": "cutout",\n\t\t\t"category": "0"\n\t\t}\n\t}, {\n\t\t"(1)": [{\n\t\t\t"word": "the",\n\t\t\t"category": 1\n\t\t}, {\n\t\t\t"word": "her",\n\t\t\t"category": 1\n\t\t}, {\n\t\t\t"word": "sugar",\n\t\t\t"category": "0"\n\t\t}],\n\t\t"correct": {\n\t\t\t"word": "sugar",\n\t\t\t"category": "0"\n\t\t}\n\t}, {\n\t\t"(2)": [{\n\t\t\t"word": "flour",\n\t\t\t"category": 1\n\t\t}, {\n\t\t\t"word": "she",\n\t\t\t"category": 1\n\t\t}, {\n\t\t\t"word": "one",\n\t\t\t"category": "0"\n\t\t}],\n\t\t"correct": {\n\t\t\t"word": "one",\n\t\t\t"category": "0"\n\t\t}\n\t},\n\t{\n\t\t"(3)": [{\n\t\t\t"word": "hear",\n\t\t\t"category": 1\n\t\t}, {\n\t\t\t"word": "see",\n\t\t\t"category": 1\n\t\t}, {\n\t\t\t"word": "calls",\n\t\t\t"category": "0"\n\t\t}],\n\t\t"correct": {\n\t\t\t"word": "calls",\n\t\t\t"category": "0"\n\t\t}\n\t}],\n\t"totalBlanks": 3\n}'};return _this11;}_createClass(Tutorial,[{key:'render',value:function render(){var passages=[];passages.push(JSON.parse(this.state.testPassage));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Content,{studentUser:this.props.studentUser,buttonClick:this.props.buttonClick,passages:passages,practice:true});}}]);return Tutorial;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ParentComponent=function(_Component4){_inherits(ParentComponent,_Component4);function ParentComponent(){var _ref12;var _temp,_this12,_ret;_classCallCheck(this,ParentComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this12=_possibleConstructorReturn(this,(_ref12=ParentComponent.__proto__||Object.getPrototypeOf(ParentComponent)).call.apply(_ref12,[this].concat(args))),_this12),_this12.handleSelection=function(selected,field){// this.setState({ selection: selected });
_this12.props.handleSelection(selected,field);},_temp),_possibleConstructorReturn(_this12,_ret);}_createClass(ParentComponent,[{key:'render',value:function render(){var _this13=this;var regExp=/\([0-9]{1,9}\)/g;var txt=this.props.passage.mazecontent;var newTxt=txt.split(regExp);var firstTxt=newTxt[0];var fields=txt.match(regExp);var tmpArray=[];var firstItem=this.props.passage.fields.filter(function(o){return o.hasOwnProperty(fields[0]);}).map(function(o){return o.correct.word;});var secondTxt=newTxt[1];tmpArray.push(firstTxt+firstItem+secondTxt);var _loop=function _loop(i){var options=void 0;var correct=void 0;_this13.props.passage.fields.forEach(function(element){if(element.hasOwnProperty(fields[i])){options=element[fields[i]];correct=element['correct'];}});tmpArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ChildComponent,{feedback:_this13.props.feedback,correct:correct,field:fields[i],options:options,key:_this13.props.passage.passageId,handleSelection:_this13.handleSelection}),' ',newTxt[i+1],' '));};for(var i=1;i<fields.length;i++){_loop(i);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer maze passage',style:{padding:30,paddingTop:5}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'tc',style:{marginBottom:0,marginTop:0}},this.props.passage.passageTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:"passageMazeID",style:{paddingLeft:30,paddingRight:30}},tmpArray));}}]);return ParentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ChildComponent=function(_Component5){_inherits(ChildComponent,_Component5);function ChildComponent(props){_classCallCheck(this,ChildComponent);var _this14=_possibleConstructorReturn(this,(ChildComponent.__proto__||Object.getPrototypeOf(ChildComponent)).call(this,props));_this14.state={selected:''};_this14.handleSelection=_this14.handleSelection.bind(_this14);_this14.handleRemove=_this14.handleRemove.bind(_this14);return _this14;}_createClass(ChildComponent,[{key:'handleSelection',value:function handleSelection(e){var selected=this.props.options[e.currentTarget.dataset.id];this.setState({selected:selected.word});this.props.handleSelection(selected,this.props.field);e.preventDefault();}},{key:'handleRemove',value:function handleRemove(e){this.props.handleSelection('',this.props.field);this.setState({selected:''});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mazeOptions'},this.props.feedback&&this.state.selected===this.props.correct.word?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"flex",width:"190px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'blankSpace correct',onClick:this.handleRemove},this.state.selected),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"fdbkPlus"})):null,this.props.feedback&&this.state.selected.length>0&&this.state.selected!==this.props.correct.word?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"flex",width:"190px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'blankSpace error',onClick:this.handleRemove},this.state.selected),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"fdbkMinus"})):null,this.props.feedback&&this.state.selected.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'blankSpace skipped',onClick:this.handleRemove},this.state.selected):null,!this.props.feedback?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'blankSpace',onClick:this.handleRemove},this.state.selected):null,this.props.feedback?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,this.state.selected!==this.props.options[0].word&&this.props.options[0].word===this.props.correct.word?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{value:this.props.options[0].word,'data-id':0,className:'correct'},this.props.options[0].word):null,this.state.selected!==this.props.options[0].word&&this.props.options[0].word!==this.props.correct.word?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{value:this.props.options[0].word,'data-id':0},this.props.options[0].word):null,this.state.selected!==this.props.options[1].word&&this.props.options[1].word===this.props.correct.word?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{value:this.props.options[1].word,'data-id':1,className:'correct'},this.props.options[1].word):null,this.state.selected!==this.props.options[1].word&&this.props.options[1].word!==this.props.correct.word?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{value:this.props.options[1].word,'data-id':1},this.props.options[1].word):null,this.state.selected!==this.props.options[2].word&&this.props.options[2].word===this.props.correct.word?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{value:this.props.options[2].word,'data-id':2,className:'correct'},this.props.options[2].word):null,this.state.selected!==this.props.options[2].word&&this.props.options[2].word!==this.props.correct.word?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{value:this.props.options[2].word,'data-id':2},this.props.options[2].word):null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,this.state.selected===this.props.options[0].word?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:"blankOption",value:this.props.options[0].word,'data-id':0,onClick:this.handleSelection},this.props.options[0].word),this.state.selected===this.props.options[1].word?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:"blankOption",value:this.props.options[1].word,'data-id':1,onClick:this.handleSelection},this.props.options[1].word),this.state.selected===this.props.options[2].word?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:"blankOption",value:this.props.options[2].word,'data-id':2,onClick:this.handleSelection},this.props.options[2].word)));}}]);return ChildComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context12.abrupt('return',_context12.sent);case 3:case'end':return _context12.stop();}}},_callee12,_this15);}));function updateStudentAppStatus(_x7){return _ref13.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context13.abrupt('return',_context13.sent);case 3:case'end':return _context13.stop();}}},_callee13,_this15);}));function updateStudentAccountTab(_x8){return _ref14.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["a" /* updateAppStates */])(appStates));case 2:return _context14.abrupt('return',_context14.sent);case 3:case'end':return _context14.stop();}}},_callee14,_this15);}));function updateAppStates(_x9){return _ref15.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(MazeComponent)));

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StudentsComponent_Common__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyle={maxWidth:"8px",padding:"5px 10px",margin:"0 2px"};var ScoreBox=function(_Component){_inherits(ScoreBox,_Component);function ScoreBox(props){_classCallCheck(this,ScoreBox);return _possibleConstructorReturn(this,(ScoreBox.__proto__||Object.getPrototypeOf(ScoreBox)).call(this,props));}_createClass(ScoreBox,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container",style:{width:"100%"}},this.props.app&&this.props.app==="slash"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Correct",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:customStyle,className:"blankSpace correct"},this.props.correct)," Wrong",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:customStyle,className:"blankSpace error"},this.props.incorrect))):null,!this.props.app||this.props.app!=="slash"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"Correct",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:customStyle,className:"blankSpace correct"},this.props.correct)," Wrong",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:customStyle,className:"blankSpace error"},this.props.incorrect))):null);}}]);return ScoreBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ScoreBox);

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/modal_correct.1c2d7c93.png";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/modal_incorrect.7d53cef9.png";

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_device_detect__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_start_here_lable_png__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_start_here_lable_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_start_here_lable_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_ico_tick_png__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_ico_tick_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_ico_tick_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_ico_cross_png__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_ico_cross_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_ico_cross_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_logo_wordmark_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_logo_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_images_logo_wordmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_logo_wordmark2_png__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_logo_wordmark2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_images_logo_wordmark2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_PNScoreTasks_png__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_PNScoreTasks_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_images_PNScoreTasks_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_PNPictureCards_png__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_PNPictureCards_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_images_PNPictureCards_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_images_App_Selection_Graphic_png__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_images_App_Selection_Graphic_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_images_App_Selection_Graphic_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_images_How_to_select_apps_png__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_images_How_to_select_apps_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__assets_images_How_to_select_apps_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_images_info_icon_2f_png__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_images_info_icon_2f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__assets_images_info_icon_2f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_images_logo_avenuepm_png__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_images_logo_avenuepm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__assets_images_logo_avenuepm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_react_to_print__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_react_to_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_react_to_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ComponentToPrint__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__assets_images_badge_1_png__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__assets_images_badge_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__assets_images_badge_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__assets_images_badge_2_png__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__assets_images_badge_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__assets_images_badge_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__assets_images_badge_3_png__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__assets_images_badge_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__assets_images_badge_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__assets_images_badge_4_png__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__assets_images_badge_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__assets_images_badge_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__assets_images_badge_5_png__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__assets_images_badge_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__assets_images_badge_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__assets_images_badge_6_png__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__assets_images_badge_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__assets_images_badge_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__assets_images_badge_7_png__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__assets_images_badge_7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__assets_images_badge_7_png__);
var _this4=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a.setAppElement('body');var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'55%'}};var customStyleApp={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'55%'}};var addClassInstruction=null;var addStudentInstruction=null;var PNInstruction=null;var WSSInstruction=null;var CopyrightInstruction=null;var KidsignInstruction=null;var noticeStorage=localStorage.getItem('notice');var tooltipReadingLevel=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["i" /* Tooltip */],{id:'tooltipReadingLevel'},'Estimate Reading Grade Level. Add the reading grade versus placement grade.');var tooltipDisability=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["i" /* Tooltip */],{id:'tooltipDisability'},'Multiple Select Option');var tooltipApps=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["i" /* Tooltip */],{id:'tooltipApps'},'Multiple Select Option');var readingLevelOptions=[{value:'0',label:'0'},{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'},{value:'4',label:'4'},{value:'5',label:'5'},{value:'6',label:'6'}];var genderOptions=[{value:'1',label:'Female'},{value:'2',label:'Male'},{value:'3',label:'Other'}];var languageOptions=[{value:'1',label:'ASL'},{value:'2',label:'Signed English'},{value:'3',label:'Spoken English'},{value:'5',label:'Sim-com'},{value:'4',label:'Other'}];var disabilityOptions=[{value:'1',label:'None'},{value:'2',label:'Deaf'},{value:'3',label:'Hard of Hearing'},{value:'4',label:'Blind / Visually impaired'},{value:'5',label:'Learning Disability'},{value:'6',label:'Behavior Challenges'},{value:'7',label:'Developmental Challenges'},{value:'8',label:'Physical Challenges'}];var placementOptions=[{value:'1',label:'General Ed'},{value:'2',label:'Special Classroom'},{value:'3',label:'Resource Room'},{value:'4',label:'School for the Deaf'}];var gradeOptions=[{value:'0',label:'K'},{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'},{value:'4',label:'4'},{value:'5',label:'5'},{value:'6',label:'6'},{value:'7',label:'7'},{value:'8',label:'8'},{value:'9',label:'9'},{value:'10',label:'10'},{value:'11',label:'11'},{value:'12',label:'12'},{value:'Transition',label:'Transition'},{value:'College',label:'College'}];var fourValueOptions=[{value:'0',label:'No'},{value:'1',label:'Yes'},{value:'2',label:'Unknown'}];var appOptions=[{value:'picturenaming',label:'PictureNaming',isSelected:true},{value:'wordsignsay',label:'WordSign/Say',isSelected:true},{value:'copyright',label:'CopyRight',isSelected:true},{value:'slash',label:'Slash',isSelected:true},{value:'kidspeak',label:'KidSpeak',isSelected:true},{value:'maze',label:'Maze',isSelected:true},{value:'kidsign',label:'KidSign/Say',isSelected:true},{value:'wordmark',label:'WordMark',isSelected:true}];var getValue=function getValue(opts,val){return opts.find(function(o){return o.value===val;});};function getFourValue(opts,val){if(val==='-1')return null;else return opts.find(function(o){return o.value===val;});}var resultMultipleValues=[];var StudentsComponent=function(_Component){_inherits(StudentsComponent,_Component);function StudentsComponent(props){var _this2=this;_classCallCheck(this,StudentsComponent);var _this=_possibleConstructorReturn(this,(StudentsComponent.__proto__||Object.getPrototypeOf(StudentsComponent)).call(this,props));_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].logout().then(function(response){console.log('Response',response);if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_this.props.userLogout();_this.props.history.push("/login");},function(error){console.log('Error',error);localStorage.removeItem('token');localStorage.clear();_this.props.userLogout();_this.props.history.push("/login");});};_this.handleSelect=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(selected){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.selectStudentTab(selected);case 2:_context.next=4;return _this.props.selectStudentScoreListTab(0);case 4:_this.setState({activeTab:selected});case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleCancel=function(){_this.props.history.goBack();};_this.handleChangeTeacher=function(){_this.setState({changeTeacher:true});};_this.handleCancelTransfer=function(){_this.setState({changeTeacher:false});};_this.handleStudentClick=function(student,classId){_this.props.updateStudent(student);//this.props.history.push('/');
//this.props.history.push('/teacher/student');
_this.props.history.go(0);};_this.state={wordMarkScoreList:[],kidSpeakScoreList:[],pictureNamingScoreList:[],copyRightScoreList:[],activeTab:_this.props.studentTab,studentId:_this.props.student.userId,changeTeacher:false};return _this;}_createClass(StudentsComponent,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;console.log('studentScoreListTab',this.props.studentScoreListTab);__WEBPACK_IMPORTED_MODULE_26__Shared_Helpers__["a" /* default */].authorize(this);window.onpopstate=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(e.state&&e.state.key!==window.history.state.key)){_context2.next=12;break;}if(!(_this3.state.activeTab>1)){_context2.next=6;break;}_context2.next=4;return _this3.handleSelect(_this3.state.activeTab-1);case 4:_context2.next=12;break;case 6:_context2.next=8;return _this3.props.updateStudent(null);case 8:_context2.next=10;return _this3.props.selectStudentTab(1);case 10:_context2.next=12;return _this3.props.selectStudentScoreListTab(0);case 12:case'end':return _context2.stop();}}},_callee2,_this3);}));return function(_x2){return _ref2.apply(this,arguments);};}();//this.props.updateStudent(this.props.student);
console.log('studentScoreListTab2',this.props.studentScoreListTab);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_Header__["a" /* default */],{notifications:!this.props.schoolAdmin,bugReport:true,studentClick:this.handleStudentClick,logout:this.handleLogout}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},this.state.changeTeacher?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TransferStudentComponent,{schoolAdmin:this.props.schoolAdmin,studentId:this.props.student.id,handleCancelTransfer:this.handleCancelTransfer}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["b" /* Nav */],{className:'nav nav-tabs',onSelect:this.handleSelect,activeKey:this.state.activeTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["c" /* NavItem */],{eventKey:1},'Student Details'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["c" /* NavItem */],{eventKey:2},'Student Data'),this.props.schoolAdmin?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["c" /* NavItem */],{eventKey:3},'Score Tasks')),this.state.activeTab===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StudentDetails,{selectStudentScoreListTab:this.props.selectStudentScoreListTab,selectStudentTab:this.props.selectStudentTab,updateStudent:this.props.updateStudent,student:this.props.student,schoolAdmin:this.props.schoolAdmin,classId:this.props.classId,handleChangeTeacher:this.handleChangeTeacher,handleCancel:this.handleCancel}):null,this.state.activeTab===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Data,{selectStudentScoreListTab:this.props.selectStudentScoreListTab,selectStudentTab:this.props.selectStudentTab,updateStudent:this.props.updateStudent,student:this.props.student,schoolAdmin:this.props.schoolAdmin}):null,this.state.activeTab===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StudentScore,{selectStudentTab:this.props.selectStudentTab,selectStudentScoreListTab:this.props.selectStudentScoreListTab,studentScoreListTab:this.props.studentScoreListTab,updateStudent:this.props.updateStudent,student:this.props.student,wordMarkScore:this.state.wordMarkScoreList,kidSpeakScore:this.state.kidSpeakScoreList,pictureNamingScore:this.state.pictureNamingScoreList,copyRightScore:this.state.copyRightScoreList}):null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Shared_Footer__["a" /* default */],null));}}]);return StudentsComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var actionToProps=function actionToProps(dispatch){return{updateStudent:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions__["h" /* updateStudent */])(student));case 2:return _context3.abrupt('return',_context3.sent);case 3:case'end':return _context3.stop();}}},_callee3,_this4);}));function updateStudent(_x3){return _ref3.apply(this,arguments);}return updateStudent;}(),selectStudentTab:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(selectedTab){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions__["e" /* selectStudentTab */])(selectedTab));case 2:return _context4.abrupt('return',_context4.sent);case 3:case'end':return _context4.stop();}}},_callee4,_this4);}));function selectStudentTab(_x4){return _ref4.apply(this,arguments);}return selectStudentTab;}(),selectStudentScoreListTab:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(selectedScoreListTab){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions__["d" /* selectStudentScoreListTab */])(selectedScoreListTab));case 2:return _context5.abrupt('return',_context5.sent);case 3:case'end':return _context5.stop();}}},_callee5,_this4);}));function selectStudentScoreListTab(_x5){return _ref5.apply(this,arguments);}return selectStudentScoreListTab;}(),userLogout:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions__["j" /* userLogout */])());case 2:return _context6.abrupt('return',_context6.sent);case 3:case'end':return _context6.stop();}}},_callee6,_this4);}));function userLogout(){return _ref6.apply(this,arguments);}return userLogout;}()};};var mapStateToProps=function mapStateToProps(state){return{student:state.teacherReducer.student,studentTab:state.teacherReducer.studentTab,studentScoreListTab:state.teacherReducer.studentScoreListTab,schoolAdmin:state.teacherReducer.schoolAdmin};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_28_react_redux__["b" /* connect */])(mapStateToProps,actionToProps)(StudentsComponent));var StudentDetailsComponent=function(_Component2){_inherits(StudentDetailsComponent,_Component2);function StudentDetailsComponent(props){_classCallCheck(this,StudentDetailsComponent);var _this5=_possibleConstructorReturn(this,(StudentDetailsComponent.__proto__||Object.getPrototypeOf(StudentDetailsComponent)).call(this,props));if(!_this5.props.student||!_this5.props.classId){return _possibleConstructorReturn(_this5);}_this5.state={firstname:_this5.props.student.user.firstname,lastname:_this5.props.student.user.lastname,email:_this5.props.student.parent?_this5.props.student.parent.email:'',loginID:_this5.props.student.userId,password:_this5.props.student.user.password,gender:_this5.props.student.gender,gradeLevel:_this5.props.student.gradeLevel,language:_this5.props.student.language,disability:_this5.props.student.disability,apps:_this5.props.student.apps,screeningLevel:_this5.props.student.screeningLevel,placement:_this5.props.student.placement,multipleValues:_this5.getInitialMultipleValues(_this5.props.student.disability.toString()),multipleValues1:[],specialNeedsData:_this5.props.student.specialNeedsData,freeLunch:_this5.props.student.freeLunch,ell:_this5.props.student.ell,title1:_this5.props.student.title1,research:_this5.props.student.research==='true'||_this5.props.student.research==='1'?true:false,parentId:_this5.props.student.parent?_this5.props.student.parent.id:null,parent:_this5.props.student.parent,firstNameError:'',lastNameError:'',passwordError:'',readingLevelError:'',genderError:'',languageError:'',disabilityError:'',placementError:'',gradeError:'',emailWarning:'',errorEmail:'',errorNote:'',modalDialog:false,responseContent:'',excludeVid:false,showAppIntro:false,analytics:{type:null,metadata:null}};_this5.handleName=_this5.handleName.bind(_this5);_this5.handleLastName=_this5.handleLastName.bind(_this5);_this5.handlePassword=_this5.handlePassword.bind(_this5);_this5.handleEmail=_this5.handleEmail.bind(_this5);_this5.handleLoginID=_this5.handleLoginID.bind(_this5);_this5.handleGender=_this5.handleGender.bind(_this5);_this5.handleReadingLevel=_this5.handleReadingLevel.bind(_this5);_this5.handleGrade=_this5.handleGrade.bind(_this5);_this5.handleLanguage=_this5.handleLanguage.bind(_this5);_this5.handleDisability=_this5.handleDisability.bind(_this5);_this5.handleFreeLunch=_this5.handleFreeLunch.bind(_this5);_this5.handleELL=_this5.handleELL.bind(_this5);_this5.handlePlacement=_this5.handlePlacement.bind(_this5);_this5.handleSpecialEd=_this5.handleSpecialEd.bind(_this5);_this5.handleTitle1=_this5.handleTitle1.bind(_this5);_this5.handleResearch=_this5.handleResearch.bind(_this5);_this5.handleAppChange=_this5.handleAppChange.bind(_this5);_this5.handleSave=_this5.handleSave.bind(_this5);_this5.handleCancel=_this5.handleCancel.bind(_this5);_this5.handleDelete=_this5.handleDelete.bind(_this5);_this5.handleChangeTeacher=_this5.handleChangeTeacher.bind(_this5);_this5.handleBackClick=_this5.handleBackClick.bind(_this5);_this5.handleExcludeVid=_this5.handleExcludeVid.bind(_this5);_this5.handleAnalytics=_this5.handleAnalytics.bind(_this5);_this5.handleAppIntroduction=_this5.handleAppIntroduction.bind(_this5);_this5.closeAppIntro=_this5.closeAppIntro.bind(_this5);_this5.getInitialMultipleValues=_this5.getInitialMultipleValues.bind(_this5);return _this5;}_createClass(StudentDetailsComponent,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'getInitialMultipleValues',value:function getInitialMultipleValues(values){var valueArray=values.split(',');var multipleValues=[];for(var i=0;i<valueArray.length;i++){multipleValues.push(getValue(disabilityOptions,valueArray[i]));}if(multipleValues.length==0){multipleValues.push(getValue(disabilityOptions,1));}return multipleValues;}},{key:'getMultipleValues',value:function getMultipleValues(values){var valueArray=values.split(',');for(var i=0;i<valueArray.length;i++){this.state.multipleValues.push(getValue(disabilityOptions,valueArray[i]));}return false;}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleExcludeVid',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(event){var values,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,opt,_values,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,_opt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:this.setState({excludeVid:event.target.checked,apps:null});if(!(event.target.checked==true)){_context7.next=29;break;}appOptions=[{value:'slash',label:'Slash',isSelected:true},{value:'kidspeak',label:'KidSpeak',isSelected:true},{value:'maze',label:'Maze',isSelected:true},{value:'wordmark',label:'WordMark',isSelected:true}];values=[];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context7.prev=7;for(_iterator=appOptions[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){opt=_step.value;values.push(opt.value);}_context7.next=15;break;case 11:_context7.prev=11;_context7.t0=_context7['catch'](7);_didIteratorError=true;_iteratorError=_context7.t0;case 15:_context7.prev=15;_context7.prev=16;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 18:_context7.prev=18;if(!_didIteratorError){_context7.next=21;break;}throw _iteratorError;case 21:return _context7.finish(18);case 22:return _context7.finish(15);case 23:_context7.next=25;return this.setState({apps:values.join(",")});case 25:_context7.next=27;return this.handleAppChange(appOptions);case 27:_context7.next=54;break;case 29:appOptions=[{value:'picturenaming',label:'PictureNaming',isSelected:true},{value:'wordsignsay',label:'WordSign/Say',isSelected:true},{value:'copyright',label:'CopyRight',isSelected:true},{value:'slash',label:'Slash',isSelected:true},{value:'kidspeak',label:'KidSpeak',isSelected:true},{value:'maze',label:'Maze',isSelected:true},{value:'kidsign',label:'KidSign',isSelected:true},{value:'wordmark',label:'WordMark',isSelected:true}];_values=[];_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context7.prev=34;for(_iterator2=appOptions[Symbol.iterator]();!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){_opt=_step2.value;_values.push(_opt.value);}_context7.next=42;break;case 38:_context7.prev=38;_context7.t1=_context7['catch'](34);_didIteratorError2=true;_iteratorError2=_context7.t1;case 42:_context7.prev=42;_context7.prev=43;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 45:_context7.prev=45;if(!_didIteratorError2){_context7.next=48;break;}throw _iteratorError2;case 48:return _context7.finish(45);case 49:return _context7.finish(42);case 50:_context7.next=52;return this.setState({apps:_values.join(",")});case 52:_context7.next=54;return this.handleAppChange(appOptions);case 54:case'end':return _context7.stop();}}},_callee7,this,[[7,11,15,23],[16,,18,22],[34,38,42,50],[43,,45,49]]);}));function handleExcludeVid(_x6){return _ref7.apply(this,arguments);}return handleExcludeVid;}()},{key:'handleName',value:function handleName(event){this.setState({firstname:event.target.value});}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastname:event.target.value});}},{key:'handlePassword',value:function handlePassword(event){this.setState({password:event.target.value});}},{key:'handleEmail',value:function handleEmail(event){this.setState({email:event.target.value});if(event.target.value.length===0){this.setState({email:null,errorEmail:'',emailWarning:''});}else{if(!this.validateEmail(event.target.value)){this.setState({errorEmail:'validationRed',emailWarning:'Email address format is invalid'});}else{this.setState({email:event.target.value,emailWarning:'',errorEmail:''});}}}},{key:'handleLoginID',value:function handleLoginID(event){this.setState({loginID:event.target.value});}},{key:'handleLanguage',value:function handleLanguage(event){this.setState({language:event.value});}},{key:'handleReadingLevel',value:function handleReadingLevel(event){this.setState({screeningLevel:event.value});}},{key:'handleDisability',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(event){var options,value,i,l;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:options=event;value=[];if(options&&options.length===0){disabilityOptions=[{value:'1',label:'None'},{value:'2',label:'Deaf'},{value:'3',label:'Hard of Hearing'},{value:'4',label:'Blind / Visually impaired'},{value:'5',label:'Learning Disability'},{value:'6',label:'Behavior Challenges'},{value:'7',label:'Developmental Challenges'},{value:'8',label:'Physical Challenges'}];}if(!options){_context8.next=8;break;}for(i=0,l=options.length;i<l;i++){if(options[i].value==1){disabilityOptions=[{value:'1',label:'None'}];value=[];value.push(1);}else{disabilityOptions=[{value:'2',label:'Deaf'},{value:'3',label:'Hard of Hearing'},{value:'4',label:'Blind / Visually impaired'},{value:'5',label:'Learning Disability'},{value:'6',label:'Behavior Challenges'},{value:'7',label:'Developmental Challenges'},{value:'8',label:'Physical Challenges'}];value.push(options[i].value);}}_context8.next=7;return this.setState({disability:value.join(",")});case 7:this.getMultipleValues(this.state.disability.toString());case 8:case'end':return _context8.stop();}}},_callee8,this);}));function handleDisability(_x7){return _ref8.apply(this,arguments);}return handleDisability;}()},{key:'handleAppChange',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(value){var values,_iteratorNormalCompletion3,_didIteratorError3,_iteratorError3,_iterator3,_step3,opt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:values=[];_iteratorNormalCompletion3=true;_didIteratorError3=false;_iteratorError3=undefined;_context9.prev=4;for(_iterator3=value[Symbol.iterator]();!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){opt=_step3.value;values.push(opt.value);}_context9.next=12;break;case 8:_context9.prev=8;_context9.t0=_context9['catch'](4);_didIteratorError3=true;_iteratorError3=_context9.t0;case 12:_context9.prev=12;_context9.prev=13;if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}case 15:_context9.prev=15;if(!_didIteratorError3){_context9.next=18;break;}throw _iteratorError3;case 18:return _context9.finish(15);case 19:return _context9.finish(12);case 20:_context9.next=22;return this.setState({apps:values.join(","),multipleValues1:value});case 22:case'end':return _context9.stop();}}},_callee9,this,[[4,8,12,20],[13,,15,19]]);}));function handleAppChange(_x8){return _ref9.apply(this,arguments);}return handleAppChange;}()},{key:'handleGrade',value:function handleGrade(event){this.setState({gradeLevel:event.value});}},{key:'handleGender',value:function handleGender(event){this.setState({gender:event.value});}},{key:'handlePlacement',value:function handlePlacement(event){this.setState({placement:event.value});}},{key:'handleELL',value:function handleELL(event){this.setState({ell:event===null?'-1':event.value});}},{key:'handleFreeLunch',value:function handleFreeLunch(event){this.setState({freeLunch:event===null?'-1':event.value});}},{key:'handleSpecialEd',value:function handleSpecialEd(event){this.setState({specialNeedsData:event===null?'-1':event.value});}},{key:'handleTitle1',value:function handleTitle1(event){this.setState({title1:event===null?'-1':event.value});}},{key:'handleResearch',value:function handleResearch(event){this.setState({research:!event.target.checked});}},{key:'handleRemoveParent',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(event){var _this6=this;var confirmed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:confirmed=window.confirm("Are you sure that you want to remove the parent?");if(!confirmed){_context10.next=7;break;}_context10.next=4;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].deleteParent(this.state.loginID);case 4:_context10.next=6;return this.setState({parentId:null,parent:null,email:'',modalDialog:true,responseContent:'The parent has been removed.'});case 6:setTimeout(function(){_this6.setState({modalDialog:false});_this6.handleCancel();},2000);case 7:case'end':return _context10.stop();}}},_callee10,this);}));function handleRemoveParent(_x9){return _ref10.apply(this,arguments);}return handleRemoveParent;}()},{key:'validateEmail',value:function validateEmail(email){var re=/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;return re.test(email);}},{key:'validate',value:function validate(){var valid=true;if(this.state.firstname===''){valid=false;this.setState({firstNameError:'firstNameError'});}else{this.setState({firstNameError:''});}if(this.state.lastname.length===0){valid=false;this.setState({lastNameError:'lastNameError'});}else{this.setState({lastNameError:''});}if(!this.state.email||this.state.email===''){this.setState({email:null,errorEmail:'',emailWarning:''});}else{if(!this.validateEmail(this.state.email)){this.setState({errorEmail:'validationRed',emailWarning:'Email address format is invalid'});valid=false;}else{this.setState({emailWarning:'',errorEmail:''});}}if(this.state.password.length===0){valid=false;this.setState({passwordError:'passwordError'});}else{this.setState({passwordError:''});}if(this.state.screeningLevel===null){valid=false;this.setState({readingLevelError:'readingLevelError'});}else{this.setState({readingLevelError:''});}if(this.state.gender===null){valid=false;this.setState({genderError:'genderError'});}else{this.setState({genderError:''});}if(this.state.language===null){valid=false;this.setState({languageError:'languageError'});}else{this.setState({languageError:''});}if(this.state.disability===null||this.state.disability.length===0){valid=false;this.setState({disabilityError:'disabilityError'});}else{this.setState({disabilityError:''});}if(this.state.placement===null){valid=false;this.setState({placementError:'placementError'});}else{this.setState({placementError:''});}if(this.state.gradeLevel===null){valid=false;this.setState({gradeError:'gradeError'});}else{this.setState({gradeError:''});}return valid;//TODO: check email for regex
}},{key:'handleSave',value:function handleSave(event){var _this7=this;if(this.validate()){this.setState({errorNote:''});var user=this.state;user['userId']=this.props.student.userId;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].updateStudent(user).then(function(response){if(response.ok){_this7.setState({modalDialog:true,responseContent:'Student Details Successfully Updated'});_this7.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].TEACHER_STUDENT_DETAILS_SAVE_CHANGES,metadata:{userId:_this7.props.student.userId}}},function(){return _this7.handleAnalytics();});setTimeout(function(){_this7.setState({modalDialog:false});_this7.handleCancel();},2000);}else if(response.statusText=="Unauthorized"){_this7.setState({modalDialog:true,responseContent:response.msg?response.msg:'Failed to save. Only the student’s teacher can change this information.'});}else{_this7.setState({modalDialog:true,responseContent:response.msg?response.msg:'Failed to save. The parent email may have been used before.'});}},function(error){console.log('Error new student',error);});}else{this.setState({errorNote:'Fields with red outline have to be filled in or selected!'});}}},{key:'handleCancel',value:function handleCancel(event){this.props.updateStudent(null);this.props.handleCancel();}},{key:'handleDelete',value:function handleDelete(event){var _this8=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].deleteStudent(this.state.loginID).then(function(response){if(response.success){_this8.setState({modalDialog:true,responseContent:'Student successfully deleted'});setTimeout(function(){_this8.setState({modalDialog:false});_this8.handleCancel();},3500);}else{_this8.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this8.setState({modalDialog:false});},3500);}},function(error){_this8.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this8.setState({modalDialog:false});},3500);});}},{key:'handleChangeTeacher',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(event){var _this9=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].TEACHER_STUDENT_DETAILS_CHANGE_TEACHER_CLICK,metadata:{userId:this.props.student.userId}}},function(){return _this9.handleAnalytics();});case 2:this.props.handleChangeTeacher();case 3:case'end':return _context11.stop();}}},_callee11,this);}));function handleChangeTeacher(_x10){return _ref11.apply(this,arguments);}return handleChangeTeacher;}()},{key:'handleBackClick',value:function handleBackClick(event){this.props.updateStudent(null);this.props.selectStudentTab(1);this.props.selectStudentScoreListTab(0);this.props.history.goBack();}},{key:'handleAppIntroduction',value:function handleAppIntroduction(){this.setState({showAppIntro:true});}},{key:'closeAppIntro',value:function closeAppIntro(){this.setState({showAppIntro:false});}},{key:'render',value:function render(){var _this10=this,_React$createElement;if(!this.props.student||!this.props.classId){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Redirect */],{to:'/login'});}var appsPreselect=appOptions.map(function(e){if(_this10.state.apps.split(",").includes(e.value)){return e;}});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this10.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.state.showAppIntro,style:{customStyleApp:customStyleApp}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{width:250,float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3',style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.closeAppIntro,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3',style:{marginLeft:50,marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.printAppIntro,className:'handBtn',href:"https://docs.google.com/document/d/1LuRBxc0aFzkC0sLe_xvfxCXrTZxPJHD70s1WhxFMKEI/edit?usp=sharing"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Print'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:100,marginLeft:50}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__ComponentToPrint__["a" /* default */],{ref:function ref(el){return _this10.componentRef=el;}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{color:'red',paddingLeft:15}},this.state.errorNote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:'formAddStudent'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentName'},'First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',defaultValue:this.state.firstname,onChange:this.handleName,id:'inputStudentName',className:this.state.firstNameError+" form-control inputStyle1",placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentLastName'},'Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',defaultValue:this.state.lastname,onChange:this.handleLastName,id:'inputStudentLastName',className:this.state.lastNameError+" form-control inputStyle1",placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentLoginID'},'User Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',defaultValue:this.state.loginID,onChange:this.handleLoginID,id:'inputStudentLoginID',className:'form-control inputStyle1',placeholder:'User Number',disabled:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentPassword'},'Password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',defaultValue:this.state.password,onChange:this.handlePassword,id:'inputStudentPassword',className:this.state.passwordError+" form-control inputStyle1",placeholder:'Password',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentReadingLevel'},'Reading Level'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* OverlayTrigger */],{placement:'top',overlay:tooltipReadingLevel},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handleReadingLevel,defaultValue:getValue(readingLevelOptions,this.state.screeningLevel),id:'inputStudentReadingLevel',className:this.state.readingLevelError,options:readingLevelOptions,isSearchable:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentGender'},'Gender'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handleGender,id:'inputStudentGender',defaultValue:getValue(genderOptions,this.state.gender),options:genderOptions,isSearchable:false,className:this.state.genderError})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentLanguage'},'Language'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handleLanguage,id:'inputStudentLanguage',options:languageOptions,defaultValue:getValue(languageOptions,this.state.language),className:this.state.languageError,isSearchable:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentDisability'},'Student Description'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* OverlayTrigger */],{placement:'top',overlay:tooltipDisability},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],(_React$createElement={onChange:this.handleDisability,id:'inputStudentDisability',defaultValue:this.state.multipleValues,className:'basic-multi-select',options:disabilityOptions},_defineProperty(_React$createElement,'className',this.state.disabilityError),_defineProperty(_React$createElement,'isMulti',true),_defineProperty(_React$createElement,'isSearchable',false),_React$createElement))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentPlacement'},'Placement'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handlePlacement,id:'inputStudentPlacement',defaultValue:getValue(placementOptions,this.state.placement),options:placementOptions,className:this.state.placementError,isSearchable:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentGrade'},'Grade Placement'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handleGrade,id:'inputStudentGrade',className:this.state.gradeError,defaultValue:getValue(gradeOptions,this.state.gradeLevel),options:gradeOptions,isSearchable:false}),this.state.parentId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputParentId'},'Parent User Number (',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this10.handleRemoveParent();}},'Remove Parent'),')'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',id:'inputParentId',value:this.state.parent.userId,className:"form-control inputStyle1",placeholder:'ParentId',disabled:"true"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentEmail'},'Parent Email'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.email,onChange:this.handleEmail,id:'inputStudentEmail',className:this.state.errorEmail+" form-control inputStyle1",placeholder:'Email',required:true,disabled:true})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentEmail'},'Parent Email'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.email,onChange:this.handleEmail,id:'inputStudentEmail',className:this.state.errorEmail+" form-control inputStyle1",placeholder:'Email',required:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentIEP'},'IEP (Optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handleSpecialEd,id:'inputStudentSpecialEd',defaultValue:getFourValue(fourValueOptions,this.state.specialNeedsData),options:fourValueOptions,isSearchable:false,isClearable:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentELL'},'ELL (Optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handleELL,id:'inputStudentELL',defaultValue:getFourValue(fourValueOptions,this.state.ell),options:fourValueOptions,isSearchable:false,isClearable:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentFreeLunch'},'Free Lunch (Optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handleFreeLunch,id:'inputStudentFreeLunch',defaultValue:getFourValue(fourValueOptions,this.state.freeLunch),options:fourValueOptions,isSearchable:false,isClearable:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentTitle1'},'Title 1 (Optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handleTitle1,id:'inputStudentTitle1',defaultValue:getFourValue(fourValueOptions,this.state.title1),options:fourValueOptions,isSearchable:false,isClearable:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'Research',className:'cb'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleResearch,name:'Research',checked:!this.state.research,id:'Research'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'checkmark'}),' Exclude Student Data'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'ExcludeVideoApps',className:'cb',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleExcludeVid,name:'ExcludeVideoApps',value:this.state.excludeVid,id:'ExcludeVideoApps'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'checkmark'}),' Exclude Video Apps'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{color:'red',paddingBottom:10}},this.state.emailWarning)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 ",style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{marginLeft:5}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentApps'},'Task Apps')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4',style:{height:40,marginTop:-30,marginLeft:90,cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_34__assets_images_info_icon_2f_png___default.a,style:{width:22,height:22},onClick:this.handleAppIntroduction}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{target:'_blank',href:"https://docs.google.com/document/d/1LuRBxc0aFzkC0sLe_xvfxCXrTZxPJHD70s1WhxFMKEI/edit?usp=sharing",style:{fontFamily:'Open Sans',fontSize:'1.00em'},name:'How',className:'btn btn-link'},'How to Select Apps'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* OverlayTrigger */],{placement:'top',overlay:tooltipApps},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{className:'basic-multi-select',isMulti:true,onChange:this.handleAppChange.bind(this),options:appOptions,value:appsPreselect,isSearchable:false})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleBackClick,className:'backArrow fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Back to Students\' List')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this10.handleSave();},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save Changes')))));}}]);return StudentDetailsComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var StudentDetails=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(StudentDetailsComponent);var StudentData=function(_Component3){_inherits(StudentData,_Component3);function StudentData(props){_classCallCheck(this,StudentData);var _this11=_possibleConstructorReturn(this,(StudentData.__proto__||Object.getPrototypeOf(StudentData)).call(this,props));_this11.state={modalDialog:false,responseContent:'',pnTypeModel:false,noDataModel:false,analytics:{type:null,metadata:null}};_this11.handleBackClick=_this11.handleBackClick.bind(_this11);_this11.handleTutorial=_this11.handleTutorial.bind(_this11);_this11.handleMazeClick=_this11.handleMazeClick.bind(_this11);_this11.handleSlashTestClick=_this11.handleSlashTestClick.bind(_this11);_this11.handleWordMarkClick=_this11.handleWordMarkClick.bind(_this11);_this11.handleWordMark2Click=_this11.handleWordMark2Click.bind(_this11);_this11.handleKidSpeakClick=_this11.handleKidSpeakClick.bind(_this11);_this11.handlePictureNamingClick=_this11.handlePictureNamingClick.bind(_this11);_this11.handlePNTypeClose=_this11.handlePNTypeClose.bind(_this11);_this11.handleChoosePNComputerModel=_this11.handleChoosePNComputerModel.bind(_this11);_this11.handleChoosePN1On1Model=_this11.handleChoosePN1On1Model.bind(_this11);_this11.handleChoosePNManualModel=_this11.handleChoosePNManualModel.bind(_this11);_this11.handleCopyRightClick=_this11.handleCopyRightClick.bind(_this11);_this11.handleWordSignSayClick=_this11.handleWordSignSayClick.bind(_this11);_this11.handleKidSignClick=_this11.handleKidSignClick.bind(_this11);_this11.handleNoDataClose=_this11.handleNoDataClose.bind(_this11);_this11.handleAnalytics=_this11.handleAnalytics.bind(_this11);return _this11;}_createClass(StudentData,[{key:'handleBackClick',value:function handleBackClick(event){this.props.updateStudent(null);this.props.selectStudentTab(1);this.props.selectStudentScoreListTab(3);if(this.props.schoolAdmin){this.props.history.push("/school-admin");}else{this.props.history.push("/teacher");}}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleTutorial',value:function handleTutorial(event){var _this12=this;this.setState({modalDialog:true,responseContent:'To Be Added'});setTimeout(function(){_this12.setState({modalDialog:false});},3500);}},{key:'handleMazeClick',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(event){var _this13=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].MAZE_DATACHART_VIEW,metadata:{userId:this.props.student.userId}}});case 2:this.handleAnalytics();_context12.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"Maze").then(function(res){if(res.body===0){_this13.setState({noDataModel:true});}else{_this13.props.history.push('/teacher/student/data/maze');}});case 5:case'end':return _context12.stop();}}},_callee12,this);}));function handleMazeClick(_x11){return _ref12.apply(this,arguments);}return handleMazeClick;}()},{key:'handleWordMarkClick',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(event){var _this14=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].WM_DATACHART_VIEW,metadata:{userId:this.props.student.userId}}});case 2:this.handleAnalytics();_context13.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"WordMark").then(function(res){if(res.body===0){_this14.setState({noDataModel:true});}else{_this14.props.history.push('/teacher/student/data/wordmark');}});case 5:case'end':return _context13.stop();}}},_callee13,this);}));function handleWordMarkClick(_x12){return _ref13.apply(this,arguments);}return handleWordMarkClick;}()},{key:'handleWordMark2Click',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(event){var _this15=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].WM_DATACHART_VIEW,metadata:{userId:this.props.student.userId}}});case 2:this.handleAnalytics();_context14.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"WordMark2").then(function(res){if(res.body===0){_this15.setState({noDataModel:true});}else{_this15.props.history.push('/teacher/student/data/wordmark2');}});case 5:case'end':return _context14.stop();}}},_callee14,this);}));function handleWordMark2Click(_x13){return _ref14.apply(this,arguments);}return handleWordMark2Click;}()},{key:'handleSlashTestClick',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(event){var _this16=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].SLASH_DATACHART_VIEW,metadata:{userId:this.props.student.userId}}});case 2:this.handleAnalytics();_context15.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"Slash").then(function(res){if(res.body===0){_this16.setState({noDataModel:true});}else{_this16.props.history.push('/teacher/student/data/slashtest');}});case 5:case'end':return _context15.stop();}}},_callee15,this);}));function handleSlashTestClick(_x14){return _ref15.apply(this,arguments);}return handleSlashTestClick;}()},{key:'handleKidSpeakClick',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(event){var _this17=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].KS_DATACHART_VIEW,metadata:{userId:this.props.student.userId}}});case 2:this.handleAnalytics();_context16.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"KidSpeak").then(function(res){if(res.body===0){_this17.setState({noDataModel:true});}else{_this17.props.history.push('/teacher/student/data/kidspeak');}});case 5:case'end':return _context16.stop();}}},_callee16,this);}));function handleKidSpeakClick(_x15){return _ref16.apply(this,arguments);}return handleKidSpeakClick;}()},{key:'handlePictureNamingClick',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:this.setState({pnTypeModel:true});case 1:case'end':return _context17.stop();}}},_callee17,this);}));function handlePictureNamingClick(_x16){return _ref17.apply(this,arguments);}return handlePictureNamingClick;}()},{key:'handlePNTypeClose',value:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:this.setState({pnTypeModel:false});case 1:case'end':return _context18.stop();}}},_callee18,this);}));function handlePNTypeClose(_x17){return _ref18.apply(this,arguments);}return handlePNTypeClose;}()},{key:'handleChoosePNComputerModel',value:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(event){var _this18=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].PN_DATACHART_VIEW,metadata:{userId:this.props.student.userId,PNModel:'Computer'}}});case 2:this.handleAnalytics();_context19.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"PictureNaming/Computer").then(function(res){if(res.body===0){_this18.setState({pnTypeModel:false,noDataModel:true});}else{_this18.props.history.push('/teacher/student/data/picturenaming/computer');}});case 5:case'end':return _context19.stop();}}},_callee19,this);}));function handleChoosePNComputerModel(_x18){return _ref19.apply(this,arguments);}return handleChoosePNComputerModel;}()},{key:'handleChoosePN1On1Model',value:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(event){var _this19=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].PN_DATACHART_VIEW,metadata:{userId:this.props.student.userId,PNModel:'1On1'}}});case 2:this.handleAnalytics();_context20.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"PictureNaming/1On1").then(function(res){if(res.body===0){_this19.setState({pnTypeModel:false,noDataModel:true});}else{_this19.props.history.push('/teacher/student/data/picturenaming/1On1');}});case 5:case'end':return _context20.stop();}}},_callee20,this);}));function handleChoosePN1On1Model(_x19){return _ref20.apply(this,arguments);}return handleChoosePN1On1Model;}()},{key:'handleChoosePNManualModel',value:function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(event){var _this20=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:_context21.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].PN_DATACHART_VIEW,metadata:{userId:this.props.student.userId,PNModel:'Manual'}}});case 2:this.handleAnalytics();_context21.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"PictureNaming/Manual").then(function(res){if(res.body===0){_this20.setState({pnTypeModel:false,noDataModel:true});}else{_this20.props.history.push('/teacher/student/data/picturenaming/manual');}});case 5:case'end':return _context21.stop();}}},_callee21,this);}));function handleChoosePNManualModel(_x20){return _ref21.apply(this,arguments);}return handleChoosePNManualModel;}()},{key:'handleCopyRightClick',value:function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(event){var _this21=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].CR_DATACHART_VIEW,metadata:{userId:this.props.student.userId}}});case 2:this.handleAnalytics();_context22.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"CopyRight").then(function(res){if(res.body===0){_this21.setState({noDataModel:true});}else{_this21.props.history.push('/teacher/student/data/copyright');}});case 5:case'end':return _context22.stop();}}},_callee22,this);}));function handleCopyRightClick(_x21){return _ref22.apply(this,arguments);}return handleCopyRightClick;}()},{key:'handleWordSignSayClick',value:function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(event){var _this22=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:_context23.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].WSS_DATACHART_VIEW,metadata:{userId:this.props.student.userId}}});case 2:this.handleAnalytics();_context23.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"WordSign/Say").then(function(res){if(res.body===0){_this22.setState({noDataModel:true});}else{_this22.props.history.push('/teacher/student/data/wordsignsay');}});case 5:case'end':return _context23.stop();}}},_callee23,this);}));function handleWordSignSayClick(_x22){return _ref23.apply(this,arguments);}return handleWordSignSayClick;}()},{key:'handleKidSignClick',value:function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(event){var _this23=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:_context24.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].KSS_DATACHART_VIEW,metadata:{userId:this.props.student.userId}}});case 2:this.handleAnalytics();_context24.next=5;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"KidSign").then(function(res){if(res.body===0){_this23.setState({noDataModel:true});}else{_this23.props.history.push('/teacher/student/data/kidsign');}});case 5:case'end':return _context24.stop();}}},_callee24,this);}));function handleKidSignClick(_x23){return _ref24.apply(this,arguments);}return handleKidSignClick;}()},{key:'handleNoDataClose',value:function(){var _ref25=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:this.setState({noDataModel:false});case 1:case'end':return _context25.stop();}}},_callee25,this);}));function handleNoDataClose(_x24){return _ref25.apply(this,arguments);}return handleNoDataClose;}()},{key:'render',value:function render(){var _this24=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-pane solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this24.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2 col-xs-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{paddingTop:15}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleBackClick,className:'backArrow fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Back to Students\' List')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-8 col-xs-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav nav-pills pill-sm',style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handlePictureNamingClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png___default.a,alt:'Picture Naming',border:'0'}),this.props.student.user.student_score_state&&this.props.student.user.student_score_state.pnLevel>12?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_44__assets_images_badge_7_png___default.a,style:{position:'absolute',right:-20,bottom:-20}}):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleWordSignSayClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png___default.a,alt:'Word Sign/Say',border:'0'}),this.props.student.user.student_score_state&&this.props.student.user.student_score_state.wssLevel>1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_41__assets_images_badge_4_png___default.a,style:{position:'absolute',right:-20,bottom:-20}}):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleCopyRightClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png___default.a,alt:'Copy Right',border:'0'}),this.props.student.user.student_score_state&&this.props.student.user.student_score_state.crLevel>6?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_38__assets_images_badge_1_png___default.a,style:{position:'absolute',right:-20,bottom:-20}}):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleSlashTestClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18__assets_images_logo_slashtest_png___default.a,alt:'Slash Test',border:'0'}),this.props.student.user.student_score_state&&this.props.student.user.student_score_state.slashLevel>8?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_40__assets_images_badge_3_png___default.a,style:{position:'absolute',right:-20,bottom:-20}}):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleKidSpeakClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png___default.a,alt:'Kid Speak',border:'0'}),this.props.student.user.student_score_state&&this.props.student.user.student_score_state.ksLevel>12?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_39__assets_images_badge_2_png___default.a,style:{position:'absolute',right:-20,bottom:-20}}):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleMazeClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__assets_images_logo_maze_png___default.a,alt:'Maze',border:'0'}),this.props.student.user.student_score_state&&this.props.student.user.student_score_state.mazeLevel>12?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_42__assets_images_badge_5_png___default.a,style:{position:'absolute',right:-20,bottom:-20}}):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleKidSignClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png___default.a,alt:'KidSign',border:'0'}),this.props.student.user.student_score_state&&this.props.student.user.student_score_state.kssLevel>12?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_43__assets_images_badge_6_png___default.a,style:{position:'absolute',right:-20,bottom:-20}}):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleWordMarkClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_22__assets_images_logo_wordmark_png___default.a,alt:'Word Mark',border:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleWordMark2Click},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_23__assets_images_logo_wordmark2_png___default.a,alt:'Word Mark2',border:'0'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2 col-xs-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{style:{textAlign:'right',paddingTop:20,fontSize:'1.25em'}},this.props.student!==null?this.props.student.user.firstname:null,' ',this.props.student!==null?this.props.student.user.lastname:null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative col-md-12 tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.state.noDataModel,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'No tasks completed yet.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNoDataClose,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.state.pnTypeModel,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'PictureNaming Data Chart')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this24.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12 bgGrey roundCorners'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Please choose the type of PictureNaming assessments')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12',style:{"marginBottom":10,"marginTop":10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleChoosePNComputerModel,className:'handBtn',type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Computer Tasks')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleChoosePNManualModel,className:'handBtn',type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Manual Tasks')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handlePNTypeClose,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-4'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-4'})))));}}]);return StudentData;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Data=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(StudentData);var StudentScore=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(function(_Component4){_inherits(StudentScore,_Component4);function StudentScore(props){_classCallCheck(this,StudentScore);var _this25=_possibleConstructorReturn(this,(StudentScore.__proto__||Object.getPrototypeOf(StudentScore)).call(this,props));_this25.handleBackClick=_this25.handleBackClick.bind(_this25);_this25.state={showData:_this25.props.studentScoreListTab,wordMarkScoreList:[],wordMark2ScoreList:[],kidSpeakScoreList:[],pictureNamingScoreList:[],copyRightScoreList:[],wordSignSayScoreList:[],kidSignScoreList:[],student:_this25.props.student,modalDialog:false,responseContent:'',pnScoreModel:false,pnTypeModel:true,noDataModel:false,analytics:{type:null,metadata:null}};_this25.handleAnalytics=_this25.handleAnalytics.bind(_this25);_this25.handlePNScoreTasks=_this25.handlePNScoreTasks.bind(_this25);_this25.handlePNClose=_this25.handlePNClose.bind(_this25);return _this25;}_createClass(StudentScore,[{key:'componentDidMount',value:function componentDidMount(){var _this26=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listWordMarkScore(this.state.student.user.id).then(function(response){if(response.success){_this26.setState({wordMarkScoreList:response.body});}else{_this26.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);}},function(error){_this26.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);});__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listWordMark2Score(this.state.student.user.id).then(function(response){if(response.success){_this26.setState({wordMark2ScoreList:response.body});}else{_this26.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);}},function(error){_this26.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);});__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listKidSpeakScore(this.state.student.user.id).then(function(response){if(response.success){_this26.setState({kidSpeakScoreList:response.body});}else{_this26.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);}},function(error){_this26.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);});__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listPictureNamingScores(this.state.student.user.id).then(function(response){if(response.success){_this26.setState({pictureNamingScoreList:response.body});}else{_this26.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);}},function(error){_this26.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);});__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listCopyRightScores(this.state.student.user.id).then(function(response){if(response.success){_this26.setState({copyRightScoreList:response.body});}else{_this26.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);}},function(error){_this26.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);});__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listWordSignSayScores(this.state.student.user.id).then(function(response){if(response.success){_this26.setState({wordSignSayScoreList:response.body});}else{_this26.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);}},function(error){_this26.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);});__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listKidSignScores(this.state.student.user.id).then(function(response){if(response.success){_this26.setState({kidSignScoreList:response.body});}else{_this26.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);}},function(error){_this26.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this26.setState({modalDialog:false});},3500);});this.handleSelect=this.handleSelect.bind(this);}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleSelect',value:function handleSelect(tabNum){this.props.selectStudentScoreListTab(tabNum);this.setState({showData:tabNum});}},{key:'handlePNScoreTasks',value:function handlePNScoreTasks(){this.props.selectStudentScoreListTab(3);this.setState({showData:3});this.setState({pnScoreModel:false});}},{key:'handlePNClose',value:function handlePNClose(){this.setState({pnScoreModel:false});}},{key:'start1to1PNSession',value:function start1to1PNSession(){var userId=this.state.student.user.id;this.props.history.push("/teacher/apps/pn-1-1?userId="+userId);}},{key:'startManualPNSession',value:function startManualPNSession(){var userId=this.state.student.user.id;this.props.history.push("/teacher/apps/pn-manual?userId="+userId);}},{key:'handleHowToScore',value:function handleHowToScore(){var _this27=this;var tutorialAddress="";switch(this.state.showData){case 1://WordMark
tutorialAddress=" https://docs.google.com/document/d/1o0Rfhf9dsDVuYzWKuxw9uJtNp48gvTL5uk0GWxcS5A0/edit?usp=sharing";break;case 2://KidSpeak
tutorialAddress="https://docs.google.com/document/d/1ZyVBeuvXxtdbFbr9p8UC684TwNywYRUUhC7Q6BJFgjc/edit?usp=sharing";break;case 3://PictureNaming
tutorialAddress="https://docs.google.com/document/d/1qtp2qimrtDn4ahX2Z0YEoWu-EwlZr-T0U0RR-04SwvE/edit?usp=sharing";break;case 4://CopyRight
tutorialAddress=" https://docs.google.com/document/d/1x_guMkt1cS7_IBPnum4vde0XzCk-PZ3etpl1dzNPz_c/edit?usp=sharing";break;case 5://WordSign
tutorialAddress="https://docs.google.com/document/d/1EY5aqLFDoDdWF5QSt5uTWY4uX2lFWk899D1J1Cesp2k/edit?usp=sharing";break;case 6://KidSign
tutorialAddress=" https://docs.google.com/document/d/1pzuldFa3wFmmj8UNkxcOhYkRphnho8X4mDJmbCE9gx0/edit?usp=sharing";break;}this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_31__Shared_DataTrackingPoints__["b" /* default */].HOW_TO_SCORE,metadata:{resourceId:this.state.showData}}},function(){return _this27.handleAnalytics();});window.open(tutorialAddress);}},{key:'handleBackClick',value:function handleBackClick(event){this.props.updateStudent(null);this.props.selectStudentTab(1);this.props.selectStudentScoreListTab(1);if(this.props.schoolAdmin){this.props.history.push("/school-admin");}else{this.props.history.push("/teacher");}}},{key:'render',value:function render(){var _this28=this;var items=null;var gradingTitle=void 0,gradingDescription="";if(this.state.showData===0){gradingTitle="";gradingDescription="";}else if(this.state.showData===1){gradingTitle="WordMark Score, Review or Edit";gradingDescription="";var list=this.state.wordMarkScoreList;console.log("wm list");console.log(list);if(list){var minIndex=-1;var minId=99999999;for(var i=0;i<=list.length-1;i++){list[i].firstUnrated=false;if(list[i].testId<minId&&list[i].gradingDate==null){minId=list[i].testId;minIndex=i;}}for(var _i=0;_i<=list.length-1;_i++){if(_i==minIndex)list[_i].firstUnrated=true;else list[_i].firstUnrated=false;}}items=list.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SSIGOTO,{key:item.testId,score:item,type:"wm-grading",firstUnrated:item.firstUnrated});});}else if(this.state.showData===7){gradingTitle="WordMark2 Score, Review or Edit";gradingDescription="";var _list=this.state.wordMark2ScoreList;console.log("wm list");console.log(_list);if(_list){var _minIndex=-1;var _minId=99999999;for(var _i2=0;_i2<=_list.length-1;_i2++){_list[_i2].firstUnrated=false;if(_list[_i2].testId<_minId&&_list[_i2].gradingDate==null){_minId=_list[_i2].testId;_minIndex=_i2;}}for(var _i3=0;_i3<=_list.length-1;_i3++){if(_i3==_minIndex)_list[_i3].firstUnrated=true;else _list[_i3].firstUnrated=false;}}items=_list.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SSIGOTO,{key:item.testId,score:item,type:"wm2-grading",firstUnrated:item.firstUnrated});});}else if(this.state.showData===2){gradingTitle="KidSpeak Score, Review or Edit";gradingDescription="";var _list2=this.state.kidSpeakScoreList;console.log("KS list");console.log(_list2);if(_list2){var _minIndex2=-1;var _minId2=99999999;for(var _i4=0;_i4<=_list2.length-1;_i4++){_list2[_i4].firstUnrated=false;if(_list2[_i4].testId<_minId2&&_list2[_i4].gradingDate==null){_minId2=_list2[_i4].testId;_minIndex2=_i4;}}for(var _i5=0;_i5<=_list2.length-1;_i5++){if(_i5==_minIndex2)_list2[_i5].firstUnrated=true;else _list2[_i5].firstUnrated=false;}}items=_list2.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SSIGOTO,{key:item.testId,score:item,type:"ks-grading",firstUnrated:item.firstUnrated});});}else if(this.state.showData===3){gradingTitle="PictureNaming Score, Review or Edit";gradingDescription="";var _list3=this.state.pictureNamingScoreList;if(_list3){var _minIndex3=-1;var _minId3=99999999;for(var _i6=0;_i6<=_list3.length-1;_i6++){_list3[_i6].firstUnrated=false;if(_list3[_i6].testId<_minId3&&_list3[_i6].gradingDate==null){_minId3=_list3[_i6].testId;_minIndex3=_i6;}}for(var _i7=0;_i7<=_list3.length-1;_i7++){if(_i7==_minIndex3)_list3[_i7].firstUnrated=true;else _list3[_i7].firstUnrated=false;}}items=_list3.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SSIGOTO,{key:item.testId,score:item,type:"pn-grading",firstUnrated:item.firstUnrated});});}else if(this.state.showData===4){gradingTitle="CopyRight Score, Review or Edit";gradingDescription="";var _list4=this.state.copyRightScoreList;if(_list4){var _minIndex4=-1;var _minId4=99999999;for(var _i8=0;_i8<=_list4.length-1;_i8++){_list4[_i8].firstUnrated=false;if(_list4[_i8].testId<_minId4&&_list4[_i8].gradingDate==null){_minId4=_list4[_i8].testId;_minIndex4=_i8;}}console.log("minId");console.log(_minId4);console.log(_minIndex4);for(var _i9=0;_i9<=_list4.length-1;_i9++){if(_i9==_minIndex4)_list4[_i9].firstUnrated=true;else _list4[_i9].firstUnrated=false;}console.log("firstUnrated");console.log(_list4);}items=_list4.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SSIGOTO,{key:item.testId,score:item,type:"cr-grading",firstUnrated:item.firstUnrated});});}else if(this.state.showData===5){gradingTitle="Word Sign/Say Score, Review or Edit";gradingDescription="";var _list5=this.state.wordSignSayScoreList;if(_list5){var _minIndex5=-1;var _minId5=99999999;for(var _i10=0;_i10<=_list5.length-1;_i10++){_list5[_i10].firstUnrated=false;if(_list5[_i10].testId<_minId5&&_list5[_i10].gradingDate==null){_minId5=_list5[_i10].testId;_minIndex5=_i10;}}for(var _i11=0;_i11<=_list5.length-1;_i11++){if(_i11==_minIndex5)_list5[_i11].firstUnrated=true;else _list5[_i11].firstUnrated=false;}}items=_list5.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SSIGOTO,{key:item.testId,score:item,type:"wss-grading",firstUnrated:item.firstUnrated});});var _unratedItems=items.filter(function(item){return item.props.score.gradingDate==null;});_unratedItems=_unratedItems.sort(function(a,b){return parseInt(a.key)<parseInt(b.key)?1:parseInt(a.key)>parseInt(b.key)?-1:0;});var _ratedItems=items.filter(function(item){return item.props.score.gradingDate!=null;});_ratedItems=_ratedItems.sort(function(a,b){return parseInt(a.key)<parseInt(b.key)?1:parseInt(a.key)>parseInt(b.key)?-1:0;});items=_unratedItems.concat(_ratedItems);}else if(this.state.showData===6){gradingTitle="Kid Sign/Say Score, Review or Edit";gradingDescription="";var _list6=this.state.kidSignScoreList;console.log("KSS list");console.log(_list6);if(_list6){var _minIndex6=-1;var _minId6=99999999;for(var _i12=0;_i12<=_list6.length-1;_i12++){_list6[_i12].firstUnrated=false;if(_list6[_i12].testId<_minId6&&_list6[_i12].gradingDate==null){_minId6=_list6[_i12].testId;_minIndex6=_i12;}}for(var _i13=0;_i13<=_list6.length-1;_i13++){if(_i13==_minIndex6)_list6[_i13].firstUnrated=true;else _list6[_i13].firstUnrated=false;}}items=_list6.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SSIGOTO,{key:item.testId,score:item,type:"kss-grading",firstUnrated:item.firstUnrated});});}var unratedItems=items?items.filter(function(item){return item.props.score.gradingDate==null;}):null;unratedItems=unratedItems?unratedItems.sort(function(a,b){return parseInt(a.key)<parseInt(b.key)?1:parseInt(a.key)>parseInt(b.key)?-1:0;}):null;var ratedItems=items?items.filter(function(item){return item.props.score.gradingDate!=null;}):null;ratedItems=items?ratedItems.sort(function(a,b){return parseInt(a.key)<parseInt(b.key)?1:parseInt(a.key)>parseInt(b.key)?-1:0;}):null;items=items?unratedItems.concat(ratedItems):null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-pane solidBorder hasDivBottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this28.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.state.pnScoreModel,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'PictureNaming')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this28.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12 bgGrey roundCorners'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:18}},'Chose Option:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{"marginBottom":200,"marginTop":50}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-6',style:{position:'absolute'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{marginLeft:150},onClick:this.handlePNScoreTasks,type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontWeight:'bold',fontSize:18}},'Score Tasks')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:150,marginTop:0}},'Score or review tasks')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'absolute',marginLeft:400}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{marginLeft:70,position:'absolute'},onClick:this.startManualPNSession.bind(this),type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontWeight:'bold',fontSize:18}},'Picture Cards')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:70,marginTop:30}},'Start New Task ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'using printed Picture ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Cards with student'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{marginLeft:100,marginTop:-400},src:__WEBPACK_IMPORTED_MODULE_24__assets_images_PNScoreTasks_png___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{marginLeft:260,marginTop:-400},src:__WEBPACK_IMPORTED_MODULE_25__assets_images_PNPictureCards_png___default.a}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-4'},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handlePNClose,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-4'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-xs-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{paddingTop:15}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleBackClick,className:'backArrow fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Back to Students\' List')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-6 col-xs-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav nav-pills pill-sm',style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===3?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this28.handleSelect(3);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__assets_images_app_picturenaming_png___default.a,alt:'Picture Naming',border:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===5?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this28.handleSelect(5);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15__assets_images_app_wordsignsay_png___default.a,alt:'Word Sign/Say',border:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===4?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this28.handleSelect(4);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_17__assets_images_app_copyright_png___default.a,alt:'Copy Right',border:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===2?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this28.handleSelect(2);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_logo_kidspeak_png___default.a,alt:'Kid Speak',border:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===6?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this28.handleSelect(6);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png___default.a,alt:'KidSign',border:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===1?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this28.handleSelect(1);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_22__assets_images_logo_wordmark_png___default.a,alt:'Word Mark',border:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===7?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this28.handleSelect(7);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_23__assets_images_logo_wordmark2_png___default.a,alt:'Word Mark2',border:'0'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-xs-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{style:{paddingTop:20,textAlign:'right',fontSize:'1.25em'}},this.props.student!==null?this.props.student.user.firstname:null,' ',this.props.student!==null?this.props.student.user.lastname:null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'tab_maze',className:'tab-pane fade in active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"pull-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,gradingTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,gradingDescription)),this.state.showData===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{style:{textAlign:'center'}},'Select an app for scoring'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"pull-right"},this.state.showData===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.startManualPNSession.bind(this),className:'handBtn active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Picture Cards')):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleHowToScore.bind(this),className:'handBtn active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'How to Score'))),this.state.showData===0?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%',className:'tableScoring'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},'#'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Test Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Date Scored'),this.state.showData===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Type'):null,this.state.showData===1||this.state.showData===7?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Scored'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Achieved Criteria'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,items)))))));}}]);return StudentScore;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));var StudentScoreItem=function(_Component5){_inherits(StudentScoreItem,_Component5);function StudentScoreItem(props){_classCallCheck(this,StudentScoreItem);var _this29=_possibleConstructorReturn(this,(StudentScoreItem.__proto__||Object.getPrototypeOf(StudentScoreItem)).call(this,props));_this29.handleClick=_this29.handleClick.bind(_this29);return _this29;}_createClass(StudentScoreItem,[{key:'handleClick',value:function handleClick(event){console.log('OnClick',this.props.score);event.preventDefault();var goto=void 0;if(this.props.type==="pn-grading"&&this.props.score.assessmentType===2){goto='/teacher/apps/pn-manual?userId='+this.props.score.userId+'&testId='+this.props.score.testId;}else{goto='apps/'+this.props.type+'?testId='+this.props.score.testId;}this.props.history.push(goto);}},{key:'render',value:function render(){var gradeDate=__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.props.score.gradingDate).format("YYYY-MM-DD");var testDate=__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.props.score.testDate).format("YYYY-MM-DD");if(gradeDate=="Invalid date"){gradeDate="";}if(testDate=="Invalid date"){testDate="";}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row',style:{background:'#a5c58b'},onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'fitWidth'},this.props.score.testId),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,testDate),this.props.firstUnrated?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_images_start_here_lable_png___default.a}),' '):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,gradeDate),this.props.type==="pn-grading"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.score.assessmentType===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'1-1 Computer Task'):this.props.score.assessmentType===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Picture Cards'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Computer Task')):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.score.gradingDate?this.props.score.meetCriteria||this.props.type=="wm-grading"||this.props.type=="wm2-grading"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_ico_tick_png___default.a,alt:'Graded',className:'ico-xs'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_21__assets_images_ico_cross_png___default.a,alt:'Graded',className:'ico-xs'}):null));}}]);return StudentScoreItem;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var SSIGOTO=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(StudentScoreItem);var TransferStudentComponent=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(function(_Component6){_inherits(TransferStudentComponent,_Component6);function TransferStudentComponent(props){_classCallCheck(this,TransferStudentComponent);var _this30=_possibleConstructorReturn(this,(TransferStudentComponent.__proto__||Object.getPrototypeOf(TransferStudentComponent)).call(this,props));_this30.handleBackClick=function(){if(_this30.props.schoolAdmin){_this30.props.history.push("/school-admin");}else{_this30.props.history.push("/teacher");}};_this30.handleCorrectTeacherData=function(data){_this30.setState({teacherId:data.teacher.id,classes:data.teacher.classes});};_this30.handleCancelTransfer=function(){_this30.props.handleCancelTransfer();};_this30.handleClassSelect=function(classId){_this30.setState({classId:parseInt(classId)});};_this30.state={teacherId:0,classId:0,studentId:_this30.props.studentId,classes:[],share:false,modalDialog:false,responseContent:''};_this30.handleDone=_this30.handleDone.bind(_this30);_this30.handleCancelTransfer=_this30.handleCancelTransfer.bind(_this30);_this30.handleBackClick=_this30.handleBackClick.bind(_this30);return _this30;}_createClass(TransferStudentComponent,[{key:'handleDone',value:function(){var _ref26=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26(event,share){var _this31=this;var label;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:if(!window.confirm('Are you sure you wish to save these changes?')){_context26.next=6;break;}delete this.state.classes;_context26.next=4;return this.setState({share:share});case 4:label=this.state.share?"Share":"Transfer";__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].transferStudent(this.state).then(function(response){console.log(label+' student',response);_this31.setState({modalDialog:true,responseContent:'Student '+label+' Successful!'});setTimeout(function(){_this31.setState({modalDialog:false});_this31.handleBackClick();},3500);},function(error){console.log(label+' student error',error);});case 6:case'end':return _context26.stop();}}},_callee26,this);}));function handleDone(_x25,_x26){return _ref26.apply(this,arguments);}return handleDone;}()},{key:'render',value:function render(){var _this32=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this32.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TeacherInfoTransferComponent,{correctTeacherData:this.handleCorrectTeacherData,handleCancelTransfer:this.handleCancelTransfer}),this.state.classes&&this.state.classes.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TeacherClassTransferComponent,{classes:this.state.classes,handleClassSelect:this.handleClassSelect}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancelTransfer,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(e){return _this32.handleDone(e,false);},disabled:this.state.classId===0,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Transfer')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(e){return _this32.handleDone(e,true);},disabled:this.state.classId===0,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Share')))):null);}}]);return TransferStudentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));var TeacherInfoTransferComponent=function(_Component7){_inherits(TeacherInfoTransferComponent,_Component7);function TeacherInfoTransferComponent(props){_classCallCheck(this,TeacherInfoTransferComponent);var _this33=_possibleConstructorReturn(this,(TeacherInfoTransferComponent.__proto__||Object.getPrototypeOf(TeacherInfoTransferComponent)).call(this,props));_this33.state={firstName:'',lastName:'',teacherId:'',hideButtons:false,modalDialog:false,responseContent:''};_this33.handleFirstName=_this33.handleFirstName.bind(_this33);_this33.handleLastName=_this33.handleLastName.bind(_this33);_this33.handleLoginID=_this33.handleLoginID.bind(_this33);_this33.handleCancel=_this33.handleCancel.bind(_this33);_this33.handleContinue=_this33.handleContinue.bind(_this33);return _this33;}_createClass(TeacherInfoTransferComponent,[{key:'handleFirstName',value:function handleFirstName(event){this.setState({firstName:event.target.value.replace(/\s+/g,'')});}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastName:event.target.value.replace(/\s+/g,'')});}},{key:'handleLoginID',value:function handleLoginID(event){event.target.value=event.target.value.replace(/[^0-9.]+/g,'');this.setState({teacherId:event.target.value});}},{key:'validate',value:function validate(){var valid=true;if(this.state.firstName.length===0){valid=false;document.getElementById("inputTeacherName").classList.add('validationRed');}else{document.getElementById("inputTeacherName").classList.remove('validationRed');}if(this.state.lastName.length===0){valid=false;document.getElementById("inputTeacherLastName").classList.add('validationRed');}else{document.getElementById("inputTeacherLastName").classList.remove('validationRed');}if(this.state.teacherId.length===0||this.state.teacherId===null){valid=false;document.getElementById("inputTeacherLoginID").classList.add('validationRed');}else{document.getElementById("inputTeacherLoginID").classList.remove('validationRed');}return valid;}},{key:'handleContinue',value:function handleContinue(event){if(this.validate()){document.getElementById("validWarning").classList.add("hidden");this.listExternalTeacher();}else{document.getElementById("validWarning").classList.remove("hidden");}}},{key:'listExternalTeacher',value:function listExternalTeacher(){var _this34=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listExternalTeacher(this.state).then(function(response){if(response.success&&response.body){_this34.props.correctTeacherData(response.body);_this34.setState({hideButtons:true});}else if(response.success){_this34.setState({modalDialog:true,responseContent:'This teacher doesn\'t have any classes.'});}else{_this34.setState({modalDialog:true,responseContent:'Incorrect input! Check it and retry!'});}},function(error){console.log('Error',error);});}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancelTransfer();}},{key:'render',value:function render(){var _this35=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this35.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Share a student with a Teacher'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'You can share this student or move the student to another teacher. First, enter the new teacher\'s first name, last name and user number for AvePM. Then you will be asked to select the new class name for the student.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:"validWarning",className:"hidden",style:{color:'red',paddingBottom:10}},' Fields with red outline have to be filled in or selected!'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherName'},'Teacher First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleFirstName,id:'inputTeacherName',className:'form-control ',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherLastName'},'Teacher Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleLastName,id:'inputTeacherLastName',className:'form-control ',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherLoginID'},'Teacher User Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onInput:this.handleLoginID,id:'inputTeacherLoginID',className:'form-control ',placeholder:'User Number',required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),this.state.hideButtons?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleContinue,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Continue'))));}}]);return TeacherInfoTransferComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var TeacherClassTransferComponent=function(_Component8){_inherits(TeacherClassTransferComponent,_Component8);function TeacherClassTransferComponent(props){_classCallCheck(this,TeacherClassTransferComponent);var _this36=_possibleConstructorReturn(this,(TeacherClassTransferComponent.__proto__||Object.getPrototypeOf(TeacherClassTransferComponent)).call(this,props));_this36.state={classes:_this36.props.classes||[]};_this36.handleClassSelect=_this36.handleClassSelect.bind(_this36);return _this36;}_createClass(TeacherClassTransferComponent,[{key:'handleClassSelect',value:function handleClassSelect(event){this.props.handleClassSelect(event.value);}},{key:'render',value:function render(){var options=[];options[0]=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:0,value:0},'Select a class');for(var i=0;i<this.state.classes.length;i++){var c=this.state.classes[i];// options[i + 1] = <option key={c.id} value={c.id}>{c.name}</option>;
options.push({value:c.id,label:c.name});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{marginTop:5}},'In the drop down list, select a class into which the student will be placed.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{onChange:this.handleClassSelect,id:'classes',name:'classes',options:options,isSearchable:false}));}}]);return TeacherClassTransferComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProgressModalComponent_InlineProgressBox__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logo_wordmark_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logo_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_logo_wordmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logo_slashtest_png__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logo_slashtest_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_logo_slashtest_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logo_maze_png__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logo_maze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_logo_maze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_data_chart_png__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_data_chart_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_data_chart_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TeachersComponent_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TeachersComponent_Students__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_modal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_modal__);
var _this11=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'45%'}};var MyProfileComponent=function(_Component){_inherits(MyProfileComponent,_Component);function MyProfileComponent(props){_classCallCheck(this,MyProfileComponent);var _this=_possibleConstructorReturn(this,(MyProfileComponent.__proto__||Object.getPrototypeOf(MyProfileComponent)).call(this,props));_this.state={noDataModel:false,refresh:false};_this.handleMazeClick=_this.handleMazeClick.bind(_this);_this.handleSlashTestClick=_this.handleSlashTestClick.bind(_this);_this.handleWordMarkClick=_this.handleWordMarkClick.bind(_this);_this.handleKidSpeakClick=_this.handleKidSpeakClick.bind(_this);_this.handlePictureNamingClick=_this.handlePictureNamingClick.bind(_this);_this.handleCopyRightClick=_this.handleCopyRightClick.bind(_this);_this.handleWordSignSayClick=_this.handleWordSignSayClick.bind(_this);_this.handleKidSignClick=_this.handleKidSignClick.bind(_this);_this.handleNoDataClose=_this.handleNoDataClose.bind(_this);return _this;}_createClass(MyProfileComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].authWithToken().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var student;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:student=void 0;if(_this2.props.userRole==="parent"){student=_this2.props.currentStudent;}else{student=res.body;student.userId=res.body.id;student.user=Object.assign({},res.body);student.personalUse=true;}if(!student){_context2.next=7;break;}_context2.next=5;return _this2.props.updateStudent(student);case 5:_context2.next=7;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentAppStatus(student.userId).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this2.props.updateStudentAppStatus(res.body);case 2:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}());case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 2:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'componentDidUpdate',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(prevProps){var student;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!(prevProps!==this.props)){_context4.next=8;break;}student=void 0;student=this.props.currentStudent;if(!student){_context4.next=6;break;}_context4.next=6;return this.props.updateStudent(student);case 6:_context4.next=8;return this.setState({refresh:this.props.refresh});case 8:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidUpdate(_x3){return _ref4.apply(this,arguments);}return componentDidUpdate;}()},{key:'handleMazeClick',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"Maze").then(function(res){if(res.body===0){_this3.setState({noDataModel:true});}else{_this3.props.history.push('/teacher/student/data/maze');}});case 2:case'end':return _context5.stop();}}},_callee5,this);}));function handleMazeClick(_x4){return _ref5.apply(this,arguments);}return handleMazeClick;}()},{key:'handleWordMarkClick',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(event){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"WordMark").then(function(res){if(res.body===0){_this4.setState({noDataModel:true});}else{_this4.props.history.push('/teacher/student/data/wordmark');}});case 2:case'end':return _context6.stop();}}},_callee6,this);}));function handleWordMarkClick(_x5){return _ref6.apply(this,arguments);}return handleWordMarkClick;}()},{key:'handleSlashTestClick',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(event){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"Slash").then(function(res){if(res.body===0){_this5.setState({noDataModel:true});}else{_this5.props.history.push('/teacher/student/data/slashtest');}});case 2:case'end':return _context7.stop();}}},_callee7,this);}));function handleSlashTestClick(_x6){return _ref7.apply(this,arguments);}return handleSlashTestClick;}()},{key:'handleKidSpeakClick',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(event){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"KidSpeak").then(function(res){if(res.body===0){_this6.setState({noDataModel:true});}else{_this6.props.history.push('/teacher/student/data/kidspeak');}});case 2:case'end':return _context8.stop();}}},_callee8,this);}));function handleKidSpeakClick(_x7){return _ref8.apply(this,arguments);}return handleKidSpeakClick;}()},{key:'handlePictureNamingClick',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(event){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"PictureNaming/Computer").then(function(res){if(res.body===0){_this7.setState({pnTypeModel:false,noDataModel:true});}else{_this7.props.history.push('/teacher/student/data/picturenaming/computer');}});case 2:case'end':return _context9.stop();}}},_callee9,this);}));function handlePictureNamingClick(_x8){return _ref9.apply(this,arguments);}return handlePictureNamingClick;}()},{key:'handleCopyRightClick',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(event){var _this8=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"CopyRight").then(function(res){if(res.body===0){_this8.setState({noDataModel:true});}else{_this8.props.history.push('/teacher/student/data/copyright');}});case 2:case'end':return _context10.stop();}}},_callee10,this);}));function handleCopyRightClick(_x9){return _ref10.apply(this,arguments);}return handleCopyRightClick;}()},{key:'handleWordSignSayClick',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(event){var _this9=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"WordSign/Say").then(function(res){if(res.body===0){_this9.setState({noDataModel:true});}else{_this9.props.history.push('/teacher/student/data/wordsignsay');}});case 2:case'end':return _context11.stop();}}},_callee11,this);}));function handleWordSignSayClick(_x10){return _ref11.apply(this,arguments);}return handleWordSignSayClick;}()},{key:'handleKidSignClick',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(event){var _this10=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].checkStudentData(this.props.student.userId,"KidSign").then(function(res){if(res.body===0){_this10.setState({noDataModel:true});}else{_this10.props.history.push('/teacher/student/data/kidsign');}});case 2:case'end':return _context12.stop();}}},_callee12,this);}));function handleKidSignClick(_x11){return _ref12.apply(this,arguments);}return handleKidSignClick;}()},{key:'handleNoDataClose',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:this.setState({noDataModel:false});case 1:case'end':return _context13.stop();}}},_callee13,this);}));function handleNoDataClose(_x12){return _ref13.apply(this,arguments);}return handleNoDataClose;}()},{key:'render',value:function render(){var sampleBestScores={id:2047,userId:2421,createdAt:'2019-02-11T22:32:27.358Z',updatedAt:'2020-02-08T02:14:06.345Z',mazeLevel:5,mazeScore:1,slashLevel:3,slashScore:1,ksLevel:1,ksScore:1,pnLevel:1,pnScore:1,crLevel:1,crScore:1,wssLevel:1,wssScore:1,kssLevel:1,kssScore:1};var currentApps=void 0;if(this.props.currentApps){currentApps=this.props.currentApps;}else if(this.props.apps.bestScores){currentApps=this.props.apps;}else{currentApps={bestScores:sampleBestScores};}var bestScores=currentApps.bestScores;var currentStudent=void 0;if(this.props.studentUser){currentStudent=this.props.studentUser;}else{currentStudent=this.props.currentStudent;}var _Helpers$filterApps=__WEBPACK_IMPORTED_MODULE_18__Shared_Helpers__["a" /* default */].filterApps(currentStudent,currentApps),allowedApps=_Helpers$filterApps.allowedApps,filteredApps=_Helpers$filterApps.filteredApps,finishedApps=_Helpers$filterApps.finishedApps;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',_defineProperty({style:{cursor:'pointer'},className:"row bgGrey"},'style',{background:'#c3c3c3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row centerOneLineVertically"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 col-sm-12 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4 padding15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:20,textAlign:"left"}},'App Name'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-9 col-sm-8 padding15 borderLeftWhite"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:35,textAlign:"left"}},'My Progress'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{position:'relative',top:12,marginLeft:10}},'(Click icons below for Data Charts)'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__assets_images_data_chart_png___default.a,style:{width:25,position:'relative',top:10,marginLeft:15}}))))))),allowedApps.includes("picturenaming")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:this.handlePictureNamingClick,style:{cursor:'pointer'},className:"row bgWhite1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row centerOneLineVertically"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 col-sm-12 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4 padding15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon paddingL15'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'','data-toggle':'pill',onClick:this.handlePictureNaming},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_app_picturenaming_png___default.a,className:'ico-m',style:{height:44},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:10,textAlign:"left"}},'PictureNaming'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-9 col-sm-8 padding15 borderLeftWhite"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProgressModalComponent_InlineProgressBox__["a" /* default */],{noDescription:"true",maxLevel:3,level:bestScores.pnLevel,badgeNo:7}))))):null,allowedApps.includes("wordsignsay")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:this.handleWordSignSayClick,style:{cursor:'pointer'},className:"row bgGrey1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row centerOneLineVertically"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 col-sm-12 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4 padding15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon paddingL15'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'','data-toggle':'pill',onClick:this.handleWordSignSay},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_images_app_wordsignsay_png___default.a,className:'ico-m',style:{height:44},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:10,textAlign:"left"}},'Word Sign/Say'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-9 col-sm-8 padding15 borderLeftWhite"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProgressModalComponent_InlineProgressBox__["a" /* default */],{noDescription:"true",level:bestScores.wssLevel,maxLevel:1,badgeNo:4}))))):null,allowedApps.includes("copyright")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:this.handleCopyRightClick,style:{cursor:'pointer'},className:"row bgWhite1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row centerOneLineVertically"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 col-sm-12 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4 padding15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon paddingL15'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'','data-toggle':'pill',onClick:this.handlePictureNaming},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__assets_images_app_copyright_png___default.a,className:'ico-m',style:{height:44},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:10,textAlign:"left"}},'CopyRight'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-9 col-sm-8 padding15 borderLeftWhite"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProgressModalComponent_InlineProgressBox__["a" /* default */],{noDescription:"true",level:bestScores.crLevel,maxLevel:6,badgeNo:1}))))):null,allowedApps.includes("slash")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:this.handleSlashTestClick,style:{cursor:'pointer'},className:"row bgGrey1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row centerOneLineVertically"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 col-sm-12 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4 padding15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon paddingL15'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'','data-toggle':'pill',onClick:this.handleSlashTest},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_logo_slashtest_png___default.a,className:'ico-m',style:{height:44},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:10,textAlign:"left"}},'Slash'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-9 col-sm-8 padding15 borderLeftWhite"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProgressModalComponent_InlineProgressBox__["a" /* default */],{noDescription:"true",level:bestScores.slashLevel,maxLevel:8,badgeNo:3}))))):null,allowedApps.includes("kidspeak")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:this.handleKidSpeakClick,style:{cursor:'pointer'},className:"row bgWhite1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row centerOneLineVertically"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 col-sm-12 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4 padding15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon paddingL15'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'','data-toggle':'pill',onClick:this.handlePictureNaming},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png___default.a,className:'ico-m',style:{height:44},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:10,textAlign:"left"}},'KidSpeak'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-9 col-sm-8 padding15 borderLeftWhite"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProgressModalComponent_InlineProgressBox__["a" /* default */],{noDescription:"true",level:bestScores.ksLevel,maxLevel:12,badgeNo:2}))))):null,allowedApps.includes("maze")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:this.handleMazeClick,style:{cursor:'pointer'},className:"row bgGrey1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row centerOneLineVertically"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 col-sm-12 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4 padding15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon paddingL15'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'','data-toggle':'pill',onClick:this.handleMaze},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_logo_maze_png___default.a,className:'ico-m',style:{height:44},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:10,textAlign:"left"}},'Maze'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-9 col-sm-8 padding15 borderLeftWhite"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProgressModalComponent_InlineProgressBox__["a" /* default */],{noDescription:"true",level:bestScores.mazeLevel,maxLevel:12,badgeNo:5}))))):null,allowedApps.includes("kidsign")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:this.handleKidSignClick,style:{cursor:'pointer'},className:"row bgWhite1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row centerOneLineVertically"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 col-sm-12 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4 padding15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon paddingL15'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'','data-toggle':'pill',onClick:this.handleKidSign},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_app_kidsignsay_png___default.a,className:'ico-m',style:{height:44},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:10,textAlign:"left"}},'Kid Sign/Say'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-9 col-sm-8 padding15 borderLeftWhite"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProgressModalComponent_InlineProgressBox__["a" /* default */],{noDescription:"true",level:bestScores.kssLevel,maxLevel:12,badgeNo:6}))))):null,allowedApps.includes("wordmark")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:this.handleWordMarkClick,style:{cursor:'pointer'},className:"row bgGrey1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row centerOneLineVertically"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 col-sm-12 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4 padding15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'taskProgressIcon paddingL15'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'','data-toggle':'pill',onClick:this.handleWordMark},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_logo_wordmark_png___default.a,className:'ico-m',style:{height:44},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:"myProfileFont",style:{width:"auto",margin:0,marginLeft:10,textAlign:"left"}},'WordMark'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-9 col-sm-8 padding15 borderLeftWhite"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProgressModalComponent_InlineProgressBox__["a" /* default */],{noDescription:"true",level:1,maxLevel:1,badgeNo:0}))))):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_modal___default.a,{isOpen:this.state.noDataModel,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'No tasks completed yet.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNoDataClose,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))));}}]);return MyProfileComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context14.abrupt('return',_context14.sent);case 3:case'end':return _context14.stop();}}},_callee14,_this11);}));function updateStudentAppStatus(_x13){return _ref14.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudent:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__TeachersComponent_actions__["h" /* updateStudent */])(student));case 2:return _context15.abrupt('return',_context15.sent);case 3:case'end':return _context15.stop();}}},_callee15,_this11);}));function updateStudent(_x14){return _ref15.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,student:state.teacherReducer.student,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(MyProfileComponent)));

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(145),
    inherits = __webpack_require__(146).inherits,
    UNICODE = __webpack_require__(144);

//Aliases
var $ = UNICODE.CODE_POINTS;

var PositionTrackingPreprocessorMixin = module.exports = function (preprocessor) {
    // NOTE: avoid installing tracker twice
    if (!preprocessor.__locTracker) {
        preprocessor.__locTracker = this;

        Mixin.call(this, preprocessor);

        this.preprocessor = preprocessor;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;

        this.col = -1;
        this.line = 1;
    }

    return preprocessor.__locTracker;
};

inherits(PositionTrackingPreprocessorMixin, Mixin);

Object.defineProperty(PositionTrackingPreprocessorMixin.prototype, 'offset', {
    get: function () {
        return this.droppedBufferSize + this.preprocessor.pos;
    }
});

PositionTrackingPreprocessorMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        advance: function () {
            var cp = orig.advance.call(this);

            //NOTE: LF should be in the last column of the line
            if (mxn.isEol) {
                mxn.isEol = false;
                mxn.line++;
                mxn.lineStartPos = mxn.offset;
            }

            if (cp === $.LINE_FEED)
                mxn.isEol = true;

            mxn.col = mxn.offset - mxn.lineStartPos + 1;

            return cp;
        },

        retreat: function () {
            orig.retreat.call(this);
            mxn.isEol = false;

            mxn.col = mxn.offset - mxn.lineStartPos + 1;
        },

        dropParsedChunk: function () {
            var prevPos = this.pos;

            orig.dropParsedChunk.call(this);

            mxn.droppedBufferSize += prevPos - this.pos;
        }
    };
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function mergeOptions(defaults, options) {
    options = options || Object.create(null);

    return [defaults, options].reduce(function (merged, optObj) {
        Object.keys(optObj).forEach(function (key) {
            merged[key] = optObj[key];
        });

        return merged;
    }, Object.create(null));
};


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EmitterSubscription
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventSubscription = __webpack_require__(799);

/**
 * EmitterSubscription represents a subscription with listener and context data.
 */

var EmitterSubscription = (function (_EventSubscription) {
  _inherits(EmitterSubscription, _EventSubscription);

  /**
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  function EmitterSubscription(subscriber, listener, context) {
    _classCallCheck(this, EmitterSubscription);

    _EventSubscription.call(this, subscriber);
    this.listener = listener;
    this.context = context;
  }

  return EmitterSubscription;
})(EventSubscription);

module.exports = EmitterSubscription;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(296);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Encoder = __webpack_require__(35);
var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

function III_psy_xmin() {
    this.l = new_float(Encoder.SBMAX_l);
    this.s = new_float_n([Encoder.SBMAX_s, 3]);

    var self = this;
    this.assign = function (iii_psy_xmin) {
        System.arraycopy(iii_psy_xmin.l, 0, self.l, 0, Encoder.SBMAX_l);
        for (var i = 0; i < Encoder.SBMAX_s; i++) {
            for (var j = 0; j < 3; j++) {
                self.s[i][j] = iii_psy_xmin.s[i][j];
            }
        }
    }
}

module.exports = III_psy_xmin;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

//package mp3;

/* MPEG modes */
function MPEGMode(ordinal) {
    var _ordinal = ordinal;
    this.ordinal = function () {
        return _ordinal;
    }
}

MPEGMode.STEREO = new MPEGMode(0);
MPEGMode.JOINT_STEREO = new MPEGMode(1);
MPEGMode.DUAL_CHANNEL = new MPEGMode(2);
MPEGMode.MONO = new MPEGMode(3);
MPEGMode.NOT_SET = new MPEGMode(4);

module.exports = MPEGMode;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

//package mp3;

/**
 * Layer III side information.
 *
 * @author Ken
 *
 */

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var Encoder = __webpack_require__(35);

function ScaleFac(arrL, arrS, arr21, arr12) {

    this.l = new_int(1 + Encoder.SBMAX_l);
    this.s = new_int(1 + Encoder.SBMAX_s);
    this.psfb21 = new_int(1 + Encoder.PSFB21);
    this.psfb12 = new_int(1 + Encoder.PSFB12);
    var l = this.l;
    var s = this.s;

    if (arguments.length == 4) {
        //public ScaleFac(final int[] arrL, final int[] arrS, final int[] arr21,
        //    final int[] arr12) {
        this.arrL = arguments[0];
        this.arrS = arguments[1];
        this.arr21 = arguments[2];
        this.arr12 = arguments[3];

        System.arraycopy(this.arrL, 0, l, 0, Math.min(this.arrL.length, this.l.length));
        System.arraycopy(this.arrS, 0, s, 0, Math.min(this.arrS.length, this.s.length));
        System.arraycopy(this.arr21, 0, this.psfb21, 0, Math.min(this.arr21.length, this.psfb21.length));
        System.arraycopy(this.arr12, 0, this.psfb12, 0, Math.min(this.arr12.length, this.psfb12.length));
    }
}

module.exports = ScaleFac;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *  ReplayGainAnalysis - analyzes input samples and give the recommended dB change
 *  Copyright (C) 2001 David Robinson and Glen Sawyer
 *  Improvements and optimizations added by Frank Klemm, and by Marcel Muller 
 *
 *  This library is free software; you can redistribute it and/or
 *  modify it under the terms of the GNU Lesser General Public
 *  License as published by the Free Software Foundation; either
 *  version 2.1 of the License, or (at your option) any later version.
 *
 *  This library is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 *  Lesser General Public License for more details.
 *
 *  You should have received a copy of the GNU Lesser General Public
 *  License along with this library; if not, write to the Free Software
 *  Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA  02111-1307  USA
 *
 *  concept and filter values by David Robinson (David@Robinson.org)
 *    -- blame him if you think the idea is flawed
 *  original coding by Glen Sawyer (mp3gain@hotmail.com)
 *    -- blame him if you think this runs too slowly, or the coding is otherwise flawed
 *
 *  lots of code improvements by Frank Klemm ( http://www.uni-jena.de/~pfk/mpp/ )
 *    -- credit him for all the _good_ programming ;)
 *
 *
 *  For an explanation of the concepts and the basic algorithms involved, go to:
 *    http://www.replaygain.org/
 */

/*
 *  Here's the deal. Call
 *
 *    InitGainAnalysis ( long samplefreq );
 *
 *  to initialize everything. Call
 *
 *    AnalyzeSamples ( var Float_t*  left_samples,
 *                     var Float_t*  right_samples,
 *                     size_t          num_samples,
 *                     int             num_channels );
 *
 *  as many times as you want, with as many or as few samples as you want.
 *  If mono, pass the sample buffer in through left_samples, leave
 *  right_samples NULL, and make sure num_channels = 1.
 *
 *    GetTitleGain()
 *
 *  will return the recommended dB level change for all samples analyzed
 *  SINCE THE LAST TIME you called GetTitleGain() OR InitGainAnalysis().
 *
 *    GetAlbumGain()
 *
 *  will return the recommended dB level change for all samples analyzed
 *  since InitGainAnalysis() was called and finalized with GetTitleGain().
 *
 *  Pseudo-code to process an album:
 *
 *    Float_t       l_samples [4096];
 *    Float_t       r_samples [4096];
 *    size_t        num_samples;
 *    unsigned int  num_songs;
 *    unsigned int  i;
 *
 *    InitGainAnalysis ( 44100 );
 *    for ( i = 1; i <= num_songs; i++ ) {
 *        while ( ( num_samples = getSongSamples ( song[i], left_samples, right_samples ) ) > 0 )
 *            AnalyzeSamples ( left_samples, right_samples, num_samples, 2 );
 *        fprintf ("Recommended dB change for song %2d: %+6.2 dB\n", i, GetTitleGain() );
 *    }
 *    fprintf ("Recommended dB change for whole album: %+6.2 dB\n", GetAlbumGain() );
 */

/*
 *  So here's the main source of potential code confusion:
 *
 *  The filters applied to the incoming samples are IIR filters,
 *  meaning they rely on up to <filter order> number of previous samples
 *  AND up to <filter order> number of previous filtered samples.
 *
 *  I set up the AnalyzeSamples routine to minimize memory usage and interface
 *  complexity. The speed isn't compromised too much (I don't think), but the
 *  internal complexity is higher than it should be for such a relatively
 *  simple routine.
 *
 *  Optimization/clarity suggestions are welcome.
 */
var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

/**
 * Table entries per dB
 */
GainAnalysis.STEPS_per_dB = 100.;
/**
 * Table entries for 0...MAX_dB (normal max. values are 70...80 dB)
 */
GainAnalysis.MAX_dB = 120.;
GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES = -24601;
GainAnalysis.GAIN_ANALYSIS_ERROR = 0;
GainAnalysis.GAIN_ANALYSIS_OK = 1;
GainAnalysis.INIT_GAIN_ANALYSIS_ERROR = 0;
GainAnalysis.INIT_GAIN_ANALYSIS_OK = 1;

GainAnalysis.YULE_ORDER = 10;
GainAnalysis.MAX_ORDER = GainAnalysis.YULE_ORDER;

GainAnalysis.MAX_SAMP_FREQ = 48000;
GainAnalysis.RMS_WINDOW_TIME_NUMERATOR = 1;
GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR = 20;
GainAnalysis.MAX_SAMPLES_PER_WINDOW = ((GainAnalysis.MAX_SAMP_FREQ * GainAnalysis.RMS_WINDOW_TIME_NUMERATOR) / GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR + 1);

function GainAnalysis() {
    /**
     * calibration value for 89dB
     */
    var PINK_REF = 64.82;

    var YULE_ORDER = GainAnalysis.YULE_ORDER;
    /**
     * percentile which is louder than the proposed level
     */
    var RMS_PERCENTILE = 0.95;
    /**
     * maximum allowed sample frequency [Hz]
     */
    var MAX_SAMP_FREQ = GainAnalysis.MAX_SAMP_FREQ;
    var RMS_WINDOW_TIME_NUMERATOR = GainAnalysis.RMS_WINDOW_TIME_NUMERATOR;
    /**
     * numerator / denominator = time slice size [s]
     */
    var RMS_WINDOW_TIME_DENOMINATOR = GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR;
    /**
     * max. Samples per Time slice
     */
    var MAX_SAMPLES_PER_WINDOW = GainAnalysis.MAX_SAMPLES_PER_WINDOW;


    var ABYule = [
        [0.03857599435200, -3.84664617118067, -0.02160367184185,
            7.81501653005538, -0.00123395316851, -11.34170355132042,
            -0.00009291677959, 13.05504219327545, -0.01655260341619,
            -12.28759895145294, 0.02161526843274, 9.48293806319790,
            -0.02074045215285, -5.87257861775999, 0.00594298065125,
            2.75465861874613, 0.00306428023191, -0.86984376593551,
            0.00012025322027, 0.13919314567432, 0.00288463683916],
        [0.05418656406430, -3.47845948550071, -0.02911007808948,
            6.36317777566148, -0.00848709379851, -8.54751527471874,
            -0.00851165645469, 9.47693607801280, -0.00834990904936,
            -8.81498681370155, 0.02245293253339, 6.85401540936998,
            -0.02596338512915, -4.39470996079559, 0.01624864962975,
            2.19611684890774, -0.00240879051584, -0.75104302451432,
            0.00674613682247, 0.13149317958808, -0.00187763777362],
        [0.15457299681924, -2.37898834973084, -0.09331049056315,
            2.84868151156327, -0.06247880153653, -2.64577170229825,
            0.02163541888798, 2.23697657451713, -0.05588393329856,
            -1.67148153367602, 0.04781476674921, 1.00595954808547,
            0.00222312597743, -0.45953458054983, 0.03174092540049,
            0.16378164858596, -0.01390589421898, -0.05032077717131,
            0.00651420667831, 0.02347897407020, -0.00881362733839],
        [0.30296907319327, -1.61273165137247, -0.22613988682123,
            1.07977492259970, -0.08587323730772, -0.25656257754070,
            0.03282930172664, -0.16276719120440, -0.00915702933434,
            -0.22638893773906, -0.02364141202522, 0.39120800788284,
            -0.00584456039913, -0.22138138954925, 0.06276101321749,
            0.04500235387352, -0.00000828086748, 0.02005851806501,
            0.00205861885564, 0.00302439095741, -0.02950134983287],
        [0.33642304856132, -1.49858979367799, -0.25572241425570,
            0.87350271418188, -0.11828570177555, 0.12205022308084,
            0.11921148675203, -0.80774944671438, -0.07834489609479,
            0.47854794562326, -0.00469977914380, -0.12453458140019,
            -0.00589500224440, -0.04067510197014, 0.05724228140351,
            0.08333755284107, 0.00832043980773, -0.04237348025746,
            -0.01635381384540, 0.02977207319925, -0.01760176568150],
        [0.44915256608450, -0.62820619233671, -0.14351757464547,
            0.29661783706366, -0.22784394429749, -0.37256372942400,
            -0.01419140100551, 0.00213767857124, 0.04078262797139,
            -0.42029820170918, -0.12398163381748, 0.22199650564824,
            0.04097565135648, 0.00613424350682, 0.10478503600251,
            0.06747620744683, -0.01863887810927, 0.05784820375801,
            -0.03193428438915, 0.03222754072173, 0.00541907748707],
        [0.56619470757641, -1.04800335126349, -0.75464456939302,
            0.29156311971249, 0.16242137742230, -0.26806001042947,
            0.16744243493672, 0.00819999645858, -0.18901604199609,
            0.45054734505008, 0.30931782841830, -0.33032403314006,
            -0.27562961986224, 0.06739368333110, 0.00647310677246,
            -0.04784254229033, 0.08647503780351, 0.01639907836189,
            -0.03788984554840, 0.01807364323573, -0.00588215443421],
        [0.58100494960553, -0.51035327095184, -0.53174909058578,
            -0.31863563325245, -0.14289799034253, -0.20256413484477,
            0.17520704835522, 0.14728154134330, 0.02377945217615,
            0.38952639978999, 0.15558449135573, -0.23313271880868,
            -0.25344790059353, -0.05246019024463, 0.01628462406333,
            -0.02505961724053, 0.06920467763959, 0.02442357316099,
            -0.03721611395801, 0.01818801111503, -0.00749618797172],
        [0.53648789255105, -0.25049871956020, -0.42163034350696,
            -0.43193942311114, -0.00275953611929, -0.03424681017675,
            0.04267842219415, -0.04678328784242, -0.10214864179676,
            0.26408300200955, 0.14590772289388, 0.15113130533216,
            -0.02459864859345, -0.17556493366449, -0.11202315195388,
            -0.18823009262115, -0.04060034127000, 0.05477720428674,
            0.04788665548180, 0.04704409688120, -0.02217936801134]];

    var ABButter = [
        [0.98621192462708, -1.97223372919527, -1.97242384925416,
            0.97261396931306, 0.98621192462708],
        [0.98500175787242, -1.96977855582618, -1.97000351574484,
            0.97022847566350, 0.98500175787242],
        [0.97938932735214, -1.95835380975398, -1.95877865470428,
            0.95920349965459, 0.97938932735214],
        [0.97531843204928, -1.95002759149878, -1.95063686409857,
            0.95124613669835, 0.97531843204928],
        [0.97316523498161, -1.94561023566527, -1.94633046996323,
            0.94705070426118, 0.97316523498161],
        [0.96454515552826, -1.92783286977036, -1.92909031105652,
            0.93034775234268, 0.96454515552826],
        [0.96009142950541, -1.91858953033784, -1.92018285901082,
            0.92177618768381, 0.96009142950541],
        [0.95856916599601, -1.91542108074780, -1.91713833199203,
            0.91885558323625, 0.95856916599601],
        [0.94597685600279, -1.88903307939452, -1.89195371200558,
            0.89487434461664, 0.94597685600279]];


    /**
     * When calling this procedure, make sure that ip[-order] and op[-order]
     * point to real data
     */
    //private void filterYule(final float[] input, int inputPos, float[] output,
    //int outputPos, int nSamples, final float[] kernel) {
    function filterYule(input, inputPos, output, outputPos, nSamples, kernel) {

        while ((nSamples--) != 0) {
            /* 1e-10 is a hack to avoid slowdown because of denormals */
            output[outputPos] = 1e-10 + input[inputPos + 0] * kernel[0]
                - output[outputPos - 1] * kernel[1] + input[inputPos - 1]
                * kernel[2] - output[outputPos - 2] * kernel[3]
                + input[inputPos - 2] * kernel[4] - output[outputPos - 3]
                * kernel[5] + input[inputPos - 3] * kernel[6]
                - output[outputPos - 4] * kernel[7] + input[inputPos - 4]
                * kernel[8] - output[outputPos - 5] * kernel[9]
                + input[inputPos - 5] * kernel[10] - output[outputPos - 6]
                * kernel[11] + input[inputPos - 6] * kernel[12]
                - output[outputPos - 7] * kernel[13] + input[inputPos - 7]
                * kernel[14] - output[outputPos - 8] * kernel[15]
                + input[inputPos - 8] * kernel[16] - output[outputPos - 9]
                * kernel[17] + input[inputPos - 9] * kernel[18]
                - output[outputPos - 10] * kernel[19]
                + input[inputPos - 10] * kernel[20];
            ++outputPos;
            ++inputPos;
        }
    }

//private void filterButter(final float[] input, int inputPos,
//    float[] output, int outputPos, int nSamples, final float[] kernel) {
    function filterButter(input, inputPos, output, outputPos, nSamples, kernel) {

        while ((nSamples--) != 0) {
            output[outputPos] = input[inputPos + 0] * kernel[0]
                - output[outputPos - 1] * kernel[1] + input[inputPos - 1]
                * kernel[2] - output[outputPos - 2] * kernel[3]
                + input[inputPos - 2] * kernel[4];
            ++outputPos;
            ++inputPos;
        }
    }

    /**
     * @return INIT_GAIN_ANALYSIS_OK if successful, INIT_GAIN_ANALYSIS_ERROR if
     *         not
     */
    function ResetSampleFrequency(rgData, samplefreq) {
        /* zero out initial values */
        for (var i = 0; i < MAX_ORDER; i++)
            rgData.linprebuf[i] = rgData.lstepbuf[i] = rgData.loutbuf[i] = rgData.rinprebuf[i] = rgData.rstepbuf[i] = rgData.routbuf[i] = 0.;

        switch (0 | (samplefreq)) {
            case 48000:
                rgData.reqindex = 0;
                break;
            case 44100:
                rgData.reqindex = 1;
                break;
            case 32000:
                rgData.reqindex = 2;
                break;
            case 24000:
                rgData.reqindex = 3;
                break;
            case 22050:
                rgData.reqindex = 4;
                break;
            case 16000:
                rgData.reqindex = 5;
                break;
            case 12000:
                rgData.reqindex = 6;
                break;
            case 11025:
                rgData.reqindex = 7;
                break;
            case 8000:
                rgData.reqindex = 8;
                break;
            default:
                return INIT_GAIN_ANALYSIS_ERROR;
        }

        rgData.sampleWindow = 0 | ((samplefreq * RMS_WINDOW_TIME_NUMERATOR
            + RMS_WINDOW_TIME_DENOMINATOR - 1) / RMS_WINDOW_TIME_DENOMINATOR);

        rgData.lsum = 0.;
        rgData.rsum = 0.;
        rgData.totsamp = 0;

        Arrays.ill(rgData.A, 0);

        return INIT_GAIN_ANALYSIS_OK;
    }

    this.InitGainAnalysis = function (rgData, samplefreq) {
        if (ResetSampleFrequency(rgData, samplefreq) != INIT_GAIN_ANALYSIS_OK) {
            return INIT_GAIN_ANALYSIS_ERROR;
        }

        rgData.linpre = MAX_ORDER;
        rgData.rinpre = MAX_ORDER;
        rgData.lstep = MAX_ORDER;
        rgData.rstep = MAX_ORDER;
        rgData.lout = MAX_ORDER;
        rgData.rout = MAX_ORDER;

        Arrays.fill(rgData.B, 0);

        return INIT_GAIN_ANALYSIS_OK;
    };

    /**
     * square
     */
    function fsqr(d) {
        return d * d;
    }

    this.AnalyzeSamples = function (rgData, left_samples, left_samplesPos, right_samples, right_samplesPos, num_samples,
                                    num_channels) {
        var curleft;
        var curleftBase;
        var curright;
        var currightBase;
        var batchsamples;
        var cursamples;
        var cursamplepos;

        if (num_samples == 0)
            return GAIN_ANALYSIS_OK;

        cursamplepos = 0;
        batchsamples = num_samples;

        switch (num_channels) {
            case 1:
                right_samples = left_samples;
                right_samplesPos = left_samplesPos;
                break;
            case 2:
                break;
            default:
                return GAIN_ANALYSIS_ERROR;
        }

        if (num_samples < MAX_ORDER) {
            System.arraycopy(left_samples, left_samplesPos, rgData.linprebuf,
                MAX_ORDER, num_samples);
            System.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf,
                MAX_ORDER, num_samples);
        } else {
            System.arraycopy(left_samples, left_samplesPos, rgData.linprebuf,
                MAX_ORDER, MAX_ORDER);
            System.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf,
                MAX_ORDER, MAX_ORDER);
        }

        while (batchsamples > 0) {
            cursamples = batchsamples > rgData.sampleWindow - rgData.totsamp ? rgData.sampleWindow
            - rgData.totsamp
                : batchsamples;
            if (cursamplepos < MAX_ORDER) {
                curleft = rgData.linpre + cursamplepos;
                curleftBase = rgData.linprebuf;
                curright = rgData.rinpre + cursamplepos;
                currightBase = rgData.rinprebuf;
                if (cursamples > MAX_ORDER - cursamplepos)
                    cursamples = MAX_ORDER - cursamplepos;
            } else {
                curleft = left_samplesPos + cursamplepos;
                curleftBase = left_samples;
                curright = right_samplesPos + cursamplepos;
                currightBase = right_samples;
            }

            filterYule(curleftBase, curleft, rgData.lstepbuf, rgData.lstep
                + rgData.totsamp, cursamples, ABYule[rgData.reqindex]);
            filterYule(currightBase, curright, rgData.rstepbuf, rgData.rstep
                + rgData.totsamp, cursamples, ABYule[rgData.reqindex]);

            filterButter(rgData.lstepbuf, rgData.lstep + rgData.totsamp,
                rgData.loutbuf, rgData.lout + rgData.totsamp, cursamples,
                ABButter[rgData.reqindex]);
            filterButter(rgData.rstepbuf, rgData.rstep + rgData.totsamp,
                rgData.routbuf, rgData.rout + rgData.totsamp, cursamples,
                ABButter[rgData.reqindex]);

            curleft = rgData.lout + rgData.totsamp;
            /* Get the squared values */
            curleftBase = rgData.loutbuf;
            curright = rgData.rout + rgData.totsamp;
            currightBase = rgData.routbuf;

            var i = cursamples % 8;
            while ((i--) != 0) {
                rgData.lsum += fsqr(curleftBase[curleft++]);
                rgData.rsum += fsqr(currightBase[curright++]);
            }
            i = cursamples / 8;
            while ((i--) != 0) {
                rgData.lsum += fsqr(curleftBase[curleft + 0])
                    + fsqr(curleftBase[curleft + 1])
                    + fsqr(curleftBase[curleft + 2])
                    + fsqr(curleftBase[curleft + 3])
                    + fsqr(curleftBase[curleft + 4])
                    + fsqr(curleftBase[curleft + 5])
                    + fsqr(curleftBase[curleft + 6])
                    + fsqr(curleftBase[curleft + 7]);
                curleft += 8;
                rgData.rsum += fsqr(currightBase[curright + 0])
                    + fsqr(currightBase[curright + 1])
                    + fsqr(currightBase[curright + 2])
                    + fsqr(currightBase[curright + 3])
                    + fsqr(currightBase[curright + 4])
                    + fsqr(currightBase[curright + 5])
                    + fsqr(currightBase[curright + 6])
                    + fsqr(currightBase[curright + 7]);
                curright += 8;
            }

            batchsamples -= cursamples;
            cursamplepos += cursamples;
            rgData.totsamp += cursamples;
            if (rgData.totsamp == rgData.sampleWindow) {
                /* Get the Root Mean Square (RMS) for this set of samples */
                var val = GainAnalysis.STEPS_per_dB
                    * 10.
                    * Math.log10((rgData.lsum + rgData.rsum)
                        / rgData.totsamp * 0.5 + 1.e-37);
                var ival = (val <= 0) ? 0 : 0 | val;
                if (ival >= rgData.A.length)
                    ival = rgData.A.length - 1;
                rgData.A[ival]++;
                rgData.lsum = rgData.rsum = 0.;

                System.arraycopy(rgData.loutbuf, rgData.totsamp,
                    rgData.loutbuf, 0, MAX_ORDER);
                System.arraycopy(rgData.routbuf, rgData.totsamp,
                    rgData.routbuf, 0, MAX_ORDER);
                System.arraycopy(rgData.lstepbuf, rgData.totsamp,
                    rgData.lstepbuf, 0, MAX_ORDER);
                System.arraycopy(rgData.rstepbuf, rgData.totsamp,
                    rgData.rstepbuf, 0, MAX_ORDER);
                rgData.totsamp = 0;
            }
            if (rgData.totsamp > rgData.sampleWindow) {
                /*
                 * somehow I really screwed up: Error in programming! Contact
                 * author about totsamp > sampleWindow
                 */
                return GAIN_ANALYSIS_ERROR;
            }
        }
        if (num_samples < MAX_ORDER) {
            System.arraycopy(rgData.linprebuf, num_samples, rgData.linprebuf,
                0, MAX_ORDER - num_samples);
            System.arraycopy(rgData.rinprebuf, num_samples, rgData.rinprebuf,
                0, MAX_ORDER - num_samples);
            System.arraycopy(left_samples, left_samplesPos, rgData.linprebuf,
                MAX_ORDER - num_samples, num_samples);
            System.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf,
                MAX_ORDER - num_samples, num_samples);
        } else {
            System.arraycopy(left_samples, left_samplesPos + num_samples
                - MAX_ORDER, rgData.linprebuf, 0, MAX_ORDER);
            System.arraycopy(right_samples, right_samplesPos + num_samples
                - MAX_ORDER, rgData.rinprebuf, 0, MAX_ORDER);
        }

        return GAIN_ANALYSIS_OK;
    };

    function analyzeResult(Array, len) {
        var i;

        var elems = 0;
        for (i = 0; i < len; i++)
            elems += Array[i];
        if (elems == 0)
            return GAIN_NOT_ENOUGH_SAMPLES;

        var upper = 0 | Math.ceil(elems * (1. - RMS_PERCENTILE));
        for (i = len; i-- > 0;) {
            if ((upper -= Array[i]) <= 0)
                break;
        }

        //return (float) ((float) PINK_REF - (float) i / (float) STEPS_per_dB);
        return (PINK_REF - i / GainAnalysis.STEPS_per_dB);
    }

    this.GetTitleGain = function (rgData) {
        var retval = analyzeResult(rgData.A, rgData.A.length);

        for (var i = 0; i < rgData.A.length; i++) {
            rgData.B[i] += rgData.A[i];
            rgData.A[i] = 0;
        }

        for (var i = 0; i < MAX_ORDER; i++)
            rgData.linprebuf[i] = rgData.lstepbuf[i] = rgData.loutbuf[i] = rgData.rinprebuf[i] = rgData.rstepbuf[i] = rgData.routbuf[i] = 0.;

        rgData.totsamp = 0;
        rgData.lsum = rgData.rsum = 0.;
        return retval;
    }

}

module.exports = GainAnalysis;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

function MeanBits(meanBits) {
    this.bits = meanBits;
}

module.exports = MeanBits;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var Takehiro = __webpack_require__(368);
var Tables = __webpack_require__(205);
var Encoder = __webpack_require__(35);
var LameInternalFlags = __webpack_require__(148);

BitStream.EQ = function (a, b) {
    return (Math.abs(a) > Math.abs(b)) ? (Math.abs((a) - (b)) <= (Math
        .abs(a) * 1e-6))
        : (Math.abs((a) - (b)) <= (Math.abs(b) * 1e-6));
};

BitStream.NEQ = function (a, b) {
    return !BitStream.EQ(a, b);
};

function BitStream() {
    var self = this;
    var CRC16_POLYNOMIAL = 0x8005;

    /*
     * we work with ints, so when doing bit manipulation, we limit ourselves to
     * MAX_LENGTH-2 just to be on the safe side
     */
    var MAX_LENGTH = 32;

    //GainAnalysis ga;
    //MPGLib mpg;
    //Version ver;
    //VBRTag vbr;
    var ga = null;
    var mpg = null;
    var ver = null;
    var vbr = null;

    //public final void setModules(GainAnalysis ga, MPGLib mpg, Version ver,
    //	VBRTag vbr) {

    this.setModules = function (_ga, _mpg, _ver, _vbr) {
        ga = _ga;
        mpg = _mpg;
        ver = _ver;
        vbr = _vbr;
    };

    /**
     * Bit stream buffer.
     */
    //private byte[] buf;
    var buf = null;
    /**
     * Bit counter of bit stream.
     */
    var totbit = 0;
    /**
     * Pointer to top byte in buffer.
     */
    var bufByteIdx = 0;
    /**
     * Pointer to top bit of top byte in buffer.
     */
    var bufBitIdx = 0;

    /**
     * compute bitsperframe and mean_bits for a layer III frame
     */
    this.getframebits = function (gfp) {
        var gfc = gfp.internal_flags;
        var bit_rate;

        /* get bitrate in kbps [?] */
        if (gfc.bitrate_index != 0)
            bit_rate = Tables.bitrate_table[gfp.version][gfc.bitrate_index];
        else
            bit_rate = gfp.brate;
        assert(8 <= bit_rate && bit_rate <= 640);

        /* main encoding routine toggles padding on and off */
        /* one Layer3 Slot consists of 8 bits */
        var bytes = 0 | (gfp.version + 1) * 72000 * bit_rate / gfp.out_samplerate + gfc.padding;
        return 8 * bytes;
    };

    function putheader_bits(gfc) {
        System.arraycopy(gfc.header[gfc.w_ptr].buf, 0, buf, bufByteIdx, gfc.sideinfo_len);
        bufByteIdx += gfc.sideinfo_len;
        totbit += gfc.sideinfo_len * 8;
        gfc.w_ptr = (gfc.w_ptr + 1) & (LameInternalFlags.MAX_HEADER_BUF - 1);
    }

    /**
     * write j bits into the bit stream
     */
    function putbits2(gfc, val, j) {
        assert(j < MAX_LENGTH - 2);

        while (j > 0) {
            var k;
            if (bufBitIdx == 0) {
                bufBitIdx = 8;
                bufByteIdx++;
                assert(bufByteIdx < Lame.LAME_MAXMP3BUFFER);
                assert(gfc.header[gfc.w_ptr].write_timing >= totbit);
                if (gfc.header[gfc.w_ptr].write_timing == totbit) {
                    putheader_bits(gfc);
                }
                buf[bufByteIdx] = 0;
            }

            k = Math.min(j, bufBitIdx);
            j -= k;

            bufBitIdx -= k;

            assert(j < MAX_LENGTH);
            /* 32 too large on 32 bit machines */
            assert(bufBitIdx < MAX_LENGTH);

            buf[bufByteIdx] |= ((val >> j) << bufBitIdx);
            totbit += k;
        }
    }

    /**
     * write j bits into the bit stream, ignoring frame headers
     */
    function putbits_noheaders(gfc, val, j) {
        assert(j < MAX_LENGTH - 2);

        while (j > 0) {
            var k;
            if (bufBitIdx == 0) {
                bufBitIdx = 8;
                bufByteIdx++;
                assert(bufByteIdx < Lame.LAME_MAXMP3BUFFER);
                buf[bufByteIdx] = 0;
            }

            k = Math.min(j, bufBitIdx);
            j -= k;

            bufBitIdx -= k;

            assert(j < MAX_LENGTH);
            /* 32 too large on 32 bit machines */
            assert(bufBitIdx < MAX_LENGTH);

            buf[bufByteIdx] |= ((val >> j) << bufBitIdx);
            totbit += k;
        }
    }

    /**
     * Some combinations of bitrate, Fs, and stereo make it impossible to stuff
     * out a frame using just main_data, due to the limited number of bits to
     * indicate main_data_length. In these situations, we put stuffing bits into
     * the ancillary data...
     */
    function drain_into_ancillary(gfp, remainingBits) {
        var gfc = gfp.internal_flags;
        var i;
        assert(remainingBits >= 0);

        if (remainingBits >= 8) {
            putbits2(gfc, 0x4c, 8);
            remainingBits -= 8;
        }
        if (remainingBits >= 8) {
            putbits2(gfc, 0x41, 8);
            remainingBits -= 8;
        }
        if (remainingBits >= 8) {
            putbits2(gfc, 0x4d, 8);
            remainingBits -= 8;
        }
        if (remainingBits >= 8) {
            putbits2(gfc, 0x45, 8);
            remainingBits -= 8;
        }

        if (remainingBits >= 32) {
            var version = ver.getLameShortVersion();
            if (remainingBits >= 32)
                for (i = 0; i < version.length && remainingBits >= 8; ++i) {
                    remainingBits -= 8;
                    putbits2(gfc, version.charAt(i), 8);
                }
        }

        for (; remainingBits >= 1; remainingBits -= 1) {
            putbits2(gfc, gfc.ancillary_flag, 1);
            gfc.ancillary_flag ^= (!gfp.disable_reservoir ? 1 : 0);
        }

        assert(remainingBits == 0);

    }

    /**
     * write N bits into the header
     */
    function writeheader(gfc, val, j) {
        var ptr = gfc.header[gfc.h_ptr].ptr;

        while (j > 0) {
            var k = Math.min(j, 8 - (ptr & 7));
            j -= k;
            assert(j < MAX_LENGTH);
            /* >> 32 too large for 32 bit machines */

            gfc.header[gfc.h_ptr].buf[ptr >> 3] |= ((val >> j)) << (8 - (ptr & 7) - k);
            ptr += k;
        }
        gfc.header[gfc.h_ptr].ptr = ptr;
    }

    function CRC_update(value, crc) {
        value <<= 8;
        for (var i = 0; i < 8; i++) {
            value <<= 1;
            crc <<= 1;

            if ((((crc ^ value) & 0x10000) != 0))
                crc ^= CRC16_POLYNOMIAL;
        }
        return crc;
    }

    this.CRC_writeheader = function (gfc, header) {
        var crc = 0xffff;
        /* (jo) init crc16 for error_protection */

        crc = CRC_update(header[2] & 0xff, crc);
        crc = CRC_update(header[3] & 0xff, crc);
        for (var i = 6; i < gfc.sideinfo_len; i++) {
            crc = CRC_update(header[i] & 0xff, crc);
        }

        header[4] = (byte)(crc >> 8);
        header[5] = (byte)(crc & 255);
    };

    function encodeSideInfo2(gfp, bitsPerFrame) {
        var gfc = gfp.internal_flags;
        var l3_side;
        var gr, ch;

        l3_side = gfc.l3_side;
        gfc.header[gfc.h_ptr].ptr = 0;
        Arrays.fill(gfc.header[gfc.h_ptr].buf, 0, gfc.sideinfo_len, 0);
        if (gfp.out_samplerate < 16000)
            writeheader(gfc, 0xffe, 12);
        else
            writeheader(gfc, 0xfff, 12);
        writeheader(gfc, (gfp.version), 1);
        writeheader(gfc, 4 - 3, 2);
        writeheader(gfc, (!gfp.error_protection ? 1 : 0), 1);
        writeheader(gfc, (gfc.bitrate_index), 4);
        writeheader(gfc, (gfc.samplerate_index), 2);
        writeheader(gfc, (gfc.padding), 1);
        writeheader(gfc, (gfp.extension), 1);
        writeheader(gfc, (gfp.mode.ordinal()), 2);
        writeheader(gfc, (gfc.mode_ext), 2);
        writeheader(gfc, (gfp.copyright), 1);
        writeheader(gfc, (gfp.original), 1);
        writeheader(gfc, (gfp.emphasis), 2);
        if (gfp.error_protection) {
            writeheader(gfc, 0, 16);
            /* dummy */
        }

        if (gfp.version == 1) {
            /* MPEG1 */
            assert(l3_side.main_data_begin >= 0);
            writeheader(gfc, (l3_side.main_data_begin), 9);

            if (gfc.channels_out == 2)
                writeheader(gfc, l3_side.private_bits, 3);
            else
                writeheader(gfc, l3_side.private_bits, 5);

            for (ch = 0; ch < gfc.channels_out; ch++) {
                var band;
                for (band = 0; band < 4; band++) {
                    writeheader(gfc, l3_side.scfsi[ch][band], 1);
                }
            }

            for (gr = 0; gr < 2; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    var gi = l3_side.tt[gr][ch];
                    writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
                    writeheader(gfc, gi.big_values / 2, 9);
                    writeheader(gfc, gi.global_gain, 8);
                    writeheader(gfc, gi.scalefac_compress, 4);

                    if (gi.block_type != Encoder.NORM_TYPE) {
                        writeheader(gfc, 1, 1);
                        /* window_switching_flag */
                        writeheader(gfc, gi.block_type, 2);
                        writeheader(gfc, gi.mixed_block_flag, 1);

                        if (gi.table_select[0] == 14)
                            gi.table_select[0] = 16;
                        writeheader(gfc, gi.table_select[0], 5);
                        if (gi.table_select[1] == 14)
                            gi.table_select[1] = 16;
                        writeheader(gfc, gi.table_select[1], 5);

                        writeheader(gfc, gi.subblock_gain[0], 3);
                        writeheader(gfc, gi.subblock_gain[1], 3);
                        writeheader(gfc, gi.subblock_gain[2], 3);
                    } else {
                        writeheader(gfc, 0, 1);
                        /* window_switching_flag */
                        if (gi.table_select[0] == 14)
                            gi.table_select[0] = 16;
                        writeheader(gfc, gi.table_select[0], 5);
                        if (gi.table_select[1] == 14)
                            gi.table_select[1] = 16;
                        writeheader(gfc, gi.table_select[1], 5);
                        if (gi.table_select[2] == 14)
                            gi.table_select[2] = 16;
                        writeheader(gfc, gi.table_select[2], 5);

                        assert(0 <= gi.region0_count && gi.region0_count < 16);
                        assert(0 <= gi.region1_count && gi.region1_count < 8);
                        writeheader(gfc, gi.region0_count, 4);
                        writeheader(gfc, gi.region1_count, 3);
                    }
                    writeheader(gfc, gi.preflag, 1);
                    writeheader(gfc, gi.scalefac_scale, 1);
                    writeheader(gfc, gi.count1table_select, 1);
                }
            }
        } else {
            /* MPEG2 */
            assert(l3_side.main_data_begin >= 0);
            writeheader(gfc, (l3_side.main_data_begin), 8);
            writeheader(gfc, l3_side.private_bits, gfc.channels_out);

            gr = 0;
            for (ch = 0; ch < gfc.channels_out; ch++) {
                var gi = l3_side.tt[gr][ch];
                writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
                writeheader(gfc, gi.big_values / 2, 9);
                writeheader(gfc, gi.global_gain, 8);
                writeheader(gfc, gi.scalefac_compress, 9);

                if (gi.block_type != Encoder.NORM_TYPE) {
                    writeheader(gfc, 1, 1);
                    /* window_switching_flag */
                    writeheader(gfc, gi.block_type, 2);
                    writeheader(gfc, gi.mixed_block_flag, 1);

                    if (gi.table_select[0] == 14)
                        gi.table_select[0] = 16;
                    writeheader(gfc, gi.table_select[0], 5);
                    if (gi.table_select[1] == 14)
                        gi.table_select[1] = 16;
                    writeheader(gfc, gi.table_select[1], 5);

                    writeheader(gfc, gi.subblock_gain[0], 3);
                    writeheader(gfc, gi.subblock_gain[1], 3);
                    writeheader(gfc, gi.subblock_gain[2], 3);
                } else {
                    writeheader(gfc, 0, 1);
                    /* window_switching_flag */
                    if (gi.table_select[0] == 14)
                        gi.table_select[0] = 16;
                    writeheader(gfc, gi.table_select[0], 5);
                    if (gi.table_select[1] == 14)
                        gi.table_select[1] = 16;
                    writeheader(gfc, gi.table_select[1], 5);
                    if (gi.table_select[2] == 14)
                        gi.table_select[2] = 16;
                    writeheader(gfc, gi.table_select[2], 5);

                    assert(0 <= gi.region0_count && gi.region0_count < 16);
                    assert(0 <= gi.region1_count && gi.region1_count < 8);
                    writeheader(gfc, gi.region0_count, 4);
                    writeheader(gfc, gi.region1_count, 3);
                }

                writeheader(gfc, gi.scalefac_scale, 1);
                writeheader(gfc, gi.count1table_select, 1);
            }
        }

        if (gfp.error_protection) {
            /* (jo) error_protection: add crc16 information to header */
            CRC_writeheader(gfc, gfc.header[gfc.h_ptr].buf);
        }

        {
            var old = gfc.h_ptr;
            assert(gfc.header[old].ptr == gfc.sideinfo_len * 8);

            gfc.h_ptr = (old + 1) & (LameInternalFlags.MAX_HEADER_BUF - 1);
            gfc.header[gfc.h_ptr].write_timing = gfc.header[old].write_timing
                + bitsPerFrame;

            if (gfc.h_ptr == gfc.w_ptr) {
                /* yikes! we are out of header buffer space */
                System.err
                    .println("Error: MAX_HEADER_BUF too small in bitstream.c \n");
            }

        }
    }

    function huffman_coder_count1(gfc, gi) {
        /* Write count1 area */
        var h = Tables.ht[gi.count1table_select + 32];
        var i, bits = 0;

        var ix = gi.big_values;
        var xr = gi.big_values;
        assert(gi.count1table_select < 2);

        for (i = (gi.count1 - gi.big_values) / 4; i > 0; --i) {
            var huffbits = 0;
            var p = 0, v;

            v = gi.l3_enc[ix + 0];
            if (v != 0) {
                p += 8;
                if (gi.xr[xr + 0] < 0)
                    huffbits++;
                assert(v <= 1);
            }

            v = gi.l3_enc[ix + 1];
            if (v != 0) {
                p += 4;
                huffbits *= 2;
                if (gi.xr[xr + 1] < 0)
                    huffbits++;
                assert(v <= 1);
            }

            v = gi.l3_enc[ix + 2];
            if (v != 0) {
                p += 2;
                huffbits *= 2;
                if (gi.xr[xr + 2] < 0)
                    huffbits++;
                assert(v <= 1);
            }

            v = gi.l3_enc[ix + 3];
            if (v != 0) {
                p++;
                huffbits *= 2;
                if (gi.xr[xr + 3] < 0)
                    huffbits++;
                assert(v <= 1);
            }

            ix += 4;
            xr += 4;
            putbits2(gfc, huffbits + h.table[p], h.hlen[p]);
            bits += h.hlen[p];
        }
        return bits;
    }

    /**
     * Implements the pseudocode of page 98 of the IS
     */
    function Huffmancode(gfc, tableindex, start, end, gi) {
        var h = Tables.ht[tableindex];
        var bits = 0;

        assert(tableindex < 32);
        if (0 == tableindex)
            return bits;

        for (var i = start; i < end; i += 2) {
            var cbits = 0;
            var xbits = 0;
            var linbits = h.xlen;
            var xlen = h.xlen;
            var ext = 0;
            var x1 = gi.l3_enc[i];
            var x2 = gi.l3_enc[i + 1];

            if (x1 != 0) {
                if (gi.xr[i] < 0)
                    ext++;
                cbits--;
            }

            if (tableindex > 15) {
                /* use ESC-words */
                if (x1 > 14) {
                    var linbits_x1 = x1 - 15;
                    assert(linbits_x1 <= h.linmax);
                    ext |= linbits_x1 << 1;
                    xbits = linbits;
                    x1 = 15;
                }

                if (x2 > 14) {
                    var linbits_x2 = x2 - 15;
                    assert(linbits_x2 <= h.linmax);
                    ext <<= linbits;
                    ext |= linbits_x2;
                    xbits += linbits;
                    x2 = 15;
                }
                xlen = 16;
            }

            if (x2 != 0) {
                ext <<= 1;
                if (gi.xr[i + 1] < 0)
                    ext++;
                cbits--;
            }

            assert((x1 | x2) < 16);

            x1 = x1 * xlen + x2;
            xbits -= cbits;
            cbits += h.hlen[x1];

            assert(cbits <= MAX_LENGTH);
            assert(xbits <= MAX_LENGTH);

            putbits2(gfc, h.table[x1], cbits);
            putbits2(gfc, ext, xbits);
            bits += cbits + xbits;
        }
        return bits;
    }

    /**
     * Note the discussion of huffmancodebits() on pages 28 and 29 of the IS, as
     * well as the definitions of the side information on pages 26 and 27.
     */
    function ShortHuffmancodebits(gfc, gi) {
        var region1Start = 3 * gfc.scalefac_band.s[3];
        if (region1Start > gi.big_values)
            region1Start = gi.big_values;

        /* short blocks do not have a region2 */
        var bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
        bits += Huffmancode(gfc, gi.table_select[1], region1Start,
            gi.big_values, gi);
        return bits;
    }

    function LongHuffmancodebits(gfc, gi) {
        var bigvalues, bits;
        var region1Start, region2Start;

        bigvalues = gi.big_values;
        assert(0 <= bigvalues && bigvalues <= 576);

        var i = gi.region0_count + 1;
        assert(0 <= i);
        assert(i < gfc.scalefac_band.l.length);
        region1Start = gfc.scalefac_band.l[i];
        i += gi.region1_count + 1;
        assert(0 <= i);
        assert(i < gfc.scalefac_band.l.length);
        region2Start = gfc.scalefac_band.l[i];

        if (region1Start > bigvalues)
            region1Start = bigvalues;

        if (region2Start > bigvalues)
            region2Start = bigvalues;

        bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
        bits += Huffmancode(gfc, gi.table_select[1], region1Start,
            region2Start, gi);
        bits += Huffmancode(gfc, gi.table_select[2], region2Start, bigvalues,
            gi);
        return bits;
    }

    function writeMainData(gfp) {
        var gr, ch, sfb, data_bits, tot_bits = 0;
        var gfc = gfp.internal_flags;
        var l3_side = gfc.l3_side;

        if (gfp.version == 1) {
            /* MPEG 1 */
            for (gr = 0; gr < 2; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    var gi = l3_side.tt[gr][ch];
                    var slen1 = Takehiro.slen1_tab[gi.scalefac_compress];
                    var slen2 = Takehiro.slen2_tab[gi.scalefac_compress];
                    data_bits = 0;
                    for (sfb = 0; sfb < gi.sfbdivide; sfb++) {
                        if (gi.scalefac[sfb] == -1)
                            continue;
                        /* scfsi is used */
                        putbits2(gfc, gi.scalefac[sfb], slen1);
                        data_bits += slen1;
                    }
                    for (; sfb < gi.sfbmax; sfb++) {
                        if (gi.scalefac[sfb] == -1)
                            continue;
                        /* scfsi is used */
                        putbits2(gfc, gi.scalefac[sfb], slen2);
                        data_bits += slen2;
                    }
                    assert(data_bits == gi.part2_length);

                    if (gi.block_type == Encoder.SHORT_TYPE) {
                        data_bits += ShortHuffmancodebits(gfc, gi);
                    } else {
                        data_bits += LongHuffmancodebits(gfc, gi);
                    }
                    data_bits += huffman_coder_count1(gfc, gi);
                    /* does bitcount in quantize.c agree with actual bit count? */
                    assert(data_bits == gi.part2_3_length + gi.part2_length);
                    tot_bits += data_bits;
                }
                /* for ch */
            }
            /* for gr */
        } else {
            /* MPEG 2 */
            gr = 0;
            for (ch = 0; ch < gfc.channels_out; ch++) {
                var gi = l3_side.tt[gr][ch];
                var i, sfb_partition, scale_bits = 0;
                assert(gi.sfb_partition_table != null);
                data_bits = 0;
                sfb = 0;
                sfb_partition = 0;

                if (gi.block_type == Encoder.SHORT_TYPE) {
                    for (; sfb_partition < 4; sfb_partition++) {
                        var sfbs = gi.sfb_partition_table[sfb_partition] / 3;
                        var slen = gi.slen[sfb_partition];
                        for (i = 0; i < sfbs; i++, sfb++) {
                            putbits2(gfc,
                                Math.max(gi.scalefac[sfb * 3 + 0], 0), slen);
                            putbits2(gfc,
                                Math.max(gi.scalefac[sfb * 3 + 1], 0), slen);
                            putbits2(gfc,
                                Math.max(gi.scalefac[sfb * 3 + 2], 0), slen);
                            scale_bits += 3 * slen;
                        }
                    }
                    data_bits += ShortHuffmancodebits(gfc, gi);
                } else {
                    for (; sfb_partition < 4; sfb_partition++) {
                        var sfbs = gi.sfb_partition_table[sfb_partition];
                        var slen = gi.slen[sfb_partition];
                        for (i = 0; i < sfbs; i++, sfb++) {
                            putbits2(gfc, Math.max(gi.scalefac[sfb], 0), slen);
                            scale_bits += slen;
                        }
                    }
                    data_bits += LongHuffmancodebits(gfc, gi);
                }
                data_bits += huffman_coder_count1(gfc, gi);
                /* does bitcount in quantize.c agree with actual bit count? */
                assert(data_bits == gi.part2_3_length);
                assert(scale_bits == gi.part2_length);
                tot_bits += scale_bits + data_bits;
            }
            /* for ch */
        }
        /* for gf */
        return tot_bits;
    }

    /* main_data */

    function TotalBytes() {
        this.total = 0;
    }

    /*
     * compute the number of bits required to flush all mp3 frames currently in
     * the buffer. This should be the same as the reservoir size. Only call this
     * routine between frames - i.e. only after all headers and data have been
     * added to the buffer by format_bitstream().
     *
     * Also compute total_bits_output = size of mp3 buffer (including frame
     * headers which may not have yet been send to the mp3 buffer) + number of
     * bits needed to flush all mp3 frames.
     *
     * total_bytes_output is the size of the mp3 output buffer if
     * lame_encode_flush_nogap() was called right now.
     */
    function compute_flushbits(gfp, total_bytes_output) {
        var gfc = gfp.internal_flags;
        var flushbits, remaining_headers;
        var bitsPerFrame;
        var last_ptr, first_ptr;
        first_ptr = gfc.w_ptr;
        /* first header to add to bitstream */
        last_ptr = gfc.h_ptr - 1;
        /* last header to add to bitstream */
        if (last_ptr == -1)
            last_ptr = LameInternalFlags.MAX_HEADER_BUF - 1;

        /* add this many bits to bitstream so we can flush all headers */
        flushbits = gfc.header[last_ptr].write_timing - totbit;
        total_bytes_output.total = flushbits;

        if (flushbits >= 0) {
            /* if flushbits >= 0, some headers have not yet been written */
            /* reduce flushbits by the size of the headers */
            remaining_headers = 1 + last_ptr - first_ptr;
            if (last_ptr < first_ptr)
                remaining_headers = 1 + last_ptr - first_ptr
                    + LameInternalFlags.MAX_HEADER_BUF;
            flushbits -= remaining_headers * 8 * gfc.sideinfo_len;
        }

        /*
         * finally, add some bits so that the last frame is complete these bits
         * are not necessary to decode the last frame, but some decoders will
         * ignore last frame if these bits are missing
         */
        bitsPerFrame = self.getframebits(gfp);
        flushbits += bitsPerFrame;
        total_bytes_output.total += bitsPerFrame;
        /* round up: */
        if ((total_bytes_output.total % 8) != 0)
            total_bytes_output.total = 1 + (total_bytes_output.total / 8);
        else
            total_bytes_output.total = (total_bytes_output.total / 8);
        total_bytes_output.total += bufByteIdx + 1;

        if (flushbits < 0) {
            System.err.println("strange error flushing buffer ... \n");
        }
        return flushbits;
    }

    this.flush_bitstream = function (gfp) {
        var gfc = gfp.internal_flags;
        var l3_side;
        var flushbits;
        var last_ptr = gfc.h_ptr - 1;
        /* last header to add to bitstream */
        if (last_ptr == -1)
            last_ptr = LameInternalFlags.MAX_HEADER_BUF - 1;
        l3_side = gfc.l3_side;

        if ((flushbits = compute_flushbits(gfp, new TotalBytes())) < 0)
            return;
        drain_into_ancillary(gfp, flushbits);

        /* check that the 100% of the last frame has been written to bitstream */
        assert(gfc.header[last_ptr].write_timing + this.getframebits(gfp) == totbit);

        /*
         * we have padded out all frames with ancillary data, which is the same
         * as filling the bitreservoir with ancillary data, so :
         */
        gfc.ResvSize = 0;
        l3_side.main_data_begin = 0;

        /* save the ReplayGain value */
        if (gfc.findReplayGain) {
            var RadioGain = ga.GetTitleGain(gfc.rgdata);
            assert(NEQ(RadioGain, GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES));
            gfc.RadioGain = Math.floor(RadioGain * 10.0 + 0.5) | 0;
            /* round to nearest */
        }

        /* find the gain and scale change required for no clipping */
        if (gfc.findPeakSample) {
            gfc.noclipGainChange = Math.ceil(Math
                        .log10(gfc.PeakSample / 32767.0) * 20.0 * 10.0) | 0;
            /* round up */

            if (gfc.noclipGainChange > 0) {
                /* clipping occurs */
                if (EQ(gfp.scale, 1.0) || EQ(gfp.scale, 0.0))
                    gfc.noclipScale = (Math
                        .floor((32767.0 / gfc.PeakSample) * 100.0) / 100.0);
                /* round down */
                else {
                    /*
                     * the user specified his own scaling factor. We could
                     * suggest the scaling factor of
                     * (32767.0/gfp.PeakSample)*(gfp.scale) but it's usually
                     * very inaccurate. So we'd rather not advice him on the
                     * scaling factor.
                     */
                    gfc.noclipScale = -1;
                }
            } else
            /* no clipping */
                gfc.noclipScale = -1;
        }
    };

    this.add_dummy_byte = function (gfp, val, n) {
        var gfc = gfp.internal_flags;
        var i;

        while (n-- > 0) {
            putbits_noheaders(gfc, val, 8);

            for (i = 0; i < LameInternalFlags.MAX_HEADER_BUF; ++i)
                gfc.header[i].write_timing += 8;
        }
    };

    /**
     * This is called after a frame of audio has been quantized and coded. It
     * will write the encoded audio to the bitstream. Note that from a layer3
     * encoder's perspective the bit stream is primarily a series of main_data()
     * blocks, with header and side information inserted at the proper locations
     * to maintain framing. (See Figure A.7 in the IS).
     */
    this.format_bitstream = function (gfp) {
        var gfc = gfp.internal_flags;
        var l3_side;
        l3_side = gfc.l3_side;

        var bitsPerFrame = this.getframebits(gfp);
        drain_into_ancillary(gfp, l3_side.resvDrain_pre);

        encodeSideInfo2(gfp, bitsPerFrame);
        var bits = 8 * gfc.sideinfo_len;
        bits += writeMainData(gfp);
        drain_into_ancillary(gfp, l3_side.resvDrain_post);
        bits += l3_side.resvDrain_post;

        l3_side.main_data_begin += (bitsPerFrame - bits) / 8;

        /*
         * compare number of bits needed to clear all buffered mp3 frames with
         * what we think the resvsize is:
         */
        if (compute_flushbits(gfp, new TotalBytes()) != gfc.ResvSize) {
            System.err.println("Internal buffer inconsistency. flushbits <> ResvSize");
        }

        /*
         * compare main_data_begin for the next frame with what we think the
         * resvsize is:
         */
        if ((l3_side.main_data_begin * 8) != gfc.ResvSize) {
            System.err.printf("bit reservoir error: \n"
                + "l3_side.main_data_begin: %d \n"
                + "Resvoir size:             %d \n"
                + "resv drain (post)         %d \n"
                + "resv drain (pre)          %d \n"
                + "header and sideinfo:      %d \n"
                + "data bits:                %d \n"
                + "total bits:               %d (remainder: %d) \n"
                + "bitsperframe:             %d \n",
                8 * l3_side.main_data_begin, gfc.ResvSize,
                l3_side.resvDrain_post, l3_side.resvDrain_pre,
                8 * gfc.sideinfo_len, bits - l3_side.resvDrain_post - 8
                * gfc.sideinfo_len, bits, bits % 8, bitsPerFrame);

            System.err.println("This is a fatal error.  It has several possible causes:");
            System.err.println("90%%  LAME compiled with buggy version of gcc using advanced optimizations");
            System.err.println(" 9%%  Your system is overclocked");
            System.err.println(" 1%%  bug in LAME encoding library");

            gfc.ResvSize = l3_side.main_data_begin * 8;
        }
        //;
        assert(totbit % 8 == 0);

        if (totbit > 1000000000) {
            /*
             * to avoid totbit overflow, (at 8h encoding at 128kbs) lets reset
             * bit counter
             */
            var i;
            for (i = 0; i < LameInternalFlags.MAX_HEADER_BUF; ++i)
                gfc.header[i].write_timing -= totbit;
            totbit = 0;
        }

        return 0;
    };

    /**
     * <PRE>
     * copy data out of the internal MP3 bit buffer into a user supplied
     *       unsigned char buffer.
     *
     *       mp3data=0      indicates data in buffer is an id3tags and VBR tags
     *       mp3data=1      data is real mp3 frame data.
     * </PRE>
     */
    this.copy_buffer = function (gfc, buffer, bufferPos, size, mp3data) {
        var minimum = bufByteIdx + 1;
        if (minimum <= 0)
            return 0;
        if (size != 0 && minimum > size) {
            /* buffer is too small */
            return -1;
        }
        System.arraycopy(buf, 0, buffer, bufferPos, minimum);
        bufByteIdx = -1;
        bufBitIdx = 0;

        if (mp3data != 0) {
            var crc = new_int(1);
            crc[0] = gfc.nMusicCRC;
            vbr.updateMusicCRC(crc, buffer, bufferPos, minimum);
            gfc.nMusicCRC = crc[0];

            /**
             * sum number of bytes belonging to the mp3 stream this info will be
             * written into the Xing/LAME header for seeking
             */
            if (minimum > 0) {
                gfc.VBR_seek_table.nBytesWritten += minimum;
            }

            if (gfc.decode_on_the_fly) { /* decode the frame */
                var pcm_buf = new_float_n([2, 1152]);
                var mp3_in = minimum;
                var samples_out = -1;
                var i;

                /* re-synthesis to pcm. Repeat until we get a samples_out=0 */
                while (samples_out != 0) {

                    samples_out = mpg.hip_decode1_unclipped(gfc.hip, buffer,
                        bufferPos, mp3_in, pcm_buf[0], pcm_buf[1]);
                    /*
                     * samples_out = 0: need more data to decode samples_out =
                     * -1: error. Lets assume 0 pcm output samples_out = number
                     * of samples output
                     */

                    /*
                     * set the lenght of the mp3 input buffer to zero, so that
                     * in the next iteration of the loop we will be querying
                     * mpglib about buffered data
                     */
                    mp3_in = 0;

                    if (samples_out == -1) {
                        /*
                         * error decoding. Not fatal, but might screw up the
                         * ReplayGain tag. What should we do? Ignore for now
                         */
                        samples_out = 0;
                    }
                    if (samples_out > 0) {
                        /* process the PCM data */

                        /*
                         * this should not be possible, and indicates we have
                         * overflown the pcm_buf buffer
                         */
                        assert(samples_out <= 1152);

                        if (gfc.findPeakSample) {
                            for (i = 0; i < samples_out; i++) {
                                if (pcm_buf[0][i] > gfc.PeakSample)
                                    gfc.PeakSample = pcm_buf[0][i];
                                else if (-pcm_buf[0][i] > gfc.PeakSample)
                                    gfc.PeakSample = -pcm_buf[0][i];
                            }
                            if (gfc.channels_out > 1)
                                for (i = 0; i < samples_out; i++) {
                                    if (pcm_buf[1][i] > gfc.PeakSample)
                                        gfc.PeakSample = pcm_buf[1][i];
                                    else if (-pcm_buf[1][i] > gfc.PeakSample)
                                        gfc.PeakSample = -pcm_buf[1][i];
                                }
                        }

                        if (gfc.findReplayGain)
                            if (ga.AnalyzeSamples(gfc.rgdata, pcm_buf[0], 0,
                                    pcm_buf[1], 0, samples_out,
                                    gfc.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR)
                                return -6;

                    }
                    /* if (samples_out>0) */
                }
                /* while (samples_out!=0) */
            }
            /* if (gfc.decode_on_the_fly) */

        }
        /* if (mp3data) */
        return minimum;
    };

    this.init_bit_stream_w = function (gfc) {
        buf = new_byte(Lame.LAME_MAXMP3BUFFER);

        gfc.h_ptr = gfc.w_ptr = 0;
        gfc.header[gfc.h_ptr].write_timing = 0;
        bufByteIdx = -1;
        bufBitIdx = 0;
        totbit = 0;
    };

    // From machine.h


}

module.exports = BitStream;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *	MP3 huffman table selecting and bit counting
 *
 *	Copyright (c) 1999-2005 Takehiro TOMINAGA
 *	Copyright (c) 2002-2005 Gabriel Bouvigne
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.	 See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

/* $Id: Takehiro.java,v 1.26 2011/05/24 20:48:06 kenchis Exp $ */

//package mp3;

//import java.util.Arrays;
var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var Encoder = __webpack_require__(35);
var Tables = __webpack_require__(205);
var GrInfo = __webpack_require__(204);
var QuantizePVT = __webpack_require__(369);


function Takehiro() {

    var qupvt = null;
    this.qupvt = null;

    this.setModules = function (_qupvt) {
        this.qupvt = _qupvt;
        qupvt = _qupvt;
    }

    function Bits(b) {
        this.bits = 0 | b;
    }

    var subdv_table = [[0, 0], /* 0 bands */
        [0, 0], /* 1 bands */
        [0, 0], /* 2 bands */
        [0, 0], /* 3 bands */
        [0, 0], /* 4 bands */
        [0, 1], /* 5 bands */
        [1, 1], /* 6 bands */
        [1, 1], /* 7 bands */
        [1, 2], /* 8 bands */
        [2, 2], /* 9 bands */
        [2, 3], /* 10 bands */
        [2, 3], /* 11 bands */
        [3, 4], /* 12 bands */
        [3, 4], /* 13 bands */
        [3, 4], /* 14 bands */
        [4, 5], /* 15 bands */
        [4, 5], /* 16 bands */
        [4, 6], /* 17 bands */
        [5, 6], /* 18 bands */
        [5, 6], /* 19 bands */
        [5, 7], /* 20 bands */
        [6, 7], /* 21 bands */
        [6, 7], /* 22 bands */
    ];

    /**
     * nonlinear quantization of xr More accurate formula than the ISO formula.
     * Takes into account the fact that we are quantizing xr . ix, but we want
     * ix^4/3 to be as close as possible to x^4/3. (taking the nearest int would
     * mean ix is as close as possible to xr, which is different.)
     *
     * From Segher Boessenkool <segher@eastsite.nl> 11/1999
     *
     * 09/2000: ASM code removed in favor of IEEE754 hack by Takehiro Tominaga.
     * If you need the ASM code, check CVS circa Aug 2000.
     *
     * 01/2004: Optimizations by Gabriel Bouvigne
     */
    function quantize_lines_xrpow_01(l, istep, xr, xrPos, ix, ixPos) {
        var compareval0 = (1.0 - 0.4054) / istep;

        assert(l > 0);
        l = l >> 1;
        while ((l--) != 0) {
            ix[ixPos++] = (compareval0 > xr[xrPos++]) ? 0 : 1;
            ix[ixPos++] = (compareval0 > xr[xrPos++]) ? 0 : 1;
        }
    }

    /**
     * XRPOW_FTOI is a macro to convert floats to ints.<BR>
     * if XRPOW_FTOI(x) = nearest_int(x), then QUANTFAC(x)=adj43asm[x]<BR>
     * ROUNDFAC= -0.0946<BR>
     *
     * if XRPOW_FTOI(x) = floor(x), then QUANTFAC(x)=asj43[x]<BR>
     * ROUNDFAC=0.4054<BR>
     *
     * Note: using floor() or 0| is extremely slow. On machines where the
     * TAKEHIRO_IEEE754_HACK code above does not work, it is worthwile to write
     * some ASM for XRPOW_FTOI().
     */
    function quantize_lines_xrpow(l, istep, xr, xrPos, ix, ixPos) {
        assert(l > 0);

        l = l >> 1;
        var remaining = l % 2;
        l = l >> 1;
        while (l-- != 0) {
            var x0, x1, x2, x3;
            var rx0, rx1, rx2, rx3;

            x0 = xr[xrPos++] * istep;
            x1 = xr[xrPos++] * istep;
            rx0 = 0 | x0;
            x2 = xr[xrPos++] * istep;
            rx1 = 0 | x1;
            x3 = xr[xrPos++] * istep;
            rx2 = 0 | x2;
            x0 += qupvt.adj43[rx0];
            rx3 = 0 | x3;
            x1 += qupvt.adj43[rx1];
            ix[ixPos++] = 0 | x0;
            x2 += qupvt.adj43[rx2];
            ix[ixPos++] = 0 | x1;
            x3 += qupvt.adj43[rx3];
            ix[ixPos++] = 0 | x2;
            ix[ixPos++] = 0 | x3;
        }
        if (remaining != 0) {
            var x0, x1;
            var rx0, rx1;

            x0 = xr[xrPos++] * istep;
            x1 = xr[xrPos++] * istep;
            rx0 = 0 | x0;
            rx1 = 0 | x1;
            x0 += qupvt.adj43[rx0];
            x1 += qupvt.adj43[rx1];
            ix[ixPos++] = 0 | x0;
            ix[ixPos++] = 0 | x1;
        }
    }

    /**
     * Quantization function This function will select which lines to quantize
     * and call the proper quantization function
     */
    function quantize_xrpow(xp, pi, istep, codInfo, prevNoise) {
        /* quantize on xr^(3/4) instead of xr */
        var sfb;
        var sfbmax;
        var j = 0;
        var prev_data_use;
        var accumulate = 0;
        var accumulate01 = 0;
        var xpPos = 0;
        var iData = pi;
        var iDataPos = 0;
        var acc_iData = iData;
        var acc_iDataPos = 0;
        var acc_xp = xp;
        var acc_xpPos = 0;

        /*
         * Reusing previously computed data does not seems to work if global
         * gain is changed. Finding why it behaves this way would allow to use a
         * cache of previously computed values (let's 10 cached values per sfb)
         * that would probably provide a noticeable speedup
         */
        prev_data_use = (prevNoise != null && (codInfo.global_gain == prevNoise.global_gain));

        if (codInfo.block_type == Encoder.SHORT_TYPE)
            sfbmax = 38;
        else
            sfbmax = 21;

        for (sfb = 0; sfb <= sfbmax; sfb++) {
            var step = -1;

            if (prev_data_use || codInfo.block_type == Encoder.NORM_TYPE) {
                step = codInfo.global_gain
                    - ((codInfo.scalefac[sfb] + (codInfo.preflag != 0 ? qupvt.pretab[sfb]
                        : 0)) << (codInfo.scalefac_scale + 1))
                    - codInfo.subblock_gain[codInfo.window[sfb]] * 8;
            }
            assert(codInfo.width[sfb] >= 0);
            if (prev_data_use && (prevNoise.step[sfb] == step)) {
                /*
                 * do not recompute this part, but compute accumulated lines
                 */
                if (accumulate != 0) {
                    quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos,
                        acc_iData, acc_iDataPos);
                    accumulate = 0;
                }
                if (accumulate01 != 0) {
                    quantize_lines_xrpow_01(accumulate01, istep, acc_xp,
                        acc_xpPos, acc_iData, acc_iDataPos);
                    accumulate01 = 0;
                }
            } else { /* should compute this part */
                var l = codInfo.width[sfb];

                if ((j + codInfo.width[sfb]) > codInfo.max_nonzero_coeff) {
                    /* do not compute upper zero part */
                    var usefullsize;
                    usefullsize = codInfo.max_nonzero_coeff - j + 1;
                    Arrays.fill(pi, codInfo.max_nonzero_coeff, 576, 0);
                    l = usefullsize;

                    if (l < 0) {
                        l = 0;
                    }

                    /* no need to compute higher sfb values */
                    sfb = sfbmax + 1;
                }

                /* accumulate lines to quantize */
                if (0 == accumulate && 0 == accumulate01) {
                    acc_iData = iData;
                    acc_iDataPos = iDataPos;
                    acc_xp = xp;
                    acc_xpPos = xpPos;
                }
                if (prevNoise != null && prevNoise.sfb_count1 > 0
                    && sfb >= prevNoise.sfb_count1
                    && prevNoise.step[sfb] > 0
                    && step >= prevNoise.step[sfb]) {

                    if (accumulate != 0) {
                        quantize_lines_xrpow(accumulate, istep, acc_xp,
                            acc_xpPos, acc_iData, acc_iDataPos);
                        accumulate = 0;
                        acc_iData = iData;
                        acc_iDataPos = iDataPos;
                        acc_xp = xp;
                        acc_xpPos = xpPos;
                    }
                    accumulate01 += l;
                } else {
                    if (accumulate01 != 0) {
                        quantize_lines_xrpow_01(accumulate01, istep, acc_xp,
                            acc_xpPos, acc_iData, acc_iDataPos);
                        accumulate01 = 0;
                        acc_iData = iData;
                        acc_iDataPos = iDataPos;
                        acc_xp = xp;
                        acc_xpPos = xpPos;
                    }
                    accumulate += l;
                }

                if (l <= 0) {
                    /*
                     * rh: 20040215 may happen due to "prev_data_use"
                     * optimization
                     */
                    if (accumulate01 != 0) {
                        quantize_lines_xrpow_01(accumulate01, istep, acc_xp,
                            acc_xpPos, acc_iData, acc_iDataPos);
                        accumulate01 = 0;
                    }
                    if (accumulate != 0) {
                        quantize_lines_xrpow(accumulate, istep, acc_xp,
                            acc_xpPos, acc_iData, acc_iDataPos);
                        accumulate = 0;
                    }

                    break;
                    /* ends for-loop */
                }
            }
            if (sfb <= sfbmax) {
                iDataPos += codInfo.width[sfb];
                xpPos += codInfo.width[sfb];
                j += codInfo.width[sfb];
            }
        }
        if (accumulate != 0) { /* last data part */
            quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos,
                acc_iData, acc_iDataPos);
            accumulate = 0;
        }
        if (accumulate01 != 0) { /* last data part */
            quantize_lines_xrpow_01(accumulate01, istep, acc_xp, acc_xpPos,
                acc_iData, acc_iDataPos);
            accumulate01 = 0;
        }

    }

    /**
     * ix_max
     */
    function ix_max(ix, ixPos, endPos) {
        var max1 = 0, max2 = 0;

        do {
            var x1 = ix[ixPos++];
            var x2 = ix[ixPos++];
            if (max1 < x1)
                max1 = x1;

            if (max2 < x2)
                max2 = x2;
        } while (ixPos < endPos);
        if (max1 < max2)
            max1 = max2;
        return max1;
    }

    function count_bit_ESC(ix, ixPos, end, t1, t2, s) {
        /* ESC-table is used */
        var linbits = Tables.ht[t1].xlen * 65536 + Tables.ht[t2].xlen;
        var sum = 0, sum2;

        do {
            var x = ix[ixPos++];
            var y = ix[ixPos++];

            if (x != 0) {
                if (x > 14) {
                    x = 15;
                    sum += linbits;
                }
                x *= 16;
            }

            if (y != 0) {
                if (y > 14) {
                    y = 15;
                    sum += linbits;
                }
                x += y;
            }

            sum += Tables.largetbl[x];
        } while (ixPos < end);

        sum2 = sum & 0xffff;
        sum >>= 16;

        if (sum > sum2) {
            sum = sum2;
            t1 = t2;
        }

        s.bits += sum;
        return t1;
    }

    function count_bit_noESC(ix, ixPos, end, s) {
        /* No ESC-words */
        var sum1 = 0;
        var hlen1 = Tables.ht[1].hlen;

        do {
            var x = ix[ixPos + 0] * 2 + ix[ixPos + 1];
            ixPos += 2;
            sum1 += hlen1[x];
        } while (ixPos < end);

        s.bits += sum1;
        return 1;
    }

    function count_bit_noESC_from2(ix, ixPos, end, t1, s) {
        /* No ESC-words */
        var sum = 0, sum2;
        var xlen = Tables.ht[t1].xlen;
        var hlen;
        if (t1 == 2)
            hlen = Tables.table23;
        else
            hlen = Tables.table56;

        do {
            var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
            ixPos += 2;
            sum += hlen[x];
        } while (ixPos < end);

        sum2 = sum & 0xffff;
        sum >>= 16;

        if (sum > sum2) {
            sum = sum2;
            t1++;
        }

        s.bits += sum;
        return t1;
    }

    function count_bit_noESC_from3(ix, ixPos, end, t1, s) {
        /* No ESC-words */
        var sum1 = 0;
        var sum2 = 0;
        var sum3 = 0;
        var xlen = Tables.ht[t1].xlen;
        var hlen1 = Tables.ht[t1].hlen;
        var hlen2 = Tables.ht[t1 + 1].hlen;
        var hlen3 = Tables.ht[t1 + 2].hlen;

        do {
            var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
            ixPos += 2;
            sum1 += hlen1[x];
            sum2 += hlen2[x];
            sum3 += hlen3[x];
        } while (ixPos < end);
        var t = t1;
        if (sum1 > sum2) {
            sum1 = sum2;
            t++;
        }
        if (sum1 > sum3) {
            sum1 = sum3;
            t = t1 + 2;
        }
        s.bits += sum1;

        return t;
    }

    /*************************************************************************/
    /* choose table */
    /*************************************************************************/

    var huf_tbl_noESC = [1, 2, 5, 7, 7, 10, 10, 13, 13,
        13, 13, 13, 13, 13, 13];

    /**
     * Choose the Huffman table that will encode ix[begin..end] with the fewest
     * bits.
     *
     * Note: This code contains knowledge about the sizes and characteristics of
     * the Huffman tables as defined in the IS (Table B.7), and will not work
     * with any arbitrary tables.
     */
    function choose_table(ix, ixPos, endPos, s) {
        var max = ix_max(ix, ixPos, endPos);

        switch (max) {
            case 0:
                return max;

            case 1:
                return count_bit_noESC(ix, ixPos, endPos, s);

            case 2:
            case 3:
                return count_bit_noESC_from2(ix, ixPos, endPos,
                    huf_tbl_noESC[max - 1], s);

            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
                return count_bit_noESC_from3(ix, ixPos, endPos,
                    huf_tbl_noESC[max - 1], s);

            default:
                /* try tables with linbits */
                if (max > QuantizePVT.IXMAX_VAL) {
                    s.bits = QuantizePVT.LARGE_BITS;
                    return -1;
                }
                max -= 15;
                var choice2;
                for (choice2 = 24; choice2 < 32; choice2++) {
                    if (Tables.ht[choice2].linmax >= max) {
                        break;
                    }
                }
                var choice;
                for (choice = choice2 - 8; choice < 24; choice++) {
                    if (Tables.ht[choice].linmax >= max) {
                        break;
                    }
                }
                return count_bit_ESC(ix, ixPos, endPos, choice, choice2, s);
        }
    }

    /**
     * count_bit
     */
    this.noquant_count_bits = function (gfc, gi, prev_noise) {
        var ix = gi.l3_enc;
        var i = Math.min(576, ((gi.max_nonzero_coeff + 2) >> 1) << 1);

        if (prev_noise != null)
            prev_noise.sfb_count1 = 0;

        /* Determine count1 region */
        for (; i > 1; i -= 2)
            if ((ix[i - 1] | ix[i - 2]) != 0)
                break;
        gi.count1 = i;

        /* Determines the number of bits to encode the quadruples. */
        var a1 = 0;
        var a2 = 0;
        for (; i > 3; i -= 4) {
            var p;
            /* hack to check if all values <= 1 */
            //throw "TODO: HACK         if ((((long) ix[i - 1] | (long) ix[i - 2] | (long) ix[i - 3] | (long) ix[i - 4]) & 0xffffffffL) > 1L        "
            //if (true) {
            if (((ix[i - 1] | ix[i - 2] | ix[i - 3] | ix[i - 4]) & 0x7fffffff) > 1) {
                break;
            }
            p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2 + ix[i - 1];
            a1 += Tables.t32l[p];
            a2 += Tables.t33l[p];
        }
        var bits = a1;
        gi.count1table_select = 0;
        if (a1 > a2) {
            bits = a2;
            gi.count1table_select = 1;
        }

        gi.count1bits = bits;
        gi.big_values = i;
        if (i == 0)
            return bits;

        if (gi.block_type == Encoder.SHORT_TYPE) {
            a1 = 3 * gfc.scalefac_band.s[3];
            if (a1 > gi.big_values)
                a1 = gi.big_values;
            a2 = gi.big_values;

        } else if (gi.block_type == Encoder.NORM_TYPE) {
            assert(i <= 576);
            /* bv_scf has 576 entries (0..575) */
            a1 = gi.region0_count = gfc.bv_scf[i - 2];
            a2 = gi.region1_count = gfc.bv_scf[i - 1];

            assert(a1 + a2 + 2 < Encoder.SBPSY_l);
            a2 = gfc.scalefac_band.l[a1 + a2 + 2];
            a1 = gfc.scalefac_band.l[a1 + 1];
            if (a2 < i) {
                var bi = new Bits(bits);
                gi.table_select[2] = choose_table(ix, a2, i, bi);
                bits = bi.bits;
            }
        } else {
            gi.region0_count = 7;
            /* gi.region1_count = SBPSY_l - 7 - 1; */
            gi.region1_count = Encoder.SBMAX_l - 1 - 7 - 1;
            a1 = gfc.scalefac_band.l[7 + 1];
            a2 = i;
            if (a1 > a2) {
                a1 = a2;
            }
        }

        /* have to allow for the case when bigvalues < region0 < region1 */
        /* (and region0, region1 are ignored) */
        a1 = Math.min(a1, i);
        a2 = Math.min(a2, i);

        assert(a1 >= 0);
        assert(a2 >= 0);

        /* Count the number of bits necessary to code the bigvalues region. */
        if (0 < a1) {
            var bi = new Bits(bits);
            gi.table_select[0] = choose_table(ix, 0, a1, bi);
            bits = bi.bits;
        }
        if (a1 < a2) {
            var bi = new Bits(bits);
            gi.table_select[1] = choose_table(ix, a1, a2, bi);
            bits = bi.bits;
        }
        if (gfc.use_best_huffman == 2) {
            gi.part2_3_length = bits;
            best_huffman_divide(gfc, gi);
            bits = gi.part2_3_length;
        }

        if (prev_noise != null) {
            if (gi.block_type == Encoder.NORM_TYPE) {
                var sfb = 0;
                while (gfc.scalefac_band.l[sfb] < gi.big_values) {
                    sfb++;
                }
                prev_noise.sfb_count1 = sfb;
            }
        }

        return bits;
    }

    this.count_bits = function (gfc, xr, gi, prev_noise) {
        var ix = gi.l3_enc;

        /* since quantize_xrpow uses table lookup, we need to check this first: */
        var w = (QuantizePVT.IXMAX_VAL) / qupvt.IPOW20(gi.global_gain);

        if (gi.xrpow_max > w)
            return QuantizePVT.LARGE_BITS;

        quantize_xrpow(xr, ix, qupvt.IPOW20(gi.global_gain), gi, prev_noise);

        if ((gfc.substep_shaping & 2) != 0) {
            var j = 0;
            /* 0.634521682242439 = 0.5946*2**(.5*0.1875) */
            var gain = gi.global_gain + gi.scalefac_scale;
            var roundfac = 0.634521682242439 / qupvt.IPOW20(gain);
            for (var sfb = 0; sfb < gi.sfbmax; sfb++) {
                var width = gi.width[sfb];
                assert(width >= 0);
                if (0 == gfc.pseudohalf[sfb]) {
                    j += width;
                } else {
                    var k;
                    for (k = j, j += width; k < j; ++k) {
                        ix[k] = (xr[k] >= roundfac) ? ix[k] : 0;
                    }
                }
            }
        }
        return this.noquant_count_bits(gfc, gi, prev_noise);
    }

    /**
     * re-calculate the best scalefac_compress using scfsi the saved bits are
     * kept in the bit reservoir.
     */
    function recalc_divide_init(gfc, cod_info, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
        var bigv = cod_info.big_values;

        for (var r0 = 0; r0 <= 7 + 15; r0++) {
            r01_bits[r0] = QuantizePVT.LARGE_BITS;
        }

        for (var r0 = 0; r0 < 16; r0++) {
            var a1 = gfc.scalefac_band.l[r0 + 1];
            if (a1 >= bigv)
                break;
            var r0bits = 0;
            var bi = new Bits(r0bits);
            var r0t = choose_table(ix, 0, a1, bi);
            r0bits = bi.bits;

            for (var r1 = 0; r1 < 8; r1++) {
                var a2 = gfc.scalefac_band.l[r0 + r1 + 2];
                if (a2 >= bigv)
                    break;
                var bits = r0bits;
                bi = new Bits(bits);
                var r1t = choose_table(ix, a1, a2, bi);
                bits = bi.bits;
                if (r01_bits[r0 + r1] > bits) {
                    r01_bits[r0 + r1] = bits;
                    r01_div[r0 + r1] = r0;
                    r0_tbl[r0 + r1] = r0t;
                    r1_tbl[r0 + r1] = r1t;
                }
            }
        }
    }

    function recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
        var bigv = cod_info2.big_values;

        for (var r2 = 2; r2 < Encoder.SBMAX_l + 1; r2++) {
            var a2 = gfc.scalefac_band.l[r2];
            if (a2 >= bigv)
                break;
            var bits = r01_bits[r2 - 2] + cod_info2.count1bits;
            if (gi.part2_3_length <= bits)
                break;

            var bi = new Bits(bits);
            var r2t = choose_table(ix, a2, bigv, bi);
            bits = bi.bits;
            if (gi.part2_3_length <= bits)
                continue;

            gi.assign(cod_info2);
            gi.part2_3_length = bits;
            gi.region0_count = r01_div[r2 - 2];
            gi.region1_count = r2 - 2 - r01_div[r2 - 2];
            gi.table_select[0] = r0_tbl[r2 - 2];
            gi.table_select[1] = r1_tbl[r2 - 2];
            gi.table_select[2] = r2t;
        }
    }

    this.best_huffman_divide = function (gfc, gi) {
        var cod_info2 = new GrInfo();
        var ix = gi.l3_enc;
        var r01_bits = new_int(7 + 15 + 1);
        var r01_div = new_int(7 + 15 + 1);
        var r0_tbl = new_int(7 + 15 + 1);
        var r1_tbl = new_int(7 + 15 + 1);

        /* SHORT BLOCK stuff fails for MPEG2 */
        if (gi.block_type == Encoder.SHORT_TYPE && gfc.mode_gr == 1)
            return;

        cod_info2.assign(gi);
        if (gi.block_type == Encoder.NORM_TYPE) {
            recalc_divide_init(gfc, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl);
            recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div,
                r0_tbl, r1_tbl);
        }
        var i = cod_info2.big_values;
        if (i == 0 || (ix[i - 2] | ix[i - 1]) > 1)
            return;

        i = gi.count1 + 2;
        if (i > 576)
            return;

        /* Determines the number of bits to encode the quadruples. */
        cod_info2.assign(gi);
        cod_info2.count1 = i;
        var a1 = 0;
        var a2 = 0;

        assert(i <= 576);

        for (; i > cod_info2.big_values; i -= 4) {
            var p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2
                + ix[i - 1];
            a1 += Tables.t32l[p];
            a2 += Tables.t33l[p];
        }
        cod_info2.big_values = i;

        cod_info2.count1table_select = 0;
        if (a1 > a2) {
            a1 = a2;
            cod_info2.count1table_select = 1;
        }

        cod_info2.count1bits = a1;

        if (cod_info2.block_type == Encoder.NORM_TYPE)
            recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div,
                r0_tbl, r1_tbl);
        else {
            /* Count the number of bits necessary to code the bigvalues region. */
            cod_info2.part2_3_length = a1;
            a1 = gfc.scalefac_band.l[7 + 1];
            if (a1 > i) {
                a1 = i;
            }
            if (a1 > 0) {
                var bi = new Bits(cod_info2.part2_3_length);
                cod_info2.table_select[0] = choose_table(ix, 0, a1, bi);
                cod_info2.part2_3_length = bi.bits;
            }
            if (i > a1) {
                var bi = new Bits(cod_info2.part2_3_length);
                cod_info2.table_select[1] = choose_table(ix, a1, i, bi);
                cod_info2.part2_3_length = bi.bits;
            }
            if (gi.part2_3_length > cod_info2.part2_3_length)
                gi.assign(cod_info2);
        }
    }

    var slen1_n = [1, 1, 1, 1, 8, 2, 2, 2, 4, 4, 4, 8, 8, 8, 16, 16];
    var slen2_n = [1, 2, 4, 8, 1, 2, 4, 8, 2, 4, 8, 2, 4, 8, 4, 8];
    var slen1_tab = [0, 0, 0, 0, 3, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4];
    var slen2_tab = [0, 1, 2, 3, 0, 1, 2, 3, 1, 2, 3, 1, 2, 3, 2, 3];
    Takehiro.slen1_tab = slen1_tab;
    Takehiro.slen2_tab = slen2_tab;

    function scfsi_calc(ch, l3_side) {
        var sfb;
        var gi = l3_side.tt[1][ch];
        var g0 = l3_side.tt[0][ch];

        for (var i = 0; i < Tables.scfsi_band.length - 1; i++) {
            for (sfb = Tables.scfsi_band[i]; sfb < Tables.scfsi_band[i + 1]; sfb++) {
                if (g0.scalefac[sfb] != gi.scalefac[sfb]
                    && gi.scalefac[sfb] >= 0)
                    break;
            }
            if (sfb == Tables.scfsi_band[i + 1]) {
                for (sfb = Tables.scfsi_band[i]; sfb < Tables.scfsi_band[i + 1]; sfb++) {
                    gi.scalefac[sfb] = -1;
                }
                l3_side.scfsi[ch][i] = 1;
            }
        }
        var s1 = 0;
        var c1 = 0;
        for (sfb = 0; sfb < 11; sfb++) {
            if (gi.scalefac[sfb] == -1)
                continue;
            c1++;
            if (s1 < gi.scalefac[sfb])
                s1 = gi.scalefac[sfb];
        }
        var s2 = 0;
        var c2 = 0;
        for (; sfb < Encoder.SBPSY_l; sfb++) {
            if (gi.scalefac[sfb] == -1)
                continue;
            c2++;
            if (s2 < gi.scalefac[sfb])
                s2 = gi.scalefac[sfb];
        }

        for (var i = 0; i < 16; i++) {
            if (s1 < slen1_n[i] && s2 < slen2_n[i]) {
                var c = slen1_tab[i] * c1 + slen2_tab[i] * c2;
                if (gi.part2_length > c) {
                    gi.part2_length = c;
                    gi.scalefac_compress = i;
                }
            }
        }
    }

    /**
     * Find the optimal way to store the scalefactors. Only call this routine
     * after final scalefactors have been chosen and the channel/granule will
     * not be re-encoded.
     */
    this.best_scalefac_store = function (gfc, gr, ch, l3_side) {
        /* use scalefac_scale if we can */
        var gi = l3_side.tt[gr][ch];
        var sfb, i, j, l;
        var recalc = 0;

        /*
         * remove scalefacs from bands with ix=0. This idea comes from the AAC
         * ISO docs. added mt 3/00
         */
        /* check if l3_enc=0 */
        j = 0;
        for (sfb = 0; sfb < gi.sfbmax; sfb++) {
            var width = gi.width[sfb];
            assert(width >= 0);
            j += width;
            for (l = -width; l < 0; l++) {
                if (gi.l3_enc[l + j] != 0)
                    break;
            }
            if (l == 0)
                gi.scalefac[sfb] = recalc = -2;
            /* anything goes. */
            /*
             * only best_scalefac_store and calc_scfsi know--and only they
             * should know--about the magic number -2.
             */
        }

        if (0 == gi.scalefac_scale && 0 == gi.preflag) {
            var s = 0;
            for (sfb = 0; sfb < gi.sfbmax; sfb++)
                if (gi.scalefac[sfb] > 0)
                    s |= gi.scalefac[sfb];

            if (0 == (s & 1) && s != 0) {
                for (sfb = 0; sfb < gi.sfbmax; sfb++)
                    if (gi.scalefac[sfb] > 0)
                        gi.scalefac[sfb] >>= 1;

                gi.scalefac_scale = recalc = 1;
            }
        }

        if (0 == gi.preflag && gi.block_type != Encoder.SHORT_TYPE
            && gfc.mode_gr == 2) {
            for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
                if (gi.scalefac[sfb] < qupvt.pretab[sfb]
                    && gi.scalefac[sfb] != -2)
                    break;
            if (sfb == Encoder.SBPSY_l) {
                for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
                    if (gi.scalefac[sfb] > 0)
                        gi.scalefac[sfb] -= qupvt.pretab[sfb];

                gi.preflag = recalc = 1;
            }
        }

        for (i = 0; i < 4; i++)
            l3_side.scfsi[ch][i] = 0;

        if (gfc.mode_gr == 2 && gr == 1
            && l3_side.tt[0][ch].block_type != Encoder.SHORT_TYPE
            && l3_side.tt[1][ch].block_type != Encoder.SHORT_TYPE) {
            scfsi_calc(ch, l3_side);
            recalc = 0;
        }
        for (sfb = 0; sfb < gi.sfbmax; sfb++) {
            if (gi.scalefac[sfb] == -2) {
                gi.scalefac[sfb] = 0;
                /* if anything goes, then 0 is a good choice */
            }
        }
        if (recalc != 0) {
            if (gfc.mode_gr == 2) {
                this.scale_bitcount(gi);
            } else {
                this.scale_bitcount_lsf(gfc, gi);
            }
        }
    }

    function all_scalefactors_not_negative(scalefac, n) {
        for (var i = 0; i < n; ++i) {
            if (scalefac[i] < 0)
                return false;
        }
        return true;
    }

    /**
     * number of bits used to encode scalefacs.
     *
     * 18*slen1_tab[i] + 18*slen2_tab[i]
     */
    var scale_short = [0, 18, 36, 54, 54, 36, 54, 72,
        54, 72, 90, 72, 90, 108, 108, 126];

    /**
     * number of bits used to encode scalefacs.
     *
     * 17*slen1_tab[i] + 18*slen2_tab[i]
     */
    var scale_mixed = [0, 18, 36, 54, 51, 35, 53, 71,
        52, 70, 88, 69, 87, 105, 104, 122];

    /**
     * number of bits used to encode scalefacs.
     *
     * 11*slen1_tab[i] + 10*slen2_tab[i]
     */
    var scale_long = [0, 10, 20, 30, 33, 21, 31, 41, 32, 42,
        52, 43, 53, 63, 64, 74];

    /**
     * Also calculates the number of bits necessary to code the scalefactors.
     */
    this.scale_bitcount = function (cod_info) {
        var k, sfb, max_slen1 = 0, max_slen2 = 0;

        /* maximum values */
        var tab;
        var scalefac = cod_info.scalefac;

        assert(all_scalefactors_not_negative(scalefac, cod_info.sfbmax));

        if (cod_info.block_type == Encoder.SHORT_TYPE) {
            tab = scale_short;
            if (cod_info.mixed_block_flag != 0)
                tab = scale_mixed;
        } else { /* block_type == 1,2,or 3 */
            tab = scale_long;
            if (0 == cod_info.preflag) {
                for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
                    if (scalefac[sfb] < qupvt.pretab[sfb])
                        break;

                if (sfb == Encoder.SBPSY_l) {
                    cod_info.preflag = 1;
                    for (sfb = 11; sfb < Encoder.SBPSY_l; sfb++)
                        scalefac[sfb] -= qupvt.pretab[sfb];
                }
            }
        }

        for (sfb = 0; sfb < cod_info.sfbdivide; sfb++)
            if (max_slen1 < scalefac[sfb])
                max_slen1 = scalefac[sfb];

        for (; sfb < cod_info.sfbmax; sfb++)
            if (max_slen2 < scalefac[sfb])
                max_slen2 = scalefac[sfb];

        /*
         * from Takehiro TOMINAGA <tominaga@isoternet.org> 10/99 loop over *all*
         * posible values of scalefac_compress to find the one which uses the
         * smallest number of bits. ISO would stop at first valid index
         */
        cod_info.part2_length = QuantizePVT.LARGE_BITS;
        for (k = 0; k < 16; k++) {
            if (max_slen1 < slen1_n[k] && max_slen2 < slen2_n[k]
                && cod_info.part2_length > tab[k]) {
                cod_info.part2_length = tab[k];
                cod_info.scalefac_compress = k;
            }
        }
        return cod_info.part2_length == QuantizePVT.LARGE_BITS;
    }

    /**
     * table of largest scalefactor values for MPEG2
     */
    var max_range_sfac_tab = [[15, 15, 7, 7],
        [15, 15, 7, 0], [7, 3, 0, 0], [15, 31, 31, 0],
        [7, 7, 7, 0], [3, 3, 0, 0]];

    /**
     * Also counts the number of bits to encode the scalefacs but for MPEG 2
     * Lower sampling frequencies (24, 22.05 and 16 kHz.)
     *
     * This is reverse-engineered from section 2.4.3.2 of the MPEG2 IS,
     * "Audio Decoding Layer III"
     */
    this.scale_bitcount_lsf = function (gfc, cod_info) {
        var table_number, row_in_table, partition, nr_sfb, window;
        var over;
        var i, sfb;
        var max_sfac = new_int(4);
//var partition_table;
        var scalefac = cod_info.scalefac;

        /*
         * Set partition table. Note that should try to use table one, but do
         * not yet...
         */
        if (cod_info.preflag != 0)
            table_number = 2;
        else
            table_number = 0;

        for (i = 0; i < 4; i++)
            max_sfac[i] = 0;

        if (cod_info.block_type == Encoder.SHORT_TYPE) {
            row_in_table = 1;
            var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
            for (sfb = 0, partition = 0; partition < 4; partition++) {
                nr_sfb = partition_table[partition] / 3;
                for (i = 0; i < nr_sfb; i++, sfb++)
                    for (window = 0; window < 3; window++)
                        if (scalefac[sfb * 3 + window] > max_sfac[partition])
                            max_sfac[partition] = scalefac[sfb * 3 + window];
            }
        } else {
            row_in_table = 0;
            var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
            for (sfb = 0, partition = 0; partition < 4; partition++) {
                nr_sfb = partition_table[partition];
                for (i = 0; i < nr_sfb; i++, sfb++)
                    if (scalefac[sfb] > max_sfac[partition])
                        max_sfac[partition] = scalefac[sfb];
            }
        }

        for (over = false, partition = 0; partition < 4; partition++) {
            if (max_sfac[partition] > max_range_sfac_tab[table_number][partition])
                over = true;
        }
        if (!over) {
            var slen1, slen2, slen3, slen4;

            cod_info.sfb_partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
            for (partition = 0; partition < 4; partition++)
                cod_info.slen[partition] = log2tab[max_sfac[partition]];

            /* set scalefac_compress */
            slen1 = cod_info.slen[0];
            slen2 = cod_info.slen[1];
            slen3 = cod_info.slen[2];
            slen4 = cod_info.slen[3];

            switch (table_number) {
                case 0:
                    cod_info.scalefac_compress = (((slen1 * 5) + slen2) << 4)
                        + (slen3 << 2) + slen4;
                    break;

                case 1:
                    cod_info.scalefac_compress = 400 + (((slen1 * 5) + slen2) << 2)
                        + slen3;
                    break;

                case 2:
                    cod_info.scalefac_compress = 500 + (slen1 * 3) + slen2;
                    break;

                default:
                    System.err.printf("intensity stereo not implemented yet\n");
                    break;
            }
        }
        if (!over) {
            assert(cod_info.sfb_partition_table != null);
            cod_info.part2_length = 0;
            for (partition = 0; partition < 4; partition++)
                cod_info.part2_length += cod_info.slen[partition]
                    * cod_info.sfb_partition_table[partition];
        }
        return over;
    }

    /*
     * Since no bands have been over-amplified, we can set scalefac_compress and
     * slen[] for the formatter
     */
    var log2tab = [0, 1, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4,
        4, 4, 4, 4];

    this.huffman_init = function (gfc) {
        for (var i = 2; i <= 576; i += 2) {
            var scfb_anz = 0, bv_index;
            while (gfc.scalefac_band.l[++scfb_anz] < i)
                ;

            bv_index = subdv_table[scfb_anz][0]; // .region0_count
            while (gfc.scalefac_band.l[bv_index + 1] > i)
                bv_index--;

            if (bv_index < 0) {
                /*
                 * this is an indication that everything is going to be encoded
                 * as region0: bigvalues < region0 < region1 so lets set
                 * region0, region1 to some value larger than bigvalues
                 */
                bv_index = subdv_table[scfb_anz][0]; // .region0_count
            }

            gfc.bv_scf[i - 2] = bv_index;

            bv_index = subdv_table[scfb_anz][1]; // .region1_count
            while (gfc.scalefac_band.l[bv_index + gfc.bv_scf[i - 2] + 2] > i)
                bv_index--;

            if (bv_index < 0) {
                bv_index = subdv_table[scfb_anz][1]; // .region1_count
            }

            gfc.bv_scf[i - 1] = bv_index;
        }
    }
}

module.exports = Takehiro;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *      quantize_pvt source file
 *
 *      Copyright (c) 1999-2002 Takehiro Tominaga
 *      Copyright (c) 2000-2002 Robert Hegemann
 *      Copyright (c) 2001 Naoki Shibata
 *      Copyright (c) 2002-2005 Gabriel Bouvigne
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

/* $Id: QuantizePVT.java,v 1.24 2011/05/24 20:48:06 kenchis Exp $ */
var ScaleFac = __webpack_require__(364);
var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var Encoder = __webpack_require__(35);
var MeanBits = __webpack_require__(366);
var LameInternalFlags = __webpack_require__(148);

QuantizePVT.Q_MAX = (256 + 1);
QuantizePVT.Q_MAX2 = 116;
QuantizePVT.LARGE_BITS = 100000;
QuantizePVT.IXMAX_VAL = 8206;

function QuantizePVT() {

    var tak = null;
    var rv = null;
    var psy = null;

    this.setModules = function (_tk, _rv, _psy) {
        tak = _tk;
        rv = _rv;
        psy = _psy;
    };

    function POW20(x) {
        assert(0 <= (x + QuantizePVT.Q_MAX2) && x < QuantizePVT.Q_MAX);
        return pow20[x + QuantizePVT.Q_MAX2];
    }

    this.IPOW20 = function (x) {
        assert(0 <= x && x < QuantizePVT.Q_MAX);
        return ipow20[x];
    }

    /**
     * smallest such that 1.0+DBL_EPSILON != 1.0
     */
    var DBL_EPSILON = 2.2204460492503131e-016;

    /**
     * ix always <= 8191+15. see count_bits()
     */
    var IXMAX_VAL = QuantizePVT.IXMAX_VAL;

    var PRECALC_SIZE = (IXMAX_VAL + 2);

    var Q_MAX = QuantizePVT.Q_MAX;


    /**
     * <CODE>
     * minimum possible number of
     * -cod_info.global_gain + ((scalefac[] + (cod_info.preflag ? pretab[sfb] : 0))
     * << (cod_info.scalefac_scale + 1)) + cod_info.subblock_gain[cod_info.window[sfb]] * 8;
     *
     * for long block, 0+((15+3)<<2) = 18*4 = 72
     * for short block, 0+(15<<2)+7*8 = 15*4+56 = 116
     * </CODE>
     */
    var Q_MAX2 = QuantizePVT.Q_MAX2;

    var LARGE_BITS = QuantizePVT.LARGE_BITS;


    /**
     * Assuming dynamic range=96dB, this value should be 92
     */
    var NSATHSCALE = 100;

    /**
     * The following table is used to implement the scalefactor partitioning for
     * MPEG2 as described in section 2.4.3.2 of the IS. The indexing corresponds
     * to the way the tables are presented in the IS:
     *
     * [table_number][row_in_table][column of nr_of_sfb]
     */
    this.nr_of_sfb_block = [
        [[6, 5, 5, 5], [9, 9, 9, 9], [6, 9, 9, 9]],
        [[6, 5, 7, 3], [9, 9, 12, 6], [6, 9, 12, 6]],
        [[11, 10, 0, 0], [18, 18, 0, 0], [15, 18, 0, 0]],
        [[7, 7, 7, 0], [12, 12, 12, 0], [6, 15, 12, 0]],
        [[6, 6, 6, 3], [12, 9, 9, 6], [6, 12, 9, 6]],
        [[8, 8, 5, 0], [15, 12, 9, 0], [6, 18, 9, 0]]];

    /**
     * Table B.6: layer3 preemphasis
     */
    var pretab = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1,
        2, 2, 3, 3, 3, 2, 0];
    this.pretab = pretab;

    /**
     * Here are MPEG1 Table B.8 and MPEG2 Table B.1 -- Layer III scalefactor
     * bands. <BR>
     * Index into this using a method such as:<BR>
     * idx = fr_ps.header.sampling_frequency + (fr_ps.header.version * 3)
     */
    this.sfBandIndex = [
        // Table B.2.b: 22.05 kHz
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
                522, 576],
            [0, 4, 8, 12, 18, 24, 32, 42, 56, 74, 100, 132, 174, 192]
            , [0, 0, 0, 0, 0, 0, 0] //  sfb21 pseudo sub bands
            , [0, 0, 0, 0, 0, 0, 0] //  sfb12 pseudo sub bands
        ),
        /* Table B.2.c: 24 kHz */ /* docs: 332. mpg123(broken): 330 */
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 114, 136, 162, 194, 232, 278, 332, 394, 464,
                540, 576],
            [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 136, 180, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* Table B.2.a: 16 kHz */
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
                522, 576],
            [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 134, 174, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* Table B.8.b: 44.1 kHz */
        new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 52, 62, 74, 90, 110, 134, 162, 196, 238, 288, 342, 418,
                576],
            [0, 4, 8, 12, 16, 22, 30, 40, 52, 66, 84, 106, 136, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* Table B.8.c: 48 kHz */
        new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 42, 50, 60, 72, 88, 106, 128, 156, 190, 230, 276, 330, 384,
                576],
            [0, 4, 8, 12, 16, 22, 28, 38, 50, 64, 80, 100, 126, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* Table B.8.a: 32 kHz */
        new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 54, 66, 82, 102, 126, 156, 194, 240, 296, 364, 448, 550,
                576],
            [0, 4, 8, 12, 16, 22, 30, 42, 58, 78, 104, 138, 180, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* MPEG-2.5 11.025 kHz */
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
                522, 576],
            [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3,
                402 / 3, 522 / 3, 576 / 3]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* MPEG-2.5 12 kHz */
        new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
                522, 576],
            [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3,
                402 / 3, 522 / 3, 576 / 3]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* MPEG-2.5 8 kHz */
        new ScaleFac([0, 12, 24, 36, 48, 60, 72, 88, 108, 132, 160, 192, 232, 280, 336, 400, 476, 566, 568, 570,
                572, 574, 576],
            [0 / 3, 24 / 3, 48 / 3, 72 / 3, 108 / 3, 156 / 3, 216 / 3, 288 / 3, 372 / 3, 480 / 3, 486 / 3,
                492 / 3, 498 / 3, 576 / 3]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        )
    ];

    var pow20 = new_float(Q_MAX + Q_MAX2 + 1);
    var ipow20 = new_float(Q_MAX);
    var pow43 = new_float(PRECALC_SIZE);

    var adj43 = new_float(PRECALC_SIZE);
    this.adj43 = adj43;

    /**
     * <PRE>
     * compute the ATH for each scalefactor band cd range: 0..96db
     *
     * Input: 3.3kHz signal 32767 amplitude (3.3kHz is where ATH is smallest =
     * -5db) longblocks: sfb=12 en0/bw=-11db max_en0 = 1.3db shortblocks: sfb=5
     * -9db 0db
     *
     * Input: 1 1 1 1 1 1 1 -1 -1 -1 -1 -1 -1 -1 (repeated) longblocks: amp=1
     * sfb=12 en0/bw=-103 db max_en0 = -92db amp=32767 sfb=12 -12 db -1.4db
     *
     * Input: 1 1 1 1 1 1 1 -1 -1 -1 -1 -1 -1 -1 (repeated) shortblocks: amp=1
     * sfb=5 en0/bw= -99 -86 amp=32767 sfb=5 -9 db 4db
     *
     *
     * MAX energy of largest wave at 3.3kHz = 1db AVE energy of largest wave at
     * 3.3kHz = -11db Let's take AVE: -11db = maximum signal in sfb=12. Dynamic
     * range of CD: 96db. Therefor energy of smallest audible wave in sfb=12 =
     * -11 - 96 = -107db = ATH at 3.3kHz.
     *
     * ATH formula for this wave: -5db. To adjust to LAME scaling, we need ATH =
     * ATH_formula - 103 (db) ATH = ATH * 2.5e-10 (ener)
     * </PRE>
     */
    function ATHmdct(gfp, f) {
        var ath = psy.ATHformula(f, gfp);

        ath -= NSATHSCALE;

        /* modify the MDCT scaling for the ATH and convert to energy */
        ath = Math.pow(10.0, ath / 10.0 + gfp.ATHlower);
        return ath;
    }

    function compute_ath(gfp) {
        var ATH_l = gfp.internal_flags.ATH.l;
        var ATH_psfb21 = gfp.internal_flags.ATH.psfb21;
        var ATH_s = gfp.internal_flags.ATH.s;
        var ATH_psfb12 = gfp.internal_flags.ATH.psfb12;
        var gfc = gfp.internal_flags;
        var samp_freq = gfp.out_samplerate;

        for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
            var start = gfc.scalefac_band.l[sfb];
            var end = gfc.scalefac_band.l[sfb + 1];
            ATH_l[sfb] = Float.MAX_VALUE;
            for (var i = start; i < end; i++) {
                var freq = i * samp_freq / (2 * 576);
                var ATH_f = ATHmdct(gfp, freq);
                /* freq in kHz */
                ATH_l[sfb] = Math.min(ATH_l[sfb], ATH_f);
            }
        }

        for (var sfb = 0; sfb < Encoder.PSFB21; sfb++) {
            var start = gfc.scalefac_band.psfb21[sfb];
            var end = gfc.scalefac_band.psfb21[sfb + 1];
            ATH_psfb21[sfb] = Float.MAX_VALUE;
            for (var i = start; i < end; i++) {
                var freq = i * samp_freq / (2 * 576);
                var ATH_f = ATHmdct(gfp, freq);
                /* freq in kHz */
                ATH_psfb21[sfb] = Math.min(ATH_psfb21[sfb], ATH_f);
            }
        }

        for (var sfb = 0; sfb < Encoder.SBMAX_s; sfb++) {
            var start = gfc.scalefac_band.s[sfb];
            var end = gfc.scalefac_band.s[sfb + 1];
            ATH_s[sfb] = Float.MAX_VALUE;
            for (var i = start; i < end; i++) {
                var freq = i * samp_freq / (2 * 192);
                var ATH_f = ATHmdct(gfp, freq);
                /* freq in kHz */
                ATH_s[sfb] = Math.min(ATH_s[sfb], ATH_f);
            }
            ATH_s[sfb] *= (gfc.scalefac_band.s[sfb + 1] - gfc.scalefac_band.s[sfb]);
        }

        for (var sfb = 0; sfb < Encoder.PSFB12; sfb++) {
            var start = gfc.scalefac_band.psfb12[sfb];
            var end = gfc.scalefac_band.psfb12[sfb + 1];
            ATH_psfb12[sfb] = Float.MAX_VALUE;
            for (var i = start; i < end; i++) {
                var freq = i * samp_freq / (2 * 192);
                var ATH_f = ATHmdct(gfp, freq);
                /* freq in kHz */
                ATH_psfb12[sfb] = Math.min(ATH_psfb12[sfb], ATH_f);
            }
            /* not sure about the following */
            ATH_psfb12[sfb] *= (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12]);
        }

        /*
         * no-ATH mode: reduce ATH to -200 dB
         */
        if (gfp.noATH) {
            for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
                ATH_l[sfb] = 1E-20;
            }
            for (var sfb = 0; sfb < Encoder.PSFB21; sfb++) {
                ATH_psfb21[sfb] = 1E-20;
            }
            for (var sfb = 0; sfb < Encoder.SBMAX_s; sfb++) {
                ATH_s[sfb] = 1E-20;
            }
            for (var sfb = 0; sfb < Encoder.PSFB12; sfb++) {
                ATH_psfb12[sfb] = 1E-20;
            }
        }

        /*
         * work in progress, don't rely on it too much
         */
        gfc.ATH.floor = 10. * Math.log10(ATHmdct(gfp, -1.));
    }

    /**
     * initialization for iteration_loop
     */
    this.iteration_init = function (gfp) {
        var gfc = gfp.internal_flags;
        var l3_side = gfc.l3_side;
        var i;

        if (gfc.iteration_init_init == 0) {
            gfc.iteration_init_init = 1;

            l3_side.main_data_begin = 0;
            compute_ath(gfp);

            pow43[0] = 0.0;
            for (i = 1; i < PRECALC_SIZE; i++)
                pow43[i] = Math.pow(i, 4.0 / 3.0);

            for (i = 0; i < PRECALC_SIZE - 1; i++)
                adj43[i] = ((i + 1) - Math.pow(
                    0.5 * (pow43[i] + pow43[i + 1]), 0.75));
            adj43[i] = 0.5;

            for (i = 0; i < Q_MAX; i++)
                ipow20[i] = Math.pow(2.0, (i - 210) * -0.1875);
            for (i = 0; i <= Q_MAX + Q_MAX2; i++)
                pow20[i] = Math.pow(2.0, (i - 210 - Q_MAX2) * 0.25);

            tak.huffman_init(gfc);

            {
                var bass, alto, treble, sfb21;

                i = (gfp.exp_nspsytune >> 2) & 63;
                if (i >= 32)
                    i -= 64;
                bass = Math.pow(10, i / 4.0 / 10.0);

                i = (gfp.exp_nspsytune >> 8) & 63;
                if (i >= 32)
                    i -= 64;
                alto = Math.pow(10, i / 4.0 / 10.0);

                i = (gfp.exp_nspsytune >> 14) & 63;
                if (i >= 32)
                    i -= 64;
                treble = Math.pow(10, i / 4.0 / 10.0);

                /*
                 * to be compatible with Naoki's original code, the next 6 bits
                 * define only the amount of changing treble for sfb21
                 */
                i = (gfp.exp_nspsytune >> 20) & 63;
                if (i >= 32)
                    i -= 64;
                sfb21 = treble * Math.pow(10, i / 4.0 / 10.0);
                for (i = 0; i < Encoder.SBMAX_l; i++) {
                    var f;
                    if (i <= 6)
                        f = bass;
                    else if (i <= 13)
                        f = alto;
                    else if (i <= 20)
                        f = treble;
                    else
                        f = sfb21;

                    gfc.nsPsy.longfact[i] = f;
                }
                for (i = 0; i < Encoder.SBMAX_s; i++) {
                    var f;
                    if (i <= 5)
                        f = bass;
                    else if (i <= 10)
                        f = alto;
                    else if (i <= 11)
                        f = treble;
                    else
                        f = sfb21;

                    gfc.nsPsy.shortfact[i] = f;
                }
            }
        }
    }

    /**
     * allocate bits among 2 channels based on PE<BR>
     * mt 6/99<BR>
     * bugfixes rh 8/01: often allocated more than the allowed 4095 bits
     */
    this.on_pe = function (gfp, pe,
                           targ_bits, mean_bits, gr, cbr) {
        var gfc = gfp.internal_flags;
        var tbits = 0, bits;
        var add_bits = new_int(2);
        var ch;

        /* allocate targ_bits for granule */
        var mb = new MeanBits(tbits);
        var extra_bits = rv.ResvMaxBits(gfp, mean_bits, mb, cbr);
        tbits = mb.bits;
        /* maximum allowed bits for this granule */
        var max_bits = tbits + extra_bits;
        if (max_bits > LameInternalFlags.MAX_BITS_PER_GRANULE) {
            // hard limit per granule
            max_bits = LameInternalFlags.MAX_BITS_PER_GRANULE;
        }
        for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
            /******************************************************************
             * allocate bits for each channel
             ******************************************************************/
            targ_bits[ch] = Math.min(LameInternalFlags.MAX_BITS_PER_CHANNEL,
                tbits / gfc.channels_out);

            add_bits[ch] = 0 | (targ_bits[ch] * pe[gr][ch] / 700.0 - targ_bits[ch]);

            /* at most increase bits by 1.5*average */
            if (add_bits[ch] > mean_bits * 3 / 4)
                add_bits[ch] = mean_bits * 3 / 4;
            if (add_bits[ch] < 0)
                add_bits[ch] = 0;

            if (add_bits[ch] + targ_bits[ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL)
                add_bits[ch] = Math.max(0,
                    LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[ch]);

            bits += add_bits[ch];
        }
        if (bits > extra_bits) {
            for (ch = 0; ch < gfc.channels_out; ++ch) {
                add_bits[ch] = extra_bits * add_bits[ch] / bits;
            }
        }

        for (ch = 0; ch < gfc.channels_out; ++ch) {
            targ_bits[ch] += add_bits[ch];
            extra_bits -= add_bits[ch];
        }

        for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
            bits += targ_bits[ch];
        }
        if (bits > LameInternalFlags.MAX_BITS_PER_GRANULE) {
            var sum = 0;
            for (ch = 0; ch < gfc.channels_out; ++ch) {
                targ_bits[ch] *= LameInternalFlags.MAX_BITS_PER_GRANULE;
                targ_bits[ch] /= bits;
                sum += targ_bits[ch];
            }
            assert(sum <= LameInternalFlags.MAX_BITS_PER_GRANULE);
        }

        return max_bits;
    }

    this.reduce_side = function (targ_bits, ms_ener_ratio, mean_bits, max_bits) {
        assert(max_bits <= LameInternalFlags.MAX_BITS_PER_GRANULE);
        assert(targ_bits[0] + targ_bits[1] <= LameInternalFlags.MAX_BITS_PER_GRANULE);

        /*
         * ms_ener_ratio = 0: allocate 66/33 mid/side fac=.33 ms_ener_ratio =.5:
         * allocate 50/50 mid/side fac= 0
         */
        /* 75/25 split is fac=.5 */
        var fac = .33 * (.5 - ms_ener_ratio) / .5;
        if (fac < 0)
            fac = 0;
        if (fac > .5)
            fac = .5;

        /* number of bits to move from side channel to mid channel */
        /* move_bits = fac*targ_bits[1]; */
        var move_bits = 0 | (fac * .5 * (targ_bits[0] + targ_bits[1]));

        if (move_bits > LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[0]) {
            move_bits = LameInternalFlags.MAX_BITS_PER_CHANNEL - targ_bits[0];
        }
        if (move_bits < 0)
            move_bits = 0;

        if (targ_bits[1] >= 125) {
            /* dont reduce side channel below 125 bits */
            if (targ_bits[1] - move_bits > 125) {

                /* if mid channel already has 2x more than average, dont bother */
                /* mean_bits = bits per granule (for both channels) */
                if (targ_bits[0] < mean_bits)
                    targ_bits[0] += move_bits;
                targ_bits[1] -= move_bits;
            } else {
                targ_bits[0] += targ_bits[1] - 125;
                targ_bits[1] = 125;
            }
        }

        move_bits = targ_bits[0] + targ_bits[1];
        if (move_bits > max_bits) {
            targ_bits[0] = (max_bits * targ_bits[0]) / move_bits;
            targ_bits[1] = (max_bits * targ_bits[1]) / move_bits;
        }
        assert(targ_bits[0] <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
        assert(targ_bits[1] <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
        assert(targ_bits[0] + targ_bits[1] <= LameInternalFlags.MAX_BITS_PER_GRANULE);
    };

    /**
     *  Robert Hegemann 2001-04-27:
     *  this adjusts the ATH, keeping the original noise floor
     *  affects the higher frequencies more than the lower ones
     */
    this.athAdjust = function (a, x, athFloor) {
        /*
         * work in progress
         */
        var o = 90.30873362;
        var p = 94.82444863;
        var u = Util.FAST_LOG10_X(x, 10.0);
        var v = a * a;
        var w = 0.0;
        u -= athFloor;
        /* undo scaling */
        if (v > 1E-20)
            w = 1. + Util.FAST_LOG10_X(v, 10.0 / o);
        if (w < 0)
            w = 0.;
        u *= w;
        u += athFloor + o - p;
        /* redo scaling */

        return Math.pow(10., 0.1 * u);
    };

    /**
     * Calculate the allowed distortion for each scalefactor band, as determined
     * by the psychoacoustic model. xmin(sb) = ratio(sb) * en(sb) / bw(sb)
     *
     * returns number of sfb's with energy > ATH
     */
    this.calc_xmin = function (gfp, ratio, cod_info, pxmin) {
        var pxminPos = 0;
        var gfc = gfp.internal_flags;
        var gsfb, j = 0, ath_over = 0;
        var ATH = gfc.ATH;
        var xr = cod_info.xr;
        var enable_athaa_fix = (gfp.VBR == VbrMode.vbr_mtrh) ? 1 : 0;
        var masking_lower = gfc.masking_lower;

        if (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) {
            /* was already done in PSY-Model */
            masking_lower = 1.0;
        }

        for (gsfb = 0; gsfb < cod_info.psy_lmax; gsfb++) {
            var en0, xmin;
            var rh1, rh2;
            var width, l;

            if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh)
                xmin = athAdjust(ATH.adjust, ATH.l[gsfb], ATH.floor);
            else
                xmin = ATH.adjust * ATH.l[gsfb];

            width = cod_info.width[gsfb];
            rh1 = xmin / width;
            rh2 = DBL_EPSILON;
            l = width >> 1;
            en0 = 0.0;
            do {
                var xa, xb;
                xa = xr[j] * xr[j];
                en0 += xa;
                rh2 += (xa < rh1) ? xa : rh1;
                j++;
                xb = xr[j] * xr[j];
                en0 += xb;
                rh2 += (xb < rh1) ? xb : rh1;
                j++;
            } while (--l > 0);
            if (en0 > xmin)
                ath_over++;

            if (gsfb == Encoder.SBPSY_l) {
                var x = xmin * gfc.nsPsy.longfact[gsfb];
                if (rh2 < x) {
                    rh2 = x;
                }
            }
            if (enable_athaa_fix != 0) {
                xmin = rh2;
            }
            if (!gfp.ATHonly) {
                var e = ratio.en.l[gsfb];
                if (e > 0.0) {
                    var x;
                    x = en0 * ratio.thm.l[gsfb] * masking_lower / e;
                    if (enable_athaa_fix != 0)
                        x *= gfc.nsPsy.longfact[gsfb];
                    if (xmin < x)
                        xmin = x;
                }
            }
            if (enable_athaa_fix != 0)
                pxmin[pxminPos++] = xmin;
            else
                pxmin[pxminPos++] = xmin * gfc.nsPsy.longfact[gsfb];
        }
        /* end of long block loop */

        /* use this function to determine the highest non-zero coeff */
        var max_nonzero = 575;
        if (cod_info.block_type != Encoder.SHORT_TYPE) {
            // NORM, START or STOP type, but not SHORT
            var k = 576;
            while (k-- != 0 && BitStream.EQ(xr[k], 0)) {
                max_nonzero = k;
            }
        }
        cod_info.max_nonzero_coeff = max_nonzero;

        for (var sfb = cod_info.sfb_smin; gsfb < cod_info.psymax; sfb++, gsfb += 3) {
            var width, b;
            var tmpATH;
            if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh)
                tmpATH = athAdjust(ATH.adjust, ATH.s[sfb], ATH.floor);
            else
                tmpATH = ATH.adjust * ATH.s[sfb];

            width = cod_info.width[gsfb];
            for (b = 0; b < 3; b++) {
                var en0 = 0.0, xmin;
                var rh1, rh2;
                var l = width >> 1;

                rh1 = tmpATH / width;
                rh2 = DBL_EPSILON;
                do {
                    var xa, xb;
                    xa = xr[j] * xr[j];
                    en0 += xa;
                    rh2 += (xa < rh1) ? xa : rh1;
                    j++;
                    xb = xr[j] * xr[j];
                    en0 += xb;
                    rh2 += (xb < rh1) ? xb : rh1;
                    j++;
                } while (--l > 0);
                if (en0 > tmpATH)
                    ath_over++;
                if (sfb == Encoder.SBPSY_s) {
                    var x = tmpATH * gfc.nsPsy.shortfact[sfb];
                    if (rh2 < x) {
                        rh2 = x;
                    }
                }
                if (enable_athaa_fix != 0)
                    xmin = rh2;
                else
                    xmin = tmpATH;

                if (!gfp.ATHonly && !gfp.ATHshort) {
                    var e = ratio.en.s[sfb][b];
                    if (e > 0.0) {
                        var x;
                        x = en0 * ratio.thm.s[sfb][b] * masking_lower / e;
                        if (enable_athaa_fix != 0)
                            x *= gfc.nsPsy.shortfact[sfb];
                        if (xmin < x)
                            xmin = x;
                    }
                }
                if (enable_athaa_fix != 0)
                    pxmin[pxminPos++] = xmin;
                else
                    pxmin[pxminPos++] = xmin * gfc.nsPsy.shortfact[sfb];
            }
            /* b */
            if (gfp.useTemporal) {
                if (pxmin[pxminPos - 3] > pxmin[pxminPos - 3 + 1])
                    pxmin[pxminPos - 3 + 1] += (pxmin[pxminPos - 3] - pxmin[pxminPos - 3 + 1])
                        * gfc.decay;
                if (pxmin[pxminPos - 3 + 1] > pxmin[pxminPos - 3 + 2])
                    pxmin[pxminPos - 3 + 2] += (pxmin[pxminPos - 3 + 1] - pxmin[pxminPos - 3 + 2])
                        * gfc.decay;
            }
        }
        /* end of short block sfb loop */

        return ath_over;
    };

    function StartLine(j) {
        this.s = j;
    }

    this.calc_noise_core = function (cod_info, startline, l, step) {
        var noise = 0;
        var j = startline.s;
        var ix = cod_info.l3_enc;

        if (j > cod_info.count1) {
            while ((l--) != 0) {
                var temp;
                temp = cod_info.xr[j];
                j++;
                noise += temp * temp;
                temp = cod_info.xr[j];
                j++;
                noise += temp * temp;
            }
        } else if (j > cod_info.big_values) {
            var ix01 = new_float(2);
            ix01[0] = 0;
            ix01[1] = step;
            while ((l--) != 0) {
                var temp;
                temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
                j++;
                noise += temp * temp;
                temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
                j++;
                noise += temp * temp;
            }
        } else {
            while ((l--) != 0) {
                var temp;
                temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
                j++;
                noise += temp * temp;
                temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
                j++;
                noise += temp * temp;
            }
        }

        startline.s = j;
        return noise;
    }

    /**
     * <PRE>
     * -oo dB  =>  -1.00
     * - 6 dB  =>  -0.97
     * - 3 dB  =>  -0.80
     * - 2 dB  =>  -0.64
     * - 1 dB  =>  -0.38
     *   0 dB  =>   0.00
     * + 1 dB  =>  +0.49
     * + 2 dB  =>  +1.06
     * + 3 dB  =>  +1.68
     * + 6 dB  =>  +3.69
     * +10 dB  =>  +6.45
     * </PRE>
     */
    this.calc_noise = function (cod_info, l3_xmin, distort, res, prev_noise) {
        var distortPos = 0;
        var l3_xminPos = 0;
        var sfb, l, over = 0;
        var over_noise_db = 0;
        /* 0 dB relative to masking */
        var tot_noise_db = 0;
        /* -200 dB relative to masking */
        var max_noise = -20.0;
        var j = 0;
        var scalefac = cod_info.scalefac;
        var scalefacPos = 0;

        res.over_SSD = 0;

        for (sfb = 0; sfb < cod_info.psymax; sfb++) {
            var s = cod_info.global_gain
                - (((scalefac[scalefacPos++]) + (cod_info.preflag != 0 ? pretab[sfb]
                    : 0)) << (cod_info.scalefac_scale + 1))
                - cod_info.subblock_gain[cod_info.window[sfb]] * 8;
            var noise = 0.0;

            if (prev_noise != null && (prev_noise.step[sfb] == s)) {

                /* use previously computed values */
                noise = prev_noise.noise[sfb];
                j += cod_info.width[sfb];
                distort[distortPos++] = noise / l3_xmin[l3_xminPos++];

                noise = prev_noise.noise_log[sfb];

            } else {
                var step = POW20(s);
                l = cod_info.width[sfb] >> 1;

                if ((j + cod_info.width[sfb]) > cod_info.max_nonzero_coeff) {
                    var usefullsize;
                    usefullsize = cod_info.max_nonzero_coeff - j + 1;

                    if (usefullsize > 0)
                        l = usefullsize >> 1;
                    else
                        l = 0;
                }

                var sl = new StartLine(j);
                noise = this.calc_noise_core(cod_info, sl, l, step);
                j = sl.s;

                if (prev_noise != null) {
                    /* save noise values */
                    prev_noise.step[sfb] = s;
                    prev_noise.noise[sfb] = noise;
                }

                noise = distort[distortPos++] = noise / l3_xmin[l3_xminPos++];

                /* multiplying here is adding in dB, but can overflow */
                noise = Util.FAST_LOG10(Math.max(noise, 1E-20));

                if (prev_noise != null) {
                    /* save noise values */
                    prev_noise.noise_log[sfb] = noise;
                }
            }

            if (prev_noise != null) {
                /* save noise values */
                prev_noise.global_gain = cod_info.global_gain;
            }

            tot_noise_db += noise;

            if (noise > 0.0) {
                var tmp;

                tmp = Math.max(0 | (noise * 10 + .5), 1);
                res.over_SSD += tmp * tmp;

                over++;
                /* multiplying here is adding in dB -but can overflow */
                /* over_noise *= noise; */
                over_noise_db += noise;
            }
            max_noise = Math.max(max_noise, noise);

        }

        res.over_count = over;
        res.tot_noise = tot_noise_db;
        res.over_noise = over_noise_db;
        res.max_noise = max_noise;

        return over;
    }

    /**
     * updates plotting data
     *
     * Mark Taylor 2000-??-??
     *
     * Robert Hegemann: moved noise/distortion calc into it
     */
    this.set_pinfo = function (gfp, cod_info, ratio, gr, ch) {
        var gfc = gfp.internal_flags;
        var sfb, sfb2;
        var l;
        var en0, en1;
        var ifqstep = (cod_info.scalefac_scale == 0) ? .5 : 1.0;
        var scalefac = cod_info.scalefac;

        var l3_xmin = new_float(L3Side.SFBMAX);
        var xfsf = new_float(L3Side.SFBMAX);
        var noise = new CalcNoiseResult();

        calc_xmin(gfp, ratio, cod_info, l3_xmin);
        calc_noise(cod_info, l3_xmin, xfsf, noise, null);

        var j = 0;
        sfb2 = cod_info.sfb_lmax;
        if (cod_info.block_type != Encoder.SHORT_TYPE
            && 0 == cod_info.mixed_block_flag)
            sfb2 = 22;
        for (sfb = 0; sfb < sfb2; sfb++) {
            var start = gfc.scalefac_band.l[sfb];
            var end = gfc.scalefac_band.l[sfb + 1];
            var bw = end - start;
            for (en0 = 0.0; j < end; j++)
                en0 += cod_info.xr[j] * cod_info.xr[j];
            en0 /= bw;
            /* convert to MDCT units */
            /* scaling so it shows up on FFT plot */
            en1 = 1e15;
            gfc.pinfo.en[gr][ch][sfb] = en1 * en0;
            gfc.pinfo.xfsf[gr][ch][sfb] = en1 * l3_xmin[sfb] * xfsf[sfb] / bw;

            if (ratio.en.l[sfb] > 0 && !gfp.ATHonly)
                en0 = en0 / ratio.en.l[sfb];
            else
                en0 = 0.0;

            gfc.pinfo.thr[gr][ch][sfb] = en1
                * Math.max(en0 * ratio.thm.l[sfb], gfc.ATH.l[sfb]);

            /* there is no scalefactor bands >= SBPSY_l */
            gfc.pinfo.LAMEsfb[gr][ch][sfb] = 0;
            if (cod_info.preflag != 0 && sfb >= 11)
                gfc.pinfo.LAMEsfb[gr][ch][sfb] = -ifqstep * pretab[sfb];

            if (sfb < Encoder.SBPSY_l) {
                /* scfsi should be decoded by caller side */
                assert(scalefac[sfb] >= 0);
                gfc.pinfo.LAMEsfb[gr][ch][sfb] -= ifqstep * scalefac[sfb];
            }
        }
        /* for sfb */

        if (cod_info.block_type == Encoder.SHORT_TYPE) {
            sfb2 = sfb;
            for (sfb = cod_info.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
                var start = gfc.scalefac_band.s[sfb];
                var end = gfc.scalefac_band.s[sfb + 1];
                var bw = end - start;
                for (var i = 0; i < 3; i++) {
                    for (en0 = 0.0, l = start; l < end; l++) {
                        en0 += cod_info.xr[j] * cod_info.xr[j];
                        j++;
                    }
                    en0 = Math.max(en0 / bw, 1e-20);
                    /* convert to MDCT units */
                    /* scaling so it shows up on FFT plot */
                    en1 = 1e15;

                    gfc.pinfo.en_s[gr][ch][3 * sfb + i] = en1 * en0;
                    gfc.pinfo.xfsf_s[gr][ch][3 * sfb + i] = en1 * l3_xmin[sfb2]
                        * xfsf[sfb2] / bw;
                    if (ratio.en.s[sfb][i] > 0)
                        en0 = en0 / ratio.en.s[sfb][i];
                    else
                        en0 = 0.0;
                    if (gfp.ATHonly || gfp.ATHshort)
                        en0 = 0;

                    gfc.pinfo.thr_s[gr][ch][3 * sfb + i] = en1
                        * Math.max(en0 * ratio.thm.s[sfb][i],
                            gfc.ATH.s[sfb]);

                    /* there is no scalefactor bands >= SBPSY_s */
                    gfc.pinfo.LAMEsfb_s[gr][ch][3 * sfb + i] = -2.0
                        * cod_info.subblock_gain[i];
                    if (sfb < Encoder.SBPSY_s) {
                        gfc.pinfo.LAMEsfb_s[gr][ch][3 * sfb + i] -= ifqstep
                            * scalefac[sfb2];
                    }
                    sfb2++;
                }
            }
        }
        /* block type short */
        gfc.pinfo.LAMEqss[gr][ch] = cod_info.global_gain;
        gfc.pinfo.LAMEmainbits[gr][ch] = cod_info.part2_3_length
            + cod_info.part2_length;
        gfc.pinfo.LAMEsfbits[gr][ch] = cod_info.part2_length;

        gfc.pinfo.over[gr][ch] = noise.over_count;
        gfc.pinfo.max_noise[gr][ch] = noise.max_noise * 10.0;
        gfc.pinfo.over_noise[gr][ch] = noise.over_noise * 10.0;
        gfc.pinfo.tot_noise[gr][ch] = noise.tot_noise * 10.0;
        gfc.pinfo.over_SSD[gr][ch] = noise.over_SSD;
    }

    /**
     * updates plotting data for a whole frame
     *
     * Robert Hegemann 2000-10-21
     */
    function set_frame_pinfo(gfp, ratio) {
        var gfc = gfp.internal_flags;

        gfc.masking_lower = 1.0;

        /*
         * for every granule and channel patch l3_enc and set info
         */
        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            for (var ch = 0; ch < gfc.channels_out; ch++) {
                var cod_info = gfc.l3_side.tt[gr][ch];
                var scalefac_sav = new_int(L3Side.SFBMAX);
                System.arraycopy(cod_info.scalefac, 0, scalefac_sav, 0,
                    scalefac_sav.length);

                /*
                 * reconstruct the scalefactors in case SCFSI was used
                 */
                if (gr == 1) {
                    var sfb;
                    for (sfb = 0; sfb < cod_info.sfb_lmax; sfb++) {
                        if (cod_info.scalefac[sfb] < 0) /* scfsi */
                            cod_info.scalefac[sfb] = gfc.l3_side.tt[0][ch].scalefac[sfb];
                    }
                }

                set_pinfo(gfp, cod_info, ratio[gr][ch], gr, ch);
                System.arraycopy(scalefac_sav, 0, cod_info.scalefac, 0,
                    scalefac_sav.length);
            }
            /* for ch */
        }
        /* for gr */
    }

}

module.exports = QuantizePVT;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_students_PictureNaming_css__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_students_PictureNaming_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_students_PictureNaming_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DialogBox__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PN1On1Student=function(_Component){_inherits(PN1On1Student,_Component);function PN1On1Student(props){_classCallCheck(this,PN1On1Student);var _this=_possibleConstructorReturn(this,(PN1On1Student.__proto__||Object.getPrototypeOf(PN1On1Student)).call(this,props));_this.openWebSocket=function(){if(_this.state.testId!=null){__WEBPACK_IMPORTED_MODULE_2__Shared_REST__["a" /* default */].getPNManualSession(_this.state.testId).then(function(res){_this.setState({sessionData:res.body});var authToken=localStorage.getItem('token');var socket=new WebSocket(__WEBPACK_IMPORTED_MODULE_5__Shared_Consts__["c" /* MAIN */].API.START_PICTURENAMING_WEBSOCKET+"?token="+authToken+"&testId="+_this.state.testId);socket.addEventListener('open',function(event){_this.setState({websocket:socket});var studentMessage=JSON.stringify({status:true});setTimeout(function(){_this.state.websocket.send(studentMessage);},500);});socket.addEventListener('message',function(event){console.log('Message from server ',event);var pic=JSON.parse(event.data);_this.setState({imageSrc:pic.url,currentIndex:pic.currentIndex});if(pic.url===""){alert("Session has finished.");_this.props.history.goBack();};});}).catch(function(e){console.log("Error",e);_this.setState({modalDialog:true,responseContent:'Invalid assessment.'});setTimeout(function(){_this.setState({modalDialog:false});},2500);});}else{_this.setState({modalDialog:true,responseContent:'Please enter the assessment Id in order to start the session.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);}};_this.state={testId:null,websocket:null,imageSrc:"",modalDialog:false,responseContent:'',currentIndex:0,sessionData:{pn_pictures:[]}};_this.openWebSocket=_this.openWebSocket.bind(_this);_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(PN1On1Student,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_4__Shared_Helpers__["a" /* default */].authorize(this);}},{key:'handleChange',value:function handleChange(evt){this.setState({testId:evt.target.value});}},{key:'render',value:function render(){var _this2=this;var imageNumerical=this.state.sessionData.pn_pictures.map(function(pnPic,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:index<=_this2.state.currentIndex?"item_done":""},(index+1).toString());});var imagesSlideshow=this.state.sessionData.pn_pictures.map(function(pnPic,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:index,hidden:_this2.state.currentIndex!==index||_this2.state.imageSrc==="",src:pnPic.url,alt:'PNPicture'});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this2.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'appContainer picturenaming'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Picture Naming 1-1 Computer Task'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{hidden:this.state.websocket,className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:"input form-control inputStyle1",type:'text',placeholder:"Task ID",onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"handBtn",onClick:this.openWebSocket},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Join')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 tc',style:{minHeight:405+"px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),imagesSlideshow,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list_items',style:{marginTop:25}},imageNumerical))))));}}]);return PN1On1Student;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(PN1On1Student));

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ico_person.60632f62.png";

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/videoInstructionFull.f5b72d43.png";

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Whiteboard.3dbf2b30.png";

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var touchStyles = {
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  WebkitTouchCallout: 'none',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  userSelect: 'none',
  cursor: 'pointer'
};

module.exports = touchStyles;

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAIRlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAA6gAwAEAAAAAQAAAA8AAAAAc6p9SQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAo1JREFUKBVtk9tLFHEUxz8zO3tfXXd1XQ1Xu2hEUUmwFZSED0aU9FKBDwW+RL5U0D+QSI891EtBEEjgQ0QvIl2gejATCxS8FBpoWZGtuqt7v8yt34xEEH2HGeb85nfO+Z3POSPNfpwzMUCSwBQ3hike/0iW0TN5Ms+nkMM+gp3tKGZZpbz0C9M0ccciOKp89rsdwApkSdOprKZYG3iKvL2G4sQiysaTcZJ3XqMX0wR7Owhf6MDdEgWHDLqO5FSoJFKkHr7BxImxpmK4dGTnzgiu4w1IYjE9OMbK9SHyM4vCyUByiY2lCoWFZbLDE8itfqp74zRePYfjxu2BfndTFOVABPVbisriCpUvCZxtUVx1IbKT8yQuDyLFgngP7aDxylnkgBtFL6l497fgb9+FJxZl7cELiuNzbL5tovTpO/mpz2hU8EabiVzswhEOYKo6iiRLmGVNfFQJHjto17QuyOXujZPDIcjIBC7FifR04dvdjFEs2y1QLGgIZ+vSCkWq4nvRNnKsz6XQPCWkpC6yVOMKhzAFLAHfbp1A91eSIGlkCmjpvFjUkOdVpLUSubvvSNwfRv2RRPa67F5vZbR8RShZcZIam2Tj8Sjm1yzhW914WpvYfPae7KNJTNmk7nwn7rZGthxFetnnIf9hwd6kzyxT299D+OQRHDUBFL8X41tWtOsl2kqa+r4zSLOzs6bkcFCYXmJ96BWlkXlCN7sJdcVRwlV2XdaBtGSG4tJPKsur+Pe0bGW0SCWHRymMTBO6doqaE2IWLewChi0xes76Gpy1QYz2NhumfVQjX0JNZ/Ad3Ufw9GGcDRZBMfl/JEqxbRFAcgsXYduOpvgj/LFmqvviuLfVYtn/lbVs9UPoN+AWDtmTqOXZAAAAAElFTkSuQmCC"

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABIUlEQVQoka2Su0tCYRjG/WOiD2kqWvsfoqU+aTm5OTVFBIJUn2fQBoda7AJFJgR2GYwuEFpLEBl+NEQGFXbDCuziOZryaxMX7RgNz/Ly/uB9n+dxaa35i1ztLGdyKRZ3AlzcnDgHo0k/Q9OdBJYlV/nz38HX90fG5/uRSnBwFufp7Zbyt9Ua/LKKTCwMIJUgk0tRrVWd/RiMGUglONbbzs1JZzeQShBJjDZ3NZr0s3e6Wh/aFQtfpA9P0E2h+NAclEogleDu+RKtNYmjWaQSLO1Ots5xbmsMqQRmbIR8Icew2YUR6sYqf7YG71+u8QTddVgqwcq+6aw54XVf/WRvuBe7UnIGluwPjFAPg1MdxA9n2utqOruJueal1hD0v5S8UT97mrD+3sPnSwAAAABJRU5ErkJggg=="

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAIRlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAA6gAwAEAAAAAQAAAA8AAAAAc6p9SQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAo1JREFUKBVtk9tLFHEUxz8zO3tfXXd1XQ1Xu2hEUUmwFZSED0aU9FKBDwW+RL5U0D+QSI891EtBEEjgQ0QvIl2gejATCxS8FBpoWZGtuqt7v8yt34xEEH2HGeb85nfO+Z3POSPNfpwzMUCSwBQ3hike/0iW0TN5Ms+nkMM+gp3tKGZZpbz0C9M0ccciOKp89rsdwApkSdOprKZYG3iKvL2G4sQiysaTcZJ3XqMX0wR7Owhf6MDdEgWHDLqO5FSoJFKkHr7BxImxpmK4dGTnzgiu4w1IYjE9OMbK9SHyM4vCyUByiY2lCoWFZbLDE8itfqp74zRePYfjxu2BfndTFOVABPVbisriCpUvCZxtUVx1IbKT8yQuDyLFgngP7aDxylnkgBtFL6l497fgb9+FJxZl7cELiuNzbL5tovTpO/mpz2hU8EabiVzswhEOYKo6iiRLmGVNfFQJHjto17QuyOXujZPDIcjIBC7FifR04dvdjFEs2y1QLGgIZ+vSCkWq4nvRNnKsz6XQPCWkpC6yVOMKhzAFLAHfbp1A91eSIGlkCmjpvFjUkOdVpLUSubvvSNwfRv2RRPa67F5vZbR8RShZcZIam2Tj8Sjm1yzhW914WpvYfPae7KNJTNmk7nwn7rZGthxFetnnIf9hwd6kzyxT299D+OQRHDUBFL8X41tWtOsl2kqa+r4zSLOzs6bkcFCYXmJ96BWlkXlCN7sJdcVRwlV2XdaBtGSG4tJPKsur+Pe0bGW0SCWHRymMTBO6doqaE2IWLewChi0xes76Gpy1QYz2NhumfVQjX0JNZ/Ad3Ufw9GGcDRZBMfl/JEqxbRFAcgsXYduOpvgj/LFmqvviuLfVYtn/lbVs9UPoN+AWDtmTqOXZAAAAAElFTkSuQmCC"

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAJZlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgExAAIAAAARAAAAWodpAAQAAAABAAAAbAAAAAAAAABIAAAAAQAAAEgAAAABQWRvYmUgSW1hZ2VSZWFkeQAAAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAA6gAwAEAAAAAQAAAA8AAAAABU56igAAAAlwSFlzAAALEwAACxMBAJqcGAAAActpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx4bXA6Q3JlYXRvclRvb2w+QWRvYmUgSW1hZ2VSZWFkeTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KKS7NPQAAAmNJREFUKBWNUktIlFEUPufcf6axxEKKmhmRIrCsKO2xiV60ikqZcZwpiR4rC6IH0TYS3ARhREGUBG5rxhkf0SJcVIvIhQUZZoSkUc0IFSaWMf/jns79c4po09nc+59zvsc590f4z0gvSy6xyD3KwFNN+bou6+HyY6HPxaktiokwxC/iE71fDRcDIPrHL2ZUznpkuix5Oxcd3klf7OlThDQQVOqRtuFmOhqrM60G1AZtZO79S5MrCOichWQILQReTIg4LrVxhzUsoOABi/FONtq0zwAEqIc2tQZschrLQO212XMFlBn+uGG/Ss+MvmopXz3IBD9s1qvmU6DKYW/zwfLasbvfXo/toerDYvq6y1oJ19MgeM2tM50OpiGpUpDxjEIuGj/CzO0LKVQ9re0HkhoE0I3ipP67dt4we4eaC/1Dc/MDGDCsBZUaydjd4VhC7LcHkGqlwQ+XvSEAOpvI556Yuc0I/vBG0YBuyTzNhd6srPyGwzzpMYMnswuoUBmseGZY1sCI7M1fnjn+hLHRE463M8IZyZaZCgEqDdwDATyZeJcrsKj6iqbo25UzG4mfF9BpoQ3Ji3TIY8YENCBPEUeHO2UPNShWfdm5YVmSu8VdZxDVSkd7VwLoXmjI35vtjiTqCfS1Cpq3bVoXn8uSjvtAo5gNN+0A1B1ibCMyX3XZupSazHwqkaYjDdUWW9vlz6iR9gEf2Aa7rHWRRY9l7VtntdNlg77Yku97Lw0l4tKC/ZGm4C35hXRVslJp96X0TSjyTsQ+9Mn97ygpl7KWfylCEANwH7W+Hcv/CzI9ovBb1Xz/BBXgAAgWrcwtAAAAAElFTkSuQmCC"

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABIUlEQVQoka2Su0tCYRjG/WOiD2kqWvsfoqU+aTm5OTVFBIJUn2fQBoda7AJFJgR2GYwuEFpLEBl+NEQGFXbDCuziOZryaxMX7RgNz/Ly/uB9n+dxaa35i1ztLGdyKRZ3AlzcnDgHo0k/Q9OdBJYlV/nz38HX90fG5/uRSnBwFufp7Zbyt9Ua/LKKTCwMIJUgk0tRrVWd/RiMGUglONbbzs1JZzeQShBJjDZ3NZr0s3e6Wh/aFQtfpA9P0E2h+NAclEogleDu+RKtNYmjWaQSLO1Ots5xbmsMqQRmbIR8Icew2YUR6sYqf7YG71+u8QTddVgqwcq+6aw54XVf/WRvuBe7UnIGluwPjFAPg1MdxA9n2utqOruJueal1hD0v5S8UT97mrD+3sPnSwAAAABJRU5ErkJggg=="

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAMAAADjyg5GAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiYmI1NDk1Ni03ZWIxLTRkYjMtYTIzOC01ZTcyMWMzMTU3MWYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTEwMDA2RkU5MThGMTFFQjgwNjdGMzhGM0MzNjI2MDciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTEwMDA2RkQ5MThGMTFFQjgwNjdGMzhGM0MzNjI2MDciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxMTQxMjU2RjQ0OTgxMUU4OEY1N0VEMkZDNTM3NUQ5QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxMTQxMjU3MDQ0OTgxMUU4OEY1N0VEMkZDNTM3NUQ5QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PupMBdgAAACNUExURVqGKYemYs/cwZu2fVyHK3icUOju4fn794amYWOMNNvk0J63gOvx5vj697zOqIenY6i/jbrMpcLSr+Lp2fX38WqRPdXgyZaxdvj69vz9/GGLMoCiWYyranqdUu3y51iEJpGucK7DleTr3MTTsmGLMZ+5gsLSsKO7h+Xs3fb48/39/FeDJPf59FmFJ////4BRH0UAAAAvdFJOU/////////////////////////////////////////////////////////////8AWqU49wAAAGxJREFUeNpi0EMBDEhsJm4xJC6zvDQXnCvHqsvHxg7jisjqMkki9HLoKiMZJaSrADWZWVBPj1eUgQfK1dUV1lPUVYXZK67LqMSiogPjajDoMuqqI1wlo6vLKYHgakppCyC7WY1fC5sXgAAgwAA6kyDHxmRBoQAAAABJRU5ErkJggg=="

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistoid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(77);


// @TODO remove once flow < 0.63 support is no longer required.

function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var serialize = config.serialize === false ? function (x) {
    return x;
  } : defaultSerialize;

  // initialize stateful values
  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
      if (lastState[key] === state[key]) return; // value unchanged? noop
      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
      keysToProcess.push(key); // add key to queue
    });

    //if any key is missing in the new state which was present in the lastState,
    //add it for processing too
    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined) {
        keysToProcess.push(key);
      }
    });

    // start the time iterator if not running (read: throttle)
    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });

    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (err && "production" !== 'production') {
      console.error('Error storing data', err);
    }
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }
    return writePromise || Promise.resolve();
  };

  // return `persistoid`
  return {
    update: update,
    flush: flush
  };
}

// @NOTE in the future this may be exposed via config
function defaultSerialize(data) {
  return JSON.stringify(data);
}

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(77);




function getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var debug = config.debug;
  var deserialize = config.serialize === false ? function (x) {
    return x;
  } : defaultDeserialize;
  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) console.log('redux-persist/getStoredState: Error restoring data ' + serialized, err);
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(77);




function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {
    console.error('redux-persist/purgeStoredState: Error purging data stored state', err);
  }
}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(397);
module.exports = __webpack_require__(402);


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(398).enable();
  window.Promise = __webpack_require__(400);
}

// fetch() polyfill for making API calls.
__webpack_require__(401);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(56);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(210);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(210);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 401 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_apps_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_apps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_apps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__registerServiceWorker__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(10);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */],null)),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_8__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(56),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(56),r=__webpack_require__(405);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(406);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_idle_timer__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_css__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoginComponent_Login__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AboutComponent_About__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MainComponent_Main__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TeachersComponent_Main__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ResourcesComponent_Resources__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TeachersComponent_Students__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AdminComponent_Admin__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AdminComponent_SchoolAdmin__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AdminComponent_SchoolManagement__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ParentComponent_Parent__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ContentComponent_Content__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ContentComponent_KidSpeak__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ContentComponent_MazeContent__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ContentComponent_MazeCreator__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__StudentsComponent_Main__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__StudentsComponent_PictureNaming__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__StudentsComponent_WordSignSay__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__StudentsComponent_PN1On1Student__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__TeachersComponent_PN1On1Teacher__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__TeachersComponent_PNManual__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__TeachersComponent_PNGrading__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__StudentsComponent_KidSpeak__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__TeachersComponent_KSGrading_KSGrading__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__StudentsComponent_Maze1__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__StudentsComponent_SlashTest__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__StudentsComponent_WordMark__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__StudentsComponent_WordMark2__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__StudentsComponent_CopyRight__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__TeachersComponent_CRGrading_CRGrading__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__TeachersComponent_WSSGrading_WSSGrading__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__StudentsComponent_KidSign__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__TeachersComponent_KidSignGrading_KidSignGrading__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__NeedsAssessmentComponent_NeedsAssessment__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__StudentsComponent_Animals__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__RequestAccountComponent_RequestAccount__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__HelpComponent_Help__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__TeachersComponent_WordMarkGrading__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__TeachersComponent_WordMark2Grading__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Shared_configureStore__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_redux_persist_integration_react__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Shared_REST__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var idleDuration=60*40;var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.setUser=function(user){_this.setState({user:user});};_this.handleStudentClick=function(student,classId){_this.setState({student:student,classId:classId});};_this.handleAddStudent=function(classId){_this.setState({classId:classId});};var _configureStore=Object(__WEBPACK_IMPORTED_MODULE_44__Shared_configureStore__["a" /* default */])(),store=_configureStore.store,persistor=_configureStore.persistor;_this.state={user:{},student:{},classId:0,store:store,persistor:persistor,timeout:1000*idleDuration,modalDialog:false,responseContent:'',userLoggedIn:false,isTimedOut:false};_this.idleTimer=null;_this.onAction=_this._onAction.bind(_this);_this.onActive=_this._onActive.bind(_this);_this.onIdle=_this._onIdle.bind(_this);return _this;}_createClass(App,[{key:'_onAction',value:function _onAction(e){//console.log('user did something', e)
this.setState({isTimedOut:false});}},{key:'_onActive',value:function _onActive(e){//console.log('user is active', e);
this.setState({isTimedOut:false});}},{key:'_onIdle',value:function _onIdle(e){var _this2=this;console.log('user is idle',e);var isTimedOut=this.state.isTimedOut;if(isTimedOut){__WEBPACK_IMPORTED_MODULE_47__Shared_REST__["a" /* default */].logout().then(function(response){localStorage.removeItem('token');_this2.setState({modalDialog:false});window.location.reload();},function(error){localStorage.removeItem('token');localStorage.clear();_this2.props.history.push("/login");});}else{if(window.location.pathname!=='/login'&&window.location.pathname!=='/resources'&&window.location.pathname!=='/request-account'&&window.location.pathname!=='/help'){this.setState({modalDialog:true,responseContent:'AvenuePM has not been used for 40 minutes. Your session will soon end automatically.'});this.idleTimer.reset();this.setState({isTimedOut:true});}}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46_react_redux__["a" /* Provider */],{store:this.state.store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45_redux_persist_integration_react__["a" /* PersistGate */],{persistor:this.state.persistor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_idle_timer__["a" /* default */],{ref:function ref(_ref){_this3.idleTimer=_ref;},element:document,onActive:this.onActive,onIdle:this.onIdle,onAction:this.onAction,debounce:250,timeout:this.state.timeout}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this3.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MainComponent_Main__["a" /* default */],Object.assign({persistor:_this3.state.persistor},props,{userCallback:_this3.setUser}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/login',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LoginComponent_Login__["a" /* default */],Object.assign({},props,{callback:_this3.setUser}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/about',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AboutComponent_About__["a" /* default */],Object.assign({},props,{callback:_this3.setUser}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/resources',exact:true,component:__WEBPACK_IMPORTED_MODULE_9__ResourcesComponent_Resources__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/request-account',exact:true,component:__WEBPACK_IMPORTED_MODULE_40__RequestAccountComponent_RequestAccount__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/help',exact:true,component:__WEBPACK_IMPORTED_MODULE_41__HelpComponent_Help__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TeachersComponent_Main__["a" /* default */],Object.assign({persistor:_this3.state.persistor,strict:true},props,{handleAddStudent:_this3.handleAddStudent,handleStudentClick:_this3.handleStudentClick,callback:_this3.setUser,user:_this3.state.user}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TeachersComponent_Students__["a" /* default */],Object.assign({},props,{edit:true,student:_this3.state.student,classId:_this3.state.classId}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/add-student',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TeachersComponent_Students__["a" /* default */],Object.assign({},props,{edit:false,classId:_this3.state.classId}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/maze',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:1,student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/slashtest',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:2,student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/wordmark',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:3,student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/kidspeak',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:4,student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/picturenaming/manual',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:5,PNModel:"manual",student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/picturenaming/1On1',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:5,PNModel:"1On1",student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/picturenaming/computer',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:5,PNModel:"computer",student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/copyright',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:6,student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/wordsignsay',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:7,student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/kidsign',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:8,student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/student/data/wordmark2',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TeachersComponent_StudentData__["a" /* default */],{type:9,student:_this3.state.student});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__StudentsComponent_Main__["a" /* default */],Object.assign({persistor:_this3.state.persistor,role:"student"},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/parent',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ParentComponent_Parent__["a" /* default */],Object.assign({persistor:_this3.state.persistor},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/apps/picturenaming',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__StudentsComponent_PictureNaming__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/apps/copyright',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__StudentsComponent_CopyRight__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/apps/kidsign',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__StudentsComponent_KidSign__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/apps/wordsignsay',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__StudentsComponent_WordSignSay__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/apps/pn-1-1',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StudentsComponent_PN1On1Student__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/apps/kidspeak',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__StudentsComponent_KidSpeak__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/apps/pn-1-1',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__TeachersComponent_PN1On1Teacher__["a" /* default */],Object.assign({persistor:_this3.state.persistor},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/apps/pn-manual',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__TeachersComponent_PNManual__["a" /* default */],Object.assign({persistor:_this3.state.persistor},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/apps/pn-grading',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__TeachersComponent_PNGrading__["a" /* default */],Object.assign({persistor:_this3.state.persistor,user:_this3.state.user},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/apps/ks-grading',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__TeachersComponent_KSGrading_KSGrading__["a" /* default */],Object.assign({persistor:_this3.state.persistor,user:_this3.state.user},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/apps/wm-grading',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__TeachersComponent_WordMarkGrading__["a" /* default */],Object.assign({persistor:_this3.state.persistor,user:_this3.state.user},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/apps/wm2-grading',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__TeachersComponent_WordMark2Grading__["a" /* default */],Object.assign({persistor:_this3.state.persistor,user:_this3.state.user},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/apps/cr-grading',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__TeachersComponent_CRGrading_CRGrading__["a" /* default */],Object.assign({persistor:_this3.state.persistor,user:_this3.state.user},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/apps/wss-grading',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__TeachersComponent_WSSGrading_WSSGrading__["a" /* default */],Object.assign({persistor:_this3.state.persistor,user:_this3.state.user},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/teacher/apps/kss-grading',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__TeachersComponent_KidSignGrading_KidSignGrading__["a" /* default */],Object.assign({persistor:_this3.state.persistor,user:_this3.state.user},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/tasks/maze',exact:true,component:__WEBPACK_IMPORTED_MODULE_29__StudentsComponent_Maze1__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/tasks/slashtest',exact:true,component:__WEBPACK_IMPORTED_MODULE_30__StudentsComponent_SlashTest__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/tasks/wordmark',exact:true,component:__WEBPACK_IMPORTED_MODULE_31__StudentsComponent_WordMark__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/student/tasks/wordmark2',exact:true,component:__WEBPACK_IMPORTED_MODULE_32__StudentsComponent_WordMark2__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/admin',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AdminComponent_Admin__["a" /* default */],Object.assign({},props,{user:_this3.state.user}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/school-admin',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__AdminComponent_SchoolAdmin__["a" /* default */],Object.assign({persistor:_this3.state.persistor,strict:true},props,{handleAddStudent:_this3.handleAddStudent,handleStudentClick:_this3.handleStudentClick,callback:_this3.setUser,user:_this3.state.user}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/content',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ContentComponent_Content__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/content/maze-creator',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ContentComponent_MazeCreator__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/school-management',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AdminComponent_SchoolManagement__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/content/kidspeak',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ContentComponent_KidSpeak__["a" /* default */],Object.assign({persistor:_this3.state.persistor},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/content/maze',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ContentComponent_MazeContent__["a" /* default */],Object.assign({persistor:_this3.state.persistor},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/needs-assessment',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__NeedsAssessmentComponent_NeedsAssessment__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:'/animals',exact:true,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__StudentsComponent_Animals__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{component:NoMatch})))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var NoMatch=function NoMatch(_ref2){var location=_ref2.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'No match for ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code',null,location.pathname)));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(App));

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(154);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(94);
var invariant = __webpack_require__(57);
var ReactPropTypesSecret = __webpack_require__(211);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(32);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(152);

var _PathUtils = __webpack_require__(95);

var _createTransitionManager = __webpack_require__(153);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(154);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(32);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(152);

var _PathUtils = __webpack_require__(95);

var _createTransitionManager = __webpack_require__(153);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(418);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(155);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(95);

var _LocationUtils = __webpack_require__(152);

var _createTransitionManager = __webpack_require__(153);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(215);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(422)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(424);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(426);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(427);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(428);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(429);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(430);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(96);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(218);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(218);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(157);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(432);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(155);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(434);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(156);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(156);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(437);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(217);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useIdleTimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_slicedToArray__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_typeof__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_typeof__);
var f="object"===("undefined"==typeof window||"undefined"==typeof window?"undefined":__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_typeof___default()(window)),v=f?document:{},g=["mousemove","keydown","wheel","DOMMouseScroll","mousewheel","mousedown","touchstart","touchmove","MSPointerDown","MSPointerMove","visibilitychange"];function b(e,t){var n;function r(){for(var r=arguments.length,i=new Array(r),s=0;s<r;s++)i[s]=arguments[s];n&&clearTimeout(n),n=setTimeout((function(){e.apply(void 0,i),n=null}),t)}return r.cancel=function(){clearTimeout(n)},r}function T(e,t){var n=0;return function(){var r=(new Date).getTime();if(!(r-n<t))return n=r,e.apply(void 0,arguments)}}var _=0,y=0;function w(){var e=(new Date).getTime();return e===_?1e3*e+ ++y:(_=e,y=0,1e3*e)}function k(){return Math.random().toString(36).substring(2)}function A(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return new Promise((function(t){return setTimeout(t,e)}))}function I(){return(new Date).getTime()}var E={create:function(e){var t={messagesCallback:null,bc:new BroadcastChannel(e)};return t.bc.onmessage=function(e){t.messagesCallback&&t.messagesCallback(e.data)},t},close:function(e){e.bc.close()},onMessage:function(e,t){e.messagesCallback=t},postMessage:function(e,t){try{return e.bc.postMessage(t,!1),Promise.resolve()}catch(e){return Promise.reject(e)}},canBeUsed:function(){return"function"==typeof BroadcastChannel},type:"broadcastChannel",averageResponseTime:function(){return 150},microSeconds:w},L=function(){function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:6e4;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,n),this.ttl=t,this.set=new Set,this.timeMap=new Map}return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(n,[{key:"has",value:function(e){return this.set.has(e)}},{key:"add",value:function(e){this.timeMap.set(e,I()),this.set.add(e),this._removeTooOldValues()}},{key:"clear",value:function(){this.set.clear(),this.timeMap.clear()}},{key:"_removeTooOldValues",value:function(){for(var e=I()-this.ttl,t=this.set[Symbol.iterator]();;){var n=t.next().value;if(!n)return;if(!(this.timeMap.get(n)<e))return;this.timeMap.delete(n),this.set.delete(n)}}}]),n}();function O(){var e;if("undefined"==typeof window)return null;try{e=window.localStorage,e=window["ie8-eventlistener/storage"]||window.localStorage}catch(e){}return e}function M(e,t){var n=e,r=function(e){e.key===n&&t(JSON.parse(e.newValue))};return window.addEventListener("storage",r),r}function D(){var e=O();if(!e)return!1;try{var t="__check";e.setItem(t,"works"),e.removeItem(t)}catch(e){return!1}return!0}var S={create:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!D())throw new Error("❌ localStorage cannot be used.");var n=k(),r=new L(t.removeTimeout),i={channelName:e,uuid:n,eMIs:r};return i.listener=M(e,(function(e){i.messagesCallback&&e.uuid!==n&&e.token&&!r.has(e.token)&&(e.data.time&&e.data.time<i.messagesCallbackTime||(r.add(e.token),i.messagesCallback(e.data)))})),i},close:function(e){var t;t=e.listener,window.removeEventListener("storage",t)},onMessage:function(e,t,n){e.messagesCallbackTime=n,e.messagesCallback=t},postMessage:function(e,t){return new Promise((function(n){var r=e.channelName,i={token:k(),time:(new Date).getTime(),data:t,uuid:e.uuid},s=JSON.stringify(i);O().setItem(r,s);var a=document.createEvent("Event");a.initEvent("storage",!0,!0),a.key=r,a.newValue=s,window.dispatchEvent(a),n()}))},canBeUsed:D,type:"localStorage",averageResponseTime:function(){var e=navigator.userAgent.toLowerCase();return e.includes("safari")&&!e.includes("chrome")?240:120},microSeconds:w},P=new Set;var C={create:function(e){var t={name:e,messagesCallback:null};return P.add(t),t},close:function(e){P.delete(e)},onMessage:function(e,t){e.messagesCallback=t},postMessage:function(e,t){return new Promise((function(n){return setTimeout((function(){Array.from(P).filter((function(t){return t.name===e.name})).filter((function(t){return t!==e})).filter((function(e){return!!e.messagesCallback})).forEach((function(e){return e.messagesCallback(t)})),n()}),5)}))},canBeUsed:function(){return!0},type:"simulate",averageResponseTime:function(){return 5},microSeconds:w},x=[E,S];function B(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(e.type){if("simulate"===e.type)return C;var t=x.find((function(t){return t.type===e.type}));if(t)return t;throw new Error("❌ Method ".concat(e.type," is not supported."))}var n=x.find((function(e){return e.canBeUsed()}));if(!n)throw new Error("❌ No method found ".concat(JSON.stringify(x.map((function(e){return e.type})))));return n}var R=function(){function n(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,n),this.name=t,this.options=r,this.method=B(this.options),this.closed=!1,this._isListening=!1,this._onMessageListener=null,this._addEventListeners={message:[],internal:[]},this._unSendMessagePromises=new Set,this._beforeClose=[],this._preparePromises=null,j(this)}return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(n,[{key:"postMessage",value:function(e){if(this.closed)throw new Error("❌ Cannot post message after channel has closed");return N(this,"message",e)}},{key:"postInternal",value:function(e){return N(this,"internal",e)}},{key:"onmessage",get:function(){return this._onMessageListener},set:function(e){var t={time:this.method.microSeconds(),fn:e};U(this,"message",this._onMessageListener),e&&"function"==typeof e?(this._onMessageListener=t,Y(this,"message",t)):this._onMessageListener=null}},{key:"addEventListener",value:function(e,t){Y(this,e,{time:this.method.microSeconds(),fn:t})}},{key:"removeEventListener",value:function(e,t){U(this,e,this._addEventListeners[e].find((function(e){return e.fn===t})))}},{key:"close",value:function(){var e=this;if(!this.closed){this.closed=!0;var t=this._preparePromises?this._preparePromises:Promise.resolve();return this._onMessageListener=null,this._addEventListeners.message=[],t.then((function(){return Promise.all(Array.from(e._unSendMessagePromises))})).then((function(){return Promise.all(e._beforeClose.map((function(e){return e()})))})).then((function(){return e.method.close(e._state)}))}}},{key:"type",get:function(){return this.method.type}},{key:"isClosed",value:function(){return this.closed}}]),n}();function N(e,t,n){var r={time:e.method.microSeconds(),type:t,data:n};return(e._preparePromises?e._preparePromises:Promise.resolve()).then((function(){var t=e.method.postMessage(e._state,r);return e._unSendMessagePromises.add(t),t.catch().then((function(){return e._unSendMessagePromises.delete(t)})),t}))}function j(e){var t,n=e.method.create(e.name,e.options);(t=n)&&"function"==typeof t.then?(e._preparePromises=n,n.then((function(t){e._state=t}))):e._state=n}function X(e){return e._addEventListeners.message.length>0||e._addEventListeners.internal.length>0}function Y(e,t,n){e._addEventListeners[t].push(n),function(e){if(!e._isListening&&X(e)){var t=function(t){e._addEventListeners[t.type].forEach((function(e){t.time>=e.time&&e.fn(t.data)}))},n=e.method.microSeconds();e._preparePromises?e._preparePromises.then((function(){e._isListening=!0,e.method.onMessage(e._state,t,n)})):(e._isListening=!0,e.method.onMessage(e._state,t,n))}}(e)}function U(e,t,n){e._addEventListeners[t]=e._addEventListeners[t].filter((function(e){return e!==n})),function(e){if(e._isListening&&!X(e)){e._isListening=!1;var t=e.method.microSeconds();e.method.onMessage(e._state,null,t)}}(e)}var F=function(){function n(t,r){var i=this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,n),this._channel=t,this._options=r,this.isLeader=!1,this.isDead=!1,this.token=k(),this._isApplying=!1,this._reApply=!1,this._unloadFns=[],this._listeners=[],this._intervals=[],this._duplicateListeners=function(){},this._duplicateCalled=!1,this._onBeforeDie=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:case"end":return e.stop()}}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default.a)})));var s=function(){var e=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",i.die());case 1:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}();f&&(window.addEventListener("beforeUnload",s),window.addEventListener("unload",s),this._unloadFns.push(["beforeUnload",s]),this._unloadFns.push(["unload",s]))}var r;return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(n,[{key:"applyOnce",value:function(){var e=this;if(this.isLeader)return Promise.resolve(!1);if(this.isDead)return Promise.resolve(!1);if(this._isApplying)return this._reApply=!0,Promise.resolve(!1);this._isApplying=!0;var t=!1,n=function(n){"leader"===n.context&&n.token!==e.token&&("apply"===n.action&&n.token>e.token&&(t=!0),"tell"===n.action&&(t=!0))};return this._channel.addEventListener("internal",n),V(this,"apply").then((function(){return A(e._options.responseTime)})).then((function(){return t?Promise.reject(new Error):V(e,"apply")})).then((function(){return A(e._options.responseTime)})).then((function(){return t?Promise.reject(new Error):V(e)})).then((function(){return function(e){e.isLeader=!0;var t=function(t){"leader"===t.context&&"apply"===t.action&&V(e,"tell"),"leader"!==t.context||"tell"!==t.action||e._duplicateCalled||(e._duplicateCalled=!0,e._duplicateListeners(),V(e,"tell"))};return e._channel.addEventListener("internal",t),e._listeners.push(t),V(e,"tell")}(e)})).then((function(){return!0})).catch((function(){return!1})).then((function(t){return e._channel.removeEventListener("internal",n),e._isApplying=!1,!t&&e._reApply?(e._reApply=!1,e.applyOnce()):t}))}},{key:"awaitLeadership",value:function(){var e;return this._awaitLeadershipPromise||(this._awaitLeadershipPromise=(e=this).isLeader?Promise.resolve():new Promise((function(t){var n=!1;function r(){n||(n=!0,clearInterval(i),e._channel.removeEventListener("internal",s),t(!0))}e.applyOnce().then((function(){e.isLeader&&r()}));var i=setInterval((function(){e.applyOnce().then((function(){e.isLeader&&r()}))}),e._options.fallbackInterval);e._intervals.push(i);var s=function(t){"leader"===t.context&&"death"===t.action&&e.applyOnce().then((function(){e.isLeader&&r()}))};e._channel.addEventListener("internal",s),e._listeners.push(s)}))),this._awaitLeadershipPromise}},{key:"onDuplicate",get:function(){return this._duplicateListeners},set:function(e){this._duplicateListeners=e}},{key:"onBeforeDie",get:function(){return this._onBeforeDie},set:function(e){this._onBeforeDie=e}},{key:"die",value:(r=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(){var t=this;return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.isDead){e.next=2;break}return e.abrupt("return");case 2:return this.isDead=!0,e.next=5,this.onBeforeDie();case 5:return this._listeners.forEach((function(e){return t._channel.removeEventListener("internal",e)})),this._intervals.forEach((function(e){return clearInterval(e)})),this._unloadFns.forEach((function(e){f&&window.removeEventListener(e[0],e[1])})),e.abrupt("return",V(this,"death"));case 9:case"end":return e.stop()}}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default.a,this)}))),function(){return r.apply(this,arguments)})}]),n}();function V(e,t){var n={context:"leader",action:t,token:e.token};return e._channel.postInternal(n)}var J=function(e){var t=e.type,n=e.channelName,r=e.fallbackInterval,i=e.responseTime,s=e.emitOnAllTabs,a=e.callbacks,o=e.start,u=e.reset,c=e.pause,l=e.resume,p=new R(n,{type:t}),f=function(e,t){if(e._leaderElector)throw new Error("❌ MessageChannel already has a leader-elector");var n=new F(e,t);return e._beforeClose.push(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",n.die());case 1:case"end":return e.stop()}}),e)})))),e._leaderElector=n,n}(p,{fallbackInterval:r,responseTime:i}),v={};v[f.token]=!1;var g=!1,b=!0,T=function(){return g};f.awaitLeadership().then((function(){g=!0})),p.addEventListener("message",(function(e){var t=__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_slicedToArray___default()(e,2),n=t[0],r=t[1];switch(n){case"register":v[r]=!1;break;case"deregister":delete v[r];break;case"idle":_(r);break;case"active":y(r);break;case"emitIdle":a.onIdle();break;case"emitActive":a.onActive();break;case"start":o(!0);break;case"reset":u(!0);break;case"pause":c(!0);break;case"resume":l(!0)}}));var _=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f.token;v[e]=!0;var t=Object.values(v).every((function(e){return e}));!b&&t&&(b=!0,T()?(a.onIdle(),s&&w("emitIdle")):w("idle"))},y=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f.token;v[e]=!1;var t=Object.values(v).some((function(e){return!e}));b&&t&&(b=!1,T()?(a.onActive(),s&&w("emitActive")):w("active"))};f.onDuplicate=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,f.die();case 2:return e.abrupt("return",e.sent);case 3:case"end":return e.stop()}}),e)}))),f.onBeforeDie=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,w("deregister");case 2:return e.abrupt("return",e.sent);case 3:case"end":return e.stop()}}),e)})));var w=function(){var e=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(t){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",p.postMessage([t,f.token]));case 1:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}(),k=function(){var e=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,f.die();case 2:return e.next=4,p.close();case 4:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}();return w("register"),{close:k,send:w,isLeader:T,idle:_,active:y,isAllIdle:function(){return b},setAllIdle:function(e){b=e}}};function z(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(e);if(t){var a=__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(this).constructor;n=Reflect.construct(r,arguments,a)}else n=r.apply(this,arguments);return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this,n)}}var G=function(i){__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default()(o,__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var s=z(o);function o(t){var r;if(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,o),(r=s.call(this,t)).state={idle:!1,oldDate:+new Date,lastActive:+new Date,lastIdle:null,idleTime:0,remaining:null,pageX:null,pageY:null},r.tId=null,r.eventsBound=!1,r.callbackRefs={},t.debounce>0&&t.throttle>0)throw new Error("onAction can either be throttled or debounced (not both)");return t.debounce>0?r._onAction=b(t.onAction,t.debounce):t.throttle>0?r._onAction=T(t.onAction,t.throttle):r._onAction=t.onAction,t.eventsThrottle>0?r.handleEvent=T(r._handleEvent.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),t.eventsThrottle):r.handleEvent=r._handleEvent.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),t.startOnMount&&!t.startManually||(r.state.idle=!0),r._toggleIdleState=r._toggleIdleState.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.start=r.start.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.reset=r.reset.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.pause=r.pause.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.resume=r.resume.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.isIdle=r.isIdle.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.getRemainingTime=r.getRemainingTime.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.getElapsedTime=r.getElapsedTime.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.getLastActiveTime=r.getLastActiveTime.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.getLastIdleTime=r.getLastIdleTime.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.getTotalIdleTime=r.getTotalIdleTime.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r.getTotalActiveTime=r.getTotalActiveTime.bind(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(r)),r}return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(o,[{key:"componentDidMount",value:function(){var e=this.props,t=e.startOnMount,n=e.startManually;this._setupTabManager(),n||(t?this.start():this._bindEvents())}},{key:"componentDidUpdate",value:function(e){e.debounce!==this.props.debounce&&this.props.debounce>0?(this._onAction.cancel&&this._onAction.cancel(),this._onAction=b(this.props.onAction,this.props.debounce)):e.throttle!==this.props.throttle&&this.props.throttle>0?(this._onAction.cancel&&this._onAction.cancel(),this._onAction=T(this.props.onAction,this.props.throttle)):(e.throttle&&0===this.props.throttle||e.debounce&&0===this.props.debounce)&&(this._onAction.cancel&&this._onAction.cancel(),this._onAction=this.props.onAction),e.eventsThrottle!==this.props.eventsThrottle&&(this._unbindEvents(),this.handleEvent=T(this._handleEvent.bind(this),this.props.eventsThrottle),this._bindEvents()),e.timeout!==this.props.timeout&&this.state.idle&&this.reset(),e.onActive!==this.props.onActive&&(this.callbackRefs.onActive=this.props.onActive),e.onIdle!==this.props.onIdle&&(this.callbackRefs.onIdle=this.props.onIdle)}},{key:"componentWillUnmount",value:function(){clearTimeout(this.tId),this._unbindEvents(!0),this._onAction.cancel&&this._onAction.cancel(),this.manager&&this.manager.close().catch(console.error)}},{key:"render",value:function(){return this.props.children||null}},{key:"_setupTabManager",value:function(){var e=this.props,t=e.crossTab,n=e.onIdle,r=e.onActive;if(this.callbackRefs={onIdle:n,onActive:r},t){var i=Object.assign({channelName:"idle-timer",fallbackInterval:2e3,responseTime:100,removeTimeout:6e4,emitOnAllTabs:!1},!0===t?{}:t),s=i.type,a=i.channelName,o=i.fallbackInterval,u=i.responseTime,c=i.emitOnAllTabs;this.manager=J({type:s,channelName:a,fallbackInterval:o,responseTime:u,emitOnAllTabs:c,callbacks:this.callbackRefs,start:this.start,reset:this.reset,pause:this.pause,resume:this.resume})}}},{key:"_bindEvents",value:function(){var e=this;if(f){var t=this.props,n=t.element,r=t.events,i=t.passive,s=t.capture;this.eventsBound||(r.forEach((function(t){n.addEventListener(t,e.handleEvent,{capture:s,passive:i})})),this.eventsBound=!0)}}},{key:"_unbindEvents",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(f){var n=this.props,r=n.element,i=n.events,s=n.passive,a=n.capture;(this.eventsBound||t)&&(i.forEach((function(t){r.removeEventListener(t,e.handleEvent,{capture:a,passive:s})})),this.eventsBound=!1)}}},{key:"_toggleIdleState",value:function(e){var t=this;this.setState((function(e){return{idle:!e.idle,lastIdle:e.idle?e.lastIdle:+new Date-t.props.timeout,idleTime:e.idle?e.idleTime+ +new Date-e.lastIdle:e.idleTime}}),(function(){var n=t.props,r=n.onActive,i=n.onIdle,s=n.stopOnIdle;t.state.idle?(s&&(clearTimeout(t.tId),t.tId=null,t._unbindEvents()),t.manager?t.manager.idle():i(e)):(t._bindEvents(),t.manager?t.manager.active():r(e))}))}},{key:"_handleEvent",value:function(e){var t=this.state,n=t.remaining,r=t.pageX,i=t.pageY,s=t.idle,a=this.props,o=a.timeout,u=a.stopOnIdle;if(this._onAction(e),!n){if("mousemove"===e.type){if(e.pageX===r&&e.pageY===i)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(this.getElapsedTime()<200)return}clearTimeout(this.tId),this.tId=null;var c=+new Date-this.getLastActiveTime();(s&&!u||!s&&c>o)&&this._toggleIdleState(e),this.setState({lastActive:+new Date,pageX:e.pageX,pageY:e.pageY}),s&&u||(this.tId=setTimeout(this._toggleIdleState,o))}}},{key:"start",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];clearTimeout(this.tId),this.tId=null,this._bindEvents(),this.setState({idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null}),this.manager&&(this.manager.setAllIdle(!1),!e&&this.props.crossTab.emitOnAllTabs&&this.manager.send("start"));var t=this.props.timeout;this.tId=setTimeout(this._toggleIdleState,t)}},{key:"reset",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];clearTimeout(this.tId),this.tId=null,this._bindEvents(),this.state.idle&&(this.manager?this.manager.active():this.props.onActive()),this.manager&&(this.manager.setAllIdle(!1),!e&&this.props.crossTab.emitOnAllTabs&&this.manager.send("reset")),this.setState({idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null});var t=this.props.timeout;this.tId=setTimeout(this._toggleIdleState,t)}},{key:"pause",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.state.remaining;null===t&&(this._unbindEvents(),clearTimeout(this.tId),this.tId=null,this.manager&&!e&&this.props.crossTab.emitOnAllTabs&&this.manager.send("pause"),this.setState({remaining:this.getRemainingTime()}))}},{key:"resume",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.state,n=t.remaining,r=t.idle;null!==n&&(this._bindEvents(),this.manager&&!e&&this.props.crossTab.emitOnAllTabs&&this.manager.send("resume"),r||(this.tId=setTimeout(this._toggleIdleState,n),this.setState({remaining:null,lastActive:+new Date})))}},{key:"getRemainingTime",value:function(){var e=this.state,t=e.remaining,n=e.lastActive,r=this.props.timeout;if(null!==t)return t<0?0:t;var i=r-(+new Date-n);return i<0?0:i}},{key:"getElapsedTime",value:function(){var e=this.state.oldDate;return+new Date-e}},{key:"getLastIdleTime",value:function(){return this.state.lastIdle}},{key:"getTotalIdleTime",value:function(){var e=this.state,t=e.idle,n=e.lastIdle,r=e.idleTime;return t?+new Date-n+r:r}},{key:"getLastActiveTime",value:function(){return this.state.lastActive}},{key:"getTotalActiveTime",value:function(){return this.getElapsedTime()-this.getTotalIdleTime()}},{key:"isIdle",value:function(){return this.state.idle}},{key:"isLeader",value:function(){return!this.manager||this.manager.isLeader()}}]),o}();function W(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.timeout,n=void 0===t?12e5:t,r=e.element,i=void 0===r?v:r,s=e.events,a=void 0===s?g:s,l=e.onIdle,h=void 0===l?function(){}:l,p=e.onActive,_=void 0===p?function(){}:p,y=e.onAction,w=void 0===y?function(){}:y,k=e.debounce,A=void 0===k?0:k,I=e.throttle,E=void 0===I?0:I,L=e.eventsThrottle,O=void 0===L?200:L,M=e.startOnMount,D=void 0===M||M,S=e.startManually,P=void 0!==S&&S,C=e.stopOnIdle,x=void 0!==C&&C,B=e.capture,R=void 0===B||B,N=e.passive,j=void 0===N||N,X=e.crossTab,Y=void 0!==X&&X,U=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(!1),F=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(!0),V=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(+new Date),z=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(null),G=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(null),W=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(null),q=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(null),H=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(null),K=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(null),Q=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(0),Z=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(!0),$=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(n),ee=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(null);Y&&(!0===Y&&(Y={}),Y=Object.assign({channelName:"idle-timer",fallbackInterval:2e3,responseTime:100,removeTimeout:6e4,emitOnAllTabs:!1},Y));var te=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(h),ne=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(_),re=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(w);Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])((function(){te.current=h}),[h]),Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])((function(){ne.current=_}),[_]),Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])((function(){re.current=w}),[w]);var ie=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useMemo"])((function(){function e(e){re.current(e)}return e.cancel&&e.cancel(),A>0?b(e,A):E>0?T(e,E):e}),[E,A]),se=function(e){var t=!F.current;F.current=t,t?(x&&(clearTimeout(q.current),q.current=null,ce()),K.current=+new Date-$.current,ee.current?ee.current.idle():te.current(e)):(Q.current+=+new Date-K.current,ue(),ee.current?ee.current.active():ne.current(e))},ae=function(e){if(ie(e),!z.current){if("mousemove"===e.type){if(e.pageX===G&&e.pageY===W)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(de()<200)return}clearTimeout(q.current),q.current=null;var t=+new Date-pe();(F.current&&!x||!F.current&&t>$.current)&&se(e),H.current=+new Date,G.current=e.pageX,W.current=e.pageY,F.current||(q.current=setTimeout(se,$.current))}},oe=Object(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(ae),ue=function(){f&&(U.current||(a.forEach((function(e){i.addEventListener(e,oe.current,{capture:R,passive:j})})),U.current=!0))},ce=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];f&&(U.current||e)&&(a.forEach((function(e){i.removeEventListener(e,oe.current,{capture:R,passive:j})})),U.current=!1)},le=function(){if(null!==z.current)return z.current<0?0:z.current;var e=$.current-(+new Date-H.current);return e<0?0:e},de=function(){return+new Date-V.current},he=function(){return K.current},me=function(){return F.current?+new Date-K.current+Q.current:Q.current},pe=function(){return H.current},fe=function(){return de()-me()},ve=function(){return F.current},ge=function(){return!ee.current||ee.current.isLeader()},be=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];clearTimeout(q.current),q.current=null,ue(),F.current=!1,V.current=+new Date,H.current=+new Date,z.current=null,ee.current&&(ee.current.setAllIdle(!1),!e&&Y.emitOnAllTabs&&ee.current.send("start")),q.current=setTimeout(se,$.current)},Te=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];clearTimeout(q.current),q.current=null,ue(),F.current&&(ee.current?ee.current.active():ne.current()),F.current=!1,V.current=+new Date,H.current=+new Date,z.current=null,ee.current&&(ee.current.setAllIdle(!1),!e&&Y.emitOnAllTabs&&ee.current.send("reset")),q.current=setTimeout(se,$.current)},_e=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];null===z.current&&(ce(),clearTimeout(q.current),q.current=null,z.current=le(),ee.current&&!e&&Y.emitOnAllTabs&&ee.current.send("pause"))},ye=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];null!==z.current&&(ue(),F.current||(q.current=setTimeout(se,z.current),z.current=null,H.current=+new Date),ee.current&&!e&&Y.emitOnAllTabs&&ee.current.send("resume"))};return Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])((function(){if(A>0&&E>0)throw new Error("onAction can either be throttled or debounced (not both)");return Y&&(ee.current=J({type:Y.type,channelName:Y.channelName,fallbackInterval:Y.fallbackInterval,responseTime:Y.responseTime,emitOnAllTabs:Y.emitOnAllTabs,callbacks:{onIdle:te.current,onActive:ne.current},start:be,reset:Te,pause:_e,resume:ye})),P?__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(clearTimeout(q.current),ce(!0),!Y){e.next=5;break}return e.next=5,ee.current.close();case 5:case"end":return e.stop()}}),e)}))):(D?be():ue(),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.mark((function e(){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_regenerator___default.a.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(clearTimeout(q.current),ce(!0),ie.cancel&&ie.cancel(),!Y){e.next=6;break}return e.next=6,ee.current.close();case 6:case"end":return e.stop()}}),e)}))))}),[]),Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])((function(){var e=U.current;e&&ce(),oe.current=O>0?T(ae,O):ae,e&&ue()}),[O]),Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])((function(){$.current=n,!Z.current&&F.current&&Te(),Z.current=!1}),[n]),{isIdle:ve,isLeader:ge,start:be,pause:_e,reset:Te,resume:ye,getLastIdleTime:he,getTotalIdleTime:me,getLastActiveTime:pe,getTotalActiveTime:fe,getElapsedTime:de,getRemainingTime:le}}G.propTypes={timeout:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,events:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),onIdle:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,onActive:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,onAction:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,debounce:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,throttle:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,eventsThrottle:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,element:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element]),startOnMount:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,startManually:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,stopOnIdle:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,passive:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,capture:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,crossTab:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({type:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(["broadcastChannel","localStorage","simulate"]),channelName:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,fallbackInterval:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,responseTime:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,removeTimeout:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,emitOnAllTabs:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool})])},G.defaultProps={timeout:12e5,element:v,events:g,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,startManually:!1,stopOnIdle:!1,capture:!0,passive:!0,crossTab:!1},W.propTypes={timeout:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,events:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),onIdle:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,onActive:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,onAction:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,debounce:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,throttle:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,eventsThrottle:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,element:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element]),startOnMount:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,startManually:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,stopOnIdle:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,passive:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,capture:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,crossTab:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({type:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(["broadcastChannel","localStorage","simulate"]),channelName:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,fallbackInterval:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,responseTime:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,removeTimeout:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,emitOnAllTabs:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool})])},W.defaultProps={timeout:12e5,element:v,events:g,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,startManually:!1,stopOnIdle:!1,capture:!0,passive:!0,crossTab:!1};/* harmony default export */ __webpack_exports__["a"] = (G);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 439 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(97)["default"];

var assertThisInitialized = __webpack_require__(222);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 441 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 443 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 444 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(447)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(97)["default"];

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(449);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 449 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(159);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(228);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(456);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(25), __webpack_require__(455)(module)))

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(465);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(462);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(460);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(25)))

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(230);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(464);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(228);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(229);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(469);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(159);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelGroup__ = __webpack_require__(242);








var Accordion = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Accordion, _React$Component);

  function Accordion() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Accordion);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Accordion.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__PanelGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { accordion: true }),
      this.props.children
    );
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(472);
module.exports = __webpack_require__(48).Object.assign;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(59);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(474) });


/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(168);
var pIE = __webpack_require__(102);
var toObject = __webpack_require__(169);
var IObject = __webpack_require__(235);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(99)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(73);
var toLength = __webpack_require__(236);
var toAbsoluteIndex = __webpack_require__(476);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(164);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(478), __esModule: true };

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(237);
__webpack_require__(484);
module.exports = __webpack_require__(174).f('iterator');


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(164);
var defined = __webpack_require__(163);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(172);
var descriptor = __webpack_require__(100);
var setToStringTag = __webpack_require__(173);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(79)(IteratorPrototype, __webpack_require__(49)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(71);
var anObject = __webpack_require__(80);
var getKeys = __webpack_require__(101);

module.exports = __webpack_require__(82) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(60).document;
module.exports = document && document.documentElement;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(72);
var toObject = __webpack_require__(169);
var IE_PROTO = __webpack_require__(165)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(485);
var global = __webpack_require__(60);
var hide = __webpack_require__(79);
var Iterators = __webpack_require__(103);
var TO_STRING_TAG = __webpack_require__(49)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(486);
var step = __webpack_require__(487);
var Iterators = __webpack_require__(103);
var toIObject = __webpack_require__(73);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(238)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(489), __esModule: true };

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(490);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
module.exports = __webpack_require__(48).Symbol;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(60);
var has = __webpack_require__(72);
var DESCRIPTORS = __webpack_require__(82);
var $export = __webpack_require__(59);
var redefine = __webpack_require__(239);
var META = __webpack_require__(491).KEY;
var $fails = __webpack_require__(99);
var shared = __webpack_require__(166);
var setToStringTag = __webpack_require__(173);
var uid = __webpack_require__(116);
var wks = __webpack_require__(49);
var wksExt = __webpack_require__(174);
var wksDefine = __webpack_require__(175);
var enumKeys = __webpack_require__(492);
var isArray = __webpack_require__(493);
var anObject = __webpack_require__(80);
var isObject = __webpack_require__(81);
var toIObject = __webpack_require__(73);
var toPrimitive = __webpack_require__(161);
var createDesc = __webpack_require__(100);
var _create = __webpack_require__(172);
var gOPNExt = __webpack_require__(494);
var $GOPD = __webpack_require__(241);
var $DP = __webpack_require__(71);
var $keys = __webpack_require__(101);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(240).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(102).f = $propertyIsEnumerable;
  __webpack_require__(168).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(171)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(79)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(116)('meta');
var isObject = __webpack_require__(81);
var has = __webpack_require__(72);
var setDesc = __webpack_require__(71).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(99)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(168);
var pIE = __webpack_require__(102);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(162);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(73);
var gOPN = __webpack_require__(240).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 495 */
/***/ (function(module, exports) {



/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(175)('asyncIterator');


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(175)('observable');


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(499), __esModule: true };

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(500);
module.exports = __webpack_require__(48).Object.setPrototypeOf;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(59);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(501).set });


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(81);
var anObject = __webpack_require__(80);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(160)(Function.call, __webpack_require__(241).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(503), __esModule: true };

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(504);
var $Object = __webpack_require__(48).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(59);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(172) });


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createUncontrollable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(32);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(506);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */


      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(32);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(508);
module.exports = __webpack_require__(48).Object.entries;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(59);
var $entries = __webpack_require__(244)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CloseButton__ = __webpack_require__(176);














var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Alert, _React$Component);

  function Alert() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Alert);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        onDismiss = _props.onDismiss,
        closeLabel = _props.closeLabel,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onDismiss', 'closeLabel', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;
    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'alert',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      dismissable && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CloseButton__["a" /* default */], { onClick: onDismiss, label: closeLabel }),
      children
    );
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]), __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */].INFO, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('alert', Alert)));

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(511);
module.exports = __webpack_require__(48).Object.values;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(59);
var $values = __webpack_require__(244)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











// TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  pullRight: false
};

var Badge = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Badge, _React$Component);

  function Badge() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Badge);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Badge.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Badge.prototype.render = function render() {
    var _props = this.props,
        pullRight = _props.pullRight,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['pullRight', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'pull-right': pullRight,

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      children
    );
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('badge', Badge));

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var Breadcrumb = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Breadcrumb, _React$Component);

  function Breadcrumb() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Breadcrumb);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Breadcrumb.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ol', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'navigation',
      'aria-label': 'breadcrumbs',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('breadcrumb', Breadcrumb));

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var ButtonToolbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonToolbar);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonToolbar.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'toolbar',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('btn-toolbar', ButtonToolbar));

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Glyphicon__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(36);
















// TODO: `slide` should be `animate`.

// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any, ?event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-left' }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-right' }),
  nextLabel: 'Next'
};

var Carousel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Carousel, _React$Component);

  function Carousel(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Carousel);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);

    var defaultActiveIndex = props.defaultActiveIndex;


    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  Carousel.prototype.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);

      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  Carousel.prototype.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  Carousel.prototype.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  Carousel.prototype.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  Carousel.prototype.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }
      index = 0;
    }

    this.select(index, e, 'next');
  };

  Carousel.prototype.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }
      index = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  };

  // This might be a public API.


  Carousel.prototype.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  };

  // This might be a public API.


  Carousel.prototype.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  Carousel.prototype.select = function select(index, e, direction) {
    clearTimeout(this.timeout);

    // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.
    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);

    var onSelect = this.props.onSelect;


    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = { direction: direction };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  Carousel.prototype.waitForNext = function waitForNext() {
    var _props = this.props,
        slide = _props.slide,
        interval = _props.interval,
        activeIndexProp = _props.activeIndex;


    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  Carousel.prototype.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;

    var controlClassName = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(children);

    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'prev',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'left'),
        onClick: this.handlePrev
      },
      prevIcon,
      prevLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        prevLabel
      )
    ), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'next',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'right'),
        onClick: this.handleNext
      },
      nextIcon,
      nextLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        nextLabel
      )
    )];
  };

  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];

    __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }),

      // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ol',
      { className: Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'indicators') },
      indicators
    );
  };

  Carousel.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        slide = _props2.slide,
        indicators = _props2.indicators,
        controls = _props2.controls,
        wrap = _props2.wrap,
        prevIcon = _props2.prevIcon,
        prevLabel = _props2.prevLabel,
        nextIcon = _props2.nextIcon,
        nextLabel = _props2.nextLabel,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);

    var _state = this.state,
        previousActiveIndex = _state.previousActiveIndex,
        direction = _state.direction;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      }),
      indicators && this.renderIndicators(children, activeIndex, bsProps),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner') },
        __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
          var active = index === activeIndex;
          var previousActive = slide && index === previousActiveIndex;

          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
            active: active,
            index: index,
            animateOut: previousActive,
            animateIn: active && previousActiveIndex != null && slide,
            direction: direction,
            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
          });
        })
      ),
      controls && this.renderControls({
        wrap: wrap,
        children: children,
        activeIndex: activeIndex,
        prevIcon: prevIcon,
        prevLabel: prevLabel,
        nextIcon: nextIcon,
        nextLabel: nextLabel,
        bsProps: bsProps
      })
    );
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

Carousel.Caption = __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_9__CarouselItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('carousel', Carousel));

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselCaption, _React$Component);

  function CarouselCaption() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselCaption);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CarouselCaption.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('carousel-caption', CarouselCaption));

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _end = _interopRequireDefault(__webpack_require__(518));

exports.end = _end.default;

var _properties = _interopRequireDefault(__webpack_require__(178));

exports.properties = _properties.default;
var _default = {
  end: _end.default,
  properties: _properties.default
};
exports.default = _default;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _properties = _interopRequireDefault(__webpack_require__(178));

var _style = _interopRequireDefault(__webpack_require__(105));

function onEnd(node, handler, duration) {
  var fakeEvent = {
    target: node,
    currentTarget: node
  },
      backup;
  if (!_properties.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;

  if (_properties.default.end) {
    node.addEventListener(_properties.default.end, done, false);
    backup = setTimeout(function () {
      return done(fakeEvent);
    }, (duration || 100) * 1.5);
  } else setTimeout(done.bind(null, fakeEvent), 0);

  function done(event) {
    if (event.target !== event.currentTarget) return;
    clearTimeout(backup);
    event.target.removeEventListener(_properties.default.end, done);
    handler.call(this);
  }
}

onEnd._parseDuration = parseDuration;
var _default = onEnd;
exports.default = _default;

function parseDuration(node) {
  var str = (0, _style.default)(node, _properties.default.duration),
      mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

module.exports = exports["default"];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(521));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(248));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);





/* eslint-disable jsx-a11y/label-has-for */








var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Checkbox.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'checkbox',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes),
          style: style,
          title: title
        },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('checkbox', Checkbox));

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(33);














var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div'
};

var Clearfix = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Clearfix, _React$Component);

  function Clearfix() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Clearfix);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Clearfix.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = 'visible' + Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(size) + 'Block';
      if (elementProps[propName]) {
        classes['visible-' + size + '-block'] = true;
      }

      delete elementProps[propName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('clearfix', Clearfix));

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  srOnly: false
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var ControlLabel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ControlLabel, _React$Component);

  function ControlLabel() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ControlLabel);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ControlLabel.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        _props$htmlFor = _props.htmlFor,
        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
        srOnly = _props.srOnly,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['htmlFor', 'srOnly', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('control-label', ControlLabel));

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(33);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  componentClass: 'div'
};

var Col = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Col, _React$Component);

  function Col() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Col);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Col.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = '' + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '' + size + modifier + '-' + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');

      var hiddenPropName = size + 'Hidden';
      if (elementProps[hiddenPropName]) {
        classes.push('hidden-' + size);
      }
      delete elementProps[hiddenPropName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('col', Col));

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(530);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(251));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(36);

















var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown'])
};

var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.handleRootClose = _this.handleRootClose.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this);
    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);

    return { items: items, activeIndex: activeIndex };
  };

  DropdownMenu.prototype.focusNext = function focusNext() {
    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd.items,
        activeIndex = _getItemsAndActiveInd.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd2.items,
        activeIndex = _getItemsAndActiveInd2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.props.onClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, { source: 'rootClose' });
  };

  DropdownMenu.prototype.render = function render() {
    var _extends2,
        _this2 = this;

    var _props = this.props,
        open = _props.open,
        pullRight = _props.pullRight,
        labelledBy = _props.labelledBy,
        onSelect = _props.onSelect,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default.a,
      {
        disabled: !open,
        onRootClose: this.handleRootClose,
        event: rootCloseEvent
      },
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
          role: 'menu',
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
          'aria-labelledby': labelledBy
        }),
        __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(child, {
            onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
            onSelect: Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
          });
        })
      )
    );
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-menu', DropdownMenu));

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(535), __esModule: true };

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(237);
__webpack_require__(536);
module.exports = __webpack_require__(48).Array.from;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(160);
var $export = __webpack_require__(59);
var toObject = __webpack_require__(169);
var call = __webpack_require__(537);
var isArrayIter = __webpack_require__(538);
var toLength = __webpack_require__(236);
var createProperty = __webpack_require__(539);
var getIterFn = __webpack_require__(540);

$export($export.S + $export.F * !__webpack_require__(542)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(80);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(103);
var ITERATOR = __webpack_require__(49)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(71);
var createDesc = __webpack_require__(100);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(541);
var ITERATOR = __webpack_require__(49)('iterator');
var Iterators = __webpack_require__(103);
module.exports = __webpack_require__(48).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(162);
var TAG = __webpack_require__(49)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(49)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dropdown__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(121);











var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var DropdownButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DropdownButton, _React$Component);

  function DropdownButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'children']);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, { bsSize: bsSize, bsStyle: bsStyle }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, { bsSize: bsSize, bsStyle: bsStyle }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownButton.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (DropdownButton);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Form, _React$Component);

  function Form() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Form);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Form.prototype.render = function render() {
    var _props = this.props,
        horizontal = _props.horizontal,
        inline = _props.inline,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['horizontal', 'inline', 'componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    if (horizontal) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'horizontal'));
    }
    if (inline) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('form', Form));

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__ = __webpack_require__(33);
















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: 'input'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControl = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControl, _React$Component);

  function FormControl() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControl);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        Component = _props.componentClass,
        type = _props.type,
        _props$id = _props.id,
        id = _props$id === undefined ? controlId : _props$id,
        inputRef = _props.inputRef,
        className = _props.className,
        bsSize = _props.bsSize,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;

    // input[type="file"] should not have .form-control.
    var classes = void 0;
    if (type !== 'file') {
      classes = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    }

    // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm
    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["b" /* SIZE_MAP */][bsSize] || bsSize;
      classes[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])({ bsClass: 'input' }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;

FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('form-control', Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["c" /* Size */].LARGE], FormControl)));

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Glyphicon__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var defaultProps = {
  bsRole: 'feedback'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControlFeedback = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlFeedback);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';
      case 'warning':
        return 'warning-sign';
      case 'error':
        return 'remove';
      default:
        return null;
    }
  };

  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);
    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Glyphicon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  FormControlFeedback.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlStatic, _React$Component);

  function FormControlStatic() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlStatic);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlStatic.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('form-control-static', FormControlStatic));

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(36);













var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};

var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};

var FormGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormGroup, _React$Component);

  function FormGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        controlId = _props.controlId,
        validationState = _props.validationState;


    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
    });
  };

  FormGroup.prototype.render = function render() {
    var _props2 = this.props,
        validationState = _props2.validationState,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['validationState', 'className', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      children
    );
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('form-group', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var HelpBlock = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HelpBlock, _React$Component);

  function HelpBlock() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, HelpBlock);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  HelpBlock.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('help-block', HelpBlock));

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Image, _React$Component);

  function Image() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Image);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Image.prototype.render = function render() {
    var _classes;

    var _props = this.props,
        responsive = _props.responsive,
        rounded = _props.rounded,
        circle = _props.circle,
        thumbnail = _props.thumbnail,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')] = responsive, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'rounded')] = rounded, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'circle')] = circle, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'thumbnail')] = thumbnail, _classes);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('img', Image));

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(33);













var InputGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroup, _React$Component);

  function InputGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroup.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('input-group', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var InputGroupAddon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupAddon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupAddon.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('input-group-addon', InputGroupAddon));

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var InputGroupButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupButton, _React$Component);

  function InputGroupButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('input-group-btn', InputGroupButton));

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Jumbotron = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Jumbotron, _React$Component);

  function Jumbotron() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Jumbotron);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Jumbotron.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes) }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('jumbotron', Jumbotron));

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(33);












var Label = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Label, _React$Component);

  function Label() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Label);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Label.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Label.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes) }),
      children
    );
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('label', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* State */]), [__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, Label)));

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(36);













var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ListGroup, _React$Component);

  function ListGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroup.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$componentClass = _props.componentClass,
        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      useListItem ? __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, { listItem: true });
      }) : children
    );
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ListGroup.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('list-group', ListGroup));

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Media__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);













var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom']),

  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var MediaBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaBody, _React$Component);

  function MediaBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'align', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_9__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('media-body', MediaBody));

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaHeading, _React$Component);

  function MediaHeading() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaHeading);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaHeading.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('media-heading', MediaHeading));

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaLeft, _React$Component);

  function MediaLeft() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaLeft);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaLeft.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaLeft.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('media-left', MediaLeft));

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var MediaList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaList, _React$Component);

  function MediaList() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaList);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaList.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-list', MediaList));

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var MediaListItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaListItem, _React$Component);

  function MediaListItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaListItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaListItem.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media', MediaListItem));

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaRight, _React$Component);

  function MediaRight() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaRight);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaRight.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaRight.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('media-right', MediaRight));

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(26);














var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  MenuItem.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        href = _props.href,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  MenuItem.prototype.render = function render() {
    var _props2 = this.props,
        active = _props2.active,
        disabled = _props2.disabled,
        divider = _props2.divider,
        header = _props2.header,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'separator',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'heading',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'menuitem',
        tabIndex: '-1',
        onClick: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', MenuItem));

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Fade__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalBody__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalDialog__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalFooter__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalHeader__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ModalTitle__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__ = __webpack_require__(33);




























var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */].propTypes, {

  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func
  })
};

/* eslint-disable no-use-before-define, react/no-multi-comp */
function DialogTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Fade__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, { timeout: Modal.TRANSITION_DURATION }));
}

function BackdropTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Fade__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, { timeout: Modal.BACKDROP_TRANSITION_DURATION }));
}

/* eslint-enable no-use-before-define */

var Modal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Modal, _React$Component);

  function Modal(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
    _this.setModalRef = _this.setModalRef.bind(_this);

    _this.state = {
      style: {}
    };
    return _this;
  }

  Modal.prototype.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  Modal.prototype.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  Modal.prototype.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  Modal.prototype.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  Modal.prototype.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  Modal.prototype.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();
    var dialogHeight = dialogNode.scrollHeight;

    var document = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_12_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;

    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        backdrop = _props.backdrop,
        backdropClassName = _props.backdropClassName,
        animation = _props.animation,
        show = _props.show,
        Dialog = _props.dialogComponentClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        onEntering = _props.onEntering,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';

    return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, baseModalProps, {
        ref: this.setModalRef,
        show: show,
        containerClassName: Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["e" /* prefix */])(props, 'open'),
        transition: animation ? DialogTransition : undefined,
        backdrop: backdrop,
        backdropTransition: animation ? BackdropTransition : undefined,
        backdropClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["e" /* prefix */])(props, 'backdrop'), backdropClassName, inClassName),
        onEntering: Object(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
        onExited: Object(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited)
      }),
      __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        Dialog,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dialogProps, {
          style: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.state.style, style),
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, inClassName),
          onClick: backdrop === true ? this.handleDialogClick : null
        }),
        children
      )
    );
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;

Modal.Body = __WEBPACK_IMPORTED_MODULE_17__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_20__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_21__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_19__ModalFooter__["a" /* default */];

Modal.Dialog = __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */];

Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["c" /* Size */].SMALL], Modal)));

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(182));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(183));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(566));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(568));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(85));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(567));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(61));

var _on = _interopRequireDefault(__webpack_require__(182));

var _off = _interopRequireDefault(__webpack_require__(183));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(252);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(85);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(61);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(124);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(570);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(16);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(571);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(261);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(577);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(254);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(578);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(126);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(86);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType2.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType2.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.backdropTransition;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        {
          appear: true,
          'in': _this2.props.show
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(572);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(105);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(258);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(260);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(575);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(573));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(574));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(259));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(259));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(124);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(126);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(86);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(33);












var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var ModalDialog = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalDialog, _React$Component);

  function ModalDialog() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalDialog);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalDialog.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        dialogClassName = _props.dialogClassName,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['dialogClassName', 'className', 'style', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps);

    var modalStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ display: 'block' }, style);

    var dialogClasses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        tabIndex: '-1',
        role: 'dialog',
        style: modalStyle,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(dialogClassName, dialogClasses) },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'), role: 'document' },
          children
        )
      )
    );
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalDialog.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Grid__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__ = __webpack_require__(26);





// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
/* eslint-disable react/no-multi-comp */
















var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};

var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var Navbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Navbar, _React$Component);

  function Navbar(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Navbar);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleCollapse = _this.handleCollapse.bind(_this);
    return _this;
  }

  Navbar.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        expanded = _props.expanded,
        onSelect = _props.onSelect,
        collapseOnSelect = _props.collapseOnSelect;


    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  Navbar.prototype.handleCollapse = function handleCollapse() {
    var _props2 = this.props,
        onToggle = _props2.onToggle,
        expanded = _props2.expanded;


    if (expanded) {
      onToggle(false);
    }
  };

  Navbar.prototype.handleToggle = function handleToggle() {
    var _props3 = this.props,
        onToggle = _props3.onToggle,
        expanded = _props3.expanded;


    onToggle(!expanded);
  };

  Navbar.prototype.render = function render() {
    var _extends2;

    var _props4 = this.props,
        Component = _props4.componentClass,
        fixedTop = _props4.fixedTop,
        fixedBottom = _props4.fixedBottom,
        staticTop = _props4.staticTop,
        inverse = _props4.inverse,
        fluid = _props4.fluid,
        className = _props4.className,
        children = _props4.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].INVERSE;
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-top')] = fixedTop, _extends2[Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Grid__["a" /* default */],
        { fluid: fluid },
        children
      )
    );
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;

Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["a" /* bsClass */])('navbar', Navbar);

var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default()(Navbar, { expanded: 'onToggle' });

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;

    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, suffix), pullRight && Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right'), pullLeft && Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;

  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  };

  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };

  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
    })
  };

  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__["a" /* default */];

UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');

// Set bsStyles here so they can be overridden.
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["c" /* bsStyles */])([__WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapse__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  })
};

var NavbarCollapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarCollapse);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarCollapse.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'collapse');

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'in': navbarProps.expanded }, props),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: bsClassName },
        children
      )
    );
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarHeader, _React$Component);

  function NavbarHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'header');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(26);












var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarToggle, _React$Component);

  function NavbarToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onClick', 'className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var buttonProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      type: 'button'
    }, props, {
      onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'button',
        buttonProps,
        children
      );
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'button',
      buttonProps,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        'Toggle navigation'
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' })
    );
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(36);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  activeHref: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
});

var NavDropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NavDropdown, _React$Component);

  function NavDropdown() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NavDropdown);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
    var props = _ref.props;

    var _this2 = this;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  NavDropdown.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        title = _props.title,
        activeKey = _props.activeKey,
        activeHref = _props.activeHref,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().
    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        componentClass: 'li',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }),
        style: style
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, { useAnchor: true }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
            active: _this3.isActive(child, activeKey, activeHref)
          });
        })
      )
    );
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavDropdown.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (NavDropdown);

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(16);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(261);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(586);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(253);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(124);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(587);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(126);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(86);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(270);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(588);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(272);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(86);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(271));

var _offset = _interopRequireDefault(__webpack_require__(270));

var _offsetParent = _interopRequireDefault(__webpack_require__(589));

var _scrollTop = _interopRequireDefault(__webpack_require__(272));

var _scrollLeft = _interopRequireDefault(__webpack_require__(590));

var _style = _interopRequireDefault(__webpack_require__(105));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(84));

var _style = _interopRequireDefault(__webpack_require__(105));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(21);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(125));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(26);















/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }
  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */].propTypes, {

  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  // FIXME: This should be `defaultShow`.
  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  // Overridden props from `<Overlay>`.
  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
   * @private
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayTrigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };
    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;

    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;

    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;
      _this2.hide();
    }, delay);
  };

  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;
      _this3.show();
    }, delay);
  };

  OverlayTrigger.prototype.handleHide = function handleHide() {
    this.hide();
  };

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  OverlayTrigger.prototype.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  OverlayTrigger.prototype.hide = function hide() {
    this.setState({ show: false });
  };

  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        show: this.state.show,
        onHide: this.handleHide,
        target: this
      }),
      overlay
    );
  };

  OverlayTrigger.prototype.show = function show() {
    this.setState({ show: true });
  };

  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  OverlayTrigger.prototype.render = function render() {
    var _props = this.props,
        trigger = _props.trigger,
        overlay = _props.overlay,
        children = _props.children,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    }

    // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.

    triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;

      triggerProps.onMouseOver = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);

    return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (OverlayTrigger);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);










var PageHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PageHeader, _React$Component);

  function PageHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PageHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PageHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h1',
        null,
        children
      )
    );
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('page-header', PageHeader));

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(594);



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);






var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message = void 0;

  if ((typeof oldname === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(oldname)) === 'object') {
    message = oldname.message;
  } else {
    message = oldname + ' is deprecated. Use ' + newname + ' instead.';

    if (link) {
      message += '\nYou can read more about it at ' + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (_Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeprecatedComponent, _Component);

    function DeprecatedComponent() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeprecatedComponent);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
    }

    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
      deprecationWarning.apply(undefined, args);

      if (_Component.prototype.componentWillMount) {
        var _Component$prototype$;

        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          methodArgs[_key2] = arguments[_key2];
        }

        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
      }
    };

    return DeprecatedComponent;
  }(Component);
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PagerItem__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(36);














var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Pager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pager, _React$Component);

  function Pager() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pager);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pager.prototype.render = function render() {
    var _props = this.props,
        onSelect = _props.onSelect,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onSelect', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
          onSelect: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
        });
      })
    );
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pager.propTypes = propTypes;

Pager.Item = __WEBPACK_IMPORTED_MODULE_8__PagerItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('pager', Pager));

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaginationItem__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pagination.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      children
    );
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('pagination', Pagination);

Pagination.First = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["b" /* First */];
Pagination.Prev = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["e" /* Prev */];
Pagination.Ellipsis = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["a" /* Ellipsis */];
Pagination.Item = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["f" /* default */];
Pagination.Next = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["d" /* Next */];
Pagination.Last = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["c" /* Last */];

/* unused harmony default export */ var _unused_webpack_default_export = (Pagination);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = PaginationItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return First; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Last; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);





/* eslint-disable react/no-multi-comp */






var propTypes = {
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  activeLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired
};

var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};

function PaginationItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['active', 'disabled', 'className', 'style', 'activeLabel', 'children']);

  var Component = active || disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'li',
    { style: style, className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }) },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ disabled: disabled }, props),
      children,
      active && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        activeLabel
      )
    )
  );
}

PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;

function createButton(name, defaultValue) {
  var _class, _temp;

  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : name;

  return _temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(_class, _React$Component);

    function _class() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
    }

    _class.prototype.render = function render() {
      var _props = this.props,
          disabled = _props.disabled,
          children = _props.children,
          className = _props.className,
          props = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['disabled', 'children', 'className']);

      var Component = disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */];

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'li',
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
          'aria-label': label,
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { disabled: disabled })
        }, props),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          Component,
          null,
          children || defaultValue
        )
      );
    };

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.displayName = name, _class.propTypes = { disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool }, _temp;
}

var First = createButton('First', '\xAB');
var Prev = createButton('Prev', '\u2039');
var Ellipsis = createButton('Ellipsis', '\u2026', 'More');
var Next = createButton('Next', '\u203A');
var Last = createButton('Last', '\xBB');

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PanelBody__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PanelHeading__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PanelTitle__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PanelFooter__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PanelToggle__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PanelCollapse__ = __webpack_require__(274);





















var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + '--' + type : null;
};

var propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var contextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var childContextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  })
};

var Panel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Panel, _React$Component);

  function Panel() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Panel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Panel.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        eventKey = _props.eventKey,
        id = _props.id;

    var idKey = eventKey == null ? id : eventKey;

    var ids = void 0;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;

      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  Panel.prototype.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? warning(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;

      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  Panel.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        children = _props2.children;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps)) }),
      children
    );
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

Panel.propTypes = propTypes;

Panel.contextTypes = contextTypes;
Panel.childContextTypes = childContextTypes;

var UncontrolledPanel = __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["a" /* bsClass */])('panel', Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["c" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__["d" /* State */]), [__WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__["e" /* Style */].DEFAULT, Panel)), { expanded: 'onToggle' });

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(UncontrolledPanel, {
  Heading: __WEBPACK_IMPORTED_MODULE_14__PanelHeading__["a" /* default */],
  Title: __WEBPACK_IMPORTED_MODULE_15__PanelTitle__["a" /* default */],
  Body: __WEBPACK_IMPORTED_MODULE_13__PanelBody__["a" /* default */],
  Footer: __WEBPACK_IMPORTED_MODULE_16__PanelFooter__["a" /* default */],
  Toggle: __WEBPACK_IMPORTED_MODULE_17__PanelToggle__["a" /* default */],
  Collapse: __WEBPACK_IMPORTED_MODULE_18__PanelCollapse__["a" /* default */]
});

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledPanel);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PanelCollapse__ = __webpack_require__(274);










var propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};

var defaultProps = {
  collapsible: false
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })
};

var PanelBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PanelBody, _React$Component);

  function PanelBody() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PanelBody);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelBody.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        collapsible = _props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    var body = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'body')) }),
      children
    );

    if (collapsible) {
      body = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__PanelCollapse__["a" /* default */],
        null,
        body
      );
    }

    return body;
  };

  return PanelBody;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelBody.propTypes = propTypes;
PanelBody.defaultProps = defaultProps;
PanelBody.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelBody));

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var PanelHeading = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PanelHeading, _React$Component);

  function PanelHeading() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PanelHeading);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelHeading.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        Component = _props.componentClass,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'className', 'componentClass']);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading'))
      }),
      children
    );
  };

  return PanelHeading;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PanelHeading.propTypes = propTypes;
PanelHeading.defaultProps = defaultProps;
PanelHeading.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelHeading));

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PanelToggle__ = __webpack_require__(275);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a,
  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
  })
};

var defaultProps = {
  componentClass: 'div'
};

var PanelTitle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PanelTitle, _React$Component);

  function PanelTitle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PanelTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelTitle.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        toggle = _props.toggle,
        Component = _props.componentClass,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'className', 'toggle', 'componentClass']);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__PanelToggle__["a" /* default */],
        null,
        children
      );
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title'))
      }),
      children
    );
  };

  return PanelTitle;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

PanelTitle.propTypes = propTypes;
PanelTitle.defaultProps = defaultProps;
PanelTitle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelTitle));

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);









var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })
};

var PanelFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PanelFooter, _React$Component);

  function PanelFooter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PanelFooter);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelFooter.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'footer'))
      }),
      children
    );
  };

  return PanelFooter;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelFooter.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelFooter));

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var defaultProps = {
  placement: 'right'
};

var Popover = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popover, _React$Component);

  function Popover() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Popover);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Popover.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        title = _props.title,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'arrow', style: arrowStyle }),
      title && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h3',
        { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title') },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content') },
        children
      )
    );
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('popover', Popover));

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(36);














var ROUND_PRECISION = 1000;

/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */
function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];
  if (!children) {
    return null;
  }

  var error = null;

  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }

    // eslint-disable-next-line no-use-before-define
    if (child.type === ProgressBar) return;

    var childIdentifier = __WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
  });

  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ProgressBar, _React$Component);

  function ProgressBar() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProgressBar);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'progressbar',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ width: getPercentage(now, min, max) + '%' }, style),
        'aria-valuenow': now,
        'aria-valuemin': min,
        'aria-valuemax': max
      }),
      srOnly ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      ) : label
    );
  };

  ProgressBar.prototype.render = function render() {
    var _props = this.props,
        isChild = _props.isChild,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['isChild']);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, wrapperProps, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, 'progress') }),
      children ? __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { isChild: true });
      }) : this.renderProgressBar({
        min: min,
        now: now,
        max: max,
        label: label,
        srOnly: srOnly,
        striped: striped,
        active: active,
        bsClass: bsClass,
        bsStyle: bsStyle
      })
    );
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('progress-bar', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]), ProgressBar)));

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);





/* eslint-disable jsx-a11y/label-has-for */








var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Radio, _React$Component);

  function Radio() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Radio);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'radio',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes),
          style: style,
          title: title
        },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('radio', Radio));

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












// TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element.isRequired,
  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ResponsiveEmbed);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ResponsiveEmbed.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        a16by9 = _props.a16by9,
        a4by3 = _props.a4by3,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['a16by9', 'a4by3', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '16by9')] = a16by9, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes) },
      Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'item'))
      }))
    );
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Row = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Row, _React$Component);

  function Row() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Row);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Row.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('row', Row));

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SplitToggle__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__ = __webpack_require__(121);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var SplitButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitButton, _React$Component);

  function SplitButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        toggleLabel = _props.toggleLabel,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, { bsSize: bsSize, bsStyle: bsStyle }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, buttonProps, {
          disabled: props.disabled,
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */], {
        'aria-label': toggleLabel || title,
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SplitButton.propTypes = propTypes;

SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (SplitButton);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__ = __webpack_require__(255);








var SplitToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitToggle, _React$Component);

  function SplitToggle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitToggle);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitToggle.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { useAnchor: false, noCaret: false }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */].defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabContainer__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TabContent__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabPane__ = __webpack_require__(276);











var propTypes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */].propTypes, {

  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
});

var Tab = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Tab, _React$Component);

  function Tab() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Tab);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tab.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);

    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
    delete props.title;
    delete props.disabled;
    delete props.tabClassName;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tab.propTypes = propTypes;

Tab.Container = __WEBPACK_IMPORTED_MODULE_6__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_7__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(8);











var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Table, _React$Component);

  function Table() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Table.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        striped = _props.striped,
        bordered = _props.bordered,
        condensed = _props.condensed,
        hover = _props.hover,
        responsive = _props.responsive,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = striped, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'bordered')] = bordered, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'condensed')] = condensed, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('table', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive') },
        table
      );
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('table', Table));

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Nav__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavItem__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContainer__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabContent__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(36);

















var TabContainer = __WEBPACK_IMPORTED_MODULE_11__TabContainer__["a" /* default */].ControlledComponent;

var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['tabs', 'pills']),

  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  id: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey = void 0;
  __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });

  return defaultActiveKey;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tabs.prototype.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__NavItem__["a" /* default */],
      { eventKey: eventKey, disabled: disabled, className: tabClassName },
      title
    );
  };

  Tabs.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        onSelect = _props.onSelect,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit,
        bsClass = _props.bsClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        _props$activeKey = _props.activeKey,
        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      TabContainer,
      {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        className: className,
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Nav__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { role: 'tablist' }),
          __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__TabContent__["a" /* default */],
          {
            bsClass: bsClass,
            animation: animation,
            mountOnEnter: mountOnEnter,
            unmountOnExit: unmountOnExit
          },
          children
        )
      )
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

Object(__WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__["a" /* bsClass */])('tab', Tabs);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Tabs, { activeKey: 'onSelect' }));

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);





/* eslint-disable jsx-a11y/alt-text */








var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * alt property that is passed down to the image inside this component
   */
  alt: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * href property that is passed down to the image inside this component
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Thumbnail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Thumbnail, _React$Component);

  function Thumbnail() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Thumbnail);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Thumbnail.prototype.render = function render() {
    var _props = this.props,
        src = _props.src,
        alt = _props.alt,
        onError = _props.onError,
        onLoad = _props.onLoad,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */] : 'div';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
      children && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'caption' },
        children
      )
    );
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Thumbnail.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('thumbnail', Thumbnail));

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ToggleButton__ = __webpack_require__(277);















var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']).isRequired
};

var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButtonGroup.prototype.getValues = function getValues() {
    var value = this.props.value;

    return value == null ? [] : [].concat(value);
  };

  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
    var _props = this.props,
        type = _props.type,
        onChange = _props.onChange;

    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }
      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange([].concat(values, [value]));
    }
  };

  ToggleButtonGroup.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        children = _props2.children,
        type = _props2.type,
        name = _props2.name,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children', 'type', 'name']);

    var values = this.getValues();

    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_7_invariant___default()(false) : void 0;

    delete props.onChange;
    delete props.value;

    // the data attribute is required b/c twbs css uses it in the selector
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { 'data-toggle': 'buttons' }),
      __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            onChange = _child$props.onChange;

        var handler = function handler() {
          return _this2.handleToggle(value);
        };

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          type: type,
          name: child.name || name,
          checked: values.indexOf(value) !== -1,
          onChange: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onChange, handler)
        });
      })
    );
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;

var UncontrolledToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(ToggleButtonGroup, {
  value: 'onChange'
});

UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_12__ToggleButton__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledToggleButtonGroup);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(8);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string])
};

var defaultProps = {
  placement: 'right'
};

var Tooltip = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _React$Component);

  function Tooltip() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tooltip.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'arrow'), style: arrowStyle }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner') },
        children
      )
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('tooltip', Tooltip));

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(33);











var Well = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Well, _React$Component);

  function Well() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Well);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Well.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('well', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].SMALL], Well)));

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(8);
/* unused harmony reexport bootstrapUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(26);
/* unused harmony reexport createChainedFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(36);
/* unused harmony reexport ValidComponentChildren */







/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/StopSign.c0ffd9f5.png";

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = {"name":"avenue-pm","version":"3.9.5","private":true,"dependencies":{"base-64":"^0.1.0","bootstrap":"^3.3.7","create-react-class":"^15.6.3","css3transform-react":"^0.1.0","d3":"^5.4.0","fbemitter":"^2.1.1","lamejs":"^1.2.0","lodash.flatten":"^4.4.0","lottie-react":"^2.1.0","network-speed":"1.2.0","npm":"^5.10.0","parse5":"^4.0.0-test","pondjs":"^0.8.8","query-string":"4.3.1","react":"^16.7.0-alpha.0","react-animated-css":"^1.0.4","react-bootstrap":"^0.32.1","react-device-detect":"^2.1.2","react-dom":"^16.7.0-alpha.0","react-google-charts":"^1.6.0","react-idle-timer":"^4.6.4","react-modal":"^3.3.2","react-multimedia-capture":"^1.2.0","react-native-network-bandwith-speed":"^3.0.0","react-player":"^1.6.2","react-radio-group":"^3.0.3","react-redux":"^5.0.7","react-router-dom":"^4.2.2","react-scripts":"^1.1.4","react-select":"^5.4.0","react-tappable":"^1.0.4","react-timeseries-charts":"^0.14.0","react-to-print":"^2.14.7","recordrtc":"^5.4.6","redux":"^4.0.0","redux-persist":"^5.10.0","redux-thunk":"^2.3.0","renamer":"^4.0.0","replace-in-file":"^6.3.2","speedtest-net":"^1.6.2","superagent":"^3.8.3","uuid":"^3.2.1","ws":"^5.2.0"},"scripts":{"start":"set PORT=3001 && react-scripts start","build":"react-scripts build && npm run build-rename","build-rename":"npm run build-rename-js && npm run build-rename-css && npm run build-fix-references","build-rename-js":"renamer --find \"/main\\.[^\\.]+\\./i\" --replace \"main.\" build/static/js/*","build-rename-css":"renamer --find \"/main\\.[^\\.]+\\./i\" --replace \"main.\" build/static/css/*","build-fix-references":"npm run build-fix-sourcemap && npm run build-fix-index && npm run build-fix-serviceworker && npm run build-fix-assetmanifest","build-fix-sourcemap":"npm run build-fix-sourcemap-js && npm run build-fix-sourcemap-css","build-fix-sourcemap-js":"replace-in-file \"/sourceMappingURL=main\\.[^\\.]+\\.js\\.map/i\" \"sourceMappingURL=main.js.map\" build/static/js/main.js --isRegex","build-fix-sourcemap-css":"replace-in-file \"/sourceMappingURL=main\\.[^\\.]+\\.css\\.map/i\" \"sourceMappingURL=main.css.map\" build/static/css/main.css --isRegex","build-fix-index":"npm run build-fix-index-js && npm run build-fix-index-css","build-fix-index-js":"replace-in-file \"/main\\.[^\\.]+\\.js/i\" \"main.js?v=$npm_package_version\" build/index.html --isRegex","build-fix-index-css":"replace-in-file \"/main\\.[^\\.]+\\.css/i\" \"main.css?v=$npm_package_version\" build/index.html --isRegex","build-fix-serviceworker":"npm run build-fix-serviceworker-js && npm run build-fix-serviceworker-css","build-fix-serviceworker-js":"replace-in-file \"/main\\.[^\\.]+\\.js/i\" \"main.js\" build/service-worker.js --isRegex","build-fix-serviceworker-css":"replace-in-file \"/main\\.[^\\.]+\\.css/i\" \"main.css\" build/service-worker.js --isRegex","build-fix-assetmanifest":"npm run build-fix-assetmanifest-js && npm run build-fix-assetmanifest-css && npm run build-fix-assetmanifest-js-map && npm run build-fix-assetmanifest-css-map","build-fix-assetmanifest-js":"replace-in-file \"/main\\.[^\\.]+\\.js/i\" \"main.js\" build/asset-manifest.json --isRegex","build-fix-assetmanifest-css":"replace-in-file \"/main\\.[^\\.]+\\.css/i\" \"main.css\" build/asset-manifest.json --isRegex","build-fix-assetmanifest-js-map":"replace-in-file \"/main\\.[^\\.]+\\.js\\.map/i\" \"main.js.map\" build/asset-manifest.json --isRegex","build-fix-assetmanifest-css-map":"replace-in-file \"/main\\.[^\\.]+\\.css\\.map/i\" \"main.css.map\" build/asset-manifest.json --isRegex","test":"react-scripts test --env=jsdom","localTest":"MOCHA_ENV=dev FE_ENV=dev react-scripts test --env=jsdom","eject":"react-scripts eject"},"devDependencies":{"chai":"^4.1.2","chai-http":"^4.0.0","chance":"^1.0.13","enzyme":"^3.3.0","enzyme-adapter-react-16":"^1.1.1","enzyme-to-json":"^3.3.0","jest-cli":"21.2.1","react-test-renderer":"^16.4.1","redux-mock-store":"^1.4.0"},"jest":{"snapshotSerializers":["enzyme-to-json/serializer"]}}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(279);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(629);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),
/* 630 */
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login_css__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoginFields_LoginFields__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StudentsComponent_Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HomeHeaderComponent_HomeHeader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_Facebook_logo_png__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_Facebook_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_Facebook_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_DataTrackingPoints__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var logo_maze=__webpack_require__(50);var logo_kidspeak=__webpack_require__(42);var logo_slashtest=__webpack_require__(51);var logo_wordmark=__webpack_require__(46);var logo_ideasthatwork=__webpack_require__(322);var img_shrimp=__webpack_require__(323);var img_fish=__webpack_require__(324);var img_seahorse=__webpack_require__(325);var ResourcesLinkComponent=function(_Component){_inherits(ResourcesLinkComponent,_Component);function ResourcesLinkComponent(props){_classCallCheck(this,ResourcesLinkComponent);var _this=_possibleConstructorReturn(this,(ResourcesLinkComponent.__proto__||Object.getPrototypeOf(ResourcesLinkComponent)).call(this,props));_this.state={analytics:{type:null,metadata:null}};_this.handleClick=_this.handleClick.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);return _this;}_createClass(ResourcesLinkComponent,[{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_14__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleClick',value:function handleClick(){var _this2=this;this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_16__Shared_DataTrackingPoints__["b" /* default */].RESOURCES_DOWNLOAD,metadata:{resourceId:this.props.value}}},function(){return _this2.handleAnalytics();});}},{key:'render',value:function render(){var sameTab=this.props.sameTab;var target=void 0;if(sameTab){target="";}else{target="_blank";}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.download==="No"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleClick,href:this.props.url,target:target},this.props.title):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleClick,href:this.props.url,target:target,download:true},this.props.title));}}]);return ResourcesLinkComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var LoginComponent=function(_Component2){_inherits(LoginComponent,_Component2);function LoginComponent(props){_classCallCheck(this,LoginComponent);var _this3=_possibleConstructorReturn(this,(LoginComponent.__proto__||Object.getPrototypeOf(LoginComponent)).call(this,props));_this3.setUser=function(user){_this3.props.callback(user);};_this3.state={showIntro:false,modalDialog:false,responseContent:''};_this3.showIntro=_this3.showIntro.bind(_this3);_this3.hideIntro=_this3.hideIntro.bind(_this3);_this3.handleIntro=_this3.handleIntro.bind(_this3);return _this3;}_createClass(LoginComponent,[{key:'showIntro',value:function showIntro(){this.setState({showIntro:true});}},{key:'hideIntro',value:function hideIntro(){this.setState({showIntro:false});}},{key:'handleIntro',value:function handleIntro(){if(this.state.showIntro){this.hideIntro();}else{this.showIntro();}}},{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this4=this;var version;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:version=__WEBPACK_IMPORTED_MODULE_13__Shared_Consts__["d" /* VERSION */];_context2.next=3;return __WEBPACK_IMPORTED_MODULE_14__Shared_REST__["a" /* default */].getVersion().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var newVersion;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:newVersion=response.body;if(newVersion!==version){/*
                this.setState({
                    modalDialog: true,
                    responseContent:'The version of the website on your browser is behind the newest version. Please click the close button to get the updated version.'
                });*/};case 3:case'end':return _context.stop();}}},_callee,_this4);}));return function(_x){return _ref2.apply(this,arguments);};}());case 3:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__HomeHeaderComponent_HomeHeader__["a" /* default */],{currentItem:"Home"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this5.setState({modalDialog:active});window.location.reload();}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Login,{callback:this.setUser}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Games,{handleIntro:this.handleIntro}));}}]);return LoginComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Login=function(_Component3){_inherits(Login,_Component3);function Login(){var _ref3;var _temp,_this6,_ret;_classCallCheck(this,Login);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this6=_possibleConstructorReturn(this,(_ref3=Login.__proto__||Object.getPrototypeOf(Login)).call.apply(_ref3,[this].concat(args))),_this6),_this6.setUser=function(user){_this6.props.callback(user);},_temp),_possibleConstructorReturn(_this6,_ret);}_createClass(Login,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGreen'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'SIMPLE, FREE TOOLS TO MONITOR STUDENT PROGRESS'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'homePageContent',className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'icon1',className:'icons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:img_seahorse,style:{marginLeft:-5,width:72,height:87},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'icon2',className:'icons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:img_fish,style:{marginTop:-15,width:72,height:87},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'homepageDescription',className:'col-md-9 aboutDescription'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'PROGRESS MONITORING APPS '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Early language, Reading and Writing tasks'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'ASL and English measures'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'K-6th Grade Level'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'EASY, INFORMATIVE AND FUN FOR TEACHERS AND STUDENTS'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Efficient 1 to 3 minute tasks'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sensitive to literacy growth'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Selected auto scoring & feedback'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Student charts created automatically'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'PROFESSIONAL DEVELOPMENT'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ResourcesLinkComponent,{value:1001,url:"https://docs.google.com/document/d/14MTpZssueNlSFK113saxzpq5xf_S_dpfDBRKkxt-Mcw/edit",title:"Options for teachers"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'loginBox',className:'col-md-3 bgGrey roundCorners',style:{paddingBottom:20,paddingTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'formLogin1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LoginFields_LoginFields__["a" /* default */],{callbackFromParent:this.setUser})))))));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Description=function(_Component4){_inherits(Description,_Component4);function Description(props){_classCallCheck(this,Description);var _this7=_possibleConstructorReturn(this,(Description.__proto__||Object.getPrototypeOf(Description)).call(this,props));_this7.state={showData:_this7.props.showData};return _this7;}_createClass(Description,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var gradingDescription="";if(this.props.showData===1){gradingDescription='<p>Picture Naming is a task designed for students who are just starting to develop their language skills in ASL or English. The student is shown a randomly selected  illustration and prompted to  say or sign the name of the picture. Teachers have a choice of using picture cards and scoring the student’s response on the computer, or having the student’s response video recorded and scoring later.  Picture naming is an indication that language is increasing weekly! ( For more detailed information, please see the Resources page.) </p>';}else if(this.props.showData===2){gradingDescription='<p>Word SignSay is a task that indicates the  student’s fluency with high frequency English words. The student  is shown a randomly selected isolated word for 3 seconds and prompted to say, sign or Cue the word. The student’s response is recorded and sent to the teacher for scoring. Word SignSign is an indicator of a student’s familiarity with high frequency words.  ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===3){gradingDescription='<p>CopyRight is a measure of a student’s short term recall of ASL.  The student  views a video of randomly selected ASL phrases and is prompted to copy or repeat the ASL story. The student’s signing is recorded and sent to the teacher.  Key items are scored as correct or incorrect. The number of correct items is automatically recorded and graphed. CopyRight is an aid in determining a student’s readiness for working with an interpreter in the classroom as well as comprehension of short ASL stories. ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===4){gradingDescription='<p>SLASH is a task where the student is presented with a block of text, however the text has no spaces! The student reads the passage and marks where the spaces should be to create meaningful words and sentences. The task is automatically graded at the end of each passage giving the student immediate feedback. The student can see the score, goals, and what is needed to unlock new levels. SLASH is a measure of a student’s comprehension of language patterns, semantic complexity, and using words in context. ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===5){gradingDescription='<p>Kid Sign/Say is a task developed to identify a student’s skills in comprehension of English text and  translating the main ideas into American Sign Language.  The student views an English text passage displayed on the screen and  is prompted to retell the story in sign language. The student\'s signed story retell is recorded and saved. The student can watch the recording, try again, or submit the recording to the teacher.   AvePM records the scores  and shows the teacher  student’s progress across levels. ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===6){gradingDescription='<p>AvePM KidSpeak is an e-version of a common progress monitoring indicator-oral reading fluency and comprehension. Students see a text-based passage on the screen and are asked to read it aloud.  The recording is saved and sent to the teacher/teacher’s aid to score. Scoring is easy, quick and AvePM collects the results and graphs them for the teacher. Students can use KidSpeak independently. ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===7){gradingDescription='<p>AvePM MAZE is an e-version of a common progress monitoring maze task.  The  student has one minute to read a story where every 7th word is deleted.  Each deleted word is replaced with  a multiple choice of 3 words. The student selects the word that best completes the story. The task is automatically scored and graphed.  Students, teachers and parents can see  progress weekly or monthly throughout the school year. The data can be used to identify the present level of performance and set IEP goals.( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===8){gradingDescription='<p>AvePM’s WordMark can be used to monitor a student’s progress in writing. Students are given a randomly selected story prompt  and  one minute to think about the topic and three minutes to type the story. The story is saved and sent to the teacher for scoring. Scoring is based on CBM rules: number of words written, number of correct word sequences, and number of incorrect word sequences. The scores are graphed and the student and teacher can monitor progress. ( For more detailed information, please see the Resources page.) </p>';}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"aboutDescription",dangerouslySetInnerHTML:{__html:gradingDescription}});}}]);return Description;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Games=function(_Component5){_inherits(Games,_Component5);function Games(props){_classCallCheck(this,Games);var _this8=_possibleConstructorReturn(this,(Games.__proto__||Object.getPrototypeOf(Games)).call(this,props));_this8.state={showData:1,showMore:false,showMoreText:'More Info'};return _this8;}_createClass(Games,[{key:'componentDidMount',value:function componentDidMount(){this.handleSelect(1);}},{key:'handleShowMore',value:function handleShowMore(){if(this.state.showMore){this.setState({showMore:false});this.setState({showMoreText:'More Info'});}else{this.setState({showMore:true});this.setState({showMoreText:'Less Info'});}}},{key:'handleSelect',value:function handleSelect(tabNum){this.setState({showData:tabNum});this.setState({showMore:false});this.setState({showMoreText:'More Info'});}},{key:'render',value:function render(){var _this9=this;var items=null;var gradingTitle=void 0,videoURL=void 0,appIntro1=void 0,appIntro2=void 0,appIntro3=void 0,appIntro4=void 0;if(this.state.showData===1){gradingTitle="Picture Naming";videoURL="T-K7iPINYhE";appIntro1="Picture Naming is designed for students who are just starting to develop their language skills in American Sign Language (ASL) or English. ";appIntro2="Picture naming is an indication that language ability is increasing weekly!";appIntro3="The student is shown a randomly selected illustration and prompted to say or sign the name of the picture. Teachers have a choice of using picture cards and scoring the student’s response on the computer, or having the student’s response video recorded and scoring later. ";appIntro4="We offer grading assistance. Please contact us.";}else if(this.state.showData===2){gradingTitle="Word Sign/Say";videoURL="LPCl6H7IEWA";appIntro1="Word Sign / Say is a task that indicates the student’s fluency with high frequency English words. ";appIntro2="Word SignSay is an indicator of a student’s familiarity with high frequency words.";appIntro3="The student is shown a randomly selected isolated word for 3 seconds and prompted to say, sign or cue the word. The student’s response is recorded and sent to the teacher for scoring. ";appIntro4="We offer grading assistance. Please contact us.";}else if(this.state.showData===3){gradingTitle="CopyRight";videoURL="FOAwwHgvrdo";appIntro1="CopyRight is a measure of a student’s short term recall of ASL. ";appIntro2="CopyRight is an aid in determining a student’s readiness for working with an interpreter in the classroom as well as comprehension of short ASL stories. ";appIntro3="The student views a video of randomly selected ASL phrases and is prompted to copy or repeat the ASL story. The student’s signing is recorded and sent to the teacher. Key items are scored as correct or incorrect. The number of correct items is automatically recorded and graphed. ";appIntro4="We offer grading assistance. Please contact us.";}else if(this.state.showData===4){gradingTitle="Slash";videoURL="kX9ddoylIok";appIntro1="SLASH is a task where the student is presented with a block of text, however the text has no spaces! ";appIntro2="The student reads the passage and marks where the spaces should be to create meaningful words and sentences. The task is automatically graded at the end of each passage giving the student immediate feedback. The student can see the score, goals, and what is needed to unlock new levels.";appIntro3="SLASH is a measure of a student’s comprehension of language patterns, semantic complexity and using words in context. ";appIntro4="Automatically scored and graphed.";}else if(this.state.showData===5){gradingTitle="KidSpeak";videoURL="CuVc8UtYu4M";appIntro1="";appIntro2="KidSpeak is an e-verison of a common progress monitoring indicator for oral reading fluency and comprehension. ";appIntro3="Students see a text-based passage on the screen and are asked to read it aloud. The recording is saved and sent to the teacher/teacher’s aid to score. Scoring is easy, quick and AvePM collects the results and graphs them for the teacher. Students can use KidSpeak independently. ";appIntro4="We offer grading assistance. Please contact us.";}else if(this.state.showData===6){gradingTitle="MAZE";videoURL="FJquK6s3-6g";appIntro1="MAZE is an e-version of a common progress monitoring maze task.";appIntro2="The data can be used to identify the present level of performance and  set IEP goals. ";appIntro3="The student has 1 minute to read a story. Every 7th word is replaced with a multiple choice of 3 words. The student selects the word that best completes the story. ";appIntro4="Automatically scored and graphed.";}else if(this.state.showData===7){gradingTitle="Kid Sign/Say";videoURL="zxPnjNnt1Dk";appIntro1="";appIntro2="Kid Sign/Say is a task developed to identify a student’s skills in comprehension of English text and translating the main ideas into ASL. ";appIntro3="The student views an English text passage displayed on the screen and is prompted to retell the story is sign language. The student's signed story retell is recorded and saved. The student can watch the recording, try again, or submit the recording to the teacher. AvePM records the scores and shows the teacher student’s progress across levels.";appIntro4="We offer grading assistance. Please contact us.";}else if(this.state.showData===8){gradingTitle="Word Mark";videoURL="PIcHfv3pfU0";appIntro1="";appIntro2="WordMark can be used to monitor a student’s progress in writing. ";appIntro3="Students are given a randomly selected story prompt and one minute to think about the topic and three minutes to type the story. The story is saved and sent to the teacher for scoring. Scoring is based on CBM rules: number of words written, number of correct word sequences, and number of incorrect word sequences. The scores are graphed and the student and teacher can monitor progress.";appIntro4="We offer grading assistance. Please contact us.";}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgYellow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'icon3',className:'icons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:img_shrimp,style:{marginLeft:-35,marginTop:-20,width:72,height:87},alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'8 Free Apps based on Curriculum-Based Measures'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Use Progress Monitoring to track students\' weekly/ monthly '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'performance and set learning and IEP goals'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{id:'appIconBox',className:this.state.showData===4||this.state.showData===6?"nav nav-pills pill iconPositionFix":"nav nav-pills pill"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===1?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this9.handleSelect(1);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_app_picturenaming_png___default.a,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:this.state.showData===1?'icon-label underline':'icon-label'},' PICTURE',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'NAMING')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===2?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this9.handleSelect(2);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_images_app_wordsignsay_png___default.a,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:this.state.showData===2?'icon-label underline':'icon-label'},'WORD',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'SIGN/SAY')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===3?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this9.handleSelect(3);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_app_copyright_png___default.a,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:this.state.showData===3?'icon-label underline':'icon-label'},'COPY',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'RIGHT')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===4?"active single-line":"single-line"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this9.handleSelect(4);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:logo_slashtest,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:this.state.showData===4?'icon-label underline':'icon-label'},'SLASH')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===5?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this9.handleSelect(5);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:logo_kidspeak,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:this.state.showData===5?'icon-label underline':'icon-label'},'KID',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'SPEAK')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===6?"active single-line":"single-line"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this9.handleSelect(6);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:logo_maze,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:this.state.showData===6?'icon-label underline':'icon-label'},'MAZE')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===7?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this9.handleSelect(7);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__assets_images_app_kidsignsay_png___default.a,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:this.state.showData===7?'icon-label underline':'icon-label'},'KID',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'SIGN/SAY')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:this.state.showData===8?"active":""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this9.handleSelect(8);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:logo_wordmark,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:this.state.showData===8?'icon-label underline':'icon-label'},'WORD',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'MARK'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'tab_maze',className:'tab-pane fade in active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'arrow-down arrowYellow'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{style:{fontSize:30}},gradingTitle,' >>'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'appIntroBox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appIntro'},appIntro1),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appIntro'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'How does it work? '),appIntro3),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appIntro'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'How is it used? '),appIntro2),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appIntro'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Grading: '),appIntro4))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'introVideo',className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StudentsComponent_Common__["h" /* YouTubeVideoComponent */],{url:"https://www.youtube.com/embed/"+videoURL+"?rel=0"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'videoLabel'},'Video: Introduction to ',gradingTitle))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('footer',{className:'bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{marginBottom:25}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-2',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Follow us: ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-10',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:1,marginLeft:-30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://twitter.com/AvenuePM",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Twitter')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:95,marginTop:-28}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://www.facebook.com/profile.php?id=100009224578527&lst=100006500830477%3A100009224578527%3A1587693428&sk=timeline",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_Facebook_logo_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Facebook')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{textAlign:'left'}},'This website was developed by the avenuePM team pursuant to Cooperative Agreement CFDA H327S170012 with the Office of Special Education Programs, United States Department of Education, Terry Jackson, Project Officer. The opinions expressed and materials contained herein do not necessarily reflect the position or policy of the United States Department of Education and you should not assume endorsement by the Federal Government.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://www.psu.edu/web-privacy-statement/",target:'_blank'},'Web Privacy Statement')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://docs.google.com/document/d/1uE2ksBcVYHP0rVIUIxrfUupfK1NW4vOZH4kQJ1B6a68/edit",target:'_blank'},'Children\u2019s Online Privacy Protection Act (COPPA) statement')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'\xA9',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('script',null,'new Date().getFullYear() > 2010 && document.write(new Date().getFullYear());'),' Designed and developed by researchers at the University of Minnesota and Penn State University.(v.',__WEBPACK_IMPORTED_MODULE_13__Shared_Consts__["d" /* VERSION */],')'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:logo_ideasthatwork,alt:'Logo - Ideas That Work. U.S. Office of Special Education Programs',border:'0'}))))));}}]);return Games;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoginComponent);

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(637);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(282);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(283);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      var isOpen = newProps.isOpen;
      // Stop unnecessary renders if modal is remaining closed

      if (!this.props.isOpen && !isOpen) return;

      var currentParent = getParentElement(this.props.parentSelector);
      var newParent = getParentElement(newProps.parentSelector);

      if (newParent !== currentParent) {
        currentParent.removeChild(this.node);
        newParent.appendChild(this.node);
      }

      !isReact16 && this.renderPortal(newProps);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      if (newProps.portalClassName !== this.props.portalClassName) {
        this.node.className = newProps.portalClassName;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
exports.default = Modal;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(638);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(639);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(282);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(640);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(283);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setFocusAfterRender = function (focus) {
      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
    };

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
    };

    _this.handleOverlayOnMouseUp = function () {
      if (_this.moveFromContentToOverlay === null) {
        _this.shouldClose = false;
      }
      if (_this.props.shouldCloseOnOverlayClick) {
        _this.shouldClose = true;
      }
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
      _this.moveFromContentToOverlay = false;
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
      _this.moveFromContentToOverlay = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc["aria-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Focus needs to be set when mounting and already open
      if (this.props.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (false) {
        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (newProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }
      // Focus only needs to be set once when the modal is being opened
      if (!this.props.isOpen && newProps.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      } else if (this.props.isOpen && !newProps.isOpen) {
        this.close();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.focusAfterRender) {
        this.focusContent();
        this.setFocusAfterRender(false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          onMouseUp: this.handleOverlayOnMouseUp,
          "aria-modal": "true"
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.ariaAttributes(this.props.aria || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  }
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(281);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(281);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prune, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(128);

var _utils = __webpack_require__(39);

var _players = __webpack_require__(645);

var _players2 = _interopRequireDefault(_players);

var _Player3 = __webpack_require__(189);

var _Player4 = _interopRequireDefault(_Player3);

var _FilePlayer = __webpack_require__(288);

var _preload = __webpack_require__(651);

var _preload2 = _interopRequireDefault(_preload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SUPPORTED_PROPS = Object.keys(_props2.propTypes);

var customPlayers = [];

var ReactPlayer = function (_Component) {
  _inherits(ReactPlayer, _Component);

  function ReactPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.getDuration = function () {
      if (!_this.player) return null;
      return _this.player.getDuration();
    }, _this.getCurrentTime = function () {
      if (!_this.player) return null;
      return _this.player.getCurrentTime();
    }, _this.getSecondsLoaded = function () {
      if (!_this.player) return null;
      return _this.player.getSecondsLoaded();
    }, _this.getInternalPlayer = function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';

      if (!_this.player) return null;
      return _this.player.getInternalPlayer(key);
    }, _this.seekTo = function (fraction) {
      if (!_this.player) return null;
      _this.player.seekTo(fraction);
    }, _this.onReady = function () {
      _this.props.onReady(_this);
    }, _this.wrapperRef = function (wrapper) {
      _this.wrapper = wrapper;
    }, _this.activePlayerRef = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.progressFrequency) {
        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _utils.isEqual)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
    }
  }, {
    key: 'getActivePlayer',
    value: function getActivePlayer(url) {
      var _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

      for (var _i = 0; _i < _arr.length; _i++) {
        var _Player = _arr[_i];
        if (_Player.canPlay(url)) {
          return _Player;
        }
      }
      // Fall back to FilePlayer if nothing else can play the URL
      return _FilePlayer.FilePlayer;
    }
  }, {
    key: 'renderActivePlayer',
    value: function renderActivePlayer(url) {
      if (!url) return null;
      var activePlayer = this.getActivePlayer(url);
      return _react2['default'].createElement(_Player4['default'], _extends({}, this.props, {
        key: activePlayer.displayName,
        ref: this.activePlayerRef,
        config: this.config,
        activePlayer: activePlayer,
        onReady: this.onReady
      }));
    }
  }, {
    key: 'sortPlayers',
    value: function sortPlayers(a, b) {
      // Retain player order to prevent weird iframe behaviour when switching players
      if (a && b) {
        return a.key < b.key ? -1 : 1;
      }
      return 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          style = _props.style,
          width = _props.width,
          height = _props.height,
          Wrapper = _props.wrapper;

      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
      var activePlayer = this.renderActivePlayer(url);
      var preloadPlayers = (0, _preload2['default'])(url, this.config);
      var players = [activePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);
      return _react2['default'].createElement(
        Wrapper,
        _extends({ ref: this.wrapperRef, style: _extends({}, style, { width: width, height: height }) }, otherProps),
        players
      );
    }
  }]);

  return ReactPlayer;
}(_react.Component);

ReactPlayer.addCustomPlayer = function (player) {
  customPlayers.push(player);
};

ReactPlayer.removeCustomPlayers = function () {
  customPlayers = [];
};

ReactPlayer.displayName = 'ReactPlayer';
ReactPlayer.propTypes = _props2.propTypes;
ReactPlayer.defaultProps = _props2.defaultProps;

ReactPlayer.canPlay = function (url) {
  var _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var _Player2 = _arr2[_i2];
    if (_Player2.canPlay(url)) {
      return true;
    }
  }
  return false;
};

exports['default'] = ReactPlayer;

/***/ }),
/* 643 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _YouTube = __webpack_require__(284);

var _SoundCloud = __webpack_require__(285);

var _Vimeo = __webpack_require__(286);

var _Facebook = __webpack_require__(646);

var _Streamable = __webpack_require__(647);

var _Wistia = __webpack_require__(648);

var _Twitch = __webpack_require__(649);

var _DailyMotion = __webpack_require__(287);

var _Mixcloud = __webpack_require__(650);

var _FilePlayer = __webpack_require__(288);

exports['default'] = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Facebook = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var MATCH_URL = /facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = exports.Facebook = function (_Component) {
  _inherits(Facebook, _Component);

  function Facebook() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Facebook.__proto__ || Object.getPrototypeOf(Facebook)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Facebook, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.facebook.appId,
          xfbml: true,
          version: 'v2.5'
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;
            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
            _this2.player.subscribe('paused', _this2.props.onPause);
            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
            _this2.player.subscribe('error', _this2.props.onError);
            if (!_this2.props.muted) {
              // Player is muted by default
              _this2.callPlayer('unmute');
            }
            _this2.props.onReady();
          }
        });
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%',
        backgroundColor: 'black'
      };
      return _react2['default'].createElement('div', {
        style: style,
        id: this.playerID,
        className: 'fb-video',
        'data-href': this.props.url,
        'data-autoplay': this.props.playing ? 'true' : 'false',
        'data-allowfullscreen': 'true',
        'data-controls': this.props.controls ? 'true' : 'false'
      });
    }
  }]);

  return Facebook;
}(_react.Component);

Facebook.displayName = 'Facebook';

Facebook.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Facebook.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Facebook);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Streamable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';
var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;

var Streamable = exports.Streamable = function (_Component) {
  _inherits(Streamable, _Component);

  function Streamable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Streamable.__proto__ || Object.getPrototypeOf(Streamable)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Streamable, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);
        _this2.player.setLoop(_this2.props.loop);
        _this2.player.on('ready', _this2.props.onReady);
        _this2.player.on('play', _this2.props.onPlay);
        _this2.player.on('pause', _this2.props.onPause);
        _this2.player.on('seeked', _this2.props.onSeek);
        _this2.player.on('ended', _this2.props.onEnded);
        _this2.player.on('error', _this2.props.onError);
        _this2.player.on('timeupdate', function (_ref2) {
          var duration = _ref2.duration,
              seconds = _ref2.seconds;

          _this2.duration = duration;
          _this2.currentTime = seconds;
        });
        _this2.player.on('buffered', function (_ref3) {
          var percent = _ref3.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });
        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.props.url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        src: 'https://streamable.com/o/' + id,
        frameBorder: '0',
        scrolling: 'no',
        style: style,
        allowFullScreen: true
      });
    }
  }]);

  return Streamable;
}(_react.Component);

Streamable.displayName = 'Streamable';

Streamable.canPlay = function (url) {
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Streamable);

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wistia = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;

var Wistia = exports.Wistia = function (_Component) {
  _inherits(Wistia, _Component);

  function Wistia() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Wistia.__proto__ || Object.getPrototypeOf(Wistia)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Wistia, [{
    key: 'getID',
    value: function getID(url) {
      return url && url.match(MATCH_URL)[1];
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          muted = _props.muted,
          controls = _props.controls,
          _onReady = _props.onReady,
          onPlay = _props.onPlay,
          onPause = _props.onPause,
          onSeek = _props.onSeek,
          onEnded = _props.onEnded,
          config = _props.config;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
        window._wq = window._wq || [];
        window._wq.push({
          id: _this2.getID(url),
          options: _extends({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls
          }, config.wistia.options),
          onReady: function onReady(player) {
            _this2.player = player;
            _this2.player.bind('play', onPlay);
            _this2.player.bind('pause', onPause);
            _this2.player.bind('seek', onSeek);
            _this2.player.bind('end', onEnded);
            _onReady();
          }
        });
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('remove');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.getID(this.props.url);
      var className = 'wistia_embed wistia_async_' + id;
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('div', { key: id, className: className, style: style });
    }
  }]);

  return Wistia;
}(_react.Component);

Wistia.displayName = 'Wistia';

Wistia.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Wistia.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Wistia);

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = exports.Twitch = function (_Component) {
  _inherits(Twitch, _Component);

  function Twitch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Twitch.__proto__ || Object.getPrototypeOf(Twitch)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
      _this.callPlayer('setMuted', true);
    }, _this.unmute = function () {
      _this.callPlayer('setMuted', false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Twitch, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      var _props = this.props,
          playsinline = _props.playsinline,
          onError = _props.onError,
          config = _props.config;

      var isChannel = MATCH_CHANNEL_URL.test(url);
      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];
      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _extends({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted
        }, config.twitch.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAY = _Twitch$Player.PLAY,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED;

        _this2.player.addEventListener(READY, _this2.props.onReady);
        _this2.player.addEventListener(PLAY, _this2.props.onPlay);
        _this2.player.addEventListener(PAUSE, _this2.props.onPause);
        _this2.player.addEventListener(ENDED, _this2.props.onEnded);
      }, onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('div', { style: style, id: this.playerID });
    }
  }]);

  return Twitch;
}(_react.Component);

Twitch.displayName = 'Twitch';

Twitch.canPlay = function (url) {
  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
};

Twitch.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Twitch);

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mixcloud = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(39);

var _singlePlayer = __webpack_require__(53);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';
var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;

var Mixcloud = exports.Mixcloud = function (_Component) {
  _inherits(Mixcloud, _Component);

  function Mixcloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Mixcloud.__proto__ || Object.getPrototypeOf(Mixcloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      // No volume support
    }, _this.unmute = function () {
      // No volume support
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Mixcloud, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);
          _this2.player.events.pause.on(_this2.props.onPause);
          _this2.player.events.ended.on(_this2.props.onEnded);
          _this2.player.events.error.on(_this2.props.error);
          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });
          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      // No volume support
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          config = _props.config;

      var id = url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, _utils.queryString)(_extends({}, config.mixcloud.options, {
        feed: '/' + id + '/'
      }));
      // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track
      return _react2['default'].createElement('iframe', {
        key: id,
        ref: this.ref,
        style: style,
        src: 'https://www.mixcloud.com/widget/iframe/?' + query,
        frameBorder: '0'
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

Mixcloud.displayName = 'Mixcloud';

Mixcloud.canPlay = function (url) {
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Mixcloud);

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = renderPreloadPlayers;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Player = __webpack_require__(189);

var _Player2 = _interopRequireDefault(_Player);

var _YouTube = __webpack_require__(284);

var _SoundCloud = __webpack_require__(285);

var _Vimeo = __webpack_require__(286);

var _DailyMotion = __webpack_require__(287);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PRELOAD_PLAYERS = [{
  Player: _YouTube.YouTube,
  configKey: 'youtube',
  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
}, {
  Player: _SoundCloud.SoundCloud,
  configKey: 'soundcloud',
  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
}, {
  Player: _Vimeo.Vimeo,
  configKey: 'vimeo',
  url: 'https://vimeo.com/127250231'
}, {
  Player: _DailyMotion.DailyMotion,
  configKey: 'dailymotion',
  url: 'http://www.dailymotion.com/video/xqdpyk'
}];

function renderPreloadPlayers(url, config) {
  var players = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = PRELOAD_PLAYERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var player = _step.value;

      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
        players.push(_react2['default'].createElement(_Player2['default'], {
          key: player.Player.displayName,
          activePlayer: player.Player,
          url: player.url,
          playing: true,
          muted: true,
          style: { display: 'none' }
        }));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return players;
}

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(653);


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(56);

var ReactBaseClasses = __webpack_require__(290);
var ReactChildren = __webpack_require__(655);
var ReactDOMFactories = __webpack_require__(660);
var ReactElement = __webpack_require__(87);
var ReactPropTypes = __webpack_require__(661);
var ReactVersion = __webpack_require__(665);

var createReactClass = __webpack_require__(666);
var onlyChild = __webpack_require__(667);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(656);
var ReactElement = __webpack_require__(87);

var emptyFunction = __webpack_require__(94);
var traverseAllChildren = __webpack_require__(657);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(129);

var invariant = __webpack_require__(57);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(129);

var ReactCurrentOwner = __webpack_require__(294);
var REACT_ELEMENT_TYPE = __webpack_require__(295);

var getIteratorFn = __webpack_require__(658);
var invariant = __webpack_require__(57);
var KeyEscapeUtils = __webpack_require__(659);
var warning = __webpack_require__(130);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(87);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(87),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(662);

module.exports = factory(isValidElement);

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(663);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(94);
var invariant = __webpack_require__(57);
var warning = __webpack_require__(130);
var assign = __webpack_require__(56);

var ReactPropTypesSecret = __webpack_require__(211);
var checkPropTypes = __webpack_require__(664);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(290),
    Component = _require.Component;

var _require2 = __webpack_require__(87),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(291);
var factory = __webpack_require__(296);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(129);

var ReactElement = __webpack_require__(87);

var invariant = __webpack_require__(57);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global window */

var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

var isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;

exports.isBrowser = isBrowser;
exports.isNode = isNode;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level0.c93bfc2b.png";

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level1.05f20712.png";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level2.a71ca673.png";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level3.badba255.png";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level4.6e5719a8.png";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level5.d8152f59.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level6.4dbcc264.png";

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level8.1569e360.png";

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level10.27add6c7.png";

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/level11.5230f863.png";

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(684), __webpack_require__(0), __webpack_require__(1)) :
  typeof define === 'function' && define.amd ? define(['exports', 'lottie-web', 'react', 'prop-types'], factory) :
  (global = global || self, factory(global['lottie-react'] = {}, global.Lottie, global.React, global.PropTypes));
}(this, (function (exports, lottie, React, PropTypes) { 'use strict';

  lottie = lottie && Object.prototype.hasOwnProperty.call(lottie, 'default') ? lottie['default'] : lottie;
  var React__default = 'default' in React ? React['default'] : React;

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var useLottie = function useLottie(props, style) {
    var animationData = props.animationData,
        loop = props.loop,
        autoplay = props.autoplay,
        initialSegment = props.initialSegment,
        onComplete = props.onComplete,
        onLoopComplete = props.onLoopComplete,
        onEnterFrame = props.onEnterFrame,
        onSegmentStart = props.onSegmentStart,
        onConfigReady = props.onConfigReady,
        onDataReady = props.onDataReady,
        onDataFailed = props.onDataFailed,
        onLoadedImages = props.onLoadedImages,
        onDOMLoaded = props.onDOMLoaded,
        onDestroy = props.onDestroy,
        lottieRef = props.lottieRef,
        renderer = props.renderer,
        name = props.name,
        assetsPath = props.assetsPath,
        rendererSettings = props.rendererSettings,
        rest = _objectWithoutProperties(props, ["animationData", "loop", "autoplay", "initialSegment", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart", "onConfigReady", "onDataReady", "onDataFailed", "onLoadedImages", "onDOMLoaded", "onDestroy", "lottieRef", "renderer", "name", "assetsPath", "rendererSettings"]);

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        animationLoaded = _useState2[0],
        setAnimationLoaded = _useState2[1];

    var animationInstanceRef = React.useRef();
    var animationContainer = React.useRef(null);
    /*
          ======================================
              INTERACTION METHODS
          ======================================
       */

    /**
     * Play
     */

    var play = function play() {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.play();
    };
    /**
     * Stop
     */


    var stop = function stop() {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.stop();
    };
    /**
     * Pause
     */


    var pause = function pause() {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.pause();
    };
    /**
     * Set animation speed
     * @param speed
     */


    var setSpeed = function setSpeed(speed) {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSpeed(speed);
    };
    /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */


    var goToAndPlay = function goToAndPlay(value, isFrame) {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndPlay(value, isFrame);
    };
    /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */


    var goToAndStop = function goToAndStop(value, isFrame) {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.goToAndStop(value, isFrame);
    };
    /**
     * Set animation direction
     * @param direction
     */


    var setDirection = function setDirection(direction) {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setDirection(direction);
    };
    /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */


    var playSegments = function playSegments(segments, forceFlag) {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.playSegments(segments, forceFlag);
    };
    /**
     * Set sub frames
     * @param useSubFrames
     */


    var setSubframe = function setSubframe(useSubFrames) {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.setSubframe(useSubFrames);
    };
    /**
     * Get animation duration
     * @param inFrames
     */


    var getDuration = function getDuration(inFrames) {
      var _a;

      return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
    };
    /**
     * Destroy animation
     */


    var destroy = function destroy() {
      var _a;

      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
    };
    /*
          ======================================
              LOTTIE
          ======================================
       */

    /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */


    var loadAnimation = function loadAnimation() {
      var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _a; // Return if the container ref is null


      if (!animationContainer.current) {
        return;
      } // Destroy any previous instance


      (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.destroy(); // Build the animation configuration

      var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
        container: animationContainer.current
      }); // Save the animation instance


      animationInstanceRef.current = lottie.loadAnimation(config);
      setAnimationLoaded(!!animationInstanceRef.current);
    };
    /**
     * Initialize and listen for changes that need to reinitialize Lottie
     */


    React.useEffect(function () {
      loadAnimation();
    }, [animationData, loop, autoplay, initialSegment]);
    /*
          ======================================
              EVENTS
          ======================================
       */

    /**
     * Reinitialize listener on change
     */

    React.useEffect(function () {
      var partialListeners = [{
        name: "complete",
        handler: onComplete
      }, {
        name: "loopComplete",
        handler: onLoopComplete
      }, {
        name: "enterFrame",
        handler: onEnterFrame
      }, {
        name: "segmentStart",
        handler: onSegmentStart
      }, {
        name: "config_ready",
        handler: onConfigReady
      }, {
        name: "data_ready",
        handler: onDataReady
      }, {
        name: "data_failed",
        handler: onDataFailed
      }, {
        name: "loaded_images",
        handler: onLoadedImages
      }, {
        name: "DOMLoaded",
        handler: onDOMLoaded
      }, {
        name: "destroy",
        handler: onDestroy
      }];
      var listeners = partialListeners.filter(function (listener) {
        return listener.handler != null;
      });

      if (!listeners.length) {
        return;
      }

      var deregisterList = listeners.map(
      /**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */
      function (listener) {
        var _a;

        (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(listener.name, listener.handler); // Return a function to deregister this listener

        return function () {
          var _a;

          (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(listener.name, listener.handler);
        };
      }); // Deregister listeners on unmount

      return function () {
        deregisterList.forEach(function (deregister) {
          return deregister();
        });
      };
    }, [onComplete, onLoopComplete, onEnterFrame, onSegmentStart, onConfigReady, onDataReady, onDataFailed, onLoadedImages, onDOMLoaded, onDestroy]);
    /**
     * Build the animation view
     */

    var View = /*#__PURE__*/React__default.createElement("div", Object.assign({
      style: style,
      ref: animationContainer
    }, rest));
    return {
      View: View,
      play: play,
      stop: stop,
      pause: pause,
      setSpeed: setSpeed,
      goToAndStop: goToAndStop,
      goToAndPlay: goToAndPlay,
      setDirection: setDirection,
      playSegments: playSegments,
      setSubframe: setSubframe,
      getDuration: getDuration,
      destroy: destroy,
      animationLoaded: animationLoaded,
      animationItem: animationInstanceRef.current
    };
  };

  function getContainerVisibility(container) {
    var _container$getBoundin = container.getBoundingClientRect(),
        top = _container$getBoundin.top,
        height = _container$getBoundin.height;

    var current = window.innerHeight - top;
    var max = window.innerHeight + height;
    return current / max;
  }
  function getContainerCursorPosition(container, cursorX, cursorY) {
    var _container$getBoundin2 = container.getBoundingClientRect(),
        top = _container$getBoundin2.top,
        left = _container$getBoundin2.left,
        width = _container$getBoundin2.width,
        height = _container$getBoundin2.height;

    var x = (cursorX - left) / width;
    var y = (cursorY - top) / height;
    return {
      x: x,
      y: y
    };
  }
  var useInitInteractivity = function useInitInteractivity(_ref) {
    var wrapperRef = _ref.wrapperRef,
        animationItem = _ref.animationItem,
        mode = _ref.mode,
        actions = _ref.actions;
    React.useEffect(function () {
      var wrapper = wrapperRef.current;

      if (!wrapper || !animationItem) {
        return;
      }

      animationItem.stop();

      var scrollModeHandler = function scrollModeHandler() {
        var assignedSegment = null;

        var scrollHandler = function scrollHandler() {
          var currentPercent = getContainerVisibility(wrapper); // Find the first action that satisfies the current position conditions

          var action = actions.find(function (_ref2) {
            var visibility = _ref2.visibility;
            return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
          }); // Skip if no matching action was found!

          if (!action) {
            return;
          }

          if (action.type === "seek" && action.visibility && action.frames.length === 2) {
            // Seek: Go to a frame based on player scroll position action
            var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]); //! goToAndStop must be relative to the start of the current segment

            animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
          }

          if (action.type === "loop") {
            // Loop: Loop a given frames
            if (assignedSegment === null) {
              // if not playing any segments currently. play those segments and save to state
              animationItem.playSegments(action.frames, true);
              assignedSegment = action.frames;
            } else {
              // if playing any segments currently.
              //check if segments in state are equal to the frames selected by action
              if (assignedSegment !== action.frames) {
                // if they are not equal. new segments are to be loaded
                animationItem.playSegments(action.frames, true);
                assignedSegment = action.frames;
              } else if (animationItem.isPaused) {
                // if they are equal the play method must be called only if lottie is paused
                animationItem.playSegments(action.frames, true);
                assignedSegment = action.frames;
              }
            }
          }

          if (action.type === "play" && animationItem.isPaused) {
            // Play: Reset segments and continue playing full animation from current position
            animationItem.resetSegments(true);
            animationItem.play();
          }

          if (action.type === "stop") {
            // Stop: Stop playback
            animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
          }
        };

        document.addEventListener("scroll", scrollHandler);
        return function () {
          document.removeEventListener("scroll", scrollHandler);
        };
      };

      var cursorModeHandler = function cursorModeHandler() {
        var handleCursor = function handleCursor(_x, _y) {
          var x = _x;
          var y = _y; // Resolve cursor position if cursor is inside container

          if (x !== -1 && y !== -1) {
            // Get container cursor position
            var pos = getContainerCursorPosition(wrapper, x, y); // Use the resolved position

            x = pos.x;
            y = pos.y;
          } // Find the first action that satisfies the current position conditions


          var action = actions.find(function (_ref3) {
            var position = _ref3.position;

            if (position && Array.isArray(position.x) && Array.isArray(position.y)) {
              return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
            }

            if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) {
              return x === position.x && y === position.y;
            }

            return false;
          }); // Skip if no matching action was found!

          if (!action) {
            return;
          } // Process action types:


          if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
            // Seek: Go to a frame based on player scroll position action
            var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
            var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
            animationItem.playSegments(action.frames, true);
            animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
          }

          if (action.type === "loop") {
            animationItem.playSegments(action.frames, true);
          }

          if (action.type === "play") {
            // Play: Reset segments and continue playing full animation from current position
            if (animationItem.isPaused) {
              animationItem.resetSegments(false);
            }

            animationItem.playSegments(action.frames);
          }

          if (action.type === "stop") {
            animationItem.goToAndStop(action.frames[0], true);
          }
        };

        var mouseMoveHandler = function mouseMoveHandler(ev) {
          handleCursor(ev.clientX, ev.clientY);
        };

        var mouseOutHandler = function mouseOutHandler() {
          handleCursor(-1, -1);
        };

        wrapper.addEventListener("mousemove", mouseMoveHandler);
        wrapper.addEventListener("mouseout", mouseOutHandler);
        return function () {
          wrapper.removeEventListener("mousemove", mouseMoveHandler);
          wrapper.removeEventListener("mouseout", mouseOutHandler);
        };
      };

      switch (mode) {
        case "scroll":
          return scrollModeHandler();

        case "cursor":
          return cursorModeHandler();
      }
    }, [mode, animationItem]);
  };

  var useLottieInteractivity = function useLottieInteractivity(_ref4) {
    var actions = _ref4.actions,
        mode = _ref4.mode,
        lottieObj = _ref4.lottieObj;
    var animationItem = lottieObj.animationItem,
        View = lottieObj.View;
    var wrapperRef = React.useRef(null);
    useInitInteractivity({
      actions: actions,
      animationItem: animationItem,
      mode: mode,
      wrapperRef: wrapperRef
    });
    return /*#__PURE__*/React__default.createElement("div", {
      ref: wrapperRef
    }, View);
  };

  var Lottie = function Lottie(props) {
    var _a;

    var style = props.style,
        interactivity = props.interactivity,
        lottieProps = _objectWithoutProperties(props, ["style", "interactivity"]);
    /**
     * Initialize the 'useLottie' hook
     */


    var _useLottie = useLottie(lottieProps, style),
        View = _useLottie.View,
        play = _useLottie.play,
        stop = _useLottie.stop,
        pause = _useLottie.pause,
        setSpeed = _useLottie.setSpeed,
        goToAndStop = _useLottie.goToAndStop,
        goToAndPlay = _useLottie.goToAndPlay,
        setDirection = _useLottie.setDirection,
        playSegments = _useLottie.playSegments,
        setSubframe = _useLottie.setSubframe,
        getDuration = _useLottie.getDuration,
        destroy = _useLottie.destroy,
        animationLoaded = _useLottie.animationLoaded,
        animationItem = _useLottie.animationItem;
    /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */


    React.useEffect(function () {
      if (props.lottieRef) {
        props.lottieRef.current = {
          play: play,
          stop: stop,
          pause: pause,
          setSpeed: setSpeed,
          goToAndPlay: goToAndPlay,
          goToAndStop: goToAndStop,
          setDirection: setDirection,
          playSegments: playSegments,
          setSubframe: setSubframe,
          getDuration: getDuration,
          destroy: destroy,
          animationLoaded: animationLoaded,
          animationItem: animationItem
        };
      }
    }, [(_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current]);

    if (interactivity) {
      var EnhancedView = useLottieInteractivity(_objectSpread2({
        lottieObj: {
          View: View,
          play: play,
          stop: stop,
          pause: pause,
          setSpeed: setSpeed,
          goToAndStop: goToAndStop,
          goToAndPlay: goToAndPlay,
          setDirection: setDirection,
          playSegments: playSegments,
          setSubframe: setSubframe,
          getDuration: getDuration,
          destroy: destroy,
          animationLoaded: animationLoaded,
          animationItem: animationItem
        }
      }, interactivity));
      return EnhancedView;
    }

    return View;
  };

  Lottie.propTypes = {
    animationData: PropTypes.shape(undefined).isRequired,
    loop: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    autoplay: PropTypes.bool,
    initialSegment: PropTypes.arrayOf(PropTypes.number.isRequired),
    onComplete: PropTypes.func,
    onLoopComplete: PropTypes.func,
    onEnterFrame: PropTypes.func,
    onSegmentStart: PropTypes.func,
    onConfigReady: PropTypes.func,
    onDataReady: PropTypes.func,
    onDataFailed: PropTypes.func,
    onLoadedImages: PropTypes.func,
    onDOMLoaded: PropTypes.func,
    onDestroy: PropTypes.func,
    style: PropTypes.shape(undefined)
  };
  Lottie.defaultProps = {
    loop: true,
    autoplay: true,
    initialSegment: null,
    onComplete: null,
    onLoopComplete: null,
    onEnterFrame: null,
    onSegmentStart: null,
    onConfigReady: null,
    onDataReady: null,
    onDataFailed: null,
    onLoadedImages: null,
    onDOMLoaded: null,
    onDestroy: null,
    style: undefined
  };

  var Animator = Lottie;
  var useAnimator = useLottie;

  exports.LottiePlayer = lottie;
  exports.Animator = Animator;
  exports.default = Lottie;
  exports.useAnimator = useAnimator;
  exports.useLottie = useLottie;
  exports.useLottieInteractivity = useLottieInteractivity;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.umd.js.map


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(typeof navigator !== "undefined") && (function(root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return factory(root);
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === "object" && module.exports) {
        module.exports = factory(root);
    } else {
        root.lottie = factory(root);
        root.bodymovin = root.lottie;
    }
}((window || {}), function(window) {
	/* global locationHref:writable, animationManager, subframeEnabled:writable, defaultCurveSegments:writable, roundValues,
expressionsPlugin:writable, PropertyFactory, ShapePropertyFactory, Matrix, idPrefix:writable, _useWebWorker:writable */
/* exported locationHref, subframeEnabled, expressionsPlugin, idPrefix, _useWebWorker */

'use strict';

/* exported svgNS, locationHref, initialDefaultFrame, _useWebWorker */

var svgNS = 'http://www.w3.org/2000/svg';

var locationHref = '';

var initialDefaultFrame = -999999;

var _useWebWorker = false;

/* global createSizedArray */
/* exported subframeEnabled, expressionsPlugin, isSafari, cachedColors, bmPow, bmSqrt, bmFloor, bmMax, bmMin, ProjectInterface,
defaultCurveSegments, degToRads, roundCorner, bmRnd, styleDiv, BMEnterFrameEvent, BMCompleteEvent, BMCompleteLoopEvent,
BMSegmentStartEvent, BMDestroyEvent, BMRenderFrameErrorEvent, BMConfigErrorEvent, BMAnimationConfigErrorEvent, createElementID,
addSaturationToRGB, addBrightnessToRGB, addHueToRGB, rgbToHex */

var subframeEnabled = true;
var idPrefix = '';
var expressionsPlugin;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var cachedColors = {};
var bmRnd;
var bmPow = Math.pow;
var bmSqrt = Math.sqrt;
var bmFloor = Math.floor;
var bmMax = Math.max;
var bmMin = Math.min;

var BMMath = {};
(function () {
  var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
  var i;
  var len = propertyNames.length;
  for (i = 0; i < len; i += 1) {
    BMMath[propertyNames[i]] = Math[propertyNames[i]];
  }
}());

function ProjectInterface() { return {}; }

BMMath.random = Math.random;
BMMath.abs = function (val) {
  var tOfVal = typeof val;
  if (tOfVal === 'object' && val.length) {
    var absArr = createSizedArray(val.length);
    var i;
    var len = val.length;
    for (i = 0; i < len; i += 1) {
      absArr[i] = Math.abs(val[i]);
    }
    return absArr;
  }
  return Math.abs(val);
};
var defaultCurveSegments = 150;
var degToRads = Math.PI / 180;
var roundCorner = 0.5519;

function roundValues(flag) {
  if (flag) {
    bmRnd = Math.round;
  } else {
    bmRnd = function (val) {
      return val;
    };
  }
}
roundValues(false);

function styleDiv(element) {
  element.style.position = 'absolute';
  element.style.top = 0;
  element.style.left = 0;
  element.style.display = 'block';
  element.style.transformOrigin = '0 0';
  element.style.webkitTransformOrigin = '0 0';
  element.style.backfaceVisibility = 'visible';
  element.style.webkitBackfaceVisibility = 'visible';
  element.style.transformStyle = 'preserve-3d';
  element.style.webkitTransformStyle = 'preserve-3d';
  element.style.mozTransformStyle = 'preserve-3d';
}

function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
  this.type = type;
  this.currentTime = currentTime;
  this.totalTime = totalTime;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMCompleteEvent(type, frameMultiplier) {
  this.type = type;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
  this.type = type;
  this.currentLoop = currentLoop;
  this.totalLoops = totalLoops;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMSegmentStartEvent(type, firstFrame, totalFrames) {
  this.type = type;
  this.firstFrame = firstFrame;
  this.totalFrames = totalFrames;
}

function BMDestroyEvent(type, target) {
  this.type = type;
  this.target = target;
}

function BMRenderFrameErrorEvent(nativeError, currentTime) {
  this.type = 'renderFrameError';
  this.nativeError = nativeError;
  this.currentTime = currentTime;
}

function BMConfigErrorEvent(nativeError) {
  this.type = 'configError';
  this.nativeError = nativeError;
}

function BMAnimationConfigErrorEvent(type, nativeError) {
  this.type = type;
  this.nativeError = nativeError;
}

var createElementID = (function () {
  var _count = 0;
  return function createID() {
    _count += 1;
    return idPrefix + '__lottie_element_' + _count;
  };
}());

function HSVtoRGB(h, s, v) {
  var r;
  var g;
  var b;
  var i;
  var f;
  var p;
  var q;
  var t;
  i = Math.floor(h * 6);
  f = h * 6 - i;
  p = v * (1 - s);
  q = v * (1 - f * s);
  t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0: r = v; g = t; b = p; break;
    case 1: r = q; g = v; b = p; break;
    case 2: r = p; g = v; b = t; break;
    case 3: r = p; g = q; b = v; break;
    case 4: r = t; g = p; b = v; break;
    case 5: r = v; g = p; b = q; break;
    default: break;
  }
  return [r,
    g,
    b];
}

function RGBtoHSV(r, g, b) {
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var d = max - min;
  var h;
  var s = (max === 0 ? 0 : d / max);
  var v = max / 255;

  switch (max) {
    case min: h = 0; break;
    case r: h = (g - b) + d * (g < b ? 6 : 0); h /= 6 * d; break;
    case g: h = (b - r) + d * 2; h /= 6 * d; break;
    case b: h = (r - g) + d * 4; h /= 6 * d; break;
    default: break;
  }

  return [
    h,
    s,
    v,
  ];
}

function addSaturationToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[1] += offset;
  if (hsv[1] > 1) {
    hsv[1] = 1;
  } else if (hsv[1] <= 0) {
    hsv[1] = 0;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

function addBrightnessToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[2] += offset;
  if (hsv[2] > 1) {
    hsv[2] = 1;
  } else if (hsv[2] < 0) {
    hsv[2] = 0;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

function addHueToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[0] += offset / 360;
  if (hsv[0] > 1) {
    hsv[0] -= 1;
  } else if (hsv[0] < 0) {
    hsv[0] += 1;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

var rgbToHex = (function () {
  var colorMap = [];
  var i;
  var hex;
  for (i = 0; i < 256; i += 1) {
    hex = i.toString(16);
    colorMap[i] = hex.length === 1 ? '0' + hex : hex;
  }

  return function (r, g, b) {
    if (r < 0) {
      r = 0;
    }
    if (g < 0) {
      g = 0;
    }
    if (b < 0) {
      b = 0;
    }
    return '#' + colorMap[r] + colorMap[g] + colorMap[b];
  };
}());

function BaseEvent() {}
BaseEvent.prototype = {
  triggerEvent: function (eventName, args) {
    if (this._cbs[eventName]) {
      var callbacks = this._cbs[eventName];
      for (var i = 0; i < callbacks.length; i += 1) {
        callbacks[i](args);
      }
    }
  },
  addEventListener: function (eventName, callback) {
    if (!this._cbs[eventName]) {
      this._cbs[eventName] = [];
    }
    this._cbs[eventName].push(callback);

    return function () {
      this.removeEventListener(eventName, callback);
    }.bind(this);
  },
  removeEventListener: function (eventName, callback) {
    if (!callback) {
      this._cbs[eventName] = null;
    } else if (this._cbs[eventName]) {
      var i = 0;
      var len = this._cbs[eventName].length;
      while (i < len) {
        if (this._cbs[eventName][i] === callback) {
          this._cbs[eventName].splice(i, 1);
          i -= 1;
          len -= 1;
        }
        i += 1;
      }
      if (!this._cbs[eventName].length) {
        this._cbs[eventName] = null;
      }
    }
  },
};

/* exported createTypedArray, createSizedArray */

var createTypedArray = (function () {
  function createRegularArray(type, len) {
    var i = 0;
    var arr = [];
    var value;
    switch (type) {
      case 'int16':
      case 'uint8c':
        value = 1;
        break;
      default:
        value = 1.1;
        break;
    }
    for (i = 0; i < len; i += 1) {
      arr.push(value);
    }
    return arr;
  }
  function createTypedArrayFactory(type, len) {
    if (type === 'float32') {
      return new Float32Array(len);
    } if (type === 'int16') {
      return new Int16Array(len);
    } if (type === 'uint8c') {
      return new Uint8ClampedArray(len);
    }
    return createRegularArray(type, len);
  }
  if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
    return createTypedArrayFactory;
  }
  return createRegularArray;
}());

function createSizedArray(len) {
  return Array.apply(null, { length: len });
}

/* global svgNS */
/* exported createNS */

function createNS(type) {
  // return {appendChild:function(){},setAttribute:function(){},style:{}}
  return document.createElementNS(svgNS, type);
}

/* exported createTag */

function createTag(type) {
  // return {appendChild:function(){},setAttribute:function(){},style:{}}
  return document.createElement(type);
}

function DynamicPropertyContainer() {}
DynamicPropertyContainer.prototype = {
  addDynamicProperty: function (prop) {
    if (this.dynamicProperties.indexOf(prop) === -1) {
      this.dynamicProperties.push(prop);
      this.container.addDynamicProperty(this);
      this._isAnimated = true;
    }
  },
  iterateDynamicProperties: function () {
    this._mdf = false;
    var i;
    var len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
      if (this.dynamicProperties[i]._mdf) {
        this._mdf = true;
      }
    }
  },
  initDynamicPropertyContainer: function (container) {
    this.container = container;
    this.dynamicProperties = [];
    this._mdf = false;
    this._isAnimated = false;
  },
};

/* exported getBlendMode */

var getBlendMode = (function () {
  var blendModeEnums = {
    0: 'source-over',
    1: 'multiply',
    2: 'screen',
    3: 'overlay',
    4: 'darken',
    5: 'lighten',
    6: 'color-dodge',
    7: 'color-burn',
    8: 'hard-light',
    9: 'soft-light',
    10: 'difference',
    11: 'exclusion',
    12: 'hue',
    13: 'saturation',
    14: 'color',
    15: 'luminosity',
  };

  return function (mode) {
    return blendModeEnums[mode] || '';
  };
}());

/* exported lineCapEnum, lineJoinEnum */

var lineCapEnum = {
  1: 'butt',
  2: 'round',
  3: 'square',
};

var lineJoinEnum = {
  1: 'miter',
  2: 'round',
  3: 'bevel',
};

/* global createTypedArray */

/*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */

/**
 * 2D transformation matrix object initialized with identity matrix.
 *
 * The matrix can synchronize a canvas context by supplying the context
 * as an argument, or later apply current absolute transform to an
 * existing context.
 *
 * All values are handled as floating point values.
 *
 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
 * @prop {number} a - scale x
 * @prop {number} b - shear y
 * @prop {number} c - shear x
 * @prop {number} d - scale y
 * @prop {number} e - translate x
 * @prop {number} f - translate y
 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
 * @constructor
 */

var Matrix = (function () {
  var _cos = Math.cos;
  var _sin = Math.sin;
  var _tan = Math.tan;
  var _rnd = Math.round;

  function reset() {
    this.props[0] = 1;
    this.props[1] = 0;
    this.props[2] = 0;
    this.props[3] = 0;
    this.props[4] = 0;
    this.props[5] = 1;
    this.props[6] = 0;
    this.props[7] = 0;
    this.props[8] = 0;
    this.props[9] = 0;
    this.props[10] = 1;
    this.props[11] = 0;
    this.props[12] = 0;
    this.props[13] = 0;
    this.props[14] = 0;
    this.props[15] = 1;
    return this;
  }

  function rotate(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  function rotateX(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
  }

  function rotateY(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
  }

  function rotateZ(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  function shear(sx, sy) {
    return this._t(1, sy, sx, 1, 0, 0);
  }

  function skew(ax, ay) {
    return this.shear(_tan(ax), _tan(ay));
  }

  function skewFromAxis(ax, angle) {
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
      ._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
      ._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
  }

  function scale(sx, sy, sz) {
    if (!sz && sz !== 0) {
      sz = 1;
    }
    if (sx === 1 && sy === 1 && sz === 1) {
      return this;
    }
    return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
  }

  function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
    this.props[0] = a;
    this.props[1] = b;
    this.props[2] = c;
    this.props[3] = d;
    this.props[4] = e;
    this.props[5] = f;
    this.props[6] = g;
    this.props[7] = h;
    this.props[8] = i;
    this.props[9] = j;
    this.props[10] = k;
    this.props[11] = l;
    this.props[12] = m;
    this.props[13] = n;
    this.props[14] = o;
    this.props[15] = p;
    return this;
  }

  function translate(tx, ty, tz) {
    tz = tz || 0;
    if (tx !== 0 || ty !== 0 || tz !== 0) {
      return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
    }
    return this;
  }

  function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
    var _p = this.props;

    if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
      // NOTE: commenting this condition because TurboFan deoptimizes code when present
      // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
      _p[12] = _p[12] * a2 + _p[15] * m2;
      _p[13] = _p[13] * f2 + _p[15] * n2;
      _p[14] = _p[14] * k2 + _p[15] * o2;
      _p[15] *= p2;
      // }
      this._identityCalculated = false;
      return this;
    }

    var a1 = _p[0];
    var b1 = _p[1];
    var c1 = _p[2];
    var d1 = _p[3];
    var e1 = _p[4];
    var f1 = _p[5];
    var g1 = _p[6];
    var h1 = _p[7];
    var i1 = _p[8];
    var j1 = _p[9];
    var k1 = _p[10];
    var l1 = _p[11];
    var m1 = _p[12];
    var n1 = _p[13];
    var o1 = _p[14];
    var p1 = _p[15];

    /* matrix order (canvas compatible):
         * ace
         * bdf
         * 001
         */
    _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
    _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
    _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
    _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;

    _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
    _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
    _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
    _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;

    _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
    _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
    _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
    _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;

    _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
    _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
    _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
    _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;

    this._identityCalculated = false;
    return this;
  }

  function isIdentity() {
    if (!this._identityCalculated) {
      this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
      this._identityCalculated = true;
    }
    return this._identity;
  }

  function equals(matr) {
    var i = 0;
    while (i < 16) {
      if (matr.props[i] !== this.props[i]) {
        return false;
      }
      i += 1;
    }
    return true;
  }

  function clone(matr) {
    var i;
    for (i = 0; i < 16; i += 1) {
      matr.props[i] = this.props[i];
    }
    return matr;
  }

  function cloneFromProps(props) {
    var i;
    for (i = 0; i < 16; i += 1) {
      this.props[i] = props[i];
    }
  }

  function applyToPoint(x, y, z) {
    return {
      x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
      y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
      z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14],
    };
    /* return {
         x: x * me.a + y * me.c + me.e,
         y: x * me.b + y * me.d + me.f
         }; */
  }
  function applyToX(x, y, z) {
    return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
  }
  function applyToY(x, y, z) {
    return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
  }
  function applyToZ(x, y, z) {
    return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
  }

  function getInverseMatrix() {
    var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
    var a = this.props[5] / determinant;
    var b = -this.props[1] / determinant;
    var c = -this.props[4] / determinant;
    var d = this.props[0] / determinant;
    var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
    var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
    var inverseMatrix = new Matrix();
    inverseMatrix.props[0] = a;
    inverseMatrix.props[1] = b;
    inverseMatrix.props[4] = c;
    inverseMatrix.props[5] = d;
    inverseMatrix.props[12] = e;
    inverseMatrix.props[13] = f;
    return inverseMatrix;
  }

  function inversePoint(pt) {
    var inverseMatrix = this.getInverseMatrix();
    return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
  }

  function inversePoints(pts) {
    var i;
    var len = pts.length;
    var retPts = [];
    for (i = 0; i < len; i += 1) {
      retPts[i] = inversePoint(pts[i]);
    }
    return retPts;
  }

  function applyToTriplePoints(pt1, pt2, pt3) {
    var arr = createTypedArray('float32', 6);
    if (this.isIdentity()) {
      arr[0] = pt1[0];
      arr[1] = pt1[1];
      arr[2] = pt2[0];
      arr[3] = pt2[1];
      arr[4] = pt3[0];
      arr[5] = pt3[1];
    } else {
      var p0 = this.props[0];
      var p1 = this.props[1];
      var p4 = this.props[4];
      var p5 = this.props[5];
      var p12 = this.props[12];
      var p13 = this.props[13];
      arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
      arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
      arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
      arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
      arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
      arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
    }
    return arr;
  }

  function applyToPointArray(x, y, z) {
    var arr;
    if (this.isIdentity()) {
      arr = [x, y, z];
    } else {
      arr = [
        x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
        x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
        x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14],
      ];
    }
    return arr;
  }

  function applyToPointStringified(x, y) {
    if (this.isIdentity()) {
      return x + ',' + y;
    }
    var _p = this.props;
    return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
  }

  function toCSS() {
    // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
    /* if(this.isIdentity()) {
            return '';
        } */
    var i = 0;
    var props = this.props;
    var cssValue = 'matrix3d(';
    var v = 10000;
    while (i < 16) {
      cssValue += _rnd(props[i] * v) / v;
      cssValue += i === 15 ? ')' : ',';
      i += 1;
    }
    return cssValue;
  }

  function roundMatrixProperty(val) {
    var v = 10000;
    if ((val < 0.000001 && val > 0) || (val > -0.000001 && val < 0)) {
      return _rnd(val * v) / v;
    }
    return val;
  }

  function to2dCSS() {
    // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
    /* if(this.isIdentity()) {
            return '';
        } */
    var props = this.props;
    var _a = roundMatrixProperty(props[0]);
    var _b = roundMatrixProperty(props[1]);
    var _c = roundMatrixProperty(props[4]);
    var _d = roundMatrixProperty(props[5]);
    var _e = roundMatrixProperty(props[12]);
    var _f = roundMatrixProperty(props[13]);
    return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
  }

  return function () {
    this.reset = reset;
    this.rotate = rotate;
    this.rotateX = rotateX;
    this.rotateY = rotateY;
    this.rotateZ = rotateZ;
    this.skew = skew;
    this.skewFromAxis = skewFromAxis;
    this.shear = shear;
    this.scale = scale;
    this.setTransform = setTransform;
    this.translate = translate;
    this.transform = transform;
    this.applyToPoint = applyToPoint;
    this.applyToX = applyToX;
    this.applyToY = applyToY;
    this.applyToZ = applyToZ;
    this.applyToPointArray = applyToPointArray;
    this.applyToTriplePoints = applyToTriplePoints;
    this.applyToPointStringified = applyToPointStringified;
    this.toCSS = toCSS;
    this.to2dCSS = to2dCSS;
    this.clone = clone;
    this.cloneFromProps = cloneFromProps;
    this.equals = equals;
    this.inversePoints = inversePoints;
    this.inversePoint = inversePoint;
    this.getInverseMatrix = getInverseMatrix;
    this._t = this.transform;
    this.isIdentity = isIdentity;
    this._identity = true;
    this._identityCalculated = false;

    this.props = createTypedArray('float32', 16);
    this.reset();
  };
}());

/* eslint-disable */
/*
 Copyright 2014 David Bau.

 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 */

(function (pool, math) {
//
// The following constants are related to IEEE 754 limits.
//
    var global = this,
        width = 256,        // each RC4 output is 0 <= x < 256
        chunks = 6,         // at least six RC4 outputs for each double
        digits = 52,        // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks),
        significance = math.pow(2, digits),
        overflow = significance * 2,
        mask = width - 1,
        nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
    function seedrandom(seed, options, callback) {
        var key = [];
        options = (options === true) ? { entropy: true } : (options || {});

        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(
            options.entropy ? [seed, tostring(pool)] :
                (seed === null) ? autoseed() : seed, 3), key);

        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);

        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
                d = startdenom,                 //   and denominator d = 2 ^ 48.
                x = 0;                          //   and no 'extra last byte'.
            while (n < significance) {          // Fill up all significant digits by
                n = (n + x) * width;              //   shifting numerator and
                d *= width;                       //   denominator and generating a
                x = arc4.g(1);                    //   new least-significant-byte.
            }
            while (n >= overflow) {             // To avoid rounding up, before adding
                n /= 2;                           //   last byte, shift everything
                d /= 2;                           //   right using integer math until
                x >>>= 1;                         //   we have exactly the desired bits.
            }
            return (n + x) / d;                 // Form the number within [0, 1).
        };

        prng.int32 = function() { return arc4.g(4) | 0; };
        prng.quick = function() { return arc4.g(4) / 0x100000000; };
        prng.double = prng;

        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);

        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback ||
        function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) { copy(state, arc4); }
                // Only provide the .state method if requested via options.state.
                prng.state = function() { return copy(arc4, {}); };
            }

            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) { math[rngname] = prng; return seed; }

            // Otherwise, it is a newer calling convention, so return the
            // prng directly.
            else return prng;
        })(
            prng,
            shortseed,
            'global' in options ? options.global : (this == math),
            options.state);
    }
    math['seed' + rngname] = seedrandom;

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
    function ARC4(key) {
        var t, keylen = key.length,
            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

        // The empty key [] is treated as [0].
        if (!keylen) { key = [keylen++]; }

        // Set up S using the standard key scheduling algorithm.
        while (i < width) {
            s[i] = i++;
        }
        for (i = 0; i < width; i++) {
            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
            s[j] = t;
        }

        // The "g" method returns the next (count) outputs as one number.
        me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0,
                i = me.i, j = me.j, s = me.S;
            while (count--) {
                t = s[i = mask & (i + 1)];
                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
            }
            me.i = i; me.j = j;
            return r;
            // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
        };
    }

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
    function flatten(obj, depth) {
        var result = [], typ = (typeof obj), prop;
        if (depth && typ == 'object') {
            for (prop in obj) {
                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
            }
        }
        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
    }

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while (j < stringseed.length) {
            key[mask & j] =
                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
        }
        return tostring(key);
    }

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
    function autoseed() {
        try {
            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
            var out = new Uint8Array(width);
            (global.crypto || global.msCrypto).getRandomValues(out);
            return tostring(out);
        } catch (e) {
            var browser = global.navigator,
                plugins = browser && browser.plugins;
            return [+new Date(), global, plugins, global.screen, tostring(pool)];
        }
    }

//
// tostring()
// Converts an array of charcodes to a string
//
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
    mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//

// End anonymous scope, and pass initial values.
})(
    [],     // pool: entropy pool starts empty
    BMMath    // math: package containing random, pow, and seedrandom
);
/* eslint-disable */
var BezierFactory = (function () {
  /**
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     *
     * Credits: is based on Firefox's nsSMILKeySpline.cpp
     * Usage:
     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
     * spline.get(x) => returns the easing value | x must be in [0, 1] range
     *
     */

  var ob = {};
  ob.getBezierEasing = getBezierEasing;
  var beziers = {};

  function getBezierEasing(a, b, c, d, nm) {
    var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
    if (beziers[str]) {
      return beziers[str];
    }
    var bezEasing = new BezierEasing([a, b, c, d]);
    beziers[str] = bezEasing;
    return bezEasing;
  }

  // These values are established by empiricism with tests (tradeoff: performance VS precision)
  var NEWTON_ITERATIONS = 4;
  var NEWTON_MIN_SLOPE = 0.001;
  var SUBDIVISION_PRECISION = 0.0000001;
  var SUBDIVISION_MAX_ITERATIONS = 10;

  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

  var float32ArraySupported = typeof Float32Array === 'function';

  function A(aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
  function B(aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
  function C(aA1) { return 3.0 * aA1; }

  // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
  function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
  }

  // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
  function getSlope(aT, aA1, aA2) {
    return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
  }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX,
      currentT,
      i = 0;
    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);
      if (currentSlope === 0.0) return aGuessT;
      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  }

  /**
     * points is an array of [ mX1, mY1, mX2, mY2 ]
     */
  function BezierEasing(points) {
    this._p = points;
    this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
    this._precomputed = false;

    this.get = this.get.bind(this);
  }

  BezierEasing.prototype = {

    get: function (x) {
      var mX1 = this._p[0],
        mY1 = this._p[1],
        mX2 = this._p[2],
        mY2 = this._p[3];
      if (!this._precomputed) this._precompute();
      if (mX1 === mY1 && mX2 === mY2) return x; // linear
      // Because JavaScript number are imprecise, we should guarantee the extremes are right.
      if (x === 0) return 0;
      if (x === 1) return 1;
      return calcBezier(this._getTForX(x), mY1, mY2);
    },

    // Private part

    _precompute: function () {
      var mX1 = this._p[0],
        mY1 = this._p[1],
        mX2 = this._p[2],
        mY2 = this._p[3];
      this._precomputed = true;
      if (mX1 !== mY1 || mX2 !== mY2) { this._calcSampleValues(); }
    },

    _calcSampleValues: function () {
      var mX1 = this._p[0],
        mX2 = this._p[2];
      for (var i = 0; i < kSplineTableSize; ++i) {
        this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    },

    /**
         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
         */
    _getTForX: function (aX) {
      var mX1 = this._p[0],
        mX2 = this._p[2],
        mSampleValues = this._mSampleValues;

      var intervalStart = 0.0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }
      --currentSample;

      // Interpolate to provide an initial guess for t
      var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;

      var initialSlope = getSlope(guessForT, mX1, mX2);
      if (initialSlope >= NEWTON_MIN_SLOPE) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } if (initialSlope === 0.0) {
        return guessForT;
      }
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    },
  };

  return ob;
}());

(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) { // eslint-disable-line no-plusplus
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = setTimeout(function () {
        callback(currTime + timeToCall);
      },
      timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
}());

/* exported extendPrototype, getDescriptor, createProxyFunction */

function extendPrototype(sources, destination) {
  var i;
  var len = sources.length;
  var sourcePrototype;
  for (i = 0; i < len; i += 1) {
    sourcePrototype = sources[i].prototype;
    for (var attr in sourcePrototype) {
      if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
    }
  }
}

function getDescriptor(object, prop) {
  return Object.getOwnPropertyDescriptor(object, prop);
}

function createProxyFunction(prototype) {
  function ProxyFunction() {}
  ProxyFunction.prototype = prototype;
  return ProxyFunction;
}

/* global segmentsLengthPool, defaultCurveSegments, createSizedArray, bmPow, bmSqrt, bmFloor, createTypedArray, bezierLengthPool */
/* exported bez */

function bezFunction() {
  var math = Math;

  function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
    var det1 = (x1 * y2) + (y1 * x3) + (x2 * y3) - (x3 * y2) - (y3 * x1) - (x2 * y1);
    return det1 > -0.001 && det1 < 0.001;
  }

  function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
    if (z1 === 0 && z2 === 0 && z3 === 0) {
      return pointOnLine2D(x1, y1, x2, y2, x3, y3);
    }
    var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
    var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
    var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
    var diffDist;
    if (dist1 > dist2) {
      if (dist1 > dist3) {
        diffDist = dist1 - dist2 - dist3;
      } else {
        diffDist = dist3 - dist2 - dist1;
      }
    } else if (dist3 > dist2) {
      diffDist = dist3 - dist2 - dist1;
    } else {
      diffDist = dist2 - dist1 - dist3;
    }
    return diffDist > -0.0001 && diffDist < 0.0001;
  }

  var getBezierLength = (function () {
    return function (pt1, pt2, pt3, pt4) {
      var curveSegments = defaultCurveSegments;
      var k;
      var i;
      var len;
      var ptCoord;
      var perc;
      var addedLength = 0;
      var ptDistance;
      var point = [];
      var lastPoint = [];
      var lengthData = bezierLengthPool.newElement();
      len = pt3.length;
      for (k = 0; k < curveSegments; k += 1) {
        perc = k / (curveSegments - 1);
        ptDistance = 0;
        for (i = 0; i < len; i += 1) {
          ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
          point[i] = ptCoord;
          if (lastPoint[i] !== null) {
            ptDistance += bmPow(point[i] - lastPoint[i], 2);
          }
          lastPoint[i] = point[i];
        }
        if (ptDistance) {
          ptDistance = bmSqrt(ptDistance);
          addedLength += ptDistance;
        }
        lengthData.percents[k] = perc;
        lengthData.lengths[k] = addedLength;
      }
      lengthData.addedLength = addedLength;
      return lengthData;
    };
  }());

  function getSegmentsLength(shapeData) {
    var segmentsLength = segmentsLengthPool.newElement();
    var closed = shapeData.c;
    var pathV = shapeData.v;
    var pathO = shapeData.o;
    var pathI = shapeData.i;
    var i;
    var len = shapeData._length;
    var lengths = segmentsLength.lengths;
    var totalLength = 0;
    for (i = 0; i < len - 1; i += 1) {
      lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
      totalLength += lengths[i].addedLength;
    }
    if (closed && len) {
      lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
      totalLength += lengths[i].addedLength;
    }
    segmentsLength.totalLength = totalLength;
    return segmentsLength;
  }

  function BezierData(length) {
    this.segmentLength = 0;
    this.points = new Array(length);
  }

  function PointData(partial, point) {
    this.partialLength = partial;
    this.point = point;
  }

  var buildBezierData = (function () {
    var storedData = {};

    return function (pt1, pt2, pt3, pt4) {
      var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
      if (!storedData[bezierName]) {
        var curveSegments = defaultCurveSegments;
        var k;
        var i;
        var len;
        var ptCoord;
        var perc;
        var addedLength = 0;
        var ptDistance;
        var point;
        var lastPoint = null;
        if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
          curveSegments = 2;
        }
        var bezierData = new BezierData(curveSegments);
        len = pt3.length;
        for (k = 0; k < curveSegments; k += 1) {
          point = createSizedArray(len);
          perc = k / (curveSegments - 1);
          ptDistance = 0;
          for (i = 0; i < len; i += 1) {
            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
            point[i] = ptCoord;
            if (lastPoint !== null) {
              ptDistance += bmPow(point[i] - lastPoint[i], 2);
            }
          }
          ptDistance = bmSqrt(ptDistance);
          addedLength += ptDistance;
          bezierData.points[k] = new PointData(ptDistance, point);
          lastPoint = point;
        }
        bezierData.segmentLength = addedLength;
        storedData[bezierName] = bezierData;
      }
      return storedData[bezierName];
    };
  }());

  function getDistancePerc(perc, bezierData) {
    var percents = bezierData.percents;
    var lengths = bezierData.lengths;
    var len = percents.length;
    var initPos = bmFloor((len - 1) * perc);
    var lengthPos = perc * bezierData.addedLength;
    var lPerc = 0;
    if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
      return percents[initPos];
    }
    var dir = lengths[initPos] > lengthPos ? -1 : 1;
    var flag = true;
    while (flag) {
      if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
        lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
        flag = false;
      } else {
        initPos += dir;
      }
      if (initPos < 0 || initPos >= len - 1) {
        // FIX for TypedArrays that don't store floating point values with enough accuracy
        if (initPos === len - 1) {
          return percents[initPos];
        }
        flag = false;
      }
    }
    return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
  }

  function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
    var t1 = getDistancePerc(percent, bezierData);
    var u1 = 1 - t1;
    var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
    var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
    return [ptX, ptY];
  }

  var bezierSegmentPoints = createTypedArray('float32', 8);

  function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
    if (startPerc < 0) {
      startPerc = 0;
    } else if (startPerc > 1) {
      startPerc = 1;
    }
    var t0 = getDistancePerc(startPerc, bezierData);
    endPerc = endPerc > 1 ? 1 : endPerc;
    var t1 = getDistancePerc(endPerc, bezierData);
    var i;
    var len = pt1.length;
    var u0 = 1 - t0;
    var u1 = 1 - t1;
    var u0u0u0 = u0 * u0 * u0;
    var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
    var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
    var t0t0t0 = t0 * t0 * t0;
    //
    var u0u0u1 = u0 * u0 * u1;
    var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
    var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
    var t0t0t1 = t0 * t0 * t1;
    //
    var u0u1u1 = u0 * u1 * u1;
    var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
    var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
    var t0t1t1 = t0 * t1 * t1;
    //
    var u1u1u1 = u1 * u1 * u1;
    var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
    var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
    var t1t1t1 = t1 * t1 * t1;
    for (i = 0; i < len; i += 1) {
      bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
    }

    return bezierSegmentPoints;
  }

  return {
    getSegmentsLength: getSegmentsLength,
    getNewSegment: getNewSegment,
    getPointInSegment: getPointInSegment,
    buildBezierData: buildBezierData,
    pointOnLine2D: pointOnLine2D,
    pointOnLine3D: pointOnLine3D,
  };
}

var bez = bezFunction();

/* global _useWebWorker */

var dataManager = (function () {
  var _counterId = 1;
  var processes = [];
  var workerFn;
  var workerInstance;
  var workerProxy = {
    onmessage: function () {

    },
    postMessage: function (path) {
      workerFn({
        data: path,
      });
    },
  };
  var _workerSelf = {
    postMessage: function (data) {
      workerProxy.onmessage({
        data: data,
      });
    },
  };
  function createWorker(fn) {
    if (window.Worker && window.Blob && _useWebWorker) {
      var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], { type: 'text/javascript' });
      // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
      var url = URL.createObjectURL(blob);
      return new Worker(url);
    }
    workerFn = fn;
    return workerProxy;
  }

  function setupWorker() {
    if (!workerInstance) {
      workerInstance = createWorker(function workerStart(e) {
        /* exported dataManager */

        function dataFunctionManager() {
          // var tCanvasHelper = createTag('canvas').getContext('2d');

          function completeLayers(layers, comps) {
            var layerData;
            var i;
            var len = layers.length;
            var j;
            var jLen;
            var k;
            var kLen;
            for (i = 0; i < len; i += 1) {
              layerData = layers[i];
              if (('ks' in layerData) && !layerData.completed) {
                layerData.completed = true;
                if (layerData.tt) {
                  layers[i - 1].td = layerData.tt;
                }
                if (layerData.hasMask) {
                  var maskProps = layerData.masksProperties;
                  jLen = maskProps.length;
                  for (j = 0; j < jLen; j += 1) {
                    if (maskProps[j].pt.k.i) {
                      convertPathsToAbsoluteValues(maskProps[j].pt.k);
                    } else {
                      kLen = maskProps[j].pt.k.length;
                      for (k = 0; k < kLen; k += 1) {
                        if (maskProps[j].pt.k[k].s) {
                          convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                        }
                        if (maskProps[j].pt.k[k].e) {
                          convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                        }
                      }
                    }
                  }
                }
                if (layerData.ty === 0) {
                  layerData.layers = findCompLayers(layerData.refId, comps);
                  completeLayers(layerData.layers, comps);
                } else if (layerData.ty === 4) {
                  completeShapes(layerData.shapes);
                } else if (layerData.ty === 5) {
                  completeText(layerData);
                }
              }
            }
          }

          function findCompLayers(id, comps) {
            var i = 0;
            var len = comps.length;
            while (i < len) {
              if (comps[i].id === id) {
                if (!comps[i].layers.__used) {
                  comps[i].layers.__used = true;
                  return comps[i].layers;
                }
                return JSON.parse(JSON.stringify(comps[i].layers));
              }
              i += 1;
            }
            return null;
          }

          function completeShapes(arr) {
            var i;
            var len = arr.length;
            var j;
            var jLen;
            for (i = len - 1; i >= 0; i -= 1) {
              if (arr[i].ty === 'sh') {
                if (arr[i].ks.k.i) {
                  convertPathsToAbsoluteValues(arr[i].ks.k);
                } else {
                  jLen = arr[i].ks.k.length;
                  for (j = 0; j < jLen; j += 1) {
                    if (arr[i].ks.k[j].s) {
                      convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                    }
                    if (arr[i].ks.k[j].e) {
                      convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                    }
                  }
                }
              } else if (arr[i].ty === 'gr') {
                completeShapes(arr[i].it);
              }
            }
          }

          function convertPathsToAbsoluteValues(path) {
            var i;
            var len = path.i.length;
            for (i = 0; i < len; i += 1) {
              path.i[i][0] += path.v[i][0];
              path.i[i][1] += path.v[i][1];
              path.o[i][0] += path.v[i][0];
              path.o[i][1] += path.v[i][1];
            }
          }

          function checkVersion(minimum, animVersionString) {
            var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];
            if (minimum[0] > animVersion[0]) {
              return true;
            } if (animVersion[0] > minimum[0]) {
              return false;
            }
            if (minimum[1] > animVersion[1]) {
              return true;
            } if (animVersion[1] > minimum[1]) {
              return false;
            }
            if (minimum[2] > animVersion[2]) {
              return true;
            } if (animVersion[2] > minimum[2]) {
              return false;
            }
            return null;
          }

          var checkText = (function () {
            var minimumVersion = [4, 4, 14];

            function updateTextLayer(textLayer) {
              var documentData = textLayer.t.d;
              textLayer.t.d = {
                k: [
                  {
                    s: documentData,
                    t: 0,
                  },
                ],
              };
            }

            function iterateLayers(layers) {
              var i;
              var len = layers.length;
              for (i = 0; i < len; i += 1) {
                if (layers[i].ty === 5) {
                  updateTextLayer(layers[i]);
                }
              }
            }

            return function (animationData) {
              if (checkVersion(minimumVersion, animationData.v)) {
                iterateLayers(animationData.layers);
                if (animationData.assets) {
                  var i;
                  var len = animationData.assets.length;
                  for (i = 0; i < len; i += 1) {
                    if (animationData.assets[i].layers) {
                      iterateLayers(animationData.assets[i].layers);
                    }
                  }
                }
              }
            };
          }());

          var checkChars = (function () {
            var minimumVersion = [4, 7, 99];
            return function (animationData) {
              if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                var i;
                var len = animationData.chars.length;
                var j;
                var jLen;
                var pathData;
                var paths;
                for (i = 0; i < len; i += 1) {
                  if (animationData.chars[i].data && animationData.chars[i].data.shapes) {
                    paths = animationData.chars[i].data.shapes[0].it;
                    jLen = paths.length;

                    for (j = 0; j < jLen; j += 1) {
                      pathData = paths[j].ks.k;
                      if (!pathData.__converted) {
                        convertPathsToAbsoluteValues(paths[j].ks.k);
                        pathData.__converted = true;
                      }
                    }
                  }
                }
              }
            };
          }());

          var checkPathProperties = (function () {
            var minimumVersion = [5, 7, 15];

            function updateTextLayer(textLayer) {
              var pathData = textLayer.t.p;
              if (typeof pathData.a === 'number') {
                pathData.a = {
                  a: 0,
                  k: pathData.a,
                };
              }
              if (typeof pathData.p === 'number') {
                pathData.p = {
                  a: 0,
                  k: pathData.p,
                };
              }
              if (typeof pathData.r === 'number') {
                pathData.r = {
                  a: 0,
                  k: pathData.r,
                };
              }
            }

            function iterateLayers(layers) {
              var i;
              var len = layers.length;
              for (i = 0; i < len; i += 1) {
                if (layers[i].ty === 5) {
                  updateTextLayer(layers[i]);
                }
              }
            }

            return function (animationData) {
              if (checkVersion(minimumVersion, animationData.v)) {
                iterateLayers(animationData.layers);
                if (animationData.assets) {
                  var i;
                  var len = animationData.assets.length;
                  for (i = 0; i < len; i += 1) {
                    if (animationData.assets[i].layers) {
                      iterateLayers(animationData.assets[i].layers);
                    }
                  }
                }
              }
            };
          }());

          var checkColors = (function () {
            var minimumVersion = [4, 1, 9];

            function iterateShapes(shapes) {
              var i;
              var len = shapes.length;
              var j;
              var jLen;
              for (i = 0; i < len; i += 1) {
                if (shapes[i].ty === 'gr') {
                  iterateShapes(shapes[i].it);
                } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                  if (shapes[i].c.k && shapes[i].c.k[0].i) {
                    jLen = shapes[i].c.k.length;
                    for (j = 0; j < jLen; j += 1) {
                      if (shapes[i].c.k[j].s) {
                        shapes[i].c.k[j].s[0] /= 255;
                        shapes[i].c.k[j].s[1] /= 255;
                        shapes[i].c.k[j].s[2] /= 255;
                        shapes[i].c.k[j].s[3] /= 255;
                      }
                      if (shapes[i].c.k[j].e) {
                        shapes[i].c.k[j].e[0] /= 255;
                        shapes[i].c.k[j].e[1] /= 255;
                        shapes[i].c.k[j].e[2] /= 255;
                        shapes[i].c.k[j].e[3] /= 255;
                      }
                    }
                  } else {
                    shapes[i].c.k[0] /= 255;
                    shapes[i].c.k[1] /= 255;
                    shapes[i].c.k[2] /= 255;
                    shapes[i].c.k[3] /= 255;
                  }
                }
              }
            }

            function iterateLayers(layers) {
              var i;
              var len = layers.length;
              for (i = 0; i < len; i += 1) {
                if (layers[i].ty === 4) {
                  iterateShapes(layers[i].shapes);
                }
              }
            }

            return function (animationData) {
              if (checkVersion(minimumVersion, animationData.v)) {
                iterateLayers(animationData.layers);
                if (animationData.assets) {
                  var i;
                  var len = animationData.assets.length;
                  for (i = 0; i < len; i += 1) {
                    if (animationData.assets[i].layers) {
                      iterateLayers(animationData.assets[i].layers);
                    }
                  }
                }
              }
            };
          }());

          var checkShapes = (function () {
            var minimumVersion = [4, 4, 18];

            function completeClosingShapes(arr) {
              var i;
              var len = arr.length;
              var j;
              var jLen;
              for (i = len - 1; i >= 0; i -= 1) {
                if (arr[i].ty === 'sh') {
                  if (arr[i].ks.k.i) {
                    arr[i].ks.k.c = arr[i].closed;
                  } else {
                    jLen = arr[i].ks.k.length;
                    for (j = 0; j < jLen; j += 1) {
                      if (arr[i].ks.k[j].s) {
                        arr[i].ks.k[j].s[0].c = arr[i].closed;
                      }
                      if (arr[i].ks.k[j].e) {
                        arr[i].ks.k[j].e[0].c = arr[i].closed;
                      }
                    }
                  }
                } else if (arr[i].ty === 'gr') {
                  completeClosingShapes(arr[i].it);
                }
              }
            }

            function iterateLayers(layers) {
              var layerData;
              var i;
              var len = layers.length;
              var j;
              var jLen;
              var k;
              var kLen;
              for (i = 0; i < len; i += 1) {
                layerData = layers[i];
                if (layerData.hasMask) {
                  var maskProps = layerData.masksProperties;
                  jLen = maskProps.length;
                  for (j = 0; j < jLen; j += 1) {
                    if (maskProps[j].pt.k.i) {
                      maskProps[j].pt.k.c = maskProps[j].cl;
                    } else {
                      kLen = maskProps[j].pt.k.length;
                      for (k = 0; k < kLen; k += 1) {
                        if (maskProps[j].pt.k[k].s) {
                          maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                        }
                        if (maskProps[j].pt.k[k].e) {
                          maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                        }
                      }
                    }
                  }
                }
                if (layerData.ty === 4) {
                  completeClosingShapes(layerData.shapes);
                }
              }
            }

            return function (animationData) {
              if (checkVersion(minimumVersion, animationData.v)) {
                iterateLayers(animationData.layers);
                if (animationData.assets) {
                  var i;
                  var len = animationData.assets.length;
                  for (i = 0; i < len; i += 1) {
                    if (animationData.assets[i].layers) {
                      iterateLayers(animationData.assets[i].layers);
                    }
                  }
                }
              }
            };
          }());

          function completeData(animationData) {
            if (animationData.__complete) {
              return;
            }
            checkColors(animationData);
            checkText(animationData);
            checkChars(animationData);
            checkPathProperties(animationData);
            checkShapes(animationData);
            completeLayers(animationData.layers, animationData.assets);
            animationData.__complete = true;
          }

          function completeText(data) {
            if (data.t.a.length === 0 && !('m' in data.t.p)) {
              data.singleShape = true;
            }
          }

          var moduleOb = {};
          moduleOb.completeData = completeData;
          moduleOb.checkColors = checkColors;
          moduleOb.checkChars = checkChars;
          moduleOb.checkPathProperties = checkPathProperties;
          moduleOb.checkShapes = checkShapes;
          moduleOb.completeLayers = completeLayers;

          return moduleOb;
        }
        if (!_workerSelf.dataManager) {
          _workerSelf.dataManager = dataFunctionManager();
        }

        /* exported assetLoader */
        if (!_workerSelf.assetLoader) {
          _workerSelf.assetLoader = (function () {
            function formatResponse(xhr) {
              // using typeof doubles the time of execution of this method,
              // so if available, it's better to use the header to validate the type
              var contentTypeHeader = xhr.getResponseHeader('content-type');
              if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
                return xhr.response;
              }
              if (xhr.response && typeof xhr.response === 'object') {
                return xhr.response;
              } if (xhr.response && typeof xhr.response === 'string') {
                return JSON.parse(xhr.response);
              } if (xhr.responseText) {
                return JSON.parse(xhr.responseText);
              }
              return null;
            }

            function loadAsset(path, fullPath, callback, errorCallback) {
              var response;
              var xhr = new XMLHttpRequest();
              // set responseType after calling open or IE will break.
              try {
                // This crashes on Android WebView prior to KitKat
                xhr.responseType = 'json';
              } catch (err) {} // eslint-disable-line no-empty
              xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                  if (xhr.status === 200) {
                    response = formatResponse(xhr);
                    callback(response);
                  } else {
                    try {
                      response = formatResponse(xhr);
                      callback(response);
                    } catch (err) {
                      if (errorCallback) {
                        errorCallback(err);
                      }
                    }
                  }
                }
              };
              try {
                xhr.open('GET', path, true);
              } catch (error) {
                xhr.open('GET', fullPath + '/' + path, true);
              }
              xhr.send();
            }
            return {
              load: loadAsset,
            };
          }());
        }

        if (e.data.type === 'loadAnimation') {
          _workerSelf.assetLoader.load(
            e.data.path,
            e.data.fullPath,
            function (data) {
              _workerSelf.dataManager.completeData(data);
              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success',
              });
            },
            function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error',
              });
            }
          );
        } else if (e.data.type === 'complete') {
          var animation = e.data.animation;
          _workerSelf.dataManager.completeData(animation);
          _workerSelf.postMessage({
            id: e.data.id,
            payload: animation,
            status: 'success',
          });
        } else if (e.data.type === 'loadData') {
          _workerSelf.assetLoader.load(
            e.data.path,
            e.data.fullPath,
            function (data) {
              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success',
              });
            },
            function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error',
              });
            }
          );
        }
      });

      workerInstance.onmessage = function (event) {
        var data = event.data;
        var id = data.id;
        var process = processes[id];
        processes[id] = null;
        if (data.status === 'success') {
          process.onComplete(data.payload);
        } else if (process.onError) {
          process.onError();
        }
      };
    }
  }

  function createProcess(onComplete, onError) {
    _counterId += 1;
    var id = 'processId_' + _counterId;
    processes[id] = {
      onComplete: onComplete,
      onError: onError,
    };
    return id;
  }

  function loadAnimation(path, onComplete, onError) {
    setupWorker();
    var processId = createProcess(onComplete, onError);
    workerInstance.postMessage({
      type: 'loadAnimation',
      path: path,
      fullPath: window.location.origin + window.location.pathname,
      id: processId,
    });
  }

  function loadData(path, onComplete, onError) {
    setupWorker();
    var processId = createProcess(onComplete, onError);
    workerInstance.postMessage({
      type: 'loadData',
      path: path,
      fullPath: window.location.origin + window.location.pathname,
      id: processId,
    });
  }

  function completeAnimation(anim, onComplete, onError) {
    setupWorker();
    var processId = createProcess(onComplete, onError);
    workerInstance.postMessage({
      type: 'complete',
      animation: anim,
      id: processId,
    });
  }

  return {
    loadAnimation: loadAnimation,
    loadData: loadData,
    completeAnimation: completeAnimation,
  };
}());

/* exported getFontProperties */

function getFontProperties(fontData) {
  var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];

  var fWeight = 'normal'; var
    fStyle = 'normal';
  var len = styles.length;
  var styleName;
  for (var i = 0; i < len; i += 1) {
    styleName = styles[i].toLowerCase();
    switch (styleName) {
      case 'italic':
        fStyle = 'italic';
        break;
      case 'bold':
        fWeight = '700';
        break;
      case 'black':
        fWeight = '900';
        break;
      case 'medium':
        fWeight = '500';
        break;
      case 'regular':
      case 'normal':
        fWeight = '400';
        break;
      case 'light':
      case 'thin':
        fWeight = '200';
        break;
      default:
        break;
    }
  }

  return {
    style: fStyle,
    weight: fontData.fWeight || fWeight,
  };
}

/* global createNS, createTag, getFontProperties */
/* exported FontManager */

var FontManager = (function () {
  var maxWaitingTime = 5000;
  var emptyChar = {
    w: 0,
    size: 0,
    shapes: [],
  };
  var combinedCharacters = [];
  // Hindi characters
  combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366,
    2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379,
    2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);

  var surrogateModifiers = [
    'd83cdffb',
    'd83cdffc',
    'd83cdffd',
    'd83cdffe',
    'd83cdfff',
  ];

  var zeroWidthJoiner = [65039, 8205];

  function trimFontOptions(font) {
    var familyArray = font.split(',');
    var i;
    var len = familyArray.length;
    var enabledFamilies = [];
    for (i = 0; i < len; i += 1) {
      if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
        enabledFamilies.push(familyArray[i]);
      }
    }
    return enabledFamilies.join(',');
  }

  function setUpNode(font, family) {
    var parentNode = createTag('span');
    // Node is invisible to screen readers.
    parentNode.setAttribute('aria-hidden', true);
    parentNode.style.fontFamily = family;
    var node = createTag('span');
    // Characters that vary significantly among different fonts
    node.innerText = 'giItT1WQy@!-/#';
    // Visible - so we can measure it - but not on the screen
    parentNode.style.position = 'absolute';
    parentNode.style.left = '-10000px';
    parentNode.style.top = '-10000px';
    // Large font size makes even subtle changes obvious
    parentNode.style.fontSize = '300px';
    // Reset any font properties
    parentNode.style.fontVariant = 'normal';
    parentNode.style.fontStyle = 'normal';
    parentNode.style.fontWeight = 'normal';
    parentNode.style.letterSpacing = '0';
    parentNode.appendChild(node);
    document.body.appendChild(parentNode);

    // Remember width with no applied web font
    var width = node.offsetWidth;
    node.style.fontFamily = trimFontOptions(font) + ', ' + family;
    return { node: node, w: width, parent: parentNode };
  }

  function checkLoadedFonts() {
    var i;
    var len = this.fonts.length;
    var node;
    var w;
    var loadedCount = len;
    for (i = 0; i < len; i += 1) {
      if (this.fonts[i].loaded) {
        loadedCount -= 1;
      } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
        this.fonts[i].loaded = true;
      } else {
        node = this.fonts[i].monoCase.node;
        w = this.fonts[i].monoCase.w;
        if (node.offsetWidth !== w) {
          loadedCount -= 1;
          this.fonts[i].loaded = true;
        } else {
          node = this.fonts[i].sansCase.node;
          w = this.fonts[i].sansCase.w;
          if (node.offsetWidth !== w) {
            loadedCount -= 1;
            this.fonts[i].loaded = true;
          }
        }
        if (this.fonts[i].loaded) {
          this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
          this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
        }
      }
    }

    if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
      setTimeout(this.checkLoadedFontsBinded, 20);
    } else {
      setTimeout(this.setIsLoadedBinded, 10);
    }
  }

  function createHelper(def, fontData) {
    var tHelper = createNS('text');
    tHelper.style.fontSize = '100px';
    // tHelper.style.fontFamily = fontData.fFamily;

    var fontProps = getFontProperties(fontData);
    tHelper.setAttribute('font-family', fontData.fFamily);
    tHelper.setAttribute('font-style', fontProps.style);
    tHelper.setAttribute('font-weight', fontProps.weight);
    tHelper.textContent = '1';
    if (fontData.fClass) {
      tHelper.style.fontFamily = 'inherit';
      tHelper.setAttribute('class', fontData.fClass);
    } else {
      tHelper.style.fontFamily = fontData.fFamily;
    }
    def.appendChild(tHelper);
    var tCanvasHelper = createTag('canvas').getContext('2d');
    tCanvasHelper.font = fontData.fWeight + ' ' + fontData.fStyle + ' 100px ' + fontData.fFamily;
    // tCanvasHelper.font = ' 100px '+ fontData.fFamily;
    return tHelper;
  }

  function addFonts(fontData, defs) {
    if (!fontData) {
      this.isLoaded = true;
      return;
    }
    if (this.chars) {
      this.isLoaded = true;
      this.fonts = fontData.list;
      return;
    }

    var fontArr = fontData.list;
    var i;
    var len = fontArr.length;
    var _pendingFonts = len;
    for (i = 0; i < len; i += 1) {
      var shouldLoadFont = true;
      var loadedSelector;
      var j;
      fontArr[i].loaded = false;
      fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
      fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
      if (!fontArr[i].fPath) {
        fontArr[i].loaded = true;
        _pendingFonts -= 1;
      } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
        loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');

        if (loadedSelector.length > 0) {
          shouldLoadFont = false;
        }

        if (shouldLoadFont) {
          var s = createTag('style');
          s.setAttribute('f-forigin', fontArr[i].fOrigin);
          s.setAttribute('f-origin', fontArr[i].origin);
          s.setAttribute('f-family', fontArr[i].fFamily);
          s.type = 'text/css';
          s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
          defs.appendChild(s);
        }
      } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
        loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

        for (j = 0; j < loadedSelector.length; j += 1) {
          if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
            // Font is already loaded
            shouldLoadFont = false;
          }
        }

        if (shouldLoadFont) {
          var l = createTag('link');
          l.setAttribute('f-forigin', fontArr[i].fOrigin);
          l.setAttribute('f-origin', fontArr[i].origin);
          l.type = 'text/css';
          l.rel = 'stylesheet';
          l.href = fontArr[i].fPath;
          document.body.appendChild(l);
        }
      } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
        loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

        for (j = 0; j < loadedSelector.length; j += 1) {
          if (fontArr[i].fPath === loadedSelector[j].src) {
            // Font is already loaded
            shouldLoadFont = false;
          }
        }

        if (shouldLoadFont) {
          var sc = createTag('link');
          sc.setAttribute('f-forigin', fontArr[i].fOrigin);
          sc.setAttribute('f-origin', fontArr[i].origin);
          sc.setAttribute('rel', 'stylesheet');
          sc.setAttribute('href', fontArr[i].fPath);
          defs.appendChild(sc);
        }
      }
      fontArr[i].helper = createHelper(defs, fontArr[i]);
      fontArr[i].cache = {};
      this.fonts.push(fontArr[i]);
    }
    if (_pendingFonts === 0) {
      this.isLoaded = true;
    } else {
      // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
      // Adding this timeout seems to fix it
      setTimeout(this.checkLoadedFonts.bind(this), 100);
    }
  }

  function addChars(chars) {
    if (!chars) {
      return;
    }
    if (!this.chars) {
      this.chars = [];
    }
    var i;
    var len = chars.length;
    var j;
    var jLen = this.chars.length;
    var found;
    for (i = 0; i < len; i += 1) {
      j = 0;
      found = false;
      while (j < jLen) {
        if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
          found = true;
        }
        j += 1;
      }
      if (!found) {
        this.chars.push(chars[i]);
        jLen += 1;
      }
    }
  }

  function getCharData(char, style, font) {
    var i = 0;
    var len = this.chars.length;
    while (i < len) {
      if (this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font) {
        return this.chars[i];
      }
      i += 1;
    }
    if (((typeof char === 'string' && char.charCodeAt(0) !== 13) || !char)
            && console
            && console.warn // eslint-disable-line no-console
            && !this._warned
    ) {
      this._warned = true;
      console.warn('Missing character from exported characters list: ', char, style, font); // eslint-disable-line no-console
    }
    return emptyChar;
  }

  function measureText(char, fontName, size) {
    var fontData = this.getFontByName(fontName);
    var index = char.charCodeAt(0);
    if (!fontData.cache[index + 1]) {
      var tHelper = fontData.helper;
      // Canvas version
      // fontData.cache[index] = tHelper.measureText(char).width / 100;
      // SVG version
      // console.log(tHelper.getBBox().width)
      if (char === ' ') {
        tHelper.textContent = '|' + char + '|';
        var doubleSize = tHelper.getComputedTextLength();
        tHelper.textContent = '||';
        var singleSize = tHelper.getComputedTextLength();
        fontData.cache[index + 1] = (doubleSize - singleSize) / 100;
      } else {
        tHelper.textContent = char;
        fontData.cache[index + 1] = (tHelper.getComputedTextLength()) / 100;
      }
    }
    return fontData.cache[index + 1] * size;
  }

  function getFontByName(name) {
    var i = 0;
    var len = this.fonts.length;
    while (i < len) {
      if (this.fonts[i].fName === name) {
        return this.fonts[i];
      }
      i += 1;
    }
    return this.fonts[0];
  }

  function isModifier(firstCharCode, secondCharCode) {
    var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
    return surrogateModifiers.indexOf(sum) !== -1;
  }

  function isZeroWidthJoiner(firstCharCode, secondCharCode) {
    if (!secondCharCode) {
      return firstCharCode === zeroWidthJoiner[1];
    }
    return firstCharCode === zeroWidthJoiner[0] && secondCharCode === zeroWidthJoiner[1];
  }

  function isCombinedCharacter(char) {
    return combinedCharacters.indexOf(char) !== -1;
  }

  function setIsLoaded() {
    this.isLoaded = true;
  }

  var Font = function () {
    this.fonts = [];
    this.chars = null;
    this.typekitLoaded = 0;
    this.isLoaded = false;
    this._warned = false;
    this.initTime = Date.now();
    this.setIsLoadedBinded = this.setIsLoaded.bind(this);
    this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
  };
  Font.isModifier = isModifier;
  Font.isZeroWidthJoiner = isZeroWidthJoiner;
  Font.isCombinedCharacter = isCombinedCharacter;

  var fontPrototype = {
    addChars: addChars,
    addFonts: addFonts,
    getCharData: getCharData,
    getFontByName: getFontByName,
    measureText: measureText,
    checkLoadedFonts: checkLoadedFonts,
    setIsLoaded: setIsLoaded,
  };

  Font.prototype = fontPrototype;

  return Font;
}());

/* global initialDefaultFrame, BezierFactory, degToRads, bez, createTypedArray */
/* exported PropertyFactory */

var PropertyFactory = (function () {
  var initFrame = initialDefaultFrame;
  var mathAbs = Math.abs;

  function interpolateValue(frameNum, caching) {
    var offsetTime = this.offsetTime;
    var newValue;
    if (this.propType === 'multidimensional') {
      newValue = createTypedArray('float32', this.pv.length);
    }
    var iterationIndex = caching.lastIndex;
    var i = iterationIndex;
    var len = this.keyframes.length - 1;
    var flag = true;
    var keyData;
    var nextKeyData;
    var keyframeMetadata;

    while (flag) {
      keyData = this.keyframes[i];
      nextKeyData = this.keyframes[i + 1];
      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
        if (keyData.h) {
          keyData = nextKeyData;
        }
        iterationIndex = 0;
        break;
      }
      if ((nextKeyData.t - offsetTime) > frameNum) {
        iterationIndex = i;
        break;
      }
      if (i < len - 1) {
        i += 1;
      } else {
        iterationIndex = 0;
        flag = false;
      }
    }
    keyframeMetadata = this.keyframesMetadata[i] || {};

    var k;
    var kLen;
    var perc;
    var jLen;
    var j;
    var fnc;
    var nextKeyTime = nextKeyData.t - offsetTime;
    var keyTime = keyData.t - offsetTime;
    var endValue;
    if (keyData.to) {
      if (!keyframeMetadata.bezierData) {
        keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
      }
      var bezierData = keyframeMetadata.bezierData;
      if (frameNum >= nextKeyTime || frameNum < keyTime) {
        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
        kLen = bezierData.points[ind].point.length;
        for (k = 0; k < kLen; k += 1) {
          newValue[k] = bezierData.points[ind].point[k];
        }
        // caching._lastKeyframeIndex = -1;
      } else {
        if (keyframeMetadata.__fnct) {
          fnc = keyframeMetadata.__fnct;
        } else {
          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
          keyframeMetadata.__fnct = fnc;
        }
        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
        var distanceInLine = bezierData.segmentLength * perc;

        var segmentPerc;
        var addedLength = (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastAddedLength : 0;
        j = (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastPoint : 0;
        flag = true;
        jLen = bezierData.points.length;
        while (flag) {
          addedLength += bezierData.points[j].partialLength;
          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k];
            }
            break;
          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
            }
            break;
          }
          if (j < jLen - 1) {
            j += 1;
          } else {
            flag = false;
          }
        }
        caching._lastPoint = j;
        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
        caching._lastKeyframeIndex = i;
      }
    } else {
      var outX;
      var outY;
      var inX;
      var inY;
      var keyValue;
      len = keyData.s.length;
      endValue = nextKeyData.s || keyData.e;
      if (this.sh && keyData.h !== 1) {
        if (frameNum >= nextKeyTime) {
          newValue[0] = endValue[0];
          newValue[1] = endValue[1];
          newValue[2] = endValue[2];
        } else if (frameNum <= keyTime) {
          newValue[0] = keyData.s[0];
          newValue[1] = keyData.s[1];
          newValue[2] = keyData.s[2];
        } else {
          var quatStart = createQuaternion(keyData.s);
          var quatEnd = createQuaternion(endValue);
          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
        }
      } else {
        for (i = 0; i < len; i += 1) {
          if (keyData.h !== 1) {
            if (frameNum >= nextKeyTime) {
              perc = 1;
            } else if (frameNum < keyTime) {
              perc = 0;
            } else {
              if (keyData.o.x.constructor === Array) {
                if (!keyframeMetadata.__fnct) {
                  keyframeMetadata.__fnct = [];
                }
                if (!keyframeMetadata.__fnct[i]) {
                  outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                  outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                  inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                  inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                  keyframeMetadata.__fnct[i] = fnc;
                } else {
                  fnc = keyframeMetadata.__fnct[i];
                }
              } else if (!keyframeMetadata.__fnct) {
                outX = keyData.o.x;
                outY = keyData.o.y;
                inX = keyData.i.x;
                inY = keyData.i.y;
                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                keyData.keyframeMetadata = fnc;
              } else {
                fnc = keyframeMetadata.__fnct;
              }
              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
            }
          }

          endValue = nextKeyData.s || keyData.e;
          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

          if (this.propType === 'multidimensional') {
            newValue[i] = keyValue;
          } else {
            newValue = keyValue;
          }
        }
      }
    }
    caching.lastIndex = iterationIndex;
    return newValue;
  }

  // based on @Toji's https://github.com/toji/gl-matrix/
  function slerp(a, b, t) {
    var out = [];
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    var bx = b[0];
    var by = b[1];
    var bz = b[2];
    var bw = b[3];

    var omega;
    var cosom;
    var sinom;
    var scale0;
    var scale1;

    cosom = ax * bx + ay * by + az * bz + aw * bw;
    if (cosom < 0.0) {
      cosom = -cosom;
      bx = -bx;
      by = -by;
      bz = -bz;
      bw = -bw;
    }
    if ((1.0 - cosom) > 0.000001) {
      omega = Math.acos(cosom);
      sinom = Math.sin(omega);
      scale0 = Math.sin((1.0 - t) * omega) / sinom;
      scale1 = Math.sin(t * omega) / sinom;
    } else {
      scale0 = 1.0 - t;
      scale1 = t;
    }
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;

    return out;
  }

  function quaternionToEuler(out, quat) {
    var qx = quat[0];
    var qy = quat[1];
    var qz = quat[2];
    var qw = quat[3];
    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
    out[0] = heading / degToRads;
    out[1] = attitude / degToRads;
    out[2] = bank / degToRads;
  }

  function createQuaternion(values) {
    var heading = values[0] * degToRads;
    var attitude = values[1] * degToRads;
    var bank = values[2] * degToRads;
    var c1 = Math.cos(heading / 2);
    var c2 = Math.cos(attitude / 2);
    var c3 = Math.cos(bank / 2);
    var s1 = Math.sin(heading / 2);
    var s2 = Math.sin(attitude / 2);
    var s3 = Math.sin(bank / 2);
    var w = c1 * c2 * c3 - s1 * s2 * s3;
    var x = s1 * s2 * c3 + c1 * c2 * s3;
    var y = s1 * c2 * c3 + c1 * s2 * s3;
    var z = c1 * s2 * c3 - s1 * c2 * s3;

    return [x, y, z, w];
  }

  function getValueAtCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    if (!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))) {
      if (this._caching.lastFrame >= frameNum) {
        this._caching._lastKeyframeIndex = -1;
        this._caching.lastIndex = 0;
      }

      var renderResult = this.interpolateValue(frameNum, this._caching);
      this.pv = renderResult;
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function setVValue(val) {
    var multipliedValue;
    if (this.propType === 'unidimensional') {
      multipliedValue = val * this.mult;
      if (mathAbs(this.v - multipliedValue) > 0.00001) {
        this.v = multipliedValue;
        this._mdf = true;
      }
    } else {
      var i = 0;
      var len = this.v.length;
      while (i < len) {
        multipliedValue = val[i] * this.mult;
        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
          this.v[i] = multipliedValue;
          this._mdf = true;
        }
        i += 1;
      }
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
      return;
    }
    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }
    this.lock = true;
    this._mdf = this._isFirstFrame;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = this.kf ? this.pv : this.data.k;
    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }
    this.setVValue(finalValue);
    this._isFirstFrame = false;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  function ValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.mult = mult || 1;
    this.data = data;
    this.v = mult ? data.k * mult : data.k;
    this.pv = data.k;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.vel = 0;
    this.effectsSequence = [];
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function MultiDimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    this.mult = mult || 1;
    this.data = data;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.frameId = -1;
    var i;
    var len = data.k.length;
    this.v = createTypedArray('float32', len);
    this.pv = createTypedArray('float32', len);
    this.vel = createTypedArray('float32', len);
    for (i = 0; i < len; i += 1) {
      this.v[i] = data.k[i] * this.mult;
      this.pv[i] = data.k[i];
    }
    this._isFirstFrame = true;
    this.effectsSequence = [];
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function KeyframedValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.frameId = -1;
    this._caching = {
      lastFrame: initFrame, lastIndex: 0, value: 0, _lastKeyframeIndex: -1,
    };
    this.k = true;
    this.kf = true;
    this.data = data;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.v = initFrame;
    this.pv = initFrame;
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.addEffect = addEffect;
  }

  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    var i;
    var len = data.k.length;
    var s;
    var e;
    var to;
    var ti;
    for (i = 0; i < len - 1; i += 1) {
      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
        s = data.k[i].s;
        e = data.k[i + 1].s;
        to = data.k[i].to;
        ti = data.k[i].ti;
        if ((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2]))) {
          data.k[i].to = null;
          data.k[i].ti = null;
        }
        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
          if (s.length === 2 || (s[2] === e[2] && to[2] === 0 && ti[2] === 0)) {
            data.k[i].to = null;
            data.k[i].ti = null;
          }
        }
      }
    }
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.data = data;
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.k = true;
    this.kf = true;
    this._isFirstFrame = true;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.frameId = -1;
    var arrLen = data.k[0].s.length;
    this.v = createTypedArray('float32', arrLen);
    this.pv = createTypedArray('float32', arrLen);
    for (i = 0; i < arrLen; i += 1) {
      this.v[i] = initFrame;
      this.pv[i] = initFrame;
    }
    this._caching = { lastFrame: initFrame, lastIndex: 0, value: createTypedArray('float32', arrLen) };
    this.addEffect = addEffect;
  }

  function getProp(elem, data, type, mult, container) {
    var p;
    if (!data.k.length) {
      p = new ValueProperty(elem, data, mult, container);
    } else if (typeof (data.k[0]) === 'number') {
      p = new MultiDimensionalProperty(elem, data, mult, container);
    } else {
      switch (type) {
        case 0:
          p = new KeyframedValueProperty(elem, data, mult, container);
          break;
        case 1:
          p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
          break;
        default:
          break;
      }
    }
    if (p.effectsSequence.length) {
      container.addDynamicProperty(p);
    }
    return p;
  }

  var ob = {
    getProp: getProp,
  };
  return ob;
}());

/* global Matrix, degToRads, PropertyFactory, extendPrototype, DynamicPropertyContainer */
/* exported TransformPropertyFactory */

var TransformPropertyFactory = (function () {
  var defaultVector = [0, 0];

  function applyToMatrix(mat) {
    var _mdf = this._mdf;
    this.iterateDynamicProperties();
    this._mdf = this._mdf || _mdf;
    if (this.a) {
      mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
    }
    if (this.s) {
      mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
    }
    if (this.sk) {
      mat.skewFromAxis(-this.sk.v, this.sa.v);
    }
    if (this.r) {
      mat.rotate(-this.r.v);
    } else {
      mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
        .rotateY(this.or.v[1])
        .rotateX(this.or.v[0]);
    }
    if (this.data.p.s) {
      if (this.data.p.z) {
        mat.translate(this.px.v, this.py.v, -this.pz.v);
      } else {
        mat.translate(this.px.v, this.py.v, 0);
      }
    } else {
      mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
    }
  }
  function processKeys(forceRender) {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    }
    if (this._isDirty) {
      this.precalculateMatrix();
      this._isDirty = false;
    }

    this.iterateDynamicProperties();

    if (this._mdf || forceRender) {
      var frameRate;
      this.v.cloneFromProps(this.pre.props);
      if (this.appliedTransformations < 1) {
        this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      }
      if (this.appliedTransformations < 2) {
        this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      }
      if (this.sk && this.appliedTransformations < 3) {
        this.v.skewFromAxis(-this.sk.v, this.sa.v);
      }
      if (this.r && this.appliedTransformations < 4) {
        this.v.rotate(-this.r.v);
      } else if (!this.r && this.appliedTransformations < 4) {
        this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
          .rotateY(this.or.v[1])
          .rotateX(this.or.v[0]);
      }
      if (this.autoOriented) {
        var v1;
        var v2;
        frameRate = this.elem.globalData.frameRate;
        if (this.p && this.p.keyframes && this.p.getValueAtTime) {
          if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
          } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
            v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / frameRate), 0);
            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
          } else {
            v1 = this.p.pv;
            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
          }
        } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
          v1 = [];
          v2 = [];
          var px = this.px;
          var py = this.py;
          if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
            v2[0] = px.getValueAtTime((px.keyframes[0].t) / frameRate, 0);
            v2[1] = py.getValueAtTime((py.keyframes[0].t) / frameRate, 0);
          } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
            v1[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t / frameRate), 0);
            v1[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t / frameRate), 0);
            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
          } else {
            v1 = [px.pv, py.pv];
            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
          }
        } else {
          v2 = defaultVector;
          v1 = v2;
        }
        this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
      }
      if (this.data.p && this.data.p.s) {
        if (this.data.p.z) {
          this.v.translate(this.px.v, this.py.v, -this.pz.v);
        } else {
          this.v.translate(this.px.v, this.py.v, 0);
        }
      } else {
        this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
    }
    this.frameId = this.elem.globalData.frameId;
  }

  function precalculateMatrix() {
    if (!this.a.k) {
      this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      this.appliedTransformations = 1;
    } else {
      return;
    }
    if (!this.s.effectsSequence.length) {
      this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      this.appliedTransformations = 2;
    } else {
      return;
    }
    if (this.sk) {
      if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
        this.pre.skewFromAxis(-this.sk.v, this.sa.v);
        this.appliedTransformations = 3;
      } else {
        return;
      }
    }
    if (this.r) {
      if (!this.r.effectsSequence.length) {
        this.pre.rotate(-this.r.v);
        this.appliedTransformations = 4;
      }
    } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
      this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
        .rotateY(this.or.v[1])
        .rotateX(this.or.v[0]);
      this.appliedTransformations = 4;
    }
  }

  function autoOrient() {
    //
    // var prevP = this.getValueAtTime();
  }

  function addDynamicProperty(prop) {
    this._addDynamicProperty(prop);
    this.elem.addDynamicProperty(prop);
    this._isDirty = true;
  }

  function TransformProperty(elem, data, container) {
    this.elem = elem;
    this.frameId = -1;
    this.propType = 'transform';
    this.data = data;
    this.v = new Matrix();
    // Precalculated matrix with non animated properties
    this.pre = new Matrix();
    this.appliedTransformations = 0;
    this.initDynamicPropertyContainer(container || elem);
    if (data.p && data.p.s) {
      this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
      this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
      if (data.p.z) {
        this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
      }
    } else {
      this.p = PropertyFactory.getProp(elem, data.p || { k: [0, 0, 0] }, 1, 0, this);
    }
    if (data.rx) {
      this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
      this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
      this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
      if (data.or.k[0].ti) {
        var i;
        var len = data.or.k.length;
        for (i = 0; i < len; i += 1) {
          data.or.k[i].to = null;
          data.or.k[i].ti = null;
        }
      }
      this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
      // sh Indicates it needs to be capped between -180 and 180
      this.or.sh = true;
    } else {
      this.r = PropertyFactory.getProp(elem, data.r || { k: 0 }, 0, degToRads, this);
    }
    if (data.sk) {
      this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
      this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
    }
    this.a = PropertyFactory.getProp(elem, data.a || { k: [0, 0, 0] }, 1, 0, this);
    this.s = PropertyFactory.getProp(elem, data.s || { k: [100, 100, 100] }, 1, 0.01, this);
    // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
    if (data.o) {
      this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
    } else {
      this.o = { _mdf: false, v: 1 };
    }
    this._isDirty = true;
    if (!this.dynamicProperties.length) {
      this.getValue(true);
    }
  }

  TransformProperty.prototype = {
    applyToMatrix: applyToMatrix,
    getValue: processKeys,
    precalculateMatrix: precalculateMatrix,
    autoOrient: autoOrient,
  };

  extendPrototype([DynamicPropertyContainer], TransformProperty);
  TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
  TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

  function getTransformProperty(elem, data, container) {
    return new TransformProperty(elem, data, container);
  }

  return {
    getTransformProperty: getTransformProperty,
  };
}());

/* global createSizedArray, createSizedArray, pointPool */

function ShapePath() {
  this.c = false;
  this._length = 0;
  this._maxLength = 8;
  this.v = createSizedArray(this._maxLength);
  this.o = createSizedArray(this._maxLength);
  this.i = createSizedArray(this._maxLength);
}

ShapePath.prototype.setPathData = function (closed, len) {
  this.c = closed;
  this.setLength(len);
  var i = 0;
  while (i < len) {
    this.v[i] = pointPool.newElement();
    this.o[i] = pointPool.newElement();
    this.i[i] = pointPool.newElement();
    i += 1;
  }
};

ShapePath.prototype.setLength = function (len) {
  while (this._maxLength < len) {
    this.doubleArrayLength();
  }
  this._length = len;
};

ShapePath.prototype.doubleArrayLength = function () {
  this.v = this.v.concat(createSizedArray(this._maxLength));
  this.i = this.i.concat(createSizedArray(this._maxLength));
  this.o = this.o.concat(createSizedArray(this._maxLength));
  this._maxLength *= 2;
};

ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
  var arr;
  this._length = Math.max(this._length, pos + 1);
  if (this._length >= this._maxLength) {
    this.doubleArrayLength();
  }
  switch (type) {
    case 'v':
      arr = this.v;
      break;
    case 'i':
      arr = this.i;
      break;
    case 'o':
      arr = this.o;
      break;
    default:
      arr = [];
      break;
  }
  if (!arr[pos] || (arr[pos] && !replace)) {
    arr[pos] = pointPool.newElement();
  }
  arr[pos][0] = x;
  arr[pos][1] = y;
};

ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
  this.setXYAt(vX, vY, 'v', pos, replace);
  this.setXYAt(oX, oY, 'o', pos, replace);
  this.setXYAt(iX, iY, 'i', pos, replace);
};

ShapePath.prototype.reverse = function () {
  var newPath = new ShapePath();
  newPath.setPathData(this.c, this._length);
  var vertices = this.v;
  var outPoints = this.o;
  var inPoints = this.i;
  var init = 0;
  if (this.c) {
    newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
    init = 1;
  }
  var cnt = this._length - 1;
  var len = this._length;

  var i;
  for (i = init; i < len; i += 1) {
    newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
    cnt -= 1;
  }
  return newPath;
};

/* global extendPrototype, roundCorner, BezierFactory, shapePool, degToRads,
  shapeCollectionPool, PropertyFactory, bmMin, DynamicPropertyContainer */
/* exported ShapePropertyFactory */

var ShapePropertyFactory = (function () {
  var initFrame = -999999;

  function interpolateShape(frameNum, previousValue, caching) {
    var iterationIndex = caching.lastIndex;
    var keyPropS;
    var keyPropE;
    var isHold;
    var j;
    var k;
    var jLen;
    var kLen;
    var perc;
    var vertexValue;
    var kf = this.keyframes;
    if (frameNum < kf[0].t - this.offsetTime) {
      keyPropS = kf[0].s[0];
      isHold = true;
      iterationIndex = 0;
    } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
      keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
      /* if(kf[kf.length - 1].s){
                keyPropS = kf[kf.length - 1].s[0];
            }else{
                keyPropS = kf[kf.length - 2].e[0];
            } */
      isHold = true;
    } else {
      var i = iterationIndex;
      var len = kf.length - 1;
      var flag = true;
      var keyData;
      var nextKeyData;
      var keyframeMetadata;
      while (flag) {
        keyData = kf[i];
        nextKeyData = kf[i + 1];
        if ((nextKeyData.t - this.offsetTime) > frameNum) {
          break;
        }
        if (i < len - 1) {
          i += 1;
        } else {
          flag = false;
        }
      }
      keyframeMetadata = this.keyframesMetadata[i] || {};
      isHold = keyData.h === 1;
      iterationIndex = i;
      if (!isHold) {
        if (frameNum >= nextKeyData.t - this.offsetTime) {
          perc = 1;
        } else if (frameNum < keyData.t - this.offsetTime) {
          perc = 0;
        } else {
          var fnc;
          if (keyframeMetadata.__fnct) {
            fnc = keyframeMetadata.__fnct;
          } else {
            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
            keyframeMetadata.__fnct = fnc;
          }
          perc = fnc((frameNum - (keyData.t - this.offsetTime)) / ((nextKeyData.t - this.offsetTime) - (keyData.t - this.offsetTime)));
        }
        keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
      }
      keyPropS = keyData.s[0];
    }
    jLen = previousValue._length;
    kLen = keyPropS.i[0].length;
    caching.lastIndex = iterationIndex;

    for (j = 0; j < jLen; j += 1) {
      for (k = 0; k < kLen; k += 1) {
        vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
        previousValue.i[j][k] = vertexValue;
        vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
        previousValue.o[j][k] = vertexValue;
        vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
        previousValue.v[j][k] = vertexValue;
      }
    }
  }

  function interpolateShapeCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    var lastFrame = this._caching.lastFrame;
    if (!(lastFrame !== initFrame && ((lastFrame < initTime && frameNum < initTime) || (lastFrame > endTime && frameNum > endTime)))) {
      /// /
      this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
      this.interpolateShape(frameNum, this.pv, this._caching);
      /// /
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function resetShape() {
    this.paths = this.localShapeCollection;
  }

  function shapesEqual(shape1, shape2) {
    if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
      return false;
    }
    var i;
    var len = shape1._length;
    for (i = 0; i < len; i += 1) {
      if (shape1.v[i][0] !== shape2.v[i][0]
            || shape1.v[i][1] !== shape2.v[i][1]
            || shape1.o[i][0] !== shape2.o[i][0]
            || shape1.o[i][1] !== shape2.o[i][1]
            || shape1.i[i][0] !== shape2.i[i][0]
            || shape1.i[i][1] !== shape2.i[i][1]) {
        return false;
      }
    }
    return true;
  }

  function setVValue(newPath) {
    if (!shapesEqual(this.v, newPath)) {
      this.v = shapePool.clone(newPath);
      this.localShapeCollection.releaseShapes();
      this.localShapeCollection.addShape(this.v);
      this._mdf = true;
      this.paths = this.localShapeCollection;
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    } if (!this.effectsSequence.length) {
      this._mdf = false;
      return;
    }
    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }
    this.lock = true;
    this._mdf = false;
    var finalValue;
    if (this.kf) {
      finalValue = this.pv;
    } else if (this.data.ks) {
      finalValue = this.data.ks.k;
    } else {
      finalValue = this.data.pt.k;
    }
    var i;
    var len = this.effectsSequence.length;
    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }
    this.setVValue(finalValue);
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function ShapeProperty(elem, data, type) {
    this.propType = 'shape';
    this.comp = elem.comp;
    this.container = elem;
    this.elem = elem;
    this.data = data;
    this.k = false;
    this.kf = false;
    this._mdf = false;
    var pathData = type === 3 ? data.pt.k : data.ks.k;
    this.v = shapePool.clone(pathData);
    this.pv = shapePool.clone(this.v);
    this.localShapeCollection = shapeCollectionPool.newShapeCollection();
    this.paths = this.localShapeCollection;
    this.paths.addShape(this.v);
    this.reset = resetShape;
    this.effectsSequence = [];
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  ShapeProperty.prototype.interpolateShape = interpolateShape;
  ShapeProperty.prototype.getValue = processEffectsSequence;
  ShapeProperty.prototype.setVValue = setVValue;
  ShapeProperty.prototype.addEffect = addEffect;

  function KeyframedShapeProperty(elem, data, type) {
    this.propType = 'shape';
    this.comp = elem.comp;
    this.elem = elem;
    this.container = elem;
    this.offsetTime = elem.data.st;
    this.keyframes = type === 3 ? data.pt.k : data.ks.k;
    this.keyframesMetadata = [];
    this.k = true;
    this.kf = true;
    var len = this.keyframes[0].s[0].i.length;
    this.v = shapePool.newElement();
    this.v.setPathData(this.keyframes[0].s[0].c, len);
    this.pv = shapePool.clone(this.v);
    this.localShapeCollection = shapeCollectionPool.newShapeCollection();
    this.paths = this.localShapeCollection;
    this.paths.addShape(this.v);
    this.lastFrame = initFrame;
    this.reset = resetShape;
    this._caching = { lastFrame: initFrame, lastIndex: 0 };
    this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
  }
  KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
  KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
  KeyframedShapeProperty.prototype.setVValue = setVValue;
  KeyframedShapeProperty.prototype.addEffect = addEffect;

  var EllShapeProperty = (function () {
    var cPoint = roundCorner;

    function EllShapePropertyFactory(elem, data) {
      /* this.v = {
                v: createSizedArray(4),
                i: createSizedArray(4),
                o: createSizedArray(4),
                c: true
            }; */
      this.v = shapePool.newElement();
      this.v.setPathData(true, 4);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.localShapeCollection.addShape(this.v);
      this.d = data.d;
      this.elem = elem;
      this.comp = elem.comp;
      this.frameId = -1;
      this.initDynamicPropertyContainer(elem);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertEllToPath();
      }
    }

    EllShapePropertyFactory.prototype = {
      reset: resetShape,
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();

        if (this._mdf) {
          this.convertEllToPath();
        }
      },
      convertEllToPath: function () {
        var p0 = this.p.v[0];
        var p1 = this.p.v[1];
        var s0 = this.s.v[0] / 2;
        var s1 = this.s.v[1] / 2;
        var _cw = this.d !== 3;
        var _v = this.v;
        _v.v[0][0] = p0;
        _v.v[0][1] = p1 - s1;
        _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.v[1][1] = p1;
        _v.v[2][0] = p0;
        _v.v[2][1] = p1 + s1;
        _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.v[3][1] = p1;
        _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
        _v.i[0][1] = p1 - s1;
        _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.i[1][1] = p1 - s1 * cPoint;
        _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
        _v.i[2][1] = p1 + s1;
        _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.i[3][1] = p1 + s1 * cPoint;
        _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
        _v.o[0][1] = p1 - s1;
        _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.o[1][1] = p1 + s1 * cPoint;
        _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
        _v.o[2][1] = p1 + s1;
        _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.o[3][1] = p1 - s1 * cPoint;
      },
    };

    extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);

    return EllShapePropertyFactory;
  }());

  var StarShapeProperty = (function () {
    function StarShapePropertyFactory(elem, data) {
      this.v = shapePool.newElement();
      this.v.setPathData(true, 0);
      this.elem = elem;
      this.comp = elem.comp;
      this.data = data;
      this.frameId = -1;
      this.d = data.d;
      this.initDynamicPropertyContainer(elem);
      if (data.sy === 1) {
        this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
        this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
        this.convertToPath = this.convertStarToPath;
      } else {
        this.convertToPath = this.convertPolygonToPath;
      }
      this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
      this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
      this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.localShapeCollection.addShape(this.v);
      this.paths = this.localShapeCollection;
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertToPath();
      }
    }

    StarShapePropertyFactory.prototype = {
      reset: resetShape,
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        if (this._mdf) {
          this.convertToPath();
        }
      },
      convertStarToPath: function () {
        var numPts = Math.floor(this.pt.v) * 2;
        var angle = (Math.PI * 2) / numPts;
        /* this.v.v.length = numPts;
                this.v.i.length = numPts;
                this.v.o.length = numPts; */
        var longFlag = true;
        var longRad = this.or.v;
        var shortRad = this.ir.v;
        var longRound = this.os.v;
        var shortRound = this.is.v;
        var longPerimSegment = (2 * Math.PI * longRad) / (numPts * 2);
        var shortPerimSegment = (2 * Math.PI * shortRad) / (numPts * 2);
        var i;
        var rad;
        var roundness;
        var perimSegment;
        var currentAng = -Math.PI / 2;
        currentAng += this.r.v;
        var dir = this.data.d === 3 ? -1 : 1;
        this.v._length = 0;
        for (i = 0; i < numPts; i += 1) {
          rad = longFlag ? longRad : shortRad;
          roundness = longFlag ? longRound : shortRound;
          perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
          var x = rad * Math.cos(currentAng);
          var y = rad * Math.sin(currentAng);
          var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
          var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
          x += +this.p.v[0];
          y += +this.p.v[1];
          this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);

          /* this.v.v[i] = [x,y];
                    this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                    this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                    this.v._length = numPts; */
          longFlag = !longFlag;
          currentAng += angle * dir;
        }
      },
      convertPolygonToPath: function () {
        var numPts = Math.floor(this.pt.v);
        var angle = (Math.PI * 2) / numPts;
        var rad = this.or.v;
        var roundness = this.os.v;
        var perimSegment = (2 * Math.PI * rad) / (numPts * 4);
        var i;
        var currentAng = -Math.PI * 0.5;
        var dir = this.data.d === 3 ? -1 : 1;
        currentAng += this.r.v;
        this.v._length = 0;
        for (i = 0; i < numPts; i += 1) {
          var x = rad * Math.cos(currentAng);
          var y = rad * Math.sin(currentAng);
          var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
          var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
          x += +this.p.v[0];
          y += +this.p.v[1];
          this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
          currentAng += angle * dir;
        }
        this.paths.length = 0;
        this.paths[0] = this.v;
      },

    };
    extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);

    return StarShapePropertyFactory;
  }());

  var RectShapeProperty = (function () {
    function RectShapePropertyFactory(elem, data) {
      this.v = shapePool.newElement();
      this.v.c = true;
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.localShapeCollection.addShape(this.v);
      this.paths = this.localShapeCollection;
      this.elem = elem;
      this.comp = elem.comp;
      this.frameId = -1;
      this.d = data.d;
      this.initDynamicPropertyContainer(elem);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
      this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertRectToPath();
      }
    }

    RectShapePropertyFactory.prototype = {
      convertRectToPath: function () {
        var p0 = this.p.v[0];
        var p1 = this.p.v[1];
        var v0 = this.s.v[0] / 2;
        var v1 = this.s.v[1] / 2;
        var round = bmMin(v0, v1, this.r.v);
        var cPoint = round * (1 - roundCorner);
        this.v._length = 0;

        if (this.d === 2 || this.d === 1) {
          this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
          this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
          if (round !== 0) {
            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
          } else {
            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
          }
        } else {
          this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
          if (round !== 0) {
            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
          } else {
            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
          }
        }
      },
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        if (this._mdf) {
          this.convertRectToPath();
        }
      },
      reset: resetShape,
    };
    extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);

    return RectShapePropertyFactory;
  }());

  function getShapeProp(elem, data, type) {
    var prop;
    if (type === 3 || type === 4) {
      var dataProp = type === 3 ? data.pt : data.ks;
      var keys = dataProp.k;
      if (keys.length) {
        prop = new KeyframedShapeProperty(elem, data, type);
      } else {
        prop = new ShapeProperty(elem, data, type);
      }
    } else if (type === 5) {
      prop = new RectShapeProperty(elem, data);
    } else if (type === 6) {
      prop = new EllShapeProperty(elem, data);
    } else if (type === 7) {
      prop = new StarShapeProperty(elem, data);
    }
    if (prop.k) {
      elem.addDynamicProperty(prop);
    }
    return prop;
  }

  function getConstructorFunction() {
    return ShapeProperty;
  }

  function getKeyframedConstructorFunction() {
    return KeyframedShapeProperty;
  }

  var ob = {};
  ob.getShapeProp = getShapeProp;
  ob.getConstructorFunction = getConstructorFunction;
  ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
  return ob;
}());

/* global shapeCollectionPool, initialDefaultFrame, extendPrototype, DynamicPropertyContainer */
/* exported ShapeModifiers */

var ShapeModifiers = (function () {
  var ob = {};
  var modifiers = {};
  ob.registerModifier = registerModifier;
  ob.getModifier = getModifier;

  function registerModifier(nm, factory) {
    if (!modifiers[nm]) {
      modifiers[nm] = factory;
    }
  }

  function getModifier(nm, elem, data) {
    return new modifiers[nm](elem, data);
  }

  return ob;
}());

function ShapeModifier() {}
ShapeModifier.prototype.initModifierProperties = function () {};
ShapeModifier.prototype.addShapeToModifier = function () {};
ShapeModifier.prototype.addShape = function (data) {
  if (!this.closed) {
    // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
    data.sh.container.addDynamicProperty(data.sh);
    var shapeData = { shape: data.sh, data: data, localShapeCollection: shapeCollectionPool.newShapeCollection() };
    this.shapes.push(shapeData);
    this.addShapeToModifier(shapeData);
    if (this._isAnimated) {
      data.setAsAnimated();
    }
  }
};
ShapeModifier.prototype.init = function (elem, data) {
  this.shapes = [];
  this.elem = elem;
  this.initDynamicPropertyContainer(elem);
  this.initModifierProperties(elem, data);
  this.frameId = initialDefaultFrame;
  this.closed = false;
  this.k = false;
  if (this.dynamicProperties.length) {
    this.k = true;
  } else {
    this.getValue(true);
  }
};
ShapeModifier.prototype.processKeys = function () {
  if (this.elem.globalData.frameId === this.frameId) {
    return;
  }
  this.frameId = this.elem.globalData.frameId;
  this.iterateDynamicProperties();
};

extendPrototype([DynamicPropertyContainer], ShapeModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, segmentsLengthPool, bez, shapePool, ShapeModifiers */

function TrimModifier() {
}
extendPrototype([ShapeModifier], TrimModifier);
TrimModifier.prototype.initModifierProperties = function (elem, data) {
  this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
  this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
  this.sValue = 0;
  this.eValue = 0;
  this.getValue = this.processKeys;
  this.m = data.m;
  this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
};

TrimModifier.prototype.addShapeToModifier = function (shapeData) {
  shapeData.pathsData = [];
};

TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
  var segments = [];
  if (e <= 1) {
    segments.push({
      s: s,
      e: e,
    });
  } else if (s >= 1) {
    segments.push({
      s: s - 1,
      e: e - 1,
    });
  } else {
    segments.push({
      s: s,
      e: 1,
    });
    segments.push({
      s: 0,
      e: e - 1,
    });
  }
  var shapeSegments = [];
  var i;
  var len = segments.length;
  var segmentOb;
  for (i = 0; i < len; i += 1) {
    segmentOb = segments[i];
    if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
      var shapeS;
      var shapeE;
      if (segmentOb.s * totalModifierLength <= addedLength) {
        shapeS = 0;
      } else {
        shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
      }
      if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
        shapeE = 1;
      } else {
        shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
      }
      shapeSegments.push([shapeS, shapeE]);
    }
  }
  if (!shapeSegments.length) {
    shapeSegments.push([0, 0]);
  }
  return shapeSegments;
};

TrimModifier.prototype.releasePathsData = function (pathsData) {
  var i;
  var len = pathsData.length;
  for (i = 0; i < len; i += 1) {
    segmentsLengthPool.release(pathsData[i]);
  }
  pathsData.length = 0;
  return pathsData;
};

TrimModifier.prototype.processShapes = function (_isFirstFrame) {
  var s;
  var e;
  if (this._mdf || _isFirstFrame) {
    var o = (this.o.v % 360) / 360;
    if (o < 0) {
      o += 1;
    }
    if (this.s.v > 1) {
      s = 1 + o;
    } else if (this.s.v < 0) {
      s = 0 + o;
    } else {
      s = this.s.v + o;
    }
    if (this.e.v > 1) {
      e = 1 + o;
    } else if (this.e.v < 0) {
      e = 0 + o;
    } else {
      e = this.e.v + o;
    }

    if (s > e) {
      var _s = s;
      s = e;
      e = _s;
    }
    s = Math.round(s * 10000) * 0.0001;
    e = Math.round(e * 10000) * 0.0001;
    this.sValue = s;
    this.eValue = e;
  } else {
    s = this.sValue;
    e = this.eValue;
  }
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var pathsData;
  var pathData;
  var totalShapeLength;
  var totalModifierLength = 0;

  if (e === s) {
    for (i = 0; i < len; i += 1) {
      this.shapes[i].localShapeCollection.releaseShapes();
      this.shapes[i].shape._mdf = true;
      this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
      if (this._mdf) {
        this.shapes[i].pathsData.length = 0;
      }
    }
  } else if (!((e === 1 && s === 0) || (e === 0 && s === 1))) {
    var segments = [];
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
      if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
        shapeData.shape.paths = shapeData.localShapeCollection;
      } else {
        shapePaths = shapeData.shape.paths;
        jLen = shapePaths._length;
        totalShapeLength = 0;
        if (!shapeData.shape._mdf && shapeData.pathsData.length) {
          totalShapeLength = shapeData.totalShapeLength;
        } else {
          pathsData = this.releasePathsData(shapeData.pathsData);
          for (j = 0; j < jLen; j += 1) {
            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
            pathsData.push(pathData);
            totalShapeLength += pathData.totalLength;
          }
          shapeData.totalShapeLength = totalShapeLength;
          shapeData.pathsData = pathsData;
        }

        totalModifierLength += totalShapeLength;
        shapeData.shape._mdf = true;
      }
    }
    var shapeS = s;
    var shapeE = e;
    var addedLength = 0;
    var edges;
    for (i = len - 1; i >= 0; i -= 1) {
      shapeData = this.shapes[i];
      if (shapeData.shape._mdf) {
        localShapeCollection = shapeData.localShapeCollection;
        localShapeCollection.releaseShapes();
        // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
        if (this.m === 2 && len > 1) {
          edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
          addedLength += shapeData.totalShapeLength;
        } else {
          edges = [[shapeS, shapeE]];
        }
        jLen = edges.length;
        for (j = 0; j < jLen; j += 1) {
          shapeS = edges[j][0];
          shapeE = edges[j][1];
          segments.length = 0;
          if (shapeE <= 1) {
            segments.push({
              s: shapeData.totalShapeLength * shapeS,
              e: shapeData.totalShapeLength * shapeE,
            });
          } else if (shapeS >= 1) {
            segments.push({
              s: shapeData.totalShapeLength * (shapeS - 1),
              e: shapeData.totalShapeLength * (shapeE - 1),
            });
          } else {
            segments.push({
              s: shapeData.totalShapeLength * shapeS,
              e: shapeData.totalShapeLength,
            });
            segments.push({
              s: 0,
              e: shapeData.totalShapeLength * (shapeE - 1),
            });
          }
          var newShapesData = this.addShapes(shapeData, segments[0]);
          if (segments[0].s !== segments[0].e) {
            if (segments.length > 1) {
              var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
              if (lastShapeInCollection.c) {
                var lastShape = newShapesData.pop();
                this.addPaths(newShapesData, localShapeCollection);
                newShapesData = this.addShapes(shapeData, segments[1], lastShape);
              } else {
                this.addPaths(newShapesData, localShapeCollection);
                newShapesData = this.addShapes(shapeData, segments[1]);
              }
            }
            this.addPaths(newShapesData, localShapeCollection);
          }
        }
        shapeData.shape.paths = localShapeCollection;
      }
    }
  } else if (this._mdf) {
    for (i = 0; i < len; i += 1) {
      // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
      // Don't remove this even if it's losing cached info.
      this.shapes[i].pathsData.length = 0;
      this.shapes[i].shape._mdf = true;
    }
  }
};

TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
  var i;
  var len = newPaths.length;
  for (i = 0; i < len; i += 1) {
    localShapeCollection.addShape(newPaths[i]);
  }
};

TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
  shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
  shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
  if (newShape) {
    shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
  }
  shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
};

TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
  shapePath.setXYAt(points[1], points[5], 'o', pos);
  shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
  if (newShape) {
    shapePath.setXYAt(points[0], points[4], 'v', pos);
  }
  shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
};

TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
  var pathsData = shapeData.pathsData;
  var shapePaths = shapeData.shape.paths.shapes;
  var i;
  var len = shapeData.shape.paths._length;
  var j;
  var jLen;
  var addedLength = 0;
  var currentLengthData;
  var segmentCount;
  var lengths;
  var segment;
  var shapes = [];
  var initPos;
  var newShape = true;
  if (!shapePath) {
    shapePath = shapePool.newElement();
    segmentCount = 0;
    initPos = 0;
  } else {
    segmentCount = shapePath._length;
    initPos = shapePath._length;
  }
  shapes.push(shapePath);
  for (i = 0; i < len; i += 1) {
    lengths = pathsData[i].lengths;
    shapePath.c = shapePaths[i].c;
    jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
    for (j = 1; j < jLen; j += 1) {
      currentLengthData = lengths[j - 1];
      if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
        addedLength += currentLengthData.addedLength;
        shapePath.c = false;
      } else if (addedLength > shapeSegment.e) {
        shapePath.c = false;
        break;
      } else {
        if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
          this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
          newShape = false;
        } else {
          segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
          this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
          // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
          newShape = false;
          shapePath.c = false;
        }
        addedLength += currentLengthData.addedLength;
        segmentCount += 1;
      }
    }
    if (shapePaths[i].c && lengths.length) {
      currentLengthData = lengths[j - 1];
      if (addedLength <= shapeSegment.e) {
        var segmentLength = lengths[j - 1].addedLength;
        if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
          this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
          newShape = false;
        } else {
          segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
          this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
          // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
          newShape = false;
          shapePath.c = false;
        }
      } else {
        shapePath.c = false;
      }
      addedLength += currentLengthData.addedLength;
      segmentCount += 1;
    }
    if (shapePath._length) {
      shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
      shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
    }
    if (addedLength > shapeSegment.e) {
      break;
    }
    if (i < len - 1) {
      shapePath = shapePool.newElement();
      newShape = true;
      shapes.push(shapePath);
      segmentCount = 0;
    }
  }
  return shapes;
};

ShapeModifiers.registerModifier('tm', TrimModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, shapePool, roundCorner, ShapeModifiers */

function RoundCornersModifier() {}
extendPrototype([ShapeModifier], RoundCornersModifier);
RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
  this._isAnimated = !!this.rd.effectsSequence.length;
};

RoundCornersModifier.prototype.processPath = function (path, round) {
  var clonedPath = shapePool.newElement();
  clonedPath.c = path.c;
  var i;
  var len = path._length;
  var currentV;
  var currentI;
  var currentO;
  var closerV;
  var distance;
  var newPosPerc;
  var index = 0;
  var vX;
  var vY;
  var oX;
  var oY;
  var iX;
  var iY;
  for (i = 0; i < len; i += 1) {
    currentV = path.v[i];
    currentO = path.o[i];
    currentI = path.i[i];
    if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
      if ((i === 0 || i === len - 1) && !path.c) {
        clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
        /* clonedPath.v[index] = currentV;
                clonedPath.o[index] = currentO;
                clonedPath.i[index] = currentI; */
        index += 1;
      } else {
        if (i === 0) {
          closerV = path.v[len - 1];
        } else {
          closerV = path.v[i - 1];
        }
        distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
        newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
        iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
        vX = iX;
        iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
        vY = iY;
        oX = vX - (vX - currentV[0]) * roundCorner;
        oY = vY - (vY - currentV[1]) * roundCorner;
        clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
        index += 1;

        if (i === len - 1) {
          closerV = path.v[0];
        } else {
          closerV = path.v[i + 1];
        }
        distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
        newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
        oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
        vX = oX;
        oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
        vY = oY;
        iX = vX - (vX - currentV[0]) * roundCorner;
        iY = vY - (vY - currentV[1]) * roundCorner;
        clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
        index += 1;
      }
    } else {
      clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
      index += 1;
    }
  }
  return clonedPath;
};

RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var rd = this.rd.v;

  if (rd !== 0) {
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      localShapeCollection = shapeData.localShapeCollection;
      if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
        localShapeCollection.releaseShapes();
        shapeData.shape._mdf = true;
        shapePaths = shapeData.shape.paths.shapes;
        jLen = shapeData.shape.paths._length;
        for (j = 0; j < jLen; j += 1) {
          localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
        }
      }
      shapeData.shape.paths = shapeData.localShapeCollection;
    }
  }
  if (!this.dynamicProperties.length) {
    this._mdf = false;
  }
};

ShapeModifiers.registerModifier('rd', RoundCornersModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, shapePool, ShapeModifiers */

function PuckerAndBloatModifier() {}
extendPrototype([ShapeModifier], PuckerAndBloatModifier);
PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
  this._isAnimated = !!this.amount.effectsSequence.length;
};

PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
  var percent = amount / 100;
  var centerPoint = [0, 0];
  var pathLength = path._length;
  var i = 0;
  for (i = 0; i < pathLength; i += 1) {
    centerPoint[0] += path.v[i][0];
    centerPoint[1] += path.v[i][1];
  }
  centerPoint[0] /= pathLength;
  centerPoint[1] /= pathLength;
  var clonedPath = shapePool.newElement();
  clonedPath.c = path.c;
  var vX;
  var vY;
  var oX;
  var oY;
  var iX;
  var iY;
  for (i = 0; i < pathLength; i += 1) {
    vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
    vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
    oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
    oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
    iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
    iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
  }
  return clonedPath;
};

PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var amount = this.amount.v;

  if (amount !== 0) {
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      localShapeCollection = shapeData.localShapeCollection;
      if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
        localShapeCollection.releaseShapes();
        shapeData.shape._mdf = true;
        shapePaths = shapeData.shape.paths.shapes;
        jLen = shapeData.shape.paths._length;
        for (j = 0; j < jLen; j += 1) {
          localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
        }
      }
      shapeData.shape.paths = shapeData.localShapeCollection;
    }
  }
  if (!this.dynamicProperties.length) {
    this._mdf = false;
  }
};
ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);

/* global extendPrototype, ShapeModifier, TransformPropertyFactory, PropertyFactory, Matrix, ShapeModifiers */

function RepeaterModifier() {}
extendPrototype([ShapeModifier], RepeaterModifier);

RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
  this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
  this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
  this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
  this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
  this.data = data;
  if (!this.dynamicProperties.length) {
    this.getValue(true);
  }
  this._isAnimated = !!this.dynamicProperties.length;
  this.pMatrix = new Matrix();
  this.rMatrix = new Matrix();
  this.sMatrix = new Matrix();
  this.tMatrix = new Matrix();
  this.matrix = new Matrix();
};

RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
  var dir = inv ? -1 : 1;
  var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
  var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
  pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
  rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
  rMatrix.rotate(-transform.r.v * dir * perc);
  rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
  sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
  sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
  sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
};

RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
  this.elem = elem;
  this.arr = arr;
  this.pos = pos;
  this.elemsData = elemsData;
  this._currentCopies = 0;
  this._elements = [];
  this._groups = [];
  this.frameId = -1;
  this.initDynamicPropertyContainer(elem);
  this.initModifierProperties(elem, arr[pos]);
  while (pos > 0) {
    pos -= 1;
    // this._elements.unshift(arr.splice(pos,1)[0]);
    this._elements.unshift(arr[pos]);
  }
  if (this.dynamicProperties.length) {
    this.k = true;
  } else {
    this.getValue(true);
  }
};

RepeaterModifier.prototype.resetElements = function (elements) {
  var i;
  var len = elements.length;
  for (i = 0; i < len; i += 1) {
    elements[i]._processed = false;
    if (elements[i].ty === 'gr') {
      this.resetElements(elements[i].it);
    }
  }
};

RepeaterModifier.prototype.cloneElements = function (elements) {
  var newElements = JSON.parse(JSON.stringify(elements));
  this.resetElements(newElements);
  return newElements;
};

RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
  var i;
  var len = elements.length;
  for (i = 0; i < len; i += 1) {
    elements[i]._render = renderFlag;
    if (elements[i].ty === 'gr') {
      this.changeGroupRender(elements[i].it, renderFlag);
    }
  }
};

RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
  var items;
  var itemsTransform;
  var i;
  var dir;
  var cont;
  var hasReloaded = false;
  if (this._mdf || _isFirstFrame) {
    var copies = Math.ceil(this.c.v);
    if (this._groups.length < copies) {
      while (this._groups.length < copies) {
        var group = {
          it: this.cloneElements(this._elements),
          ty: 'gr',
        };
        group.it.push({
          a: { a: 0, ix: 1, k: [0, 0] }, nm: 'Transform', o: { a: 0, ix: 7, k: 100 }, p: { a: 0, ix: 2, k: [0, 0] }, r: { a: 1, ix: 6, k: [{ s: 0, e: 0, t: 0 }, { s: 0, e: 0, t: 1 }] }, s: { a: 0, ix: 3, k: [100, 100] }, sa: { a: 0, ix: 5, k: 0 }, sk: { a: 0, ix: 4, k: 0 }, ty: 'tr',
        });

        this.arr.splice(0, 0, group);
        this._groups.splice(0, 0, group);
        this._currentCopies += 1;
      }
      this.elem.reloadShapes();
      hasReloaded = true;
    }
    cont = 0;
    var renderFlag;
    for (i = 0; i <= this._groups.length - 1; i += 1) {
      renderFlag = cont < copies;
      this._groups[i]._render = renderFlag;
      this.changeGroupRender(this._groups[i].it, renderFlag);
      if (!renderFlag) {
        var elems = this.elemsData[i].it;
        var transformData = elems[elems.length - 1];
        if (transformData.transform.op.v !== 0) {
          transformData.transform.op._mdf = true;
          transformData.transform.op.v = 0;
        } else {
          transformData.transform.op._mdf = false;
        }
      }
      cont += 1;
    }

    this._currentCopies = copies;
    /// /

    var offset = this.o.v;
    var offsetModulo = offset % 1;
    var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    var pProps = this.pMatrix.props;
    var rProps = this.rMatrix.props;
    var sProps = this.sMatrix.props;
    this.pMatrix.reset();
    this.rMatrix.reset();
    this.sMatrix.reset();
    this.tMatrix.reset();
    this.matrix.reset();
    var iteration = 0;

    if (offset > 0) {
      while (iteration < roundOffset) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
        iteration += 1;
      }
      if (offsetModulo) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
        iteration += offsetModulo;
      }
    } else if (offset < 0) {
      while (iteration > roundOffset) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
        iteration -= 1;
      }
      if (offsetModulo) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
        iteration -= offsetModulo;
      }
    }
    i = this.data.m === 1 ? 0 : this._currentCopies - 1;
    dir = this.data.m === 1 ? 1 : -1;
    cont = this._currentCopies;
    var j;
    var jLen;
    while (cont) {
      items = this.elemsData[i].it;
      itemsTransform = items[items.length - 1].transform.mProps.v.props;
      jLen = itemsTransform.length;
      items[items.length - 1].transform.mProps._mdf = true;
      items[items.length - 1].transform.op._mdf = true;
      items[items.length - 1].transform.op.v = this._currentCopies === 1
        ? this.so.v
        : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));

      if (iteration !== 0) {
        if ((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
        }
        this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
        this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
        this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);

        for (j = 0; j < jLen; j += 1) {
          itemsTransform[j] = this.matrix.props[j];
        }
        this.matrix.reset();
      } else {
        this.matrix.reset();
        for (j = 0; j < jLen; j += 1) {
          itemsTransform[j] = this.matrix.props[j];
        }
      }
      iteration += 1;
      cont -= 1;
      i += dir;
    }
  } else {
    cont = this._currentCopies;
    i = 0;
    dir = 1;
    while (cont) {
      items = this.elemsData[i].it;
      itemsTransform = items[items.length - 1].transform.mProps.v.props;
      items[items.length - 1].transform.mProps._mdf = false;
      items[items.length - 1].transform.op._mdf = false;
      cont -= 1;
      i += dir;
    }
  }
  return hasReloaded;
};

RepeaterModifier.prototype.addShape = function () {};

ShapeModifiers.registerModifier('rp', RepeaterModifier);

/* global createSizedArray, shapePool */

function ShapeCollection() {
  this._length = 0;
  this._maxLength = 4;
  this.shapes = createSizedArray(this._maxLength);
}

ShapeCollection.prototype.addShape = function (shapeData) {
  if (this._length === this._maxLength) {
    this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
    this._maxLength *= 2;
  }
  this.shapes[this._length] = shapeData;
  this._length += 1;
};

ShapeCollection.prototype.releaseShapes = function () {
  var i;
  for (i = 0; i < this._length; i += 1) {
    shapePool.release(this.shapes[i]);
  }
  this._length = 0;
};

/* global createSizedArray, createTypedArray, PropertyFactory, extendPrototype, DynamicPropertyContainer */

function DashProperty(elem, data, renderer, container) {
  this.elem = elem;
  this.frameId = -1;
  this.dataProps = createSizedArray(data.length);
  this.renderer = renderer;
  this.k = false;
  this.dashStr = '';
  this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
  this.dashoffset = createTypedArray('float32', 1);
  this.initDynamicPropertyContainer(container);
  var i;
  var len = data.length || 0;
  var prop;
  for (i = 0; i < len; i += 1) {
    prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
    this.k = prop.k || this.k;
    this.dataProps[i] = { n: data[i].n, p: prop };
  }
  if (!this.k) {
    this.getValue(true);
  }
  this._isAnimated = this.k;
}

DashProperty.prototype.getValue = function (forceRender) {
  if (this.elem.globalData.frameId === this.frameId && !forceRender) {
    return;
  }
  this.frameId = this.elem.globalData.frameId;
  this.iterateDynamicProperties();
  this._mdf = this._mdf || forceRender;
  if (this._mdf) {
    var i = 0;
    var len = this.dataProps.length;
    if (this.renderer === 'svg') {
      this.dashStr = '';
    }
    for (i = 0; i < len; i += 1) {
      if (this.dataProps[i].n !== 'o') {
        if (this.renderer === 'svg') {
          this.dashStr += ' ' + this.dataProps[i].p.v;
        } else {
          this.dashArray[i] = this.dataProps[i].p.v;
        }
      } else {
        this.dashoffset[0] = this.dataProps[i].p.v;
      }
    }
  }
};
extendPrototype([DynamicPropertyContainer], DashProperty);

/* global createTypedArray, PropertyFactory, extendPrototype, DynamicPropertyContainer */
function GradientProperty(elem, data, container) {
  this.data = data;
  this.c = createTypedArray('uint8c', data.p * 4);
  var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p * 4) : data.k.k.length - data.p * 4;
  this.o = createTypedArray('float32', cLength);
  this._cmdf = false;
  this._omdf = false;
  this._collapsable = this.checkCollapsable();
  this._hasOpacity = cLength;
  this.initDynamicPropertyContainer(container);
  this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
  this.k = this.prop.k;
  this.getValue(true);
}

GradientProperty.prototype.comparePoints = function (values, points) {
  var i = 0;
  var len = this.o.length / 2;
  var diff;
  while (i < len) {
    diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
    if (diff > 0.01) {
      return false;
    }
    i += 1;
  }
  return true;
};

GradientProperty.prototype.checkCollapsable = function () {
  if (this.o.length / 2 !== this.c.length / 4) {
    return false;
  }
  if (this.data.k.k[0].s) {
    var i = 0;
    var len = this.data.k.k.length;
    while (i < len) {
      if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
        return false;
      }
      i += 1;
    }
  } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
    return false;
  }
  return true;
};

GradientProperty.prototype.getValue = function (forceRender) {
  this.prop.getValue();
  this._mdf = false;
  this._cmdf = false;
  this._omdf = false;
  if (this.prop._mdf || forceRender) {
    var i;
    var len = this.data.p * 4;
    var mult;
    var val;
    for (i = 0; i < len; i += 1) {
      mult = i % 4 === 0 ? 100 : 255;
      val = Math.round(this.prop.v[i] * mult);
      if (this.c[i] !== val) {
        this.c[i] = val;
        this._cmdf = !forceRender;
      }
    }
    if (this.o.length) {
      len = this.prop.v.length;
      for (i = this.data.p * 4; i < len; i += 1) {
        mult = i % 2 === 0 ? 100 : 1;
        val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
        if (this.o[i - this.data.p * 4] !== val) {
          this.o[i - this.data.p * 4] = val;
          this._omdf = !forceRender;
        }
      }
    }
    this._mdf = !forceRender;
  }
};

extendPrototype([DynamicPropertyContainer], GradientProperty);

/* exported buildShapeString */

var buildShapeString = function (pathNodes, length, closed, mat) {
  if (length === 0) {
    return '';
  }
  var _o = pathNodes.o;
  var _i = pathNodes.i;
  var _v = pathNodes.v;
  var i;
  var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
  for (i = 1; i < length; i += 1) {
    shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
  }
  if (closed && length) {
    shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
    shapeString += 'z';
  }
  return shapeString;
};

/* global Howl */
/* exported audioControllerFactory */

var audioControllerFactory = (function () {
  function AudioController(audioFactory) {
    this.audios = [];
    this.audioFactory = audioFactory;
    this._volume = 1;
    this._isMuted = false;
  }

  AudioController.prototype = {
    addAudio: function (audio) {
      this.audios.push(audio);
    },
    pause: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].pause();
      }
    },
    resume: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].resume();
      }
    },
    setRate: function (rateValue) {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].setRate(rateValue);
      }
    },
    createAudio: function (assetPath) {
      if (this.audioFactory) {
        return this.audioFactory(assetPath);
      } if (Howl) {
        return new Howl({
          src: [assetPath],
        });
      }
      return {
        isPlaying: false,
        play: function () { this.isPlaying = true; },
        seek: function () { this.isPlaying = false; },
        playing: function () {},
        rate: function () {},
        setVolume: function () {},
      };
    },
    setAudioFactory: function (audioFactory) {
      this.audioFactory = audioFactory;
    },
    setVolume: function (value) {
      this._volume = value;
      this._updateVolume();
    },
    mute: function () {
      this._isMuted = true;
      this._updateVolume();
    },
    unmute: function () {
      this._isMuted = false;
      this._updateVolume();
    },
    getVolume: function () {
      return this._volume;
    },
    _updateVolume: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
      }
    },
  };

  return function () {
    return new AudioController();
  };
}());

/* global createTag, createNS, isSafari, dataManager */
/* exported ImagePreloader */

var ImagePreloader = (function () {
  var proxyImage = (function () {
    var canvas = createTag('canvas');
    canvas.width = 1;
    canvas.height = 1;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return canvas;
  }());

  function imageLoaded() {
    this.loadedAssets += 1;
    if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
      if (this.imagesLoadedCb) {
        this.imagesLoadedCb(null);
      }
    }
  }
  function footageLoaded() {
    this.loadedFootagesCount += 1;
    if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
      if (this.imagesLoadedCb) {
        this.imagesLoadedCb(null);
      }
    }
  }

  function getAssetsPath(assetData, assetsPath, originalPath) {
    var path = '';
    if (assetData.e) {
      path = assetData.p;
    } else if (assetsPath) {
      var imagePath = assetData.p;
      if (imagePath.indexOf('images/') !== -1) {
        imagePath = imagePath.split('/')[1];
      }
      path = assetsPath + imagePath;
    } else {
      path = originalPath;
      path += assetData.u ? assetData.u : '';
      path += assetData.p;
    }
    return path;
  }

  function testImageLoaded(img) {
    var _count = 0;
    var intervalId = setInterval(function () {
      var box = img.getBBox();
      if (box.width || _count > 500) {
        this._imageLoaded();
        clearInterval(intervalId);
      }
      _count += 1;
    }.bind(this), 50);
  }

  function createImageData(assetData) {
    var path = getAssetsPath(assetData, this.assetsPath, this.path);
    var img = createNS('image');
    if (isSafari) {
      this.testImageLoaded(img);
    } else {
      img.addEventListener('load', this._imageLoaded, false);
    }
    img.addEventListener('error', function () {
      ob.img = proxyImage;
      this._imageLoaded();
    }.bind(this), false);
    img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
    if (this._elementHelper.append) {
      this._elementHelper.append(img);
    } else {
      this._elementHelper.appendChild(img);
    }
    var ob = {
      img: img,
      assetData: assetData,
    };
    return ob;
  }

  function createImgData(assetData) {
    var path = getAssetsPath(assetData, this.assetsPath, this.path);
    var img = createTag('img');
    img.crossOrigin = 'anonymous';
    img.addEventListener('load', this._imageLoaded, false);
    img.addEventListener('error', function () {
      ob.img = proxyImage;
      this._imageLoaded();
    }.bind(this), false);
    img.src = path;
    var ob = {
      img: img,
      assetData: assetData,
    };
    return ob;
  }

  function createFootageData(data) {
    var ob = {
      assetData: data,
    };
    var path = getAssetsPath(data, this.assetsPath, this.path);
    dataManager.loadData(path, function (footageData) {
      ob.img = footageData;
      this._footageLoaded();
    }.bind(this), function () {
      ob.img = {};
      this._footageLoaded();
    }.bind(this));
    return ob;
  }

  function loadAssets(assets, cb) {
    this.imagesLoadedCb = cb;
    var i;
    var len = assets.length;
    for (i = 0; i < len; i += 1) {
      if (!assets[i].layers) {
        if (!assets[i].t || assets[i].t === 'seq') {
          this.totalImages += 1;
          this.images.push(this._createImageData(assets[i]));
        } else if (assets[i].t === 3) {
          this.totalFootages += 1;
          this.images.push(this.createFootageData(assets[i]));
        }
      }
    }
  }

  function setPath(path) {
    this.path = path || '';
  }

  function setAssetsPath(path) {
    this.assetsPath = path || '';
  }

  function getAsset(assetData) {
    var i = 0;
    var len = this.images.length;
    while (i < len) {
      if (this.images[i].assetData === assetData) {
        return this.images[i].img;
      }
      i += 1;
    }
    return null;
  }

  function destroy() {
    this.imagesLoadedCb = null;
    this.images.length = 0;
  }

  function loadedImages() {
    return this.totalImages === this.loadedAssets;
  }

  function loadedFootages() {
    return this.totalFootages === this.loadedFootagesCount;
  }

  function setCacheType(type, elementHelper) {
    if (type === 'svg') {
      this._elementHelper = elementHelper;
      this._createImageData = this.createImageData.bind(this);
    } else {
      this._createImageData = this.createImgData.bind(this);
    }
  }

  function ImagePreloaderFactory() {
    this._imageLoaded = imageLoaded.bind(this);
    this._footageLoaded = footageLoaded.bind(this);
    this.testImageLoaded = testImageLoaded.bind(this);
    this.createFootageData = createFootageData.bind(this);
    this.assetsPath = '';
    this.path = '';
    this.totalImages = 0;
    this.totalFootages = 0;
    this.loadedAssets = 0;
    this.loadedFootagesCount = 0;
    this.imagesLoadedCb = null;
    this.images = [];
  }

  ImagePreloaderFactory.prototype = {
    loadAssets: loadAssets,
    setAssetsPath: setAssetsPath,
    setPath: setPath,
    loadedImages: loadedImages,
    loadedFootages: loadedFootages,
    destroy: destroy,
    getAsset: getAsset,
    createImgData: createImgData,
    createImageData: createImageData,
    imageLoaded: imageLoaded,
    footageLoaded: footageLoaded,
    setCacheType: setCacheType,
  };

  return ImagePreloaderFactory;
}());

/* exported featureSupport */

var featureSupport = (function () {
  var ob = {
    maskType: true,
  };
  if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
    ob.maskType = false;
  }
  return ob;
}());

/* global createNS */
/* exported filtersFactory */

var filtersFactory = (function () {
  var ob = {};
  ob.createFilter = createFilter;
  ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

  function createFilter(filId, skipCoordinates) {
    var fil = createNS('filter');
    fil.setAttribute('id', filId);
    if (skipCoordinates !== true) {
      fil.setAttribute('filterUnits', 'objectBoundingBox');
      fil.setAttribute('x', '0%');
      fil.setAttribute('y', '0%');
      fil.setAttribute('width', '100%');
      fil.setAttribute('height', '100%');
    }
    return fil;
  }

  function createAlphaToLuminanceFilter() {
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
    return feColorMatrix;
  }

  return ob;
}());

/* global createSizedArray, PropertyFactory, TextAnimatorDataProperty, bez, addHueToRGB,
  addSaturationToRGB, addBrightnessToRGB, LetterProps, Matrix, extendPrototype, DynamicPropertyContainer */

function TextAnimatorProperty(textData, renderType, elem) {
  this._isFirstFrame = true;
  this._hasMaskedPath = false;
  this._frameId = -1;
  this._textData = textData;
  this._renderType = renderType;
  this._elem = elem;
  this._animatorsData = createSizedArray(this._textData.a.length);
  this._pathData = {};
  this._moreOptions = {
    alignment: {},
  };
  this.renderedLetters = [];
  this.lettersChangedFlag = false;
  this.initDynamicPropertyContainer(elem);
}

TextAnimatorProperty.prototype.searchProperties = function () {
  var i;
  var len = this._textData.a.length;
  var animatorProps;
  var getProp = PropertyFactory.getProp;
  for (i = 0; i < len; i += 1) {
    animatorProps = this._textData.a[i];
    this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
  }
  if (this._textData.p && 'm' in this._textData.p) {
    this._pathData = {
      a: getProp(this._elem, this._textData.p.a, 0, 0, this),
      f: getProp(this._elem, this._textData.p.f, 0, 0, this),
      l: getProp(this._elem, this._textData.p.l, 0, 0, this),
      r: getProp(this._elem, this._textData.p.r, 0, 0, this),
      p: getProp(this._elem, this._textData.p.p, 0, 0, this),
      m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
    };
    this._hasMaskedPath = true;
  } else {
    this._hasMaskedPath = false;
  }
  this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
};

TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
  this.lettersChangedFlag = lettersChangedFlag;
  if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
    return;
  }
  this._isFirstFrame = false;
  var alignment = this._moreOptions.alignment.v;
  var animators = this._animatorsData;
  var textData = this._textData;
  var matrixHelper = this.mHelper;
  var renderType = this._renderType;
  var renderedLettersCount = this.renderedLetters.length;
  var xPos;
  var yPos;
  var i;
  var len;
  var letters = documentData.l;
  var pathInfo;
  var currentLength;
  var currentPoint;
  var segmentLength;
  var flag;
  var pointInd;
  var segmentInd;
  var prevPoint;
  var points;
  var segments;
  var partialLength;
  var totalLength;
  var perc;
  var tanAngle;
  var mask;
  if (this._hasMaskedPath) {
    mask = this._pathData.m;
    if (!this._pathData.n || this._pathData._mdf) {
      var paths = mask.v;
      if (this._pathData.r.v) {
        paths = paths.reverse();
      }
      // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
      pathInfo = {
        tLength: 0,
        segments: [],
      };
      len = paths._length - 1;
      var bezierData;
      totalLength = 0;
      for (i = 0; i < len; i += 1) {
        bezierData = bez.buildBezierData(paths.v[i],
          paths.v[i + 1],
          [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
          [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
        pathInfo.tLength += bezierData.segmentLength;
        pathInfo.segments.push(bezierData);
        totalLength += bezierData.segmentLength;
      }
      i = len;
      if (mask.v.c) {
        bezierData = bez.buildBezierData(paths.v[i],
          paths.v[0],
          [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
          [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
        pathInfo.tLength += bezierData.segmentLength;
        pathInfo.segments.push(bezierData);
        totalLength += bezierData.segmentLength;
      }
      this._pathData.pi = pathInfo;
    }
    pathInfo = this._pathData.pi;

    currentLength = this._pathData.f.v;
    segmentInd = 0;
    pointInd = 1;
    segmentLength = 0;
    flag = true;
    segments = pathInfo.segments;
    if (currentLength < 0 && mask.v.c) {
      if (pathInfo.tLength < Math.abs(currentLength)) {
        currentLength = -Math.abs(currentLength) % pathInfo.tLength;
      }
      segmentInd = segments.length - 1;
      points = segments[segmentInd].points;
      pointInd = points.length - 1;
      while (currentLength < 0) {
        currentLength += points[pointInd].partialLength;
        pointInd -= 1;
        if (pointInd < 0) {
          segmentInd -= 1;
          points = segments[segmentInd].points;
          pointInd = points.length - 1;
        }
      }
    }
    points = segments[segmentInd].points;
    prevPoint = points[pointInd - 1];
    currentPoint = points[pointInd];
    partialLength = currentPoint.partialLength;
  }

  len = letters.length;
  xPos = 0;
  yPos = 0;
  var yOff = documentData.finalSize * 1.2 * 0.714;
  var firstLine = true;
  var animatorProps;
  var animatorSelector;
  var j;
  var jLen;
  var letterValue;

  jLen = animators.length;

  var mult;
  var ind = -1;
  var offf;
  var xPathPos;
  var yPathPos;
  var initPathPos = currentLength;
  var initSegmentInd = segmentInd;
  var initPointInd = pointInd;
  var currentLine = -1;
  var elemOpacity;
  var sc;
  var sw;
  var fc;
  var k;
  var letterSw;
  var letterSc;
  var letterFc;
  var letterM = '';
  var letterP = this.defaultPropsArray;
  var letterO;

  //
  if (documentData.j === 2 || documentData.j === 1) {
    var animatorJustifyOffset = 0;
    var animatorFirstCharOffset = 0;
    var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
    var lastIndex = 0;
    var isNewLine = true;

    for (i = 0; i < len; i += 1) {
      if (letters[i].n) {
        if (animatorJustifyOffset) {
          animatorJustifyOffset += animatorFirstCharOffset;
        }
        while (lastIndex < i) {
          letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
          lastIndex += 1;
        }
        animatorJustifyOffset = 0;
        isNewLine = true;
      } else {
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.t.propType) {
            if (isNewLine && documentData.j === 2) {
              animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
            }
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
            } else {
              animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
            }
          }
        }
        isNewLine = false;
      }
    }
    if (animatorJustifyOffset) {
      animatorJustifyOffset += animatorFirstCharOffset;
    }
    while (lastIndex < i) {
      letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
      lastIndex += 1;
    }
  }
  //

  for (i = 0; i < len; i += 1) {
    matrixHelper.reset();
    elemOpacity = 1;
    if (letters[i].n) {
      xPos = 0;
      yPos += documentData.yOffset;
      yPos += firstLine ? 1 : 0;
      currentLength = initPathPos;
      firstLine = false;
      if (this._hasMaskedPath) {
        segmentInd = initSegmentInd;
        pointInd = initPointInd;
        points = segments[segmentInd].points;
        prevPoint = points[pointInd - 1];
        currentPoint = points[pointInd];
        partialLength = currentPoint.partialLength;
        segmentLength = 0;
      }
      letterM = '';
      letterFc = '';
      letterSw = '';
      letterO = '';
      letterP = this.defaultPropsArray;
    } else {
      if (this._hasMaskedPath) {
        if (currentLine !== letters[i].line) {
          switch (documentData.j) {
            case 1:
              currentLength += totalLength - documentData.lineWidths[letters[i].line];
              break;
            case 2:
              currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
              break;
            default:
              break;
          }
          currentLine = letters[i].line;
        }
        if (ind !== letters[i].ind) {
          if (letters[ind]) {
            currentLength += letters[ind].extra;
          }
          currentLength += letters[i].an / 2;
          ind = letters[i].ind;
        }
        currentLength += (alignment[0] * letters[i].an) * 0.005;
        var animatorOffset = 0;
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.p.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorOffset += animatorProps.p.v[0] * mult[0];
            } else {
              animatorOffset += animatorProps.p.v[0] * mult;
            }
          }
          if (animatorProps.a.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorOffset += animatorProps.a.v[0] * mult[0];
            } else {
              animatorOffset += animatorProps.a.v[0] * mult;
            }
          }
        }
        flag = true;
        // Force alignment only works with a single line for now
        if (this._pathData.a.v) {
          currentLength = letters[0].an * 0.5 + ((totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind) / (len - 1);
          currentLength += this._pathData.f.v;
        }
        while (flag) {
          if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
            matrixHelper.translate((-alignment[0] * letters[i].an) * 0.005, -(alignment[1] * yOff) * 0.01);
            flag = false;
          } else if (points) {
            segmentLength += currentPoint.partialLength;
            pointInd += 1;
            if (pointInd >= points.length) {
              pointInd = 0;
              segmentInd += 1;
              if (!segments[segmentInd]) {
                if (mask.v.c) {
                  pointInd = 0;
                  segmentInd = 0;
                  points = segments[segmentInd].points;
                } else {
                  segmentLength -= currentPoint.partialLength;
                  points = null;
                }
              } else {
                points = segments[segmentInd].points;
              }
            }
            if (points) {
              prevPoint = currentPoint;
              currentPoint = points[pointInd];
              partialLength = currentPoint.partialLength;
            }
          }
        }
        offf = letters[i].an / 2 - letters[i].add;
        matrixHelper.translate(-offf, 0, 0);
      } else {
        offf = letters[i].an / 2 - letters[i].add;
        matrixHelper.translate(-offf, 0, 0);

        // Grouping alignment
        matrixHelper.translate((-alignment[0] * letters[i].an) * 0.005, (-alignment[1] * yOff) * 0.01, 0);
      }

      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.t.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
          if (xPos !== 0 || documentData.j !== 0) {
            if (this._hasMaskedPath) {
              if (mult.length) {
                currentLength += animatorProps.t.v * mult[0];
              } else {
                currentLength += animatorProps.t.v * mult;
              }
            } else if (mult.length) {
              xPos += animatorProps.t.v * mult[0];
            } else {
              xPos += animatorProps.t.v * mult;
            }
          }
        }
      }
      if (documentData.strokeWidthAnim) {
        sw = documentData.sw || 0;
      }
      if (documentData.strokeColorAnim) {
        if (documentData.sc) {
          sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
        } else {
          sc = [0, 0, 0];
        }
      }
      if (documentData.fillColorAnim && documentData.fc) {
        fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.a.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

          if (mult.length) {
            matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
          } else {
            matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
          }
        }
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.s.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          if (mult.length) {
            matrixHelper.scale(1 + ((animatorProps.s.v[0] - 1) * mult[0]), 1 + ((animatorProps.s.v[1] - 1) * mult[1]), 1);
          } else {
            matrixHelper.scale(1 + ((animatorProps.s.v[0] - 1) * mult), 1 + ((animatorProps.s.v[1] - 1) * mult), 1);
          }
        }
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        animatorSelector = animators[j].s;
        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
        if (animatorProps.sk.propType) {
          if (mult.length) {
            matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
          } else {
            matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
          }
        }
        if (animatorProps.r.propType) {
          if (mult.length) {
            matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
          } else {
            matrixHelper.rotateZ(-animatorProps.r.v * mult);
          }
        }
        if (animatorProps.ry.propType) {
          if (mult.length) {
            matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
          } else {
            matrixHelper.rotateY(animatorProps.ry.v * mult);
          }
        }
        if (animatorProps.rx.propType) {
          if (mult.length) {
            matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
          } else {
            matrixHelper.rotateX(animatorProps.rx.v * mult);
          }
        }
        if (animatorProps.o.propType) {
          if (mult.length) {
            elemOpacity += ((animatorProps.o.v) * mult[0] - elemOpacity) * mult[0];
          } else {
            elemOpacity += ((animatorProps.o.v) * mult - elemOpacity) * mult;
          }
        }
        if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
          if (mult.length) {
            sw += animatorProps.sw.v * mult[0];
          } else {
            sw += animatorProps.sw.v * mult;
          }
        }
        if (documentData.strokeColorAnim && animatorProps.sc.propType) {
          for (k = 0; k < 3; k += 1) {
            if (mult.length) {
              sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
            } else {
              sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
            }
          }
        }
        if (documentData.fillColorAnim && documentData.fc) {
          if (animatorProps.fc.propType) {
            for (k = 0; k < 3; k += 1) {
              if (mult.length) {
                fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
              } else {
                fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
              }
            }
          }
          if (animatorProps.fh.propType) {
            if (mult.length) {
              fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
            } else {
              fc = addHueToRGB(fc, animatorProps.fh.v * mult);
            }
          }
          if (animatorProps.fs.propType) {
            if (mult.length) {
              fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
            } else {
              fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
            }
          }
          if (animatorProps.fb.propType) {
            if (mult.length) {
              fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
            } else {
              fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
            }
          }
        }
      }

      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;

        if (animatorProps.p.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          if (this._hasMaskedPath) {
            if (mult.length) {
              matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
            } else {
              matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
            }
          } else if (mult.length) {
            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
          } else {
            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
          }
        }
      }
      if (documentData.strokeWidthAnim) {
        letterSw = sw < 0 ? 0 : sw;
      }
      if (documentData.strokeColorAnim) {
        letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
      }
      if (documentData.fillColorAnim && documentData.fc) {
        letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
      }

      if (this._hasMaskedPath) {
        matrixHelper.translate(0, -documentData.ls);

        matrixHelper.translate(0, (alignment[1] * yOff) * 0.01 + yPos, 0);
        if (this._pathData.p.v) {
          tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
          var rot = (Math.atan(tanAngle) * 180) / Math.PI;
          if (currentPoint.point[0] < prevPoint.point[0]) {
            rot += 180;
          }
          matrixHelper.rotate((-rot * Math.PI) / 180);
        }
        matrixHelper.translate(xPathPos, yPathPos, 0);
        currentLength -= (alignment[0] * letters[i].an) * 0.005;
        if (letters[i + 1] && ind !== letters[i + 1].ind) {
          currentLength += letters[i].an / 2;
          currentLength += (documentData.tr * 0.001) * documentData.finalSize;
        }
      } else {
        matrixHelper.translate(xPos, yPos, 0);

        if (documentData.ps) {
          // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
          matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        }
        switch (documentData.j) {
          case 1:
            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
            break;
          case 2:
            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
            break;
          default:
            break;
        }
        matrixHelper.translate(0, -documentData.ls);
        matrixHelper.translate(offf, 0, 0);
        matrixHelper.translate((alignment[0] * letters[i].an) * 0.005, (alignment[1] * yOff) * 0.01, 0);
        xPos += letters[i].l + (documentData.tr * 0.001) * documentData.finalSize;
      }
      if (renderType === 'html') {
        letterM = matrixHelper.toCSS();
      } else if (renderType === 'svg') {
        letterM = matrixHelper.to2dCSS();
      } else {
        letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
      }
      letterO = elemOpacity;
    }

    if (renderedLettersCount <= i) {
      letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
      this.renderedLetters.push(letterValue);
      renderedLettersCount += 1;
      this.lettersChangedFlag = true;
    } else {
      letterValue = this.renderedLetters[i];
      this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
    }
  }
};

TextAnimatorProperty.prototype.getValue = function () {
  if (this._elem.globalData.frameId === this._frameId) {
    return;
  }
  this._frameId = this._elem.globalData.frameId;
  this.iterateDynamicProperties();
};

TextAnimatorProperty.prototype.mHelper = new Matrix();
TextAnimatorProperty.prototype.defaultPropsArray = [];
extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

/* global PropertyFactory, degToRads, TextSelectorProp */
/* exported TextAnimatorDataProperty */

function TextAnimatorDataProperty(elem, animatorProps, container) {
  var defaultData = { propType: false };
  var getProp = PropertyFactory.getProp;
  var textAnimatorAnimatables = animatorProps.a;
  this.a = {
    r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
    rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
    ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
    sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
    sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
    s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
    a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
    o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
    p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
    sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
    sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
    fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
    fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
    fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
    fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
    t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData,
  };

  this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
  this.s.t = animatorProps.s.t;
}

function LetterProps(o, sw, sc, fc, m, p) {
  this.o = o;
  this.sw = sw;
  this.sc = sc;
  this.fc = fc;
  this.m = m;
  this.p = p;
  this._mdf = {
    o: true,
    sw: !!sw,
    sc: !!sc,
    fc: !!fc,
    m: true,
    p: true,
  };
}

LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
  this._mdf.o = false;
  this._mdf.sw = false;
  this._mdf.sc = false;
  this._mdf.fc = false;
  this._mdf.m = false;
  this._mdf.p = false;
  var updated = false;

  if (this.o !== o) {
    this.o = o;
    this._mdf.o = true;
    updated = true;
  }
  if (this.sw !== sw) {
    this.sw = sw;
    this._mdf.sw = true;
    updated = true;
  }
  if (this.sc !== sc) {
    this.sc = sc;
    this._mdf.sc = true;
    updated = true;
  }
  if (this.fc !== fc) {
    this.fc = fc;
    this._mdf.fc = true;
    updated = true;
  }
  if (this.m !== m) {
    this.m = m;
    this._mdf.m = true;
    updated = true;
  }
  if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
    this.p = p;
    this._mdf.p = true;
    updated = true;
  }
  return updated;
};

/* global FontManager, initialDefaultFrame, getFontProperties */
/* exported TextProperty */

function TextProperty(elem, data) {
  this._frameId = initialDefaultFrame;
  this.pv = '';
  this.v = '';
  this.kf = false;
  this._isFirstFrame = true;
  this._mdf = false;
  this.data = data;
  this.elem = elem;
  this.comp = this.elem.comp;
  this.keysIndex = 0;
  this.canResize = false;
  this.minimumFontSize = 1;
  this.effectsSequence = [];
  this.currentData = {
    ascent: 0,
    boxWidth: this.defaultBoxWidth,
    f: '',
    fStyle: '',
    fWeight: '',
    fc: '',
    j: '',
    justifyOffset: '',
    l: [],
    lh: 0,
    lineWidths: [],
    ls: '',
    of: '',
    s: '',
    sc: '',
    sw: 0,
    t: 0,
    tr: 0,
    sz: 0,
    ps: null,
    fillColorAnim: false,
    strokeColorAnim: false,
    strokeWidthAnim: false,
    yOffset: 0,
    finalSize: 0,
    finalText: [],
    finalLineHeight: 0,
    __complete: false,

  };
  this.copyData(this.currentData, this.data.d.k[0].s);

  if (!this.searchProperty()) {
    this.completeTextData(this.currentData);
  }
}

TextProperty.prototype.defaultBoxWidth = [0, 0];

TextProperty.prototype.copyData = function (obj, data) {
  for (var s in data) {
    if (Object.prototype.hasOwnProperty.call(data, s)) {
      obj[s] = data[s];
    }
  }
  return obj;
};

TextProperty.prototype.setCurrentData = function (data) {
  if (!data.__complete) {
    this.completeTextData(data);
  }
  this.currentData = data;
  this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
  this._mdf = true;
};

TextProperty.prototype.searchProperty = function () {
  return this.searchKeyframes();
};

TextProperty.prototype.searchKeyframes = function () {
  this.kf = this.data.d.k.length > 1;
  if (this.kf) {
    this.addEffect(this.getKeyframeValue.bind(this));
  }
  return this.kf;
};

TextProperty.prototype.addEffect = function (effectFunction) {
  this.effectsSequence.push(effectFunction);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.getValue = function (_finalValue) {
  if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
    return;
  }
  this.currentData.t = this.data.d.k[this.keysIndex].s.t;
  var currentValue = this.currentData;
  var currentIndex = this.keysIndex;
  if (this.lock) {
    this.setCurrentData(this.currentData);
    return;
  }
  this.lock = true;
  this._mdf = false;
  var i; var
    len = this.effectsSequence.length;
  var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
  for (i = 0; i < len; i += 1) {
    // Checking if index changed to prevent creating a new object every time the expression updates.
    if (currentIndex !== this.keysIndex) {
      finalValue = this.effectsSequence[i](finalValue, finalValue.t);
    } else {
      finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
    }
  }
  if (currentValue !== finalValue) {
    this.setCurrentData(finalValue);
  }
  this.v = this.currentData;
  this.pv = this.v;
  this.lock = false;
  this.frameId = this.elem.globalData.frameId;
};

TextProperty.prototype.getKeyframeValue = function () {
  var textKeys = this.data.d.k;
  var frameNum = this.elem.comp.renderedFrame;
  var i = 0; var
    len = textKeys.length;
  while (i <= len - 1) {
    if (i === len - 1 || textKeys[i + 1].t > frameNum) {
      break;
    }
    i += 1;
  }
  if (this.keysIndex !== i) {
    this.keysIndex = i;
  }
  return this.data.d.k[this.keysIndex].s;
};

TextProperty.prototype.buildFinalText = function (text) {
  var charactersArray = [];
  var i = 0;
  var len = text.length;
  var charCode;
  var secondCharCode;
  var shouldCombine = false;
  while (i < len) {
    charCode = text.charCodeAt(i);
    if (FontManager.isCombinedCharacter(charCode)) {
      charactersArray[charactersArray.length - 1] += text.charAt(i);
    } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      secondCharCode = text.charCodeAt(i + 1);
      if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
        if (shouldCombine || FontManager.isModifier(charCode, secondCharCode)) {
          charactersArray[charactersArray.length - 1] += text.substr(i, 2);
          shouldCombine = false;
        } else {
          charactersArray.push(text.substr(i, 2));
        }
        i += 1;
      } else {
        charactersArray.push(text.charAt(i));
      }
    } else if (charCode > 0xDBFF) {
      secondCharCode = text.charCodeAt(i + 1);
      if (FontManager.isZeroWidthJoiner(charCode, secondCharCode)) {
        shouldCombine = true;
        charactersArray[charactersArray.length - 1] += text.substr(i, 2);
        i += 1;
      } else {
        charactersArray.push(text.charAt(i));
      }
    } else if (FontManager.isZeroWidthJoiner(charCode)) {
      charactersArray[charactersArray.length - 1] += text.charAt(i);
      shouldCombine = true;
    } else {
      charactersArray.push(text.charAt(i));
    }
    i += 1;
  }
  return charactersArray;
};

TextProperty.prototype.completeTextData = function (documentData) {
  documentData.__complete = true;
  var fontManager = this.elem.globalData.fontManager;
  var data = this.data;
  var letters = [];
  var i; var
    len;
  var newLineFlag; var index = 0; var
    val;
  var anchorGrouping = data.m.g;
  var currentSize = 0; var currentPos = 0; var currentLine = 0; var
    lineWidths = [];
  var lineWidth = 0;
  var maxLineWidth = 0;
  var j; var
    jLen;
  var fontData = fontManager.getFontByName(documentData.f);
  var charData; var
    cLength = 0;

  var fontProps = getFontProperties(fontData);
  documentData.fWeight = fontProps.weight;
  documentData.fStyle = fontProps.style;
  documentData.finalSize = documentData.s;
  documentData.finalText = this.buildFinalText(documentData.t);
  len = documentData.finalText.length;
  documentData.finalLineHeight = documentData.lh;
  var trackingOffset = (documentData.tr / 1000) * documentData.finalSize;
  var charCode;
  if (documentData.sz) {
    var flag = true;
    var boxWidth = documentData.sz[0];
    var boxHeight = documentData.sz[1];
    var currentHeight; var
      finalText;
    while (flag) {
      finalText = this.buildFinalText(documentData.t);
      currentHeight = 0;
      lineWidth = 0;
      len = finalText.length;
      trackingOffset = (documentData.tr / 1000) * documentData.finalSize;
      var lastSpaceIndex = -1;
      for (i = 0; i < len; i += 1) {
        charCode = finalText[i].charCodeAt(0);
        newLineFlag = false;
        if (finalText[i] === ' ') {
          lastSpaceIndex = i;
        } else if (charCode === 13 || charCode === 3) {
          lineWidth = 0;
          newLineFlag = true;
          currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
        }
        if (fontManager.chars) {
          charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
          cLength = newLineFlag ? 0 : (charData.w * documentData.finalSize) / 100;
        } else {
          // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
          cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
        }
        if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
          if (lastSpaceIndex === -1) {
            len += 1;
          } else {
            i = lastSpaceIndex;
          }
          currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
          finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r');
          // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
          lastSpaceIndex = -1;
          lineWidth = 0;
        } else {
          lineWidth += cLength;
          lineWidth += trackingOffset;
        }
      }
      currentHeight += (fontData.ascent * documentData.finalSize) / 100;
      if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
        documentData.finalSize -= 1;
        documentData.finalLineHeight = (documentData.finalSize * documentData.lh) / documentData.s;
      } else {
        documentData.finalText = finalText;
        len = documentData.finalText.length;
        flag = false;
      }
    }
  }
  lineWidth = -trackingOffset;
  cLength = 0;
  var uncollapsedSpaces = 0;
  var currentChar;
  for (i = 0; i < len; i += 1) {
    newLineFlag = false;
    currentChar = documentData.finalText[i];
    charCode = currentChar.charCodeAt(0);
    if (charCode === 13 || charCode === 3) {
      uncollapsedSpaces = 0;
      lineWidths.push(lineWidth);
      maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
      lineWidth = -2 * trackingOffset;
      val = '';
      newLineFlag = true;
      currentLine += 1;
    } else {
      val = currentChar;
    }
    if (fontManager.chars) {
      charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
      cLength = newLineFlag ? 0 : (charData.w * documentData.finalSize) / 100;
    } else {
      // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
      // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
      cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
    }

    //
    if (currentChar === ' ') {
      uncollapsedSpaces += cLength + trackingOffset;
    } else {
      lineWidth += cLength + trackingOffset + uncollapsedSpaces;
      uncollapsedSpaces = 0;
    }
    letters.push({
      l: cLength, an: cLength, add: currentSize, n: newLineFlag, anIndexes: [], val: val, line: currentLine, animatorJustifyOffset: 0,
    });
    if (anchorGrouping == 2) { // eslint-disable-line eqeqeq
      currentSize += cLength;
      if (val === '' || val === ' ' || i === len - 1) {
        if (val === '' || val === ' ') {
          currentSize -= cLength;
        }
        while (currentPos <= i) {
          letters[currentPos].an = currentSize;
          letters[currentPos].ind = index;
          letters[currentPos].extra = cLength;
          currentPos += 1;
        }
        index += 1;
        currentSize = 0;
      }
    } else if (anchorGrouping == 3) { // eslint-disable-line eqeqeq
      currentSize += cLength;
      if (val === '' || i === len - 1) {
        if (val === '') {
          currentSize -= cLength;
        }
        while (currentPos <= i) {
          letters[currentPos].an = currentSize;
          letters[currentPos].ind = index;
          letters[currentPos].extra = cLength;
          currentPos += 1;
        }
        currentSize = 0;
        index += 1;
      }
    } else {
      letters[index].ind = index;
      letters[index].extra = 0;
      index += 1;
    }
  }
  documentData.l = letters;
  maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
  lineWidths.push(lineWidth);
  if (documentData.sz) {
    documentData.boxWidth = documentData.sz[0];
    documentData.justifyOffset = 0;
  } else {
    documentData.boxWidth = maxLineWidth;
    switch (documentData.j) {
      case 1:
        documentData.justifyOffset = -documentData.boxWidth;
        break;
      case 2:
        documentData.justifyOffset = -documentData.boxWidth / 2;
        break;
      default:
        documentData.justifyOffset = 0;
    }
  }
  documentData.lineWidths = lineWidths;

  var animators = data.a; var animatorData; var
    letterData;
  jLen = animators.length;
  var based; var ind; var
    indexes = [];
  for (j = 0; j < jLen; j += 1) {
    animatorData = animators[j];
    if (animatorData.a.sc) {
      documentData.strokeColorAnim = true;
    }
    if (animatorData.a.sw) {
      documentData.strokeWidthAnim = true;
    }
    if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
      documentData.fillColorAnim = true;
    }
    ind = 0;
    based = animatorData.s.b;
    for (i = 0; i < len; i += 1) {
      letterData = letters[i];
      letterData.anIndexes[j] = ind;
      if ((based == 1 && letterData.val !== '') || (based == 2 && letterData.val !== '' && letterData.val !== ' ') || (based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))) { // eslint-disable-line eqeqeq
        if (animatorData.s.rn === 1) {
          indexes.push(ind);
        }
        ind += 1;
      }
    }
    data.a[j].s.totalChars = ind;
    var currentInd = -1; var
      newInd;
    if (animatorData.s.rn === 1) {
      for (i = 0; i < len; i += 1) {
        letterData = letters[i];
        if (currentInd != letterData.anIndexes[j]) { // eslint-disable-line eqeqeq
          currentInd = letterData.anIndexes[j];
          newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
        }
        letterData.anIndexes[j] = newInd;
      }
    }
  }
  documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
  documentData.ls = documentData.ls || 0;
  documentData.ascent = (fontData.ascent * documentData.finalSize) / 100;
};

TextProperty.prototype.updateDocumentData = function (newData, index) {
  index = index === undefined ? this.keysIndex : index;
  var dData = this.copyData({}, this.data.d.k[index].s);
  dData = this.copyData(dData, newData);
  this.data.d.k[index].s = dData;
  this.recalculate(index);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.recalculate = function (index) {
  var dData = this.data.d.k[index].s;
  dData.__complete = false;
  this.keysIndex = 0;
  this._isFirstFrame = true;
  this.getValue(dData);
};

TextProperty.prototype.canResizeFont = function (_canResize) {
  this.canResize = _canResize;
  this.recalculate(this.keysIndex);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
  this.minimumFontSize = Math.floor(_fontValue) || 1;
  this.recalculate(this.keysIndex);
  this.elem.addDynamicProperty(this);
};

/* global extendPrototype, BezierFactory, PropertyFactory, DynamicPropertyContainer */
/* exported TextSelectorProp */

var TextSelectorProp = (function () {
  var max = Math.max;
  var min = Math.min;
  var floor = Math.floor;

  function TextSelectorPropFactory(elem, data) {
    this._currentTextLength = -1;
    this.k = false;
    this.data = data;
    this.elem = elem;
    this.comp = elem.comp;
    this.finalS = 0;
    this.finalE = 0;
    this.initDynamicPropertyContainer(elem);
    this.s = PropertyFactory.getProp(elem, data.s || { k: 0 }, 0, 0, this);
    if ('e' in data) {
      this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
    } else {
      this.e = { v: 100 };
    }
    this.o = PropertyFactory.getProp(elem, data.o || { k: 0 }, 0, 0, this);
    this.xe = PropertyFactory.getProp(elem, data.xe || { k: 0 }, 0, 0, this);
    this.ne = PropertyFactory.getProp(elem, data.ne || { k: 0 }, 0, 0, this);
    this.sm = PropertyFactory.getProp(elem, data.sm || { k: 100 }, 0, 0, this);
    this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
    if (!this.dynamicProperties.length) {
      this.getValue();
    }
  }

  TextSelectorPropFactory.prototype = {
    getMult: function (ind) {
      if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
        this.getValue();
      }
      // var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
      var x1 = 0;
      var y1 = 0;
      var x2 = 1;
      var y2 = 1;
      if (this.ne.v > 0) {
        x1 = this.ne.v / 100.0;
      } else {
        y1 = -this.ne.v / 100.0;
      }
      if (this.xe.v > 0) {
        x2 = 1.0 - this.xe.v / 100.0;
      } else {
        y2 = 1.0 + this.xe.v / 100.0;
      }
      var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;

      var mult = 0;
      var s = this.finalS;
      var e = this.finalE;
      var type = this.data.sh;
      if (type === 2) {
        if (e === s) {
          mult = ind >= e ? 1 : 0;
        } else {
          mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
        }
        mult = easer(mult);
      } else if (type === 3) {
        if (e === s) {
          mult = ind >= e ? 0 : 1;
        } else {
          mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
        }

        mult = easer(mult);
      } else if (type === 4) {
        if (e === s) {
          mult = 0;
        } else {
          mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          if (mult < 0.5) {
            mult *= 2;
          } else {
            mult = 1 - 2 * (mult - 0.5);
          }
        }
        mult = easer(mult);
      } else if (type === 5) {
        if (e === s) {
          mult = 0;
        } else {
          var tot = e - s;
          /* ind += 0.5;
                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */
          ind = min(max(0, ind + 0.5 - s), e - s);
          var x = -tot / 2 + ind;
          var a = tot / 2;
          mult = Math.sqrt(1 - (x * x) / (a * a));
        }
        mult = easer(mult);
      } else if (type === 6) {
        if (e === s) {
          mult = 0;
        } else {
          ind = min(max(0, ind + 0.5 - s), e - s);
          mult = (1 + (Math.cos((Math.PI + Math.PI * 2 * (ind) / (e - s))))) / 2; // eslint-disable-line
        }
        mult = easer(mult);
      } else {
        if (ind >= floor(s)) {
          if (ind - s < 0) {
            mult = max(0, min(min(e, 1) - (s - ind), 1));
          } else {
            mult = max(0, min(e - ind, 1));
          }
        }
        mult = easer(mult);
      }
      // Smoothness implementation.
      // The smoothness represents a reduced range of the original [0; 1] range.
      // if smoothness is 25%, the new range will be [0.375; 0.625]
      // Steps are:
      // - find the lower value of the new range (threshold)
      // - if multiplier is smaller than that value, floor it to 0
      // - if it is larger,
      //     - subtract the threshold
      //     - divide it by the smoothness (this will return the range to [0; 1])
      // Note: If it doesn't work on some scenarios, consider applying it before the easer.
      if (this.sm.v !== 100) {
        var smoothness = this.sm.v * 0.01;
        if (smoothness === 0) {
          smoothness = 0.00000001;
        }
        var threshold = 0.5 - smoothness * 0.5;
        if (mult < threshold) {
          mult = 0;
        } else {
          mult = (mult - threshold) / smoothness;
          if (mult > 1) {
            mult = 1;
          }
        }
      }
      return mult * this.a.v;
    },
    getValue: function (newCharsFlag) {
      this.iterateDynamicProperties();
      this._mdf = newCharsFlag || this._mdf;
      this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
      if (newCharsFlag && this.data.r === 2) {
        this.e.v = this._currentTextLength;
      }
      var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
      var o = this.o.v / divisor;
      var s = this.s.v / divisor + o;
      var e = (this.e.v / divisor) + o;
      if (s > e) {
        var _s = s;
        s = e;
        e = _s;
      }
      this.finalS = s;
      this.finalE = e;
    },
  };
  extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);

  function getTextSelectorProp(elem, data, arr) {
    return new TextSelectorPropFactory(elem, data, arr);
  }

  return {
    getTextSelectorProp: getTextSelectorProp,
  };
}());

/* global createSizedArray, pooling */
/* exported poolFactory */

var poolFactory = (function () {
  return function (initialLength, _create, _release) {
    var _length = 0;
    var _maxLength = initialLength;
    var pool = createSizedArray(_maxLength);

    var ob = {
      newElement: newElement,
      release: release,
    };

    function newElement() {
      var element;
      if (_length) {
        _length -= 1;
        element = pool[_length];
      } else {
        element = _create();
      }
      return element;
    }

    function release(element) {
      if (_length === _maxLength) {
        pool = pooling.double(pool);
        _maxLength *= 2;
      }
      if (_release) {
        _release(element);
      }
      pool[_length] = element;
      _length += 1;
    }

    return ob;
  };
}());

/* global createSizedArray */
/* exported pooling */

var pooling = (function () {
  function double(arr) {
    return arr.concat(createSizedArray(arr.length));
  }

  return {
    double: double,
  };
}());

/* global createTypedArray, poolFactory */
/* exported pointPool */

var pointPool = (function () {
  function create() {
    return createTypedArray('float32', 2);
  }
  return poolFactory(8, create);
}());

/* global ShapePath, pointPool, poolFactory */
/* exported shapePool */

var shapePool = (function () {
  function create() {
    return new ShapePath();
  }

  function release(shapePath) {
    var len = shapePath._length;
    var i;
    for (i = 0; i < len; i += 1) {
      pointPool.release(shapePath.v[i]);
      pointPool.release(shapePath.i[i]);
      pointPool.release(shapePath.o[i]);
      shapePath.v[i] = null;
      shapePath.i[i] = null;
      shapePath.o[i] = null;
    }
    shapePath._length = 0;
    shapePath.c = false;
  }

  function clone(shape) {
    var cloned = factory.newElement();
    var i;
    var len = shape._length === undefined ? shape.v.length : shape._length;
    cloned.setLength(len);
    cloned.c = shape.c;

    for (i = 0; i < len; i += 1) {
      cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
    }
    return cloned;
  }

  var factory = poolFactory(4, create, release);
  factory.clone = clone;

  return factory;
}());

/* global createSizedArray, ShapeCollection, shapePool, pooling */
/* exported shapeCollectionPool */

var shapeCollectionPool = (function () {
  var ob = {
    newShapeCollection: newShapeCollection,
    release: release,
  };

  var _length = 0;
  var _maxLength = 4;
  var pool = createSizedArray(_maxLength);

  function newShapeCollection() {
    var shapeCollection;
    if (_length) {
      _length -= 1;
      shapeCollection = pool[_length];
    } else {
      shapeCollection = new ShapeCollection();
    }
    return shapeCollection;
  }

  function release(shapeCollection) {
    var i;
    var len = shapeCollection._length;
    for (i = 0; i < len; i += 1) {
      shapePool.release(shapeCollection.shapes[i]);
    }
    shapeCollection._length = 0;

    if (_length === _maxLength) {
      pool = pooling.double(pool);
      _maxLength *= 2;
    }
    pool[_length] = shapeCollection;
    _length += 1;
  }

  return ob;
}());

/* global poolFactory, bezierLengthPool */
/* exported segmentsLengthPool */

var segmentsLengthPool = (function () {
  function create() {
    return {
      lengths: [],
      totalLength: 0,
    };
  }

  function release(element) {
    var i;
    var len = element.lengths.length;
    for (i = 0; i < len; i += 1) {
      bezierLengthPool.release(element.lengths[i]);
    }
    element.lengths.length = 0;
  }

  return poolFactory(8, create, release);
}());

/* global createTypedArray, defaultCurveSegments, poolFactory */
/* exported bezierLengthPool */

var bezierLengthPool = (function () {
  function create() {
    return {
      addedLength: 0,
      percents: createTypedArray('float32', defaultCurveSegments),
      lengths: createTypedArray('float32', defaultCurveSegments),
    };
  }
  return poolFactory(8, create);
}());

/* exported markerParser */

var markerParser = (

  function () {
    function parsePayloadLines(payload) {
      var lines = payload.split('\r\n');
      var keys = {};
      var line;
      var keysCount = 0;
      for (var i = 0; i < lines.length; i += 1) {
        line = lines[i].split(':');
        if (line.length === 2) {
          keys[line[0]] = line[1].trim();
          keysCount += 1;
        }
      }
      if (keysCount === 0) {
        throw new Error();
      }
      return keys;
    }

    return function (_markers) {
      var markers = [];
      for (var i = 0; i < _markers.length; i += 1) {
        var _marker = _markers[i];
        var markerData = {
          time: _marker.tm,
          duration: _marker.dr,
        };
        try {
          markerData.payload = JSON.parse(_markers[i].cm);
        } catch (_) {
          try {
            markerData.payload = parsePayloadLines(_markers[i].cm);
          } catch (__) {
            markerData.payload = {
              name: _markers[i],
            };
          }
        }
        markers.push(markerData);
      }
      return markers;
    };
  }());

/* global AudioElement, FootageElement, FontManager */

function BaseRenderer() {}
BaseRenderer.prototype.checkLayers = function (num) {
  var i;
  var len = this.layers.length;
  var data;
  this.completeLayers = true;
  for (i = len - 1; i >= 0; i -= 1) {
    if (!this.elements[i]) {
      data = this.layers[i];
      if (data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st)) {
        this.buildItem(i);
      }
    }
    this.completeLayers = this.elements[i] ? this.completeLayers : false;
  }
  this.checkPendingElements();
};

BaseRenderer.prototype.createItem = function (layer) {
  switch (layer.ty) {
    case 2:
      return this.createImage(layer);
    case 0:
      return this.createComp(layer);
    case 1:
      return this.createSolid(layer);
    case 3:
      return this.createNull(layer);
    case 4:
      return this.createShape(layer);
    case 5:
      return this.createText(layer);
    case 6:
      return this.createAudio(layer);
    case 13:
      return this.createCamera(layer);
    case 15:
      return this.createFootage(layer);
    default:
      return this.createNull(layer);
  }
};

BaseRenderer.prototype.createCamera = function () {
  throw new Error('You\'re using a 3d camera. Try the html renderer.');
};

BaseRenderer.prototype.createAudio = function (data) {
  return new AudioElement(data, this.globalData, this);
};

BaseRenderer.prototype.createFootage = function (data) {
  return new FootageElement(data, this.globalData, this);
};

BaseRenderer.prototype.buildAllItems = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    this.buildItem(i);
  }
  this.checkPendingElements();
};

BaseRenderer.prototype.includeLayers = function (newLayers) {
  this.completeLayers = false;
  var i;
  var len = newLayers.length;
  var j;
  var jLen = this.layers.length;
  for (i = 0; i < len; i += 1) {
    j = 0;
    while (j < jLen) {
      if (this.layers[j].id === newLayers[i].id) {
        this.layers[j] = newLayers[i];
        break;
      }
      j += 1;
    }
  }
};

BaseRenderer.prototype.setProjectInterface = function (pInterface) {
  this.globalData.projectInterface = pInterface;
};

BaseRenderer.prototype.initItems = function () {
  if (!this.globalData.progressiveLoad) {
    this.buildAllItems();
  }
};
BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
  var elements = this.elements;
  var layers = this.layers;
  var i = 0;
  var len = layers.length;
  while (i < len) {
    if (layers[i].ind == parentName) { // eslint-disable-line eqeqeq
      if (!elements[i] || elements[i] === true) {
        this.buildItem(i);
        this.addPendingElement(element);
      } else {
        hierarchy.push(elements[i]);
        elements[i].setAsParent();
        if (layers[i].parent !== undefined) {
          this.buildElementParenting(element, layers[i].parent, hierarchy);
        } else {
          element.setHierarchy(hierarchy);
        }
      }
    }
    i += 1;
  }
};

BaseRenderer.prototype.addPendingElement = function (element) {
  this.pendingElements.push(element);
};

BaseRenderer.prototype.searchExtraCompositions = function (assets) {
  var i;
  var len = assets.length;
  for (i = 0; i < len; i += 1) {
    if (assets[i].xt) {
      var comp = this.createComp(assets[i]);
      comp.initExpressions();
      this.globalData.projectInterface.registerComposition(comp);
    }
  }
};

BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
  this.globalData.fontManager = new FontManager();
  this.globalData.fontManager.addChars(animData.chars);
  this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
  this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
  this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
  this.globalData.imageLoader = this.animationItem.imagePreloader;
  this.globalData.audioController = this.animationItem.audioController;
  this.globalData.frameId = 0;
  this.globalData.frameRate = animData.fr;
  this.globalData.nm = animData.nm;
  this.globalData.compSize = {
    w: animData.w,
    h: animData.h,
  };
};

/* global createElementID, extendPrototype, BaseRenderer, NullElement, SVGShapeElement, SVGTextLottieElement,
IImageElement, SVGCompElement, ISolidElement, createNS, locationHref, createSizedArray, expressionsPlugin */

function SVGRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.layers = null;
  this.renderedFrame = -1;
  this.svgElement = createNS('svg');
  var ariaLabel = '';
  if (config && config.title) {
    var titleElement = createNS('title');
    var titleId = createElementID();
    titleElement.setAttribute('id', titleId);
    titleElement.textContent = config.title;
    this.svgElement.appendChild(titleElement);
    ariaLabel += titleId;
  }
  if (config && config.description) {
    var descElement = createNS('desc');
    var descId = createElementID();
    descElement.setAttribute('id', descId);
    descElement.textContent = config.description;
    this.svgElement.appendChild(descElement);
    ariaLabel += ' ' + descId;
  }
  if (ariaLabel) {
    this.svgElement.setAttribute('aria-labelledby', ariaLabel);
  }
  var defs = createNS('defs');
  this.svgElement.appendChild(defs);
  var maskElement = createNS('g');
  this.svgElement.appendChild(maskElement);
  this.layerElement = maskElement;
  this.renderConfig = {
    preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    contentVisibility: (config && config.contentVisibility) || 'visible',
    progressiveLoad: (config && config.progressiveLoad) || false,
    hideOnTransparent: !((config && config.hideOnTransparent === false)),
    viewBoxOnly: (config && config.viewBoxOnly) || false,
    viewBoxSize: (config && config.viewBoxSize) || false,
    className: (config && config.className) || '',
    id: (config && config.id) || '',
    focusable: config && config.focusable,
    filterSize: {
      width: (config && config.filterSize && config.filterSize.width) || '100%',
      height: (config && config.filterSize && config.filterSize.height) || '100%',
      x: (config && config.filterSize && config.filterSize.x) || '0%',
      y: (config && config.filterSize && config.filterSize.y) || '0%',
    },
  };

  this.globalData = {
    _mdf: false,
    frameNum: -1,
    defs: defs,
    renderConfig: this.renderConfig,
  };
  this.elements = [];
  this.pendingElements = [];
  this.destroyed = false;
  this.rendererType = 'svg';
}

extendPrototype([BaseRenderer], SVGRenderer);

SVGRenderer.prototype.createNull = function (data) {
  return new NullElement(data, this.globalData, this);
};

SVGRenderer.prototype.createShape = function (data) {
  return new SVGShapeElement(data, this.globalData, this);
};

SVGRenderer.prototype.createText = function (data) {
  return new SVGTextLottieElement(data, this.globalData, this);
};

SVGRenderer.prototype.createImage = function (data) {
  return new IImageElement(data, this.globalData, this);
};

SVGRenderer.prototype.createComp = function (data) {
  return new SVGCompElement(data, this.globalData, this);
};

SVGRenderer.prototype.createSolid = function (data) {
  return new ISolidElement(data, this.globalData, this);
};

SVGRenderer.prototype.configAnimation = function (animData) {
  this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  if (this.renderConfig.viewBoxSize) {
    this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
  } else {
    this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
  }

  if (!this.renderConfig.viewBoxOnly) {
    this.svgElement.setAttribute('width', animData.w);
    this.svgElement.setAttribute('height', animData.h);
    this.svgElement.style.width = '100%';
    this.svgElement.style.height = '100%';
    this.svgElement.style.transform = 'translate3d(0,0,0)';
    this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
  }
  if (this.renderConfig.className) {
    this.svgElement.setAttribute('class', this.renderConfig.className);
  }
  if (this.renderConfig.id) {
    this.svgElement.setAttribute('id', this.renderConfig.id);
  }
  if (this.renderConfig.focusable !== undefined) {
    this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
  }
  this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio);
  // this.layerElement.style.transform = 'translate3d(0,0,0)';
  // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
  this.animationItem.wrapper.appendChild(this.svgElement);
  // Mask animation
  var defs = this.globalData.defs;

  this.setupGlobalData(animData, defs);
  this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
  this.data = animData;

  var maskElement = createNS('clipPath');
  var rect = createNS('rect');
  rect.setAttribute('width', animData.w);
  rect.setAttribute('height', animData.h);
  rect.setAttribute('x', 0);
  rect.setAttribute('y', 0);
  var maskId = createElementID();
  maskElement.setAttribute('id', maskId);
  maskElement.appendChild(rect);
  this.layerElement.setAttribute('clip-path', 'url(' + locationHref + '#' + maskId + ')');

  defs.appendChild(maskElement);
  this.layers = animData.layers;
  this.elements = createSizedArray(animData.layers.length);
};

SVGRenderer.prototype.destroy = function () {
  if (this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  this.layerElement = null;
  this.globalData.defs = null;
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = 0; i < len; i += 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.elements.length = 0;
  this.destroyed = true;
  this.animationItem = null;
};

SVGRenderer.prototype.updateContainerSize = function () {
};

SVGRenderer.prototype.buildItem = function (pos) {
  var elements = this.elements;
  if (elements[pos] || this.layers[pos].ty === 99) {
    return;
  }
  elements[pos] = true;
  var element = this.createItem(this.layers[pos]);

  elements[pos] = element;
  if (expressionsPlugin) {
    if (this.layers[pos].ty === 0) {
      this.globalData.projectInterface.registerComposition(element);
    }
    element.initExpressions();
  }
  this.appendElementInPos(element, pos);
  if (this.layers[pos].tt) {
    if (!this.elements[pos - 1] || this.elements[pos - 1] === true) {
      this.buildItem(pos - 1);
      this.addPendingElement(element);
    } else {
      element.setMatte(elements[pos - 1].layerId);
    }
  }
};

SVGRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
    if (element.data.tt) {
      var i = 0;
      var len = this.elements.length;
      while (i < len) {
        if (this.elements[i] === element) {
          element.setMatte(this.elements[i - 1].layerId);
          break;
        }
        i += 1;
      }
    }
  }
};

SVGRenderer.prototype.renderFrame = function (num) {
  if (this.renderedFrame === num || this.destroyed) {
    return;
  }
  if (num === null) {
    num = this.renderedFrame;
  } else {
    this.renderedFrame = num;
  }
  // console.log('-------');
  // console.log('FRAME ',num);
  this.globalData.frameNum = num;
  this.globalData.frameId += 1;
  this.globalData.projectInterface.currentFrame = num;
  this.globalData._mdf = false;
  var i;
  var len = this.layers.length;
  if (!this.completeLayers) {
    this.checkLayers(num);
  }
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(num - this.layers[i].st);
    }
  }
  if (this.globalData._mdf) {
    for (i = 0; i < len; i += 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  }
};

SVGRenderer.prototype.appendElementInPos = function (element, pos) {
  var newElement = element.getBaseElement();
  if (!newElement) {
    return;
  }
  var i = 0;
  var nextElement;
  while (i < pos) {
    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
      nextElement = this.elements[i].getBaseElement();
    }
    i += 1;
  }
  if (nextElement) {
    this.layerElement.insertBefore(newElement, nextElement);
  } else {
    this.layerElement.appendChild(newElement);
  }
};

SVGRenderer.prototype.hide = function () {
  this.layerElement.style.display = 'none';
};

SVGRenderer.prototype.show = function () {
  this.layerElement.style.display = 'block';
};

/* global CVContextData, Matrix, extendPrototype, BaseRenderer, CVShapeElement, CVTextElement,
CVImageElement, CVCompElement, CVSolidElement, SVGRenderer, createTag, createSizedArray */

function CanvasRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.renderConfig = {
    clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
    context: (config && config.context) || null,
    progressiveLoad: (config && config.progressiveLoad) || false,
    preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    contentVisibility: (config && config.contentVisibility) || 'visible',
    className: (config && config.className) || '',
    id: (config && config.id) || '',
  };
  this.renderConfig.dpr = (config && config.dpr) || 1;
  if (this.animationItem.wrapper) {
    this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
  }
  this.renderedFrame = -1;
  this.globalData = {
    frameNum: -1,
    _mdf: false,
    renderConfig: this.renderConfig,
    currentGlobalAlpha: -1,
  };
  this.contextData = new CVContextData();
  this.elements = [];
  this.pendingElements = [];
  this.transformMat = new Matrix();
  this.completeLayers = false;
  this.rendererType = 'canvas';
}
extendPrototype([BaseRenderer], CanvasRenderer);

CanvasRenderer.prototype.createShape = function (data) {
  return new CVShapeElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createText = function (data) {
  return new CVTextElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createImage = function (data) {
  return new CVImageElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createComp = function (data) {
  return new CVCompElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createSolid = function (data) {
  return new CVSolidElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

CanvasRenderer.prototype.ctxTransform = function (props) {
  if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
    return;
  }
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    return;
  }
  this.transformMat.cloneFromProps(props);
  var cProps = this.contextData.cTr.props;
  this.transformMat.transform(cProps[0], cProps[1], cProps[2], cProps[3], cProps[4], cProps[5], cProps[6], cProps[7], cProps[8], cProps[9], cProps[10], cProps[11], cProps[12], cProps[13], cProps[14], cProps[15]);
  // this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
  this.contextData.cTr.cloneFromProps(this.transformMat.props);
  var trProps = this.contextData.cTr.props;
  this.canvasContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
};

CanvasRenderer.prototype.ctxOpacity = function (op) {
  /* if(op === 1){
        return;
    } */
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    this.globalData.currentGlobalAlpha = this.contextData.cO;
    return;
  }
  this.contextData.cO *= op < 0 ? 0 : op;
  if (this.globalData.currentGlobalAlpha !== this.contextData.cO) {
    this.canvasContext.globalAlpha = this.contextData.cO;
    this.globalData.currentGlobalAlpha = this.contextData.cO;
  }
};

CanvasRenderer.prototype.reset = function () {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  this.contextData.reset();
};

CanvasRenderer.prototype.save = function (actionFlag) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.save();
    return;
  }
  if (actionFlag) {
    this.canvasContext.save();
  }
  var props = this.contextData.cTr.props;
  if (this.contextData._length <= this.contextData.cArrPos) {
    this.contextData.duplicate();
  }
  var i;
  var arr = this.contextData.saved[this.contextData.cArrPos];
  for (i = 0; i < 16; i += 1) {
    arr[i] = props[i];
  }
  this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
  this.contextData.cArrPos += 1;
};

CanvasRenderer.prototype.restore = function (actionFlag) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  if (actionFlag) {
    this.canvasContext.restore();
    this.globalData.blendMode = 'source-over';
  }
  this.contextData.cArrPos -= 1;
  var popped = this.contextData.saved[this.contextData.cArrPos];
  var i;
  var arr = this.contextData.cTr.props;
  for (i = 0; i < 16; i += 1) {
    arr[i] = popped[i];
  }
  this.canvasContext.setTransform(popped[0], popped[1], popped[4], popped[5], popped[12], popped[13]);
  popped = this.contextData.savedOp[this.contextData.cArrPos];
  this.contextData.cO = popped;
  if (this.globalData.currentGlobalAlpha !== popped) {
    this.canvasContext.globalAlpha = popped;
    this.globalData.currentGlobalAlpha = popped;
  }
};

CanvasRenderer.prototype.configAnimation = function (animData) {
  if (this.animationItem.wrapper) {
    this.animationItem.container = createTag('canvas');
    var containerStyle = this.animationItem.container.style;
    containerStyle.width = '100%';
    containerStyle.height = '100%';
    var origin = '0px 0px 0px';
    containerStyle.transformOrigin = origin;
    containerStyle.mozTransformOrigin = origin;
    containerStyle.webkitTransformOrigin = origin;
    containerStyle['-webkit-transform'] = origin;
    containerStyle.contentVisibility = this.renderConfig.contentVisibility;
    this.animationItem.wrapper.appendChild(this.animationItem.container);
    this.canvasContext = this.animationItem.container.getContext('2d');
    if (this.renderConfig.className) {
      this.animationItem.container.setAttribute('class', this.renderConfig.className);
    }
    if (this.renderConfig.id) {
      this.animationItem.container.setAttribute('id', this.renderConfig.id);
    }
  } else {
    this.canvasContext = this.renderConfig.context;
  }
  this.data = animData;
  this.layers = animData.layers;
  this.transformCanvas = {
    w: animData.w,
    h: animData.h,
    sx: 0,
    sy: 0,
    tx: 0,
    ty: 0,
  };
  this.setupGlobalData(animData, document.body);
  this.globalData.canvasContext = this.canvasContext;
  this.globalData.renderer = this;
  this.globalData.isDashed = false;
  this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
  this.globalData.transformCanvas = this.transformCanvas;
  this.elements = createSizedArray(animData.layers.length);

  this.updateContainerSize();
};

CanvasRenderer.prototype.updateContainerSize = function () {
  this.reset();
  var elementWidth;
  var elementHeight;
  if (this.animationItem.wrapper && this.animationItem.container) {
    elementWidth = this.animationItem.wrapper.offsetWidth;
    elementHeight = this.animationItem.wrapper.offsetHeight;
    this.animationItem.container.setAttribute('width', elementWidth * this.renderConfig.dpr);
    this.animationItem.container.setAttribute('height', elementHeight * this.renderConfig.dpr);
  } else {
    elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
    elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
  }
  var elementRel;
  var animationRel;
  if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
    var par = this.renderConfig.preserveAspectRatio.split(' ');
    var fillType = par[1] || 'meet';
    var pos = par[0] || 'xMidYMid';
    var xPos = pos.substr(0, 4);
    var yPos = pos.substr(4);
    elementRel = elementWidth / elementHeight;
    animationRel = this.transformCanvas.w / this.transformCanvas.h;
    if ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice')) {
      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
    } else {
      this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
    }

    if (xPos === 'xMid' && ((animationRel < elementRel && fillType === 'meet') || (animationRel > elementRel && fillType === 'slice'))) {
      this.transformCanvas.tx = ((elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2) * this.renderConfig.dpr;
    } else if (xPos === 'xMax' && ((animationRel < elementRel && fillType === 'meet') || (animationRel > elementRel && fillType === 'slice'))) {
      this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
    } else {
      this.transformCanvas.tx = 0;
    }
    if (yPos === 'YMid' && ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice'))) {
      this.transformCanvas.ty = ((elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2) * this.renderConfig.dpr;
    } else if (yPos === 'YMax' && ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice'))) {
      this.transformCanvas.ty = ((elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w))) * this.renderConfig.dpr;
    } else {
      this.transformCanvas.ty = 0;
    }
  } else if (this.renderConfig.preserveAspectRatio === 'none') {
    this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
    this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
    this.transformCanvas.tx = 0;
    this.transformCanvas.ty = 0;
  } else {
    this.transformCanvas.sx = this.renderConfig.dpr;
    this.transformCanvas.sy = this.renderConfig.dpr;
    this.transformCanvas.tx = 0;
    this.transformCanvas.ty = 0;
  }
  this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
  /* var i, len = this.elements.length;
    for(i=0;i<len;i+=1){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(this.globalData.transformCanvas);
        }
    } */
  this.ctxTransform(this.transformCanvas.props);
  this.canvasContext.beginPath();
  this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
  this.canvasContext.closePath();
  this.canvasContext.clip();

  this.renderFrame(this.renderedFrame, true);
};

CanvasRenderer.prototype.destroy = function () {
  if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.elements.length = 0;
  this.globalData.canvasContext = null;
  this.animationItem.container = null;
  this.destroyed = true;
};

CanvasRenderer.prototype.renderFrame = function (num, forceRender) {
  if ((this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender) || this.destroyed || num === -1) {
    return;
  }
  this.renderedFrame = num;
  this.globalData.frameNum = num - this.animationItem._isFirstFrame;
  this.globalData.frameId += 1;
  this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
  this.globalData.projectInterface.currentFrame = num;

  // console.log('--------');
  // console.log('NEW: ',num);
  var i;
  var len = this.layers.length;
  if (!this.completeLayers) {
    this.checkLayers(num);
  }

  for (i = 0; i < len; i += 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(num - this.layers[i].st);
    }
  }
  if (this.globalData._mdf) {
    if (this.renderConfig.clearCanvas === true) {
      this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
    } else {
      this.save();
    }
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
    if (this.renderConfig.clearCanvas !== true) {
      this.restore();
    }
  }
};

CanvasRenderer.prototype.buildItem = function (pos) {
  var elements = this.elements;
  if (elements[pos] || this.layers[pos].ty === 99) {
    return;
  }
  var element = this.createItem(this.layers[pos], this, this.globalData);
  elements[pos] = element;
  element.initExpressions();
  /* if(this.layers[pos].ty === 0){
        element.resize(this.globalData.transformCanvas);
    } */
};

CanvasRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
  }
};

CanvasRenderer.prototype.hide = function () {
  this.animationItem.container.style.display = 'none';
};

CanvasRenderer.prototype.show = function () {
  this.animationItem.container.style.display = 'block';
};

/* global extendPrototype, BaseRenderer, SVGRenderer, SVGShapeElement, HShapeElement, SVGTextLottieElement,
HTextElement, HCameraElement, IImageElement, HImageElement, SVGCompElement, HCompElement, ISolidElement,
HSolidElement, styleDiv, createTag, createNS */

function HybridRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.layers = null;
  this.renderedFrame = -1;
  this.renderConfig = {
    className: (config && config.className) || '',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    hideOnTransparent: !(config && config.hideOnTransparent === false),
    filterSize: {
      width: (config && config.filterSize && config.filterSize.width) || '400%',
      height: (config && config.filterSize && config.filterSize.height) || '400%',
      x: (config && config.filterSize && config.filterSize.x) || '-100%',
      y: (config && config.filterSize && config.filterSize.y) || '-100%',
    },
  };
  this.globalData = {
    _mdf: false,
    frameNum: -1,
    renderConfig: this.renderConfig,
  };
  this.pendingElements = [];
  this.elements = [];
  this.threeDElements = [];
  this.destroyed = false;
  this.camera = null;
  this.supports3d = true;
  this.rendererType = 'html';
}

extendPrototype([BaseRenderer], HybridRenderer);

HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;

HybridRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
  }
};

HybridRenderer.prototype.appendElementInPos = function (element, pos) {
  var newDOMElement = element.getBaseElement();
  if (!newDOMElement) {
    return;
  }
  var layer = this.layers[pos];
  if (!layer.ddd || !this.supports3d) {
    if (this.threeDElements) {
      this.addTo3dContainer(newDOMElement, pos);
    } else {
      var i = 0;
      var nextDOMElement;
      var nextLayer;
      var tmpDOMElement;
      while (i < pos) {
        if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
          nextLayer = this.elements[i];
          tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
          nextDOMElement = tmpDOMElement || nextDOMElement;
        }
        i += 1;
      }
      if (nextDOMElement) {
        if (!layer.ddd || !this.supports3d) {
          this.layerElement.insertBefore(newDOMElement, nextDOMElement);
        }
      } else if (!layer.ddd || !this.supports3d) {
        this.layerElement.appendChild(newDOMElement);
      }
    }
  } else {
    this.addTo3dContainer(newDOMElement, pos);
  }
};

HybridRenderer.prototype.createShape = function (data) {
  if (!this.supports3d) {
    return new SVGShapeElement(data, this.globalData, this);
  }
  return new HShapeElement(data, this.globalData, this);
};

HybridRenderer.prototype.createText = function (data) {
  if (!this.supports3d) {
    return new SVGTextLottieElement(data, this.globalData, this);
  }
  return new HTextElement(data, this.globalData, this);
};

HybridRenderer.prototype.createCamera = function (data) {
  this.camera = new HCameraElement(data, this.globalData, this);
  return this.camera;
};

HybridRenderer.prototype.createImage = function (data) {
  if (!this.supports3d) {
    return new IImageElement(data, this.globalData, this);
  }
  return new HImageElement(data, this.globalData, this);
};

HybridRenderer.prototype.createComp = function (data) {
  if (!this.supports3d) {
    return new SVGCompElement(data, this.globalData, this);
  }
  return new HCompElement(data, this.globalData, this);
};

HybridRenderer.prototype.createSolid = function (data) {
  if (!this.supports3d) {
    return new ISolidElement(data, this.globalData, this);
  }
  return new HSolidElement(data, this.globalData, this);
};

HybridRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

HybridRenderer.prototype.getThreeDContainerByPos = function (pos) {
  var i = 0;
  var len = this.threeDElements.length;
  while (i < len) {
    if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
      return this.threeDElements[i].perspectiveElem;
    }
    i += 1;
  }
  return null;
};

HybridRenderer.prototype.createThreeDContainer = function (pos, type) {
  var perspectiveElem = createTag('div');
  var style;
  var containerStyle;
  styleDiv(perspectiveElem);
  var container = createTag('div');
  styleDiv(container);
  if (type === '3d') {
    style = perspectiveElem.style;
    style.width = this.globalData.compSize.w + 'px';
    style.height = this.globalData.compSize.h + 'px';
    var center = '50% 50%';
    style.webkitTransformOrigin = center;
    style.mozTransformOrigin = center;
    style.transformOrigin = center;
    containerStyle = container.style;
    var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    containerStyle.transform = matrix;
    containerStyle.webkitTransform = matrix;
  }

  perspectiveElem.appendChild(container);
  // this.resizerElem.appendChild(perspectiveElem);
  var threeDContainerData = {
    container: container,
    perspectiveElem: perspectiveElem,
    startPos: pos,
    endPos: pos,
    type: type,
  };
  this.threeDElements.push(threeDContainerData);
  return threeDContainerData;
};

HybridRenderer.prototype.build3dContainers = function () {
  var i;
  var len = this.layers.length;
  var lastThreeDContainerData;
  var currentContainer = '';
  for (i = 0; i < len; i += 1) {
    if (this.layers[i].ddd && this.layers[i].ty !== 3) {
      if (currentContainer !== '3d') {
        currentContainer = '3d';
        lastThreeDContainerData = this.createThreeDContainer(i, '3d');
      }
      lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
    } else {
      if (currentContainer !== '2d') {
        currentContainer = '2d';
        lastThreeDContainerData = this.createThreeDContainer(i, '2d');
      }
      lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
    }
  }
  len = this.threeDElements.length;
  for (i = len - 1; i >= 0; i -= 1) {
    this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
  }
};

HybridRenderer.prototype.addTo3dContainer = function (elem, pos) {
  var i = 0;
  var len = this.threeDElements.length;
  while (i < len) {
    if (pos <= this.threeDElements[i].endPos) {
      var j = this.threeDElements[i].startPos;
      var nextElement;
      while (j < pos) {
        if (this.elements[j] && this.elements[j].getBaseElement) {
          nextElement = this.elements[j].getBaseElement();
        }
        j += 1;
      }
      if (nextElement) {
        this.threeDElements[i].container.insertBefore(elem, nextElement);
      } else {
        this.threeDElements[i].container.appendChild(elem);
      }
      break;
    }
    i += 1;
  }
};

HybridRenderer.prototype.configAnimation = function (animData) {
  var resizerElem = createTag('div');
  var wrapper = this.animationItem.wrapper;
  var style = resizerElem.style;
  style.width = animData.w + 'px';
  style.height = animData.h + 'px';
  this.resizerElem = resizerElem;
  styleDiv(resizerElem);
  style.transformStyle = 'flat';
  style.mozTransformStyle = 'flat';
  style.webkitTransformStyle = 'flat';
  if (this.renderConfig.className) {
    resizerElem.setAttribute('class', this.renderConfig.className);
  }
  wrapper.appendChild(resizerElem);

  style.overflow = 'hidden';
  var svg = createNS('svg');
  svg.setAttribute('width', '1');
  svg.setAttribute('height', '1');
  styleDiv(svg);
  this.resizerElem.appendChild(svg);
  var defs = createNS('defs');
  svg.appendChild(defs);
  this.data = animData;
  // Mask animation
  this.setupGlobalData(animData, svg);
  this.globalData.defs = defs;
  this.layers = animData.layers;
  this.layerElement = this.resizerElem;
  this.build3dContainers();
  this.updateContainerSize();
};

HybridRenderer.prototype.destroy = function () {
  if (this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  this.animationItem.container = null;
  this.globalData.defs = null;
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = 0; i < len; i += 1) {
    this.elements[i].destroy();
  }
  this.elements.length = 0;
  this.destroyed = true;
  this.animationItem = null;
};

HybridRenderer.prototype.updateContainerSize = function () {
  var elementWidth = this.animationItem.wrapper.offsetWidth;
  var elementHeight = this.animationItem.wrapper.offsetHeight;
  var elementRel = elementWidth / elementHeight;
  var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
  var sx;
  var sy;
  var tx;
  var ty;
  if (animationRel > elementRel) {
    sx = elementWidth / (this.globalData.compSize.w);
    sy = elementWidth / (this.globalData.compSize.w);
    tx = 0;
    ty = ((elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2);
  } else {
    sx = elementHeight / (this.globalData.compSize.h);
    sy = elementHeight / (this.globalData.compSize.h);
    tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
    ty = 0;
  }
  var style = this.resizerElem.style;
  style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
  style.transform = style.webkitTransform;
};

HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

HybridRenderer.prototype.hide = function () {
  this.resizerElem.style.display = 'none';
};

HybridRenderer.prototype.show = function () {
  this.resizerElem.style.display = 'block';
};

HybridRenderer.prototype.initItems = function () {
  this.buildAllItems();
  if (this.camera) {
    this.camera.setup();
  } else {
    var cWidth = this.globalData.compSize.w;
    var cHeight = this.globalData.compSize.h;
    var i;
    var len = this.threeDElements.length;
    for (i = 0; i < len; i += 1) {
      var style = this.threeDElements[i].perspectiveElem.style;
      style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
      style.perspective = style.webkitPerspective;
    }
  }
};

HybridRenderer.prototype.searchExtraCompositions = function (assets) {
  var i;
  var len = assets.length;
  var floatingContainer = createTag('div');
  for (i = 0; i < len; i += 1) {
    if (assets[i].xt) {
      var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
      comp.initExpressions();
      this.globalData.projectInterface.registerComposition(comp);
    }
  }
};

/* global createSizedArray, createElementID, PropertyFactory, ShapePropertyFactory, createNS, locationHref */

function MaskElement(data, element, globalData) {
  this.data = data;
  this.element = element;
  this.globalData = globalData;
  this.storedData = [];
  this.masksProperties = this.data.masksProperties || [];
  this.maskElement = null;
  var defs = this.globalData.defs;
  var i;
  var len = this.masksProperties ? this.masksProperties.length : 0;
  this.viewData = createSizedArray(len);
  this.solidPath = '';

  var path;
  var properties = this.masksProperties;
  var count = 0;
  var currentMasks = [];
  var j;
  var jLen;
  var layerId = createElementID();
  var rect;
  var expansor;
  var feMorph;
  var x;
  var maskType = 'clipPath';
  var maskRef = 'clip-path';
  for (i = 0; i < len; i += 1) {
    if ((properties[i].mode !== 'a' && properties[i].mode !== 'n') || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
      maskType = 'mask';
      maskRef = 'mask';
    }

    if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
      rect = createNS('rect');
      rect.setAttribute('fill', '#ffffff');
      rect.setAttribute('width', this.element.comp.data.w || 0);
      rect.setAttribute('height', this.element.comp.data.h || 0);
      currentMasks.push(rect);
    } else {
      rect = null;
    }

    path = createNS('path');
    if (properties[i].mode === 'n') {
      // TODO move this to a factory or to a constructor
      this.viewData[i] = {
        op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
        prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
        elem: path,
        lastPath: '',
      };
      defs.appendChild(path);
    } else {
      count += 1;

      path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
      path.setAttribute('clip-rule', 'nonzero');
      var filterID;

      if (properties[i].x.k !== 0) {
        maskType = 'mask';
        maskRef = 'mask';
        x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
        filterID = createElementID();
        expansor = createNS('filter');
        expansor.setAttribute('id', filterID);
        feMorph = createNS('feMorphology');
        feMorph.setAttribute('operator', 'erode');
        feMorph.setAttribute('in', 'SourceGraphic');
        feMorph.setAttribute('radius', '0');
        expansor.appendChild(feMorph);
        defs.appendChild(expansor);
        path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
      } else {
        feMorph = null;
        x = null;
      }

      // TODO move this to a factory or to a constructor
      this.storedData[i] = {
        elem: path,
        x: x,
        expan: feMorph,
        lastPath: '',
        lastOperator: '',
        filterId: filterID,
        lastRadius: 0,
      };
      if (properties[i].mode === 'i') {
        jLen = currentMasks.length;
        var g = createNS('g');
        for (j = 0; j < jLen; j += 1) {
          g.appendChild(currentMasks[j]);
        }
        var mask = createNS('mask');
        mask.setAttribute('mask-type', 'alpha');
        mask.setAttribute('id', layerId + '_' + count);
        mask.appendChild(path);
        defs.appendChild(mask);
        g.setAttribute('mask', 'url(' + locationHref + '#' + layerId + '_' + count + ')');

        currentMasks.length = 0;
        currentMasks.push(g);
      } else {
        currentMasks.push(path);
      }
      if (properties[i].inv && !this.solidPath) {
        this.solidPath = this.createLayerSolidPath();
      }
      // TODO move this to a factory or to a constructor
      this.viewData[i] = {
        elem: path,
        lastPath: '',
        op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
        prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
        invRect: rect,
      };
      if (!this.viewData[i].prop.k) {
        this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
      }
    }
  }

  this.maskElement = createNS(maskType);

  len = currentMasks.length;
  for (i = 0; i < len; i += 1) {
    this.maskElement.appendChild(currentMasks[i]);
  }

  if (count > 0) {
    this.maskElement.setAttribute('id', layerId);
    this.element.maskedElement.setAttribute(maskRef, 'url(' + locationHref + '#' + layerId + ')');
    defs.appendChild(this.maskElement);
  }
  if (this.viewData.length) {
    this.element.addRenderableComponent(this);
  }
}

MaskElement.prototype.getMaskProperty = function (pos) {
  return this.viewData[pos].prop;
};

MaskElement.prototype.renderFrame = function (isFirstFrame) {
  var finalMat = this.element.finalTransform.mat;
  var i;
  var len = this.masksProperties.length;
  for (i = 0; i < len; i += 1) {
    if (this.viewData[i].prop._mdf || isFirstFrame) {
      this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
    }
    if (this.viewData[i].op._mdf || isFirstFrame) {
      this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
    }
    if (this.masksProperties[i].mode !== 'n') {
      if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
        this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
      }
      if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
        var feMorph = this.storedData[i].expan;
        if (this.storedData[i].x.v < 0) {
          if (this.storedData[i].lastOperator !== 'erode') {
            this.storedData[i].lastOperator = 'erode';
            this.storedData[i].elem.setAttribute('filter', 'url(' + locationHref + '#' + this.storedData[i].filterId + ')');
          }
          feMorph.setAttribute('radius', -this.storedData[i].x.v);
        } else {
          if (this.storedData[i].lastOperator !== 'dilate') {
            this.storedData[i].lastOperator = 'dilate';
            this.storedData[i].elem.setAttribute('filter', null);
          }
          this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
        }
      }
    }
  }
};

MaskElement.prototype.getMaskelement = function () {
  return this.maskElement;
};

MaskElement.prototype.createLayerSolidPath = function () {
  var path = 'M0,0 ';
  path += ' h' + this.globalData.compSize.w;
  path += ' v' + this.globalData.compSize.h;
  path += ' h-' + this.globalData.compSize.w;
  path += ' v-' + this.globalData.compSize.h + ' ';
  return path;
};

MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
  var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
  var i;
  var len;
  len = pathNodes._length;
  for (i = 1; i < len; i += 1) {
    // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
    pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
  }
  // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
  if (pathNodes.c && len > 1) {
    pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
  }
  // pathNodes.__renderedString = pathString;

  if (viewData.lastPath !== pathString) {
    var pathShapeValue = '';
    if (viewData.elem) {
      if (pathNodes.c) {
        pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
      }
      viewData.elem.setAttribute('d', pathShapeValue);
    }
    viewData.lastPath = pathString;
  }
};

MaskElement.prototype.destroy = function () {
  this.element = null;
  this.globalData = null;
  this.maskElement = null;
  this.data = null;
  this.masksProperties = null;
};

/**
 * @file
 * Handles AE's layer parenting property.
 *
 */

function HierarchyElement() {}

HierarchyElement.prototype = {
  /**
     * @function
     * Initializes hierarchy properties
     *
     */
  initHierarchy: function () {
    // element's parent list
    this.hierarchy = [];
    // if element is parent of another layer _isParent will be true
    this._isParent = false;
    this.checkParenting();
  },
  /**
     * @function
     * Sets layer's hierarchy.
     * @param {array} hierarch
     * layer's parent list
     *
     */
  setHierarchy: function (hierarchy) {
    this.hierarchy = hierarchy;
  },
  /**
     * @function
     * Sets layer as parent.
     *
     */
  setAsParent: function () {
    this._isParent = true;
  },
  /**
     * @function
     * Searches layer's parenting chain
     *
     */
  checkParenting: function () {
    if (this.data.parent !== undefined) {
      this.comp.buildElementParenting(this, this.data.parent, []);
    }
  },
};

/**
 * @file
 * Handles element's layer frame update.
 * Checks layer in point and out point
 *
 */

function FrameElement() {}

FrameElement.prototype = {
  /**
     * @function
     * Initializes frame related properties.
     *
     */
  initFrame: function () {
    // set to true when inpoint is rendered
    this._isFirstFrame = false;
    // list of animated properties
    this.dynamicProperties = [];
    // If layer has been modified in current tick this will be true
    this._mdf = false;
  },
  /**
     * @function
     * Calculates all dynamic values
     *
     * @param {number} num
     * current frame number in Layer's time
     * @param {boolean} isVisible
     * if layers is currently in range
     *
     */
  prepareProperties: function (num, isVisible) {
    var i;
    var len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      if (isVisible || (this._isParent && this.dynamicProperties[i].propType === 'transform')) {
        this.dynamicProperties[i].getValue();
        if (this.dynamicProperties[i]._mdf) {
          this.globalData._mdf = true;
          this._mdf = true;
        }
      }
    }
  },
  addDynamicProperty: function (prop) {
    if (this.dynamicProperties.indexOf(prop) === -1) {
      this.dynamicProperties.push(prop);
    }
  },
};

/* global TransformPropertyFactory, Matrix */

function TransformElement() {}

TransformElement.prototype = {
  initTransform: function () {
    this.finalTransform = {
      mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : { o: 0 },
      _matMdf: false,
      _opMdf: false,
      mat: new Matrix(),
    };
    if (this.data.ao) {
      this.finalTransform.mProp.autoOriented = true;
    }

    // TODO: check TYPE 11: Guided elements
    if (this.data.ty !== 11) {
      // this.createElements();
    }
  },
  renderTransform: function () {
    this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
    this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

    if (this.hierarchy) {
      var mat;
      var finalMat = this.finalTransform.mat;
      var i = 0;
      var len = this.hierarchy.length;
      // Checking if any of the transformation matrices in the hierarchy chain has changed.
      if (!this.finalTransform._matMdf) {
        while (i < len) {
          if (this.hierarchy[i].finalTransform.mProp._mdf) {
            this.finalTransform._matMdf = true;
            break;
          }
          i += 1;
        }
      }

      if (this.finalTransform._matMdf) {
        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for (i = 0; i < len; i += 1) {
          mat = this.hierarchy[i].finalTransform.mProp.v.props;
          finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
        }
      }
    }
  },
  globalToLocal: function (pt) {
    var transforms = [];
    transforms.push(this.finalTransform);
    var flag = true;
    var comp = this.comp;
    while (flag) {
      if (comp.finalTransform) {
        if (comp.data.hasMask) {
          transforms.splice(0, 0, comp.finalTransform);
        }
        comp = comp.comp;
      } else {
        flag = false;
      }
    }
    var i;
    var len = transforms.length;
    var ptNew;
    for (i = 0; i < len; i += 1) {
      ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
      // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
      pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
    }
    return pt;
  },
  mHelper: new Matrix(),
};

function RenderableElement() {

}

RenderableElement.prototype = {
  initRenderable: function () {
    // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
    this.isInRange = false;
    // layer's display state
    this.hidden = false;
    // If layer's transparency equals 0, it can be hidden
    this.isTransparent = false;
    // list of animated components
    this.renderableComponents = [];
  },
  addRenderableComponent: function (component) {
    if (this.renderableComponents.indexOf(component) === -1) {
      this.renderableComponents.push(component);
    }
  },
  removeRenderableComponent: function (component) {
    if (this.renderableComponents.indexOf(component) !== -1) {
      this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
    }
  },
  prepareRenderableFrame: function (num) {
    this.checkLayerLimits(num);
  },
  checkTransparency: function () {
    if (this.finalTransform.mProp.o.v <= 0) {
      if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
        this.isTransparent = true;
        this.hide();
      }
    } else if (this.isTransparent) {
      this.isTransparent = false;
      this.show();
    }
  },
  /**
     * @function
     * Initializes frame related properties.
     *
     * @param {number} num
     * current frame number in Layer's time
     *
     */
  checkLayerLimits: function (num) {
    if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
      if (this.isInRange !== true) {
        this.globalData._mdf = true;
        this._mdf = true;
        this.isInRange = true;
        this.show();
      }
    } else if (this.isInRange !== false) {
      this.globalData._mdf = true;
      this.isInRange = false;
      this.hide();
    }
  },
  renderRenderable: function () {
    var i;
    var len = this.renderableComponents.length;
    for (i = 0; i < len; i += 1) {
      this.renderableComponents[i].renderFrame(this._isFirstFrame);
    }
    /* this.maskManager.renderFrame(this.finalTransform.mat);
        this.renderableEffectsManager.renderFrame(this._isFirstFrame); */
  },
  sourceRectAtTime: function () {
    return {
      top: 0,
      left: 0,
      width: 100,
      height: 100,
    };
  },
  getLayerSize: function () {
    if (this.data.ty === 5) {
      return { w: this.data.textData.width, h: this.data.textData.height };
    }
    return { w: this.data.width, h: this.data.height };
  },
};

/* global extendPrototype, RenderableElement, createProxyFunction */

function RenderableDOMElement() {}

(function () {
  var _prototype = {
    initElement: function (data, globalData, comp) {
      this.initFrame();
      this.initBaseData(data, globalData, comp);
      this.initTransform(data, globalData, comp);
      this.initHierarchy();
      this.initRenderable();
      this.initRendererElement();
      this.createContainerElements();
      this.createRenderableComponents();
      this.createContent();
      this.hide();
    },
    hide: function () {
      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
        var elem = this.baseElement || this.layerElement;
        elem.style.display = 'none';
        this.hidden = true;
      }
    },
    show: function () {
      if (this.isInRange && !this.isTransparent) {
        if (!this.data.hd) {
          var elem = this.baseElement || this.layerElement;
          elem.style.display = 'block';
        }
        this.hidden = false;
        this._isFirstFrame = true;
      }
    },
    renderFrame: function () {
      // If it is exported as hidden (data.hd === true) no need to render
      // If it is not visible no need to render
      if (this.data.hd || this.hidden) {
        return;
      }
      this.renderTransform();
      this.renderRenderable();
      this.renderElement();
      this.renderInnerContent();
      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    renderInnerContent: function () {},
    prepareFrame: function (num) {
      this._mdf = false;
      this.prepareRenderableFrame(num);
      this.prepareProperties(num, this.isInRange);
      this.checkTransparency();
    },
    destroy: function () {
      this.innerElem = null;
      this.destroyBaseElement();
    },
  };
  extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
}());

/* exported ProcessedElement */

function ProcessedElement(element, position) {
  this.elem = element;
  this.pos = position;
}

/* global createNS */

function SVGStyleData(data, level) {
  this.data = data;
  this.type = data.ty;
  this.d = '';
  this.lvl = level;
  this._mdf = false;
  this.closed = data.hd === true;
  this.pElem = createNS('path');
  this.msElem = null;
}

SVGStyleData.prototype.reset = function () {
  this.d = '';
  this._mdf = false;
};

function SVGShapeData(transformers, level, shape) {
  this.caches = [];
  this.styles = [];
  this.transformers = transformers;
  this.lStr = '';
  this.sh = shape;
  this.lvl = level;
  // TODO find if there are some cases where _isAnimated can be false.
  // For now, since shapes add up with other shapes. They have to be calculated every time.
  // One way of finding out is checking if all styles associated to this shape depend only of this shape
  this._isAnimated = !!shape.k;
  // TODO: commenting this for now since all shapes are animated
  var i = 0;
  var len = transformers.length;
  while (i < len) {
    if (transformers[i].mProps.dynamicProperties.length) {
      this._isAnimated = true;
      break;
    }
    i += 1;
  }
}

SVGShapeData.prototype.setAsAnimated = function () {
  this._isAnimated = true;
};

/* exported SVGTransformData */

function SVGTransformData(mProps, op, container) {
  this.transform = {
    mProps: mProps,
    op: op,
    container: container,
  };
  this.elements = [];
  this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
}

/* global DashProperty, PropertyFactory, extendPrototype, DynamicPropertyContainer */

function SVGStrokeStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
  this.d = new DashProperty(elem, data.d || {}, 'svg', this);
  this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
  this.style = styleOb;
  this._isAnimated = !!this._isAnimated;
}

extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

/* global PropertyFactory, extendPrototype, DynamicPropertyContainer */

function SVGFillStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
  this.style = styleOb;
}

extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

/* global PropertyFactory, degToRads, GradientProperty, createElementID, createNS, locationHref,
extendPrototype, DynamicPropertyContainer, lineCapEnum, lineJoinEnum */

function SVGGradientFillStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.initGradientData(elem, data, styleOb);
}

SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
  this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
  this.h = PropertyFactory.getProp(elem, data.h || { k: 0 }, 0, 0.01, this);
  this.a = PropertyFactory.getProp(elem, data.a || { k: 0 }, 0, degToRads, this);
  this.g = new GradientProperty(elem, data.g, this);
  this.style = styleOb;
  this.stops = [];
  this.setGradientData(styleOb.pElem, data);
  this.setGradientOpacity(data, styleOb);
  this._isAnimated = !!this._isAnimated;
};

SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
  var gradientId = createElementID();
  var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
  gfill.setAttribute('id', gradientId);
  gfill.setAttribute('spreadMethod', 'pad');
  gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
  var stops = [];
  var stop;
  var j;
  var jLen;
  jLen = data.g.p * 4;
  for (j = 0; j < jLen; j += 4) {
    stop = createNS('stop');
    gfill.appendChild(stop);
    stops.push(stop);
  }
  pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + locationHref + '#' + gradientId + ')');
  this.gf = gfill;
  this.cst = stops;
};

SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
  if (this.g._hasOpacity && !this.g._collapsable) {
    var stop;
    var j;
    var jLen;
    var mask = createNS('mask');
    var maskElement = createNS('path');
    mask.appendChild(maskElement);
    var opacityId = createElementID();
    var maskId = createElementID();
    mask.setAttribute('id', maskId);
    var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
    opFill.setAttribute('id', opacityId);
    opFill.setAttribute('spreadMethod', 'pad');
    opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
    jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
    var stops = this.stops;
    for (j = data.g.p * 4; j < jLen; j += 2) {
      stop = createNS('stop');
      stop.setAttribute('stop-color', 'rgb(255,255,255)');
      opFill.appendChild(stop);
      stops.push(stop);
    }
    maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + locationHref + '#' + opacityId + ')');
    if (data.ty === 'gs') {
      maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
      maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
      if (data.lj === 1) {
        maskElement.setAttribute('stroke-miterlimit', data.ml);
      }
    }
    this.of = opFill;
    this.ms = mask;
    this.ost = stops;
    this.maskId = maskId;
    styleOb.msElem = maskElement;
  }
};

extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

/* global PropertyFactory, DashProperty, extendPrototype, SVGGradientFillStyleData, DynamicPropertyContainer */

function SVGGradientStrokeStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
  this.d = new DashProperty(elem, data.d || {}, 'svg', this);
  this.initGradientData(elem, data, styleOb);
  this._isAnimated = !!this._isAnimated;
}

extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

/* global createNS */
/* exported ShapeGroupData */

function ShapeGroupData() {
  this.it = [];
  this.prevViewData = [];
  this.gr = createNS('g');
}

/* global Matrix, buildShapeString, bmFloor */
/* exported SVGElementsRenderer */

var SVGElementsRenderer = (function () {
  var _identityMatrix = new Matrix();
  var _matrixHelper = new Matrix();

  var ob = {
    createRenderFunction: createRenderFunction,
  };

  function createRenderFunction(data) {
    switch (data.ty) {
      case 'fl':
        return renderFill;
      case 'gf':
        return renderGradient;
      case 'gs':
        return renderGradientStroke;
      case 'st':
        return renderStroke;
      case 'sh':
      case 'el':
      case 'rc':
      case 'sr':
        return renderPath;
      case 'tr':
        return renderContentTransform;
      default:
        return null;
    }
  }

  function renderContentTransform(styleData, itemData, isFirstFrame) {
    if (isFirstFrame || itemData.transform.op._mdf) {
      itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
    }
    if (isFirstFrame || itemData.transform.mProps._mdf) {
      itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
    }
  }

  function renderPath(styleData, itemData, isFirstFrame) {
    var j;
    var jLen;
    var pathStringTransformed;
    var redraw;
    var pathNodes;
    var l;
    var lLen = itemData.styles.length;
    var lvl = itemData.lvl;
    var paths;
    var mat;
    var props;
    var iterations;
    var k;
    for (l = 0; l < lLen; l += 1) {
      redraw = itemData.sh._mdf || isFirstFrame;
      if (itemData.styles[l].lvl < lvl) {
        mat = _matrixHelper.reset();
        iterations = lvl - itemData.styles[l].lvl;
        k = itemData.transformers.length - 1;
        while (!redraw && iterations > 0) {
          redraw = itemData.transformers[k].mProps._mdf || redraw;
          iterations -= 1;
          k -= 1;
        }
        if (redraw) {
          iterations = lvl - itemData.styles[l].lvl;
          k = itemData.transformers.length - 1;
          while (iterations > 0) {
            props = itemData.transformers[k].mProps.v.props;
            mat.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
            iterations -= 1;
            k -= 1;
          }
        }
      } else {
        mat = _identityMatrix;
      }
      paths = itemData.sh.paths;
      jLen = paths._length;
      if (redraw) {
        pathStringTransformed = '';
        for (j = 0; j < jLen; j += 1) {
          pathNodes = paths.shapes[j];
          if (pathNodes && pathNodes._length) {
            pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
          }
        }
        itemData.caches[l] = pathStringTransformed;
      } else {
        pathStringTransformed = itemData.caches[l];
      }
      itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
      itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
    }
  }

  function renderFill(styleData, itemData, isFirstFrame) {
    var styleElem = itemData.style;

    if (itemData.c._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
    }
    if (itemData.o._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
    }
  }

  function renderGradientStroke(styleData, itemData, isFirstFrame) {
    renderGradient(styleData, itemData, isFirstFrame);
    renderStroke(styleData, itemData, isFirstFrame);
  }

  function renderGradient(styleData, itemData, isFirstFrame) {
    var gfill = itemData.gf;
    var hasOpacity = itemData.g._hasOpacity;
    var pt1 = itemData.s.v;
    var pt2 = itemData.e.v;

    if (itemData.o._mdf || isFirstFrame) {
      var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
      itemData.style.pElem.setAttribute(attr, itemData.o.v);
    }
    if (itemData.s._mdf || isFirstFrame) {
      var attr1 = styleData.t === 1 ? 'x1' : 'cx';
      var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
      gfill.setAttribute(attr1, pt1[0]);
      gfill.setAttribute(attr2, pt1[1]);
      if (hasOpacity && !itemData.g._collapsable) {
        itemData.of.setAttribute(attr1, pt1[0]);
        itemData.of.setAttribute(attr2, pt1[1]);
      }
    }
    var stops;
    var i;
    var len;
    var stop;
    if (itemData.g._cmdf || isFirstFrame) {
      stops = itemData.cst;
      var cValues = itemData.g.c;
      len = stops.length;
      for (i = 0; i < len; i += 1) {
        stop = stops[i];
        stop.setAttribute('offset', cValues[i * 4] + '%');
        stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
      }
    }
    if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
      var oValues = itemData.g.o;
      if (itemData.g._collapsable) {
        stops = itemData.cst;
      } else {
        stops = itemData.ost;
      }
      len = stops.length;
      for (i = 0; i < len; i += 1) {
        stop = stops[i];
        if (!itemData.g._collapsable) {
          stop.setAttribute('offset', oValues[i * 2] + '%');
        }
        stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
      }
    }
    if (styleData.t === 1) {
      if (itemData.e._mdf || isFirstFrame) {
        gfill.setAttribute('x2', pt2[0]);
        gfill.setAttribute('y2', pt2[1]);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('x2', pt2[0]);
          itemData.of.setAttribute('y2', pt2[1]);
        }
      }
    } else {
      var rad;
      if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
        rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        gfill.setAttribute('r', rad);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('r', rad);
        }
      }
      if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
        if (!rad) {
          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        }
        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

        var percent = itemData.h.v;
        if (percent >= 1) {
          percent = 0.99;
        } else if (percent <= -1) {
          percent = -0.99;
        }
        var dist = rad * percent;
        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
        gfill.setAttribute('fx', x);
        gfill.setAttribute('fy', y);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('fx', x);
          itemData.of.setAttribute('fy', y);
        }
      }
      // gfill.setAttribute('fy','200');
    }
  }

  function renderStroke(styleData, itemData, isFirstFrame) {
    var styleElem = itemData.style;
    var d = itemData.d;
    if (d && (d._mdf || isFirstFrame) && d.dashStr) {
      styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
      styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
    }
    if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
      styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
    }
    if (itemData.o._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
    }
    if (itemData.w._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
      if (styleElem.msElem) {
        styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
      }
    }
  }

  return ob;
}());

/* global Matrix */

function ShapeTransformManager() {
  this.sequences = {};
  this.sequenceList = [];
  this.transform_key_count = 0;
}

ShapeTransformManager.prototype = {
  addTransformSequence: function (transforms) {
    var i;
    var len = transforms.length;
    var key = '_';
    for (i = 0; i < len; i += 1) {
      key += transforms[i].transform.key + '_';
    }
    var sequence = this.sequences[key];
    if (!sequence) {
      sequence = {
        transforms: [].concat(transforms),
        finalTransform: new Matrix(),
        _mdf: false,
      };
      this.sequences[key] = sequence;
      this.sequenceList.push(sequence);
    }
    return sequence;
  },
  processSequence: function (sequence, isFirstFrame) {
    var i = 0;
    var len = sequence.transforms.length;
    var _mdf = isFirstFrame;
    while (i < len && !isFirstFrame) {
      if (sequence.transforms[i].transform.mProps._mdf) {
        _mdf = true;
        break;
      }
      i += 1;
    }
    if (_mdf) {
      var props;
      sequence.finalTransform.reset();
      for (i = len - 1; i >= 0; i -= 1) {
        props = sequence.transforms[i].transform.mProps.v.props;
        sequence.finalTransform.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
      }
    }
    sequence._mdf = _mdf;
  },
  processSequences: function (isFirstFrame) {
    var i;
    var len = this.sequenceList.length;
    for (i = 0; i < len; i += 1) {
      this.processSequence(this.sequenceList[i], isFirstFrame);
    }
  },
  getNewKey: function () {
    this.transform_key_count += 1;
    return '_' + this.transform_key_count;
  },
};

/* global ShapePropertyFactory, SVGShapeData */

function CVShapeData(element, data, styles, transformsManager) {
  this.styledShapes = [];
  this.tr = [0, 0, 0, 0, 0, 0];
  var ty = 4;
  if (data.ty === 'rc') {
    ty = 5;
  } else if (data.ty === 'el') {
    ty = 6;
  } else if (data.ty === 'sr') {
    ty = 7;
  }
  this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
  var i;
  var len = styles.length;
  var styledShape;
  for (i = 0; i < len; i += 1) {
    if (!styles[i].closed) {
      styledShape = {
        transforms: transformsManager.addTransformSequence(styles[i].transforms),
        trNodes: [],
      };
      this.styledShapes.push(styledShape);
      styles[i].elements.push(styledShape);
    }
  }
}

CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;

/* global LayerExpressionInterface, EffectsExpressionInterface, CompExpressionInterface, ShapeExpressionInterface,
TextExpressionInterface, getBlendMode,createElementID, EffectsManager */

function BaseElement() {
}

BaseElement.prototype = {
  checkMasks: function () {
    if (!this.data.hasMask) {
      return false;
    }
    var i = 0;
    var len = this.data.masksProperties.length;
    while (i < len) {
      if ((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
        return true;
      }
      i += 1;
    }
    return false;
  },
  initExpressions: function () {
    this.layerInterface = LayerExpressionInterface(this);
    if (this.data.hasMask && this.maskManager) {
      this.layerInterface.registerMaskInterface(this.maskManager);
    }
    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
    this.layerInterface.registerEffectsInterface(effectsInterface);

    if (this.data.ty === 0 || this.data.xt) {
      this.compInterface = CompExpressionInterface(this);
    } else if (this.data.ty === 4) {
      this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
      this.layerInterface.content = this.layerInterface.shapeInterface;
    } else if (this.data.ty === 5) {
      this.layerInterface.textInterface = TextExpressionInterface(this);
      this.layerInterface.text = this.layerInterface.textInterface;
    }
  },
  setBlendMode: function () {
    var blendModeValue = getBlendMode(this.data.bm);
    var elem = this.baseElement || this.layerElement;

    elem.style['mix-blend-mode'] = blendModeValue;
  },
  initBaseData: function (data, globalData, comp) {
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.layerId = createElementID();

    // Stretch factor for old animations missing this property.
    if (!this.data.sr) {
      this.data.sr = 1;
    }
    // effects manager
    this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
  },
  getType: function () {
    return this.type;
  },
  sourceRectAtTime: function () {},
};

/* global extendPrototype, BaseElement, TransformElement, HierarchyElement, FrameElement */

function NullElement(data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initFrame();
  this.initTransform(data, globalData, comp);
  this.initHierarchy();
}

NullElement.prototype.prepareFrame = function (num) {
  this.prepareProperties(num, true);
};

NullElement.prototype.renderFrame = function () {
};

NullElement.prototype.getBaseElement = function () {
  return null;
};

NullElement.prototype.destroy = function () {
};

NullElement.prototype.sourceRectAtTime = function () {
};

NullElement.prototype.hide = function () {
};

extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

/* global filtersFactory, featureSupport, filtersFactory, createElementID, createNS, MaskElement, SVGEffects, locationHref */

function SVGBaseElement() {
}

SVGBaseElement.prototype = {
  initRendererElement: function () {
    this.layerElement = createNS('g');
  },
  createContainerElements: function () {
    this.matteElement = createNS('g');
    this.transformedElement = this.layerElement;
    this.maskedElement = this.layerElement;
    this._sizeChanged = false;
    var layerElementParent = null;
    // If this layer acts as a mask for the following layer
    var filId;
    var fil;
    var gg;
    if (this.data.td) {
      if (this.data.td == 3 || this.data.td == 1) { // eslint-disable-line eqeqeq
        var masker = createNS('mask');
        masker.setAttribute('id', this.layerId);
        masker.setAttribute('mask-type', this.data.td == 3 ? 'luminance' : 'alpha'); // eslint-disable-line eqeqeq
        masker.appendChild(this.layerElement);
        layerElementParent = masker;
        this.globalData.defs.appendChild(masker);
        // This is only for IE and Edge when mask if of type alpha
        if (!featureSupport.maskType && this.data.td == 1) { // eslint-disable-line eqeqeq
          masker.setAttribute('mask-type', 'luminance');
          filId = createElementID();
          fil = filtersFactory.createFilter(filId);
          this.globalData.defs.appendChild(fil);
          fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
          gg = createNS('g');
          gg.appendChild(this.layerElement);
          layerElementParent = gg;
          masker.appendChild(gg);
          gg.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
        }
      } else if (this.data.td == 2) { // eslint-disable-line eqeqeq
        var maskGroup = createNS('mask');
        maskGroup.setAttribute('id', this.layerId);
        maskGroup.setAttribute('mask-type', 'alpha');
        var maskGrouper = createNS('g');
        maskGroup.appendChild(maskGrouper);
        filId = createElementID();
        fil = filtersFactory.createFilter(filId);
        /// /

        // This solution doesn't work on Android when meta tag with viewport attribute is set
        /* var feColorMatrix = createNS('feColorMatrix');
                feColorMatrix.setAttribute('type', 'matrix');
                feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
                feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
                fil.appendChild(feColorMatrix); */
        /// /
        var feCTr = createNS('feComponentTransfer');
        feCTr.setAttribute('in', 'SourceGraphic');
        fil.appendChild(feCTr);
        var feFunc = createNS('feFuncA');
        feFunc.setAttribute('type', 'table');
        feFunc.setAttribute('tableValues', '1.0 0.0');
        feCTr.appendChild(feFunc);
        /// /
        this.globalData.defs.appendChild(fil);
        var alphaRect = createNS('rect');
        alphaRect.setAttribute('width', this.comp.data.w);
        alphaRect.setAttribute('height', this.comp.data.h);
        alphaRect.setAttribute('x', '0');
        alphaRect.setAttribute('y', '0');
        alphaRect.setAttribute('fill', '#ffffff');
        alphaRect.setAttribute('opacity', '0');
        maskGrouper.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
        maskGrouper.appendChild(alphaRect);
        maskGrouper.appendChild(this.layerElement);
        layerElementParent = maskGrouper;
        if (!featureSupport.maskType) {
          maskGroup.setAttribute('mask-type', 'luminance');
          fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
          gg = createNS('g');
          maskGrouper.appendChild(alphaRect);
          gg.appendChild(this.layerElement);
          layerElementParent = gg;
          maskGrouper.appendChild(gg);
        }
        this.globalData.defs.appendChild(maskGroup);
      }
    } else if (this.data.tt) {
      this.matteElement.appendChild(this.layerElement);
      layerElementParent = this.matteElement;
      this.baseElement = this.matteElement;
    } else {
      this.baseElement = this.layerElement;
    }
    if (this.data.ln) {
      this.layerElement.setAttribute('id', this.data.ln);
    }
    if (this.data.cl) {
      this.layerElement.setAttribute('class', this.data.cl);
    }
    // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
    if (this.data.ty === 0 && !this.data.hd) {
      var cp = createNS('clipPath');
      var pt = createNS('path');
      pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
      var clipId = createElementID();
      cp.setAttribute('id', clipId);
      cp.appendChild(pt);
      this.globalData.defs.appendChild(cp);

      if (this.checkMasks()) {
        var cpGroup = createNS('g');
        cpGroup.setAttribute('clip-path', 'url(' + locationHref + '#' + clipId + ')');
        cpGroup.appendChild(this.layerElement);
        this.transformedElement = cpGroup;
        if (layerElementParent) {
          layerElementParent.appendChild(this.transformedElement);
        } else {
          this.baseElement = this.transformedElement;
        }
      } else {
        this.layerElement.setAttribute('clip-path', 'url(' + locationHref + '#' + clipId + ')');
      }
    }
    if (this.data.bm !== 0) {
      this.setBlendMode();
    }
  },
  renderElement: function () {
    if (this.finalTransform._matMdf) {
      this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
    }
    if (this.finalTransform._opMdf) {
      this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
    }
  },
  destroyBaseElement: function () {
    this.layerElement = null;
    this.matteElement = null;
    this.maskManager.destroy();
  },
  getBaseElement: function () {
    if (this.data.hd) {
      return null;
    }
    return this.baseElement;
  },
  createRenderableComponents: function () {
    this.maskManager = new MaskElement(this.data, this, this.globalData);
    this.renderableEffectsManager = new SVGEffects(this);
  },
  setMatte: function (id) {
    if (!this.matteElement) {
      return;
    }
    this.matteElement.setAttribute('mask', 'url(' + locationHref + '#' + id + ')');
  },
};

/* global ProcessedElement */

function IShapeElement() {
}

IShapeElement.prototype = {
  addShapeToModifiers: function (data) {
    var i;
    var len = this.shapeModifiers.length;
    for (i = 0; i < len; i += 1) {
      this.shapeModifiers[i].addShape(data);
    }
  },
  isShapeInAnimatedModifiers: function (data) {
    var i = 0;
    var len = this.shapeModifiers.length;
    while (i < len) {
      if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
        return true;
      }
    }
    return false;
  },
  renderModifiers: function () {
    if (!this.shapeModifiers.length) {
      return;
    }
    var i;
    var len = this.shapes.length;
    for (i = 0; i < len; i += 1) {
      this.shapes[i].sh.reset();
    }

    len = this.shapeModifiers.length;
    var shouldBreakProcess;
    for (i = len - 1; i >= 0; i -= 1) {
      shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame);
      // workaround to fix cases where a repeater resets the shape so the following processes get called twice
      // TODO: find a better solution for this
      if (shouldBreakProcess) {
        break;
      }
    }
  },

  searchProcessedElement: function (elem) {
    var elements = this.processedElements;
    var i = 0;
    var len = elements.length;
    while (i < len) {
      if (elements[i].elem === elem) {
        return elements[i].pos;
      }
      i += 1;
    }
    return 0;
  },
  addProcessedElement: function (elem, pos) {
    var elements = this.processedElements;
    var i = elements.length;
    while (i) {
      i -= 1;
      if (elements[i].elem === elem) {
        elements[i].pos = pos;
        return;
      }
    }
    elements.push(new ProcessedElement(elem, pos));
  },
  prepareFrame: function (num) {
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
  },
};

/* global TextProperty, TextAnimatorProperty, buildShapeString, LetterProps */

function ITextElement() {
}

ITextElement.prototype.initElement = function (data, globalData, comp) {
  this.lettersChangedFlag = true;
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
  this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
  this.initTransform(data, globalData, comp);
  this.initHierarchy();
  this.initRenderable();
  this.initRendererElement();
  this.createContainerElements();
  this.createRenderableComponents();
  this.createContent();
  this.hide();
  this.textAnimator.searchProperties(this.dynamicProperties);
};

ITextElement.prototype.prepareFrame = function (num) {
  this._mdf = false;
  this.prepareRenderableFrame(num);
  this.prepareProperties(num, this.isInRange);
  if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
    this.buildNewText();
    this.textProperty._isFirstFrame = false;
    this.textProperty._mdf = false;
  }
};

ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
  var j;
  var jLen = shapes.length;
  var pathNodes;
  var shapeStr = '';
  for (j = 0; j < jLen; j += 1) {
    pathNodes = shapes[j].ks.k;
    shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
  }
  return shapeStr;
};

ITextElement.prototype.updateDocumentData = function (newData, index) {
  this.textProperty.updateDocumentData(newData, index);
};

ITextElement.prototype.canResizeFont = function (_canResize) {
  this.textProperty.canResizeFont(_canResize);
};

ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
  this.textProperty.setMinimumFontSize(_fontSize);
};

ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
  if (documentData.ps) {
    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
  }
  matrixHelper.translate(0, -documentData.ls, 0);
  switch (documentData.j) {
    case 1:
      matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
      break;
    case 2:
      matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
      break;
    default:
      break;
  }
  matrixHelper.translate(xPos, yPos, 0);
};

ITextElement.prototype.buildColor = function (colorData) {
  return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
};

ITextElement.prototype.emptyProp = new LetterProps();

ITextElement.prototype.destroy = function () {

};

/* global extendPrototype, BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement */

function ICompElement() {}

extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

ICompElement.prototype.initElement = function (data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initTransform(data, globalData, comp);
  this.initRenderable();
  this.initHierarchy();
  this.initRendererElement();
  this.createContainerElements();
  this.createRenderableComponents();
  if (this.data.xt || !globalData.progressiveLoad) {
    this.buildAllItems();
  }
  this.hide();
};

/* ICompElement.prototype.hide = function(){
    if(!this.hidden){
        this.hideElement();
        var i,len = this.elements.length;
        for( i = 0; i < len; i+=1 ){
            if(this.elements[i]){
                this.elements[i].hide();
            }
        }
    }
}; */

ICompElement.prototype.prepareFrame = function (num) {
  this._mdf = false;
  this.prepareRenderableFrame(num);
  this.prepareProperties(num, this.isInRange);
  if (!this.isInRange && !this.data.xt) {
    return;
  }

  if (!this.tm._placeholder) {
    var timeRemapped = this.tm.v;
    if (timeRemapped === this.data.op) {
      timeRemapped = this.data.op - 1;
    }
    this.renderedFrame = timeRemapped;
  } else {
    this.renderedFrame = num / this.data.sr;
  }
  var i;
  var len = this.elements.length;
  if (!this.completeLayers) {
    this.checkLayers(this.renderedFrame);
  }
  // This iteration needs to be backwards because of how expressions connect between each other
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
      if (this.elements[i]._mdf) {
        this._mdf = true;
      }
    }
  }
};

ICompElement.prototype.renderInnerContent = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].renderFrame();
    }
  }
};

ICompElement.prototype.setElements = function (elems) {
  this.elements = elems;
};

ICompElement.prototype.getElements = function () {
  return this.elements;
};

ICompElement.prototype.destroyElements = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
};

ICompElement.prototype.destroy = function () {
  this.destroyElements();
  this.destroyBaseElement();
};

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, createNS */

function IImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.initElement(data, globalData, comp);
  this.sourceRect = {
    top: 0, left: 0, width: this.assetData.w, height: this.assetData.h,
  };
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);

IImageElement.prototype.createContent = function () {
  var assetPath = this.globalData.getAssetsPath(this.assetData);

  this.innerElem = createNS('image');
  this.innerElem.setAttribute('width', this.assetData.w + 'px');
  this.innerElem.setAttribute('height', this.assetData.h + 'px');
  this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
  this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);

  this.layerElement.appendChild(this.innerElem);
};

IImageElement.prototype.sourceRectAtTime = function () {
  return this.sourceRect;
};

/* global extendPrototype, IImageElement, createNS */

function ISolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([IImageElement], ISolidElement);

ISolidElement.prototype.createContent = function () {
  var rect = createNS('rect');
  /// /rect.style.width = this.data.sw;
  /// /rect.style.height = this.data.sh;
  /// /rect.style.fill = this.data.sc;
  rect.setAttribute('width', this.data.sw);
  rect.setAttribute('height', this.data.sh);
  rect.setAttribute('fill', this.data.sc);
  this.layerElement.appendChild(rect);
};

/* global PropertyFactory, extendPrototype, RenderableElement, BaseElement, FrameElement */

function AudioElement(data, globalData, comp) {
  this.initFrame();
  this.initRenderable();
  this.assetData = globalData.getAssetData(data.refId);
  this.initBaseData(data, globalData, comp);
  this._isPlaying = false;
  this._canPlay = false;
  var assetPath = this.globalData.getAssetsPath(this.assetData);
  this.audio = this.globalData.audioController.createAudio(assetPath);
  this._currentTime = 0;
  this.globalData.audioController.addAudio(this);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

AudioElement.prototype.prepareFrame = function (num) {
  this.prepareRenderableFrame(num, true);
  this.prepareProperties(num, true);
  if (!this.tm._placeholder) {
    var timeRemapped = this.tm.v;
    this._currentTime = timeRemapped;
  } else {
    this._currentTime = num / this.data.sr;
  }
};

extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);

AudioElement.prototype.renderFrame = function () {
  if (this.isInRange && this._canPlay) {
    if (!this._isPlaying) {
      this.audio.play();
      this.audio.seek(this._currentTime / this.globalData.frameRate);
      this._isPlaying = true;
    } else if (!this.audio.playing()
      || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1
    ) {
      this.audio.seek(this._currentTime / this.globalData.frameRate);
    }
  }
};

AudioElement.prototype.show = function () {
  // this.audio.play()
};

AudioElement.prototype.hide = function () {
  this.audio.pause();
  this._isPlaying = false;
};

AudioElement.prototype.pause = function () {
  this.audio.pause();
  this._isPlaying = false;
  this._canPlay = false;
};

AudioElement.prototype.resume = function () {
  this._canPlay = true;
};

AudioElement.prototype.setRate = function (rateValue) {
  this.audio.rate(rateValue);
};

AudioElement.prototype.volume = function (volumeValue) {
  this.audio.volume(volumeValue);
};

AudioElement.prototype.getBaseElement = function () {
  return null;
};

AudioElement.prototype.destroy = function () {
};

AudioElement.prototype.sourceRectAtTime = function () {
};

AudioElement.prototype.initExpressions = function () {
};

/* global extendPrototype, RenderableElement, BaseElement, FrameElement, FootageInterface */

function FootageElement(data, globalData, comp) {
  this.initFrame();
  this.initRenderable();
  this.assetData = globalData.getAssetData(data.refId);
  this.footageData = globalData.imageLoader.getAsset(this.assetData);
  this.initBaseData(data, globalData, comp);
}

FootageElement.prototype.prepareFrame = function () {
};

extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);

FootageElement.prototype.getBaseElement = function () {
  return null;
};

FootageElement.prototype.renderFrame = function () {
};

FootageElement.prototype.destroy = function () {
};

FootageElement.prototype.initExpressions = function () {
  this.layerInterface = FootageInterface(this);
};

FootageElement.prototype.getFootageData = function () {
  return this.footageData;
};

/* global createSizedArray, PropertyFactory, extendPrototype, SVGRenderer, ICompElement, SVGBaseElement */

function SVGCompElement(data, globalData, comp) {
  this.layers = data.layers;
  this.supports3d = true;
  this.completeLayers = false;
  this.pendingElements = [];
  this.elements = this.layers ? createSizedArray(this.layers.length) : [];
  // this.layerElement = createNS('g');
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([SVGRenderer, ICompElement, SVGBaseElement], SVGCompElement);

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, ITextElement, createSizedArray, createNS */

function SVGTextLottieElement(data, globalData, comp) {
  this.textSpans = [];
  this.renderType = 'svg';
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);

SVGTextLottieElement.prototype.createContent = function () {
  if (this.data.singleShape && !this.globalData.fontManager.chars) {
    this.textContainer = createNS('text');
  }
};

SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
  var i = 0;
  var len = textArray.length;
  var textContents = [];
  var currentTextContent = '';
  while (i < len) {
    if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
      textContents.push(currentTextContent);
      currentTextContent = '';
    } else {
      currentTextContent += textArray[i];
    }
    i += 1;
  }
  textContents.push(currentTextContent);
  return textContents;
};

SVGTextLottieElement.prototype.buildNewText = function () {
  var i;
  var len;

  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
  if (documentData.fc) {
    this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
  } else {
    this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
  }
  if (documentData.sc) {
    this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
    this.layerElement.setAttribute('stroke-width', documentData.sw);
  }
  this.layerElement.setAttribute('font-size', documentData.finalSize);
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  if (fontData.fClass) {
    this.layerElement.setAttribute('class', fontData.fClass);
  } else {
    this.layerElement.setAttribute('font-family', fontData.fFamily);
    var fWeight = documentData.fWeight;
    var fStyle = documentData.fStyle;
    this.layerElement.setAttribute('font-style', fStyle);
    this.layerElement.setAttribute('font-weight', fWeight);
  }
  this.layerElement.setAttribute('aria-label', documentData.t);

  var letters = documentData.l || [];
  var usesGlyphs = !!this.globalData.fontManager.chars;
  len = letters.length;

  var tSpan;
  var matrixHelper = this.mHelper;
  var shapes;
  var shapeStr = '';
  var singleShape = this.data.singleShape;
  var xPos = 0;
  var yPos = 0;
  var firstLine = true;
  var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
  if (singleShape && !usesGlyphs && !documentData.sz) {
    var tElement = this.textContainer;
    var justify = 'start';
    switch (documentData.j) {
      case 1:
        justify = 'end';
        break;
      case 2:
        justify = 'middle';
        break;
      default:
        justify = 'start';
        break;
    }
    tElement.setAttribute('text-anchor', justify);
    tElement.setAttribute('letter-spacing', trackingOffset);
    var textContent = this.buildTextContents(documentData.finalText);
    len = textContent.length;
    yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
    for (i = 0; i < len; i += 1) {
      tSpan = this.textSpans[i] || createNS('tspan');
      tSpan.textContent = textContent[i];
      tSpan.setAttribute('x', 0);
      tSpan.setAttribute('y', yPos);
      tSpan.style.display = 'inherit';
      tElement.appendChild(tSpan);
      this.textSpans[i] = tSpan;
      yPos += documentData.finalLineHeight;
    }

    this.layerElement.appendChild(tElement);
  } else {
    var cachedSpansLength = this.textSpans.length;
    var shapeData;
    var charData;
    for (i = 0; i < len; i += 1) {
      if (!usesGlyphs || !singleShape || i === 0) {
        tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs ? 'path' : 'text');
        if (cachedSpansLength <= i) {
          tSpan.setAttribute('stroke-linecap', 'butt');
          tSpan.setAttribute('stroke-linejoin', 'round');
          tSpan.setAttribute('stroke-miterlimit', '4');
          this.textSpans[i] = tSpan;
          this.layerElement.appendChild(tSpan);
        }
        tSpan.style.display = 'inherit';
      }

      matrixHelper.reset();
      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
      if (singleShape) {
        if (letters[i].n) {
          xPos = -trackingOffset;
          yPos += documentData.yOffset;
          yPos += firstLine ? 1 : 0;
          firstLine = false;
        }
        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
        xPos += letters[i].l || 0;
        // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
        xPos += trackingOffset;
      }
      if (usesGlyphs) {
        charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        shapeData = (charData && charData.data) || {};
        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
        if (!singleShape) {
          tSpan.setAttribute('d', this.createPathShape(matrixHelper, shapes));
        } else {
          shapeStr += this.createPathShape(matrixHelper, shapes);
        }
      } else {
        if (singleShape) {
          tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
        }
        tSpan.textContent = letters[i].val;
        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
      }
      //
    }
    if (singleShape && tSpan) {
      tSpan.setAttribute('d', shapeStr);
    }
  }
  while (i < this.textSpans.length) {
    this.textSpans[i].style.display = 'none';
    i += 1;
  }

  this._sizeChanged = true;
};

SVGTextLottieElement.prototype.sourceRectAtTime = function () {
  this.prepareFrame(this.comp.renderedFrame - this.data.st);
  this.renderInnerContent();
  if (this._sizeChanged) {
    this._sizeChanged = false;
    var textBox = this.layerElement.getBBox();
    this.bbox = {
      top: textBox.y,
      left: textBox.x,
      width: textBox.width,
      height: textBox.height,
    };
  }
  return this.bbox;
};

SVGTextLottieElement.prototype.renderInnerContent = function () {
  if (!this.data.singleShape) {
    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
      this._sizeChanged = true;
      var i;
      var len;
      var renderedLetters = this.textAnimator.renderedLetters;

      var letters = this.textProperty.currentData.l;

      len = letters.length;
      var renderedLetter;
      var textSpan;
      for (i = 0; i < len; i += 1) {
        if (!letters[i].n) {
          renderedLetter = renderedLetters[i];
          textSpan = this.textSpans[i];
          if (renderedLetter._mdf.m) {
            textSpan.setAttribute('transform', renderedLetter.m);
          }
          if (renderedLetter._mdf.o) {
            textSpan.setAttribute('opacity', renderedLetter.o);
          }
          if (renderedLetter._mdf.sw) {
            textSpan.setAttribute('stroke-width', renderedLetter.sw);
          }
          if (renderedLetter._mdf.sc) {
            textSpan.setAttribute('stroke', renderedLetter.sc);
          }
          if (renderedLetter._mdf.fc) {
            textSpan.setAttribute('fill', renderedLetter.fc);
          }
        }
      }
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement,
FrameElement, RenderableDOMElement, Matrix, SVGStyleData, SVGStrokeStyleData, SVGFillStyleData,
SVGGradientFillStyleData, SVGGradientStrokeStyleData, locationHref, getBlendMode, ShapeGroupData,
TransformPropertyFactory, SVGTransformData, ShapePropertyFactory, SVGShapeData, SVGElementsRenderer, ShapeModifiers,
lineCapEnum, lineJoinEnum */

function SVGShapeElement(data, globalData, comp) {
  // List of drawable elements
  this.shapes = [];
  // Full shape data
  this.shapesData = data.shapes;
  // List of styles that will be applied to shapes
  this.stylesList = [];
  // List of modifiers that will be applied to shapes
  this.shapeModifiers = [];
  // List of items in shape tree
  this.itemsData = [];
  // List of items in previous shape tree
  this.processedElements = [];
  // List of animated components
  this.animatedContents = [];
  this.initElement(data, globalData, comp);
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  // List of elements that have been created
  this.prevViewData = [];
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);

SVGShapeElement.prototype.initSecondaryElement = function () {
};

SVGShapeElement.prototype.identityMatrix = new Matrix();

SVGShapeElement.prototype.buildExpressionInterface = function () {};

SVGShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
  this.filterUniqueShapes();
};

/*
This method searches for multiple shapes that affect a single element and one of them is animated
*/
SVGShapeElement.prototype.filterUniqueShapes = function () {
  var i;
  var len = this.shapes.length;
  var shape;
  var j;
  var jLen = this.stylesList.length;
  var style;
  var tempShapes = [];
  var areAnimated = false;
  for (j = 0; j < jLen; j += 1) {
    style = this.stylesList[j];
    areAnimated = false;
    tempShapes.length = 0;
    for (i = 0; i < len; i += 1) {
      shape = this.shapes[i];
      if (shape.styles.indexOf(style) !== -1) {
        tempShapes.push(shape);
        areAnimated = shape._isAnimated || areAnimated;
      }
    }
    if (tempShapes.length > 1 && areAnimated) {
      this.setShapesAsAnimated(tempShapes);
    }
  }
};

SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
  var i;
  var len = shapes.length;
  for (i = 0; i < len; i += 1) {
    shapes[i].setAsAnimated();
  }
};

SVGShapeElement.prototype.createStyleElement = function (data, level) {
  // TODO: prevent drawing of hidden styles
  var elementData;
  var styleOb = new SVGStyleData(data, level);

  var pathElement = styleOb.pElem;
  if (data.ty === 'st') {
    elementData = new SVGStrokeStyleData(this, data, styleOb);
  } else if (data.ty === 'fl') {
    elementData = new SVGFillStyleData(this, data, styleOb);
  } else if (data.ty === 'gf' || data.ty === 'gs') {
    var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
    elementData = new GradientConstructor(this, data, styleOb);
    this.globalData.defs.appendChild(elementData.gf);
    if (elementData.maskId) {
      this.globalData.defs.appendChild(elementData.ms);
      this.globalData.defs.appendChild(elementData.of);
      pathElement.setAttribute('mask', 'url(' + locationHref + '#' + elementData.maskId + ')');
    }
  }

  if (data.ty === 'st' || data.ty === 'gs') {
    pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
    pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
    pathElement.setAttribute('fill-opacity', '0');
    if (data.lj === 1) {
      pathElement.setAttribute('stroke-miterlimit', data.ml);
    }
  }

  if (data.r === 2) {
    pathElement.setAttribute('fill-rule', 'evenodd');
  }

  if (data.ln) {
    pathElement.setAttribute('id', data.ln);
  }
  if (data.cl) {
    pathElement.setAttribute('class', data.cl);
  }
  if (data.bm) {
    pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
  }
  this.stylesList.push(styleOb);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.createGroupElement = function (data) {
  var elementData = new ShapeGroupData();
  if (data.ln) {
    elementData.gr.setAttribute('id', data.ln);
  }
  if (data.cl) {
    elementData.gr.setAttribute('class', data.cl);
  }
  if (data.bm) {
    elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
  }
  return elementData;
};

SVGShapeElement.prototype.createTransformElement = function (data, container) {
  var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
  var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
  var ty = 4;
  if (data.ty === 'rc') {
    ty = 5;
  } else if (data.ty === 'el') {
    ty = 6;
  } else if (data.ty === 'sr') {
    ty = 7;
  }
  var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
  var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
  this.shapes.push(elementData);
  this.addShapeToModifiers(elementData);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
  var i = 0;
  var len = this.animatedContents.length;
  while (i < len) {
    if (this.animatedContents[i].element === element) {
      return;
    }
    i += 1;
  }
  this.animatedContents.push({
    fn: SVGElementsRenderer.createRenderFunction(data),
    element: element,
    data: data,
  });
};

SVGShapeElement.prototype.setElementStyles = function (elementData) {
  var arr = elementData.styles;
  var j;
  var jLen = this.stylesList.length;
  for (j = 0; j < jLen; j += 1) {
    if (!this.stylesList[j].closed) {
      arr.push(this.stylesList[j]);
    }
  }
};

SVGShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = true;
  var i;
  var len = this.itemsData.length;
  for (i = 0; i < len; i += 1) {
    this.prevViewData[i] = this.itemsData[i];
  }
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
  this.filterUniqueShapes();
  len = this.dynamicProperties.length;
  for (i = 0; i < len; i += 1) {
    this.dynamicProperties[i].getValue();
  }
  this.renderModifiers();
};

SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
  var ownTransformers = [].concat(transformers);
  var i;
  var len = arr.length - 1;
  var j;
  var jLen;
  var ownStyles = [];
  var ownModifiers = [];
  var currentTransform;
  var modifier;
  var processedPos;
  for (i = len; i >= 0; i -= 1) {
    processedPos = this.searchProcessedElement(arr[i]);
    if (!processedPos) {
      arr[i]._render = render;
    } else {
      itemsData[i] = prevViewData[processedPos - 1];
    }
    if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
      if (!processedPos) {
        itemsData[i] = this.createStyleElement(arr[i], level);
      } else {
        itemsData[i].style.closed = false;
      }
      if (arr[i]._render) {
        if (itemsData[i].style.pElem.parentNode !== container) {
          container.appendChild(itemsData[i].style.pElem);
        }
      }
      ownStyles.push(itemsData[i].style);
    } else if (arr[i].ty === 'gr') {
      if (!processedPos) {
        itemsData[i] = this.createGroupElement(arr[i]);
      } else {
        jLen = itemsData[i].it.length;
        for (j = 0; j < jLen; j += 1) {
          itemsData[i].prevViewData[j] = itemsData[i].it[j];
        }
      }
      this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
      if (arr[i]._render) {
        if (itemsData[i].gr.parentNode !== container) {
          container.appendChild(itemsData[i].gr);
        }
      }
    } else if (arr[i].ty === 'tr') {
      if (!processedPos) {
        itemsData[i] = this.createTransformElement(arr[i], container);
      }
      currentTransform = itemsData[i].transform;
      ownTransformers.push(currentTransform);
    } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
      if (!processedPos) {
        itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
      }
      this.setElementStyles(itemsData[i]);
    } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        modifier.init(this, arr[i]);
        itemsData[i] = modifier;
        this.shapeModifiers.push(modifier);
      } else {
        modifier = itemsData[i];
        modifier.closed = false;
      }
      ownModifiers.push(modifier);
    } else if (arr[i].ty === 'rp') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        itemsData[i] = modifier;
        modifier.init(this, arr, i, itemsData);
        this.shapeModifiers.push(modifier);
        render = false;
      } else {
        modifier = itemsData[i];
        modifier.closed = true;
      }
      ownModifiers.push(modifier);
    }
    this.addProcessedElement(arr[i], i + 1);
  }
  len = ownStyles.length;
  for (i = 0; i < len; i += 1) {
    ownStyles[i].closed = true;
  }
  len = ownModifiers.length;
  for (i = 0; i < len; i += 1) {
    ownModifiers[i].closed = true;
  }
};

SVGShapeElement.prototype.renderInnerContent = function () {
  this.renderModifiers();
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    this.stylesList[i].reset();
  }
  this.renderShape();

  for (i = 0; i < len; i += 1) {
    if (this.stylesList[i]._mdf || this._isFirstFrame) {
      if (this.stylesList[i].msElem) {
        this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
        // Adding M0 0 fixes same mask bug on all browsers
        this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
      }
      this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
    }
  }
};

SVGShapeElement.prototype.renderShape = function () {
  var i;
  var len = this.animatedContents.length;
  var animatedContent;
  for (i = 0; i < len; i += 1) {
    animatedContent = this.animatedContents[i];
    if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
      animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
    }
  }
};

SVGShapeElement.prototype.destroy = function () {
  this.destroyBaseElement();
  this.shapesData = null;
  this.itemsData = null;
};

/* global createNS */

function SVGTintFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
  feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f1');
  filter.appendChild(feColorMatrix);
  feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
  feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f2');
  filter.appendChild(feColorMatrix);
  this.matrixFilter = feColorMatrix;
  if (filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k) {
    var feMerge = createNS('feMerge');
    filter.appendChild(feMerge);
    var feMergeNode;
    feMergeNode = createNS('feMergeNode');
    feMergeNode.setAttribute('in', 'SourceGraphic');
    feMerge.appendChild(feMergeNode);
    feMergeNode = createNS('feMergeNode');
    feMergeNode.setAttribute('in', 'f2');
    feMerge.appendChild(feMergeNode);
  }
}

SVGTintFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var colorBlack = this.filterManager.effectElements[0].p.v;
    var colorWhite = this.filterManager.effectElements[1].p.v;
    var opacity = this.filterManager.effectElements[2].p.v / 100;
    this.matrixFilter.setAttribute('values', (colorWhite[0] - colorBlack[0]) + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGFillFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
  feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
  filter.appendChild(feColorMatrix);
  this.matrixFilter = feColorMatrix;
}
SVGFillFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var color = this.filterManager.effectElements[2].p.v;
    var opacity = this.filterManager.effectElements[6].p.v;
    this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGGaussianBlurEffect(filter, filterManager) {
  // Outset the filter region by 100% on all sides to accommodate blur expansion.
  filter.setAttribute('x', '-100%');
  filter.setAttribute('y', '-100%');
  filter.setAttribute('width', '300%');
  filter.setAttribute('height', '300%');

  this.filterManager = filterManager;
  var feGaussianBlur = createNS('feGaussianBlur');
  filter.appendChild(feGaussianBlur);
  this.feGaussianBlur = feGaussianBlur;
}

SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    // Empirical value, matching AE's blur appearance.
    var kBlurrinessToSigma = 0.3;
    var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma;

    // Dimensions mapping:
    //
    //   1 -> horizontal & vertical
    //   2 -> horizontal only
    //   3 -> vertical only
    //
    var dimensions = this.filterManager.effectElements[1].p.v;
    var sigmaX = (dimensions == 3) ? 0 : sigma; // eslint-disable-line eqeqeq
    var sigmaY = (dimensions == 2) ? 0 : sigma; // eslint-disable-line eqeqeq

    this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY);

    // Repeat edges mapping:
    //
    //   0 -> off -> duplicate
    //   1 -> on  -> wrap
    var edgeMode = (this.filterManager.effectElements[2].p.v == 1) ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
    this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
  }
};

/* global createNS, createElementID, locationHref, bmFloor */

function SVGStrokeEffect(elem, filterManager) {
  this.initialized = false;
  this.filterManager = filterManager;
  this.elem = elem;
  this.paths = [];
}

SVGStrokeEffect.prototype.initialize = function () {
  var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
  var path;
  var groupPath;
  var i;
  var len;
  if (this.filterManager.effectElements[1].p.v === 1) {
    len = this.elem.maskManager.masksProperties.length;
    i = 0;
  } else {
    i = this.filterManager.effectElements[0].p.v - 1;
    len = i + 1;
  }
  groupPath = createNS('g');
  groupPath.setAttribute('fill', 'none');
  groupPath.setAttribute('stroke-linecap', 'round');
  groupPath.setAttribute('stroke-dashoffset', 1);
  for (i; i < len; i += 1) {
    path = createNS('path');
    groupPath.appendChild(path);
    this.paths.push({ p: path, m: i });
  }
  if (this.filterManager.effectElements[10].p.v === 3) {
    var mask = createNS('mask');
    var id = createElementID();
    mask.setAttribute('id', id);
    mask.setAttribute('mask-type', 'alpha');
    mask.appendChild(groupPath);
    this.elem.globalData.defs.appendChild(mask);
    var g = createNS('g');
    g.setAttribute('mask', 'url(' + locationHref + '#' + id + ')');
    while (elemChildren[0]) {
      g.appendChild(elemChildren[0]);
    }
    this.elem.layerElement.appendChild(g);
    this.masker = mask;
    groupPath.setAttribute('stroke', '#fff');
  } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
    if (this.filterManager.effectElements[10].p.v === 2) {
      elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
      while (elemChildren.length) {
        this.elem.layerElement.removeChild(elemChildren[0]);
      }
    }
    this.elem.layerElement.appendChild(groupPath);
    this.elem.layerElement.removeAttribute('mask');
    groupPath.setAttribute('stroke', '#fff');
  }
  this.initialized = true;
  this.pathMasker = groupPath;
};

SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
  if (!this.initialized) {
    this.initialize();
  }
  var i;
  var len = this.paths.length;
  var mask;
  var path;
  for (i = 0; i < len; i += 1) {
    if (this.paths[i].m !== -1) {
      mask = this.elem.maskManager.viewData[this.paths[i].m];
      path = this.paths[i].p;
      if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
        path.setAttribute('d', mask.lastPath);
      }
      if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
        var dasharrayValue;
        if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
          var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
          var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
          var l = path.getTotalLength();
          dasharrayValue = '0 0 0 ' + l * s + ' ';
          var lineLength = l * (e - s);
          var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          var units = Math.floor(lineLength / segment);
          var j;
          for (j = 0; j < units; j += 1) {
            dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
          }
          dasharrayValue += '0 ' + l * 10 + ' 0 0';
        } else {
          dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
        }
        path.setAttribute('stroke-dasharray', dasharrayValue);
      }
    }
  }
  if (forceRender || this.filterManager.effectElements[4].p._mdf) {
    this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
  }

  if (forceRender || this.filterManager.effectElements[6].p._mdf) {
    this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
  }
  if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
    if (forceRender || this.filterManager.effectElements[3].p._mdf) {
      var color = this.filterManager.effectElements[3].p.v;
      this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
    }
  }
};

/* global createNS */

function SVGTritoneFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
  feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f1');
  filter.appendChild(feColorMatrix);
  var feComponentTransfer = createNS('feComponentTransfer');
  feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
  filter.appendChild(feComponentTransfer);
  this.matrixFilter = feComponentTransfer;
  var feFuncR = createNS('feFuncR');
  feFuncR.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncR);
  this.feFuncR = feFuncR;
  var feFuncG = createNS('feFuncG');
  feFuncG.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncG);
  this.feFuncG = feFuncG;
  var feFuncB = createNS('feFuncB');
  feFuncB.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncB);
  this.feFuncB = feFuncB;
}

SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var color1 = this.filterManager.effectElements[0].p.v;
    var color2 = this.filterManager.effectElements[1].p.v;
    var color3 = this.filterManager.effectElements[2].p.v;
    var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
    var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
    var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
    this.feFuncR.setAttribute('tableValues', tableR);
    this.feFuncG.setAttribute('tableValues', tableG);
    this.feFuncB.setAttribute('tableValues', tableB);
    // var opacity = this.filterManager.effectElements[2].p.v/100;
    // this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGProLevelsFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var effectElements = this.filterManager.effectElements;
  var feComponentTransfer = createNS('feComponentTransfer');

  if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
    this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
  }
  if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
    this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
  }
  if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
    this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
  }
  if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
    this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
  }

  if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    filter.appendChild(feComponentTransfer);
    feComponentTransfer = createNS('feComponentTransfer');
  }

  if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    filter.appendChild(feComponentTransfer);
    this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
    this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
    this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
  }
}

SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
  var feFunc = createNS(type);
  feFunc.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFunc);
  return feFunc;
};

SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
  var cnt = 0;
  var segments = 256;
  var perc;
  var min = Math.min(inputBlack, inputWhite);
  var max = Math.max(inputBlack, inputWhite);
  var table = Array.call(null, { length: segments });
  var colorValue;
  var pos = 0;
  var outputDelta = outputWhite - outputBlack;
  var inputDelta = inputWhite - inputBlack;
  while (cnt <= 256) {
    perc = cnt / 256;
    if (perc <= min) {
      colorValue = inputDelta < 0 ? outputWhite : outputBlack;
    } else if (perc >= max) {
      colorValue = inputDelta < 0 ? outputBlack : outputWhite;
    } else {
      colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
    }
    table[pos] = colorValue;
    pos += 1;
    cnt += 256 / (segments - 1);
  }
  return table.join(' ');
};

SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var val;
    var effectElements = this.filterManager.effectElements;
    if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
      val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
      this.feFuncRComposed.setAttribute('tableValues', val);
      this.feFuncGComposed.setAttribute('tableValues', val);
      this.feFuncBComposed.setAttribute('tableValues', val);
    }

    if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
      val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
      this.feFuncR.setAttribute('tableValues', val);
    }

    if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
      val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
      this.feFuncG.setAttribute('tableValues', val);
    }

    if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
      val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
      this.feFuncB.setAttribute('tableValues', val);
    }

    if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
      val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
      this.feFuncA.setAttribute('tableValues', val);
    }
  }
};

/* global createNS, rgbToHex, degToRads */

function SVGDropShadowEffect(filter, filterManager) {
  var filterSize = filterManager.container.globalData.renderConfig.filterSize;
  filter.setAttribute('x', filterSize.x);
  filter.setAttribute('y', filterSize.y);
  filter.setAttribute('width', filterSize.width);
  filter.setAttribute('height', filterSize.height);
  this.filterManager = filterManager;

  var feGaussianBlur = createNS('feGaussianBlur');
  feGaussianBlur.setAttribute('in', 'SourceAlpha');
  feGaussianBlur.setAttribute('result', 'drop_shadow_1');
  feGaussianBlur.setAttribute('stdDeviation', '0');
  this.feGaussianBlur = feGaussianBlur;
  filter.appendChild(feGaussianBlur);

  var feOffset = createNS('feOffset');
  feOffset.setAttribute('dx', '25');
  feOffset.setAttribute('dy', '0');
  feOffset.setAttribute('in', 'drop_shadow_1');
  feOffset.setAttribute('result', 'drop_shadow_2');
  this.feOffset = feOffset;
  filter.appendChild(feOffset);
  var feFlood = createNS('feFlood');
  feFlood.setAttribute('flood-color', '#00ff00');
  feFlood.setAttribute('flood-opacity', '1');
  feFlood.setAttribute('result', 'drop_shadow_3');
  this.feFlood = feFlood;
  filter.appendChild(feFlood);

  var feComposite = createNS('feComposite');
  feComposite.setAttribute('in', 'drop_shadow_3');
  feComposite.setAttribute('in2', 'drop_shadow_2');
  feComposite.setAttribute('operator', 'in');
  feComposite.setAttribute('result', 'drop_shadow_4');
  filter.appendChild(feComposite);

  var feMerge = createNS('feMerge');
  filter.appendChild(feMerge);
  var feMergeNode;
  feMergeNode = createNS('feMergeNode');
  feMerge.appendChild(feMergeNode);
  feMergeNode = createNS('feMergeNode');
  feMergeNode.setAttribute('in', 'SourceGraphic');
  this.feMergeNode = feMergeNode;
  this.feMerge = feMerge;
  this.originalNodeAdded = false;
  feMerge.appendChild(feMergeNode);
}

SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
      this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
    }
    if (forceRender || this.filterManager.effectElements[0].p._mdf) {
      var col = this.filterManager.effectElements[0].p.v;
      this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
    }
    if (forceRender || this.filterManager.effectElements[1].p._mdf) {
      this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
    }
    if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
      var distance = this.filterManager.effectElements[3].p.v;
      var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
      var x = distance * Math.cos(angle);
      var y = distance * Math.sin(angle);
      this.feOffset.setAttribute('dx', x);
      this.feOffset.setAttribute('dy', y);
    }
    /* if(forceRender || this.filterManager.effectElements[5].p._mdf){
            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
                this.feMerge.removeChild(this.feMergeNode);
                this.originalNodeAdded = false;
            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
                this.feMerge.appendChild(this.feMergeNode);
                this.originalNodeAdded = true;
            }
        } */
  }
};

/* global createElementID, createNS */

var _svgMatteSymbols = [];

function SVGMatte3Effect(filterElem, filterManager, elem) {
  this.initialized = false;
  this.filterManager = filterManager;
  this.filterElem = filterElem;
  this.elem = elem;
  elem.matteElement = createNS('g');
  elem.matteElement.appendChild(elem.layerElement);
  elem.matteElement.appendChild(elem.transformedElement);
  elem.baseElement = elem.matteElement;
}

SVGMatte3Effect.prototype.findSymbol = function (mask) {
  var i = 0;
  var len = _svgMatteSymbols.length;
  while (i < len) {
    if (_svgMatteSymbols[i] === mask) {
      return _svgMatteSymbols[i];
    }
    i += 1;
  }
  return null;
};

SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
  var parentNode = mask.layerElement.parentNode;
  if (!parentNode) {
    return;
  }
  var children = parentNode.children;
  var i = 0;
  var len = children.length;
  while (i < len) {
    if (children[i] === mask.layerElement) {
      break;
    }
    i += 1;
  }
  var nextChild;
  if (i <= len - 2) {
    nextChild = children[i + 1];
  }
  var useElem = createNS('use');
  useElem.setAttribute('href', '#' + symbolId);
  if (nextChild) {
    parentNode.insertBefore(useElem, nextChild);
  } else {
    parentNode.appendChild(useElem);
  }
};

SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
  if (!this.findSymbol(mask)) {
    var symbolId = createElementID();
    var masker = createNS('mask');
    masker.setAttribute('id', mask.layerId);
    masker.setAttribute('mask-type', 'alpha');
    _svgMatteSymbols.push(mask);
    var defs = elem.globalData.defs;
    defs.appendChild(masker);
    var symbol = createNS('symbol');
    symbol.setAttribute('id', symbolId);
    this.replaceInParent(mask, symbolId);
    symbol.appendChild(mask.layerElement);
    defs.appendChild(symbol);
    var useElem = createNS('use');
    useElem.setAttribute('href', '#' + symbolId);
    masker.appendChild(useElem);
    mask.data.hd = false;
    mask.show();
  }
  elem.setMatte(mask.layerId);
};

SVGMatte3Effect.prototype.initialize = function () {
  var ind = this.filterManager.effectElements[0].p.v;
  var elements = this.elem.comp.elements;
  var i = 0;
  var len = elements.length;
  while (i < len) {
    if (elements[i] && elements[i].data.ind === ind) {
      this.setElementAsMask(this.elem, elements[i]);
    }
    i += 1;
  }
  this.initialized = true;
};

SVGMatte3Effect.prototype.renderFrame = function () {
  if (!this.initialized) {
    this.initialize();
  }
};

/* global createElementID, filtersFactory, SVGTintFilter, SVGFillFilter, SVGStrokeEffect, SVGTritoneFilter,
SVGProLevelsFilter, SVGDropShadowEffect, SVGMatte3Effect, SVGGaussianBlurEffect, locationHref */

function SVGEffects(elem) {
  var i;
  var len = elem.data.ef ? elem.data.ef.length : 0;
  var filId = createElementID();
  var fil = filtersFactory.createFilter(filId, true);
  var count = 0;
  this.filters = [];
  var filterManager;
  for (i = 0; i < len; i += 1) {
    filterManager = null;
    if (elem.data.ef[i].ty === 20) {
      count += 1;
      filterManager = new SVGTintFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 21) {
      count += 1;
      filterManager = new SVGFillFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 22) {
      filterManager = new SVGStrokeEffect(elem, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 23) {
      count += 1;
      filterManager = new SVGTritoneFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 24) {
      count += 1;
      filterManager = new SVGProLevelsFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 25) {
      count += 1;
      filterManager = new SVGDropShadowEffect(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 28) {
      // count += 1;
      filterManager = new SVGMatte3Effect(fil, elem.effectsManager.effectElements[i], elem);
    } else if (elem.data.ef[i].ty === 29) {
      count += 1;
      filterManager = new SVGGaussianBlurEffect(fil, elem.effectsManager.effectElements[i]);
    }
    if (filterManager) {
      this.filters.push(filterManager);
    }
  }
  if (count) {
    elem.globalData.defs.appendChild(fil);
    elem.layerElement.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
  }
  if (this.filters.length) {
    elem.addRenderableComponent(this);
  }
}

SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
  var i;
  var len = this.filters.length;
  for (i = 0; i < len; i += 1) {
    this.filters[i].renderFrame(_isFirstFrame);
  }
};

/* global Matrix, createTypedArray */

function CVContextData() {
  this.saved = [];
  this.cArrPos = 0;
  this.cTr = new Matrix();
  this.cO = 1;
  var i;
  var len = 15;
  this.savedOp = createTypedArray('float32', len);
  for (i = 0; i < len; i += 1) {
    this.saved[i] = createTypedArray('float32', 16);
  }
  this._length = len;
}

CVContextData.prototype.duplicate = function () {
  var newLength = this._length * 2;
  var currentSavedOp = this.savedOp;
  this.savedOp = createTypedArray('float32', newLength);
  this.savedOp.set(currentSavedOp);
  var i = 0;
  for (i = this._length; i < newLength; i += 1) {
    this.saved[i] = createTypedArray('float32', 16);
  }
  this._length = newLength;
};

CVContextData.prototype.reset = function () {
  this.cArrPos = 0;
  this.cTr.reset();
  this.cO = 1;
};

/* global CVEffects, getBlendMode, CVMaskElement, Matrix */

function CVBaseElement() {
}

CVBaseElement.prototype = {
  createElements: function () {},
  initRendererElement: function () {},
  createContainerElements: function () {
    this.canvasContext = this.globalData.canvasContext;
    this.renderableEffectsManager = new CVEffects(this);
  },
  createContent: function () {},
  setBlendMode: function () {
    var globalData = this.globalData;
    if (globalData.blendMode !== this.data.bm) {
      globalData.blendMode = this.data.bm;
      var blendModeValue = getBlendMode(this.data.bm);
      globalData.canvasContext.globalCompositeOperation = blendModeValue;
    }
  },
  createRenderableComponents: function () {
    this.maskManager = new CVMaskElement(this.data, this);
  },
  hideElement: function () {
    if (!this.hidden && (!this.isInRange || this.isTransparent)) {
      this.hidden = true;
    }
  },
  showElement: function () {
    if (this.isInRange && !this.isTransparent) {
      this.hidden = false;
      this._isFirstFrame = true;
      this.maskManager._isFirstFrame = true;
    }
  },
  renderFrame: function () {
    if (this.hidden || this.data.hd) {
      return;
    }
    this.renderTransform();
    this.renderRenderable();
    this.setBlendMode();
    var forceRealStack = this.data.ty === 0;
    this.globalData.renderer.save(forceRealStack);
    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v);
    this.renderInnerContent();
    this.globalData.renderer.restore(forceRealStack);
    if (this.maskManager.hasMasks) {
      this.globalData.renderer.restore(true);
    }
    if (this._isFirstFrame) {
      this._isFirstFrame = false;
    }
  },
  destroy: function () {
    this.canvasContext = null;
    this.data = null;
    this.globalData = null;
    this.maskManager.destroy();
  },
  mHelper: new Matrix(),
};
CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement,HierarchyElement, FrameElement,
RenderableElement, SVGShapeElement, IImageElement, createTag */

function CVImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.img = globalData.imageLoader.getAsset(this.assetData);
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);

CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

CVImageElement.prototype.createContent = function () {
  if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
    var canvas = createTag('canvas');
    canvas.width = this.assetData.w;
    canvas.height = this.assetData.h;
    var ctx = canvas.getContext('2d');

    var imgW = this.img.width;
    var imgH = this.img.height;
    var imgRel = imgW / imgH;
    var canvasRel = this.assetData.w / this.assetData.h;
    var widthCrop;
    var heightCrop;
    var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
    if ((imgRel > canvasRel && par === 'xMidYMid slice') || (imgRel < canvasRel && par !== 'xMidYMid slice')) {
      heightCrop = imgH;
      widthCrop = heightCrop * canvasRel;
    } else {
      widthCrop = imgW;
      heightCrop = widthCrop / canvasRel;
    }
    ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
    this.img = canvas;
  }
};

CVImageElement.prototype.renderInnerContent = function () {
  this.canvasContext.drawImage(this.img, 0, 0);
};

CVImageElement.prototype.destroy = function () {
  this.img = null;
};

/* global createSizedArray, PropertyFactory, extendPrototype, CanvasRenderer, ICompElement, CVBaseElement */

function CVCompElement(data, globalData, comp) {
  this.completeLayers = false;
  this.layers = data.layers;
  this.pendingElements = [];
  this.elements = createSizedArray(this.layers.length);
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([CanvasRenderer, ICompElement, CVBaseElement], CVCompElement);

CVCompElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(this.data.w, 0);
  ctx.lineTo(this.data.w, this.data.h);
  ctx.lineTo(0, this.data.h);
  ctx.lineTo(0, 0);
  ctx.clip();
  var i;
  var len = this.layers.length;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].renderFrame();
    }
  }
};

CVCompElement.prototype.destroy = function () {
  var i;
  var len = this.layers.length;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.layers = null;
  this.elements = null;
};

/* global createSizedArray, ShapePropertyFactory, MaskElement */

function CVMaskElement(data, element) {
  this.data = data;
  this.element = element;
  this.masksProperties = this.data.masksProperties || [];
  this.viewData = createSizedArray(this.masksProperties.length);
  var i;
  var len = this.masksProperties.length;
  var hasMasks = false;
  for (i = 0; i < len; i += 1) {
    if (this.masksProperties[i].mode !== 'n') {
      hasMasks = true;
    }
    this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
  }
  this.hasMasks = hasMasks;
  if (hasMasks) {
    this.element.addRenderableComponent(this);
  }
}

CVMaskElement.prototype.renderFrame = function () {
  if (!this.hasMasks) {
    return;
  }
  var transform = this.element.finalTransform.mat;
  var ctx = this.element.canvasContext;
  var i;
  var len = this.masksProperties.length;
  var pt;
  var pts;
  var data;
  ctx.beginPath();
  for (i = 0; i < len; i += 1) {
    if (this.masksProperties[i].mode !== 'n') {
      if (this.masksProperties[i].inv) {
        ctx.moveTo(0, 0);
        ctx.lineTo(this.element.globalData.compSize.w, 0);
        ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
        ctx.lineTo(0, this.element.globalData.compSize.h);
        ctx.lineTo(0, 0);
      }
      data = this.viewData[i].v;
      pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
      ctx.moveTo(pt[0], pt[1]);
      var j;
      var jLen = data._length;
      for (j = 1; j < jLen; j += 1) {
        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
      }
      pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
      ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
    }
  }
  this.element.globalData.renderer.save(true);
  ctx.clip();
};

CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

CVMaskElement.prototype.destroy = function () {
  this.element = null;
};

/* global ShapeTransformManager, extendPrototype, BaseElement, TransformElement, CVBaseElement, IShapeElement,
HierarchyElement, FrameElement, RenderableElement, RenderableDOMElement, PropertyFactory, degToRads, GradientProperty,
DashProperty, TransformPropertyFactory, CVShapeData, ShapeModifiers, bmFloor, lineCapEnum, lineJoinEnum */

function CVShapeElement(data, globalData, comp) {
  this.shapes = [];
  this.shapesData = data.shapes;
  this.stylesList = [];
  this.itemsData = [];
  this.prevViewData = [];
  this.shapeModifiers = [];
  this.processedElements = [];
  this.transformsManager = new ShapeTransformManager();
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);

CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;

CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: false };

CVShapeElement.prototype.dashResetter = [];

CVShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
};

CVShapeElement.prototype.createStyleElement = function (data, transforms) {
  var styleElem = {
    data: data,
    type: data.ty,
    preTransforms: this.transformsManager.addTransformSequence(transforms),
    transforms: [],
    elements: [],
    closed: data.hd === true,
  };
  var elementData = {};
  if (data.ty === 'fl' || data.ty === 'st') {
    elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
    if (!elementData.c.k) {
      styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
    }
  } else if (data.ty === 'gf' || data.ty === 'gs') {
    elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
    elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
    elementData.h = PropertyFactory.getProp(this, data.h || { k: 0 }, 0, 0.01, this);
    elementData.a = PropertyFactory.getProp(this, data.a || { k: 0 }, 0, degToRads, this);
    elementData.g = new GradientProperty(this, data.g, this);
  }
  elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
  if (data.ty === 'st' || data.ty === 'gs') {
    styleElem.lc = lineCapEnum[data.lc || 2];
    styleElem.lj = lineJoinEnum[data.lj || 2];
    if (data.lj == 1) { // eslint-disable-line eqeqeq
      styleElem.ml = data.ml;
    }
    elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
    if (!elementData.w.k) {
      styleElem.wi = elementData.w.v;
    }
    if (data.d) {
      var d = new DashProperty(this, data.d, 'canvas', this);
      elementData.d = d;
      if (!elementData.d.k) {
        styleElem.da = elementData.d.dashArray;
        styleElem.do = elementData.d.dashoffset[0];
      }
    }
  } else {
    styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
  }
  this.stylesList.push(styleElem);
  elementData.style = styleElem;
  return elementData;
};

CVShapeElement.prototype.createGroupElement = function () {
  var elementData = {
    it: [],
    prevViewData: [],
  };
  return elementData;
};

CVShapeElement.prototype.createTransformElement = function (data) {
  var elementData = {
    transform: {
      opacity: 1,
      _opMdf: false,
      key: this.transformsManager.getNewKey(),
      op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
      mProps: TransformPropertyFactory.getTransformProperty(this, data, this),
    },
  };
  return elementData;
};

CVShapeElement.prototype.createShapeElement = function (data) {
  var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);

  this.shapes.push(elementData);
  this.addShapeToModifiers(elementData);
  return elementData;
};

CVShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = true;
  var i;
  var len = this.itemsData.length;
  for (i = 0; i < len; i += 1) {
    this.prevViewData[i] = this.itemsData[i];
  }
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
  len = this.dynamicProperties.length;
  for (i = 0; i < len; i += 1) {
    this.dynamicProperties[i].getValue();
  }
  this.renderModifiers();
  this.transformsManager.processSequences(this._isFirstFrame);
};

CVShapeElement.prototype.addTransformToStyleList = function (transform) {
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    if (!this.stylesList[i].closed) {
      this.stylesList[i].transforms.push(transform);
    }
  }
};

CVShapeElement.prototype.removeTransformFromStyleList = function () {
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    if (!this.stylesList[i].closed) {
      this.stylesList[i].transforms.pop();
    }
  }
};

CVShapeElement.prototype.closeStyles = function (styles) {
  var i;
  var len = styles.length;
  for (i = 0; i < len; i += 1) {
    styles[i].closed = true;
  }
};

CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
  var i;
  var len = arr.length - 1;
  var j;
  var jLen;
  var ownStyles = [];
  var ownModifiers = [];
  var processedPos;
  var modifier;
  var currentTransform;
  var ownTransforms = [].concat(transforms);
  for (i = len; i >= 0; i -= 1) {
    processedPos = this.searchProcessedElement(arr[i]);
    if (!processedPos) {
      arr[i]._shouldRender = shouldRender;
    } else {
      itemsData[i] = prevViewData[processedPos - 1];
    }
    if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
      if (!processedPos) {
        itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
      } else {
        itemsData[i].style.closed = false;
      }

      ownStyles.push(itemsData[i].style);
    } else if (arr[i].ty === 'gr') {
      if (!processedPos) {
        itemsData[i] = this.createGroupElement(arr[i]);
      } else {
        jLen = itemsData[i].it.length;
        for (j = 0; j < jLen; j += 1) {
          itemsData[i].prevViewData[j] = itemsData[i].it[j];
        }
      }
      this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
    } else if (arr[i].ty === 'tr') {
      if (!processedPos) {
        currentTransform = this.createTransformElement(arr[i]);
        itemsData[i] = currentTransform;
      }
      ownTransforms.push(itemsData[i]);
      this.addTransformToStyleList(itemsData[i]);
    } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
      if (!processedPos) {
        itemsData[i] = this.createShapeElement(arr[i]);
      }
    } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        modifier.init(this, arr[i]);
        itemsData[i] = modifier;
        this.shapeModifiers.push(modifier);
      } else {
        modifier = itemsData[i];
        modifier.closed = false;
      }
      ownModifiers.push(modifier);
    } else if (arr[i].ty === 'rp') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        itemsData[i] = modifier;
        modifier.init(this, arr, i, itemsData);
        this.shapeModifiers.push(modifier);
        shouldRender = false;
      } else {
        modifier = itemsData[i];
        modifier.closed = true;
      }
      ownModifiers.push(modifier);
    }
    this.addProcessedElement(arr[i], i + 1);
  }
  this.removeTransformFromStyleList();
  this.closeStyles(ownStyles);
  len = ownModifiers.length;
  for (i = 0; i < len; i += 1) {
    ownModifiers[i].closed = true;
  }
};

CVShapeElement.prototype.renderInnerContent = function () {
  this.transformHelper.opacity = 1;
  this.transformHelper._opMdf = false;
  this.renderModifiers();
  this.transformsManager.processSequences(this._isFirstFrame);
  this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
};

CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
  if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
    groupTransform.opacity = parentTransform.opacity;
    groupTransform.opacity *= groupTransform.op.v;
    groupTransform._opMdf = true;
  }
};

CVShapeElement.prototype.drawLayer = function () {
  var i;
  var len = this.stylesList.length;
  var j;
  var jLen;
  var k;
  var kLen;
  var elems;
  var nodes;
  var renderer = this.globalData.renderer;
  var ctx = this.globalData.canvasContext;
  var type;
  var currentStyle;
  for (i = 0; i < len; i += 1) {
    currentStyle = this.stylesList[i];
    type = currentStyle.type;

    // Skipping style when
    // Stroke width equals 0
    // style should not be rendered (extra unused repeaters)
    // current opacity equals 0
    // global opacity equals 0
    if (!(((type === 'st' || type === 'gs') && currentStyle.wi === 0) || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
      renderer.save();
      elems = currentStyle.elements;
      if (type === 'st' || type === 'gs') {
        ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
        ctx.lineWidth = currentStyle.wi;
        ctx.lineCap = currentStyle.lc;
        ctx.lineJoin = currentStyle.lj;
        ctx.miterLimit = currentStyle.ml || 0;
      } else {
        ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
      }
      renderer.ctxOpacity(currentStyle.coOp);
      if (type !== 'st' && type !== 'gs') {
        ctx.beginPath();
      }
      renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
      jLen = elems.length;
      for (j = 0; j < jLen; j += 1) {
        if (type === 'st' || type === 'gs') {
          ctx.beginPath();
          if (currentStyle.da) {
            ctx.setLineDash(currentStyle.da);
            ctx.lineDashOffset = currentStyle.do;
          }
        }
        nodes = elems[j].trNodes;
        kLen = nodes.length;

        for (k = 0; k < kLen; k += 1) {
          if (nodes[k].t === 'm') {
            ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
          } else if (nodes[k].t === 'c') {
            ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
          } else {
            ctx.closePath();
          }
        }
        if (type === 'st' || type === 'gs') {
          ctx.stroke();
          if (currentStyle.da) {
            ctx.setLineDash(this.dashResetter);
          }
        }
      }
      if (type !== 'st' && type !== 'gs') {
        ctx.fill(currentStyle.r);
      }
      renderer.restore();
    }
  }
};

CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
  var i;
  var len = items.length - 1;
  var groupTransform;
  groupTransform = parentTransform;
  for (i = len; i >= 0; i -= 1) {
    if (items[i].ty === 'tr') {
      groupTransform = data[i].transform;
      this.renderShapeTransform(parentTransform, groupTransform);
    } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
      this.renderPath(items[i], data[i]);
    } else if (items[i].ty === 'fl') {
      this.renderFill(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'st') {
      this.renderStroke(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
      this.renderGradientFill(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'gr') {
      this.renderShape(groupTransform, items[i].it, data[i].it);
    } else if (items[i].ty === 'tm') {
      //
    }
  }
  if (isMain) {
    this.drawLayer();
  }
};

CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
  if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
    var shapeNodes = styledShape.trNodes;
    var paths = shape.paths;
    var i;
    var len;
    var j;
    var jLen = paths._length;
    shapeNodes.length = 0;
    var groupTransformMat = styledShape.transforms.finalTransform;
    for (j = 0; j < jLen; j += 1) {
      var pathNodes = paths.shapes[j];
      if (pathNodes && pathNodes.v) {
        len = pathNodes._length;
        for (i = 1; i < len; i += 1) {
          if (i === 1) {
            shapeNodes.push({
              t: 'm',
              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0),
            });
          }
          shapeNodes.push({
            t: 'c',
            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i]),
          });
        }
        if (len === 1) {
          shapeNodes.push({
            t: 'm',
            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0),
          });
        }
        if (pathNodes.c && len) {
          shapeNodes.push({
            t: 'c',
            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0]),
          });
          shapeNodes.push({
            t: 'z',
          });
        }
      }
    }
    styledShape.trNodes = shapeNodes;
  }
};

CVShapeElement.prototype.renderPath = function (pathData, itemData) {
  if (pathData.hd !== true && pathData._shouldRender) {
    var i;
    var len = itemData.styledShapes.length;
    for (i = 0; i < len; i += 1) {
      this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
    }
  }
};

CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;

  if (itemData.c._mdf || this._isFirstFrame) {
    styleElem.co = 'rgb('
        + bmFloor(itemData.c.v[0]) + ','
        + bmFloor(itemData.c.v[1]) + ','
        + bmFloor(itemData.c.v[2]) + ')';
  }
  if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  }
};

CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;
  var grd;
  if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || (styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf))) {
    var ctx = this.globalData.canvasContext;
    var pt1 = itemData.s.v;
    var pt2 = itemData.e.v;
    if (styleData.t === 1) {
      grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
    } else {
      var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
      var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

      var percent = itemData.h.v;
      if (percent >= 1) {
        percent = 0.99;
      } else if (percent <= -1) {
        percent = -0.99;
      }
      var dist = rad * percent;
      var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
      var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
      grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
    }

    var i;
    var len = styleData.g.p;
    var cValues = itemData.g.c;
    var opacity = 1;

    for (i = 0; i < len; i += 1) {
      if (itemData.g._hasOpacity && itemData.g._collapsable) {
        opacity = itemData.g.o[i * 2 + 1];
      }
      grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
    }
    styleElem.grd = grd;
  }
  styleElem.coOp = itemData.o.v * groupTransform.opacity;
};

CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;
  var d = itemData.d;
  if (d && (d._mdf || this._isFirstFrame)) {
    styleElem.da = d.dashArray;
    styleElem.do = d.dashoffset[0];
  }
  if (itemData.c._mdf || this._isFirstFrame) {
    styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
  }
  if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  }
  if (itemData.w._mdf || this._isFirstFrame) {
    styleElem.wi = itemData.w.v;
  }
};

CVShapeElement.prototype.destroy = function () {
  this.shapesData = null;
  this.globalData = null;
  this.canvasContext = null;
  this.stylesList.length = 0;
  this.itemsData.length = 0;
};

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement,
SVGShapeElement, IImageElement */

function CVSolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);

CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

CVSolidElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.fillStyle = this.data.sc;
  ctx.fillRect(0, 0, this.data.sw, this.data.sh);
  //
};

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement,
RenderableElement, ITextElement, createTag, createSizedArray */

function CVTextElement(data, globalData, comp) {
  this.textSpans = [];
  this.yOffset = 0;
  this.fillColorAnim = false;
  this.strokeColorAnim = false;
  this.strokeWidthAnim = false;
  this.stroke = false;
  this.fill = false;
  this.justifyOffset = 0;
  this.currentRender = null;
  this.renderType = 'canvas';
  this.values = {
    fill: 'rgba(0,0,0,0)',
    stroke: 'rgba(0,0,0,0)',
    sWidth: 0,
    fValue: '',
  };
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);

CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');

CVTextElement.prototype.buildNewText = function () {
  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);

  var hasFill = false;
  if (documentData.fc) {
    hasFill = true;
    this.values.fill = this.buildColor(documentData.fc);
  } else {
    this.values.fill = 'rgba(0,0,0,0)';
  }
  this.fill = hasFill;
  var hasStroke = false;
  if (documentData.sc) {
    hasStroke = true;
    this.values.stroke = this.buildColor(documentData.sc);
    this.values.sWidth = documentData.sw;
  }
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  var i;
  var len;
  var letters = documentData.l;
  var matrixHelper = this.mHelper;
  this.stroke = hasStroke;
  this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
  len = documentData.finalText.length;
  // this.tHelper.font = this.values.fValue;
  var charData;
  var shapeData;
  var k;
  var kLen;
  var shapes;
  var j;
  var jLen;
  var pathNodes;
  var commands;
  var pathArr;
  var singleShape = this.data.singleShape;
  var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
  var xPos = 0;
  var yPos = 0;
  var firstLine = true;
  var cnt = 0;
  for (i = 0; i < len; i += 1) {
    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
    shapeData = (charData && charData.data) || {};
    matrixHelper.reset();
    if (singleShape && letters[i].n) {
      xPos = -trackingOffset;
      yPos += documentData.yOffset;
      yPos += firstLine ? 1 : 0;
      firstLine = false;
    }

    shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
    jLen = shapes.length;
    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
    if (singleShape) {
      this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
    }
    commands = createSizedArray(jLen);
    for (j = 0; j < jLen; j += 1) {
      kLen = shapes[j].ks.k.i.length;
      pathNodes = shapes[j].ks.k;
      pathArr = [];
      for (k = 1; k < kLen; k += 1) {
        if (k === 1) {
          pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
        }
        pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
      }
      pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
      commands[j] = pathArr;
    }
    if (singleShape) {
      xPos += letters[i].l;
      xPos += trackingOffset;
    }
    if (this.textSpans[cnt]) {
      this.textSpans[cnt].elem = commands;
    } else {
      this.textSpans[cnt] = { elem: commands };
    }
    cnt += 1;
  }
};

CVTextElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.font = this.values.fValue;
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;

  if (!this.data.singleShape) {
    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
  }

  var i;
  var len;
  var j;
  var jLen;
  var k;
  var kLen;
  var renderedLetters = this.textAnimator.renderedLetters;

  var letters = this.textProperty.currentData.l;

  len = letters.length;
  var renderedLetter;
  var lastFill = null;
  var lastStroke = null;
  var lastStrokeW = null;
  var commands;
  var pathArr;
  for (i = 0; i < len; i += 1) {
    if (!letters[i].n) {
      renderedLetter = renderedLetters[i];
      if (renderedLetter) {
        this.globalData.renderer.save();
        this.globalData.renderer.ctxTransform(renderedLetter.p);
        this.globalData.renderer.ctxOpacity(renderedLetter.o);
      }
      if (this.fill) {
        if (renderedLetter && renderedLetter.fc) {
          if (lastFill !== renderedLetter.fc) {
            lastFill = renderedLetter.fc;
            ctx.fillStyle = renderedLetter.fc;
          }
        } else if (lastFill !== this.values.fill) {
          lastFill = this.values.fill;
          ctx.fillStyle = this.values.fill;
        }
        commands = this.textSpans[i].elem;
        jLen = commands.length;
        this.globalData.canvasContext.beginPath();
        for (j = 0; j < jLen; j += 1) {
          pathArr = commands[j];
          kLen = pathArr.length;
          this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
          for (k = 2; k < kLen; k += 6) {
            this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
          }
        }
        this.globalData.canvasContext.closePath();
        this.globalData.canvasContext.fill();
        /// ctx.fillText(this.textSpans[i].val,0,0);
      }
      if (this.stroke) {
        if (renderedLetter && renderedLetter.sw) {
          if (lastStrokeW !== renderedLetter.sw) {
            lastStrokeW = renderedLetter.sw;
            ctx.lineWidth = renderedLetter.sw;
          }
        } else if (lastStrokeW !== this.values.sWidth) {
          lastStrokeW = this.values.sWidth;
          ctx.lineWidth = this.values.sWidth;
        }
        if (renderedLetter && renderedLetter.sc) {
          if (lastStroke !== renderedLetter.sc) {
            lastStroke = renderedLetter.sc;
            ctx.strokeStyle = renderedLetter.sc;
          }
        } else if (lastStroke !== this.values.stroke) {
          lastStroke = this.values.stroke;
          ctx.strokeStyle = this.values.stroke;
        }
        commands = this.textSpans[i].elem;
        jLen = commands.length;
        this.globalData.canvasContext.beginPath();
        for (j = 0; j < jLen; j += 1) {
          pathArr = commands[j];
          kLen = pathArr.length;
          this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
          for (k = 2; k < kLen; k += 6) {
            this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
          }
        }
        this.globalData.canvasContext.closePath();
        this.globalData.canvasContext.stroke();
        /// ctx.strokeText(letters[i].val,0,0);
      }
      if (renderedLetter) {
        this.globalData.renderer.restore();
      }
    }
  }
};

function CVEffects() {

}
CVEffects.prototype.renderFrame = function () {};

/* global createTag, createNS, styleDiv, CVEffects, MaskElement, SVGBaseElement, HybridRenderer */

function HBaseElement() {}
HBaseElement.prototype = {
  checkBlendMode: function () {},
  initRendererElement: function () {
    this.baseElement = createTag(this.data.tg || 'div');
    if (this.data.hasMask) {
      this.svgElement = createNS('svg');
      this.layerElement = createNS('g');
      this.maskedElement = this.layerElement;
      this.svgElement.appendChild(this.layerElement);
      this.baseElement.appendChild(this.svgElement);
    } else {
      this.layerElement = this.baseElement;
    }
    styleDiv(this.baseElement);
  },
  createContainerElements: function () {
    this.renderableEffectsManager = new CVEffects(this);
    this.transformedElement = this.baseElement;
    this.maskedElement = this.layerElement;
    if (this.data.ln) {
      this.layerElement.setAttribute('id', this.data.ln);
    }
    if (this.data.cl) {
      this.layerElement.setAttribute('class', this.data.cl);
    }
    if (this.data.bm !== 0) {
      this.setBlendMode();
    }
  },
  renderElement: function () {
    var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
    if (this.finalTransform._matMdf) {
      var matrixValue = this.finalTransform.mat.toCSS();
      transformedElementStyle.transform = matrixValue;
      transformedElementStyle.webkitTransform = matrixValue;
    }
    if (this.finalTransform._opMdf) {
      transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
    }
  },
  renderFrame: function () {
    // If it is exported as hidden (data.hd === true) no need to render
    // If it is not visible no need to render
    if (this.data.hd || this.hidden) {
      return;
    }
    this.renderTransform();
    this.renderRenderable();
    this.renderElement();
    this.renderInnerContent();
    if (this._isFirstFrame) {
      this._isFirstFrame = false;
    }
  },
  destroy: function () {
    this.layerElement = null;
    this.transformedElement = null;
    if (this.matteElement) {
      this.matteElement = null;
    }
    if (this.maskManager) {
      this.maskManager.destroy();
      this.maskManager = null;
    }
  },
  createRenderableComponents: function () {
    this.maskManager = new MaskElement(this.data, this, this.globalData);
  },
  addEffects: function () {
  },
  setMatte: function () {},
};
HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, createNS, createTag */

function HSolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);

HSolidElement.prototype.createContent = function () {
  var rect;
  if (this.data.hasMask) {
    rect = createNS('rect');
    rect.setAttribute('width', this.data.sw);
    rect.setAttribute('height', this.data.sh);
    rect.setAttribute('fill', this.data.sc);
    this.svgElement.setAttribute('width', this.data.sw);
    this.svgElement.setAttribute('height', this.data.sh);
  } else {
    rect = createTag('div');
    rect.style.width = this.data.sw + 'px';
    rect.style.height = this.data.sh + 'px';
    rect.style.backgroundColor = this.data.sc;
  }
  this.layerElement.appendChild(rect);
};

/* global createSizedArray, PropertyFactory, extendPrototype, HybridRenderer, ICompElement, HBaseElement */

function HCompElement(data, globalData, comp) {
  this.layers = data.layers;
  this.supports3d = !data.hasMask;
  this.completeLayers = false;
  this.pendingElements = [];
  this.elements = this.layers ? createSizedArray(this.layers.length) : [];
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([HybridRenderer, ICompElement, HBaseElement], HCompElement);
HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;

HCompElement.prototype.createContainerElements = function () {
  this._createBaseContainerElements();
  // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
  if (this.data.hasMask) {
    this.svgElement.setAttribute('width', this.data.w);
    this.svgElement.setAttribute('height', this.data.h);
    this.transformedElement = this.baseElement;
  } else {
    this.transformedElement = this.layerElement;
  }
};

HCompElement.prototype.addTo3dContainer = function (elem, pos) {
  var j = 0;
  var nextElement;
  while (j < pos) {
    if (this.elements[j] && this.elements[j].getBaseElement) {
      nextElement = this.elements[j].getBaseElement();
    }
    j += 1;
  }
  if (nextElement) {
    this.layerElement.insertBefore(elem, nextElement);
  } else {
    this.layerElement.appendChild(elem);
  }
};

/* global createNS, extendPrototype, BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement,
HierarchyElement, FrameElement, RenderableElement, createNS, bmMin, bmSqrt, bmMin, bmMax, bmPow */

function HShapeElement(data, globalData, comp) {
  // List of drawable elements
  this.shapes = [];
  // Full shape data
  this.shapesData = data.shapes;
  // List of styles that will be applied to shapes
  this.stylesList = [];
  // List of modifiers that will be applied to shapes
  this.shapeModifiers = [];
  // List of items in shape tree
  this.itemsData = [];
  // List of items in previous shape tree
  this.processedElements = [];
  // List of animated components
  this.animatedContents = [];
  this.shapesContainer = createNS('g');
  this.initElement(data, globalData, comp);
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  // List of elements that have been created
  this.prevViewData = [];
  this.currentBBox = {
    x: 999999,
    y: -999999,
    h: 0,
    w: 0,
  };
}
extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;

HShapeElement.prototype.createContent = function () {
  var cont;
  this.baseElement.style.fontSize = 0;
  if (this.data.hasMask) {
    this.layerElement.appendChild(this.shapesContainer);
    cont = this.svgElement;
  } else {
    cont = createNS('svg');
    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
    cont.setAttribute('width', size.w);
    cont.setAttribute('height', size.h);
    cont.appendChild(this.shapesContainer);
    this.layerElement.appendChild(cont);
  }

  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
  this.filterUniqueShapes();
  this.shapeCont = cont;
};

HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
  var i;
  var len = transformers.length;
  for (i = 0; i < len; i += 1) {
    point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
  }
  return point;
};

HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
  var shape = item.sh.v;
  var transformers = item.transformers;
  var i;
  var len = shape._length;
  var vPoint;
  var oPoint;
  var nextIPoint;
  var nextVPoint;
  if (len <= 1) {
    return;
  }
  for (i = 0; i < len - 1; i += 1) {
    vPoint = this.getTransformedPoint(transformers, shape.v[i]);
    oPoint = this.getTransformedPoint(transformers, shape.o[i]);
    nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
    nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
    this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
  }
  if (shape.c) {
    vPoint = this.getTransformedPoint(transformers, shape.v[i]);
    oPoint = this.getTransformedPoint(transformers, shape.o[i]);
    nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
    nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
    this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
  }
};

HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
  this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
  var bounds = this.shapeBoundingBox;
  boundingBox.x = bmMin(bounds.left, boundingBox.x);
  boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
  boundingBox.y = bmMin(bounds.top, boundingBox.y);
  boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
};

HShapeElement.prototype.shapeBoundingBox = {
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
};

HShapeElement.prototype.tempBoundingBox = {
  x: 0,
  xMax: 0,
  y: 0,
  yMax: 0,
  width: 0,
  height: 0,
};

HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
  var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];

  for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) { // eslint-disable-line no-plusplus
    b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
    a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
    c = 3 * p1[i] - 3 * p0[i];

    b |= 0; // eslint-disable-line no-bitwise
    a |= 0; // eslint-disable-line no-bitwise
    c |= 0; // eslint-disable-line no-bitwise

    if (a === 0 && b === 0) {
      //
    } else if (a === 0) {
      t = -c / b;

      if (t > 0 && t < 1) {
        bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
      }
    } else {
      b2ac = b * b - 4 * c * a;

      if (b2ac >= 0) {
        t1 = (-b + bmSqrt(b2ac)) / (2 * a);
        if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
        t2 = (-b - bmSqrt(b2ac)) / (2 * a);
        if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
      }
    }
  }

  this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
  this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
  this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
  this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
};

HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
  return bmPow(1 - t, 3) * p0[i]
        + 3 * bmPow(1 - t, 2) * t * p1[i]
        + 3 * (1 - t) * bmPow(t, 2) * p2[i]
        + bmPow(t, 3) * p3[i];
};

HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
  var i;
  var len = itemsData.length;
  for (i = 0; i < len; i += 1) {
    if (itemsData[i] && itemsData[i].sh) {
      this.calculateShapeBoundingBox(itemsData[i], boundingBox);
    } else if (itemsData[i] && itemsData[i].it) {
      this.calculateBoundingBox(itemsData[i].it, boundingBox);
    }
  }
};

HShapeElement.prototype.currentBoxContains = function (box) {
  return this.currentBBox.x <= box.x
    && this.currentBBox.y <= box.y
    && this.currentBBox.width + this.currentBBox.x >= box.x + box.width
    && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
};

HShapeElement.prototype.renderInnerContent = function () {
  this._renderShapeFrame();

  if (!this.hidden && (this._isFirstFrame || this._mdf)) {
    var tempBoundingBox = this.tempBoundingBox;
    var max = 999999;
    tempBoundingBox.x = max;
    tempBoundingBox.xMax = -max;
    tempBoundingBox.y = max;
    tempBoundingBox.yMax = -max;
    this.calculateBoundingBox(this.itemsData, tempBoundingBox);
    tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
    tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
    // var tempBoundingBox = this.shapeCont.getBBox();
    if (this.currentBoxContains(tempBoundingBox)) {
      return;
    }
    var changed = false;
    if (this.currentBBox.w !== tempBoundingBox.width) {
      this.currentBBox.w = tempBoundingBox.width;
      this.shapeCont.setAttribute('width', tempBoundingBox.width);
      changed = true;
    }
    if (this.currentBBox.h !== tempBoundingBox.height) {
      this.currentBBox.h = tempBoundingBox.height;
      this.shapeCont.setAttribute('height', tempBoundingBox.height);
      changed = true;
    }
    if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
      this.currentBBox.w = tempBoundingBox.width;
      this.currentBBox.h = tempBoundingBox.height;
      this.currentBBox.x = tempBoundingBox.x;
      this.currentBBox.y = tempBoundingBox.y;

      this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
      var shapeStyle = this.shapeCont.style;
      var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
      shapeStyle.transform = shapeTransform;
      shapeStyle.webkitTransform = shapeTransform;
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, ITextElement, createSizedArray, createTag, styleDiv, createNS, lineJoinEnum, lineCapEnum */

function HTextElement(data, globalData, comp) {
  this.textSpans = [];
  this.textPaths = [];
  this.currentBBox = {
    x: 999999,
    y: -999999,
    h: 0,
    w: 0,
  };
  this.renderType = 'svg';
  this.isMasked = false;
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);

HTextElement.prototype.createContent = function () {
  this.isMasked = this.checkMasks();
  if (this.isMasked) {
    this.renderType = 'svg';
    this.compW = this.comp.data.w;
    this.compH = this.comp.data.h;
    this.svgElement.setAttribute('width', this.compW);
    this.svgElement.setAttribute('height', this.compH);
    var g = createNS('g');
    this.maskedElement.appendChild(g);
    this.innerElem = g;
  } else {
    this.renderType = 'html';
    this.innerElem = this.layerElement;
  }

  this.checkParenting();
};

HTextElement.prototype.buildNewText = function () {
  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
  var innerElemStyle = this.innerElem.style;
  var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
  innerElemStyle.fill = textColor;
  innerElemStyle.color = textColor;
  if (documentData.sc) {
    innerElemStyle.stroke = this.buildColor(documentData.sc);
    innerElemStyle.strokeWidth = documentData.sw + 'px';
  }
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  if (!this.globalData.fontManager.chars) {
    innerElemStyle.fontSize = documentData.finalSize + 'px';
    innerElemStyle.lineHeight = documentData.finalSize + 'px';
    if (fontData.fClass) {
      this.innerElem.className = fontData.fClass;
    } else {
      innerElemStyle.fontFamily = fontData.fFamily;
      var fWeight = documentData.fWeight;
      var fStyle = documentData.fStyle;
      innerElemStyle.fontStyle = fStyle;
      innerElemStyle.fontWeight = fWeight;
    }
  }
  var i;
  var len;

  var letters = documentData.l;
  len = letters.length;
  var tSpan;
  var tParent;
  var tCont;
  var matrixHelper = this.mHelper;
  var shapes;
  var shapeStr = '';
  var cnt = 0;
  for (i = 0; i < len; i += 1) {
    if (this.globalData.fontManager.chars) {
      if (!this.textPaths[cnt]) {
        tSpan = createNS('path');
        tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
        tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
        tSpan.setAttribute('stroke-miterlimit', '4');
      } else {
        tSpan = this.textPaths[cnt];
      }
      if (!this.isMasked) {
        if (this.textSpans[cnt]) {
          tParent = this.textSpans[cnt];
          tCont = tParent.children[0];
        } else {
          tParent = createTag('div');
          tParent.style.lineHeight = 0;
          tCont = createNS('svg');
          tCont.appendChild(tSpan);
          styleDiv(tParent);
        }
      }
    } else if (!this.isMasked) {
      if (this.textSpans[cnt]) {
        tParent = this.textSpans[cnt];
        tSpan = this.textPaths[cnt];
      } else {
        tParent = createTag('span');
        styleDiv(tParent);
        tSpan = createTag('span');
        styleDiv(tSpan);
        tParent.appendChild(tSpan);
      }
    } else {
      tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
    }
    // tSpan.setAttribute('visibility', 'hidden');
    if (this.globalData.fontManager.chars) {
      var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
      var shapeData;
      if (charData) {
        shapeData = charData.data;
      } else {
        shapeData = null;
      }
      matrixHelper.reset();
      if (shapeData && shapeData.shapes) {
        shapes = shapeData.shapes[0].it;
        matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
        shapeStr = this.createPathShape(matrixHelper, shapes);
        tSpan.setAttribute('d', shapeStr);
      }
      if (!this.isMasked) {
        this.innerElem.appendChild(tParent);
        if (shapeData && shapeData.shapes) {
          // document.body.appendChild is needed to get exact measure of shape
          document.body.appendChild(tCont);
          var boundingBox = tCont.getBBox();
          tCont.setAttribute('width', boundingBox.width + 2);
          tCont.setAttribute('height', boundingBox.height + 2);
          tCont.setAttribute('viewBox', (boundingBox.x - 1) + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
          var tContStyle = tCont.style;
          var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
          tContStyle.transform = tContTranslation;
          tContStyle.webkitTransform = tContTranslation;

          letters[i].yOffset = boundingBox.y - 1;
        } else {
          tCont.setAttribute('width', 1);
          tCont.setAttribute('height', 1);
        }
        tParent.appendChild(tCont);
      } else {
        this.innerElem.appendChild(tSpan);
      }
    } else {
      tSpan.textContent = letters[i].val;
      tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
      if (!this.isMasked) {
        this.innerElem.appendChild(tParent);
        //
        var tStyle = tSpan.style;
        var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
        tStyle.transform = tSpanTranslation;
        tStyle.webkitTransform = tSpanTranslation;
      } else {
        this.innerElem.appendChild(tSpan);
      }
    }
    //
    if (!this.isMasked) {
      this.textSpans[cnt] = tParent;
    } else {
      this.textSpans[cnt] = tSpan;
    }
    this.textSpans[cnt].style.display = 'block';
    this.textPaths[cnt] = tSpan;
    cnt += 1;
  }
  while (cnt < this.textSpans.length) {
    this.textSpans[cnt].style.display = 'none';
    cnt += 1;
  }
};

HTextElement.prototype.renderInnerContent = function () {
  var svgStyle;
  if (this.data.singleShape) {
    if (!this._isFirstFrame && !this.lettersChangedFlag) {
      return;
    } if (this.isMasked && this.finalTransform._matMdf) {
      // Todo Benchmark if using this is better than getBBox
      this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
      svgStyle = this.svgElement.style;
      var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
      svgStyle.transform = translation;
      svgStyle.webkitTransform = translation;
    }
  }

  this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
  if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
    return;
  }
  var i;
  var len;
  var count = 0;
  var renderedLetters = this.textAnimator.renderedLetters;

  var letters = this.textProperty.currentData.l;

  len = letters.length;
  var renderedLetter;
  var textSpan;
  var textPath;
  for (i = 0; i < len; i += 1) {
    if (letters[i].n) {
      count += 1;
    } else {
      textSpan = this.textSpans[i];
      textPath = this.textPaths[i];
      renderedLetter = renderedLetters[count];
      count += 1;
      if (renderedLetter._mdf.m) {
        if (!this.isMasked) {
          textSpan.style.webkitTransform = renderedLetter.m;
          textSpan.style.transform = renderedLetter.m;
        } else {
          textSpan.setAttribute('transform', renderedLetter.m);
        }
      }
      /// /textSpan.setAttribute('opacity',renderedLetter.o);
      textSpan.style.opacity = renderedLetter.o;
      if (renderedLetter.sw && renderedLetter._mdf.sw) {
        textPath.setAttribute('stroke-width', renderedLetter.sw);
      }
      if (renderedLetter.sc && renderedLetter._mdf.sc) {
        textPath.setAttribute('stroke', renderedLetter.sc);
      }
      if (renderedLetter.fc && renderedLetter._mdf.fc) {
        textPath.setAttribute('fill', renderedLetter.fc);
        textPath.style.color = renderedLetter.fc;
      }
    }
  }

  if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
    var boundingBox = this.innerElem.getBBox();

    if (this.currentBBox.w !== boundingBox.width) {
      this.currentBBox.w = boundingBox.width;
      this.svgElement.setAttribute('width', boundingBox.width);
    }
    if (this.currentBBox.h !== boundingBox.height) {
      this.currentBBox.h = boundingBox.height;
      this.svgElement.setAttribute('height', boundingBox.height);
    }

    var margin = 1;
    if (this.currentBBox.w !== (boundingBox.width + margin * 2) || this.currentBBox.h !== (boundingBox.height + margin * 2) || this.currentBBox.x !== (boundingBox.x - margin) || this.currentBBox.y !== (boundingBox.y - margin)) {
      this.currentBBox.w = boundingBox.width + margin * 2;
      this.currentBBox.h = boundingBox.height + margin * 2;
      this.currentBBox.x = boundingBox.x - margin;
      this.currentBBox.y = boundingBox.y - margin;

      this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
      svgStyle = this.svgElement.style;
      var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
      svgStyle.transform = svgTransform;
      svgStyle.webkitTransform = svgTransform;
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement,
FrameElement, RenderableElement, createNS */

function HImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);

HImageElement.prototype.createContent = function () {
  var assetPath = this.globalData.getAssetsPath(this.assetData);
  var img = new Image();

  if (this.data.hasMask) {
    this.imageElem = createNS('image');
    this.imageElem.setAttribute('width', this.assetData.w + 'px');
    this.imageElem.setAttribute('height', this.assetData.h + 'px');
    this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
    this.layerElement.appendChild(this.imageElem);
    this.baseElement.setAttribute('width', this.assetData.w);
    this.baseElement.setAttribute('height', this.assetData.h);
  } else {
    this.layerElement.appendChild(img);
  }
  img.crossOrigin = 'anonymous';
  img.src = assetPath;
  if (this.data.ln) {
    this.baseElement.setAttribute('id', this.data.ln);
  }
};

/* global PropertyFactory, degToRads, Matrix, extendPrototype, BaseElement, FrameElement, HierarchyElement */

function HCameraElement(data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initHierarchy();
  var getProp = PropertyFactory.getProp;
  this.pe = getProp(this, data.pe, 0, 0, this);
  if (data.ks.p.s) {
    this.px = getProp(this, data.ks.p.x, 1, 0, this);
    this.py = getProp(this, data.ks.p.y, 1, 0, this);
    this.pz = getProp(this, data.ks.p.z, 1, 0, this);
  } else {
    this.p = getProp(this, data.ks.p, 1, 0, this);
  }
  if (data.ks.a) {
    this.a = getProp(this, data.ks.a, 1, 0, this);
  }
  if (data.ks.or.k.length && data.ks.or.k[0].to) {
    var i;
    var len = data.ks.or.k.length;
    for (i = 0; i < len; i += 1) {
      data.ks.or.k[i].to = null;
      data.ks.or.k[i].ti = null;
    }
  }
  this.or = getProp(this, data.ks.or, 1, degToRads, this);
  this.or.sh = true;
  this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
  this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
  this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
  this.mat = new Matrix();
  this._prevMat = new Matrix();
  this._isFirstFrame = true;

  // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
  this.finalTransform = {
    mProp: this,
  };
}
extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);

HCameraElement.prototype.setup = function () {
  var i;
  var len = this.comp.threeDElements.length;
  var comp;
  var perspectiveStyle;
  var containerStyle;
  for (i = 0; i < len; i += 1) {
    // [perspectiveElem,container]
    comp = this.comp.threeDElements[i];
    if (comp.type === '3d') {
      perspectiveStyle = comp.perspectiveElem.style;
      containerStyle = comp.container.style;
      var perspective = this.pe.v + 'px';
      var origin = '0px 0px 0px';
      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
      perspectiveStyle.perspective = perspective;
      perspectiveStyle.webkitPerspective = perspective;
      containerStyle.transformOrigin = origin;
      containerStyle.mozTransformOrigin = origin;
      containerStyle.webkitTransformOrigin = origin;
      perspectiveStyle.transform = matrix;
      perspectiveStyle.webkitTransform = matrix;
    }
  }
};

HCameraElement.prototype.createElements = function () {
};

HCameraElement.prototype.hide = function () {
};

HCameraElement.prototype.renderFrame = function () {
  var _mdf = this._isFirstFrame;
  var i;
  var len;
  if (this.hierarchy) {
    len = this.hierarchy.length;
    for (i = 0; i < len; i += 1) {
      _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
    }
  }
  if (_mdf || this.pe._mdf || (this.p && this.p._mdf) || (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || (this.a && this.a._mdf)) {
    this.mat.reset();

    if (this.hierarchy) {
      len = this.hierarchy.length - 1;
      for (i = len; i >= 0; i -= 1) {
        var mTransf = this.hierarchy[i].finalTransform.mProp;
        this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
        this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
        this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
        this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
        this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
      }
    }
    if (this.p) {
      this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
    } else {
      this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
    }
    if (this.a) {
      var diffVector;
      if (this.p) {
        diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
      } else {
        diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
      }
      var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2));
      // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
      var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
      var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
      var mRotationX = (Math.atan2(lookDir[1], lookLengthOnXZ));
      var mRotationY = (Math.atan2(lookDir[0], -lookDir[2]));
      this.mat.rotateY(mRotationY).rotateX(-mRotationX);
    }
    this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
    this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
    this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
    this.mat.translate(0, 0, this.pe.v);

    var hasMatrixChanged = !this._prevMat.equals(this.mat);
    if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
      len = this.comp.threeDElements.length;
      var comp;
      var perspectiveStyle;
      var containerStyle;
      for (i = 0; i < len; i += 1) {
        comp = this.comp.threeDElements[i];
        if (comp.type === '3d') {
          if (hasMatrixChanged) {
            var matValue = this.mat.toCSS();
            containerStyle = comp.container.style;
            containerStyle.transform = matValue;
            containerStyle.webkitTransform = matValue;
          }
          if (this.pe._mdf) {
            perspectiveStyle = comp.perspectiveElem.style;
            perspectiveStyle.perspective = this.pe.v + 'px';
            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
          }
        }
      }
      this.mat.clone(this._prevMat);
    }
  }
  this._isFirstFrame = false;
};

HCameraElement.prototype.prepareFrame = function (num) {
  this.prepareProperties(num, true);
};

HCameraElement.prototype.destroy = function () {
};
HCameraElement.prototype.getBaseElement = function () { return null; };

function HEffects() {
}
HEffects.prototype.renderFrame = function () {};

/* global createTag, AnimationItem */
/* exported animationManager */

var animationManager = (function () {
  var moduleOb = {};
  var registeredAnimations = [];
  var initTime = 0;
  var len = 0;
  var playingAnimationsNum = 0;
  var _stopped = true;
  var _isFrozen = false;

  function removeElement(ev) {
    var i = 0;
    var animItem = ev.target;
    while (i < len) {
      if (registeredAnimations[i].animation === animItem) {
        registeredAnimations.splice(i, 1);
        i -= 1;
        len -= 1;
        if (!animItem.isPaused) {
          subtractPlayingCount();
        }
      }
      i += 1;
    }
  }

  function registerAnimation(element, animationData) {
    if (!element) {
      return null;
    }
    var i = 0;
    while (i < len) {
      if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
        return registeredAnimations[i].animation;
      }
      i += 1;
    }
    var animItem = new AnimationItem();
    setupAnimation(animItem, element);
    animItem.setData(element, animationData);
    return animItem;
  }

  function getRegisteredAnimations() {
    var i;
    var lenAnims = registeredAnimations.length;
    var animations = [];
    for (i = 0; i < lenAnims; i += 1) {
      animations.push(registeredAnimations[i].animation);
    }
    return animations;
  }

  function addPlayingCount() {
    playingAnimationsNum += 1;
    activate();
  }

  function subtractPlayingCount() {
    playingAnimationsNum -= 1;
  }

  function setupAnimation(animItem, element) {
    animItem.addEventListener('destroy', removeElement);
    animItem.addEventListener('_active', addPlayingCount);
    animItem.addEventListener('_idle', subtractPlayingCount);
    registeredAnimations.push({ elem: element, animation: animItem });
    len += 1;
  }

  function loadAnimation(params) {
    var animItem = new AnimationItem();
    setupAnimation(animItem, null);
    animItem.setParams(params);
    return animItem;
  }

  function setSpeed(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setSpeed(val, animation);
    }
  }

  function setDirection(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setDirection(val, animation);
    }
  }

  function play(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.play(animation);
    }
  }
  function resume(nowTime) {
    var elapsedTime = nowTime - initTime;
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.advanceTime(elapsedTime);
    }
    initTime = nowTime;
    if (playingAnimationsNum && !_isFrozen) {
      window.requestAnimationFrame(resume);
    } else {
      _stopped = true;
    }
  }

  function first(nowTime) {
    initTime = nowTime;
    window.requestAnimationFrame(resume);
  }

  function pause(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.pause(animation);
    }
  }

  function goToAndStop(value, isFrame, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
    }
  }

  function stop(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.stop(animation);
    }
  }

  function togglePause(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.togglePause(animation);
    }
  }

  function destroy(animation) {
    var i;
    for (i = (len - 1); i >= 0; i -= 1) {
      registeredAnimations[i].animation.destroy(animation);
    }
  }

  function searchAnimations(animationData, standalone, renderer) {
    var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
      [].slice.call(document.getElementsByClassName('bodymovin')));
    var i;
    var lenAnims = animElements.length;
    for (i = 0; i < lenAnims; i += 1) {
      if (renderer) {
        animElements[i].setAttribute('data-bm-type', renderer);
      }
      registerAnimation(animElements[i], animationData);
    }
    if (standalone && lenAnims === 0) {
      if (!renderer) {
        renderer = 'svg';
      }
      var body = document.getElementsByTagName('body')[0];
      body.innerText = '';
      var div = createTag('div');
      div.style.width = '100%';
      div.style.height = '100%';
      div.setAttribute('data-bm-type', renderer);
      body.appendChild(div);
      registerAnimation(div, animationData);
    }
  }

  function resize() {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.resize();
    }
  }

  function activate() {
    if (!_isFrozen && playingAnimationsNum) {
      if (_stopped) {
        window.requestAnimationFrame(first);
        _stopped = false;
      }
    }
  }

  function freeze() {
    _isFrozen = true;
  }

  function unfreeze() {
    _isFrozen = false;
    activate();
  }

  function setVolume(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setVolume(val, animation);
    }
  }

  function mute(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.mute(animation);
    }
  }

  function unmute(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.unmute(animation);
    }
  }

  moduleOb.registerAnimation = registerAnimation;
  moduleOb.loadAnimation = loadAnimation;
  moduleOb.setSpeed = setSpeed;
  moduleOb.setDirection = setDirection;
  moduleOb.play = play;
  moduleOb.pause = pause;
  moduleOb.stop = stop;
  moduleOb.togglePause = togglePause;
  moduleOb.searchAnimations = searchAnimations;
  moduleOb.resize = resize;
  // moduleOb.start = start;
  moduleOb.goToAndStop = goToAndStop;
  moduleOb.destroy = destroy;
  moduleOb.freeze = freeze;
  moduleOb.unfreeze = unfreeze;
  moduleOb.setVolume = setVolume;
  moduleOb.mute = mute;
  moduleOb.unmute = unmute;
  moduleOb.getRegisteredAnimations = getRegisteredAnimations;
  return moduleOb;
}());

/* global createElementID, subframeEnabled, ProjectInterface, ImagePreloader, audioControllerFactory, extendPrototype, BaseEvent,
CanvasRenderer, SVGRenderer, HybridRenderer, dataManager, expressionsPlugin, BMEnterFrameEvent, BMCompleteLoopEvent,
BMCompleteEvent, BMSegmentStartEvent, BMDestroyEvent, BMEnterFrameEvent, BMCompleteLoopEvent, BMCompleteEvent, BMSegmentStartEvent,
BMDestroyEvent, BMRenderFrameErrorEvent, BMConfigErrorEvent, markerParser */

var AnimationItem = function () {
  this._cbs = [];
  this.name = '';
  this.path = '';
  this.isLoaded = false;
  this.currentFrame = 0;
  this.currentRawFrame = 0;
  this.firstFrame = 0;
  this.totalFrames = 0;
  this.frameRate = 0;
  this.frameMult = 0;
  this.playSpeed = 1;
  this.playDirection = 1;
  this.playCount = 0;
  this.animationData = {};
  this.assets = [];
  this.isPaused = true;
  this.autoplay = false;
  this.loop = true;
  this.renderer = null;
  this.animationID = createElementID();
  this.assetsPath = '';
  this.timeCompleted = 0;
  this.segmentPos = 0;
  this.isSubframeEnabled = subframeEnabled;
  this.segments = [];
  this._idle = true;
  this._completedLoop = false;
  this.projectInterface = ProjectInterface();
  this.imagePreloader = new ImagePreloader();
  this.audioController = audioControllerFactory();
  this.markers = [];
  this.configAnimation = this.configAnimation.bind(this);
  this.onSetupError = this.onSetupError.bind(this);
  this.onSegmentComplete = this.onSegmentComplete.bind(this);
};

extendPrototype([BaseEvent], AnimationItem);

AnimationItem.prototype.setParams = function (params) {
  if (params.wrapper || params.container) {
    this.wrapper = params.wrapper || params.container;
  }
  var animType = 'svg';
  if (params.animType) {
    animType = params.animType;
  } else if (params.renderer) {
    animType = params.renderer;
  }
  switch (animType) {
    case 'canvas':
      this.renderer = new CanvasRenderer(this, params.rendererSettings);
      break;
    case 'svg':
      this.renderer = new SVGRenderer(this, params.rendererSettings);
      break;
    default:
      this.renderer = new HybridRenderer(this, params.rendererSettings);
      break;
  }
  this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
  this.renderer.setProjectInterface(this.projectInterface);
  this.animType = animType;
  if (params.loop === ''
        || params.loop === null
        || params.loop === undefined
        || params.loop === true) {
    this.loop = true;
  } else if (params.loop === false) {
    this.loop = false;
  } else {
    this.loop = parseInt(params.loop, 10);
  }
  this.autoplay = 'autoplay' in params ? params.autoplay : true;
  this.name = params.name ? params.name : '';
  this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
  this.assetsPath = params.assetsPath;
  this.initialSegment = params.initialSegment;
  if (params.audioFactory) {
    this.audioController.setAudioFactory(params.audioFactory);
  }
  if (params.animationData) {
    this.setupAnimation(params.animationData);
  } else if (params.path) {
    if (params.path.lastIndexOf('\\') !== -1) {
      this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
    } else {
      this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
    }
    this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
    this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
    dataManager.loadAnimation(
      params.path,
      this.configAnimation,
      this.onSetupError
    );
  }
};

AnimationItem.prototype.onSetupError = function () {
  this.trigger('data_failed');
};

AnimationItem.prototype.setupAnimation = function (data) {
  dataManager.completeAnimation(
    data,
    this.configAnimation
  );
};

AnimationItem.prototype.setData = function (wrapper, animationData) {
  if (animationData) {
    if (typeof animationData !== 'object') {
      animationData = JSON.parse(animationData);
    }
  }
  var params = {
    wrapper: wrapper,
    animationData: animationData,
  };
  var wrapperAttributes = wrapper.attributes;

  params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-animation-path').value
    : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-path').value
      : wrapperAttributes.getNamedItem('bm-path')
        ? wrapperAttributes.getNamedItem('bm-path').value
        : '';
  params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-type').value
    : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-type').value
      : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
        ? wrapperAttributes.getNamedItem('bm-type').value
        : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
          ? wrapperAttributes.getNamedItem('data-bm-renderer').value
          : wrapperAttributes.getNamedItem('bm-renderer')
            ? wrapperAttributes.getNamedItem('bm-renderer').value
            : 'canvas';

  var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-loop').value
    : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-loop').value
      : wrapperAttributes.getNamedItem('bm-loop')
        ? wrapperAttributes.getNamedItem('bm-loop').value
        : '';
  if (loop === 'false') {
    params.loop = false;
  } else if (loop === 'true') {
    params.loop = true;
  } else if (loop !== '') {
    params.loop = parseInt(loop, 10);
  }
  var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value
    : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-autoplay').value
      : wrapperAttributes.getNamedItem('bm-autoplay')
        ? wrapperAttributes.getNamedItem('bm-autoplay').value
        : true;
  params.autoplay = autoplay !== 'false';

  params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-name').value
    : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-name').value
      : wrapperAttributes.getNamedItem('bm-name')
        ? wrapperAttributes.getNamedItem('bm-name').value
        : '';
  var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-prerender').value
    : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-prerender').value
      : wrapperAttributes.getNamedItem('bm-prerender')
        ? wrapperAttributes.getNamedItem('bm-prerender').value
        : '';

  if (prerender === 'false') {
    params.prerender = false;
  }
  this.setParams(params);
};

AnimationItem.prototype.includeLayers = function (data) {
  if (data.op > this.animationData.op) {
    this.animationData.op = data.op;
    this.totalFrames = Math.floor(data.op - this.animationData.ip);
  }
  var layers = this.animationData.layers;
  var i;
  var len = layers.length;
  var newLayers = data.layers;
  var j;
  var jLen = newLayers.length;
  for (j = 0; j < jLen; j += 1) {
    i = 0;
    while (i < len) {
      if (layers[i].id === newLayers[j].id) {
        layers[i] = newLayers[j];
        break;
      }
      i += 1;
    }
  }
  if (data.chars || data.fonts) {
    this.renderer.globalData.fontManager.addChars(data.chars);
    this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
  }
  if (data.assets) {
    len = data.assets.length;
    for (i = 0; i < len; i += 1) {
      this.animationData.assets.push(data.assets[i]);
    }
  }
  this.animationData.__complete = false;
  dataManager.completeAnimation(
    this.animationData,
    this.onSegmentComplete
  );
};

AnimationItem.prototype.onSegmentComplete = function (data) {
  this.animationData = data;
  if (expressionsPlugin) {
    expressionsPlugin.initExpressions(this);
  }
  this.loadNextSegment();
};

AnimationItem.prototype.loadNextSegment = function () {
  var segments = this.animationData.segments;
  if (!segments || segments.length === 0 || !this.autoloadSegments) {
    this.trigger('data_ready');
    this.timeCompleted = this.totalFrames;
    return;
  }
  var segment = segments.shift();
  this.timeCompleted = segment.time * this.frameRate;
  var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
  this.segmentPos += 1;
  dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
    this.trigger('data_failed');
  }.bind(this));
};

AnimationItem.prototype.loadSegments = function () {
  var segments = this.animationData.segments;
  if (!segments) {
    this.timeCompleted = this.totalFrames;
  }
  this.loadNextSegment();
};

AnimationItem.prototype.imagesLoaded = function () {
  this.trigger('loaded_images');
  this.checkLoaded();
};

AnimationItem.prototype.preloadImages = function () {
  this.imagePreloader.setAssetsPath(this.assetsPath);
  this.imagePreloader.setPath(this.path);
  this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
};

AnimationItem.prototype.configAnimation = function (animData) {
  if (!this.renderer) {
    return;
  }
  try {
    this.animationData = animData;
    if (this.initialSegment) {
      this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
      this.firstFrame = Math.round(this.initialSegment[0]);
    } else {
      this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
      this.firstFrame = Math.round(this.animationData.ip);
    }
    this.renderer.configAnimation(animData);
    if (!animData.assets) {
      animData.assets = [];
    }

    this.assets = this.animationData.assets;
    this.frameRate = this.animationData.fr;
    this.frameMult = this.animationData.fr / 1000;
    this.renderer.searchExtraCompositions(animData.assets);
    this.markers = markerParser(animData.markers || []);
    this.trigger('config_ready');
    this.preloadImages();
    this.loadSegments();
    this.updaFrameModifier();
    this.waitForFontsLoaded();
    if (this.isPaused) {
      this.audioController.pause();
    }
  } catch (error) {
    this.triggerConfigError(error);
  }
};

AnimationItem.prototype.waitForFontsLoaded = function () {
  if (!this.renderer) {
    return;
  }
  if (this.renderer.globalData.fontManager.isLoaded) {
    this.checkLoaded();
  } else {
    setTimeout(this.waitForFontsLoaded.bind(this), 20);
  }
};

AnimationItem.prototype.checkLoaded = function () {
  if (!this.isLoaded
        && this.renderer.globalData.fontManager.isLoaded
        && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas')
        && (this.imagePreloader.loadedFootages())
  ) {
    this.isLoaded = true;
    if (expressionsPlugin) {
      expressionsPlugin.initExpressions(this);
    }
    this.renderer.initItems();
    setTimeout(function () {
      this.trigger('DOMLoaded');
    }.bind(this), 0);
    this.gotoFrame();
    if (this.autoplay) {
      this.play();
    }
  }
};

AnimationItem.prototype.resize = function () {
  this.renderer.updateContainerSize();
};

AnimationItem.prototype.setSubframe = function (flag) {
  this.isSubframeEnabled = !!flag;
};

AnimationItem.prototype.gotoFrame = function () {
  this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

  if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
    this.currentFrame = this.timeCompleted;
  }
  this.trigger('enterFrame');
  this.renderFrame();
  this.trigger('drawnFrame');
};

AnimationItem.prototype.renderFrame = function () {
  if (this.isLoaded === false || !this.renderer) {
    return;
  }
  try {
    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
  } catch (error) {
    this.triggerRenderFrameError(error);
  }
};

AnimationItem.prototype.play = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === true) {
    this.isPaused = false;
    this.audioController.resume();
    if (this._idle) {
      this._idle = false;
      this.trigger('_active');
    }
  }
};

AnimationItem.prototype.pause = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === false) {
    this.isPaused = true;
    this._idle = true;
    this.trigger('_idle');
    this.audioController.pause();
  }
};

AnimationItem.prototype.togglePause = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === true) {
    this.play();
  } else {
    this.pause();
  }
};

AnimationItem.prototype.stop = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.pause();
  this.playCount = 0;
  this._completedLoop = false;
  this.setCurrentRawFrameValue(0);
};

AnimationItem.prototype.getMarkerData = function (markerName) {
  var marker;
  for (var i = 0; i < this.markers.length; i += 1) {
    marker = this.markers[i];
    if (marker.payload && marker.payload.name === markerName) {
      return marker;
    }
  }
  return null;
};

AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
  if (name && this.name !== name) {
    return;
  }
  var numValue = Number(value);
  if (isNaN(numValue)) {
    var marker = this.getMarkerData(value);
    if (marker) {
      this.goToAndStop(marker.time, true);
    }
  } else if (isFrame) {
    this.setCurrentRawFrameValue(value);
  } else {
    this.setCurrentRawFrameValue(value * this.frameModifier);
  }
  this.pause();
};

AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
  if (name && this.name !== name) {
    return;
  }
  var numValue = Number(value);
  if (isNaN(numValue)) {
    var marker = this.getMarkerData(value);
    if (marker) {
      if (!marker.duration) {
        this.goToAndStop(marker.time, true);
      } else {
        this.playSegments([marker.time, marker.time + marker.duration], true);
      }
    }
  } else {
    this.goToAndStop(numValue, isFrame, name);
  }
  this.play();
};

AnimationItem.prototype.advanceTime = function (value) {
  if (this.isPaused === true || this.isLoaded === false) {
    return;
  }
  var nextValue = this.currentRawFrame + value * this.frameModifier;
  var _isComplete = false;
  // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
  // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
  if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
    if (!this.loop || this.playCount === this.loop) {
      if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
        _isComplete = true;
        nextValue = this.totalFrames - 1;
      }
    } else if (nextValue >= this.totalFrames) {
      this.playCount += 1;
      if (!this.checkSegments(nextValue % this.totalFrames)) {
        this.setCurrentRawFrameValue(nextValue % this.totalFrames);
        this._completedLoop = true;
        this.trigger('loopComplete');
      }
    } else {
      this.setCurrentRawFrameValue(nextValue);
    }
  } else if (nextValue < 0) {
    if (!this.checkSegments(nextValue % this.totalFrames)) {
      if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) { // eslint-disable-line no-plusplus
        this.setCurrentRawFrameValue(this.totalFrames + (nextValue % this.totalFrames));
        if (!this._completedLoop) {
          this._completedLoop = true;
        } else {
          this.trigger('loopComplete');
        }
      } else {
        _isComplete = true;
        nextValue = 0;
      }
    }
  } else {
    this.setCurrentRawFrameValue(nextValue);
  }
  if (_isComplete) {
    this.setCurrentRawFrameValue(nextValue);
    this.pause();
    this.trigger('complete');
  }
};

AnimationItem.prototype.adjustSegment = function (arr, offset) {
  this.playCount = 0;
  if (arr[1] < arr[0]) {
    if (this.frameModifier > 0) {
      if (this.playSpeed < 0) {
        this.setSpeed(-this.playSpeed);
      } else {
        this.setDirection(-1);
      }
    }
    this.totalFrames = arr[0] - arr[1];
    this.timeCompleted = this.totalFrames;
    this.firstFrame = arr[1];
    this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
  } else if (arr[1] > arr[0]) {
    if (this.frameModifier < 0) {
      if (this.playSpeed < 0) {
        this.setSpeed(-this.playSpeed);
      } else {
        this.setDirection(1);
      }
    }
    this.totalFrames = arr[1] - arr[0];
    this.timeCompleted = this.totalFrames;
    this.firstFrame = arr[0];
    this.setCurrentRawFrameValue(0.001 + offset);
  }
  this.trigger('segmentStart');
};
AnimationItem.prototype.setSegment = function (init, end) {
  var pendingFrame = -1;
  if (this.isPaused) {
    if (this.currentRawFrame + this.firstFrame < init) {
      pendingFrame = init;
    } else if (this.currentRawFrame + this.firstFrame > end) {
      pendingFrame = end - init;
    }
  }

  this.firstFrame = init;
  this.totalFrames = end - init;
  this.timeCompleted = this.totalFrames;
  if (pendingFrame !== -1) {
    this.goToAndStop(pendingFrame, true);
  }
};

AnimationItem.prototype.playSegments = function (arr, forceFlag) {
  if (forceFlag) {
    this.segments.length = 0;
  }
  if (typeof arr[0] === 'object') {
    var i;
    var len = arr.length;
    for (i = 0; i < len; i += 1) {
      this.segments.push(arr[i]);
    }
  } else {
    this.segments.push(arr);
  }
  if (this.segments.length && forceFlag) {
    this.adjustSegment(this.segments.shift(), 0);
  }
  if (this.isPaused) {
    this.play();
  }
};

AnimationItem.prototype.resetSegments = function (forceFlag) {
  this.segments.length = 0;
  this.segments.push([this.animationData.ip, this.animationData.op]);
  if (forceFlag) {
    this.checkSegments(0);
  }
};
AnimationItem.prototype.checkSegments = function (offset) {
  if (this.segments.length) {
    this.adjustSegment(this.segments.shift(), offset);
    return true;
  }
  return false;
};

AnimationItem.prototype.destroy = function (name) {
  if ((name && this.name !== name) || !this.renderer) {
    return;
  }
  this.renderer.destroy();
  this.imagePreloader.destroy();
  this.trigger('destroy');
  this._cbs = null;
  this.onEnterFrame = null;
  this.onLoopComplete = null;
  this.onComplete = null;
  this.onSegmentStart = null;
  this.onDestroy = null;
  this.renderer = null;
  this.renderer = null;
  this.imagePreloader = null;
  this.projectInterface = null;
};

AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
  this.currentRawFrame = value;
  this.gotoFrame();
};

AnimationItem.prototype.setSpeed = function (val) {
  this.playSpeed = val;
  this.updaFrameModifier();
};

AnimationItem.prototype.setDirection = function (val) {
  this.playDirection = val < 0 ? -1 : 1;
  this.updaFrameModifier();
};

AnimationItem.prototype.setVolume = function (val, name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.setVolume(val);
};

AnimationItem.prototype.getVolume = function () {
  return this.audioController.getVolume();
};

AnimationItem.prototype.mute = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.mute();
};

AnimationItem.prototype.unmute = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.unmute();
};

AnimationItem.prototype.updaFrameModifier = function () {
  this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
  this.audioController.setRate(this.playSpeed * this.playDirection);
};

AnimationItem.prototype.getPath = function () {
  return this.path;
};

AnimationItem.prototype.getAssetsPath = function (assetData) {
  var path = '';
  if (assetData.e) {
    path = assetData.p;
  } else if (this.assetsPath) {
    var imagePath = assetData.p;
    if (imagePath.indexOf('images/') !== -1) {
      imagePath = imagePath.split('/')[1];
    }
    path = this.assetsPath + imagePath;
  } else {
    path = this.path;
    path += assetData.u ? assetData.u : '';
    path += assetData.p;
  }
  return path;
};

AnimationItem.prototype.getAssetData = function (id) {
  var i = 0;
  var len = this.assets.length;
  while (i < len) {
    if (id === this.assets[i].id) {
      return this.assets[i];
    }
    i += 1;
  }
  return null;
};

AnimationItem.prototype.hide = function () {
  this.renderer.hide();
};

AnimationItem.prototype.show = function () {
  this.renderer.show();
};

AnimationItem.prototype.getDuration = function (isFrame) {
  return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
};

AnimationItem.prototype.trigger = function (name) {
  if (this._cbs && this._cbs[name]) {
    switch (name) {
      case 'enterFrame':
      case 'drawnFrame':
        this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
        break;
      case 'loopComplete':
        this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        break;
      case 'complete':
        this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
        break;
      case 'segmentStart':
        this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        break;
      case 'destroy':
        this.triggerEvent(name, new BMDestroyEvent(name, this));
        break;
      default:
        this.triggerEvent(name);
    }
  }
  if (name === 'enterFrame' && this.onEnterFrame) {
    this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
  }
  if (name === 'loopComplete' && this.onLoopComplete) {
    this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
  }
  if (name === 'complete' && this.onComplete) {
    this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
  }
  if (name === 'segmentStart' && this.onSegmentStart) {
    this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
  }
  if (name === 'destroy' && this.onDestroy) {
    this.onDestroy.call(this, new BMDestroyEvent(name, this));
  }
};

AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
  var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
  this.triggerEvent('error', error);

  if (this.onError) {
    this.onError.call(this, error);
  }
};

AnimationItem.prototype.triggerConfigError = function (nativeError) {
  var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
  this.triggerEvent('error', error);

  if (this.onError) {
    this.onError.call(this, error);
  }
};

/* global CompExpressionInterface, expressionsPlugin: writable */
/* exported expressionsPlugin */

var Expressions = (function () {
  var ob = {};
  ob.initExpressions = initExpressions;

  function initExpressions(animation) {
    var stackCount = 0;
    var registers = [];

    function pushExpression() {
      stackCount += 1;
    }

    function popExpression() {
      stackCount -= 1;
      if (stackCount === 0) {
        releaseInstances();
      }
    }

    function registerExpressionProperty(expression) {
      if (registers.indexOf(expression) === -1) {
        registers.push(expression);
      }
    }

    function releaseInstances() {
      var i;
      var len = registers.length;
      for (i = 0; i < len; i += 1) {
        registers[i].release();
      }
      registers.length = 0;
    }

    animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
    animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
    animation.renderer.globalData.pushExpression = pushExpression;
    animation.renderer.globalData.popExpression = popExpression;
    animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
  }
  return ob;
}());

expressionsPlugin = Expressions;

/* eslint-disable camelcase, no-unused-vars */
/* global BMMath, BezierFactory, createTypedArray, degToRads, shapePool */

var ExpressionManager = (function () {
  'use strict';

  var ob = {};
  var Math = BMMath;
  var window = null;
  var document = null;
  var XMLHttpRequest = null;
  var fetch = null;
  var frames = null;

  function $bm_isInstanceOfArray(arr) {
    return arr.constructor === Array || arr.constructor === Float32Array;
  }

  function isNumerable(tOfV, v) {
    return tOfV === 'number' || tOfV === 'boolean' || tOfV === 'string' || v instanceof Number;
  }

  function $bm_neg(a) {
    var tOfA = typeof a;
    if (tOfA === 'number' || tOfA === 'boolean' || a instanceof Number) {
      return -a;
    }
    if ($bm_isInstanceOfArray(a)) {
      var i;
      var lenA = a.length;
      var retArr = [];
      for (i = 0; i < lenA; i += 1) {
        retArr[i] = -a[i];
      }
      return retArr;
    }
    if (a.propType) {
      return a.v;
    }
    return -a;
  }

  var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
  var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
  var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;

  function sum(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    if (tOfA === 'string' || tOfB === 'string') {
      return a + b;
    }
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      return a + b;
    }
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      a = a.slice(0);
      a[0] += b;
      return a;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      b = b.slice(0);
      b[0] = a + b[0];
      return b;
    }
    if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
      var i = 0;
      var lenA = a.length;
      var lenB = b.length;
      var retArr = [];
      while (i < lenA || i < lenB) {
        if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
          retArr[i] = a[i] + b[i];
        } else {
          retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
        }
        i += 1;
      }
      return retArr;
    }
    return 0;
  }
  var add = sum;

  function sub(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      if (tOfA === 'string') {
        a = parseInt(a, 10);
      }
      if (tOfB === 'string') {
        b = parseInt(b, 10);
      }
      return a - b;
    }
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      a = a.slice(0);
      a[0] -= b;
      return a;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      b = b.slice(0);
      b[0] = a - b[0];
      return b;
    }
    if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
      var i = 0;
      var lenA = a.length;
      var lenB = b.length;
      var retArr = [];
      while (i < lenA || i < lenB) {
        if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
          retArr[i] = a[i] - b[i];
        } else {
          retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
        }
        i += 1;
      }
      return retArr;
    }
    return 0;
  }

  function mul(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    var arr;
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      return a * b;
    }

    var i;
    var len;
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      len = a.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a[i] * b;
      }
      return arr;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      len = b.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a * b[i];
      }
      return arr;
    }
    return 0;
  }

  function div(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    var arr;
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      return a / b;
    }
    var i;
    var len;
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      len = a.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a[i] / b;
      }
      return arr;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      len = b.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a / b[i];
      }
      return arr;
    }
    return 0;
  }
  function mod(a, b) {
    if (typeof a === 'string') {
      a = parseInt(a, 10);
    }
    if (typeof b === 'string') {
      b = parseInt(b, 10);
    }
    return a % b;
  }
  var $bm_sum = sum;
  var $bm_sub = sub;
  var $bm_mul = mul;
  var $bm_div = div;
  var $bm_mod = mod;

  function clamp(num, min, max) {
    if (min > max) {
      var mm = max;
      max = min;
      min = mm;
    }
    return Math.min(Math.max(num, min), max);
  }

  function radiansToDegrees(val) {
    return val / degToRads;
  }
  var radians_to_degrees = radiansToDegrees;

  function degreesToRadians(val) {
    return val * degToRads;
  }
  var degrees_to_radians = radiansToDegrees;

  var helperLengthArray = [0, 0, 0, 0, 0, 0];

  function length(arr1, arr2) {
    if (typeof arr1 === 'number' || arr1 instanceof Number) {
      arr2 = arr2 || 0;
      return Math.abs(arr1 - arr2);
    }
    if (!arr2) {
      arr2 = helperLengthArray;
    }
    var i;
    var len = Math.min(arr1.length, arr2.length);
    var addedLength = 0;
    for (i = 0; i < len; i += 1) {
      addedLength += Math.pow(arr2[i] - arr1[i], 2);
    }
    return Math.sqrt(addedLength);
  }

  function normalize(vec) {
    return div(vec, length(vec));
  }

  function rgbToHsl(val) {
    var r = val[0]; var g = val[1]; var b = val[2];
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h;
    var s;
    var l = (max + min) / 2;

    if (max === min) {
      h = 0; // achromatic
      s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
        default: break;
      }
      h /= 6;
    }

    return [h, s, l, val[3]];
  }

  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  function hslToRgb(val) {
    var h = val[0];
    var s = val[1];
    var l = val[2];

    var r;
    var g;
    var b;

    if (s === 0) {
      r = l; // achromatic
      b = l; // achromatic
      g = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [r, g, b, val[3]];
  }

  function linear(t, tMin, tMax, value1, value2) {
    if (value1 === undefined || value2 === undefined) {
      value1 = tMin;
      value2 = tMax;
      tMin = 0;
      tMax = 1;
    }
    if (tMax < tMin) {
      var _tMin = tMax;
      tMax = tMin;
      tMin = _tMin;
    }
    if (t <= tMin) {
      return value1;
    } if (t >= tMax) {
      return value2;
    }
    var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
    if (!value1.length) {
      return value1 + (value2 - value1) * perc;
    }
    var i;
    var len = value1.length;
    var arr = createTypedArray('float32', len);
    for (i = 0; i < len; i += 1) {
      arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
    }
    return arr;
  }
  function random(min, max) {
    if (max === undefined) {
      if (min === undefined) {
        min = 0;
        max = 1;
      } else {
        max = min;
        min = undefined;
      }
    }
    if (max.length) {
      var i;
      var len = max.length;
      if (!min) {
        min = createTypedArray('float32', len);
      }
      var arr = createTypedArray('float32', len);
      var rnd = BMMath.random();
      for (i = 0; i < len; i += 1) {
        arr[i] = min[i] + rnd * (max[i] - min[i]);
      }
      return arr;
    }
    if (min === undefined) {
      min = 0;
    }
    var rndm = BMMath.random();
    return min + rndm * (max - min);
  }

  function createPath(points, inTangents, outTangents, closed) {
    var i;
    var len = points.length;
    var path = shapePool.newElement();
    path.setPathData(!!closed, len);
    var arrPlaceholder = [0, 0];
    var inVertexPoint;
    var outVertexPoint;
    for (i = 0; i < len; i += 1) {
      inVertexPoint = (inTangents && inTangents[i]) ? inTangents[i] : arrPlaceholder;
      outVertexPoint = (outTangents && outTangents[i]) ? outTangents[i] : arrPlaceholder;
      path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
    }
    return path;
  }

  function initiateExpression(elem, data, property) {
    var val = data.x;
    var needsVelocity = /velocity(?![\w\d])/.test(val);
    var _needsRandom = val.indexOf('random') !== -1;
    var elemType = elem.data.ty;
    var transform;
    var $bm_transform;
    var content;
    var effect;
    var thisProperty = property;
    thisProperty.valueAtTime = thisProperty.getValueAtTime;
    Object.defineProperty(thisProperty, 'value', {
      get: function () {
        return thisProperty.v;
      },
    });
    elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
    elem.comp.displayStartTime = 0;
    var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
    var outPoint = elem.data.op / elem.comp.globalData.frameRate;
    var width = elem.data.sw ? elem.data.sw : 0;
    var height = elem.data.sh ? elem.data.sh : 0;
    var name = elem.data.nm;
    var loopIn;
    var loop_in;
    var loopOut;
    var loop_out;
    var smooth;
    var toWorld;
    var fromWorld;
    var fromComp;
    var toComp;
    var fromCompToSurface;
    var position;
    var rotation;
    var anchorPoint;
    var scale;
    var thisLayer;
    var thisComp;
    var mask;
    var valueAtTime;
    var velocityAtTime;

    var scoped_bm_rt;
    // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
    var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
    var numKeys = property.kf ? data.k.length : 0;

    var active = !this.data || this.data.hd !== true;

    var wiggle = function wiggle(freq, amp) {
      var iWiggle;
      var j;
      var lenWiggle = this.pv.length ? this.pv.length : 1;
      var addedAmps = createTypedArray('float32', lenWiggle);
      freq = 5;
      var iterations = Math.floor(time * freq);
      iWiggle = 0;
      j = 0;
      while (iWiggle < iterations) {
        // var rnd = BMMath.random();
        for (j = 0; j < lenWiggle; j += 1) {
          addedAmps[j] += -amp + amp * 2 * BMMath.random();
          // addedAmps[j] += -amp + amp*2*rnd;
        }
        iWiggle += 1;
      }
      // var rnd2 = BMMath.random();
      var periods = time * freq;
      var perc = periods - Math.floor(periods);
      var arr = createTypedArray('float32', lenWiggle);
      if (lenWiggle > 1) {
        for (j = 0; j < lenWiggle; j += 1) {
          arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc;
          // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
          // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
        }
        return arr;
      }
      return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
    }.bind(this);

    if (thisProperty.loopIn) {
      loopIn = thisProperty.loopIn.bind(thisProperty);
      loop_in = loopIn;
    }

    if (thisProperty.loopOut) {
      loopOut = thisProperty.loopOut.bind(thisProperty);
      loop_out = loopOut;
    }

    if (thisProperty.smooth) {
      smooth = thisProperty.smooth.bind(thisProperty);
    }

    function loopInDuration(type, duration) {
      return loopIn(type, duration, true);
    }

    function loopOutDuration(type, duration) {
      return loopOut(type, duration, true);
    }

    if (this.getValueAtTime) {
      valueAtTime = this.getValueAtTime.bind(this);
    }

    if (this.getVelocityAtTime) {
      velocityAtTime = this.getVelocityAtTime.bind(this);
    }

    var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

    function lookAt(elem1, elem2) {
      var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
      var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
      var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
      return [yaw, pitch, 0];
    }

    function easeOut(t, tMin, tMax, val1, val2) {
      return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
    }

    function easeIn(t, tMin, tMax, val1, val2) {
      return applyEase(easeInBez, t, tMin, tMax, val1, val2);
    }

    function ease(t, tMin, tMax, val1, val2) {
      return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
    }

    function applyEase(fn, t, tMin, tMax, val1, val2) {
      if (val1 === undefined) {
        val1 = tMin;
        val2 = tMax;
      } else {
        t = (t - tMin) / (tMax - tMin);
      }
      if (t > 1) {
        t = 1;
      } else if (t < 0) {
        t = 0;
      }
      var mult = fn(t);
      if ($bm_isInstanceOfArray(val1)) {
        var iKey;
        var lenKey = val1.length;
        var arr = createTypedArray('float32', lenKey);
        for (iKey = 0; iKey < lenKey; iKey += 1) {
          arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
        }
        return arr;
      }
      return (val2 - val1) * mult + val1;
    }

    function nearestKey(time) {
      var iKey;
      var lenKey = data.k.length;
      var index;
      var keyTime;
      if (!data.k.length || typeof (data.k[0]) === 'number') {
        index = 0;
        keyTime = 0;
      } else {
        index = -1;
        time *= elem.comp.globalData.frameRate;
        if (time < data.k[0].t) {
          index = 1;
          keyTime = data.k[0].t;
        } else {
          for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
            if (time === data.k[iKey].t) {
              index = iKey + 1;
              keyTime = data.k[iKey].t;
              break;
            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
              if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                index = iKey + 2;
                keyTime = data.k[iKey + 1].t;
              } else {
                index = iKey + 1;
                keyTime = data.k[iKey].t;
              }
              break;
            }
          }
          if (index === -1) {
            index = iKey + 1;
            keyTime = data.k[iKey].t;
          }
        }
      }
      var obKey = {};
      obKey.index = index;
      obKey.time = keyTime / elem.comp.globalData.frameRate;
      return obKey;
    }

    function key(ind) {
      var obKey;
      var iKey;
      var lenKey;
      if (!data.k.length || typeof (data.k[0]) === 'number') {
        throw new Error('The property has no keyframe at index ' + ind);
      }
      ind -= 1;
      obKey = {
        time: data.k[ind].t / elem.comp.globalData.frameRate,
        value: [],
      };
      var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;

      lenKey = arr.length;
      for (iKey = 0; iKey < lenKey; iKey += 1) {
        obKey[iKey] = arr[iKey];
        obKey.value[iKey] = arr[iKey];
      }
      return obKey;
    }

    function framesToTime(fr, fps) {
      if (!fps) {
        fps = elem.comp.globalData.frameRate;
      }
      return fr / fps;
    }

    function timeToFrames(t, fps) {
      if (!t && t !== 0) {
        t = time;
      }
      if (!fps) {
        fps = elem.comp.globalData.frameRate;
      }
      return t * fps;
    }

    function seedRandom(seed) {
      BMMath.seedrandom(randSeed + seed);
    }

    function sourceRectAtTime() {
      return elem.sourceRectAtTime();
    }

    function substring(init, end) {
      if (typeof value === 'string') {
        if (end === undefined) {
          return value.substring(init);
        }
        return value.substring(init, end);
      }
      return '';
    }

    function substr(init, end) {
      if (typeof value === 'string') {
        if (end === undefined) {
          return value.substr(init);
        }
        return value.substr(init, end);
      }
      return '';
    }

    function posterizeTime(framesPerSecond) {
      time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
      value = valueAtTime(time);
    }

    var time;
    var velocity;
    var value;
    var text;
    var textIndex;
    var textTotal;
    var selectorValue;
    var index = elem.data.ind;
    var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
    var parent;
    var randSeed = Math.floor(Math.random() * 1000000);
    var globalData = elem.globalData;
    function executeExpression(_value) {
      // globalData.pushExpression();
      value = _value;
      if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
        return value;
      }
      if (this.propType === 'textSelector') {
        textIndex = this.textIndex;
        textTotal = this.textTotal;
        selectorValue = this.selectorValue;
      }
      if (!thisLayer) {
        text = elem.layerInterface.text;
        thisLayer = elem.layerInterface;
        thisComp = elem.comp.compInterface;
        toWorld = thisLayer.toWorld.bind(thisLayer);
        fromWorld = thisLayer.fromWorld.bind(thisLayer);
        fromComp = thisLayer.fromComp.bind(thisLayer);
        toComp = thisLayer.toComp.bind(thisLayer);
        mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
        fromCompToSurface = fromComp;
      }
      if (!transform) {
        transform = elem.layerInterface('ADBE Transform Group');
        $bm_transform = transform;
        if (transform) {
          anchorPoint = transform.anchorPoint;
          /* position = transform.position;
                    rotation = transform.rotation;
                    scale = transform.scale; */
        }
      }

      if (elemType === 4 && !content) {
        content = thisLayer('ADBE Root Vectors Group');
      }
      if (!effect) {
        effect = thisLayer(4);
      }
      hasParent = !!(elem.hierarchy && elem.hierarchy.length);
      if (hasParent && !parent) {
        parent = elem.hierarchy[0].layerInterface;
      }
      time = this.comp.renderedFrame / this.comp.globalData.frameRate;
      if (_needsRandom) {
        seedRandom(randSeed + time);
      }
      if (needsVelocity) {
        velocity = velocityAtTime(time);
      }
      expression_function();
      this.frameExpressionId = elem.globalData.frameId;

      // TODO: Check if it's possible to return on ShapeInterface the .v value
      if (scoped_bm_rt.propType === 'shape') {
        scoped_bm_rt = scoped_bm_rt.v;
      }
      // globalData.popExpression();
      return scoped_bm_rt;
    }
    return executeExpression;
  }

  ob.initiateExpression = initiateExpression;
  return ob;
}());

/* global ExpressionManager, createTypedArray */
/* exported expressionHelpers */

var expressionHelpers = (function () {
  function searchExpressions(elem, data, prop) {
    if (data.x) {
      prop.k = true;
      prop.x = true;
      prop.initiateExpression = ExpressionManager.initiateExpression;
      prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
    }
  }

  function getValueAtTime(frameNum) {
    frameNum *= this.elem.globalData.frameRate;
    frameNum -= this.offsetTime;
    if (frameNum !== this._cachingAtTime.lastFrame) {
      this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
      this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
      this._cachingAtTime.lastFrame = frameNum;
    }
    return this._cachingAtTime.value;
  }

  function getSpeedAtTime(frameNum) {
    var delta = -0.01;
    var v1 = this.getValueAtTime(frameNum);
    var v2 = this.getValueAtTime(frameNum + delta);
    var speed = 0;
    if (v1.length) {
      var i;
      for (i = 0; i < v1.length; i += 1) {
        speed += Math.pow(v2[i] - v1[i], 2);
      }
      speed = Math.sqrt(speed) * 100;
    } else {
      speed = 0;
    }
    return speed;
  }

  function getVelocityAtTime(frameNum) {
    if (this.vel !== undefined) {
      return this.vel;
    }
    var delta = -0.001;
    // frameNum += this.elem.data.st;
    var v1 = this.getValueAtTime(frameNum);
    var v2 = this.getValueAtTime(frameNum + delta);
    var velocity;
    if (v1.length) {
      velocity = createTypedArray('float32', v1.length);
      var i;
      for (i = 0; i < v1.length; i += 1) {
        // removing frameRate
        // if needed, don't add it here
        // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
        velocity[i] = (v2[i] - v1[i]) / delta;
      }
    } else {
      velocity = (v2 - v1) / delta;
    }
    return velocity;
  }

  function getStaticValueAtTime() {
    return this.pv;
  }

  function setGroupProperty(propertyGroup) {
    this.propertyGroup = propertyGroup;
  }

  return {
    searchExpressions: searchExpressions,
    getSpeedAtTime: getSpeedAtTime,
    getVelocityAtTime: getVelocityAtTime,
    getValueAtTime: getValueAtTime,
    getStaticValueAtTime: getStaticValueAtTime,
    setGroupProperty: setGroupProperty,
  };
}());

/* global createTypedArray, Matrix, TransformPropertyFactory, expressionHelpers, PropertyFactory, expressionHelpers,
initialDefaultFrame, shapePool, ShapePropertyFactory, bez, extendPrototype, ExpressionManager, createSizedArray */

(function addPropertyDecorator() {
  function loopOut(type, duration, durationFlag) {
    if (!this.k || !this.keyframes) {
      return this.pv;
    }
    type = type ? type.toLowerCase() : '';
    var currentFrame = this.comp.renderedFrame;
    var keyframes = this.keyframes;
    var lastKeyFrame = keyframes[keyframes.length - 1].t;
    if (currentFrame <= lastKeyFrame) {
      return this.pv;
    }
    var cycleDuration;
    var firstKeyFrame;
    if (!durationFlag) {
      if (!duration || duration > keyframes.length - 1) {
        duration = keyframes.length - 1;
      }
      firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
      cycleDuration = lastKeyFrame - firstKeyFrame;
    } else {
      if (!duration) {
        cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
      } else {
        cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
      }
      firstKeyFrame = lastKeyFrame - cycleDuration;
    }
    var i;
    var len;
    var ret;
    if (type === 'pingpong') {
      var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
      if (iterations % 2 !== 0) {
          return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      }
    } else if (type === 'offset') {
      var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
      if (this.pv.length) {
        ret = new Array(initV.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = (endV[i] - initV[i]) * repeats + current[i];
        }
        return ret;
      }
      return (endV - initV) * repeats + current;
    } else if (type === 'continue') {
      var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
      var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        ret = new Array(lastValue.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
        }
        return ret;
      }
      return lastValue + (lastValue - nextLastValue) * (((currentFrame - lastKeyFrame)) / 0.001);
    }
      return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line

  }

  function loopIn(type, duration, durationFlag) {
    if (!this.k) {
      return this.pv;
    }
    type = type ? type.toLowerCase() : '';
    var currentFrame = this.comp.renderedFrame;
    var keyframes = this.keyframes;
    var firstKeyFrame = keyframes[0].t;
    if (currentFrame >= firstKeyFrame) {
      return this.pv;
    }
    var cycleDuration;
    var lastKeyFrame;
    if (!durationFlag) {
      if (!duration || duration > keyframes.length - 1) {
        duration = keyframes.length - 1;
      }
      lastKeyFrame = keyframes[duration].t;
      cycleDuration = lastKeyFrame - firstKeyFrame;
    } else {
      if (!duration) {
        cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
      } else {
        cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
      }
      lastKeyFrame = firstKeyFrame + cycleDuration;
    }
    var i;
    var len;
    var ret;
    if (type === 'pingpong') {
      var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
      if (iterations % 2 === 0) {
          return this.getValueAtTime((((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      }
    } else if (type === 'offset') {
      var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
      var current = this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration) + firstKeyFrame) / this.comp.globalData.frameRate, 0);
      var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
      if (this.pv.length) {
        ret = new Array(initV.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
        }
        return ret;
      }
      return current - (endV - initV) * repeats;
    } else if (type === 'continue') {
      var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        ret = new Array(firstValue.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = firstValue[i] + ((firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame)) / 0.001;
        }
        return ret;
      }
      return firstValue + ((firstValue - nextFirstValue) * (firstKeyFrame - currentFrame)) / 0.001;
    }
      return this.getValueAtTime(((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame))) / this.comp.globalData.frameRate, 0); // eslint-disable-line

  }

  function smooth(width, samples) {
    if (!this.k) {
      return this.pv;
    }
    width = (width || 0.4) * 0.5;
    samples = Math.floor(samples || 5);
    if (samples <= 1) {
      return this.pv;
    }
    var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
    var initFrame = currentTime - width;
    var endFrame = currentTime + width;
    var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
    var i = 0;
    var j = 0;
    var value;
    if (this.pv.length) {
      value = createTypedArray('float32', this.pv.length);
    } else {
      value = 0;
    }
    var sampleValue;
    while (i < samples) {
      sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
      if (this.pv.length) {
        for (j = 0; j < this.pv.length; j += 1) {
          value[j] += sampleValue[j];
        }
      } else {
        value += sampleValue;
      }
      i += 1;
    }
    if (this.pv.length) {
      for (j = 0; j < this.pv.length; j += 1) {
        value[j] /= samples;
      }
    } else {
      value /= samples;
    }
    return value;
  }

  function getTransformValueAtTime(time) {
    if (!this._transformCachingAtTime) {
      this._transformCachingAtTime = {
        v: new Matrix(),
      };
    }
    /// /
    var matrix = this._transformCachingAtTime.v;
    matrix.cloneFromProps(this.pre.props);
    if (this.appliedTransformations < 1) {
      var anchor = this.a.getValueAtTime(time);
      matrix.translate(
        -anchor[0] * this.a.mult,
        -anchor[1] * this.a.mult,
        anchor[2] * this.a.mult
      );
    }
    if (this.appliedTransformations < 2) {
      var scale = this.s.getValueAtTime(time);
      matrix.scale(
        scale[0] * this.s.mult,
        scale[1] * this.s.mult,
        scale[2] * this.s.mult
      );
    }
    if (this.sk && this.appliedTransformations < 3) {
      var skew = this.sk.getValueAtTime(time);
      var skewAxis = this.sa.getValueAtTime(time);
      matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
    }
    if (this.r && this.appliedTransformations < 4) {
      var rotation = this.r.getValueAtTime(time);
      matrix.rotate(-rotation * this.r.mult);
    } else if (!this.r && this.appliedTransformations < 4) {
      var rotationZ = this.rz.getValueAtTime(time);
      var rotationY = this.ry.getValueAtTime(time);
      var rotationX = this.rx.getValueAtTime(time);
      var orientation = this.or.getValueAtTime(time);
      matrix.rotateZ(-rotationZ * this.rz.mult)
        .rotateY(rotationY * this.ry.mult)
        .rotateX(rotationX * this.rx.mult)
        .rotateZ(-orientation[2] * this.or.mult)
        .rotateY(orientation[1] * this.or.mult)
        .rotateX(orientation[0] * this.or.mult);
    }
    if (this.data.p && this.data.p.s) {
      var positionX = this.px.getValueAtTime(time);
      var positionY = this.py.getValueAtTime(time);
      if (this.data.p.z) {
        var positionZ = this.pz.getValueAtTime(time);
        matrix.translate(
          positionX * this.px.mult,
          positionY * this.py.mult,
          -positionZ * this.pz.mult
        );
      } else {
        matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
      }
    } else {
      var position = this.p.getValueAtTime(time);
      matrix.translate(
        position[0] * this.p.mult,
        position[1] * this.p.mult,
        -position[2] * this.p.mult
      );
    }
    return matrix;
    /// /
  }

  function getTransformStaticValueAtTime() {
    return this.v.clone(new Matrix());
  }

  var getTransformProperty = TransformPropertyFactory.getTransformProperty;
  TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
    var prop = getTransformProperty(elem, data, container);
    if (prop.dynamicProperties.length) {
      prop.getValueAtTime = getTransformValueAtTime.bind(prop);
    } else {
      prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
    }
    prop.setGroupProperty = expressionHelpers.setGroupProperty;
    return prop;
  };

  var propertyGetProp = PropertyFactory.getProp;
  PropertyFactory.getProp = function (elem, data, type, mult, container) {
    var prop = propertyGetProp(elem, data, type, mult, container);
    // prop.getVelocityAtTime = getVelocityAtTime;
    // prop.loopOut = loopOut;
    // prop.loopIn = loopIn;
    if (prop.kf) {
      prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
    } else {
      prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
    }
    prop.setGroupProperty = expressionHelpers.setGroupProperty;
    prop.loopOut = loopOut;
    prop.loopIn = loopIn;
    prop.smooth = smooth;
    prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
    prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
    prop.numKeys = data.a === 1 ? data.k.length : 0;
    prop.propertyIndex = data.ix;
    var value = 0;
    if (type !== 0) {
      value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
    }
    prop._cachingAtTime = {
      lastFrame: initialDefaultFrame,
      lastIndex: 0,
      value: value,
    };
    expressionHelpers.searchExpressions(elem, data, prop);
    if (prop.k) {
      container.addDynamicProperty(prop);
    }

    return prop;
  };

  function getShapeValueAtTime(frameNum) {
    // For now this caching object is created only when needed instead of creating it when the shape is initialized.
    if (!this._cachingAtTime) {
      this._cachingAtTime = {
        shapeValue: shapePool.clone(this.pv),
        lastIndex: 0,
        lastTime: initialDefaultFrame,
      };
    }

    frameNum *= this.elem.globalData.frameRate;
    frameNum -= this.offsetTime;
    if (frameNum !== this._cachingAtTime.lastTime) {
      this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
      this._cachingAtTime.lastTime = frameNum;
      this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
    }
    return this._cachingAtTime.shapeValue;
  }

  var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
  var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

  function ShapeExpressions() {}
  ShapeExpressions.prototype = {
    vertices: function (prop, time) {
      if (this.k) {
        this.getValue();
      }
      var shapePath = this.v;
      if (time !== undefined) {
        shapePath = this.getValueAtTime(time, 0);
      }
      var i;
      var len = shapePath._length;
      var vertices = shapePath[prop];
      var points = shapePath.v;
      var arr = createSizedArray(len);
      for (i = 0; i < len; i += 1) {
        if (prop === 'i' || prop === 'o') {
          arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
        } else {
          arr[i] = [vertices[i][0], vertices[i][1]];
        }
      }
      return arr;
    },
    points: function (time) {
      return this.vertices('v', time);
    },
    inTangents: function (time) {
      return this.vertices('i', time);
    },
    outTangents: function (time) {
      return this.vertices('o', time);
    },
    isClosed: function () {
      return this.v.c;
    },
    pointOnPath: function (perc, time) {
      var shapePath = this.v;
      if (time !== undefined) {
        shapePath = this.getValueAtTime(time, 0);
      }
      if (!this._segmentsLength) {
        this._segmentsLength = bez.getSegmentsLength(shapePath);
      }

      var segmentsLength = this._segmentsLength;
      var lengths = segmentsLength.lengths;
      var lengthPos = segmentsLength.totalLength * perc;
      var i = 0;
      var len = lengths.length;
      var accumulatedLength = 0;
      var pt;
      while (i < len) {
        if (accumulatedLength + lengths[i].addedLength > lengthPos) {
          var initIndex = i;
          var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
          var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
          pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
          break;
        } else {
          accumulatedLength += lengths[i].addedLength;
        }
        i += 1;
      }
      if (!pt) {
        pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
      }
      return pt;
    },
    vectorOnPath: function (perc, time, vectorType) {
      // perc doesn't use triple equality because it can be a Number object as well as a primitive.
      if (perc == 1) { // eslint-disable-line eqeqeq
        perc = this.v.c;
      } else if (perc == 0) { // eslint-disable-line eqeqeq
        perc = 0.999;
      }
      var pt1 = this.pointOnPath(perc, time);
      var pt2 = this.pointOnPath(perc + 0.001, time);
      var xLength = pt2[0] - pt1[0];
      var yLength = pt2[1] - pt1[1];
      var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
      if (magnitude === 0) {
        return [0, 0];
      }
      var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
      return unitVector;
    },
    tangentOnPath: function (perc, time) {
      return this.vectorOnPath(perc, time, 'tangent');
    },
    normalOnPath: function (perc, time) {
      return this.vectorOnPath(perc, time, 'normal');
    },
    setGroupProperty: expressionHelpers.setGroupProperty,
    getValueAtTime: expressionHelpers.getStaticValueAtTime,
  };
  extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
  extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
  KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
  KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;

  var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
  ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
    var prop = propertyGetShapeProp(elem, data, type, arr, trims);
    prop.propertyIndex = data.ix;
    prop.lock = false;
    if (type === 3) {
      expressionHelpers.searchExpressions(elem, data.pt, prop);
    } else if (type === 4) {
      expressionHelpers.searchExpressions(elem, data.ks, prop);
    }
    if (prop.k) {
      elem.addDynamicProperty(prop);
    }
    return prop;
  };
}());

/* global ExpressionManager, TextProperty */

(function addDecorator() {
  function searchExpressions() {
    if (this.data.d.x) {
      this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
      this.addEffect(this.getExpressionValue.bind(this));
      return true;
    }
    return null;
  }

  TextProperty.prototype.getExpressionValue = function (currentValue, text) {
    var newValue = this.calculateExpression(text);
    if (currentValue.t !== newValue) {
      var newData = {};
      this.copyData(newData, currentValue);
      newData.t = newValue.toString();
      newData.__complete = false;
      return newData;
    }
    return currentValue;
  };

  TextProperty.prototype.searchProperty = function () {
    var isKeyframed = this.searchKeyframes();
    var hasExpressions = this.searchExpressions();
    this.kf = isKeyframed || hasExpressions;
    return this.kf;
  };

  TextProperty.prototype.searchExpressions = searchExpressions;
}());

/* global propertyGroupFactory, PropertyInterface */
/* exported ShapePathInterface */

var ShapePathInterface = (

  function () {
    return function pathInterfaceFactory(shape, view, propertyGroup) {
      var prop = view.sh;

      function interfaceFunction(val) {
        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
          return interfaceFunction.path;
        }
        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        path: {
          get: function () {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          },
        },
        shape: {
          get: function () {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          },
        },
        _name: { value: shape.nm },
        ix: { value: shape.ix },
        propertyIndex: { value: shape.ix },
        mn: { value: shape.mn },
        propertyGroup: { value: propertyGroup },
      });
      return interfaceFunction;
    };
  }()
);

/* exported propertyGroupFactory */

var propertyGroupFactory = (function () {
  return function (interfaceFunction, parentPropertyGroup) {
    return function (val) {
      val = val === undefined ? 1 : val;
      if (val <= 0) {
        return interfaceFunction;
      }
      return parentPropertyGroup(val - 1);
    };
  };
}());

/* exported PropertyInterface */

var PropertyInterface = (function () {
  return function (propertyName, propertyGroup) {
    var interfaceFunction = {
      _name: propertyName,
    };

    function _propertyGroup(val) {
      val = val === undefined ? 1 : val;
      if (val <= 0) {
        return interfaceFunction;
      }
      return propertyGroup(val - 1);
    }

    return _propertyGroup;
  };
}());

/* global ExpressionPropertyInterface, PropertyInterface, propertyGroupFactory, ShapePathInterface */
/* exported ShapeExpressionInterface */

var ShapeExpressionInterface = (function () {
  function iterateElements(shapes, view, propertyGroup) {
    var arr = [];
    var i;
    var len = shapes ? shapes.length : 0;
    for (i = 0; i < len; i += 1) {
      if (shapes[i].ty === 'gr') {
        arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'fl') {
        arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'st') {
        arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'tm') {
        arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'tr') {
        // arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
      } else if (shapes[i].ty === 'el') {
        arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'sr') {
        arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'sh') {
        arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rc') {
        arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rd') {
        arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rp') {
        arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'gf') {
        arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else {
        arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
      }
    }
    return arr;
  }

  function contentsInterfaceFactory(shape, view, propertyGroup) {
    var interfaces;
    var interfaceFunction = function _interfaceFunction(value) {
      var i = 0;
      var len = interfaces.length;
      while (i < len) {
        if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
          return interfaces[i];
        }
        i += 1;
      }
      if (typeof value === 'number') {
        return interfaces[value - 1];
      }
      return null;
    };

    interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
    interfaceFunction.numProperties = interfaces.length;
    var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
    interfaceFunction.transform = transformInterface;
    interfaceFunction.propertyIndex = shape.cix;
    interfaceFunction._name = shape.nm;

    return interfaceFunction;
  }

  function groupInterfaceFactory(shape, view, propertyGroup) {
    var interfaceFunction = function _interfaceFunction(value) {
      switch (value) {
        case 'ADBE Vectors Group':
        case 'Contents':
        case 2:
          return interfaceFunction.content;
          // Not necessary for now. Keeping them here in case a new case appears
          // case 'ADBE Vector Transform Group':
          // case 3:
        default:
          return interfaceFunction.transform;
      }
    };
    interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
    var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
    interfaceFunction.content = content;
    interfaceFunction.transform = transformInterface;
    Object.defineProperty(interfaceFunction, '_name', {
      get: function () {
        return shape.nm;
      },
    });
    // interfaceFunction.content = interfaceFunction;
    interfaceFunction.numProperties = shape.np;
    interfaceFunction.propertyIndex = shape.ix;
    interfaceFunction.nm = shape.nm;
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function fillInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === 'Color' || val === 'color') {
        return interfaceFunction.color;
      } if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      color: {
        get: ExpressionPropertyInterface(view.c),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
    return interfaceFunction;
  }

  function gradientFillInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === 'Start Point' || val === 'start point') {
        return interfaceFunction.startPoint;
      }
      if (val === 'End Point' || val === 'end point') {
        return interfaceFunction.endPoint;
      }
      if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      startPoint: {
        get: ExpressionPropertyInterface(view.s),
      },
      endPoint: {
        get: ExpressionPropertyInterface(view.e),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      type: {
        get: function () {
          return 'a';
        },
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
    view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
    return interfaceFunction;
  }
  function defaultInterfaceFactory() {
    function interfaceFunction() {
      return null;
    }
    return interfaceFunction;
  }

  function strokeInterfaceFactory(shape, view, propertyGroup) {
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
    function addPropertyToDashOb(i) {
      Object.defineProperty(dashOb, shape.d[i].nm, {
        get: ExpressionPropertyInterface(view.d.dataProps[i].p),
      });
    }
    var i;
    var len = shape.d ? shape.d.length : 0;
    var dashOb = {};
    for (i = 0; i < len; i += 1) {
      addPropertyToDashOb(i);
      view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
    }

    function interfaceFunction(val) {
      if (val === 'Color' || val === 'color') {
        return interfaceFunction.color;
      } if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      } if (val === 'Stroke Width' || val === 'stroke width') {
        return interfaceFunction.strokeWidth;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      color: {
        get: ExpressionPropertyInterface(view.c),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      strokeWidth: {
        get: ExpressionPropertyInterface(view.w),
      },
      dash: {
        get: function () {
          return dashOb;
        },
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
    return interfaceFunction;
  }

  function trimInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === shape.e.ix || val === 'End' || val === 'end') {
        return interfaceFunction.end;
      }
      if (val === shape.s.ix) {
        return interfaceFunction.start;
      }
      if (val === shape.o.ix) {
        return interfaceFunction.offset;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaceFunction.propertyIndex = shape.ix;

    view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
    view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
    interfaceFunction.propertyIndex = shape.ix;
    interfaceFunction.propertyGroup = propertyGroup;

    Object.defineProperties(interfaceFunction, {
      start: {
        get: ExpressionPropertyInterface(view.s),
      },
      end: {
        get: ExpressionPropertyInterface(view.e),
      },
      offset: {
        get: ExpressionPropertyInterface(view.o),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function transformInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.a.ix === value || value === 'Anchor Point') {
        return interfaceFunction.anchorPoint;
      }
      if (shape.o.ix === value || value === 'Opacity') {
        return interfaceFunction.opacity;
      }
      if (shape.p.ix === value || value === 'Position') {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
        return interfaceFunction.rotation;
      }
      if (shape.s.ix === value || value === 'Scale') {
        return interfaceFunction.scale;
      }
      if ((shape.sk && shape.sk.ix === value) || value === 'Skew') {
        return interfaceFunction.skew;
      }
      if ((shape.sa && shape.sa.ix === value) || value === 'Skew Axis') {
        return interfaceFunction.skewAxis;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
    view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
    view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
    if (view.transform.mProps.sk) {
      view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
      view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
    }
    view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    Object.defineProperties(interfaceFunction, {
      opacity: {
        get: ExpressionPropertyInterface(view.transform.mProps.o),
      },
      position: {
        get: ExpressionPropertyInterface(view.transform.mProps.p),
      },
      anchorPoint: {
        get: ExpressionPropertyInterface(view.transform.mProps.a),
      },
      scale: {
        get: ExpressionPropertyInterface(view.transform.mProps.s),
      },
      rotation: {
        get: ExpressionPropertyInterface(view.transform.mProps.r),
      },
      skew: {
        get: ExpressionPropertyInterface(view.transform.mProps.sk),
      },
      skewAxis: {
        get: ExpressionPropertyInterface(view.transform.mProps.sa),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.ty = 'tr';
    interfaceFunction.mn = shape.mn;
    interfaceFunction.propertyGroup = propertyGroup;
    return interfaceFunction;
  }

  function ellipseInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.s.ix === value) {
        return interfaceFunction.size;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaceFunction.propertyIndex = shape.ix;
    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      size: {
        get: ExpressionPropertyInterface(prop.s),
      },
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function starInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value) {
        return interfaceFunction.rotation;
      }
      if (shape.pt.ix === value) {
        return interfaceFunction.points;
      }
      if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
        return interfaceFunction.outerRadius;
      }
      if (shape.os.ix === value) {
        return interfaceFunction.outerRoundness;
      }
      if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
        return interfaceFunction.innerRadius;
      }
      if (shape.is && shape.is.ix === value) {
        return interfaceFunction.innerRoundness;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    interfaceFunction.propertyIndex = shape.ix;
    prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
    prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
    prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
    if (shape.ir) {
      prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
      prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
    }

    Object.defineProperties(interfaceFunction, {
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      rotation: {
        get: ExpressionPropertyInterface(prop.r),
      },
      points: {
        get: ExpressionPropertyInterface(prop.pt),
      },
      outerRadius: {
        get: ExpressionPropertyInterface(prop.or),
      },
      outerRoundness: {
        get: ExpressionPropertyInterface(prop.os),
      },
      innerRadius: {
        get: ExpressionPropertyInterface(prop.ir),
      },
      innerRoundness: {
        get: ExpressionPropertyInterface(prop.is),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function rectInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value) {
        return interfaceFunction.roundness;
      }
      if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
        return interfaceFunction.size;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    interfaceFunction.propertyIndex = shape.ix;
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
    prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      roundness: {
        get: ExpressionPropertyInterface(prop.r),
      },
      size: {
        get: ExpressionPropertyInterface(prop.s),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function roundedInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.r.ix === value || value === 'Round Corners 1') {
        return interfaceFunction.radius;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view;
    interfaceFunction.propertyIndex = shape.ix;
    prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      radius: {
        get: ExpressionPropertyInterface(prop.rd),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function repeaterInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.c.ix === value || value === 'Copies') {
        return interfaceFunction.copies;
      } if (shape.o.ix === value || value === 'Offset') {
        return interfaceFunction.offset;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view;
    interfaceFunction.propertyIndex = shape.ix;
    prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
    prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
    Object.defineProperties(interfaceFunction, {
      copies: {
        get: ExpressionPropertyInterface(prop.c),
      },
      offset: {
        get: ExpressionPropertyInterface(prop.o),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  return function (shapes, view, propertyGroup) {
    var interfaces;
    function _interfaceFunction(value) {
      if (typeof value === 'number') {
        value = value === undefined ? 1 : value;
        if (value === 0) {
          return propertyGroup;
        }
        return interfaces[value - 1];
      }
      var i = 0;
      var len = interfaces.length;
      while (i < len) {
        if (interfaces[i]._name === value) {
          return interfaces[i];
        }
        i += 1;
      }
      return null;
    }
    function parentGroupWrapper() {
      return propertyGroup;
    }
    _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
    interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
    _interfaceFunction.numProperties = interfaces.length;
    _interfaceFunction._name = 'Contents';
    return _interfaceFunction;
  };
}());

/* exported TextExpressionInterface */

var TextExpressionInterface = (function () {
  return function (elem) {
    var _prevValue;
    var _sourceText;
    function _thisLayerFunction(name) {
      switch (name) {
        case 'ADBE Text Document':
          return _thisLayerFunction.sourceText;
        default:
          return null;
      }
    }
    Object.defineProperty(_thisLayerFunction, 'sourceText', {
      get: function () {
        elem.textProperty.getValue();
        var stringValue = elem.textProperty.currentData.t;
        if (stringValue !== _prevValue) {
          elem.textProperty.currentData.t = _prevValue;
          _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
          // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
          _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
        }
        return _sourceText;
      },
    });
    return _thisLayerFunction;
  };
}());

/* global Matrix, MaskManagerInterface, TransformExpressionInterface, getDescriptor */
/* exported LayerExpressionInterface */

var LayerExpressionInterface = (function () {
  function getMatrix(time) {
    var toWorldMat = new Matrix();
    if (time !== undefined) {
      var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
      propMatrix.clone(toWorldMat);
    } else {
      var transformMat = this._elem.finalTransform.mProp;
      transformMat.applyToMatrix(toWorldMat);
    }
    return toWorldMat;
  }

  function toWorldVec(arr, time) {
    var toWorldMat = this.getMatrix(time);
    toWorldMat.props[12] = 0;
    toWorldMat.props[13] = 0;
    toWorldMat.props[14] = 0;
    return this.applyPoint(toWorldMat, arr);
  }

  function toWorld(arr, time) {
    var toWorldMat = this.getMatrix(time);
    return this.applyPoint(toWorldMat, arr);
  }

  function fromWorldVec(arr, time) {
    var toWorldMat = this.getMatrix(time);
    toWorldMat.props[12] = 0;
    toWorldMat.props[13] = 0;
    toWorldMat.props[14] = 0;
    return this.invertPoint(toWorldMat, arr);
  }

  function fromWorld(arr, time) {
    var toWorldMat = this.getMatrix(time);
    return this.invertPoint(toWorldMat, arr);
  }

  function applyPoint(matrix, arr) {
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
      }
    }
    return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
  }

  function invertPoint(matrix, arr) {
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
      }
    }
    return matrix.inversePoint(arr);
  }

  function fromComp(arr) {
    var toWorldMat = new Matrix();
    toWorldMat.reset();
    this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
      }
      return toWorldMat.inversePoint(arr);
    }
    return toWorldMat.inversePoint(arr);
  }

  function sampleImage() {
    return [1, 1, 1, 1];
  }

  return function (elem) {
    var transformInterface;

    function _registerMaskInterface(maskManager) {
      _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
    }
    function _registerEffectsInterface(effects) {
      _thisLayerFunction.effect = effects;
    }

    function _thisLayerFunction(name) {
      switch (name) {
        case 'ADBE Root Vectors Group':
        case 'Contents':
        case 2:
          return _thisLayerFunction.shapeInterface;
        case 1:
        case 6:
        case 'Transform':
        case 'transform':
        case 'ADBE Transform Group':
          return transformInterface;
        case 4:
        case 'ADBE Effect Parade':
        case 'effects':
        case 'Effects':
          return _thisLayerFunction.effect;
        case 'ADBE Text Properties':
          return _thisLayerFunction.textInterface;
        default:
          return null;
      }
    }
    _thisLayerFunction.getMatrix = getMatrix;
    _thisLayerFunction.invertPoint = invertPoint;
    _thisLayerFunction.applyPoint = applyPoint;
    _thisLayerFunction.toWorld = toWorld;
    _thisLayerFunction.toWorldVec = toWorldVec;
    _thisLayerFunction.fromWorld = fromWorld;
    _thisLayerFunction.fromWorldVec = fromWorldVec;
    _thisLayerFunction.toComp = toWorld;
    _thisLayerFunction.fromComp = fromComp;
    _thisLayerFunction.sampleImage = sampleImage;
    _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
    _thisLayerFunction._elem = elem;
    transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
    var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
    Object.defineProperties(_thisLayerFunction, {
      hasParent: {
        get: function () {
          return elem.hierarchy.length;
        },
      },
      parent: {
        get: function () {
          return elem.hierarchy[0].layerInterface;
        },
      },
      rotation: getDescriptor(transformInterface, 'rotation'),
      scale: getDescriptor(transformInterface, 'scale'),
      position: getDescriptor(transformInterface, 'position'),
      opacity: getDescriptor(transformInterface, 'opacity'),
      anchorPoint: anchorPointDescriptor,
      anchor_point: anchorPointDescriptor,
      transform: {
        get: function () {
          return transformInterface;
        },
      },
      active: {
        get: function () {
          return elem.isInRange;
        },
      },
    });

    _thisLayerFunction.startTime = elem.data.st;
    _thisLayerFunction.index = elem.data.ind;
    _thisLayerFunction.source = elem.data.refId;
    _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
    _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
    _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
    _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
    _thisLayerFunction._name = elem.data.nm;

    _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
    _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
    return _thisLayerFunction;
  };
}());

/* global */
/* exported FootageInterface */

var FootageInterface = (function () {
  var outlineInterfaceFactory = (function (elem) {
    var currentPropertyName = '';
    var currentProperty = elem.getFootageData();
    function init() {
      currentPropertyName = '';
      currentProperty = elem.getFootageData();
      return searchProperty;
    }
    function searchProperty(value) {
      if (currentProperty[value]) {
        currentPropertyName = value;
        currentProperty = currentProperty[value];
        if (typeof currentProperty === 'object') {
          return searchProperty;
        }
        return currentProperty;
      }
      var propertyNameIndex = value.indexOf(currentPropertyName);
      if (propertyNameIndex !== -1) {
        var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
        currentProperty = currentProperty[index];
        if (typeof currentProperty === 'object') {
          return searchProperty;
        }
        return currentProperty;
      }
      return '';
    }
    return init;
  });

  var dataInterfaceFactory = function (elem) {
    function interfaceFunction(value) {
      if (value === 'Outline') {
        return interfaceFunction.outlineInterface();
      }
      return null;
    }

    interfaceFunction._name = 'Outline';
    interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
    return interfaceFunction;
  };

  return function (elem) {
    function _interfaceFunction(value) {
      if (value === 'Data') {
        return _interfaceFunction.dataInterface;
      }
      return null;
    }

    _interfaceFunction._name = 'Data';
    _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
    return _interfaceFunction;
  };
}());

/* exported CompExpressionInterface */

var CompExpressionInterface = (function () {
  return function (comp) {
    function _thisLayerFunction(name) {
      var i = 0;
      var len = comp.layers.length;
      while (i < len) {
        if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
          return comp.elements[i].layerInterface;
        }
        i += 1;
      }
      return null;
      // return {active:false};
    }
    Object.defineProperty(_thisLayerFunction, '_name', { value: comp.data.nm });
    _thisLayerFunction.layer = _thisLayerFunction;
    _thisLayerFunction.pixelAspect = 1;
    _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
    _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
    _thisLayerFunction.pixelAspect = 1;
    _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
    _thisLayerFunction.displayStartTime = 0;
    _thisLayerFunction.numLayers = comp.layers.length;
    return _thisLayerFunction;
  };
}());

/* global ExpressionPropertyInterface */
/* exported TransformExpressionInterface */

var TransformExpressionInterface = (function () {
  return function (transform) {
    function _thisFunction(name) {
      switch (name) {
        case 'scale':
        case 'Scale':
        case 'ADBE Scale':
        case 6:
          return _thisFunction.scale;
        case 'rotation':
        case 'Rotation':
        case 'ADBE Rotation':
        case 'ADBE Rotate Z':
        case 10:
          return _thisFunction.rotation;
        case 'ADBE Rotate X':
          return _thisFunction.xRotation;
        case 'ADBE Rotate Y':
          return _thisFunction.yRotation;
        case 'position':
        case 'Position':
        case 'ADBE Position':
        case 2:
          return _thisFunction.position;
        case 'ADBE Position_0':
          return _thisFunction.xPosition;
        case 'ADBE Position_1':
          return _thisFunction.yPosition;
        case 'ADBE Position_2':
          return _thisFunction.zPosition;
        case 'anchorPoint':
        case 'AnchorPoint':
        case 'Anchor Point':
        case 'ADBE AnchorPoint':
        case 1:
          return _thisFunction.anchorPoint;
        case 'opacity':
        case 'Opacity':
        case 11:
          return _thisFunction.opacity;
        default:
          return null;
      }
    }
    Object.defineProperty(_thisFunction, 'rotation', {
      get: ExpressionPropertyInterface(transform.r || transform.rz),
    });

    Object.defineProperty(_thisFunction, 'zRotation', {
      get: ExpressionPropertyInterface(transform.rz || transform.r),
    });

    Object.defineProperty(_thisFunction, 'xRotation', {
      get: ExpressionPropertyInterface(transform.rx),
    });

    Object.defineProperty(_thisFunction, 'yRotation', {
      get: ExpressionPropertyInterface(transform.ry),
    });
    Object.defineProperty(_thisFunction, 'scale', {
      get: ExpressionPropertyInterface(transform.s),
    });
    var _px;
    var _py;
    var _pz;
    var _transformFactory;
    if (transform.p) {
      _transformFactory = ExpressionPropertyInterface(transform.p);
    } else {
      _px = ExpressionPropertyInterface(transform.px);
      _py = ExpressionPropertyInterface(transform.py);
      if (transform.pz) {
        _pz = ExpressionPropertyInterface(transform.pz);
      }
    }
    Object.defineProperty(_thisFunction, 'position', {
      get: function () {
        if (transform.p) {
          return _transformFactory();
        }
        return [
          _px(),
          _py(),
          _pz ? _pz() : 0];
      },
    });

    Object.defineProperty(_thisFunction, 'xPosition', {
      get: ExpressionPropertyInterface(transform.px),
    });

    Object.defineProperty(_thisFunction, 'yPosition', {
      get: ExpressionPropertyInterface(transform.py),
    });

    Object.defineProperty(_thisFunction, 'zPosition', {
      get: ExpressionPropertyInterface(transform.pz),
    });

    Object.defineProperty(_thisFunction, 'anchorPoint', {
      get: ExpressionPropertyInterface(transform.a),
    });

    Object.defineProperty(_thisFunction, 'opacity', {
      get: ExpressionPropertyInterface(transform.o),
    });

    Object.defineProperty(_thisFunction, 'skew', {
      get: ExpressionPropertyInterface(transform.sk),
    });

    Object.defineProperty(_thisFunction, 'skewAxis', {
      get: ExpressionPropertyInterface(transform.sa),
    });

    Object.defineProperty(_thisFunction, 'orientation', {
      get: ExpressionPropertyInterface(transform.or),
    });

    return _thisFunction;
  };
}());

/* exported ProjectInterface */

var ProjectInterface = (function () {
  function registerComposition(comp) {
    this.compositions.push(comp);
  }

  return function () {
    function _thisProjectFunction(name) {
      var i = 0;
      var len = this.compositions.length;
      while (i < len) {
        if (this.compositions[i].data && this.compositions[i].data.nm === name) {
          if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
            this.compositions[i].prepareFrame(this.currentFrame);
          }
          return this.compositions[i].compInterface;
        }
        i += 1;
      }
      return null;
    }

    _thisProjectFunction.compositions = [];
    _thisProjectFunction.currentFrame = 0;

    _thisProjectFunction.registerComposition = registerComposition;

    return _thisProjectFunction;
  };
}());

/* global propertyGroupFactory, ExpressionPropertyInterface, PropertyInterface */
/* exported EffectsExpressionInterface */

var EffectsExpressionInterface = (function () {
  var ob = {
    createEffectsInterface: createEffectsInterface,
  };

  function createEffectsInterface(elem, propertyGroup) {
    if (elem.effectsManager) {
      var effectElements = [];
      var effectsData = elem.data.ef;
      var i;
      var len = elem.effectsManager.effectElements.length;
      for (i = 0; i < len; i += 1) {
        effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
      }

      var effects = elem.data.ef || [];
      var groupInterface = function (name) {
        i = 0;
        len = effects.length;
        while (i < len) {
          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
            return effectElements[i];
          }
          i += 1;
        }
        return null;
      };
      Object.defineProperty(groupInterface, 'numProperties', {
        get: function () {
          return effects.length;
        },
      });
      return groupInterface;
    }
    return null;
  }

  function createGroupInterface(data, elements, propertyGroup, elem) {
    function groupInterface(name) {
      var effects = data.ef;
      var i = 0;
      var len = effects.length;
      while (i < len) {
        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
          if (effects[i].ty === 5) {
            return effectElements[i];
          }
          return effectElements[i]();
        }
        i += 1;
      }
      throw new Error();
    }
    var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);

    var effectElements = [];
    var i;
    var len = data.ef.length;
    for (i = 0; i < len; i += 1) {
      if (data.ef[i].ty === 5) {
        effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
      } else {
        effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
      }
    }

    if (data.mn === 'ADBE Color Control') {
      Object.defineProperty(groupInterface, 'color', {
        get: function () {
          return effectElements[0]();
        },
      });
    }
    Object.defineProperties(groupInterface, {
      numProperties: {
        get: function () {
          return data.np;
        },
      },
      _name: { value: data.nm },
      propertyGroup: { value: _propertyGroup },
    });
    groupInterface.enabled = data.en !== 0;
    groupInterface.active = groupInterface.enabled;
    return groupInterface;
  }

  function createValueInterface(element, type, elem, propertyGroup) {
    var expressionProperty = ExpressionPropertyInterface(element.p);
    function interfaceFunction() {
      if (type === 10) {
        return elem.comp.compInterface(element.p.v);
      }
      return expressionProperty();
    }

    if (element.p.setGroupProperty) {
      element.p.setGroupProperty(PropertyInterface('', propertyGroup));
    }

    return interfaceFunction;
  }

  return ob;
}());

/* global createSizedArray */
/* exported MaskManagerInterface */

var MaskManagerInterface = (function () {
  function MaskInterface(mask, data) {
    this._mask = mask;
    this._data = data;
  }
  Object.defineProperty(MaskInterface.prototype, 'maskPath', {
    get: function () {
      if (this._mask.prop.k) {
        this._mask.prop.getValue();
      }
      return this._mask.prop;
    },
  });
  Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
    get: function () {
      if (this._mask.op.k) {
        this._mask.op.getValue();
      }
      return this._mask.op.v * 100;
    },
  });

  var MaskManager = function (maskManager) {
    var _masksInterfaces = createSizedArray(maskManager.viewData.length);
    var i;
    var len = maskManager.viewData.length;
    for (i = 0; i < len; i += 1) {
      _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
    }

    var maskFunction = function (name) {
      i = 0;
      while (i < len) {
        if (maskManager.masksProperties[i].nm === name) {
          return _masksInterfaces[i];
        }
        i += 1;
      }
      return null;
    };
    return maskFunction;
  };
  return MaskManager;
}());

/* global createTypedArray */
/* exported ExpressionPropertyInterface */

var ExpressionPropertyInterface = (function () {
  var defaultUnidimensionalValue = { pv: 0, v: 0, mult: 1 };
  var defaultMultidimensionalValue = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };

  function completeProperty(expressionValue, property, type) {
    Object.defineProperty(expressionValue, 'velocity', {
      get: function () {
        return property.getVelocityAtTime(property.comp.currentFrame);
      },
    });
    expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
    expressionValue.key = function (pos) {
      if (!expressionValue.numKeys) {
        return 0;
      }
      var value = '';
      if ('s' in property.keyframes[pos - 1]) {
        value = property.keyframes[pos - 1].s;
      } else if ('e' in property.keyframes[pos - 2]) {
        value = property.keyframes[pos - 2].e;
      } else {
        value = property.keyframes[pos - 2].s;
      }
      var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
      valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
      valueProp.value = type === 'unidimensional' ? value[0] : value;
      return valueProp;
    };
    expressionValue.valueAtTime = property.getValueAtTime;
    expressionValue.speedAtTime = property.getSpeedAtTime;
    expressionValue.velocityAtTime = property.getVelocityAtTime;
    expressionValue.propertyGroup = property.propertyGroup;
  }

  function UnidimensionalPropertyInterface(property) {
    if (!property || !('pv' in property)) {
      property = defaultUnidimensionalValue;
    }
    var mult = 1 / property.mult;
    var val = property.pv * mult;
    var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
    expressionValue.value = val;
    completeProperty(expressionValue, property, 'unidimensional');

    return function () {
      if (property.k) {
        property.getValue();
      }
      val = property.v * mult;
      if (expressionValue.value !== val) {
        expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
        expressionValue.value = val;
        completeProperty(expressionValue, property, 'unidimensional');
      }
      return expressionValue;
    };
  }

  function MultidimensionalPropertyInterface(property) {
    if (!property || !('pv' in property)) {
      property = defaultMultidimensionalValue;
    }
    var mult = 1 / property.mult;
    var len = (property.data && property.data.l) || property.pv.length;
    var expressionValue = createTypedArray('float32', len);
    var arrValue = createTypedArray('float32', len);
    expressionValue.value = arrValue;
    completeProperty(expressionValue, property, 'multidimensional');

    return function () {
      if (property.k) {
        property.getValue();
      }
      for (var i = 0; i < len; i += 1) {
        arrValue[i] = property.v[i] * mult;
        expressionValue[i] = arrValue[i];
      }
      return expressionValue;
    };
  }

  // TODO: try to avoid using this getter
  function defaultGetter() {
    return defaultUnidimensionalValue;
  }

  return function (property) {
    if (!property) {
      return defaultGetter;
    } if (property.propType === 'unidimensional') {
      return UnidimensionalPropertyInterface(property);
    }
    return MultidimensionalPropertyInterface(property);
  };
}());

/* global expressionHelpers, TextSelectorProp, ExpressionManager */
/* exported TextExpressionSelectorPropFactory */

var TextExpressionSelectorPropFactory = (function () { // eslint-disable-line no-unused-vars
  function getValueProxy(index, total) {
    this.textIndex = index + 1;
    this.textTotal = total;
    this.v = this.getValue() * this.mult;
    return this.v;
  }

  return function (elem, data) {
    this.pv = 1;
    this.comp = elem.comp;
    this.elem = elem;
    this.mult = 0.01;
    this.propType = 'textSelector';
    this.textTotal = data.totalChars;
    this.selectorValue = 100;
    this.lastValue = [1, 1, 1];
    this.k = true;
    this.x = true;
    this.getValue = ExpressionManager.initiateExpression.bind(this)(elem, data, this);
    this.getMult = getValueProxy;
    this.getVelocityAtTime = expressionHelpers.getVelocityAtTime;
    if (this.kf) {
      this.getValueAtTime = expressionHelpers.getValueAtTime.bind(this);
    } else {
      this.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(this);
    }
    this.setGroupProperty = expressionHelpers.setGroupProperty;
  };
}());

var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
TextSelectorProp.getTextSelectorProp = function (elem, data, arr) {
  if (data.t === 1) {
    return new TextExpressionSelectorPropFactory(elem, data, arr); // eslint-disable-line no-undef
  }
  return propertyGetTextProp(elem, data, arr);
};

/* global PropertyFactory */
/* exported SliderEffect, AngleEffect, ColorEffect, PointEffect, LayerIndexEffect, MaskIndexEffect, CheckboxEffect, NoValueEffect */

function SliderEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function AngleEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function ColorEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function PointEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function LayerIndexEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function MaskIndexEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function CheckboxEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function NoValueEffect() {
  this.p = {};
}

/* global extendPrototype, SliderEffect, AngleEffect, ColorEffect, PointEffect, CheckboxEffect, LayerIndexEffect,
MaskIndexEffect, NoValueEffect, DynamicPropertyContainer */

function EffectsManager(data, element) {
  var effects = data.ef || [];
  this.effectElements = [];
  var i;
  var len = effects.length;
  var effectItem;
  for (i = 0; i < len; i += 1) {
    effectItem = new GroupEffect(effects[i], element);
    this.effectElements.push(effectItem);
  }
}

function GroupEffect(data, element) {
  this.init(data, element);
}

extendPrototype([DynamicPropertyContainer], GroupEffect);

GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

GroupEffect.prototype.init = function (data, element) {
  this.data = data;
  this.effectElements = [];
  this.initDynamicPropertyContainer(element);
  var i;
  var len = this.data.ef.length;
  var eff;
  var effects = this.data.ef;
  for (i = 0; i < len; i += 1) {
    eff = null;
    switch (effects[i].ty) {
      case 0:
        eff = new SliderEffect(effects[i], element, this);
        break;
      case 1:
        eff = new AngleEffect(effects[i], element, this);
        break;
      case 2:
        eff = new ColorEffect(effects[i], element, this);
        break;
      case 3:
        eff = new PointEffect(effects[i], element, this);
        break;
      case 4:
      case 7:
        eff = new CheckboxEffect(effects[i], element, this);
        break;
      case 10:
        eff = new LayerIndexEffect(effects[i], element, this);
        break;
      case 11:
        eff = new MaskIndexEffect(effects[i], element, this);
        break;
      case 5:
        eff = new EffectsManager(effects[i], element, this);
        break;
        // case 6:
      default:
        eff = new NoValueEffect(effects[i], element, this);
        break;
    }
    if (eff) {
      this.effectElements.push(eff);
    }
  }
};


var lottie = {};

function setLocationHref(href) {
  locationHref = href;
}

function searchAnimations() {
  if (standalone === true) {
    animationManager.searchAnimations(animationData, standalone, renderer);
  } else {
    animationManager.searchAnimations();
  }
}

function setSubframeRendering(flag) {
  subframeEnabled = flag;
}

function setIDPrefix(prefix) {
  idPrefix = prefix;
}

function loadAnimation(params) {
  if (standalone === true) {
    params.animationData = JSON.parse(animationData);
  }
  return animationManager.loadAnimation(params);
}

function setQuality(value) {
  if (typeof value === 'string') {
    switch (value) {
      case 'high':
        defaultCurveSegments = 200;
        break;
      default:
      case 'medium':
        defaultCurveSegments = 50;
        break;
      case 'low':
        defaultCurveSegments = 10;
        break;
    }
  } else if (!isNaN(value) && value > 1) {
    defaultCurveSegments = value;
  }
  if (defaultCurveSegments >= 50) {
    roundValues(false);
  } else {
    roundValues(true);
  }
}

function inBrowser() {
  return typeof navigator !== 'undefined';
}

function installPlugin(type, plugin) {
  if (type === 'expressions') {
    expressionsPlugin = plugin;
  }
}

function getFactory(name) {
  switch (name) {
    case 'propertyFactory':
      return PropertyFactory;
    case 'shapePropertyFactory':
      return ShapePropertyFactory;
    case 'matrix':
      return Matrix;
    default:
      return null;
  }
}

lottie.play = animationManager.play;
lottie.pause = animationManager.pause;
lottie.setLocationHref = setLocationHref;
lottie.togglePause = animationManager.togglePause;
lottie.setSpeed = animationManager.setSpeed;
lottie.setDirection = animationManager.setDirection;
lottie.stop = animationManager.stop;
lottie.searchAnimations = searchAnimations;
lottie.registerAnimation = animationManager.registerAnimation;
lottie.loadAnimation = loadAnimation;
lottie.setSubframeRendering = setSubframeRendering;
lottie.resize = animationManager.resize;
// lottie.start = start;
lottie.goToAndStop = animationManager.goToAndStop;
lottie.destroy = animationManager.destroy;
lottie.setQuality = setQuality;
lottie.inBrowser = inBrowser;
lottie.installPlugin = installPlugin;
lottie.freeze = animationManager.freeze;
lottie.unfreeze = animationManager.unfreeze;
lottie.setVolume = animationManager.setVolume;
lottie.mute = animationManager.mute;
lottie.unmute = animationManager.unmute;
lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
lottie.useWebWorker = function (flag) {
  _useWebWorker = flag;
};
lottie.setIDPrefix = setIDPrefix;
lottie.__getFactory = getFactory;
lottie.version = '5.8.1';

function checkReady() {
  if (document.readyState === 'complete') {
    clearInterval(readyStateCheckInterval);
    searchAnimations();
  }
}

function getQueryVariable(variable) {
  var vars = queryString.split('&');
  for (var i = 0; i < vars.length; i += 1) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) { // eslint-disable-line eqeqeq
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
}
var standalone = '__[STANDALONE]__';
var animationData = '__[ANIMATIONDATA]__';
var renderer = '';
var queryString;
if (standalone) {
  var scripts = document.getElementsByTagName('script');
  var index = scripts.length - 1;
  var myScript = scripts[index] || {
    src: '',
  };
  queryString = myScript.src.replace(/^[^\?]+\??/, ''); // eslint-disable-line no-useless-escape
  renderer = getQueryVariable('renderer');
}
var readyStateCheckInterval = setInterval(checkReady, 100);

return lottie;
}));

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = {"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":29.9700012207031,"ip":0,"op":60.0000024438501,"w":1440,"h":900,"nm":"congrats-anim","ddd":0,"assets":[],"fonts":{"list":[{"fName":"Neucha","fFamily":"Neucha","fStyle":"Regular","ascent":78.2669067382812}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[2.965,3.413],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949020026712,1,1,1],"ix":4},"o":{"a":0,"k":0,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1109.482,-460.294],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":"EXCELLENT!","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[306.751,526.074,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":165,"f":"Neucha","t":"EXCELLENT!","j":0,"tr":0,"lh":198,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Positon !","s":{"t":0,"xe":{"a":0,"k":100,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[-100]},{"t":35.0000014255792,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-100,0],"ix":2}}},{"nm":"Positon ! 2","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[-100]},{"t":42.0000017106951,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,100,0],"ix":2}}},{"nm":"Positon ! 3","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[-100]},{"t":50.0000020365418,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-20,0],"ix":2}}},{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":1,"r":1},"a":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":24,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[100]},{"t":50.0000020365418,"s":[0]}],"ix":9}}}]},"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Vector 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":160,"ix":10},"p":{"a":0,"k":[584.527,440.481,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[301,301,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.592,-12.412],[2,-16.5],[13.997,-5.599],[-27.5,8.5],[10.5,-11]],"o":[[-5.333,6.667],[-1.12,23.5],[-2,16.5],[-17.5,7],[21.203,-6.554],[0,0]],"v":[[20.348,-63],[5.348,-27.5],[17.848,19],[-1.773,47],[-4.273,19],[11.348,63]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.737254917622,0.929411768913,0.964705884457,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":34.0000013848484,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1050.187,96.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[237,237,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.6,3.6],[-1.5,-2],[8,-2],[-14,18],[-2.5,-1.5],[13.5,-4],[-16.5,6.5],[-2.5,-15.5]],"o":[[-0.667,-5.167],[12,-4.5],[1.5,2],[-8,2],[14,-18],[7.34,4.404],[-13.5,4],[16.5,-6.5],[0,0]],"v":[[-52.17,25.752],[-42.17,5.752],[-21.67,7.752],[-24.67,19.752],[-30.67,-10.248],[12.83,-19.748],[16.33,3.752],[12.83,-23.248],[52.33,-7.748]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.341176480055,0.384313732386,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":47.0000019143492,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[338.677,338.677],"ix":3},"r":{"a":0,"k":-152.245,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":47.0000019143492,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Vector 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.241,603.609,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[291,291,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.019,15.142],[-21.544,1.854],[21.843,-0.123],[-19.051,-0.566],[-1.053,6.591]],"o":[[20.081,-4.4],[18.48,-14.713],[39.724,-3.419],[-16.471,0.093],[15.241,0.452],[0,0]],"v":[[-75.292,75.735],[-60.995,27.44],[-14.55,20.726],[-7.144,-15.78],[-4.048,2.355],[23.103,-21.036]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.349019616842,0.521568655968,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[2]},{"t":52.0000021180034,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":4.645,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":35.0000014255792,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":52.0000021180034,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[270.187,812.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[225,225,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.5,-6.5],[-13.5,4],[7.34,4.404],[14,-18],[-8,2],[1.5,2],[12,-4.5],[-0.667,-5.167]],"o":[[-2.5,-15.5],[-16.5,6.5],[13.5,-4],[-2.5,-1.5],[-14,18],[8,-2],[-1.5,-2],[-9.6,3.6],[0,0]],"v":[[52.33,-7.748],[12.83,-23.248],[16.33,3.752],[12.83,-19.748],[-30.67,-10.248],[-24.67,19.752],[-21.67,7.752],[-42.17,5.752],[-52.17,25.752]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.800000011921,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":48.0000019550801,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,16],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":16.945,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":48.0000019550801,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Vector 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[283.99,512.842,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[273.086,215.359,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.5,13.5],[-23.5,0],[11.167,-2.5],[-1.56,32.421],[-2.788,-11.5],[22.8,-2.8],[-8.333,15.667]],"o":[[-27,-2],[-4.5,-13.5],[11.674,0],[-11.167,2.5],[2,-44.8],[1.333,5.5],[-36.8,2.8],[0,0]],"v":[[31.163,87.75],[-21.837,47.75],[6.163,3.75],[9.163,17.75],[-28.337,-9.75],[21.163,-64.25],[-3.337,-44.25],[-24.337,-87.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.996078431606,0.372549027205,0.333333343267,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[3]},{"t":37.0000015070409,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 6","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Vector 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":147,"ix":10},"p":{"a":0,"k":[493.605,-13.278,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[221,221,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-26.751,23.049],[-17.579,29.801],[-38.844,16.733]],"o":[[-4.793,-10.962],[21.816,-18.796],[14.832,-25.144],[0,0]],"v":[[-12.046,101.322],[2.42,15.388],[89.01,-32.998],[104.067,-125.327]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.65098041296,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[2]},{"t":51.0000020772726,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":-92.056,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 7","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":13,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":36.0000014663101,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[1444.67,903.138],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.665,-2.431],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"E","size":165,"style":"Regular","w":45.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[14.908,1.367],[-0.098,5.827],[0,2.866],[-13.737,1.237],[0,0],[5.859,0.488],[2.213,0.261],[0.227,4.623],[0.064,1.498],[-8.789,0.717],[-2.93,0.522],[0,0],[9.537,0.131],[2.213,0.195],[0.13,-16.797],[0.65,-7.161],[-4.819,0],[-6.674,0.227],[-2.539,0],[0,0]],"o":[[0,-2.734],[0.098,-5.826],[2.344,-0.064],[0,0],[-1.562,-0.13],[-5.859,-0.488],[-0.066,-2.994],[-0.229,-4.622],[0.455,-0.064],[8.789,-0.716],[0,0],[-2.93,-0.455],[-9.538,-0.13],[-0.717,6.641],[-0.131,16.797],[1.758,0.455],[2.994,0],[6.673,-0.229],[0,0],[-3.842,-0.586]],"v":[[13.086,-7.324],[13.232,-20.166],[13.379,-33.203],[37.5,-35.156],[36.523,-39.648],[25.391,-40.576],[13.281,-41.699],[12.842,-53.125],[12.402,-62.305],[26.27,-63.477],[43.848,-65.332],[42.773,-69.727],[24.072,-70.605],[6.445,-71.094],[5.176,-35.938],[4.004,0],[13.867,0.684],[28.369,0.342],[42.188,0],[41.211,-4.395]],"c":true},"ix":2},"nm":"E","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"E","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"X","size":165,"style":"Regular","w":54.49,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-5.078,7.162],[-2.019,3.256],[0,0],[-2.214,0],[-0.62,0.65],[0,1.237],[6.25,8.496],[2.213,3.452],[-6.348,8.855],[-0.391,0.456],[1.041,1.14],[1.302,0],[0.977,-1.627],[5.371,-7.422],[0.325,-1.236],[5.533,6.445],[0,0],[-5.046,-7.259],[-1.628,-2.539],[3.809,-5.826],[2.18,-3.809],[1.692,-3.97],[0,0]],"o":[[5.078,-7.161],[0,0],[1.172,2.148],[0.977,0],[0.618,-0.652],[-1.628,-2.798],[-6.25,-8.496],[1.562,-1.822],[6.348,-8.853],[-0.066,-1.497],[-1.042,-1.138],[-1.367,0],[-0.781,1.367],[-5.371,7.422],[-8.334,-12.109],[0,0],[2.473,4.102],[5.045,7.26],[-0.912,1.433],[-3.809,5.827],[-2.182,3.809],[0,0],[2.408,-3.97]],"v":[[15.43,-15.82],[26.074,-31.445],[46.094,-1.562],[51.172,1.66],[53.564,0.684],[54.492,-2.148],[42.676,-19.092],[29.98,-37.012],[41.846,-53.027],[51.953,-66.992],[50.293,-70.947],[46.777,-72.656],[43.262,-70.215],[34.033,-57.031],[25.488,-44.043],[4.688,-71.875],[0.586,-70.02],[11.865,-52.979],[21.875,-38.281],[14.795,-27.393],[5.811,-12.939],[0,-1.27],[4.199,0.879]],"c":true},"ix":2},"nm":"X","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"X","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"C","size":165,"style":"Regular","w":46.39,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.036,1.303],[3.775,0],[3.157,-2.473],[1.562,-4.036],[0.65,-4.004],[0,-4.231],[-1.074,-4.263],[-1.987,-3.906],[-3.452,-2.539],[-4.167,0],[-8.203,5.664],[0.845,1.237],[4.102,0],[2.864,3.581],[1.204,4.135],[0,3.256],[-0.163,2.475],[-0.684,3.386],[-1.205,2.214],[-2.344,1.562],[-3.256,0],[-5.078,-3.775],[0,0]],"o":[[-4.037,-1.302],[-4.362,0],[-3.159,2.475],[-1.562,4.037],[-0.652,4.004],[0,3.842],[1.074,4.265],[1.985,3.906],[3.45,2.539],[6.445,0],[-1.367,-2.864],[-8.464,4.297],[-3.777,0],[-2.866,-3.58],[-1.205,-4.134],[0,-3.32],[0.162,-2.473],[0.684,-3.384],[1.204,-2.213],[2.344,-1.562],[4.947,0],[0,0],[-2.866,-1.953]],"v":[[38.379,-69.336],[26.66,-71.289],[15.381,-67.578],[8.301,-57.812],[4.98,-45.752],[4.004,-33.398],[5.615,-21.24],[10.205,-8.984],[18.359,0.684],[29.785,4.492],[51.758,-4.004],[48.438,-10.156],[29.59,-3.711],[19.629,-9.082],[13.525,-20.654],[11.719,-31.738],[11.963,-40.43],[13.232,-49.219],[16.064,-57.617],[21.387,-63.281],[29.785,-65.625],[44.824,-59.961],[48.73,-64.453]],"c":true},"ix":2},"nm":"C","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"C","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"L","size":165,"style":"Regular","w":47.46,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.034,-16.145],[0.33,-9.634],[0,0],[-8.53,-0.522],[0.162,2.019],[0.391,1.108],[6.686,0],[4.349,-0.259],[0.989,9.961],[0,0]],"o":[[-0.034,16.147],[0,0],[13.216,0],[-0.195,-0.977],[-0.163,-2.017],[-4.025,0.195],[-6.686,0],[-0.909,-31.055],[0,0],[-0.066,4.623]],"v":[[4.547,-38.867],[4.004,-0.195],[14.844,-0.195],[47.461,0.586],[46.924,-3.906],[46.094,-8.594],[30.026,-8.301],[13.472,-7.91],[10.626,-69.434],[4.695,-70.02]],"c":true},"ix":2},"nm":"L","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"L","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"N","size":165,"style":"Regular","w":54.88,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.074,-0.977],[-1.172,0],[-0.586,2.017],[0.032,11.719],[0.064,4.428],[-5.893,-11.783],[-3.972,-6.119],[-2.214,0],[-1.367,0.586],[0.716,14.128],[0,0],[0,-19.661],[0,0],[0,0],[0,0],[0,0]],"o":[[1.074,0.977],[1.692,0],[-0.195,-6.055],[-0.034,-11.719],[2.473,4.362],[5.891,11.784],[2.408,1.302],[1.497,0],[-0.456,-32.422],[0,0],[-0.717,15.691],[0,0],[0,0],[0,0],[0,0],[0.259,1.367]],"v":[[6.006,0.781],[9.375,2.246],[12.793,-0.781],[12.451,-27.441],[12.305,-51.66],[24.854,-27.441],[39.648,-0.586],[46.582,1.367],[50.879,0.488],[49.121,-69.336],[43.555,-70.41],[42.48,-17.383],[42.48,-9.668],[10.547,-70.312],[5.273,-70.312],[4.004,-2.734]],"c":true},"ix":2},"nm":"N","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"N","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"T","size":165,"style":"Regular","w":43.07,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-7.358,-0.52],[0,-7.747],[-0.034,-5.338],[0,-2.669],[0.13,-3.516],[-1.108,-0.943],[-1.172,0],[-0.586,1.953],[1.627,22.983],[0,0],[-0.652,0.652],[0,0.847],[1.106,1.108],[1.627,0.066],[0,0],[0,0]],"o":[[-0.261,6.25],[0,2.67],[0.032,5.339],[0,7.162],[0.259,1.367],[1.106,0.943],[1.627,0],[-0.781,-18.814],[0,0],[1.302,-0.13],[0.65,-0.65],[0,-1.302],[-1.108,-1.106],[0,0],[0,0],[4.036,0.195]],"v":[[18.066,-64.453],[17.676,-43.457],[17.725,-31.445],[17.773,-19.434],[17.578,-3.418],[19.629,0.049],[23.047,1.465],[26.367,-1.465],[22.754,-64.16],[39.16,-63.281],[42.09,-64.453],[43.066,-66.699],[41.406,-70.312],[37.305,-72.07],[0,-69.922],[0.977,-65.527]],"c":true},"ix":2},"nm":"T","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"T","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"!","size":165,"style":"Regular","w":18.16,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.261,11.784],[-0.195,3.516],[1.106,1.108],[1.302,0],[0.259,-2.539],[-0.327,-4.297],[0,0]],"o":[[0.259,-11.783],[-0.066,-1.627],[-1.108,-1.106],[-2.019,0],[1.367,29.819],[0,0],[0.52,-6.38]],"v":[[12.109,-44.043],[12.793,-66.992],[11.035,-71.094],[7.422,-72.754],[4.004,-68.945],[6.543,-17.773],[10.938,-16.797]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.618,-0.879],[0,-1.431],[-1.042,-1.497],[-1.823,0],[-0.684,0.879],[0,1.433],[1.172,1.53],[1.758,0]],"o":[[-0.62,0.879],[0,2.019],[1.041,1.497],[1.172,0],[0.684,-0.879],[0,-1.953],[-1.172,-1.529],[-1.108,0]],"v":[[5.42,-10.01],[4.492,-6.543],[6.055,-1.27],[10.352,0.977],[13.135,-0.342],[14.16,-3.809],[12.402,-9.033],[8.008,-11.328]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"!","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"}]}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports = {"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":29.9700012207031,"ip":0,"op":60.0000024438501,"w":1440,"h":900,"nm":"congrats-anim","ddd":0,"assets":[],"fonts":{"list":[{"fName":"Neucha","fFamily":"Neucha","fStyle":"Regular","ascent":78.2669067382812}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[2.965,3.413],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949020026712,1,1,1],"ix":4},"o":{"a":0,"k":0,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1109.482,-460.294],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":"FANTASTIC!","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[337.326,526.074,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":165,"f":"Neucha","t":"FANTASTIC!","j":0,"tr":0,"lh":198,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Positon !","s":{"t":0,"xe":{"a":0,"k":100,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[-100]},{"t":35.0000014255792,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-100,0],"ix":2}}},{"nm":"Positon ! 2","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[-100]},{"t":42.0000017106951,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,100,0],"ix":2}}},{"nm":"Positon ! 3","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[-100]},{"t":50.0000020365418,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-20,0],"ix":2}}},{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":1,"r":1},"a":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":24,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[100]},{"t":50.0000020365418,"s":[0]}],"ix":9}}}]},"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Vector 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":160,"ix":10},"p":{"a":0,"k":[584.527,440.481,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[301,301,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.592,-12.412],[2,-16.5],[13.997,-5.599],[-27.5,8.5],[10.5,-11]],"o":[[-5.333,6.667],[-1.12,23.5],[-2,16.5],[-17.5,7],[21.203,-6.554],[0,0]],"v":[[20.348,-63],[5.348,-27.5],[17.848,19],[-1.773,47],[-4.273,19],[11.348,63]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.737254917622,0.929411768913,0.964705884457,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":34.0000013848484,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1050.187,96.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[237,237,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.6,3.6],[-1.5,-2],[8,-2],[-14,18],[-2.5,-1.5],[13.5,-4],[-16.5,6.5],[-2.5,-15.5]],"o":[[-0.667,-5.167],[12,-4.5],[1.5,2],[-8,2],[14,-18],[7.34,4.404],[-13.5,4],[16.5,-6.5],[0,0]],"v":[[-52.17,25.752],[-42.17,5.752],[-21.67,7.752],[-24.67,19.752],[-30.67,-10.248],[12.83,-19.748],[16.33,3.752],[12.83,-23.248],[52.33,-7.748]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.341176480055,0.384313732386,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":47.0000019143492,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[338.677,338.677],"ix":3},"r":{"a":0,"k":-152.245,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":47.0000019143492,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Vector 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.241,603.609,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[291,291,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.019,15.142],[-21.544,1.854],[21.843,-0.123],[-19.051,-0.566],[-1.053,6.591]],"o":[[20.081,-4.4],[18.48,-14.713],[39.724,-3.419],[-16.471,0.093],[15.241,0.452],[0,0]],"v":[[-75.292,75.735],[-60.995,27.44],[-14.55,20.726],[-7.144,-15.78],[-4.048,2.355],[23.103,-21.036]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.349019616842,0.521568655968,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[2]},{"t":52.0000021180034,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":4.645,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":35.0000014255792,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":52.0000021180034,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[270.187,812.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[225,225,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.5,-6.5],[-13.5,4],[7.34,4.404],[14,-18],[-8,2],[1.5,2],[12,-4.5],[-0.667,-5.167]],"o":[[-2.5,-15.5],[-16.5,6.5],[13.5,-4],[-2.5,-1.5],[-14,18],[8,-2],[-1.5,-2],[-9.6,3.6],[0,0]],"v":[[52.33,-7.748],[12.83,-23.248],[16.33,3.752],[12.83,-19.748],[-30.67,-10.248],[-24.67,19.752],[-21.67,7.752],[-42.17,5.752],[-52.17,25.752]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.800000011921,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":48.0000019550801,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,16],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":16.945,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":48.0000019550801,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Vector 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[283.99,512.842,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[273.086,215.359,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.5,13.5],[-23.5,0],[11.167,-2.5],[-1.56,32.421],[-2.788,-11.5],[22.8,-2.8],[-8.333,15.667]],"o":[[-27,-2],[-4.5,-13.5],[11.674,0],[-11.167,2.5],[2,-44.8],[1.333,5.5],[-36.8,2.8],[0,0]],"v":[[31.163,87.75],[-21.837,47.75],[6.163,3.75],[9.163,17.75],[-28.337,-9.75],[21.163,-64.25],[-3.337,-44.25],[-24.337,-87.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.996078431606,0.372549027205,0.333333343267,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[3]},{"t":37.0000015070409,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 6","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Vector 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":147,"ix":10},"p":{"a":0,"k":[493.605,-13.278,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[221,221,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-26.751,23.049],[-17.579,29.801],[-38.844,16.733]],"o":[[-4.793,-10.962],[21.816,-18.796],[14.832,-25.144],[0,0]],"v":[[-12.046,101.322],[2.42,15.388],[89.01,-32.998],[104.067,-125.327]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.65098041296,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[2]},{"t":51.0000020772726,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":-92.056,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 7","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":13,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":36.0000014663101,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[1444.67,903.138],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.665,-2.431],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"F","size":165,"style":"Regular","w":44.73,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-0.163,7.78],[0,2.475],[0,0],[-13.737,1.237],[0,0],[5.859,0.488],[2.213,0.261],[0.227,4.623],[0.064,1.498],[-8.789,0.717],[-2.93,0.522],[0,0],[9.537,0.131],[2.213,0.195],[0.13,-16.797],[0.65,-7.161],[0,0]],"o":[[0,-2.408],[0.162,-7.779],[0,0],[2.344,-0.064],[0,0],[-1.562,-0.13],[-5.859,-0.488],[-0.066,-2.994],[-0.229,-4.622],[0.455,-0.064],[8.789,-0.716],[0,0],[-2.93,-0.455],[-9.538,-0.13],[-0.717,6.641],[-0.131,16.797],[0,0],[0,0]],"v":[[12.891,-0.879],[13.135,-16.162],[13.379,-31.543],[13.379,-33.203],[37.5,-35.156],[36.523,-39.648],[25.391,-40.576],[13.281,-41.699],[12.842,-53.125],[12.402,-62.305],[26.27,-63.477],[43.848,-65.332],[42.773,-69.727],[24.072,-70.605],[6.445,-71.094],[5.176,-35.938],[4.004,0],[12.891,0.586]],"c":true},"ix":2},"nm":"F","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"F","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"A","size":165,"style":"Regular","w":52.54,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[5.469,-14.778],[2.083,-7.617],[-0.977,-1.204],[-1.367,0],[-0.977,1.172],[-1.233,5.273],[-0.845,2.344],[-13.376,-1.692],[-0.584,-2.864],[-0.749,-0.684],[-0.847,0],[-0.652,0.943],[0,1.889],[5.664,14.746],[1.822,8.073],[0,0]],"o":[[-5.469,14.78],[0,1.758],[0.977,1.204],[1.236,0],[0.716,-2.017],[1.233,-5.273],[3.441,0.391],[3.181,8.594],[0.259,1.237],[0.748,0.684],[0.977,0],[0.65,-0.945],[-1.823,-7.291],[-5.664,-14.746],[0,0],[-2.148,7.553]],"v":[[11.328,-37.305],[0,-3.711],[1.465,0.732],[4.98,2.539],[8.301,0.781],[11.224,-10.156],[14.342,-21.582],[39.566,-18.457],[45.215,-1.27],[46.729,1.611],[49.121,2.637],[51.562,1.221],[52.539,-3.027],[41.309,-36.084],[30.078,-70.312],[22.754,-70.801]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-6.686,-14.388],[4.935,0],[0,0],[-1.3,7.878]],"o":[[-3.311,-0.325],[0,0],[5.908,-15.234],[1.624,9.05]],"v":[[38.593,-25.781],[26.224,-26.27],[15.317,-26.27],[26.128,-60.938]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"A","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"N","size":165,"style":"Regular","w":54.88,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.074,-0.977],[-1.172,0],[-0.586,2.017],[0.032,11.719],[0.064,4.428],[-5.893,-11.783],[-3.972,-6.119],[-2.214,0],[-1.367,0.586],[0.716,14.128],[0,0],[0,-19.661],[0,0],[0,0],[0,0],[0,0]],"o":[[1.074,0.977],[1.692,0],[-0.195,-6.055],[-0.034,-11.719],[2.473,4.362],[5.891,11.784],[2.408,1.302],[1.497,0],[-0.456,-32.422],[0,0],[-0.717,15.691],[0,0],[0,0],[0,0],[0,0],[0.259,1.367]],"v":[[6.006,0.781],[9.375,2.246],[12.793,-0.781],[12.451,-27.441],[12.305,-51.66],[24.854,-27.441],[39.648,-0.586],[46.582,1.367],[50.879,0.488],[49.121,-69.336],[43.555,-70.41],[42.48,-17.383],[42.48,-9.668],[10.547,-70.312],[5.273,-70.312],[4.004,-2.734]],"c":true},"ix":2},"nm":"N","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"N","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"T","size":165,"style":"Regular","w":43.07,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-7.358,-0.52],[0,-7.747],[-0.034,-5.338],[0,-2.669],[0.13,-3.516],[-1.108,-0.943],[-1.172,0],[-0.586,1.953],[1.627,22.983],[0,0],[-0.652,0.652],[0,0.847],[1.106,1.108],[1.627,0.066],[0,0],[0,0]],"o":[[-0.261,6.25],[0,2.67],[0.032,5.339],[0,7.162],[0.259,1.367],[1.106,0.943],[1.627,0],[-0.781,-18.814],[0,0],[1.302,-0.13],[0.65,-0.65],[0,-1.302],[-1.108,-1.106],[0,0],[0,0],[4.036,0.195]],"v":[[18.066,-64.453],[17.676,-43.457],[17.725,-31.445],[17.773,-19.434],[17.578,-3.418],[19.629,0.049],[23.047,1.465],[26.367,-1.465],[22.754,-64.16],[39.16,-63.281],[42.09,-64.453],[43.066,-66.699],[41.406,-70.312],[37.305,-72.07],[0,-69.922],[0.977,-65.527]],"c":true},"ix":2},"nm":"T","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"T","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"S","size":165,"style":"Regular","w":44.63,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-4.851,-1.193],[-4.297,0],[-3.125,3.093],[0,4.883],[1.236,2.768],[1.985,1.823],[2.408,1.562],[2.441,1.367],[1.985,1.433],[1.236,1.953],[0,2.409],[-2.214,2.019],[-3.125,0],[-7.422,-2.539],[0,0],[4.395,1.433],[3.58,0],[3.32,-3.809],[0,-4.622],[-2.344,-3.091],[-3.32,-2.115],[-3.32,-2.025],[-2.344,-2.646],[0,-3.201],[2.766,-1.601],[3.906,0],[5.664,3.061],[0,0]],"o":[[4.849,1.195],[5.013,0],[3.125,-3.091],[0,-3.45],[-1.237,-2.766],[-1.987,-1.822],[-2.409,-1.562],[-2.441,-1.367],[-1.987,-1.431],[-1.237,-1.953],[0,-3.189],[2.213,-2.017],[5.078,0],[0,0],[-2.995,-1.431],[-4.395,-1.431],[-4.688,0],[-3.32,3.809],[0,3.777],[2.344,3.093],[3.32,2.116],[3.32,2.025],[2.344,2.646],[0,3.592],[-2.768,1.601],[-5.469,0],[0,0],[2.017,1.614]],"v":[[13.037,-1.303],[26.758,0.488],[38.965,-4.15],[43.652,-16.113],[41.797,-25.439],[36.963,-32.324],[30.371,-37.402],[23.096,-41.797],[16.455,-45.996],[11.621,-51.074],[9.766,-57.617],[13.086,-65.43],[21.094,-68.457],[39.844,-64.648],[41.016,-68.555],[29.932,-72.852],[17.969,-75],[5.957,-69.287],[0.977,-56.641],[4.492,-46.338],[12.988,-38.525],[22.949,-32.314],[31.445,-25.308],[34.961,-16.537],[30.811,-8.748],[20.801,-6.348],[4.102,-10.938],[2.734,-5.515]],"c":true},"ix":2},"nm":"S","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"S","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"I","size":165,"style":"Regular","w":32.91,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-4.362,0.032],[-2.214,0],[-1.953,-0.066],[0,0],[2.93,0.261],[1.041,0.195],[0,8.936],[0.032,7.37],[0.195,1.826],[-2.019,0.096],[-1.108,0.449],[0,0],[5.728,0],[2.669,0.064],[0,0],[0,0],[-0.261,-11.053],[0,-5.869],[0.064,-2.217],[5.989,-0.977],[0,0]],"o":[[4.361,-0.034],[4.231,0],[0,0],[-0.717,-0.13],[-2.93,-0.259],[-0.131,-3.781],[0,-8.934],[-0.034,-7.37],[0.52,-0.064],[2.017,-0.096],[0,0],[-2.8,-0.064],[-5.6,0],[0,0],[0,0],[0.064,3.587],[0.259,11.053],[0,4.434],[-1.433,0.066],[0,0],[1.822,0]],"v":[[11.621,0.244],[21.484,0.195],[30.762,0.293],[30.957,-4.785],[25.488,-5.371],[19.531,-6.055],[19.336,-25.13],[19.287,-49.585],[18.945,-63.379],[22.754,-63.618],[27.441,-64.436],[27.148,-69.241],[14.355,-69.337],[1.953,-69.434],[2.637,-63.86],[12.5,-63.379],[12.988,-41.417],[13.379,-16.032],[13.281,-6.055],[2.148,-4.492],[2.344,0.293]],"c":true},"ix":2},"nm":"I","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"I","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"C","size":165,"style":"Regular","w":46.39,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.036,1.303],[3.775,0],[3.157,-2.473],[1.562,-4.036],[0.65,-4.004],[0,-4.231],[-1.074,-4.263],[-1.987,-3.906],[-3.452,-2.539],[-4.167,0],[-8.203,5.664],[0.845,1.237],[4.102,0],[2.864,3.581],[1.204,4.135],[0,3.256],[-0.163,2.475],[-0.684,3.386],[-1.205,2.214],[-2.344,1.562],[-3.256,0],[-5.078,-3.775],[0,0]],"o":[[-4.037,-1.302],[-4.362,0],[-3.159,2.475],[-1.562,4.037],[-0.652,4.004],[0,3.842],[1.074,4.265],[1.985,3.906],[3.45,2.539],[6.445,0],[-1.367,-2.864],[-8.464,4.297],[-3.777,0],[-2.866,-3.58],[-1.205,-4.134],[0,-3.32],[0.162,-2.473],[0.684,-3.384],[1.204,-2.213],[2.344,-1.562],[4.947,0],[0,0],[-2.866,-1.953]],"v":[[38.379,-69.336],[26.66,-71.289],[15.381,-67.578],[8.301,-57.812],[4.98,-45.752],[4.004,-33.398],[5.615,-21.24],[10.205,-8.984],[18.359,0.684],[29.785,4.492],[51.758,-4.004],[48.438,-10.156],[29.59,-3.711],[19.629,-9.082],[13.525,-20.654],[11.719,-31.738],[11.963,-40.43],[13.232,-49.219],[16.064,-57.617],[21.387,-63.281],[29.785,-65.625],[44.824,-59.961],[48.73,-64.453]],"c":true},"ix":2},"nm":"C","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"C","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"!","size":165,"style":"Regular","w":18.16,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.261,11.784],[-0.195,3.516],[1.106,1.108],[1.302,0],[0.259,-2.539],[-0.327,-4.297],[0,0]],"o":[[0.259,-11.783],[-0.066,-1.627],[-1.108,-1.106],[-2.019,0],[1.367,29.819],[0,0],[0.52,-6.38]],"v":[[12.109,-44.043],[12.793,-66.992],[11.035,-71.094],[7.422,-72.754],[4.004,-68.945],[6.543,-17.773],[10.938,-16.797]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.618,-0.879],[0,-1.431],[-1.042,-1.497],[-1.823,0],[-0.684,0.879],[0,1.433],[1.172,1.53],[1.758,0]],"o":[[-0.62,0.879],[0,2.019],[1.041,1.497],[1.172,0],[0.684,-0.879],[0,-1.953],[-1.172,-1.529],[-1.108,0]],"v":[[5.42,-10.01],[4.492,-6.543],[6.055,-1.27],[10.352,0.977],[13.135,-0.342],[14.16,-3.809],[12.402,-9.033],[8.008,-11.328]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"!","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"}]}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = {"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":29.9700012207031,"ip":0,"op":60.0000024438501,"w":1440,"h":900,"nm":"congrats-anim","ddd":0,"assets":[],"fonts":{"list":[{"fName":"Neucha","fFamily":"Neucha","fStyle":"Regular","ascent":78.2669067382812}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[2.965,3.413],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949020026712,1,1,1],"ix":4},"o":{"a":0,"k":0,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1109.482,-460.294],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":"GOOD WORK!","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[287.076,526.074,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":165,"f":"Neucha","t":"GOOD WORK!","j":0,"tr":0,"lh":198,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Positon !","s":{"t":0,"xe":{"a":0,"k":100,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[-100]},{"t":35.0000014255792,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-100,0],"ix":2}}},{"nm":"Positon ! 2","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[-100]},{"t":42.0000017106951,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,100,0],"ix":2}}},{"nm":"Positon ! 3","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[-100]},{"t":50.0000020365418,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-20,0],"ix":2}}},{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":1,"r":1},"a":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":24,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[100]},{"t":50.0000020365418,"s":[0]}],"ix":9}}}]},"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Vector 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":160,"ix":10},"p":{"a":0,"k":[584.527,440.481,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[301,301,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.592,-12.412],[2,-16.5],[13.997,-5.599],[-27.5,8.5],[10.5,-11]],"o":[[-5.333,6.667],[-1.12,23.5],[-2,16.5],[-17.5,7],[21.203,-6.554],[0,0]],"v":[[20.348,-63],[5.348,-27.5],[17.848,19],[-1.773,47],[-4.273,19],[11.348,63]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.737254917622,0.929411768913,0.964705884457,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":34.0000013848484,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1050.187,96.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[237,237,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.6,3.6],[-1.5,-2],[8,-2],[-14,18],[-2.5,-1.5],[13.5,-4],[-16.5,6.5],[-2.5,-15.5]],"o":[[-0.667,-5.167],[12,-4.5],[1.5,2],[-8,2],[14,-18],[7.34,4.404],[-13.5,4],[16.5,-6.5],[0,0]],"v":[[-52.17,25.752],[-42.17,5.752],[-21.67,7.752],[-24.67,19.752],[-30.67,-10.248],[12.83,-19.748],[16.33,3.752],[12.83,-23.248],[52.33,-7.748]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.341176480055,0.384313732386,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":47.0000019143492,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[338.677,338.677],"ix":3},"r":{"a":0,"k":-152.245,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":47.0000019143492,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Vector 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.241,603.609,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[291,291,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.019,15.142],[-21.544,1.854],[21.843,-0.123],[-19.051,-0.566],[-1.053,6.591]],"o":[[20.081,-4.4],[18.48,-14.713],[39.724,-3.419],[-16.471,0.093],[15.241,0.452],[0,0]],"v":[[-75.292,75.735],[-60.995,27.44],[-14.55,20.726],[-7.144,-15.78],[-4.048,2.355],[23.103,-21.036]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.349019616842,0.521568655968,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[2]},{"t":52.0000021180034,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":4.645,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":35.0000014255792,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":52.0000021180034,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[270.187,812.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[225,225,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.5,-6.5],[-13.5,4],[7.34,4.404],[14,-18],[-8,2],[1.5,2],[12,-4.5],[-0.667,-5.167]],"o":[[-2.5,-15.5],[-16.5,6.5],[13.5,-4],[-2.5,-1.5],[-14,18],[8,-2],[-1.5,-2],[-9.6,3.6],[0,0]],"v":[[52.33,-7.748],[12.83,-23.248],[16.33,3.752],[12.83,-19.748],[-30.67,-10.248],[-24.67,19.752],[-21.67,7.752],[-42.17,5.752],[-52.17,25.752]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.800000011921,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":48.0000019550801,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,16],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":16.945,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":48.0000019550801,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Vector 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[283.99,512.842,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[273.086,215.359,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.5,13.5],[-23.5,0],[11.167,-2.5],[-1.56,32.421],[-2.788,-11.5],[22.8,-2.8],[-8.333,15.667]],"o":[[-27,-2],[-4.5,-13.5],[11.674,0],[-11.167,2.5],[2,-44.8],[1.333,5.5],[-36.8,2.8],[0,0]],"v":[[31.163,87.75],[-21.837,47.75],[6.163,3.75],[9.163,17.75],[-28.337,-9.75],[21.163,-64.25],[-3.337,-44.25],[-24.337,-87.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.996078431606,0.372549027205,0.333333343267,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[3]},{"t":37.0000015070409,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 6","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Vector 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":147,"ix":10},"p":{"a":0,"k":[493.605,-13.278,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[221,221,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-26.751,23.049],[-17.579,29.801],[-38.844,16.733]],"o":[[-4.793,-10.962],[21.816,-18.796],[14.832,-25.144],[0,0]],"v":[[-12.046,101.322],[2.42,15.388],[89.01,-32.998],[104.067,-125.327]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.65098041296,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[2]},{"t":51.0000020772726,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":-92.056,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 7","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":13,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":36.0000014663101,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[1444.67,903.138],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.665,-2.431],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"G","size":165,"style":"Regular","w":57.03,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.552,-0.65],[1.106,-0.977],[1.367,-0.911],[1.92,-0.65],[2.017,0],[2.93,5.046],[0,7.944],[-0.163,2.475],[-0.684,3.386],[-1.205,2.214],[-2.344,1.562],[-3.256,0],[-5.078,-3.775],[0,0],[4.036,1.303],[3.775,0],[3.157,-2.473],[1.562,-4.036],[0.65,-4.004],[0,-4.231],[-15.82,0],[-2.019,0.586],[-1.303,0.845],[-0.977,0.912],[-0.456,0.62],[0,0.131],[0,-2.441],[-0.066,-0.652],[0,0],[0,0],[4.817,-0.423],[1.302,-0.195],[0,0]],"o":[[0,0],[0,0.131],[-0.554,0.652],[-1.108,0.977],[-1.367,0.912],[-1.921,0.652],[-4.688,0],[-2.93,-5.045],[0,-3.32],[0.162,-2.473],[0.684,-3.384],[1.204,-2.213],[2.344,-1.562],[4.947,0],[0,0],[-2.866,-1.953],[-4.037,-1.302],[-4.362,0],[-3.159,2.475],[-1.562,4.037],[-0.652,4.004],[0,24.609],[2.213,0],[2.017,-0.586],[1.302,-0.845],[0.977,-0.911],[0.455,-0.618],[0.064,0.717],[0,2.441],[0,0],[0,0],[-1.237,0.261],[-4.819,0.424],[0,0],[0,0]],"v":[[45.41,-20.703],[45.41,-14.453],[44.58,-13.281],[42.09,-10.84],[38.379,-8.008],[33.447,-5.664],[27.539,-4.688],[16.113,-12.256],[11.719,-31.738],[11.963,-40.43],[13.232,-49.219],[16.064,-57.617],[21.387,-63.281],[29.785,-65.625],[44.824,-59.961],[48.73,-64.453],[38.379,-69.336],[26.66,-71.289],[15.381,-67.578],[8.301,-57.812],[4.98,-45.752],[4.004,-33.398],[27.734,3.516],[34.082,2.637],[39.062,0.488],[42.48,-2.148],[44.629,-4.443],[45.312,-5.566],[45.41,-0.83],[45.508,3.809],[53.125,2.246],[53.125,-28.809],[44.043,-27.783],[34.863,-26.855],[35.938,-22.461]],"c":true},"ix":2},"nm":"G","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"G","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"O","size":165,"style":"Regular","w":52.34,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.424,-3.384],[-1.074,-2.864],[-1.855,-1.758],[-2.898,-0.977],[-4.037,0],[-2.019,0.845],[-1.335,1.335],[-0.977,2.051],[-0.554,2.019],[-0.293,2.637],[-0.098,2.084],[0,2.605],[0.293,3.191],[1.009,3.516],[1.692,2.409],[2.994,1.596],[4.036,0],[1.692,-0.455],[1.236,-0.943],[1.041,-1.041],[0.684,-1.692],[0.52,-1.334],[0.325,-2.18],[0.162,-1.367],[0.098,-2.344],[0,-1.138],[0,-2.213]],"o":[[0.423,3.386],[1.074,2.866],[1.855,1.758],[2.896,0.977],[2.473,0],[2.017,-0.845],[1.334,-1.334],[0.977,-2.051],[0.552,-2.017],[0.293,-2.637],[0.098,-2.083],[0,-3.841],[-0.293,-3.189],[-1.01,-3.516],[-1.694,-2.408],[-2.995,-1.595],[-2.019,0],[-1.694,0.456],[-1.237,0.945],[-1.042,1.042],[-0.684,1.694],[-0.522,1.335],[-0.327,2.182],[-0.163,1.367],[-0.098,2.344],[0,1.14],[0,4.623]],"v":[[4.736,-20.703],[6.982,-11.328],[11.377,-4.395],[18.506,-0.293],[28.906,1.172],[35.645,-0.098],[40.674,-3.369],[44.141,-8.447],[46.436,-14.551],[47.705,-21.533],[48.291,-28.613],[48.438,-35.645],[47.998,-46.191],[46.045,-56.25],[41.992,-65.137],[34.961,-71.143],[24.414,-73.535],[18.848,-72.852],[14.453,-70.752],[11.035,-67.773],[8.447,-63.672],[6.641,-59.131],[5.371,-53.857],[4.639,-48.535],[4.248,-42.969],[4.102,-37.744],[4.102,-32.715]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[2.351,-5.078],[4.767,-0.259],[1.73,0.815],[1.077,1.074],[0.784,1.953],[0.36,1.498],[0.195,2.573],[0.032,1.401],[0,2.67],[-0.848,4.33],[-1.993,3.484],[-2.614,0],[-2.483,-2.505],[-1.143,-3.97],[-0.49,-3.45],[0,-3.189]],"o":[[-2.351,5.078],[-2.156,-0.064],[-1.73,-0.813],[-1.077,-1.074],[-0.784,-1.953],[-0.36,-1.497],[-0.195,-2.571],[-0.034,-1.399],[0,-3.841],[0.848,-4.329],[1.993,-3.482],[3.461,0],[2.481,2.507],[1.143,3.972],[0.49,3.452],[0,7.358]],"v":[[37.878,-13.281],[27.2,-5.273],[21.37,-6.592],[17.157,-9.424],[14.365,-13.965],[12.65,-19.141],[11.816,-25.244],[11.475,-31.201],[11.426,-37.305],[12.698,-49.561],[16.96,-61.279],[23.869,-66.504],[32.785,-62.744],[38.222,-53.027],[40.671,-41.895],[41.406,-31.934]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"O","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"D","size":165,"style":"Regular","w":53.52,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.605,0],[-4.265,1.205],[-3.679,2.214],[-2.344,3.711],[0,4.492],[7.877,7.26],[14.453,0.131],[0,0]],"o":[[4.166,0],[4.263,-1.204],[3.677,-2.213],[2.344,-3.711],[0,-13.997],[-7.878,-7.259],[0,0],[3.059,0.391]],"v":[[12.5,0],[25.146,-1.807],[37.061,-6.934],[46.094,-15.82],[49.609,-28.125],[37.793,-60.01],[4.297,-71.094],[4.004,-0.586]],"c":true},"ix":2},"nm":"D","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,3.906],[-0.847,0],[-4.655,-3.482],[-3.288,-5.63],[0,-5.469],[1.758,-3.091],[2.93,-1.758],[3.45,-0.879],[3.711,0],[0,0]],"o":[[0.781,-0.195],[3.97,0],[4.654,3.484],[3.287,5.632],[0,4.037],[-1.758,3.093],[-2.93,1.758],[-3.452,0.879],[0,0],[-0.391,-35.091]],"v":[[10.742,-65.039],[13.184,-65.332],[26.123,-60.107],[38.037,-46.436],[42.969,-29.785],[40.332,-19.092],[33.301,-11.816],[23.73,-7.861],[12.988,-6.543],[11.328,-6.543]],"c":true},"ix":2},"nm":"D","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"D","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":" ","size":165,"style":"Regular","w":27.93,"data":{},"fFamily":"Neucha"},{"ch":"W","size":165,"style":"Regular","w":66.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[10.025,-36.588],[2.603,11.98],[0,0],[-0.912,-4.166],[2.344,-8.723],[0.977,-3.516],[2.603,11.98],[0,0],[-1.108,-5.469],[-1.01,-4.785],[-1.367,-6.184],[-1.27,-5.078],[-0.977,-2.93],[-1.823,0],[-0.652,0.13],[-4.037,16.602],[-1.758,-5.208],[-1.823,0],[-0.652,0.13],[-5.014,20.898],[-0.066,0.131],[0,0]],"o":[[-6.772,-26.431],[0,0],[2.083,10.483],[-0.781,2.8],[-2.344,8.725],[-6.772,-26.431],[0,0],[0.13,0.522],[1.106,5.469],[1.009,4.785],[1.367,6.186],[1.27,5.078],[2.278,0.456],[0.65,0],[1.758,-4.817],[3.58,15.886],[2.278,0.456],[0.65,0],[1.822,-4.688],[5.013,-20.898],[0,0],[-0.912,1.823]],"v":[[44.434,-12.695],[30.371,-70.312],[24.805,-70.312],[29.297,-48.34],[24.609,-31.055],[19.629,-12.695],[5.566,-70.312],[0,-70.312],[1.855,-61.328],[5.029,-45.947],[8.594,-29.492],[12.549,-12.598],[15.918,-0.586],[22.07,0.098],[24.023,-0.098],[32.715,-32.227],[40.723,-0.586],[46.875,0.098],[48.828,-0.098],[59.082,-38.477],[66.699,-70.02],[60.84,-70.312]],"c":true},"ix":2},"nm":"W","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"W","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"R","size":165,"style":"Regular","w":51.86,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.827,4.492],[2.271,4.753],[-2.464,1.562],[-1.395,2.409],[-0.714,2.768],[0,2.995],[3.571,4.526],[7.207,0],[3.7,-2.473],[0,2.084],[0,0],[0.232,-15.82],[0.198,-5.469],[-1.088,-0.945],[-1.187,0],[-0.587,2.017],[0.13,4.753],[0,0],[-2.176,-2.832],[-2.76,-2.766],[-3.183,-1.823],[-2.924,-0.066],[0,0]],"o":[[-3.828,-4.492],[3.177,-0.259],[2.463,-1.562],[1.395,-2.408],[0.713,-2.766],[0,-8.138],[-3.572,-4.524],[-6.689,0],[-0.066,-0.259],[0,0],[-0.398,8.659],[-0.232,15.82],[0.262,1.367],[1.086,0.943],[1.712,0],[-0.391,-10.025],[0,0],[1.558,2.734],[2.176,2.832],[2.759,2.768],[3.183,1.822],[0,0],[-3.764,-1.042]],"v":[[37.935,-6.738],[28.787,-20.605],[37.248,-23.34],[43.034,-29.297],[46.196,-37.061],[47.266,-45.703],[41.908,-64.697],[25.74,-71.484],[10.156,-67.773],[10.059,-71.289],[5.592,-70.117],[4.648,-33.398],[4.004,-1.465],[6.03,2.002],[9.441,3.418],[12.891,0.391],[12.109,-21.777],[19.803,-20.898],[25.404,-12.549],[32.808,-4.15],[41.721,2.734],[50.879,5.566],[49.323,1.562]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-3.958,0],[-3.244,-4.231],[0,-5.273],[3.114,-3.384],[4.477,0],[3.568,1.953],[0,0]],"o":[[4.866,0],[3.244,4.233],[0,4.883],[-3.114,3.386],[-4.672,0],[0,0],[4.153,-3.125]],"v":[[23.203,-65.918],[35.368,-59.57],[40.234,-45.312],[35.562,-32.91],[24.176,-27.832],[11.816,-30.762],[11.035,-61.23]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"R","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"K","size":165,"style":"Regular","w":44.82,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[7.129,8.789],[2.278,2.409],[-2.344,3.906],[0,0],[1.822,-1.888],[2.18,-2.539],[1.138,-1.334],[3.027,-3.677],[1.106,-1.367],[0.259,8.041],[0.195,3.256],[0,0],[0.13,-16.406],[0.195,-5.208],[-1.074,-0.943],[-1.172,0],[-0.586,1.953],[0,0],[-2.702,-3.352],[-1.53,-1.822],[-2.409,-2.603],[-2.148,-2.017],[0,0]],"o":[[-7.129,-8.789],[15.82,-18.228],[0,0],[-2.084,1.953],[-1.823,1.889],[-2.182,2.539],[-1.14,1.335],[-3.027,3.679],[-0.131,-2.669],[-0.261,-8.04],[0,0],[-0.456,7.812],[-0.131,16.406],[0.259,1.367],[1.074,0.943],[1.692,0],[0,0],[1.106,1.367],[2.701,3.354],[1.529,1.823],[2.408,2.605],[0,0],[-2.734,-2.734]],"v":[[30.127,-16.602],[16.016,-33.398],[43.262,-66.602],[40.332,-71.387],[34.473,-65.625],[28.467,-58.984],[23.486,-53.174],[17.236,-45.654],[11.035,-38.086],[10.449,-54.15],[9.766,-71.094],[5.371,-72.07],[4.492,-35.742],[4.004,-3.32],[6.006,0.146],[9.375,1.562],[12.793,-1.367],[11.523,-27.734],[17.236,-20.654],[23.584,-12.891],[29.492,-6.25],[36.328,0.684],[44.922,0.684]],"c":true},"ix":2},"nm":"K","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"K","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"!","size":165,"style":"Regular","w":18.16,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.261,11.784],[-0.195,3.516],[1.106,1.108],[1.302,0],[0.259,-2.539],[-0.327,-4.297],[0,0]],"o":[[0.259,-11.783],[-0.066,-1.627],[-1.108,-1.106],[-2.019,0],[1.367,29.819],[0,0],[0.52,-6.38]],"v":[[12.109,-44.043],[12.793,-66.992],[11.035,-71.094],[7.422,-72.754],[4.004,-68.945],[6.543,-17.773],[10.938,-16.797]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.618,-0.879],[0,-1.431],[-1.042,-1.497],[-1.823,0],[-0.684,0.879],[0,1.433],[1.172,1.53],[1.758,0]],"o":[[-0.62,0.879],[0,2.019],[1.041,1.497],[1.172,0],[0.684,-0.879],[0,-1.953],[-1.172,-1.529],[-1.108,0]],"v":[[5.42,-10.01],[4.492,-6.543],[6.055,-1.27],[10.352,0.977],[13.135,-0.342],[14.16,-3.809],[12.402,-9.033],[8.008,-11.328]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"!","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"}]}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = {"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":29.9700012207031,"ip":0,"op":60.0000024438501,"w":1440,"h":900,"nm":"congrats-anim","ddd":0,"assets":[],"fonts":{"list":[{"fName":"Neucha","fFamily":"Neucha","fStyle":"Regular","ascent":78.2669067382812}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[2.965,3.413],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949020026712,1,1,1],"ix":4},"o":{"a":0,"k":0,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1109.482,-460.294],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":"GREAT JOB!","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[333.338,507.202,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":165,"f":"Neucha","t":"GREAT JOB!","j":0,"tr":0,"lh":198,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Positon !","s":{"t":0,"xe":{"a":0,"k":100,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[-100]},{"t":35.0000014255792,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-100,0],"ix":2}}},{"nm":"Positon ! 2","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[-100]},{"t":42.0000017106951,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,100,0],"ix":2}}},{"nm":"Positon ! 3","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[-100]},{"t":50.0000020365418,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-20,0],"ix":2}}},{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":1,"r":1},"a":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":24,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[100]},{"t":50.0000020365418,"s":[0]}],"ix":9}}}]},"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Vector 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":160,"ix":10},"p":{"a":0,"k":[584.527,440.481,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[301,301,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.592,-12.412],[2,-16.5],[13.997,-5.599],[-27.5,8.5],[10.5,-11]],"o":[[-5.333,6.667],[-1.12,23.5],[-2,16.5],[-17.5,7],[21.203,-6.554],[0,0]],"v":[[20.348,-63],[5.348,-27.5],[17.848,19],[-1.773,47],[-4.273,19],[11.348,63]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.737254917622,0.929411768913,0.964705884457,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":34.0000013848484,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1050.187,96.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[237,237,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.6,3.6],[-1.5,-2],[8,-2],[-14,18],[-2.5,-1.5],[13.5,-4],[-16.5,6.5],[-2.5,-15.5]],"o":[[-0.667,-5.167],[12,-4.5],[1.5,2],[-8,2],[14,-18],[7.34,4.404],[-13.5,4],[16.5,-6.5],[0,0]],"v":[[-52.17,25.752],[-42.17,5.752],[-21.67,7.752],[-24.67,19.752],[-30.67,-10.248],[12.83,-19.748],[16.33,3.752],[12.83,-23.248],[52.33,-7.748]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.341176480055,0.384313732386,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":47.0000019143492,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[338.677,338.677],"ix":3},"r":{"a":0,"k":-152.245,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":47.0000019143492,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Vector 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.241,603.609,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[291,291,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.019,15.142],[-21.544,1.854],[21.843,-0.123],[-19.051,-0.566],[-1.053,6.591]],"o":[[20.081,-4.4],[18.48,-14.713],[39.724,-3.419],[-16.471,0.093],[15.241,0.452],[0,0]],"v":[[-75.292,75.735],[-60.995,27.44],[-14.55,20.726],[-7.144,-15.78],[-4.048,2.355],[23.103,-21.036]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.349019616842,0.521568655968,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[2]},{"t":52.0000021180034,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":4.645,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":35.0000014255792,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":52.0000021180034,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[270.187,812.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[225,225,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.5,-6.5],[-13.5,4],[7.34,4.404],[14,-18],[-8,2],[1.5,2],[12,-4.5],[-0.667,-5.167]],"o":[[-2.5,-15.5],[-16.5,6.5],[13.5,-4],[-2.5,-1.5],[-14,18],[8,-2],[-1.5,-2],[-9.6,3.6],[0,0]],"v":[[52.33,-7.748],[12.83,-23.248],[16.33,3.752],[12.83,-19.748],[-30.67,-10.248],[-24.67,19.752],[-21.67,7.752],[-42.17,5.752],[-52.17,25.752]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.800000011921,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":48.0000019550801,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,16],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":16.945,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":48.0000019550801,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Vector 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[283.99,512.842,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[273.086,215.359,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.5,13.5],[-23.5,0],[11.167,-2.5],[-1.56,32.421],[-2.788,-11.5],[22.8,-2.8],[-8.333,15.667]],"o":[[-27,-2],[-4.5,-13.5],[11.674,0],[-11.167,2.5],[2,-44.8],[1.333,5.5],[-36.8,2.8],[0,0]],"v":[[31.163,87.75],[-21.837,47.75],[6.163,3.75],[9.163,17.75],[-28.337,-9.75],[21.163,-64.25],[-3.337,-44.25],[-24.337,-87.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.996078431606,0.372549027205,0.333333343267,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[3]},{"t":37.0000015070409,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 6","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Vector 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":147,"ix":10},"p":{"a":0,"k":[493.605,-13.278,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[221,221,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-26.751,23.049],[-17.579,29.801],[-38.844,16.733]],"o":[[-4.793,-10.962],[21.816,-18.796],[14.832,-25.144],[0,0]],"v":[[-12.046,101.322],[2.42,15.388],[89.01,-32.998],[104.067,-125.327]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.65098041296,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[2]},{"t":51.0000020772726,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":-92.056,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 7","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":13,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":36.0000014663101,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[1444.67,903.138],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.665,-2.431],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"G","size":165,"style":"Regular","w":57.03,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.552,-0.65],[1.106,-0.977],[1.367,-0.911],[1.92,-0.65],[2.017,0],[2.93,5.046],[0,7.944],[-0.163,2.475],[-0.684,3.386],[-1.205,2.214],[-2.344,1.562],[-3.256,0],[-5.078,-3.775],[0,0],[4.036,1.303],[3.775,0],[3.157,-2.473],[1.562,-4.036],[0.65,-4.004],[0,-4.231],[-15.82,0],[-2.019,0.586],[-1.303,0.845],[-0.977,0.912],[-0.456,0.62],[0,0.131],[0,-2.441],[-0.066,-0.652],[0,0],[0,0],[4.817,-0.423],[1.302,-0.195],[0,0]],"o":[[0,0],[0,0.131],[-0.554,0.652],[-1.108,0.977],[-1.367,0.912],[-1.921,0.652],[-4.688,0],[-2.93,-5.045],[0,-3.32],[0.162,-2.473],[0.684,-3.384],[1.204,-2.213],[2.344,-1.562],[4.947,0],[0,0],[-2.866,-1.953],[-4.037,-1.302],[-4.362,0],[-3.159,2.475],[-1.562,4.037],[-0.652,4.004],[0,24.609],[2.213,0],[2.017,-0.586],[1.302,-0.845],[0.977,-0.911],[0.455,-0.618],[0.064,0.717],[0,2.441],[0,0],[0,0],[-1.237,0.261],[-4.819,0.424],[0,0],[0,0]],"v":[[45.41,-20.703],[45.41,-14.453],[44.58,-13.281],[42.09,-10.84],[38.379,-8.008],[33.447,-5.664],[27.539,-4.688],[16.113,-12.256],[11.719,-31.738],[11.963,-40.43],[13.232,-49.219],[16.064,-57.617],[21.387,-63.281],[29.785,-65.625],[44.824,-59.961],[48.73,-64.453],[38.379,-69.336],[26.66,-71.289],[15.381,-67.578],[8.301,-57.812],[4.98,-45.752],[4.004,-33.398],[27.734,3.516],[34.082,2.637],[39.062,0.488],[42.48,-2.148],[44.629,-4.443],[45.312,-5.566],[45.41,-0.83],[45.508,3.809],[53.125,2.246],[53.125,-28.809],[44.043,-27.783],[34.863,-26.855],[35.938,-22.461]],"c":true},"ix":2},"nm":"G","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"G","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"R","size":165,"style":"Regular","w":51.86,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.827,4.492],[2.271,4.753],[-2.464,1.562],[-1.395,2.409],[-0.714,2.768],[0,2.995],[3.571,4.526],[7.207,0],[3.7,-2.473],[0,2.084],[0,0],[0.232,-15.82],[0.198,-5.469],[-1.088,-0.945],[-1.187,0],[-0.587,2.017],[0.13,4.753],[0,0],[-2.176,-2.832],[-2.76,-2.766],[-3.183,-1.823],[-2.924,-0.066],[0,0]],"o":[[-3.828,-4.492],[3.177,-0.259],[2.463,-1.562],[1.395,-2.408],[0.713,-2.766],[0,-8.138],[-3.572,-4.524],[-6.689,0],[-0.066,-0.259],[0,0],[-0.398,8.659],[-0.232,15.82],[0.262,1.367],[1.086,0.943],[1.712,0],[-0.391,-10.025],[0,0],[1.558,2.734],[2.176,2.832],[2.759,2.768],[3.183,1.822],[0,0],[-3.764,-1.042]],"v":[[37.935,-6.738],[28.787,-20.605],[37.248,-23.34],[43.034,-29.297],[46.196,-37.061],[47.266,-45.703],[41.908,-64.697],[25.74,-71.484],[10.156,-67.773],[10.059,-71.289],[5.592,-70.117],[4.648,-33.398],[4.004,-1.465],[6.03,2.002],[9.441,3.418],[12.891,0.391],[12.109,-21.777],[19.803,-20.898],[25.404,-12.549],[32.808,-4.15],[41.721,2.734],[50.879,5.566],[49.323,1.562]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-3.958,0],[-3.244,-4.231],[0,-5.273],[3.114,-3.384],[4.477,0],[3.568,1.953],[0,0]],"o":[[4.866,0],[3.244,4.233],[0,4.883],[-3.114,3.386],[-4.672,0],[0,0],[4.153,-3.125]],"v":[[23.203,-65.918],[35.368,-59.57],[40.234,-45.312],[35.562,-32.91],[24.176,-27.832],[11.816,-30.762],[11.035,-61.23]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"R","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"E","size":165,"style":"Regular","w":45.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[14.908,1.367],[-0.098,5.827],[0,2.866],[-13.737,1.237],[0,0],[5.859,0.488],[2.213,0.261],[0.227,4.623],[0.064,1.498],[-8.789,0.717],[-2.93,0.522],[0,0],[9.537,0.131],[2.213,0.195],[0.13,-16.797],[0.65,-7.161],[-4.819,0],[-6.674,0.227],[-2.539,0],[0,0]],"o":[[0,-2.734],[0.098,-5.826],[2.344,-0.064],[0,0],[-1.562,-0.13],[-5.859,-0.488],[-0.066,-2.994],[-0.229,-4.622],[0.455,-0.064],[8.789,-0.716],[0,0],[-2.93,-0.455],[-9.538,-0.13],[-0.717,6.641],[-0.131,16.797],[1.758,0.455],[2.994,0],[6.673,-0.229],[0,0],[-3.842,-0.586]],"v":[[13.086,-7.324],[13.232,-20.166],[13.379,-33.203],[37.5,-35.156],[36.523,-39.648],[25.391,-40.576],[13.281,-41.699],[12.842,-53.125],[12.402,-62.305],[26.27,-63.477],[43.848,-65.332],[42.773,-69.727],[24.072,-70.605],[6.445,-71.094],[5.176,-35.938],[4.004,0],[13.867,0.684],[28.369,0.342],[42.188,0],[41.211,-4.395]],"c":true},"ix":2},"nm":"E","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"E","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"A","size":165,"style":"Regular","w":52.54,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[5.469,-14.778],[2.083,-7.617],[-0.977,-1.204],[-1.367,0],[-0.977,1.172],[-1.233,5.273],[-0.845,2.344],[-13.376,-1.692],[-0.584,-2.864],[-0.749,-0.684],[-0.847,0],[-0.652,0.943],[0,1.889],[5.664,14.746],[1.822,8.073],[0,0]],"o":[[-5.469,14.78],[0,1.758],[0.977,1.204],[1.236,0],[0.716,-2.017],[1.233,-5.273],[3.441,0.391],[3.181,8.594],[0.259,1.237],[0.748,0.684],[0.977,0],[0.65,-0.945],[-1.823,-7.291],[-5.664,-14.746],[0,0],[-2.148,7.553]],"v":[[11.328,-37.305],[0,-3.711],[1.465,0.732],[4.98,2.539],[8.301,0.781],[11.224,-10.156],[14.342,-21.582],[39.566,-18.457],[45.215,-1.27],[46.729,1.611],[49.121,2.637],[51.562,1.221],[52.539,-3.027],[41.309,-36.084],[30.078,-70.312],[22.754,-70.801]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-6.686,-14.388],[4.935,0],[0,0],[-1.3,7.878]],"o":[[-3.311,-0.325],[0,0],[5.908,-15.234],[1.624,9.05]],"v":[[38.593,-25.781],[26.224,-26.27],[15.317,-26.27],[26.128,-60.938]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"A","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"T","size":165,"style":"Regular","w":43.07,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-7.358,-0.52],[0,-7.747],[-0.034,-5.338],[0,-2.669],[0.13,-3.516],[-1.108,-0.943],[-1.172,0],[-0.586,1.953],[1.627,22.983],[0,0],[-0.652,0.652],[0,0.847],[1.106,1.108],[1.627,0.066],[0,0],[0,0]],"o":[[-0.261,6.25],[0,2.67],[0.032,5.339],[0,7.162],[0.259,1.367],[1.106,0.943],[1.627,0],[-0.781,-18.814],[0,0],[1.302,-0.13],[0.65,-0.65],[0,-1.302],[-1.108,-1.106],[0,0],[0,0],[4.036,0.195]],"v":[[18.066,-64.453],[17.676,-43.457],[17.725,-31.445],[17.773,-19.434],[17.578,-3.418],[19.629,0.049],[23.047,1.465],[26.367,-1.465],[22.754,-64.16],[39.16,-63.281],[42.09,-64.453],[43.066,-66.699],[41.406,-70.312],[37.305,-72.07],[0,-69.922],[0.977,-65.527]],"c":true},"ix":2},"nm":"T","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"T","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":" ","size":165,"style":"Regular","w":27.93,"data":{},"fFamily":"Neucha"},{"ch":"J","size":165,"style":"Regular","w":37.99,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-8.008,0],[-1.562,0.162],[-1.205,0.586],[-0.781,0.488],[-0.554,1.303],[-0.293,0.945],[-0.131,2.051],[-0.034,1.498],[0,2.93],[0.198,8.237],[0,3.711],[-0.133,4.428],[1.12,0],[0.494,-0.032],[0.262,0],[0.458,0.195],[0,-3.516],[-0.131,-9.114],[0,-4.297],[1.134,-2.603],[3.629,0],[3.758,5.078],[0,0]],"o":[[2.083,0],[1.562,-0.163],[1.204,-0.586],[0.781,-0.488],[0.552,-1.302],[0.293,-0.943],[0.13,-2.051],[0.032,-1.497],[0,-4.556],[-0.198,-8.235],[0,-2.344],[-0.859,-0.391],[-0.331,0],[-0.494,0.034],[-0.793,0],[-0.066,1.823],[0,5.209],[0.13,9.116],[0,5.925],[-1.135,2.605],[-4.797,0],[0,0],[3.45,8.203]],"v":[[17.188,2.734],[22.656,2.49],[26.807,1.367],[29.785,-0.244],[31.787,-2.93],[33.057,-6.299],[33.691,-10.791],[33.936,-16.113],[33.984,-22.754],[33.687,-41.943],[33.391,-59.863],[33.589,-70.02],[30.62,-70.605],[29.381,-70.557],[28.244,-70.508],[26.367,-70.801],[26.27,-62.793],[26.465,-41.309],[26.66,-21.191],[24.959,-8.398],[17.813,-4.492],[4.98,-12.109],[0,-9.57]],"c":true},"ix":2},"nm":"J","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"J","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"O","size":165,"style":"Regular","w":52.34,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.424,-3.384],[-1.074,-2.864],[-1.855,-1.758],[-2.898,-0.977],[-4.037,0],[-2.019,0.845],[-1.335,1.335],[-0.977,2.051],[-0.554,2.019],[-0.293,2.637],[-0.098,2.084],[0,2.605],[0.293,3.191],[1.009,3.516],[1.692,2.409],[2.994,1.596],[4.036,0],[1.692,-0.455],[1.236,-0.943],[1.041,-1.041],[0.684,-1.692],[0.52,-1.334],[0.325,-2.18],[0.162,-1.367],[0.098,-2.344],[0,-1.138],[0,-2.213]],"o":[[0.423,3.386],[1.074,2.866],[1.855,1.758],[2.896,0.977],[2.473,0],[2.017,-0.845],[1.334,-1.334],[0.977,-2.051],[0.552,-2.017],[0.293,-2.637],[0.098,-2.083],[0,-3.841],[-0.293,-3.189],[-1.01,-3.516],[-1.694,-2.408],[-2.995,-1.595],[-2.019,0],[-1.694,0.456],[-1.237,0.945],[-1.042,1.042],[-0.684,1.694],[-0.522,1.335],[-0.327,2.182],[-0.163,1.367],[-0.098,2.344],[0,1.14],[0,4.623]],"v":[[4.736,-20.703],[6.982,-11.328],[11.377,-4.395],[18.506,-0.293],[28.906,1.172],[35.645,-0.098],[40.674,-3.369],[44.141,-8.447],[46.436,-14.551],[47.705,-21.533],[48.291,-28.613],[48.438,-35.645],[47.998,-46.191],[46.045,-56.25],[41.992,-65.137],[34.961,-71.143],[24.414,-73.535],[18.848,-72.852],[14.453,-70.752],[11.035,-67.773],[8.447,-63.672],[6.641,-59.131],[5.371,-53.857],[4.639,-48.535],[4.248,-42.969],[4.102,-37.744],[4.102,-32.715]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[2.351,-5.078],[4.767,-0.259],[1.73,0.815],[1.077,1.074],[0.784,1.953],[0.36,1.498],[0.195,2.573],[0.032,1.401],[0,2.67],[-0.848,4.33],[-1.993,3.484],[-2.614,0],[-2.483,-2.505],[-1.143,-3.97],[-0.49,-3.45],[0,-3.189]],"o":[[-2.351,5.078],[-2.156,-0.064],[-1.73,-0.813],[-1.077,-1.074],[-0.784,-1.953],[-0.36,-1.497],[-0.195,-2.571],[-0.034,-1.399],[0,-3.841],[0.848,-4.329],[1.993,-3.482],[3.461,0],[2.481,2.507],[1.143,3.972],[0.49,3.452],[0,7.358]],"v":[[37.878,-13.281],[27.2,-5.273],[21.37,-6.592],[17.157,-9.424],[14.365,-13.965],[12.65,-19.141],[11.816,-25.244],[11.475,-31.201],[11.426,-37.305],[12.698,-49.561],[16.96,-61.279],[23.869,-66.504],[32.785,-62.744],[38.222,-53.027],[40.671,-41.895],[41.406,-31.934]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"O","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"B","size":165,"style":"Regular","w":48.54,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-5.405,0],[-4.33,1.334],[-3.256,3.026],[0,4.099],[2.539,4.425],[4.166,0.586],[-1.53,2.933],[0,3.128],[2.571,2.835],[3.775,1.205],[4.492,0],[0.716,-2.408],[0,0]],"o":[[4.427,0],[4.329,-1.334],[3.255,-3.024],[0,-6.05],[-2.539,-4.424],[2.213,-0.847],[1.529,-2.933],[0,-3.973],[-2.573,-2.835],[-3.777,-1.205],[-4.883,0],[0,0],[2.083,1.953]],"v":[[15.234,0.391],[28.369,-1.61],[39.746,-8.148],[44.629,-18.834],[40.82,-34.546],[30.762,-42.061],[36.377,-47.729],[38.672,-56.821],[34.814,-67.033],[25.293,-73.094],[12.891,-74.902],[4.492,-71.289],[4.004,-2.539]],"c":true},"ix":2},"nm":"B","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-3.32,0],[-3.191,-2.652],[0,-4.721],[3.775,-3.331],[4.036,0],[1.953,2.2],[0,4.465]],"o":[[5.013,0],[3.189,2.652],[0,3.818],[-3.777,3.333],[-3.061,0],[0.13,-13.455],[1.758,-0.388]],"v":[[19.629,-37.207],[31.934,-33.228],[36.719,-22.166],[31.055,-11.443],[19.336,-6.445],[11.816,-9.744],[12.012,-36.624]],"c":true},"ix":2},"nm":"B","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[0.032,5.859],[0.13,3.972],[-1.823,0],[-2.28,-2.505],[0,-3.45],[2.246,-2.441],[4.166,0],[0,0]],"o":[[-0.034,-5.859],[2.473,-0.781],[4.036,0],[2.278,2.507],[0,3.386],[-2.246,2.441],[0,0],[0,-0.325]],"v":[[11.768,-53.223],[11.523,-67.969],[17.969,-69.141],[27.441,-65.381],[30.859,-56.445],[27.49,-47.705],[17.871,-44.043],[11.816,-43.945]],"c":true},"ix":2},"nm":"B","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"B","np":6,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"!","size":165,"style":"Regular","w":18.16,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.261,11.784],[-0.195,3.516],[1.106,1.108],[1.302,0],[0.259,-2.539],[-0.327,-4.297],[0,0]],"o":[[0.259,-11.783],[-0.066,-1.627],[-1.108,-1.106],[-2.019,0],[1.367,29.819],[0,0],[0.52,-6.38]],"v":[[12.109,-44.043],[12.793,-66.992],[11.035,-71.094],[7.422,-72.754],[4.004,-68.945],[6.543,-17.773],[10.938,-16.797]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.618,-0.879],[0,-1.431],[-1.042,-1.497],[-1.823,0],[-0.684,0.879],[0,1.433],[1.172,1.53],[1.758,0]],"o":[[-0.62,0.879],[0,2.019],[1.041,1.497],[1.172,0],[0.684,-0.879],[0,-1.953],[-1.172,-1.529],[-1.108,0]],"v":[[5.42,-10.01],[4.492,-6.543],[6.055,-1.27],[10.352,0.977],[13.135,-0.342],[14.16,-3.809],[12.402,-9.033],[8.008,-11.328]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"!","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"}]}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = {"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":29.9700012207031,"ip":0,"op":60.0000024438501,"w":1440,"h":900,"nm":"congrats-anim","ddd":0,"assets":[],"fonts":{"list":[{"fName":"Neucha","fFamily":"Neucha","fStyle":"Regular","ascent":78.2669067382812}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[2.965,3.413],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949020026712,1,1,1],"ix":4},"o":{"a":0,"k":0,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1109.482,-460.294],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":"GREAT!","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[484.706,526.074,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":165,"f":"Neucha","t":"GREAT!","j":0,"tr":0,"lh":198,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Positon !","s":{"t":0,"xe":{"a":0,"k":100,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[-100]},{"t":35.0000014255792,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-100,0],"ix":2}}},{"nm":"Positon ! 2","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[-100]},{"t":42.0000017106951,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,100,0],"ix":2}}},{"nm":"Positon ! 3","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[-100]},{"t":50.0000020365418,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-20,0],"ix":2}}},{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":1,"r":1},"a":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":24,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[100]},{"t":50.0000020365418,"s":[0]}],"ix":9}}}]},"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Vector 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":160,"ix":10},"p":{"a":0,"k":[584.527,440.481,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[301,301,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.592,-12.412],[2,-16.5],[13.997,-5.599],[-27.5,8.5],[10.5,-11]],"o":[[-5.333,6.667],[-1.12,23.5],[-2,16.5],[-17.5,7],[21.203,-6.554],[0,0]],"v":[[20.348,-63],[5.348,-27.5],[17.848,19],[-1.773,47],[-4.273,19],[11.348,63]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.737254917622,0.929411768913,0.964705884457,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":34.0000013848484,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1050.187,96.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[237,237,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.6,3.6],[-1.5,-2],[8,-2],[-14,18],[-2.5,-1.5],[13.5,-4],[-16.5,6.5],[-2.5,-15.5]],"o":[[-0.667,-5.167],[12,-4.5],[1.5,2],[-8,2],[14,-18],[7.34,4.404],[-13.5,4],[16.5,-6.5],[0,0]],"v":[[-52.17,25.752],[-42.17,5.752],[-21.67,7.752],[-24.67,19.752],[-30.67,-10.248],[12.83,-19.748],[16.33,3.752],[12.83,-23.248],[52.33,-7.748]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.341176480055,0.384313732386,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":47.0000019143492,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[338.677,338.677],"ix":3},"r":{"a":0,"k":-152.245,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":47.0000019143492,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Vector 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.241,603.609,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[291,291,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.019,15.142],[-21.544,1.854],[21.843,-0.123],[-19.051,-0.566],[-1.053,6.591]],"o":[[20.081,-4.4],[18.48,-14.713],[39.724,-3.419],[-16.471,0.093],[15.241,0.452],[0,0]],"v":[[-75.292,75.735],[-60.995,27.44],[-14.55,20.726],[-7.144,-15.78],[-4.048,2.355],[23.103,-21.036]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.349019616842,0.521568655968,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[2]},{"t":52.0000021180034,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":4.645,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":35.0000014255792,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":52.0000021180034,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[270.187,812.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[225,225,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.5,-6.5],[-13.5,4],[7.34,4.404],[14,-18],[-8,2],[1.5,2],[12,-4.5],[-0.667,-5.167]],"o":[[-2.5,-15.5],[-16.5,6.5],[13.5,-4],[-2.5,-1.5],[-14,18],[8,-2],[-1.5,-2],[-9.6,3.6],[0,0]],"v":[[52.33,-7.748],[12.83,-23.248],[16.33,3.752],[12.83,-19.748],[-30.67,-10.248],[-24.67,19.752],[-21.67,7.752],[-42.17,5.752],[-52.17,25.752]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.800000011921,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":48.0000019550801,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,16],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":16.945,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":48.0000019550801,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Vector 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[283.99,512.842,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[273.086,215.359,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.5,13.5],[-23.5,0],[11.167,-2.5],[-1.56,32.421],[-2.788,-11.5],[22.8,-2.8],[-8.333,15.667]],"o":[[-27,-2],[-4.5,-13.5],[11.674,0],[-11.167,2.5],[2,-44.8],[1.333,5.5],[-36.8,2.8],[0,0]],"v":[[31.163,87.75],[-21.837,47.75],[6.163,3.75],[9.163,17.75],[-28.337,-9.75],[21.163,-64.25],[-3.337,-44.25],[-24.337,-87.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.996078431606,0.372549027205,0.333333343267,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[3]},{"t":37.0000015070409,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 6","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Vector 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":147,"ix":10},"p":{"a":0,"k":[493.605,-13.278,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[221,221,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-26.751,23.049],[-17.579,29.801],[-38.844,16.733]],"o":[[-4.793,-10.962],[21.816,-18.796],[14.832,-25.144],[0,0]],"v":[[-12.046,101.322],[2.42,15.388],[89.01,-32.998],[104.067,-125.327]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.65098041296,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[2]},{"t":51.0000020772726,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":-92.056,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 7","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":13,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":36.0000014663101,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[1444.67,903.138],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.665,-2.431],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"G","size":165,"style":"Regular","w":57.03,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.552,-0.65],[1.106,-0.977],[1.367,-0.911],[1.92,-0.65],[2.017,0],[2.93,5.046],[0,7.944],[-0.163,2.475],[-0.684,3.386],[-1.205,2.214],[-2.344,1.562],[-3.256,0],[-5.078,-3.775],[0,0],[4.036,1.303],[3.775,0],[3.157,-2.473],[1.562,-4.036],[0.65,-4.004],[0,-4.231],[-15.82,0],[-2.019,0.586],[-1.303,0.845],[-0.977,0.912],[-0.456,0.62],[0,0.131],[0,-2.441],[-0.066,-0.652],[0,0],[0,0],[4.817,-0.423],[1.302,-0.195],[0,0]],"o":[[0,0],[0,0.131],[-0.554,0.652],[-1.108,0.977],[-1.367,0.912],[-1.921,0.652],[-4.688,0],[-2.93,-5.045],[0,-3.32],[0.162,-2.473],[0.684,-3.384],[1.204,-2.213],[2.344,-1.562],[4.947,0],[0,0],[-2.866,-1.953],[-4.037,-1.302],[-4.362,0],[-3.159,2.475],[-1.562,4.037],[-0.652,4.004],[0,24.609],[2.213,0],[2.017,-0.586],[1.302,-0.845],[0.977,-0.911],[0.455,-0.618],[0.064,0.717],[0,2.441],[0,0],[0,0],[-1.237,0.261],[-4.819,0.424],[0,0],[0,0]],"v":[[45.41,-20.703],[45.41,-14.453],[44.58,-13.281],[42.09,-10.84],[38.379,-8.008],[33.447,-5.664],[27.539,-4.688],[16.113,-12.256],[11.719,-31.738],[11.963,-40.43],[13.232,-49.219],[16.064,-57.617],[21.387,-63.281],[29.785,-65.625],[44.824,-59.961],[48.73,-64.453],[38.379,-69.336],[26.66,-71.289],[15.381,-67.578],[8.301,-57.812],[4.98,-45.752],[4.004,-33.398],[27.734,3.516],[34.082,2.637],[39.062,0.488],[42.48,-2.148],[44.629,-4.443],[45.312,-5.566],[45.41,-0.83],[45.508,3.809],[53.125,2.246],[53.125,-28.809],[44.043,-27.783],[34.863,-26.855],[35.938,-22.461]],"c":true},"ix":2},"nm":"G","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"G","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"R","size":165,"style":"Regular","w":51.86,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.827,4.492],[2.271,4.753],[-2.464,1.562],[-1.395,2.409],[-0.714,2.768],[0,2.995],[3.571,4.526],[7.207,0],[3.7,-2.473],[0,2.084],[0,0],[0.232,-15.82],[0.198,-5.469],[-1.088,-0.945],[-1.187,0],[-0.587,2.017],[0.13,4.753],[0,0],[-2.176,-2.832],[-2.76,-2.766],[-3.183,-1.823],[-2.924,-0.066],[0,0]],"o":[[-3.828,-4.492],[3.177,-0.259],[2.463,-1.562],[1.395,-2.408],[0.713,-2.766],[0,-8.138],[-3.572,-4.524],[-6.689,0],[-0.066,-0.259],[0,0],[-0.398,8.659],[-0.232,15.82],[0.262,1.367],[1.086,0.943],[1.712,0],[-0.391,-10.025],[0,0],[1.558,2.734],[2.176,2.832],[2.759,2.768],[3.183,1.822],[0,0],[-3.764,-1.042]],"v":[[37.935,-6.738],[28.787,-20.605],[37.248,-23.34],[43.034,-29.297],[46.196,-37.061],[47.266,-45.703],[41.908,-64.697],[25.74,-71.484],[10.156,-67.773],[10.059,-71.289],[5.592,-70.117],[4.648,-33.398],[4.004,-1.465],[6.03,2.002],[9.441,3.418],[12.891,0.391],[12.109,-21.777],[19.803,-20.898],[25.404,-12.549],[32.808,-4.15],[41.721,2.734],[50.879,5.566],[49.323,1.562]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-3.958,0],[-3.244,-4.231],[0,-5.273],[3.114,-3.384],[4.477,0],[3.568,1.953],[0,0]],"o":[[4.866,0],[3.244,4.233],[0,4.883],[-3.114,3.386],[-4.672,0],[0,0],[4.153,-3.125]],"v":[[23.203,-65.918],[35.368,-59.57],[40.234,-45.312],[35.562,-32.91],[24.176,-27.832],[11.816,-30.762],[11.035,-61.23]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"R","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"E","size":165,"style":"Regular","w":45.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[14.908,1.367],[-0.098,5.827],[0,2.866],[-13.737,1.237],[0,0],[5.859,0.488],[2.213,0.261],[0.227,4.623],[0.064,1.498],[-8.789,0.717],[-2.93,0.522],[0,0],[9.537,0.131],[2.213,0.195],[0.13,-16.797],[0.65,-7.161],[-4.819,0],[-6.674,0.227],[-2.539,0],[0,0]],"o":[[0,-2.734],[0.098,-5.826],[2.344,-0.064],[0,0],[-1.562,-0.13],[-5.859,-0.488],[-0.066,-2.994],[-0.229,-4.622],[0.455,-0.064],[8.789,-0.716],[0,0],[-2.93,-0.455],[-9.538,-0.13],[-0.717,6.641],[-0.131,16.797],[1.758,0.455],[2.994,0],[6.673,-0.229],[0,0],[-3.842,-0.586]],"v":[[13.086,-7.324],[13.232,-20.166],[13.379,-33.203],[37.5,-35.156],[36.523,-39.648],[25.391,-40.576],[13.281,-41.699],[12.842,-53.125],[12.402,-62.305],[26.27,-63.477],[43.848,-65.332],[42.773,-69.727],[24.072,-70.605],[6.445,-71.094],[5.176,-35.938],[4.004,0],[13.867,0.684],[28.369,0.342],[42.188,0],[41.211,-4.395]],"c":true},"ix":2},"nm":"E","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"E","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"A","size":165,"style":"Regular","w":52.54,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[5.469,-14.778],[2.083,-7.617],[-0.977,-1.204],[-1.367,0],[-0.977,1.172],[-1.233,5.273],[-0.845,2.344],[-13.376,-1.692],[-0.584,-2.864],[-0.749,-0.684],[-0.847,0],[-0.652,0.943],[0,1.889],[5.664,14.746],[1.822,8.073],[0,0]],"o":[[-5.469,14.78],[0,1.758],[0.977,1.204],[1.236,0],[0.716,-2.017],[1.233,-5.273],[3.441,0.391],[3.181,8.594],[0.259,1.237],[0.748,0.684],[0.977,0],[0.65,-0.945],[-1.823,-7.291],[-5.664,-14.746],[0,0],[-2.148,7.553]],"v":[[11.328,-37.305],[0,-3.711],[1.465,0.732],[4.98,2.539],[8.301,0.781],[11.224,-10.156],[14.342,-21.582],[39.566,-18.457],[45.215,-1.27],[46.729,1.611],[49.121,2.637],[51.562,1.221],[52.539,-3.027],[41.309,-36.084],[30.078,-70.312],[22.754,-70.801]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-6.686,-14.388],[4.935,0],[0,0],[-1.3,7.878]],"o":[[-3.311,-0.325],[0,0],[5.908,-15.234],[1.624,9.05]],"v":[[38.593,-25.781],[26.224,-26.27],[15.317,-26.27],[26.128,-60.938]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"A","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"T","size":165,"style":"Regular","w":43.07,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-7.358,-0.52],[0,-7.747],[-0.034,-5.338],[0,-2.669],[0.13,-3.516],[-1.108,-0.943],[-1.172,0],[-0.586,1.953],[1.627,22.983],[0,0],[-0.652,0.652],[0,0.847],[1.106,1.108],[1.627,0.066],[0,0],[0,0]],"o":[[-0.261,6.25],[0,2.67],[0.032,5.339],[0,7.162],[0.259,1.367],[1.106,0.943],[1.627,0],[-0.781,-18.814],[0,0],[1.302,-0.13],[0.65,-0.65],[0,-1.302],[-1.108,-1.106],[0,0],[0,0],[4.036,0.195]],"v":[[18.066,-64.453],[17.676,-43.457],[17.725,-31.445],[17.773,-19.434],[17.578,-3.418],[19.629,0.049],[23.047,1.465],[26.367,-1.465],[22.754,-64.16],[39.16,-63.281],[42.09,-64.453],[43.066,-66.699],[41.406,-70.312],[37.305,-72.07],[0,-69.922],[0.977,-65.527]],"c":true},"ix":2},"nm":"T","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"T","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"!","size":165,"style":"Regular","w":18.16,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.261,11.784],[-0.195,3.516],[1.106,1.108],[1.302,0],[0.259,-2.539],[-0.327,-4.297],[0,0]],"o":[[0.259,-11.783],[-0.066,-1.627],[-1.108,-1.106],[-2.019,0],[1.367,29.819],[0,0],[0.52,-6.38]],"v":[[12.109,-44.043],[12.793,-66.992],[11.035,-71.094],[7.422,-72.754],[4.004,-68.945],[6.543,-17.773],[10.938,-16.797]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.618,-0.879],[0,-1.431],[-1.042,-1.497],[-1.823,0],[-0.684,0.879],[0,1.433],[1.172,1.53],[1.758,0]],"o":[[-0.62,0.879],[0,2.019],[1.041,1.497],[1.172,0],[0.684,-0.879],[0,-1.953],[-1.172,-1.529],[-1.108,0]],"v":[[5.42,-10.01],[4.492,-6.543],[6.055,-1.27],[10.352,0.977],[13.135,-0.342],[14.16,-3.809],[12.402,-9.033],[8.008,-11.328]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"!","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"}]}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = {"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":29.9700012207031,"ip":0,"op":60.0000024438501,"w":1440,"h":900,"nm":"congrats-anim","ddd":0,"assets":[],"fonts":{"list":[{"fName":"Neucha","fFamily":"Neucha","fStyle":"Regular","ascent":78.2669067382812}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[2.965,3.413],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949020026712,1,1,1],"ix":4},"o":{"a":0,"k":0,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1109.482,-460.294],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":"HOORAY!","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[439.951,526.074,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":165,"f":"Neucha","t":"HOORAY!","j":0,"tr":0,"lh":198,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Positon !","s":{"t":0,"xe":{"a":0,"k":100,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[-100]},{"t":35.0000014255792,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-100,0],"ix":2}}},{"nm":"Positon ! 2","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[-100]},{"t":42.0000017106951,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,100,0],"ix":2}}},{"nm":"Positon ! 3","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[-100]},{"t":50.0000020365418,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-20,0],"ix":2}}},{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":1,"r":1},"a":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":24,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[100]},{"t":50.0000020365418,"s":[0]}],"ix":9}}}]},"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Vector 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":160,"ix":10},"p":{"a":0,"k":[584.527,440.481,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[301,301,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.592,-12.412],[2,-16.5],[13.997,-5.599],[-27.5,8.5],[10.5,-11]],"o":[[-5.333,6.667],[-1.12,23.5],[-2,16.5],[-17.5,7],[21.203,-6.554],[0,0]],"v":[[20.348,-63],[5.348,-27.5],[17.848,19],[-1.773,47],[-4.273,19],[11.348,63]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.737254917622,0.929411768913,0.964705884457,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":34.0000013848484,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1050.187,96.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[237,237,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.6,3.6],[-1.5,-2],[8,-2],[-14,18],[-2.5,-1.5],[13.5,-4],[-16.5,6.5],[-2.5,-15.5]],"o":[[-0.667,-5.167],[12,-4.5],[1.5,2],[-8,2],[14,-18],[7.34,4.404],[-13.5,4],[16.5,-6.5],[0,0]],"v":[[-52.17,25.752],[-42.17,5.752],[-21.67,7.752],[-24.67,19.752],[-30.67,-10.248],[12.83,-19.748],[16.33,3.752],[12.83,-23.248],[52.33,-7.748]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.341176480055,0.384313732386,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":47.0000019143492,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[338.677,338.677],"ix":3},"r":{"a":0,"k":-152.245,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":47.0000019143492,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Vector 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.241,603.609,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[291,291,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.019,15.142],[-21.544,1.854],[21.843,-0.123],[-19.051,-0.566],[-1.053,6.591]],"o":[[20.081,-4.4],[18.48,-14.713],[39.724,-3.419],[-16.471,0.093],[15.241,0.452],[0,0]],"v":[[-75.292,75.735],[-60.995,27.44],[-14.55,20.726],[-7.144,-15.78],[-4.048,2.355],[23.103,-21.036]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.349019616842,0.521568655968,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[2]},{"t":52.0000021180034,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":4.645,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":35.0000014255792,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":52.0000021180034,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[270.187,812.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[225,225,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.5,-6.5],[-13.5,4],[7.34,4.404],[14,-18],[-8,2],[1.5,2],[12,-4.5],[-0.667,-5.167]],"o":[[-2.5,-15.5],[-16.5,6.5],[13.5,-4],[-2.5,-1.5],[-14,18],[8,-2],[-1.5,-2],[-9.6,3.6],[0,0]],"v":[[52.33,-7.748],[12.83,-23.248],[16.33,3.752],[12.83,-19.748],[-30.67,-10.248],[-24.67,19.752],[-21.67,7.752],[-42.17,5.752],[-52.17,25.752]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.800000011921,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":48.0000019550801,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,16],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":16.945,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":48.0000019550801,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Vector 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[283.99,512.842,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[273.086,215.359,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.5,13.5],[-23.5,0],[11.167,-2.5],[-1.56,32.421],[-2.788,-11.5],[22.8,-2.8],[-8.333,15.667]],"o":[[-27,-2],[-4.5,-13.5],[11.674,0],[-11.167,2.5],[2,-44.8],[1.333,5.5],[-36.8,2.8],[0,0]],"v":[[31.163,87.75],[-21.837,47.75],[6.163,3.75],[9.163,17.75],[-28.337,-9.75],[21.163,-64.25],[-3.337,-44.25],[-24.337,-87.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.996078431606,0.372549027205,0.333333343267,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[3]},{"t":37.0000015070409,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 6","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Vector 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":147,"ix":10},"p":{"a":0,"k":[493.605,-13.278,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[221,221,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-26.751,23.049],[-17.579,29.801],[-38.844,16.733]],"o":[[-4.793,-10.962],[21.816,-18.796],[14.832,-25.144],[0,0]],"v":[[-12.046,101.322],[2.42,15.388],[89.01,-32.998],[104.067,-125.327]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.65098041296,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[2]},{"t":51.0000020772726,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":-92.056,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 7","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":13,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":36.0000014663101,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[1444.67,903.138],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.665,-2.431],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"H","size":165,"style":"Regular","w":46.88,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.032,-4.622],[0,-0.65],[0.064,0],[3.04,-0.293],[2.518,-0.227],[2.222,-0.195],[0.835,16.016],[0.032,0.424],[0,0.195],[0,0],[0.16,-16.145],[0.192,-5.598],[-1.06,-0.977],[-1.157,0],[-0.586,2.017],[0.325,7.26],[0.13,3.972],[-1.7,0],[-2.126,0.131],[-2.583,0.229],[-1.439,0.066],[0,0],[0.064,-2.344],[-1.074,-0.977],[-1.172,0],[-0.586,2.017],[0.293,16.309],[1.172,9.18],[0,0]],"o":[[-0.034,4.623],[0,0.652],[-1.7,0.131],[-3.041,0.293],[-2.518,0.229],[-0.128,-4.036],[0,-0.259],[-0.034,-0.423],[0,0],[-0.45,7.878],[-0.162,16.147],[0.256,1.367],[1.059,0.977],[1.674,0],[-0.131,-2.734],[-0.327,-7.259],[0.784,0.066],[1.895,0],[2.124,-0.13],[2.582,-0.227],[0,0],[0,5.469],[0.259,1.367],[1.074,0.977],[1.692,0],[-0.327,-5.273],[-0.293,-16.309],[0,0],[0,9.311]],"v":[[34.033,-49.316],[33.984,-41.406],[33.887,-40.43],[26.776,-39.795],[18.439,-39.014],[11.328,-38.379],[9.883,-68.457],[9.834,-69.482],[9.785,-70.41],[5.449,-71.387],[4.533,-35.352],[4.004,-2.734],[5.98,0.781],[9.305,2.246],[12.695,-0.781],[12.012,-15.771],[11.328,-32.617],[15.054,-32.52],[21.086,-32.715],[28.148,-33.252],[34.18,-33.691],[34.18,-14.453],[34.082,-2.734],[36.084,0.781],[39.453,2.246],[42.871,-0.781],[41.943,-33.154],[39.746,-71.387],[34.082,-70.215]],"c":true},"ix":2},"nm":"H","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"H","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"O","size":165,"style":"Regular","w":52.34,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.424,-3.384],[-1.074,-2.864],[-1.855,-1.758],[-2.898,-0.977],[-4.037,0],[-2.019,0.845],[-1.335,1.335],[-0.977,2.051],[-0.554,2.019],[-0.293,2.637],[-0.098,2.084],[0,2.605],[0.293,3.191],[1.009,3.516],[1.692,2.409],[2.994,1.596],[4.036,0],[1.692,-0.455],[1.236,-0.943],[1.041,-1.041],[0.684,-1.692],[0.52,-1.334],[0.325,-2.18],[0.162,-1.367],[0.098,-2.344],[0,-1.138],[0,-2.213]],"o":[[0.423,3.386],[1.074,2.866],[1.855,1.758],[2.896,0.977],[2.473,0],[2.017,-0.845],[1.334,-1.334],[0.977,-2.051],[0.552,-2.017],[0.293,-2.637],[0.098,-2.083],[0,-3.841],[-0.293,-3.189],[-1.01,-3.516],[-1.694,-2.408],[-2.995,-1.595],[-2.019,0],[-1.694,0.456],[-1.237,0.945],[-1.042,1.042],[-0.684,1.694],[-0.522,1.335],[-0.327,2.182],[-0.163,1.367],[-0.098,2.344],[0,1.14],[0,4.623]],"v":[[4.736,-20.703],[6.982,-11.328],[11.377,-4.395],[18.506,-0.293],[28.906,1.172],[35.645,-0.098],[40.674,-3.369],[44.141,-8.447],[46.436,-14.551],[47.705,-21.533],[48.291,-28.613],[48.438,-35.645],[47.998,-46.191],[46.045,-56.25],[41.992,-65.137],[34.961,-71.143],[24.414,-73.535],[18.848,-72.852],[14.453,-70.752],[11.035,-67.773],[8.447,-63.672],[6.641,-59.131],[5.371,-53.857],[4.639,-48.535],[4.248,-42.969],[4.102,-37.744],[4.102,-32.715]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[2.351,-5.078],[4.767,-0.259],[1.73,0.815],[1.077,1.074],[0.784,1.953],[0.36,1.498],[0.195,2.573],[0.032,1.401],[0,2.67],[-0.848,4.33],[-1.993,3.484],[-2.614,0],[-2.483,-2.505],[-1.143,-3.97],[-0.49,-3.45],[0,-3.189]],"o":[[-2.351,5.078],[-2.156,-0.064],[-1.73,-0.813],[-1.077,-1.074],[-0.784,-1.953],[-0.36,-1.497],[-0.195,-2.571],[-0.034,-1.399],[0,-3.841],[0.848,-4.329],[1.993,-3.482],[3.461,0],[2.481,2.507],[1.143,3.972],[0.49,3.452],[0,7.358]],"v":[[37.878,-13.281],[27.2,-5.273],[21.37,-6.592],[17.157,-9.424],[14.365,-13.965],[12.65,-19.141],[11.816,-25.244],[11.475,-31.201],[11.426,-37.305],[12.698,-49.561],[16.96,-61.279],[23.869,-66.504],[32.785,-62.744],[38.222,-53.027],[40.671,-41.895],[41.406,-31.934]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"O","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"R","size":165,"style":"Regular","w":51.86,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.827,4.492],[2.271,4.753],[-2.464,1.562],[-1.395,2.409],[-0.714,2.768],[0,2.995],[3.571,4.526],[7.207,0],[3.7,-2.473],[0,2.084],[0,0],[0.232,-15.82],[0.198,-5.469],[-1.088,-0.945],[-1.187,0],[-0.587,2.017],[0.13,4.753],[0,0],[-2.176,-2.832],[-2.76,-2.766],[-3.183,-1.823],[-2.924,-0.066],[0,0]],"o":[[-3.828,-4.492],[3.177,-0.259],[2.463,-1.562],[1.395,-2.408],[0.713,-2.766],[0,-8.138],[-3.572,-4.524],[-6.689,0],[-0.066,-0.259],[0,0],[-0.398,8.659],[-0.232,15.82],[0.262,1.367],[1.086,0.943],[1.712,0],[-0.391,-10.025],[0,0],[1.558,2.734],[2.176,2.832],[2.759,2.768],[3.183,1.822],[0,0],[-3.764,-1.042]],"v":[[37.935,-6.738],[28.787,-20.605],[37.248,-23.34],[43.034,-29.297],[46.196,-37.061],[47.266,-45.703],[41.908,-64.697],[25.74,-71.484],[10.156,-67.773],[10.059,-71.289],[5.592,-70.117],[4.648,-33.398],[4.004,-1.465],[6.03,2.002],[9.441,3.418],[12.891,0.391],[12.109,-21.777],[19.803,-20.898],[25.404,-12.549],[32.808,-4.15],[41.721,2.734],[50.879,5.566],[49.323,1.562]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-3.958,0],[-3.244,-4.231],[0,-5.273],[3.114,-3.384],[4.477,0],[3.568,1.953],[0,0]],"o":[[4.866,0],[3.244,4.233],[0,4.883],[-3.114,3.386],[-4.672,0],[0,0],[4.153,-3.125]],"v":[[23.203,-65.918],[35.368,-59.57],[40.234,-45.312],[35.562,-32.91],[24.176,-27.832],[11.816,-30.762],[11.035,-61.23]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"R","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"A","size":165,"style":"Regular","w":52.54,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[5.469,-14.778],[2.083,-7.617],[-0.977,-1.204],[-1.367,0],[-0.977,1.172],[-1.233,5.273],[-0.845,2.344],[-13.376,-1.692],[-0.584,-2.864],[-0.749,-0.684],[-0.847,0],[-0.652,0.943],[0,1.889],[5.664,14.746],[1.822,8.073],[0,0]],"o":[[-5.469,14.78],[0,1.758],[0.977,1.204],[1.236,0],[0.716,-2.017],[1.233,-5.273],[3.441,0.391],[3.181,8.594],[0.259,1.237],[0.748,0.684],[0.977,0],[0.65,-0.945],[-1.823,-7.291],[-5.664,-14.746],[0,0],[-2.148,7.553]],"v":[[11.328,-37.305],[0,-3.711],[1.465,0.732],[4.98,2.539],[8.301,0.781],[11.224,-10.156],[14.342,-21.582],[39.566,-18.457],[45.215,-1.27],[46.729,1.611],[49.121,2.637],[51.562,1.221],[52.539,-3.027],[41.309,-36.084],[30.078,-70.312],[22.754,-70.801]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-6.686,-14.388],[4.935,0],[0,0],[-1.3,7.878]],"o":[[-3.311,-0.325],[0,0],[5.908,-15.234],[1.624,9.05]],"v":[[38.593,-25.781],[26.224,-26.27],[15.317,-26.27],[26.128,-60.938]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"A","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"Y","size":165,"style":"Regular","w":41.21,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.21,-8.267],[1.175,-2.083],[0,0],[0,0],[-4.004,-9.7],[-3.256,-5.403],[0.098,-6.802],[0.195,-2.798],[-2.307,0],[-0.592,0.131],[0.064,6.706],[0.259,3.191],[-2.734,5.405],[-2.312,5.112],[-0.586,1.108],[0,0]],"o":[[-4.211,8.269],[0,0],[0,0],[1.108,2.28],[4.004,9.702],[-0.261,3.125],[-0.098,6.804],[0.458,0.131],[2.438,0],[-0.195,-2.93],[-0.066,-6.705],[2.603,-4.102],[2.734,-5.403],[2.31,-5.11],[0,0],[-2.35,3.452]],"v":[[28.148,-53.027],[20.07,-37.5],[4.688,-70.703],[-1.953,-70.215],[5.713,-52.246],[16.602,-29.59],[16.064,-14.697],[15.625,-0.293],[19.772,-0.098],[24.316,-0.293],[23.926,-14.746],[23.438,-29.59],[31.445,-43.848],[39.014,-59.619],[43.359,-68.945],[37.988,-70.605]],"c":true},"ix":2},"nm":"Y","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"Y","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"!","size":165,"style":"Regular","w":18.16,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.261,11.784],[-0.195,3.516],[1.106,1.108],[1.302,0],[0.259,-2.539],[-0.327,-4.297],[0,0]],"o":[[0.259,-11.783],[-0.066,-1.627],[-1.108,-1.106],[-2.019,0],[1.367,29.819],[0,0],[0.52,-6.38]],"v":[[12.109,-44.043],[12.793,-66.992],[11.035,-71.094],[7.422,-72.754],[4.004,-68.945],[6.543,-17.773],[10.938,-16.797]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.618,-0.879],[0,-1.431],[-1.042,-1.497],[-1.823,0],[-0.684,0.879],[0,1.433],[1.172,1.53],[1.758,0]],"o":[[-0.62,0.879],[0,2.019],[1.041,1.497],[1.172,0],[0.684,-0.879],[0,-1.953],[-1.172,-1.529],[-1.108,0]],"v":[[5.42,-10.01],[4.492,-6.543],[6.055,-1.27],[10.352,0.977],[13.135,-0.342],[14.16,-3.809],[12.402,-9.033],[8.008,-11.328]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"!","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"}]}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = {"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":29.9700012207031,"ip":0,"op":60.0000024438501,"w":1440,"h":900,"nm":"congrats-anim","ddd":0,"assets":[],"fonts":{"list":[{"fName":"Neucha","fFamily":"Neucha","fStyle":"Regular","ascent":78.2669067382812}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[2.965,3.413],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949020026712,1,1,1],"ix":4},"o":{"a":0,"k":0,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1109.482,-460.294],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":"WELL DONE!","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[306.308,526.074,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":165,"f":"Neucha","t":"WELL DONE!","j":0,"tr":0,"lh":198,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Positon !","s":{"t":0,"xe":{"a":0,"k":100,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[-100]},{"t":35.0000014255792,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-100,0],"ix":2}}},{"nm":"Positon ! 2","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[-100]},{"t":42.0000017106951,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,100,0],"ix":2}}},{"nm":"Positon ! 3","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[-100]},{"t":50.0000020365418,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-20,0],"ix":2}}},{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":1,"r":1},"a":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":24,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[100]},{"t":50.0000020365418,"s":[0]}],"ix":9}}}]},"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Vector 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":160,"ix":10},"p":{"a":0,"k":[584.527,440.481,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[301,301,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.592,-12.412],[2,-16.5],[13.997,-5.599],[-27.5,8.5],[10.5,-11]],"o":[[-5.333,6.667],[-1.12,23.5],[-2,16.5],[-17.5,7],[21.203,-6.554],[0,0]],"v":[[20.348,-63],[5.348,-27.5],[17.848,19],[-1.773,47],[-4.273,19],[11.348,63]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.737254917622,0.929411768913,0.964705884457,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":34.0000013848484,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1050.187,96.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[237,237,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.6,3.6],[-1.5,-2],[8,-2],[-14,18],[-2.5,-1.5],[13.5,-4],[-16.5,6.5],[-2.5,-15.5]],"o":[[-0.667,-5.167],[12,-4.5],[1.5,2],[-8,2],[14,-18],[7.34,4.404],[-13.5,4],[16.5,-6.5],[0,0]],"v":[[-52.17,25.752],[-42.17,5.752],[-21.67,7.752],[-24.67,19.752],[-30.67,-10.248],[12.83,-19.748],[16.33,3.752],[12.83,-23.248],[52.33,-7.748]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.341176480055,0.384313732386,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":47.0000019143492,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[338.677,338.677],"ix":3},"r":{"a":0,"k":-152.245,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":47.0000019143492,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Vector 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.241,603.609,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[291,291,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.019,15.142],[-21.544,1.854],[21.843,-0.123],[-19.051,-0.566],[-1.053,6.591]],"o":[[20.081,-4.4],[18.48,-14.713],[39.724,-3.419],[-16.471,0.093],[15.241,0.452],[0,0]],"v":[[-75.292,75.735],[-60.995,27.44],[-14.55,20.726],[-7.144,-15.78],[-4.048,2.355],[23.103,-21.036]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.349019616842,0.521568655968,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[2]},{"t":52.0000021180034,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":4.645,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":35.0000014255792,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":52.0000021180034,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[270.187,812.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[225,225,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.5,-6.5],[-13.5,4],[7.34,4.404],[14,-18],[-8,2],[1.5,2],[12,-4.5],[-0.667,-5.167]],"o":[[-2.5,-15.5],[-16.5,6.5],[13.5,-4],[-2.5,-1.5],[-14,18],[8,-2],[-1.5,-2],[-9.6,3.6],[0,0]],"v":[[52.33,-7.748],[12.83,-23.248],[16.33,3.752],[12.83,-19.748],[-30.67,-10.248],[-24.67,19.752],[-21.67,7.752],[-42.17,5.752],[-52.17,25.752]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.800000011921,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":48.0000019550801,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,16],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":16.945,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":48.0000019550801,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Vector 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[283.99,512.842,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[273.086,215.359,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.5,13.5],[-23.5,0],[11.167,-2.5],[-1.56,32.421],[-2.788,-11.5],[22.8,-2.8],[-8.333,15.667]],"o":[[-27,-2],[-4.5,-13.5],[11.674,0],[-11.167,2.5],[2,-44.8],[1.333,5.5],[-36.8,2.8],[0,0]],"v":[[31.163,87.75],[-21.837,47.75],[6.163,3.75],[9.163,17.75],[-28.337,-9.75],[21.163,-64.25],[-3.337,-44.25],[-24.337,-87.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.996078431606,0.372549027205,0.333333343267,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[3]},{"t":37.0000015070409,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 6","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Vector 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":147,"ix":10},"p":{"a":0,"k":[493.605,-13.278,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[221,221,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-26.751,23.049],[-17.579,29.801],[-38.844,16.733]],"o":[[-4.793,-10.962],[21.816,-18.796],[14.832,-25.144],[0,0]],"v":[[-12.046,101.322],[2.42,15.388],[89.01,-32.998],[104.067,-125.327]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.65098041296,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[2]},{"t":51.0000020772726,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":-92.056,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 7","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":13,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":36.0000014663101,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[1444.67,903.138],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.665,-2.431],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"W","size":165,"style":"Regular","w":66.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[10.025,-36.588],[2.603,11.98],[0,0],[-0.912,-4.166],[2.344,-8.723],[0.977,-3.516],[2.603,11.98],[0,0],[-1.108,-5.469],[-1.01,-4.785],[-1.367,-6.184],[-1.27,-5.078],[-0.977,-2.93],[-1.823,0],[-0.652,0.13],[-4.037,16.602],[-1.758,-5.208],[-1.823,0],[-0.652,0.13],[-5.014,20.898],[-0.066,0.131],[0,0]],"o":[[-6.772,-26.431],[0,0],[2.083,10.483],[-0.781,2.8],[-2.344,8.725],[-6.772,-26.431],[0,0],[0.13,0.522],[1.106,5.469],[1.009,4.785],[1.367,6.186],[1.27,5.078],[2.278,0.456],[0.65,0],[1.758,-4.817],[3.58,15.886],[2.278,0.456],[0.65,0],[1.822,-4.688],[5.013,-20.898],[0,0],[-0.912,1.823]],"v":[[44.434,-12.695],[30.371,-70.312],[24.805,-70.312],[29.297,-48.34],[24.609,-31.055],[19.629,-12.695],[5.566,-70.312],[0,-70.312],[1.855,-61.328],[5.029,-45.947],[8.594,-29.492],[12.549,-12.598],[15.918,-0.586],[22.07,0.098],[24.023,-0.098],[32.715,-32.227],[40.723,-0.586],[46.875,0.098],[48.828,-0.098],[59.082,-38.477],[66.699,-70.02],[60.84,-70.312]],"c":true},"ix":2},"nm":"W","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"W","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"E","size":165,"style":"Regular","w":45.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[14.908,1.367],[-0.098,5.827],[0,2.866],[-13.737,1.237],[0,0],[5.859,0.488],[2.213,0.261],[0.227,4.623],[0.064,1.498],[-8.789,0.717],[-2.93,0.522],[0,0],[9.537,0.131],[2.213,0.195],[0.13,-16.797],[0.65,-7.161],[-4.819,0],[-6.674,0.227],[-2.539,0],[0,0]],"o":[[0,-2.734],[0.098,-5.826],[2.344,-0.064],[0,0],[-1.562,-0.13],[-5.859,-0.488],[-0.066,-2.994],[-0.229,-4.622],[0.455,-0.064],[8.789,-0.716],[0,0],[-2.93,-0.455],[-9.538,-0.13],[-0.717,6.641],[-0.131,16.797],[1.758,0.455],[2.994,0],[6.673,-0.229],[0,0],[-3.842,-0.586]],"v":[[13.086,-7.324],[13.232,-20.166],[13.379,-33.203],[37.5,-35.156],[36.523,-39.648],[25.391,-40.576],[13.281,-41.699],[12.842,-53.125],[12.402,-62.305],[26.27,-63.477],[43.848,-65.332],[42.773,-69.727],[24.072,-70.605],[6.445,-71.094],[5.176,-35.938],[4.004,0],[13.867,0.684],[28.369,0.342],[42.188,0],[41.211,-4.395]],"c":true},"ix":2},"nm":"E","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"E","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"L","size":165,"style":"Regular","w":47.46,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.034,-16.145],[0.33,-9.634],[0,0],[-8.53,-0.522],[0.162,2.019],[0.391,1.108],[6.686,0],[4.349,-0.259],[0.989,9.961],[0,0]],"o":[[-0.034,16.147],[0,0],[13.216,0],[-0.195,-0.977],[-0.163,-2.017],[-4.025,0.195],[-6.686,0],[-0.909,-31.055],[0,0],[-0.066,4.623]],"v":[[4.547,-38.867],[4.004,-0.195],[14.844,-0.195],[47.461,0.586],[46.924,-3.906],[46.094,-8.594],[30.026,-8.301],[13.472,-7.91],[10.626,-69.434],[4.695,-70.02]],"c":true},"ix":2},"nm":"L","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"L","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":" ","size":165,"style":"Regular","w":27.93,"data":{},"fFamily":"Neucha"},{"ch":"D","size":165,"style":"Regular","w":53.52,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.605,0],[-4.265,1.205],[-3.679,2.214],[-2.344,3.711],[0,4.492],[7.877,7.26],[14.453,0.131],[0,0]],"o":[[4.166,0],[4.263,-1.204],[3.677,-2.213],[2.344,-3.711],[0,-13.997],[-7.878,-7.259],[0,0],[3.059,0.391]],"v":[[12.5,0],[25.146,-1.807],[37.061,-6.934],[46.094,-15.82],[49.609,-28.125],[37.793,-60.01],[4.297,-71.094],[4.004,-0.586]],"c":true},"ix":2},"nm":"D","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,3.906],[-0.847,0],[-4.655,-3.482],[-3.288,-5.63],[0,-5.469],[1.758,-3.091],[2.93,-1.758],[3.45,-0.879],[3.711,0],[0,0]],"o":[[0.781,-0.195],[3.97,0],[4.654,3.484],[3.287,5.632],[0,4.037],[-1.758,3.093],[-2.93,1.758],[-3.452,0.879],[0,0],[-0.391,-35.091]],"v":[[10.742,-65.039],[13.184,-65.332],[26.123,-60.107],[38.037,-46.436],[42.969,-29.785],[40.332,-19.092],[33.301,-11.816],[23.73,-7.861],[12.988,-6.543],[11.328,-6.543]],"c":true},"ix":2},"nm":"D","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"D","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"O","size":165,"style":"Regular","w":52.34,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.424,-3.384],[-1.074,-2.864],[-1.855,-1.758],[-2.898,-0.977],[-4.037,0],[-2.019,0.845],[-1.335,1.335],[-0.977,2.051],[-0.554,2.019],[-0.293,2.637],[-0.098,2.084],[0,2.605],[0.293,3.191],[1.009,3.516],[1.692,2.409],[2.994,1.596],[4.036,0],[1.692,-0.455],[1.236,-0.943],[1.041,-1.041],[0.684,-1.692],[0.52,-1.334],[0.325,-2.18],[0.162,-1.367],[0.098,-2.344],[0,-1.138],[0,-2.213]],"o":[[0.423,3.386],[1.074,2.866],[1.855,1.758],[2.896,0.977],[2.473,0],[2.017,-0.845],[1.334,-1.334],[0.977,-2.051],[0.552,-2.017],[0.293,-2.637],[0.098,-2.083],[0,-3.841],[-0.293,-3.189],[-1.01,-3.516],[-1.694,-2.408],[-2.995,-1.595],[-2.019,0],[-1.694,0.456],[-1.237,0.945],[-1.042,1.042],[-0.684,1.694],[-0.522,1.335],[-0.327,2.182],[-0.163,1.367],[-0.098,2.344],[0,1.14],[0,4.623]],"v":[[4.736,-20.703],[6.982,-11.328],[11.377,-4.395],[18.506,-0.293],[28.906,1.172],[35.645,-0.098],[40.674,-3.369],[44.141,-8.447],[46.436,-14.551],[47.705,-21.533],[48.291,-28.613],[48.438,-35.645],[47.998,-46.191],[46.045,-56.25],[41.992,-65.137],[34.961,-71.143],[24.414,-73.535],[18.848,-72.852],[14.453,-70.752],[11.035,-67.773],[8.447,-63.672],[6.641,-59.131],[5.371,-53.857],[4.639,-48.535],[4.248,-42.969],[4.102,-37.744],[4.102,-32.715]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[2.351,-5.078],[4.767,-0.259],[1.73,0.815],[1.077,1.074],[0.784,1.953],[0.36,1.498],[0.195,2.573],[0.032,1.401],[0,2.67],[-0.848,4.33],[-1.993,3.484],[-2.614,0],[-2.483,-2.505],[-1.143,-3.97],[-0.49,-3.45],[0,-3.189]],"o":[[-2.351,5.078],[-2.156,-0.064],[-1.73,-0.813],[-1.077,-1.074],[-0.784,-1.953],[-0.36,-1.497],[-0.195,-2.571],[-0.034,-1.399],[0,-3.841],[0.848,-4.329],[1.993,-3.482],[3.461,0],[2.481,2.507],[1.143,3.972],[0.49,3.452],[0,7.358]],"v":[[37.878,-13.281],[27.2,-5.273],[21.37,-6.592],[17.157,-9.424],[14.365,-13.965],[12.65,-19.141],[11.816,-25.244],[11.475,-31.201],[11.426,-37.305],[12.698,-49.561],[16.96,-61.279],[23.869,-66.504],[32.785,-62.744],[38.222,-53.027],[40.671,-41.895],[41.406,-31.934]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"O","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"N","size":165,"style":"Regular","w":54.88,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.074,-0.977],[-1.172,0],[-0.586,2.017],[0.032,11.719],[0.064,4.428],[-5.893,-11.783],[-3.972,-6.119],[-2.214,0],[-1.367,0.586],[0.716,14.128],[0,0],[0,-19.661],[0,0],[0,0],[0,0],[0,0]],"o":[[1.074,0.977],[1.692,0],[-0.195,-6.055],[-0.034,-11.719],[2.473,4.362],[5.891,11.784],[2.408,1.302],[1.497,0],[-0.456,-32.422],[0,0],[-0.717,15.691],[0,0],[0,0],[0,0],[0,0],[0.259,1.367]],"v":[[6.006,0.781],[9.375,2.246],[12.793,-0.781],[12.451,-27.441],[12.305,-51.66],[24.854,-27.441],[39.648,-0.586],[46.582,1.367],[50.879,0.488],[49.121,-69.336],[43.555,-70.41],[42.48,-17.383],[42.48,-9.668],[10.547,-70.312],[5.273,-70.312],[4.004,-2.734]],"c":true},"ix":2},"nm":"N","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"N","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"!","size":165,"style":"Regular","w":18.16,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.261,11.784],[-0.195,3.516],[1.106,1.108],[1.302,0],[0.259,-2.539],[-0.327,-4.297],[0,0]],"o":[[0.259,-11.783],[-0.066,-1.627],[-1.108,-1.106],[-2.019,0],[1.367,29.819],[0,0],[0.52,-6.38]],"v":[[12.109,-44.043],[12.793,-66.992],[11.035,-71.094],[7.422,-72.754],[4.004,-68.945],[6.543,-17.773],[10.938,-16.797]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.618,-0.879],[0,-1.431],[-1.042,-1.497],[-1.823,0],[-0.684,0.879],[0,1.433],[1.172,1.53],[1.758,0]],"o":[[-0.62,0.879],[0,2.019],[1.041,1.497],[1.172,0],[0.684,-0.879],[0,-1.953],[-1.172,-1.529],[-1.108,0]],"v":[[5.42,-10.01],[4.492,-6.543],[6.055,-1.27],[10.352,0.977],[13.135,-0.342],[14.16,-3.809],[12.402,-9.033],[8.008,-11.328]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"!","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"}]}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = {"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":29.9700012207031,"ip":0,"op":60.0000024438501,"w":1440,"h":900,"nm":"congrats-anim","ddd":0,"assets":[],"fonts":{"list":[{"fName":"Neucha","fFamily":"Neucha","fStyle":"Regular","ascent":78.2669067382812}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[2.965,3.413],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949020026712,1,1,1],"ix":4},"o":{"a":0,"k":0,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1109.482,-460.294],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":"WOW!","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[538.589,526.074,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":165,"f":"Neucha","t":"WOW!","j":0,"tr":0,"lh":198,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Positon !","s":{"t":0,"xe":{"a":0,"k":100,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[-100]},{"t":35.0000014255792,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-100,0],"ix":2}}},{"nm":"Positon ! 2","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[-100]},{"t":42.0000017106951,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,100,0],"ix":2}}},{"nm":"Positon ! 3","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[-100]},{"t":50.0000020365418,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-20,0],"ix":2}}},{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":1,"r":1},"a":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":24,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[100]},{"t":50.0000020365418,"s":[0]}],"ix":9}}}]},"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Vector 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":160,"ix":10},"p":{"a":0,"k":[584.527,440.481,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[301,301,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.592,-12.412],[2,-16.5],[13.997,-5.599],[-27.5,8.5],[10.5,-11]],"o":[[-5.333,6.667],[-1.12,23.5],[-2,16.5],[-17.5,7],[21.203,-6.554],[0,0]],"v":[[20.348,-63],[5.348,-27.5],[17.848,19],[-1.773,47],[-4.273,19],[11.348,63]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.737254917622,0.929411768913,0.964705884457,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":34.0000013848484,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1050.187,96.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[237,237,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.6,3.6],[-1.5,-2],[8,-2],[-14,18],[-2.5,-1.5],[13.5,-4],[-16.5,6.5],[-2.5,-15.5]],"o":[[-0.667,-5.167],[12,-4.5],[1.5,2],[-8,2],[14,-18],[7.34,4.404],[-13.5,4],[16.5,-6.5],[0,0]],"v":[[-52.17,25.752],[-42.17,5.752],[-21.67,7.752],[-24.67,19.752],[-30.67,-10.248],[12.83,-19.748],[16.33,3.752],[12.83,-23.248],[52.33,-7.748]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.341176480055,0.384313732386,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":47.0000019143492,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[338.677,338.677],"ix":3},"r":{"a":0,"k":-152.245,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":47.0000019143492,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Vector 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.241,603.609,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[291,291,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.019,15.142],[-21.544,1.854],[21.843,-0.123],[-19.051,-0.566],[-1.053,6.591]],"o":[[20.081,-4.4],[18.48,-14.713],[39.724,-3.419],[-16.471,0.093],[15.241,0.452],[0,0]],"v":[[-75.292,75.735],[-60.995,27.44],[-14.55,20.726],[-7.144,-15.78],[-4.048,2.355],[23.103,-21.036]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.349019616842,0.521568655968,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[2]},{"t":52.0000021180034,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":4.645,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":35.0000014255792,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":52.0000021180034,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[270.187,812.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[225,225,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.5,-6.5],[-13.5,4],[7.34,4.404],[14,-18],[-8,2],[1.5,2],[12,-4.5],[-0.667,-5.167]],"o":[[-2.5,-15.5],[-16.5,6.5],[13.5,-4],[-2.5,-1.5],[-14,18],[8,-2],[-1.5,-2],[-9.6,3.6],[0,0]],"v":[[52.33,-7.748],[12.83,-23.248],[16.33,3.752],[12.83,-19.748],[-30.67,-10.248],[-24.67,19.752],[-21.67,7.752],[-42.17,5.752],[-52.17,25.752]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.800000011921,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":48.0000019550801,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,16],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":16.945,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":48.0000019550801,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Vector 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[283.99,512.842,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[273.086,215.359,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.5,13.5],[-23.5,0],[11.167,-2.5],[-1.56,32.421],[-2.788,-11.5],[22.8,-2.8],[-8.333,15.667]],"o":[[-27,-2],[-4.5,-13.5],[11.674,0],[-11.167,2.5],[2,-44.8],[1.333,5.5],[-36.8,2.8],[0,0]],"v":[[31.163,87.75],[-21.837,47.75],[6.163,3.75],[9.163,17.75],[-28.337,-9.75],[21.163,-64.25],[-3.337,-44.25],[-24.337,-87.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.996078431606,0.372549027205,0.333333343267,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[3]},{"t":37.0000015070409,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 6","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Vector 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":147,"ix":10},"p":{"a":0,"k":[493.605,-13.278,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[221,221,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-26.751,23.049],[-17.579,29.801],[-38.844,16.733]],"o":[[-4.793,-10.962],[21.816,-18.796],[14.832,-25.144],[0,0]],"v":[[-12.046,101.322],[2.42,15.388],[89.01,-32.998],[104.067,-125.327]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.65098041296,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[2]},{"t":51.0000020772726,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":-92.056,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 7","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":13,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":36.0000014663101,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[1444.67,903.138],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.665,-2.431],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"W","size":165,"style":"Regular","w":66.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[10.025,-36.588],[2.603,11.98],[0,0],[-0.912,-4.166],[2.344,-8.723],[0.977,-3.516],[2.603,11.98],[0,0],[-1.108,-5.469],[-1.01,-4.785],[-1.367,-6.184],[-1.27,-5.078],[-0.977,-2.93],[-1.823,0],[-0.652,0.13],[-4.037,16.602],[-1.758,-5.208],[-1.823,0],[-0.652,0.13],[-5.014,20.898],[-0.066,0.131],[0,0]],"o":[[-6.772,-26.431],[0,0],[2.083,10.483],[-0.781,2.8],[-2.344,8.725],[-6.772,-26.431],[0,0],[0.13,0.522],[1.106,5.469],[1.009,4.785],[1.367,6.186],[1.27,5.078],[2.278,0.456],[0.65,0],[1.758,-4.817],[3.58,15.886],[2.278,0.456],[0.65,0],[1.822,-4.688],[5.013,-20.898],[0,0],[-0.912,1.823]],"v":[[44.434,-12.695],[30.371,-70.312],[24.805,-70.312],[29.297,-48.34],[24.609,-31.055],[19.629,-12.695],[5.566,-70.312],[0,-70.312],[1.855,-61.328],[5.029,-45.947],[8.594,-29.492],[12.549,-12.598],[15.918,-0.586],[22.07,0.098],[24.023,-0.098],[32.715,-32.227],[40.723,-0.586],[46.875,0.098],[48.828,-0.098],[59.082,-38.477],[66.699,-70.02],[60.84,-70.312]],"c":true},"ix":2},"nm":"W","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"W","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"O","size":165,"style":"Regular","w":52.34,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.424,-3.384],[-1.074,-2.864],[-1.855,-1.758],[-2.898,-0.977],[-4.037,0],[-2.019,0.845],[-1.335,1.335],[-0.977,2.051],[-0.554,2.019],[-0.293,2.637],[-0.098,2.084],[0,2.605],[0.293,3.191],[1.009,3.516],[1.692,2.409],[2.994,1.596],[4.036,0],[1.692,-0.455],[1.236,-0.943],[1.041,-1.041],[0.684,-1.692],[0.52,-1.334],[0.325,-2.18],[0.162,-1.367],[0.098,-2.344],[0,-1.138],[0,-2.213]],"o":[[0.423,3.386],[1.074,2.866],[1.855,1.758],[2.896,0.977],[2.473,0],[2.017,-0.845],[1.334,-1.334],[0.977,-2.051],[0.552,-2.017],[0.293,-2.637],[0.098,-2.083],[0,-3.841],[-0.293,-3.189],[-1.01,-3.516],[-1.694,-2.408],[-2.995,-1.595],[-2.019,0],[-1.694,0.456],[-1.237,0.945],[-1.042,1.042],[-0.684,1.694],[-0.522,1.335],[-0.327,2.182],[-0.163,1.367],[-0.098,2.344],[0,1.14],[0,4.623]],"v":[[4.736,-20.703],[6.982,-11.328],[11.377,-4.395],[18.506,-0.293],[28.906,1.172],[35.645,-0.098],[40.674,-3.369],[44.141,-8.447],[46.436,-14.551],[47.705,-21.533],[48.291,-28.613],[48.438,-35.645],[47.998,-46.191],[46.045,-56.25],[41.992,-65.137],[34.961,-71.143],[24.414,-73.535],[18.848,-72.852],[14.453,-70.752],[11.035,-67.773],[8.447,-63.672],[6.641,-59.131],[5.371,-53.857],[4.639,-48.535],[4.248,-42.969],[4.102,-37.744],[4.102,-32.715]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[2.351,-5.078],[4.767,-0.259],[1.73,0.815],[1.077,1.074],[0.784,1.953],[0.36,1.498],[0.195,2.573],[0.032,1.401],[0,2.67],[-0.848,4.33],[-1.993,3.484],[-2.614,0],[-2.483,-2.505],[-1.143,-3.97],[-0.49,-3.45],[0,-3.189]],"o":[[-2.351,5.078],[-2.156,-0.064],[-1.73,-0.813],[-1.077,-1.074],[-0.784,-1.953],[-0.36,-1.497],[-0.195,-2.571],[-0.034,-1.399],[0,-3.841],[0.848,-4.329],[1.993,-3.482],[3.461,0],[2.481,2.507],[1.143,3.972],[0.49,3.452],[0,7.358]],"v":[[37.878,-13.281],[27.2,-5.273],[21.37,-6.592],[17.157,-9.424],[14.365,-13.965],[12.65,-19.141],[11.816,-25.244],[11.475,-31.201],[11.426,-37.305],[12.698,-49.561],[16.96,-61.279],[23.869,-66.504],[32.785,-62.744],[38.222,-53.027],[40.671,-41.895],[41.406,-31.934]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"O","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"!","size":165,"style":"Regular","w":18.16,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.261,11.784],[-0.195,3.516],[1.106,1.108],[1.302,0],[0.259,-2.539],[-0.327,-4.297],[0,0]],"o":[[0.259,-11.783],[-0.066,-1.627],[-1.108,-1.106],[-2.019,0],[1.367,29.819],[0,0],[0.52,-6.38]],"v":[[12.109,-44.043],[12.793,-66.992],[11.035,-71.094],[7.422,-72.754],[4.004,-68.945],[6.543,-17.773],[10.938,-16.797]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.618,-0.879],[0,-1.431],[-1.042,-1.497],[-1.823,0],[-0.684,0.879],[0,1.433],[1.172,1.53],[1.758,0]],"o":[[-0.62,0.879],[0,2.019],[1.041,1.497],[1.172,0],[0.684,-0.879],[0,-1.953],[-1.172,-1.529],[-1.108,0]],"v":[[5.42,-10.01],[4.492,-6.543],[6.055,-1.27],[10.352,0.977],[13.135,-0.342],[14.16,-3.809],[12.402,-9.033],[8.008,-11.328]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"!","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"}]}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = {"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":29.9700012207031,"ip":0,"op":60.0000024438501,"w":1440,"h":900,"nm":"congrats-anim","ddd":0,"assets":[],"fonts":{"list":[{"fName":"Neucha","fFamily":"Neucha","fStyle":"Regular","ascent":78.2669067382812}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[2.965,3.413],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949020026712,1,1,1],"ix":4},"o":{"a":0,"k":0,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1109.482,-460.294],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":"YOU DID IT!","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[334.401,526.074,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":165,"f":"Neucha","t":"YOU DID IT!","j":0,"tr":0,"lh":198,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Positon !","s":{"t":0,"xe":{"a":0,"k":100,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[-100]},{"t":35.0000014255792,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-100,0],"ix":2}}},{"nm":"Positon ! 2","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[-100]},{"t":42.0000017106951,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,100,0],"ix":2}}},{"nm":"Positon ! 3","s":{"t":0,"xe":{"a":0,"k":50,"ix":7},"ne":{"a":0,"k":50,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[-100]},{"t":50.0000020365418,"s":[99]}],"ix":3},"r":1},"a":{"p":{"a":0,"k":[0,-20,0],"ix":2}}},{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":1,"r":1},"a":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":24,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":42,"s":[100]},{"t":50.0000020365418,"s":[0]}],"ix":9}}}]},"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Vector 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":160,"ix":10},"p":{"a":0,"k":[584.527,440.481,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[301,301,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.592,-12.412],[2,-16.5],[13.997,-5.599],[-27.5,8.5],[10.5,-11]],"o":[[-5.333,6.667],[-1.12,23.5],[-2,16.5],[-17.5,7],[21.203,-6.554],[0,0]],"v":[[20.348,-63],[5.348,-27.5],[17.848,19],[-1.773,47],[-4.273,19],[11.348,63]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.737254917622,0.929411768913,0.964705884457,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 4","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":7,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":34.0000013848484,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1050.187,96.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[237,237,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.6,3.6],[-1.5,-2],[8,-2],[-14,18],[-2.5,-1.5],[13.5,-4],[-16.5,6.5],[-2.5,-15.5]],"o":[[-0.667,-5.167],[12,-4.5],[1.5,2],[-8,2],[14,-18],[7.34,4.404],[-13.5,4],[16.5,-6.5],[0,0]],"v":[[-52.17,25.752],[-42.17,5.752],[-21.67,7.752],[-24.67,19.752],[-30.67,-10.248],[12.83,-19.748],[16.33,3.752],[12.83,-23.248],[52.33,-7.748]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.341176480055,0.384313732386,0.835294127464,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":47.0000019143492,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[338.677,338.677],"ix":3},"r":{"a":0,"k":-152.245,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":47.0000019143492,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Vector 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.241,603.609,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[291,291,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.019,15.142],[-21.544,1.854],[21.843,-0.123],[-19.051,-0.566],[-1.053,6.591]],"o":[[20.081,-4.4],[18.48,-14.713],[39.724,-3.419],[-16.471,0.093],[15.241,0.452],[0,0]],"v":[[-75.292,75.735],[-60.995,27.44],[-14.55,20.726],[-7.144,-15.78],[-4.048,2.355],[23.103,-21.036]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.349019616842,0.521568655968,0.152941182256,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[2]},{"t":52.0000021180034,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":4.645,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 2","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":35.0000014255792,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":52.0000021180034,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Vector 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[270.187,812.757,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[225,225,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[16.5,-6.5],[-13.5,4],[7.34,4.404],[14,-18],[-8,2],[1.5,2],[12,-4.5],[-0.667,-5.167]],"o":[[-2.5,-15.5],[-16.5,6.5],[13.5,-4],[-2.5,-1.5],[-14,18],[8,-2],[-1.5,-2],[-9.6,3.6],[0,0]],"v":[[52.33,-7.748],[12.83,-23.248],[16.33,3.752],[12.83,-19.748],[-30.67,-10.248],[-24.67,19.752],[-21.67,7.752],[-42.17,5.752],[-52.17,25.752]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.800000011921,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":48.0000019550801,"s":[2]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,16],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":16.945,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 3","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":37.0000015070409,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":11,"s":[0]},{"t":48.0000019550801,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Vector 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[283.99,512.842,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[273.086,215.359,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[4.5,13.5],[-23.5,0],[11.167,-2.5],[-1.56,32.421],[-2.788,-11.5],[22.8,-2.8],[-8.333,15.667]],"o":[[-27,-2],[-4.5,-13.5],[11.674,0],[-11.167,2.5],[2,-44.8],[1.333,5.5],[-36.8,2.8],[0,0]],"v":[[31.163,87.75],[-21.837,47.75],[6.163,3.75],[9.163,17.75],[-28.337,-9.75],[21.163,-64.25],[-3.337,-44.25],[-24.337,-87.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.996078431606,0.372549027205,0.333333343267,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[3]},{"t":37.0000015070409,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 6","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":10,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":41.0000016699642,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Vector 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":147,"ix":10},"p":{"a":0,"k":[493.605,-13.278,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[221,221,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-26.751,23.049],[-17.579,29.801],[-38.844,16.733]],"o":[[-4.793,-10.962],[21.816,-18.796],[14.832,-25.144],[0,0]],"v":[[-12.046,101.322],[2.42,15.388],[89.01,-32.998],[104.067,-125.327]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.65098041296,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[2]},{"t":51.0000020772726,"s":[1]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[270.677,270.677],"ix":3},"r":{"a":0,"k":-92.056,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Vector 7","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":13,"s":[0]},{"t":51.0000020772726,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":36.0000014663101,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[720,450,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[1444.67,903.138],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.949020026712,0.949020026712,0.949020026712,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":27,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.665,-2.431],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":60.0000024438501,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"Y","size":165,"style":"Regular","w":41.21,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.21,-8.267],[1.175,-2.083],[0,0],[0,0],[-4.004,-9.7],[-3.256,-5.403],[0.098,-6.802],[0.195,-2.798],[-2.307,0],[-0.592,0.131],[0.064,6.706],[0.259,3.191],[-2.734,5.405],[-2.312,5.112],[-0.586,1.108],[0,0]],"o":[[-4.211,8.269],[0,0],[0,0],[1.108,2.28],[4.004,9.702],[-0.261,3.125],[-0.098,6.804],[0.458,0.131],[2.438,0],[-0.195,-2.93],[-0.066,-6.705],[2.603,-4.102],[2.734,-5.403],[2.31,-5.11],[0,0],[-2.35,3.452]],"v":[[28.148,-53.027],[20.07,-37.5],[4.688,-70.703],[-1.953,-70.215],[5.713,-52.246],[16.602,-29.59],[16.064,-14.697],[15.625,-0.293],[19.772,-0.098],[24.316,-0.293],[23.926,-14.746],[23.438,-29.59],[31.445,-43.848],[39.014,-59.619],[43.359,-68.945],[37.988,-70.605]],"c":true},"ix":2},"nm":"Y","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"Y","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"O","size":165,"style":"Regular","w":52.34,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.424,-3.384],[-1.074,-2.864],[-1.855,-1.758],[-2.898,-0.977],[-4.037,0],[-2.019,0.845],[-1.335,1.335],[-0.977,2.051],[-0.554,2.019],[-0.293,2.637],[-0.098,2.084],[0,2.605],[0.293,3.191],[1.009,3.516],[1.692,2.409],[2.994,1.596],[4.036,0],[1.692,-0.455],[1.236,-0.943],[1.041,-1.041],[0.684,-1.692],[0.52,-1.334],[0.325,-2.18],[0.162,-1.367],[0.098,-2.344],[0,-1.138],[0,-2.213]],"o":[[0.423,3.386],[1.074,2.866],[1.855,1.758],[2.896,0.977],[2.473,0],[2.017,-0.845],[1.334,-1.334],[0.977,-2.051],[0.552,-2.017],[0.293,-2.637],[0.098,-2.083],[0,-3.841],[-0.293,-3.189],[-1.01,-3.516],[-1.694,-2.408],[-2.995,-1.595],[-2.019,0],[-1.694,0.456],[-1.237,0.945],[-1.042,1.042],[-0.684,1.694],[-0.522,1.335],[-0.327,2.182],[-0.163,1.367],[-0.098,2.344],[0,1.14],[0,4.623]],"v":[[4.736,-20.703],[6.982,-11.328],[11.377,-4.395],[18.506,-0.293],[28.906,1.172],[35.645,-0.098],[40.674,-3.369],[44.141,-8.447],[46.436,-14.551],[47.705,-21.533],[48.291,-28.613],[48.438,-35.645],[47.998,-46.191],[46.045,-56.25],[41.992,-65.137],[34.961,-71.143],[24.414,-73.535],[18.848,-72.852],[14.453,-70.752],[11.035,-67.773],[8.447,-63.672],[6.641,-59.131],[5.371,-53.857],[4.639,-48.535],[4.248,-42.969],[4.102,-37.744],[4.102,-32.715]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[2.351,-5.078],[4.767,-0.259],[1.73,0.815],[1.077,1.074],[0.784,1.953],[0.36,1.498],[0.195,2.573],[0.032,1.401],[0,2.67],[-0.848,4.33],[-1.993,3.484],[-2.614,0],[-2.483,-2.505],[-1.143,-3.97],[-0.49,-3.45],[0,-3.189]],"o":[[-2.351,5.078],[-2.156,-0.064],[-1.73,-0.813],[-1.077,-1.074],[-0.784,-1.953],[-0.36,-1.497],[-0.195,-2.571],[-0.034,-1.399],[0,-3.841],[0.848,-4.329],[1.993,-3.482],[3.461,0],[2.481,2.507],[1.143,3.972],[0.49,3.452],[0,7.358]],"v":[[37.878,-13.281],[27.2,-5.273],[21.37,-6.592],[17.157,-9.424],[14.365,-13.965],[12.65,-19.141],[11.816,-25.244],[11.475,-31.201],[11.426,-37.305],[12.698,-49.561],[16.96,-61.279],[23.869,-66.504],[32.785,-62.744],[38.222,-53.027],[40.671,-41.895],[41.406,-31.934]],"c":true},"ix":2},"nm":"O","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"O","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"U","size":165,"style":"Regular","w":52.44,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.064,-12.5],[0.455,-5.598],[0.162,-1.138],[0.391,-1.529],[0.684,-0.781],[1.074,-0.781],[1.66,-0.293],[2.278,0],[1.562,0.652],[0.845,0.912],[0.488,1.694],[0.13,1.303],[0.064,2.214],[0.586,11.101],[0.13,5.991],[0,0],[0,-4.688],[-0.327,-7.942],[0,-0.195],[-0.131,-1.692],[-0.293,-1.888],[-0.554,-1.367],[-0.977,-1.27],[-1.401,-0.781],[-2.084,-0.488],[-2.734,0],[-2.67,0.748],[-1.66,1.27],[-0.977,2.148],[-0.391,2.246],[-0.131,3.256],[0,5.991],[0.845,11.98],[0,0]],"o":[[-0.066,12.5],[-0.195,2.214],[-0.163,1.14],[-0.391,1.53],[-0.684,0.781],[-1.074,0.781],[-1.66,0.293],[-2.28,0],[-1.562,-0.65],[-0.847,-0.911],[-0.488,-1.692],[-0.131,-1.302],[-0.195,-4.688],[-0.586,-11.099],[0,0],[-0.391,14.194],[0,5.534],[0,0.066],[0.13,2.28],[0.13,1.694],[0.293,1.889],[0.552,1.367],[0.977,1.27],[1.399,0.781],[2.083,0.488],[3.775,0],[2.669,-0.749],[1.66,-1.27],[0.977,-2.148],[0.391,-2.246],[0.325,-7.681],[0,-8.267],[0,0],[-0.131,3.581]],"v":[[41.211,-48.34],[40.43,-21.191],[39.893,-16.162],[39.062,-12.158],[37.451,-8.691],[34.814,-6.348],[30.713,-4.736],[24.805,-4.297],[19.043,-5.273],[15.43,-7.617],[13.428,-11.523],[12.5,-16.016],[12.207,-21.289],[11.035,-44.971],[9.961,-70.605],[4.59,-71.777],[4.004,-43.457],[4.492,-23.242],[4.492,-22.852],[4.883,-16.895],[5.518,-11.523],[6.787,-6.641],[9.082,-2.686],[12.646,0.391],[17.871,2.295],[25.098,3.027],[34.766,1.904],[41.26,-1.123],[45.215,-6.25],[47.266,-12.842],[48.047,-21.094],[48.535,-41.602],[47.266,-71.973],[41.504,-72.461]],"c":true},"ix":2},"nm":"U","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"U","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":" ","size":165,"style":"Regular","w":27.93,"data":{},"fFamily":"Neucha"},{"ch":"D","size":165,"style":"Regular","w":53.52,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.605,0],[-4.265,1.205],[-3.679,2.214],[-2.344,3.711],[0,4.492],[7.877,7.26],[14.453,0.131],[0,0]],"o":[[4.166,0],[4.263,-1.204],[3.677,-2.213],[2.344,-3.711],[0,-13.997],[-7.878,-7.259],[0,0],[3.059,0.391]],"v":[[12.5,0],[25.146,-1.807],[37.061,-6.934],[46.094,-15.82],[49.609,-28.125],[37.793,-60.01],[4.297,-71.094],[4.004,-0.586]],"c":true},"ix":2},"nm":"D","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,3.906],[-0.847,0],[-4.655,-3.482],[-3.288,-5.63],[0,-5.469],[1.758,-3.091],[2.93,-1.758],[3.45,-0.879],[3.711,0],[0,0]],"o":[[0.781,-0.195],[3.97,0],[4.654,3.484],[3.287,5.632],[0,4.037],[-1.758,3.093],[-2.93,1.758],[-3.452,0.879],[0,0],[-0.391,-35.091]],"v":[[10.742,-65.039],[13.184,-65.332],[26.123,-60.107],[38.037,-46.436],[42.969,-29.785],[40.332,-19.092],[33.301,-11.816],[23.73,-7.861],[12.988,-6.543],[11.328,-6.543]],"c":true},"ix":2},"nm":"D","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"D","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"I","size":165,"style":"Regular","w":32.91,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-4.362,0.032],[-2.214,0],[-1.953,-0.066],[0,0],[2.93,0.261],[1.041,0.195],[0,8.936],[0.032,7.37],[0.195,1.826],[-2.019,0.096],[-1.108,0.449],[0,0],[5.728,0],[2.669,0.064],[0,0],[0,0],[-0.261,-11.053],[0,-5.869],[0.064,-2.217],[5.989,-0.977],[0,0]],"o":[[4.361,-0.034],[4.231,0],[0,0],[-0.717,-0.13],[-2.93,-0.259],[-0.131,-3.781],[0,-8.934],[-0.034,-7.37],[0.52,-0.064],[2.017,-0.096],[0,0],[-2.8,-0.064],[-5.6,0],[0,0],[0,0],[0.064,3.587],[0.259,11.053],[0,4.434],[-1.433,0.066],[0,0],[1.822,0]],"v":[[11.621,0.244],[21.484,0.195],[30.762,0.293],[30.957,-4.785],[25.488,-5.371],[19.531,-6.055],[19.336,-25.13],[19.287,-49.585],[18.945,-63.379],[22.754,-63.618],[27.441,-64.436],[27.148,-69.241],[14.355,-69.337],[1.953,-69.434],[2.637,-63.86],[12.5,-63.379],[12.988,-41.417],[13.379,-16.032],[13.281,-6.055],[2.148,-4.492],[2.344,0.293]],"c":true},"ix":2},"nm":"I","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"I","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"T","size":165,"style":"Regular","w":43.07,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-7.358,-0.52],[0,-7.747],[-0.034,-5.338],[0,-2.669],[0.13,-3.516],[-1.108,-0.943],[-1.172,0],[-0.586,1.953],[1.627,22.983],[0,0],[-0.652,0.652],[0,0.847],[1.106,1.108],[1.627,0.066],[0,0],[0,0]],"o":[[-0.261,6.25],[0,2.67],[0.032,5.339],[0,7.162],[0.259,1.367],[1.106,0.943],[1.627,0],[-0.781,-18.814],[0,0],[1.302,-0.13],[0.65,-0.65],[0,-1.302],[-1.108,-1.106],[0,0],[0,0],[4.036,0.195]],"v":[[18.066,-64.453],[17.676,-43.457],[17.725,-31.445],[17.773,-19.434],[17.578,-3.418],[19.629,0.049],[23.047,1.465],[26.367,-1.465],[22.754,-64.16],[39.16,-63.281],[42.09,-64.453],[43.066,-66.699],[41.406,-70.312],[37.305,-72.07],[0,-69.922],[0.977,-65.527]],"c":true},"ix":2},"nm":"T","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"T","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"},{"ch":"!","size":165,"style":"Regular","w":18.16,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.261,11.784],[-0.195,3.516],[1.106,1.108],[1.302,0],[0.259,-2.539],[-0.327,-4.297],[0,0]],"o":[[0.259,-11.783],[-0.066,-1.627],[-1.108,-1.106],[-2.019,0],[1.367,29.819],[0,0],[0.52,-6.38]],"v":[[12.109,-44.043],[12.793,-66.992],[11.035,-71.094],[7.422,-72.754],[4.004,-68.945],[6.543,-17.773],[10.938,-16.797]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.618,-0.879],[0,-1.431],[-1.042,-1.497],[-1.823,0],[-0.684,0.879],[0,1.433],[1.172,1.53],[1.758,0]],"o":[[-0.62,0.879],[0,2.019],[1.041,1.497],[1.172,0],[0.684,-0.879],[0,-1.953],[-1.172,-1.529],[-1.108,0]],"v":[[5.42,-10.01],[4.492,-6.543],[6.055,-1.27],[10.352,0.977],[13.135,-0.342],[14.16,-3.809],[12.402,-9.033],[8.008,-11.328]],"c":true},"ix":2},"nm":"!","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"!","np":5,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Neucha"}]}

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v0.7.31
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="0.7.31",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=255;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY).replace(/\s\s*$/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,/(ba?idubrowser)[\/ ]?([\w\.]+)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/\bqbcore\/([\w\.]+)/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/yabrowser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|samsung|sailfish)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(metasr)[\/ ]?([\w\.]+)/i,/(lbbrowser)/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/\((ip(?:hone|od)[\w ]*);/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+)(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows) nt 6\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,strMapper,windowsVersionMap]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+ ([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _ua=ua||(typeof window!==UNDEF_TYPE&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var _rgxmap=extensions?extend(regexes,extensions):regexes;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser.major=majorize(_browser.version);return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(695)){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 695 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var ClientRequest = __webpack_require__(697)
var response = __webpack_require__(313)
var extend = __webpack_require__(707)
var statusCodes = __webpack_require__(708)
var url = __webpack_require__(709)

var http = exports

http.request = function (opts, cb) {
	if (typeof opts === 'string')
		opts = url.parse(opts)
	else
		opts = extend(opts)

	// Normally, the page is loaded from http or https, so not specifying a protocol
	// will result in a (valid) protocol-relative url. However, this won't work if
	// the protocol is something else, like 'file:'
	var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''

	var protocol = opts.protocol || defaultProtocol
	var host = opts.hostname || opts.host
	var port = opts.port
	var path = opts.path || '/'

	// Necessary for IPv6 addresses
	if (host && host.indexOf(':') !== -1)
		host = '[' + host + ']'

	// This may be a relative url. The browser should always be able to interpret it correctly.
	opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
	opts.method = (opts.method || 'GET').toUpperCase()
	opts.headers = opts.headers || {}

	// Also valid opts.auth, opts.mode

	var req = new ClientRequest(opts)
	if (cb)
		req.on('response', cb)
	return req
}

http.get = function get (opts, cb) {
	var req = http.request(opts, cb)
	req.end()
	return req
}

http.ClientRequest = ClientRequest
http.IncomingMessage = response.IncomingMessage

http.Agent = function () {}
http.Agent.defaultMaxSockets = 4

http.globalAgent = new http.Agent()

http.STATUS_CODES = statusCodes

http.METHODS = [
	'CHECKOUT',
	'CONNECT',
	'COPY',
	'DELETE',
	'GET',
	'HEAD',
	'LOCK',
	'M-SEARCH',
	'MERGE',
	'MKACTIVITY',
	'MKCOL',
	'MOVE',
	'NOTIFY',
	'OPTIONS',
	'PATCH',
	'POST',
	'PROPFIND',
	'PROPPATCH',
	'PURGE',
	'PUT',
	'REPORT',
	'SEARCH',
	'SUBSCRIBE',
	'TRACE',
	'UNLOCK',
	'UNSUBSCRIBE'
]
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {var capability = __webpack_require__(312)
var inherits = __webpack_require__(63)
var response = __webpack_require__(313)
var stream = __webpack_require__(314)
var toArrayBuffer = __webpack_require__(706)

var IncomingMessage = response.IncomingMessage
var rStates = response.readyStates

function decideMode (preferBinary, useFetch) {
	if (capability.fetch && useFetch) {
		return 'fetch'
	} else if (capability.mozchunkedarraybuffer) {
		return 'moz-chunked-arraybuffer'
	} else if (capability.msstream) {
		return 'ms-stream'
	} else if (capability.arraybuffer && preferBinary) {
		return 'arraybuffer'
	} else if (capability.vbArray && preferBinary) {
		return 'text:vbarray'
	} else {
		return 'text'
	}
}

var ClientRequest = module.exports = function (opts) {
	var self = this
	stream.Writable.call(self)

	self._opts = opts
	self._body = []
	self._headers = {}
	if (opts.auth)
		self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'))
	Object.keys(opts.headers).forEach(function (name) {
		self.setHeader(name, opts.headers[name])
	})

	var preferBinary
	var useFetch = true
	if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
		// If the use of XHR should be preferred. Not typically needed.
		useFetch = false
		preferBinary = true
	} else if (opts.mode === 'prefer-streaming') {
		// If streaming is a high priority but binary compatibility and
		// the accuracy of the 'content-type' header aren't
		preferBinary = false
	} else if (opts.mode === 'allow-wrong-content-type') {
		// If streaming is more important than preserving the 'content-type' header
		preferBinary = !capability.overrideMimeType
	} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
		// Use binary if text streaming may corrupt data or the content-type header, or for speed
		preferBinary = true
	} else {
		throw new Error('Invalid value for opts.mode')
	}
	self._mode = decideMode(preferBinary, useFetch)
	self._fetchTimer = null

	self.on('finish', function () {
		self._onFinish()
	})
}

inherits(ClientRequest, stream.Writable)

ClientRequest.prototype.setHeader = function (name, value) {
	var self = this
	var lowerName = name.toLowerCase()
	// This check is not necessary, but it prevents warnings from browsers about setting unsafe
	// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	// http-browserify did it, so I will too.
	if (unsafeHeaders.indexOf(lowerName) !== -1)
		return

	self._headers[lowerName] = {
		name: name,
		value: value
	}
}

ClientRequest.prototype.getHeader = function (name) {
	var header = this._headers[name.toLowerCase()]
	if (header)
		return header.value
	return null
}

ClientRequest.prototype.removeHeader = function (name) {
	var self = this
	delete self._headers[name.toLowerCase()]
}

ClientRequest.prototype._onFinish = function () {
	var self = this

	if (self._destroyed)
		return
	var opts = self._opts

	var headersObj = self._headers
	var body = null
	if (opts.method !== 'GET' && opts.method !== 'HEAD') {
		if (capability.arraybuffer) {
			body = toArrayBuffer(Buffer.concat(self._body))
		} else if (capability.blobConstructor) {
			body = new global.Blob(self._body.map(function (buffer) {
				return toArrayBuffer(buffer)
			}), {
				type: (headersObj['content-type'] || {}).value || ''
			})
		} else {
			// get utf8 string
			body = Buffer.concat(self._body).toString()
		}
	}

	// create flattened list of headers
	var headersList = []
	Object.keys(headersObj).forEach(function (keyName) {
		var name = headersObj[keyName].name
		var value = headersObj[keyName].value
		if (Array.isArray(value)) {
			value.forEach(function (v) {
				headersList.push([name, v])
			})
		} else {
			headersList.push([name, value])
		}
	})

	if (self._mode === 'fetch') {
		var signal = null
		var fetchTimer = null
		if (capability.abortController) {
			var controller = new AbortController()
			signal = controller.signal
			self._fetchAbortController = controller

			if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
				self._fetchTimer = global.setTimeout(function () {
					self.emit('requestTimeout')
					if (self._fetchAbortController)
						self._fetchAbortController.abort()
				}, opts.requestTimeout)
			}
		}

		global.fetch(self._opts.url, {
			method: self._opts.method,
			headers: headersList,
			body: body || undefined,
			mode: 'cors',
			credentials: opts.withCredentials ? 'include' : 'same-origin',
			signal: signal
		}).then(function (response) {
			self._fetchResponse = response
			self._connect()
		}, function (reason) {
			global.clearTimeout(self._fetchTimer)
			if (!self._destroyed)
				self.emit('error', reason)
		})
	} else {
		var xhr = self._xhr = new global.XMLHttpRequest()
		try {
			xhr.open(self._opts.method, self._opts.url, true)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}

		// Can't set responseType on really old browsers
		if ('responseType' in xhr)
			xhr.responseType = self._mode.split(':')[0]

		if ('withCredentials' in xhr)
			xhr.withCredentials = !!opts.withCredentials

		if (self._mode === 'text' && 'overrideMimeType' in xhr)
			xhr.overrideMimeType('text/plain; charset=x-user-defined')

		if ('requestTimeout' in opts) {
			xhr.timeout = opts.requestTimeout
			xhr.ontimeout = function () {
				self.emit('requestTimeout')
			}
		}

		headersList.forEach(function (header) {
			xhr.setRequestHeader(header[0], header[1])
		})

		self._response = null
		xhr.onreadystatechange = function () {
			switch (xhr.readyState) {
				case rStates.LOADING:
				case rStates.DONE:
					self._onXHRProgress()
					break
			}
		}
		// Necessary for streaming in Firefox, since xhr.response is ONLY defined
		// in onprogress, not in onreadystatechange with xhr.readyState = 3
		if (self._mode === 'moz-chunked-arraybuffer') {
			xhr.onprogress = function () {
				self._onXHRProgress()
			}
		}

		xhr.onerror = function () {
			if (self._destroyed)
				return
			self.emit('error', new Error('XHR error'))
		}

		try {
			xhr.send(body)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}
	}
}

/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */
function statusValid (xhr) {
	try {
		var status = xhr.status
		return (status !== null && status !== 0)
	} catch (e) {
		return false
	}
}

ClientRequest.prototype._onXHRProgress = function () {
	var self = this

	if (!statusValid(self._xhr) || self._destroyed)
		return

	if (!self._response)
		self._connect()

	self._response._onXHRProgress()
}

ClientRequest.prototype._connect = function () {
	var self = this

	if (self._destroyed)
		return

	self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._fetchTimer)
	self._response.on('error', function(err) {
		self.emit('error', err)
	})

	self.emit('response', self._response)
}

ClientRequest.prototype._write = function (chunk, encoding, cb) {
	var self = this

	self._body.push(chunk)
	cb()
}

ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
	var self = this
	self._destroyed = true
	global.clearTimeout(self._fetchTimer)
	if (self._response)
		self._response._destroyed = true
	if (self._xhr)
		self._xhr.abort()
	else if (self._fetchAbortController)
		self._fetchAbortController.abort()
}

ClientRequest.prototype.end = function (data, encoding, cb) {
	var self = this
	if (typeof data === 'function') {
		cb = data
		data = undefined
	}

	stream.Writable.prototype.end.call(self, data, encoding, cb)
}

ClientRequest.prototype.flushHeaders = function () {}
ClientRequest.prototype.setTimeout = function () {}
ClientRequest.prototype.setNoDelay = function () {}
ClientRequest.prototype.setSocketKeepAlive = function () {}

// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
	'accept-charset',
	'accept-encoding',
	'access-control-request-headers',
	'access-control-request-method',
	'connection',
	'content-length',
	'cookie',
	'cookie2',
	'date',
	'dnt',
	'expect',
	'host',
	'keep-alive',
	'origin',
	'referer',
	'te',
	'trailer',
	'transfer-encoding',
	'upgrade',
	'via'
]

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(106).Buffer, __webpack_require__(25), __webpack_require__(58)))

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = ((uint8[i] << 16) & 0xFF0000) + ((uint8[i + 1] << 8) & 0xFF00) + (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 699 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 700 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(139).Buffer;
var util = __webpack_require__(702);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25), __webpack_require__(58)))

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(321);

/*<replacement>*/
var util = __webpack_require__(107);
util.inherits = __webpack_require__(63);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(106).Buffer

module.exports = function (buf) {
	// If the buffer is backed by a Uint8Array, a faster version will work
	if (buf instanceof Uint8Array) {
		// If the buffer isn't a subarray, return the underlying ArrayBuffer
		if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
			return buf.buffer
		} else if (typeof buf.buffer.slice === 'function') {
			// Otherwise we need to get a proper copy
			return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength)
		}
	}

	if (Buffer.isBuffer(buf)) {
		// This is the slow version that will work with any Buffer
		// implementation (even in old browsers)
		var arrayCopy = new Uint8Array(buf.length)
		var len = buf.length
		for (var i = 0; i < len; i++) {
			arrayCopy[i] = buf[i]
		}
		return arrayCopy.buffer
	} else {
		throw new Error('Argument must be a Buffer')
	}
}


/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = {
  "100": "Continue",
  "101": "Switching Protocols",
  "102": "Processing",
  "200": "OK",
  "201": "Created",
  "202": "Accepted",
  "203": "Non-Authoritative Information",
  "204": "No Content",
  "205": "Reset Content",
  "206": "Partial Content",
  "207": "Multi-Status",
  "208": "Already Reported",
  "226": "IM Used",
  "300": "Multiple Choices",
  "301": "Moved Permanently",
  "302": "Found",
  "303": "See Other",
  "304": "Not Modified",
  "305": "Use Proxy",
  "307": "Temporary Redirect",
  "308": "Permanent Redirect",
  "400": "Bad Request",
  "401": "Unauthorized",
  "402": "Payment Required",
  "403": "Forbidden",
  "404": "Not Found",
  "405": "Method Not Allowed",
  "406": "Not Acceptable",
  "407": "Proxy Authentication Required",
  "408": "Request Timeout",
  "409": "Conflict",
  "410": "Gone",
  "411": "Length Required",
  "412": "Precondition Failed",
  "413": "Payload Too Large",
  "414": "URI Too Long",
  "415": "Unsupported Media Type",
  "416": "Range Not Satisfiable",
  "417": "Expectation Failed",
  "418": "I'm a teapot",
  "421": "Misdirected Request",
  "422": "Unprocessable Entity",
  "423": "Locked",
  "424": "Failed Dependency",
  "425": "Unordered Collection",
  "426": "Upgrade Required",
  "428": "Precondition Required",
  "429": "Too Many Requests",
  "431": "Request Header Fields Too Large",
  "451": "Unavailable For Legal Reasons",
  "500": "Internal Server Error",
  "501": "Not Implemented",
  "502": "Bad Gateway",
  "503": "Service Unavailable",
  "504": "Gateway Timeout",
  "505": "HTTP Version Not Supported",
  "506": "Variant Also Negotiates",
  "507": "Insufficient Storage",
  "508": "Loop Detected",
  "509": "Bandwidth Limit Exceeded",
  "510": "Not Extended",
  "511": "Network Authentication Required"
}


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(710);
var util = __webpack_require__(711);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(712);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(190)(module), __webpack_require__(25)))

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(713);
exports.encode = exports.stringify = __webpack_require__(714);


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StudentsComponent_Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HomeHeaderComponent_HomeHeader__ = __webpack_require__(108);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var logo_maze=__webpack_require__(50);var logo_kidspeak=__webpack_require__(42);var logo_slashtest=__webpack_require__(51);var logo_wordmark=__webpack_require__(46);var logo_ideasthatwork=__webpack_require__(322);var AboutComponent=function(_Component){_inherits(AboutComponent,_Component);function AboutComponent(props){_classCallCheck(this,AboutComponent);var _this=_possibleConstructorReturn(this,(AboutComponent.__proto__||Object.getPrototypeOf(AboutComponent)).call(this,props));_this.setUser=function(user){_this.props.callback(user);};_this.state={showIntro:false};_this.showIntro=_this.showIntro.bind(_this);_this.hideIntro=_this.hideIntro.bind(_this);_this.handleIntro=_this.handleIntro.bind(_this);return _this;}_createClass(AboutComponent,[{key:'showIntro',value:function showIntro(){this.setState({showIntro:true});}},{key:'hideIntro',value:function hideIntro(){this.setState({showIntro:false});}},{key:'handleIntro',value:function handleIntro(){if(this.state.showIntro){this.hideIntro();}else{this.showIntro();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__HomeHeaderComponent_HomeHeader__["a" /* default */],{currentItem:"About"}),this.state.showIntro?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Login,{callback:this.setUser}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Games,{handleIntro:this.handleIntro}));}}]);return AboutComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Login=function(_Component2){_inherits(Login,_Component2);function Login(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,Login);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=Login.__proto__||Object.getPrototypeOf(Login)).call.apply(_ref,[this].concat(args))),_this2),_this2.setUser=function(user){_this2.props.callback(user);},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(Login,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section bgGreen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'What is Avenue: PM?'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9 aboutDescription'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Progress monitoring was designed for students who are Deaf or Hard of Hearing (DHH) and students with language differences. The software may be used with all students.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Eight tasks track students\u2019 progress from early reading through sixth grade beginning with picture naming, and word recognition to slash, maze, story retell and writing measures. Selected tasks include gaming elements and are designed to include students who communicate using American Sign Language and/or spoken English.'))))));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Description=function(_Component3){_inherits(Description,_Component3);function Description(props){_classCallCheck(this,Description);var _this3=_possibleConstructorReturn(this,(Description.__proto__||Object.getPrototypeOf(Description)).call(this,props));_this3.state={showData:_this3.props.showData};return _this3;}_createClass(Description,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var gradingDescription="";if(this.props.showData===1){gradingDescription='<p>Picture Naming is a task designed for students who are just starting to develop their language skills in ASL or English. The student is shown a randomly selected  illustration and prompted to  say or sign the name of the picture. Teachers have a choice of using picture cards and scoring the student’s response on the computer, or having the student’s response video recorded and scoring later.  Picture naming is an indication that language is increasing weekly! ( For more detailed information, please see the Resources page.) </p>';}else if(this.props.showData===2){gradingDescription='<p>Word SignSay is a task that indicates the  student’s fluency with high frequency English words. The student  is shown a randomly selected isolated word for 3 seconds and prompted to say, sign or Cue the word. The student’s response is recorded and sent to the teacher for scoring. Word SignSign is an indicator of a student’s familiarity with high frequency words.  ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===3){gradingDescription='<p>CopyRight is a measure of a student’s short term recall of ASL.  The student  views a video of randomly selected ASL phrases and is prompted to copy or repeat the ASL story. The student’s signing is recorded and sent to the teacher.  Key items are scored as correct or incorrect. The number of correct items is automatically recorded and graphed. CopyRight is an aid in determining a student’s readiness for working with an interpreter in the classroom as well as comprehension of short ASL stories. ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===4){gradingDescription='<p>SLASH is a task where the student is presented with a block of text, however the text has no spaces! The student reads the passage and marks where the spaces should be to create meaningful words and sentences. The task is automatically graded at the end of each passage giving the student immediate feedback. The student can see the score, goals, and what is needed to unlock new levels. SLASH is a measure a student’s comprehension of language patterns, semantic complexity, and using words in context. ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===5){gradingDescription='<p>Kid Sign/Say is a task developed to identify a student’s skills in comprehension of English text and  translating the main ideas into American Sign Language.  The student views an English text passage displayed on the screen and  is prompted to retell the story is sign language. The student\'s signed story retell is recorded and saved. The student can watch the recording, try again, or submit the recording to the teacher.   AvePM records the scores  and shows the teacher  student’s progress across levels. ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===6){gradingDescription='<p>AvePM KidSpeak is an e-verison of a common progress monitoring indicator-oral reading fluency and comprehension. Students see a text-based passage on the screen and are asked to read it aloud.  The recording is saved and sent to the teacher/teacher’s aid to score. Scoring is easy, quick and AvePM collects the results and graphs them for the teacher. Students can use KidSpeak independently. ( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===7){gradingDescription='<p>AvePM MAZE is an e-version of a common progress monitoring maze task.  The  student has one minute to read a story where every 7th word is deleted.  Each deleted word is replaced with  a multiple choice of 3 words. The student selects the word that best completes the story. The task is automatically scored and graphed.  Students, teachers and parents can see  progress weekly or monthly throughout the school year. The data can be used to identify the present level of performance and set IEP goals.( For more detailed information, please see the Resources page.)</p>';}else if(this.props.showData===8){gradingDescription='<p>AvePM’s WordMark can be used to monitor a student’s progress in writing. Students are given a randomly selected story prompt  and  one minute to think about the topic and three minutes to type the story. The story is saved and sent to the teacher for scoring. Scoring is based on CBM rules: number of words written, number of correct word sequences, and number of incorrect word sequences. The scores are graphed and the student and teacher can monitor progress. ( For more detailed information, please see the Resources page.) </p>';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"aboutDescription",dangerouslySetInnerHTML:{__html:gradingDescription}});}}]);return Description;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Games=function(_Component4){_inherits(Games,_Component4);function Games(props){_classCallCheck(this,Games);var _this4=_possibleConstructorReturn(this,(Games.__proto__||Object.getPrototypeOf(Games)).call(this,props));_this4.state={showData:1,showMore:false,showMoreText:'More Info'};return _this4;}_createClass(Games,[{key:'componentDidMount',value:function componentDidMount(){this.handleSelect(1);}},{key:'handleShowMore',value:function handleShowMore(){if(this.state.showMore){this.setState({showMore:false});this.setState({showMoreText:'More Info'});}else{this.setState({showMore:true});this.setState({showMoreText:'Less Info'});}}},{key:'handleSelect',value:function handleSelect(tabNum){this.setState({showData:tabNum});this.setState({showMore:false});this.setState({showMoreText:'More Info'});}},{key:'render',value:function render(){var _this5=this;var items=null;var gradingTitle=void 0,videoURL=void 0;if(this.state.showData===1){gradingTitle="Picture Naming";videoURL="PN+intro.mp4";}else if(this.state.showData===2){gradingTitle="Word Sign/Sign";videoURL="WSS+intro.mp4";}else if(this.state.showData===3){gradingTitle="CopyRight";videoURL="CopyRight+intro.mp4";}else if(this.state.showData===4){gradingTitle="Slash";videoURL="Slash+intro.mp4";}else if(this.state.showData===5){gradingTitle="Kid Sign/Say";videoURL="KidSign+intro.mp4";}else if(this.state.showData===6){gradingTitle="KidSpeak";videoURL="KidSpeak+intro.mp4";}else if(this.state.showData===7){gradingTitle="MAZE";videoURL="Maze+intro.mp4";}else if(this.state.showData===8){gradingTitle="Word Mark";videoURL="WordMark+intro.mp4";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section bgYellow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn',onClick:this.props.handleIntro},' What is AvenuePM')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'The Apps'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(Click on each app icon to learn more about them)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav nav-pills pill'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.showData===1?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this5.handleSelect(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_images_app_picturenaming_png___default.a,alt:'Picture Naming',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.showData===2?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this5.handleSelect(2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_app_wordsignsay_png___default.a,alt:'Word Sign/Say',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.showData===3?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this5.handleSelect(3);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_app_copyright_png___default.a,alt:'Copy Right',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.showData===4?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this5.handleSelect(4);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logo_slashtest,alt:'Slash',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.showData===5?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this5.handleSelect(5);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_app_kidsignsay_png___default.a,alt:'KidSign',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.showData===6?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this5.handleSelect(6);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logo_kidspeak,alt:'Kid Speak',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.showData===7?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this5.handleSelect(7);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logo_maze,alt:'MAZE',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:this.state.showData===8?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:function onClick(e){return _this5.handleSelect(8);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logo_wordmark,alt:'Word Mark',border:'0'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tab_maze',className:'tab-pane fade in active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow-down arrowYellow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{fontSize:30}},gradingTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StudentsComponent_Common__["g" /* VideoComponent */],{url:"https://s3.us-east-2.amazonaws.com/uploadbeta/video/intro/"+videoURL,appName:"intro",play:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(e){return _this5.handleShowMore();},name:'Login',className:'btn btn-primary btn-block',style:{textAlign:'center'}},this.state.showMoreText),this.state.showMore?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Description,{showData:this.state.showData}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'bgGrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'left'}},'This website was developed by the avenuePM team pursuant to Cooperative Agreement CFDA H327S170012 with the Office of Special Education Programs, United States Department of Education, Project Officer name, Project Officer. The opinions expressed and materials contained herein do not necessarily reflect the position or policy of the United States Department of Education and you should not assume endorsement by the Federal Government.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xA9',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',null,'new Date().getFullYear() > 2010 && document.write(new Date().getFullYear());'),' Designed and developed by researchers at the University of Minnesota and Penn State University.(v.3.0.32)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logo_ideasthatwork,alt:'Ideas That Work. U.S. Office of Special Education Programs',border:'0'}))))));}}]);return Games;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AboutComponent);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TeachersComponent_actions__ = __webpack_require__(27);
var _this3=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainComponent=function(_Component){_inherits(MainComponent,_Component);function MainComponent(props){_classCallCheck(this,MainComponent);return _possibleConstructorReturn(this,(MainComponent.__proto__||Object.getPrototypeOf(MainComponent)).call(this,props));}_createClass(MainComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var parsed,token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:parsed=__WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(this.props.location.search);if(!(parsed.emailGUID&&parsed.emailGUID!=="")){_context.next=13;break;}localStorage.removeItem('token');localStorage.clear();_context.next=6;return this.props.persistor.purge();case 6:_context.next=8;return this.props.userLogout();case 8:_context.next=10;return localStorage.setItem('emailGUID',parsed.emailGUID);case 10:this.props.history.push("/");_context.next=17;break;case 13:token=localStorage.getItem('token');if(!token){_context.next=17;break;}_context.next=17;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].authWithToken().then(function(response){if(response.success){_this2.props.userCallback(response.body);_this2.props.history.push('/'+response.body.role);}else{_this2.props.history.push('/login');}},function(error){alert(error);_this2.props.history.push('/login');});case 17:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var token=localStorage.getItem('token');if(!token){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Redirect */],{to:'/login'});}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Loading...');}}}]);return MainComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{userLogout:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__TeachersComponent_actions__["j" /* userLogout */])());case 2:return _context2.abrupt('return',_context2.sent);case 3:case'end':return _context2.stop();}}},_callee2,_this3);}));function userLogout(){return _ref2.apply(this,arguments);}return userLogout;}()};};var mapStateToProps=function mapStateToProps(state){return{lastClass:state.teacherReducer.lastClass,lastStudent:state.teacherReducer.student};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(MainComponent)));

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClassNavigation */
/* unused harmony export ClassListComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_ico_view_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_ico_view_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_ico_view_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_ico_plus_green_png__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_ico_plus_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_ico_plus_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_modal_x_red_png__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_modal_x_red_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_modal_x_red_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_How_to_select_apps_png__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_How_to_select_apps_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_How_to_select_apps_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalFormComponents_EmailConsentForm__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_ico_view_1_png__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_ico_view_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_images_ico_view_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_App_Selection_Graphic_png__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_App_Selection_Graphic_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_images_App_Selection_Graphic_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_info_icon_2f_png__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_info_icon_2f_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_images_info_icon_2f_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_images_logo_kidspeak_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_images_logo_kidspeak_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_images_logo_kidspeak_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_images_logo_maze_png__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_images_logo_maze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_images_logo_maze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_images_logo_wordmark_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_images_logo_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_images_logo_wordmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_images_logo_slashtest_png__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_images_logo_slashtest_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_images_logo_slashtest_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_to_print__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_to_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_react_to_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ComponentToPrint__ = __webpack_require__(347);
var _this38=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'80%'}};var tooltipReadingLevel=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Tooltip */],{id:'tooltipReadingLevel'},'Estimate Reading Grade Level. Add the reading grade versus placement grade.');var tooltipDisability=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Tooltip */],{id:'tooltipDisability'},'Multiple Select Option');var tooltipSelectClass=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Tooltip */],{id:'tooltipDisability'},'Select a class to view students');var popoverAddClass=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["f" /* Popover */],{id:'popover-positioned-top',title:'Step 1'},'Add a Class');var popoverAddStudent=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["f" /* Popover */],{id:'popover-positioned-top',title:'Step 2'},'Add a Student(s)');var addClassStorage=localStorage.getItem('addClass');var addStudentStorage=localStorage.getItem('addStudent');var notice1Storage=localStorage.getItem('notice1');var notice2Storage=localStorage.getItem('notice2');var notice3Storage=localStorage.getItem('notice3');var addClassInstruction=null;var addStudentInstruction=null;var PNInstruction=null;var WSSInstruction=null;var CopyrightInstruction=null;var KidsignInstruction=null;var KidspeakInstruction=null;var readingLevelOptions=[{value:'0',label:'0'},{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'},{value:'4',label:'4'},{value:'5',label:'5'},{value:'6',label:'6'}];var genderOptions=[{value:'1',label:'Female'},{value:'2',label:'Male'},{value:'3',label:'Other'}];var languageOptions=[{value:'1',label:'ASL'},{value:'2',label:'Signed English'},{value:'3',label:'Spoken English'},{value:'5',label:'Sim-com'},{value:'4',label:'Other'}];var disabilityOptions=[{value:'1',label:'None'},{value:'2',label:'Deaf'},{value:'3',label:'Hard of Hearing'},{value:'4',label:'Blind / Visually impaired'},{value:'5',label:'Learning Disability'},{value:'6',label:'Behavior Challenges'},{value:'7',label:'Developmental Challenges'},{value:'8',label:'Physical Challenges'}];var placementOptions=[{value:'1',label:'General Ed'},{value:'2',label:'Special Classroom'},{value:'3',label:'Resource Room'},{value:'4',label:'School for the Deaf'}];var gradeOptions=[{value:'0',label:'K'},{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'},{value:'4',label:'4'},{value:'5',label:'5'},{value:'6',label:'6'},{value:'7',label:'7'},{value:'8',label:'8'},{value:'9',label:'9'},{value:'10',label:'10'},{value:'11',label:'11'},{value:'12',label:'12'},{value:'Transition',label:'Transition'},{value:'College',label:'College'}];var fourValueOptions=[{value:'0',label:'No'},{value:'1',label:'Yes'},{value:'2',label:'Unknown'}];var appOptions=[{value:'picturenaming',label:'PictureNaming',isSelected:true},{value:'wordsignsay',label:'WordSign/Say',isSelected:true},{value:'copyright',label:'CopyRight',isSelected:true},{value:'slash',label:'Slash',isSelected:true},{value:'kidspeak',label:'KidSpeak',isSelected:true},{value:'maze',label:'Maze',isSelected:true},{value:'kidsign',label:'KidSign/Say',isSelected:true},{value:'wordmark',label:'WordMark',isSelected:true}];var getValue=function getValue(opts,val){return opts.find(function(o){return o.value===val;});};var getChecked=function getChecked(checkList,studentId){var student=checkList.find(function(o){return o.studentId===studentId;});if(student){return student.checked;}else{return null;}};var getFourValue=function getFourValue(opts,val){if(val==='-1')return null;else opts.find(function(o){return o.value===val;});};var resultMultipleValues=[];var newVersion=void 0;var MainTeacherComponent=function(_Component){_inherits(MainTeacherComponent,_Component);function MainTeacherComponent(props){var _this2=this;_classCallCheck(this,MainTeacherComponent);var _this=_possibleConstructorReturn(this,(MainTeacherComponent.__proto__||Object.getPrototypeOf(MainTeacherComponent)).call(this,props));_this.handleCancel=function(){_this.setState({showClass:false,addClass:false,showStudent:false,newStudent:false});_this.props.selectClass(null);_this.props.updateStudent(null);};_this.handleNewClassCallback=function(classObject){var classes=_this.state.classes;classes.push(classObject);_this.setState({classes:classes});_this.handleClassItemClick(classes[classes.length-1]);_this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].TEACHER_ADDED_CLASS,metadata:{classId:classObject.id,className:classObject.name}}},function(){return _this.handleAnalytics();});};_this.handleClassItemClick=function(object){_this.handleCancel();__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listStudents(object.id).then(function(response){if(response.success){var res=response.body;_this.setState({showClass:true,classStudents:res,class:object,newStudent:false,showNotice:false,showStudent:false,clickedClassId:object.id});_this.props.selectClass(object);_this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].TEACHER_SELECT_CLASS,metadata:{classId:object.id,className:object.name}}},function(){return _this.handleAnalytics();});}else{_this.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this.setState({modalDialog:false});},3500);}},function(error){console.log('Error',error.msg);});};_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].logout().then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!response.success){_context.next=14;break;}_this.props.callback({});if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_context.next=9;return _this.props.persistor.purge();case 9:_context.next=11;return _this.props.userLogout();case 11:_this.props.history.push("/");_context.next=16;break;case 14:_this.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 16:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}(),function(error){_this.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this.setState({modalDialog:false});},3500);});};_this.handleUpdateClass=function(object){_this.handleCancel();_this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].TEACHER_UPDATED_CLASS,metadata:{classId:object.id,className:object.name}}},function(){return _this.handleAnalytics();});_this.setState({classes:[]});_this.listClasses();};_this.handleStudentClick=function(student,classId){_this.props.handleStudentClick(student,classId);_this.props.updateStudent(student);_this.props.history.push('/teacher/student');};_this.handleAddStudent=function(classId){_this.setState({newStudent:true,showNotice:false,addClass:false,showClass:false});};_this.state={classes:[],class:{},classStudents:[],student:{},addClass:false,showClass:false,showStudent:false,newStudent:false,clickedClassId:-1,modalDialog:false,responseContent:'',showAddClassHint:true,showNotice:true,showNotice1:true,showNotice2:true,showNotice3:false,showNotice4:true,versionConflict:false,analytics:{type:null,metadata:null}};_this.handleAddClass=_this.handleAddClass.bind(_this);_this.handleClassItemClick=_this.handleClassItemClick.bind(_this);_this.handleDeleteStudent=_this.handleDeleteStudent.bind(_this);_this.handleDeleteClass=_this.handleDeleteClass.bind(_this);_this.handleToggleAddClassHint=_this.handleToggleAddClassHint.bind(_this);_this.getTarget=_this.getTarget.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);_this.handleCloseNotice1=_this.handleCloseNotice1.bind(_this);_this.handleCloseNotice2=_this.handleCloseNotice2.bind(_this);_this.handleCloseNotice3=_this.handleCloseNotice3.bind(_this);_this.handleCloseNotice4=_this.handleCloseNotice4.bind(_this);_this.handleShowAllNotice=_this.handleShowAllNotice.bind(_this);_this.handleShowNotice1=_this.handleShowNotice1.bind(_this);_this.handleShowNotice2=_this.handleShowNotice2.bind(_this);_this.handleShowNotice3=_this.handleShowNotice3.bind(_this);_this.handleShowNotice4=_this.handleShowNotice4.bind(_this);return _this;}_createClass(MainTeacherComponent,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:__WEBPACK_IMPORTED_MODULE_14__Shared_Helpers__["a" /* default */].authorize(this);this.listClasses();_context3.next=4;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].getVersion().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:newVersion=response.body;if(!(newVersion!==__WEBPACK_IMPORTED_MODULE_21__Shared_Consts__["d" /* VERSION */])){_context2.next=4;break;}_context2.next=4;return _this3.setState({showNotice3:true,versionConflict:true});case 4:;case 5:case'end':return _context2.stop();}}},_callee2,_this3);}));return function(_x2){return _ref3.apply(this,arguments);};}());case 4:if(localStorage.getItem('addClass')==='hide'){this.setState({showAddClassHint:false});}if(localStorage.getItem('notice1')==='hide'){this.setState({showNotice1:false});}if(localStorage.getItem('notice2')==='hide'){this.setState({showNotice2:false});}if(!this.state.versionConflict&localStorage.getItem('notice3')==='hide'){this.setState({showNotice3:false});}if(this.props.lastClass){this.handleClassItemClick(this.props.lastClass);if(this.props.lastStudent){this.handleStudentClick(this.props.lastStudent,this.props.lastClass.id);}}case 9:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleCloseNotice1',value:function handleCloseNotice1(){this.setState({showNotice1:false});localStorage.setItem('notice1','hide');}},{key:'handleCloseNotice2',value:function handleCloseNotice2(){this.setState({showNotice2:false});localStorage.setItem('notice2','hide');}},{key:'handleCloseNotice3',value:function handleCloseNotice3(){this.setState({showNotice3:false});localStorage.setItem('notice3','hide');}},{key:'handleCloseNotice4',value:function handleCloseNotice4(){this.setState({showNotice4:false});localStorage.setItem('notice4','hide');}},{key:'handleShowAllNotice',value:function handleShowAllNotice(){if(this.state.versionConflict){this.setState({showNotice1:true,showNotice2:true,showNotice3:true,showNotice4:true});localStorage.setItem('notice1','show');localStorage.setItem('notice2','show');localStorage.setItem('notice3','show');localStorage.setItem('notice4','show');}else{this.setState({showNotice1:true,showNotice2:true,showNotice3:false,showNotice4:true});localStorage.setItem('notice1','show');localStorage.setItem('notice2','show');localStorage.setItem('notice3','hide');localStorage.setItem('notice4','show');}}},{key:'handleShowNotice1',value:function handleShowNotice1(){this.setState({showNotice1:true});localStorage.setItem('notice1','show');}},{key:'handleShowNotice2',value:function handleShowNotice2(){this.setState({showNotice2:true});localStorage.setItem('notice2','show');}},{key:'handleShowNotice3',value:function handleShowNotice3(){this.setState({showNotice3:true});localStorage.setItem('notice3','show');}},{key:'handleShowNotice4',value:function handleShowNotice4(){this.setState({showNotice4:true});localStorage.setItem('notice4','show');}},{key:'handleToggleAddClassHint',value:function handleToggleAddClassHint(){this.setState({showAddClassHint:false});}},{key:'getTarget',value:function getTarget(){return __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this.target);}},{key:'handleAddClass',value:function handleAddClass(){this.setState({showClass:false,showNotice:false,addClass:!this.state.addClass,showStudent:false,newStudent:false});this.handleToggleAddClassHint();localStorage.setItem('addClass','hide');}},{key:'handleDeleteStudent',value:function handleDeleteStudent(student){var _this4=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].deleteStudent(student.userId,this.props.lastClass.id).then(function(res){_this4.handleClassItemClick(_this4.props.lastClass);_this4.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].TEACHER_STUDENT_DELETE,metadata:{userId:student.user.id,firstName:student.user.firstname,lastName:student.user.lastname}}},function(){return _this4.handleAnalytics();});});}},{key:'handleDeleteClass',value:function handleDeleteClass(theclass){var _this5=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].deleteClass(theclass.id).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this5.handleCancel();case 2:_context4.next=4;return _this5.listClasses();case 4:case'end':return _context4.stop();}}},_callee4,_this5);}));return function(_x3){return _ref4.apply(this,arguments);};}());}},{key:'listClasses',value:function listClasses(){var _this6=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].classList().then(function(response){if(response.success){_this6.setState({classes:response.body});}else{_this6.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this6.setState({modalDialog:false});},3500);}},function(error){_this6.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this6.setState({modalDialog:false});},3500);});}},{key:'handleSurveyBack',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:case'end':return _context5.stop();}}},_callee5,this);}));function handleSurveyBack(){return _ref5.apply(this,arguments);}return handleSurveyBack;}()},{key:'render',value:function render(){var _this7=this;var sharedProps={container:this,target:this.getTarget,show:this.state.showAddClassHint};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_Header__["a" /* default */],{logout:this.handleLogout,teacherId:this.props.teacher&&this.props.teacher.id?this.props.teacher.id:null,notifications:true,bugReport:true,studentClick:this.handleStudentClick}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this7.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:'Homepage',userId:this.props.teacher&&this.props.teacher.id?this.props.teacher.id:null,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-10'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'fl'},'My Classes')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{ref:function ref(button){_this7.target=button;},className:'fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_ico_plus_green_png___default.a,onClick:this.handleAddClass,alt:'Add a Class',border:'0',className:'ico-xs ico-add'})),addClassStorage!=='hide'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["d" /* Overlay */],Object.assign({},sharedProps,{placement:'top'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["f" /* Popover */],{id:'popover-positioned-top',title:'Step 1'},'Add a Class')):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder noPadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClassListComponent,{classes:this.state.classes,handleItemClick:this.handleClassItemClick,clickedClassID:this.state.clickedClassId,deleteClass:this.handleDeleteClass}))),this.state.addClass?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-9 container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Add Class'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AddClassComponent,{edit:false,cancelCallback:this.handleCancel,saveClassCallback:this.handleNewClassCallback})):null,this.state.showClass?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClassNavigation,{'class':this.state.class,students:this.state.classStudents,handleAddStudent:this.handleAddStudent,studentClick:this.handleStudentClick,updateClassCallback:this.handleUpdateClass,deleteStudent:this.handleDeleteStudent}):null,this.state.showNotice?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'popover-positioned-bottom',className:'col-md-9 container navbar-container',title:'Notice'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Notice'),this.state.showNotice1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"showNotice"},'\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"showNotice",onClick:this.handleShowAllNotice},'[show all]')),this.state.showNotice2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeBox",style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeTitle"},'WordMark2'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeClose",onClick:this.handleCloseNotice2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:"noticeCloseIcon",src:__WEBPACK_IMPORTED_MODULE_12__assets_images_modal_x_red_png___default.a,alt:"Close"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeContent"},'Have your students tried WordMark2? We have created a new version of WordMark that we think your students will love. They will find it in their list of apps that appear when they logon.')):null,this.state.showNotice4?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeBox",style:{marginTop:135}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeTitle"},'Sharing and transferring students has been moved '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeClose",onClick:this.handleCloseNotice4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:"noticeCloseIcon",src:__WEBPACK_IMPORTED_MODULE_12__assets_images_modal_x_red_png___default.a,alt:"Close"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeContent"},'We\'ve moved the SHARE/ TRANSFER student feature. When you select your class, notice the SHARE/ TRANSFER tab at the top of the screen and follow the instructions.')):null,this.state.showNotice1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeBox",style:{marginTop:260}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeTitle"},'Parent Feature'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeClose",onClick:this.handleCloseNotice1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:"noticeCloseIcon",src:__WEBPACK_IMPORTED_MODULE_12__assets_images_modal_x_red_png___default.a,alt:"Close"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeContent"},'To add a parent account, enter a parent\'s email address in the Student Details page. The parent will receive account information and access to their student\'s data charts (but not the teacher notes). Look in the Resources tab on the login page for more details.')):null,this.state.showNotice3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeBox",style:{marginTop:405}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeTitle"},'Version Conflict '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeClose",onClick:this.handleCloseNotice3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:"noticeCloseIcon",src:__WEBPACK_IMPORTED_MODULE_12__assets_images_modal_x_red_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"noticeContent"},'The current version of the website on your computer (v.',__WEBPACK_IMPORTED_MODULE_21__Shared_Consts__["d" /* VERSION */],') is behind the newest version (v.',newVersion,'). Please clean your browser cache and refresh the page.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'* If you are using Chrome (Mac), please click on the \'Chrome\' menu and select \'Clean Browsing Data\'. Then click on the \'Clear Data\' button.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'* If you are using FireFox (Mac), please click on the \'History\'. Choose the select box \'time range to clear\' as \'Everything\' and then click on \'OK\'.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))):null):null,this.state.newStudent?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AddStudent,{'class':this.state.class,classId:this.state.class.id,handleCancel:this.handleCancel,handleClassItemClick:this.handleClassItemClick}):null))),this.props.teacher&&!this.props.teacher.teacher.consent?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ModalFormComponents_EmailConsentForm__["a" /* default */],{updateTeacher:this.props.updateTeacher,teacher:this.props.teacher}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Shared_Footer__["a" /* default */],null));}}]);return MainTeacherComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ClassNavigation=function(_Component2){_inherits(ClassNavigation,_Component2);function ClassNavigation(props){_classCallCheck(this,ClassNavigation);var _this8=_possibleConstructorReturn(this,(ClassNavigation.__proto__||Object.getPrototypeOf(ClassNavigation)).call(this,props));_this8.handleStudentClick=function(student,classId){_this8.props.studentClick(student,classId);};_this8.handleAddStudent=function(){_this8.props.handleAddStudent(_this8.state.class.id);};_this8.handleCancel=function(){_this8.setState({listStudents:true,listMultipleStudents:false});};_this8.handleUpdateClass=function(object){_this8.props.updateClassCallback(object);};_this8.state={class:_this8.props.class,listStudents:true,listMultipleStudents:false};_this8.handleStudentsTab=_this8.handleStudentsTab.bind(_this8);_this8.handleMultipleStudentsTab=_this8.handleMultipleStudentsTab.bind(_this8);_this8.handleClassTab=_this8.handleClassTab.bind(_this8);return _this8;}_createClass(ClassNavigation,[{key:'handleStudentsTab',value:function handleStudentsTab(event){this.setState({listStudents:true,listMultipleStudents:false});event.preventDefault();}},{key:'handleMultipleStudentsTab',value:function handleMultipleStudentsTab(event){this.setState({listStudents:false,listMultipleStudents:true});event.preventDefault();}},{key:'handleClassTab',value:function handleClassTab(event){this.setState({listStudents:false,listMultipleStudents:false});// event.preventDefault();
}},{key:'listStudents',value:function listStudents(){var _this9=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listStudents(this.props.class.id).then(function(response){if(response.success){_this9.setState({students:response.body});}else{_this9.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this9.setState({modalDialog:false});},3500);}},function(error){console.log('List students error',error);_this9.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this9.setState({modalDialog:false});},3500);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-9'},this.state.listStudents?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Students,{handleClassTab:this.handleClassTab,handleMultipleStudentsTab:this.handleMultipleStudentsTab,classId:this.state.class.id,handleAddStudent:this.handleAddStudent,students:this.props.students,handleItemClick:this.handleStudentClick,deleteStudent:this.props.deleteStudent}):this.state.listMultipleStudents?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MultipleStudents,{handleStudentsTab:this.handleStudentsTab,handleClassTab:this.handleClassTab,classId:this.state.class.id,handleAddStudent:this.handleAddStudent,students:this.props.students,handleItemClick:this.handleStudentClick,deleteStudent:this.props.deleteStudent}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav nav-tabs'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Students')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'active',onClick:this.handleClassTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Class Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleMultipleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Share/Transfer Students'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AddClassComponent,{edit:true,'class':this.state.class,cancelCallback:this.handleCancel,saveClassCallback:this.handleUpdateClass}))));}}]);return ClassNavigation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var AddStudentComponent=function(_Component3){_inherits(AddStudentComponent,_Component3);function AddStudentComponent(props){_classCallCheck(this,AddStudentComponent);var _this10=_possibleConstructorReturn(this,(AddStudentComponent.__proto__||Object.getPrototypeOf(AddStudentComponent)).call(this,props));_this10.state={firstname:'',lastname:'',email:null,gender:null,language:null,disability:null,placement:null,gradeLevel:null,specialNeedsData:'-1',freeLunch:'-1',ell:'-1',title1:'-1',research:true,screeningLevel:null,firstNameError:'',lastNameError:'',readingLevelError:'',genderError:'',languageError:'',disabilityError:'',placementError:'',gradeError:'',emailWarning:'',errorEmail:'',errorNote:'',apps:"picturenaming,wordsignsay,copyright,slash,kidsign,kidspeak,maze,wordmark",excludeVid:false,multipleValues:[],showAppIntro:false};_this10.handleName=_this10.handleName.bind(_this10);_this10.handleLastName=_this10.handleLastName.bind(_this10);_this10.handleEmail=_this10.handleEmail.bind(_this10);_this10.handleReadingLevel=_this10.handleReadingLevel.bind(_this10);_this10.handleGender=_this10.handleGender.bind(_this10);_this10.handleLanguage=_this10.handleLanguage.bind(_this10);_this10.handleFreeLunch=_this10.handleFreeLunch.bind(_this10);_this10.handleELL=_this10.handleELL.bind(_this10);_this10.handlePlacement=_this10.handlePlacement.bind(_this10);_this10.handleSpecialEd=_this10.handleSpecialEd.bind(_this10);_this10.handleGrade=_this10.handleGrade.bind(_this10);_this10.handleTitle1=_this10.handleTitle1.bind(_this10);_this10.handleResearch=_this10.handleResearch.bind(_this10);_this10.handleDisability=_this10.handleDisability.bind(_this10);// this.handleAppChange = this.handleAppChange.bind(this);
_this10.handleExcludeVid=_this10.handleExcludeVid.bind(_this10);_this10.handleSave=_this10.handleSave.bind(_this10);_this10.handleCancel=_this10.handleCancel.bind(_this10);_this10.handleAnalytics=_this10.handleAnalytics.bind(_this10);_this10.handleAppIntroduction=_this10.handleAppIntroduction.bind(_this10);_this10.closeAppIntro=_this10.closeAppIntro.bind(_this10);return _this10;}_createClass(AddStudentComponent,[{key:'componentDidMount',value:function componentDidMount(){this.setState({multipleValues:appOptions});}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'getMultipleValues',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(values){var valueArray,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:this.setState({multipleValues:[]});valueArray=values.split(',');i=0;case 3:if(!(i<valueArray.length)){_context6.next=9;break;}_context6.next=6;return this.state.multipleValues.push(getValue(appOptions,valueArray[i]));case 6:i++;_context6.next=3;break;case 9:return _context6.abrupt('return',false);case 10:case'end':return _context6.stop();}}},_callee6,this);}));function getMultipleValues(_x4){return _ref6.apply(this,arguments);}return getMultipleValues;}()},{key:'handleName',value:function handleName(event){this.setState({firstname:event.target.value.trim()});}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastname:event.target.value.trim()});}},{key:'handleEmail',value:function handleEmail(event){this.setState({email:event.target.value});if(event.target.value.length===0){this.setState({email:null,errorEmail:'',emailWarning:''});}else{if(!this.validateEmail(event.target.value)){this.setState({errorEmail:'validationRed',emailWarning:'Email address format is invalid'});}else{this.setState({email:event.target.value,emailWarning:'',errorEmail:''});}}}},{key:'handleReadingLevel',value:function handleReadingLevel(event){this.setState({screeningLevel:event.value});}},{key:'handleLanguage',value:function handleLanguage(event){this.setState({language:event.value});}},{key:'handleDisability',value:function handleDisability(event){var options=event;var value=[];if(options.length===0){disabilityOptions=[{value:'1',label:'None'},{value:'2',label:'Deaf'},{value:'3',label:'Hard of Hearing'},{value:'4',label:'Blind / Visually impaired'},{value:'5',label:'Learning Disability'},{value:'6',label:'Behavior Challenges'},{value:'7',label:'Developmental Challenges'},{value:'8',label:'Physical Challenges'}];}for(var i=0,l=options.length;i<l;i++){if(options[i].value==1){disabilityOptions=[{value:'1',label:'None'}];value=[];value.push(1);}else{disabilityOptions=[{value:'2',label:'Deaf'},{value:'3',label:'Hard of Hearing'},{value:'4',label:'Blind / Visually impaired'},{value:'5',label:'Learning Disability'},{value:'6',label:'Behavior Challenges'},{value:'7',label:'Developmental Challenges'},{value:'8',label:'Physical Challenges'}];value.push(options[i].value);}}this.setState({disability:value.join(",")});}},{key:'handleExcludeVid',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(event){var values,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,opt,_values,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,_opt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:this.setState({excludeVid:event.target.checked});if(!event.target.checked){_context7.next=29;break;}appOptions=[{value:'slash',label:'Slash',isSelected:true},{value:'kidspeak',label:'KidSpeak',isSelected:true},{value:'maze',label:'Maze',isSelected:true},{value:'wordmark',label:'WordMark',isSelected:true}];values=[];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context7.prev=7;for(_iterator=appOptions[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){opt=_step.value;values.push(opt.value);}_context7.next=15;break;case 11:_context7.prev=11;_context7.t0=_context7['catch'](7);_didIteratorError=true;_iteratorError=_context7.t0;case 15:_context7.prev=15;_context7.prev=16;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 18:_context7.prev=18;if(!_didIteratorError){_context7.next=21;break;}throw _iteratorError;case 21:return _context7.finish(18);case 22:return _context7.finish(15);case 23:_context7.next=25;return this.setState({apps:values.join(",")});case 25:_context7.next=27;return this.handleAppChange(appOptions);case 27:_context7.next=54;break;case 29:appOptions=[{value:'picturenaming',label:'PictureNaming',isSelected:true},{value:'wordsignsay',label:'WordSign/Say',isSelected:true},{value:'copyright',label:'CopyRight',isSelected:true},{value:'slash',label:'Slash',isSelected:true},{value:'kidspeak',label:'KidSpeak',isSelected:true},{value:'maze',label:'Maze',isSelected:true},{value:'kidsign',label:'KidSign',isSelected:true},{value:'wordmark',label:'WordMark',isSelected:true}];_values=[];_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context7.prev=34;for(_iterator2=appOptions[Symbol.iterator]();!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){_opt=_step2.value;_values.push(_opt.value);}_context7.next=42;break;case 38:_context7.prev=38;_context7.t1=_context7['catch'](34);_didIteratorError2=true;_iteratorError2=_context7.t1;case 42:_context7.prev=42;_context7.prev=43;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 45:_context7.prev=45;if(!_didIteratorError2){_context7.next=48;break;}throw _iteratorError2;case 48:return _context7.finish(45);case 49:return _context7.finish(42);case 50:_context7.next=52;return this.setState({apps:_values.join(",")});case 52:_context7.next=54;return this.handleAppChange(appOptions);case 54:case'end':return _context7.stop();}}},_callee7,this,[[7,11,15,23],[16,,18,22],[34,38,42,50],[43,,45,49]]);}));function handleExcludeVid(_x5){return _ref7.apply(this,arguments);}return handleExcludeVid;}()},{key:'handleAppChange',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(value){var values,_iteratorNormalCompletion3,_didIteratorError3,_iteratorError3,_iterator3,_step3,opt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:values=[];_iteratorNormalCompletion3=true;_didIteratorError3=false;_iteratorError3=undefined;_context8.prev=4;for(_iterator3=value[Symbol.iterator]();!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){opt=_step3.value;values.push(opt.value);}_context8.next=12;break;case 8:_context8.prev=8;_context8.t0=_context8['catch'](4);_didIteratorError3=true;_iteratorError3=_context8.t0;case 12:_context8.prev=12;_context8.prev=13;if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}case 15:_context8.prev=15;if(!_didIteratorError3){_context8.next=18;break;}throw _iteratorError3;case 18:return _context8.finish(15);case 19:return _context8.finish(12);case 20:_context8.next=22;return this.setState({apps:values.join(","),multipleValues:value});case 22:case'end':return _context8.stop();}}},_callee8,this,[[4,8,12,20],[13,,15,19]]);}));function handleAppChange(_x6){return _ref8.apply(this,arguments);}return handleAppChange;}()},{key:'handleGender',value:function handleGender(event){this.setState({gender:event.value});}},{key:'handleGrade',value:function handleGrade(event){this.setState({gradeLevel:event.value});}},{key:'handlePlacement',value:function handlePlacement(event){this.setState({placement:event.value});}},{key:'validateEmail',value:function validateEmail(email){var re=/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;return re.test(email);}},{key:'validate',value:function validate(){var valid=true;if(this.state.firstname===''){valid=false;this.setState({firstNameError:'firstNameError'});}else{this.setState({firstNameError:''});}if(this.state.lastname.length===0){valid=false;this.setState({lastNameError:'lastNameError'});}else{this.setState({lastNameError:''});}if(!this.state.email||this.state.email===''){this.setState({email:null,errorEmail:'',emailWarning:''});}else{if(!this.validateEmail(this.state.email)){this.setState({errorEmail:'validationRed',emailWarning:'Email address format is invalid'});valid=false;}else{this.setState({emailWarning:'',errorEmail:''});}}if(this.state.screeningLevel===null){valid=false;this.setState({readingLevelError:'readingLevelError'});}else{this.setState({readingLevelError:''});}if(this.state.gender===null){valid=false;this.setState({genderError:'genderError'});}else{this.setState({genderError:''});}if(this.state.language===null){valid=false;this.setState({languageError:'languageError'});}else{this.setState({languageError:''});}if(this.state.disability===null||this.state.disability.length===0){valid=false;this.setState({disabilityError:'disabilityError'});}else{this.setState({disabilityError:''});}if(this.state.placement===null){valid=false;this.setState({placementError:'placementError'});}else{this.setState({placementError:''});}if(this.state.gradeLevel===null){valid=false;this.setState({gradeError:'gradeError'});}else{this.setState({gradeError:''});}return valid;}},{key:'handleELL',value:function handleELL(event){this.setState({ell:event===null?'-1':event.value});}},{key:'handleFreeLunch',value:function handleFreeLunch(event){this.setState({freeLunch:event===null?'-1':event.value});}},{key:'handleSpecialEd',value:function handleSpecialEd(event){this.setState({specialNeedsData:event===null?'-1':event.value});}},{key:'handleTitle1',value:function handleTitle1(event){this.setState({title1:event===null?'-1':event.value});}},{key:'handleResearch',value:function handleResearch(event){this.setState({research:!event.target.checked});}},{key:'handleSave',value:function handleSave(event){var _this11=this;if(this.validate()){this.setState({errorNote:''});__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addNewStudent(this.props.classId,this.state).then(function(response){_this11.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].TEACHER_ADD_STUDENT,metadata:{userId:response.body.students[0].user.id,firstName:response.body.students[0].user.firstname,lastName:response.body.students[0].user.lastname}}},function(){return _this11.handleAnalytics();});_this11.handleCancel();},function(error){console.log('Error new student',error);});}else{this.setState({errorNote:'Fields with red outline have to be filled in or selected!'});}}},{key:'handleCancel',value:function handleCancel(event){//this.props.handleCancel();
this.props.handleClassItemClick(this.props.class);}},{key:'handleAppIntroduction',value:function handleAppIntroduction(){this.setState({showAppIntro:true});}},{key:'closeAppIntro',value:function closeAppIntro(){this.setState({showAppIntro:false});}},{key:'render',value:function render(){var _this12=this;if(!this.props.classId){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Redirect */],{to:'/login'});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this12.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:this.state.showAppIntro,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{width:250,float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3',style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.closeAppIntro,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3',style:{marginLeft:50,marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.printAppIntro,className:'handBtn',href:"https://docs.google.com/document/d/1LuRBxc0aFzkC0sLe_xvfxCXrTZxPJHD70s1WhxFMKEI/edit?usp=sharing"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Print'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:90,marginLeft:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__ComponentToPrint__["a" /* default */],{ref:function ref(el){return _this12.componentRef=el;}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Add Student'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{color:'red',paddingLeft:15}},this.state.errorNote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:'formAddStudent'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-8 noPaddingLR15"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentName'},'First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.firstName,onChange:this.handleName,id:'inputStudentName',className:this.state.firstNameError+" form-control inputStyle1",placeholder:'First Name',required:true,autoFocus:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentLastName'},'Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.lastName,onChange:this.handleLastName,id:'inputStudentLastName',className:this.state.lastNameError+" form-control inputStyle1",placeholder:'Last Name',required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentReadingLevel'},'Reading Level'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* OverlayTrigger */],{placement:'top',overlay:tooltipReadingLevel},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{className:this.state.readingLevelError,onChange:this.handleReadingLevel,id:'inputStudentReadingLevel',options:readingLevelOptions,isSearchable:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentGender'},'Gender'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{className:this.state.genderError,onChange:this.handleGender,id:'inputStudentGender',options:genderOptions,isSearchable:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentLanguage'},'Language'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{className:this.state.languageError,onChange:this.handleLanguage,id:'inputStudentLanguage',options:languageOptions,isSearchable:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentDisability'},'Student Description'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* OverlayTrigger */],{placement:'top',overlay:tooltipDisability},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{className:"basic-multi-select "+this.state.disabilityError,onChange:this.handleDisability,id:'inputStudentDisability',options:disabilityOptions,isMulti:true,isSearchable:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentPlacement'},'Placement'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{className:this.state.placementError,onChange:this.handlePlacement,id:'inputStudentPlacement',options:placementOptions,isSearchable:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentGrade'},'Grade Placement'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{className:this.state.gradeError,onChange:this.handleGrade,id:'inputStudentGrade',options:gradeOptions,isSearchable:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentGrade'},'Task Apps'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-6',style:{height:40,marginTop:-30,marginLeft:80,cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_25__assets_images_info_icon_2f_png___default.a,style:{width:22,height:22},onClick:this.handleAppIntroduction}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{target:'_blank',href:"https://docs.google.com/document/d/1LuRBxc0aFzkC0sLe_xvfxCXrTZxPJHD70s1WhxFMKEI/edit?usp=sharing",style:{fontFamily:'Open Sans',fontSize:'1.00em'},name:'How',className:'btn btn-link'},'How to Select Apps'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{className:'basic-multi-select',isMulti:true,options:appOptions,value:this.state.multipleValues,isSearchable:false,onChange:this.handleAppChange.bind(this)})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{color:'red'}},this.state.emailWarning),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentEmail'},'Parent Email (Optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',defaultValue:this.state.email,onChange:this.handleEmail,id:'inputStudentEmail',className:this.state.errorEmail+' form-control inputStyle1',placeholder:'Email'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentIEP'},'IEP (Optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{onChange:this.handleSpecialEd,id:'inputStudentSpecialEd',defaultValue:getFourValue(fourValueOptions,this.state.specialNeedsData),options:fourValueOptions,isSearchable:false,isClearable:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentELL'},'ELL (Optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{onChange:this.handleELL,id:'inputStudentELL',defaultValue:getFourValue(fourValueOptions,this.state.ell),options:fourValueOptions,isSearchable:false,isClearable:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentFreeLunch'},'Free Lunch (Optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{onChange:this.handleFreeLunch,id:'inputStudentFreeLunch',defaultValue:getFourValue(fourValueOptions,this.state.freeLunch),options:fourValueOptions,isSearchable:false,isClearable:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputStudentTitle1'},'Title 1 (Optional)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{onChange:this.handleTitle1,id:'inputStudentTitle1',defaultValue:getFourValue(fourValueOptions,this.state.title1),options:fourValueOptions,isSearchable:false,isClearable:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'Research',className:'cb'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleResearch,name:'Research',value:!this.state.research,id:'Research'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'checkmark'}),' Exclude Student Data'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'ExcludeVideoApps',className:'cb',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleExcludeVid,name:'ExcludeVideoApps',value:this.state.excludeVid,id:'ExcludeVideoApps'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'checkmark'}),' Exclude Video Apps'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this12.handleSave();},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save Changes')))));}}]);return AddStudentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var AddStudent=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(AddStudentComponent);var StudentsList=function(_Component4){_inherits(StudentsList,_Component4);function StudentsList(props){var _this14=this;_classCallCheck(this,StudentsList);var _this13=_possibleConstructorReturn(this,(StudentsList.__proto__||Object.getPrototypeOf(StudentsList)).call(this,props));_this13.handleItemClick=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return _this13.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].TEACHER_STUDENT_DETAILS_VIEW,metadata:{userId:student.userId}}},function(){_this13.handleAnalytics();_this13.props.handleItemClick(student,_this13.props.classId);});case 2:case'end':return _context9.stop();}}},_callee9,_this14);}));return function(_x7){return _ref9.apply(this,arguments);};}();_this13.state={students:_this13.props.students,showAddStudentHint:true,analytics:{type:null,metadata:null}};_this13.sortStudentsByName=_this13.sortStudentsByName.bind(_this13);_this13.sortStudentsByUserId=_this13.sortStudentsByUserId.bind(_this13);_this13.handleItemClick=_this13.handleItemClick.bind(_this13);_this13.handleClassTab=_this13.handleClassTab.bind(_this13);_this13.handleAddStudent=_this13.handleAddStudent.bind(_this13);_this13.handleAddStudentHint=_this13.handleAddStudentHint.bind(_this13);_this13.getTarget=_this13.getTarget.bind(_this13);_this13.handleAnalytics=_this13.handleAnalytics.bind(_this13);return _this13;}_createClass(StudentsList,[{key:'componentDidMount',value:function componentDidMount(){if(localStorage.getItem('addStudent')==='hide'){this.setState({showAddStudentHint:false});}}},{key:'sortStudentsByUserId',value:function sortStudentsByUserId(){this.setState({students:this.state.students.sort(function(a,b){return a.userId>b.userId?1:a.userId<b.userId?-1:0;})});}},{key:'sortStudentsByName',value:function sortStudentsByName(){this.setState({students:this.state.students.sort(function(a,b){var nameA=a.user.firstname+' '+a.user.lastname;var nameB=b.user.firstname+' '+b.user.lastname;return nameA>nameB?1:nameA<nameB?-1:0;})});}},{key:'handleAddStudentHint',value:function handleAddStudentHint(){this.setState({showAddStudentHint:!this.state.showAddStudentHint});}},{key:'getTarget',value:function getTarget(){return __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this.target);}},{key:'handleClassTab',value:function handleClassTab(event){this.props.handleClassTab();}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleAddStudent',value:function handleAddStudent(event){this.props.handleAddStudent();this.handleAddStudentHint();localStorage.setItem('addStudent','hide');event.preventDefault();}},{key:'render',value:function render(){var _this15=this;var sharedProps={container:this,target:this.getTarget,show:this.state.showAddStudentHint};var items=this.state.students;var students=items.map(function(student){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StudentListItem,{key:student.id,student:student,handleClick:_this15.handleItemClick,deleteStudent:_this15.props.deleteStudent});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{ref:function ref(button){_this15.target=button;},className:'fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_ico_plus_green_png___default.a,onClick:this.handleAddStudent,style:{cursor:'pointer'},alt:'Add a Student',border:'0',className:'ico-xs ico-add'})),addStudentStorage!=='hide'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["d" /* Overlay */],Object.assign({},sharedProps,{placement:'left'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["f" /* Popover */],{id:'popover-positioned-top',title:'Step 2'},'Add a Student(s)')):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav nav-tabs'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'active',onClick:this.handleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Students')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleClassTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Class Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.props.handleMultipleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Share/Transfer Students'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-pane active solidBorder noPadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},'#'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortStudentsByName},'Full Name')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortStudentsByUserId},'User Number')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},'Password'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,students))));}}]);return StudentsList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Students=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(StudentsList);var StudentListItem=function(_Component5){_inherits(StudentListItem,_Component5);function StudentListItem(props){_classCallCheck(this,StudentListItem);var _this16=_possibleConstructorReturn(this,(StudentListItem.__proto__||Object.getPrototypeOf(StudentListItem)).call(this,props));_this16.deleteStudent=function(confirm){if(confirm){_this16.props.deleteStudent(_this16.props.student);}};_this16.state={modalDialog:false,responseContent:''};_this16.handleClick=_this16.handleClick.bind(_this16);_this16.deleteStudent=_this16.deleteStudent.bind(_this16);return _this16;}_createClass(StudentListItem,[{key:'handleClick',value:function handleClick(event){this.props.handleClick(this.props.student);event.stopPropagation();}},{key:'render',value:function render(){var _this17=this;var student=this.props.student;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__["a" /* default */],{modalOpen:this.state.modalDialog,confirmDelete:this.deleteStudent,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this17.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:function onClick(event){_this17.setState({modalDialog:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS STUDENT?'});event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{style:{maxHeight:30},type:'image',alt:"Delete",src:__webpack_require__(744)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:this.handleClick},student.user.firstname,' ',student.user.lastname),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:this.handleClick},student.userId),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:this.handleClick},student.user.password),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'fitWidth',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_images_ico_view_png___default.a,alt:'View Student Details',border:'0',className:'ico-xs'}))));}}]);return StudentListItem;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var MultipleStudentsList=function(_Component6){_inherits(MultipleStudentsList,_Component6);function MultipleStudentsList(props){var _this19=this;_classCallCheck(this,MultipleStudentsList);var _this18=_possibleConstructorReturn(this,(MultipleStudentsList.__proto__||Object.getPrototypeOf(MultipleStudentsList)).call(this,props));_this18.handleSelect=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(studentId,isChecked){var checkList,i,studentIds,_i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:checkList=_this18.state.checkList;for(i=0;i<checkList.length;i++){if(checkList[i].studentId==studentId){checkList[i].checked=isChecked;}}studentIds=[];for(_i=0;_i<checkList.length;_i++){if(checkList[_i].checked){studentIds.push(checkList[_i].studentId);}}_this18.setState({checkList:checkList,studentIds:studentIds});case 5:case'end':return _context10.stop();}}},_callee10,_this19);}));return function(_x8,_x9){return _ref10.apply(this,arguments);};}();_this18.state={showAddStudentHint:true,showTeacherInfo:false,showClassList:false,allChecked:false,checkList:[],studentIds:[],students:_this18.props.students,analytics:{type:null,metadata:null}};_this18.sortStudentsByName=_this18.sortStudentsByName.bind(_this18);_this18.sortStudentsByUserId=_this18.sortStudentsByUserId.bind(_this18);_this18.handleSelect=_this18.handleSelect.bind(_this18);_this18.handleClassTab=_this18.handleClassTab.bind(_this18);_this18.handleContinue=_this18.handleContinue.bind(_this18);_this18.handleAllChecked=_this18.handleAllChecked.bind(_this18);_this18.handleCancelTransfer=_this18.handleCancelTransfer.bind(_this18);return _this18;}_createClass(MultipleStudentsList,[{key:'componentDidMount',value:function componentDidMount(){var students=this.props.students;var checkList=[];students.forEach(function(student){checkList.push({studentId:student.id,checked:false});});this.setState({checkList:checkList});}},{key:'handleClassTab',value:function handleClassTab(event){this.props.handleClassTab();}},{key:'sortStudentsByUserId',value:function sortStudentsByUserId(){this.setState({students:this.state.students.sort(function(a,b){return a.userId>b.userId?1:a.userId<b.userId?-1:0;})});}},{key:'sortStudentsByName',value:function sortStudentsByName(){this.setState({students:this.state.students.sort(function(a,b){var nameA=a.user.firstname+' '+a.user.lastname;var nameB=b.user.firstname+' '+b.user.lastname;return nameA>nameB?1:nameA<nameB?-1:0;})});}},{key:'handleContinue',value:function handleContinue(){this.setState({showTeacherInfo:true});}},{key:'handleAllChecked',value:function handleAllChecked(){var newCheckStatus=!this.state.allChecked;var students=this.state.students;var checkList=[];students.forEach(function(student){if(newCheckStatus){checkList.push({studentId:student.id,checked:true});}else{checkList.push({studentId:student.id,checked:false});}});var studentIds=[];for(var i=0;i<checkList.length;i++){if(checkList[i].checked){studentIds.push(checkList[i].studentId);}}this.setState({studentIds:studentIds,checkList:checkList,allChecked:newCheckStatus});}},{key:'handleCancelTransfer',value:function handleCancelTransfer(){this.setState({showTeacherInfo:false});}},{key:'render',value:function render(){var _this20=this;var sharedProps={container:this,target:this.getTarget,show:this.state.showAddStudentHint};var items=this.state.students;var students=items.map(function(student){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MultipleStudentListItem,{key:student.id,student:student,checked:getChecked(_this20.state.checkList,student.id),handleSelect:_this20.handleSelect});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav nav-tabs'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.props.handleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Students')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleClassTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Class Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'active',onClick:this.handleMultipleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Share/Transfer Students'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-pane active solidBorder noPadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'You can share or transfer students to another teacher.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Step 1: Select the students to share or transfer'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleAllChecked,name:'selectStudent',checked:this.state.allChecked,id:'allChecked'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortStudentsByName},'Full Name')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortStudentsByUserId},'User Number')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,students))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleContinue,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Continue'))),this.state.showTeacherInfo?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TransferStudentComponent,{schoolAdmin:this.props.schoolAdmin,studentIds:this.state.studentIds,handleCancelTransfer:this.handleCancelTransfer})):null);}}]);return MultipleStudentsList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var MultipleStudents=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(MultipleStudentsList);var MultipleStudentListItem=function(_Component7){_inherits(MultipleStudentListItem,_Component7);function MultipleStudentListItem(props){var _this22=this;_classCallCheck(this,MultipleStudentListItem);var _this21=_possibleConstructorReturn(this,(MultipleStudentListItem.__proto__||Object.getPrototypeOf(MultipleStudentListItem)).call(this,props));_this21.handleSelectStudent=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(studentId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return _this21.setState({isSelected:!_this21.state.isSelected});case 2:_this21.props.handleSelect(studentId,_this21.state.isSelected);case 3:case'end':return _context11.stop();}}},_callee11,_this22);}));return function(_x10){return _ref11.apply(this,arguments);};}();_this21.state={isSelected:_this21.props.checked};_this21.handleSelectStudent=_this21.handleSelectStudent.bind(_this21);return _this21;}_createClass(MultipleStudentListItem,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.checked!==newProps.checked){this.setState({isSelected:newProps.checked});}}},{key:'render',value:function render(){var _this23=this;var student=this.props.student;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(){return _this23.handleSelectStudent(student.id);},name:'selectStudent',checked:this.state.isSelected,id:'checkSelected'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:function onClick(){return _this23.handleSelectStudent(student.id);}},student.user.firstname,' ',student.user.lastname),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:function onClick(){return _this23.handleSelectStudent(student.id);}},student.userId));}}]);return MultipleStudentListItem;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var TransferStudentComponent=Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(function(_Component8){_inherits(TransferStudentComponent,_Component8);function TransferStudentComponent(props){_classCallCheck(this,TransferStudentComponent);var _this24=_possibleConstructorReturn(this,(TransferStudentComponent.__proto__||Object.getPrototypeOf(TransferStudentComponent)).call(this,props));_this24.handleBackClick=function(){if(_this24.props.schoolAdmin){_this24.props.history.push("/school-admin");}else{_this24.props.history.push("/teacher");}};_this24.handleCorrectTeacherData=function(data){_this24.setState({teacherId:data.teacher.id,classes:data.teacher.classes});};_this24.handleCancelTransfer=function(){_this24.props.handleCancelTransfer();};_this24.handleClassSelect=function(classId){_this24.setState({classId:parseInt(classId)});};_this24.state={teacherId:0,classId:0,studentId:_this24.props.studentId,studentIds:_this24.props.studentIds,classes:[],share:false,modalDialog:false,responseContent:'',modalInfoDialog:false,responseInfoContent:''};_this24.handleDone=_this24.handleDone.bind(_this24);_this24.handleCancelTransfer=_this24.handleCancelTransfer.bind(_this24);_this24.handleBackClick=_this24.handleBackClick.bind(_this24);return _this24;}_createClass(TransferStudentComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.studentIds!==newProps.studentIds){this.setState({studentIds:newProps.studentIds});}}},{key:'handleDone',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(event,share){var _this25=this;var promptText;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:if(!(this.state.classId>0)){_context12.next=9;break;}promptText=void 0;if(share){promptText='Are you sure you wish to share the students?';}else{promptText='Are you sure you wish to transfer the students?';}if(!window.confirm(promptText)){_context12.next=7;break;}_context12.next=6;return this.setState({share:share});case 6:__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].transferMultipleStudents(this.state).then(function(response){_this25.setState({modalDialog:true,responseContent:_this25.state.share?'Student has been shared Successfully!':'Student has been transferred Successfully!'});},function(error){console.log('transfer student error',error);});case 7:_context12.next=10;break;case 9:this.setState({modalInfoDialog:true,responseInfoContent:'Step 3:In the drop down list, select a class into which the student will be placed!'});case 10:case'end':return _context12.stop();}}},_callee12,this);}));function handleDone(_x11,_x12){return _ref12.apply(this,arguments);}return handleDone;}()},{key:'render',value:function render(){var _this26=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this26.setState({modalDialog:active});window.location.reload();}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalInfoDialog,sectionContent:this.state.responseInfoContent,closeClick:function closeClick(active){_this26.setState({modalInfoDialog:false});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TeacherInfoTransferComponent,{correctTeacherData:this.handleCorrectTeacherData,handleCancelTransfer:this.handleCancelTransfer}),this.state.classes&&this.state.classes.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TeacherClassTransferComponent,{classes:this.state.classes,handleClassSelect:this.handleClassSelect}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancelTransfer,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(e){return _this26.handleDone(e,false);},disabled:this.state.classId===0,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Transfer')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(e){return _this26.handleDone(e,true);},disabled:this.state.classId===0,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Share')))):null);}}]);return TransferStudentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));var TeacherInfoTransferComponent=function(_Component9){_inherits(TeacherInfoTransferComponent,_Component9);function TeacherInfoTransferComponent(props){_classCallCheck(this,TeacherInfoTransferComponent);var _this27=_possibleConstructorReturn(this,(TeacherInfoTransferComponent.__proto__||Object.getPrototypeOf(TeacherInfoTransferComponent)).call(this,props));_this27.state={firstName:'',lastName:'',teacherId:'',hideButtons:false,modalDialog:false,responseContent:''};_this27.handleFirstName=_this27.handleFirstName.bind(_this27);_this27.handleLastName=_this27.handleLastName.bind(_this27);_this27.handleLoginID=_this27.handleLoginID.bind(_this27);_this27.handleCancel=_this27.handleCancel.bind(_this27);_this27.handleContinue=_this27.handleContinue.bind(_this27);return _this27;}_createClass(TeacherInfoTransferComponent,[{key:'handleFirstName',value:function handleFirstName(event){this.setState({firstName:event.target.value.replace(/\s+/g,'')});}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastName:event.target.value.replace(/\s+/g,'')});}},{key:'handleLoginID',value:function handleLoginID(event){event.target.value=event.target.value.replace(/[^0-9.]+/g,'');this.setState({teacherId:event.target.value});}},{key:'validate',value:function validate(){var valid=true;if(this.state.firstName.length===0){valid=false;document.getElementById("inputTeacherName").classList.add('validationRed');}else{document.getElementById("inputTeacherName").classList.remove('validationRed');}if(this.state.lastName.length===0){valid=false;document.getElementById("inputTeacherLastName").classList.add('validationRed');}else{document.getElementById("inputTeacherLastName").classList.remove('validationRed');}if(this.state.teacherId.length===0||this.state.teacherId===null){valid=false;document.getElementById("inputTeacherLoginID").classList.add('validationRed');}else{document.getElementById("inputTeacherLoginID").classList.remove('validationRed');}return valid;}},{key:'handleContinue',value:function handleContinue(event){if(this.validate()){document.getElementById("validWarning").classList.add("hidden");this.listExternalTeacher();}else{document.getElementById("validWarning").classList.remove("hidden");}}},{key:'listExternalTeacher',value:function listExternalTeacher(){var _this28=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listExternalTeacher(this.state).then(function(response){if(response.success&&response.body){_this28.props.correctTeacherData(response.body);_this28.setState({hideButtons:true});}else if(response.success){_this28.setState({modalDialog:true,responseContent:'This teacher doesn\'t have any classes.'});}else{_this28.setState({modalDialog:true,responseContent:'Incorrect input! Check it and retry!'});}},function(error){console.log('Error',error);});}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancelTransfer();}},{key:'render',value:function render(){var _this29=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this29.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Step 2: Share/ transfer students with a teacher'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Enter the new teacher\'s first name, last name and user number for AvePM. Then you will be asked to select the new class name for the students.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:"validWarning",className:"hidden",style:{color:'red',paddingBottom:10}},' Fields with red outline have to be filled in or selected!'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherName'},'Teacher First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleFirstName,id:'inputTeacherName',className:'form-control ',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherLastName'},'Teacher Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleLastName,id:'inputTeacherLastName',className:'form-control ',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherLoginID'},'Teacher User Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onInput:this.handleLoginID,id:'inputTeacherLoginID',className:'form-control ',placeholder:'User Number',required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),this.state.hideButtons?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleContinue,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Continue'))));}}]);return TeacherInfoTransferComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var TeacherClassTransferComponent=function(_Component10){_inherits(TeacherClassTransferComponent,_Component10);function TeacherClassTransferComponent(props){_classCallCheck(this,TeacherClassTransferComponent);var _this30=_possibleConstructorReturn(this,(TeacherClassTransferComponent.__proto__||Object.getPrototypeOf(TeacherClassTransferComponent)).call(this,props));_this30.state={classes:_this30.props.classes||[]};_this30.handleClassSelect=_this30.handleClassSelect.bind(_this30);return _this30;}_createClass(TeacherClassTransferComponent,[{key:'handleClassSelect',value:function handleClassSelect(event){this.props.handleClassSelect(event.value);}},{key:'render',value:function render(){var options=[];options[0]=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:0,value:0},'Select a class');for(var i=0;i<this.state.classes.length;i++){var c=this.state.classes[i];// ///options[i + 1] = <option key={c.id} value={c.id}>{c.name}</option>;
options.push({value:c.id,label:c.name});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{marginTop:5}},'Step 3: In the drop down list, select a class into which the student will be placed.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{onChange:this.handleClassSelect,id:'classes',name:'classes',options:options,isSearchable:false}));}}]);return TeacherClassTransferComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var AddClassComponent=function(_Component11){_inherits(AddClassComponent,_Component11);function AddClassComponent(props){_classCallCheck(this,AddClassComponent);var _this31=_possibleConstructorReturn(this,(AddClassComponent.__proto__||Object.getPrototypeOf(AddClassComponent)).call(this,props));_this31.deleteClass=function(confirm){if(confirm){_this31.handleDelete();}};_this31.state={name:_this31.props.class?_this31.props.class.name:"",confirmDelete:false};_this31.handleName=_this31.handleName.bind(_this31);_this31.handleGrade=_this31.handleGrade.bind(_this31);_this31.handleSemester=_this31.handleSemester.bind(_this31);_this31.handleYear=_this31.handleYear.bind(_this31);_this31.handleSave=_this31.handleSave.bind(_this31);_this31.handleCancel=_this31.handleCancel.bind(_this31);_this31.handleDelete=_this31.handleDelete.bind(_this31);_this31.deleteClass=_this31.deleteClass.bind(_this31);_this31.handleAnalytics=_this31.handleAnalytics.bind(_this31);return _this31;}_createClass(AddClassComponent,[{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleName',value:function handleName(event){this.setState({name:event.target.value});}},{key:'handleGrade',value:function handleGrade(event){this.setState({grade:event.target.value});}},{key:'handleSemester',value:function handleSemester(event){this.setState({semester:event.target.value});}},{key:'handleYear',value:function handleYear(event){this.setState({year:event.target.value});}},{key:'handleSave',value:function handleSave(event){var _this32=this;if(!this.state.name){this.setState({modalDialog:true,responseContent:'Must enter class name'});setTimeout(function(){_this32.setState({modalDialog:false});},3500);return;}if(this.props.edit){var body={classId:this.props.class.id,name:this.state.name};__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].updateClass(body).then(function(response){if(response.success){_this32.props.saveClassCallback(response.body);}else{_this32.setState({modalDialog:true,responseContent:'Please input another class name.'});//setTimeout(()=>{this.setState({modalDialog:false})},3500);
}},function(error){console.log('Add new class error',error);_this32.setState({modalDialog:true,responseContent:'Please input another class name.'});//setTimeout(()=>{this.setState({modalDialog:false})},3500);
});}else{var _body={name:this.state.name};__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addNewClass(_body).then(function(response){if(response.success){_this32.props.saveClassCallback(response.body);}else{_this32.setState({modalDialog:true,responseContent:'Please input another class name.'});//setTimeout(()=>{this.setState({modalDialog:false})},3500);
}},function(error){console.log('Add new class error',error);_this32.setState({modalDialog:true,responseContent:'Please input another class name.'});//setTimeout(()=>{this.setState({modalDialog:false})},3500);
});}event.preventDefault();}},{key:'handleCancel',value:function handleCancel(){this.props.cancelCallback();}},{key:'handleDelete',value:function handleDelete(){var _this33=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].deleteClass(this.props.class.id).then(function(response){if(response.success){_this33.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].TEACHER_DELETED_CLASS,metadata:{classId:_this33.props.class.id}}},function(){return _this33.handleAnalytics();});_this33.props.saveClassCallback(response.body);}else{_this33.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this33.setState({modalDialog:false});},3500);}},function(error){console.log('Delete class error',error);});}},{key:'render',value:function render(){var _this34=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this34.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:'formAddClass'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputClassName'},'Class Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleName,id:'inputClassName',value:this.state.name,className:'form-control',placeholder:'Class Name',required:true,autoFocus:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),!this.props.edit?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save Changes'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_DialogBox__["a" /* default */],{modalOpen:this.state.modalDialog,confirmDelete:this.deleteClass,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this34.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this34.setState({modalDialog:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS CLASS?'});},className:'handBtn fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete Class')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save Changes'))));}}]);return AddClassComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ClassListComponent=function(_Component12){_inherits(ClassListComponent,_Component12);function ClassListComponent(){var _ref13;var _temp,_this35,_ret;_classCallCheck(this,ClassListComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this35=_possibleConstructorReturn(this,(_ref13=ClassListComponent.__proto__||Object.getPrototypeOf(ClassListComponent)).call.apply(_ref13,[this].concat(args))),_this35),_this35.handleItemClick=function(object){_this35.props.handleItemClick(object);},_temp),_possibleConstructorReturn(_this35,_ret);}_createClass(ClassListComponent,[{key:'render',value:function render(){var _this36=this;var items=this.props.classes;var classes=items.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClassItemComponent,{key:item.id,item:item,active:_this36.props.clickedClassID===item.id?"active":"",handleClick:_this36.handleItemClick,deleteClass:_this36.props.deleteClass});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,classes));}}]);return ClassListComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ClassItemComponent=function(_Component13){_inherits(ClassItemComponent,_Component13);function ClassItemComponent(props){_classCallCheck(this,ClassItemComponent);var _this37=_possibleConstructorReturn(this,(ClassItemComponent.__proto__||Object.getPrototypeOf(ClassItemComponent)).call(this,props));_this37.handleClick=_this37.handleClick.bind(_this37);_this37.deleteClass=_this37.deleteClass.bind(_this37);return _this37;}_createClass(ClassItemComponent,[{key:'handleClick',value:function handleClick(event){this.props.handleClick(this.props.item);event.preventDefault();}},{key:'deleteClass',value:function deleteClass(event){var confirmed=window.confirm("Are you sure that you want to delete this class ?");if(confirmed){this.props.deleteClass(this.props.item);}event.stopPropagation();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:"clickable-row "+this.props.active,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.item.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_images_ico_view_png___default.a,alt:'View Class Students',border:'0',className:'ico-xs'}))));}}]);return ClassItemComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{selectClass:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(selectedClass){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["b" /* selectClass */])(selectedClass));case 2:return _context13.abrupt('return',_context13.sent);case 3:case'end':return _context13.stop();}}},_callee13,_this38);}));function selectClass(_x13){return _ref14.apply(this,arguments);}return selectClass;}(),updateStudent:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(selectedStudent){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["h" /* updateStudent */])(selectedStudent));case 2:return _context14.abrupt('return',_context14.sent);case 3:case'end':return _context14.stop();}}},_callee14,_this38);}));function updateStudent(_x14){return _ref15.apply(this,arguments);}return updateStudent;}(),updateTeacher:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["i" /* updateTeacher */])(data));case 2:return _context15.abrupt('return',_context15.sent);case 3:case'end':return _context15.stop();}}},_callee15,_this38);}));function updateTeacher(_x15){return _ref16.apply(this,arguments);}return updateTeacher;}(),userLogout:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["j" /* userLogout */])());case 2:return _context16.abrupt('return',_context16.sent);case 3:case'end':return _context16.stop();}}},_callee16,_this38);}));function userLogout(){return _ref17.apply(this,arguments);}return userLogout;}()};};var mapStateToProps=function mapStateToProps(state){return{lastClass:state.teacherReducer.lastClass,lastStudent:state.teacherReducer.student,teacher:state.teacherReducer.teacher};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["e" /* withRouter */])(MainTeacherComponent)));

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();




/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CHARSET */
/* unused harmony export COMMENT */
/* unused harmony export COUNTER_STYLE */
/* unused harmony export DECLARATION */
/* unused harmony export DOCUMENT */
/* unused harmony export FONT_FACE */
/* unused harmony export FONT_FEATURE_VALUES */
/* unused harmony export IMPORT */
/* unused harmony export KEYFRAMES */
/* unused harmony export MEDIA */
/* unused harmony export MOZ */
/* unused harmony export MS */
/* unused harmony export NAMESPACE */
/* unused harmony export PAGE */
/* unused harmony export RULESET */
/* unused harmony export SUPPORTS */
/* unused harmony export VIEWPORT */
/* unused harmony export WEBKIT */
/* unused harmony export abs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return U; });
/* unused harmony export append */
/* unused harmony export assign */
/* unused harmony export caret */
/* unused harmony export char */
/* unused harmony export character */
/* unused harmony export characters */
/* unused harmony export charat */
/* unused harmony export column */
/* unused harmony export combine */
/* unused harmony export comment */
/* unused harmony export commenter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ce; });
/* unused harmony export copy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return V; });
/* unused harmony export declaration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return W; });
/* unused harmony export delimiter */
/* unused harmony export escaping */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return d; });
/* unused harmony export hash */
/* unused harmony export identifier */
/* unused harmony export indexof */
/* unused harmony export length */
/* unused harmony export line */
/* unused harmony export match */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return le; });
/* unused harmony export namespace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return N; });
/* unused harmony export node */
/* unused harmony export parse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return P; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return F; });
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return he; });
/* unused harmony export prev */
/* unused harmony export replace */
/* unused harmony export ruleset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ve; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fe; });
/* unused harmony export sizeof */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return R; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return oe; });
/* unused harmony export strlen */
/* unused harmony export substr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return T; });
/* unused harmony export tokenize */
/* unused harmony export tokenizer */
/* unused harmony export trim */
/* unused harmony export whitespace */
var e="-ms-";var r="-moz-";var a="-webkit-";var c="comm";var n="rule";var t="decl";var s="@page";var u="@media";var i="@import";var f="@charset";var o="@viewport";var l="@supports";var v="@document";var h="@namespace";var p="@keyframes";var b="@font-face";var w="@counter-style";var $="@font-feature-values";var k=Math.abs;var d=String.fromCharCode;var g=Object.assign;function m(e,r){return(((r<<2^z(e,0))<<2^z(e,1))<<2^z(e,2))<<2^z(e,3)}function x(e){return e.trim()}function y(e,r){return(e=r.exec(e))?e[0]:e}function j(e,r,a){return e.replace(r,a)}function C(e,r){return e.indexOf(r)}function z(e,r){return e.charCodeAt(r)|0}function A(e,r,a){return e.slice(r,a)}function O(e){return e.length}function M(e){return e.length}function S(e,r){return r.push(e),e}function q(e,r){return e.map(r).join("")}var B=1;var D=1;var E=0;var F=0;var G=0;var H="";function I(e,r,a,c,n,t,s){return{value:e,root:r,parent:a,type:c,props:n,children:t,line:B,column:D,length:s,return:""}}function J(e,r){return g(I("",null,null,"",null,null,0),e,{length:-e.length},r)}function K(){return G}function L(){G=F>0?z(H,--F):0;if(D--,G===10)D=1,B--;return G}function N(){G=F<E?z(H,F++):0;if(D++,G===10)D=1,B++;return G}function P(){return z(H,F)}function Q(){return F}function R(e,r){return A(H,e,r)}function T(e){switch(e){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function U(e){return B=D=1,E=O(H=e),F=0,[]}function V(e){return H="",e}function W(e){return x(R(F-1,ee(e===91?e+2:e===40?e+1:e)))}function X(e){return V(Z(U(e)))}function Y(e){while(G=P())if(G<33)N();else break;return T(e)>2||T(G)>3?"":" "}function Z(e){while(N())switch(T(G)){case 0:S(ae(F-1),e);break;case 2:S(W(G),e);break;default:S(d(G),e)}return e}function _(e,r){while(--r&&N())if(G<48||G>102||G>57&&G<65||G>70&&G<97)break;return R(e,Q()+(r<6&&P()==32&&N()==32))}function ee(e){while(N())switch(G){case e:return F;case 34:case 39:if(e!==34&&e!==39)ee(G);break;case 40:if(e===41)ee(e);break;case 92:N();break}return F}function re(e,r){while(N())if(e+G===47+10)break;else if(e+G===42+42&&P()===47)break;return"/*"+R(r,F-1)+"*"+d(e===47?e:N())}function ae(e){while(!T(P()))N();return R(e,F)}function ce(e){return V(ne("",null,null,null,[""],e=U(e),0,[0],e))}function ne(e,r,a,c,n,t,s,u,i){var f=0;var o=0;var l=s;var v=0;var h=0;var p=0;var b=1;var w=1;var $=1;var k=0;var g="";var m=n;var x=t;var y=c;var z=g;while(w)switch(p=k,k=N()){case 40:if(p!=108&&z.charCodeAt(l-1)==58){if(C(z+=j(W(k),"&","&\f"),"&\f")!=-1)$=-1;break}case 34:case 39:case 91:z+=W(k);break;case 9:case 10:case 13:case 32:z+=Y(p);break;case 92:z+=_(Q()-1,7);continue;case 47:switch(P()){case 42:case 47:S(se(re(N(),Q()),r,a),i);break;default:z+="/"}break;case 123*b:u[f++]=O(z)*$;case 125*b:case 59:case 0:switch(k){case 0:case 125:w=0;case 59+o:if(h>0&&O(z)-l)S(h>32?ue(z+";",c,a,l-1):ue(j(z," ","")+";",c,a,l-2),i);break;case 59:z+=";";default:S(y=te(z,r,a,f,o,n,u,g,m=[],x=[],l),t);if(k===123)if(o===0)ne(z,r,y,y,m,t,l,u,x);else switch(v){case 100:case 109:case 115:ne(e,y,y,c&&S(te(e,y,y,0,0,n,u,g,n,m=[],l),x),n,x,l,u,c?m:x);break;default:ne(z,y,y,y,[""],x,0,u,x)}}f=o=h=0,b=$=1,g=z="",l=s;break;case 58:l=1+O(z),h=p;default:if(b<1)if(k==123)--b;else if(k==125&&b++==0&&L()==125)continue;switch(z+=d(k),k*b){case 38:$=o>0?1:(z+="\f",-1);break;case 44:u[f++]=(O(z)-1)*$,$=1;break;case 64:if(P()===45)z+=W(N());v=P(),o=l=O(g=z+=ae(Q())),k++;break;case 45:if(p===45&&O(z)==2)b=0}}return t}function te(e,r,a,c,t,s,u,i,f,o,l){var v=t-1;var h=t===0?s:[""];var p=M(h);for(var b=0,w=0,$=0;b<c;++b)for(var d=0,g=A(e,v+1,v=k(w=u[b])),m=e;d<p;++d)if(m=x(w>0?h[d]+" "+g:j(g,/&\f/g,h[d])))f[$++]=m;return I(e,r,a,t===0?n:i,f,o,l)}function se(e,r,a){return I(e,r,a,c,d(K()),A(e,2,-2),0)}function ue(e,r,a,c){return I(e,r,a,t,A(e,0,c),A(e,c+1,-1),c)}function ie(c,n){switch(m(c,n)){case 5103:return a+"print-"+c+c;case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return a+c+c;case 5349:case 4246:case 4810:case 6968:case 2756:return a+c+r+c+e+c+c;case 6828:case 4268:return a+c+e+c+c;case 6165:return a+c+e+"flex-"+c+c;case 5187:return a+c+j(c,/(\w+).+(:[^]+)/,a+"box-$1$2"+e+"flex-$1$2")+c;case 5443:return a+c+e+"flex-item-"+j(c,/flex-|-self/,"")+c;case 4675:return a+c+e+"flex-line-pack"+j(c,/align-content|flex-|-self/,"")+c;case 5548:return a+c+e+j(c,"shrink","negative")+c;case 5292:return a+c+e+j(c,"basis","preferred-size")+c;case 6060:return a+"box-"+j(c,"-grow","")+a+c+e+j(c,"grow","positive")+c;case 4554:return a+j(c,/([^-])(transform)/g,"$1"+a+"$2")+c;case 6187:return j(j(j(c,/(zoom-|grab)/,a+"$1"),/(image-set)/,a+"$1"),c,"")+c;case 5495:case 3959:return j(c,/(image-set\([^]*)/,a+"$1"+"$`$1");case 4968:return j(j(c,/(.+:)(flex-)?(.*)/,a+"box-pack:$3"+e+"flex-pack:$3"),/s.+-b[^;]+/,"justify")+a+c+c;case 4095:case 3583:case 4068:case 2532:return j(c,/(.+)-inline(.+)/,a+"$1$2")+c;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(O(c)-1-n>6)switch(z(c,n+1)){case 109:if(z(c,n+4)!==45)break;case 102:return j(c,/(.+:)(.+)-([^]+)/,"$1"+a+"$2-$3"+"$1"+r+(z(c,n+3)==108?"$3":"$2-$3"))+c;case 115:return~C(c,"stretch")?ie(j(c,"stretch","fill-available"),n)+c:c}break;case 4949:if(z(c,n+1)!==115)break;case 6444:switch(z(c,O(c)-3-(~C(c,"!important")&&10))){case 107:return j(c,":",":"+a)+c;case 101:return j(c,/(.+:)([^;!]+)(;|!.+)?/,"$1"+a+(z(c,14)===45?"inline-":"")+"box$3"+"$1"+a+"$2$3"+"$1"+e+"$2box$3")+c}break;case 5936:switch(z(c,n+11)){case 114:return a+c+e+j(c,/[svh]\w+-[tblr]{2}/,"tb")+c;case 108:return a+c+e+j(c,/[svh]\w+-[tblr]{2}/,"tb-rl")+c;case 45:return a+c+e+j(c,/[svh]\w+-[tblr]{2}/,"lr")+c}return a+c+e+c+c}return c}function fe(e,r){var a="";var c=M(e);for(var n=0;n<c;n++)a+=r(e[n],n,e,r)||"";return a}function oe(e,r,a,s){switch(e.type){case i:case t:return e.return=e.return||e.value;case c:return"";case p:return e.return=e.value+"{"+fe(e.children,s)+"}";case n:e.value=e.props.join(",")}return O(a=fe(e.children,s))?e.return=e.value+"{"+a+"}":""}function le(e){var r=M(e);return function(a,c,n,t){var s="";for(var u=0;u<r;u++)s+=e[u](a,c,n,t)||"";return s}}function ve(e){return function(r){if(!r.root)if(r=r.return)e(r)}}function he(c,s,u,i){if(c.length>-1)if(!c.return)switch(c.type){case t:c.return=ie(c.value,c.length);break;case p:return fe([J(c,{value:j(c.value,"@","@"+a)})],i);case n:if(c.length)return q(c.props,(function(n){switch(y(n,/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":return fe([J(c,{props:[j(n,/:(read-\w+)/,":"+r+"$1")]})],i);case"::placeholder":return fe([J(c,{props:[j(n,/:(plac\w+)/,":"+a+"input-$1")]}),J(c,{props:[j(n,/:(plac\w+)/,":"+r+"$1")]}),J(c,{props:[j(n,/:(plac\w+)/,e+"input-$1")]})],i)}return""}))}}function pe(e){switch(e.type){case n:e.props=e.props.map((function(r){return q(X(r),(function(r,a,c){switch(z(r,0)){case 12:return A(r,1,O(r));case 0:case 40:case 43:case 62:case 126:return r;case 58:if(c[++a]==="global")c[a]="",c[++a]="\f"+A(c[a],a=1,-1);case 32:return a===1?"":r;default:switch(a){case 0:e=r;return M(c)>1?"":r;case a=M(c)-1:case 2:return a===2?r+e+e:r+e;default:return r}}}))}))}}
//# sourceMappingURL=stylis.mjs.map


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(723);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmur2);


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _taggedTemplateLiteral;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(335);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(225);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 739 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 740 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dist_Select_54ac8379_esm_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dist_useStateManager_68425271_esm_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dist_useCreatable_8a6670a3_esm_js__ = __webpack_require__(342);
/* unused harmony reexport useCreatable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dist_index_a7690a33_esm_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emotion_react__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_slicedToArray__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_typeof__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_classCallCheck__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_helpers_createClass__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_helpers_inherits__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_defineProperty__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_memoize_one__ = __webpack_require__(197);





















var CreatableSelect = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(function (props, ref) {
  var creatableProps = Object(__WEBPACK_IMPORTED_MODULE_3__dist_useStateManager_68425271_esm_js__["a" /* u */])(props);
  var selectProps = Object(__WEBPACK_IMPORTED_MODULE_4__dist_useCreatable_8a6670a3_esm_js__["a" /* u */])(creatableProps);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__dist_Select_54ac8379_esm_js__["a" /* S */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, selectProps));
});

/* unused harmony default export */ var _unused_webpack_default_export = (CreatableSelect);


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DialogBox__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a.setAppElement('body');var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'50%'}};var EmailConsentForm=function(_Component){_inherits(EmailConsentForm,_Component);function EmailConsentForm(props){_classCallCheck(this,EmailConsentForm);var _this=_possibleConstructorReturn(this,(EmailConsentForm.__proto__||Object.getPrototypeOf(EmailConsentForm)).call(this,props));_this.state={done:false,submitting:false,isOpen:false,downloadCliced:false,checkboxChecked:false,agreeChecked:false,email:"",modalDialog:false,responseContent:''};_this.submitForm=_this.submitForm.bind(_this);_this.downloadClicked=_this.downloadClicked.bind(_this);_this.handleCheckBox=_this.handleCheckBox.bind(_this);_this.handleAgreeChecked=_this.handleAgreeChecked.bind(_this);_this.handleEmailChange=_this.handleEmailChange.bind(_this);_this.handleClose=_this.handleClose.bind(_this);return _this;}_createClass(EmailConsentForm,[{key:'componentDidMount',value:function componentDidMount(){this.setState({isOpen:!this.props.teacher.teacher.consent});}},{key:'downloadClicked',value:function downloadClicked(){this.setState({downloadClicked:true});}},{key:'handleCheckBox',value:function handleCheckBox(e){this.setState({checkboxChecked:e.target.checked});}},{key:'handleAgreeChecked',value:function handleAgreeChecked(e){this.setState({agreeChecked:e.target.checked});}},{key:'handleEmailChange',value:function handleEmailChange(e){this.setState({email:e.target.value});}},{key:'handleClose',value:function handleClose(){this.setState({modalDialog:false});if(this.state.responseContent==="Your consent has been recorded."){this.props.updateTeacher(Object.assign({},this.props.teacher,{teacher:Object.assign({},this.props.teacher.teacher,{consent:true})}));this.setState({isOpen:false});}}},{key:'submitForm',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(this.state.agreeChecked){_context.next=4;break;}this.setState({modalDialog:true,responseContent:"Please check the 'I agree' checkbox."});_context.next=8;break;case 4:this.setState({submitting:true});data={email:this.state.email};_context.next=8;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].teacherConsent(data).then(function(res){_this2.setState({done:true,submitting:false});_this2.setState({modalDialog:true,responseContent:"Your consent has been recorded."});}).catch(function(err){console.log(err);_this2.setState({done:true,submitting:false});_this2.setState({modalDialog:true,responseContent:"An error occurred, please try again."});});case 8:case'end':return _context.stop();}}},_callee,this);}));function submitForm(){return _ref.apply(this,arguments);}return submitForm;}()},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:this.state.isOpen,style:customStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Consent Form')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12 bgGrey roundCorners'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:this.handleClose}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'form'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Please download and read the document below.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.downloadClicked,href:"https://api-beta.avepm.com/documents/Consent_teachers.docx",className:'handBtn',type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Download')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'May we contact you to ask for feedback (select the checkbox) ?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:'left',marginLeft:50,width:100}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{name:'Checkbox',type:'checkbox',checked:this.state.checkboxChecked,onChange:this.handleCheckBox})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.checkboxChecked},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Email Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{onChange:this.handleEmailChange,type:'email',className:'form-control',placeholder:'Email Address',required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'By checking the checkbox below you are acknowledging that you have read the consent document and you agree to participate.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{style:{float:'left',width:100}},'I agree'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:'left',marginLeft:-50,marginTop:10,width:100}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{name:'Checkbox',type:'checkbox',checked:this.state.agreeChecked,onChange:this.handleAgreeChecked})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:'auto',marginRight:'auto',width:150}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://uploadbeta.s3.us-east-2.amazonaws.com/documents/ApplicationPrivacyStatement.pdf",target:'_blank'},'Privacy Statement')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitForm,className:'handBtn',type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Done')))));}}]);return EmailConsentForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EmailConsentForm);

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HomeHeaderComponent_HomeHeader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StudentsComponent_Maze1__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Facebook_logo_png__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Facebook_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_Facebook_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var logoDocs=__webpack_require__(751);var logoVideo=__webpack_require__(352);var logoDevice=__webpack_require__(353);var logoIdeasThatWork=__webpack_require__(198);var ResourcesLinkComponent=function(_Component){_inherits(ResourcesLinkComponent,_Component);function ResourcesLinkComponent(props){_classCallCheck(this,ResourcesLinkComponent);var _this=_possibleConstructorReturn(this,(ResourcesLinkComponent.__proto__||Object.getPrototypeOf(ResourcesLinkComponent)).call(this,props));_this.state={analytics:{type:null,metadata:null}};_this.handleClick=_this.handleClick.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);return _this;}_createClass(ResourcesLinkComponent,[{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_4__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleClick',value:function handleClick(){var _this2=this;this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_5__Shared_DataTrackingPoints__["b" /* default */].RESOURCES_DOWNLOAD,metadata:{resourceId:this.props.value}}},function(){return _this2.handleAnalytics();});}},{key:'render',value:function render(){var sameTab=this.props.sameTab;var target=void 0;if(sameTab){target="";}else{target="_blank";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,this.props.download==="No"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.handleClick,href:this.props.url,target:target},this.props.title):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.handleClick,href:this.props.url,target:target,download:true},this.props.title));}}]);return ResourcesLinkComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var VideoTutorialComponent=function(_Component2){_inherits(VideoTutorialComponent,_Component2);function VideoTutorialComponent(props){_classCallCheck(this,VideoTutorialComponent);var _this3=_possibleConstructorReturn(this,(VideoTutorialComponent.__proto__||Object.getPrototypeOf(VideoTutorialComponent)).call(this,props));_this3.state={analytics:{type:null,metadata:null}};_this3.handleClick=_this3.handleClick.bind(_this3);_this3.handleAnalytics=_this3.handleAnalytics.bind(_this3);return _this3;}_createClass(VideoTutorialComponent,[{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_4__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleClick',value:function handleClick(){var _this4=this;this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_5__Shared_DataTrackingPoints__["b" /* default */].VIDEO_PLAY,metadata:{videoId:this.props.id}}},function(){return _this4.handleAnalytics();});this.props.handleOpenVideo(this.props.id,this.props.title,this.props.url);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.handleClick},this.props.title));}}]);return VideoTutorialComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ResourcesComponent=function(_Component3){_inherits(ResourcesComponent,_Component3);function ResourcesComponent(props){_classCallCheck(this,ResourcesComponent);var _this5=_possibleConstructorReturn(this,(ResourcesComponent.__proto__||Object.getPrototypeOf(ResourcesComponent)).call(this,props));_this5.state={showVideo:false,videoURL:null,videoId:null,videoTitle:null};_this5.handleOpenVideo=_this5.handleOpenVideo.bind(_this5);_this5.handleCloseVideo=_this5.handleCloseVideo.bind(_this5);return _this5;}_createClass(ResourcesComponent,[{key:'handleOpenVideo',value:function handleOpenVideo(id,title,url){this.setState({showVideo:true,videoURL:url,videoId:id,videoTitle:title});}},{key:'handleCloseVideo',value:function handleCloseVideo(){this.setState({showVideo:false,videoURL:null,videoId:null,videoTitle:null});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__HomeHeaderComponent_HomeHeader__["a" /* default */],{currentItem:"Resources"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section bgGreen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Here you\u2019ll find all you need: From video tutorials to manuscripts and more!'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logoDocs,alt:'',border:'0',className:'ico-s'}),' Getting Started'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'listArrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:25,url:"https://docs.google.com/document/d/1tq1YlUUnuJJ7rkRWac7W1-nL-GyxujEnchIGj5YfQAE/",title:"How to Log in, Create a Class and Add a Student"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:13,url:"https://docs.google.com/document/d/1A88PHzgLpOFqDNfT2WSxRDCCrMf-objT1J0sgS67b94/edit?usp=sharing",title:"Selecting apps -- quick lookup"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:30,url:"https://docs.google.com/document/d/1nZqoGGYdv3Ba7CkvdbYSoYAboWa3bvwN-_NzLPysdQM/edit?usp=sharing",title:"Add a Parent Account"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:31,url:"https://docs.google.com/document/d/1Sx4IklA7n5YlxPyGHTPwb1GKIp4nR5lWBdvfCZEYzq8/edit?usp=sharing",title:"Scoring"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:32,url:"https://docs.google.com/document/d/1SU81DQjcqJkfexNCO3oVU_UpBRt13LD0EKSk3Wul-qo/edit?usp=sharing",title:"Accessing the Data Charts: Overview"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:33,url:"https://docs.google.com/document/d/1bq4Oxxgtvdu0IrFwV-5Y41Ayt6z1mLIR5lGxGneV1PI/edit?usp=sharing",title:"Share a Student"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:34,url:"https://docs.google.com/document/d/1Xd6_ICz6qymRfVI7_aF7PLIQ8JGa5tP2/edit#",title:"Progression Rules"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logoVideo,alt:'',border:'0',className:'ico-s'}),' Video Tutorials'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'listArrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideoTutorialComponent,{id:1,url:"https://www.youtube.com/embed/wy-KrJ_iRas?rel=0",title:"Progress monitoring overview",handleOpenVideo:this.handleOpenVideo}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logoDevice,alt:'',border:'0',className:'ico-s'}),' Device Check'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'listArrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:23,url:"./needs-assessment",title:"Check your device for internet speed, webcam and microphone",download:"No",sameTab:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logoDocs,alt:'',border:'0',className:'ico-s'}),' Tech Docs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'listArrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:7,url:"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/MonitoringProgressofStudentsWhoAreDeaforHardofHearing.pdf",title:"Monitoring Progress for Students Who Are DHH"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:8,url:"https://docs.google.com/document/d/1uE2ksBcVYHP0rVIUIxrfUupfK1NW4vOZH4kQJ1B6a68/edit",title:"Children’s Online Privacy Protection Act (COPPA) statement"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:9,url:"https://docs.google.com/document/d/1Et2sZWpNL_tZJzgvhI7LENaHIASxia9r/edit",title:"Technical documentation for each of the apps"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:35,url:"https://docs.google.com/document/d/1ljjANoXyYHSZ9rEAab1SjBnUf5Ifa3sB/edit",title:"Technical Manual"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logoDocs,alt:'',border:'0',className:'ico-s'}),' Consent Forms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'listArrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:10,url:"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/ActiveConsentForm.pdf",title:"Active Consent form"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:26,url:"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/Consent_parents_Somali.pdf",title:"Active consent form: Somali"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:27,url:"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/Consent_parents_Spanish.pdf",title:"Active consent form: Spanish"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:28,url:"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/Consent_parents_Hmong.pdf",title:"Active consent form: Hmong"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:29,url:"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/Consent_teachers_Spanish.pdf",title:"Teachers consent form: Spanish"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResourcesLinkComponent,{value:11,url:"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/AssentForm.pdf",title:"Passive Consent form"})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["a" /* Modal */],{id:"videoBox",show:this.state.showVideo,style:{top:100,left:-270}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content',style:{width:620}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header',style:{width:620}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.state.videoTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"modal-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{width:'560',height:'315',src:this.state.videoURL,frameBorder:'0',allow:'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',allowFullScreen:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:100,marginLeft:'auto',marginRight:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'handBtn',onClick:this.handleCloseVideo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Close')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'bgGrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:25}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-2',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Follow us: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-10',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:1,marginLeft:-30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://twitter.com/AvenuePM",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_Twitter_Social_Icon_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Twitter')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:95,marginTop:-28}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://www.facebook.com/profile.php?id=100009224578527&lst=100006500830477%3A100009224578527%3A1587693428&sk=timeline",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_Facebook_logo_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Facebook')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This document was produced under U.S. Department of Education, Office of Special Education Programs Grant No. H327S170012. The views  expressed herein do not necessarily represent the positions or polices of the Department of Education. No official endorsement by the U.S. Department of Education of any product, commodity, service or enterprise mentioned in this publication is intended or should be inferred. This product is public domain.  Authorization to reproduce it in whole or in part is granted. While permission to reprint this publication is not necessary, the citation should be.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xA9 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',null,'new Date().getFullYear()>2010&&document.write(new Date().getFullYear());'),' Designed and developed by researchers at the University of Minnesota and Penn State University.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logoIdeasThatWork,alt:'Logo - Ideas That Work. U.S. Office of Special Education Programs',border:'0'}))))));}}]);return ResourcesComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ResourcesComponent);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StudentsComponent_Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProgressBox__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a.setAppElement('body');var customStyle={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',width:'30%'}};var ProgressModal=function(_Component){_inherits(ProgressModal,_Component);function ProgressModal(props){_classCallCheck(this,ProgressModal);return _possibleConstructorReturn(this,(ProgressModal.__proto__||Object.getPrototypeOf(ProgressModal)).call(this,props));}_createClass(ProgressModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:this.props.isOpen,style:customStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProgressBox__["a" /* default */],{level:this.props.level||1,step:this.props.step||1,steps:this.props.steps||6})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.closeModal,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Go')))));}}]);return ProgressModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (ProgressModal);

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./medal_level0.png": 297,
	"./medal_level1.png": 298,
	"./medal_level10.png": 307,
	"./medal_level11.png": 308,
	"./medal_level2.png": 299,
	"./medal_level3.png": 300,
	"./medal_level4.png": 301,
	"./medal_level5.png": 302,
	"./medal_level6.png": 303,
	"./medal_level7.png": 304,
	"./medal_level8.png": 305,
	"./medal_level9.png": 306
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 747;

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.1';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(190)(module)))

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAiTSURBVGhD5VkLWI/3Ho/IfUipiNwj1g7GhtyKmcs4srWxrIvbwpoVaSmVSFqokCRJy7q4ZseEQhdFZCtqLqlO58FjbJ3H9ZH4nN/316+t9V7a2Xl6nfOcj+f75P993//7fz+/y+d7+engfxz/HwSys7Kwds0aeHt5wftLL6z29uHmv9oXa3z92LUArAtYi6DAQGxYvx7BQRvw1YZgbAoJweaNGxG2ORThoWHYGr4F27ZswfaICERGbMfOHVGIjorCruhoxOzahT27YxEXG4v4uDjsjY/HN/F7sS85GVd/vCreRIoGCXx39CjMe/WGqZExDDt01NSMOxmgf5++cPrEQbyNFA0ScLCfi+4mXTDfyZmPIo2mFhYeGspnu7dZD9jNel+8jRQNEvh0wUK0b90Gp9LThUc7lJeXo4dpN8y2+1B4pJAl8OTJEzx9+hTV1dXIzMjAHPaAhw8fiqva4ftLl2Bmaoq5cz4WHikkBJ4/f47ZH9hhiOUbePvNYZgyaRKmTZ7CRsEOLgsX4e9sVLRC/sWLMOtiCse5c4VHCtkZyDhzBp98bI9p706GRT9zdOlshGGDh2Dxpy64ffu2uKvxkXf+PLp36fqfbeIlLi78ITSdcnj27Bmqqqr4zFWTsWX34sULbi9fvhR3/Tnk5uSgmxAQJTRIwH72HK4ExUXFwlOD5+ylP1u8BEP/MhijR4zEWCsrjLMajfFjxsJ67DhMGDce71jb4N0JEzHlHbYM2WxOnzIVf31vOj6wteVLkmZ5vvM8LGEz67NqFX4s/v1vZGVlo5uxCRYtWCA8UjRIgH60H4sDZWVlwlODyl8q0bu7GVo310PHtu3Qoa61afurta81pmSvkbVqg3atWqNdS2bsb9sWLdGyWXO00WuBlEOHxdNrkHEmg8cfl0WLhEeKBgk42NtjzMhR4tNvoOVxKT8fWRmZOJudLbGcs2dxLjdX0c6fO4cLeXnccnNycbOkRDz5N5xOP4WujMBSl8XCI4UsgYitW/ERUyJnB0fYsOVgxZaIl6cnAvz9UVFRIe5qfJw8cYILyLLPXIVHClkCX7h+jv69+8CcGS0f2ki6OjrQYUY5ilY4npoKE8POcF+2THikkCVASnLl8mUkJyZyAoMGWPAEi5SoiqmOVqA8zMTAECvc3YVHCtU9QNGYkikKaC/Zv/qg6zdv3uQKRUGH9sOJ48fxbcoR7EtKZqS/xm6WZe7YHoktYeHY+FUI1q8LxBo/P/h4rcLKFR5wY6NLKkQbNf9ivnhyDb49coQndJ7sPiWoErh79y4nMHzIUFRWVgpvDQp++AGWFgNhzEaos34nrjSkJKQoek110Ywtt6Zi2dVaE2a0FJvpNIFek6ZoodsMrdj9LXWb8+uUktfF4UOHYKRvgFWeXwqPFKoEHj16xAm8NfRNVLEgVRelbOSdHR251k9mOv/+TFseMSn5W+bqCk8PD/ixeiEocD1CN23C9m0RbDZikLB3Lw4eOIDv/nYUp9LSWa2RjazMLL486we+A/v3s8Ex4DFCCbIEKIrSA0kFiMDg1y1x5vRpXL9+nUddrUDFTOeO+mwgVguPFLIEaKToxfv17IU+PXqiZ7fuaM2Wh1lXU1y7ek3c1fhITEiAISMQ4OcvPFLIEqAAtXDefEwcb4NeLNpSRUabjXITmh2tQJJNldm6gADhkUJ1D/zENjHlQdYsv5HD/fv3kXYyDanHjnHJI9U4fPAg9u/bh6SERFbTxiNuzx4+o1T7Uh1MNXHY5s1ckYKDghC4dh38fX2Z+aHkxg3x5Bp8zb5LBKjWVsIfIjB+9BieddYFfZ5kM4GrRwumOnpNdNFcpylXH1IaUiBSnboKREb+GiWqUSMy8tF3aXPXRWxMDCcQEhwsPFL8aQKkGIfYaJPqeHqs5LpOI0lSSCO7KWQj0/4wpj7bePdhN3sZCoaJ3yTwGaLvktFL018KnPWxa+dOToCepQRVAj+zJUJ7gPKhV4GoyEhOgGRYCbIELuRd4GXcjGnv8Rmgqmy1tzffxJRmaAWaPSJA3RAlyBKIi93Dkrm+PJnry6SUkjlav5RYFdcrOhoT1AgjApQdK0FxCRUWFHAZo7YGVVqpx1JZ+lCgaSAjtSICpF5KUN0DlEpQPWw3a5bwaAtqTRKBqMgdwiOFKgHqQBAB2xkzhEdbhARv4ARioqOFRwpVAo8fP+YEqAh/FaBEkAjExuwWHilkCTx48IBF2JNcu4kAdRlu1IuSWoBSCCJAEVkJsgSoJW7R15yrECVzpEKUVH1k9yGLDT+LuxofVPgQAbUyVpbA5cJCLHdzw0y29imQDTTvz9OGmdNn4PatW+Kuxoevjw8nQNFbCap74N69e3z0qTf6KuDN0hMikJyUJDxSqBK4xUa7hsBk4dEWXis9OYH6SV5dqBIgGX2VBDyWL+cEUlhtrARVAnfu3IGpsQmmT50qPNrC/Qs3TuBISorwSCFLIJylwXa2s1hFZs3LyTcGDuJHTZQVUhdaK1CDzbCDPm8AKEGWwAo3d97QIgklIyXSf609b+JSuakVXJcu5fJNeZgSFJdQeVk5b1ZRLHB2cMD1a9dQXFTE8yOtQE1d6kpQd0QJqnugmhXwlgMGqp4SNiaoY0cE0tOUDxhVCVBKMdjSkrcWqbx8wnIjyo+0MDponOfoBKNOBqonpKoE/llZiUH9B/CiZsSw4fwkxmrECFi93QhGz2XPp98gGzNqFF4fYCFOh4rEG0mhvoRY+bh08RJeUpIaUWJHskqHDqZGJvz/tUZHQRQzao0Ox5Xs1/vqfp99ppelfuvI4W9horUN5jk5ISkxUbyNPFQJ1IIi8j8qKlBWWoaSkhLenStio1JYUMhVKe88nbLk8B4nnXCmp6XxjUdGPaNao34/+eh6VmYmP6khoSi6cgWlpaU87tCs/ztV3x8i8N8L4F9EdBHf4fG5JgAAAABJRU5ErkJggg=="

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_ico_plus_green_png__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_ico_plus_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_ico_plus_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_ico_view_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_ico_view_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_ico_view_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_DeleteDialogBox__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var addClassInstruction=null;var addStudentInstruction=null;var PNInstruction=null;var WSSInstruction=null;var CopyrightInstruction=null;var KidsignInstruction=null;var AdminComponent=function(_Component){_inherits(AdminComponent,_Component);function AdminComponent(props){_classCallCheck(this,AdminComponent);var _this=_possibleConstructorReturn(this,(AdminComponent.__proto__||Object.getPrototypeOf(AdminComponent)).call(this,props));_this.setTeachers=function(object){_this.setState({teachers:object});};_this.handleCancel=function(){_this.setState({addTeacher:false,editTeacher:false});};_this.handleTeacherItemClick=function(object){_this.setState({addTeacher:false,editTeacher:true,teacherToEdit:null});_this.handleAddTeacher();_this.setState({addTeacher:false,editTeacher:true,teacherToEdit:object});console.log(object);};_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].logout().then(function(response){if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_this.props.history.push("/login");},function(error){localStorage.removeItem('token');localStorage.clear();_this.props.history.push("/login");});};_this.teacherAdded=function(){_this.listTeachers();};_this.state={teachers:[],teacherToEdit:{},addTeacher:false,editTeacher:false};_this.handleAddTeacher=_this.handleAddTeacher.bind(_this);return _this;}_createClass(AdminComponent,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.user.id==100){this.listTeachers();}else{this.props.history.push("/content");}}},{key:'listTeachers',value:function listTeachers(){var _this2=this;__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].listTeachers().then(function(response){if(response.success){_this2.setTeachers(response.body);}else{console.log('Error',response.msg);}},function(error){console.log('Error',error.msg);});}},{key:'handleAddTeacher',value:function handleAddTeacher(event){this.setState({addTeacher:!this.state.addTeacher,editTeacher:false});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_Header__["a" /* default */],{admin:true,userId:this.props.user.id,logout:this.handleLogout}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'fl'},'Teachers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'fr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_ico_plus_green_png___default.a,onClick:this.handleAddTeacher,alt:'Plus Icon',border:'0',className:'ico-xs ico-add'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12 col-md-12 solidBorder noPadding scrollable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeachersListComponent,{teachers:this.state.teachers,handleItemClick:this.handleTeacherItemClick}))),this.state.addTeacher?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9 container navbar-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddTeacherComponent,{handleTeacherAdded:this.teacherAdded,handleCancel:this.handleCancel})):null,this.state.editTeacher?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9 container navbar-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpdateTeacherComponent,{handleTeacherUpdated:this.teacherAdded,teacher:this.state.teacherToEdit,handleCancel:this.handleCancel})):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_Footer__["a" /* default */],null));}}]);return AdminComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AddTeacherComponent=function(_Component2){_inherits(AddTeacherComponent,_Component2);function AddTeacherComponent(props){_classCallCheck(this,AddTeacherComponent);var _this3=_possibleConstructorReturn(this,(AddTeacherComponent.__proto__||Object.getPrototypeOf(AddTeacherComponent)).call(this,props));_this3.state={firstname:'',lastname:'',email:'',modalDialog:false,responseContent:''};_this3.handleName=_this3.handleName.bind(_this3);_this3.handleLastName=_this3.handleLastName.bind(_this3);_this3.handleEmail=_this3.handleEmail.bind(_this3);_this3.handleCancel=_this3.handleCancel.bind(_this3);_this3.handleSave=_this3.handleSave.bind(_this3);return _this3;}_createClass(AddTeacherComponent,[{key:'handleName',value:function handleName(event){this.setState({firstname:event.target.value});event.preventDefault();}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastname:event.target.value});event.preventDefault();}},{key:'handleEmail',value:function handleEmail(event){this.setState({email:event.target.value});event.preventDefault();}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();}},{key:'handleSave',value:function handleSave(event){var _this4=this;__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].createTeacher(this.state).then(function(response){if(response.success){_this4.setState({modalDialog:true,responseContent:'Teacher Successfully Added!'});setTimeout(function(){_this4.setState({modalDialog:false});_this4.props.handleCancel();},3500);_this4.props.handleTeacherAdded();_this4.myFormRef.reset();}else{_this4.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this4.setState({modalDialog:false});},3500);}},function(error){_this4.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this4.setState({modalDialog:false});},3500);});}},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this5.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'formAddTeacher',ref:function ref(el){return _this5.myFormRef=el;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputTeacherName'},'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',onChange:this.handleName,id:'inputTeacherName',className:'form-control',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputTeacherLastName'},'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',onChange:this.handleLastName,id:'inputTeacherLastName',className:'form-control',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputTeacherEmail'},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',onChange:this.handleEmail,id:'inputTeacherEmail',className:'form-control',placeholder:'Email',required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Save Changes'))));}}]);return AddTeacherComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateTeacherComponent=function(_Component3){_inherits(UpdateTeacherComponent,_Component3);function UpdateTeacherComponent(props){_classCallCheck(this,UpdateTeacherComponent);var _this6=_possibleConstructorReturn(this,(UpdateTeacherComponent.__proto__||Object.getPrototypeOf(UpdateTeacherComponent)).call(this,props));_this6.deleteTeacher=function(confirm){if(confirm){_this6.handleDelete();}_this6.setState({modalDialogDelete:false});};_this6.state={firstname:_this6.props.teacher.user.firstname,lastname:_this6.props.teacher.user.lastname,email:_this6.props.teacher.user.email,userId:_this6.props.teacher.userId,researcher:_this6.props.teacher.researcher,modalDialog:false,modalDialogDelete:false};_this6.handleName=_this6.handleName.bind(_this6);_this6.handleLastName=_this6.handleLastName.bind(_this6);_this6.handleEmail=_this6.handleEmail.bind(_this6);_this6.handleUserId=_this6.handleUserId.bind(_this6);_this6.handleReseacher=_this6.handleReseacher.bind(_this6);_this6.handleCancel=_this6.handleCancel.bind(_this6);_this6.handleSave=_this6.handleSave.bind(_this6);_this6.handleDelete=_this6.handleDelete.bind(_this6);_this6.deleteTeacher=_this6.deleteTeacher.bind(_this6);return _this6;}_createClass(UpdateTeacherComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.teacher.userId!==newProps.teacher.userId){this.setState({firstname:this.props.teacher.user.firstname,lastname:this.props.teacher.user.lastname,email:this.props.teacher.user.email,userId:this.props.teacher.userId,researcher:this.props.teacher.researcher,modalDialog:false,modalDialogDelete:false});}}},{key:'handleName',value:function handleName(event){this.setState({firstname:event.target.value.replace(/\s+/g,'')});event.preventDefault();}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastname:event.target.value.replace(/\s+/g,'')});event.preventDefault();}},{key:'handleEmail',value:function handleEmail(event){this.setState({email:event.target.value});event.preventDefault();}},{key:'handleUserId',value:function handleUserId(event){this.setState({userId:event.target.value});event.preventDefault();}},{key:'handleReseacher',value:function handleReseacher(event){this.setState({researcher:!this.state.researcher});// event.preventDefault();
}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();event.preventDefault();}},{key:'handleSave',value:function handleSave(event){var _this7=this;__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].updateTeacher(this.state).then(function(response){if(response.success){_this7.setState({modalDialog:true,responseContent:'Teacher Data Successfully Updated!'});setTimeout(function(){_this7.setState({modalDialog:false});},3500);_this7.props.handleTeacherUpdated();}else{alert(response.msg);}},function(error){alert(error.msg);});event.preventDefault();}},{key:'handleDelete',value:function handleDelete(event){var _this8=this;__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].deleteTeacher(this.state.userId).then(function(response){if(response.success){_this8.setState({modalDialog:true,responseContent:'Teacher Successfully Deleted!'});setTimeout(function(){_this8.setState({modalDialog:false});_this8.props.handleCancel();},3500);_this8.props.handleTeacherUpdated();}else{alert(response.msg);}},function(error){alert(error.msg);});}},{key:'render',value:function render(){var _this9=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this9.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteTeacher,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this9.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputTeacherName'},'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.state.firstname,onChange:this.handleName,id:'inputTeacherName',className:'form-control',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputTeacherLastName'},'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.state.lastname,onChange:this.handleLastName,id:'inputTeacherLastName',className:'form-control',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputTeacherUserId'},'User Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.state.userId,onChange:this.handleUserId,id:'inputTeacherUserId',className:'form-control',placeholder:'UserID',required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{width:'30%'}},' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'inline-block',position:'relative',width:'70%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'cbResearcher',className:'cb '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleReseacher,name:'researcher',checked:this.state.researcher,id:'cbResearcher'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark'}),' Researcher')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav navbar fl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(event){_this9.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TEACHER?'});event.stopPropagation();},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Delete Teacher'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Save Changes'))));}}]);return UpdateTeacherComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var TeachersListComponent=function(_Component4){_inherits(TeachersListComponent,_Component4);function TeachersListComponent(){var _ref;var _temp,_this10,_ret;_classCallCheck(this,TeachersListComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this10=_possibleConstructorReturn(this,(_ref=TeachersListComponent.__proto__||Object.getPrototypeOf(TeachersListComponent)).call.apply(_ref,[this].concat(args))),_this10),_this10.handleItemClick=function(object){_this10.props.handleItemClick(object);},_temp),_possibleConstructorReturn(_this10,_ret);}_createClass(TeachersListComponent,[{key:'render',value:function render(){var _this11=this;var items=this.props.teachers;var teachers=items.map(function(item){if(item.user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeachersListItemComponent,{key:item.id,item:item,handleClick:_this11.handleItemClick});}else return null;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,teachers));}}]);return TeachersListComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var TeachersListItemComponent=function(_Component5){_inherits(TeachersListItemComponent,_Component5);function TeachersListItemComponent(props){_classCallCheck(this,TeachersListItemComponent);var _this12=_possibleConstructorReturn(this,(TeachersListItemComponent.__proto__||Object.getPrototypeOf(TeachersListItemComponent)).call(this,props));_this12.handleClick=_this12.handleClick.bind(_this12);return _this12;}_createClass(TeachersListItemComponent,[{key:'handleClick',value:function handleClick(event){this.props.handleClick(this.props.item);event.preventDefault();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'clickable-row',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.props.item.user.lastname,', ',this.props.item.user.firstname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_ico_view_png___default.a,alt:'View Icon',border:'0',className:'ico-xs'}))));}}]);return TeachersListItemComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* withRouter */])(AdminComponent));

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TeachersComponent_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Shared_Helpers__ = __webpack_require__(15);
var _this37=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var addClassInstruction=null;var addStudentInstruction=null;var addStudentStorage=localStorage.getItem('addStudent');var getValue=function getValue(opts,val){return opts.find(function(o){return o.value===val;});};var getChecked=function getChecked(checkList,studentId){var student=checkList.find(function(o){return o.studentId===studentId;});if(student){return student.checked;}else{return null;}};var SchoolAdminComponent=function(_Component){_inherits(SchoolAdminComponent,_Component);function SchoolAdminComponent(props){var _this2=this;_classCallCheck(this,SchoolAdminComponent);var _this=_possibleConstructorReturn(this,(SchoolAdminComponent.__proto__||Object.getPrototypeOf(SchoolAdminComponent)).call(this,props));_this.handleSchoolLoaded=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(schools){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.setState({schoolOptions:schools});case 2:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleSchoolChange=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(newValue){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listTeachersInSchool(newValue).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!response.success){_context2.next=6;break;}_this.setTeachers(response.body);_context2.next=4;return _this.setState({classes:[],classStudents:[],addTeacher:false,editTeacher:false});case 4:_context2.next=7;break;case 6:console.log('Error',response.msg);case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x3){return _ref3.apply(this,arguments);};}(),function(error){console.log('Error',error.msg);});case 1:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();_this.setTeachers=function(object){_this.setState({teachers:object});};_this.handleCancel=function(){_this.setState({addTeacher:false,editTeacher:false});};_this.handleTeacherEditClick=function(object){_this.setState({addTeacher:false,editTeacher:true,teacherToEdit:null});_this.handleAddTeacher();_this.setState({addTeacher:false,editTeacher:true,teacherToEdit:object});};_this.handleTeacherItemClick=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(object){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_this.setState({addTeacher:false,editTeacher:false,clickedTeacherId:object.id,classStudents:[]});_context4.next=3;return _this.listClasses(object.id);case 3:_context4.next=5;return _this.props.updateTeacher(object);case 5:_context4.next=7;return _this.props.selectTeacher(object);case 7:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref4.apply(this,arguments);};}();_this.handleClassItemClick=function(object){_this.handleCancel();__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listStudents(object.id).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(response){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!response.success){_context5.next=8;break;}res=response.body;_context5.next=4;return _this.setState({classStudents:res,class:object,clickedClassId:object.id});case 4:_context5.next=6;return _this.props.selectClass(object);case 6:_context5.next=10;break;case 8:_this.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 10:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x5){return _ref5.apply(this,arguments);};}(),function(error){console.log('Error',error.msg);});};_this.handleStudentClick=function(student,classId){_this.props.handleStudentClick(student,classId);_this.props.updateStudent(student);_this.props.history.push('/teacher/student');};_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].logout().then(function(response){if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_this.props.history.push("/login");},function(error){localStorage.removeItem('token');localStorage.clear();_this.props.history.push("/login");});};_this.teacherAdded=function(){window.location.reload();};_this.state={teachers:[],teacherToEdit:{},addTeacher:false,editTeacher:false,classes:[],class:{},classStudents:[],student:{},clickedClassId:-1,clickedTeacherId:-1,modalDialog:false,responseContent:'',schoolOptions:'',schoolValue:''};_this.handleAddTeacher=_this.handleAddTeacher.bind(_this);return _this;}_createClass(SchoolAdminComponent,[{key:'componentDidMount',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var lastTeacher,_selectTeacher,lastClass,_selectClass;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:__WEBPACK_IMPORTED_MODULE_17__Shared_Helpers__["a" /* default */].authorize(this);if(!this.props.lastSchool){_context8.next=7;break;}_context8.next=4;return this.handleSchoolChange(this.props.lastSchool);case 4:lastTeacher=this.props.lastTeacher;_selectTeacher=this.handleTeacherItemClick;if(lastTeacher){setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return _selectTeacher(lastTeacher);case 2:case'end':return _context6.stop();}}},_callee6,this);})),100);lastClass=this.props.lastClass;_selectClass=this.handleClassItemClick;if(lastClass){setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_selectClass(lastClass);case 1:case'end':return _context7.stop();}}},_callee7,this);})),100);if(this.props.lastStudent){this.handleStudentClick(this.props.lastStudent,this.props.lastClass.id);}}}case 7:case'end':return _context8.stop();}}},_callee8,this);}));function componentDidMount(){return _ref6.apply(this,arguments);}return componentDidMount;}()},{key:'handleAddTeacher',value:function handleAddTeacher(event){this.setState({addTeacher:!this.state.addTeacher,editTeacher:false});}},{key:'listClasses',value:function listClasses(teacherId){var _this3=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].teacherClassList(teacherId).then(function(response){if(response.success){_this3.setState({classes:response.body});console.log(response.body);}else{_this3.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this3.setState({modalDialog:false});},3500);}},function(error){_this3.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this3.setState({modalDialog:false});},3500);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_Header__["a" /* default */],{schoolAdmin:this.props.schoolAdmin,changeSchool:this.handleSchoolChange,schoolLoaded:this.handleSchoolLoaded,logout:this.handleLogout}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-10"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'fl'},'Teachers')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png___default.a,onClick:this.handleAddTeacher,alt:'Plus Icon',border:'0',className:'ico-xs ico-add'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 col-md-12 solidBorder noPadding scrollable',style:{maxHeight:450,height:450}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TeachersListComponent,{teachers:this.state.teachers,handleItemClick:this.handleTeacherItemClick,handleEditClick:this.handleTeacherEditClick,clickedTeacherID:this.state.clickedTeacherId}))),this.state.classes.length>0&&!this.state.editTeacher&&!this.state.addTeacher?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-10"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'fl'},'Classes')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 col-md-12 solidBorder noPadding scrollable',style:{maxHeight:450,height:450}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClassListComponent,{classes:this.state.classes,handleItemClick:this.handleClassItemClick,clickedClassID:this.state.clickedClassId}))):null,this.state.classStudents.length>0&&!this.state.editTeacher&&!this.state.addTeacher?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClassNavigation,{'class':this.state.class,students:this.state.classStudents,handleAddStudent:this.handleAddStudent,studentClick:this.handleStudentClick,updateClassCallback:this.handleUpdateClass,deleteStudent:this.handleDeleteStudent})):null,this.state.addTeacher?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-9 container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AddTeacherComponent,{handleTeacherAdded:this.teacherAdded,schoolOptions:this.state.schoolOptions,schoolValue:this.props.lastSchool,handleCancel:this.handleCancel})):null,this.state.editTeacher?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-9 container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(UpdateTeacherComponent,{handleTeacherUpdated:this.teacherAdded,teacher:this.state.teacherToEdit,schoolOptions:this.state.schoolOptions,schoolValue:this.props.lastSchool,handleCancel:this.handleCancel})):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_Footer__["a" /* default */],null));}}]);return SchoolAdminComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var AddTeacherComponent=function(_Component2){_inherits(AddTeacherComponent,_Component2);function AddTeacherComponent(props){_classCallCheck(this,AddTeacherComponent);var _this4=_possibleConstructorReturn(this,(AddTeacherComponent.__proto__||Object.getPrototypeOf(AddTeacherComponent)).call(this,props));_this4.state={firstname:'',lastname:'',email:'',schoolId:_this4.props.schoolValue,inProject:true,modalDialog:false,responseContent:''};_this4.handleName=_this4.handleName.bind(_this4);_this4.handleLastName=_this4.handleLastName.bind(_this4);_this4.handleEmail=_this4.handleEmail.bind(_this4);_this4.handleCancel=_this4.handleCancel.bind(_this4);_this4.handleSave=_this4.handleSave.bind(_this4);return _this4;}_createClass(AddTeacherComponent,[{key:'handleName',value:function handleName(event){this.setState({firstname:event.target.value});event.preventDefault();}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastname:event.target.value});event.preventDefault();}},{key:'handleEmail',value:function handleEmail(event){this.setState({email:event.target.value});event.preventDefault();}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();}},{key:'handleSave',value:function handleSave(event){var _this5=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].createTeacher(this.state).then(function(response){if(response.success){_this5.setState({modalDialog:true,responseContent:'The teacher account has been added successfully.\n'+'Some school districts block emails from external sites which may prevent the teacher from receiving the user number and password link. If this is the case, you  may need to contact the school district to ask about blocked email.'});setTimeout(function(){_this5.setState({modalDialog:false});_this5.props.handleCancel();_this5.props.handleTeacherAdded();},3500);_this5.myFormRef.reset();}else{_this5.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this5.setState({modalDialog:false});},3500);}},function(error){_this5.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this5.setState({modalDialog:false});},3500);});}},{key:'render',value:function render(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:'formAddTeacher',ref:function ref(el){return _this6.myFormRef=el;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherName'},'First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleName,id:'inputTeacherName',className:'form-control',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherLastName'},'Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleLastName,id:'inputTeacherLastName',className:'form-control',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherEmail'},'Email'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleEmail,id:'inputTeacherEmail',className:'form-control',placeholder:'Email',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherEmail'},'School'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:'68%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{id:"addTeacherSchool",onChange:function onChange(newValue){_this6.setState({schoolId:newValue.value});},options:this.props.schoolOptions,placeholder:"Select a school...",value:getValue(this.props.schoolOptions,this.props.schoolValue)}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr',style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save Changes'))));}}]);return AddTeacherComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var UpdateTeacherComponent=function(_Component3){_inherits(UpdateTeacherComponent,_Component3);function UpdateTeacherComponent(props){_classCallCheck(this,UpdateTeacherComponent);var _this7=_possibleConstructorReturn(this,(UpdateTeacherComponent.__proto__||Object.getPrototypeOf(UpdateTeacherComponent)).call(this,props));_this7.deleteTeacher=function(confirm){if(confirm){_this7.handleDelete();}_this7.setState({modalDialogDelete:false});};_this7.state={firstname:_this7.props.teacher.user.firstname,lastname:_this7.props.teacher.user.lastname,email:_this7.props.teacher.user.email,inProject:true,userId:_this7.props.teacher.userId,researcher:_this7.props.teacher.researcher,schoolId:_this7.props.schoolValue,modalDialog:false,modalDialogDelete:false};_this7.handleName=_this7.handleName.bind(_this7);_this7.handleLastName=_this7.handleLastName.bind(_this7);_this7.handleEmail=_this7.handleEmail.bind(_this7);_this7.handleUserId=_this7.handleUserId.bind(_this7);_this7.handleReseacher=_this7.handleReseacher.bind(_this7);_this7.handleCancel=_this7.handleCancel.bind(_this7);_this7.handleSave=_this7.handleSave.bind(_this7);_this7.handleDelete=_this7.handleDelete.bind(_this7);_this7.deleteTeacher=_this7.deleteTeacher.bind(_this7);return _this7;}_createClass(UpdateTeacherComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.teacher.userId!==newProps.teacher.userId){this.setState({firstname:this.props.teacher.user.firstname,lastname:this.props.teacher.user.lastname,email:this.props.teacher.user.email,schoolId:this.props.schoolValue,userId:this.props.teacher.userId,researcher:this.props.teacher.researcher,modalDialog:false,modalDialogDelete:false});}}},{key:'handleName',value:function handleName(event){this.setState({firstname:event.target.value.replace(/\s+/g,'')});event.preventDefault();}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastname:event.target.value.replace(/\s+/g,'')});event.preventDefault();}},{key:'handleEmail',value:function handleEmail(event){this.setState({email:event.target.value});event.preventDefault();}},{key:'handleUserId',value:function handleUserId(event){this.setState({userId:event.target.value});event.preventDefault();}},{key:'handleReseacher',value:function handleReseacher(event){this.setState({researcher:!this.state.researcher});// event.preventDefault();
}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();event.preventDefault();}},{key:'handleSave',value:function handleSave(event){var _this8=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].updateTeacher(this.state).then(function(response){if(response.success){_this8.setState({modalDialog:true,responseContent:'Teacher Data Successfully Updated!'});setTimeout(function(){_this8.setState({modalDialog:false});},3500);_this8.props.handleTeacherUpdated();}else{alert(response.msg);}},function(error){alert(error.msg);});event.preventDefault();}},{key:'handleDelete',value:function handleDelete(event){var _this9=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].deleteTeacher(this.state.userId).then(function(response){if(response.success){_this9.setState({modalDialog:true,responseContent:'Teacher Successfully Deleted!'});setTimeout(function(){_this9.setState({modalDialog:false});_this9.props.handleCancel();_this9.props.handleTeacherUpdated();},3500);}else{alert(response.msg);}},function(error){alert(error.msg);});}},{key:'render',value:function render(){var _this10=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this10.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteTeacher,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this10.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherName'},'First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.firstname,onChange:this.handleName,id:'inputTeacherName',className:'form-control',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherLastName'},'Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.lastname,onChange:this.handleLastName,id:'inputTeacherLastName',className:'form-control',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherUserId'},'User Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.userId,onChange:this.handleUserId,id:'inputTeacherUserId',className:'form-control',placeholder:'UserID',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:'68%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{id:"updateTeacherSchool",onChange:function onChange(newValue){_this10.setState({schoolId:newValue.value});},options:this.props.schoolOptions,placeholder:"Select a school...",value:getValue(this.props.schoolOptions,this.state.schoolId)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{width:'30%'}},' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'inline-block',position:'relative',width:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'cbResearcher',className:'cb '},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleReseacher,name:'researcher',checked:this.state.researcher,id:'cbResearcher'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'checkmark'}),' Researcher')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(event){_this10.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TEACHER?'});event.stopPropagation();},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete Teacher'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save Changes'))));}}]);return UpdateTeacherComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var TeachersListComponent=function(_Component4){_inherits(TeachersListComponent,_Component4);function TeachersListComponent(){var _ref9;var _temp,_this11,_ret;_classCallCheck(this,TeachersListComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this11=_possibleConstructorReturn(this,(_ref9=TeachersListComponent.__proto__||Object.getPrototypeOf(TeachersListComponent)).call.apply(_ref9,[this].concat(args))),_this11),_this11.handleItemClick=function(object){_this11.props.handleItemClick(object);},_this11.handleEditClick=function(object){_this11.props.handleEditClick(object);},_temp),_possibleConstructorReturn(_this11,_ret);}_createClass(TeachersListComponent,[{key:'render',value:function render(){var _this12=this;var items=this.props.teachers;var teachers=items.map(function(item){if(item.user){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TeachersListItemComponent,{key:item.id,item:item,active:_this12.props.clickedTeacherID===item.id?"active":"",handleClick:_this12.handleItemClick,handleEditClick:_this12.handleEditClick});}else return null;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,teachers));}}]);return TeachersListComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var TeachersListItemComponent=function(_Component5){_inherits(TeachersListItemComponent,_Component5);function TeachersListItemComponent(props){_classCallCheck(this,TeachersListItemComponent);var _this13=_possibleConstructorReturn(this,(TeachersListItemComponent.__proto__||Object.getPrototypeOf(TeachersListItemComponent)).call(this,props));_this13.handleClick=_this13.handleClick.bind(_this13);_this13.handleEditClick=_this13.handleEditClick.bind(_this13);return _this13;}_createClass(TeachersListItemComponent,[{key:'handleClick',value:function handleClick(event){this.props.handleClick(this.props.item);event.preventDefault();}},{key:'handleEditClick',value:function handleEditClick(event){this.props.handleEditClick(this.props.item);event.preventDefault();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:"clickable-row "+this.props.active},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:this.handleClick},this.props.item.user.lastname,', ',this.props.item.user.firstname,'  '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{onClick:this.handleEditClick,src:__WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png___default.a,alt:'View Icon',border:'0',className:'ico-xs'}))));}}]);return TeachersListItemComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ClassListComponent=function(_Component6){_inherits(ClassListComponent,_Component6);function ClassListComponent(){var _ref10;var _temp2,_this14,_ret2;_classCallCheck(this,ClassListComponent);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this14=_possibleConstructorReturn(this,(_ref10=ClassListComponent.__proto__||Object.getPrototypeOf(ClassListComponent)).call.apply(_ref10,[this].concat(args))),_this14),_this14.handleItemClick=function(object){_this14.props.handleItemClick(object);},_temp2),_possibleConstructorReturn(_this14,_ret2);}_createClass(ClassListComponent,[{key:'render',value:function render(){var _this15=this;var items=this.props.classes;var classes=items.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClassItemComponent,{key:item.id,item:item,active:_this15.props.clickedClassID===item.id?"active":"",handleClick:_this15.handleItemClick,deleteClass:_this15.props.deleteClass});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,classes));}}]);return ClassListComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ClassItemComponent=function(_Component7){_inherits(ClassItemComponent,_Component7);function ClassItemComponent(props){_classCallCheck(this,ClassItemComponent);var _this16=_possibleConstructorReturn(this,(ClassItemComponent.__proto__||Object.getPrototypeOf(ClassItemComponent)).call(this,props));_this16.handleClick=_this16.handleClick.bind(_this16);_this16.deleteClass=_this16.deleteClass.bind(_this16);return _this16;}_createClass(ClassItemComponent,[{key:'handleClick',value:function handleClick(event){this.props.handleClick(this.props.item);event.preventDefault();}},{key:'deleteClass',value:function deleteClass(event){var confirmed=window.confirm("Are you sure that you want to delete this class ?");if(confirmed){this.props.deleteClass(this.props.item);}event.stopPropagation();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:"clickable-row "+this.props.active,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.item.name));}}]);return ClassItemComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var ClassNavigation=function(_Component8){_inherits(ClassNavigation,_Component8);function ClassNavigation(props){_classCallCheck(this,ClassNavigation);var _this17=_possibleConstructorReturn(this,(ClassNavigation.__proto__||Object.getPrototypeOf(ClassNavigation)).call(this,props));_this17.handleStudentClick=function(student,classId){_this17.props.studentClick(student,classId);};_this17.handleAddStudent=function(){_this17.props.handleAddStudent(_this17.state.class.id);};_this17.handleCancel=function(){_this17.setState({listStudents:true,listMultipleStudents:false});};_this17.handleUpdateClass=function(object){_this17.props.updateClassCallback(object);};_this17.state={class:_this17.props.class,listStudents:true,listMultipleStudents:false};_this17.handleStudentsTab=_this17.handleStudentsTab.bind(_this17);_this17.handleMultipleStudentsTab=_this17.handleMultipleStudentsTab.bind(_this17);_this17.handleClassTab=_this17.handleClassTab.bind(_this17);return _this17;}_createClass(ClassNavigation,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.students!==newProps.students){this.setState({listStudents:true,listMultipleStudents:false});}}},{key:'handleStudentsTab',value:function handleStudentsTab(event){this.setState({listStudents:true,listMultipleStudents:false});event.preventDefault();}},{key:'handleMultipleStudentsTab',value:function handleMultipleStudentsTab(event){this.setState({listStudents:false,listMultipleStudents:true});event.preventDefault();}},{key:'handleClassTab',value:function handleClassTab(event){this.setState({listStudents:false,listMultipleStudents:false});// event.preventDefault();
}},{key:'listStudents',value:function listStudents(){var _this18=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listStudents(this.props.class.id).then(function(response){if(response.success){_this18.setState({students:response.body});}else{_this18.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this18.setState({modalDialog:false});},3500);}},function(error){console.log('List students error',error);_this18.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this18.setState({modalDialog:false});},3500);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},this.state.listStudents?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StudentsList,{handleClassTab:this.handleClassTab,handleMultipleStudentsTab:this.handleMultipleStudentsTab,classId:this.state.class.id,handleAddStudent:this.handleAddStudent,students:this.props.students,handleItemClick:this.handleStudentClick,deleteStudent:this.props.deleteStudent}):this.state.listMultipleStudents?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MultipleStudents,{handleStudentsTab:this.handleStudentsTab,handleClassTab:this.handleClassTab,classId:this.state.class.id,handleAddStudent:this.handleAddStudent,students:this.props.students,handleItemClick:this.handleStudentClick,deleteStudent:this.props.deleteStudent}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav nav-tabs'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Students')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'active',onClick:this.handleClassTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Class Info')))));}}]);return ClassNavigation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var StudentsList=function(_Component9){_inherits(StudentsList,_Component9);function StudentsList(props){var _this20=this;_classCallCheck(this,StudentsList);var _this19=_possibleConstructorReturn(this,(StudentsList.__proto__||Object.getPrototypeOf(StudentsList)).call(this,props));_this19.handleItemClick=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return _this19.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_14__Shared_DataTrackingPoints__["b" /* default */].TEACHER_STUDENT_DETAILS_VIEW,metadata:{userId:student.userId}}},function(){_this19.handleAnalytics();_this19.props.handleItemClick(student,_this19.props.classId);});case 2:case'end':return _context9.stop();}}},_callee9,_this20);}));return function(_x6){return _ref11.apply(this,arguments);};}();_this19.state={showAddStudentHint:true,analytics:{type:null,metadata:null}};_this19.handleItemClick=_this19.handleItemClick.bind(_this19);_this19.handleClassTab=_this19.handleClassTab.bind(_this19);_this19.handleAddStudent=_this19.handleAddStudent.bind(_this19);_this19.handleAddStudentHint=_this19.handleAddStudentHint.bind(_this19);_this19.getTarget=_this19.getTarget.bind(_this19);_this19.handleAnalytics=_this19.handleAnalytics.bind(_this19);return _this19;}_createClass(StudentsList,[{key:'componentDidMount',value:function componentDidMount(){if(localStorage.getItem('addStudent')==='hide'){this.setState({showAddStudentHint:false});}}},{key:'handleAddStudentHint',value:function handleAddStudentHint(){this.setState({showAddStudentHint:!this.state.showAddStudentHint});}},{key:'getTarget',value:function getTarget(){return __WEBPACK_IMPORTED_MODULE_13_react_dom___default.a.findDOMNode(this.target);}},{key:'handleClassTab',value:function handleClassTab(event){this.props.handleClassTab();}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleAddStudent',value:function handleAddStudent(event){this.props.handleAddStudent();this.handleAddStudentHint();localStorage.setItem('addStudent','hide');event.preventDefault();}},{key:'render',value:function render(){var _this21=this;var sharedProps={container:this,target:this.getTarget,show:this.state.showAddStudentHint};var items=this.props.students;var students=items.map(function(student){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StudentListItem,{key:student.id,student:student,handleClick:_this21.handleItemClick,deleteStudent:_this21.props.deleteStudent});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav nav-tabs'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'active',onClick:this.handleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Students')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.props.handleMultipleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Share/Transfer Students'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 col-md-12 solidBorder noPadding scrollable',style:{maxHeight:450,height:450}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Full Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},'User Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},'Password'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,students))));}}]);return StudentsList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var StudentListItem=function(_Component10){_inherits(StudentListItem,_Component10);function StudentListItem(props){_classCallCheck(this,StudentListItem);var _this22=_possibleConstructorReturn(this,(StudentListItem.__proto__||Object.getPrototypeOf(StudentListItem)).call(this,props));_this22.deleteStudent=function(confirm){if(confirm){_this22.props.deleteStudent(_this22.props.student);}};_this22.state={modalDialog:false,responseContent:''};_this22.handleClick=_this22.handleClick.bind(_this22);_this22.deleteStudent=_this22.deleteStudent.bind(_this22);return _this22;}_createClass(StudentListItem,[{key:'handleClick',value:function handleClick(event){this.props.handleClick(this.props.student);event.stopPropagation();}},{key:'render',value:function render(){var _this23=this;var student=this.props.student;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{modalOpen:this.state.modalDialog,confirmDelete:this.deleteStudent,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this23.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:this.handleClick},student.user.firstname,' ',student.user.lastname),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:this.handleClick},student.userId),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:this.handleClick},student.user.password));}}]);return StudentListItem;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var MultipleStudentsList=function(_Component11){_inherits(MultipleStudentsList,_Component11);function MultipleStudentsList(props){var _this25=this;_classCallCheck(this,MultipleStudentsList);var _this24=_possibleConstructorReturn(this,(MultipleStudentsList.__proto__||Object.getPrototypeOf(MultipleStudentsList)).call(this,props));_this24.handleSelect=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(studentId,isChecked){var checkList,i,studentIds,_i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:checkList=_this24.state.checkList;for(i=0;i<checkList.length;i++){if(checkList[i].studentId==studentId){checkList[i].checked=isChecked;}}studentIds=[];for(_i=0;_i<checkList.length;_i++){if(checkList[_i].checked){studentIds.push(checkList[_i].studentId);}}_this24.setState({checkList:checkList,studentIds:studentIds});case 5:case'end':return _context10.stop();}}},_callee10,_this25);}));return function(_x7,_x8){return _ref12.apply(this,arguments);};}();_this24.state={showAddStudentHint:true,showTeacherInfo:false,showClassList:false,allChecked:false,checkList:[],studentIds:[],students:_this24.props.students,analytics:{type:null,metadata:null}};_this24.sortStudentsByName=_this24.sortStudentsByName.bind(_this24);_this24.sortStudentsByUserId=_this24.sortStudentsByUserId.bind(_this24);_this24.handleSelect=_this24.handleSelect.bind(_this24);_this24.handleClassTab=_this24.handleClassTab.bind(_this24);_this24.handleContinue=_this24.handleContinue.bind(_this24);_this24.handleAllChecked=_this24.handleAllChecked.bind(_this24);_this24.handleCancelTransfer=_this24.handleCancelTransfer.bind(_this24);return _this24;}_createClass(MultipleStudentsList,[{key:'componentDidMount',value:function componentDidMount(){var students=this.props.students;var checkList=[];students.forEach(function(student){checkList.push({studentId:student.id,checked:false});});this.setState({checkList:checkList});}},{key:'handleClassTab',value:function handleClassTab(event){this.props.handleClassTab();}},{key:'sortStudentsByUserId',value:function sortStudentsByUserId(){this.setState({students:this.state.students.sort(function(a,b){return a.userId>b.userId?1:a.userId<b.userId?-1:0;})});}},{key:'sortStudentsByName',value:function sortStudentsByName(){this.setState({students:this.state.students.sort(function(a,b){var nameA=a.user.firstname+' '+a.user.lastname;var nameB=b.user.firstname+' '+b.user.lastname;return nameA>nameB?1:nameA<nameB?-1:0;})});}},{key:'handleContinue',value:function handleContinue(){this.setState({showTeacherInfo:true});}},{key:'handleAllChecked',value:function handleAllChecked(){var newCheckStatus=!this.state.allChecked;var students=this.state.students;var checkList=[];students.forEach(function(student){if(newCheckStatus){checkList.push({studentId:student.id,checked:true});}else{checkList.push({studentId:student.id,checked:false});}});var studentIds=[];for(var i=0;i<checkList.length;i++){if(checkList[i].checked){studentIds.push(checkList[i].studentId);}}this.setState({studentIds:studentIds,checkList:checkList,allChecked:newCheckStatus});}},{key:'handleCancelTransfer',value:function handleCancelTransfer(){this.setState({showTeacherInfo:false});}},{key:'render',value:function render(){var _this26=this;var sharedProps={container:this,target:this.getTarget,show:this.state.showAddStudentHint};var items=this.state.students;var students=items.map(function(student){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MultipleStudentListItem,{key:student.id,student:student,checked:getChecked(_this26.state.checkList,student.id),handleSelect:_this26.handleSelect});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav nav-tabs'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.props.handleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Students')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'active',onClick:this.handleMultipleStudentsTab},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'tab'},'Share/Transfer Students'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tab-pane active solidBorder noPadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'You can share or transfer students to another teacher.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Step 1: Select the students to share or transfer'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleAllChecked,name:'selectStudent',checked:this.state.allChecked,id:'allChecked'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortStudentsByName},'Full Name')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortStudentsByUserId},'User Number')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,students))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleContinue,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Continue'))),this.state.showTeacherInfo?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TransferStudentComponent,{schoolAdmin:this.props.schoolAdmin,studentIds:this.state.studentIds,handleCancelTransfer:this.handleCancelTransfer})):null);}}]);return MultipleStudentsList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var MultipleStudents=Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* withRouter */])(MultipleStudentsList);var MultipleStudentListItem=function(_Component12){_inherits(MultipleStudentListItem,_Component12);function MultipleStudentListItem(props){var _this28=this;_classCallCheck(this,MultipleStudentListItem);var _this27=_possibleConstructorReturn(this,(MultipleStudentListItem.__proto__||Object.getPrototypeOf(MultipleStudentListItem)).call(this,props));_this27.handleSelectStudent=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(studentId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return _this27.setState({isSelected:!_this27.state.isSelected});case 2:_this27.props.handleSelect(studentId,_this27.state.isSelected);case 3:case'end':return _context11.stop();}}},_callee11,_this28);}));return function(_x9){return _ref13.apply(this,arguments);};}();_this27.state={isSelected:_this27.props.checked};_this27.handleSelectStudent=_this27.handleSelectStudent.bind(_this27);return _this27;}_createClass(MultipleStudentListItem,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.checked!==newProps.checked){this.setState({isSelected:newProps.checked});}}},{key:'render',value:function render(){var _this29=this;var student=this.props.student;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(){return _this29.handleSelectStudent(student.id);},name:'selectStudent',checked:this.state.isSelected,id:'checkSelected'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:function onClick(){return _this29.handleSelectStudent(student.id);}},student.user.firstname,' ',student.user.lastname),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{onClick:function onClick(){return _this29.handleSelectStudent(student.id);}},student.userId));}}]);return MultipleStudentListItem;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var TransferStudentComponent=Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* withRouter */])(function(_Component13){_inherits(TransferStudentComponent,_Component13);function TransferStudentComponent(props){_classCallCheck(this,TransferStudentComponent);var _this30=_possibleConstructorReturn(this,(TransferStudentComponent.__proto__||Object.getPrototypeOf(TransferStudentComponent)).call(this,props));_this30.handleBackClick=function(){if(_this30.props.schoolAdmin){_this30.props.history.push("/school-admin");}else{_this30.props.history.push("/teacher");}};_this30.handleCorrectTeacherData=function(data){_this30.setState({teacherId:data.teacher.id,classes:data.teacher.classes});};_this30.handleCancelTransfer=function(){_this30.props.handleCancelTransfer();};_this30.handleClassSelect=function(classId){_this30.setState({classId:parseInt(classId)});};_this30.state={teacherId:0,classId:0,studentId:_this30.props.studentId,studentIds:_this30.props.studentIds,classes:[],share:false,modalDialog:false,responseContent:''};_this30.handleDone=_this30.handleDone.bind(_this30);_this30.handleCancelTransfer=_this30.handleCancelTransfer.bind(_this30);_this30.handleBackClick=_this30.handleBackClick.bind(_this30);return _this30;}_createClass(TransferStudentComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.studentIds!==newProps.studentIds){this.setState({studentIds:newProps.studentIds});}}},{key:'handleDone',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(event,share){var _this31=this;var promptText;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:promptText=void 0;if(share){promptText='Are you sure you wish to share the students?';}else{promptText='Are you sure you wish to transfer the students?';}if(!window.confirm(promptText)){_context12.next=6;break;}_context12.next=5;return this.setState({share:share});case 5:__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].transferMultipleStudents(this.state).then(function(response){_this31.setState({modalDialog:true,responseContent:_this31.state.share?'Student has been shared Successfully!':'Student has been transferred Successfully!'});},function(error){console.log('transfer student error',error);});case 6:case'end':return _context12.stop();}}},_callee12,this);}));function handleDone(_x10,_x11){return _ref14.apply(this,arguments);}return handleDone;}()},{key:'render',value:function render(){var _this32=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this32.setState({modalDialog:active});window.location.reload();}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TeacherInfoTransferComponent,{correctTeacherData:this.handleCorrectTeacherData,handleCancelTransfer:this.handleCancelTransfer}),this.state.classes&&this.state.classes.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TeacherClassTransferComponent,{classes:this.state.classes,handleClassSelect:this.handleClassSelect}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancelTransfer,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(e){return _this32.handleDone(e,false);},disabled:this.state.classId===0,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Transfer')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(e){return _this32.handleDone(e,true);},disabled:this.state.classId===0,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Share')))):null);}}]);return TransferStudentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));var TeacherInfoTransferComponent=function(_Component14){_inherits(TeacherInfoTransferComponent,_Component14);function TeacherInfoTransferComponent(props){_classCallCheck(this,TeacherInfoTransferComponent);var _this33=_possibleConstructorReturn(this,(TeacherInfoTransferComponent.__proto__||Object.getPrototypeOf(TeacherInfoTransferComponent)).call(this,props));_this33.state={firstName:'',lastName:'',teacherId:'',hideButtons:false,modalDialog:false,responseContent:''};_this33.handleFirstName=_this33.handleFirstName.bind(_this33);_this33.handleLastName=_this33.handleLastName.bind(_this33);_this33.handleLoginID=_this33.handleLoginID.bind(_this33);_this33.handleCancel=_this33.handleCancel.bind(_this33);_this33.handleContinue=_this33.handleContinue.bind(_this33);return _this33;}_createClass(TeacherInfoTransferComponent,[{key:'handleFirstName',value:function handleFirstName(event){this.setState({firstName:event.target.value.replace(/\s+/g,'')});}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastName:event.target.value.replace(/\s+/g,'')});}},{key:'handleLoginID',value:function handleLoginID(event){event.target.value=event.target.value.replace(/[^0-9.]+/g,'');this.setState({teacherId:event.target.value});}},{key:'validate',value:function validate(){var valid=true;if(this.state.firstName.length===0){valid=false;document.getElementById("inputTeacherName").classList.add('validationRed');}else{document.getElementById("inputTeacherName").classList.remove('validationRed');}if(this.state.lastName.length===0){valid=false;document.getElementById("inputTeacherLastName").classList.add('validationRed');}else{document.getElementById("inputTeacherLastName").classList.remove('validationRed');}if(this.state.teacherId.length===0||this.state.teacherId===null){valid=false;document.getElementById("inputTeacherLoginID").classList.add('validationRed');}else{document.getElementById("inputTeacherLoginID").classList.remove('validationRed');}return valid;}},{key:'handleContinue',value:function handleContinue(event){if(this.validate()){document.getElementById("validWarning").classList.add("hidden");this.listExternalTeacher();}else{document.getElementById("validWarning").classList.remove("hidden");}}},{key:'listExternalTeacher',value:function listExternalTeacher(){var _this34=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listExternalTeacher(this.state).then(function(response){if(response.success&&response.body){_this34.props.correctTeacherData(response.body);_this34.setState({hideButtons:true});}else if(response.success){_this34.setState({modalDialog:true,responseContent:'This teacher doesn\'t have any classes.'});}else{_this34.setState({modalDialog:true,responseContent:'Incorrect input! Check it and retry!'});}},function(error){console.log('Error',error);});}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancelTransfer();}},{key:'render',value:function render(){var _this35=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this35.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Step 2: Share/ transfer students with a teacher'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Enter the new teacher\'s first name, last name and user number for AvePM. Then you will be asked to select the new class name for the students.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:"validWarning",className:"hidden",style:{color:'red',paddingBottom:10}},' Fields with red outline have to be filled in or selected!'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherName'},'Teacher First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleFirstName,id:'inputTeacherName',className:'form-control ',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherLastName'},'Teacher Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleLastName,id:'inputTeacherLastName',className:'form-control ',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTeacherLoginID'},'Teacher User Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onInput:this.handleLoginID,id:'inputTeacherLoginID',className:'form-control ',placeholder:'User Number',required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),this.state.hideButtons?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleContinue,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Continue'))));}}]);return TeacherInfoTransferComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var TeacherClassTransferComponent=function(_Component15){_inherits(TeacherClassTransferComponent,_Component15);function TeacherClassTransferComponent(props){_classCallCheck(this,TeacherClassTransferComponent);var _this36=_possibleConstructorReturn(this,(TeacherClassTransferComponent.__proto__||Object.getPrototypeOf(TeacherClassTransferComponent)).call(this,props));_this36.state={classes:_this36.props.classes||[]};_this36.handleClassSelect=_this36.handleClassSelect.bind(_this36);return _this36;}_createClass(TeacherClassTransferComponent,[{key:'handleClassSelect',value:function handleClassSelect(event){this.props.handleClassSelect(event.value);}},{key:'render',value:function render(){var options=[];options[0]=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:0,value:0},'Select a class');for(var i=0;i<this.state.classes.length;i++){var c=this.state.classes[i];// options[i + 1] = <option key={c.id} value={c.id}>{c.name}</option>;
options.push({value:c.id,label:c.name});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{marginTop:5}},'Step 3: In the drop down list, select a class into which the student will be placed.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{onChange:this.handleClassSelect,id:'classes',name:'classes',options:options,isSearchable:false}));}}]);return TeacherClassTransferComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{selectSchool:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(selectedSchool){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__TeachersComponent_actions__["c" /* selectSchool */])(selectedSchool));case 2:return _context13.abrupt('return',_context13.sent);case 3:case'end':return _context13.stop();}}},_callee13,_this37);}));function selectSchool(_x12){return _ref15.apply(this,arguments);}return selectSchool;}(),selectTeacher:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(selectedTeacher){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__TeachersComponent_actions__["f" /* selectTeacher */])(selectedTeacher));case 2:return _context14.abrupt('return',_context14.sent);case 3:case'end':return _context14.stop();}}},_callee14,_this37);}));function selectTeacher(_x13){return _ref16.apply(this,arguments);}return selectTeacher;}(),selectClass:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(selectedClass){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__TeachersComponent_actions__["b" /* selectClass */])(selectedClass));case 2:return _context15.abrupt('return',_context15.sent);case 3:case'end':return _context15.stop();}}},_callee15,_this37);}));function selectClass(_x14){return _ref17.apply(this,arguments);}return selectClass;}(),updateStudent:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(selectedStudent){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__TeachersComponent_actions__["h" /* updateStudent */])(selectedStudent));case 2:return _context16.abrupt('return',_context16.sent);case 3:case'end':return _context16.stop();}}},_callee16,_this37);}));function updateStudent(_x15){return _ref18.apply(this,arguments);}return updateStudent;}(),updateTeacher:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__TeachersComponent_actions__["i" /* updateTeacher */])(data));case 2:return _context17.abrupt('return',_context17.sent);case 3:case'end':return _context17.stop();}}},_callee17,_this37);}));function updateTeacher(_x16){return _ref19.apply(this,arguments);}return updateTeacher;}(),userLogout:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__TeachersComponent_actions__["j" /* userLogout */])());case 2:return _context18.abrupt('return',_context18.sent);case 3:case'end':return _context18.stop();}}},_callee18,_this37);}));function userLogout(){return _ref20.apply(this,arguments);}return userLogout;}()};};var mapStateToProps=function mapStateToProps(state){return{lastSchool:state.teacherReducer.lastSchool,lastTeacher:state.teacherReducer.lastTeacher,lastClass:state.teacherReducer.lastClass,lastStudent:state.teacherReducer.student,teacher:state.teacherReducer.teacher,schoolAdmin:state.teacherReducer.schoolAdmin};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* withRouter */])(SchoolAdminComponent)));

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_ico_plus_green_png__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_ico_plus_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_ico_plus_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_view_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_view_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_ico_view_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tooltipSchools=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["i" /* Tooltip */],{id:'tooltipSchools'},'Multiple Select Option');var getValue=function getValue(opts,val){return opts.find(function(o){return o.value==val;});};var addClassInstruction=null;var addStudentInstruction=null;var schoolOptions=[];var SchoolManagementComponent=function(_Component){_inherits(SchoolManagementComponent,_Component);function SchoolManagementComponent(props){var _this2=this;_classCallCheck(this,SchoolManagementComponent);var _this=_possibleConstructorReturn(this,(SchoolManagementComponent.__proto__||Object.getPrototypeOf(SchoolManagementComponent)).call(this,props));_this.setSchoolAdmins=function(object){_this.setState({schoolAdmins:object});};_this.handleCancel=function(){_this.setState({addSchoolAdmin:false,editSchoolAdmin:false});};_this.handleSchoolAdminItemClick=function(object){_this.setState({addSchoolAdmin:false,editSchoolAdmin:true,schoolAdminToEdit:null});_this.handleAddSchoolAdmin();_this.setState({addSchoolAdmin:false,editSchoolAdmin:true,schoolAdminToEdit:object});console.log(object);};_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].logout().then(function(response){if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_this.props.history.push("/login");},function(error){localStorage.removeItem('token');localStorage.clear();_this.props.history.push("/login");});};_this.schoolAdminAdded=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.listSchoolAdmins();case 1:case'end':return _context.stop();}}},_callee,_this2);}));_this.state={schoolAdmins:[],schoolAdminToEdit:{},addSchoolAdmin:false,editSchoolAdmin:false};_this.handleAddSchoolAdmin=_this.handleAddSchoolAdmin.bind(_this);return _this;}_createClass(SchoolManagementComponent,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:this.listSchoolAdmins();_context3.next=3;return __WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].listSchools().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){var data,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,school;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!response.success){_context2.next=24;break;}schoolOptions=[];data=response.body;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=6;for(_iterator=data[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){school=_step.value;schoolOptions.push({value:school.id,label:school.name});}_context2.next=14;break;case 10:_context2.prev=10;_context2.t0=_context2['catch'](6);_didIteratorError=true;_iteratorError=_context2.t0;case 14:_context2.prev=14;_context2.prev=15;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 17:_context2.prev=17;if(!_didIteratorError){_context2.next=20;break;}throw _iteratorError;case 20:return _context2.finish(17);case 21:return _context2.finish(14);case 22:_context2.next=25;break;case 24:console.log('Error',response.msg);case 25:case'end':return _context2.stop();}}},_callee2,_this3,[[6,10,14,22],[15,,17,21]]);}));return function(_x){return _ref3.apply(this,arguments);};}(),function(error){console.log('Error',error.msg);});case 3:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'listSchoolAdmins',value:function listSchoolAdmins(){var _this4=this;__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].listSchoolAdmins().then(function(response){if(response.success){_this4.setSchoolAdmins(response.body);}else{console.log('Error',response.msg);}},function(error){console.log('Error',error.msg);});}},{key:'handleAddSchoolAdmin',value:function handleAddSchoolAdmin(event){this.setState({addSchoolAdmin:!this.state.addSchoolAdmin,editSchoolAdmin:false});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_Header__["a" /* default */],{schoolManagement:true,logout:this.handleLogout}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-10"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'fl'},'School Admins')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_ico_plus_green_png___default.a,onClick:this.handleAddSchoolAdmin,alt:'Plus Icon',border:'0',className:'ico-xs ico-add'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 col-md-12 solidBorder noPadding scrollable'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SchoolAdminsListComponent,{schoolAdmins:this.state.schoolAdmins,handleItemClick:this.handleSchoolAdminItemClick}))),this.state.addSchoolAdmin?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-9 container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AddSchoolAdminComponent,{handleSchoolAdminAdded:this.schoolAdminAdded,handleCancel:this.handleCancel})):null,this.state.editSchoolAdmin?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-9 container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(UpdateSchoolAdminComponent,{handleSchoolAdminUpdated:this.schoolAdminAdded,schoolAdmin:this.state.schoolAdminToEdit,handleCancel:this.handleCancel})):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_Footer__["a" /* default */],null));}}]);return SchoolManagementComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var AddSchoolAdminComponent=function(_Component2){_inherits(AddSchoolAdminComponent,_Component2);function AddSchoolAdminComponent(props){_classCallCheck(this,AddSchoolAdminComponent);var _this5=_possibleConstructorReturn(this,(AddSchoolAdminComponent.__proto__||Object.getPrototypeOf(AddSchoolAdminComponent)).call(this,props));_this5.state={firstname:'',lastname:'',email:'',modalDialog:false,responseContent:'',schools:[]};_this5.handleName=_this5.handleName.bind(_this5);_this5.handleLastName=_this5.handleLastName.bind(_this5);_this5.handleEmail=_this5.handleEmail.bind(_this5);_this5.handleSchoolsChange=_this5.handleSchoolsChange.bind(_this5);_this5.handleCancel=_this5.handleCancel.bind(_this5);_this5.handleSave=_this5.handleSave.bind(_this5);return _this5;}_createClass(AddSchoolAdminComponent,[{key:'handleName',value:function handleName(event){this.setState({firstname:event.target.value});event.preventDefault();}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastname:event.target.value});event.preventDefault();}},{key:'handleEmail',value:function handleEmail(event){this.setState({email:event.target.value});event.preventDefault();}},{key:'handleSchoolsChange',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(value){var values,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,opt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:values=[];_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context4.prev=4;for(_iterator2=value[Symbol.iterator]();!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){opt=_step2.value;values.push(opt.value);}_context4.next=12;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](4);_didIteratorError2=true;_iteratorError2=_context4.t0;case 12:_context4.prev=12;_context4.prev=13;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 15:_context4.prev=15;if(!_didIteratorError2){_context4.next=18;break;}throw _iteratorError2;case 18:return _context4.finish(15);case 19:return _context4.finish(12);case 20:_context4.next=22;return this.setState({schools:values});case 22:case'end':return _context4.stop();}}},_callee4,this,[[4,8,12,20],[13,,15,19]]);}));function handleSchoolsChange(_x2){return _ref4.apply(this,arguments);}return handleSchoolsChange;}()},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();}},{key:'handleSave',value:function handleSave(event){var _this6=this;__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].createSchoolAdmin(this.state).then(function(response){if(response.success){_this6.setState({modalDialog:true,responseContent:'School Admin Successfully Added!'});setTimeout(function(){_this6.setState({modalDialog:false});_this6.props.handleCancel();},2500);_this6.props.handleSchoolAdminAdded();_this6.myFormRef.reset();}else{_this6.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this6.setState({modalDialog:false});},2500);}},function(error){_this6.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this6.setState({modalDialog:false});},2500);});}},{key:'render',value:function render(){var _this7=this,_React$createElement;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this7.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:'formAddSchoolAdmin',ref:function ref(el){return _this7.myFormRef=el;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputSchoolAdminName'},'First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleName,id:'inputSchoolAdminName',className:'form-control',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputSchoolAdminLastName'},'Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleLastName,id:'inputSchoolAdminLastName',className:'form-control',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputSchoolAdminEmail'},'Email'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleEmail,id:'inputSchoolAdminEmail',className:'form-control',placeholder:'Email',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputAdminSchools'},'Schools'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* OverlayTrigger */],{placement:'top',overlay:tooltipSchools},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],(_React$createElement={onChange:this.handleSchoolsChange,id:'inputAdminSchools',className:'basic-multi-select',options:schoolOptions},_defineProperty(_React$createElement,'className',this.state.schoolError),_defineProperty(_React$createElement,'isMulti',true),_defineProperty(_React$createElement,'isSearchable',false),_React$createElement))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save Changes'))));}}]);return AddSchoolAdminComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var UpdateSchoolAdminComponent=function(_Component3){_inherits(UpdateSchoolAdminComponent,_Component3);function UpdateSchoolAdminComponent(props){_classCallCheck(this,UpdateSchoolAdminComponent);var _this8=_possibleConstructorReturn(this,(UpdateSchoolAdminComponent.__proto__||Object.getPrototypeOf(UpdateSchoolAdminComponent)).call(this,props));_this8.deleteSchoolAdmin=function(confirm){if(confirm){_this8.handleDelete();}_this8.setState({modalDialogDelete:false});};_this8.state={firstname:_this8.props.schoolAdmin.user.firstname,lastname:_this8.props.schoolAdmin.user.lastname,email:_this8.props.schoolAdmin.user.email,userId:_this8.props.schoolAdmin.userId,schools:[],schoolRecords:_this8.props.schoolAdmin.schools,modalDialog:false,modalDialogDelete:false,schoolValues:[]};_this8.getSchools=_this8.getSchools.bind(_this8);_this8.getSchoolValues=_this8.getSchoolValues.bind(_this8);_this8.handleFirstName=_this8.handleFirstName.bind(_this8);_this8.handleLastName=_this8.handleLastName.bind(_this8);_this8.handleEmail=_this8.handleEmail.bind(_this8);_this8.handleUserId=_this8.handleUserId.bind(_this8);_this8.handleSchoolsChange=_this8.handleSchoolsChange.bind(_this8);_this8.handleCancel=_this8.handleCancel.bind(_this8);_this8.handleSave=_this8.handleSave.bind(_this8);_this8.handleDelete=_this8.handleDelete.bind(_this8);_this8.deleteSchoolAdmin=_this8.deleteSchoolAdmin.bind(_this8);return _this8;}_createClass(UpdateSchoolAdminComponent,[{key:'componentDidMount',value:function componentDidMount(){this.setState({firstname:this.props.schoolAdmin.user.firstname,lastname:this.props.schoolAdmin.user.lastname,email:this.props.schoolAdmin.user.email,userId:this.props.schoolAdmin.userId,schoolValues:[],modalDialog:false,modalDialogDelete:false});this.getSchools(this.props.schoolAdmin.schools);}},{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.schoolAdmin.userId!==newProps.schoolAdmin.userId){this.setState({firstname:this.props.schoolAdmin.user.firstname,lastname:this.props.schoolAdmin.user.lastname,email:this.props.schoolAdmin.user.email,userId:this.props.schoolAdmin.userId,schoolValues:[],modalDialog:false,modalDialogDelete:false});this.getSchools(this.props.schoolAdmin.schools);}}},{key:'getSchools',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(values){var schools,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:schools=[];for(i=0;i<values.length;i++){schools[i]=parseInt(values[i].id);}_context5.next=4;return this.setState({schools:schools});case 4:return _context5.abrupt('return',false);case 5:case'end':return _context5.stop();}}},_callee5,this);}));function getSchools(_x3){return _ref5.apply(this,arguments);}return getSchools;}()},{key:'getSchoolValues',value:function getSchoolValues(values){var valueArray=values.split(',');this.state.schoolValues=[];for(var i=0;i<valueArray.length;i++){this.state.schoolValues.push(getValue(schoolOptions,valueArray[i]));}return false;}},{key:'handleSchoolsChange',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(value){var values,_iteratorNormalCompletion3,_didIteratorError3,_iteratorError3,_iterator3,_step3,opt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:values=[];_iteratorNormalCompletion3=true;_didIteratorError3=false;_iteratorError3=undefined;_context6.prev=4;for(_iterator3=value[Symbol.iterator]();!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){opt=_step3.value;values.push(opt.value);}_context6.next=12;break;case 8:_context6.prev=8;_context6.t0=_context6['catch'](4);_didIteratorError3=true;_iteratorError3=_context6.t0;case 12:_context6.prev=12;_context6.prev=13;if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}case 15:_context6.prev=15;if(!_didIteratorError3){_context6.next=18;break;}throw _iteratorError3;case 18:return _context6.finish(15);case 19:return _context6.finish(12);case 20:_context6.next=22;return this.setState({schools:values});case 22:case'end':return _context6.stop();}}},_callee6,this,[[4,8,12,20],[13,,15,19]]);}));function handleSchoolsChange(_x4){return _ref6.apply(this,arguments);}return handleSchoolsChange;}()},{key:'handleFirstName',value:function handleFirstName(event){this.setState({firstname:event.target.value.replace(/\s+/g,'')});event.preventDefault();}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastname:event.target.value.replace(/\s+/g,'')});event.preventDefault();}},{key:'handleEmail',value:function handleEmail(event){this.setState({email:event.target.value});event.preventDefault();}},{key:'handleUserId',value:function handleUserId(event){this.setState({userId:event.target.value});event.preventDefault();}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();event.preventDefault();}},{key:'handleSave',value:function handleSave(event){var _this9=this;__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].updateSchoolAdmin(this.state).then(function(response){if(response.success){_this9.setState({modalDialog:true,responseContent:'School Admin Data Successfully Updated!'});setTimeout(function(){_this9.setState({modalDialog:false});},2500);_this9.props.handleSchoolAdminUpdated();}else{alert(response.msg);}},function(error){alert(error.msg);});event.preventDefault();}},{key:'handleDelete',value:function handleDelete(event){var _this10=this;__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].deleteSchoolAdmin(this.state.userId).then(function(response){if(response.success){_this10.setState({modalDialog:true,responseContent:'School Admin Successfully Deleted!'});setTimeout(function(){_this10.setState({modalDialog:false});_this10.props.handleCancel();},2500);_this10.props.handleSchoolAdminUpdated();}else{alert(response.msg);}},function(error){alert(error.msg);});}},{key:'render',value:function render(){var _this11=this,_React$createElement2;this.getSchoolValues(this.state.schools.toString());return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this11.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteSchoolAdmin,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this11.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputSchoolAdminName'},'First Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.firstname,onChange:this.handleFirstName,id:'inputSchoolAdminName',className:'form-control',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputSchoolAdminLastName'},'Last Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.lastname,onChange:this.handleLastName,id:'inputSchoolAdminLastName',className:'form-control',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputSchoolAdminUserId'},'User Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.userId,onChange:this.handleUserId,id:'inputSchoolAdminUserId',className:'form-control',placeholder:'UserID',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputAdminSchools'},'Schools'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* OverlayTrigger */],{placement:'top',overlay:tooltipSchools},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],(_React$createElement2={onChange:this.handleSchoolsChange,id:'inputAdminSchools',value:this.state.schoolValues,className:'basic-multi-select',options:schoolOptions},_defineProperty(_React$createElement2,'className',this.state.schoolError),_defineProperty(_React$createElement2,'isMulti',true),_defineProperty(_React$createElement2,'isSearchable',false),_React$createElement2))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(event){_this11.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS SCHOOL ADMIN?'});event.stopPropagation();},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete School Admin'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save Changes'))));}}]);return UpdateSchoolAdminComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var SchoolAdminsListComponent=function(_Component4){_inherits(SchoolAdminsListComponent,_Component4);function SchoolAdminsListComponent(){var _ref7;var _temp,_this12,_ret;_classCallCheck(this,SchoolAdminsListComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this12=_possibleConstructorReturn(this,(_ref7=SchoolAdminsListComponent.__proto__||Object.getPrototypeOf(SchoolAdminsListComponent)).call.apply(_ref7,[this].concat(args))),_this12),_this12.handleItemClick=function(object){_this12.props.handleItemClick(object);},_temp),_possibleConstructorReturn(_this12,_ret);}_createClass(SchoolAdminsListComponent,[{key:'render',value:function render(){var _this13=this;var items=this.props.schoolAdmins;var schoolAdmins=items.map(function(item){if(item.user){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SchoolAdminsListItemComponent,{key:item.id,item:item,handleClick:_this13.handleItemClick});}else return null;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,schoolAdmins));}}]);return SchoolAdminsListComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var SchoolAdminsListItemComponent=function(_Component5){_inherits(SchoolAdminsListItemComponent,_Component5);function SchoolAdminsListItemComponent(props){_classCallCheck(this,SchoolAdminsListItemComponent);var _this14=_possibleConstructorReturn(this,(SchoolAdminsListItemComponent.__proto__||Object.getPrototypeOf(SchoolAdminsListItemComponent)).call(this,props));_this14.handleClick=_this14.handleClick.bind(_this14);return _this14;}_createClass(SchoolAdminsListItemComponent,[{key:'handleClick',value:function handleClick(event){this.props.handleClick(this.props.item);event.preventDefault();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.item.user.lastname,', ',this.props.item.user.firstname),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_ico_view_png___default.a,alt:'View Icon',border:'0',className:'ico-xs'}))));}}]);return SchoolAdminsListItemComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* withRouter */])(SchoolManagementComponent));

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_avenuepm_png__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_avenuepm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_avenuepm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StudentsComponent_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StudentsComponent_MyProfile__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Footer__ = __webpack_require__(31);
var _this5=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var addClassInstruction=null;var addStudentInstruction=null;var ParentComponent=function(_Component){_inherits(ParentComponent,_Component);function ParentComponent(props){_classCallCheck(this,ParentComponent);var _this=_possibleConstructorReturn(this,(ParentComponent.__proto__||Object.getPrototypeOf(ParentComponent)).call(this,props));_this.handleNext=function(){var studentAmount=_this.state.students.length;_this.state.currentStudentNo++;if(_this.state.currentStudentNo>=studentAmount){_this.state.currentStudentNo=0;}_this.showStudent(_this.state.currentStudentNo);};_this.handleSelect=function(selected){_this.props.updateStudentAccountTab(selected);_this.setState({activeTab:selected});};_this.state={students:null,currentStudentNo:0,currentStudent:null,isRefresh:false};_this.logout=_this.logout.bind(_this);_this.handleSelect=_this.handleSelect.bind(_this);_this.showStudent=_this.showStudent.bind(_this);return _this;}_createClass(ParentComponent,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__["a" /* default */].authorize(this);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getParentStudents().then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this2.setState({students:res.body});case 2:if(_this2.state.students){_this2.showStudent(_this2.state.currentStudentNo);}case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}());}},{key:'showStudent',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(studentNo){var _this3=this;var studentUser;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:studentUser={student:this.state.students[studentNo]};studentUser.student.personalUse=true;_context3.next=4;return this.props.updateStudentUser(studentUser);case 4:_context3.next=6;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentAppStatus(studentUser.student.userId).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var _Helpers$filterApps,allowedApps,filteredApps,finishedApps;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this3.props.updateStudentAppStatus(res.body);case 2:_Helpers$filterApps=__WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__["a" /* default */].filterApps(studentUser,res.body),allowedApps=_Helpers$filterApps.allowedApps,filteredApps=_Helpers$filterApps.filteredApps,finishedApps=_Helpers$filterApps.finishedApps;_context2.next=5;return _this3.props.updateAppStates({allowedApps:allowedApps,filteredApps:filteredApps,finishedApps:finishedApps});case 5:_this3.setState({currentStudent:studentUser.student,currentApps:res.body,isRefresh:true});case 6:case'end':return _context2.stop();}}},_callee2,_this3);}));return function(_x3){return _ref3.apply(this,arguments);};}());case 6:return _context3.abrupt('return',true);case 7:case'end':return _context3.stop();}}},_callee3,this);}));function showStudent(_x2){return _ref2.apply(this,arguments);}return showStudent;}()},{key:'logout',value:function logout(){var _this4=this;this.setState({activeTab:3});__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].logout().then(function(response){if(response.success){if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_this4.props.persistor.purge();_this4.props.history.push("/login");}},function(error){console.log('Error',error);localStorage.removeItem('token');localStorage.clear();_this4.props.persistor.purge();_this4.props.history.push("/login");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('nav',{id:'header',className:'navbar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'header-container',className:'container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar-header fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'brand',className:'navbar-brand',href:'/'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_avenuepm_png___default.a,alt:'AvenuePM',border:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar-collapse',id:'bs-example-navbar-collapse-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav navbar-nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.logout,className:"handBtn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Logout')))))),this.state.students&&this.state.students.length>1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar-collapse',id:'bs-example-navbar-collapse-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav navbar-nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNext,className:"handBtn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Next')))))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar fr'},this.state.currentStudent?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Parent: ',this.state.currentStudent.parent.userId,' (Student: ',this.state.currentStudent.user.firstname,' ',this.state.currentStudent.user.lastname,')'):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__StudentsComponent_MyProfile__["a" /* default */],{userRole:'parent',currentStudent:this.state.currentStudent,refresh:this.state.isRefresh,currentApps:this.state.currentApps}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_Footer__["a" /* default */],null));}}]);return ParentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateParent:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(parent){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__StudentsComponent_actions__["c" /* updateParent */])(parent));case 2:return _context4.abrupt('return',_context4.sent);case 3:case'end':return _context4.stop();}}},_callee4,_this5);}));function updateParent(_x4){return _ref4.apply(this,arguments);}return updateParent;}(),updateStudentAppStatus:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__StudentsComponent_actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context5.abrupt('return',_context5.sent);case 3:case'end':return _context5.stop();}}},_callee5,_this5);}));function updateStudentAppStatus(_x5){return _ref5.apply(this,arguments);}return updateStudentAppStatus;}(),updateAppStates:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__StudentsComponent_actions__["a" /* updateAppStates */])(appStates));case 2:return _context6.abrupt('return',_context6.sent);case 3:case'end':return _context6.stop();}}},_callee6,_this5);}));function updateAppStates(_x6){return _ref6.apply(this,arguments);}return updateAppStates;}(),updateStudentUser:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(studentUser){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__StudentsComponent_actions__["f" /* updateStudentUser */])(studentUser));case 2:return _context7.abrupt('return',_context7.sent);case 3:case'end':return _context7.stop();}}},_callee7,_this5);}));function updateStudentUser(_x7){return _ref7.apply(this,arguments);}return updateStudentUser;}()};};var mapStateToProps=function mapStateToProps(state){return{parent:state.studentReducer.parent,apps:state.studentReducer.apps,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(ParentComponent)));

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StudentsComponent_Common__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InlineProgressBox=function(_Component){_inherits(InlineProgressBox,_Component);function InlineProgressBox(props){_classCallCheck(this,InlineProgressBox);return _possibleConstructorReturn(this,(InlineProgressBox.__proto__||Object.getPrototypeOf(InlineProgressBox)).call(this,props));}_createClass(InlineProgressBox,[{key:"render",value:function render(){var animalMap=[];var maxlevel=this.props.maxLevel||12;for(var i=1;i<=maxlevel;i++){animalMap.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i,style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"img-responsive",src:__webpack_require__(761)("./animal"+i+".png"),title:"Level "+i/*alt={`Level ${i}`} // only title or alt required; alt disabled */,style:{opacity:this.props.level>=i?1:0.2,height:40,marginLeft:10,marginRight:10}})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-md-12"},animalMap,this.props.badgeNo>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:this.props.maxLevel+1,style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"img-responsive",src:__webpack_require__(771)("./badge_"+this.props.badgeNo+'.png'),title:"Level "+(this.props.maxLevel+1)/*alt={`Level ${this.props.maxLevel+1}`}  // only title or alt required; alt disabled*/,style:{marginLeft:10,opacity:this.props.level>this.props.maxLevel?1:0.2,height:40}})):null)),!this.props.noDescription?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"I need to score ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,this.props.steps-this.props.step)," correct.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Don't skip! Scoring stops if you skip 3 questions.")):null);}}]);return InlineProgressBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (InlineProgressBox);

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./animal1.png": 323,
	"./animal10.png": 762,
	"./animal11.png": 763,
	"./animal12.png": 764,
	"./animal2.png": 324,
	"./animal3.png": 325,
	"./animal4.png": 765,
	"./animal5.png": 766,
	"./animal6.png": 767,
	"./animal7.png": 768,
	"./animal8.png": 769,
	"./animal9.png": 770
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 761;

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal11.27add6c7.png";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal12.5230f863.png";

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal4.badba255.png";

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal5.6e5719a8.png";

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal6.d8152f59.png";

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal7.4dbcc264.png";

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/animal9.1569e360.png";

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./badge_1.png": 131,
	"./badge_2.png": 132,
	"./badge_3.png": 133,
	"./badge_4.png": 134,
	"./badge_5.png": 135,
	"./badge_6.png": 136,
	"./badge_7.png": 137
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 771;

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_kidspeak_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_kidspeak_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_kidspeak_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_wordmark_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logo_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_logo_wordmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_slashtest_png__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_slashtest_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_slashtest_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_logo_maze_png__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_logo_maze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_maze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_Footer__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var addClassInstruction=null;var addStudentInstruction=null;var ContentComponent=function(_Component){_inherits(ContentComponent,_Component);function ContentComponent(props){_classCallCheck(this,ContentComponent);var _this=_possibleConstructorReturn(this,(ContentComponent.__proto__||Object.getPrototypeOf(ContentComponent)).call(this,props));_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_13__Shared_REST__["a" /* default */].logout().then(function(response){if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_this.props.history.push("/login");},function(error){localStorage.removeItem('token');localStorage.clear();_this.props.history.push("/login");});};_this.handleKidSpeak=_this.handleKidSpeak.bind(_this);_this.handleMaze=_this.handleMaze.bind(_this);return _this;}_createClass(ContentComponent,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'handleMaze',value:function handleMaze(){this.props.history.push("/content/maze");}},{key:'handleKidSpeak',value:function handleKidSpeak(){this.props.history.push("/content/kidspeak");}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_Header__["a" /* default */],{contentManagement:true,logout:this.handleLogout}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'tc'},'Content Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav nav-pills pill-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handlePictureNaming,style:{cursor:"default"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_app_picturenaming_png___default.a,className:'ico-l',alt:'Picture Naming',style:{height:75,filter:"grayscale(100%)",opacity:"0.5"},border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleWordSignSay,style:{cursor:"default"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_app_wordsignsay_png___default.a,className:'ico-l',alt:'Word Sign/Say',style:{height:75,filter:"grayscale(100%)",opacity:"0.5"},border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleCopyRight,style:{cursor:"default"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_images_app_copyright_png___default.a,className:'ico-l',alt:'CopyRight',border:'0',style:{height:75,filter:"grayscale(100%)",opacity:"0.5"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleSlashTest,style:{cursor:"default"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_slashtest_png___default.a,className:'ico-l',alt:'Slashtest',border:'0',style:{height:75,filter:"grayscale(100%)",opacity:"0.5"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleKidSpeak,style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_kidspeak_png___default.a,className:'ico-l',alt:'Kid Speak',border:'0',style:{height:75,filter:"none",opacity:"1"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleMaze,style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_logo_maze_png___default.a,className:'ico-l',alt:'Maze',border:'0',style:{height:75,filter:"none",opacity:"1"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleKidSign,style:{cursor:"default"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_app_kidsignsay_png___default.a,className:'ico-l',alt:'KidSign',border:'0',style:{height:75,filter:"grayscale(100%)",opacity:"0.5"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleWordMark,style:{cursor:"default"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_logo_wordmark_png___default.a,className:'ico-l',alt:'Word Mark',border:'0',style:{height:75,filter:"grayscale(100%)",opacity:"0.5"}})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shared_Footer__["a" /* default */],null));}}]);return ContentComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* withRouter */])(ContentComponent));

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Content_css__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Content_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Content_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var typeOptions=[{value:'E',label:'Expository'},{value:'N',label:'Narrative'}];var levelOptions=[{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'},{value:'4',label:'4'},{value:'5',label:'5'},{value:'6',label:'6'},{value:'7',label:'7'},{value:'8',label:'8'},{value:'9',label:'9'},{value:'10',label:'10'},{value:'11',label:'11'},{value:'12',label:'12'}];var KSContent=function(_Component){_inherits(KSContent,_Component);function KSContent(props){var _this2=this;_classCallCheck(this,KSContent);var _this=_possibleConstructorReturn(this,(KSContent.__proto__||Object.getPrototypeOf(KSContent)).call(this,props));_this.setPassages=function(object){object.sort(function(a,b){return a.level>b.level||a.level===b.level&&a.id>b.id?1:a.level<b.level||a.level===b.level&&a.id<b.id?-1:0;});_this.setState({passages:object});};_this.handleCancel=function(){_this.setState({addPassage:false,editPassage:false});};_this.handlePassageItemClick=function(object){_this.setState({addPassage:false,editPassage:true,passageToEdit:object});};_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].logout().then(function(response){localStorage.removeItem('token');_this.props.history.push("/login");},function(error){_this.props.history.push("/login");});};_this.passageAdded=function(){_this.listPassages();};_this.passageUpdated=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(passageId){var newPassage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.listPassages();case 2:newPassage=_this.state.passages.filter(function(passage){return passage.id==passageId;})[0];_this.setState({addPassage:false,editPassage:true,passageToEdit:newPassage});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state={passages:[],passageToEdit:{},addPassage:false,editPassage:false,showDeleted:false};_this.handleAddPassage=_this.handleAddPassage.bind(_this);_this.handleHideDeleted=_this.handleHideDeleted.bind(_this);return _this;}_createClass(KSContent,[{key:'componentDidMount',value:function componentDidMount(){this.listPassages();}},{key:'handleHideDeleted',value:function handleHideDeleted(event){this.setState({showDeleted:event.target.checked});this.listPassages();}},{key:'listPassages',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listKidSpeakPassages().then(function(response){if(response.success){_this3.setPassages(response.body);}else{console.log('Error',response.msg);}},function(error){console.log('Error',error.msg);});case 2:case'end':return _context2.stop();}}},_callee2,this);}));function listPassages(){return _ref2.apply(this,arguments);}return listPassages;}()},{key:'handleAddPassage',value:function handleAddPassage(event){this.setState({addPassage:!this.state.addPassage,editPassage:false});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_Header__["a" /* default */],{contentManagement:true,logout:this.handleLogout}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'fl'},'KidSpeak Passages')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",width:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleHideDeleted,id:'checkHideDeleted',className:'form-control'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",marginTop:10,marginLeft:10}},'Show Decommissioned'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png___default.a,onClick:this.handleAddPassage,alt:'Plus Icon',border:'0',className:'ico-xs ico-add'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 col-md-12 solidBorder noPadding scrollable',style:{maxHeight:500}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PassagesListComponent,{passages:this.state.passages,handleItemClick:this.handlePassageItemClick,showDeleted:this.state.showDeleted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'In Total: ',this.state.passages.length)),this.state.addPassage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6 container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AddPassageComponent,{handlePassageAdded:this.passageAdded,handleCancel:this.handleCancel})):null,this.state.editPassage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6 container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(UpdatePassageComponent,{handlePassageUpdated:this.passageUpdated,passages:this.state.passages,passage:this.state.passageToEdit,handleCancel:this.handleCancel})):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_Footer__["a" /* default */],null));}}]);return KSContent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var AddPassageComponent=function(_Component2){_inherits(AddPassageComponent,_Component2);function AddPassageComponent(props){_classCallCheck(this,AddPassageComponent);var _this4=_possibleConstructorReturn(this,(AddPassageComponent.__proto__||Object.getPrototypeOf(AddPassageComponent)).call(this,props));_this4.state={level:'',passageType:'',title:'',storyStarter:''};_this4.handleLevelSelect=_this4.handleLevelSelect.bind(_this4);_this4.handleTypeSelect=_this4.handleTypeSelect.bind(_this4);_this4.handleTitleChange=_this4.handleTitleChange.bind(_this4);_this4.handleContentChange=_this4.handleContentChange.bind(_this4);_this4.handleCancel=_this4.handleCancel.bind(_this4);_this4.handleSave=_this4.handleSave.bind(_this4);return _this4;}_createClass(AddPassageComponent,[{key:'handleLevelSelect',value:function handleLevelSelect(event){this.setState({level:event.value});}},{key:'handleTypeSelect',value:function handleTypeSelect(event){this.setState({passageType:event.value});}},{key:'handleTitleChange',value:function handleTitleChange(event){this.setState({title:event.target.value});event.preventDefault();}},{key:'handleContentChange',value:function handleContentChange(event){this.setState({storyStarter:event.target.value});event.preventDefault();}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();}},{key:'handleSave',value:function handleSave(event){var _this5=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addKidSpeakPassage(this.state).then(function(response){if(response.success){_this5.setState({modalDialog:true,responseContent:'Passage Successfully Added!'});setTimeout(function(){_this5.setState({modalDialog:false});_this5.props.handleCancel();},3500);_this5.props.handlePassageAdded();_this5.myFormRef.reset();}else{_this5.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this5.setState({modalDialog:false});},3500);}},function(error){_this5.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this5.setState({modalDialog:false});},3500);});}},{key:'render',value:function render(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:'formAddPassage',ref:function ref(el){return _this6.myFormRef=el;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'selectLevel'},'Level'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleLevelSelect,id:'selectLevel',name:'classes',options:levelOptions,isSearchable:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'selectType'},'Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleTypeSelect,id:'selectType',name:'classes',options:typeOptions,isSearchable:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTitle'},'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleTitleChange,id:'inputTitle',className:'form-control fullWidth',placeholder:'Title',size:'30',maxLength:50,required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputContent'},'Content'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{onChange:this.handleContentChange,placeholder:'Input KidSpeak passage content',className:'form-control w100',rows:8})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Add Passage'))));}}]);return AddPassageComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var UpdatePassageComponent=function(_Component3){_inherits(UpdatePassageComponent,_Component3);function UpdatePassageComponent(props){_classCallCheck(this,UpdatePassageComponent);var _this7=_possibleConstructorReturn(this,(UpdatePassageComponent.__proto__||Object.getPrototypeOf(UpdatePassageComponent)).call(this,props));_this7.deletePassage=function(confirm){if(confirm){if(_this7.state.passage.deletedAt){_this7.handleActivate();}else{_this7.handleDelete();}}_this7.setState({modalDialogDelete:false});};_this7.state={passageIdOptions:_this7.getVersionOptions(_this7.props.passage.uId),passage:{id:_this7.props.passage.id,level:_this7.props.passage.level,passageType:_this7.props.passage.passageType,title:_this7.props.passage.title,storyStarter:_this7.props.passage.storyStarter,uId:_this7.props.passage.uId,deletedAt:_this7.props.passage.deletedAt},modalDialog:false,modalDialogDelete:false};_this7.handleVersionSelect=_this7.handleVersionSelect.bind(_this7);_this7.getVersionOptions=_this7.getVersionOptions.bind(_this7);_this7.handleLevelSelect=_this7.handleLevelSelect.bind(_this7);_this7.handleTypeSelect=_this7.handleTypeSelect.bind(_this7);_this7.handleTitleChange=_this7.handleTitleChange.bind(_this7);_this7.handleContentChange=_this7.handleContentChange.bind(_this7);_this7.handleCancel=_this7.handleCancel.bind(_this7);_this7.handleSave=_this7.handleSave.bind(_this7);_this7.handleDelete=_this7.handleDelete.bind(_this7);_this7.handleActivate=_this7.handleActivate.bind(_this7);_this7.deletePassage=_this7.deletePassage.bind(_this7);return _this7;}_createClass(UpdatePassageComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.passage&&newProps.passage&&oldProps.passage.id!==newProps.passage.id){this.setState({passageIdOptions:this.getVersionOptions(this.props.passage.uId),passage:{id:this.props.passage.id,level:this.props.passage.level,passageType:this.props.passage.passageType,title:this.props.passage.title,storyStarter:this.props.passage.storyStarter,uId:this.props.passage.uId,deletedAt:this.props.passage.deletedAt},modalDialog:false,modalDialogDelete:false});}}},{key:'handleVersionSelect',value:function handleVersionSelect(event){var selectedPassage=this.props.passages.filter(function(passage){return passage.id==event.value;})[0];this.setState({passage:{id:selectedPassage.id,level:selectedPassage.level,passageType:selectedPassage.passageType,title:selectedPassage.title,storyStarter:selectedPassage.storyStarter,uId:selectedPassage.uId,deletedAt:selectedPassage.deletedAt}});}},{key:'getVersionOptions',value:function getVersionOptions(uId){var versionOptions=[];this.props.passages.forEach(function(passage){if(passage.uId===uId){var version={value:passage.id,label:'passageId: '+passage.id,deletedAt:passage.deletedAt};if(passage.deletedAt){version.label+=' (Decommissioned | '+passage.deletedAt.substring(0,19).replace('T',' ')+')';}else{version.label+=' (Active)';}versionOptions.push(version);}});var sortedVersionOptions=versionOptions.sort(function(a,b){if(!a.deletedAt)return-1;if(!b.deletedAt)return 1;return a.deletedAt>b.deletedAt?-1:a.deletedAt<b.deletedAt?1:0;});return sortedVersionOptions;}},{key:'handleLevelSelect',value:function handleLevelSelect(event){this.setState({passage:Object.assign({},this.state.passage,{level:event.value})});}},{key:'handleTypeSelect',value:function handleTypeSelect(event){this.setState({passage:Object.assign({},this.state.passage,{passageType:event.value})});}},{key:'handleTitleChange',value:function handleTitleChange(event){this.setState({passage:Object.assign({},this.state.passage,{title:event.target.value})});event.preventDefault();}},{key:'handleContentChange',value:function handleContentChange(event){this.setState({passage:Object.assign({},this.state.passage,{storyStarter:event.target.value})});event.preventDefault();}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();event.preventDefault();}},{key:'handleSave',value:function handleSave(event){var _this8=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].updateKidSpeakPassage(this.state.passage).then(function(response){if(response.success){_this8.setState({modalDialog:true,responseContent:'Passage Data Successfully Updated!'});setTimeout(function(){_this8.setState({modalDialog:false});},3500);_this8.props.handlePassageUpdated(response.body.id);}else{alert(response.msg);}},function(error){alert(error.msg);});event.preventDefault();}},{key:'handleDelete',value:function handleDelete(event){var _this9=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].deleteKidSpeakPassage(this.state.passage.id).then(function(response){if(response.success){_this9.setState({modalDialog:true,responseContent:'Passage Successfully Deleted!'});setTimeout(function(){_this9.setState({modalDialog:false});_this9.props.handleCancel();},3500);_this9.props.handlePassageUpdated();}else{alert(response.msg);}},function(error){alert(error.msg);});}},{key:'handleActivate',value:function handleActivate(event){var _this10=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].activateKidSpeakPassage(this.state.passage.id).then(function(response){if(response.success){_this10.setState({modalDialog:true,responseContent:'Passage Successfully Activated!'});setTimeout(function(){_this10.setState({modalDialog:false});_this10.props.handleCancel();},3500);_this10.props.handlePassageUpdated();}else{alert(response.msg);}},function(error){alert(error.msg);});}},{key:'render',value:function render(){var _this11=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this11.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deletePassage,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this11.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputPassageName'},'Versions (UID: ',this.state.passage.uId,')'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleVersionSelect,id:'classes',name:'classes',options:this.state.passageIdOptions,value:this.state.passageIdOptions.filter(function(option){return option.value==_this11.state.passage.id;}),isSearchable:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'selectLevel'},'Level'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleLevelSelect,id:'selectLevel',name:'classes',value:levelOptions.filter(function(option){return option.value==_this11.state.passage.level;}),options:levelOptions,isSearchable:false,isDisabled:this.state.passage.deletedAt?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'selectType'},'Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleTypeSelect,id:'selectType',name:'classes',value:typeOptions.filter(function(option){return option.value==_this11.state.passage.passageType;}),options:typeOptions,isSearchable:false,isDisabled:this.state.passage.deletedAt?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTitle'},'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleTitleChange,id:'inputTitle',value:this.state.passage.title,className:'form-control fullWidth',placeholder:'Title',size:'30',maxLength:50,required:true,autoFocus:true,disabled:this.state.passage.deletedAt?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputContent'},'Content'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{onChange:this.handleContentChange,value:this.state.passage.storyStarter,placeholder:'Input KidSpeak passage content',className:'form-control w100',rows:8,disabled:this.state.passage.deletedAt?true:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fl'},this.state.passage.deletedAt?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(event){_this11.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO ACTIVATE THIS PASSAGE?'});event.stopPropagation();},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Activate')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(event){_this11.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS PASSAGE?'});event.stopPropagation();},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Decommission'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),this.state.passage.deletedAt?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Update'))));}}]);return UpdatePassageComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var PassagesListComponent=function(_Component4){_inherits(PassagesListComponent,_Component4);function PassagesListComponent(props){_classCallCheck(this,PassagesListComponent);var _this12=_possibleConstructorReturn(this,(PassagesListComponent.__proto__||Object.getPrototypeOf(PassagesListComponent)).call(this,props));_this12.handleItemClick=function(object){_this12.props.handleItemClick(object);};_this12.state={items:_this12.props.passages};_this12.sortPassagesById=_this12.sortPassagesById.bind(_this12);_this12.sortPassagesByLevel=_this12.sortPassagesByLevel.bind(_this12);return _this12;}_createClass(PassagesListComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.passages!==newProps.passages){this.setState({items:this.props.passages});}}},{key:'sortPassagesById',value:function sortPassagesById(){this.setState({items:this.state.items.sort(function(a,b){return a.id>b.id?1:a.id<b.id?-1:0;})});}},{key:'sortPassagesByLevel',value:function sortPassagesByLevel(){this.setState({items:this.state.items.sort(function(a,b){return a.level>b.level?1:a.level<b.level?-1:0;})});}},{key:'render',value:function render(){var _this13=this;var passages=this.state.items.map(function(item){if(!(item.deletedAt&&!_this13.props.showDeleted)){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PassagesListItemComponent,{key:item.id,item:item,handleClick:_this13.handleItemClick});}else return null;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortPassagesByLevel},'Level')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortPassagesById},'ID')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Status')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,passages));}}]);return PassagesListComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var PassagesListItemComponent=function(_Component5){_inherits(PassagesListItemComponent,_Component5);function PassagesListItemComponent(props){_classCallCheck(this,PassagesListItemComponent);var _this14=_possibleConstructorReturn(this,(PassagesListItemComponent.__proto__||Object.getPrototypeOf(PassagesListItemComponent)).call(this,props));_this14.handleClick=_this14.handleClick.bind(_this14);return _this14;}_createClass(PassagesListItemComponent,[{key:'handleClick',value:function handleClick(event){this.props.handleClick(this.props.item);event.preventDefault();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.item.level),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.item.id),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.item.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,this.props.item.deletedAt?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png___default.a,alt:'View Icon',border:'0',className:'ico-xs'}))));}}]);return PassagesListItemComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* withRouter */])(KSContent));

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Content_css__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Content_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Content_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var typeOptions=[{value:'E',label:'Expository'},{value:'N',label:'Narrative'}];var levelOptions=[{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'},{value:'4',label:'4'},{value:'5',label:'5'},{value:'6',label:'6'},{value:'7',label:'7'},{value:'8',label:'8'},{value:'9',label:'9'},{value:'10',label:'10'},{value:'11',label:'11'},{value:'12',label:'12'}];var MazeContent=function(_Component){_inherits(MazeContent,_Component);function MazeContent(props){var _this2=this;_classCallCheck(this,MazeContent);var _this=_possibleConstructorReturn(this,(MazeContent.__proto__||Object.getPrototypeOf(MazeContent)).call(this,props));_this.setPassages=function(object){object.sort(function(a,b){return a.level>b.level||a.level===b.level&&a.id>b.id?1:a.level<b.level||a.level===b.level&&a.id<b.id?-1:0;});_this.setState({passages:object});};_this.handleCancel=function(){_this.setState({addPassage:false,editPassage:false});};_this.handlePassageItemClick=function(object){_this.setState({addPassage:false,editPassage:true,passageToEdit:object});};_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].logout().then(function(response){localStorage.removeItem('token');_this.props.history.push("/login");},function(error){_this.props.history.push("/login");});};_this.passageAdded=function(){_this.listPassages();};_this.passageUpdated=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(passageId){var newPassage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.listPassages();case 2:newPassage=_this.state.passages.filter(function(passage){return passage.id==passageId;})[0];_this.setState({addPassage:false,editPassage:true,passageToEdit:newPassage});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state={passages:[],passageToEdit:{},addPassage:false,editPassage:false,showDeleted:false};_this.handleAddPassage=_this.handleAddPassage.bind(_this);_this.handleHideDeleted=_this.handleHideDeleted.bind(_this);return _this;}_createClass(MazeContent,[{key:'componentDidMount',value:function componentDidMount(){this.listPassages();}},{key:'handleHideDeleted',value:function handleHideDeleted(event){this.setState({showDeleted:event.target.checked});this.listPassages();}},{key:'listPassages',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].listMazePassages().then(function(response){if(response.success){_this3.setPassages(response.body);}else{console.log('Error',response.msg);}},function(error){console.log('Error',error.msg);});case 2:case'end':return _context2.stop();}}},_callee2,this);}));function listPassages(){return _ref2.apply(this,arguments);}return listPassages;}()},{key:'handleAddPassage',value:function handleAddPassage(event){this.props.history.push("/content/maze-creator");}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_Header__["a" /* default */],{contentManagement:true,logout:this.handleLogout}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-5"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'fl'},'Maze Passages')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",width:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',onChange:this.handleHideDeleted,id:'checkHideDeleted',className:'form-control'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",marginTop:10,marginLeft:10}},'Show Decommissioned'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png___default.a,onClick:this.handleAddPassage,alt:'Plus Icon',border:'0',className:'ico-xs ico-add'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 col-md-12 solidBorder noPadding scrollable',style:{maxHeight:500}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PassagesListComponent,{passages:this.state.passages,handleItemClick:this.handlePassageItemClick,showDeleted:this.state.showDeleted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'In Total: ',this.state.passages.length)),this.state.addPassage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6 container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AddPassageComponent,{handlePassageAdded:this.passageAdded,handleCancel:this.handleCancel})):null,this.state.editPassage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6 container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(UpdatePassageComponent,{handlePassageUpdated:this.passageUpdated,passages:this.state.passages,passage:this.state.passageToEdit,handleCancel:this.handleCancel})):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_Footer__["a" /* default */],null));}}]);return MazeContent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var AddPassageComponent=function(_Component2){_inherits(AddPassageComponent,_Component2);function AddPassageComponent(props){_classCallCheck(this,AddPassageComponent);var _this4=_possibleConstructorReturn(this,(AddPassageComponent.__proto__||Object.getPrototypeOf(AddPassageComponent)).call(this,props));_this4.state={level:'',passageType:'',passageTitle:'',passage:''};_this4.handleLevelSelect=_this4.handleLevelSelect.bind(_this4);_this4.handleTypeSelect=_this4.handleTypeSelect.bind(_this4);_this4.handleTitleChange=_this4.handleTitleChange.bind(_this4);_this4.handleContentChange=_this4.handleContentChange.bind(_this4);_this4.handleCancel=_this4.handleCancel.bind(_this4);_this4.handleSave=_this4.handleSave.bind(_this4);return _this4;}_createClass(AddPassageComponent,[{key:'handleLevelSelect',value:function handleLevelSelect(event){this.setState({level:event.value});}},{key:'handleTypeSelect',value:function handleTypeSelect(event){this.setState({passageType:event.value});}},{key:'handleTitleChange',value:function handleTitleChange(event){this.setState({passageTitle:event.target.value});event.preventDefault();}},{key:'handleContentChange',value:function handleContentChange(event){this.setState({passage:event.target.value});event.preventDefault();}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();}},{key:'handleSave',value:function handleSave(event){var _this5=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].addMazePassage(this.state).then(function(response){if(response.success){_this5.setState({modalDialog:true,responseContent:'Passage Successfully Added!'});setTimeout(function(){_this5.setState({modalDialog:false});_this5.props.handleCancel();},3500);_this5.props.handlePassageAdded();_this5.myFormRef.reset();}else{_this5.setState({modalDialog:true,responseContent:response.msg});setTimeout(function(){_this5.setState({modalDialog:false});},3500);}},function(error){_this5.setState({modalDialog:true,responseContent:error.msg});setTimeout(function(){_this5.setState({modalDialog:false});},3500);});}},{key:'render',value:function render(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{id:'formAddPassage',ref:function ref(el){return _this6.myFormRef=el;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'selectLevel'},'Level'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleLevelSelect,id:'selectLevel',name:'classes',options:levelOptions,isSearchable:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'selectType'},'Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleTypeSelect,id:'selectType',name:'classes',options:typeOptions,isSearchable:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTitle'},'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleTitleChange,id:'inputTitle',className:'form-control fullWidth',placeholder:'Title',size:'30',maxLength:50,required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputContent'},'Content'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{onChange:this.handleContentChange,placeholder:'Input KidSpeak passage content',className:'form-control w100',rows:8})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Add Passage'))));}}]);return AddPassageComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var UpdatePassageComponent=function(_Component3){_inherits(UpdatePassageComponent,_Component3);function UpdatePassageComponent(props){_classCallCheck(this,UpdatePassageComponent);var _this7=_possibleConstructorReturn(this,(UpdatePassageComponent.__proto__||Object.getPrototypeOf(UpdatePassageComponent)).call(this,props));_this7.deletePassage=function(confirm){if(confirm){if(_this7.state.passage.deletedAt){_this7.handleActivate();}else{_this7.handleDelete();}}_this7.setState({modalDialogDelete:false});};_this7.state={passageIdOptions:_this7.getVersionOptions(_this7.props.passage.uId),passage:{id:_this7.props.passage.id,level:_this7.props.passage.level,passageType:_this7.props.passage.passageType,passageTitle:_this7.props.passage.passageTitle,passage:_this7.props.passage.passage,uId:_this7.props.passage.uId,deletedAt:_this7.props.passage.deletedAt},modalDialog:false,modalDialogDelete:false};_this7.handleVersionSelect=_this7.handleVersionSelect.bind(_this7);_this7.getVersionOptions=_this7.getVersionOptions.bind(_this7);_this7.handleLevelSelect=_this7.handleLevelSelect.bind(_this7);_this7.handleTypeSelect=_this7.handleTypeSelect.bind(_this7);_this7.handleTitleChange=_this7.handleTitleChange.bind(_this7);_this7.handleContentChange=_this7.handleContentChange.bind(_this7);_this7.handleCancel=_this7.handleCancel.bind(_this7);_this7.handleSave=_this7.handleSave.bind(_this7);_this7.handleDelete=_this7.handleDelete.bind(_this7);_this7.handleActivate=_this7.handleActivate.bind(_this7);_this7.deletePassage=_this7.deletePassage.bind(_this7);return _this7;}_createClass(UpdatePassageComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.passage.id!==newProps.passage.id){this.setState({passageIdOptions:this.getVersionOptions(this.props.passage.uId),passage:{id:this.props.passage.id,level:this.props.passage.level,passageType:this.props.passage.passageType,passageTitle:this.props.passage.passageTitle,passage:this.props.passage.passage,uId:this.props.passage.uId,deletedAt:this.props.passage.deletedAt},modalDialog:false,modalDialogDelete:false});}}},{key:'handleVersionSelect',value:function handleVersionSelect(event){var selectedPassage=this.props.passages.filter(function(passage){return passage.id==event.value;})[0];this.setState({passage:{id:selectedPassage.id,level:selectedPassage.level,passageType:selectedPassage.passageType,passageTitle:selectedPassage.passageTitle,passage:selectedPassage.passage,uId:selectedPassage.uId,deletedAt:selectedPassage.deletedAt}});}},{key:'getVersionOptions',value:function getVersionOptions(uId){var versionOptions=[];this.props.passages.forEach(function(passage){if(passage.uId===uId){var version={value:passage.id,label:'passageId: '+passage.id,deletedAt:passage.deletedAt};if(passage.deletedAt){version.label+=' (Decommissioned | '+passage.deletedAt.substring(0,19).replace('T',' ')+')';}else{version.label+=' (Active)';}versionOptions.push(version);}});var sortedVersionOptions=versionOptions.sort(function(a,b){if(!a.deletedAt)return-1;if(!b.deletedAt)return 1;return a.deletedAt>b.deletedAt?-1:a.deletedAt<b.deletedAt?1:0;});return sortedVersionOptions;}},{key:'handleLevelSelect',value:function handleLevelSelect(event){this.setState({passage:Object.assign({},this.state.passage,{level:event.value})});}},{key:'handleTypeSelect',value:function handleTypeSelect(event){this.setState({passage:Object.assign({},this.state.passage,{passageType:event.value})});}},{key:'handleTitleChange',value:function handleTitleChange(event){this.setState({passage:Object.assign({},this.state.passage,{passageTitle:event.target.value})});event.preventDefault();}},{key:'handleContentChange',value:function handleContentChange(event){this.setState({passage:Object.assign({},this.state.passage,{passage:event.target.value})});event.preventDefault();}},{key:'handleCancel',value:function handleCancel(event){this.props.handleCancel();event.preventDefault();}},{key:'handleSave',value:function handleSave(event){var _this8=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].updateMazePassage(this.state.passage).then(function(response){if(response.success){_this8.setState({modalDialog:true,responseContent:'Passage Data Successfully Updated!'});setTimeout(function(){_this8.setState({modalDialog:false});},3500);_this8.props.handlePassageUpdated(response.body.id);}else{alert(response.msg);}},function(error){alert(error.msg);});event.preventDefault();}},{key:'handleDelete',value:function handleDelete(event){var _this9=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].deleteMazePassage(this.state.passage.id).then(function(response){if(response.success){_this9.setState({modalDialog:true,responseContent:'Passage Successfully Deleted!'});setTimeout(function(){_this9.setState({modalDialog:false});_this9.props.handleCancel();},3500);_this9.props.handlePassageUpdated();}else{alert(response.msg);}},function(error){alert(error.msg);});}},{key:'handleActivate',value:function handleActivate(event){var _this10=this;__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].activateMazePassage(this.state.passage.id).then(function(response){if(response.success){_this10.setState({modalDialog:true,responseContent:'Passage Successfully Activated!'});setTimeout(function(){_this10.setState({modalDialog:false});_this10.props.handleCancel();},3500);_this10.props.handlePassageUpdated();}else{alert(response.msg);}},function(error){alert(error.msg);});}},{key:'render',value:function render(){var _this11=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder hasfitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this11.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deletePassage,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this11.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputPassageName'},'Versions (UID: ',this.state.passage.uId,')'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleVersionSelect,id:'classes',name:'classes',options:this.state.passageIdOptions,value:this.state.passageIdOptions.filter(function(option){return option.value==_this11.state.passage.id;}),isSearchable:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'selectLevel'},'Level'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleLevelSelect,id:'selectLevel',name:'classes',value:levelOptions.filter(function(option){return option.value==_this11.state.passage.level;}),options:levelOptions,isSearchable:false,isDisabled:this.state.passage.deletedAt?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'selectType'},'Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleTypeSelect,id:'selectType',name:'classes',value:typeOptions.filter(function(option){return option.value==_this11.state.passage.passageType;}),options:typeOptions,isSearchable:false,isDisabled:this.state.passage.deletedAt?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputTitle'},'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleTitleChange,id:'inputTitle',value:this.state.passage.passageTitle,className:'form-control fullWidth',placeholder:'Title',size:'30',maxLength:50,required:true,autoFocus:true,disabled:this.state.passage.deletedAt?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inputContent'},'Content'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{onChange:this.handleContentChange,value:this.state.passage.passage,placeholder:'Input KidSpeak passage content',className:'form-control w100',rows:8,disabled:this.state.passage.deletedAt?true:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fl'},this.state.passage.deletedAt?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(event){_this11.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO ACTIVATE THIS PASSAGE?'});event.stopPropagation();},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Activate')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(event){_this11.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS PASSAGE?'});event.stopPropagation();},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Decommission'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleCancel,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')),this.state.passage.deletedAt?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Update'))));}}]);return UpdatePassageComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var PassagesListComponent=function(_Component4){_inherits(PassagesListComponent,_Component4);function PassagesListComponent(props){_classCallCheck(this,PassagesListComponent);var _this12=_possibleConstructorReturn(this,(PassagesListComponent.__proto__||Object.getPrototypeOf(PassagesListComponent)).call(this,props));_this12.handleItemClick=function(object){_this12.props.handleItemClick(object);};_this12.state={items:_this12.props.passages};_this12.sortPassagesById=_this12.sortPassagesById.bind(_this12);_this12.sortPassagesByLevel=_this12.sortPassagesByLevel.bind(_this12);return _this12;}_createClass(PassagesListComponent,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var newProps=this.props;if(oldProps.passages!==newProps.passages){this.setState({items:this.props.passages});}}},{key:'sortPassagesById',value:function sortPassagesById(){this.setState({items:this.state.items.sort(function(a,b){return a.id>b.id?1:a.id<b.id?-1:0;})});}},{key:'sortPassagesByLevel',value:function sortPassagesByLevel(){this.setState({items:this.state.items.sort(function(a,b){return a.level>b.level?1:a.level<b.level?-1:0;})});}},{key:'render',value:function render(){var _this13=this;var passages=this.state.items.map(function(item){if(!(item.deletedAt&&!_this13.props.showDeleted)){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PassagesListItemComponent,{key:item.id,item:item,handleClick:_this13.handleItemClick});}else return null;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortPassagesByLevel},'Level')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.sortPassagesById},'ID')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Status')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,passages));}}]);return PassagesListComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var PassagesListItemComponent=function(_Component5){_inherits(PassagesListItemComponent,_Component5);function PassagesListItemComponent(props){_classCallCheck(this,PassagesListItemComponent);var _this14=_possibleConstructorReturn(this,(PassagesListItemComponent.__proto__||Object.getPrototypeOf(PassagesListItemComponent)).call(this,props));_this14.handleClick=_this14.handleClick.bind(_this14);return _this14;}_createClass(PassagesListItemComponent,[{key:'handleClick',value:function handleClick(event){this.props.handleClick(this.props.item);event.preventDefault();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.item.level),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.item.id),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.item.passageTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'fitWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,this.props.item.deletedAt?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png___default.a,alt:'View Icon',border:'0',className:'ico-xs'}))));}}]);return PassagesListItemComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* withRouter */])(MazeContent));

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Content_css__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Content_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Content_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_ico_plus_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_ico_view_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var levelOptions=[{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'},{value:'4',label:'4'},{value:'5',label:'5'},{value:'6',label:'6'},{value:'7',label:'7'},{value:'8',label:'8'},{value:'9',label:'9'},{value:'10',label:'10'},{value:'11',label:'11'},{value:'12',label:'12'}];var typeOptions=[{value:'N',label:'Narrative'},{value:'E',label:'Expository'}];var statusOptions=[{value:'|',label:'Noun/Pronoun'},{value:'\\',label:'Adjective'},{value:'/',label:'Verb/Adverb'},{value:'>',label:'Conjunction'},{value:'~',label:'Determinent/Art'},{value:'^',label:'Preposition'}];var getValue=function getValue(opts,val){return opts.find(function(o){return o.value===val;});};var MazeCreator=function(_Component){_inherits(MazeCreator,_Component);function MazeCreator(props){_classCallCheck(this,MazeCreator);var _this=_possibleConstructorReturn(this,(MazeCreator.__proto__||Object.getPrototypeOf(MazeCreator)).call(this,props));_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].logout().then(function(response){localStorage.removeItem('token');_this.props.history.push("/login");},function(error){_this.props.history.push("/login");});};_this.state={passageTitle:'',level:'',passageType:'',version:0,content:'',passage:'',deleted:4,//unpublished
oldPassageId:'',words:[],wordsArray:[],statuses:[],showNext:false};_this.handleTitle=_this.handleTitle.bind(_this);_this.handleLevel=_this.handleLevel.bind(_this);_this.handleType=_this.handleType.bind(_this);_this.handleContent=_this.handleContent.bind(_this);_this.handleNext=_this.handleNext.bind(_this);_this.handleCancel=_this.handleCancel.bind(_this);_this.handleWordStatusChange=_this.handleWordStatusChange.bind(_this);_this.validate=_this.validate.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);return _this;}_createClass(MazeCreator,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'handleTitle',value:function handleTitle(event){this.setState({passageTitle:event.target.value});}},{key:'handleLevel',value:function handleLevel(event){this.setState({level:event.value});}},{key:'handleType',value:function handleType(event){this.setState({passageType:event.value});}},{key:'handleContent',value:function handleContent(event){this.setState({content:event.target.value});}},{key:'handleCancel',value:function handleCancel(event){this.props.history.push("/content/maze");}},{key:'handleNext',value:function handleNext(event){var wordsArray=this.state.content.replace(/\s\s+/g,' ').trim().split(" ");this.setState({wordsArray:wordsArray});var words=[];var pureWords=[];var number=1;var wordNumber=1;wordsArray.map(function(item){if(number==7){var regex=/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;var pureWord=item.replaceAll(regex,'').trim();if(pureWord){var wordStatus={number:wordNumber,word:pureWord,status:''};words.push(wordStatus);number=1;wordNumber++;}}else{number++;}});this.setState({showNext:true,words:words});}},{key:'handleWordStatusChange',value:function handleWordStatusChange(number,status){var statuses=[];if(this.state.statuses[number]){statuses=this.state.statuses.map(function(item,j){if(j===number){return status;}else{return item;}});}else{statuses=this.state.statuses.map(function(item){return item;});statuses[number-1]=status;}try{this.setState({statuses:statuses});}catch(e){alert(e);}}},{key:'validate',value:function validate(){var valid=true;if(!this.state.passageTitle)valid=false;if(!this.state.level)valid=false;if(!this.state.passageType)valid=false;if(!this.state.content)valid=false;for(var i=0;i<this.state.words.length;i++){if(!this.state.statuses[i]){valid=false;}}return valid;}},{key:'handleSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var passage,statusNo,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!this.validate()){_context.next=9;break;}passage='';statusNo=0;for(i=0;i<this.state.wordsArray.length;i++){if(i>0&&i%7==0){passage+=this.state.statuses[statusNo].trim()+this.state.wordsArray[i].trim()+' ';statusNo++;}else{passage+=this.state.wordsArray[i].trim()+' ';}console.log(this.state.statuses[statusNo]);console.log(this.state.wordsArray[i]);console.log(passage);}_context.next=6;return this.setState({passage:passage});case 6:__WEBPACK_IMPORTED_MODULE_7__Shared_REST__["a" /* default */].createMazeContent(this.state).then(function(response){alert('Submitted successfully!');},function(error){alert('Fail to submit.');});_context.next=10;break;case 9:alert('Please fill in all fields');case 10:case'end':return _context.stop();}}},_callee,this);}));function handleSubmit(_x){return _ref.apply(this,arguments);}return handleSubmit;}()},{key:'render',value:function render(){var _this2=this;var items=this.state.words;var listLength=items.length;var wordlist=items.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WordItemComponent,{listLength:listLength,number:item.number,word:item.word,status:item.status,handleStatusChange:_this2.handleWordStatusChange});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_Header__["a" /* default */],{contentManagement:true,logout:this.handleLogout}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-center',style:{width:250}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Maze Content Creator'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'form-label',htmlFor:'inputTitle'},'Title')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-11'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleTitle,id:'inputTitle',className:this.state.titleError+" form-control inputStyle1",placeholder:'Title',required:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{marginTop:15}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'form-label',htmlFor:'selectLevel'},'Level')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleLevel,id:'selectLevel',options:levelOptions,defaultValue:getValue(levelOptions,this.state.level),className:this.state.levelError,isSearchable:false})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'form-label',htmlFor:'selectType'},'Type')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleType,id:'selectLevel',options:typeOptions,defaultValue:getValue(typeOptions,this.state.passageType),className:this.state.typeError,isSearchable:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:5}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'form-label',htmlFor:'selectLevel'},'Passage Content')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{onChange:this.handleContent,value:this.state.content,style:{width:'100%',height:'300px'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-center',style:{width:150}},'Character Limit: ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,1200-this.state.content.length))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'navbar',className:'navbar form-center',style:{width:100,marginTop:160},onClick:this.handleNext},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:"handBtn"},this.state.showNext?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Update'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Next'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'navbar',className:'navbar form-center',style:this.state.showNext?{width:100,marginTop:30,marginLeft:31}:{width:100,marginTop:30,marginLeft:23},onClick:this.handleCancel},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:"handBtn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Cancel')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-4'},this.state.showNext?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{width:'',style:{height:440,overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},'#'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'fitWidth'},'Word'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Status'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,wordlist))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'navbar',className:'navbar form-center',style:{width:100,marginTop:20},onClick:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:"handBtn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Submit')))):null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_Footer__["a" /* default */],null));}}]);return MazeCreator;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var WordItemComponent=function(_Component2){_inherits(WordItemComponent,_Component2);function WordItemComponent(props){_classCallCheck(this,WordItemComponent);var _this3=_possibleConstructorReturn(this,(WordItemComponent.__proto__||Object.getPrototypeOf(WordItemComponent)).call(this,props));_this3.state={value:''};_this3.handleStatusChange=_this3.handleStatusChange.bind(_this3);return _this3;}_createClass(WordItemComponent,[{key:'handleStatusChange',value:function handleStatusChange(event){this.props.handleStatusChange(this.props.number,event.value);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'clickable-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.number),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.props.word),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */],{onChange:this.handleStatusChange,id:'selectStatus',options:statusOptions,defaultValue:getValue(statusOptions,this.props.status),menuPlacement:"auto",isSearchable:false})));}}]);return WordItemComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* withRouter */])(MazeCreator));

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_avenuepm_png__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logo_avenuepm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_avenuepm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logo_wordmark_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logo_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_logo_wordmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark2_png__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_logo_slashtest_png__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_logo_slashtest_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_logo_slashtest_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_logo_maze_png__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_logo_maze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_logo_maze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_badge_1_png__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_badge_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_badge_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_badge_2_png__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_badge_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_badge_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_badge_3_png__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_badge_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_badge_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_badge_4_png__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_badge_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_badge_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_badge_5_png__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_badge_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_badge_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_badge_6_png__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_badge_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_badge_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_badge_7_png__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_badge_7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_badge_7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__StudentsComponent_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__MyProfile__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_device_detect__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react_device_detect__);
var _this7=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var addClassInstruction=null;var addStudentInstruction=null;var PNInstruction=null;var WSSInstruction=null;var CopyrightInstruction=null;var KidsignInstruction=null;var KidspeakInstruction=null;var MainStudentComponent=function(_Component){_inherits(MainStudentComponent,_Component);function MainStudentComponent(props){_classCallCheck(this,MainStudentComponent);var _this=_possibleConstructorReturn(this,(MainStudentComponent.__proto__||Object.getPrototypeOf(MainStudentComponent)).call(this,props));_this.handleSelect=function(selected){_this.props.updateStudentAccountTab(selected);_this.setState({activeTab:selected});};_this.state={activeTab:_this.props.tabNum,bestScores:[]};_this.myProfile=_this.myProfile.bind(_this);_this.myTasks=_this.myTasks.bind(_this);_this.logout=_this.logout.bind(_this);_this.handleSelect=_this.handleSelect.bind(_this);return _this;}_createClass(MainStudentComponent,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_22__Shared_Helpers__["a" /* default */].authorize(this);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentAppStatus().then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){var _Helpers$filterApps,allowedApps,filteredApps,finishedApps;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this2.props.updateStudentAppStatus(res.body);case 2:_Helpers$filterApps=__WEBPACK_IMPORTED_MODULE_22__Shared_Helpers__["a" /* default */].filterApps(_this2.props.studentUser,_this2.props.apps),allowedApps=_Helpers$filterApps.allowedApps,filteredApps=_Helpers$filterApps.filteredApps,finishedApps=_Helpers$filterApps.finishedApps;_context.next=5;return _this2.props.updateAppStates({allowedApps:allowedApps,filteredApps:filteredApps,finishedApps:finishedApps});case 5:_context.next=7;return _this2.setState({bestScores:res.body.bestScores});case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}());}},{key:'logout',value:function logout(){var _this3=this;this.props.updateStudentAccountTab(1);this.setState({activeTab:3});__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].logout().then(function(response){if(response.success){if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_this3.props.persistor.purge();_this3.props.history.push("/login");}},function(error){console.log('Error',error);localStorage.removeItem('token');localStorage.clear();_this3.props.persistor.purge();_this3.props.history.push("/login");});}},{key:'myTasks',value:function myTasks(event){this.setState({activeTab:1});this.props.updateStudentAccountTab(1);event.preventDefault();}},{key:'myProfile',value:function myProfile(event){this.setState({activeTab:2});this.props.updateStudentAccountTab(2);event.preventDefault();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('nav',{id:'header',className:'navbar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'header-container',className:'container navbar-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar-header fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{id:'brand',className:'navbar-brand',href:'/'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_logo_avenuepm_png___default.a,alt:'AvenuePM',border:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar fr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'navbar-collapse',id:'bs-example-navbar-collapse-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav navbar-nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.myTasks,className:this.state.activeTab===1?"handBtn active":"handBtn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'My Tasks'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.myProfile,className:this.state.activeTab===2?"handBtn active":"handBtn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'My Progress'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.logout,className:this.state.activeTab===3?"handBtn active":"handBtn"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Logout')))))))),this.state.activeTab===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MyTasksComponent,Object.assign({bestScores:this.state.bestScores},this.props)):null,this.state.activeTab===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__MyProfile__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Shared_Footer__["a" /* default */],null));}}]);return MainStudentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var MyTasksComponent=function(_Component2){_inherits(MyTasksComponent,_Component2);function MyTasksComponent(props){_classCallCheck(this,MyTasksComponent);var _this4=_possibleConstructorReturn(this,(MyTasksComponent.__proto__||Object.getPrototypeOf(MyTasksComponent)).call(this,props));_this4.state={modalDialog:false,popupSurvey:true,responseContent:''};_this4.handleSurveyBack=_this4.handleSurveyBack.bind(_this4);_this4.handleMaze=_this4.handleMaze.bind(_this4);_this4.handleSlashTest=_this4.handleSlashTest.bind(_this4);_this4.handleWordMark=_this4.handleWordMark.bind(_this4);_this4.handleWordMark2=_this4.handleWordMark2.bind(_this4);_this4.handleKidSpeak=_this4.handleKidSpeak.bind(_this4);_this4.handlePictureNaming=_this4.handlePictureNaming.bind(_this4);_this4.handleCopyRight=_this4.handleCopyRight.bind(_this4);_this4.handleWordSignSay=_this4.handleWordSignSay.bind(_this4);_this4.handleKidSign=_this4.handleKidSign.bind(_this4);return _this4;}_createClass(MyTasksComponent,[{key:'handleSurveyBack',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:case'end':return _context2.stop();}}},_callee2,this);}));function handleSurveyBack(){return _ref2.apply(this,arguments);}return handleSurveyBack;}()},{key:'handleMaze',value:function handleMaze(event){event.preventDefault();if(!this.props.appStates.filteredApps.includes("maze")){return null;}else{this.props.history.push('/student/tasks/maze');}}},{key:'handleSlashTest',value:function handleSlashTest(event){event.preventDefault();if(!this.props.appStates.filteredApps.includes("slash")){return null;}else{this.props.history.push('/student/tasks/slashtest');}}},{key:'handleWordMark',value:function handleWordMark(event){event.preventDefault();if(!this.props.appStates.filteredApps.includes("wordmark")){return null;}else if(this.props.apps.wordMarkScores.filter(function(x){return x.gradingDate==null;}).length>2){this.setState({modalDialog:true,responseContent:'You have 3 WordMark tasks waiting to be scored. You can continue after they are scored by your teacher.'});}else{this.props.history.push('/student/tasks/wordmark');}}},{key:'handleWordMark2',value:function handleWordMark2(event){event.preventDefault();this.props.history.push('/student/tasks/wordmark2');}},{key:'handleKidSpeak',value:function handleKidSpeak(event){event.preventDefault();if(!this.props.appStates.filteredApps.includes("kidspeak")){return null;}else if(this.props.apps.kidSpeakScores.filter(function(x){return x.gradingDate==null;}).length>2){this.setState({modalDialog:true,responseContent:'You have 3 KidSpeak tasks waiting to be scored. You can continue after they are scored by your teacher.'});}else{this.props.history.push('/student/apps/kidspeak');}}},{key:'handlePictureNaming',value:function handlePictureNaming(event){event.preventDefault();if(!this.props.appStates.filteredApps.includes("picturenaming")){return null;}else if(this.props.apps.pictureNamingScores.filter(function(x){return x.gradingDate==null;}).length>2){this.setState({modalDialog:true,responseContent:'You have 3 Picture Naming tasks waiting to be scored. You can continue after they are graded.'});}else{this.props.history.push('/student/apps/picturenaming');}}},{key:'handleCopyRight',value:function handleCopyRight(event){event.preventDefault();if(!this.props.appStates.filteredApps.includes("copyright")){return null;}else if(this.props.apps.copyRightScores.filter(function(x){return x.gradingDate==null;}).length>2){this.setState({modalDialog:true,responseContent:'You have 3 CopyRight tasks waiting to be scored. You can continue after they are scored by your teacher.'});}else{this.props.history.push('/student/apps/copyright');}}},{key:'handleKidSign',value:function handleKidSign(event){event.preventDefault();if(!this.props.appStates.filteredApps.includes("kidsign")){return null;}else if(this.props.apps.kidSignScores.filter(function(x){return x.gradingDate==null;}).length>2){this.setState({modalDialog:true,responseContent:'You have 3 KidSign tasks waiting to be scored. You can continue after they are scored by your teacher.'});}else{this.props.history.push('/student/apps/kidsign');}}},{key:'handleWordSignSay',value:function handleWordSignSay(event){event.preventDefault();if(!this.props.appStates.filteredApps.includes("wordsignsay")){return null;}else if(this.props.apps.wordSignSayScores.filter(function(x){return x.gradingDate==null;}).length>2){this.setState({modalDialog:true,responseContent:'You have 3 Word Sign/Say tasks waiting to be scored. You can continue after they are scored by your teacher.'});}else{this.props.history.push('/student/apps/wordsignsay');}}},{key:'render',value:function render(){var _this5=this;var _ref3=this.props.appStates?this.props.appStates:{allowedApps:[],filteredApps:[],finishedApps:[]},allowedApps=_ref3.allowedApps,filteredApps=_ref3.filteredApps,finishedApps=_ref3.finishedApps;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Shared_DialogBox__["a" /* default */],{warning:true,notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this5.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Shared_DialogBox__["a" /* default */],{surveyModal:true,app:'Homepage',userId:this.props.studentUser.id,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'tc'},'MY TASKS: ',this.props.studentUser.firstname+' '+this.props.studentUser.lastname),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav nav-pills pill-sm'},allowedApps.includes("picturenaming")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{margin:10}},this.props.bestScores.pnLevel>3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',style:{cursor:'not-allowed'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_app_picturenaming_png___default.a,className:'ico-l',alt:'Picture Naming',style:{height:75,filter:filteredApps.includes("picturenaming")?"none":"grayscale(100%)",opacity:filteredApps.includes("picturenaming")?"1":"0.5"},border:'0'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_21__assets_images_badge_7_png___default.a,style:{position:'absolute',right:-20,bottom:-20}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handlePictureNaming,style:{cursor:filteredApps.includes("picturenaming")?"pointer":"default"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_app_picturenaming_png___default.a,className:'ico-l',alt:'Picture Naming',style:{height:75,filter:filteredApps.includes("picturenaming")?"none":"grayscale(100%)",opacity:filteredApps.includes("picturenaming")?"1":"0.5"},border:'0'}))):null,allowedApps.includes("wordsignsay")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{margin:10}},this.props.bestScores.wssLevel>1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',style:{cursor:"not-allowed"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_app_wordsignsay_png___default.a,className:'ico-l',alt:'Word Sign/Say',style:{height:75,filter:filteredApps.includes("wordsignsay")?"none":"grayscale(100%)",opacity:filteredApps.includes("wordsignsay")?"1":"0.5"},border:'0'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18__assets_images_badge_4_png___default.a,style:{position:'absolute',right:-20,bottom:-20}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleWordSignSay,style:{cursor:filteredApps.includes("wordsignsay")?"pointer":"default"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__assets_images_app_wordsignsay_png___default.a,className:'ico-l',alt:'Word Sign/Say',style:{height:75,filter:filteredApps.includes("wordsignsay")?"none":"grayscale(100%)",opacity:filteredApps.includes("wordsignsay")?"1":"0.5"},border:'0'}))):null,allowedApps.includes("copyright")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{margin:10}},this.props.bestScores.crLevel>6?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',style:{cursor:"not-allowed"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_app_copyright_png___default.a,className:'ico-l',alt:'CopyRight',border:'0',style:{height:75,filter:filteredApps.includes("copyright")?"none":"grayscale(100%)",opacity:filteredApps.includes("copyright")?"1":"0.5"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15__assets_images_badge_1_png___default.a,style:{position:'absolute',right:-20,bottom:-20}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleCopyRight,style:{cursor:filteredApps.includes("copyright")?"pointer":"default"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_app_copyright_png___default.a,className:'ico-l',alt:'CopyRight',border:'0',style:{height:75,filter:filteredApps.includes("copyright")?"none":"grayscale(100%)",opacity:filteredApps.includes("copyright")?"1":"0.5"}}))):null,allowedApps.includes("slash")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{margin:10}},this.props.bestScores.slashLevel>8?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',style:{cursor:"not-allowed"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_images_logo_slashtest_png___default.a,className:'ico-l',alt:'Slashtest',border:'0',style:{height:75,filter:filteredApps.includes("slash")?"none":"grayscale(100%)",opacity:filteredApps.includes("slash")?"1":"0.5"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_17__assets_images_badge_3_png___default.a,style:{position:'absolute',right:-20,bottom:-20}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleSlashTest,style:{cursor:filteredApps.includes("slash")?"pointer":"default"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_images_logo_slashtest_png___default.a,className:'ico-l',alt:'Slashtest',border:'0',style:{height:75,filter:filteredApps.includes("slash")?"none":"grayscale(100%)",opacity:filteredApps.includes("slash")?"1":"0.5"}}))):null,allowedApps.includes("kidspeak")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{margin:10}},this.props.bestScores.ksLevel>12?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',style:{cursor:"not-allowed"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png___default.a,className:'ico-l',alt:'Kid Speak',border:'0',style:{height:75,filter:filteredApps.includes("kidspeak")?"none":"grayscale(100%)",opacity:filteredApps.includes("kidspeak")?"1":"0.5"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_badge_2_png___default.a,style:{position:'absolute',right:-20,bottom:-20}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleKidSpeak,style:{cursor:filteredApps.includes("kidspeak")?"pointer":"default"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png___default.a,className:'ico-l',alt:'Kid Speak',border:'0',style:{height:75,filter:filteredApps.includes("kidspeak")?"none":"grayscale(100%)",opacity:filteredApps.includes("kidspeak")?"1":"0.5"}}))):null,allowedApps.includes("maze")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{margin:10}},this.props.bestScores.mazeLevel>12?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',style:{cursor:"not-allowed"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__assets_images_logo_maze_png___default.a,className:'ico-l',alt:'Maze',border:'0',style:{height:75,filter:filteredApps.includes("maze")?"none":"grayscale(100%)",opacity:filteredApps.includes("maze")?"1":"0.5"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_images_badge_5_png___default.a,style:{position:'absolute',right:-20,bottom:-20}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleMaze,style:{cursor:filteredApps.includes("maze")?"pointer":"default"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__assets_images_logo_maze_png___default.a,className:'ico-l',alt:'Maze',border:'0',style:{height:75,filter:filteredApps.includes("maze")?"none":"grayscale(100%)",opacity:filteredApps.includes("maze")?"1":"0.5"}}))):null,allowedApps.includes("kidsign")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{margin:10}},this.props.bestScores.kssLevel>12?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',style:{cursor:"not-allowed"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__assets_images_app_kidsignsay_png___default.a,className:'ico-l',alt:'KidSign',border:'0',style:{height:75,filter:filteredApps.includes("kidsign")?"none":"grayscale(100%)",opacity:filteredApps.includes("kidsign")?"1":"0.5"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_badge_6_png___default.a,style:{position:'absolute',right:-20,bottom:-20}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleKidSign,style:{cursor:filteredApps.includes("kidsign")?"pointer":"default"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__assets_images_app_kidsignsay_png___default.a,className:'ico-l',alt:'KidSign',border:'0',style:{height:75,filter:filteredApps.includes("kidsign")?"none":"grayscale(100%)",opacity:filteredApps.includes("kidsign")?"1":"0.5"}}))):null,allowedApps.includes("wordmark")?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleWordMark,style:{cursor:filteredApps.includes("wordmark")?"pointer":"default"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_logo_wordmark_png___default.a,className:'ico-l',alt:'Word Mark',border:'0',style:{height:75,filter:filteredApps.includes("wordmark")?"none":"grayscale(100%)",opacity:filteredApps.includes("wordmark")?"1":"0.5"}}))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{style:{margin:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-toggle':'pill',onClick:this.handleWordMark2,style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark2_png___default.a,className:'ico-l',alt:'Word Mark',border:'0',style:{height:75,filter:"none",opacity:"1"}}))))))));}}]);return MyTasksComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Tasks=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(MyTasksComponent);var MyHistoryComponent=function(_Component3){_inherits(MyHistoryComponent,_Component3);function MyHistoryComponent(){_classCallCheck(this,MyHistoryComponent);return _possibleConstructorReturn(this,(MyHistoryComponent.__proto__||Object.getPrototypeOf(MyHistoryComponent)).apply(this,arguments));}_createClass(MyHistoryComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'tc'},'My History Component');}}]);return MyHistoryComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__StudentsComponent_actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context3.abrupt('return',_context3.sent);case 3:case'end':return _context3.stop();}}},_callee3,_this7);}));function updateStudentAppStatus(_x2){return _ref4.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context4.abrupt('return',_context4.sent);case 3:case'end':return _context4.stop();}}},_callee4,_this7);}));function updateStudentAccountTab(_x3){return _ref5.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_27__actions__["a" /* updateAppStates */])(appStates));case 2:return _context5.abrupt('return',_context5.sent);case 3:case'end':return _context5.stop();}}},_callee5,_this7);}));function updateAppStates(_x4){return _ref6.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_24_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(MainStudentComponent)));

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Chart_Chart__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(27);
var _this12=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { LineChart, Line, CartesianGrid, XAxis, YAxis, ResponsiveContainer } from 'recharts';
var addClassInstruction=null;var addStudentInstruction=null;var PNInstruction=null;var WSSInstruction=null;var CopyrightInstruction=null;var KidsignInstruction=null;var StudentDataComponent=function(_Component){_inherits(StudentDataComponent,_Component);function StudentDataComponent(props){var _this2=this;_classCallCheck(this,StudentDataComponent);var _this=_possibleConstructorReturn(this,(StudentDataComponent.__proto__||Object.getPrototypeOf(StudentDataComponent)).call(this,props));_this.handleLogout=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(localStorage.getItem('addClass')==='hide'){addClassInstruction=localStorage.getItem('addClass');}if(localStorage.getItem('addStudent')==='hide'){addStudentInstruction=localStorage.getItem('addStudent');}localStorage.removeItem('token');if(addClassInstruction!==null){localStorage.setItem('addClass',addClassInstruction);}if(addStudentInstruction!==null){localStorage.setItem('addStudent',addStudentInstruction);}_this.props.history.push("/");case 6:case'end':return _context.stop();}}},_callee,_this2);}));_this.state={data:[],updateNote:null,appName:"appName",student:_this.props.student,PNModel:_this.props.PNModel};return _this;}_createClass(StudentDataComponent,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__["a" /* default */].authorize(this);switch(this.props.type){case 1:this.listMazeData();break;case 2:this.listSlashTestData();break;case 3:this.listWordMarkData();break;case 4:this.listKidSpeakData();break;case 5:this.listPictureNamingData();break;case 6:this.listCopyRightData();break;case 7:this.listWordSignSayData();break;case 8:this.listKidSignData();break;case 9:this.listWordMark2Data();break;default:break;}}},{key:'listMazeData',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listMazeScoreData(this.props.student.userId).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('Response',response.body);if(!response.success){_context2.next=10;break;}if(!(response.body&&response.body.length===0)){_context2.next=4;break;}return _context2.abrupt('return',_this3.props.history.push("/"));case 4:_context2.next=6;return _this3.setState({data:response.body,updateNote:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateMazeNote,appName:"Maze"});case 6:_context2.next=8;return _this3.props.updateChartData(Object.assign({},_this3.state,{chartData:_this3.state.data,chartRules:{growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],maxLevel:12,showScore:false,isTeacher:true,macroLevelGrowth:26//move up a level every 18 weeks
},xLabel:"Weeks",yLabel:"Highest Level Reached"}));case 8:_context2.next=11;break;case 10:alert('Error fetching data: '+response.msg);case 11:case'end':return _context2.stop();}}},_callee2,_this3);}));return function(_x){return _ref3.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 2:case'end':return _context3.stop();}}},_callee3,this);}));function listMazeData(){return _ref2.apply(this,arguments);}return listMazeData;}()},{key:'listSlashTestData',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listSlashTestScoreData(this.props.student.userId).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!response.success){_context4.next=9;break;}if(!(response.body&&response.body.length===0)){_context4.next=3;break;}return _context4.abrupt('return',_this4.props.history.push("/"));case 3:_context4.next=5;return _this4.setState({data:response.body,updateNote:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateSlashNote,appName:"Slash"});case 5:_context4.next=7;return _this4.props.updateChartData(Object.assign({},_this4.state,{chartData:_this4.state.data,chartRules:{growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25,1.25,1.25,1.25,1.25],maxLevel:12,showScore:false,isTeacher:true},xLabel:"Weeks",yLabel:"Highest Level Reached"}));case 7:_context4.next=10;break;case 9:alert('Error fetching data: '+response.msg);case 10:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x2){return _ref5.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 2:case'end':return _context5.stop();}}},_callee5,this);}));function listSlashTestData(){return _ref4.apply(this,arguments);}return listSlashTestData;}()},{key:'listKidSpeakData',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listKidSpeakScoreData(this.props.student.userId).then(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!response.success){_context6.next=9;break;}if(!(response.body&&response.body.length===0)){_context6.next=3;break;}return _context6.abrupt('return',_this5.props.history.push("/"));case 3:_context6.next=5;return _this5.setState({data:response.body,updateNote:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateKidSpeakNote,appName:"KidSpeak"});case 5:_context6.next=7;return _this5.props.updateChartData(Object.assign({},_this5.state,{chartData:_this5.state.data,chartRules:{growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25,1.25,1.25,1.25,1.25],maxLevel:12,showScore:false,isTeacher:true,macroLevelGrowth:26},xLabel:"Weeks",yLabel:"Highest Level Reached"}));case 7:_context6.next=10;break;case 9:alert('Error fetching data: '+response.msg);case 10:case'end':return _context6.stop();}}},_callee6,_this5);}));return function(_x3){return _ref7.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 2:case'end':return _context7.stop();}}},_callee7,this);}));function listKidSpeakData(){return _ref6.apply(this,arguments);}return listKidSpeakData;}()},{key:'listPictureNamingData',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listPictureNamingData(this.props.student.userId,this.state.PNModel).then(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(response){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:if(!response.success){_context8.next=10;break;}if(!(response.body&&response.body.length===0)){_context8.next=3;break;}return _context8.abrupt('return',_this6.props.history.push("/"));case 3:data=response.body;_context8.next=6;return _this6.setState({data:response.body,updateNote:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updatePNNote,appName:"Picture Naming"});case 6:_context8.next=8;return _this6.props.updateChartData(Object.assign({},_this6.state,{chartData:_this6.state.data,chartRules:{growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],maxLevel:3,showScore:true,isTeacher:true},xLabel:"Weeks",yLabel:"Speed",PNModel:_this6.state.PNModel}));case 8:_context8.next=11;break;case 10:alert('Error fetching data: '+response.msg);case 11:case'end':return _context8.stop();}}},_callee8,_this6);}));return function(_x4){return _ref9.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 2:case'end':return _context9.stop();}}},_callee9,this);}));function listPictureNamingData(){return _ref8.apply(this,arguments);}return listPictureNamingData;}()},{key:'listCopyRightData',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listCopyRightData(this.props.student.userId).then(function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(!response.success){_context10.next=9;break;}if(!(response.body&&response.body.length===0)){_context10.next=3;break;}return _context10.abrupt('return',_this7.props.history.push("/"));case 3:_context10.next=5;return _this7.setState({data:response.body,updateNote:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateCopyRightNote,appName:"CopyRight"});case 5:_context10.next=7;return _this7.props.updateChartData(Object.assign({},_this7.state,{chartData:_this7.state.data,chartRules:{growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],maxLevel:12,showScore:false,isTeacher:true},xLabel:"Weeks",yLabel:"Highest Level Reached"}));case 7:_context10.next=10;break;case 9:alert('Error fetching data: '+response.msg);case 10:case'end':return _context10.stop();}}},_callee10,_this7);}));return function(_x5){return _ref11.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 2:case'end':return _context11.stop();}}},_callee11,this);}));function listCopyRightData(){return _ref10.apply(this,arguments);}return listCopyRightData;}()},{key:'listKidSignData',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){var _this8=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listKidSignData(this.props.student.userId).then(function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:if(!response.success){_context12.next=9;break;}if(!(response.body&&response.body.length===0)){_context12.next=3;break;}return _context12.abrupt('return',_this8.props.history.push("/"));case 3:_context12.next=5;return _this8.setState({data:response.body,updateNote:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateKidSignNote,appName:"KidSign"});case 5:_context12.next=7;return _this8.props.updateChartData(Object.assign({},_this8.state,{chartData:_this8.state.data,chartRules:{growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],maxLevel:12,showScore:false,isTeacher:true},xLabel:"Weeks",yLabel:"Highest Level Reached"}));case 7:_context12.next=10;break;case 9:alert('Error fetching data: '+response.msg);case 10:case'end':return _context12.stop();}}},_callee12,_this8);}));return function(_x6){return _ref13.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 2:case'end':return _context13.stop();}}},_callee13,this);}));function listKidSignData(){return _ref12.apply(this,arguments);}return listKidSignData;}()},{key:'listWordSignSayData',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(){var _this9=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listWordSignSayData(this.props.student.userId).then(function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(response){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:if(!response.success){_context14.next=10;break;}if(!(response.body&&response.body.length===0)){_context14.next=3;break;}return _context14.abrupt('return',_this9.props.history.push("/"));case 3:data=response.body;_context14.next=6;return _this9.setState({data:response.body,updateNote:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWordSignSayNote,appName:"Word Sign/Say"});case 6:_context14.next=8;return _this9.props.updateChartData(Object.assign({},_this9.state,{chartData:_this9.state.data,chartRules:{growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],maxLevel:12,showScore:true,isTeacher:true},xLabel:"Weeks",yLabel:"Speed"}));case 8:_context14.next=11;break;case 10:alert('Error fetching data: '+response.msg);case 11:case'end':return _context14.stop();}}},_callee14,_this9);}));return function(_x7){return _ref15.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 2:case'end':return _context15.stop();}}},_callee15,this);}));function listWordSignSayData(){return _ref14.apply(this,arguments);}return listWordSignSayData;}()},{key:'listWordMarkData',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(){var _this10=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listWorkMarkScoreData(this.props.student.userId).then(function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:if(!response.success){_context16.next=9;break;}if(!(response.body&&response.body.length===0)){_context16.next=3;break;}return _context16.abrupt('return',_this10.props.history.push("/"));case 3:_context16.next=5;return _this10.setState({data:response.body,updateNote:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWordMarkNote,appName:"WordMark"});case 5:_context16.next=7;return _this10.props.updateChartData(Object.assign({},_this10.state,{chartData:_this10.state.data,chartRules:{growthRate:[2,2],maxLevel:2,showScore:true,isTeacher:true},xLabel:"Weeks",yLabel:"Highest Level Reached"}));case 7:_context16.next=10;break;case 9:alert('Error fetching data: '+response.msg);case 10:case'end':return _context16.stop();}}},_callee16,_this10);}));return function(_x8){return _ref17.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 2:case'end':return _context17.stop();}}},_callee17,this);}));function listWordMarkData(){return _ref16.apply(this,arguments);}return listWordMarkData;}()},{key:'listWordMark2Data',value:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(){var _this11=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listWorkMark2ScoreData(this.props.student.userId).then(function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:if(!response.success){_context18.next=9;break;}if(!(response.body&&response.body.length===0)){_context18.next=3;break;}return _context18.abrupt('return',_this11.props.history.push("/"));case 3:_context18.next=5;return _this11.setState({data:response.body,updateNote:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWordMark2Note,appName:"WordMark2"});case 5:_context18.next=7;return _this11.props.updateChartData(Object.assign({},_this11.state,{chartData:_this11.state.data,chartRules:{growthRate:[2,2],maxLevel:2,showScore:true,isTeacher:true},xLabel:"Weeks",yLabel:"Highest Level Reached"}));case 7:_context18.next=10;break;case 9:alert('Error fetching data: '+response.msg);case 10:case'end':return _context18.stop();}}},_callee18,_this11);}));return function(_x9){return _ref19.apply(this,arguments);};}(),function(error){console.log('Error',error);});case 2:case'end':return _context19.stop();}}},_callee19,this);}));function listWordMark2Data(){return _ref18.apply(this,arguments);}return listWordMark2Data;}()},{key:'render',value:function render(){if(this.props.chartData&&this.props.chartData.length>0&&this.state.appName===this.props.appName){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-fluid chartLoader1 hidden',style:{paddingLeft:0,paddingRight:0,background:'#f2f2f2'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container-fluid",style:{background:'#fff'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_Header__["a" /* default */],{dataCharts:true,appName:this.props.appName,PNModel:this.props.PNModel,imageSrc:true,sName:this.props.student,logout:this.handleLogout})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_Chart_Chart__["a" /* default */],{appName:this.props.appName,student:this.props.student,globalData:this.props.chartData,updateNote:this.props.updateNote,max:20,chartRules:this.props.chartRules,xLabel:this.props.xLabel,yLabel:this.props.yLabel,PNModel:this.props.PNModel,teacher:this.props.teacher}));}return null;}}]);return StudentDataComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionsToProps=function bindActionsToProps(dispatch){return{updateChartData:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(state){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* prepareChartData */])(state));case 2:return _context20.abrupt('return',_context20.sent);case 3:case'end':return _context20.stop();}}},_callee20,_this12);}));function updateChartData(_x10){return _ref20.apply(this,arguments);}return updateChartData;}()};};var mapStateToProps=function mapStateToProps(state){return{chartData:state.teacherReducer.chartData,chartRules:state.teacherReducer.chartRules,xLabel:state.teacherReducer.xLabel,yLabel:state.teacherReducer.yLabel,updateNote:state.teacherReducer.updateNote,appName:state.teacherReducer.appName,student:state.teacherReducer.student,teacher:state.teacherReducer.teacher};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,bindActionsToProps)(StudentDataComponent)));

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TemplateImporter_TemplateImporter_js__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TemplateImporter_TemplateImporter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TemplateImporter_TemplateImporter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_DialogBox__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChartComponent=function(_Component){_inherits(ChartComponent,_Component);function ChartComponent(props){_classCallCheck(this,ChartComponent);var _this=_possibleConstructorReturn(this,(ChartComponent.__proto__||Object.getPrototypeOf(ChartComponent)).call(this,props));_this.state={extHTML:{__html:""},chartData:[],student:_this.props.student};_this.recordHowToUseData=_this.recordHowToUseData.bind(_this);_this.recordViewMicroDataChart=_this.recordViewMicroDataChart.bind(_this);_this.recordViewMacroDataChart=_this.recordViewMacroDataChart.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleResourceAnalytics=_this.handleResourceAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(ChartComponent,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get("/charts/chartTemplate.html").then(function(res){console.log(res);_this2.setState({extHTML:{__html:res.text}});}).catch(function(err){//handle your error here
});}},{key:"handleAnalytics",value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:"handleSurveyBack",value:function handleSurveyBack(){}},{key:"handleResourceAnalytics",value:function handleResourceAnalytics(resourceId){var _this3=this;this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].RESOURCES_DOWNLOAD,metadata:{resourceId:resourceId}}},function(){return _this3.handleAnalytics();});}},{key:"recordHowToUseData",value:function recordHowToUseData(app,PNModel){var _this4=this;this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].HOW_TO_USE_DATA,metadata:{app:app,PNModel:PNModel}}},function(){return _this4.handleAnalytics();});}},{key:"recordViewMicroDataChart",value:function recordViewMicroDataChart(app,studentUserId,level){var _this5=this;var appType=void 0;switch(app){case'Maze':appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].MAZE_DATACHART_VIEW_MICRO;break;case"Slash":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].SLASH_DATACHART_VIEW_MICRO;break;case"WordMark":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].WORDMARK_DATACHART_VIEW_MICRO;break;case'KidSign':appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].KSS_DATACHART_VIEW_MICRO;break;case'KidSpeak':appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].KS_DATACHART_VIEW_MICRO;break;case"Picture Naming":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].PN_DATACHART_VIEW_MICRO;break;case"Word Sign/Say":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].WSS_DATACHART_VIEW_MICRO;break;case"CopyRight":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].COPYRIGHT_DATACHART_VIEW_MICRO;break;}this.setState({analytics:{type:appType,metadata:{userId:studentUserId,level:level}}},function(){return _this5.handleAnalytics();});}},{key:"recordViewMacroDataChart",value:function recordViewMacroDataChart(app,studentUserId){var _this6=this;var appType=void 0;switch(app){case'Maze':appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].MAZE_DATACHART_VIEW_MACRO;break;case"Slash":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].SLASH_DATACHART_VIEW_MACRO;break;case"WordMark":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].WORDMARK_DATACHART_VIEW_MACRO;break;case'KidSign':appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].KSS_DATACHART_VIEW_MACRO;break;case'KidSpeak':appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].KS_DATACHART_VIEW_MACRO;break;case"Picture Naming":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].PN_DATACHART_VIEW_MACRO;break;case"Word Sign/Say":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].WSS_DATACHART_VIEW_MACRO;break;case"CopyRight":appType=__WEBPACK_IMPORTED_MODULE_4__DataTrackingPoints__["b" /* default */].COPYRIGHT_DATACHART_VIEW_MACRO;break;}this.setState({analytics:{type:appType,metadata:{userId:studentUserId}}},function(){return _this6.handleAnalytics();});}},{key:"render",value:function render(){window.recordHowToUseData=this.recordHowToUseData;window.recordViewMacroDataChart=this.recordViewMacroDataChart;window.recordViewMicroDataChart=this.recordViewMicroDataChart;window.handleResourceAnalytics=this.handleResourceAnalytics;if(this.props.globalData.length>0){window.chartComponentContext={chartData:this.props.globalData,student:this.props.student,updateNote:this.props.updateNote,appName:this.props.appName,chartRules:this.props.chartRules,xLabel:this.props.xLabel,yLabel:this.props.yLabel,PNModel:this.props.PNModel};}else{window.chartComponentContext={chartData:[],student:null,updateNote:null,chartRules:this.props.chartRules,xLabel:this.props.xLabel,yLabel:this.props.yLabel,PNModel:this.props.PNModel};}var appName=void 0;switch(this.props.appName){case'Maze':appName="MazeDataChart";break;case"Slash":appName="SlashDataChart";break;case"WordMark":appName="WMDataChart";break;case'KidSign':appName="KSSDataChart";break;case'KidSpeak':appName="KSDataChart";break;case"Picture Naming":appName="PNDataChart";break;case"Word Sign/Say":appName="WSSDataChart";break;case"CopyRight":appName="CRDataChart";break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:appName,userId:this.props.teacher?this.props.teacher.id:null,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TemplateImporter_TemplateImporter_js___default.a,{html:this.state.extHTML.__html}));}}]);return ChartComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChartComponent);

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var parse5=__webpack_require__(780);var flatten=__webpack_require__(794);var React=__webpack_require__(0);var uuid=__webpack_require__(795).v4;var fbemitter=__webpack_require__(797);var createReactClass=__webpack_require__(361);var isBrowser=!!(document&&window);var totalNumber=0;var loadNumber=0;var toLoadSrc=[];var emitter=new fbemitter.EventEmitter();emitter.addListener('loaded',function(){loadNumber++;onLoaded();});var onLoaded=function onLoaded(src){src&&toLoadSrc.push(src);if(loadNumber>=totalNumber){toLoadSrc.map(function(s){loadText(s);});toLoadSrc=[];}};var loadSrc=function loadSrc(src){totalNumber++;var script=document.createElement("script");script.src=src;script.onload=function(){emitter.emit('loaded');};script.async=false;document.body.appendChild(script);};var loadText=function loadText(src){var script=document.createElement("script");script.innerHTML=src;script.async=false;document.body.appendChild(script);};var findScritps=function findScritps(node){if(node.tagName&&node.tagName==='script'){if(node.childNodes&&node.childNodes.length>0){return(node.childNodes||[]).map(function(n){return n.value;});}else{var srcs=(node.attrs||[]).map(function(n){if(n['name']=='src'){return n.value;}});var fns=(srcs||[]).map(function(n){n&&loadSrc(n);});}}return flatten((node.childNodes||[]).map(findScritps));};var run=function run(){var scripts=(this.state||{}).scripts||[];var fns=scripts.map(function(src){src&&onLoaded(src);});};module.exports=createReactClass({displayName:'exports',clean:function clean(){if(!this.state.id||!isBrowser){return;}var node=document.getElementById(this.state.id);if(!node){return;}while(node.hasChildNodes()){node.removeChild(node.lastChild);}},parse:function parse(props){var html=(props||{}).html;if(!html||typeof html!=='string'){return;}return findScritps(parse5.parseFragment(html));},initialState:function initialState(props){return{id:(this.state||{}).id||uuid(),scripts:this.parse(props)};},getInitialState:function getInitialState(){return this.initialState(this.props);},shouldComponentUpdate:function shouldComponentUpdate(nextProps){return this.props.html!==nextProps.html;},componentWillReceiveProps:function componentWillReceiveProps(nextProps){if(this.props.html===nextProps.html){return;}this.clean();this.setState(this.initialState(nextProps));},componentDidMount:run,componentDidUpdate:run,render:function render(){if(typeof this.props.html!=='string'){return null;}return React.createElement('div',{id:this.state.id,dangerouslySetInnerHTML:{__html:this.props.html}});}});

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Parser = __webpack_require__(781),
    Serializer = __webpack_require__(791);


// Shorthands
exports.parse = function parse(html, options) {
    var parser = new Parser(options);

    return parser.parse(html);
};

exports.parseFragment = function parseFragment(fragmentContext, html, options) {
    if (typeof fragmentContext === 'string') {
        options = html;
        html = fragmentContext;
        fragmentContext = null;
    }

    var parser = new Parser(options);

    return parser.parseFragment(html, fragmentContext);
};

exports.serialize = function (node, options) {
    var serializer = new Serializer(node, options);

    return serializer.serialize();
};


// Tree adapters
exports.treeAdapters = {
    default: __webpack_require__(202),
    htmlparser2: __webpack_require__(792)
};


// Streaming
// NOTE: streaming API is lazy loadable to enable bundling for platforms
// that are different from Node.js.
// See https://github.com/inikulin/parse5/issues/235.
var streamingAPI = {
    ParserStream: './parser/parser_stream',
    PlainTextConversionStream: './parser/plain_text_conversion_stream',
    SerializerStream: './serializer/serializer_stream',
    SAXParser: './sax'
};

Object.keys(streamingAPI).forEach(function (cls) {
    Object.defineProperty(exports, cls, {
        get: function () {
            try {
                return !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            }

            catch (e) {
                throw new Error(
                    cls + ' is supported only for Node.js.' +
                    'See https://github.com/inikulin/parse5/issues/235 for the details.'
                );
            }
        }
    });
});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__(143),
    OpenElementStack = __webpack_require__(784),
    FormattingElementList = __webpack_require__(785),
    LocationInfoParserMixin = __webpack_require__(786),
    defaultTreeAdapter = __webpack_require__(202),
    mergeOptions = __webpack_require__(357),
    doctype = __webpack_require__(203),
    foreignContent = __webpack_require__(790),
    UNICODE = __webpack_require__(144),
    HTML = __webpack_require__(67);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES,
    ATTRS = HTML.ATTRS;

var DEFAULT_OPTIONS = {
    locationInfo: false,
    treeAdapter: defaultTreeAdapter
};

//Misc constants
var HIDDEN_INPUT_TYPE = 'hidden';

//Adoption agency loops iteration count
var AA_OUTER_LOOP_ITER = 8,
    AA_INNER_LOOP_ITER = 3;

//Insertion modes
var INITIAL_MODE = 'INITIAL_MODE',
    BEFORE_HTML_MODE = 'BEFORE_HTML_MODE',
    BEFORE_HEAD_MODE = 'BEFORE_HEAD_MODE',
    IN_HEAD_MODE = 'IN_HEAD_MODE',
    AFTER_HEAD_MODE = 'AFTER_HEAD_MODE',
    IN_BODY_MODE = 'IN_BODY_MODE',
    TEXT_MODE = 'TEXT_MODE',
    IN_TABLE_MODE = 'IN_TABLE_MODE',
    IN_TABLE_TEXT_MODE = 'IN_TABLE_TEXT_MODE',
    IN_CAPTION_MODE = 'IN_CAPTION_MODE',
    IN_COLUMN_GROUP_MODE = 'IN_COLUMN_GROUP_MODE',
    IN_TABLE_BODY_MODE = 'IN_TABLE_BODY_MODE',
    IN_ROW_MODE = 'IN_ROW_MODE',
    IN_CELL_MODE = 'IN_CELL_MODE',
    IN_SELECT_MODE = 'IN_SELECT_MODE',
    IN_SELECT_IN_TABLE_MODE = 'IN_SELECT_IN_TABLE_MODE',
    IN_TEMPLATE_MODE = 'IN_TEMPLATE_MODE',
    AFTER_BODY_MODE = 'AFTER_BODY_MODE',
    IN_FRAMESET_MODE = 'IN_FRAMESET_MODE',
    AFTER_FRAMESET_MODE = 'AFTER_FRAMESET_MODE',
    AFTER_AFTER_BODY_MODE = 'AFTER_AFTER_BODY_MODE',
    AFTER_AFTER_FRAMESET_MODE = 'AFTER_AFTER_FRAMESET_MODE';

//Insertion mode reset map
var INSERTION_MODE_RESET_MAP = Object.create(null);

INSERTION_MODE_RESET_MAP[$.TR] = IN_ROW_MODE;
INSERTION_MODE_RESET_MAP[$.TBODY] =
INSERTION_MODE_RESET_MAP[$.THEAD] =
INSERTION_MODE_RESET_MAP[$.TFOOT] = IN_TABLE_BODY_MODE;
INSERTION_MODE_RESET_MAP[$.CAPTION] = IN_CAPTION_MODE;
INSERTION_MODE_RESET_MAP[$.COLGROUP] = IN_COLUMN_GROUP_MODE;
INSERTION_MODE_RESET_MAP[$.TABLE] = IN_TABLE_MODE;
INSERTION_MODE_RESET_MAP[$.BODY] = IN_BODY_MODE;
INSERTION_MODE_RESET_MAP[$.FRAMESET] = IN_FRAMESET_MODE;

//Template insertion mode switch map
var TEMPLATE_INSERTION_MODE_SWITCH_MAP = Object.create(null);

TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.CAPTION] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COLGROUP] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TBODY] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TFOOT] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.THEAD] = IN_TABLE_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COL] = IN_COLUMN_GROUP_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TR] = IN_TABLE_BODY_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TD] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TH] = IN_ROW_MODE;

//Token handlers map for insertion modes
var _ = Object.create(null);

_[INITIAL_MODE] = Object.create(null);
_[INITIAL_MODE][Tokenizer.CHARACTER_TOKEN] =
_[INITIAL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInInitialMode;
_[INITIAL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[INITIAL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[INITIAL_MODE][Tokenizer.DOCTYPE_TOKEN] = doctypeInInitialMode;
_[INITIAL_MODE][Tokenizer.START_TAG_TOKEN] =
_[INITIAL_MODE][Tokenizer.END_TAG_TOKEN] =
_[INITIAL_MODE][Tokenizer.EOF_TOKEN] = tokenInInitialMode;

_[BEFORE_HTML_MODE] = Object.create(null);
_[BEFORE_HTML_MODE][Tokenizer.CHARACTER_TOKEN] =
_[BEFORE_HTML_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[BEFORE_HTML_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[BEFORE_HTML_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[BEFORE_HTML_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHtml;

_[BEFORE_HEAD_MODE] = Object.create(null);
_[BEFORE_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[BEFORE_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[BEFORE_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[BEFORE_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[BEFORE_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHead;

_[IN_HEAD_MODE] = Object.create(null);
_[IN_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInHead;
_[IN_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagInHead;
_[IN_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagInHead;
_[IN_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenInHead;

_[AFTER_HEAD_MODE] = Object.create(null);
_[AFTER_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[AFTER_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[AFTER_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenAfterHead;

_[IN_BODY_MODE] = Object.create(null);
_[IN_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInBody;
_[IN_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInBody;
_[IN_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[TEXT_MODE] = Object.create(null);
_[TEXT_MODE][Tokenizer.CHARACTER_TOKEN] =
_[TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
_[TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
_[TEXT_MODE][Tokenizer.START_TAG_TOKEN] = ignoreToken;
_[TEXT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInText;
_[TEXT_MODE][Tokenizer.EOF_TOKEN] = eofInText;

_[IN_TABLE_MODE] = Object.create(null);
_[IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTable;
_[IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTable;
_[IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TABLE_TEXT_MODE] = Object.create(null);
_[IN_TABLE_TEXT_MODE][Tokenizer.CHARACTER_TOKEN] = characterInTableText;
_[IN_TABLE_TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_TABLE_TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInTableText;
_[IN_TABLE_TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.START_TAG_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.END_TAG_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.EOF_TOKEN] = tokenInTableText;

_[IN_CAPTION_MODE] = Object.create(null);
_[IN_CAPTION_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_CAPTION_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_CAPTION_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_CAPTION_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_CAPTION_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_CAPTION_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCaption;
_[IN_CAPTION_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCaption;
_[IN_CAPTION_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_COLUMN_GROUP_MODE] = Object.create(null);
_[IN_COLUMN_GROUP_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_COLUMN_GROUP_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_COLUMN_GROUP_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_COLUMN_GROUP_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_COLUMN_GROUP_MODE][Tokenizer.START_TAG_TOKEN] = startTagInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.END_TAG_TOKEN] = endTagInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TABLE_BODY_MODE] = Object.create(null);
_[IN_TABLE_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_TABLE_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_TABLE_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_TABLE_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TABLE_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TABLE_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTableBody;
_[IN_TABLE_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTableBody;
_[IN_TABLE_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_ROW_MODE] = Object.create(null);
_[IN_ROW_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_ROW_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_ROW_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_ROW_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_ROW_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_ROW_MODE][Tokenizer.START_TAG_TOKEN] = startTagInRow;
_[IN_ROW_MODE][Tokenizer.END_TAG_TOKEN] = endTagInRow;
_[IN_ROW_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_CELL_MODE] = Object.create(null);
_[IN_CELL_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_CELL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_CELL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_CELL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_CELL_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_CELL_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCell;
_[IN_CELL_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCell;
_[IN_CELL_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_SELECT_MODE] = Object.create(null);
_[IN_SELECT_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_SELECT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_SELECT_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_SELECT_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelect;
_[IN_SELECT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelect;
_[IN_SELECT_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_SELECT_IN_TABLE_MODE] = Object.create(null);
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelectInTable;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelectInTable;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TEMPLATE_MODE] = Object.create(null);
_[IN_TEMPLATE_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_TEMPLATE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_TEMPLATE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_TEMPLATE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TEMPLATE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TEMPLATE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTemplate;
_[IN_TEMPLATE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTemplate;
_[IN_TEMPLATE_MODE][Tokenizer.EOF_TOKEN] = eofInTemplate;

_[AFTER_BODY_MODE] = Object.create(null);
_[AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterBody;
_[AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToRootHtmlElement;
_[AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterBody;
_[AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterBody;
_[AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[IN_FRAMESET_MODE] = Object.create(null);
_[IN_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagInFrameset;
_[IN_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagInFrameset;
_[IN_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_FRAMESET_MODE] = Object.create(null);
_[AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterFrameset;
_[AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterFrameset;
_[AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_AFTER_BODY_MODE] = Object.create(null);
_[AFTER_AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
_[AFTER_AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_AFTER_FRAMESET_MODE] = Object.create(null);
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterFrameset;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;


//Parser
var Parser = module.exports = function (options) {
    this.options = mergeOptions(DEFAULT_OPTIONS, options);

    this.treeAdapter = this.options.treeAdapter;
    this.pendingScript = null;

    if (this.options.locationInfo)
        new LocationInfoParserMixin(this);
};

// API
Parser.prototype.parse = function (html) {
    var document = this.treeAdapter.createDocument();

    this._bootstrap(document, null);
    this.tokenizer.write(html, true);
    this._runParsingLoop(null);

    return document;
};

Parser.prototype.parseFragment = function (html, fragmentContext) {
    //NOTE: use <template> element as a fragment context if context element was not provided,
    //so we will parse in "forgiving" manner
    if (!fragmentContext)
        fragmentContext = this.treeAdapter.createElement($.TEMPLATE, NS.HTML, []);

    //NOTE: create fake element which will be used as 'document' for fragment parsing.
    //This is important for jsdom there 'document' can't be recreated, therefore
    //fragment parsing causes messing of the main `document`.
    var documentMock = this.treeAdapter.createElement('documentmock', NS.HTML, []);

    this._bootstrap(documentMock, fragmentContext);

    if (this.treeAdapter.getTagName(fragmentContext) === $.TEMPLATE)
        this._pushTmplInsertionMode(IN_TEMPLATE_MODE);

    this._initTokenizerForFragmentParsing();
    this._insertFakeRootElement();
    this._resetInsertionMode();
    this._findFormInFragmentContext();
    this.tokenizer.write(html, true);
    this._runParsingLoop(null);

    var rootElement = this.treeAdapter.getFirstChild(documentMock),
        fragment = this.treeAdapter.createDocumentFragment();

    this._adoptNodes(rootElement, fragment);

    return fragment;
};

//Bootstrap parser
Parser.prototype._bootstrap = function (document, fragmentContext) {
    this.tokenizer = new Tokenizer(this.options);

    this.stopped = false;

    this.insertionMode = INITIAL_MODE;
    this.originalInsertionMode = '';

    this.document = document;
    this.fragmentContext = fragmentContext;

    this.headElement = null;
    this.formElement = null;

    this.openElements = new OpenElementStack(this.document, this.treeAdapter);
    this.activeFormattingElements = new FormattingElementList(this.treeAdapter);

    this.tmplInsertionModeStack = [];
    this.tmplInsertionModeStackTop = -1;
    this.currentTmplInsertionMode = null;

    this.pendingCharacterTokens = [];
    this.hasNonWhitespacePendingCharacterToken = false;

    this.framesetOk = true;
    this.skipNextNewLine = false;
    this.fosterParentingEnabled = false;
};

//Parsing loop
Parser.prototype._runParsingLoop  = function (scriptHandler) {
    while (!this.stopped) {
        this._setupTokenizerCDATAMode();

        var token = this.tokenizer.getNextToken();

        if (token.type === Tokenizer.HIBERNATION_TOKEN)
            break;

        if (this.skipNextNewLine) {
            this.skipNextNewLine = false;

            if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
                if (token.chars.length === 1)
                    continue;

                token.chars = token.chars.substr(1);
            }
        }

        this._processInputToken(token);

        if (scriptHandler && this.pendingScript)
            break;
    }
};

Parser.prototype.runParsingLoopForCurrentChunk = function (writeCallback, scriptHandler) {
    this._runParsingLoop(scriptHandler);

    if (scriptHandler && this.pendingScript) {
        var script = this.pendingScript;

        this.pendingScript = null;

        scriptHandler(script);

        return;
    }

    if (writeCallback)
        writeCallback();
};

//Text parsing
Parser.prototype._setupTokenizerCDATAMode = function () {
    var current = this._getAdjustedCurrentElement();

    this.tokenizer.allowCDATA = current && current !== this.document &&
                                this.treeAdapter.getNamespaceURI(current) !== NS.HTML && !this._isIntegrationPoint(current);
};

Parser.prototype._switchToTextParsing = function (currentToken, nextTokenizerState) {
    this._insertElement(currentToken, NS.HTML);
    this.tokenizer.state = nextTokenizerState;
    this.originalInsertionMode = this.insertionMode;
    this.insertionMode = TEXT_MODE;
};

Parser.prototype.switchToPlaintextParsing = function () {
    this.insertionMode = TEXT_MODE;
    this.originalInsertionMode = IN_BODY_MODE;
    this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
};

//Fragment parsing
Parser.prototype._getAdjustedCurrentElement = function () {
    return this.openElements.stackTop === 0 && this.fragmentContext ?
        this.fragmentContext :
        this.openElements.current;
};

Parser.prototype._findFormInFragmentContext = function () {
    var node = this.fragmentContext;

    do {
        if (this.treeAdapter.getTagName(node) === $.FORM) {
            this.formElement = node;
            break;
        }

        node = this.treeAdapter.getParentNode(node);
    } while (node);
};

Parser.prototype._initTokenizerForFragmentParsing = function () {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === NS.HTML) {
        var tn = this.treeAdapter.getTagName(this.fragmentContext);

        if (tn === $.TITLE || tn === $.TEXTAREA)
            this.tokenizer.state = Tokenizer.MODE.RCDATA;

        else if (tn === $.STYLE || tn === $.XMP || tn === $.IFRAME ||
                 tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT)
            this.tokenizer.state = Tokenizer.MODE.RAWTEXT;

        else if (tn === $.SCRIPT)
            this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;

        else if (tn === $.PLAINTEXT)
            this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
    }
};

//Tree mutation
Parser.prototype._setDocumentType = function (token) {
    this.treeAdapter.setDocumentType(this.document, token.name, token.publicId, token.systemId);
};

Parser.prototype._attachElementToTree = function (element) {
    if (this._shouldFosterParentOnInsertion())
        this._fosterParentElement(element);

    else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;

        this.treeAdapter.appendChild(parent, element);
    }
};

Parser.prototype._appendElement = function (token, namespaceURI) {
    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

    this._attachElementToTree(element);
};

Parser.prototype._insertElement = function (token, namespaceURI) {
    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

    this._attachElementToTree(element);
    this.openElements.push(element);
};

Parser.prototype._insertFakeElement = function (tagName) {
    var element = this.treeAdapter.createElement(tagName, NS.HTML, []);

    this._attachElementToTree(element);
    this.openElements.push(element);
};

Parser.prototype._insertTemplate = function (token) {
    var tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs),
        content = this.treeAdapter.createDocumentFragment();

    this.treeAdapter.setTemplateContent(tmpl, content);
    this._attachElementToTree(tmpl);
    this.openElements.push(tmpl);
};

Parser.prototype._insertFakeRootElement = function () {
    var element = this.treeAdapter.createElement($.HTML, NS.HTML, []);

    this.treeAdapter.appendChild(this.openElements.current, element);
    this.openElements.push(element);
};

Parser.prototype._appendCommentNode = function (token, parent) {
    var commentNode = this.treeAdapter.createCommentNode(token.data);

    this.treeAdapter.appendChild(parent, commentNode);
};

Parser.prototype._insertCharacters = function (token) {
    if (this._shouldFosterParentOnInsertion())
        this._fosterParentText(token.chars);

    else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;

        this.treeAdapter.insertText(parent, token.chars);
    }
};

Parser.prototype._adoptNodes = function (donor, recipient) {
    while (true) {
        var child = this.treeAdapter.getFirstChild(donor);

        if (!child)
            break;

        this.treeAdapter.detachNode(child);
        this.treeAdapter.appendChild(recipient, child);
    }
};

//Token processing
Parser.prototype._shouldProcessTokenInForeignContent = function (token) {
    var current = this._getAdjustedCurrentElement();

    if (!current || current === this.document)
        return false;

    var ns = this.treeAdapter.getNamespaceURI(current);

    if (ns === NS.HTML)
        return false;

    if (this.treeAdapter.getTagName(current) === $.ANNOTATION_XML && ns === NS.MATHML &&
        token.type === Tokenizer.START_TAG_TOKEN && token.tagName === $.SVG)
        return false;

    var isCharacterToken = token.type === Tokenizer.CHARACTER_TOKEN ||
                           token.type === Tokenizer.NULL_CHARACTER_TOKEN ||
                           token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN,
        isMathMLTextStartTag = token.type === Tokenizer.START_TAG_TOKEN &&
                               token.tagName !== $.MGLYPH &&
                               token.tagName !== $.MALIGNMARK;

    if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, NS.MATHML))
        return false;

    if ((token.type === Tokenizer.START_TAG_TOKEN || isCharacterToken) && this._isIntegrationPoint(current, NS.HTML))
        return false;

    return token.type !== Tokenizer.EOF_TOKEN;
};

Parser.prototype._processToken = function (token) {
    _[this.insertionMode][token.type](this, token);
};

Parser.prototype._processTokenInBodyMode = function (token) {
    _[IN_BODY_MODE][token.type](this, token);
};

Parser.prototype._processTokenInForeignContent = function (token) {
    if (token.type === Tokenizer.CHARACTER_TOKEN)
        characterInForeignContent(this, token);

    else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN)
        nullCharacterInForeignContent(this, token);

    else if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN)
        insertCharacters(this, token);

    else if (token.type === Tokenizer.COMMENT_TOKEN)
        appendComment(this, token);

    else if (token.type === Tokenizer.START_TAG_TOKEN)
        startTagInForeignContent(this, token);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        endTagInForeignContent(this, token);
};

Parser.prototype._processInputToken = function (token) {
    if (this._shouldProcessTokenInForeignContent(token))
        this._processTokenInForeignContent(token);

    else
        this._processToken(token);
};

//Integration points
Parser.prototype._isIntegrationPoint = function (element, foreignNS) {
    var tn = this.treeAdapter.getTagName(element),
        ns = this.treeAdapter.getNamespaceURI(element),
        attrs = this.treeAdapter.getAttrList(element);

    return foreignContent.isIntegrationPoint(tn, ns, attrs, foreignNS);
};

//Active formatting elements reconstruction
Parser.prototype._reconstructActiveFormattingElements = function () {
    var listLength = this.activeFormattingElements.length;

    if (listLength) {
        var unopenIdx = listLength,
            entry = null;

        do {
            unopenIdx--;
            entry = this.activeFormattingElements.entries[unopenIdx];

            if (entry.type === FormattingElementList.MARKER_ENTRY || this.openElements.contains(entry.element)) {
                unopenIdx++;
                break;
            }
        } while (unopenIdx > 0);

        for (var i = unopenIdx; i < listLength; i++) {
            entry = this.activeFormattingElements.entries[i];
            this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
            entry.element = this.openElements.current;
        }
    }
};

//Close elements
Parser.prototype._closeTableCell = function () {
    this.openElements.generateImpliedEndTags();
    this.openElements.popUntilTableCellPopped();
    this.activeFormattingElements.clearToLastMarker();
    this.insertionMode = IN_ROW_MODE;
};

Parser.prototype._closePElement = function () {
    this.openElements.generateImpliedEndTagsWithExclusion($.P);
    this.openElements.popUntilTagNamePopped($.P);
};

//Insertion modes
Parser.prototype._resetInsertionMode = function () {
    for (var i = this.openElements.stackTop, last = false; i >= 0; i--) {
        var element = this.openElements.items[i];

        if (i === 0) {
            last = true;

            if (this.fragmentContext)
                element = this.fragmentContext;
        }

        var tn = this.treeAdapter.getTagName(element),
            newInsertionMode = INSERTION_MODE_RESET_MAP[tn];

        if (newInsertionMode) {
            this.insertionMode = newInsertionMode;
            break;
        }

        else if (!last && (tn === $.TD || tn === $.TH)) {
            this.insertionMode = IN_CELL_MODE;
            break;
        }

        else if (!last && tn === $.HEAD) {
            this.insertionMode = IN_HEAD_MODE;
            break;
        }

        else if (tn === $.SELECT) {
            this._resetInsertionModeForSelect(i);
            break;
        }

        else if (tn === $.TEMPLATE) {
            this.insertionMode = this.currentTmplInsertionMode;
            break;
        }

        else if (tn === $.HTML) {
            this.insertionMode = this.headElement ? AFTER_HEAD_MODE : BEFORE_HEAD_MODE;
            break;
        }

        else if (last) {
            this.insertionMode = IN_BODY_MODE;
            break;
        }
    }
};

Parser.prototype._resetInsertionModeForSelect = function (selectIdx) {
    if (selectIdx > 0) {
        for (var i = selectIdx - 1; i > 0; i--) {
            var ancestor = this.openElements.items[i],
                tn = this.treeAdapter.getTagName(ancestor);

            if (tn === $.TEMPLATE)
                break;

            else if (tn === $.TABLE) {
                this.insertionMode = IN_SELECT_IN_TABLE_MODE;
                return;
            }
        }
    }

    this.insertionMode = IN_SELECT_MODE;
};

Parser.prototype._pushTmplInsertionMode = function (mode) {
    this.tmplInsertionModeStack.push(mode);
    this.tmplInsertionModeStackTop++;
    this.currentTmplInsertionMode = mode;
};

Parser.prototype._popTmplInsertionMode = function () {
    this.tmplInsertionModeStack.pop();
    this.tmplInsertionModeStackTop--;
    this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
};

//Foster parenting
Parser.prototype._isElementCausesFosterParenting = function (element) {
    var tn = this.treeAdapter.getTagName(element);

    return tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR;
};

Parser.prototype._shouldFosterParentOnInsertion = function () {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
};

Parser.prototype._findFosterParentingLocation = function () {
    var location = {
        parent: null,
        beforeElement: null
    };

    for (var i = this.openElements.stackTop; i >= 0; i--) {
        var openElement = this.openElements.items[i],
            tn = this.treeAdapter.getTagName(openElement),
            ns = this.treeAdapter.getNamespaceURI(openElement);

        if (tn === $.TEMPLATE && ns === NS.HTML) {
            location.parent = this.treeAdapter.getTemplateContent(openElement);
            break;
        }

        else if (tn === $.TABLE) {
            location.parent = this.treeAdapter.getParentNode(openElement);

            if (location.parent)
                location.beforeElement = openElement;
            else
                location.parent = this.openElements.items[i - 1];

            break;
        }
    }

    if (!location.parent)
        location.parent = this.openElements.items[0];

    return location;
};

Parser.prototype._fosterParentElement = function (element) {
    var location = this._findFosterParentingLocation();

    if (location.beforeElement)
        this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
    else
        this.treeAdapter.appendChild(location.parent, element);
};

Parser.prototype._fosterParentText = function (chars) {
    var location = this._findFosterParentingLocation();

    if (location.beforeElement)
        this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
    else
        this.treeAdapter.insertText(location.parent, chars);
};

//Special elements
Parser.prototype._isSpecialElement = function (element) {
    var tn = this.treeAdapter.getTagName(element),
        ns = this.treeAdapter.getNamespaceURI(element);

    return HTML.SPECIAL_ELEMENTS[ns][tn];
};

//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------

//Steps 5-8 of the algorithm
function aaObtainFormattingElementEntry(p, token) {
    var formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);

    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        }

        else if (!p.openElements.hasInScope(token.tagName))
            formattingElementEntry = null;
    }

    else
        genericEndTagInBody(p, token);

    return formattingElementEntry;
}

//Steps 9 and 10 of the algorithm
function aaObtainFurthestBlock(p, formattingElementEntry) {
    var furthestBlock = null;

    for (var i = p.openElements.stackTop; i >= 0; i--) {
        var element = p.openElements.items[i];

        if (element === formattingElementEntry.element)
            break;

        if (p._isSpecialElement(element))
            furthestBlock = element;
    }

    if (!furthestBlock) {
        p.openElements.popUntilElementPopped(formattingElementEntry.element);
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }

    return furthestBlock;
}

//Step 13 of the algorithm
function aaInnerLoop(p, furthestBlock, formattingElement) {
    var lastElement = furthestBlock,
        nextElement = p.openElements.getCommonAncestor(furthestBlock);

    for (var i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
        //NOTE: store next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);

        var elementEntry = p.activeFormattingElements.getElementEntry(element),
            counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER,
            shouldRemoveFromOpenElements = !elementEntry || counterOverflow;

        if (shouldRemoveFromOpenElements) {
            if (counterOverflow)
                p.activeFormattingElements.removeEntry(elementEntry);

            p.openElements.remove(element);
        }

        else {
            element = aaRecreateElementFromEntry(p, elementEntry);

            if (lastElement === furthestBlock)
                p.activeFormattingElements.bookmark = elementEntry;

            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }

    return lastElement;
}

//Step 13.7 of the algorithm
function aaRecreateElementFromEntry(p, elementEntry) {
    var ns = p.treeAdapter.getNamespaceURI(elementEntry.element),
        newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);

    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;

    return newElement;
}

//Step 14 of the algorithm
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    if (p._isElementCausesFosterParenting(commonAncestor))
        p._fosterParentElement(lastElement);

    else {
        var tn = p.treeAdapter.getTagName(commonAncestor),
            ns = p.treeAdapter.getNamespaceURI(commonAncestor);

        if (tn === $.TEMPLATE && ns === NS.HTML)
            commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);

        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}

//Steps 15-19 of the algorithm
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    var ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element),
        token = formattingElementEntry.token,
        newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);

    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);

    p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);

    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement);
}

//Algorithm entry point
function callAdoptionAgency(p, token) {
    var formattingElementEntry;

    for (var i = 0; i < AA_OUTER_LOOP_ITER; i++) {
        formattingElementEntry = aaObtainFormattingElementEntry(p, token, formattingElementEntry);

        if (!formattingElementEntry)
            break;

        var furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);

        if (!furthestBlock)
            break;

        p.activeFormattingElements.bookmark = formattingElementEntry;

        var lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element),
            commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);

        p.treeAdapter.detachNode(lastElement);
        aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}


//Generic token handlers
//------------------------------------------------------------------
function ignoreToken() {
    //NOTE: do nothing =)
}

function appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
}

function appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}

function appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}

function insertCharacters(p, token) {
    p._insertCharacters(token);
}

function stopParsing(p) {
    p.stopped = true;
}

//12.2.5.4.1 The "initial" insertion mode
//------------------------------------------------------------------
function doctypeInInitialMode(p, token) {
    p._setDocumentType(token);

    var mode = token.forceQuirks ?
        HTML.DOCUMENT_MODE.QUIRKS :
        doctype.getDocumentMode(token.name, token.publicId, token.systemId);

    p.treeAdapter.setDocumentMode(p.document, mode);

    p.insertionMode = BEFORE_HTML_MODE;
}

function tokenInInitialMode(p, token) {
    p.treeAdapter.setDocumentMode(p.document, HTML.DOCUMENT_MODE.QUIRKS);
    p.insertionMode = BEFORE_HTML_MODE;
    p._processToken(token);
}


//12.2.5.4.2 The "before html" insertion mode
//------------------------------------------------------------------
function startTagBeforeHtml(p, token) {
    if (token.tagName === $.HTML) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = BEFORE_HEAD_MODE;
    }

    else
        tokenBeforeHtml(p, token);
}

function endTagBeforeHtml(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML || tn === $.HEAD || tn === $.BODY || tn === $.BR)
        tokenBeforeHtml(p, token);
}

function tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = BEFORE_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.3 The "before head" insertion mode
//------------------------------------------------------------------
function startTagBeforeHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.HEAD) {
        p._insertElement(token, NS.HTML);
        p.headElement = p.openElements.current;
        p.insertionMode = IN_HEAD_MODE;
    }

    else
        tokenBeforeHead(p, token);
}

function endTagBeforeHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HEAD || tn === $.BODY || tn === $.HTML || tn === $.BR)
        tokenBeforeHead(p, token);
}

function tokenBeforeHead(p, token) {
    p._insertFakeElement($.HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.4 The "in head" insertion mode
//------------------------------------------------------------------
function startTagInHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META)
        p._appendElement(token, NS.HTML);

    else if (tn === $.TITLE)
        p._switchToTextParsing(token, Tokenizer.MODE.RCDATA);

    //NOTE: here we assume that we always act as an interactive user agent with enabled scripting, so we parse
    //<noscript> as a rawtext.
    else if (tn === $.NOSCRIPT || tn === $.NOFRAMES || tn === $.STYLE)
        p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);

    else if (tn === $.SCRIPT)
        p._switchToTextParsing(token, Tokenizer.MODE.SCRIPT_DATA);

    else if (tn === $.TEMPLATE) {
        p._insertTemplate(token, NS.HTML);
        p.activeFormattingElements.insertMarker();
        p.framesetOk = false;
        p.insertionMode = IN_TEMPLATE_MODE;
        p._pushTmplInsertionMode(IN_TEMPLATE_MODE);
    }

    else if (tn !== $.HEAD)
        tokenInHead(p, token);
}

function endTagInHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HEAD) {
        p.openElements.pop();
        p.insertionMode = AFTER_HEAD_MODE;
    }

    else if (tn === $.BODY || tn === $.BR || tn === $.HTML)
        tokenInHead(p, token);

    else if (tn === $.TEMPLATE && p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
    }
}

function tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = AFTER_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.6 The "after head" insertion mode
//------------------------------------------------------------------
function startTagAfterHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.BODY) {
        p._insertElement(token, NS.HTML);
        p.framesetOk = false;
        p.insertionMode = IN_BODY_MODE;
    }

    else if (tn === $.FRAMESET) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }

    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
             tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE) {
        p.openElements.push(p.headElement);
        startTagInHead(p, token);
        p.openElements.remove(p.headElement);
    }

    else if (tn !== $.HEAD)
        tokenAfterHead(p, token);
}

function endTagAfterHead(p, token) {
    var tn = token.tagName;

    if (tn === $.BODY || tn === $.HTML || tn === $.BR)
        tokenAfterHead(p, token);

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);
}

function tokenAfterHead(p, token) {
    p._insertFakeElement($.BODY);
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}


//12.2.5.4.7 The "in body" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}

function characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}

function htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0)
        p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
}

function bodyStartTagInBody(p, token) {
    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}

function framesetStartTagInBody(p, token) {
    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }
}

function addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
}

function numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    var tn = p.openElements.currentTagName;

    if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
        p.openElements.pop();

    p._insertElement(token, NS.HTML);
}

function preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}

function formStartTagInBody(p, token) {
    var inTemplate = p.openElements.tmplCount > 0;

    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope($.P))
            p._closePElement();

        p._insertElement(token, NS.HTML);

        if (!inTemplate)
            p.formElement = p.openElements.current;
    }
}

function listItemStartTagInBody(p, token) {
    p.framesetOk = false;

    var tn = token.tagName;

    for (var i = p.openElements.stackTop; i >= 0; i--) {
        var element = p.openElements.items[i],
            elementTn = p.treeAdapter.getTagName(element),
            closeTn = null;

        if (tn === $.LI && elementTn === $.LI)
            closeTn = $.LI;

        else if ((tn === $.DD || tn === $.DT) && (elementTn === $.DD || elementTn === $.DT))
            closeTn = elementTn;

        if (closeTn) {
            p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
            p.openElements.popUntilTagNamePopped(closeTn);
            break;
        }

        if (elementTn !== $.ADDRESS && elementTn !== $.DIV && elementTn !== $.P && p._isSpecialElement(element))
            break;
    }

    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
}

function plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    p.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
}

function buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.BUTTON);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
}

function aStartTagInBody(p, token) {
    var activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($.A);

    if (activeElementEntry) {
        callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    if (p.openElements.hasInScope($.NOBR)) {
        callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }

    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}

function tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== HTML.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode = IN_TABLE_MODE;
}

function areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
}

function inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);

    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (!inputType || inputType.toLowerCase() !== HIDDEN_INPUT_TYPE)
        p.framesetOk = false;

}

function paramStartTagInBody(p, token) {
    p._appendElement(token, NS.HTML);
}

function hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
}

function imageStartTagInBody(p, token) {
    token.tagName = $.IMG;
    areaStartTagInBody(p, token);
}

function textareaStartTagInBody(p, token) {
    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = Tokenizer.MODE.RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = TEXT_MODE;
}

function xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
//<noembed> as a rawtext.
function noembedStartTagInBody(p, token) {
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;

    if (p.insertionMode === IN_TABLE_MODE ||
        p.insertionMode === IN_CAPTION_MODE ||
        p.insertionMode === IN_TABLE_BODY_MODE ||
        p.insertionMode === IN_ROW_MODE ||
        p.insertionMode === IN_CELL_MODE)

        p.insertionMode = IN_SELECT_IN_TABLE_MODE;

    else
        p.insertionMode = IN_SELECT_MODE;
}

function optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.OPTION)
        p.openElements.pop();

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

function rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY))
        p.openElements.generateImpliedEndTags();

    p._insertElement(token, NS.HTML);
}

function rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY))
        p.openElements.generateImpliedEndTagsWithExclusion($.RTC);

    p._insertElement(token, NS.HTML);
}

function menuitemStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    // TODO needs clarification, see https://github.com/whatwg/html/pull/907/files#r73505877
    p._reconstructActiveFormattingElements();

    p._insertElement(token, NS.HTML);
}

function menuStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    p._insertElement(token, NS.HTML);
}

function mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenMathMLAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing)
        p._appendElement(token, NS.MATHML);
    else
        p._insertElement(token, NS.MATHML);
}

function svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenSVGAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing)
        p._appendElement(token, NS.SVG);
    else
        p._insertElement(token, NS.SVG);
}

function genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function startTagInBody(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.I || tn === $.S || tn === $.B || tn === $.U)
                bStartTagInBody(p, token);

            else if (tn === $.P)
                addressStartTagInBody(p, token);

            else if (tn === $.A)
                aStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 2:
            if (tn === $.DL || tn === $.OL || tn === $.UL)
                addressStartTagInBody(p, token);

            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
                numberedHeaderStartTagInBody(p, token);

            else if (tn === $.LI || tn === $.DD || tn === $.DT)
                listItemStartTagInBody(p, token);

            else if (tn === $.EM || tn === $.TT)
                bStartTagInBody(p, token);

            else if (tn === $.BR)
                areaStartTagInBody(p, token);

            else if (tn === $.HR)
                hrStartTagInBody(p, token);

            else if (tn === $.RB)
                rbStartTagInBody(p, token);

            else if (tn === $.RT || tn === $.RP)
                rtStartTagInBody(p, token);

            else if (tn !== $.TH && tn !== $.TD && tn !== $.TR)
                genericStartTagInBody(p, token);

            break;

        case 3:
            if (tn === $.DIV || tn === $.DIR || tn === $.NAV)
                addressStartTagInBody(p, token);

            else if (tn === $.PRE)
                preStartTagInBody(p, token);

            else if (tn === $.BIG)
                bStartTagInBody(p, token);

            else if (tn === $.IMG || tn === $.WBR)
                areaStartTagInBody(p, token);

            else if (tn === $.XMP)
                xmpStartTagInBody(p, token);

            else if (tn === $.SVG)
                svgStartTagInBody(p, token);

            else if (tn === $.RTC)
                rbStartTagInBody(p, token);

            else if (tn !== $.COL)
                genericStartTagInBody(p, token);

            break;

        case 4:
            if (tn === $.HTML)
                htmlStartTagInBody(p, token);

            else if (tn === $.BASE || tn === $.LINK || tn === $.META)
                startTagInHead(p, token);

            else if (tn === $.BODY)
                bodyStartTagInBody(p, token);

            else if (tn === $.MAIN)
                addressStartTagInBody(p, token);

            else if (tn === $.FORM)
                formStartTagInBody(p, token);

            else if (tn === $.CODE || tn === $.FONT)
                bStartTagInBody(p, token);

            else if (tn === $.NOBR)
                nobrStartTagInBody(p, token);

            else if (tn === $.AREA)
                areaStartTagInBody(p, token);

            else if (tn === $.MATH)
                mathStartTagInBody(p, token);

            else if (tn === $.MENU)
                menuStartTagInBody(p, token);

            else if (tn !== $.HEAD)
                genericStartTagInBody(p, token);

            break;

        case 5:
            if (tn === $.STYLE || tn === $.TITLE)
                startTagInHead(p, token);

            else if (tn === $.ASIDE)
                addressStartTagInBody(p, token);

            else if (tn === $.SMALL)
                bStartTagInBody(p, token);

            else if (tn === $.TABLE)
                tableStartTagInBody(p, token);

            else if (tn === $.EMBED)
                areaStartTagInBody(p, token);

            else if (tn === $.INPUT)
                inputStartTagInBody(p, token);

            else if (tn === $.PARAM || tn === $.TRACK)
                paramStartTagInBody(p, token);

            else if (tn === $.IMAGE)
                imageStartTagInBody(p, token);

            else if (tn !== $.FRAME && tn !== $.TBODY && tn !== $.TFOOT && tn !== $.THEAD)
                genericStartTagInBody(p, token);

            break;

        case 6:
            if (tn === $.SCRIPT)
                startTagInHead(p, token);

            else if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
                addressStartTagInBody(p, token);

            else if (tn === $.BUTTON)
                buttonStartTagInBody(p, token);

            else if (tn === $.STRIKE || tn === $.STRONG)
                bStartTagInBody(p, token);

            else if (tn === $.APPLET || tn === $.OBJECT)
                appletStartTagInBody(p, token);

            else if (tn === $.KEYGEN)
                areaStartTagInBody(p, token);

            else if (tn === $.SOURCE)
                paramStartTagInBody(p, token);

            else if (tn === $.IFRAME)
                iframeStartTagInBody(p, token);

            else if (tn === $.SELECT)
                selectStartTagInBody(p, token);

            else if (tn === $.OPTION)
                optgroupStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 7:
            if (tn === $.BGSOUND)
                startTagInHead(p, token);

            else if (tn === $.DETAILS || tn === $.ADDRESS || tn === $.ARTICLE || tn === $.SECTION || tn === $.SUMMARY)
                addressStartTagInBody(p, token);

            else if (tn === $.LISTING)
                preStartTagInBody(p, token);

            else if (tn === $.MARQUEE)
                appletStartTagInBody(p, token);

            else if (tn === $.NOEMBED)
                noembedStartTagInBody(p, token);

            else if (tn !== $.CAPTION)
                genericStartTagInBody(p, token);

            break;

        case 8:
            if (tn === $.BASEFONT)
                startTagInHead(p, token);

            else if (tn === $.MENUITEM)
                menuitemStartTagInBody(p, token);

            else if (tn === $.FRAMESET)
                framesetStartTagInBody(p, token);

            else if (tn === $.FIELDSET)
                addressStartTagInBody(p, token);

            else if (tn === $.TEXTAREA)
                textareaStartTagInBody(p, token);

            else if (tn === $.TEMPLATE)
                startTagInHead(p, token);

            else if (tn === $.NOSCRIPT)
                noembedStartTagInBody(p, token);

            else if (tn === $.OPTGROUP)
                optgroupStartTagInBody(p, token);

            else if (tn !== $.COLGROUP)
                genericStartTagInBody(p, token);

            break;

        case 9:
            if (tn === $.PLAINTEXT)
                plaintextStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
                addressStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        default:
            genericStartTagInBody(p, token);
    }
}

function bodyEndTagInBody(p) {
    if (p.openElements.hasInScope($.BODY))
        p.insertionMode = AFTER_BODY_MODE;
}

function htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope($.BODY)) {
        p.insertionMode = AFTER_BODY_MODE;
        p._processToken(token);
    }
}

function addressEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function formEndTagInBody(p) {
    var inTemplate = p.openElements.tmplCount > 0,
        formElement = p.formElement;

    if (!inTemplate)
        p.formElement = null;

    if ((formElement || inTemplate) && p.openElements.hasInScope($.FORM)) {
        p.openElements.generateImpliedEndTags();

        if (inTemplate)
            p.openElements.popUntilTagNamePopped($.FORM);

        else
            p.openElements.remove(formElement);
    }
}

function pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope($.P))
        p._insertFakeElement($.P);

    p._closePElement();
}

function liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope($.LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion($.LI);
        p.openElements.popUntilTagNamePopped($.LI);
    }
}

function ddEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}

function appletEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}

function brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement($.BR);
    p.openElements.pop();
    p.framesetOk = false;
}

function genericEndTagInBody(p, token) {
    var tn = token.tagName;

    for (var i = p.openElements.stackTop; i > 0; i--) {
        var element = p.openElements.items[i];

        if (p.treeAdapter.getTagName(element) === tn) {
            p.openElements.generateImpliedEndTagsWithExclusion(tn);
            p.openElements.popUntilElementPopped(element);
            break;
        }

        if (p._isSpecialElement(element))
            break;
    }
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function endTagInBody(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.A || tn === $.B || tn === $.I || tn === $.S || tn === $.U)
                callAdoptionAgency(p, token);

            else if (tn === $.P)
                pEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 2:
            if (tn === $.DL || tn === $.UL || tn === $.OL)
                addressEndTagInBody(p, token);

            else if (tn === $.LI)
                liEndTagInBody(p, token);

            else if (tn === $.DD || tn === $.DT)
                ddEndTagInBody(p, token);

            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
                numberedHeaderEndTagInBody(p, token);

            else if (tn === $.BR)
                brEndTagInBody(p, token);

            else if (tn === $.EM || tn === $.TT)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 3:
            if (tn === $.BIG)
                callAdoptionAgency(p, token);

            else if (tn === $.DIR || tn === $.DIV || tn === $.NAV)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 4:
            if (tn === $.BODY)
                bodyEndTagInBody(p, token);

            else if (tn === $.HTML)
                htmlEndTagInBody(p, token);

            else if (tn === $.FORM)
                formEndTagInBody(p, token);

            else if (tn === $.CODE || tn === $.FONT || tn === $.NOBR)
                callAdoptionAgency(p, token);

            else if (tn === $.MAIN || tn === $.MENU)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 5:
            if (tn === $.ASIDE)
                addressEndTagInBody(p, token);

            else if (tn === $.SMALL)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 6:
            if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
                addressEndTagInBody(p, token);

            else if (tn === $.APPLET || tn === $.OBJECT)
                appletEndTagInBody(p, token);

            else if (tn === $.STRIKE || tn === $.STRONG)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 7:
            if (tn === $.ADDRESS || tn === $.ARTICLE || tn === $.DETAILS || tn === $.SECTION || tn === $.SUMMARY)
                addressEndTagInBody(p, token);

            else if (tn === $.MARQUEE)
                appletEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 8:
            if (tn === $.FIELDSET)
                addressEndTagInBody(p, token);

            else if (tn === $.TEMPLATE)
                endTagInHead(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        default :
            genericEndTagInBody(p, token);
    }
}

function eofInBody(p, token) {
    if (p.tmplInsertionModeStackTop > -1)
        eofInTemplate(p, token);

    else
        p.stopped = true;
}

//12.2.5.4.8 The "text" insertion mode
//------------------------------------------------------------------
function endTagInText(p, token) {
    if (token.tagName === $.SCRIPT)
        p.pendingScript = p.openElements.current;

    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}


function eofInText(p, token) {
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}


//12.2.5.4.9 The "in table" insertion mode
//------------------------------------------------------------------
function characterInTable(p, token) {
    var curTn = p.openElements.currentTagName;

    if (curTn === $.TABLE || curTn === $.TBODY || curTn === $.TFOOT || curTn === $.THEAD || curTn === $.TR) {
        p.pendingCharacterTokens = [];
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = IN_TABLE_TEXT_MODE;
        p._processToken(token);
    }

    else
        tokenInTable(p, token);
}

function captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_CAPTION_MODE;
}

function colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
}

function colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.COLGROUP);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
    p._processToken(token);
}

function tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_TABLE_BODY_MODE;
}

function tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.TBODY);
    p.insertionMode = IN_TABLE_BODY_MODE;
    p._processToken(token);
}

function tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope($.TABLE)) {
        p.openElements.popUntilTagNamePopped($.TABLE);
        p._resetInsertionMode();
        p._processToken(token);
    }
}

function inputStartTagInTable(p, token) {
    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (inputType && inputType.toLowerCase() === HIDDEN_INPUT_TYPE)
        p._appendElement(token, NS.HTML);

    else
        tokenInTable(p, token);
}

function formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, NS.HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}

function startTagInTable(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH || tn === $.TR)
                tdStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 3:
            if (tn === $.COL)
                colStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 4:
            if (tn === $.FORM)
                formStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 5:
            if (tn === $.TABLE)
                tableStartTagInTable(p, token);

            else if (tn === $.STYLE)
                startTagInHead(p, token);

            else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD)
                tbodyStartTagInTable(p, token);

            else if (tn === $.INPUT)
                inputStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 6:
            if (tn === $.SCRIPT)
                startTagInHead(p, token);

            else
                tokenInTable(p, token);

            break;

        case 7:
            if (tn === $.CAPTION)
                captionStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 8:
            if (tn === $.COLGROUP)
                colgroupStartTagInTable(p, token);

            else if (tn === $.TEMPLATE)
                startTagInHead(p, token);

            else
                tokenInTable(p, token);

            break;

        default:
            tokenInTable(p, token);
    }

}

function endTagInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TABLE)) {
            p.openElements.popUntilTagNamePopped($.TABLE);
            p._resetInsertionMode();
        }
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML &&
             tn !== $.TBODY && tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
        tokenInTable(p, token);
}

function tokenInTable(p, token) {
    var savedFosterParentingState = p.fosterParentingEnabled;

    p.fosterParentingEnabled = true;
    p._processTokenInBodyMode(token);
    p.fosterParentingEnabled = savedFosterParentingState;
}


//12.2.5.4.10 The "in table text" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}

function characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}

function tokenInTableText(p, token) {
    var i = 0;

    if (p.hasNonWhitespacePendingCharacterToken) {
        for (; i < p.pendingCharacterTokens.length; i++)
            tokenInTable(p, p.pendingCharacterTokens[i]);
    }

    else {
        for (; i < p.pendingCharacterTokens.length; i++)
            p._insertCharacters(p.pendingCharacterTokens[i]);
    }

    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}


//12.2.5.4.11 The "in caption" insertion mode
//------------------------------------------------------------------
function startTagInCaption(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInBody(p, token);
}

function endTagInCaption(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;

            if (tn === $.TABLE)
                p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML && tn !== $.TBODY &&
             tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
        endTagInBody(p, token);
}


//12.2.5.4.12 The "in column group" insertion mode
//------------------------------------------------------------------
function startTagInColumnGroup(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.COL)
        p._appendElement(token, NS.HTML);

    else if (tn === $.TEMPLATE)
        startTagInHead(p, token);

    else
        tokenInColumnGroup(p, token);
}

function endTagInColumnGroup(p, token) {
    var tn = token.tagName;

    if (tn === $.COLGROUP) {
        if (p.openElements.currentTagName === $.COLGROUP) {
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);

    else if (tn !== $.COL)
        tokenInColumnGroup(p, token);
}

function tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagName === $.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
        p._processToken(token);
    }
}

//12.2.5.4.13 The "in table body" insertion mode
//------------------------------------------------------------------
function startTagInTableBody(p, token) {
    var tn = token.tagName;

    if (tn === $.TR) {
        p.openElements.clearBackToTableBodyContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_ROW_MODE;
    }

    else if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableBodyContext();
        p._insertFakeElement($.TR);
        p.insertionMode = IN_ROW_MODE;
        p._processToken(token);
    }

    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP ||
             tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {

        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInTable(p, token);
}

function endTagInTableBody(p, token) {
    var tn = token.tagName;

    if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    }

    else if (tn === $.TABLE) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
             tn !== $.HTML && tn !== $.TD && tn !== $.TH && tn !== $.TR)
        endTagInTable(p, token);
}

//12.2.5.4.14 The "in row" insertion mode
//------------------------------------------------------------------
function startTagInRow(p, token) {
    var tn = token.tagName;

    if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableRowContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_CELL_MODE;
        p.activeFormattingElements.insertMarker();
    }

    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
             tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInTable(p, token);
}

function endTagInRow(p, token) {
    var tn = token.tagName;

    if (tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
        }
    }

    else if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
             tn !== $.HTML && tn !== $.TD && tn !== $.TH)
        endTagInTable(p, token);
}


//12.2.5.4.15 The "in cell" insertion mode
//------------------------------------------------------------------
function startTagInCell(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {

        if (p.openElements.hasInTableScope($.TD) || p.openElements.hasInTableScope($.TH)) {
            p._closeTableCell();
            p._processToken(token);
        }
    }

    else
        startTagInBody(p, token);
}

function endTagInCell(p, token) {
    var tn = token.tagName;

    if (tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped(tn);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_ROW_MODE;
        }
    }

    else if (tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope(tn)) {
            p._closeTableCell();
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML)
        endTagInBody(p, token);
}

//12.2.5.4.16 The "in select" insertion mode
//------------------------------------------------------------------
function startTagInSelect(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();

        p._insertElement(token, NS.HTML);
    }

    else if (tn === $.OPTGROUP) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();

        if (p.openElements.currentTagName === $.OPTGROUP)
            p.openElements.pop();

        p._insertElement(token, NS.HTML);
    }

    else if (tn === $.INPUT || tn === $.KEYGEN || tn === $.TEXTAREA || tn === $.SELECT) {
        if (p.openElements.hasInSelectScope($.SELECT)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();

            if (tn !== $.SELECT)
                p._processToken(token);
        }
    }

    else if (tn === $.SCRIPT || tn === $.TEMPLATE)
        startTagInHead(p, token);
}

function endTagInSelect(p, token) {
    var tn = token.tagName;

    if (tn === $.OPTGROUP) {
        var prevOpenElement = p.openElements.items[p.openElements.stackTop - 1],
            prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);

        if (p.openElements.currentTagName === $.OPTION && prevOpenElementTn === $.OPTGROUP)
            p.openElements.pop();

        if (p.openElements.currentTagName === $.OPTGROUP)
            p.openElements.pop();
    }

    else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();
    }

    else if (tn === $.SELECT && p.openElements.hasInSelectScope($.SELECT)) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);
}

//12.2.5.4.17 The "in select in table" insertion mode
//------------------------------------------------------------------
function startTagInSelectInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
        p._processToken(token);
    }

    else
        startTagInSelect(p, token);
}

function endTagInSelectInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();
            p._processToken(token);
        }
    }

    else
        endTagInSelect(p, token);
}

//12.2.5.4.18 The "in template" insertion mode
//------------------------------------------------------------------
function startTagInTemplate(p, token) {
    var tn = token.tagName;

    if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
        tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE)
        startTagInHead(p, token);

    else {
        var newInsertionMode = TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || IN_BODY_MODE;

        p._popTmplInsertionMode();
        p._pushTmplInsertionMode(newInsertionMode);
        p.insertionMode = newInsertionMode;
        p._processToken(token);
    }
}

function endTagInTemplate(p, token) {
    if (token.tagName === $.TEMPLATE)
        endTagInHead(p, token);
}

function eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
        p._processToken(token);
    }

    else
        p.stopped = true;
}


//12.2.5.4.19 The "after body" insertion mode
//------------------------------------------------------------------
function startTagAfterBody(p, token) {
    if (token.tagName === $.HTML)
        startTagInBody(p, token);

    else
        tokenAfterBody(p, token);
}

function endTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        if (!p.fragmentContext)
            p.insertionMode = AFTER_AFTER_BODY_MODE;
    }

    else
        tokenAfterBody(p, token);
}

function tokenAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

//12.2.5.4.20 The "in frameset" insertion mode
//------------------------------------------------------------------
function startTagInFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.FRAMESET)
        p._insertElement(token, NS.HTML);

    else if (tn === $.FRAME)
        p._appendElement(token, NS.HTML);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}

function endTagInFrameset(p, token) {
    if (token.tagName === $.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();

        if (!p.fragmentContext && p.openElements.currentTagName !== $.FRAMESET)
            p.insertionMode = AFTER_FRAMESET_MODE;
    }
}

//12.2.5.4.21 The "after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}

function endTagAfterFrameset(p, token) {
    if (token.tagName === $.HTML)
        p.insertionMode = AFTER_AFTER_FRAMESET_MODE;
}

//12.2.5.4.22 The "after after body" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterBody(p, token) {
    if (token.tagName === $.HTML)
        startTagInBody(p, token);

    else
        tokenAfterAfterBody(p, token);
}

function tokenAfterAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

//12.2.5.4.23 The "after after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}


//12.2.5.5 The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function nullCharacterInForeignContent(p, token) {
    token.chars = UNICODE.REPLACEMENT_CHARACTER;
    p._insertCharacters(token);
}

function characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}

function startTagInForeignContent(p, token) {
    if (foreignContent.causesExit(token) && !p.fragmentContext) {
        while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML && !p._isIntegrationPoint(p.openElements.current))
            p.openElements.pop();

        p._processToken(token);
    }

    else {
        var current = p._getAdjustedCurrentElement(),
            currentNs = p.treeAdapter.getNamespaceURI(current);

        if (currentNs === NS.MATHML)
            foreignContent.adjustTokenMathMLAttrs(token);

        else if (currentNs === NS.SVG) {
            foreignContent.adjustTokenSVGTagName(token);
            foreignContent.adjustTokenSVGAttrs(token);
        }

        foreignContent.adjustTokenXMLAttrs(token);

        if (token.selfClosing)
            p._appendElement(token, currentNs);
        else
            p._insertElement(token, currentNs);
    }
}

function endTagInForeignContent(p, token) {
    for (var i = p.openElements.stackTop; i > 0; i--) {
        var element = p.openElements.items[i];

        if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
            p._processToken(token);
            break;
        }

        if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
            p.openElements.popUntilElementPopped(element);
            break;
        }
    }
}


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UNICODE = __webpack_require__(144);

//Aliases
var $ = UNICODE.CODE_POINTS;

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isSurrogatePair(cp1, cp2) {
    return cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF;
}

function getSurrogatePairCodePoint(cp1, cp2) {
    return (cp1 - 0xD800) * 0x400 + 0x2400 + cp2;
}


//Const
var DEFAULT_BUFFER_WATERLINE = 1 << 16;


//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
var Preprocessor = module.exports = function () {
    this.html = null;

    this.pos = -1;
    this.lastGapPos = -1;
    this.lastCharPos = -1;

    this.gapStack = [];

    this.skipNextNewLine = false;

    this.lastChunkWritten = false;
    this.endOfChunkHit = false;
    this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
};

Preprocessor.prototype.dropParsedChunk = function () {
    if (this.pos > this.bufferWaterline) {
        this.lastCharPos -= this.pos;
        this.html = this.html.substring(this.pos);
        this.pos = 0;
        this.lastGapPos = -1;
        this.gapStack = [];
    }
};

Preprocessor.prototype._addGap = function () {
    this.gapStack.push(this.lastGapPos);
    this.lastGapPos = this.pos;
};

Preprocessor.prototype._processHighRangeCodePoint = function (cp) {
    //NOTE: try to peek a surrogate pair
    if (this.pos !== this.lastCharPos) {
        var nextCp = this.html.charCodeAt(this.pos + 1);

        if (isSurrogatePair(cp, nextCp)) {
            //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
            this.pos++;
            cp = getSurrogatePairCodePoint(cp, nextCp);

            //NOTE: add gap that should be avoided during retreat
            this._addGap();
        }
    }

    // NOTE: we've hit the end of chunk, stop processing at this point
    else if (!this.lastChunkWritten) {
        this.endOfChunkHit = true;
        return $.EOF;
    }

    return cp;
};

Preprocessor.prototype.write = function (chunk, isLastChunk) {
    if (this.html)
        this.html += chunk;

    else
        this.html = chunk;

    this.lastCharPos = this.html.length - 1;
    this.endOfChunkHit = false;
    this.lastChunkWritten = isLastChunk;
};

Preprocessor.prototype.insertHtmlAtCurrentPos = function (chunk) {
    this.html = this.html.substring(0, this.pos + 1) +
                chunk +
                this.html.substring(this.pos + 1, this.html.length);

    this.lastCharPos = this.html.length - 1;
    this.endOfChunkHit = false;
};


Preprocessor.prototype.advance = function () {
    this.pos++;

    if (this.pos > this.lastCharPos) {
        if (!this.lastChunkWritten)
            this.endOfChunkHit = true;

        return $.EOF;
    }

    var cp = this.html.charCodeAt(this.pos);

    //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
    //must be ignored.
    if (this.skipNextNewLine && cp === $.LINE_FEED) {
        this.skipNextNewLine = false;
        this._addGap();
        return this.advance();
    }

    //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
    if (cp === $.CARRIAGE_RETURN) {
        this.skipNextNewLine = true;
        return $.LINE_FEED;
    }

    this.skipNextNewLine = false;

    //OPTIMIZATION: first perform check if the code point in the allowed range that covers most common
    //HTML input (e.g. ASCII codes) to avoid performance-cost operations for high-range code points.
    return cp >= 0xD800 ? this._processHighRangeCodePoint(cp) : cp;
};

Preprocessor.prototype.retreat = function () {
    if (this.pos === this.lastGapPos) {
        this.lastGapPos = this.gapStack.pop();
        this.pos--;
    }

    this.pos--;
};



/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//NOTE: this file contains auto-generated array mapped radix tree that is used for the named entity references consumption
//(details: https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md)
module.exports = new Uint16Array([4,52,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,106,303,412,810,1432,1701,1796,1987,2114,2360,2420,2484,3170,3251,4140,4393,4575,4610,5106,5512,5728,6117,6274,6315,6345,6427,6516,7002,7910,8733,9323,9870,10170,10631,10893,11318,11386,11467,12773,13092,14474,14922,15448,15542,16419,17666,18166,18611,19004,19095,19298,19397,4,16,69,77,97,98,99,102,103,108,109,110,111,112,114,115,116,117,140,150,158,169,176,194,199,210,216,222,226,242,256,266,283,294,108,105,103,5,198,1,59,148,1,198,80,5,38,1,59,156,1,38,99,117,116,101,5,193,1,59,167,1,193,114,101,118,101,59,1,258,4,2,105,121,182,191,114,99,5,194,1,59,189,1,194,59,1,1040,114,59,3,55349,56580,114,97,118,101,5,192,1,59,208,1,192,112,104,97,59,1,913,97,99,114,59,1,256,100,59,1,10835,4,2,103,112,232,237,111,110,59,1,260,102,59,3,55349,56632,112,108,121,70,117,110,99,116,105,111,110,59,1,8289,105,110,103,5,197,1,59,264,1,197,4,2,99,115,272,277,114,59,3,55349,56476,105,103,110,59,1,8788,105,108,100,101,5,195,1,59,292,1,195,109,108,5,196,1,59,301,1,196,4,8,97,99,101,102,111,114,115,117,321,350,354,383,388,394,400,405,4,2,99,114,327,336,107,115,108,97,115,104,59,1,8726,4,2,118,119,342,345,59,1,10983,101,100,59,1,8966,121,59,1,1041,4,3,99,114,116,362,369,379,97,117,115,101,59,1,8757,110,111,117,108,108,105,115,59,1,8492,97,59,1,914,114,59,3,55349,56581,112,102,59,3,55349,56633,101,118,101,59,1,728,99,114,59,1,8492,109,112,101,113,59,1,8782,4,14,72,79,97,99,100,101,102,104,105,108,111,114,115,117,442,447,456,504,542,547,569,573,577,616,678,784,790,796,99,121,59,1,1063,80,89,5,169,1,59,454,1,169,4,3,99,112,121,464,470,497,117,116,101,59,1,262,4,2,59,105,476,478,1,8914,116,97,108,68,105,102,102,101,114,101,110,116,105,97,108,68,59,1,8517,108,101,121,115,59,1,8493,4,4,97,101,105,111,514,520,530,535,114,111,110,59,1,268,100,105,108,5,199,1,59,528,1,199,114,99,59,1,264,110,105,110,116,59,1,8752,111,116,59,1,266,4,2,100,110,553,560,105,108,108,97,59,1,184,116,101,114,68,111,116,59,1,183,114,59,1,8493,105,59,1,935,114,99,108,101,4,4,68,77,80,84,591,596,603,609,111,116,59,1,8857,105,110,117,115,59,1,8854,108,117,115,59,1,8853,105,109,101,115,59,1,8855,111,4,2,99,115,623,646,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8754,101,67,117,114,108,121,4,2,68,81,658,671,111,117,98,108,101,81,117,111,116,101,59,1,8221,117,111,116,101,59,1,8217,4,4,108,110,112,117,688,701,736,753,111,110,4,2,59,101,696,698,1,8759,59,1,10868,4,3,103,105,116,709,717,722,114,117,101,110,116,59,1,8801,110,116,59,1,8751,111,117,114,73,110,116,101,103,114,97,108,59,1,8750,4,2,102,114,742,745,59,1,8450,111,100,117,99,116,59,1,8720,110,116,101,114,67,108,111,99,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8755,111,115,115,59,1,10799,99,114,59,3,55349,56478,112,4,2,59,67,803,805,1,8915,97,112,59,1,8781,4,11,68,74,83,90,97,99,101,102,105,111,115,834,850,855,860,865,888,903,916,921,1011,1415,4,2,59,111,840,842,1,8517,116,114,97,104,100,59,1,10513,99,121,59,1,1026,99,121,59,1,1029,99,121,59,1,1039,4,3,103,114,115,873,879,883,103,101,114,59,1,8225,114,59,1,8609,104,118,59,1,10980,4,2,97,121,894,900,114,111,110,59,1,270,59,1,1044,108,4,2,59,116,910,912,1,8711,97,59,1,916,114,59,3,55349,56583,4,2,97,102,927,998,4,2,99,109,933,992,114,105,116,105,99,97,108,4,4,65,68,71,84,950,957,978,985,99,117,116,101,59,1,180,111,4,2,116,117,964,967,59,1,729,98,108,101,65,99,117,116,101,59,1,733,114,97,118,101,59,1,96,105,108,100,101,59,1,732,111,110,100,59,1,8900,102,101,114,101,110,116,105,97,108,68,59,1,8518,4,4,112,116,117,119,1021,1026,1048,1249,102,59,3,55349,56635,4,3,59,68,69,1034,1036,1041,1,168,111,116,59,1,8412,113,117,97,108,59,1,8784,98,108,101,4,6,67,68,76,82,85,86,1065,1082,1101,1189,1211,1236,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8751,111,4,2,116,119,1089,1092,59,1,168,110,65,114,114,111,119,59,1,8659,4,2,101,111,1107,1141,102,116,4,3,65,82,84,1117,1124,1136,114,114,111,119,59,1,8656,105,103,104,116,65,114,114,111,119,59,1,8660,101,101,59,1,10980,110,103,4,2,76,82,1149,1177,101,102,116,4,2,65,82,1158,1165,114,114,111,119,59,1,10232,105,103,104,116,65,114,114,111,119,59,1,10234,105,103,104,116,65,114,114,111,119,59,1,10233,105,103,104,116,4,2,65,84,1199,1206,114,114,111,119,59,1,8658,101,101,59,1,8872,112,4,2,65,68,1218,1225,114,114,111,119,59,1,8657,111,119,110,65,114,114,111,119,59,1,8661,101,114,116,105,99,97,108,66,97,114,59,1,8741,110,4,6,65,66,76,82,84,97,1264,1292,1299,1352,1391,1408,114,114,111,119,4,3,59,66,85,1276,1278,1283,1,8595,97,114,59,1,10515,112,65,114,114,111,119,59,1,8693,114,101,118,101,59,1,785,101,102,116,4,3,82,84,86,1310,1323,1334,105,103,104,116,86,101,99,116,111,114,59,1,10576,101,101,86,101,99,116,111,114,59,1,10590,101,99,116,111,114,4,2,59,66,1345,1347,1,8637,97,114,59,1,10582,105,103,104,116,4,2,84,86,1362,1373,101,101,86,101,99,116,111,114,59,1,10591,101,99,116,111,114,4,2,59,66,1384,1386,1,8641,97,114,59,1,10583,101,101,4,2,59,65,1399,1401,1,8868,114,114,111,119,59,1,8615,114,114,111,119,59,1,8659,4,2,99,116,1421,1426,114,59,3,55349,56479,114,111,107,59,1,272,4,16,78,84,97,99,100,102,103,108,109,111,112,113,115,116,117,120,1466,1470,1478,1489,1515,1520,1525,1536,1544,1593,1609,1617,1650,1664,1668,1677,71,59,1,330,72,5,208,1,59,1476,1,208,99,117,116,101,5,201,1,59,1487,1,201,4,3,97,105,121,1497,1503,1512,114,111,110,59,1,282,114,99,5,202,1,59,1510,1,202,59,1,1069,111,116,59,1,278,114,59,3,55349,56584,114,97,118,101,5,200,1,59,1534,1,200,101,109,101,110,116,59,1,8712,4,2,97,112,1550,1555,99,114,59,1,274,116,121,4,2,83,86,1563,1576,109,97,108,108,83,113,117,97,114,101,59,1,9723,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9643,4,2,103,112,1599,1604,111,110,59,1,280,102,59,3,55349,56636,115,105,108,111,110,59,1,917,117,4,2,97,105,1624,1640,108,4,2,59,84,1631,1633,1,10869,105,108,100,101,59,1,8770,108,105,98,114,105,117,109,59,1,8652,4,2,99,105,1656,1660,114,59,1,8496,109,59,1,10867,97,59,1,919,109,108,5,203,1,59,1675,1,203,4,2,105,112,1683,1689,115,116,115,59,1,8707,111,110,101,110,116,105,97,108,69,59,1,8519,4,5,99,102,105,111,115,1713,1717,1722,1762,1791,121,59,1,1060,114,59,3,55349,56585,108,108,101,100,4,2,83,86,1732,1745,109,97,108,108,83,113,117,97,114,101,59,1,9724,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9642,4,3,112,114,117,1770,1775,1781,102,59,3,55349,56637,65,108,108,59,1,8704,114,105,101,114,116,114,102,59,1,8497,99,114,59,1,8497,4,12,74,84,97,98,99,100,102,103,111,114,115,116,1822,1827,1834,1848,1855,1877,1882,1887,1890,1896,1978,1984,99,121,59,1,1027,5,62,1,59,1832,1,62,109,109,97,4,2,59,100,1843,1845,1,915,59,1,988,114,101,118,101,59,1,286,4,3,101,105,121,1863,1869,1874,100,105,108,59,1,290,114,99,59,1,284,59,1,1043,111,116,59,1,288,114,59,3,55349,56586,59,1,8921,112,102,59,3,55349,56638,101,97,116,101,114,4,6,69,70,71,76,83,84,1915,1933,1944,1953,1959,1971,113,117,97,108,4,2,59,76,1925,1927,1,8805,101,115,115,59,1,8923,117,108,108,69,113,117,97,108,59,1,8807,114,101,97,116,101,114,59,1,10914,101,115,115,59,1,8823,108,97,110,116,69,113,117,97,108,59,1,10878,105,108,100,101,59,1,8819,99,114,59,3,55349,56482,59,1,8811,4,8,65,97,99,102,105,111,115,117,2005,2012,2026,2032,2036,2049,2073,2089,82,68,99,121,59,1,1066,4,2,99,116,2018,2023,101,107,59,1,711,59,1,94,105,114,99,59,1,292,114,59,1,8460,108,98,101,114,116,83,112,97,99,101,59,1,8459,4,2,112,114,2055,2059,102,59,1,8461,105,122,111,110,116,97,108,76,105,110,101,59,1,9472,4,2,99,116,2079,2083,114,59,1,8459,114,111,107,59,1,294,109,112,4,2,68,69,2097,2107,111,119,110,72,117,109,112,59,1,8782,113,117,97,108,59,1,8783,4,14,69,74,79,97,99,100,102,103,109,110,111,115,116,117,2144,2149,2155,2160,2171,2189,2194,2198,2209,2245,2307,2329,2334,2341,99,121,59,1,1045,108,105,103,59,1,306,99,121,59,1,1025,99,117,116,101,5,205,1,59,2169,1,205,4,2,105,121,2177,2186,114,99,5,206,1,59,2184,1,206,59,1,1048,111,116,59,1,304,114,59,1,8465,114,97,118,101,5,204,1,59,2207,1,204,4,3,59,97,112,2217,2219,2238,1,8465,4,2,99,103,2225,2229,114,59,1,298,105,110,97,114,121,73,59,1,8520,108,105,101,115,59,1,8658,4,2,116,118,2251,2281,4,2,59,101,2257,2259,1,8748,4,2,103,114,2265,2271,114,97,108,59,1,8747,115,101,99,116,105,111,110,59,1,8898,105,115,105,98,108,101,4,2,67,84,2293,2300,111,109,109,97,59,1,8291,105,109,101,115,59,1,8290,4,3,103,112,116,2315,2320,2325,111,110,59,1,302,102,59,3,55349,56640,97,59,1,921,99,114,59,1,8464,105,108,100,101,59,1,296,4,2,107,109,2347,2352,99,121,59,1,1030,108,5,207,1,59,2358,1,207,4,5,99,102,111,115,117,2372,2386,2391,2397,2414,4,2,105,121,2378,2383,114,99,59,1,308,59,1,1049,114,59,3,55349,56589,112,102,59,3,55349,56641,4,2,99,101,2403,2408,114,59,3,55349,56485,114,99,121,59,1,1032,107,99,121,59,1,1028,4,7,72,74,97,99,102,111,115,2436,2441,2446,2452,2467,2472,2478,99,121,59,1,1061,99,121,59,1,1036,112,112,97,59,1,922,4,2,101,121,2458,2464,100,105,108,59,1,310,59,1,1050,114,59,3,55349,56590,112,102,59,3,55349,56642,99,114,59,3,55349,56486,4,11,74,84,97,99,101,102,108,109,111,115,116,2508,2513,2520,2562,2585,2981,2986,3004,3011,3146,3167,99,121,59,1,1033,5,60,1,59,2518,1,60,4,5,99,109,110,112,114,2532,2538,2544,2548,2558,117,116,101,59,1,313,98,100,97,59,1,923,103,59,1,10218,108,97,99,101,116,114,102,59,1,8466,114,59,1,8606,4,3,97,101,121,2570,2576,2582,114,111,110,59,1,317,100,105,108,59,1,315,59,1,1051,4,2,102,115,2591,2907,116,4,10,65,67,68,70,82,84,85,86,97,114,2614,2663,2672,2728,2735,2760,2820,2870,2888,2895,4,2,110,114,2620,2633,103,108,101,66,114,97,99,107,101,116,59,1,10216,114,111,119,4,3,59,66,82,2644,2646,2651,1,8592,97,114,59,1,8676,105,103,104,116,65,114,114,111,119,59,1,8646,101,105,108,105,110,103,59,1,8968,111,4,2,117,119,2679,2692,98,108,101,66,114,97,99,107,101,116,59,1,10214,110,4,2,84,86,2699,2710,101,101,86,101,99,116,111,114,59,1,10593,101,99,116,111,114,4,2,59,66,2721,2723,1,8643,97,114,59,1,10585,108,111,111,114,59,1,8970,105,103,104,116,4,2,65,86,2745,2752,114,114,111,119,59,1,8596,101,99,116,111,114,59,1,10574,4,2,101,114,2766,2792,101,4,3,59,65,86,2775,2777,2784,1,8867,114,114,111,119,59,1,8612,101,99,116,111,114,59,1,10586,105,97,110,103,108,101,4,3,59,66,69,2806,2808,2813,1,8882,97,114,59,1,10703,113,117,97,108,59,1,8884,112,4,3,68,84,86,2829,2841,2852,111,119,110,86,101,99,116,111,114,59,1,10577,101,101,86,101,99,116,111,114,59,1,10592,101,99,116,111,114,4,2,59,66,2863,2865,1,8639,97,114,59,1,10584,101,99,116,111,114,4,2,59,66,2881,2883,1,8636,97,114,59,1,10578,114,114,111,119,59,1,8656,105,103,104,116,97,114,114,111,119,59,1,8660,115,4,6,69,70,71,76,83,84,2922,2936,2947,2956,2962,2974,113,117,97,108,71,114,101,97,116,101,114,59,1,8922,117,108,108,69,113,117,97,108,59,1,8806,114,101,97,116,101,114,59,1,8822,101,115,115,59,1,10913,108,97,110,116,69,113,117,97,108,59,1,10877,105,108,100,101,59,1,8818,114,59,3,55349,56591,4,2,59,101,2992,2994,1,8920,102,116,97,114,114,111,119,59,1,8666,105,100,111,116,59,1,319,4,3,110,112,119,3019,3110,3115,103,4,4,76,82,108,114,3030,3058,3070,3098,101,102,116,4,2,65,82,3039,3046,114,114,111,119,59,1,10229,105,103,104,116,65,114,114,111,119,59,1,10231,105,103,104,116,65,114,114,111,119,59,1,10230,101,102,116,4,2,97,114,3079,3086,114,114,111,119,59,1,10232,105,103,104,116,97,114,114,111,119,59,1,10234,105,103,104,116,97,114,114,111,119,59,1,10233,102,59,3,55349,56643,101,114,4,2,76,82,3123,3134,101,102,116,65,114,114,111,119,59,1,8601,105,103,104,116,65,114,114,111,119,59,1,8600,4,3,99,104,116,3154,3158,3161,114,59,1,8466,59,1,8624,114,111,107,59,1,321,59,1,8810,4,8,97,99,101,102,105,111,115,117,3188,3192,3196,3222,3227,3237,3243,3248,112,59,1,10501,121,59,1,1052,4,2,100,108,3202,3213,105,117,109,83,112,97,99,101,59,1,8287,108,105,110,116,114,102,59,1,8499,114,59,3,55349,56592,110,117,115,80,108,117,115,59,1,8723,112,102,59,3,55349,56644,99,114,59,1,8499,59,1,924,4,9,74,97,99,101,102,111,115,116,117,3271,3276,3283,3306,3422,3427,4120,4126,4137,99,121,59,1,1034,99,117,116,101,59,1,323,4,3,97,101,121,3291,3297,3303,114,111,110,59,1,327,100,105,108,59,1,325,59,1,1053,4,3,103,115,119,3314,3380,3415,97,116,105,118,101,4,3,77,84,86,3327,3340,3365,101,100,105,117,109,83,112,97,99,101,59,1,8203,104,105,4,2,99,110,3348,3357,107,83,112,97,99,101,59,1,8203,83,112,97,99,101,59,1,8203,101,114,121,84,104,105,110,83,112,97,99,101,59,1,8203,116,101,100,4,2,71,76,3389,3405,114,101,97,116,101,114,71,114,101,97,116,101,114,59,1,8811,101,115,115,76,101,115,115,59,1,8810,76,105,110,101,59,1,10,114,59,3,55349,56593,4,4,66,110,112,116,3437,3444,3460,3464,114,101,97,107,59,1,8288,66,114,101,97,107,105,110,103,83,112,97,99,101,59,1,160,102,59,1,8469,4,13,59,67,68,69,71,72,76,78,80,82,83,84,86,3492,3494,3517,3536,3578,3657,3685,3784,3823,3860,3915,4066,4107,1,10988,4,2,111,117,3500,3510,110,103,114,117,101,110,116,59,1,8802,112,67,97,112,59,1,8813,111,117,98,108,101,86,101,114,116,105,99,97,108,66,97,114,59,1,8742,4,3,108,113,120,3544,3552,3571,101,109,101,110,116,59,1,8713,117,97,108,4,2,59,84,3561,3563,1,8800,105,108,100,101,59,3,8770,824,105,115,116,115,59,1,8708,114,101,97,116,101,114,4,7,59,69,70,71,76,83,84,3600,3602,3609,3621,3631,3637,3650,1,8815,113,117,97,108,59,1,8817,117,108,108,69,113,117,97,108,59,3,8807,824,114,101,97,116,101,114,59,3,8811,824,101,115,115,59,1,8825,108,97,110,116,69,113,117,97,108,59,3,10878,824,105,108,100,101,59,1,8821,117,109,112,4,2,68,69,3666,3677,111,119,110,72,117,109,112,59,3,8782,824,113,117,97,108,59,3,8783,824,101,4,2,102,115,3692,3724,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3709,3711,3717,1,8938,97,114,59,3,10703,824,113,117,97,108,59,1,8940,115,4,6,59,69,71,76,83,84,3739,3741,3748,3757,3764,3777,1,8814,113,117,97,108,59,1,8816,114,101,97,116,101,114,59,1,8824,101,115,115,59,3,8810,824,108,97,110,116,69,113,117,97,108,59,3,10877,824,105,108,100,101,59,1,8820,101,115,116,101,100,4,2,71,76,3795,3812,114,101,97,116,101,114,71,114,101,97,116,101,114,59,3,10914,824,101,115,115,76,101,115,115,59,3,10913,824,114,101,99,101,100,101,115,4,3,59,69,83,3838,3840,3848,1,8832,113,117,97,108,59,3,10927,824,108,97,110,116,69,113,117,97,108,59,1,8928,4,2,101,105,3866,3881,118,101,114,115,101,69,108,101,109,101,110,116,59,1,8716,103,104,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3900,3902,3908,1,8939,97,114,59,3,10704,824,113,117,97,108,59,1,8941,4,2,113,117,3921,3973,117,97,114,101,83,117,4,2,98,112,3933,3952,115,101,116,4,2,59,69,3942,3945,3,8847,824,113,117,97,108,59,1,8930,101,114,115,101,116,4,2,59,69,3963,3966,3,8848,824,113,117,97,108,59,1,8931,4,3,98,99,112,3981,4000,4045,115,101,116,4,2,59,69,3990,3993,3,8834,8402,113,117,97,108,59,1,8840,99,101,101,100,115,4,4,59,69,83,84,4015,4017,4025,4037,1,8833,113,117,97,108,59,3,10928,824,108,97,110,116,69,113,117,97,108,59,1,8929,105,108,100,101,59,3,8831,824,101,114,115,101,116,4,2,59,69,4056,4059,3,8835,8402,113,117,97,108,59,1,8841,105,108,100,101,4,4,59,69,70,84,4080,4082,4089,4100,1,8769,113,117,97,108,59,1,8772,117,108,108,69,113,117,97,108,59,1,8775,105,108,100,101,59,1,8777,101,114,116,105,99,97,108,66,97,114,59,1,8740,99,114,59,3,55349,56489,105,108,100,101,5,209,1,59,4135,1,209,59,1,925,4,14,69,97,99,100,102,103,109,111,112,114,115,116,117,118,4170,4176,4187,4205,4212,4217,4228,4253,4259,4292,4295,4316,4337,4346,108,105,103,59,1,338,99,117,116,101,5,211,1,59,4185,1,211,4,2,105,121,4193,4202,114,99,5,212,1,59,4200,1,212,59,1,1054,98,108,97,99,59,1,336,114,59,3,55349,56594,114,97,118,101,5,210,1,59,4226,1,210,4,3,97,101,105,4236,4241,4246,99,114,59,1,332,103,97,59,1,937,99,114,111,110,59,1,927,112,102,59,3,55349,56646,101,110,67,117,114,108,121,4,2,68,81,4272,4285,111,117,98,108,101,81,117,111,116,101,59,1,8220,117,111,116,101,59,1,8216,59,1,10836,4,2,99,108,4301,4306,114,59,3,55349,56490,97,115,104,5,216,1,59,4314,1,216,105,4,2,108,109,4323,4332,100,101,5,213,1,59,4330,1,213,101,115,59,1,10807,109,108,5,214,1,59,4344,1,214,101,114,4,2,66,80,4354,4380,4,2,97,114,4360,4364,114,59,1,8254,97,99,4,2,101,107,4372,4375,59,1,9182,101,116,59,1,9140,97,114,101,110,116,104,101,115,105,115,59,1,9180,4,9,97,99,102,104,105,108,111,114,115,4413,4422,4426,4431,4435,4438,4448,4471,4561,114,116,105,97,108,68,59,1,8706,121,59,1,1055,114,59,3,55349,56595,105,59,1,934,59,1,928,117,115,77,105,110,117,115,59,1,177,4,2,105,112,4454,4467,110,99,97,114,101,112,108,97,110,101,59,1,8460,102,59,1,8473,4,4,59,101,105,111,4481,4483,4526,4531,1,10939,99,101,100,101,115,4,4,59,69,83,84,4498,4500,4507,4519,1,8826,113,117,97,108,59,1,10927,108,97,110,116,69,113,117,97,108,59,1,8828,105,108,100,101,59,1,8830,109,101,59,1,8243,4,2,100,112,4537,4543,117,99,116,59,1,8719,111,114,116,105,111,110,4,2,59,97,4555,4557,1,8759,108,59,1,8733,4,2,99,105,4567,4572,114,59,3,55349,56491,59,1,936,4,4,85,102,111,115,4585,4594,4599,4604,79,84,5,34,1,59,4592,1,34,114,59,3,55349,56596,112,102,59,1,8474,99,114,59,3,55349,56492,4,12,66,69,97,99,101,102,104,105,111,114,115,117,4636,4642,4650,4681,4704,4763,4767,4771,5047,5069,5081,5094,97,114,114,59,1,10512,71,5,174,1,59,4648,1,174,4,3,99,110,114,4658,4664,4668,117,116,101,59,1,340,103,59,1,10219,114,4,2,59,116,4675,4677,1,8608,108,59,1,10518,4,3,97,101,121,4689,4695,4701,114,111,110,59,1,344,100,105,108,59,1,342,59,1,1056,4,2,59,118,4710,4712,1,8476,101,114,115,101,4,2,69,85,4722,4748,4,2,108,113,4728,4736,101,109,101,110,116,59,1,8715,117,105,108,105,98,114,105,117,109,59,1,8651,112,69,113,117,105,108,105,98,114,105,117,109,59,1,10607,114,59,1,8476,111,59,1,929,103,104,116,4,8,65,67,68,70,84,85,86,97,4792,4840,4849,4905,4912,4972,5022,5040,4,2,110,114,4798,4811,103,108,101,66,114,97,99,107,101,116,59,1,10217,114,111,119,4,3,59,66,76,4822,4824,4829,1,8594,97,114,59,1,8677,101,102,116,65,114,114,111,119,59,1,8644,101,105,108,105,110,103,59,1,8969,111,4,2,117,119,4856,4869,98,108,101,66,114,97,99,107,101,116,59,1,10215,110,4,2,84,86,4876,4887,101,101,86,101,99,116,111,114,59,1,10589,101,99,116,111,114,4,2,59,66,4898,4900,1,8642,97,114,59,1,10581,108,111,111,114,59,1,8971,4,2,101,114,4918,4944,101,4,3,59,65,86,4927,4929,4936,1,8866,114,114,111,119,59,1,8614,101,99,116,111,114,59,1,10587,105,97,110,103,108,101,4,3,59,66,69,4958,4960,4965,1,8883,97,114,59,1,10704,113,117,97,108,59,1,8885,112,4,3,68,84,86,4981,4993,5004,111,119,110,86,101,99,116,111,114,59,1,10575,101,101,86,101,99,116,111,114,59,1,10588,101,99,116,111,114,4,2,59,66,5015,5017,1,8638,97,114,59,1,10580,101,99,116,111,114,4,2,59,66,5033,5035,1,8640,97,114,59,1,10579,114,114,111,119,59,1,8658,4,2,112,117,5053,5057,102,59,1,8477,110,100,73,109,112,108,105,101,115,59,1,10608,105,103,104,116,97,114,114,111,119,59,1,8667,4,2,99,104,5087,5091,114,59,1,8475,59,1,8625,108,101,68,101,108,97,121,101,100,59,1,10740,4,13,72,79,97,99,102,104,105,109,111,113,115,116,117,5134,5150,5157,5164,5198,5203,5259,5265,5277,5283,5374,5380,5385,4,2,67,99,5140,5146,72,99,121,59,1,1065,121,59,1,1064,70,84,99,121,59,1,1068,99,117,116,101,59,1,346,4,5,59,97,101,105,121,5176,5178,5184,5190,5195,1,10940,114,111,110,59,1,352,100,105,108,59,1,350,114,99,59,1,348,59,1,1057,114,59,3,55349,56598,111,114,116,4,4,68,76,82,85,5216,5227,5238,5250,111,119,110,65,114,114,111,119,59,1,8595,101,102,116,65,114,114,111,119,59,1,8592,105,103,104,116,65,114,114,111,119,59,1,8594,112,65,114,114,111,119,59,1,8593,103,109,97,59,1,931,97,108,108,67,105,114,99,108,101,59,1,8728,112,102,59,3,55349,56650,4,2,114,117,5289,5293,116,59,1,8730,97,114,101,4,4,59,73,83,85,5306,5308,5322,5367,1,9633,110,116,101,114,115,101,99,116,105,111,110,59,1,8851,117,4,2,98,112,5329,5347,115,101,116,4,2,59,69,5338,5340,1,8847,113,117,97,108,59,1,8849,101,114,115,101,116,4,2,59,69,5358,5360,1,8848,113,117,97,108,59,1,8850,110,105,111,110,59,1,8852,99,114,59,3,55349,56494,97,114,59,1,8902,4,4,98,99,109,112,5395,5420,5475,5478,4,2,59,115,5401,5403,1,8912,101,116,4,2,59,69,5411,5413,1,8912,113,117,97,108,59,1,8838,4,2,99,104,5426,5468,101,101,100,115,4,4,59,69,83,84,5440,5442,5449,5461,1,8827,113,117,97,108,59,1,10928,108,97,110,116,69,113,117,97,108,59,1,8829,105,108,100,101,59,1,8831,84,104,97,116,59,1,8715,59,1,8721,4,3,59,101,115,5486,5488,5507,1,8913,114,115,101,116,4,2,59,69,5498,5500,1,8835,113,117,97,108,59,1,8839,101,116,59,1,8913,4,11,72,82,83,97,99,102,104,105,111,114,115,5536,5546,5552,5567,5579,5602,5607,5655,5695,5701,5711,79,82,78,5,222,1,59,5544,1,222,65,68,69,59,1,8482,4,2,72,99,5558,5563,99,121,59,1,1035,121,59,1,1062,4,2,98,117,5573,5576,59,1,9,59,1,932,4,3,97,101,121,5587,5593,5599,114,111,110,59,1,356,100,105,108,59,1,354,59,1,1058,114,59,3,55349,56599,4,2,101,105,5613,5631,4,2,114,116,5619,5627,101,102,111,114,101,59,1,8756,97,59,1,920,4,2,99,110,5637,5647,107,83,112,97,99,101,59,3,8287,8202,83,112,97,99,101,59,1,8201,108,100,101,4,4,59,69,70,84,5668,5670,5677,5688,1,8764,113,117,97,108,59,1,8771,117,108,108,69,113,117,97,108,59,1,8773,105,108,100,101,59,1,8776,112,102,59,3,55349,56651,105,112,108,101,68,111,116,59,1,8411,4,2,99,116,5717,5722,114,59,3,55349,56495,114,111,107,59,1,358,4,14,97,98,99,100,102,103,109,110,111,112,114,115,116,117,5758,5789,5805,5823,5830,5835,5846,5852,5921,5937,6089,6095,6101,6108,4,2,99,114,5764,5774,117,116,101,5,218,1,59,5772,1,218,114,4,2,59,111,5781,5783,1,8607,99,105,114,59,1,10569,114,4,2,99,101,5796,5800,121,59,1,1038,118,101,59,1,364,4,2,105,121,5811,5820,114,99,5,219,1,59,5818,1,219,59,1,1059,98,108,97,99,59,1,368,114,59,3,55349,56600,114,97,118,101,5,217,1,59,5844,1,217,97,99,114,59,1,362,4,2,100,105,5858,5905,101,114,4,2,66,80,5866,5892,4,2,97,114,5872,5876,114,59,1,95,97,99,4,2,101,107,5884,5887,59,1,9183,101,116,59,1,9141,97,114,101,110,116,104,101,115,105,115,59,1,9181,111,110,4,2,59,80,5913,5915,1,8899,108,117,115,59,1,8846,4,2,103,112,5927,5932,111,110,59,1,370,102,59,3,55349,56652,4,8,65,68,69,84,97,100,112,115,5955,5985,5996,6009,6026,6033,6044,6075,114,114,111,119,4,3,59,66,68,5967,5969,5974,1,8593,97,114,59,1,10514,111,119,110,65,114,114,111,119,59,1,8645,111,119,110,65,114,114,111,119,59,1,8597,113,117,105,108,105,98,114,105,117,109,59,1,10606,101,101,4,2,59,65,6017,6019,1,8869,114,114,111,119,59,1,8613,114,114,111,119,59,1,8657,111,119,110,97,114,114,111,119,59,1,8661,101,114,4,2,76,82,6052,6063,101,102,116,65,114,114,111,119,59,1,8598,105,103,104,116,65,114,114,111,119,59,1,8599,105,4,2,59,108,6082,6084,1,978,111,110,59,1,933,105,110,103,59,1,366,99,114,59,3,55349,56496,105,108,100,101,59,1,360,109,108,5,220,1,59,6115,1,220,4,9,68,98,99,100,101,102,111,115,118,6137,6143,6148,6152,6166,6250,6255,6261,6267,97,115,104,59,1,8875,97,114,59,1,10987,121,59,1,1042,97,115,104,4,2,59,108,6161,6163,1,8873,59,1,10982,4,2,101,114,6172,6175,59,1,8897,4,3,98,116,121,6183,6188,6238,97,114,59,1,8214,4,2,59,105,6194,6196,1,8214,99,97,108,4,4,66,76,83,84,6209,6214,6220,6231,97,114,59,1,8739,105,110,101,59,1,124,101,112,97,114,97,116,111,114,59,1,10072,105,108,100,101,59,1,8768,84,104,105,110,83,112,97,99,101,59,1,8202,114,59,3,55349,56601,112,102,59,3,55349,56653,99,114,59,3,55349,56497,100,97,115,104,59,1,8874,4,5,99,101,102,111,115,6286,6292,6298,6303,6309,105,114,99,59,1,372,100,103,101,59,1,8896,114,59,3,55349,56602,112,102,59,3,55349,56654,99,114,59,3,55349,56498,4,4,102,105,111,115,6325,6330,6333,6339,114,59,3,55349,56603,59,1,926,112,102,59,3,55349,56655,99,114,59,3,55349,56499,4,9,65,73,85,97,99,102,111,115,117,6365,6370,6375,6380,6391,6405,6410,6416,6422,99,121,59,1,1071,99,121,59,1,1031,99,121,59,1,1070,99,117,116,101,5,221,1,59,6389,1,221,4,2,105,121,6397,6402,114,99,59,1,374,59,1,1067,114,59,3,55349,56604,112,102,59,3,55349,56656,99,114,59,3,55349,56500,109,108,59,1,376,4,8,72,97,99,100,101,102,111,115,6445,6450,6457,6472,6477,6501,6505,6510,99,121,59,1,1046,99,117,116,101,59,1,377,4,2,97,121,6463,6469,114,111,110,59,1,381,59,1,1047,111,116,59,1,379,4,2,114,116,6483,6497,111,87,105,100,116,104,83,112,97,99,101,59,1,8203,97,59,1,918,114,59,1,8488,112,102,59,1,8484,99,114,59,3,55349,56501,4,16,97,98,99,101,102,103,108,109,110,111,112,114,115,116,117,119,6550,6561,6568,6612,6622,6634,6645,6672,6699,6854,6870,6923,6933,6963,6974,6983,99,117,116,101,5,225,1,59,6559,1,225,114,101,118,101,59,1,259,4,6,59,69,100,105,117,121,6582,6584,6588,6591,6600,6609,1,8766,59,3,8766,819,59,1,8767,114,99,5,226,1,59,6598,1,226,116,101,5,180,1,59,6607,1,180,59,1,1072,108,105,103,5,230,1,59,6620,1,230,4,2,59,114,6628,6630,1,8289,59,3,55349,56606,114,97,118,101,5,224,1,59,6643,1,224,4,2,101,112,6651,6667,4,2,102,112,6657,6663,115,121,109,59,1,8501,104,59,1,8501,104,97,59,1,945,4,2,97,112,6678,6692,4,2,99,108,6684,6688,114,59,1,257,103,59,1,10815,5,38,1,59,6697,1,38,4,2,100,103,6705,6737,4,5,59,97,100,115,118,6717,6719,6724,6727,6734,1,8743,110,100,59,1,10837,59,1,10844,108,111,112,101,59,1,10840,59,1,10842,4,7,59,101,108,109,114,115,122,6753,6755,6758,6762,6814,6835,6848,1,8736,59,1,10660,101,59,1,8736,115,100,4,2,59,97,6770,6772,1,8737,4,8,97,98,99,100,101,102,103,104,6790,6793,6796,6799,6802,6805,6808,6811,59,1,10664,59,1,10665,59,1,10666,59,1,10667,59,1,10668,59,1,10669,59,1,10670,59,1,10671,116,4,2,59,118,6821,6823,1,8735,98,4,2,59,100,6830,6832,1,8894,59,1,10653,4,2,112,116,6841,6845,104,59,1,8738,59,1,197,97,114,114,59,1,9084,4,2,103,112,6860,6865,111,110,59,1,261,102,59,3,55349,56658,4,7,59,69,97,101,105,111,112,6886,6888,6891,6897,6900,6904,6908,1,8776,59,1,10864,99,105,114,59,1,10863,59,1,8778,100,59,1,8779,115,59,1,39,114,111,120,4,2,59,101,6917,6919,1,8776,113,59,1,8778,105,110,103,5,229,1,59,6931,1,229,4,3,99,116,121,6941,6946,6949,114,59,3,55349,56502,59,1,42,109,112,4,2,59,101,6957,6959,1,8776,113,59,1,8781,105,108,100,101,5,227,1,59,6972,1,227,109,108,5,228,1,59,6981,1,228,4,2,99,105,6989,6997,111,110,105,110,116,59,1,8755,110,116,59,1,10769,4,16,78,97,98,99,100,101,102,105,107,108,110,111,112,114,115,117,7036,7041,7119,7135,7149,7155,7219,7224,7347,7354,7463,7489,7786,7793,7814,7866,111,116,59,1,10989,4,2,99,114,7047,7094,107,4,4,99,101,112,115,7058,7064,7073,7080,111,110,103,59,1,8780,112,115,105,108,111,110,59,1,1014,114,105,109,101,59,1,8245,105,109,4,2,59,101,7088,7090,1,8765,113,59,1,8909,4,2,118,119,7100,7105,101,101,59,1,8893,101,100,4,2,59,103,7113,7115,1,8965,101,59,1,8965,114,107,4,2,59,116,7127,7129,1,9141,98,114,107,59,1,9142,4,2,111,121,7141,7146,110,103,59,1,8780,59,1,1073,113,117,111,59,1,8222,4,5,99,109,112,114,116,7167,7181,7188,7193,7199,97,117,115,4,2,59,101,7176,7178,1,8757,59,1,8757,112,116,121,118,59,1,10672,115,105,59,1,1014,110,111,117,59,1,8492,4,3,97,104,119,7207,7210,7213,59,1,946,59,1,8502,101,101,110,59,1,8812,114,59,3,55349,56607,103,4,7,99,111,115,116,117,118,119,7241,7262,7288,7305,7328,7335,7340,4,3,97,105,117,7249,7253,7258,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,4,3,100,112,116,7270,7275,7281,111,116,59,1,10752,108,117,115,59,1,10753,105,109,101,115,59,1,10754,4,2,113,116,7294,7300,99,117,112,59,1,10758,97,114,59,1,9733,114,105,97,110,103,108,101,4,2,100,117,7318,7324,111,119,110,59,1,9661,112,59,1,9651,112,108,117,115,59,1,10756,101,101,59,1,8897,101,100,103,101,59,1,8896,97,114,111,119,59,1,10509,4,3,97,107,111,7362,7436,7458,4,2,99,110,7368,7432,107,4,3,108,115,116,7377,7386,7394,111,122,101,110,103,101,59,1,10731,113,117,97,114,101,59,1,9642,114,105,97,110,103,108,101,4,4,59,100,108,114,7411,7413,7419,7425,1,9652,111,119,110,59,1,9662,101,102,116,59,1,9666,105,103,104,116,59,1,9656,107,59,1,9251,4,2,49,51,7442,7454,4,2,50,52,7448,7451,59,1,9618,59,1,9617,52,59,1,9619,99,107,59,1,9608,4,2,101,111,7469,7485,4,2,59,113,7475,7478,3,61,8421,117,105,118,59,3,8801,8421,116,59,1,8976,4,4,112,116,119,120,7499,7504,7517,7523,102,59,3,55349,56659,4,2,59,116,7510,7512,1,8869,111,109,59,1,8869,116,105,101,59,1,8904,4,12,68,72,85,86,98,100,104,109,112,116,117,118,7549,7571,7597,7619,7655,7660,7682,7708,7715,7721,7728,7750,4,4,76,82,108,114,7559,7562,7565,7568,59,1,9559,59,1,9556,59,1,9558,59,1,9555,4,5,59,68,85,100,117,7583,7585,7588,7591,7594,1,9552,59,1,9574,59,1,9577,59,1,9572,59,1,9575,4,4,76,82,108,114,7607,7610,7613,7616,59,1,9565,59,1,9562,59,1,9564,59,1,9561,4,7,59,72,76,82,104,108,114,7635,7637,7640,7643,7646,7649,7652,1,9553,59,1,9580,59,1,9571,59,1,9568,59,1,9579,59,1,9570,59,1,9567,111,120,59,1,10697,4,4,76,82,108,114,7670,7673,7676,7679,59,1,9557,59,1,9554,59,1,9488,59,1,9484,4,5,59,68,85,100,117,7694,7696,7699,7702,7705,1,9472,59,1,9573,59,1,9576,59,1,9516,59,1,9524,105,110,117,115,59,1,8863,108,117,115,59,1,8862,105,109,101,115,59,1,8864,4,4,76,82,108,114,7738,7741,7744,7747,59,1,9563,59,1,9560,59,1,9496,59,1,9492,4,7,59,72,76,82,104,108,114,7766,7768,7771,7774,7777,7780,7783,1,9474,59,1,9578,59,1,9569,59,1,9566,59,1,9532,59,1,9508,59,1,9500,114,105,109,101,59,1,8245,4,2,101,118,7799,7804,118,101,59,1,728,98,97,114,5,166,1,59,7812,1,166,4,4,99,101,105,111,7824,7829,7834,7846,114,59,3,55349,56503,109,105,59,1,8271,109,4,2,59,101,7841,7843,1,8765,59,1,8909,108,4,3,59,98,104,7855,7857,7860,1,92,59,1,10693,115,117,98,59,1,10184,4,2,108,109,7872,7885,108,4,2,59,101,7879,7881,1,8226,116,59,1,8226,112,4,3,59,69,101,7894,7896,7899,1,8782,59,1,10926,4,2,59,113,7905,7907,1,8783,59,1,8783,4,15,97,99,100,101,102,104,105,108,111,114,115,116,117,119,121,7942,8021,8075,8080,8121,8126,8157,8279,8295,8430,8446,8485,8491,8707,8726,4,3,99,112,114,7950,7956,8007,117,116,101,59,1,263,4,6,59,97,98,99,100,115,7970,7972,7977,7984,7998,8003,1,8745,110,100,59,1,10820,114,99,117,112,59,1,10825,4,2,97,117,7990,7994,112,59,1,10827,112,59,1,10823,111,116,59,1,10816,59,3,8745,65024,4,2,101,111,8013,8017,116,59,1,8257,110,59,1,711,4,4,97,101,105,117,8031,8046,8056,8061,4,2,112,114,8037,8041,115,59,1,10829,111,110,59,1,269,100,105,108,5,231,1,59,8054,1,231,114,99,59,1,265,112,115,4,2,59,115,8069,8071,1,10828,109,59,1,10832,111,116,59,1,267,4,3,100,109,110,8088,8097,8104,105,108,5,184,1,59,8095,1,184,112,116,121,118,59,1,10674,116,5,162,2,59,101,8112,8114,1,162,114,100,111,116,59,1,183,114,59,3,55349,56608,4,3,99,101,105,8134,8138,8154,121,59,1,1095,99,107,4,2,59,109,8146,8148,1,10003,97,114,107,59,1,10003,59,1,967,114,4,7,59,69,99,101,102,109,115,8174,8176,8179,8258,8261,8268,8273,1,9675,59,1,10691,4,3,59,101,108,8187,8189,8193,1,710,113,59,1,8791,101,4,2,97,100,8200,8223,114,114,111,119,4,2,108,114,8210,8216,101,102,116,59,1,8634,105,103,104,116,59,1,8635,4,5,82,83,97,99,100,8235,8238,8241,8246,8252,59,1,174,59,1,9416,115,116,59,1,8859,105,114,99,59,1,8858,97,115,104,59,1,8861,59,1,8791,110,105,110,116,59,1,10768,105,100,59,1,10991,99,105,114,59,1,10690,117,98,115,4,2,59,117,8288,8290,1,9827,105,116,59,1,9827,4,4,108,109,110,112,8305,8326,8376,8400,111,110,4,2,59,101,8313,8315,1,58,4,2,59,113,8321,8323,1,8788,59,1,8788,4,2,109,112,8332,8344,97,4,2,59,116,8339,8341,1,44,59,1,64,4,3,59,102,108,8352,8354,8358,1,8705,110,59,1,8728,101,4,2,109,120,8365,8371,101,110,116,59,1,8705,101,115,59,1,8450,4,2,103,105,8382,8395,4,2,59,100,8388,8390,1,8773,111,116,59,1,10861,110,116,59,1,8750,4,3,102,114,121,8408,8412,8417,59,3,55349,56660,111,100,59,1,8720,5,169,2,59,115,8424,8426,1,169,114,59,1,8471,4,2,97,111,8436,8441,114,114,59,1,8629,115,115,59,1,10007,4,2,99,117,8452,8457,114,59,3,55349,56504,4,2,98,112,8463,8474,4,2,59,101,8469,8471,1,10959,59,1,10961,4,2,59,101,8480,8482,1,10960,59,1,10962,100,111,116,59,1,8943,4,7,100,101,108,112,114,118,119,8507,8522,8536,8550,8600,8697,8702,97,114,114,4,2,108,114,8516,8519,59,1,10552,59,1,10549,4,2,112,115,8528,8532,114,59,1,8926,99,59,1,8927,97,114,114,4,2,59,112,8545,8547,1,8630,59,1,10557,4,6,59,98,99,100,111,115,8564,8566,8573,8587,8592,8596,1,8746,114,99,97,112,59,1,10824,4,2,97,117,8579,8583,112,59,1,10822,112,59,1,10826,111,116,59,1,8845,114,59,1,10821,59,3,8746,65024,4,4,97,108,114,118,8610,8623,8663,8672,114,114,4,2,59,109,8618,8620,1,8631,59,1,10556,121,4,3,101,118,119,8632,8651,8656,113,4,2,112,115,8639,8645,114,101,99,59,1,8926,117,99,99,59,1,8927,101,101,59,1,8910,101,100,103,101,59,1,8911,101,110,5,164,1,59,8670,1,164,101,97,114,114,111,119,4,2,108,114,8684,8690,101,102,116,59,1,8630,105,103,104,116,59,1,8631,101,101,59,1,8910,101,100,59,1,8911,4,2,99,105,8713,8721,111,110,105,110,116,59,1,8754,110,116,59,1,8753,108,99,116,121,59,1,9005,4,19,65,72,97,98,99,100,101,102,104,105,106,108,111,114,115,116,117,119,122,8773,8778,8783,8821,8839,8854,8887,8914,8930,8944,9036,9041,9058,9197,9227,9258,9281,9297,9305,114,114,59,1,8659,97,114,59,1,10597,4,4,103,108,114,115,8793,8799,8805,8809,103,101,114,59,1,8224,101,116,104,59,1,8504,114,59,1,8595,104,4,2,59,118,8816,8818,1,8208,59,1,8867,4,2,107,108,8827,8834,97,114,111,119,59,1,10511,97,99,59,1,733,4,2,97,121,8845,8851,114,111,110,59,1,271,59,1,1076,4,3,59,97,111,8862,8864,8880,1,8518,4,2,103,114,8870,8876,103,101,114,59,1,8225,114,59,1,8650,116,115,101,113,59,1,10871,4,3,103,108,109,8895,8902,8907,5,176,1,59,8900,1,176,116,97,59,1,948,112,116,121,118,59,1,10673,4,2,105,114,8920,8926,115,104,116,59,1,10623,59,3,55349,56609,97,114,4,2,108,114,8938,8941,59,1,8643,59,1,8642,4,5,97,101,103,115,118,8956,8986,8989,8996,9001,109,4,3,59,111,115,8965,8967,8983,1,8900,110,100,4,2,59,115,8975,8977,1,8900,117,105,116,59,1,9830,59,1,9830,59,1,168,97,109,109,97,59,1,989,105,110,59,1,8946,4,3,59,105,111,9009,9011,9031,1,247,100,101,5,247,2,59,111,9020,9022,1,247,110,116,105,109,101,115,59,1,8903,110,120,59,1,8903,99,121,59,1,1106,99,4,2,111,114,9048,9053,114,110,59,1,8990,111,112,59,1,8973,4,5,108,112,116,117,119,9070,9076,9081,9130,9144,108,97,114,59,1,36,102,59,3,55349,56661,4,5,59,101,109,112,115,9093,9095,9109,9116,9122,1,729,113,4,2,59,100,9102,9104,1,8784,111,116,59,1,8785,105,110,117,115,59,1,8760,108,117,115,59,1,8724,113,117,97,114,101,59,1,8865,98,108,101,98,97,114,119,101,100,103,101,59,1,8966,110,4,3,97,100,104,9153,9160,9172,114,114,111,119,59,1,8595,111,119,110,97,114,114,111,119,115,59,1,8650,97,114,112,111,111,110,4,2,108,114,9184,9190,101,102,116,59,1,8643,105,103,104,116,59,1,8642,4,2,98,99,9203,9211,107,97,114,111,119,59,1,10512,4,2,111,114,9217,9222,114,110,59,1,8991,111,112,59,1,8972,4,3,99,111,116,9235,9248,9252,4,2,114,121,9241,9245,59,3,55349,56505,59,1,1109,108,59,1,10742,114,111,107,59,1,273,4,2,100,114,9264,9269,111,116,59,1,8945,105,4,2,59,102,9276,9278,1,9663,59,1,9662,4,2,97,104,9287,9292,114,114,59,1,8693,97,114,59,1,10607,97,110,103,108,101,59,1,10662,4,2,99,105,9311,9315,121,59,1,1119,103,114,97,114,114,59,1,10239,4,18,68,97,99,100,101,102,103,108,109,110,111,112,113,114,115,116,117,120,9361,9376,9398,9439,9444,9447,9462,9495,9531,9585,9598,9614,9659,9755,9771,9792,9808,9826,4,2,68,111,9367,9372,111,116,59,1,10871,116,59,1,8785,4,2,99,115,9382,9392,117,116,101,5,233,1,59,9390,1,233,116,101,114,59,1,10862,4,4,97,105,111,121,9408,9414,9430,9436,114,111,110,59,1,283,114,4,2,59,99,9421,9423,1,8790,5,234,1,59,9428,1,234,108,111,110,59,1,8789,59,1,1101,111,116,59,1,279,59,1,8519,4,2,68,114,9453,9458,111,116,59,1,8786,59,3,55349,56610,4,3,59,114,115,9470,9472,9482,1,10906,97,118,101,5,232,1,59,9480,1,232,4,2,59,100,9488,9490,1,10902,111,116,59,1,10904,4,4,59,105,108,115,9505,9507,9515,9518,1,10905,110,116,101,114,115,59,1,9191,59,1,8467,4,2,59,100,9524,9526,1,10901,111,116,59,1,10903,4,3,97,112,115,9539,9544,9564,99,114,59,1,275,116,121,4,3,59,115,118,9554,9556,9561,1,8709,101,116,59,1,8709,59,1,8709,112,4,2,49,59,9571,9583,4,2,51,52,9577,9580,59,1,8196,59,1,8197,1,8195,4,2,103,115,9591,9594,59,1,331,112,59,1,8194,4,2,103,112,9604,9609,111,110,59,1,281,102,59,3,55349,56662,4,3,97,108,115,9622,9635,9640,114,4,2,59,115,9629,9631,1,8917,108,59,1,10723,117,115,59,1,10865,105,4,3,59,108,118,9649,9651,9656,1,949,111,110,59,1,949,59,1,1013,4,4,99,115,117,118,9669,9686,9716,9747,4,2,105,111,9675,9680,114,99,59,1,8790,108,111,110,59,1,8789,4,2,105,108,9692,9696,109,59,1,8770,97,110,116,4,2,103,108,9705,9710,116,114,59,1,10902,101,115,115,59,1,10901,4,3,97,101,105,9724,9729,9734,108,115,59,1,61,115,116,59,1,8799,118,4,2,59,68,9741,9743,1,8801,68,59,1,10872,112,97,114,115,108,59,1,10725,4,2,68,97,9761,9766,111,116,59,1,8787,114,114,59,1,10609,4,3,99,100,105,9779,9783,9788,114,59,1,8495,111,116,59,1,8784,109,59,1,8770,4,2,97,104,9798,9801,59,1,951,5,240,1,59,9806,1,240,4,2,109,114,9814,9822,108,5,235,1,59,9820,1,235,111,59,1,8364,4,3,99,105,112,9834,9838,9843,108,59,1,33,115,116,59,1,8707,4,2,101,111,9849,9859,99,116,97,116,105,111,110,59,1,8496,110,101,110,116,105,97,108,101,59,1,8519,4,12,97,99,101,102,105,106,108,110,111,112,114,115,9896,9910,9914,9921,9954,9960,9967,9989,9994,10027,10036,10164,108,108,105,110,103,100,111,116,115,101,113,59,1,8786,121,59,1,1092,109,97,108,101,59,1,9792,4,3,105,108,114,9929,9935,9950,108,105,103,59,1,64259,4,2,105,108,9941,9945,103,59,1,64256,105,103,59,1,64260,59,3,55349,56611,108,105,103,59,1,64257,108,105,103,59,3,102,106,4,3,97,108,116,9975,9979,9984,116,59,1,9837,105,103,59,1,64258,110,115,59,1,9649,111,102,59,1,402,4,2,112,114,10000,10005,102,59,3,55349,56663,4,2,97,107,10011,10016,108,108,59,1,8704,4,2,59,118,10022,10024,1,8916,59,1,10969,97,114,116,105,110,116,59,1,10765,4,2,97,111,10042,10159,4,2,99,115,10048,10155,4,6,49,50,51,52,53,55,10062,10102,10114,10135,10139,10151,4,6,50,51,52,53,54,56,10076,10083,10086,10093,10096,10099,5,189,1,59,10081,1,189,59,1,8531,5,188,1,59,10091,1,188,59,1,8533,59,1,8537,59,1,8539,4,2,51,53,10108,10111,59,1,8532,59,1,8534,4,3,52,53,56,10122,10129,10132,5,190,1,59,10127,1,190,59,1,8535,59,1,8540,53,59,1,8536,4,2,54,56,10145,10148,59,1,8538,59,1,8541,56,59,1,8542,108,59,1,8260,119,110,59,1,8994,99,114,59,3,55349,56507,4,17,69,97,98,99,100,101,102,103,105,106,108,110,111,114,115,116,118,10206,10217,10247,10254,10268,10273,10358,10363,10374,10380,10385,10406,10458,10464,10470,10497,10610,4,2,59,108,10212,10214,1,8807,59,1,10892,4,3,99,109,112,10225,10231,10244,117,116,101,59,1,501,109,97,4,2,59,100,10239,10241,1,947,59,1,989,59,1,10886,114,101,118,101,59,1,287,4,2,105,121,10260,10265,114,99,59,1,285,59,1,1075,111,116,59,1,289,4,4,59,108,113,115,10283,10285,10288,10308,1,8805,59,1,8923,4,3,59,113,115,10296,10298,10301,1,8805,59,1,8807,108,97,110,116,59,1,10878,4,4,59,99,100,108,10318,10320,10324,10345,1,10878,99,59,1,10921,111,116,4,2,59,111,10332,10334,1,10880,4,2,59,108,10340,10342,1,10882,59,1,10884,4,2,59,101,10351,10354,3,8923,65024,115,59,1,10900,114,59,3,55349,56612,4,2,59,103,10369,10371,1,8811,59,1,8921,109,101,108,59,1,8503,99,121,59,1,1107,4,4,59,69,97,106,10395,10397,10400,10403,1,8823,59,1,10898,59,1,10917,59,1,10916,4,4,69,97,101,115,10416,10419,10434,10453,59,1,8809,112,4,2,59,112,10426,10428,1,10890,114,111,120,59,1,10890,4,2,59,113,10440,10442,1,10888,4,2,59,113,10448,10450,1,10888,59,1,8809,105,109,59,1,8935,112,102,59,3,55349,56664,97,118,101,59,1,96,4,2,99,105,10476,10480,114,59,1,8458,109,4,3,59,101,108,10489,10491,10494,1,8819,59,1,10894,59,1,10896,5,62,6,59,99,100,108,113,114,10512,10514,10527,10532,10538,10545,1,62,4,2,99,105,10520,10523,59,1,10919,114,59,1,10874,111,116,59,1,8919,80,97,114,59,1,10645,117,101,115,116,59,1,10876,4,5,97,100,101,108,115,10557,10574,10579,10599,10605,4,2,112,114,10563,10570,112,114,111,120,59,1,10886,114,59,1,10616,111,116,59,1,8919,113,4,2,108,113,10586,10592,101,115,115,59,1,8923,108,101,115,115,59,1,10892,101,115,115,59,1,8823,105,109,59,1,8819,4,2,101,110,10616,10626,114,116,110,101,113,113,59,3,8809,65024,69,59,3,8809,65024,4,10,65,97,98,99,101,102,107,111,115,121,10653,10658,10713,10718,10724,10760,10765,10786,10850,10875,114,114,59,1,8660,4,4,105,108,109,114,10668,10674,10678,10684,114,115,112,59,1,8202,102,59,1,189,105,108,116,59,1,8459,4,2,100,114,10690,10695,99,121,59,1,1098,4,3,59,99,119,10703,10705,10710,1,8596,105,114,59,1,10568,59,1,8621,97,114,59,1,8463,105,114,99,59,1,293,4,3,97,108,114,10732,10748,10754,114,116,115,4,2,59,117,10741,10743,1,9829,105,116,59,1,9829,108,105,112,59,1,8230,99,111,110,59,1,8889,114,59,3,55349,56613,115,4,2,101,119,10772,10779,97,114,111,119,59,1,10533,97,114,111,119,59,1,10534,4,5,97,109,111,112,114,10798,10803,10809,10839,10844,114,114,59,1,8703,116,104,116,59,1,8763,107,4,2,108,114,10816,10827,101,102,116,97,114,114,111,119,59,1,8617,105,103,104,116,97,114,114,111,119,59,1,8618,102,59,3,55349,56665,98,97,114,59,1,8213,4,3,99,108,116,10858,10863,10869,114,59,3,55349,56509,97,115,104,59,1,8463,114,111,107,59,1,295,4,2,98,112,10881,10887,117,108,108,59,1,8259,104,101,110,59,1,8208,4,15,97,99,101,102,103,105,106,109,110,111,112,113,115,116,117,10925,10936,10958,10977,10990,11001,11039,11045,11101,11192,11220,11226,11237,11285,11299,99,117,116,101,5,237,1,59,10934,1,237,4,3,59,105,121,10944,10946,10955,1,8291,114,99,5,238,1,59,10953,1,238,59,1,1080,4,2,99,120,10964,10968,121,59,1,1077,99,108,5,161,1,59,10975,1,161,4,2,102,114,10983,10986,59,1,8660,59,3,55349,56614,114,97,118,101,5,236,1,59,10999,1,236,4,4,59,105,110,111,11011,11013,11028,11034,1,8520,4,2,105,110,11019,11024,110,116,59,1,10764,116,59,1,8749,102,105,110,59,1,10716,116,97,59,1,8489,108,105,103,59,1,307,4,3,97,111,112,11053,11092,11096,4,3,99,103,116,11061,11065,11088,114,59,1,299,4,3,101,108,112,11073,11076,11082,59,1,8465,105,110,101,59,1,8464,97,114,116,59,1,8465,104,59,1,305,102,59,1,8887,101,100,59,1,437,4,5,59,99,102,111,116,11113,11115,11121,11136,11142,1,8712,97,114,101,59,1,8453,105,110,4,2,59,116,11129,11131,1,8734,105,101,59,1,10717,100,111,116,59,1,305,4,5,59,99,101,108,112,11154,11156,11161,11179,11186,1,8747,97,108,59,1,8890,4,2,103,114,11167,11173,101,114,115,59,1,8484,99,97,108,59,1,8890,97,114,104,107,59,1,10775,114,111,100,59,1,10812,4,4,99,103,112,116,11202,11206,11211,11216,121,59,1,1105,111,110,59,1,303,102,59,3,55349,56666,97,59,1,953,114,111,100,59,1,10812,117,101,115,116,5,191,1,59,11235,1,191,4,2,99,105,11243,11248,114,59,3,55349,56510,110,4,5,59,69,100,115,118,11261,11263,11266,11271,11282,1,8712,59,1,8953,111,116,59,1,8949,4,2,59,118,11277,11279,1,8948,59,1,8947,59,1,8712,4,2,59,105,11291,11293,1,8290,108,100,101,59,1,297,4,2,107,109,11305,11310,99,121,59,1,1110,108,5,239,1,59,11316,1,239,4,6,99,102,109,111,115,117,11332,11346,11351,11357,11363,11380,4,2,105,121,11338,11343,114,99,59,1,309,59,1,1081,114,59,3,55349,56615,97,116,104,59,1,567,112,102,59,3,55349,56667,4,2,99,101,11369,11374,114,59,3,55349,56511,114,99,121,59,1,1112,107,99,121,59,1,1108,4,8,97,99,102,103,104,106,111,115,11404,11418,11433,11438,11445,11450,11455,11461,112,112,97,4,2,59,118,11413,11415,1,954,59,1,1008,4,2,101,121,11424,11430,100,105,108,59,1,311,59,1,1082,114,59,3,55349,56616,114,101,101,110,59,1,312,99,121,59,1,1093,99,121,59,1,1116,112,102,59,3,55349,56668,99,114,59,3,55349,56512,4,23,65,66,69,72,97,98,99,100,101,102,103,104,106,108,109,110,111,112,114,115,116,117,118,11515,11538,11544,11555,11560,11721,11780,11818,11868,12136,12160,12171,12203,12208,12246,12275,12327,12509,12523,12569,12641,12732,12752,4,3,97,114,116,11523,11528,11532,114,114,59,1,8666,114,59,1,8656,97,105,108,59,1,10523,97,114,114,59,1,10510,4,2,59,103,11550,11552,1,8806,59,1,10891,97,114,59,1,10594,4,9,99,101,103,109,110,112,113,114,116,11580,11586,11594,11600,11606,11624,11627,11636,11694,117,116,101,59,1,314,109,112,116,121,118,59,1,10676,114,97,110,59,1,8466,98,100,97,59,1,955,103,4,3,59,100,108,11615,11617,11620,1,10216,59,1,10641,101,59,1,10216,59,1,10885,117,111,5,171,1,59,11634,1,171,114,4,8,59,98,102,104,108,112,115,116,11655,11657,11669,11673,11677,11681,11685,11690,1,8592,4,2,59,102,11663,11665,1,8676,115,59,1,10527,115,59,1,10525,107,59,1,8617,112,59,1,8619,108,59,1,10553,105,109,59,1,10611,108,59,1,8610,4,3,59,97,101,11702,11704,11709,1,10923,105,108,59,1,10521,4,2,59,115,11715,11717,1,10925,59,3,10925,65024,4,3,97,98,114,11729,11734,11739,114,114,59,1,10508,114,107,59,1,10098,4,2,97,107,11745,11758,99,4,2,101,107,11752,11755,59,1,123,59,1,91,4,2,101,115,11764,11767,59,1,10635,108,4,2,100,117,11774,11777,59,1,10639,59,1,10637,4,4,97,101,117,121,11790,11796,11811,11815,114,111,110,59,1,318,4,2,100,105,11802,11807,105,108,59,1,316,108,59,1,8968,98,59,1,123,59,1,1083,4,4,99,113,114,115,11828,11832,11845,11864,97,59,1,10550,117,111,4,2,59,114,11840,11842,1,8220,59,1,8222,4,2,100,117,11851,11857,104,97,114,59,1,10599,115,104,97,114,59,1,10571,104,59,1,8626,4,5,59,102,103,113,115,11880,11882,12008,12011,12031,1,8804,116,4,5,97,104,108,114,116,11895,11913,11935,11947,11996,114,114,111,119,4,2,59,116,11905,11907,1,8592,97,105,108,59,1,8610,97,114,112,111,111,110,4,2,100,117,11925,11931,111,119,110,59,1,8637,112,59,1,8636,101,102,116,97,114,114,111,119,115,59,1,8647,105,103,104,116,4,3,97,104,115,11959,11974,11984,114,114,111,119,4,2,59,115,11969,11971,1,8596,59,1,8646,97,114,112,111,111,110,115,59,1,8651,113,117,105,103,97,114,114,111,119,59,1,8621,104,114,101,101,116,105,109,101,115,59,1,8907,59,1,8922,4,3,59,113,115,12019,12021,12024,1,8804,59,1,8806,108,97,110,116,59,1,10877,4,5,59,99,100,103,115,12043,12045,12049,12070,12083,1,10877,99,59,1,10920,111,116,4,2,59,111,12057,12059,1,10879,4,2,59,114,12065,12067,1,10881,59,1,10883,4,2,59,101,12076,12079,3,8922,65024,115,59,1,10899,4,5,97,100,101,103,115,12095,12103,12108,12126,12131,112,112,114,111,120,59,1,10885,111,116,59,1,8918,113,4,2,103,113,12115,12120,116,114,59,1,8922,103,116,114,59,1,10891,116,114,59,1,8822,105,109,59,1,8818,4,3,105,108,114,12144,12150,12156,115,104,116,59,1,10620,111,111,114,59,1,8970,59,3,55349,56617,4,2,59,69,12166,12168,1,8822,59,1,10897,4,2,97,98,12177,12198,114,4,2,100,117,12184,12187,59,1,8637,4,2,59,108,12193,12195,1,8636,59,1,10602,108,107,59,1,9604,99,121,59,1,1113,4,5,59,97,99,104,116,12220,12222,12227,12235,12241,1,8810,114,114,59,1,8647,111,114,110,101,114,59,1,8990,97,114,100,59,1,10603,114,105,59,1,9722,4,2,105,111,12252,12258,100,111,116,59,1,320,117,115,116,4,2,59,97,12267,12269,1,9136,99,104,101,59,1,9136,4,4,69,97,101,115,12285,12288,12303,12322,59,1,8808,112,4,2,59,112,12295,12297,1,10889,114,111,120,59,1,10889,4,2,59,113,12309,12311,1,10887,4,2,59,113,12317,12319,1,10887,59,1,8808,105,109,59,1,8934,4,8,97,98,110,111,112,116,119,122,12345,12359,12364,12421,12446,12467,12474,12490,4,2,110,114,12351,12355,103,59,1,10220,114,59,1,8701,114,107,59,1,10214,103,4,3,108,109,114,12373,12401,12409,101,102,116,4,2,97,114,12382,12389,114,114,111,119,59,1,10229,105,103,104,116,97,114,114,111,119,59,1,10231,97,112,115,116,111,59,1,10236,105,103,104,116,97,114,114,111,119,59,1,10230,112,97,114,114,111,119,4,2,108,114,12433,12439,101,102,116,59,1,8619,105,103,104,116,59,1,8620,4,3,97,102,108,12454,12458,12462,114,59,1,10629,59,3,55349,56669,117,115,59,1,10797,105,109,101,115,59,1,10804,4,2,97,98,12480,12485,115,116,59,1,8727,97,114,59,1,95,4,3,59,101,102,12498,12500,12506,1,9674,110,103,101,59,1,9674,59,1,10731,97,114,4,2,59,108,12517,12519,1,40,116,59,1,10643,4,5,97,99,104,109,116,12535,12540,12548,12561,12564,114,114,59,1,8646,111,114,110,101,114,59,1,8991,97,114,4,2,59,100,12556,12558,1,8651,59,1,10605,59,1,8206,114,105,59,1,8895,4,6,97,99,104,105,113,116,12583,12589,12594,12597,12614,12635,113,117,111,59,1,8249,114,59,3,55349,56513,59,1,8624,109,4,3,59,101,103,12606,12608,12611,1,8818,59,1,10893,59,1,10895,4,2,98,117,12620,12623,59,1,91,111,4,2,59,114,12630,12632,1,8216,59,1,8218,114,111,107,59,1,322,5,60,8,59,99,100,104,105,108,113,114,12660,12662,12675,12680,12686,12692,12698,12705,1,60,4,2,99,105,12668,12671,59,1,10918,114,59,1,10873,111,116,59,1,8918,114,101,101,59,1,8907,109,101,115,59,1,8905,97,114,114,59,1,10614,117,101,115,116,59,1,10875,4,2,80,105,12711,12716,97,114,59,1,10646,4,3,59,101,102,12724,12726,12729,1,9667,59,1,8884,59,1,9666,114,4,2,100,117,12739,12746,115,104,97,114,59,1,10570,104,97,114,59,1,10598,4,2,101,110,12758,12768,114,116,110,101,113,113,59,3,8808,65024,69,59,3,8808,65024,4,14,68,97,99,100,101,102,104,105,108,110,111,112,115,117,12803,12809,12893,12908,12914,12928,12933,12937,13011,13025,13032,13049,13052,13069,68,111,116,59,1,8762,4,4,99,108,112,114,12819,12827,12849,12887,114,5,175,1,59,12825,1,175,4,2,101,116,12833,12836,59,1,9794,4,2,59,101,12842,12844,1,10016,115,101,59,1,10016,4,2,59,115,12855,12857,1,8614,116,111,4,4,59,100,108,117,12869,12871,12877,12883,1,8614,111,119,110,59,1,8615,101,102,116,59,1,8612,112,59,1,8613,107,101,114,59,1,9646,4,2,111,121,12899,12905,109,109,97,59,1,10793,59,1,1084,97,115,104,59,1,8212,97,115,117,114,101,100,97,110,103,108,101,59,1,8737,114,59,3,55349,56618,111,59,1,8487,4,3,99,100,110,12945,12954,12985,114,111,5,181,1,59,12952,1,181,4,4,59,97,99,100,12964,12966,12971,12976,1,8739,115,116,59,1,42,105,114,59,1,10992,111,116,5,183,1,59,12983,1,183,117,115,4,3,59,98,100,12995,12997,13000,1,8722,59,1,8863,4,2,59,117,13006,13008,1,8760,59,1,10794,4,2,99,100,13017,13021,112,59,1,10971,114,59,1,8230,112,108,117,115,59,1,8723,4,2,100,112,13038,13044,101,108,115,59,1,8871,102,59,3,55349,56670,59,1,8723,4,2,99,116,13058,13063,114,59,3,55349,56514,112,111,115,59,1,8766,4,3,59,108,109,13077,13079,13087,1,956,116,105,109,97,112,59,1,8888,97,112,59,1,8888,4,24,71,76,82,86,97,98,99,100,101,102,103,104,105,106,108,109,111,112,114,115,116,117,118,119,13142,13165,13217,13229,13247,13330,13359,13414,13420,13508,13513,13579,13602,13626,13631,13762,13767,13855,13936,13995,14214,14285,14312,14432,4,2,103,116,13148,13152,59,3,8921,824,4,2,59,118,13158,13161,3,8811,8402,59,3,8811,824,4,3,101,108,116,13173,13200,13204,102,116,4,2,97,114,13181,13188,114,114,111,119,59,1,8653,105,103,104,116,97,114,114,111,119,59,1,8654,59,3,8920,824,4,2,59,118,13210,13213,3,8810,8402,59,3,8810,824,105,103,104,116,97,114,114,111,119,59,1,8655,4,2,68,100,13235,13241,97,115,104,59,1,8879,97,115,104,59,1,8878,4,5,98,99,110,112,116,13259,13264,13270,13275,13308,108,97,59,1,8711,117,116,101,59,1,324,103,59,3,8736,8402,4,5,59,69,105,111,112,13287,13289,13293,13298,13302,1,8777,59,3,10864,824,100,59,3,8779,824,115,59,1,329,114,111,120,59,1,8777,117,114,4,2,59,97,13316,13318,1,9838,108,4,2,59,115,13325,13327,1,9838,59,1,8469,4,2,115,117,13336,13344,112,5,160,1,59,13342,1,160,109,112,4,2,59,101,13352,13355,3,8782,824,59,3,8783,824,4,5,97,101,111,117,121,13371,13385,13391,13407,13411,4,2,112,114,13377,13380,59,1,10819,111,110,59,1,328,100,105,108,59,1,326,110,103,4,2,59,100,13399,13401,1,8775,111,116,59,3,10861,824,112,59,1,10818,59,1,1085,97,115,104,59,1,8211,4,7,59,65,97,100,113,115,120,13436,13438,13443,13466,13472,13478,13494,1,8800,114,114,59,1,8663,114,4,2,104,114,13450,13454,107,59,1,10532,4,2,59,111,13460,13462,1,8599,119,59,1,8599,111,116,59,3,8784,824,117,105,118,59,1,8802,4,2,101,105,13484,13489,97,114,59,1,10536,109,59,3,8770,824,105,115,116,4,2,59,115,13503,13505,1,8708,59,1,8708,114,59,3,55349,56619,4,4,69,101,115,116,13523,13527,13563,13568,59,3,8807,824,4,3,59,113,115,13535,13537,13559,1,8817,4,3,59,113,115,13545,13547,13551,1,8817,59,3,8807,824,108,97,110,116,59,3,10878,824,59,3,10878,824,105,109,59,1,8821,4,2,59,114,13574,13576,1,8815,59,1,8815,4,3,65,97,112,13587,13592,13597,114,114,59,1,8654,114,114,59,1,8622,97,114,59,1,10994,4,3,59,115,118,13610,13612,13623,1,8715,4,2,59,100,13618,13620,1,8956,59,1,8954,59,1,8715,99,121,59,1,1114,4,7,65,69,97,100,101,115,116,13647,13652,13656,13661,13665,13737,13742,114,114,59,1,8653,59,3,8806,824,114,114,59,1,8602,114,59,1,8229,4,4,59,102,113,115,13675,13677,13703,13725,1,8816,116,4,2,97,114,13684,13691,114,114,111,119,59,1,8602,105,103,104,116,97,114,114,111,119,59,1,8622,4,3,59,113,115,13711,13713,13717,1,8816,59,3,8806,824,108,97,110,116,59,3,10877,824,4,2,59,115,13731,13734,3,10877,824,59,1,8814,105,109,59,1,8820,4,2,59,114,13748,13750,1,8814,105,4,2,59,101,13757,13759,1,8938,59,1,8940,105,100,59,1,8740,4,2,112,116,13773,13778,102,59,3,55349,56671,5,172,3,59,105,110,13787,13789,13829,1,172,110,4,4,59,69,100,118,13800,13802,13806,13812,1,8713,59,3,8953,824,111,116,59,3,8949,824,4,3,97,98,99,13820,13823,13826,59,1,8713,59,1,8951,59,1,8950,105,4,2,59,118,13836,13838,1,8716,4,3,97,98,99,13846,13849,13852,59,1,8716,59,1,8958,59,1,8957,4,3,97,111,114,13863,13892,13899,114,4,4,59,97,115,116,13874,13876,13883,13888,1,8742,108,108,101,108,59,1,8742,108,59,3,11005,8421,59,3,8706,824,108,105,110,116,59,1,10772,4,3,59,99,101,13907,13909,13914,1,8832,117,101,59,1,8928,4,2,59,99,13920,13923,3,10927,824,4,2,59,101,13929,13931,1,8832,113,59,3,10927,824,4,4,65,97,105,116,13946,13951,13971,13982,114,114,59,1,8655,114,114,4,3,59,99,119,13961,13963,13967,1,8603,59,3,10547,824,59,3,8605,824,103,104,116,97,114,114,111,119,59,1,8603,114,105,4,2,59,101,13990,13992,1,8939,59,1,8941,4,7,99,104,105,109,112,113,117,14011,14036,14060,14080,14085,14090,14106,4,4,59,99,101,114,14021,14023,14028,14032,1,8833,117,101,59,1,8929,59,3,10928,824,59,3,55349,56515,111,114,116,4,2,109,112,14045,14050,105,100,59,1,8740,97,114,97,108,108,101,108,59,1,8742,109,4,2,59,101,14067,14069,1,8769,4,2,59,113,14075,14077,1,8772,59,1,8772,105,100,59,1,8740,97,114,59,1,8742,115,117,4,2,98,112,14098,14102,101,59,1,8930,101,59,1,8931,4,3,98,99,112,14114,14157,14171,4,4,59,69,101,115,14124,14126,14130,14133,1,8836,59,3,10949,824,59,1,8840,101,116,4,2,59,101,14141,14144,3,8834,8402,113,4,2,59,113,14151,14153,1,8840,59,3,10949,824,99,4,2,59,101,14164,14166,1,8833,113,59,3,10928,824,4,4,59,69,101,115,14181,14183,14187,14190,1,8837,59,3,10950,824,59,1,8841,101,116,4,2,59,101,14198,14201,3,8835,8402,113,4,2,59,113,14208,14210,1,8841,59,3,10950,824,4,4,103,105,108,114,14224,14228,14238,14242,108,59,1,8825,108,100,101,5,241,1,59,14236,1,241,103,59,1,8824,105,97,110,103,108,101,4,2,108,114,14254,14269,101,102,116,4,2,59,101,14263,14265,1,8938,113,59,1,8940,105,103,104,116,4,2,59,101,14279,14281,1,8939,113,59,1,8941,4,2,59,109,14291,14293,1,957,4,3,59,101,115,14301,14303,14308,1,35,114,111,59,1,8470,112,59,1,8199,4,9,68,72,97,100,103,105,108,114,115,14332,14338,14344,14349,14355,14369,14376,14408,14426,97,115,104,59,1,8877,97,114,114,59,1,10500,112,59,3,8781,8402,97,115,104,59,1,8876,4,2,101,116,14361,14365,59,3,8805,8402,59,3,62,8402,110,102,105,110,59,1,10718,4,3,65,101,116,14384,14389,14393,114,114,59,1,10498,59,3,8804,8402,4,2,59,114,14399,14402,3,60,8402,105,101,59,3,8884,8402,4,2,65,116,14414,14419,114,114,59,1,10499,114,105,101,59,3,8885,8402,105,109,59,3,8764,8402,4,3,65,97,110,14440,14445,14468,114,114,59,1,8662,114,4,2,104,114,14452,14456,107,59,1,10531,4,2,59,111,14462,14464,1,8598,119,59,1,8598,101,97,114,59,1,10535,4,18,83,97,99,100,101,102,103,104,105,108,109,111,112,114,115,116,117,118,14512,14515,14535,14560,14597,14603,14618,14643,14657,14662,14701,14741,14747,14769,14851,14877,14907,14916,59,1,9416,4,2,99,115,14521,14531,117,116,101,5,243,1,59,14529,1,243,116,59,1,8859,4,2,105,121,14541,14557,114,4,2,59,99,14548,14550,1,8858,5,244,1,59,14555,1,244,59,1,1086,4,5,97,98,105,111,115,14572,14577,14583,14587,14591,115,104,59,1,8861,108,97,99,59,1,337,118,59,1,10808,116,59,1,8857,111,108,100,59,1,10684,108,105,103,59,1,339,4,2,99,114,14609,14614,105,114,59,1,10687,59,3,55349,56620,4,3,111,114,116,14626,14630,14640,110,59,1,731,97,118,101,5,242,1,59,14638,1,242,59,1,10689,4,2,98,109,14649,14654,97,114,59,1,10677,59,1,937,110,116,59,1,8750,4,4,97,99,105,116,14672,14677,14693,14698,114,114,59,1,8634,4,2,105,114,14683,14687,114,59,1,10686,111,115,115,59,1,10683,110,101,59,1,8254,59,1,10688,4,3,97,101,105,14709,14714,14719,99,114,59,1,333,103,97,59,1,969,4,3,99,100,110,14727,14733,14736,114,111,110,59,1,959,59,1,10678,117,115,59,1,8854,112,102,59,3,55349,56672,4,3,97,101,108,14755,14759,14764,114,59,1,10679,114,112,59,1,10681,117,115,59,1,8853,4,7,59,97,100,105,111,115,118,14785,14787,14792,14831,14837,14841,14848,1,8744,114,114,59,1,8635,4,4,59,101,102,109,14802,14804,14817,14824,1,10845,114,4,2,59,111,14811,14813,1,8500,102,59,1,8500,5,170,1,59,14822,1,170,5,186,1,59,14829,1,186,103,111,102,59,1,8886,114,59,1,10838,108,111,112,101,59,1,10839,59,1,10843,4,3,99,108,111,14859,14863,14873,114,59,1,8500,97,115,104,5,248,1,59,14871,1,248,108,59,1,8856,105,4,2,108,109,14884,14893,100,101,5,245,1,59,14891,1,245,101,115,4,2,59,97,14901,14903,1,8855,115,59,1,10806,109,108,5,246,1,59,14914,1,246,98,97,114,59,1,9021,4,12,97,99,101,102,104,105,108,109,111,114,115,117,14948,14992,14996,15033,15038,15068,15090,15189,15192,15222,15427,15441,114,4,4,59,97,115,116,14959,14961,14976,14989,1,8741,5,182,2,59,108,14968,14970,1,182,108,101,108,59,1,8741,4,2,105,108,14982,14986,109,59,1,10995,59,1,11005,59,1,8706,121,59,1,1087,114,4,5,99,105,109,112,116,15009,15014,15019,15024,15027,110,116,59,1,37,111,100,59,1,46,105,108,59,1,8240,59,1,8869,101,110,107,59,1,8241,114,59,3,55349,56621,4,3,105,109,111,15046,15057,15063,4,2,59,118,15052,15054,1,966,59,1,981,109,97,116,59,1,8499,110,101,59,1,9742,4,3,59,116,118,15076,15078,15087,1,960,99,104,102,111,114,107,59,1,8916,59,1,982,4,2,97,117,15096,15119,110,4,2,99,107,15103,15115,107,4,2,59,104,15110,15112,1,8463,59,1,8462,118,59,1,8463,115,4,9,59,97,98,99,100,101,109,115,116,15140,15142,15148,15151,15156,15168,15171,15179,15184,1,43,99,105,114,59,1,10787,59,1,8862,105,114,59,1,10786,4,2,111,117,15162,15165,59,1,8724,59,1,10789,59,1,10866,110,5,177,1,59,15177,1,177,105,109,59,1,10790,119,111,59,1,10791,59,1,177,4,3,105,112,117,15200,15208,15213,110,116,105,110,116,59,1,10773,102,59,3,55349,56673,110,100,5,163,1,59,15220,1,163,4,10,59,69,97,99,101,105,110,111,115,117,15244,15246,15249,15253,15258,15334,15347,15367,15416,15421,1,8826,59,1,10931,112,59,1,10935,117,101,59,1,8828,4,2,59,99,15264,15266,1,10927,4,6,59,97,99,101,110,115,15280,15282,15290,15299,15303,15329,1,8826,112,112,114,111,120,59,1,10935,117,114,108,121,101,113,59,1,8828,113,59,1,10927,4,3,97,101,115,15311,15319,15324,112,112,114,111,120,59,1,10937,113,113,59,1,10933,105,109,59,1,8936,105,109,59,1,8830,109,101,4,2,59,115,15342,15344,1,8242,59,1,8473,4,3,69,97,115,15355,15358,15362,59,1,10933,112,59,1,10937,105,109,59,1,8936,4,3,100,102,112,15375,15378,15404,59,1,8719,4,3,97,108,115,15386,15392,15398,108,97,114,59,1,9006,105,110,101,59,1,8978,117,114,102,59,1,8979,4,2,59,116,15410,15412,1,8733,111,59,1,8733,105,109,59,1,8830,114,101,108,59,1,8880,4,2,99,105,15433,15438,114,59,3,55349,56517,59,1,968,110,99,115,112,59,1,8200,4,6,102,105,111,112,115,117,15462,15467,15472,15478,15485,15491,114,59,3,55349,56622,110,116,59,1,10764,112,102,59,3,55349,56674,114,105,109,101,59,1,8279,99,114,59,3,55349,56518,4,3,97,101,111,15499,15520,15534,116,4,2,101,105,15506,15515,114,110,105,111,110,115,59,1,8461,110,116,59,1,10774,115,116,4,2,59,101,15528,15530,1,63,113,59,1,8799,116,5,34,1,59,15540,1,34,4,21,65,66,72,97,98,99,100,101,102,104,105,108,109,110,111,112,114,115,116,117,120,15586,15609,15615,15620,15796,15855,15893,15931,15977,16001,16039,16183,16204,16222,16228,16285,16312,16318,16363,16408,16416,4,3,97,114,116,15594,15599,15603,114,114,59,1,8667,114,59,1,8658,97,105,108,59,1,10524,97,114,114,59,1,10511,97,114,59,1,10596,4,7,99,100,101,110,113,114,116,15636,15651,15656,15664,15687,15696,15770,4,2,101,117,15642,15646,59,3,8765,817,116,101,59,1,341,105,99,59,1,8730,109,112,116,121,118,59,1,10675,103,4,4,59,100,101,108,15675,15677,15680,15683,1,10217,59,1,10642,59,1,10661,101,59,1,10217,117,111,5,187,1,59,15694,1,187,114,4,11,59,97,98,99,102,104,108,112,115,116,119,15721,15723,15727,15739,15742,15746,15750,15754,15758,15763,15767,1,8594,112,59,1,10613,4,2,59,102,15733,15735,1,8677,115,59,1,10528,59,1,10547,115,59,1,10526,107,59,1,8618,112,59,1,8620,108,59,1,10565,105,109,59,1,10612,108,59,1,8611,59,1,8605,4,2,97,105,15776,15781,105,108,59,1,10522,111,4,2,59,110,15788,15790,1,8758,97,108,115,59,1,8474,4,3,97,98,114,15804,15809,15814,114,114,59,1,10509,114,107,59,1,10099,4,2,97,107,15820,15833,99,4,2,101,107,15827,15830,59,1,125,59,1,93,4,2,101,115,15839,15842,59,1,10636,108,4,2,100,117,15849,15852,59,1,10638,59,1,10640,4,4,97,101,117,121,15865,15871,15886,15890,114,111,110,59,1,345,4,2,100,105,15877,15882,105,108,59,1,343,108,59,1,8969,98,59,1,125,59,1,1088,4,4,99,108,113,115,15903,15907,15914,15927,97,59,1,10551,100,104,97,114,59,1,10601,117,111,4,2,59,114,15922,15924,1,8221,59,1,8221,104,59,1,8627,4,3,97,99,103,15939,15966,15970,108,4,4,59,105,112,115,15950,15952,15957,15963,1,8476,110,101,59,1,8475,97,114,116,59,1,8476,59,1,8477,116,59,1,9645,5,174,1,59,15975,1,174,4,3,105,108,114,15985,15991,15997,115,104,116,59,1,10621,111,111,114,59,1,8971,59,3,55349,56623,4,2,97,111,16007,16028,114,4,2,100,117,16014,16017,59,1,8641,4,2,59,108,16023,16025,1,8640,59,1,10604,4,2,59,118,16034,16036,1,961,59,1,1009,4,3,103,110,115,16047,16167,16171,104,116,4,6,97,104,108,114,115,116,16063,16081,16103,16130,16143,16155,114,114,111,119,4,2,59,116,16073,16075,1,8594,97,105,108,59,1,8611,97,114,112,111,111,110,4,2,100,117,16093,16099,111,119,110,59,1,8641,112,59,1,8640,101,102,116,4,2,97,104,16112,16120,114,114,111,119,115,59,1,8644,97,114,112,111,111,110,115,59,1,8652,105,103,104,116,97,114,114,111,119,115,59,1,8649,113,117,105,103,97,114,114,111,119,59,1,8605,104,114,101,101,116,105,109,101,115,59,1,8908,103,59,1,730,105,110,103,100,111,116,115,101,113,59,1,8787,4,3,97,104,109,16191,16196,16201,114,114,59,1,8644,97,114,59,1,8652,59,1,8207,111,117,115,116,4,2,59,97,16214,16216,1,9137,99,104,101,59,1,9137,109,105,100,59,1,10990,4,4,97,98,112,116,16238,16252,16257,16278,4,2,110,114,16244,16248,103,59,1,10221,114,59,1,8702,114,107,59,1,10215,4,3,97,102,108,16265,16269,16273,114,59,1,10630,59,3,55349,56675,117,115,59,1,10798,105,109,101,115,59,1,10805,4,2,97,112,16291,16304,114,4,2,59,103,16298,16300,1,41,116,59,1,10644,111,108,105,110,116,59,1,10770,97,114,114,59,1,8649,4,4,97,99,104,113,16328,16334,16339,16342,113,117,111,59,1,8250,114,59,3,55349,56519,59,1,8625,4,2,98,117,16348,16351,59,1,93,111,4,2,59,114,16358,16360,1,8217,59,1,8217,4,3,104,105,114,16371,16377,16383,114,101,101,59,1,8908,109,101,115,59,1,8906,105,4,4,59,101,102,108,16394,16396,16399,16402,1,9657,59,1,8885,59,1,9656,116,114,105,59,1,10702,108,117,104,97,114,59,1,10600,59,1,8478,4,19,97,98,99,100,101,102,104,105,108,109,111,112,113,114,115,116,117,119,122,16459,16466,16472,16572,16590,16672,16687,16746,16844,16850,16924,16963,16988,17115,17121,17154,17206,17614,17656,99,117,116,101,59,1,347,113,117,111,59,1,8218,4,10,59,69,97,99,101,105,110,112,115,121,16494,16496,16499,16513,16518,16531,16536,16556,16564,16569,1,8827,59,1,10932,4,2,112,114,16505,16508,59,1,10936,111,110,59,1,353,117,101,59,1,8829,4,2,59,100,16524,16526,1,10928,105,108,59,1,351,114,99,59,1,349,4,3,69,97,115,16544,16547,16551,59,1,10934,112,59,1,10938,105,109,59,1,8937,111,108,105,110,116,59,1,10771,105,109,59,1,8831,59,1,1089,111,116,4,3,59,98,101,16582,16584,16587,1,8901,59,1,8865,59,1,10854,4,7,65,97,99,109,115,116,120,16606,16611,16634,16642,16646,16652,16668,114,114,59,1,8664,114,4,2,104,114,16618,16622,107,59,1,10533,4,2,59,111,16628,16630,1,8600,119,59,1,8600,116,5,167,1,59,16640,1,167,105,59,1,59,119,97,114,59,1,10537,109,4,2,105,110,16659,16665,110,117,115,59,1,8726,59,1,8726,116,59,1,10038,114,4,2,59,111,16679,16682,3,55349,56624,119,110,59,1,8994,4,4,97,99,111,121,16697,16702,16716,16739,114,112,59,1,9839,4,2,104,121,16708,16713,99,121,59,1,1097,59,1,1096,114,116,4,2,109,112,16724,16729,105,100,59,1,8739,97,114,97,108,108,101,108,59,1,8741,5,173,1,59,16744,1,173,4,2,103,109,16752,16770,109,97,4,3,59,102,118,16762,16764,16767,1,963,59,1,962,59,1,962,4,8,59,100,101,103,108,110,112,114,16788,16790,16795,16806,16817,16828,16832,16838,1,8764,111,116,59,1,10858,4,2,59,113,16801,16803,1,8771,59,1,8771,4,2,59,69,16812,16814,1,10910,59,1,10912,4,2,59,69,16823,16825,1,10909,59,1,10911,101,59,1,8774,108,117,115,59,1,10788,97,114,114,59,1,10610,97,114,114,59,1,8592,4,4,97,101,105,116,16860,16883,16891,16904,4,2,108,115,16866,16878,108,115,101,116,109,105,110,117,115,59,1,8726,104,112,59,1,10803,112,97,114,115,108,59,1,10724,4,2,100,108,16897,16900,59,1,8739,101,59,1,8995,4,2,59,101,16910,16912,1,10922,4,2,59,115,16918,16920,1,10924,59,3,10924,65024,4,3,102,108,112,16932,16938,16958,116,99,121,59,1,1100,4,2,59,98,16944,16946,1,47,4,2,59,97,16952,16954,1,10692,114,59,1,9023,102,59,3,55349,56676,97,4,2,100,114,16970,16985,101,115,4,2,59,117,16978,16980,1,9824,105,116,59,1,9824,59,1,8741,4,3,99,115,117,16996,17028,17089,4,2,97,117,17002,17015,112,4,2,59,115,17009,17011,1,8851,59,3,8851,65024,112,4,2,59,115,17022,17024,1,8852,59,3,8852,65024,117,4,2,98,112,17035,17062,4,3,59,101,115,17043,17045,17048,1,8847,59,1,8849,101,116,4,2,59,101,17056,17058,1,8847,113,59,1,8849,4,3,59,101,115,17070,17072,17075,1,8848,59,1,8850,101,116,4,2,59,101,17083,17085,1,8848,113,59,1,8850,4,3,59,97,102,17097,17099,17112,1,9633,114,4,2,101,102,17106,17109,59,1,9633,59,1,9642,59,1,9642,97,114,114,59,1,8594,4,4,99,101,109,116,17131,17136,17142,17148,114,59,3,55349,56520,116,109,110,59,1,8726,105,108,101,59,1,8995,97,114,102,59,1,8902,4,2,97,114,17160,17172,114,4,2,59,102,17167,17169,1,9734,59,1,9733,4,2,97,110,17178,17202,105,103,104,116,4,2,101,112,17188,17197,112,115,105,108,111,110,59,1,1013,104,105,59,1,981,115,59,1,175,4,5,98,99,109,110,112,17218,17351,17420,17423,17427,4,9,59,69,100,101,109,110,112,114,115,17238,17240,17243,17248,17261,17267,17279,17285,17291,1,8834,59,1,10949,111,116,59,1,10941,4,2,59,100,17254,17256,1,8838,111,116,59,1,10947,117,108,116,59,1,10945,4,2,69,101,17273,17276,59,1,10955,59,1,8842,108,117,115,59,1,10943,97,114,114,59,1,10617,4,3,101,105,117,17299,17335,17339,116,4,3,59,101,110,17308,17310,17322,1,8834,113,4,2,59,113,17317,17319,1,8838,59,1,10949,101,113,4,2,59,113,17330,17332,1,8842,59,1,10955,109,59,1,10951,4,2,98,112,17345,17348,59,1,10965,59,1,10963,99,4,6,59,97,99,101,110,115,17366,17368,17376,17385,17389,17415,1,8827,112,112,114,111,120,59,1,10936,117,114,108,121,101,113,59,1,8829,113,59,1,10928,4,3,97,101,115,17397,17405,17410,112,112,114,111,120,59,1,10938,113,113,59,1,10934,105,109,59,1,8937,105,109,59,1,8831,59,1,8721,103,59,1,9834,4,13,49,50,51,59,69,100,101,104,108,109,110,112,115,17455,17462,17469,17476,17478,17481,17496,17509,17524,17530,17536,17548,17554,5,185,1,59,17460,1,185,5,178,1,59,17467,1,178,5,179,1,59,17474,1,179,1,8835,59,1,10950,4,2,111,115,17487,17491,116,59,1,10942,117,98,59,1,10968,4,2,59,100,17502,17504,1,8839,111,116,59,1,10948,115,4,2,111,117,17516,17520,108,59,1,10185,98,59,1,10967,97,114,114,59,1,10619,117,108,116,59,1,10946,4,2,69,101,17542,17545,59,1,10956,59,1,8843,108,117,115,59,1,10944,4,3,101,105,117,17562,17598,17602,116,4,3,59,101,110,17571,17573,17585,1,8835,113,4,2,59,113,17580,17582,1,8839,59,1,10950,101,113,4,2,59,113,17593,17595,1,8843,59,1,10956,109,59,1,10952,4,2,98,112,17608,17611,59,1,10964,59,1,10966,4,3,65,97,110,17622,17627,17650,114,114,59,1,8665,114,4,2,104,114,17634,17638,107,59,1,10534,4,2,59,111,17644,17646,1,8601,119,59,1,8601,119,97,114,59,1,10538,108,105,103,5,223,1,59,17664,1,223,4,13,97,98,99,100,101,102,104,105,111,112,114,115,119,17694,17709,17714,17737,17742,17749,17754,17860,17905,17957,17964,18090,18122,4,2,114,117,17700,17706,103,101,116,59,1,8982,59,1,964,114,107,59,1,9140,4,3,97,101,121,17722,17728,17734,114,111,110,59,1,357,100,105,108,59,1,355,59,1,1090,111,116,59,1,8411,108,114,101,99,59,1,8981,114,59,3,55349,56625,4,4,101,105,107,111,17764,17805,17836,17851,4,2,114,116,17770,17786,101,4,2,52,102,17777,17780,59,1,8756,111,114,101,59,1,8756,97,4,3,59,115,118,17795,17797,17802,1,952,121,109,59,1,977,59,1,977,4,2,99,110,17811,17831,107,4,2,97,115,17818,17826,112,112,114,111,120,59,1,8776,105,109,59,1,8764,115,112,59,1,8201,4,2,97,115,17842,17846,112,59,1,8776,105,109,59,1,8764,114,110,5,254,1,59,17858,1,254,4,3,108,109,110,17868,17873,17901,100,101,59,1,732,101,115,5,215,3,59,98,100,17884,17886,17898,1,215,4,2,59,97,17892,17894,1,8864,114,59,1,10801,59,1,10800,116,59,1,8749,4,3,101,112,115,17913,17917,17953,97,59,1,10536,4,4,59,98,99,102,17927,17929,17934,17939,1,8868,111,116,59,1,9014,105,114,59,1,10993,4,2,59,111,17945,17948,3,55349,56677,114,107,59,1,10970,97,59,1,10537,114,105,109,101,59,1,8244,4,3,97,105,112,17972,17977,18082,100,101,59,1,8482,4,7,97,100,101,109,112,115,116,17993,18051,18056,18059,18066,18072,18076,110,103,108,101,4,5,59,100,108,113,114,18009,18011,18017,18032,18035,1,9653,111,119,110,59,1,9663,101,102,116,4,2,59,101,18026,18028,1,9667,113,59,1,8884,59,1,8796,105,103,104,116,4,2,59,101,18045,18047,1,9657,113,59,1,8885,111,116,59,1,9708,59,1,8796,105,110,117,115,59,1,10810,108,117,115,59,1,10809,98,59,1,10701,105,109,101,59,1,10811,101,122,105,117,109,59,1,9186,4,3,99,104,116,18098,18111,18116,4,2,114,121,18104,18108,59,3,55349,56521,59,1,1094,99,121,59,1,1115,114,111,107,59,1,359,4,2,105,111,18128,18133,120,116,59,1,8812,104,101,97,100,4,2,108,114,18143,18154,101,102,116,97,114,114,111,119,59,1,8606,105,103,104,116,97,114,114,111,119,59,1,8608,4,18,65,72,97,98,99,100,102,103,104,108,109,111,112,114,115,116,117,119,18204,18209,18214,18234,18250,18268,18292,18308,18319,18343,18379,18397,18413,18504,18547,18553,18584,18603,114,114,59,1,8657,97,114,59,1,10595,4,2,99,114,18220,18230,117,116,101,5,250,1,59,18228,1,250,114,59,1,8593,114,4,2,99,101,18241,18245,121,59,1,1118,118,101,59,1,365,4,2,105,121,18256,18265,114,99,5,251,1,59,18263,1,251,59,1,1091,4,3,97,98,104,18276,18281,18287,114,114,59,1,8645,108,97,99,59,1,369,97,114,59,1,10606,4,2,105,114,18298,18304,115,104,116,59,1,10622,59,3,55349,56626,114,97,118,101,5,249,1,59,18317,1,249,4,2,97,98,18325,18338,114,4,2,108,114,18332,18335,59,1,8639,59,1,8638,108,107,59,1,9600,4,2,99,116,18349,18374,4,2,111,114,18355,18369,114,110,4,2,59,101,18363,18365,1,8988,114,59,1,8988,111,112,59,1,8975,114,105,59,1,9720,4,2,97,108,18385,18390,99,114,59,1,363,5,168,1,59,18395,1,168,4,2,103,112,18403,18408,111,110,59,1,371,102,59,3,55349,56678,4,6,97,100,104,108,115,117,18427,18434,18445,18470,18475,18494,114,114,111,119,59,1,8593,111,119,110,97,114,114,111,119,59,1,8597,97,114,112,111,111,110,4,2,108,114,18457,18463,101,102,116,59,1,8639,105,103,104,116,59,1,8638,117,115,59,1,8846,105,4,3,59,104,108,18484,18486,18489,1,965,59,1,978,111,110,59,1,965,112,97,114,114,111,119,115,59,1,8648,4,3,99,105,116,18512,18537,18542,4,2,111,114,18518,18532,114,110,4,2,59,101,18526,18528,1,8989,114,59,1,8989,111,112,59,1,8974,110,103,59,1,367,114,105,59,1,9721,99,114,59,3,55349,56522,4,3,100,105,114,18561,18566,18572,111,116,59,1,8944,108,100,101,59,1,361,105,4,2,59,102,18579,18581,1,9653,59,1,9652,4,2,97,109,18590,18595,114,114,59,1,8648,108,5,252,1,59,18601,1,252,97,110,103,108,101,59,1,10663,4,15,65,66,68,97,99,100,101,102,108,110,111,112,114,115,122,18643,18648,18661,18667,18847,18851,18857,18904,18909,18915,18931,18937,18943,18949,18996,114,114,59,1,8661,97,114,4,2,59,118,18656,18658,1,10984,59,1,10985,97,115,104,59,1,8872,4,2,110,114,18673,18679,103,114,116,59,1,10652,4,7,101,107,110,112,114,115,116,18695,18704,18711,18720,18742,18754,18810,112,115,105,108,111,110,59,1,1013,97,112,112,97,59,1,1008,111,116,104,105,110,103,59,1,8709,4,3,104,105,114,18728,18732,18735,105,59,1,981,59,1,982,111,112,116,111,59,1,8733,4,2,59,104,18748,18750,1,8597,111,59,1,1009,4,2,105,117,18760,18766,103,109,97,59,1,962,4,2,98,112,18772,18791,115,101,116,110,101,113,4,2,59,113,18784,18787,3,8842,65024,59,3,10955,65024,115,101,116,110,101,113,4,2,59,113,18803,18806,3,8843,65024,59,3,10956,65024,4,2,104,114,18816,18822,101,116,97,59,1,977,105,97,110,103,108,101,4,2,108,114,18834,18840,101,102,116,59,1,8882,105,103,104,116,59,1,8883,121,59,1,1074,97,115,104,59,1,8866,4,3,101,108,114,18865,18884,18890,4,3,59,98,101,18873,18875,18880,1,8744,97,114,59,1,8891,113,59,1,8794,108,105,112,59,1,8942,4,2,98,116,18896,18901,97,114,59,1,124,59,1,124,114,59,3,55349,56627,116,114,105,59,1,8882,115,117,4,2,98,112,18923,18927,59,3,8834,8402,59,3,8835,8402,112,102,59,3,55349,56679,114,111,112,59,1,8733,116,114,105,59,1,8883,4,2,99,117,18955,18960,114,59,3,55349,56523,4,2,98,112,18966,18981,110,4,2,69,101,18973,18977,59,3,10955,65024,59,3,8842,65024,110,4,2,69,101,18988,18992,59,3,10956,65024,59,3,8843,65024,105,103,122,97,103,59,1,10650,4,7,99,101,102,111,112,114,115,19020,19026,19061,19066,19072,19075,19089,105,114,99,59,1,373,4,2,100,105,19032,19055,4,2,98,103,19038,19043,97,114,59,1,10847,101,4,2,59,113,19050,19052,1,8743,59,1,8793,101,114,112,59,1,8472,114,59,3,55349,56628,112,102,59,3,55349,56680,59,1,8472,4,2,59,101,19081,19083,1,8768,97,116,104,59,1,8768,99,114,59,3,55349,56524,4,14,99,100,102,104,105,108,109,110,111,114,115,117,118,119,19125,19146,19152,19157,19173,19176,19192,19197,19202,19236,19252,19269,19286,19291,4,3,97,105,117,19133,19137,19142,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,116,114,105,59,1,9661,114,59,3,55349,56629,4,2,65,97,19163,19168,114,114,59,1,10234,114,114,59,1,10231,59,1,958,4,2,65,97,19182,19187,114,114,59,1,10232,114,114,59,1,10229,97,112,59,1,10236,105,115,59,1,8955,4,3,100,112,116,19210,19215,19230,111,116,59,1,10752,4,2,102,108,19221,19225,59,3,55349,56681,117,115,59,1,10753,105,109,101,59,1,10754,4,2,65,97,19242,19247,114,114,59,1,10233,114,114,59,1,10230,4,2,99,113,19258,19263,114,59,3,55349,56525,99,117,112,59,1,10758,4,2,112,116,19275,19281,108,117,115,59,1,10756,114,105,59,1,9651,101,101,59,1,8897,101,100,103,101,59,1,8896,4,8,97,99,101,102,105,111,115,117,19316,19335,19349,19357,19362,19367,19373,19379,99,4,2,117,121,19323,19332,116,101,5,253,1,59,19330,1,253,59,1,1103,4,2,105,121,19341,19346,114,99,59,1,375,59,1,1099,110,5,165,1,59,19355,1,165,114,59,3,55349,56630,99,121,59,1,1111,112,102,59,3,55349,56682,99,114,59,3,55349,56526,4,2,99,109,19385,19389,121,59,1,1102,108,5,255,1,59,19395,1,255,4,10,97,99,100,101,102,104,105,111,115,119,19419,19426,19441,19446,19462,19467,19472,19480,19486,19492,99,117,116,101,59,1,378,4,2,97,121,19432,19438,114,111,110,59,1,382,59,1,1079,111,116,59,1,380,4,2,101,116,19452,19458,116,114,102,59,1,8488,97,59,1,950,114,59,3,55349,56631,99,121,59,1,1078,103,114,97,114,114,59,1,8669,112,102,59,3,55349,56683,99,114,59,3,55349,56527,4,2,106,110,19498,19501,59,1,8205,106,59,1,8204]);

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HTML = __webpack_require__(67);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;

//Element utils

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function isImpliedEndTagRequired(tn) {
    switch (tn.length) {
        case 1:
            return tn === $.P;

        case 2:
            return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI;

        case 3:
            return tn === $.RTC;

        case 6:
            return tn === $.OPTION;

        case 8:
            return tn === $.OPTGROUP || tn === $.MENUITEM;
    }

    return false;
}

function isScopingElement(tn, ns) {
    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH)
                return ns === NS.HTML;

            else if (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS)
                return ns === NS.MATHML;

            break;

        case 4:
            if (tn === $.HTML)
                return ns === NS.HTML;

            else if (tn === $.DESC)
                return ns === NS.SVG;

            break;

        case 5:
            if (tn === $.TABLE)
                return ns === NS.HTML;

            else if (tn === $.MTEXT)
                return ns === NS.MATHML;

            else if (tn === $.TITLE)
                return ns === NS.SVG;

            break;

        case 6:
            return (tn === $.APPLET || tn === $.OBJECT) && ns === NS.HTML;

        case 7:
            return (tn === $.CAPTION || tn === $.MARQUEE) && ns === NS.HTML;

        case 8:
            return tn === $.TEMPLATE && ns === NS.HTML;

        case 13:
            return tn === $.FOREIGN_OBJECT && ns === NS.SVG;

        case 14:
            return tn === $.ANNOTATION_XML && ns === NS.MATHML;
    }

    return false;
}

//Stack of open elements
var OpenElementStack = module.exports = function (document, treeAdapter) {
    this.stackTop = -1;
    this.items = [];
    this.current = document;
    this.currentTagName = null;
    this.currentTmplContent = null;
    this.tmplCount = 0;
    this.treeAdapter = treeAdapter;
};

//Index of element
OpenElementStack.prototype._indexOf = function (element) {
    var idx = -1;

    for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
            idx = i;
            break;
        }
    }
    return idx;
};

//Update current element
OpenElementStack.prototype._isInTemplate = function () {
    return this.currentTagName === $.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
};

OpenElementStack.prototype._updateCurrentElement = function () {
    this.current = this.items[this.stackTop];
    this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);

    this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
};

//Mutations
OpenElementStack.prototype.push = function (element) {
    this.items[++this.stackTop] = element;
    this._updateCurrentElement();

    if (this._isInTemplate())
        this.tmplCount++;

};

OpenElementStack.prototype.pop = function () {
    this.stackTop--;

    if (this.tmplCount > 0 && this._isInTemplate())
        this.tmplCount--;

    this._updateCurrentElement();
};

OpenElementStack.prototype.replace = function (oldElement, newElement) {
    var idx = this._indexOf(oldElement);

    this.items[idx] = newElement;

    if (idx === this.stackTop)
        this._updateCurrentElement();
};

OpenElementStack.prototype.insertAfter = function (referenceElement, newElement) {
    var insertionIdx = this._indexOf(referenceElement) + 1;

    this.items.splice(insertionIdx, 0, newElement);

    if (insertionIdx === ++this.stackTop)
        this._updateCurrentElement();
};

OpenElementStack.prototype.popUntilTagNamePopped = function (tagName) {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === tagName && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popUntilElementPopped = function (element) {
    while (this.stackTop > -1) {
        var poppedElement = this.current;

        this.pop();

        if (poppedElement === element)
            break;
    }
};

OpenElementStack.prototype.popUntilNumberedHeaderPopped = function () {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6 && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popUntilTableCellPopped = function () {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === $.TD || tn === $.TH && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popAllUpToHtmlElement = function () {
    //NOTE: here we assume that root <html> element is always first in the open element stack, so
    //we perform this fast stack clean up.
    this.stackTop = 0;
    this._updateCurrentElement();
};

OpenElementStack.prototype.clearBackToTableContext = function () {
    while (this.currentTagName !== $.TABLE &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.clearBackToTableBodyContext = function () {
    while (this.currentTagName !== $.TBODY &&
           this.currentTagName !== $.TFOOT &&
           this.currentTagName !== $.THEAD &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.clearBackToTableRowContext = function () {
    while (this.currentTagName !== $.TR &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.remove = function (element) {
    for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
            this.items.splice(i, 1);
            this.stackTop--;
            this._updateCurrentElement();
            break;
        }
    }
};

//Search
OpenElementStack.prototype.tryPeekProperlyNestedBodyElement = function () {
    //Properly nested <body> element (should be second element in stack).
    var element = this.items[1];

    return element && this.treeAdapter.getTagName(element) === $.BODY ? element : null;
};

OpenElementStack.prototype.contains = function (element) {
    return this._indexOf(element) > -1;
};

OpenElementStack.prototype.getCommonAncestor = function (element) {
    var elementIdx = this._indexOf(element);

    return --elementIdx >= 0 ? this.items[elementIdx] : null;
};

OpenElementStack.prototype.isRootHtmlElementCurrent = function () {
    return this.stackTop === 0 && this.currentTagName === $.HTML;
};

//Element in scope
OpenElementStack.prototype.hasInScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if (isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasNumberedHeaderInScope = function () {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if ((tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) && ns === NS.HTML)
            return true;

        if (isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInListItemScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if ((tn === $.UL || tn === $.OL) && ns === NS.HTML || isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInButtonScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if (tn === $.BUTTON && ns === NS.HTML || isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInTableScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === tagName)
            return true;

        if (tn === $.TABLE || tn === $.TEMPLATE || tn === $.HTML)
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasTableBodyContextInTableScope = function () {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === $.TBODY || tn === $.THEAD || tn === $.TFOOT)
            return true;

        if (tn === $.TABLE || tn === $.HTML)
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInSelectScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === tagName)
            return true;

        if (tn !== $.OPTION && tn !== $.OPTGROUP)
            return false;
    }

    return true;
};

//Implied end tags
OpenElementStack.prototype.generateImpliedEndTags = function () {
    while (isImpliedEndTagRequired(this.currentTagName))
        this.pop();
};

OpenElementStack.prototype.generateImpliedEndTagsWithExclusion = function (exclusionTagName) {
    while (isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName)
        this.pop();
};


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Const
var NOAH_ARK_CAPACITY = 3;

//List of formatting elements
var FormattingElementList = module.exports = function (treeAdapter) {
    this.length = 0;
    this.entries = [];
    this.treeAdapter = treeAdapter;
    this.bookmark = null;
};

//Entry types
FormattingElementList.MARKER_ENTRY = 'MARKER_ENTRY';
FormattingElementList.ELEMENT_ENTRY = 'ELEMENT_ENTRY';

//Noah Ark's condition
//OPTIMIZATION: at first we try to find possible candidates for exclusion using
//lightweight heuristics without thorough attributes check.
FormattingElementList.prototype._getNoahArkConditionCandidates = function (newElement) {
    var candidates = [];

    if (this.length >= NOAH_ARK_CAPACITY) {
        var neAttrsLength = this.treeAdapter.getAttrList(newElement).length,
            neTagName = this.treeAdapter.getTagName(newElement),
            neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);

        for (var i = this.length - 1; i >= 0; i--) {
            var entry = this.entries[i];

            if (entry.type === FormattingElementList.MARKER_ENTRY)
                break;

            var element = entry.element,
                elementAttrs = this.treeAdapter.getAttrList(element),
                isCandidate = this.treeAdapter.getTagName(element) === neTagName &&
                              this.treeAdapter.getNamespaceURI(element) === neNamespaceURI &&
                              elementAttrs.length === neAttrsLength;

            if (isCandidate)
                candidates.push({idx: i, attrs: elementAttrs});
        }
    }

    return candidates.length < NOAH_ARK_CAPACITY ? [] : candidates;
};

FormattingElementList.prototype._ensureNoahArkCondition = function (newElement) {
    var candidates = this._getNoahArkConditionCandidates(newElement),
        cLength = candidates.length;

    if (cLength) {
        var neAttrs = this.treeAdapter.getAttrList(newElement),
            neAttrsLength = neAttrs.length,
            neAttrsMap = Object.create(null);

        //NOTE: build attrs map for the new element so we can perform fast lookups
        for (var i = 0; i < neAttrsLength; i++) {
            var neAttr = neAttrs[i];

            neAttrsMap[neAttr.name] = neAttr.value;
        }

        for (i = 0; i < neAttrsLength; i++) {
            for (var j = 0; j < cLength; j++) {
                var cAttr = candidates[j].attrs[i];

                if (neAttrsMap[cAttr.name] !== cAttr.value) {
                    candidates.splice(j, 1);
                    cLength--;
                }

                if (candidates.length < NOAH_ARK_CAPACITY)
                    return;
            }
        }

        //NOTE: remove bottommost candidates until Noah's Ark condition will not be met
        for (i = cLength - 1; i >= NOAH_ARK_CAPACITY - 1; i--) {
            this.entries.splice(candidates[i].idx, 1);
            this.length--;
        }
    }
};

//Mutations
FormattingElementList.prototype.insertMarker = function () {
    this.entries.push({type: FormattingElementList.MARKER_ENTRY});
    this.length++;
};

FormattingElementList.prototype.pushElement = function (element, token) {
    this._ensureNoahArkCondition(element);

    this.entries.push({
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
    });

    this.length++;
};

FormattingElementList.prototype.insertElementAfterBookmark = function (element, token) {
    var bookmarkIdx = this.length - 1;

    for (; bookmarkIdx >= 0; bookmarkIdx--) {
        if (this.entries[bookmarkIdx] === this.bookmark)
            break;
    }

    this.entries.splice(bookmarkIdx + 1, 0, {
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
    });

    this.length++;
};

FormattingElementList.prototype.removeEntry = function (entry) {
    for (var i = this.length - 1; i >= 0; i--) {
        if (this.entries[i] === entry) {
            this.entries.splice(i, 1);
            this.length--;
            break;
        }
    }
};

FormattingElementList.prototype.clearToLastMarker = function () {
    while (this.length) {
        var entry = this.entries.pop();

        this.length--;

        if (entry.type === FormattingElementList.MARKER_ENTRY)
            break;
    }
};

//Search
FormattingElementList.prototype.getElementEntryInScopeWithTagName = function (tagName) {
    for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];

        if (entry.type === FormattingElementList.MARKER_ENTRY)
            return null;

        if (this.treeAdapter.getTagName(entry.element) === tagName)
            return entry;
    }

    return null;
};

FormattingElementList.prototype.getElementEntry = function (element) {
    for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];

        if (entry.type === FormattingElementList.ELEMENT_ENTRY && entry.element === element)
            return entry;
    }

    return null;
};


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(145),
    Tokenizer = __webpack_require__(143),
    LocationInfoTokenizerMixin = __webpack_require__(787),
    PositionTrackingPreprocessorMixin = __webpack_require__(356),
    LocationInfoOpenElementStackMixin = __webpack_require__(789),
    HTML = __webpack_require__(67),
    inherits = __webpack_require__(146).inherits;


//Aliases
var $ = HTML.TAG_NAMES;

var LocationInfoParserMixin = module.exports = function (parser) {
    Mixin.call(this, parser);

    this.parser = parser;
    this.posTracker = null;
    this.lastStartTagToken = null;
    this.lastFosterParentingLocation = null;
    this.currentToken = null;
};

inherits(LocationInfoParserMixin, Mixin);


LocationInfoParserMixin.prototype._setStartLocation = function (element) {
    if (this.lastStartTagToken) {
        element.__location = Object.create(this.lastStartTagToken.location);
        element.__location.startTag = this.lastStartTagToken.location;
    }
    else
        element.__location = null;
};

LocationInfoParserMixin.prototype._setEndLocation = function (element, closingToken) {
    var loc = element.__location;

    if (loc) {
        if (closingToken.location) {
            var ctLoc = closingToken.location,
                tn = this.parser.treeAdapter.getTagName(element);

            // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
            var isClosingEndTag = closingToken.type === Tokenizer.END_TAG_TOKEN && tn === closingToken.tagName;

            if (isClosingEndTag) {
                loc.endTag = Object.create(ctLoc);
                loc.endOffset = ctLoc.endOffset;
            }

            else
                loc.endOffset = ctLoc.startOffset;
        }

        else if (closingToken.type === Tokenizer.EOF_TOKEN)
            loc.endOffset = this.posTracker.offset;
    }
};

LocationInfoParserMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        _bootstrap: function (document, fragmentContext) {
            orig._bootstrap.call(this, document, fragmentContext);

            mxn.lastStartTagToken = null;
            mxn.lastFosterParentingLocation = null;
            mxn.currentToken = null;
            mxn.posTracker = new PositionTrackingPreprocessorMixin(this.tokenizer.preprocessor);

            new LocationInfoTokenizerMixin(this.tokenizer);

            new LocationInfoOpenElementStackMixin(this.openElements, {
                onItemPop: function (element) {
                    mxn._setEndLocation(element, mxn.currentToken);
                }
            });
        },

        _runParsingLoop: function (scriptHandler) {
            orig._runParsingLoop.call(this, scriptHandler);

            // NOTE: generate location info for elements
            // that remains on open element stack
            for (var i = this.openElements.stackTop; i >= 0; i--)
                mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
        },


        //Token processing
        _processTokenInForeignContent: function (token) {
            mxn.currentToken = token;
            orig._processTokenInForeignContent.call(this, token);
        },

        _processToken: function (token) {
            mxn.currentToken = token;
            orig._processToken.call(this, token);

            //NOTE: <body> and <html> are never popped from the stack, so we need to updated
            //their end location explicitly.
            var requireExplicitUpdate = token.type === Tokenizer.END_TAG_TOKEN &&
                                        (token.tagName === $.HTML ||
                                         token.tagName === $.BODY && this.openElements.hasInScope($.BODY));

            if (requireExplicitUpdate) {
                for (var i = this.openElements.stackTop; i >= 0; i--) {
                    var element = this.openElements.items[i];

                    if (this.treeAdapter.getTagName(element) === token.tagName) {
                        mxn._setEndLocation(element, token);
                        break;
                    }
                }
            }
        },


        //Doctype
        _setDocumentType: function (token) {
            orig._setDocumentType.call(this, token);

            var documentChildren = this.treeAdapter.getChildNodes(this.document),
                cnLength = documentChildren.length;

            for (var i = 0; i < cnLength; i++) {
                var node = documentChildren[i];

                if (this.treeAdapter.isDocumentTypeNode(node)) {
                    node.__location = token.location;
                    break;
                }
            }
        },


        //Elements
        _attachElementToTree: function (element) {
            //NOTE: _attachElementToTree is called from _appendElement, _insertElement and _insertTemplate methods.
            //So we will use token location stored in this methods for the element.
            mxn._setStartLocation(element);
            mxn.lastStartTagToken = null;
            orig._attachElementToTree.call(this, element);
        },

        _appendElement: function (token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._appendElement.call(this, token, namespaceURI);
        },

        _insertElement: function (token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._insertElement.call(this, token, namespaceURI);
        },

        _insertTemplate: function (token) {
            mxn.lastStartTagToken = token;
            orig._insertTemplate.call(this, token);

            var tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);

            tmplContent.__location = null;
        },

        _insertFakeRootElement: function () {
            orig._insertFakeRootElement.call(this);
            this.openElements.current.__location = null;
        },

        //Comments
        _appendCommentNode: function (token, parent) {
            orig._appendCommentNode.call(this, token, parent);

            var children = this.treeAdapter.getChildNodes(parent),
                commentNode = children[children.length - 1];

            commentNode.__location = token.location;
        },

        //Text
        _findFosterParentingLocation: function () {
            //NOTE: store last foster parenting location, so we will be able to find inserted text
            //in case of foster parenting
            mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);

            return mxn.lastFosterParentingLocation;
        },

        _insertCharacters: function (token) {
            orig._insertCharacters.call(this, token);

            var hasFosterParent = this._shouldFosterParentOnInsertion(),
                parent = hasFosterParent && mxn.lastFosterParentingLocation.parent ||
                         this.openElements.currentTmplContent ||
                         this.openElements.current,
                siblings = this.treeAdapter.getChildNodes(parent),
                textNodeIdx = hasFosterParent && mxn.lastFosterParentingLocation.beforeElement ?
                siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1 :
                siblings.length - 1,
                textNode = siblings[textNodeIdx];

            //NOTE: if we have location assigned by another token, then just update end position
            if (textNode.__location)
                textNode.__location.endOffset = token.location.endOffset;

            else
                textNode.__location = token.location;
        }
    };
};



/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(145),
    Tokenizer = __webpack_require__(143),
    PositionTrackingPreprocessorMixin = __webpack_require__(356),
    inherits = __webpack_require__(146).inherits;

var LocationInfoTokenizerMixin = module.exports = function (tokenizer) {
    Mixin.call(this, tokenizer);

    this.tokenizer = tokenizer;
    this.posTracker = new PositionTrackingPreprocessorMixin(tokenizer.preprocessor);
    this.currentAttrLocation = null;
    this.currentTokenLocation = null;
};

inherits(LocationInfoTokenizerMixin, Mixin);

LocationInfoTokenizerMixin.prototype._getCurrentLocation = function () {
    return {
        line: this.posTracker.line,
        col: this.posTracker.col,
        startOffset: this.posTracker.offset,
        endOffset: -1
    };
};

LocationInfoTokenizerMixin.prototype._attachCurrentAttrLocationInfo = function () {
    this.currentAttrLocation.endOffset = this.posTracker.offset;

    var currentToken = this.tokenizer.currentToken,
        currentAttr = this.tokenizer.currentAttr;

    if (!currentToken.location.attrs)
        currentToken.location.attrs = Object.create(null);

    currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
};

LocationInfoTokenizerMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    var methods = {
        _createStartTagToken: function () {
            orig._createStartTagToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createEndTagToken: function () {
            orig._createEndTagToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createCommentToken: function () {
            orig._createCommentToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createDoctypeToken: function (initialName) {
            orig._createDoctypeToken.call(this, initialName);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createCharacterToken: function (type, ch) {
            orig._createCharacterToken.call(this, type, ch);
            this.currentCharacterToken.location = mxn.currentTokenLocation;
        },

        _createAttr: function (attrNameFirstCh) {
            orig._createAttr.call(this, attrNameFirstCh);
            mxn.currentAttrLocation = mxn._getCurrentLocation();
        },

        _leaveAttrName: function (toState) {
            orig._leaveAttrName.call(this, toState);
            mxn._attachCurrentAttrLocationInfo();
        },

        _leaveAttrValue: function (toState) {
            orig._leaveAttrValue.call(this, toState);
            mxn._attachCurrentAttrLocationInfo();
        },

        _emitCurrentToken: function () {
            //NOTE: if we have pending character token make it's end location equal to the
            //current token's start location.
            if (this.currentCharacterToken)
                this.currentCharacterToken.location.endOffset = this.currentToken.location.startOffset;

            this.currentToken.location.endOffset = mxn.posTracker.offset + 1;
            orig._emitCurrentToken.call(this);
        },

        _emitCurrentCharacterToken: function () {
            //NOTE: if we have character token and it's location wasn't set in the _emitCurrentToken(),
            //then set it's location at the current preprocessor position.
            //We don't need to increment preprocessor position, since character token
            //emission is always forced by the start of the next character token here.
            //So, we already have advanced position.
            if (this.currentCharacterToken && this.currentCharacterToken.location.endOffset === -1)
                this.currentCharacterToken.location.endOffset = mxn.posTracker.offset;

            orig._emitCurrentCharacterToken.call(this);
        }
    };

    //NOTE: patch initial states for each mode to obtain token start position
    Object.keys(Tokenizer.MODE).forEach(function (modeName) {
        var state = Tokenizer.MODE[modeName];

        methods[state] = function (cp) {
            mxn.currentTokenLocation = mxn._getCurrentLocation();
            orig[state].call(this, cp);
        };
    });

    return methods;
};



/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(145),
    inherits = __webpack_require__(146).inherits;

var LocationInfoOpenElementStackMixin = module.exports = function (stack, options) {
    Mixin.call(this, stack);

    this.onItemPop = options.onItemPop;
};

inherits(LocationInfoOpenElementStackMixin, Mixin);

LocationInfoOpenElementStackMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        pop: function () {
            mxn.onItemPop(this.current);
            orig.pop.call(this);
        },

        popAllUpToHtmlElement: function () {
            for (var i = this.stackTop; i > 0; i--)
                mxn.onItemPop(this.items[i]);

            orig.popAllUpToHtmlElement.call(this);
        },

        remove: function (element) {
            mxn.onItemPop(this.current);
            orig.remove.call(this, element);
        }
    };
};



/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__(143),
    HTML = __webpack_require__(67);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES,
    ATTRS = HTML.ATTRS;


//MIME types
var MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};

//Attributes
var DEFINITION_URL_ATTR = 'definitionurl',
    ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL',
    SVG_ATTRS_ADJUSTMENT_MAP = {
        'attributename': 'attributeName',
        'attributetype': 'attributeType',
        'basefrequency': 'baseFrequency',
        'baseprofile': 'baseProfile',
        'calcmode': 'calcMode',
        'clippathunits': 'clipPathUnits',
        'diffuseconstant': 'diffuseConstant',
        'edgemode': 'edgeMode',
        'filterunits': 'filterUnits',
        'glyphref': 'glyphRef',
        'gradienttransform': 'gradientTransform',
        'gradientunits': 'gradientUnits',
        'kernelmatrix': 'kernelMatrix',
        'kernelunitlength': 'kernelUnitLength',
        'keypoints': 'keyPoints',
        'keysplines': 'keySplines',
        'keytimes': 'keyTimes',
        'lengthadjust': 'lengthAdjust',
        'limitingconeangle': 'limitingConeAngle',
        'markerheight': 'markerHeight',
        'markerunits': 'markerUnits',
        'markerwidth': 'markerWidth',
        'maskcontentunits': 'maskContentUnits',
        'maskunits': 'maskUnits',
        'numoctaves': 'numOctaves',
        'pathlength': 'pathLength',
        'patterncontentunits': 'patternContentUnits',
        'patterntransform': 'patternTransform',
        'patternunits': 'patternUnits',
        'pointsatx': 'pointsAtX',
        'pointsaty': 'pointsAtY',
        'pointsatz': 'pointsAtZ',
        'preservealpha': 'preserveAlpha',
        'preserveaspectratio': 'preserveAspectRatio',
        'primitiveunits': 'primitiveUnits',
        'refx': 'refX',
        'refy': 'refY',
        'repeatcount': 'repeatCount',
        'repeatdur': 'repeatDur',
        'requiredextensions': 'requiredExtensions',
        'requiredfeatures': 'requiredFeatures',
        'specularconstant': 'specularConstant',
        'specularexponent': 'specularExponent',
        'spreadmethod': 'spreadMethod',
        'startoffset': 'startOffset',
        'stddeviation': 'stdDeviation',
        'stitchtiles': 'stitchTiles',
        'surfacescale': 'surfaceScale',
        'systemlanguage': 'systemLanguage',
        'tablevalues': 'tableValues',
        'targetx': 'targetX',
        'targety': 'targetY',
        'textlength': 'textLength',
        'viewbox': 'viewBox',
        'viewtarget': 'viewTarget',
        'xchannelselector': 'xChannelSelector',
        'ychannelselector': 'yChannelSelector',
        'zoomandpan': 'zoomAndPan'
    },
    XML_ATTRS_ADJUSTMENT_MAP = {
        'xlink:actuate': {prefix: 'xlink', name: 'actuate', namespace: NS.XLINK},
        'xlink:arcrole': {prefix: 'xlink', name: 'arcrole', namespace: NS.XLINK},
        'xlink:href': {prefix: 'xlink', name: 'href', namespace: NS.XLINK},
        'xlink:role': {prefix: 'xlink', name: 'role', namespace: NS.XLINK},
        'xlink:show': {prefix: 'xlink', name: 'show', namespace: NS.XLINK},
        'xlink:title': {prefix: 'xlink', name: 'title', namespace: NS.XLINK},
        'xlink:type': {prefix: 'xlink', name: 'type', namespace: NS.XLINK},
        'xml:base': {prefix: 'xml', name: 'base', namespace: NS.XML},
        'xml:lang': {prefix: 'xml', name: 'lang', namespace: NS.XML},
        'xml:space': {prefix: 'xml', name: 'space', namespace: NS.XML},
        'xmlns': {prefix: '', name: 'xmlns', namespace: NS.XMLNS},
        'xmlns:xlink': {prefix: 'xmlns', name: 'xlink', namespace: NS.XMLNS}

    };

//SVG tag names adjustment map
var SVG_TAG_NAMES_ADJUSTMENT_MAP = exports.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    'altglyph': 'altGlyph',
    'altglyphdef': 'altGlyphDef',
    'altglyphitem': 'altGlyphItem',
    'animatecolor': 'animateColor',
    'animatemotion': 'animateMotion',
    'animatetransform': 'animateTransform',
    'clippath': 'clipPath',
    'feblend': 'feBlend',
    'fecolormatrix': 'feColorMatrix',
    'fecomponenttransfer': 'feComponentTransfer',
    'fecomposite': 'feComposite',
    'feconvolvematrix': 'feConvolveMatrix',
    'fediffuselighting': 'feDiffuseLighting',
    'fedisplacementmap': 'feDisplacementMap',
    'fedistantlight': 'feDistantLight',
    'feflood': 'feFlood',
    'fefunca': 'feFuncA',
    'fefuncb': 'feFuncB',
    'fefuncg': 'feFuncG',
    'fefuncr': 'feFuncR',
    'fegaussianblur': 'feGaussianBlur',
    'feimage': 'feImage',
    'femerge': 'feMerge',
    'femergenode': 'feMergeNode',
    'femorphology': 'feMorphology',
    'feoffset': 'feOffset',
    'fepointlight': 'fePointLight',
    'fespecularlighting': 'feSpecularLighting',
    'fespotlight': 'feSpotLight',
    'fetile': 'feTile',
    'feturbulence': 'feTurbulence',
    'foreignobject': 'foreignObject',
    'glyphref': 'glyphRef',
    'lineargradient': 'linearGradient',
    'radialgradient': 'radialGradient',
    'textpath': 'textPath'
};

//Tags that causes exit from foreign content
var EXITS_FOREIGN_CONTENT = Object.create(null);

EXITS_FOREIGN_CONTENT[$.B] = true;
EXITS_FOREIGN_CONTENT[$.BIG] = true;
EXITS_FOREIGN_CONTENT[$.BLOCKQUOTE] = true;
EXITS_FOREIGN_CONTENT[$.BODY] = true;
EXITS_FOREIGN_CONTENT[$.BR] = true;
EXITS_FOREIGN_CONTENT[$.CENTER] = true;
EXITS_FOREIGN_CONTENT[$.CODE] = true;
EXITS_FOREIGN_CONTENT[$.DD] = true;
EXITS_FOREIGN_CONTENT[$.DIV] = true;
EXITS_FOREIGN_CONTENT[$.DL] = true;
EXITS_FOREIGN_CONTENT[$.DT] = true;
EXITS_FOREIGN_CONTENT[$.EM] = true;
EXITS_FOREIGN_CONTENT[$.EMBED] = true;
EXITS_FOREIGN_CONTENT[$.H1] = true;
EXITS_FOREIGN_CONTENT[$.H2] = true;
EXITS_FOREIGN_CONTENT[$.H3] = true;
EXITS_FOREIGN_CONTENT[$.H4] = true;
EXITS_FOREIGN_CONTENT[$.H5] = true;
EXITS_FOREIGN_CONTENT[$.H6] = true;
EXITS_FOREIGN_CONTENT[$.HEAD] = true;
EXITS_FOREIGN_CONTENT[$.HR] = true;
EXITS_FOREIGN_CONTENT[$.I] = true;
EXITS_FOREIGN_CONTENT[$.IMG] = true;
EXITS_FOREIGN_CONTENT[$.LI] = true;
EXITS_FOREIGN_CONTENT[$.LISTING] = true;
EXITS_FOREIGN_CONTENT[$.MENU] = true;
EXITS_FOREIGN_CONTENT[$.META] = true;
EXITS_FOREIGN_CONTENT[$.NOBR] = true;
EXITS_FOREIGN_CONTENT[$.OL] = true;
EXITS_FOREIGN_CONTENT[$.P] = true;
EXITS_FOREIGN_CONTENT[$.PRE] = true;
EXITS_FOREIGN_CONTENT[$.RUBY] = true;
EXITS_FOREIGN_CONTENT[$.S] = true;
EXITS_FOREIGN_CONTENT[$.SMALL] = true;
EXITS_FOREIGN_CONTENT[$.SPAN] = true;
EXITS_FOREIGN_CONTENT[$.STRONG] = true;
EXITS_FOREIGN_CONTENT[$.STRIKE] = true;
EXITS_FOREIGN_CONTENT[$.SUB] = true;
EXITS_FOREIGN_CONTENT[$.SUP] = true;
EXITS_FOREIGN_CONTENT[$.TABLE] = true;
EXITS_FOREIGN_CONTENT[$.TT] = true;
EXITS_FOREIGN_CONTENT[$.U] = true;
EXITS_FOREIGN_CONTENT[$.UL] = true;
EXITS_FOREIGN_CONTENT[$.VAR] = true;

//Check exit from foreign content
exports.causesExit = function (startTagToken) {
    var tn = startTagToken.tagName;
    var isFontWithAttrs = tn === $.FONT && (Tokenizer.getTokenAttr(startTagToken, ATTRS.COLOR) !== null ||
                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.SIZE) !== null ||
                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.FACE) !== null);

    return isFontWithAttrs ? true : EXITS_FOREIGN_CONTENT[tn];
};

//Token adjustments
exports.adjustTokenMathMLAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        if (token.attrs[i].name === DEFINITION_URL_ATTR) {
            token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
            break;
        }
    }
};

exports.adjustTokenSVGAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        var adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrName)
            token.attrs[i].name = adjustedAttrName;
    }
};

exports.adjustTokenXMLAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        var adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
};

exports.adjustTokenSVGTagName = function (token) {
    var adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];

    if (adjustedTagName)
        token.tagName = adjustedTagName;
};

//Integration points
function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === NS.MATHML && (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS || tn === $.MTEXT);
}

function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === NS.MATHML && tn === $.ANNOTATION_XML) {
        for (var i = 0; i < attrs.length; i++) {
            if (attrs[i].name === ATTRS.ENCODING) {
                var value = attrs[i].value.toLowerCase();

                return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
            }
        }
    }

    return ns === NS.SVG && (tn === $.FOREIGN_OBJECT || tn === $.DESC || tn === $.TITLE);
}

exports.isIntegrationPoint = function (tn, ns, attrs, foreignNS) {
    if ((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs))
        return true;

    if ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns))
        return true;

    return false;
};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaultTreeAdapter = __webpack_require__(202),
    mergeOptions = __webpack_require__(357),
    doctype = __webpack_require__(203),
    HTML = __webpack_require__(67);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;

//Default serializer options
var DEFAULT_OPTIONS = {
    treeAdapter: defaultTreeAdapter
};

//Escaping regexes
var AMP_REGEX = /&/g,
    NBSP_REGEX = /\u00a0/g,
    DOUBLE_QUOTE_REGEX = /"/g,
    LT_REGEX = /</g,
    GT_REGEX = />/g;

//Serializer
var Serializer = module.exports = function (node, options) {
    this.options = mergeOptions(DEFAULT_OPTIONS, options);
    this.treeAdapter = this.options.treeAdapter;

    this.html = '';
    this.startNode = node;
};

// NOTE: exported as static method for the testing purposes
Serializer.escapeString = function (str, attrMode) {
    str = str
        .replace(AMP_REGEX, '&amp;')
        .replace(NBSP_REGEX, '&nbsp;');

    if (attrMode)
        str = str.replace(DOUBLE_QUOTE_REGEX, '&quot;');

    else {
        str = str
            .replace(LT_REGEX, '&lt;')
            .replace(GT_REGEX, '&gt;');
    }

    return str;
};


//API
Serializer.prototype.serialize = function () {
    this._serializeChildNodes(this.startNode);

    return this.html;
};


//Internals
Serializer.prototype._serializeChildNodes = function (parentNode) {
    var childNodes = this.treeAdapter.getChildNodes(parentNode);

    if (childNodes) {
        for (var i = 0, cnLength = childNodes.length; i < cnLength; i++) {
            var currentNode = childNodes[i];

            if (this.treeAdapter.isElementNode(currentNode))
                this._serializeElement(currentNode);

            else if (this.treeAdapter.isTextNode(currentNode))
                this._serializeTextNode(currentNode);

            else if (this.treeAdapter.isCommentNode(currentNode))
                this._serializeCommentNode(currentNode);

            else if (this.treeAdapter.isDocumentTypeNode(currentNode))
                this._serializeDocumentTypeNode(currentNode);
        }
    }
};

Serializer.prototype._serializeElement = function (node) {
    var tn = this.treeAdapter.getTagName(node),
        ns = this.treeAdapter.getNamespaceURI(node);

    this.html += '<' + tn;
    this._serializeAttributes(node);
    this.html += '>';

    if (tn !== $.AREA && tn !== $.BASE && tn !== $.BASEFONT && tn !== $.BGSOUND && tn !== $.BR && tn !== $.BR &&
        tn !== $.COL && tn !== $.EMBED && tn !== $.FRAME && tn !== $.HR && tn !== $.IMG && tn !== $.INPUT &&
        tn !== $.KEYGEN && tn !== $.LINK && tn !== $.MENUITEM && tn !== $.META && tn !== $.PARAM && tn !== $.SOURCE &&
        tn !== $.TRACK && tn !== $.WBR) {

        var childNodesHolder = tn === $.TEMPLATE && ns === NS.HTML ?
            this.treeAdapter.getTemplateContent(node) :
            node;

        this._serializeChildNodes(childNodesHolder);
        this.html += '</' + tn + '>';
    }
};

Serializer.prototype._serializeAttributes = function (node) {
    var attrs = this.treeAdapter.getAttrList(node);

    for (var i = 0, attrsLength = attrs.length; i < attrsLength; i++) {
        var attr = attrs[i],
            value = Serializer.escapeString(attr.value, true);

        this.html += ' ';

        if (!attr.namespace)
            this.html += attr.name;

        else if (attr.namespace === NS.XML)
            this.html += 'xml:' + attr.name;

        else if (attr.namespace === NS.XMLNS) {
            if (attr.name !== 'xmlns')
                this.html += 'xmlns:';

            this.html += attr.name;
        }

        else if (attr.namespace === NS.XLINK)
            this.html += 'xlink:' + attr.name;

        else
            this.html += attr.namespace + ':' + attr.name;

        this.html += '="' + value + '"';
    }
};

Serializer.prototype._serializeTextNode = function (node) {
    var content = this.treeAdapter.getTextNodeContent(node),
        parent = this.treeAdapter.getParentNode(node),
        parentTn = void 0;

    if (parent && this.treeAdapter.isElementNode(parent))
        parentTn = this.treeAdapter.getTagName(parent);

    if (parentTn === $.STYLE || parentTn === $.SCRIPT || parentTn === $.XMP || parentTn === $.IFRAME ||
        parentTn === $.NOEMBED || parentTn === $.NOFRAMES || parentTn === $.PLAINTEXT || parentTn === $.NOSCRIPT)

        this.html += content;

    else
        this.html += Serializer.escapeString(content, false);
};

Serializer.prototype._serializeCommentNode = function (node) {
    this.html += '<!--' + this.treeAdapter.getCommentNodeContent(node) + '-->';
};

Serializer.prototype._serializeDocumentTypeNode = function (node) {
    var name = this.treeAdapter.getDocumentTypeNodeName(node);

    this.html += '<' + doctype.serializeContent(name, null, null) + '>';
};


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var doctype = __webpack_require__(203),
    DOCUMENT_MODE = __webpack_require__(67).DOCUMENT_MODE;


//Conversion tables for DOM Level1 structure emulation
var nodeTypes = {
    element: 1,
    text: 3,
    cdata: 4,
    comment: 8
};

var nodePropertyShorthands = {
    tagName: 'name',
    childNodes: 'children',
    parentNode: 'parent',
    previousSibling: 'prev',
    nextSibling: 'next',
    nodeValue: 'data'
};

//Node
var Node = function (props) {
    for (var key in props) {
        if (props.hasOwnProperty(key))
            this[key] = props[key];
    }
};

Node.prototype = {
    get firstChild() {
        var children = this.children;

        return children && children[0] || null;
    },

    get lastChild() {
        var children = this.children;

        return children && children[children.length - 1] || null;
    },

    get nodeType() {
        return nodeTypes[this.type] || nodeTypes.element;
    }
};

Object.keys(nodePropertyShorthands).forEach(function (key) {
    var shorthand = nodePropertyShorthands[key];

    Object.defineProperty(Node.prototype, key, {
        get: function () {
            return this[shorthand] || null;
        },
        set: function (val) {
            this[shorthand] = val;
            return val;
        }
    });
});


//Node construction
exports.createDocument = function () {
    return new Node({
        type: 'root',
        name: 'root',
        parent: null,
        prev: null,
        next: null,
        children: [],
        'x-mode': DOCUMENT_MODE.NO_QUIRKS
    });
};

exports.createDocumentFragment = function () {
    return new Node({
        type: 'root',
        name: 'root',
        parent: null,
        prev: null,
        next: null,
        children: []
    });
};

exports.createElement = function (tagName, namespaceURI, attrs) {
    var attribs = Object.create(null),
        attribsNamespace = Object.create(null),
        attribsPrefix = Object.create(null);

    for (var i = 0; i < attrs.length; i++) {
        var attrName = attrs[i].name;

        attribs[attrName] = attrs[i].value;
        attribsNamespace[attrName] = attrs[i].namespace;
        attribsPrefix[attrName] = attrs[i].prefix;
    }

    return new Node({
        type: tagName === 'script' || tagName === 'style' ? tagName : 'tag',
        name: tagName,
        namespace: namespaceURI,
        attribs: attribs,
        'x-attribsNamespace': attribsNamespace,
        'x-attribsPrefix': attribsPrefix,
        children: [],
        parent: null,
        prev: null,
        next: null
    });
};

exports.createCommentNode = function (data) {
    return new Node({
        type: 'comment',
        data: data,
        parent: null,
        prev: null,
        next: null
    });
};

var createTextNode = function (value) {
    return new Node({
        type: 'text',
        data: value,
        parent: null,
        prev: null,
        next: null
    });
};


//Tree mutation
var appendChild = exports.appendChild = function (parentNode, newNode) {
    var prev = parentNode.children[parentNode.children.length - 1];

    if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
    }

    parentNode.children.push(newNode);
    newNode.parent = parentNode;
};

var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
    var insertionIdx = parentNode.children.indexOf(referenceNode),
        prev = referenceNode.prev;

    if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
    }

    referenceNode.prev = newNode;
    newNode.next = referenceNode;

    parentNode.children.splice(insertionIdx, 0, newNode);
    newNode.parent = parentNode;
};

exports.setTemplateContent = function (templateElement, contentElement) {
    appendChild(templateElement, contentElement);
};

exports.getTemplateContent = function (templateElement) {
    return templateElement.children[0];
};

exports.setDocumentType = function (document, name, publicId, systemId) {
    var data = doctype.serializeContent(name, publicId, systemId),
        doctypeNode = null;

    for (var i = 0; i < document.children.length; i++) {
        if (document.children[i].type === 'directive' && document.children[i].name === '!doctype') {
            doctypeNode = document.children[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.data = data;
        doctypeNode['x-name'] = name;
        doctypeNode['x-publicId'] = publicId;
        doctypeNode['x-systemId'] = systemId;
    }

    else {
        appendChild(document, new Node({
            type: 'directive',
            name: '!doctype',
            data: data,
            'x-name': name,
            'x-publicId': publicId,
            'x-systemId': systemId
        }));
    }

};

exports.setDocumentMode = function (document, mode) {
    document['x-mode'] = mode;
};

exports.getDocumentMode = function (document) {
    return document['x-mode'];
};

exports.detachNode = function (node) {
    if (node.parent) {
        var idx = node.parent.children.indexOf(node),
            prev = node.prev,
            next = node.next;

        node.prev = null;
        node.next = null;

        if (prev)
            prev.next = next;

        if (next)
            next.prev = prev;

        node.parent.children.splice(idx, 1);
        node.parent = null;
    }
};

exports.insertText = function (parentNode, text) {
    var lastChild = parentNode.children[parentNode.children.length - 1];

    if (lastChild && lastChild.type === 'text')
        lastChild.data += text;
    else
        appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function (parentNode, text, referenceNode) {
    var prevNode = parentNode.children[parentNode.children.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.type === 'text')
        prevNode.data += text;
    else
        insertBefore(parentNode, createTextNode(text), referenceNode);
};

exports.adoptAttributes = function (recipient, attrs) {
    for (var i = 0; i < attrs.length; i++) {
        var attrName = attrs[i].name;

        if (typeof recipient.attribs[attrName] === 'undefined') {
            recipient.attribs[attrName] = attrs[i].value;
            recipient['x-attribsNamespace'][attrName] = attrs[i].namespace;
            recipient['x-attribsPrefix'][attrName] = attrs[i].prefix;
        }
    }
};


//Tree traversing
exports.getFirstChild = function (node) {
    return node.children[0];
};

exports.getChildNodes = function (node) {
    return node.children;
};

exports.getParentNode = function (node) {
    return node.parent;
};

exports.getAttrList = function (element) {
    var attrList = [];

    for (var name in element.attribs) {
        attrList.push({
            name: name,
            value: element.attribs[name],
            namespace: element['x-attribsNamespace'][name],
            prefix: element['x-attribsPrefix'][name]
        });
    }

    return attrList;
};


//Node data
exports.getTagName = function (element) {
    return element.name;
};

exports.getNamespaceURI = function (element) {
    return element.namespace;
};

exports.getTextNodeContent = function (textNode) {
    return textNode.data;
};

exports.getCommentNodeContent = function (commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function (doctypeNode) {
    return doctypeNode['x-name'];
};

exports.getDocumentTypeNodePublicId = function (doctypeNode) {
    return doctypeNode['x-publicId'];
};

exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
    return doctypeNode['x-systemId'];
};


//Node types
exports.isTextNode = function (node) {
    return node.type === 'text';
};

exports.isCommentNode = function (node) {
    return node.type === 'comment';
};

exports.isDocumentTypeNode = function (node) {
    return node.type === 'directive' && node.name === '!doctype';
};

exports.isElementNode = function (node) {
    return !!node.attribs;
};


/***/ }),
/* 793 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 793;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(796);
var v4 = __webpack_require__(68);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(358);
var bytesToUuid = __webpack_require__(359);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var fbemitter = {
  EventEmitter: __webpack_require__(798),
  EmitterSubscription : __webpack_require__(360)
};

module.exports = fbemitter;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BaseEventEmitter
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EmitterSubscription = __webpack_require__(360);
var EventSubscriptionVendor = __webpack_require__(800);

var emptyFunction = __webpack_require__(94);
var invariant = __webpack_require__(57);

/**
 * @class BaseEventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */

var BaseEventEmitter = (function () {
  /**
   * @constructor
   */

  function BaseEventEmitter() {
    _classCallCheck(this, BaseEventEmitter);

    this._subscriber = new EventSubscriptionVendor();
    this._currentSubscription = null;
  }

  /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
    return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
  };

  /**
   * Similar to addListener, except that the listener is removed after it is
   * invoked once.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke only once when the
   *   specified event is emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.once = function once(eventType, listener, context) {
    var emitter = this;
    return this.addListener(eventType, function () {
      emitter.removeCurrentListener();
      listener.apply(context, arguments);
    });
  };

  /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */

  BaseEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
    this._subscriber.removeAllSubscriptions(eventType);
  };

  /**
   * Provides an API that can be called during an eventing cycle to remove the
   * last listener that was invoked. This allows a developer to provide an event
   * object that can remove the listener (or listener map) during the
   * invocation.
   *
   * If it is called when not inside of an emitting cycle it will throw.
   *
   * @throws {Error} When called not during an eventing cycle
   *
   * @example
   *   var subscription = emitter.addListenerMap({
   *     someEvent: function(data, event) {
   *       console.log(data);
   *       emitter.removeCurrentListener();
   *     }
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   *   emitter.emit('someEvent', 'def'); // does not log anything
   */

  BaseEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
    !!!this._currentSubscription ?  false ? invariant(false, 'Not in an emitting cycle; there is no current subscription') : invariant(false) : undefined;
    this._subscriber.removeSubscription(this._currentSubscription);
  };

  /**
   * Returns an array of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @return {array}
   */

  BaseEventEmitter.prototype.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */{
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    return subscriptions ? subscriptions.filter(emptyFunction.thatReturnsTrue).map(function (subscription) {
      return subscription.listener;
    }) : [];
  };

  /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */

  BaseEventEmitter.prototype.emit = function emit(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    if (subscriptions) {
      var keys = Object.keys(subscriptions);
      for (var ii = 0; ii < keys.length; ii++) {
        var key = keys[ii];
        var subscription = subscriptions[key];
        // The subscription may have been removed during this event loop.
        if (subscription) {
          this._currentSubscription = subscription;
          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
        }
      }
      this._currentSubscription = null;
    }
  };

  /**
   * Provides a hook to override how the emitter emits an event to a specific
   * subscription. This allows you to set up logging and error boundaries
   * specific to your environment.
   *
   * @param {EmitterSubscription} subscription
   * @param {string} eventType
   * @param {*} Arbitrary arguments to be passed to each registered listener
   */

  BaseEventEmitter.prototype.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
    var args = Array.prototype.slice.call(arguments, 2);
    subscription.listener.apply(subscription.context, args);
  };

  return BaseEventEmitter;
})();

module.exports = BaseEventEmitter;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventSubscription
 * @typechecks
 */



/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EventSubscription = (function () {

  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */

  function EventSubscription(subscriber) {
    _classCallCheck(this, EventSubscription);

    this.subscriber = subscriber;
  }

  /**
   * Removes this subscription from the subscriber that controls it.
   */

  EventSubscription.prototype.remove = function remove() {
    if (this.subscriber) {
      this.subscriber.removeSubscription(this);
      this.subscriber = null;
    }
  };

  return EventSubscription;
})();

module.exports = EventSubscription;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EventSubscriptionVendor
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var invariant = __webpack_require__(57);

/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */

var EventSubscriptionVendor = (function () {
  function EventSubscriptionVendor() {
    _classCallCheck(this, EventSubscriptionVendor);

    this._subscriptionsForType = {};
    this._currentSubscription = null;
  }

  /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */

  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
    !(subscription.subscriber === this) ?  false ? invariant(false, 'The subscriber of the subscription is incorrectly set.') : invariant(false) : undefined;
    if (!this._subscriptionsForType[eventType]) {
      this._subscriptionsForType[eventType] = [];
    }
    var key = this._subscriptionsForType[eventType].length;
    this._subscriptionsForType[eventType].push(subscription);
    subscription.eventType = eventType;
    subscription.key = key;
    return subscription;
  };

  /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */

  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
    if (eventType === undefined) {
      this._subscriptionsForType = {};
    } else {
      delete this._subscriptionsForType[eventType];
    }
  };

  /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */

  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
    var eventType = subscription.eventType;
    var key = subscription.key;

    var subscriptionsForType = this._subscriptionsForType[eventType];
    if (subscriptionsForType) {
      delete subscriptionsForType[key];
    }
  };

  /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @return {?array}
   */

  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
    return this._subscriptionsForType[eventType];
  };

  return EventSubscriptionVendor;
})();

module.exports = EventSubscriptionVendor;

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recordrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_SafariWorker__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lamejs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lamejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lamejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_PictureNaming_css__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_PictureNaming_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_students_PictureNaming_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LoadingModalComponent_LoadingModal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PN1On1Student__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_ico_video_png__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_ico_video_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_ico_video_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_ico_person_png__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_ico_person_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_ico_person_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_ico_audio_png__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_ico_audio_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_ico_audio_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_video_instructions_png__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_video_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_video_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_video_mask_png__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_video_mask_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_video_mask_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_device_detect__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shared_InstructionModals__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Shared_DataTrackingPoints__ = __webpack_require__(17);
var _this17=this;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var testPN='[{\n\t"id": 109,\n\t"createdAt": "2018-10-17T17:34:32.706Z",\n\t"updatedAt": "2018-10-17T17:34:32.706Z",\n\t"word": "scissors",\n\t"source": "CID",\n\t"classification": "school",\n\t"author": "MacAuthur",\n\t"url": "https://s3.us-east-2.amazonaws.com/uploadbeta/images/pictureNaming/image109.png",\n\t"deletedAt": null\n}, {\n\t"id": 10,\n\t"createdAt": "2018-10-17T17:34:32.706Z",\n\t"updatedAt": "2018-10-17T17:34:32.706Z",\n\t"word": "grapes",\n\t"source": "CID",\n\t"classification": "food",\n\t"author": "MacAuthur",\n\t"url": "https://s3.us-east-2.amazonaws.com/uploadbeta/images/pictureNaming/image10.png",\n\t"deletedAt": null\n}, {\n\t"id": 23,\n\t"createdAt": "2018-10-17T17:34:32.706Z",\n\t"updatedAt": "2018-10-17T17:34:32.706Z",\n\t"word": "shower",\n\t"source": "CID",\n\t"classification": "house",\n\t"author": "MacAuthur",\n\t"url": "https://s3.us-east-2.amazonaws.com/uploadbeta/images/pictureNaming/image23.png",\n\t"deletedAt": null\n}]';var newSes='{\n\t"AV_FileName": "",\n\t"startLevel": 2,\n\t"endLevel": 0,\n\t"pnPictures": [{\n\t\t"id": 109,\n\t\t"createdAt": "2018-10-17T17:34:32.706Z",\n\t\t"updatedAt": "2018-10-17T17:34:32.706Z",\n\t\t"word": "scissors",\n\t\t"source": "CID",\n\t\t"classification": "school",\n\t\t"author": "MacAuthur",\n\t\t"url": "https://s3.us-east-2.amazonaws.com/uploadbeta/images/pictureNaming/image109.png",\n\t\t"deletedAt": null\n\t}, {\n\t\t"id": 10,\n\t\t"createdAt": "2018-10-17T17:34:32.706Z",\n\t\t"updatedAt": "2018-10-17T17:34:32.706Z",\n\t\t"word": "grapes",\n\t\t"source": "CID",\n\t\t"classification": "food",\n\t\t"author": "MacAuthur",\n\t\t"url": "https://s3.us-east-2.amazonaws.com/uploadbeta/images/pictureNaming/image10.png",\n\t\t"deletedAt": null\n\t}, {\n\t\t"id": 23,\n\t\t"createdAt": "2018-10-17T17:34:32.706Z",\n\t\t"updatedAt": "2018-10-17T17:34:32.706Z",\n\t\t"word": "shower",\n\t\t"source": "CID",\n\t\t"classification": "house",\n\t\t"author": "MacAuthur",\n\t\t"url": "https://s3.us-east-2.amazonaws.com/uploadbeta/images/pictureNaming/image23.png",\n\t\t"deletedAt": null\n\t}],\n\t"assessmentType": 0,\n\t"startProgress": 1,\n\t"endProgress": 0,\n\t"guid": "86352f40-81cd-4a22-b699-3beb025989b9"\n}';var bestScor='{\n\t"id": 4430,\n\t"userId": 6974,\n\t"createdAt": "2018-10-16T18:36:55.759Z",\n\t"updatedAt": "2018-12-24T09:27:26.541Z",\n\t"mazeLevel": 3,\n\t"mazeScore": 2,\n\t"slashLevel": 4,\n\t"slashScore": 2,\n\t"ksLevel": 4,\n\t"ksScore": 1,\n\t"pnLevel": 2,\n\t"pnScore": 1,\n\t"crLevel": 2,\n\t"crScore": 1,\n\t"wssLevel": 1,\n\t"wssScore": 1,\n\t"kssLevel": 3,\n\t"kssScore": 2,\n\t"deletedAt": null\n}';var recordedSession=true;var timerDown=null;var params=null;var hasGetUserMedia=false;try{hasGetUserMedia=!!navigator.getUserMedia||!!navigator.mediaDevices.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}catch(err){hasGetUserMedia=!!navigator.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}var PictureNamingComponent=function(_Component){_inherits(PictureNamingComponent,_Component);function PictureNamingComponent(props){_classCallCheck(this,PictureNamingComponent);var _this=_possibleConstructorReturn(this,(PictureNamingComponent.__proto__||Object.getPrototypeOf(PictureNamingComponent)).call(this,props));_this.handleActive=function(active){_this.setState({active:active});};_this.handleModalBack=function(modalActive){_this.setState({modalActive:modalActive});};_this.handleSurveyBack=function(modalActive){};_this.handleSwitch=function(test){_this.setState({audioVideoSwitch:test});};_this.handleBeginTest=function(){_this.setState({active:3});};_this.state={active:0,audioVideoSwitch:'video',modalDialog:false,responseContent:'',modalActive:true,loadedScores:false,bestScores:{pnScore:1,pnLevel:1}};return _this;}_createClass(PictureNamingComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);case 2:_context3.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!response.success){_context.next=3;break;}_context.next=3;return _this2.setState({loadedScores:true,bestScores:response.body});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 4:_context3.next=6;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentAppStatus().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var _Helpers$filterApps,allowedApps,filteredApps,finishedApps;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this2.props.updateStudentAppStatus(res.body);case 2:_Helpers$filterApps=__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].filterApps(_this2.props.studentUser,_this2.props.apps),allowedApps=_Helpers$filterApps.allowedApps,filteredApps=_Helpers$filterApps.filteredApps,finishedApps=_Helpers$filterApps.finishedApps;_context2.next=5;return _this2.props.updateAppStates({allowedApps:allowedApps,filteredApps:filteredApps,finishedApps:finishedApps});case 5:_context2.next=7;return _this2.setState({bestScores:res.body.bestScores});case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}());case 6:if(this.props.apps.pictureNamingScores.filter(function(x){return x.gradingDate==null;}).length>3){this.props.history.goBack();}case 7:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.state.active!==2?"bgGrey PictureNaming":"bgYellow PictureNaming"},this.state.active===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Shared_DialogBox__["a" /* default */],{surveyModal:true,userId:this.props.studentUser.id,app:'Picture Naming',active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer progressBox1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:42}},'Picture Naming'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 text-center"},this.state.loadedScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProgressModalComponent_ProgressBox__["a" /* default */],{appName:"picturenaming",speed:true,level:this.state.bestScores.pnLevel,step:this.state.bestScores.pnScore,steps:3,maxLevel:3,noDescription:true}):null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"picturenaming",pnManual:true,buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{demo:true,appName:"picturenaming",pnManual:true,buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer picturenaming'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center"}},'Picture Naming: Show Me'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["g" /* VideoComponent */],{url:"https://s3.us-east-2.amazonaws.com/uploaddev/video/picturenaming/PN-revised.mp4"}))))))):null,this.state.active===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{practice:true,appName:"picturenaming",pnManual:true,buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tutorial,{studentUser:this.props.studentUser,buttonClick:this.handleActive,beginTest:this.handleBeginTest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"picturenaming",pnManual:true,buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{recordedSession:this.state.modalActive,appName:"picturenaming",pnManual:true,buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PictureNaming,{studentUser:this.props.studentUser,buttonClick:this.handleActive,backBtn:this.handleModalBack,pnSwitch:this.state.audioVideoSwitch}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"picturenaming",pnManual:true,buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===4?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{appName:"picturenaming",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__PN1On1Student__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"picturenaming",pnManual:true,buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===5?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{appName:"picturenaming",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PNChoseOption,{switchCheck:this.handleSwitch,checkClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"picturenaming",pnManual:true,buttonClick:this.handleActive,currentTabActive:this.state.active})):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this3.setState({modalDialog:active});}}));}}]);return PictureNamingComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var PictureNaming=function(_Component2){_inherits(PictureNaming,_Component2);function PictureNaming(props){var _this5=this;_classCallCheck(this,PictureNaming);var _this4=_possibleConstructorReturn(this,(PictureNaming.__proto__||Object.getPrototypeOf(PictureNaming)).call(this,props));_this4.handleToggleInstruction=function(toggleInstruction){localStorage.setItem('PNInstruction',toggleInstruction);};_this4.captureUserMedia=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(callback,options){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(params){_context4.next=4;break;}_context4.next=3;return _this4.getMediaParam(options);case 3:params=_context4.sent;case 4:navigator.mediaDevices.getUserMedia(params).then(callback).catch(function(error){console.log(error);_this4.setState({modalDialog:true,responseContent:error});});case 5:case'end':return _context4.stop();}}},_callee4,_this5);}));return function(_x3,_x4){return _ref4.apply(this,arguments);};}();_this4.rotatePictures=function(pictures){var i=0;var time=_this4.state.timeInterval;_this4.setState({countdown:time});var countDownTimer=Object(__WEBPACK_IMPORTED_MODULE_23_timers__["setInterval"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return _this4.setState({countdown:_this4.state.countdown-1});case 2:if(_this4.state.countdown<0){Object(__WEBPACK_IMPORTED_MODULE_23_timers__["clearInterval"])(countDownTimer);}if(!(_this4.state.countdown===0)){_context5.next=7;break;}_context5.next=6;return _this4.setState({isCounting:false});case 6:_this4.startRecord();case 7:case'end':return _context5.stop();}}},_callee5,_this5);})),1000);var timer=Object(__WEBPACK_IMPORTED_MODULE_23_timers__["setInterval"])(function(){if(i===pictures.length){_this4.setState({imageSrc:"",imageIndex:-1});_this4.stopRecord();Object(__WEBPACK_IMPORTED_MODULE_23_timers__["clearInterval"])(timer);}else{var pic=pictures[i];_this4.setState({imageSrc:pic.url,imageIndex:i});i++;}},1000*time);_this4.setState({countDownTimer:countDownTimer,rotateTimer:timer});};_this4.handleStartPictureNaming=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return _this4.setState({instructionVisible:false,isCounting:true});case 2:if(_this4.props.practice){_context7.next=7;break;}_this4.props.backBtn(false);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].listRandomPNPictures().then(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(res){var pnPictures,bestScores,newSesh,timeInterval;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:pnPictures=res.body;_context6.next=3;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores();case 3:bestScores=_context6.sent;newSesh=_this4.state.sessionData;newSesh.startLevel=bestScores.body.pnLevel;newSesh.startProgress=bestScores.body.pnScore;timeInterval=_this4.determineTimeInterval(bestScores.body);pnPictures=pnPictures.slice(0,60/timeInterval);newSesh.pnPictures=pnPictures;_context6.next=12;return _this4.setState({bestScores:bestScores.body,timeInterval:timeInterval,sessionData:newSesh});case 12:_this4.rotatePictures(pnPictures);case 13:case'end':return _context6.stop();}}},_callee6,_this5);}));return function(_x5){return _ref7.apply(this,arguments);};}()).catch(function(error){});_context7.next=22;break;case 7:if(!((typeof newSes==='undefined'?'undefined':_typeof(newSes))!=='object'&&newSes!==null)){_context7.next=11;break;}_context7.next=10;return JSON.parse(newSes);case 10:newSes=_context7.sent;case 11:if(!((typeof bestScor==='undefined'?'undefined':_typeof(bestScor))!=='object'&&bestScor!==null)){_context7.next=15;break;}_context7.next=14;return JSON.parse(bestScor);case 14:bestScor=_context7.sent;case 15:if(!((typeof testPN==='undefined'?'undefined':_typeof(testPN))!=='object'&&testPN!==null)){_context7.next=19;break;}_context7.next=18;return JSON.parse(testPN);case 18:testPN=_context7.sent;case 19:_context7.next=21;return _this4.setState({bestScores:bestScor.body,timeInterval:3,sessionData:newSes});case 21:_this4.rotatePictures(testPN);case 22:case'end':return _context7.stop();}}},_callee7,_this5);}));_this4.state={showVideo:true,isUploading:false,timeInterval:3,isCounting:false,countdown:-1,countDownTimer:null,rotateTimer:null,bestScores:null,recordVideo:null,rejectedReason:'',recording:false,imageSrc:"",imageIndex:-1,videoSrc:false,audioSrc:false,audioBlob:false,recordAudio:null,audioVideoSwitch:_this4.props.pnSwitch,instructionVisible:true,modalDialog:false,modalInstruction:false,responseContent:'',recordedSession:false,upTime:null,analytics:{type:null,metadata:null},sessionData:{AV_FileName:"",startLevel:0,endLevel:0,pnPictures:[],assessmentType:0,startProgress:0,endProgress:0,guid:__webpack_require__(68)()}};_this4.timer=0;_this4.handleStartPictureNaming=_this4.handleStartPictureNaming.bind(_this4);_this4.handleShowVideo=_this4.handleShowVideo.bind(_this4);_this4.handleStart=_this4.handleStart.bind(_this4);_this4.handleStop=_this4.handleStop.bind(_this4);_this4.setStreamToVideo=_this4.setStreamToVideo.bind(_this4);_this4.releaseStreamFromVideo=_this4.releaseStreamFromVideo.bind(_this4);_this4.uploadVideo=_this4.uploadVideo.bind(_this4);_this4.requestUserMedia=_this4.requestUserMedia.bind(_this4);_this4.startRecord=_this4.startRecord.bind(_this4);_this4.stopRecord=_this4.stopRecord.bind(_this4);_this4.handleBackToMenu=_this4.handleBackToMenu.bind(_this4);_this4.toggleAudioVideo=_this4.toggleAudioVideo.bind(_this4);_this4.onUnload=_this4.onUnload.bind(_this4);_this4.handleToggleInstruction=_this4.handleToggleInstruction.bind(_this4);_this4.handleCloseModal=_this4.handleCloseModal.bind(_this4);_this4.startTimer=_this4.startTimer.bind(_this4);_this4.countDown=_this4.countDown.bind(_this4);_this4.handleAnalytics=_this4.handleAnalytics.bind(_this4);return _this4;}_createClass(PictureNaming,[{key:'onUnload',value:function onUnload(event){// the method that will be used for both add and remove event
event.returnValue="By leaving or reloading the page you will lose your app progress";}},{key:'componentDidMount',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:window.addEventListener("beforeunload",this.onUnload);if(!/firefox/i.test(navigator.userAgent)){_context8.next=4;break;}this.setState({modalDialog:true,responseContent:'Please use Safari or Chrome browser for this task'});return _context8.abrupt('return');case 4:if(hasGetUserMedia){_context8.next=7;break;}this.setState({modalDialog:true,responseContent:!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform)&&(navigator.userAgent.match('CriOS')||navigator.userAgent.match('Mozilla'))?'Please use Safari (above version 11) for this task':'Your browser cannot stream from your webcam. Please switch to Chrome.'});return _context8.abrupt('return');case 7:this.requestUserMedia();_context8.next=10;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_26__Shared_DataTrackingPoints__["b" /* default */].STUDENT_PN_START,metadata:{platform:navigator.platform,userAgent:navigator.userAgent}}});case 10:console.log(this.state.device);console.log(this.state.orientation);console.log(navigator.platform);console.log(navigator.platform.includes('Linux'));this.handleAnalytics();case 15:case'end':return _context8.stop();}}},_callee8,this);}));function componentDidMount(){return _ref8.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("beforeunload",this.onUnload);if(this.state.recording){if(this.state.audioVideoSwitch==="video"){this.state.recordVideo.stop(function(res){});}else{this.state.recordAudio.stop(function(res){});}Object(__WEBPACK_IMPORTED_MODULE_23_timers__["clearInterval"])(this.state.countDownTimer);Object(__WEBPACK_IMPORTED_MODULE_23_timers__["clearInterval"])(this.state.rotateTimer);this.captureUserMedia(function(stream){stream.stop();});}if(this.video&&this.video.srcObject){this.video.srcObject.stop();}}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleShowVideo',value:function handleShowVideo(){this.setState({showVideo:!this.state.showVideo});}},{key:'handleCloseModal',value:function handleCloseModal(active){window.removeEventListener("beforeunload",this.onUnload);this.setState({modalDialog:active});window.location.reload();// this.props.buttonClick(0);
}},{key:'handleBackToMenu',value:function handleBackToMenu(e){this.props.history.goBack();}},{key:'requestUserMedia',value:function requestUserMedia(){var _this6=this;this.captureUserMedia(function(stream){_this6.setStreamToVideo(stream);});}},{key:'handleStart',value:function handleStart(stream){this.setState({recording:true});this.setStreamToVideo(stream);}},{key:'handleStop',value:function handleStop(blob){this.setState({recording:false});if(this.state.audioVideoSwitch==="video"){this.releaseStreamFromVideo();}else{this.releaseStreamFromAudio();}this.uploadVideo(blob instanceof Blob,blob);}},{key:'setStreamToVideo',value:function setStreamToVideo(stream){this.video.srcObject=stream;}},{key:'releaseStreamFromVideo',value:function releaseStreamFromVideo(){this.video.srcObject=null;}},{key:'encodeMono',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(channels,sampleRate,samples){var kbps,mp3encoder,sampleBlockSize,mp3Data,i,sampleChunk,_mp3buf,mp3buf,blob;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:kbps=256;//encode 128kbps mp3
mp3encoder=new __WEBPACK_IMPORTED_MODULE_9_lamejs___default.a.Mp3Encoder(channels,sampleRate,kbps);sampleBlockSize=1152;//can be anything but make it a multiple of 576 to make encoders life easier
mp3Data=[];for(i=0;i<samples.length;i+=sampleBlockSize){sampleChunk=samples.subarray(i,i+sampleBlockSize);_mp3buf=mp3encoder.encodeBuffer(sampleChunk);if(_mp3buf.length>0){mp3Data.push(_mp3buf);}}mp3buf=mp3encoder.flush();//finish writing mp3
if(mp3buf.length>0){mp3Data.push(new Int8Array(mp3buf));}blob=new Blob(mp3Data,{type:'audio/mp3'});_context9.next=10;return this.setState({audioBlob:blob});case 10:this.handleStop(blob);case 11:case'end':return _context9.stop();}}},_callee9,this);}));function encodeMono(_x6,_x7,_x8){return _ref9.apply(this,arguments);}return encodeMono;}()},{key:'setStreamToAudio',value:function setStreamToAudio(stream){this.audio.srcObject=stream;}},{key:'releaseStreamFromAudio',value:function releaseStreamFromAudio(){this.audio.pause();this.audio.srcObject=null;this.audio.src="";this.audio.load();}},{key:'startRecordAudio',value:function startRecordAudio(){var _this7=this;this.captureUserMedia(function(stream){var options={type:'audio',audio:_this7.audio,sampleRate:44100,bufferSize:4096,numberOfAudioChannels:1,recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder};_this7.setState({recordAudio:new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder(stream,options)});_this7.state.recordAudio.record();_this7.handleStartAudio(stream);},{audio:true,video:false});}},{key:'handleStopAudio',value:function handleStopAudio(wavBlob){var _this8=this;this.setState({recording:false});var fileReader=new FileReader();fileReader.onload=function(event){var arrayBuffer=event.target.result;var wav=__WEBPACK_IMPORTED_MODULE_9_lamejs___default.a.WavHeader.readHeader(new DataView(arrayBuffer));var samples=new Int16Array(arrayBuffer,wav.dataOffset,wav.dataLen/2);_this8.encodeMono(wav.channels,wav.sampleRate,samples);_this8.releaseStreamFromAudio();};fileReader.readAsArrayBuffer(wavBlob);}},{key:'handleStartAudio',value:function handleStartAudio(stream){this.setState({recording:true});this.setStreamToAudio(stream);}},{key:'stopRecordAudio',value:function stopRecordAudio(){var _this9=this;this.state.recordAudio.stop(function(wavBlob){_this9.handleStopAudio(wavBlob);});}},{key:'getMediaParam',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(options){var userAgent;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return navigator.userAgent;case 2:userAgent=_context10.sent;if(!options){_context10.next=7;break;}params=options;_context10.next=15;break;case 7:if(!(/Chrome/i.test(userAgent)&&/Windows/i.test(userAgent))){_context10.next=11;break;}params={audio:true,video:true};_context10.next=15;break;case 11:_context10.next=13;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].getVideoSizes();case 13:_context10.t0=_context10.sent;params={audio:true,video:_context10.t0};case 15:return _context10.abrupt('return',params);case 16:case'end':return _context10.stop();}}},_callee10,this);}));function getMediaParam(_x9){return _ref10.apply(this,arguments);}return getMediaParam;}()},{key:'uploadVideo',value:function uploadVideo(isBlob,blob){var _this10=this;console.log('start to upload');__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].uploadPNVideo(isBlob,blob).then(function(res){if(_this10.state.audioVideoSwitch==="video"){_this10.video.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_this10.setState({videoSrc:_this10.video.src});}else{_this10.audio2.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_this10.audio2.load();_this10.audio2.play();}var seshData=_this10.state.sessionData;seshData.AV_FileName=res.body.filepath;_this10.setState({isUploading:false,recordedSession:true});if(!_this10.props.practice){window.removeEventListener("beforeunload",_this10.onUnload);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].insertPNSession(seshData).then(function(res){_this10.setState({modalDialog:true,responseContent:'Video saved'});setTimeout(function(){_this10.setState({modalDialog:false});},2500);});}window.removeEventListener("beforeunload",_this10.onUnload);return false;}).catch(function(error){console.log(error);_this10.setState({modalDialog:true,responseContent:'Failed to save video.'});});}},{key:'determineTimeInterval',value:function determineTimeInterval(bestScores){if(bestScores.pnLevel===1){return 5;}else if(bestScores.pnLevel===2){return 4;}else if(bestScores.pnLevel===3){return 3;}}},{key:'noWebM',value:function noWebM(){return __WEBPACK_IMPORTED_MODULE_21_react_device_detect__["isIOS"]||__WEBPACK_IMPORTED_MODULE_21_react_device_detect__["isSafari"];}},{key:'startRecordVideo',value:function startRecordVideo(){var _this11=this;this.captureUserMedia(function(stream){var audio_options={type:'audio',audio:_this11.audio,sampleRate:44100,bufferSize:4096,numberOfAudioChannels:1,recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder};var video_options=void 0;var videoRecorderClass=void 0;if(_this11.noWebM()){video_options={type:'video',recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.WhammyRecorder,frameInterval:50,video:_this11.video,width:320,height:240};videoRecorderClass=new __WEBPACK_IMPORTED_MODULE_7__Shared_SafariWorker__["a" /* default */]().WhammyRecorder(stream,video_options);}else{video_options={mimeType:'video/webm',recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.MediaStreamRecorder,width:320,height:240};videoRecorderClass=new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.MediaStreamRecorder(stream,video_options);}_this11.setState({recordAudio:new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder(stream,audio_options),recordVideo:videoRecorderClass},function(){if(_this11.noWebM()){_this11.state.recordVideo.record(_this11.state.recordAudio.record());}else{_this11.state.recordVideo.record();}_this11.handleStart(stream);});},{audio:true,video:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].getVideoSizes()});}},{key:'handleStopWrapper',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(vidResult,wavBlob){var _this12=this;var vidETA;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:this.setState({recording:false});if(this.props.practice){_context11.next=13;break;}if(this.state.audioVideoSwitch==="video"){this.releaseStreamFromVideo();if(this.noWebM()){this.releaseStreamFromAudio();}}_context11.next=5;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].calculateETA(vidResult,wavBlob);case 5:vidETA=_context11.sent;this.setState({upTime:vidETA});_context11.next=9;return this.startTimer();case 9:_context11.next=11;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].uploadPNVideo(true,vidResult,wavBlob).then(function(res){if(_this12.state.audioVideoSwitch==="video"){_this12.video.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_this12.setState({videoSrc:_this12.video.src});}var seshData=_this12.state.sessionData;seshData.AV_FileName=res.body.filepath;_this12.setState({isUploading:false,recordedSession:true});if(!_this12.props.practice){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].insertPNSession(seshData).then(function(res){_this12.setState({modalDialog:true,responseContent:'Video saved'});});}}).catch(function(error){});case 11:_context11.next=14;break;case 13:this.setState({modalDialog:true,responseContent:'Practice Finished'});case 14:case'end':return _context11.stop();}}},_callee11,this);}));function handleStopWrapper(_x10,_x11){return _ref11.apply(this,arguments);}return handleStopWrapper;}()},{key:'stopRecordVideo',value:function stopRecordVideo(){var _this13=this;if(this.noWebM()){var promise1=function promise1(){return new Promise(function(resolve,reject){_this13.state.recordAudio.stop(function(wavBlob){resolve(wavBlob);});});};var promise2=function promise2(){return new Promise(function(resolve,reject){_this13.state.recordVideo.stop(function(result){resolve(result);});});};Promise.all([promise1(),promise2()]).then(function(values){if(values[0]instanceof Array){_this13.handleStopWrapper(values[0],values[1]);}else{_this13.handleStopWrapper(values[1],values[0]);}});}else{this.state.recordVideo.stop(function(result){_this13.handleStopWrapper([],result);});}}},{key:'stopRecord',value:function stopRecord(){if(this.state.audioVideoSwitch==="video"){this.stopRecordVideo();}else{this.stopRecordAudio();}this.setState({recording:false,isUploading:true,recordedSession:true});if(!this.props.practice){this.props.backBtn(this.state.recordedSession);}}},{key:'startRecord',value:function startRecord(){if(this.state.audioVideoSwitch==="video"){this.startRecordVideo();}else{this.startRecordAudio();}this.setState({recording:true});}},{key:'toggleAudioVideo',value:function toggleAudioVideo(){if(this.state.audioVideoSwitch==="video"){this.setState({audioVideoSwitch:"audio"});this.releaseStreamFromVideo();}else{this.setState({audioVideoSwitch:"video"});this.releaseStreamFromAudio();this.requestUserMedia();}}},{key:'startTimer',value:function startTimer(){this.timer=Object(__WEBPACK_IMPORTED_MODULE_23_timers__["setInterval"])(this.countDown,1000);}},{key:'countDown',value:function countDown(){var seconds=this.state.upTime-1;this.setState({upTime:seconds});if(seconds<=0){Object(__WEBPACK_IMPORTED_MODULE_23_timers__["clearInterval"])(this.timer);}}},{key:'render',value:function render(){var _this14=this;var imageNumerical=this.state.sessionData.pnPictures.map(function(pnPic,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:index,className:index<=_this14.state.imageIndex?"item_done":""},(index+1).toString());});var countDown=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.imageIndex>-1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:"fontCountdown",hidden:this.state.countdown<=0},this.state.countdown),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.audioVideoSwitch==="audio",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{hidden:!this.state.instructionVisible,src:__WEBPACK_IMPORTED_MODULE_18__assets_images_video_instructions_png___default.a,alt:"Align your body in center of the outline shown in video",style:{marginTop:'15%'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.audioVideoSwitch==="video",style:{position:'relative'}}));var imagesSlideshow=this.state.sessionData.pnPictures.map(function(pnPic,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{maxWidth:'80%',marginTop:50},key:index,hidden:_this14.state.imageIndex!==index,src:pnPic.url,alt:'PNPicture'});});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.practice?"appSection bgGrey":"appSection bgYellow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},!this.props.practice?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Shared_InstructionModals__["a" /* default */],{PN:true,modalOpen:this.state.modalInstruction,instructionMask:__WEBPACK_IMPORTED_MODULE_18__assets_images_video_instructions_png___default.a,toggleInstruction:this.handleToggleInstruction,closeClick:function closeClick(active){_this14.setState({modalInstruction:active});}}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:this.handleCloseModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer picturenaming'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-sm-6 col-md-6'},countDown,imagesSlideshow,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{hidden:this.state.isUploading||this.state.recordedSession,className:'list_items'},imageNumerical)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-sm-6 col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.audioVideoSwitch==="video",style:{paddingTop:"35%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{ref:function ref(audio){_this14.audio=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{controls:true,ref:function ref(audio2){_this14.audio2=audio2;}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.audioVideoSwitch==="audio",style:this.state.showVideo?{position:'relative'}:{position:'relative',display:'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.isUploading||this.state.recording||this.state.recordedSession,style:{position:'absolute',margin:'auto',zIndex:1,top:65,left:0,bottom:0,right:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_images_video_mask_png___default.a,alt:"Outline to Align Yourself in Video",style:{minWidth:200,width:'70%'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"PictureNamingVidPlay",hidden:this.state.recordedSession,playsInline:true,ref:function ref(video){_this14.video=video;},style:{position:'relative',top:65},width:'100%',autoPlay:true,controls:!this.state.recording&&this.state.videoSrc&&this.state.videoSrc!=="",className:this.state.recording||!this.state.videoSrc||this.state.videoSrc===""?"flippedVideo":"",muted:this.state.recording||!this.state.videoSrc||this.state.recordedSession?"muted":""}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:720,marginTop:450}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",width:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',defaultChecked:true,onChange:this.handleShowVideo,id:'checkHideDeleted',className:'form-control'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",marginTop:9,marginLeft:10}},'Show my video'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},!this.state.recording&&!this.state.isUploading&&!this.state.isCounting?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block text-center"},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.recordedSession?"hidden":"handBtn",onClick:this.handleStartPictureNaming},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Start')),' '):null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LoadingModalComponent_LoadingModal__["a" /* default */],{upTime:this.state.upTime,timer:true,isUploading:this.state.isUploading}));}}]);return PictureNaming;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Tutorial=function(_Component3){_inherits(Tutorial,_Component3);function Tutorial(props){_classCallCheck(this,Tutorial);return _possibleConstructorReturn(this,(Tutorial.__proto__||Object.getPrototypeOf(Tutorial)).call(this,props));}_createClass(Tutorial,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PictureNaming,{studentUser:this.props.studentUser,buttonClick:this.props.buttonClick,pnSwitch:"video",practice:true});}}]);return Tutorial;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var PNChoseOption=function(_Component4){_inherits(PNChoseOption,_Component4);function PNChoseOption(props){_classCallCheck(this,PNChoseOption);var _this16=_possibleConstructorReturn(this,(PNChoseOption.__proto__||Object.getPrototypeOf(PNChoseOption)).call(this,props));_this16.state={mode:1,currentActive:_this16.props.currentTabActive};_this16.handleStartTask=_this16.handleStartTask.bind(_this16);_this16.handleStartTaskAudio=_this16.handleStartTaskAudio.bind(_this16);_this16.handleStartTaskManual=_this16.handleStartTaskManual.bind(_this16);return _this16;}_createClass(PNChoseOption,[{key:'handleStartTask',value:function handleStartTask(event){this.props.checkClick(3);this.props.switchCheck('video');this.setState({mode:3});}},{key:'handleStartTaskAudio',value:function handleStartTaskAudio(event){this.props.checkClick(3);this.props.switchCheck('audio');this.setState({mode:3});}},{key:'handleStartTaskManual',value:function handleStartTaskManual(event){this.props.checkClick(4);this.setState({mode:4});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:' appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer progressBox1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:42}},'Picture Naming'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'tasktype'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleStartTask},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15__assets_images_ico_video_png___default.a,className:'ico-lg'}),'Video Recording Task')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{onClick:this.handleStartTaskManual},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_ico_person_png___default.a,className:'ico-lg'}),'1-1 computer Tasks',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' \xA0 (with Teacher)'))))));}}]);return PNChoseOption;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context12.abrupt('return',_context12.sent);case 3:case'end':return _context12.stop();}}},_callee12,_this17);}));function updateStudentAppStatus(_x12){return _ref12.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context13.abrupt('return',_context13.sent);case 3:case'end':return _context13.stop();}}},_callee13,_this17);}));function updateStudentAccountTab(_x13){return _ref13.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__actions__["a" /* updateAppStates */])(appStates));case 2:return _context14.abrupt('return',_context14.sent);case 3:case'end':return _context14.stop();}}},_callee14,_this17);}));function updateAppStates(_x14){return _ref14.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_25_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(PictureNamingComponent)));

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var d;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '0.1.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return base64;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.base64 = base64;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(190)(module), __webpack_require__(25)))

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var new_short_n = common.new_short_n;
var assert = common.assert;

var PsyModel = __webpack_require__(804);
var LameGlobalFlags = __webpack_require__(808);
var LameInternalFlags = __webpack_require__(148);
var ATH = __webpack_require__(812);
var ReplayGain = __webpack_require__(813);
var CBRNewIterationLoop = __webpack_require__(814);
var BitStream = __webpack_require__(367);
var Tables = __webpack_require__(205);
var Encoder = __webpack_require__(35);

function Lame() {
    var self = this;
    var LAME_MAXALBUMART = (128 * 1024);

    Lame.V9 = 410;
    Lame.V8 = 420;
    Lame.V7 = 430;
    Lame.V6 = 440;
    Lame.V5 = 450;
    Lame.V4 = 460;
    Lame.V3 = 470;
    Lame.V2 = 480;
    Lame.V1 = 490;
    Lame.V0 = 500;

    /* still there for compatibility */

    Lame.R3MIX = 1000;
    Lame.STANDARD = 1001;
    Lame.EXTREME = 1002;
    Lame.INSANE = 1003;
    Lame.STANDARD_FAST = 1004;
    Lame.EXTREME_FAST = 1005;
    Lame.MEDIUM = 1006;
    Lame.MEDIUM_FAST = 1007;

    /**
     * maximum size of mp3buffer needed if you encode at most 1152 samples for
     * each call to lame_encode_buffer. see lame_encode_buffer() below
     * (LAME_MAXMP3BUFFER is now obsolete)
     */
    var LAME_MAXMP3BUFFER = (16384 + LAME_MAXALBUMART);
    Lame.LAME_MAXMP3BUFFER = LAME_MAXMP3BUFFER;

    var ga;
    var bs;
    var p;
    var qupvt;
    var qu;
    var psy = new PsyModel();
    var vbr;
    var ver;
    var id3;
    var mpglib;
    this.enc = new Encoder();

    this.setModules = function (_ga, _bs, _p, _qupvt, _qu, _vbr, _ver, _id3, _mpglib) {
        ga = _ga;
        bs = _bs;
        p = _p;
        qupvt = _qupvt;
        qu = _qu;
        vbr = _vbr;
        ver = _ver;
        id3 = _id3;
        mpglib = _mpglib;
        this.enc.setModules(bs, psy, qupvt, vbr);
    }

    /**
     * PSY Model related stuff
     */
    function PSY() {
        /**
         * The dbQ stuff.
         */
        this.mask_adjust = 0.;
        /**
         * The dbQ stuff.
         */
        this.mask_adjust_short = 0.;
        /* at transition from one scalefactor band to next */
        /**
         * Band weight long scalefactor bands.
         */
        this.bo_l_weight = new_float(Encoder.SBMAX_l);
        /**
         * Band weight short scalefactor bands.
         */
        this.bo_s_weight = new_float(Encoder.SBMAX_s);
    }

    function LowPassHighPass() {
        this.lowerlimit = 0.;
    }

    function BandPass(bitrate, lPass) {
        this.lowpass = lPass;
    }

    var LAME_ID = 0xFFF88E3B;

    function lame_init_old(gfp) {
        var gfc;

        gfp.class_id = LAME_ID;

        gfc = gfp.internal_flags = new LameInternalFlags();

        /* Global flags. set defaults here for non-zero values */
        /* see lame.h for description */
        /*
         * set integer values to -1 to mean that LAME will compute the best
         * value, UNLESS the calling program as set it (and the value is no
         * longer -1)
         */

        gfp.mode = MPEGMode.NOT_SET;
        gfp.original = 1;
        gfp.in_samplerate = 44100;
        gfp.num_channels = 2;
        gfp.num_samples = -1;

        gfp.bWriteVbrTag = true;
        gfp.quality = -1;
        gfp.short_blocks = null;
        gfc.subblock_gain = -1;

        gfp.lowpassfreq = 0;
        gfp.highpassfreq = 0;
        gfp.lowpasswidth = -1;
        gfp.highpasswidth = -1;

        gfp.VBR = VbrMode.vbr_off;
        gfp.VBR_q = 4;
        gfp.ATHcurve = -1;
        gfp.VBR_mean_bitrate_kbps = 128;
        gfp.VBR_min_bitrate_kbps = 0;
        gfp.VBR_max_bitrate_kbps = 0;
        gfp.VBR_hard_min = 0;
        gfc.VBR_min_bitrate = 1;
        /* not 0 ????? */
        gfc.VBR_max_bitrate = 13;
        /* not 14 ????? */

        gfp.quant_comp = -1;
        gfp.quant_comp_short = -1;

        gfp.msfix = -1;

        gfc.resample_ratio = 1;

        gfc.OldValue[0] = 180;
        gfc.OldValue[1] = 180;
        gfc.CurrentStep[0] = 4;
        gfc.CurrentStep[1] = 4;
        gfc.masking_lower = 1;
        gfc.nsPsy.attackthre = -1;
        gfc.nsPsy.attackthre_s = -1;

        gfp.scale = -1;

        gfp.athaa_type = -1;
        gfp.ATHtype = -1;
        /* default = -1 = set in lame_init_params */
        gfp.athaa_loudapprox = -1;
        /* 1 = flat loudness approx. (total energy) */
        /* 2 = equal loudness curve */
        gfp.athaa_sensitivity = 0.0;
        /* no offset */
        gfp.useTemporal = null;
        gfp.interChRatio = -1;

        /*
         * The reason for int mf_samples_to_encode = ENCDELAY + POSTDELAY;
         * ENCDELAY = internal encoder delay. And then we have to add
         * POSTDELAY=288 because of the 50% MDCT overlap. A 576 MDCT granule
         * decodes to 1152 samples. To synthesize the 576 samples centered under
         * this granule we need the previous granule for the first 288 samples
         * (no problem), and the next granule for the next 288 samples (not
         * possible if this is last granule). So we need to pad with 288 samples
         * to make sure we can encode the 576 samples we are interested in.
         */
        gfc.mf_samples_to_encode = Encoder.ENCDELAY + Encoder.POSTDELAY;
        gfp.encoder_padding = 0;
        gfc.mf_size = Encoder.ENCDELAY - Encoder.MDCTDELAY;
        /*
         * we pad input with this many 0's
         */

        gfp.findReplayGain = false;
        gfp.decode_on_the_fly = false;

        gfc.decode_on_the_fly = false;
        gfc.findReplayGain = false;
        gfc.findPeakSample = false;

        gfc.RadioGain = 0;
        gfc.AudiophileGain = 0;
        gfc.noclipGainChange = 0;
        gfc.noclipScale = -1.0;

        gfp.preset = 0;

        gfp.write_id3tag_automatic = true;
        return 0;
    }

    this.lame_init = function () {
        var gfp = new LameGlobalFlags();

        var ret = lame_init_old(gfp);
        if (ret != 0) {
            return null;
        }

        gfp.lame_allocated_gfp = 1;
        return gfp;
    }

    function filter_coef(x) {
        if (x > 1.0)
            return 0.0;
        if (x <= 0.0)
            return 1.0;

        return Math.cos(Math.PI / 2 * x);
    }

    this.nearestBitrateFullIndex = function (bitrate) {
        /* borrowed from DM abr presets */

        var full_bitrate_table = [8, 16, 24, 32, 40, 48, 56, 64, 80,
            96, 112, 128, 160, 192, 224, 256, 320];

        var lower_range = 0, lower_range_kbps = 0, upper_range = 0, upper_range_kbps = 0;

        /* We assume specified bitrate will be 320kbps */
        upper_range_kbps = full_bitrate_table[16];
        upper_range = 16;
        lower_range_kbps = full_bitrate_table[16];
        lower_range = 16;

        /*
         * Determine which significant bitrates the value specified falls
         * between, if loop ends without breaking then we were correct above
         * that the value was 320
         */
        for (var b = 0; b < 16; b++) {
            if ((Math.max(bitrate, full_bitrate_table[b + 1])) != bitrate) {
                upper_range_kbps = full_bitrate_table[b + 1];
                upper_range = b + 1;
                lower_range_kbps = full_bitrate_table[b];
                lower_range = (b);
                break;
                /* We found upper range */
            }
        }

        /* Determine which range the value specified is closer to */
        if ((upper_range_kbps - bitrate) > (bitrate - lower_range_kbps)) {
            return lower_range;
        }
        return upper_range;
    }

    function optimum_samplefreq(lowpassfreq, input_samplefreq) {
        /*
         * Rules:
         *
         * - if possible, sfb21 should NOT be used
         */
        var suggested_samplefreq = 44100;

        if (input_samplefreq >= 48000)
            suggested_samplefreq = 48000;
        else if (input_samplefreq >= 44100)
            suggested_samplefreq = 44100;
        else if (input_samplefreq >= 32000)
            suggested_samplefreq = 32000;
        else if (input_samplefreq >= 24000)
            suggested_samplefreq = 24000;
        else if (input_samplefreq >= 22050)
            suggested_samplefreq = 22050;
        else if (input_samplefreq >= 16000)
            suggested_samplefreq = 16000;
        else if (input_samplefreq >= 12000)
            suggested_samplefreq = 12000;
        else if (input_samplefreq >= 11025)
            suggested_samplefreq = 11025;
        else if (input_samplefreq >= 8000)
            suggested_samplefreq = 8000;

        if (lowpassfreq == -1)
            return suggested_samplefreq;

        if (lowpassfreq <= 15960)
            suggested_samplefreq = 44100;
        if (lowpassfreq <= 15250)
            suggested_samplefreq = 32000;
        if (lowpassfreq <= 11220)
            suggested_samplefreq = 24000;
        if (lowpassfreq <= 9970)
            suggested_samplefreq = 22050;
        if (lowpassfreq <= 7230)
            suggested_samplefreq = 16000;
        if (lowpassfreq <= 5420)
            suggested_samplefreq = 12000;
        if (lowpassfreq <= 4510)
            suggested_samplefreq = 11025;
        if (lowpassfreq <= 3970)
            suggested_samplefreq = 8000;

        if (input_samplefreq < suggested_samplefreq) {
            /*
             * choose a valid MPEG sample frequency above the input sample
             * frequency to avoid SFB21/12 bitrate bloat rh 061115
             */
            if (input_samplefreq > 44100) {
                return 48000;
            }
            if (input_samplefreq > 32000) {
                return 44100;
            }
            if (input_samplefreq > 24000) {
                return 32000;
            }
            if (input_samplefreq > 22050) {
                return 24000;
            }
            if (input_samplefreq > 16000) {
                return 22050;
            }
            if (input_samplefreq > 12000) {
                return 16000;
            }
            if (input_samplefreq > 11025) {
                return 12000;
            }
            if (input_samplefreq > 8000) {
                return 11025;
            }
            return 8000;
        }
        return suggested_samplefreq;
    }

    /**
     * convert samp freq in Hz to index
     */
    function SmpFrqIndex(sample_freq, gpf) {
        switch (sample_freq) {
            case 44100:
                gpf.version = 1;
                return 0;
            case 48000:
                gpf.version = 1;
                return 1;
            case 32000:
                gpf.version = 1;
                return 2;
            case 22050:
                gpf.version = 0;
                return 0;
            case 24000:
                gpf.version = 0;
                return 1;
            case 16000:
                gpf.version = 0;
                return 2;
            case 11025:
                gpf.version = 0;
                return 0;
            case 12000:
                gpf.version = 0;
                return 1;
            case 8000:
                gpf.version = 0;
                return 2;
            default:
                gpf.version = 0;
                return -1;
        }
    }

    /**
     * @param bRate
     *            legal rates from 8 to 320
     */
    function FindNearestBitrate(bRate, version, samplerate) {
        /* MPEG-1 or MPEG-2 LSF */
        if (samplerate < 16000)
            version = 2;

        var bitrate = Tables.bitrate_table[version][1];

        for (var i = 2; i <= 14; i++) {
            if (Tables.bitrate_table[version][i] > 0) {
                if (Math.abs(Tables.bitrate_table[version][i] - bRate) < Math
                        .abs(bitrate - bRate))
                    bitrate = Tables.bitrate_table[version][i];
            }
        }
        return bitrate;
    }

    /**
     * @param bRate
     *            legal rates from 32 to 448 kbps
     * @param version
     *            MPEG-1 or MPEG-2/2.5 LSF
     */
    function BitrateIndex(bRate, version, samplerate) {
        /* convert bitrate in kbps to index */
        if (samplerate < 16000)
            version = 2;
        for (var i = 0; i <= 14; i++) {
            if (Tables.bitrate_table[version][i] > 0) {
                if (Tables.bitrate_table[version][i] == bRate) {
                    return i;
                }
            }
        }
        return -1;
    }

    function optimum_bandwidth(lh, bitrate) {
        /**
         * <PRE>
         *  Input:
         *      bitrate     total bitrate in kbps
         *
         *   Output:
         *      lowerlimit: best lowpass frequency limit for input filter in Hz
         *      upperlimit: best highpass frequency limit for input filter in Hz
         * </PRE>
         */
        var freq_map = [new BandPass(8, 2000),
            new BandPass(16, 3700), new BandPass(24, 3900),
            new BandPass(32, 5500), new BandPass(40, 7000),
            new BandPass(48, 7500), new BandPass(56, 10000),
            new BandPass(64, 11000), new BandPass(80, 13500),
            new BandPass(96, 15100), new BandPass(112, 15600),
            new BandPass(128, 17000), new BandPass(160, 17500),
            new BandPass(192, 18600), new BandPass(224, 19400),
            new BandPass(256, 19700), new BandPass(320, 20500)];

        var table_index = self.nearestBitrateFullIndex(bitrate);
        lh.lowerlimit = freq_map[table_index].lowpass;
    }

    function lame_init_params_ppflt(gfp) {
        var gfc = gfp.internal_flags;
        /***************************************************************/
        /* compute info needed for polyphase filter (filter type==0, default) */
        /***************************************************************/

        var lowpass_band = 32;
        var highpass_band = -1;

        if (gfc.lowpass1 > 0) {
            var minband = 999;
            for (var band = 0; band <= 31; band++) {
                var freq = (band / 31.0);
                /* this band and above will be zeroed: */
                if (freq >= gfc.lowpass2) {
                    lowpass_band = Math.min(lowpass_band, band);
                }
                if (gfc.lowpass1 < freq && freq < gfc.lowpass2) {
                    minband = Math.min(minband, band);
                }
            }

            /*
             * compute the *actual* transition band implemented by the polyphase
             * filter
             */
            if (minband == 999) {
                gfc.lowpass1 = (lowpass_band - .75) / 31.0;
            } else {
                gfc.lowpass1 = (minband - .75) / 31.0;
            }
            gfc.lowpass2 = lowpass_band / 31.0;
        }

        /*
         * make sure highpass filter is within 90% of what the effective
         * highpass frequency will be
         */
        if (gfc.highpass2 > 0) {
            if (gfc.highpass2 < .9 * (.75 / 31.0)) {
                gfc.highpass1 = 0;
                gfc.highpass2 = 0;
                System.err.println("Warning: highpass filter disabled.  "
                    + "highpass frequency too small\n");
            }
        }

        if (gfc.highpass2 > 0) {
            var maxband = -1;
            for (var band = 0; band <= 31; band++) {
                var freq = band / 31.0;
                /* this band and below will be zereod */
                if (freq <= gfc.highpass1) {
                    highpass_band = Math.max(highpass_band, band);
                }
                if (gfc.highpass1 < freq && freq < gfc.highpass2) {
                    maxband = Math.max(maxband, band);
                }
            }
            /*
             * compute the *actual* transition band implemented by the polyphase
             * filter
             */
            gfc.highpass1 = highpass_band / 31.0;
            if (maxband == -1) {
                gfc.highpass2 = (highpass_band + .75) / 31.0;
            } else {
                gfc.highpass2 = (maxband + .75) / 31.0;
            }
        }

        for (var band = 0; band < 32; band++) {
            var fc1, fc2;
            var freq = band / 31.0;
            if (gfc.highpass2 > gfc.highpass1) {
                fc1 = filter_coef((gfc.highpass2 - freq)
                    / (gfc.highpass2 - gfc.highpass1 + 1e-20));
            } else {
                fc1 = 1.0;
            }
            if (gfc.lowpass2 > gfc.lowpass1) {
                fc2 = filter_coef((freq - gfc.lowpass1)
                    / (gfc.lowpass2 - gfc.lowpass1 + 1e-20));
            } else {
                fc2 = 1.0;
            }
            gfc.amp_filter[band] = (fc1 * fc2);
        }
    }

    function lame_init_qval(gfp) {
        var gfc = gfp.internal_flags;

        switch (gfp.quality) {
            default:
            case 9: /* no psymodel, no noise shaping */
                gfc.psymodel = 0;
                gfc.noise_shaping = 0;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                gfc.use_best_huffman = 0;
                gfc.full_outer_loop = 0;
                break;

            case 8:
                gfp.quality = 7;
            //$FALL-THROUGH$
            case 7:
                /*
                 * use psymodel (for short block and m/s switching), but no noise
                 * shapping
                 */
                gfc.psymodel = 1;
                gfc.noise_shaping = 0;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                gfc.use_best_huffman = 0;
                gfc.full_outer_loop = 0;
                break;

            case 6:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 0;
                gfc.full_outer_loop = 0;
                break;

            case 5:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 0;
                gfc.full_outer_loop = 0;
                break;

            case 4:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                gfc.full_outer_loop = 0;
                break;

            case 3:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                gfc.noise_shaping_amp = 1;
                gfc.noise_shaping_stop = 1;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                gfc.full_outer_loop = 0;
                break;

            case 2:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                if (gfc.substep_shaping == 0)
                    gfc.substep_shaping = 2;
                gfc.noise_shaping_amp = 1;
                gfc.noise_shaping_stop = 1;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                /* inner loop */
                gfc.full_outer_loop = 0;
                break;

            case 1:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                if (gfc.substep_shaping == 0)
                    gfc.substep_shaping = 2;
                gfc.noise_shaping_amp = 2;
                gfc.noise_shaping_stop = 1;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                gfc.full_outer_loop = 0;
                break;

            case 0:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                if (gfc.substep_shaping == 0)
                    gfc.substep_shaping = 2;
                gfc.noise_shaping_amp = 2;
                gfc.noise_shaping_stop = 1;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                /*
                 * type 2 disabled because of it slowness, in favor of full outer
                 * loop search
                 */
                gfc.full_outer_loop = 0;
                /*
                 * full outer loop search disabled because of audible distortions it
                 * may generate rh 060629
                 */
                break;
        }

    }

    function lame_init_bitstream(gfp) {
        var gfc = gfp.internal_flags;
        gfp.frameNum = 0;

        if (gfp.write_id3tag_automatic) {
            id3.id3tag_write_v2(gfp);
        }
        /* initialize histogram data optionally used by frontend */

        gfc.bitrate_stereoMode_Hist = new_int_n([16, 4 + 1]);
        gfc.bitrate_blockType_Hist = new_int_n([16, 4 + 1 + 1]);

        gfc.PeakSample = 0.0;

        /* Write initial VBR Header to bitstream and init VBR data */
        if (gfp.bWriteVbrTag)
            vbr.InitVbrTag(gfp);
    }

    /********************************************************************
     * initialize internal params based on data in gf (globalflags struct filled
     * in by calling program)
     *
     * OUTLINE:
     *
     * We first have some complex code to determine bitrate, output samplerate
     * and mode. It is complicated by the fact that we allow the user to set
     * some or all of these parameters, and need to determine best possible
     * values for the rest of them:
     *
     * 1. set some CPU related flags 2. check if we are mono.mono, stereo.mono
     * or stereo.stereo 3. compute bitrate and output samplerate: user may have
     * set compression ratio user may have set a bitrate user may have set a
     * output samplerate 4. set some options which depend on output samplerate
     * 5. compute the actual compression ratio 6. set mode based on compression
     * ratio
     *
     * The remaining code is much simpler - it just sets options based on the
     * mode & compression ratio:
     *
     * set allow_diff_short based on mode select lowpass filter based on
     * compression ratio & mode set the bitrate index, and min/max bitrates for
     * VBR modes disable VBR tag if it is not appropriate initialize the
     * bitstream initialize scalefac_band data set sideinfo_len (based on
     * channels, CRC, out_samplerate) write an id3v2 tag into the bitstream
     * write VBR tag into the bitstream set mpeg1/2 flag estimate the number of
     * frames (based on a lot of data)
     *
     * now we set more flags: nspsytune: see code VBR modes see code CBR/ABR see
     * code
     *
     * Finally, we set the algorithm flags based on the gfp.quality value
     * lame_init_qval(gfp);
     *
     ********************************************************************/
    this.lame_init_params = function (gfp) {
        var gfc = gfp.internal_flags;

        gfc.Class_ID = 0;
        if (gfc.ATH == null)
            gfc.ATH = new ATH();
        if (gfc.PSY == null)
            gfc.PSY = new PSY();
        if (gfc.rgdata == null)
            gfc.rgdata = new ReplayGain();

        gfc.channels_in = gfp.num_channels;
        if (gfc.channels_in == 1)
            gfp.mode = MPEGMode.MONO;
        gfc.channels_out = (gfp.mode == MPEGMode.MONO) ? 1 : 2;
        gfc.mode_ext = Encoder.MPG_MD_MS_LR;
        if (gfp.mode == MPEGMode.MONO)
            gfp.force_ms = false;
        /*
         * don't allow forced mid/side stereo for mono output
         */

        if (gfp.VBR == VbrMode.vbr_off && gfp.VBR_mean_bitrate_kbps != 128
            && gfp.brate == 0)
            gfp.brate = gfp.VBR_mean_bitrate_kbps;

        if (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_mtrh
            || gfp.VBR == VbrMode.vbr_mt) {
            /* these modes can handle free format condition */
        } else {
            gfp.free_format = false;
            /* mode can't be mixed with free format */
        }

        if (gfp.VBR == VbrMode.vbr_off && gfp.brate == 0) {
            /* no bitrate or compression ratio specified, use 11.025 */
            if (BitStream.EQ(gfp.compression_ratio, 0))
                gfp.compression_ratio = 11.025;
            /*
             * rate to compress a CD down to exactly 128000 bps
             */
        }

        /* find bitrate if user specify a compression ratio */
        if (gfp.VBR == VbrMode.vbr_off && gfp.compression_ratio > 0) {

            if (gfp.out_samplerate == 0)
                gfp.out_samplerate = map2MP3Frequency((int)(0.97 * gfp.in_samplerate));
            /*
             * round up with a margin of 3 %
             */

            /*
             * choose a bitrate for the output samplerate which achieves
             * specified compression ratio
             */
            gfp.brate = 0 | (gfp.out_samplerate * 16 * gfc.channels_out / (1.e3 * gfp.compression_ratio));

            /* we need the version for the bitrate table look up */
            gfc.samplerate_index = SmpFrqIndex(gfp.out_samplerate, gfp);

            if (!gfp.free_format) /*
             * for non Free Format find the nearest allowed
             * bitrate
             */
                gfp.brate = FindNearestBitrate(gfp.brate, gfp.version,
                    gfp.out_samplerate);
        }

        if (gfp.out_samplerate != 0) {
            if (gfp.out_samplerate < 16000) {
                gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps,
                    8);
                gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps,
                    64);
            } else if (gfp.out_samplerate < 32000) {
                gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps,
                    8);
                gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps,
                    160);
            } else {
                gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps,
                    32);
                gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps,
                    320);
            }
        }

        /****************************************************************/
        /* if a filter has not been enabled, see if we should add one: */
        /****************************************************************/
        if (gfp.lowpassfreq == 0) {
            var lowpass = 16000.;

            switch (gfp.VBR) {
                case VbrMode.vbr_off:
                {
                    var lh = new LowPassHighPass();
                    optimum_bandwidth(lh, gfp.brate);
                    lowpass = lh.lowerlimit;
                    break;
                }
                case VbrMode.vbr_abr:
                {
                    var lh = new LowPassHighPass();
                    optimum_bandwidth(lh, gfp.VBR_mean_bitrate_kbps);
                    lowpass = lh.lowerlimit;
                    break;
                }
                case VbrMode.vbr_rh:
                {
                    var x = [19500, 19000, 18600, 18000, 17500, 16000,
                        15600, 14900, 12500, 10000, 3950];
                    if (0 <= gfp.VBR_q && gfp.VBR_q <= 9) {
                        var a = x[gfp.VBR_q], b = x[gfp.VBR_q + 1], m = gfp.VBR_q_frac;
                        lowpass = linear_int(a, b, m);
                    } else {
                        lowpass = 19500;
                    }
                    break;
                }
                default:
                {
                    var x = [19500, 19000, 18500, 18000, 17500, 16500,
                        15500, 14500, 12500, 9500, 3950];
                    if (0 <= gfp.VBR_q && gfp.VBR_q <= 9) {
                        var a = x[gfp.VBR_q], b = x[gfp.VBR_q + 1], m = gfp.VBR_q_frac;
                        lowpass = linear_int(a, b, m);
                    } else {
                        lowpass = 19500;
                    }
                }
            }
            if (gfp.mode == MPEGMode.MONO
                && (gfp.VBR == VbrMode.vbr_off || gfp.VBR == VbrMode.vbr_abr))
                lowpass *= 1.5;

            gfp.lowpassfreq = lowpass | 0;
        }

        if (gfp.out_samplerate == 0) {
            if (2 * gfp.lowpassfreq > gfp.in_samplerate) {
                gfp.lowpassfreq = gfp.in_samplerate / 2;
            }
            gfp.out_samplerate = optimum_samplefreq(gfp.lowpassfreq | 0,
                gfp.in_samplerate);
        }

        gfp.lowpassfreq = Math.min(20500, gfp.lowpassfreq);
        gfp.lowpassfreq = Math.min(gfp.out_samplerate / 2, gfp.lowpassfreq);

        if (gfp.VBR == VbrMode.vbr_off) {
            gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
                / (1.e3 * gfp.brate);
        }
        if (gfp.VBR == VbrMode.vbr_abr) {
            gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
                / (1.e3 * gfp.VBR_mean_bitrate_kbps);
        }

        /*
         * do not compute ReplayGain values and do not find the peak sample if
         * we can't store them
         */
        if (!gfp.bWriteVbrTag) {
            gfp.findReplayGain = false;
            gfp.decode_on_the_fly = false;
            gfc.findPeakSample = false;
        }
        gfc.findReplayGain = gfp.findReplayGain;
        gfc.decode_on_the_fly = gfp.decode_on_the_fly;

        if (gfc.decode_on_the_fly)
            gfc.findPeakSample = true;

        if (gfc.findReplayGain) {
            if (ga.InitGainAnalysis(gfc.rgdata, gfp.out_samplerate) == GainAnalysis.INIT_GAIN_ANALYSIS_ERROR) {
                gfp.internal_flags = null;
                return -6;
            }
        }

        if (gfc.decode_on_the_fly && !gfp.decode_only) {
            if (gfc.hip != null) {
                mpglib.hip_decode_exit(gfc.hip);
            }
            gfc.hip = mpglib.hip_decode_init();
        }

        gfc.mode_gr = gfp.out_samplerate <= 24000 ? 1 : 2;
        /*
         * Number of granules per frame
         */
        gfp.framesize = 576 * gfc.mode_gr;
        gfp.encoder_delay = Encoder.ENCDELAY;

        gfc.resample_ratio = gfp.in_samplerate / gfp.out_samplerate;

        /**
         * <PRE>
         *  sample freq       bitrate     compression ratio
         *     [kHz]      [kbps/channel]   for 16 bit input
         *     44.1            56               12.6
         *     44.1            64               11.025
         *     44.1            80                8.82
         *     22.05           24               14.7
         *     22.05           32               11.025
         *     22.05           40                8.82
         *     16              16               16.0
         *     16              24               10.667
         * </PRE>
         */
        /**
         * <PRE>
         *  For VBR, take a guess at the compression_ratio.
         *  For example:
         *
         *    VBR_q    compression     like
         *     -        4.4         320 kbps/44 kHz
         *   0...1      5.5         256 kbps/44 kHz
         *     2        7.3         192 kbps/44 kHz
         *     4        8.8         160 kbps/44 kHz
         *     6       11           128 kbps/44 kHz
         *     9       14.7          96 kbps
         *
         *  for lower bitrates, downsample with --resample
         * </PRE>
         */
        switch (gfp.VBR) {
            case VbrMode.vbr_mt:
            case VbrMode.vbr_rh:
            case VbrMode.vbr_mtrh:
            {
                /* numbers are a bit strange, but they determine the lowpass value */
                var cmp = [5.7, 6.5, 7.3, 8.2, 10, 11.9, 13, 14,
                    15, 16.5];
                gfp.compression_ratio = cmp[gfp.VBR_q];
            }
                break;
            case VbrMode.vbr_abr:
                gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
                    / (1.e3 * gfp.VBR_mean_bitrate_kbps);
                break;
            default:
                gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
                    / (1.e3 * gfp.brate);
                break;
        }

        /*
         * mode = -1 (not set by user) or mode = MONO (because of only 1 input
         * channel). If mode has not been set, then select J-STEREO
         */
        if (gfp.mode == MPEGMode.NOT_SET) {
            gfp.mode = MPEGMode.JOINT_STEREO;
        }

        /* apply user driven high pass filter */
        if (gfp.highpassfreq > 0) {
            gfc.highpass1 = 2. * gfp.highpassfreq;

            if (gfp.highpasswidth >= 0)
                gfc.highpass2 = 2. * (gfp.highpassfreq + gfp.highpasswidth);
            else
            /* 0% above on default */
                gfc.highpass2 = (1 + 0.00) * 2. * gfp.highpassfreq;

            gfc.highpass1 /= gfp.out_samplerate;
            gfc.highpass2 /= gfp.out_samplerate;
        } else {
            gfc.highpass1 = 0;
            gfc.highpass2 = 0;
        }
        /* apply user driven low pass filter */
        if (gfp.lowpassfreq > 0) {
            gfc.lowpass2 = 2. * gfp.lowpassfreq;
            if (gfp.lowpasswidth >= 0) {
                gfc.lowpass1 = 2. * (gfp.lowpassfreq - gfp.lowpasswidth);
                if (gfc.lowpass1 < 0) /* has to be >= 0 */
                    gfc.lowpass1 = 0;
            } else { /* 0% below on default */
                gfc.lowpass1 = (1 - 0.00) * 2. * gfp.lowpassfreq;
            }
            gfc.lowpass1 /= gfp.out_samplerate;
            gfc.lowpass2 /= gfp.out_samplerate;
        } else {
            gfc.lowpass1 = 0;
            gfc.lowpass2 = 0;
        }

        /**********************************************************************/
        /* compute info needed for polyphase filter (filter type==0, default) */
        /**********************************************************************/
        lame_init_params_ppflt(gfp);
        /*******************************************************
         * samplerate and bitrate index
         *******************************************************/
        gfc.samplerate_index = SmpFrqIndex(gfp.out_samplerate, gfp);
        if (gfc.samplerate_index < 0) {
            gfp.internal_flags = null;
            return -1;
        }

        if (gfp.VBR == VbrMode.vbr_off) {
            if (gfp.free_format) {
                gfc.bitrate_index = 0;
            } else {
                gfp.brate = FindNearestBitrate(gfp.brate, gfp.version,
                    gfp.out_samplerate);
                gfc.bitrate_index = BitrateIndex(gfp.brate, gfp.version,
                    gfp.out_samplerate);
                if (gfc.bitrate_index <= 0) {
                    gfp.internal_flags = null;
                    return -1;
                }
            }
        } else {
            gfc.bitrate_index = 1;
        }

        /* for CBR, we will write an "info" tag. */

        if (gfp.analysis)
            gfp.bWriteVbrTag = false;

        /* some file options not allowed if output is: not specified or stdout */
        if (gfc.pinfo != null)
            gfp.bWriteVbrTag = false;
        /* disable Xing VBR tag */

        bs.init_bit_stream_w(gfc);

        var j = gfc.samplerate_index + (3 * gfp.version) + 6
            * (gfp.out_samplerate < 16000 ? 1 : 0);
        for (var i = 0; i < Encoder.SBMAX_l + 1; i++)
            gfc.scalefac_band.l[i] = qupvt.sfBandIndex[j].l[i];

        for (var i = 0; i < Encoder.PSFB21 + 1; i++) {
            var size = (gfc.scalefac_band.l[22] - gfc.scalefac_band.l[21])
                / Encoder.PSFB21;
            var start = gfc.scalefac_band.l[21] + i * size;
            gfc.scalefac_band.psfb21[i] = start;
        }
        gfc.scalefac_band.psfb21[Encoder.PSFB21] = 576;

        for (var i = 0; i < Encoder.SBMAX_s + 1; i++)
            gfc.scalefac_band.s[i] = qupvt.sfBandIndex[j].s[i];

        for (var i = 0; i < Encoder.PSFB12 + 1; i++) {
            var size = (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12])
                / Encoder.PSFB12;
            var start = gfc.scalefac_band.s[12] + i * size;
            gfc.scalefac_band.psfb12[i] = start;
        }
        gfc.scalefac_band.psfb12[Encoder.PSFB12] = 192;
        /* determine the mean bitrate for main data */
        if (gfp.version == 1) /* MPEG 1 */
            gfc.sideinfo_len = (gfc.channels_out == 1) ? 4 + 17 : 4 + 32;
        else
        /* MPEG 2 */
            gfc.sideinfo_len = (gfc.channels_out == 1) ? 4 + 9 : 4 + 17;

        if (gfp.error_protection)
            gfc.sideinfo_len += 2;

        lame_init_bitstream(gfp);

        gfc.Class_ID = LAME_ID;

        {
            var k;

            for (k = 0; k < 19; k++)
                gfc.nsPsy.pefirbuf[k] = 700 * gfc.mode_gr * gfc.channels_out;

            if (gfp.ATHtype == -1)
                gfp.ATHtype = 4;
        }
        assert(gfp.VBR_q <= 9);
        assert(gfp.VBR_q >= 0);

        switch (gfp.VBR) {

            case VbrMode.vbr_mt:
                gfp.VBR = VbrMode.vbr_mtrh;
            //$FALL-THROUGH$
            case VbrMode.vbr_mtrh:
            {
                if (gfp.useTemporal == null) {
                    gfp.useTemporal = false;
                    /* off by default for this VBR mode */
                }

                p.apply_preset(gfp, 500 - (gfp.VBR_q * 10), 0);
                /**
                 * <PRE>
                 *   The newer VBR code supports only a limited
                 *     subset of quality levels:
                 *     9-5=5 are the same, uses x^3/4 quantization
                 *   4-0=0 are the same  5 plus best huffman divide code
                 * </PRE>
                 */
                if (gfp.quality < 0)
                    gfp.quality = LAME_DEFAULT_QUALITY;
                if (gfp.quality < 5)
                    gfp.quality = 0;
                if (gfp.quality > 5)
                    gfp.quality = 5;

                gfc.PSY.mask_adjust = gfp.maskingadjust;
                gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;

                /*
                 * sfb21 extra only with MPEG-1 at higher sampling rates
                 */
                if (gfp.experimentalY)
                    gfc.sfb21_extra = false;
                else
                    gfc.sfb21_extra = (gfp.out_samplerate > 44000);

                gfc.iteration_loop = new VBRNewIterationLoop(qu);
                break;

            }
            case VbrMode.vbr_rh:
            {

                p.apply_preset(gfp, 500 - (gfp.VBR_q * 10), 0);

                gfc.PSY.mask_adjust = gfp.maskingadjust;
                gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;

                /*
                 * sfb21 extra only with MPEG-1 at higher sampling rates
                 */
                if (gfp.experimentalY)
                    gfc.sfb21_extra = false;
                else
                    gfc.sfb21_extra = (gfp.out_samplerate > 44000);

                /*
                 * VBR needs at least the output of GPSYCHO, so we have to garantee
                 * that by setting a minimum quality level, actually level 6 does
                 * it. down to level 6
                 */
                if (gfp.quality > 6)
                    gfp.quality = 6;

                if (gfp.quality < 0)
                    gfp.quality = LAME_DEFAULT_QUALITY;

                gfc.iteration_loop = new VBROldIterationLoop(qu);
                break;
            }

            default: /* cbr/abr */
            {
                var vbrmode;

                /*
                 * no sfb21 extra with CBR code
                 */
                gfc.sfb21_extra = false;

                if (gfp.quality < 0)
                    gfp.quality = LAME_DEFAULT_QUALITY;

                vbrmode = gfp.VBR;
                if (vbrmode == VbrMode.vbr_off)
                    gfp.VBR_mean_bitrate_kbps = gfp.brate;
                /* second, set parameters depending on bitrate */
                p.apply_preset(gfp, gfp.VBR_mean_bitrate_kbps, 0);
                gfp.VBR = vbrmode;

                gfc.PSY.mask_adjust = gfp.maskingadjust;
                gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;

                if (vbrmode == VbrMode.vbr_off) {
                    gfc.iteration_loop = new CBRNewIterationLoop(qu);
                } else {
                    gfc.iteration_loop = new ABRIterationLoop(qu);
                }
                break;
            }
        }
        assert(gfp.scale >= 0);
        /* initialize default values common for all modes */

        if (gfp.VBR != VbrMode.vbr_off) { /* choose a min/max bitrate for VBR */
            /* if the user didn't specify VBR_max_bitrate: */
            gfc.VBR_min_bitrate = 1;
            /*
             * default: allow 8 kbps (MPEG-2) or 32 kbps (MPEG-1)
             */
            gfc.VBR_max_bitrate = 14;
            /*
             * default: allow 160 kbps (MPEG-2) or 320 kbps (MPEG-1)
             */
            if (gfp.out_samplerate < 16000)
                gfc.VBR_max_bitrate = 8;
            /* default: allow 64 kbps (MPEG-2.5) */
            if (gfp.VBR_min_bitrate_kbps != 0) {
                gfp.VBR_min_bitrate_kbps = FindNearestBitrate(
                    gfp.VBR_min_bitrate_kbps, gfp.version,
                    gfp.out_samplerate);
                gfc.VBR_min_bitrate = BitrateIndex(gfp.VBR_min_bitrate_kbps,
                    gfp.version, gfp.out_samplerate);
                if (gfc.VBR_min_bitrate < 0)
                    return -1;
            }
            if (gfp.VBR_max_bitrate_kbps != 0) {
                gfp.VBR_max_bitrate_kbps = FindNearestBitrate(
                    gfp.VBR_max_bitrate_kbps, gfp.version,
                    gfp.out_samplerate);
                gfc.VBR_max_bitrate = BitrateIndex(gfp.VBR_max_bitrate_kbps,
                    gfp.version, gfp.out_samplerate);
                if (gfc.VBR_max_bitrate < 0)
                    return -1;
            }
            gfp.VBR_min_bitrate_kbps = Tables.bitrate_table[gfp.version][gfc.VBR_min_bitrate];
            gfp.VBR_max_bitrate_kbps = Tables.bitrate_table[gfp.version][gfc.VBR_max_bitrate];
            gfp.VBR_mean_bitrate_kbps = Math.min(
                Tables.bitrate_table[gfp.version][gfc.VBR_max_bitrate],
                gfp.VBR_mean_bitrate_kbps);
            gfp.VBR_mean_bitrate_kbps = Math.max(
                Tables.bitrate_table[gfp.version][gfc.VBR_min_bitrate],
                gfp.VBR_mean_bitrate_kbps);
        }

        /* just another daily changing developer switch */
        if (gfp.tune) {
            gfc.PSY.mask_adjust += gfp.tune_value_a;
            gfc.PSY.mask_adjust_short += gfp.tune_value_a;
        }

        /* initialize internal qval settings */
        lame_init_qval(gfp);
        assert(gfp.scale >= 0);
        /*
         * automatic ATH adjustment on
         */
        if (gfp.athaa_type < 0)
            gfc.ATH.useAdjust = 3;
        else
            gfc.ATH.useAdjust = gfp.athaa_type;

        /* initialize internal adaptive ATH settings -jd */
        gfc.ATH.aaSensitivityP = Math.pow(10.0, gfp.athaa_sensitivity
            / -10.0);

        if (gfp.short_blocks == null) {
            gfp.short_blocks = ShortBlock.short_block_allowed;
        }

        /*
         * Note Jan/2003: Many hardware decoders cannot handle short blocks in
         * regular stereo mode unless they are coupled (same type in both
         * channels) it is a rare event (1 frame per min. or so) that LAME would
         * use uncoupled short blocks, so lets turn them off until we decide how
         * to handle this. No other encoders allow uncoupled short blocks, even
         * though it is in the standard.
         */
        /*
         * rh 20040217: coupling makes no sense for mono and dual-mono streams
         */
        if (gfp.short_blocks == ShortBlock.short_block_allowed
            && (gfp.mode == MPEGMode.JOINT_STEREO || gfp.mode == MPEGMode.STEREO)) {
            gfp.short_blocks = ShortBlock.short_block_coupled;
        }

        if (gfp.quant_comp < 0)
            gfp.quant_comp = 1;
        if (gfp.quant_comp_short < 0)
            gfp.quant_comp_short = 0;

        if (gfp.msfix < 0)
            gfp.msfix = 0;

        /* select psychoacoustic model */
        gfp.exp_nspsytune = gfp.exp_nspsytune | 1;

        if (gfp.internal_flags.nsPsy.attackthre < 0)
            gfp.internal_flags.nsPsy.attackthre = PsyModel.NSATTACKTHRE;
        if (gfp.internal_flags.nsPsy.attackthre_s < 0)
            gfp.internal_flags.nsPsy.attackthre_s = PsyModel.NSATTACKTHRE_S;

        assert(gfp.scale >= 0);

        if (gfp.scale < 0)
            gfp.scale = 1;

        if (gfp.ATHtype < 0)
            gfp.ATHtype = 4;

        if (gfp.ATHcurve < 0)
            gfp.ATHcurve = 4;

        if (gfp.athaa_loudapprox < 0)
            gfp.athaa_loudapprox = 2;

        if (gfp.interChRatio < 0)
            gfp.interChRatio = 0;

        if (gfp.useTemporal == null)
            gfp.useTemporal = true;
        /* on by default */

        /*
         * padding method as described in
         * "MPEG-Layer3 / Bitstream Syntax and Decoding" by Martin Sieler, Ralph
         * Sperschneider
         *
         * note: there is no padding for the very first frame
         *
         * Robert Hegemann 2000-06-22
         */
        gfc.slot_lag = gfc.frac_SpF = 0;
        if (gfp.VBR == VbrMode.vbr_off)
            gfc.slot_lag = gfc.frac_SpF = (((gfp.version + 1) * 72000 * gfp.brate) % gfp.out_samplerate) | 0;

        qupvt.iteration_init(gfp);
        psy.psymodel_init(gfp);
        assert(gfp.scale >= 0);
        return 0;
    }

    function update_inbuffer_size(gfc, nsamples) {
        if (gfc.in_buffer_0 == null || gfc.in_buffer_nsamples < nsamples) {
            gfc.in_buffer_0 = new_float(nsamples);
            gfc.in_buffer_1 = new_float(nsamples);
            gfc.in_buffer_nsamples = nsamples;
        }
    }

    this.lame_encode_flush = function (gfp, mp3buffer, mp3bufferPos, mp3buffer_size) {
        var gfc = gfp.internal_flags;
        var buffer = new_short_n([2, 1152]);
        var imp3 = 0, mp3count, mp3buffer_size_remaining;

        /*
         * we always add POSTDELAY=288 padding to make sure granule with real
         * data can be complety decoded (because of 50% overlap with next
         * granule
         */
        var end_padding;
        var frames_left;
        var samples_to_encode = gfc.mf_samples_to_encode - Encoder.POSTDELAY;
        var mf_needed = calcNeeded(gfp);

        /* Was flush already called? */
        if (gfc.mf_samples_to_encode < 1) {
            return 0;
        }
        mp3count = 0;

        if (gfp.in_samplerate != gfp.out_samplerate) {
            /*
             * delay due to resampling; needs to be fixed, if resampling code
             * gets changed
             */
            samples_to_encode += 16. * gfp.out_samplerate / gfp.in_samplerate;
        }
        end_padding = gfp.framesize - (samples_to_encode % gfp.framesize);
        if (end_padding < 576)
            end_padding += gfp.framesize;
        gfp.encoder_padding = end_padding;

        frames_left = (samples_to_encode + end_padding) / gfp.framesize;

        /*
         * send in a frame of 0 padding until all internal sample buffers are
         * flushed
         */
        while (frames_left > 0 && imp3 >= 0) {
            var bunch = mf_needed - gfc.mf_size;
            var frame_num = gfp.frameNum;

            bunch *= gfp.in_samplerate;
            bunch /= gfp.out_samplerate;
            if (bunch > 1152)
                bunch = 1152;
            if (bunch < 1)
                bunch = 1;

            mp3buffer_size_remaining = mp3buffer_size - mp3count;

            /* if user specifed buffer size = 0, dont check size */
            if (mp3buffer_size == 0)
                mp3buffer_size_remaining = 0;

            imp3 = this.lame_encode_buffer(gfp, buffer[0], buffer[1], bunch,
                mp3buffer, mp3bufferPos, mp3buffer_size_remaining);

            mp3bufferPos += imp3;
            mp3count += imp3;
            frames_left -= (frame_num != gfp.frameNum) ? 1 : 0;
        }
        /*
         * Set gfc.mf_samples_to_encode to 0, so we may detect and break loops
         * calling it more than once in a row.
         */
        gfc.mf_samples_to_encode = 0;

        if (imp3 < 0) {
            /* some type of fatal error */
            return imp3;
        }

        mp3buffer_size_remaining = mp3buffer_size - mp3count;
        /* if user specifed buffer size = 0, dont check size */
        if (mp3buffer_size == 0)
            mp3buffer_size_remaining = 0;

        /* mp3 related stuff. bit buffer might still contain some mp3 data */
        bs.flush_bitstream(gfp);
        imp3 = bs.copy_buffer(gfc, mp3buffer, mp3bufferPos,
            mp3buffer_size_remaining, 1);
        if (imp3 < 0) {
            /* some type of fatal error */
            return imp3;
        }
        mp3bufferPos += imp3;
        mp3count += imp3;
        mp3buffer_size_remaining = mp3buffer_size - mp3count;
        /* if user specifed buffer size = 0, dont check size */
        if (mp3buffer_size == 0)
            mp3buffer_size_remaining = 0;

        if (gfp.write_id3tag_automatic) {
            /* write a id3 tag to the bitstream */
            id3.id3tag_write_v1(gfp);

            imp3 = bs.copy_buffer(gfc, mp3buffer, mp3bufferPos,
                mp3buffer_size_remaining, 0);

            if (imp3 < 0) {
                return imp3;
            }
            mp3count += imp3;
        }
        return mp3count;
    };

    this.lame_encode_buffer = function (gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
        var gfc = gfp.internal_flags;
        var in_buffer = [null, null];

        if (gfc.Class_ID != LAME_ID)
            return -3;

        if (nsamples == 0)
            return 0;

        update_inbuffer_size(gfc, nsamples);

        in_buffer[0] = gfc.in_buffer_0;
        in_buffer[1] = gfc.in_buffer_1;

        /* make a copy of input buffer, changing type to sample_t */
        for (var i = 0; i < nsamples; i++) {
            in_buffer[0][i] = buffer_l[i];
            if (gfc.channels_in > 1)
                in_buffer[1][i] = buffer_r[i];
        }

        return lame_encode_buffer_sample(gfp, in_buffer[0], in_buffer[1],
            nsamples, mp3buf, mp3bufPos, mp3buf_size);
    }

    function calcNeeded(gfp) {
        var mf_needed = Encoder.BLKSIZE + gfp.framesize - Encoder.FFTOFFSET;
        /*
         * amount needed for FFT
         */
        mf_needed = Math.max(mf_needed, 512 + gfp.framesize - 32);
        assert(LameInternalFlags.MFSIZE >= mf_needed);

        return mf_needed;
    }

    function lame_encode_buffer_sample(gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
        var gfc = gfp.internal_flags;
        var mp3size = 0, ret, i, ch, mf_needed;
        var mp3out;
        var mfbuf = [null, null];
        var in_buffer = [null, null];

        if (gfc.Class_ID != LAME_ID)
            return -3;

        if (nsamples == 0)
            return 0;

        /* copy out any tags that may have been written into bitstream */
        mp3out = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 0);
        if (mp3out < 0)
            return mp3out;
        /* not enough buffer space */
        mp3bufPos += mp3out;
        mp3size += mp3out;

        in_buffer[0] = buffer_l;
        in_buffer[1] = buffer_r;

        /* Apply user defined re-scaling */

        /* user selected scaling of the samples */
        if (BitStream.NEQ(gfp.scale, 0) && BitStream.NEQ(gfp.scale, 1.0)) {
            for (i = 0; i < nsamples; ++i) {
                in_buffer[0][i] *= gfp.scale;
                if (gfc.channels_out == 2)
                    in_buffer[1][i] *= gfp.scale;
            }
        }

        /* user selected scaling of the channel 0 (left) samples */
        if (BitStream.NEQ(gfp.scale_left, 0)
            && BitStream.NEQ(gfp.scale_left, 1.0)) {
            for (i = 0; i < nsamples; ++i) {
                in_buffer[0][i] *= gfp.scale_left;
            }
        }

        /* user selected scaling of the channel 1 (right) samples */
        if (BitStream.NEQ(gfp.scale_right, 0)
            && BitStream.NEQ(gfp.scale_right, 1.0)) {
            for (i = 0; i < nsamples; ++i) {
                in_buffer[1][i] *= gfp.scale_right;
            }
        }

        /* Downsample to Mono if 2 channels in and 1 channel out */
        if (gfp.num_channels == 2 && gfc.channels_out == 1) {
            for (i = 0; i < nsamples; ++i) {
                in_buffer[0][i] = 0.5 * ( in_buffer[0][i] + in_buffer[1][i]);
                in_buffer[1][i] = 0.0;
            }
        }

        mf_needed = calcNeeded(gfp);

        mfbuf[0] = gfc.mfbuf[0];
        mfbuf[1] = gfc.mfbuf[1];

        var in_bufferPos = 0;
        while (nsamples > 0) {
            var in_buffer_ptr = [null, null];
            var n_in = 0;
            /* number of input samples processed with fill_buffer */
            var n_out = 0;
            /* number of samples output with fill_buffer */
            /* n_in <> n_out if we are resampling */

            in_buffer_ptr[0] = in_buffer[0];
            in_buffer_ptr[1] = in_buffer[1];
            /* copy in new samples into mfbuf, with resampling */
            var inOut = new InOut();
            fill_buffer(gfp, mfbuf, in_buffer_ptr, in_bufferPos, nsamples,
                inOut);
            n_in = inOut.n_in;
            n_out = inOut.n_out;

            /* compute ReplayGain of resampled input if requested */
            if (gfc.findReplayGain && !gfc.decode_on_the_fly)
                if (ga.AnalyzeSamples(gfc.rgdata, mfbuf[0], gfc.mf_size,
                        mfbuf[1], gfc.mf_size, n_out, gfc.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR)
                    return -6;

            /* update in_buffer counters */
            nsamples -= n_in;
            in_bufferPos += n_in;
            if (gfc.channels_out == 2)
                ;// in_bufferPos += n_in;

            /* update mfbuf[] counters */
            gfc.mf_size += n_out;
            assert(gfc.mf_size <= LameInternalFlags.MFSIZE);

            /*
             * lame_encode_flush may have set gfc.mf_sample_to_encode to 0 so we
             * have to reinitialize it here when that happened.
             */
            if (gfc.mf_samples_to_encode < 1) {
                gfc.mf_samples_to_encode = Encoder.ENCDELAY + Encoder.POSTDELAY;
            }
            gfc.mf_samples_to_encode += n_out;

            if (gfc.mf_size >= mf_needed) {
                /* encode the frame. */
                /* mp3buf = pointer to current location in buffer */
                /* mp3buf_size = size of original mp3 output buffer */
                /* = 0 if we should not worry about the */
                /* buffer size because calling program is */
                /* to lazy to compute it */
                /* mp3size = size of data written to buffer so far */
                /* mp3buf_size-mp3size = amount of space avalable */

                var buf_size = mp3buf_size - mp3size;
                if (mp3buf_size == 0)
                    buf_size = 0;

                ret = lame_encode_frame(gfp, mfbuf[0], mfbuf[1], mp3buf,
                    mp3bufPos, buf_size);

                if (ret < 0)
                    return ret;
                mp3bufPos += ret;
                mp3size += ret;

                /* shift out old samples */
                gfc.mf_size -= gfp.framesize;
                gfc.mf_samples_to_encode -= gfp.framesize;
                for (ch = 0; ch < gfc.channels_out; ch++)
                    for (i = 0; i < gfc.mf_size; i++)
                        mfbuf[ch][i] = mfbuf[ch][i + gfp.framesize];
            }
        }
        assert(nsamples == 0);

        return mp3size;
    }

    function lame_encode_frame(gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
        var ret = self.enc.lame_encode_mp3_frame(gfp, inbuf_l, inbuf_r, mp3buf,
            mp3bufPos, mp3buf_size);
        gfp.frameNum++;
        return ret;
    }

    function InOut() {
        this.n_in = 0;
        this.n_out = 0;
    }


    function NumUsed() {
        this.num_used = 0;
    }

    /**
     * Greatest common divisor.
     * <p>
     * Joint work of Euclid and M. Hendry
     */
    function gcd(i, j) {
        return j != 0 ? gcd(j, i % j) : i;
    }

    /**
     * Resampling via FIR filter, blackman window.
     */
    function blackman(x, fcn, l) {
        /*
         * This algorithm from: SIGNAL PROCESSING ALGORITHMS IN FORTRAN AND C
         * S.D. Stearns and R.A. David, Prentice-Hall, 1992
         */
        var wcn = (Math.PI * fcn);

        x /= l;
        if (x < 0)
            x = 0;
        if (x > 1)
            x = 1;
        var x2 = x - .5;

        var bkwn = 0.42 - 0.5 * Math.cos(2 * x * Math.PI) + 0.08 * Math.cos(4 * x * Math.PI);
        if (Math.abs(x2) < 1e-9)
            return (wcn / Math.PI);
        else
            return (bkwn * Math.sin(l * wcn * x2) / (Math.PI * l * x2));
    }

    function fill_buffer_resample(gfp, outbuf, outbufPos, desired_len, inbuf, in_bufferPos, len, num_used, ch) {
        var gfc = gfp.internal_flags;
        var i, j = 0, k;
        /* number of convolution functions to pre-compute */
        var bpc = gfp.out_samplerate
            / gcd(gfp.out_samplerate, gfp.in_samplerate);
        if (bpc > LameInternalFlags.BPC)
            bpc = LameInternalFlags.BPC;

        var intratio = (Math.abs(gfc.resample_ratio
            - Math.floor(.5 + gfc.resample_ratio)) < .0001) ? 1 : 0;
        var fcn = 1.00 / gfc.resample_ratio;
        if (fcn > 1.00)
            fcn = 1.00;
        var filter_l = 31;
        if (0 == filter_l % 2)
            --filter_l;
        /* must be odd */
        filter_l += intratio;
        /* unless resample_ratio=int, it must be even */

        var BLACKSIZE = filter_l + 1;
        /* size of data needed for FIR */

        if (gfc.fill_buffer_resample_init == 0) {
            gfc.inbuf_old[0] = new_float(BLACKSIZE);
            gfc.inbuf_old[1] = new_float(BLACKSIZE);
            for (i = 0; i <= 2 * bpc; ++i)
                gfc.blackfilt[i] = new_float(BLACKSIZE);

            gfc.itime[0] = 0;
            gfc.itime[1] = 0;

            /* precompute blackman filter coefficients */
            for (j = 0; j <= 2 * bpc; j++) {
                var sum = 0.;
                var offset = (j - bpc) / (2. * bpc);
                for (i = 0; i <= filter_l; i++)
                    sum += gfc.blackfilt[j][i] = blackman(i - offset, fcn,
                        filter_l);
                for (i = 0; i <= filter_l; i++)
                    gfc.blackfilt[j][i] /= sum;
            }
            gfc.fill_buffer_resample_init = 1;
        }

        var inbuf_old = gfc.inbuf_old[ch];

        /* time of j'th element in inbuf = itime + j/ifreq; */
        /* time of k'th element in outbuf = j/ofreq */
        for (k = 0; k < desired_len; k++) {
            var time0;
            var joff;

            time0 = k * gfc.resample_ratio;
            /* time of k'th output sample */
            j = 0 | Math.floor(time0 - gfc.itime[ch]);

            /* check if we need more input data */
            if ((filter_l + j - filter_l / 2) >= len)
                break;

            /* blackman filter. by default, window centered at j+.5(filter_l%2) */
            /* but we want a window centered at time0. */
            var offset = (time0 - gfc.itime[ch] - (j + .5 * (filter_l % 2)));
            assert(Math.abs(offset) <= .501);

            /* find the closest precomputed window for this offset: */
            joff = 0 | Math.floor((offset * 2 * bpc) + bpc + .5);
            var xvalue = 0.;
            for (i = 0; i <= filter_l; ++i) {
                var j2 = i + j - filter_l / 2;
                var y;
                assert(j2 < len);
                assert(j2 + BLACKSIZE >= 0);
                y = (j2 < 0) ? inbuf_old[BLACKSIZE + j2] : inbuf[in_bufferPos
                + j2];
                xvalue += y * gfc.blackfilt[joff][i];
            }
            outbuf[outbufPos + k] = xvalue;
        }

        /* k = number of samples added to outbuf */
        /* last k sample used data from [j-filter_l/2,j+filter_l-filter_l/2] */

        /* how many samples of input data were used: */
        num_used.num_used = Math.min(len, filter_l + j - filter_l / 2);

        /*
         * adjust our input time counter. Incriment by the number of samples
         * used, then normalize so that next output sample is at time 0, next
         * input buffer is at time itime[ch]
         */
        gfc.itime[ch] += num_used.num_used - k * gfc.resample_ratio;

        /* save the last BLACKSIZE samples into the inbuf_old buffer */
        if (num_used.num_used >= BLACKSIZE) {
            for (i = 0; i < BLACKSIZE; i++)
                inbuf_old[i] = inbuf[in_bufferPos + num_used.num_used + i
                - BLACKSIZE];
        } else {
            /* shift in num_used.num_used samples into inbuf_old */
            var n_shift = BLACKSIZE - num_used.num_used;
            /*
             * number of samples to
             * shift
             */

            /*
             * shift n_shift samples by num_used.num_used, to make room for the
             * num_used new samples
             */
            for (i = 0; i < n_shift; ++i)
                inbuf_old[i] = inbuf_old[i + num_used.num_used];

            /* shift in the num_used.num_used samples */
            for (j = 0; i < BLACKSIZE; ++i, ++j)
                inbuf_old[i] = inbuf[in_bufferPos + j];

            assert(j == num_used.num_used);
        }
        return k;
        /* return the number samples created at the new samplerate */
    }

    function fill_buffer(gfp, mfbuf, in_buffer, in_bufferPos, nsamples, io) {
        var gfc = gfp.internal_flags;

        /* copy in new samples into mfbuf, with resampling if necessary */
        if ((gfc.resample_ratio < .9999) || (gfc.resample_ratio > 1.0001)) {
            for (var ch = 0; ch < gfc.channels_out; ch++) {
                var numUsed = new NumUsed();
                io.n_out = fill_buffer_resample(gfp, mfbuf[ch], gfc.mf_size,
                    gfp.framesize, in_buffer[ch], in_bufferPos, nsamples,
                    numUsed, ch);
                io.n_in = numUsed.num_used;
            }
        } else {
            io.n_out = Math.min(gfp.framesize, nsamples);
            io.n_in = io.n_out;
            for (var i = 0; i < io.n_out; ++i) {
                mfbuf[0][gfc.mf_size + i] = in_buffer[0][in_bufferPos + i];
                if (gfc.channels_out == 2)
                    mfbuf[1][gfc.mf_size + i] = in_buffer[1][in_bufferPos + i];
            }
        }
    }

}

module.exports = Lame;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *      psymodel.c
 *
 *      Copyright (c) 1999-2000 Mark Taylor
 *      Copyright (c) 2001-2002 Naoki Shibata
 *      Copyright (c) 2000-2003 Takehiro Tominaga
 *      Copyright (c) 2000-2008 Robert Hegemann
 *      Copyright (c) 2000-2005 Gabriel Bouvigne
 *      Copyright (c) 2000-2005 Alexander Leidinger
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

/* $Id: PsyModel.java,v 1.27 2011/05/24 20:48:06 kenchis Exp $ */


/*
 PSYCHO ACOUSTICS


 This routine computes the psycho acoustics, delayed by one granule.

 Input: buffer of PCM data (1024 samples).

 This window should be centered over the 576 sample granule window.
 The routine will compute the psycho acoustics for
 this granule, but return the psycho acoustics computed
 for the *previous* granule.  This is because the block
 type of the previous granule can only be determined
 after we have computed the psycho acoustics for the following
 granule.

 Output:  maskings and energies for each scalefactor band.
 block type, PE, and some correlation measures.
 The PE is used by CBR modes to determine if extra bits
 from the bit reservoir should be used.  The correlation
 measures are used to determine mid/side or regular stereo.
 */
/*
 Notation:

 barks:  a non-linear frequency scale.  Mapping from frequency to
 barks is given by freq2bark()

 scalefactor bands: The spectrum (frequencies) are broken into
 SBMAX "scalefactor bands".  Thes bands
 are determined by the MPEG ISO spec.  In
 the noise shaping/quantization code, we allocate
 bits among the partition bands to achieve the
 best possible quality

 partition bands:   The spectrum is also broken into about
 64 "partition bands".  Each partition
 band is about .34 barks wide.  There are about 2-5
 partition bands for each scalefactor band.

 LAME computes all psycho acoustic information for each partition
 band.  Then at the end of the computations, this information
 is mapped to scalefactor bands.  The energy in each scalefactor
 band is taken as the sum of the energy in all partition bands
 which overlap the scalefactor band.  The maskings can be computed
 in the same way (and thus represent the average masking in that band)
 or by taking the minmum value multiplied by the number of
 partition bands used (which represents a minimum masking in that band).
 */
/*
 The general outline is as follows:

 1. compute the energy in each partition band
 2. compute the tonality in each partition band
 3. compute the strength of each partion band "masker"
 4. compute the masking (via the spreading function applied to each masker)
 5. Modifications for mid/side masking.

 Each partition band is considiered a "masker".  The strength
 of the i'th masker in band j is given by:

 s3(bark(i)-bark(j))*strength(i)

 The strength of the masker is a function of the energy and tonality.
 The more tonal, the less masking.  LAME uses a simple linear formula
 (controlled by NMT and TMN) which says the strength is given by the
 energy divided by a linear function of the tonality.
 */
/*
 s3() is the "spreading function".  It is given by a formula
 determined via listening tests.

 The total masking in the j'th partition band is the sum over
 all maskings i.  It is thus given by the convolution of
 the strength with s3(), the "spreading function."

 masking(j) = sum_over_i  s3(i-j)*strength(i)  = s3 o strength

 where "o" = convolution operator.  s3 is given by a formula determined
 via listening tests.  It is normalized so that s3 o 1 = 1.

 Note: instead of a simple convolution, LAME also has the
 option of using "additive masking"

 The most critical part is step 2, computing the tonality of each
 partition band.  LAME has two tonality estimators.  The first
 is based on the ISO spec, and measures how predictiable the
 signal is over time.  The more predictable, the more tonal.
 The second measure is based on looking at the spectrum of
 a single granule.  The more peaky the spectrum, the more
 tonal.  By most indications, the latter approach is better.

 Finally, in step 5, the maskings for the mid and side
 channel are possibly increased.  Under certain circumstances,
 noise in the mid & side channels is assumed to also
 be masked by strong maskers in the L or R channels.


 Other data computed by the psy-model:

 ms_ratio        side-channel / mid-channel masking ratio (for previous granule)
 ms_ratio_next   side-channel / mid-channel masking ratio for this granule

 percep_entropy[2]     L and R values (prev granule) of PE - A measure of how
 much pre-echo is in the previous granule
 percep_entropy_MS[2]  mid and side channel values (prev granule) of percep_entropy
 energy[4]             L,R,M,S energy in each channel, prev granule
 blocktype_d[2]        block type to use for previous granule
 */
//package mp3;

//import java.util.Arrays;
var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var FFT = __webpack_require__(805);
var Encoder = __webpack_require__(35);

function PsyModel() {

    var fft = new FFT();

    var LOG10 = 2.30258509299404568402;

    var rpelev = 2;
    var rpelev2 = 16;
    var rpelev_s = 2;
    var rpelev2_s = 16;

    /* size of each partition band, in barks: */
    var DELBARK = .34;

    /* tuned for output level (sensitive to energy scale) */
    var VO_SCALE = (1. / (14752 * 14752) / (Encoder.BLKSIZE / 2));

    var temporalmask_sustain_sec = 0.01;

    var NS_PREECHO_ATT0 = 0.8;
    var NS_PREECHO_ATT1 = 0.6;
    var NS_PREECHO_ATT2 = 0.3;

    var NS_MSFIX = 3.5;

    var NSATTACKTHRE = 4.4;
    var NSATTACKTHRE_S = 25;

    var NSFIRLEN = 21;

    /* size of each partition band, in barks: */
    var LN_TO_LOG10 = 0.2302585093;

    function NON_LINEAR_SCALE_ENERGY(x) {
        return x;
    }

    /**
     * <PRE>
     *       L3psycho_anal.  Compute psycho acoustics.
     *
     *       Data returned to the calling program must be delayed by one
     *       granule.
     *
     *       This is done in two places.
     *       If we do not need to know the blocktype, the copying
     *       can be done here at the top of the program: we copy the data for
     *       the last granule (computed during the last call) before it is
     *       overwritten with the new data.  It looks like this:
     *
     *       0. static psymodel_data
     *       1. calling_program_data = psymodel_data
     *       2. compute psymodel_data
     *
     *       For data which needs to know the blocktype, the copying must be
     *       done at the end of this loop, and the old values must be saved:
     *
     *       0. static psymodel_data_old
     *       1. compute psymodel_data
     *       2. compute possible block type of this granule
     *       3. compute final block type of previous granule based on #2.
     *       4. calling_program_data = psymodel_data_old
     *       5. psymodel_data_old = psymodel_data
     *     psycho_loudness_approx
     *       jd - 2001 mar 12
     *    in:  energy   - BLKSIZE/2 elements of frequency magnitudes ^ 2
     *         gfp      - uses out_samplerate, ATHtype (also needed for ATHformula)
     *    returns: loudness^2 approximation, a positive value roughly tuned for a value
     *             of 1.0 for signals near clipping.
     *    notes:   When calibrated, feeding this function binary white noise at sample
     *             values +32767 or -32768 should return values that approach 3.
     *             ATHformula is used to approximate an equal loudness curve.
     *    future:  Data indicates that the shape of the equal loudness curve varies
     *             with intensity.  This function might be improved by using an equal
     *             loudness curve shaped for typical playback levels (instead of the
     *             ATH, that is shaped for the threshold).  A flexible realization might
     *             simply bend the existing ATH curve to achieve the desired shape.
     *             However, the potential gain may not be enough to justify an effort.
     * </PRE>
     */
    function psycho_loudness_approx(energy, gfc) {
        var loudness_power = 0.0;
        /* apply weights to power in freq. bands */
        for (var i = 0; i < Encoder.BLKSIZE / 2; ++i)
            loudness_power += energy[i] * gfc.ATH.eql_w[i];
        loudness_power *= VO_SCALE;

        return loudness_power;
    }

    function compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, wsamp_lPos, wsamp_s, wsamp_sPos, gr_out, chn, buffer, bufPos) {
        var gfc = gfp.internal_flags;
        if (chn < 2) {
            fft.fft_long(gfc, wsamp_l[wsamp_lPos], chn, buffer, bufPos);
            fft.fft_short(gfc, wsamp_s[wsamp_sPos], chn, buffer, bufPos);
        }
        /* FFT data for mid and side channel is derived from L & R */
        else if (chn == 2) {
            for (var j = Encoder.BLKSIZE - 1; j >= 0; --j) {
                var l = wsamp_l[wsamp_lPos + 0][j];
                var r = wsamp_l[wsamp_lPos + 1][j];
                wsamp_l[wsamp_lPos + 0][j] = (l + r) * Util.SQRT2 * 0.5;
                wsamp_l[wsamp_lPos + 1][j] = (l - r) * Util.SQRT2 * 0.5;
            }
            for (var b = 2; b >= 0; --b) {
                for (var j = Encoder.BLKSIZE_s - 1; j >= 0; --j) {
                    var l = wsamp_s[wsamp_sPos + 0][b][j];
                    var r = wsamp_s[wsamp_sPos + 1][b][j];
                    wsamp_s[wsamp_sPos + 0][b][j] = (l + r) * Util.SQRT2 * 0.5;
                    wsamp_s[wsamp_sPos + 1][b][j] = (l - r) * Util.SQRT2 * 0.5;
                }
            }
        }

        /*********************************************************************
         * compute energies
         *********************************************************************/
        fftenergy[0] = NON_LINEAR_SCALE_ENERGY(wsamp_l[wsamp_lPos + 0][0]);
        fftenergy[0] *= fftenergy[0];

        for (var j = Encoder.BLKSIZE / 2 - 1; j >= 0; --j) {
            var re = (wsamp_l[wsamp_lPos + 0])[Encoder.BLKSIZE / 2 - j];
            var im = (wsamp_l[wsamp_lPos + 0])[Encoder.BLKSIZE / 2 + j];
            fftenergy[Encoder.BLKSIZE / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
                * re + im * im) * 0.5);
        }
        for (var b = 2; b >= 0; --b) {
            fftenergy_s[b][0] = (wsamp_s[wsamp_sPos + 0])[b][0];
            fftenergy_s[b][0] *= fftenergy_s[b][0];
            for (var j = Encoder.BLKSIZE_s / 2 - 1; j >= 0; --j) {
                var re = (wsamp_s[wsamp_sPos + 0])[b][Encoder.BLKSIZE_s
                / 2 - j];
                var im = (wsamp_s[wsamp_sPos + 0])[b][Encoder.BLKSIZE_s
                / 2 + j];
                fftenergy_s[b][Encoder.BLKSIZE_s / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
                    * re + im * im) * 0.5);
            }
        }
        /* total energy */
        {
            var totalenergy = 0.0;
            for (var j = 11; j < Encoder.HBLKSIZE; j++)
                totalenergy += fftenergy[j];

            gfc.tot_ener[chn] = totalenergy;
        }

        if (gfp.analysis) {
            for (var j = 0; j < Encoder.HBLKSIZE; j++) {
                gfc.pinfo.energy[gr_out][chn][j] = gfc.pinfo.energy_save[chn][j];
                gfc.pinfo.energy_save[chn][j] = fftenergy[j];
            }
            gfc.pinfo.pe[gr_out][chn] = gfc.pe[chn];
        }

        /*********************************************************************
         * compute loudness approximation (used for ATH auto-level adjustment)
         *********************************************************************/
        if (gfp.athaa_loudapprox == 2 && chn < 2) {
            // no loudness for mid/side ch
            gfc.loudness_sq[gr_out][chn] = gfc.loudness_sq_save[chn];
            gfc.loudness_sq_save[chn] = psycho_loudness_approx(fftenergy, gfc);
        }
    }

    /* mask_add optimization */
    /* init the limit values used to avoid computing log in mask_add when it is not necessary */

    /**
     * <PRE>
     *  For example, with i = 10*log10(m2/m1)/10*16         (= log10(m2/m1)*16)
     *
     * abs(i)>8 is equivalent (as i is an integer) to
     * abs(i)>=9
     * i>=9 || i<=-9
     * equivalent to (as i is the biggest integer smaller than log10(m2/m1)*16
     * or the smallest integer bigger than log10(m2/m1)*16 depending on the sign of log10(m2/m1)*16)
     * log10(m2/m1)>=9/16 || log10(m2/m1)<=-9/16
     * exp10 is strictly increasing thus this is equivalent to
     * m2/m1 >= 10^(9/16) || m2/m1<=10^(-9/16) which are comparisons to constants
     * </PRE>
     */

    /**
     * as in if(i>8)
     */
    var I1LIMIT = 8;
    /**
     * as in if(i>24) . changed 23
     */
    var I2LIMIT = 23;
    /**
     * as in if(m<15)
     */
    var MLIMIT = 15;

    var ma_max_i1;
    var ma_max_i2;
    var ma_max_m;

    /**
     * This is the masking table:<BR>
     * According to tonality, values are going from 0dB (TMN) to 9.3dB (NMT).<BR>
     * After additive masking computation, 8dB are added, so final values are
     * going from 8dB to 17.3dB
     *
     * pow(10, -0.0..-0.6)
     */
    var tab = [1.0, 0.79433, 0.63096, 0.63096,
        0.63096, 0.63096, 0.63096, 0.25119, 0.11749];

    function init_mask_add_max_values() {
        ma_max_i1 = Math.pow(10, (I1LIMIT + 1) / 16.0);
        ma_max_i2 = Math.pow(10, (I2LIMIT + 1) / 16.0);
        ma_max_m = Math.pow(10, (MLIMIT) / 10.0);
    }

    var table1 = [3.3246 * 3.3246,
        3.23837 * 3.23837, 3.15437 * 3.15437, 3.00412 * 3.00412,
        2.86103 * 2.86103, 2.65407 * 2.65407, 2.46209 * 2.46209,
        2.284 * 2.284, 2.11879 * 2.11879, 1.96552 * 1.96552,
        1.82335 * 1.82335, 1.69146 * 1.69146, 1.56911 * 1.56911,
        1.46658 * 1.46658, 1.37074 * 1.37074, 1.31036 * 1.31036,
        1.25264 * 1.25264, 1.20648 * 1.20648, 1.16203 * 1.16203,
        1.12765 * 1.12765, 1.09428 * 1.09428, 1.0659 * 1.0659,
        1.03826 * 1.03826, 1.01895 * 1.01895, 1];

    var table2 = [1.33352 * 1.33352,
        1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497,
        1.40548 * 1.40548, 1.3537 * 1.3537, 1.30382 * 1.30382,
        1.22321 * 1.22321, 1.14758 * 1.14758, 1];

    var table3 = [2.35364 * 2.35364,
        2.29259 * 2.29259, 2.23313 * 2.23313, 2.12675 * 2.12675,
        2.02545 * 2.02545, 1.87894 * 1.87894, 1.74303 * 1.74303,
        1.61695 * 1.61695, 1.49999 * 1.49999, 1.39148 * 1.39148,
        1.29083 * 1.29083, 1.19746 * 1.19746, 1.11084 * 1.11084,
        1.03826 * 1.03826];

    /**
     * addition of simultaneous masking Naoki Shibata 2000/7
     */
    function mask_add(m1, m2, kk, b, gfc, shortblock) {
        var ratio;

        if (m2 > m1) {
            if (m2 < (m1 * ma_max_i2))
                ratio = m2 / m1;
            else
                return (m1 + m2);
        } else {
            if (m1 >= (m2 * ma_max_i2))
                return (m1 + m2);
            ratio = m1 / m2;
        }

        /* Should always be true, just checking */
        assert(m1 >= 0);
        assert(m2 >= 0);

        m1 += m2;
        //if (((long)(b + 3) & 0xffffffff) <= 3 + 3) {
        if ((b + 3) <= 3 + 3) {
            /* approximately, 1 bark = 3 partitions */
            /* 65% of the cases */
            /* originally 'if(i > 8)' */
            if (ratio >= ma_max_i1) {
                /* 43% of the total */
                return m1;
            }

            /* 22% of the total */
            var i = 0 | (Util.FAST_LOG10_X(ratio, 16.0));
            return m1 * table2[i];
        }

        /**
         * <PRE>
         * m<15 equ log10((m1+m2)/gfc.ATH.cb[k])<1.5
         * equ (m1+m2)/gfc.ATH.cb[k]<10^1.5
         * equ (m1+m2)<10^1.5 * gfc.ATH.cb[k]
         * </PRE>
         */
        var i = 0 | Util.FAST_LOG10_X(ratio, 16.0);
        if (shortblock != 0) {
            m2 = gfc.ATH.cb_s[kk] * gfc.ATH.adjust;
        } else {
            m2 = gfc.ATH.cb_l[kk] * gfc.ATH.adjust;
        }
        assert(m2 >= 0);
        if (m1 < ma_max_m * m2) {
            /* 3% of the total */
            /* Originally if (m > 0) { */
            if (m1 > m2) {
                var f, r;

                f = 1.0;
                if (i <= 13)
                    f = table3[i];

                r = Util.FAST_LOG10_X(m1 / m2, 10.0 / 15.0);
                return m1 * ((table1[i] - f) * r + f);
            }

            if (i > 13)
                return m1;

            return m1 * table3[i];
        }

        /* 10% of total */
        return m1 * table1[i];
    }

    var table2_ = [1.33352 * 1.33352,
        1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497,
        1.40548 * 1.40548, 1.3537 * 1.3537, 1.30382 * 1.30382,
        1.22321 * 1.22321, 1.14758 * 1.14758, 1];

    /**
     * addition of simultaneous masking Naoki Shibata 2000/7
     */
    function vbrpsy_mask_add(m1, m2, b) {
        var ratio;

        if (m1 < 0) {
            m1 = 0;
        }
        if (m2 < 0) {
            m2 = 0;
        }
        if (m1 <= 0) {
            return m2;
        }
        if (m2 <= 0) {
            return m1;
        }
        if (m2 > m1) {
            ratio = m2 / m1;
        } else {
            ratio = m1 / m2;
        }
        if (-2 <= b && b <= 2) {
            /* approximately, 1 bark = 3 partitions */
            /* originally 'if(i > 8)' */
            if (ratio >= ma_max_i1) {
                return m1 + m2;
            } else {
                var i = 0 | (Util.FAST_LOG10_X(ratio, 16.0));
                return (m1 + m2) * table2_[i];
            }
        }
        if (ratio < ma_max_i2) {
            return m1 + m2;
        }
        if (m1 < m2) {
            m1 = m2;
        }
        return m1;
    }

    /**
     * compute interchannel masking effects
     */
    function calc_interchannel_masking(gfp, ratio) {
        var gfc = gfp.internal_flags;
        if (gfc.channels_out > 1) {
            for (var sb = 0; sb < Encoder.SBMAX_l; sb++) {
                var l = gfc.thm[0].l[sb];
                var r = gfc.thm[1].l[sb];
                gfc.thm[0].l[sb] += r * ratio;
                gfc.thm[1].l[sb] += l * ratio;
            }
            for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
                for (var sblock = 0; sblock < 3; sblock++) {
                    var l = gfc.thm[0].s[sb][sblock];
                    var r = gfc.thm[1].s[sb][sblock];
                    gfc.thm[0].s[sb][sblock] += r * ratio;
                    gfc.thm[1].s[sb][sblock] += l * ratio;
                }
            }
        }
    }

    /**
     * compute M/S thresholds from Johnston & Ferreira 1992 ICASSP paper
     */
    function msfix1(gfc) {
        for (var sb = 0; sb < Encoder.SBMAX_l; sb++) {
            /* use this fix if L & R masking differs by 2db or less */
            /* if db = 10*log10(x2/x1) < 2 */
            /* if (x2 < 1.58*x1) { */
            if (gfc.thm[0].l[sb] > 1.58 * gfc.thm[1].l[sb]
                || gfc.thm[1].l[sb] > 1.58 * gfc.thm[0].l[sb])
                continue;
            var mld = gfc.mld_l[sb] * gfc.en[3].l[sb];
            var rmid = Math.max(gfc.thm[2].l[sb],
                Math.min(gfc.thm[3].l[sb], mld));

            mld = gfc.mld_l[sb] * gfc.en[2].l[sb];
            var rside = Math.max(gfc.thm[3].l[sb],
                Math.min(gfc.thm[2].l[sb], mld));
            gfc.thm[2].l[sb] = rmid;
            gfc.thm[3].l[sb] = rside;
        }

        for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
            for (var sblock = 0; sblock < 3; sblock++) {
                if (gfc.thm[0].s[sb][sblock] > 1.58 * gfc.thm[1].s[sb][sblock]
                    || gfc.thm[1].s[sb][sblock] > 1.58 * gfc.thm[0].s[sb][sblock])
                    continue;
                var mld = gfc.mld_s[sb] * gfc.en[3].s[sb][sblock];
                var rmid = Math.max(gfc.thm[2].s[sb][sblock],
                    Math.min(gfc.thm[3].s[sb][sblock], mld));

                mld = gfc.mld_s[sb] * gfc.en[2].s[sb][sblock];
                var rside = Math.max(gfc.thm[3].s[sb][sblock],
                    Math.min(gfc.thm[2].s[sb][sblock], mld));

                gfc.thm[2].s[sb][sblock] = rmid;
                gfc.thm[3].s[sb][sblock] = rside;
            }
        }
    }

    /**
     * Adjust M/S maskings if user set "msfix"
     *
     * Naoki Shibata 2000
     */
    function ns_msfix(gfc, msfix, athadjust) {
        var msfix2 = msfix;
        var athlower = Math.pow(10, athadjust);

        msfix *= 2.0;
        msfix2 *= 2.0;
        for (var sb = 0; sb < Encoder.SBMAX_l; sb++) {
            var thmLR, thmM, thmS, ath;
            ath = (gfc.ATH.cb_l[gfc.bm_l[sb]]) * athlower;
            thmLR = Math.min(Math.max(gfc.thm[0].l[sb], ath),
                Math.max(gfc.thm[1].l[sb], ath));
            thmM = Math.max(gfc.thm[2].l[sb], ath);
            thmS = Math.max(gfc.thm[3].l[sb], ath);
            if (thmLR * msfix < thmM + thmS) {
                var f = thmLR * msfix2 / (thmM + thmS);
                thmM *= f;
                thmS *= f;
                assert(thmM + thmS > 0);
            }
            gfc.thm[2].l[sb] = Math.min(thmM, gfc.thm[2].l[sb]);
            gfc.thm[3].l[sb] = Math.min(thmS, gfc.thm[3].l[sb]);
        }

        athlower *= ( Encoder.BLKSIZE_s / Encoder.BLKSIZE);
        for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
            for (var sblock = 0; sblock < 3; sblock++) {
                var thmLR, thmM, thmS, ath;
                ath = (gfc.ATH.cb_s[gfc.bm_s[sb]]) * athlower;
                thmLR = Math.min(Math.max(gfc.thm[0].s[sb][sblock], ath),
                    Math.max(gfc.thm[1].s[sb][sblock], ath));
                thmM = Math.max(gfc.thm[2].s[sb][sblock], ath);
                thmS = Math.max(gfc.thm[3].s[sb][sblock], ath);

                if (thmLR * msfix < thmM + thmS) {
                    var f = thmLR * msfix / (thmM + thmS);
                    thmM *= f;
                    thmS *= f;
                    assert(thmM + thmS > 0);
                }
                gfc.thm[2].s[sb][sblock] = Math.min(gfc.thm[2].s[sb][sblock],
                    thmM);
                gfc.thm[3].s[sb][sblock] = Math.min(gfc.thm[3].s[sb][sblock],
                    thmS);
            }
        }
    }

    /**
     * short block threshold calculation (part 2)
     *
     * partition band bo_s[sfb] is at the transition from scalefactor band sfb
     * to the next one sfb+1; enn and thmm have to be split between them
     */
    function convert_partition2scalefac_s(gfc, eb, thr, chn, sblock) {
        var sb, b;
        var enn = 0.0;
        var thmm = 0.0;
        for (sb = b = 0; sb < Encoder.SBMAX_s; ++b, ++sb) {
            var bo_s_sb = gfc.bo_s[sb];
            var npart_s = gfc.npart_s;
            var b_lim = bo_s_sb < npart_s ? bo_s_sb : npart_s;
            while (b < b_lim) {
                assert(eb[b] >= 0);
                // iff failed, it may indicate some index error elsewhere
                assert(thr[b] >= 0);
                enn += eb[b];
                thmm += thr[b];
                b++;
            }
            gfc.en[chn].s[sb][sblock] = enn;
            gfc.thm[chn].s[sb][sblock] = thmm;

            if (b >= npart_s) {
                ++sb;
                break;
            }
            assert(eb[b] >= 0);
            // iff failed, it may indicate some index error elsewhere
            assert(thr[b] >= 0);
            {
                /* at transition sfb . sfb+1 */
                var w_curr = gfc.PSY.bo_s_weight[sb];
                var w_next = 1.0 - w_curr;
                enn = w_curr * eb[b];
                thmm = w_curr * thr[b];
                gfc.en[chn].s[sb][sblock] += enn;
                gfc.thm[chn].s[sb][sblock] += thmm;
                enn = w_next * eb[b];
                thmm = w_next * thr[b];
            }
        }
        /* zero initialize the rest */
        for (; sb < Encoder.SBMAX_s; ++sb) {
            gfc.en[chn].s[sb][sblock] = 0;
            gfc.thm[chn].s[sb][sblock] = 0;
        }
    }

    /**
     * longblock threshold calculation (part 2)
     */
    function convert_partition2scalefac_l(gfc, eb, thr, chn) {
        var sb, b;
        var enn = 0.0;
        var thmm = 0.0;
        for (sb = b = 0; sb < Encoder.SBMAX_l; ++b, ++sb) {
            var bo_l_sb = gfc.bo_l[sb];
            var npart_l = gfc.npart_l;
            var b_lim = bo_l_sb < npart_l ? bo_l_sb : npart_l;
            while (b < b_lim) {
                assert(eb[b] >= 0);
                // iff failed, it may indicate some index error elsewhere
                assert(thr[b] >= 0);
                enn += eb[b];
                thmm += thr[b];
                b++;
            }
            gfc.en[chn].l[sb] = enn;
            gfc.thm[chn].l[sb] = thmm;

            if (b >= npart_l) {
                ++sb;
                break;
            }
            assert(eb[b] >= 0);
            assert(thr[b] >= 0);
            {
                /* at transition sfb . sfb+1 */
                var w_curr = gfc.PSY.bo_l_weight[sb];
                var w_next = 1.0 - w_curr;
                enn = w_curr * eb[b];
                thmm = w_curr * thr[b];
                gfc.en[chn].l[sb] += enn;
                gfc.thm[chn].l[sb] += thmm;
                enn = w_next * eb[b];
                thmm = w_next * thr[b];
            }
        }
        /* zero initialize the rest */
        for (; sb < Encoder.SBMAX_l; ++sb) {
            gfc.en[chn].l[sb] = 0;
            gfc.thm[chn].l[sb] = 0;
        }
    }

    function compute_masking_s(gfp, fftenergy_s, eb, thr, chn, sblock) {
        var gfc = gfp.internal_flags;
        var j, b;

        for (b = j = 0; b < gfc.npart_s; ++b) {
            var ebb = 0, m = 0;
            var n = gfc.numlines_s[b];
            for (var i = 0; i < n; ++i, ++j) {
                var el = fftenergy_s[sblock][j];
                ebb += el;
                if (m < el)
                    m = el;
            }
            eb[b] = ebb;
        }
        assert(b == gfc.npart_s);
        assert(j == 129);
        for (j = b = 0; b < gfc.npart_s; b++) {
            var kk = gfc.s3ind_s[b][0];
            var ecb = gfc.s3_ss[j++] * eb[kk];
            ++kk;
            while (kk <= gfc.s3ind_s[b][1]) {
                ecb += gfc.s3_ss[j] * eb[kk];
                ++j;
                ++kk;
            }

            { /* limit calculated threshold by previous granule */
                var x = rpelev_s * gfc.nb_s1[chn][b];
                thr[b] = Math.min(ecb, x);
            }
            if (gfc.blocktype_old[chn & 1] == Encoder.SHORT_TYPE) {
                /* limit calculated threshold by even older granule */
                var x = rpelev2_s * gfc.nb_s2[chn][b];
                var y = thr[b];
                thr[b] = Math.min(x, y);
            }

            gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
            gfc.nb_s1[chn][b] = ecb;
            assert(thr[b] >= 0);
        }
        for (; b <= Encoder.CBANDS; ++b) {
            eb[b] = 0;
            thr[b] = 0;
        }
    }

    function block_type_set(gfp, uselongblock, blocktype_d, blocktype) {
        var gfc = gfp.internal_flags;

        if (gfp.short_blocks == ShortBlock.short_block_coupled
                /* force both channels to use the same block type */
                /* this is necessary if the frame is to be encoded in ms_stereo. */
                /* But even without ms_stereo, FhG does this */
            && !(uselongblock[0] != 0 && uselongblock[1] != 0))
            uselongblock[0] = uselongblock[1] = 0;

        /*
         * update the blocktype of the previous granule, since it depends on
         * what happend in this granule
         */
        for (var chn = 0; chn < gfc.channels_out; chn++) {
            blocktype[chn] = Encoder.NORM_TYPE;
            /* disable short blocks */
            if (gfp.short_blocks == ShortBlock.short_block_dispensed)
                uselongblock[chn] = 1;
            if (gfp.short_blocks == ShortBlock.short_block_forced)
                uselongblock[chn] = 0;

            if (uselongblock[chn] != 0) {
                /* no attack : use long blocks */
                assert(gfc.blocktype_old[chn] != Encoder.START_TYPE);
                if (gfc.blocktype_old[chn] == Encoder.SHORT_TYPE)
                    blocktype[chn] = Encoder.STOP_TYPE;
            } else {
                /* attack : use short blocks */
                blocktype[chn] = Encoder.SHORT_TYPE;
                if (gfc.blocktype_old[chn] == Encoder.NORM_TYPE) {
                    gfc.blocktype_old[chn] = Encoder.START_TYPE;
                }
                if (gfc.blocktype_old[chn] == Encoder.STOP_TYPE)
                    gfc.blocktype_old[chn] = Encoder.SHORT_TYPE;
            }

            blocktype_d[chn] = gfc.blocktype_old[chn];
            // value returned to calling program
            gfc.blocktype_old[chn] = blocktype[chn];
            // save for next call to l3psy_anal
        }
    }

    function NS_INTERP(x, y, r) {
        /* was pow((x),(r))*pow((y),1-(r)) */
        if (r >= 1.0) {
            /* 99.7% of the time */
            return x;
        }
        if (r <= 0.0)
            return y;
        if (y > 0.0) {
            /* rest of the time */
            return (Math.pow(x / y, r) * y);
        }
        /* never happens */
        return 0.0;
    }

    /**
     * these values are tuned only for 44.1kHz...
     */
    var regcoef_s = [11.8, 13.6, 17.2, 32, 46.5,
        51.3, 57.5, 67.1, 71.5, 84.6, 97.6, 130,
        /* 255.8 */
    ];

    function pecalc_s(mr, masking_lower) {
        var pe_s = 1236.28 / 4;
        for (var sb = 0; sb < Encoder.SBMAX_s - 1; sb++) {
            for (var sblock = 0; sblock < 3; sblock++) {
                var thm = mr.thm.s[sb][sblock];
                assert(sb < regcoef_s.length);
                if (thm > 0.0) {
                    var x = thm * masking_lower;
                    var en = mr.en.s[sb][sblock];
                    if (en > x) {
                        if (en > x * 1e10) {
                            pe_s += regcoef_s[sb] * (10.0 * LOG10);
                        } else {
                            assert(x > 0);
                            pe_s += regcoef_s[sb] * Util.FAST_LOG10(en / x);
                        }
                    }
                }
            }
        }

        return pe_s;
    }

    /**
     * these values are tuned only for 44.1kHz...
     */
    var regcoef_l = [6.8, 5.8, 5.8, 6.4, 6.5, 9.9,
        12.1, 14.4, 15, 18.9, 21.6, 26.9, 34.2, 40.2, 46.8, 56.5,
        60.7, 73.9, 85.7, 93.4, 126.1,
        /* 241.3 */
    ];

    function pecalc_l(mr, masking_lower) {
        var pe_l = 1124.23 / 4;
        for (var sb = 0; sb < Encoder.SBMAX_l - 1; sb++) {
            var thm = mr.thm.l[sb];
            assert(sb < regcoef_l.length);
            if (thm > 0.0) {
                var x = thm * masking_lower;
                var en = mr.en.l[sb];
                if (en > x) {
                    if (en > x * 1e10) {
                        pe_l += regcoef_l[sb] * (10.0 * LOG10);
                    } else {
                        assert(x > 0);
                        pe_l += regcoef_l[sb] * Util.FAST_LOG10(en / x);
                    }
                }
            }
        }
        return pe_l;
    }

    function calc_energy(gfc, fftenergy, eb, max, avg) {
        var b, j;

        for (b = j = 0; b < gfc.npart_l; ++b) {
            var ebb = 0, m = 0;
            var i;
            for (i = 0; i < gfc.numlines_l[b]; ++i, ++j) {
                var el = fftenergy[j];
                assert(el >= 0);
                ebb += el;
                if (m < el)
                    m = el;
            }
            eb[b] = ebb;
            max[b] = m;
            avg[b] = ebb * gfc.rnumlines_l[b];
            assert(gfc.rnumlines_l[b] >= 0);
            assert(ebb >= 0);
            assert(eb[b] >= 0);
            assert(max[b] >= 0);
            assert(avg[b] >= 0);
        }
    }

    function calc_mask_index_l(gfc, max, avg, mask_idx) {
        var last_tab_entry = tab.length - 1;
        var b = 0;
        var a = avg[b] + avg[b + 1];
        assert(a >= 0);
        if (a > 0.0) {
            var m = max[b];
            if (m < max[b + 1])
                m = max[b + 1];
            assert((gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1) > 0);
            a = 20.0 * (m * 2.0 - a)
                / (a * (gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1));
            var k = 0 | a;
            if (k > last_tab_entry)
                k = last_tab_entry;
            mask_idx[b] = k;
        } else {
            mask_idx[b] = 0;
        }

        for (b = 1; b < gfc.npart_l - 1; b++) {
            a = avg[b - 1] + avg[b] + avg[b + 1];
            assert(a >= 0);
            if (a > 0.0) {
                var m = max[b - 1];
                if (m < max[b])
                    m = max[b];
                if (m < max[b + 1])
                    m = max[b + 1];
                assert((gfc.numlines_l[b - 1] + gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1) > 0);
                a = 20.0
                    * (m * 3.0 - a)
                    / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b]
                    + gfc.numlines_l[b + 1] - 1));
                var k = 0 | a;
                if (k > last_tab_entry)
                    k = last_tab_entry;
                mask_idx[b] = k;
            } else {
                mask_idx[b] = 0;
            }
        }
        assert(b > 0);
        assert(b == gfc.npart_l - 1);

        a = avg[b - 1] + avg[b];
        assert(a >= 0);
        if (a > 0.0) {
            var m = max[b - 1];
            if (m < max[b])
                m = max[b];
            assert((gfc.numlines_l[b - 1] + gfc.numlines_l[b] - 1) > 0);
            a = 20.0 * (m * 2.0 - a)
                / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b] - 1));
            var k = 0 | a;
            if (k > last_tab_entry)
                k = last_tab_entry;
            mask_idx[b] = k;
        } else {
            mask_idx[b] = 0;
        }
        assert(b == (gfc.npart_l - 1));
    }

    var fircoef = [
        -8.65163e-18 * 2, -0.00851586 * 2, -6.74764e-18 * 2, 0.0209036 * 2,
        -3.36639e-17 * 2, -0.0438162 * 2, -1.54175e-17 * 2, 0.0931738 * 2,
        -5.52212e-17 * 2, -0.313819 * 2
    ];

    this.L3psycho_anal_ns = function (gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, percep_entropy, percep_MS_entropy, energy, blocktype_d) {
        /*
         * to get a good cache performance, one has to think about the sequence,
         * in which the variables are used.
         */
        var gfc = gfp.internal_flags;

        /* fft and energy calculation */
        var wsamp_L = new_float_n([2, Encoder.BLKSIZE]);
        var wsamp_S = new_float_n([2, 3, Encoder.BLKSIZE_s]);

        /* convolution */
        var eb_l = new_float(Encoder.CBANDS + 1);
        var eb_s = new_float(Encoder.CBANDS + 1);
        var thr = new_float(Encoder.CBANDS + 2);

        /* block type */
        var blocktype = new_int(2), uselongblock = new_int(2);

        /* usual variables like loop indices, etc.. */
        var numchn, chn;
        var b, i, j, k;
        var sb, sblock;

        /* variables used for --nspsytune */
        var ns_hpfsmpl = new_float_n([2, 576]);
        var pcfact;
        var mask_idx_l = new_int(Encoder.CBANDS + 2), mask_idx_s = new_int(Encoder.CBANDS + 2);

        Arrays.fill(mask_idx_s, 0);

        numchn = gfc.channels_out;
        /* chn=2 and 3 = Mid and Side channels */
        if (gfp.mode == MPEGMode.JOINT_STEREO)
            numchn = 4;

        if (gfp.VBR == VbrMode.vbr_off)
            pcfact = gfc.ResvMax == 0 ? 0 : ( gfc.ResvSize)
            / gfc.ResvMax * 0.5;
        else if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh
            || gfp.VBR == VbrMode.vbr_mt) {
            pcfact = 0.6;
        } else
            pcfact = 1.0;

        /**********************************************************************
         * Apply HPF of fs/4 to the input signal. This is used for attack
         * detection / handling.
         **********************************************************************/
        /* Don't copy the input buffer into a temporary buffer */
        /* unroll the loop 2 times */
        for (chn = 0; chn < gfc.channels_out; chn++) {
            /* apply high pass filter of fs/4 */
            var firbuf = buffer[chn];
            var firbufPos = bufPos + 576 - 350 - NSFIRLEN + 192;
            assert(fircoef.length == ((NSFIRLEN - 1) / 2));
            for (i = 0; i < 576; i++) {
                var sum1, sum2;
                sum1 = firbuf[firbufPos + i + 10];
                sum2 = 0.0;
                for (j = 0; j < ((NSFIRLEN - 1) / 2) - 1; j += 2) {
                    sum1 += fircoef[j]
                        * (firbuf[firbufPos + i + j] + firbuf[firbufPos + i
                        + NSFIRLEN - j]);
                    sum2 += fircoef[j + 1]
                        * (firbuf[firbufPos + i + j + 1] + firbuf[firbufPos
                        + i + NSFIRLEN - j - 1]);
                }
                ns_hpfsmpl[chn][i] = sum1 + sum2;
            }
            masking_ratio[gr_out][chn].en.assign(gfc.en[chn]);
            masking_ratio[gr_out][chn].thm.assign(gfc.thm[chn]);
            if (numchn > 2) {
                /* MS maskings */
                /* percep_MS_entropy [chn-2] = gfc . pe [chn]; */
                masking_MS_ratio[gr_out][chn].en.assign(gfc.en[chn + 2]);
                masking_MS_ratio[gr_out][chn].thm.assign(gfc.thm[chn + 2]);
            }
        }

        for (chn = 0; chn < numchn; chn++) {
            var wsamp_l;
            var wsamp_s;
            var en_subshort = new_float(12);
            var en_short = [0, 0, 0, 0];
            var attack_intensity = new_float(12);
            var ns_uselongblock = 1;
            var attackThreshold;
            var max = new_float(Encoder.CBANDS), avg = new_float(Encoder.CBANDS);
            var ns_attacks = [0, 0, 0, 0];
            var fftenergy = new_float(Encoder.HBLKSIZE);
            var fftenergy_s = new_float_n([3, Encoder.HBLKSIZE_s]);

            /*
             * rh 20040301: the following loops do access one off the limits so
             * I increase the array dimensions by one and initialize the
             * accessed values to zero
             */
            assert(gfc.npart_s <= Encoder.CBANDS);
            assert(gfc.npart_l <= Encoder.CBANDS);

            /***************************************************************
             * determine the block type (window type)
             ***************************************************************/
            /* calculate energies of each sub-shortblocks */
            for (i = 0; i < 3; i++) {
                en_subshort[i] = gfc.nsPsy.last_en_subshort[chn][i + 6];
                assert(gfc.nsPsy.last_en_subshort[chn][i + 4] > 0);
                attack_intensity[i] = en_subshort[i]
                    / gfc.nsPsy.last_en_subshort[chn][i + 4];
                en_short[0] += en_subshort[i];
            }

            if (chn == 2) {
                for (i = 0; i < 576; i++) {
                    var l, r;
                    l = ns_hpfsmpl[0][i];
                    r = ns_hpfsmpl[1][i];
                    ns_hpfsmpl[0][i] = l + r;
                    ns_hpfsmpl[1][i] = l - r;
                }
            }
            {
                var pf = ns_hpfsmpl[chn & 1];
                var pfPos = 0;
                for (i = 0; i < 9; i++) {
                    var pfe = pfPos + 576 / 9;
                    var p = 1.;
                    for (; pfPos < pfe; pfPos++)
                        if (p < Math.abs(pf[pfPos]))
                            p = Math.abs(pf[pfPos]);

                    gfc.nsPsy.last_en_subshort[chn][i] = en_subshort[i + 3] = p;
                    en_short[1 + i / 3] += p;
                    if (p > en_subshort[i + 3 - 2]) {
                        assert(en_subshort[i + 3 - 2] > 0);
                        p = p / en_subshort[i + 3 - 2];
                    } else if (en_subshort[i + 3 - 2] > p * 10.0) {
                        assert(p > 0);
                        p = en_subshort[i + 3 - 2] / (p * 10.0);
                    } else
                        p = 0.0;
                    attack_intensity[i + 3] = p;
                }
            }

            if (gfp.analysis) {
                var x = attack_intensity[0];
                for (i = 1; i < 12; i++)
                    if (x < attack_intensity[i])
                        x = attack_intensity[i];
                gfc.pinfo.ers[gr_out][chn] = gfc.pinfo.ers_save[chn];
                gfc.pinfo.ers_save[chn] = x;
            }

            /* compare energies between sub-shortblocks */
            attackThreshold = (chn == 3) ? gfc.nsPsy.attackthre_s
                : gfc.nsPsy.attackthre;
            for (i = 0; i < 12; i++)
                if (0 == ns_attacks[i / 3]
                    && attack_intensity[i] > attackThreshold)
                    ns_attacks[i / 3] = (i % 3) + 1;

            /*
             * should have energy change between short blocks, in order to avoid
             * periodic signals
             */
            for (i = 1; i < 4; i++) {
                var ratio;
                if (en_short[i - 1] > en_short[i]) {
                    assert(en_short[i] > 0);
                    ratio = en_short[i - 1] / en_short[i];
                } else {
                    assert(en_short[i - 1] > 0);
                    ratio = en_short[i] / en_short[i - 1];
                }
                if (ratio < 1.7) {
                    ns_attacks[i] = 0;
                    if (i == 1)
                        ns_attacks[0] = 0;
                }
            }

            if (ns_attacks[0] != 0 && gfc.nsPsy.lastAttacks[chn] != 0)
                ns_attacks[0] = 0;

            if (gfc.nsPsy.lastAttacks[chn] == 3
                || (ns_attacks[0] + ns_attacks[1] + ns_attacks[2] + ns_attacks[3]) != 0) {
                ns_uselongblock = 0;

                if (ns_attacks[1] != 0 && ns_attacks[0] != 0)
                    ns_attacks[1] = 0;
                if (ns_attacks[2] != 0 && ns_attacks[1] != 0)
                    ns_attacks[2] = 0;
                if (ns_attacks[3] != 0 && ns_attacks[2] != 0)
                    ns_attacks[3] = 0;
            }

            if (chn < 2) {
                uselongblock[chn] = ns_uselongblock;
            } else {
                if (ns_uselongblock == 0) {
                    uselongblock[0] = uselongblock[1] = 0;
                }
            }

            /*
             * there is a one granule delay. Copy maskings computed last call
             * into masking_ratio to return to calling program.
             */
            energy[chn] = gfc.tot_ener[chn];

            /*********************************************************************
             * compute FFTs
             *********************************************************************/
            wsamp_s = wsamp_S;
            wsamp_l = wsamp_L;
            compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, (chn & 1),
                wsamp_s, (chn & 1), gr_out, chn, buffer, bufPos);

            /*********************************************************************
             * Calculate the energy and the tonality of each partition.
             *********************************************************************/
            calc_energy(gfc, fftenergy, eb_l, max, avg);
            calc_mask_index_l(gfc, max, avg, mask_idx_l);
            /* compute masking thresholds for short blocks */
            for (sblock = 0; sblock < 3; sblock++) {
                var enn, thmm;
                compute_masking_s(gfp, fftenergy_s, eb_s, thr, chn, sblock);
                convert_partition2scalefac_s(gfc, eb_s, thr, chn, sblock);
                /**** short block pre-echo control ****/
                for (sb = 0; sb < Encoder.SBMAX_s; sb++) {
                    thmm = gfc.thm[chn].s[sb][sblock];

                    thmm *= NS_PREECHO_ATT0;
                    if (ns_attacks[sblock] >= 2 || ns_attacks[sblock + 1] == 1) {
                        var idx = (sblock != 0) ? sblock - 1 : 2;
                        var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                            NS_PREECHO_ATT1 * pcfact);
                        thmm = Math.min(thmm, p);
                    }

                    if (ns_attacks[sblock] == 1) {
                        var idx = (sblock != 0) ? sblock - 1 : 2;
                        var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                            NS_PREECHO_ATT2 * pcfact);
                        thmm = Math.min(thmm, p);
                    } else if ((sblock != 0 && ns_attacks[sblock - 1] == 3)
                        || (sblock == 0 && gfc.nsPsy.lastAttacks[chn] == 3)) {
                        var idx = (sblock != 2) ? sblock + 1 : 0;
                        var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                            NS_PREECHO_ATT2 * pcfact);
                        thmm = Math.min(thmm, p);
                    }

                    /* pulse like signal detection for fatboy.wav and so on */
                    enn = en_subshort[sblock * 3 + 3]
                        + en_subshort[sblock * 3 + 4]
                        + en_subshort[sblock * 3 + 5];
                    if (en_subshort[sblock * 3 + 5] * 6 < enn) {
                        thmm *= 0.5;
                        if (en_subshort[sblock * 3 + 4] * 6 < enn)
                            thmm *= 0.5;
                    }

                    gfc.thm[chn].s[sb][sblock] = thmm;
                }
            }
            gfc.nsPsy.lastAttacks[chn] = ns_attacks[2];

            /*********************************************************************
             * convolve the partitioned energy and unpredictability with the
             * spreading function, s3_l[b][k]
             ********************************************************************/
            k = 0;
            {
                for (b = 0; b < gfc.npart_l; b++) {
                    /*
                     * convolve the partitioned energy with the spreading
                     * function
                     */
                    var kk = gfc.s3ind[b][0];
                    var eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
                    var ecb = gfc.s3_ll[k++] * eb2;
                    while (++kk <= gfc.s3ind[b][1]) {
                        eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
                        ecb = mask_add(ecb, gfc.s3_ll[k++] * eb2, kk, kk - b,
                            gfc, 0);
                    }
                    ecb *= 0.158489319246111;
                    /* pow(10,-0.8) */

                    /**** long block pre-echo control ****/
                    /**
                     * <PRE>
                     * dont use long block pre-echo control if previous granule was
                     * a short block.  This is to avoid the situation:
                     * frame0:  quiet (very low masking)
                     * frame1:  surge  (triggers short blocks)
                     * frame2:  regular frame.  looks like pre-echo when compared to
                     *          frame0, but all pre-echo was in frame1.
                     * </PRE>
                     */
                    /*
                     * chn=0,1 L and R channels
                     *
                     * chn=2,3 S and M channels.
                     */

                    if (gfc.blocktype_old[chn & 1] == Encoder.SHORT_TYPE)
                        thr[b] = ecb;
                    else
                        thr[b] = NS_INTERP(
                            Math.min(ecb, Math.min(rpelev
                                * gfc.nb_1[chn][b], rpelev2
                                * gfc.nb_2[chn][b])), ecb, pcfact);

                    gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
                    gfc.nb_1[chn][b] = ecb;
                }
            }
            for (; b <= Encoder.CBANDS; ++b) {
                eb_l[b] = 0;
                thr[b] = 0;
            }
            /* compute masking thresholds for long blocks */
            convert_partition2scalefac_l(gfc, eb_l, thr, chn);
        }
        /* end loop over chn */

        if (gfp.mode == MPEGMode.STEREO || gfp.mode == MPEGMode.JOINT_STEREO) {
            if (gfp.interChRatio > 0.0) {
                calc_interchannel_masking(gfp, gfp.interChRatio);
            }
        }

        if (gfp.mode == MPEGMode.JOINT_STEREO) {
            var msfix;
            msfix1(gfc);
            msfix = gfp.msfix;
            if (Math.abs(msfix) > 0.0)
                ns_msfix(gfc, msfix, gfp.ATHlower * gfc.ATH.adjust);
        }

        /***************************************************************
         * determine final block type
         ***************************************************************/
        block_type_set(gfp, uselongblock, blocktype_d, blocktype);

        /*********************************************************************
         * compute the value of PE to return ... no delay and advance
         *********************************************************************/
        for (chn = 0; chn < numchn; chn++) {
            var ppe;
            var ppePos = 0;
            var type;
            var mr;

            if (chn > 1) {
                ppe = percep_MS_entropy;
                ppePos = -2;
                type = Encoder.NORM_TYPE;
                if (blocktype_d[0] == Encoder.SHORT_TYPE
                    || blocktype_d[1] == Encoder.SHORT_TYPE)
                    type = Encoder.SHORT_TYPE;
                mr = masking_MS_ratio[gr_out][chn - 2];
            } else {
                ppe = percep_entropy;
                ppePos = 0;
                type = blocktype_d[chn];
                mr = masking_ratio[gr_out][chn];
            }

            if (type == Encoder.SHORT_TYPE)
                ppe[ppePos + chn] = pecalc_s(mr, gfc.masking_lower);
            else
                ppe[ppePos + chn] = pecalc_l(mr, gfc.masking_lower);

            if (gfp.analysis)
                gfc.pinfo.pe[gr_out][chn] = ppe[ppePos + chn];

        }
        return 0;
    }

    function vbrpsy_compute_fft_l(gfp, buffer, bufPos, chn, gr_out, fftenergy, wsamp_l, wsamp_lPos) {
        var gfc = gfp.internal_flags;
        if (chn < 2) {
            fft.fft_long(gfc, wsamp_l[wsamp_lPos], chn, buffer, bufPos);
        } else if (chn == 2) {
            /* FFT data for mid and side channel is derived from L & R */
            for (var j = Encoder.BLKSIZE - 1; j >= 0; --j) {
                var l = wsamp_l[wsamp_lPos + 0][j];
                var r = wsamp_l[wsamp_lPos + 1][j];
                wsamp_l[wsamp_lPos + 0][j] = (l + r) * Util.SQRT2 * 0.5;
                wsamp_l[wsamp_lPos + 1][j] = (l - r) * Util.SQRT2 * 0.5;
            }
        }

        /*********************************************************************
         * compute energies
         *********************************************************************/
        fftenergy[0] = NON_LINEAR_SCALE_ENERGY(wsamp_l[wsamp_lPos + 0][0]);
        fftenergy[0] *= fftenergy[0];

        for (var j = Encoder.BLKSIZE / 2 - 1; j >= 0; --j) {
            var re = wsamp_l[wsamp_lPos + 0][Encoder.BLKSIZE / 2 - j];
            var im = wsamp_l[wsamp_lPos + 0][Encoder.BLKSIZE / 2 + j];
            fftenergy[Encoder.BLKSIZE / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
                * re + im * im) * 0.5);
        }
        /* total energy */
        {
            var totalenergy = 0.0;
            for (var j = 11; j < Encoder.HBLKSIZE; j++)
                totalenergy += fftenergy[j];

            gfc.tot_ener[chn] = totalenergy;
        }

        if (gfp.analysis) {
            for (var j = 0; j < Encoder.HBLKSIZE; j++) {
                gfc.pinfo.energy[gr_out][chn][j] = gfc.pinfo.energy_save[chn][j];
                gfc.pinfo.energy_save[chn][j] = fftenergy[j];
            }
            gfc.pinfo.pe[gr_out][chn] = gfc.pe[chn];
        }
    }

    function vbrpsy_compute_fft_s(gfp, buffer, bufPos, chn, sblock, fftenergy_s, wsamp_s, wsamp_sPos) {
        var gfc = gfp.internal_flags;

        if (sblock == 0 && chn < 2) {
            fft.fft_short(gfc, wsamp_s[wsamp_sPos], chn, buffer, bufPos);
        }
        if (chn == 2) {
            /* FFT data for mid and side channel is derived from L & R */
            for (var j = Encoder.BLKSIZE_s - 1; j >= 0; --j) {
                var l = wsamp_s[wsamp_sPos + 0][sblock][j];
                var r = wsamp_s[wsamp_sPos + 1][sblock][j];
                wsamp_s[wsamp_sPos + 0][sblock][j] = (l + r) * Util.SQRT2 * 0.5;
                wsamp_s[wsamp_sPos + 1][sblock][j] = (l - r) * Util.SQRT2 * 0.5;
            }
        }

        /*********************************************************************
         * compute energies
         *********************************************************************/
        fftenergy_s[sblock][0] = wsamp_s[wsamp_sPos + 0][sblock][0];
        fftenergy_s[sblock][0] *= fftenergy_s[sblock][0];
        for (var j = Encoder.BLKSIZE_s / 2 - 1; j >= 0; --j) {
            var re = wsamp_s[wsamp_sPos + 0][sblock][Encoder.BLKSIZE_s / 2 - j];
            var im = wsamp_s[wsamp_sPos + 0][sblock][Encoder.BLKSIZE_s / 2 + j];
            fftenergy_s[sblock][Encoder.BLKSIZE_s / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
                * re + im * im) * 0.5);
        }
    }

    /**
     * compute loudness approximation (used for ATH auto-level adjustment)
     */
    function vbrpsy_compute_loudness_approximation_l(gfp, gr_out, chn, fftenergy) {
        var gfc = gfp.internal_flags;
        if (gfp.athaa_loudapprox == 2 && chn < 2) {
            // no loudness for mid/side ch
            gfc.loudness_sq[gr_out][chn] = gfc.loudness_sq_save[chn];
            gfc.loudness_sq_save[chn] = psycho_loudness_approx(fftenergy, gfc);
        }
    }

    var fircoef_ = [-8.65163e-18 * 2,
        -0.00851586 * 2, -6.74764e-18 * 2, 0.0209036 * 2,
        -3.36639e-17 * 2, -0.0438162 * 2, -1.54175e-17 * 2,
        0.0931738 * 2, -5.52212e-17 * 2, -0.313819 * 2];

    /**
     * Apply HPF of fs/4 to the input signal. This is used for attack detection
     * / handling.
     */
    function vbrpsy_attack_detection(gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, energy, sub_short_factor, ns_attacks, uselongblock) {
        var ns_hpfsmpl = new_float_n([2, 576]);
        var gfc = gfp.internal_flags;
        var n_chn_out = gfc.channels_out;
        /* chn=2 and 3 = Mid and Side channels */
        var n_chn_psy = (gfp.mode == MPEGMode.JOINT_STEREO) ? 4 : n_chn_out;
        /* Don't copy the input buffer into a temporary buffer */
        /* unroll the loop 2 times */
        for (var chn = 0; chn < n_chn_out; chn++) {
            /* apply high pass filter of fs/4 */
            firbuf = buffer[chn];
            var firbufPos = bufPos + 576 - 350 - NSFIRLEN + 192;
            assert(fircoef_.length == ((NSFIRLEN - 1) / 2));
            for (var i = 0; i < 576; i++) {
                var sum1, sum2;
                sum1 = firbuf[firbufPos + i + 10];
                sum2 = 0.0;
                for (var j = 0; j < ((NSFIRLEN - 1) / 2) - 1; j += 2) {
                    sum1 += fircoef_[j]
                        * (firbuf[firbufPos + i + j] + firbuf[firbufPos + i
                        + NSFIRLEN - j]);
                    sum2 += fircoef_[j + 1]
                        * (firbuf[firbufPos + i + j + 1] + firbuf[firbufPos
                        + i + NSFIRLEN - j - 1]);
                }
                ns_hpfsmpl[chn][i] = sum1 + sum2;
            }
            masking_ratio[gr_out][chn].en.assign(gfc.en[chn]);
            masking_ratio[gr_out][chn].thm.assign(gfc.thm[chn]);
            if (n_chn_psy > 2) {
                /* MS maskings */
                /* percep_MS_entropy [chn-2] = gfc . pe [chn]; */
                masking_MS_ratio[gr_out][chn].en.assign(gfc.en[chn + 2]);
                masking_MS_ratio[gr_out][chn].thm.assign(gfc.thm[chn + 2]);
            }
        }
        for (var chn = 0; chn < n_chn_psy; chn++) {
            var attack_intensity = new_float(12);
            var en_subshort = new_float(12);
            var en_short = [0, 0, 0, 0];
            var pf = ns_hpfsmpl[chn & 1];
            var pfPos = 0;
            var attackThreshold = (chn == 3) ? gfc.nsPsy.attackthre_s
                : gfc.nsPsy.attackthre;
            var ns_uselongblock = 1;

            if (chn == 2) {
                for (var i = 0, j = 576; j > 0; ++i, --j) {
                    var l = ns_hpfsmpl[0][i];
                    var r = ns_hpfsmpl[1][i];
                    ns_hpfsmpl[0][i] = l + r;
                    ns_hpfsmpl[1][i] = l - r;
                }
            }
            /***************************************************************
             * determine the block type (window type)
             ***************************************************************/
            /* calculate energies of each sub-shortblocks */
            for (var i = 0; i < 3; i++) {
                en_subshort[i] = gfc.nsPsy.last_en_subshort[chn][i + 6];
                assert(gfc.nsPsy.last_en_subshort[chn][i + 4] > 0);
                attack_intensity[i] = en_subshort[i]
                    / gfc.nsPsy.last_en_subshort[chn][i + 4];
                en_short[0] += en_subshort[i];
            }

            for (var i = 0; i < 9; i++) {
                var pfe = pfPos + 576 / 9;
                var p = 1.;
                for (; pfPos < pfe; pfPos++)
                    if (p < Math.abs(pf[pfPos]))
                        p = Math.abs(pf[pfPos]);

                gfc.nsPsy.last_en_subshort[chn][i] = en_subshort[i + 3] = p;
                en_short[1 + i / 3] += p;
                if (p > en_subshort[i + 3 - 2]) {
                    assert(en_subshort[i + 3 - 2] > 0);
                    p = p / en_subshort[i + 3 - 2];
                } else if (en_subshort[i + 3 - 2] > p * 10.0) {
                    assert(p > 0);
                    p = en_subshort[i + 3 - 2] / (p * 10.0);
                } else {
                    p = 0.0;
                }
                attack_intensity[i + 3] = p;
            }
            /* pulse like signal detection for fatboy.wav and so on */
            for (var i = 0; i < 3; ++i) {
                var enn = en_subshort[i * 3 + 3]
                    + en_subshort[i * 3 + 4] + en_subshort[i * 3 + 5];
                var factor = 1.;
                if (en_subshort[i * 3 + 5] * 6 < enn) {
                    factor *= 0.5;
                    if (en_subshort[i * 3 + 4] * 6 < enn) {
                        factor *= 0.5;
                    }
                }
                sub_short_factor[chn][i] = factor;
            }

            if (gfp.analysis) {
                var x = attack_intensity[0];
                for (var i = 1; i < 12; i++) {
                    if (x < attack_intensity[i]) {
                        x = attack_intensity[i];
                    }
                }
                gfc.pinfo.ers[gr_out][chn] = gfc.pinfo.ers_save[chn];
                gfc.pinfo.ers_save[chn] = x;
            }

            /* compare energies between sub-shortblocks */
            for (var i = 0; i < 12; i++) {
                if (0 == ns_attacks[chn][i / 3]
                    && attack_intensity[i] > attackThreshold) {
                    ns_attacks[chn][i / 3] = (i % 3) + 1;
                }
            }

            /*
             * should have energy change between short blocks, in order to avoid
             * periodic signals
             */
            /* Good samples to show the effect are Trumpet test songs */
            /*
             * GB: tuned (1) to avoid too many short blocks for test sample
             * TRUMPET
             */
            /*
             * RH: tuned (2) to let enough short blocks through for test sample
             * FSOL and SNAPS
             */
            for (var i = 1; i < 4; i++) {
                var u = en_short[i - 1];
                var v = en_short[i];
                var m = Math.max(u, v);
                if (m < 40000) { /* (2) */
                    if (u < 1.7 * v && v < 1.7 * u) { /* (1) */
                        if (i == 1 && ns_attacks[chn][0] <= ns_attacks[chn][i]) {
                            ns_attacks[chn][0] = 0;
                        }
                        ns_attacks[chn][i] = 0;
                    }
                }
            }

            if (ns_attacks[chn][0] <= gfc.nsPsy.lastAttacks[chn]) {
                ns_attacks[chn][0] = 0;
            }

            if (gfc.nsPsy.lastAttacks[chn] == 3
                || (ns_attacks[chn][0] + ns_attacks[chn][1]
                + ns_attacks[chn][2] + ns_attacks[chn][3]) != 0) {
                ns_uselongblock = 0;

                if (ns_attacks[chn][1] != 0 && ns_attacks[chn][0] != 0) {
                    ns_attacks[chn][1] = 0;
                }
                if (ns_attacks[chn][2] != 0 && ns_attacks[chn][1] != 0) {
                    ns_attacks[chn][2] = 0;
                }
                if (ns_attacks[chn][3] != 0 && ns_attacks[chn][2] != 0) {
                    ns_attacks[chn][3] = 0;
                }
            }
            if (chn < 2) {
                uselongblock[chn] = ns_uselongblock;
            } else {
                if (ns_uselongblock == 0) {
                    uselongblock[0] = uselongblock[1] = 0;
                }
            }

            /*
             * there is a one granule delay. Copy maskings computed last call
             * into masking_ratio to return to calling program.
             */
            energy[chn] = gfc.tot_ener[chn];
        }
    }

    function vbrpsy_skip_masking_s(gfc, chn, sblock) {
        if (sblock == 0) {
            for (var b = 0; b < gfc.npart_s; b++) {
                gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
                gfc.nb_s1[chn][b] = 0;
            }
        }
    }

    function vbrpsy_skip_masking_l(gfc, chn) {
        for (var b = 0; b < gfc.npart_l; b++) {
            gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
            gfc.nb_1[chn][b] = 0;
        }
    }

    function psyvbr_calc_mask_index_s(gfc, max, avg, mask_idx) {
        var last_tab_entry = tab.length - 1;
        var b = 0;
        var a = avg[b] + avg[b + 1];
        assert(a >= 0);
        if (a > 0.0) {
            var m = max[b];
            if (m < max[b + 1])
                m = max[b + 1];
            assert((gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1) > 0);
            a = 20.0 * (m * 2.0 - a)
                / (a * (gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1));
            var k = 0 | a;
            if (k > last_tab_entry)
                k = last_tab_entry;
            mask_idx[b] = k;
        } else {
            mask_idx[b] = 0;
        }

        for (b = 1; b < gfc.npart_s - 1; b++) {
            a = avg[b - 1] + avg[b] + avg[b + 1];
            assert(b + 1 < gfc.npart_s);
            assert(a >= 0);
            if (a > 0.0) {
                var m = max[b - 1];
                if (m < max[b])
                    m = max[b];
                if (m < max[b + 1])
                    m = max[b + 1];
                assert((gfc.numlines_s[b - 1] + gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1) > 0);
                a = 20.0
                    * (m * 3.0 - a)
                    / (a * (gfc.numlines_s[b - 1] + gfc.numlines_s[b]
                    + gfc.numlines_s[b + 1] - 1));
                var k = 0 | a;
                if (k > last_tab_entry)
                    k = last_tab_entry;
                mask_idx[b] = k;
            } else {
                mask_idx[b] = 0;
            }
        }
        assert(b > 0);
        assert(b == gfc.npart_s - 1);

        a = avg[b - 1] + avg[b];
        assert(a >= 0);
        if (a > 0.0) {
            var m = max[b - 1];
            if (m < max[b])
                m = max[b];
            assert((gfc.numlines_s[b - 1] + gfc.numlines_s[b] - 1) > 0);
            a = 20.0 * (m * 2.0 - a)
                / (a * (gfc.numlines_s[b - 1] + gfc.numlines_s[b] - 1));
            var k = 0 | a;
            if (k > last_tab_entry)
                k = last_tab_entry;
            mask_idx[b] = k;
        } else {
            mask_idx[b] = 0;
        }
        assert(b == (gfc.npart_s - 1));
    }

    function vbrpsy_compute_masking_s(gfp, fftenergy_s, eb, thr, chn, sblock) {
        var gfc = gfp.internal_flags;
        var max = new float[Encoder.CBANDS], avg = new_float(Encoder.CBANDS);
        var i, j, b;
        var mask_idx_s = new int[Encoder.CBANDS];

        for (b = j = 0; b < gfc.npart_s; ++b) {
            var ebb = 0, m = 0;
            var n = gfc.numlines_s[b];
            for (i = 0; i < n; ++i, ++j) {
                var el = fftenergy_s[sblock][j];
                ebb += el;
                if (m < el)
                    m = el;
            }
            eb[b] = ebb;
            assert(ebb >= 0);
            max[b] = m;
            assert(n > 0);
            avg[b] = ebb / n;
            assert(avg[b] >= 0);
        }
        assert(b == gfc.npart_s);
        assert(j == 129);
        for (; b < Encoder.CBANDS; ++b) {
            max[b] = 0;
            avg[b] = 0;
        }
        psyvbr_calc_mask_index_s(gfc, max, avg, mask_idx_s);
        for (j = b = 0; b < gfc.npart_s; b++) {
            var kk = gfc.s3ind_s[b][0];
            var last = gfc.s3ind_s[b][1];
            var dd, dd_n;
            var x, ecb, avg_mask;
            dd = mask_idx_s[kk];
            dd_n = 1;
            ecb = gfc.s3_ss[j] * eb[kk] * tab[mask_idx_s[kk]];
            ++j;
            ++kk;
            while (kk <= last) {
                dd += mask_idx_s[kk];
                dd_n += 1;
                x = gfc.s3_ss[j] * eb[kk] * tab[mask_idx_s[kk]];
                ecb = vbrpsy_mask_add(ecb, x, kk - b);
                ++j;
                ++kk;
            }
            dd = (1 + 2 * dd) / (2 * dd_n);
            avg_mask = tab[dd] * 0.5;
            ecb *= avg_mask;
            thr[b] = ecb;
            gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
            gfc.nb_s1[chn][b] = ecb;
            {
                /*
                 * if THR exceeds EB, the quantization routines will take the
                 * difference from other bands. in case of strong tonal samples
                 * (tonaltest.wav) this leads to heavy distortions. that's why
                 * we limit THR here.
                 */
                x = max[b];
                x *= gfc.minval_s[b];
                x *= avg_mask;
                if (thr[b] > x) {
                    thr[b] = x;
                }
            }
            if (gfc.masking_lower > 1) {
                thr[b] *= gfc.masking_lower;
            }
            if (thr[b] > eb[b]) {
                thr[b] = eb[b];
            }
            if (gfc.masking_lower < 1) {
                thr[b] *= gfc.masking_lower;
            }

            assert(thr[b] >= 0);
        }
        for (; b < Encoder.CBANDS; ++b) {
            eb[b] = 0;
            thr[b] = 0;
        }
    }

    function vbrpsy_compute_masking_l(gfc, fftenergy, eb_l, thr, chn) {
        var max = new_float(Encoder.CBANDS), avg = new_float(Encoder.CBANDS);
        var mask_idx_l = new_int(Encoder.CBANDS + 2);
        var b;

        /*********************************************************************
         * Calculate the energy and the tonality of each partition.
         *********************************************************************/
        calc_energy(gfc, fftenergy, eb_l, max, avg);
        calc_mask_index_l(gfc, max, avg, mask_idx_l);

        /*********************************************************************
         * convolve the partitioned energy and unpredictability with the
         * spreading function, s3_l[b][k]
         ********************************************************************/
        var k = 0;
        for (b = 0; b < gfc.npart_l; b++) {
            var x, ecb, avg_mask, t;
            /* convolve the partitioned energy with the spreading function */
            var kk = gfc.s3ind[b][0];
            var last = gfc.s3ind[b][1];
            var dd = 0, dd_n = 0;
            dd = mask_idx_l[kk];
            dd_n += 1;
            ecb = gfc.s3_ll[k] * eb_l[kk] * tab[mask_idx_l[kk]];
            ++k;
            ++kk;
            while (kk <= last) {
                dd += mask_idx_l[kk];
                dd_n += 1;
                x = gfc.s3_ll[k] * eb_l[kk] * tab[mask_idx_l[kk]];
                t = vbrpsy_mask_add(ecb, x, kk - b);
                ecb = t;
                ++k;
                ++kk;
            }
            dd = (1 + 2 * dd) / (2 * dd_n);
            avg_mask = tab[dd] * 0.5;
            ecb *= avg_mask;

            /**** long block pre-echo control ****/
            /**
             * <PRE>
             * dont use long block pre-echo control if previous granule was
             * a short block.  This is to avoid the situation:
             * frame0:  quiet (very low masking)
             * frame1:  surge  (triggers short blocks)
             * frame2:  regular frame.  looks like pre-echo when compared to
             *          frame0, but all pre-echo was in frame1.
             * </PRE>
             */
            /*
             * chn=0,1 L and R channels chn=2,3 S and M channels.
             */
            if (gfc.blocktype_old[chn & 0x01] == Encoder.SHORT_TYPE) {
                var ecb_limit = rpelev * gfc.nb_1[chn][b];
                if (ecb_limit > 0) {
                    thr[b] = Math.min(ecb, ecb_limit);
                } else {
                    /**
                     * <PRE>
                     * Robert 071209:
                     * Because we don't calculate long block psy when we know a granule
                     * should be of short blocks, we don't have any clue how the granule
                     * before would have looked like as a long block. So we have to guess
                     * a little bit for this END_TYPE block.
                     * Most of the time we get away with this sloppyness. (fingers crossed :)
                     * The speed increase is worth it.
                     * </PRE>
                     */
                    thr[b] = Math.min(ecb, eb_l[b] * NS_PREECHO_ATT2);
                }
            } else {
                var ecb_limit_2 = rpelev2 * gfc.nb_2[chn][b];
                var ecb_limit_1 = rpelev * gfc.nb_1[chn][b];
                var ecb_limit;
                if (ecb_limit_2 <= 0) {
                    ecb_limit_2 = ecb;
                }
                if (ecb_limit_1 <= 0) {
                    ecb_limit_1 = ecb;
                }
                if (gfc.blocktype_old[chn & 0x01] == Encoder.NORM_TYPE) {
                    ecb_limit = Math.min(ecb_limit_1, ecb_limit_2);
                } else {
                    ecb_limit = ecb_limit_1;
                }
                thr[b] = Math.min(ecb, ecb_limit);
            }
            gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
            gfc.nb_1[chn][b] = ecb;
            {
                /*
                 * if THR exceeds EB, the quantization routines will take the
                 * difference from other bands. in case of strong tonal samples
                 * (tonaltest.wav) this leads to heavy distortions. that's why
                 * we limit THR here.
                 */
                x = max[b];
                x *= gfc.minval_l[b];
                x *= avg_mask;
                if (thr[b] > x) {
                    thr[b] = x;
                }
            }
            if (gfc.masking_lower > 1) {
                thr[b] *= gfc.masking_lower;
            }
            if (thr[b] > eb_l[b]) {
                thr[b] = eb_l[b];
            }
            if (gfc.masking_lower < 1) {
                thr[b] *= gfc.masking_lower;
            }
            assert(thr[b] >= 0);
        }
        for (; b < Encoder.CBANDS; ++b) {
            eb_l[b] = 0;
            thr[b] = 0;
        }
    }

    function vbrpsy_compute_block_type(gfp, uselongblock) {
        var gfc = gfp.internal_flags;

        if (gfp.short_blocks == ShortBlock.short_block_coupled
                /* force both channels to use the same block type */
                /* this is necessary if the frame is to be encoded in ms_stereo. */
                /* But even without ms_stereo, FhG does this */
            && !(uselongblock[0] != 0 && uselongblock[1] != 0))
            uselongblock[0] = uselongblock[1] = 0;

        for (var chn = 0; chn < gfc.channels_out; chn++) {
            /* disable short blocks */
            if (gfp.short_blocks == ShortBlock.short_block_dispensed) {
                uselongblock[chn] = 1;
            }
            if (gfp.short_blocks == ShortBlock.short_block_forced) {
                uselongblock[chn] = 0;
            }
        }
    }

    function vbrpsy_apply_block_type(gfp, uselongblock, blocktype_d) {
        var gfc = gfp.internal_flags;

        /*
         * update the blocktype of the previous granule, since it depends on
         * what happend in this granule
         */
        for (var chn = 0; chn < gfc.channels_out; chn++) {
            var blocktype = Encoder.NORM_TYPE;
            /* disable short blocks */

            if (uselongblock[chn] != 0) {
                /* no attack : use long blocks */
                assert(gfc.blocktype_old[chn] != Encoder.START_TYPE);
                if (gfc.blocktype_old[chn] == Encoder.SHORT_TYPE)
                    blocktype = Encoder.STOP_TYPE;
            } else {
                /* attack : use short blocks */
                blocktype = Encoder.SHORT_TYPE;
                if (gfc.blocktype_old[chn] == Encoder.NORM_TYPE) {
                    gfc.blocktype_old[chn] = Encoder.START_TYPE;
                }
                if (gfc.blocktype_old[chn] == Encoder.STOP_TYPE)
                    gfc.blocktype_old[chn] = Encoder.SHORT_TYPE;
            }

            blocktype_d[chn] = gfc.blocktype_old[chn];
            // value returned to calling program
            gfc.blocktype_old[chn] = blocktype;
            // save for next call to l3psy_anal
        }
    }

    /**
     * compute M/S thresholds from Johnston & Ferreira 1992 ICASSP paper
     */
    function vbrpsy_compute_MS_thresholds(eb, thr, cb_mld, ath_cb, athadjust, msfix, n) {
        var msfix2 = msfix * 2;
        var athlower = msfix > 0 ? Math.pow(10, athadjust) : 1;
        var rside, rmid;
        for (var b = 0; b < n; ++b) {
            var ebM = eb[2][b];
            var ebS = eb[3][b];
            var thmL = thr[0][b];
            var thmR = thr[1][b];
            var thmM = thr[2][b];
            var thmS = thr[3][b];

            /* use this fix if L & R masking differs by 2db or less */
            if (thmL <= 1.58 * thmR && thmR <= 1.58 * thmL) {
                var mld_m = cb_mld[b] * ebS;
                var mld_s = cb_mld[b] * ebM;
                rmid = Math.max(thmM, Math.min(thmS, mld_m));
                rside = Math.max(thmS, Math.min(thmM, mld_s));
            } else {
                rmid = thmM;
                rside = thmS;
            }
            if (msfix > 0) {
                /***************************************************************/
                /* Adjust M/S maskings if user set "msfix" */
                /***************************************************************/
                /* Naoki Shibata 2000 */
                var thmLR, thmMS;
                var ath = ath_cb[b] * athlower;
                thmLR = Math.min(Math.max(thmL, ath), Math.max(thmR, ath));
                thmM = Math.max(rmid, ath);
                thmS = Math.max(rside, ath);
                thmMS = thmM + thmS;
                if (thmMS > 0 && (thmLR * msfix2) < thmMS) {
                    var f = thmLR * msfix2 / thmMS;
                    thmM *= f;
                    thmS *= f;
                    assert(thmMS > 0);
                }
                rmid = Math.min(thmM, rmid);
                rside = Math.min(thmS, rside);
            }
            if (rmid > ebM) {
                rmid = ebM;
            }
            if (rside > ebS) {
                rside = ebS;
            }
            thr[2][b] = rmid;
            thr[3][b] = rside;
        }
    }

    this.L3psycho_anal_vbr = function (gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, percep_entropy, percep_MS_entropy, energy, blocktype_d) {
        var gfc = gfp.internal_flags;

        /* fft and energy calculation */
        var wsamp_l;
        var wsamp_s;
        var fftenergy = new_float(Encoder.HBLKSIZE);
        var fftenergy_s = new_float_n([3, Encoder.HBLKSIZE_s]);
        var wsamp_L = new_float_n([2, Encoder.BLKSIZE]);
        var wsamp_S = new_float_n([2, 3, Encoder.BLKSIZE_s]);
        var eb = new_float_n([4, Encoder.CBANDS]), thr = new_float_n([4, Encoder.CBANDS]);
        var sub_short_factor = new_float_n([4, 3]);
        var pcfact = 0.6;

        /* block type */
        var ns_attacks = [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0],
            [0, 0, 0, 0]];
        var uselongblock = new_int(2);

        /* usual variables like loop indices, etc.. */

        /* chn=2 and 3 = Mid and Side channels */
        var n_chn_psy = (gfp.mode == MPEGMode.JOINT_STEREO) ? 4
            : gfc.channels_out;

        vbrpsy_attack_detection(gfp, buffer, bufPos, gr_out, masking_ratio,
            masking_MS_ratio, energy, sub_short_factor, ns_attacks,
            uselongblock);

        vbrpsy_compute_block_type(gfp, uselongblock);

        /* LONG BLOCK CASE */
        {
            for (var chn = 0; chn < n_chn_psy; chn++) {
                var ch01 = chn & 0x01;
                wsamp_l = wsamp_L;
                vbrpsy_compute_fft_l(gfp, buffer, bufPos, chn, gr_out,
                    fftenergy, wsamp_l, ch01);

                vbrpsy_compute_loudness_approximation_l(gfp, gr_out, chn,
                    fftenergy);

                if (uselongblock[ch01] != 0) {
                    vbrpsy_compute_masking_l(gfc, fftenergy, eb[chn], thr[chn],
                        chn);
                } else {
                    vbrpsy_skip_masking_l(gfc, chn);
                }
            }
            if ((uselongblock[0] + uselongblock[1]) == 2) {
                /* M/S channel */
                if (gfp.mode == MPEGMode.JOINT_STEREO) {
                    vbrpsy_compute_MS_thresholds(eb, thr, gfc.mld_cb_l,
                        gfc.ATH.cb_l, gfp.ATHlower * gfc.ATH.adjust,
                        gfp.msfix, gfc.npart_l);
                }
            }
            /* TODO: apply adaptive ATH masking here ?? */
            for (var chn = 0; chn < n_chn_psy; chn++) {
                var ch01 = chn & 0x01;
                if (uselongblock[ch01] != 0) {
                    convert_partition2scalefac_l(gfc, eb[chn], thr[chn], chn);
                }
            }
        }

        /* SHORT BLOCKS CASE */
        {
            for (var sblock = 0; sblock < 3; sblock++) {
                for (var chn = 0; chn < n_chn_psy; ++chn) {
                    var ch01 = chn & 0x01;

                    if (uselongblock[ch01] != 0) {
                        vbrpsy_skip_masking_s(gfc, chn, sblock);
                    } else {
                        /* compute masking thresholds for short blocks */
                        wsamp_s = wsamp_S;
                        vbrpsy_compute_fft_s(gfp, buffer, bufPos, chn, sblock,
                            fftenergy_s, wsamp_s, ch01);
                        vbrpsy_compute_masking_s(gfp, fftenergy_s, eb[chn],
                            thr[chn], chn, sblock);
                    }
                }
                if ((uselongblock[0] + uselongblock[1]) == 0) {
                    /* M/S channel */
                    if (gfp.mode == MPEGMode.JOINT_STEREO) {
                        vbrpsy_compute_MS_thresholds(eb, thr, gfc.mld_cb_s,
                            gfc.ATH.cb_s, gfp.ATHlower * gfc.ATH.adjust,
                            gfp.msfix, gfc.npart_s);
                    }
                    /* L/R channel */
                }
                /* TODO: apply adaptive ATH masking here ?? */
                for (var chn = 0; chn < n_chn_psy; ++chn) {
                    var ch01 = chn & 0x01;
                    if (0 == uselongblock[ch01]) {
                        convert_partition2scalefac_s(gfc, eb[chn], thr[chn],
                            chn, sblock);
                    }
                }
            }

            /**** short block pre-echo control ****/
            for (var chn = 0; chn < n_chn_psy; chn++) {
                var ch01 = chn & 0x01;

                if (uselongblock[ch01] != 0) {
                    continue;
                }
                for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
                    var new_thmm = new_float(3);
                    for (var sblock = 0; sblock < 3; sblock++) {
                        var thmm = gfc.thm[chn].s[sb][sblock];
                        thmm *= NS_PREECHO_ATT0;

                        if (ns_attacks[chn][sblock] >= 2
                            || ns_attacks[chn][sblock + 1] == 1) {
                            var idx = (sblock != 0) ? sblock - 1 : 2;
                            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                                NS_PREECHO_ATT1 * pcfact);
                            thmm = Math.min(thmm, p);
                        } else if (ns_attacks[chn][sblock] == 1) {
                            var idx = (sblock != 0) ? sblock - 1 : 2;
                            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                                NS_PREECHO_ATT2 * pcfact);
                            thmm = Math.min(thmm, p);
                        } else if ((sblock != 0 && ns_attacks[chn][sblock - 1] == 3)
                            || (sblock == 0 && gfc.nsPsy.lastAttacks[chn] == 3)) {
                            var idx = (sblock != 2) ? sblock + 1 : 0;
                            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                                NS_PREECHO_ATT2 * pcfact);
                            thmm = Math.min(thmm, p);
                        }

                        /* pulse like signal detection for fatboy.wav and so on */
                        thmm *= sub_short_factor[chn][sblock];

                        new_thmm[sblock] = thmm;
                    }
                    for (var sblock = 0; sblock < 3; sblock++) {
                        gfc.thm[chn].s[sb][sblock] = new_thmm[sblock];
                    }
                }
            }
        }
        for (var chn = 0; chn < n_chn_psy; chn++) {
            gfc.nsPsy.lastAttacks[chn] = ns_attacks[chn][2];
        }

        /***************************************************************
         * determine final block type
         ***************************************************************/
        vbrpsy_apply_block_type(gfp, uselongblock, blocktype_d);

        /*********************************************************************
         * compute the value of PE to return ... no delay and advance
         *********************************************************************/
        for (var chn = 0; chn < n_chn_psy; chn++) {
            var ppe;
            var ppePos;
            var type;
            var mr;

            if (chn > 1) {
                ppe = percep_MS_entropy;
                ppePos = -2;
                type = Encoder.NORM_TYPE;
                if (blocktype_d[0] == Encoder.SHORT_TYPE
                    || blocktype_d[1] == Encoder.SHORT_TYPE)
                    type = Encoder.SHORT_TYPE;
                mr = masking_MS_ratio[gr_out][chn - 2];
            } else {
                ppe = percep_entropy;
                ppePos = 0;
                type = blocktype_d[chn];
                mr = masking_ratio[gr_out][chn];
            }

            if (type == Encoder.SHORT_TYPE) {
                ppe[ppePos + chn] = pecalc_s(mr, gfc.masking_lower);
            } else {
                ppe[ppePos + chn] = pecalc_l(mr, gfc.masking_lower);
            }

            if (gfp.analysis) {
                gfc.pinfo.pe[gr_out][chn] = ppe[ppePos + chn];
            }
        }
        return 0;
    }

    function s3_func_x(bark, hf_slope) {
        var tempx = bark, tempy;

        if (tempx >= 0) {
            tempy = -tempx * 27;
        } else {
            tempy = tempx * hf_slope;
        }
        if (tempy <= -72.0) {
            return 0;
        }
        return Math.exp(tempy * LN_TO_LOG10);
    }

    function norm_s3_func_x(hf_slope) {
        var lim_a = 0, lim_b = 0;
        {
            var x = 0, l, h;
            for (x = 0; s3_func_x(x, hf_slope) > 1e-20; x -= 1)
                ;
            l = x;
            h = 0;
            while (Math.abs(h - l) > 1e-12) {
                x = (h + l) / 2;
                if (s3_func_x(x, hf_slope) > 0) {
                    h = x;
                } else {
                    l = x;
                }
            }
            lim_a = l;
        }
        {
            var x = 0, l, h;
            for (x = 0; s3_func_x(x, hf_slope) > 1e-20; x += 1)
                ;
            l = 0;
            h = x;
            while (Math.abs(h - l) > 1e-12) {
                x = (h + l) / 2;
                if (s3_func_x(x, hf_slope) > 0) {
                    l = x;
                } else {
                    h = x;
                }
            }
            lim_b = h;
        }
        {
            var sum = 0;
            var m = 1000;
            var i;
            for (i = 0; i <= m; ++i) {
                var x = lim_a + i * (lim_b - lim_a) / m;
                var y = s3_func_x(x, hf_slope);
                sum += y;
            }
            {
                var norm = (m + 1) / (sum * (lim_b - lim_a));
                /* printf( "norm = %lf\n",norm); */
                return norm;
            }
        }
    }

    /**
     *   The spreading function.  Values returned in units of energy
     */
    function s3_func(bark) {
        var tempx, x, tempy, temp;
        tempx = bark;
        if (tempx >= 0)
            tempx *= 3;
        else
            tempx *= 1.5;

        if (tempx >= 0.5 && tempx <= 2.5) {
            temp = tempx - 0.5;
            x = 8.0 * (temp * temp - 2.0 * temp);
        } else
            x = 0.0;
        tempx += 0.474;
        tempy = 15.811389 + 7.5 * tempx - 17.5
            * Math.sqrt(1.0 + tempx * tempx);

        if (tempy <= -60.0)
            return 0.0;

        tempx = Math.exp((x + tempy) * LN_TO_LOG10);

        /**
         * <PRE>
         * Normalization.  The spreading function should be normalized so that:
         * +inf
         * /
         * |  s3 [ bark ]  d(bark)   =  1
         * /
         * -inf
         * </PRE>
         */
        tempx /= .6609193;
        return tempx;
    }

    /**
     * see for example "Zwicker: Psychoakustik, 1982; ISBN 3-540-11401-7
     */
    function freq2bark(freq) {
        /* input: freq in hz output: barks */
        if (freq < 0)
            freq = 0;
        freq = freq * 0.001;
        return 13.0 * Math.atan(.76 * freq) + 3.5
            * Math.atan(freq * freq / (7.5 * 7.5));
    }

    function init_numline(numlines, bo, bm, bval, bval_width, mld, bo_w, sfreq, blksize, scalepos, deltafreq, sbmax) {
        var b_frq = new_float(Encoder.CBANDS + 1);
        var sample_freq_frac = sfreq / (sbmax > 15 ? 2 * 576 : 2 * 192);
        var partition = new_int(Encoder.HBLKSIZE);
        var i;
        sfreq /= blksize;
        var j = 0;
        var ni = 0;
        /* compute numlines, the number of spectral lines in each partition band */
        /* each partition band should be about DELBARK wide. */
        for (i = 0; i < Encoder.CBANDS; i++) {
            var bark1;
            var j2;
            bark1 = freq2bark(sfreq * j);

            b_frq[i] = sfreq * j;

            for (j2 = j; freq2bark(sfreq * j2) - bark1 < DELBARK
            && j2 <= blksize / 2; j2++)
                ;

            numlines[i] = j2 - j;
            ni = i + 1;

            while (j < j2) {
                assert(j < Encoder.HBLKSIZE);
                partition[j++] = i;
            }
            if (j > blksize / 2) {
                j = blksize / 2;
                ++i;
                break;
            }
        }
        assert(i < Encoder.CBANDS);
        b_frq[i] = sfreq * j;

        for (var sfb = 0; sfb < sbmax; sfb++) {
            var i1, i2, start, end;
            var arg;
            start = scalepos[sfb];
            end = scalepos[sfb + 1];

            i1 = 0 | Math.floor(.5 + deltafreq * (start - .5));
            if (i1 < 0)
                i1 = 0;
            i2 = 0 | Math.floor(.5 + deltafreq * (end - .5));

            if (i2 > blksize / 2)
                i2 = blksize / 2;

            bm[sfb] = (partition[i1] + partition[i2]) / 2;
            bo[sfb] = partition[i2];
            var f_tmp = sample_freq_frac * end;
            /*
             * calculate how much of this band belongs to current scalefactor
             * band
             */
            bo_w[sfb] = (f_tmp - b_frq[bo[sfb]])
                / (b_frq[bo[sfb] + 1] - b_frq[bo[sfb]]);
            if (bo_w[sfb] < 0) {
                bo_w[sfb] = 0;
            } else {
                if (bo_w[sfb] > 1) {
                    bo_w[sfb] = 1;
                }
            }
            /* setup stereo demasking thresholds */
            /* formula reverse enginerred from plot in paper */
            arg = freq2bark(sfreq * scalepos[sfb] * deltafreq);
            arg = ( Math.min(arg, 15.5) / 15.5);

            mld[sfb] = Math.pow(10.0,
                1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
        }

        /* compute bark values of each critical band */
        j = 0;
        for (var k = 0; k < ni; k++) {
            var w = numlines[k];
            var bark1, bark2;

            bark1 = freq2bark(sfreq * (j));
            bark2 = freq2bark(sfreq * (j + w - 1));
            bval[k] = .5 * (bark1 + bark2);

            bark1 = freq2bark(sfreq * (j - .5));
            bark2 = freq2bark(sfreq * (j + w - .5));
            bval_width[k] = bark2 - bark1;
            j += w;
        }

        return ni;
    }

    function init_s3_values(s3ind, npart, bval, bval_width, norm, use_old_s3) {
        var s3 = new_float_n([Encoder.CBANDS, Encoder.CBANDS]);
        /*
         * The s3 array is not linear in the bark scale.
         *
         * bval[x] should be used to get the bark value.
         */
        var j;
        var numberOfNoneZero = 0;

        /**
         * <PRE>
         * s[i][j], the value of the spreading function,
         * centered at band j (masker), for band i (maskee)
         *
         * i.e.: sum over j to spread into signal barkval=i
         * NOTE: i and j are used opposite as in the ISO docs
         * </PRE>
         */
        if (use_old_s3) {
            for (var i = 0; i < npart; i++) {
                for (j = 0; j < npart; j++) {
                    var v = s3_func(bval[i] - bval[j]) * bval_width[j];
                    s3[i][j] = v * norm[i];
                }
            }
        } else {
            for (j = 0; j < npart; j++) {
                var hf_slope = 15 + Math.min(21 / bval[j], 12);
                var s3_x_norm = norm_s3_func_x(hf_slope);
                for (var i = 0; i < npart; i++) {
                    var v = s3_x_norm
                        * s3_func_x(bval[i] - bval[j], hf_slope)
                        * bval_width[j];
                    s3[i][j] = v * norm[i];
                }
            }
        }
        for (var i = 0; i < npart; i++) {
            for (j = 0; j < npart; j++) {
                if (s3[i][j] > 0.0)
                    break;
            }
            s3ind[i][0] = j;

            for (j = npart - 1; j > 0; j--) {
                if (s3[i][j] > 0.0)
                    break;
            }
            s3ind[i][1] = j;
            numberOfNoneZero += (s3ind[i][1] - s3ind[i][0] + 1);
        }

        var p = new_float(numberOfNoneZero);
        var k = 0;
        for (var i = 0; i < npart; i++)
            for (j = s3ind[i][0]; j <= s3ind[i][1]; j++)
                p[k++] = s3[i][j];

        return p;
    }

    function stereo_demask(f) {
        /* setup stereo demasking thresholds */
        /* formula reverse enginerred from plot in paper */
        var arg = freq2bark(f);
        arg = (Math.min(arg, 15.5) / 15.5);

        return Math.pow(10.0,
            1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
    }

    /**
     * NOTE: the bitrate reduction from the inter-channel masking effect is low
     * compared to the chance of getting annyoing artefacts. L3psycho_anal_vbr
     * does not use this feature. (Robert 071216)
     */
    this.psymodel_init = function (gfp) {
        var gfc = gfp.internal_flags;
        var i;
        var useOldS3 = true;
        var bvl_a = 13, bvl_b = 24;
        var snr_l_a = 0, snr_l_b = 0;
        var snr_s_a = -8.25, snr_s_b = -4.5;
        var bval = new_float(Encoder.CBANDS);
        var bval_width = new_float(Encoder.CBANDS);
        var norm = new_float(Encoder.CBANDS);
        var sfreq = gfp.out_samplerate;

        switch (gfp.experimentalZ) {
            default:
            case 0:
                useOldS3 = true;
                break;
            case 1:
                useOldS3 = (gfp.VBR == VbrMode.vbr_mtrh || gfp.VBR == VbrMode.vbr_mt) ? false
                    : true;
                break;
            case 2:
                useOldS3 = false;
                break;
            case 3:
                bvl_a = 8;
                snr_l_a = -1.75;
                snr_l_b = -0.0125;
                snr_s_a = -8.25;
                snr_s_b = -2.25;
                break;
        }
        gfc.ms_ener_ratio_old = .25;
        gfc.blocktype_old[0] = gfc.blocktype_old[1] = Encoder.NORM_TYPE;
        // the vbr header is long blocks

        for (i = 0; i < 4; ++i) {
            for (var j = 0; j < Encoder.CBANDS; ++j) {
                gfc.nb_1[i][j] = 1e20;
                gfc.nb_2[i][j] = 1e20;
                gfc.nb_s1[i][j] = gfc.nb_s2[i][j] = 1.0;
            }
            for (var sb = 0; sb < Encoder.SBMAX_l; sb++) {
                gfc.en[i].l[sb] = 1e20;
                gfc.thm[i].l[sb] = 1e20;
            }
            for (var j = 0; j < 3; ++j) {
                for (var sb = 0; sb < Encoder.SBMAX_s; sb++) {
                    gfc.en[i].s[sb][j] = 1e20;
                    gfc.thm[i].s[sb][j] = 1e20;
                }
                gfc.nsPsy.lastAttacks[i] = 0;
            }
            for (var j = 0; j < 9; j++)
                gfc.nsPsy.last_en_subshort[i][j] = 10.;
        }

        /* init. for loudness approx. -jd 2001 mar 27 */
        gfc.loudness_sq_save[0] = gfc.loudness_sq_save[1] = 0.0;

        /*************************************************************************
         * now compute the psychoacoustic model specific constants
         ************************************************************************/
        /* compute numlines, bo, bm, bval, bval_width, mld */

        gfc.npart_l = init_numline(gfc.numlines_l, gfc.bo_l, gfc.bm_l, bval,
            bval_width, gfc.mld_l, gfc.PSY.bo_l_weight, sfreq,
            Encoder.BLKSIZE, gfc.scalefac_band.l, Encoder.BLKSIZE
            / (2.0 * 576), Encoder.SBMAX_l);
        assert(gfc.npart_l < Encoder.CBANDS);
        /* compute the spreading function */
        for (i = 0; i < gfc.npart_l; i++) {
            var snr = snr_l_a;
            if (bval[i] >= bvl_a) {
                snr = snr_l_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_l_a
                    * (bvl_b - bval[i]) / (bvl_b - bvl_a);
            }
            norm[i] = Math.pow(10.0, snr / 10.0);
            if (gfc.numlines_l[i] > 0) {
                gfc.rnumlines_l[i] = 1.0 / gfc.numlines_l[i];
            } else {
                gfc.rnumlines_l[i] = 0;
            }
        }
        gfc.s3_ll = init_s3_values(gfc.s3ind, gfc.npart_l, bval, bval_width,
            norm, useOldS3);

        /* compute long block specific values, ATH and MINVAL */
        var j = 0;
        for (i = 0; i < gfc.npart_l; i++) {
            var x;

            /* ATH */
            x = Float.MAX_VALUE;
            for (var k = 0; k < gfc.numlines_l[i]; k++, j++) {
                var freq = sfreq * j / (1000.0 * Encoder.BLKSIZE);
                var level;
                /*
                 * ATH below 100 Hz constant, not further climbing
                 */
                level = this.ATHformula(freq * 1000, gfp) - 20;
                // scale to FFT units; returned value is in dB
                level = Math.pow(10., 0.1 * level);
                // convert from dB . energy
                level *= gfc.numlines_l[i];
                if (x > level)
                    x = level;
            }
            gfc.ATH.cb_l[i] = x;

            /*
             * MINVAL. For low freq, the strength of the masking is limited by
             * minval this is an ISO MPEG1 thing, dont know if it is really
             * needed
             */
            /*
             * FIXME: it does work to reduce low-freq problems in S53-Wind-Sax
             * and lead-voice samples, but introduces some 3 kbps bit bloat too.
             * TODO: Further refinement of the shape of this hack.
             */
            x = -20 + bval[i] * 20 / 10;
            if (x > 6) {
                x = 100;
            }
            if (x < -15) {
                x = -15;
            }
            x -= 8.;
            gfc.minval_l[i] = (Math.pow(10.0, x / 10.) * gfc.numlines_l[i]);
        }

        /************************************************************************
         * do the same things for short blocks
         ************************************************************************/
        gfc.npart_s = init_numline(gfc.numlines_s, gfc.bo_s, gfc.bm_s, bval,
            bval_width, gfc.mld_s, gfc.PSY.bo_s_weight, sfreq,
            Encoder.BLKSIZE_s, gfc.scalefac_band.s, Encoder.BLKSIZE_s
            / (2.0 * 192), Encoder.SBMAX_s);
        assert(gfc.npart_s < Encoder.CBANDS);

        /* SNR formula. short block is normalized by SNR. is it still right ? */
        j = 0;
        for (i = 0; i < gfc.npart_s; i++) {
            var x;
            var snr = snr_s_a;
            if (bval[i] >= bvl_a) {
                snr = snr_s_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_s_a
                    * (bvl_b - bval[i]) / (bvl_b - bvl_a);
            }
            norm[i] = Math.pow(10.0, snr / 10.0);

            /* ATH */
            x = Float.MAX_VALUE;
            for (var k = 0; k < gfc.numlines_s[i]; k++, j++) {
                var freq = sfreq * j / (1000.0 * Encoder.BLKSIZE_s);
                var level;
                /* freq = Min(.1,freq); */
                /*
                 * ATH below 100 Hz constant, not
                 * further climbing
                 */
                level = this.ATHformula(freq * 1000, gfp) - 20;
                // scale to FFT units; returned value is in dB
                level = Math.pow(10., 0.1 * level);
                // convert from dB . energy
                level *= gfc.numlines_s[i];
                if (x > level)
                    x = level;
            }
            gfc.ATH.cb_s[i] = x;

            /*
             * MINVAL. For low freq, the strength of the masking is limited by
             * minval this is an ISO MPEG1 thing, dont know if it is really
             * needed
             */
            x = (-7.0 + bval[i] * 7.0 / 12.0);
            if (bval[i] > 12) {
                x *= 1 + Math.log(1 + x) * 3.1;
            }
            if (bval[i] < 12) {
                x *= 1 + Math.log(1 - x) * 2.3;
            }
            if (x < -15) {
                x = -15;
            }
            x -= 8;
            gfc.minval_s[i] = Math.pow(10.0, x / 10)
                * gfc.numlines_s[i];
        }

        gfc.s3_ss = init_s3_values(gfc.s3ind_s, gfc.npart_s, bval, bval_width,
            norm, useOldS3);

        init_mask_add_max_values();
        fft.init_fft(gfc);

        /* setup temporal masking */
        gfc.decay = Math.exp(-1.0 * LOG10
            / (temporalmask_sustain_sec * sfreq / 192.0));

        {
            var msfix;
            msfix = NS_MSFIX;
            if ((gfp.exp_nspsytune & 2) != 0)
                msfix = 1.0;
            if (Math.abs(gfp.msfix) > 0.0)
                msfix = gfp.msfix;
            gfp.msfix = msfix;

            /*
             * spread only from npart_l bands. Normally, we use the spreading
             * function to convolve from npart_l down to npart_l bands
             */
            for (var b = 0; b < gfc.npart_l; b++)
                if (gfc.s3ind[b][1] > gfc.npart_l - 1)
                    gfc.s3ind[b][1] = gfc.npart_l - 1;
        }

        /*
         * prepare for ATH auto adjustment: we want to decrease the ATH by 12 dB
         * per second
         */
        var frame_duration = (576. * gfc.mode_gr / sfreq);
        gfc.ATH.decay = Math.pow(10., -12. / 10. * frame_duration);
        gfc.ATH.adjust = 0.01;
        /* minimum, for leading low loudness */
        gfc.ATH.adjustLimit = 1.0;
        /* on lead, allow adjust up to maximum */

        assert(gfc.bo_l[Encoder.SBMAX_l - 1] <= gfc.npart_l);
        assert(gfc.bo_s[Encoder.SBMAX_s - 1] <= gfc.npart_s);

        if (gfp.ATHtype != -1) {
            /* compute equal loudness weights (eql_w) */
            var freq;
            var freq_inc = gfp.out_samplerate
                / (Encoder.BLKSIZE);
            var eql_balance = 0.0;
            freq = 0.0;
            for (i = 0; i < Encoder.BLKSIZE / 2; ++i) {
                /* convert ATH dB to relative power (not dB) */
                /* to determine eql_w */
                freq += freq_inc;
                gfc.ATH.eql_w[i] = 1. / Math.pow(10, this.ATHformula(freq, gfp) / 10);
                eql_balance += gfc.ATH.eql_w[i];
            }
            eql_balance = 1.0 / eql_balance;
            for (i = Encoder.BLKSIZE / 2; --i >= 0;) { /* scale weights */
                gfc.ATH.eql_w[i] *= eql_balance;
            }
        }
        {
            for (var b = j = 0; b < gfc.npart_s; ++b) {
                for (i = 0; i < gfc.numlines_s[b]; ++i) {
                    ++j;
                }
            }
            assert(j == 129);
            for (var b = j = 0; b < gfc.npart_l; ++b) {
                for (i = 0; i < gfc.numlines_l[b]; ++i) {
                    ++j;
                }
            }
            assert(j == 513);
        }
        j = 0;
        for (i = 0; i < gfc.npart_l; i++) {
            var freq = sfreq * (j + gfc.numlines_l[i] / 2) / (1.0 * Encoder.BLKSIZE);
            gfc.mld_cb_l[i] = stereo_demask(freq);
            j += gfc.numlines_l[i];
        }
        for (; i < Encoder.CBANDS; ++i) {
            gfc.mld_cb_l[i] = 1;
        }
        j = 0;
        for (i = 0; i < gfc.npart_s; i++) {
            var freq = sfreq * (j + gfc.numlines_s[i] / 2) / (1.0 * Encoder.BLKSIZE_s);
            gfc.mld_cb_s[i] = stereo_demask(freq);
            j += gfc.numlines_s[i];
        }
        for (; i < Encoder.CBANDS; ++i) {
            gfc.mld_cb_s[i] = 1;
        }
        return 0;
    }

    /**
     * Those ATH formulas are returning their minimum value for input = -1
     */
    function ATHformula_GB(f, value) {
        /**
         * <PRE>
         *  from Painter & Spanias
         *           modified by Gabriel Bouvigne to better fit the reality
         *           ath =    3.640 * pow(f,-0.8)
         *           - 6.800 * exp(-0.6*pow(f-3.4,2.0))
         *           + 6.000 * exp(-0.15*pow(f-8.7,2.0))
         *           + 0.6* 0.001 * pow(f,4.0);
         *
         *
         *           In the past LAME was using the Painter &Spanias formula.
         *           But we had some recurrent problems with HF content.
         *           We measured real ATH values, and found the older formula
         *           to be inaccurate in the higher part. So we made this new
         *           formula and this solved most of HF problematic test cases.
         *           The tradeoff is that in VBR mode it increases a lot the
         *           bitrate.
         * </PRE>
         */

        /*
         * This curve can be adjusted according to the VBR scale: it adjusts
         * from something close to Painter & Spanias on V9 up to Bouvigne's
         * formula for V0. This way the VBR bitrate is more balanced according
         * to the -V value.
         */

        // the following Hack allows to ask for the lowest value
        if (f < -.3)
            f = 3410;

        // convert to khz
        f /= 1000;
        f = Math.max(0.1, f);
        var ath = 3.640 * Math.pow(f, -0.8) - 6.800
            * Math.exp(-0.6 * Math.pow(f - 3.4, 2.0)) + 6.000
            * Math.exp(-0.15 * Math.pow(f - 8.7, 2.0))
            + (0.6 + 0.04 * value) * 0.001 * Math.pow(f, 4.0);
        return ath;
    }

    this.ATHformula = function (f, gfp) {
        var ath;
        switch (gfp.ATHtype) {
            case 0:
                ath = ATHformula_GB(f, 9);
                break;
            case 1:
                // over sensitive, should probably be removed
                ath = ATHformula_GB(f, -1);
                break;
            case 2:
                ath = ATHformula_GB(f, 0);
                break;
            case 3:
                // modification of GB formula by Roel
                ath = ATHformula_GB(f, 1) + 6;
                break;
            case 4:
                ath = ATHformula_GB(f, gfp.ATHcurve);
                break;
            default:
                ath = ATHformula_GB(f, 0);
                break;
        }
        return ath;
    }

}

module.exports = PsyModel;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var Encoder = __webpack_require__(35);

function FFT() {

    var window = new_float(Encoder.BLKSIZE);
    var window_s = new_float(Encoder.BLKSIZE_s / 2);

    var costab = [
        9.238795325112867e-01, 3.826834323650898e-01,
        9.951847266721969e-01, 9.801714032956060e-02,
        9.996988186962042e-01, 2.454122852291229e-02,
        9.999811752826011e-01, 6.135884649154475e-03
    ];

    function fht(fz, fzPos, n) {
        var tri = 0;
        var k4;
        var fi;
        var gi;

        n <<= 1;
        /* to get BLKSIZE, because of 3DNow! ASM routine */
        var fn = fzPos + n;
        k4 = 4;
        do {
            var s1, c1;
            var i, k1, k2, k3, kx;
            kx = k4 >> 1;
            k1 = k4;
            k2 = k4 << 1;
            k3 = k2 + k1;
            k4 = k2 << 1;
            fi = fzPos;
            gi = fi + kx;
            do {
                var f0, f1, f2, f3;
                f1 = fz[fi + 0] - fz[fi + k1];
                f0 = fz[fi + 0] + fz[fi + k1];
                f3 = fz[fi + k2] - fz[fi + k3];
                f2 = fz[fi + k2] + fz[fi + k3];
                fz[fi + k2] = f0 - f2;
                fz[fi + 0] = f0 + f2;
                fz[fi + k3] = f1 - f3;
                fz[fi + k1] = f1 + f3;
                f1 = fz[gi + 0] - fz[gi + k1];
                f0 = fz[gi + 0] + fz[gi + k1];
                f3 = (Util.SQRT2 * fz[gi + k3]);
                f2 = (Util.SQRT2 * fz[gi + k2]);
                fz[gi + k2] = f0 - f2;
                fz[gi + 0] = f0 + f2;
                fz[gi + k3] = f1 - f3;
                fz[gi + k1] = f1 + f3;
                gi += k4;
                fi += k4;
            } while (fi < fn);
            c1 = costab[tri + 0];
            s1 = costab[tri + 1];
            for (i = 1; i < kx; i++) {
                var c2, s2;
                c2 = 1 - (2 * s1) * s1;
                s2 = (2 * s1) * c1;
                fi = fzPos + i;
                gi = fzPos + k1 - i;
                do {
                    var a, b, g0, f0, f1, g1, f2, g2, f3, g3;
                    b = s2 * fz[fi + k1] - c2 * fz[gi + k1];
                    a = c2 * fz[fi + k1] + s2 * fz[gi + k1];
                    f1 = fz[fi + 0] - a;
                    f0 = fz[fi + 0] + a;
                    g1 = fz[gi + 0] - b;
                    g0 = fz[gi + 0] + b;
                    b = s2 * fz[fi + k3] - c2 * fz[gi + k3];
                    a = c2 * fz[fi + k3] + s2 * fz[gi + k3];
                    f3 = fz[fi + k2] - a;
                    f2 = fz[fi + k2] + a;
                    g3 = fz[gi + k2] - b;
                    g2 = fz[gi + k2] + b;
                    b = s1 * f2 - c1 * g3;
                    a = c1 * f2 + s1 * g3;
                    fz[fi + k2] = f0 - a;
                    fz[fi + 0] = f0 + a;
                    fz[gi + k3] = g1 - b;
                    fz[gi + k1] = g1 + b;
                    b = c1 * g2 - s1 * f3;
                    a = s1 * g2 + c1 * f3;
                    fz[gi + k2] = g0 - a;
                    fz[gi + 0] = g0 + a;
                    fz[fi + k3] = f1 - b;
                    fz[fi + k1] = f1 + b;
                    gi += k4;
                    fi += k4;
                } while (fi < fn);
                c2 = c1;
                c1 = c2 * costab[tri + 0] - s1 * costab[tri + 1];
                s1 = c2 * costab[tri + 1] + s1 * costab[tri + 0];
            }
            tri += 2;
        } while (k4 < n);
    }

    var rv_tbl = [0x00, 0x80, 0x40,
        0xc0, 0x20, 0xa0, 0x60, 0xe0, 0x10,
        0x90, 0x50, 0xd0, 0x30, 0xb0, 0x70,
        0xf0, 0x08, 0x88, 0x48, 0xc8, 0x28,
        0xa8, 0x68, 0xe8, 0x18, 0x98, 0x58,
        0xd8, 0x38, 0xb8, 0x78, 0xf8, 0x04,
        0x84, 0x44, 0xc4, 0x24, 0xa4, 0x64,
        0xe4, 0x14, 0x94, 0x54, 0xd4, 0x34,
        0xb4, 0x74, 0xf4, 0x0c, 0x8c, 0x4c,
        0xcc, 0x2c, 0xac, 0x6c, 0xec, 0x1c,
        0x9c, 0x5c, 0xdc, 0x3c, 0xbc, 0x7c,
        0xfc, 0x02, 0x82, 0x42, 0xc2, 0x22,
        0xa2, 0x62, 0xe2, 0x12, 0x92, 0x52,
        0xd2, 0x32, 0xb2, 0x72, 0xf2, 0x0a,
        0x8a, 0x4a, 0xca, 0x2a, 0xaa, 0x6a,
        0xea, 0x1a, 0x9a, 0x5a, 0xda, 0x3a,
        0xba, 0x7a, 0xfa, 0x06, 0x86, 0x46,
        0xc6, 0x26, 0xa6, 0x66, 0xe6, 0x16,
        0x96, 0x56, 0xd6, 0x36, 0xb6, 0x76,
        0xf6, 0x0e, 0x8e, 0x4e, 0xce, 0x2e,
        0xae, 0x6e, 0xee, 0x1e, 0x9e, 0x5e,
        0xde, 0x3e, 0xbe, 0x7e, 0xfe];

    this.fft_short = function (gfc, x_real, chn, buffer, bufPos) {
        for (var b = 0; b < 3; b++) {
            var x = Encoder.BLKSIZE_s / 2;
            var k = 0xffff & ((576 / 3) * (b + 1));
            var j = Encoder.BLKSIZE_s / 8 - 1;
            do {
                var f0, f1, f2, f3, w;
                var i = rv_tbl[j << 2] & 0xff;

                f0 = window_s[i] * buffer[chn][bufPos + i + k];
                w = window_s[0x7f - i] * buffer[chn][bufPos + i + k + 0x80];
                f1 = f0 - w;
                f0 = f0 + w;
                f2 = window_s[i + 0x40] * buffer[chn][bufPos + i + k + 0x40];
                w = window_s[0x3f - i] * buffer[chn][bufPos + i + k + 0xc0];
                f3 = f2 - w;
                f2 = f2 + w;

                x -= 4;
                x_real[b][x + 0] = f0 + f2;
                x_real[b][x + 2] = f0 - f2;
                x_real[b][x + 1] = f1 + f3;
                x_real[b][x + 3] = f1 - f3;

                f0 = window_s[i + 0x01] * buffer[chn][bufPos + i + k + 0x01];
                w = window_s[0x7e - i] * buffer[chn][bufPos + i + k + 0x81];
                f1 = f0 - w;
                f0 = f0 + w;
                f2 = window_s[i + 0x41] * buffer[chn][bufPos + i + k + 0x41];
                w = window_s[0x3e - i] * buffer[chn][bufPos + i + k + 0xc1];
                f3 = f2 - w;
                f2 = f2 + w;

                x_real[b][x + Encoder.BLKSIZE_s / 2 + 0] = f0 + f2;
                x_real[b][x + Encoder.BLKSIZE_s / 2 + 2] = f0 - f2;
                x_real[b][x + Encoder.BLKSIZE_s / 2 + 1] = f1 + f3;
                x_real[b][x + Encoder.BLKSIZE_s / 2 + 3] = f1 - f3;
            } while (--j >= 0);

            fht(x_real[b], x, Encoder.BLKSIZE_s / 2);
            /* BLKSIZE_s/2 because of 3DNow! ASM routine */
            /* BLKSIZE/2 because of 3DNow! ASM routine */
        }
    }

    this.fft_long = function (gfc, y, chn, buffer, bufPos) {
        var jj = Encoder.BLKSIZE / 8 - 1;
        var x = Encoder.BLKSIZE / 2;

        do {
            var f0, f1, f2, f3, w;
            var i = rv_tbl[jj] & 0xff;
            f0 = window[i] * buffer[chn][bufPos + i];
            w = window[i + 0x200] * buffer[chn][bufPos + i + 0x200];
            f1 = f0 - w;
            f0 = f0 + w;
            f2 = window[i + 0x100] * buffer[chn][bufPos + i + 0x100];
            w = window[i + 0x300] * buffer[chn][bufPos + i + 0x300];
            f3 = f2 - w;
            f2 = f2 + w;

            x -= 4;
            y[x + 0] = f0 + f2;
            y[x + 2] = f0 - f2;
            y[x + 1] = f1 + f3;
            y[x + 3] = f1 - f3;

            f0 = window[i + 0x001] * buffer[chn][bufPos + i + 0x001];
            w = window[i + 0x201] * buffer[chn][bufPos + i + 0x201];
            f1 = f0 - w;
            f0 = f0 + w;
            f2 = window[i + 0x101] * buffer[chn][bufPos + i + 0x101];
            w = window[i + 0x301] * buffer[chn][bufPos + i + 0x301];
            f3 = f2 - w;
            f2 = f2 + w;

            y[x + Encoder.BLKSIZE / 2 + 0] = f0 + f2;
            y[x + Encoder.BLKSIZE / 2 + 2] = f0 - f2;
            y[x + Encoder.BLKSIZE / 2 + 1] = f1 + f3;
            y[x + Encoder.BLKSIZE / 2 + 3] = f1 - f3;
        } while (--jj >= 0);

        fht(y, x, Encoder.BLKSIZE / 2);
        /* BLKSIZE/2 because of 3DNow! ASM routine */
    }

    this.init_fft = function (gfc) {
        /* The type of window used here will make no real difference, but */
        /*
         * in the interest of merging nspsytune stuff - switch to blackman
         * window
         */
        for (var i = 0; i < Encoder.BLKSIZE; i++)
            /* blackman window */
            window[i] = (0.42 - 0.5 * Math.cos(2 * Math.PI * (i + .5)
                / Encoder.BLKSIZE) + 0.08 * Math.cos(4 * Math.PI * (i + .5)
                / Encoder.BLKSIZE));

        for (var i = 0; i < Encoder.BLKSIZE_s / 2; i++)
            window_s[i] = (0.5 * (1.0 - Math.cos(2.0 * Math.PI
                * (i + 0.5) / Encoder.BLKSIZE_s)));

    }

}

module.exports = FFT;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *      MP3 window subband -> subband filtering -> mdct routine
 *
 *      Copyright (c) 1999-2000 Takehiro Tominaga
 *
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Library General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */
/*
 *         Special Thanks to Patrick De Smet for your advices.
 */

/* $Id: NewMDCT.java,v 1.11 2011/05/24 20:48:06 kenchis Exp $ */

//package mp3;

//import java.util.Arrays;
var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var Encoder = __webpack_require__(35);


function NewMDCT() {

	var enwindow = [
			-4.77e-07 * 0.740951125354959 / 2.384e-06,
			1.03951e-04 * 0.740951125354959 / 2.384e-06,
			9.53674e-04 * 0.740951125354959 / 2.384e-06,
			2.841473e-03 * 0.740951125354959 / 2.384e-06,
			3.5758972e-02 * 0.740951125354959 / 2.384e-06,
			3.401756e-03 * 0.740951125354959 / 2.384e-06,
			9.83715e-04 * 0.740951125354959 / 2.384e-06,
			9.9182e-05 * 0.740951125354959 / 2.384e-06, /* 15 */
			1.2398e-05 * 0.740951125354959 / 2.384e-06,
			1.91212e-04 * 0.740951125354959 / 2.384e-06,
			2.283096e-03 * 0.740951125354959 / 2.384e-06,
			1.6994476e-02 * 0.740951125354959 / 2.384e-06,
			-1.8756866e-02 * 0.740951125354959 / 2.384e-06,
			-2.630711e-03 * 0.740951125354959 / 2.384e-06,
			-2.47478e-04 * 0.740951125354959 / 2.384e-06,
			-1.4782e-05 * 0.740951125354959 / 2.384e-06,
			9.063471690191471e-01, 1.960342806591213e-01,

			-4.77e-07 * 0.773010453362737 / 2.384e-06,
			1.05858e-04 * 0.773010453362737 / 2.384e-06,
			9.30786e-04 * 0.773010453362737 / 2.384e-06,
			2.521515e-03 * 0.773010453362737 / 2.384e-06,
			3.5694122e-02 * 0.773010453362737 / 2.384e-06,
			3.643036e-03 * 0.773010453362737 / 2.384e-06,
			9.91821e-04 * 0.773010453362737 / 2.384e-06,
			9.6321e-05 * 0.773010453362737 / 2.384e-06, /* 14 */
			1.1444e-05 * 0.773010453362737 / 2.384e-06,
			1.65462e-04 * 0.773010453362737 / 2.384e-06,
			2.110004e-03 * 0.773010453362737 / 2.384e-06,
			1.6112804e-02 * 0.773010453362737 / 2.384e-06,
			-1.9634247e-02 * 0.773010453362737 / 2.384e-06,
			-2.803326e-03 * 0.773010453362737 / 2.384e-06,
			-2.77042e-04 * 0.773010453362737 / 2.384e-06,
			-1.6689e-05 * 0.773010453362737 / 2.384e-06,
			8.206787908286602e-01, 3.901806440322567e-01,

			-4.77e-07 * 0.803207531480645 / 2.384e-06,
			1.07288e-04 * 0.803207531480645 / 2.384e-06,
			9.02653e-04 * 0.803207531480645 / 2.384e-06,
			2.174854e-03 * 0.803207531480645 / 2.384e-06,
			3.5586357e-02 * 0.803207531480645 / 2.384e-06,
			3.858566e-03 * 0.803207531480645 / 2.384e-06,
			9.95159e-04 * 0.803207531480645 / 2.384e-06,
			9.3460e-05 * 0.803207531480645 / 2.384e-06, /* 13 */
			1.0014e-05 * 0.803207531480645 / 2.384e-06,
			1.40190e-04 * 0.803207531480645 / 2.384e-06,
			1.937389e-03 * 0.803207531480645 / 2.384e-06,
			1.5233517e-02 * 0.803207531480645 / 2.384e-06,
			-2.0506859e-02 * 0.803207531480645 / 2.384e-06,
			-2.974033e-03 * 0.803207531480645 / 2.384e-06,
			-3.07560e-04 * 0.803207531480645 / 2.384e-06,
			-1.8120e-05 * 0.803207531480645 / 2.384e-06,
			7.416505462720353e-01, 5.805693545089249e-01,

			-4.77e-07 * 0.831469612302545 / 2.384e-06,
			1.08242e-04 * 0.831469612302545 / 2.384e-06,
			8.68797e-04 * 0.831469612302545 / 2.384e-06,
			1.800537e-03 * 0.831469612302545 / 2.384e-06,
			3.5435200e-02 * 0.831469612302545 / 2.384e-06,
			4.049301e-03 * 0.831469612302545 / 2.384e-06,
			9.94205e-04 * 0.831469612302545 / 2.384e-06,
			9.0599e-05 * 0.831469612302545 / 2.384e-06, /* 12 */
			9.060e-06 * 0.831469612302545 / 2.384e-06,
			1.16348e-04 * 0.831469612302545 / 2.384e-06,
			1.766682e-03 * 0.831469612302545 / 2.384e-06,
			1.4358521e-02 * 0.831469612302545 / 2.384e-06,
			-2.1372318e-02 * 0.831469612302545 / 2.384e-06,
			-3.14188e-03 * 0.831469612302545 / 2.384e-06,
			-3.39031e-04 * 0.831469612302545 / 2.384e-06,
			-1.9550e-05 * 0.831469612302545 / 2.384e-06,
			6.681786379192989e-01, 7.653668647301797e-01,

			-4.77e-07 * 0.857728610000272 / 2.384e-06,
			1.08719e-04 * 0.857728610000272 / 2.384e-06,
			8.29220e-04 * 0.857728610000272 / 2.384e-06,
			1.399517e-03 * 0.857728610000272 / 2.384e-06,
			3.5242081e-02 * 0.857728610000272 / 2.384e-06,
			4.215240e-03 * 0.857728610000272 / 2.384e-06,
			9.89437e-04 * 0.857728610000272 / 2.384e-06,
			8.7261e-05 * 0.857728610000272 / 2.384e-06, /* 11 */
			8.106e-06 * 0.857728610000272 / 2.384e-06,
			9.3937e-05 * 0.857728610000272 / 2.384e-06,
			1.597881e-03 * 0.857728610000272 / 2.384e-06,
			1.3489246e-02 * 0.857728610000272 / 2.384e-06,
			-2.2228718e-02 * 0.857728610000272 / 2.384e-06,
			-3.306866e-03 * 0.857728610000272 / 2.384e-06,
			-3.71456e-04 * 0.857728610000272 / 2.384e-06,
			-2.1458e-05 * 0.857728610000272 / 2.384e-06,
			5.993769336819237e-01, 9.427934736519954e-01,

			-4.77e-07 * 0.881921264348355 / 2.384e-06,
			1.08719e-04 * 0.881921264348355 / 2.384e-06,
			7.8392e-04 * 0.881921264348355 / 2.384e-06,
			9.71317e-04 * 0.881921264348355 / 2.384e-06,
			3.5007000e-02 * 0.881921264348355 / 2.384e-06,
			4.357815e-03 * 0.881921264348355 / 2.384e-06,
			9.80854e-04 * 0.881921264348355 / 2.384e-06,
			8.3923e-05 * 0.881921264348355 / 2.384e-06, /* 10 */
			7.629e-06 * 0.881921264348355 / 2.384e-06,
			7.2956e-05 * 0.881921264348355 / 2.384e-06,
			1.432419e-03 * 0.881921264348355 / 2.384e-06,
			1.2627602e-02 * 0.881921264348355 / 2.384e-06,
			-2.3074150e-02 * 0.881921264348355 / 2.384e-06,
			-3.467083e-03 * 0.881921264348355 / 2.384e-06,
			-4.04358e-04 * 0.881921264348355 / 2.384e-06,
			-2.3365e-05 * 0.881921264348355 / 2.384e-06,
			5.345111359507916e-01, 1.111140466039205e+00,

			-9.54e-07 * 0.903989293123443 / 2.384e-06,
			1.08242e-04 * 0.903989293123443 / 2.384e-06,
			7.31945e-04 * 0.903989293123443 / 2.384e-06,
			5.15938e-04 * 0.903989293123443 / 2.384e-06,
			3.4730434e-02 * 0.903989293123443 / 2.384e-06,
			4.477024e-03 * 0.903989293123443 / 2.384e-06,
			9.68933e-04 * 0.903989293123443 / 2.384e-06,
			8.0585e-05 * 0.903989293123443 / 2.384e-06, /* 9 */
			6.676e-06 * 0.903989293123443 / 2.384e-06,
			5.2929e-05 * 0.903989293123443 / 2.384e-06,
			1.269817e-03 * 0.903989293123443 / 2.384e-06,
			1.1775017e-02 * 0.903989293123443 / 2.384e-06,
			-2.3907185e-02 * 0.903989293123443 / 2.384e-06,
			-3.622532e-03 * 0.903989293123443 / 2.384e-06,
			-4.38213e-04 * 0.903989293123443 / 2.384e-06,
			-2.5272e-05 * 0.903989293123443 / 2.384e-06,
			4.729647758913199e-01, 1.268786568327291e+00,

			-9.54e-07 * 0.92387953251128675613 / 2.384e-06,
			1.06812e-04 * 0.92387953251128675613 / 2.384e-06,
			6.74248e-04 * 0.92387953251128675613 / 2.384e-06,
			3.3379e-05 * 0.92387953251128675613 / 2.384e-06,
			3.4412861e-02 * 0.92387953251128675613 / 2.384e-06,
			4.573822e-03 * 0.92387953251128675613 / 2.384e-06,
			9.54151e-04 * 0.92387953251128675613 / 2.384e-06,
			7.6771e-05 * 0.92387953251128675613 / 2.384e-06,
			6.199e-06 * 0.92387953251128675613 / 2.384e-06,
			3.4332e-05 * 0.92387953251128675613 / 2.384e-06,
			1.111031e-03 * 0.92387953251128675613 / 2.384e-06,
			1.0933399e-02 * 0.92387953251128675613 / 2.384e-06,
			-2.4725437e-02 * 0.92387953251128675613 / 2.384e-06,
			-3.771782e-03 * 0.92387953251128675613 / 2.384e-06,
			-4.72546e-04 * 0.92387953251128675613 / 2.384e-06,
			-2.7657e-05 * 0.92387953251128675613 / 2.384e-06,
			4.1421356237309504879e-01, /* tan(PI/8) */
			1.414213562373095e+00,

			-9.54e-07 * 0.941544065183021 / 2.384e-06,
			1.05381e-04 * 0.941544065183021 / 2.384e-06,
			6.10352e-04 * 0.941544065183021 / 2.384e-06,
			-4.75883e-04 * 0.941544065183021 / 2.384e-06,
			3.4055710e-02 * 0.941544065183021 / 2.384e-06,
			4.649162e-03 * 0.941544065183021 / 2.384e-06,
			9.35555e-04 * 0.941544065183021 / 2.384e-06,
			7.3433e-05 * 0.941544065183021 / 2.384e-06, /* 7 */
			5.245e-06 * 0.941544065183021 / 2.384e-06,
			1.7166e-05 * 0.941544065183021 / 2.384e-06,
			9.56535e-04 * 0.941544065183021 / 2.384e-06,
			1.0103703e-02 * 0.941544065183021 / 2.384e-06,
			-2.5527000e-02 * 0.941544065183021 / 2.384e-06,
			-3.914356e-03 * 0.941544065183021 / 2.384e-06,
			-5.07355e-04 * 0.941544065183021 / 2.384e-06,
			-3.0041e-05 * 0.941544065183021 / 2.384e-06,
			3.578057213145241e-01, 1.546020906725474e+00,

			-9.54e-07 * 0.956940335732209 / 2.384e-06,
			1.02520e-04 * 0.956940335732209 / 2.384e-06,
			5.39303e-04 * 0.956940335732209 / 2.384e-06,
			-1.011848e-03 * 0.956940335732209 / 2.384e-06,
			3.3659935e-02 * 0.956940335732209 / 2.384e-06,
			4.703045e-03 * 0.956940335732209 / 2.384e-06,
			9.15051e-04 * 0.956940335732209 / 2.384e-06,
			7.0095e-05 * 0.956940335732209 / 2.384e-06, /* 6 */
			4.768e-06 * 0.956940335732209 / 2.384e-06,
			9.54e-07 * 0.956940335732209 / 2.384e-06,
			8.06808e-04 * 0.956940335732209 / 2.384e-06,
			9.287834e-03 * 0.956940335732209 / 2.384e-06,
			-2.6310921e-02 * 0.956940335732209 / 2.384e-06,
			-4.048824e-03 * 0.956940335732209 / 2.384e-06,
			-5.42164e-04 * 0.956940335732209 / 2.384e-06,
			-3.2425e-05 * 0.956940335732209 / 2.384e-06,
			3.033466836073424e-01, 1.662939224605090e+00,

			-1.431e-06 * 0.970031253194544 / 2.384e-06,
			9.9182e-05 * 0.970031253194544 / 2.384e-06,
			4.62532e-04 * 0.970031253194544 / 2.384e-06,
			-1.573563e-03 * 0.970031253194544 / 2.384e-06,
			3.3225536e-02 * 0.970031253194544 / 2.384e-06,
			4.737377e-03 * 0.970031253194544 / 2.384e-06,
			8.91685e-04 * 0.970031253194544 / 2.384e-06,
			6.6280e-05 * 0.970031253194544 / 2.384e-06, /* 5 */
			4.292e-06 * 0.970031253194544 / 2.384e-06,
			-1.3828e-05 * 0.970031253194544 / 2.384e-06,
			6.61850e-04 * 0.970031253194544 / 2.384e-06,
			8.487225e-03 * 0.970031253194544 / 2.384e-06,
			-2.7073860e-02 * 0.970031253194544 / 2.384e-06,
			-4.174709e-03 * 0.970031253194544 / 2.384e-06,
			-5.76973e-04 * 0.970031253194544 / 2.384e-06,
			-3.4809e-05 * 0.970031253194544 / 2.384e-06,
			2.504869601913055e-01, 1.763842528696710e+00,

			-1.431e-06 * 0.98078528040323 / 2.384e-06,
			9.5367e-05 * 0.98078528040323 / 2.384e-06,
			3.78609e-04 * 0.98078528040323 / 2.384e-06,
			-2.161503e-03 * 0.98078528040323 / 2.384e-06,
			3.2754898e-02 * 0.98078528040323 / 2.384e-06,
			4.752159e-03 * 0.98078528040323 / 2.384e-06,
			8.66413e-04 * 0.98078528040323 / 2.384e-06,
			6.2943e-05 * 0.98078528040323 / 2.384e-06, /* 4 */
			3.815e-06 * 0.98078528040323 / 2.384e-06,
			-2.718e-05 * 0.98078528040323 / 2.384e-06,
			5.22137e-04 * 0.98078528040323 / 2.384e-06,
			7.703304e-03 * 0.98078528040323 / 2.384e-06,
			-2.7815342e-02 * 0.98078528040323 / 2.384e-06,
			-4.290581e-03 * 0.98078528040323 / 2.384e-06,
			-6.11782e-04 * 0.98078528040323 / 2.384e-06,
			-3.7670e-05 * 0.98078528040323 / 2.384e-06,
			1.989123673796580e-01, 1.847759065022573e+00,

			-1.907e-06 * 0.989176509964781 / 2.384e-06,
			9.0122e-05 * 0.989176509964781 / 2.384e-06,
			2.88486e-04 * 0.989176509964781 / 2.384e-06,
			-2.774239e-03 * 0.989176509964781 / 2.384e-06,
			3.2248020e-02 * 0.989176509964781 / 2.384e-06,
			4.748821e-03 * 0.989176509964781 / 2.384e-06,
			8.38757e-04 * 0.989176509964781 / 2.384e-06,
			5.9605e-05 * 0.989176509964781 / 2.384e-06, /* 3 */
			3.338e-06 * 0.989176509964781 / 2.384e-06,
			-3.9577e-05 * 0.989176509964781 / 2.384e-06,
			3.88145e-04 * 0.989176509964781 / 2.384e-06,
			6.937027e-03 * 0.989176509964781 / 2.384e-06,
			-2.8532982e-02 * 0.989176509964781 / 2.384e-06,
			-4.395962e-03 * 0.989176509964781 / 2.384e-06,
			-6.46591e-04 * 0.989176509964781 / 2.384e-06,
			-4.0531e-05 * 0.989176509964781 / 2.384e-06,
			1.483359875383474e-01, 1.913880671464418e+00,

			-1.907e-06 * 0.995184726672197 / 2.384e-06,
			8.4400e-05 * 0.995184726672197 / 2.384e-06,
			1.91689e-04 * 0.995184726672197 / 2.384e-06,
			-3.411293e-03 * 0.995184726672197 / 2.384e-06,
			3.1706810e-02 * 0.995184726672197 / 2.384e-06,
			4.728317e-03 * 0.995184726672197 / 2.384e-06,
			8.09669e-04 * 0.995184726672197 / 2.384e-06,
			5.579e-05 * 0.995184726672197 / 2.384e-06,
			3.338e-06 * 0.995184726672197 / 2.384e-06,
			-5.0545e-05 * 0.995184726672197 / 2.384e-06,
			2.59876e-04 * 0.995184726672197 / 2.384e-06,
			6.189346e-03 * 0.995184726672197 / 2.384e-06,
			-2.9224873e-02 * 0.995184726672197 / 2.384e-06,
			-4.489899e-03 * 0.995184726672197 / 2.384e-06,
			-6.80923e-04 * 0.995184726672197 / 2.384e-06,
			-4.3392e-05 * 0.995184726672197 / 2.384e-06,
			9.849140335716425e-02, 1.961570560806461e+00,

			-2.384e-06 * 0.998795456205172 / 2.384e-06,
			7.7724e-05 * 0.998795456205172 / 2.384e-06,
			8.8215e-05 * 0.998795456205172 / 2.384e-06,
			-4.072189e-03 * 0.998795456205172 / 2.384e-06,
			3.1132698e-02 * 0.998795456205172 / 2.384e-06,
			4.691124e-03 * 0.998795456205172 / 2.384e-06,
			7.79152e-04 * 0.998795456205172 / 2.384e-06,
			5.2929e-05 * 0.998795456205172 / 2.384e-06,
			2.861e-06 * 0.998795456205172 / 2.384e-06,
			-6.0558e-05 * 0.998795456205172 / 2.384e-06,
			1.37329e-04 * 0.998795456205172 / 2.384e-06,
			5.462170e-03 * 0.998795456205172 / 2.384e-06,
			-2.9890060e-02 * 0.998795456205172 / 2.384e-06,
			-4.570484e-03 * 0.998795456205172 / 2.384e-06,
			-7.14302e-04 * 0.998795456205172 / 2.384e-06,
			-4.6253e-05 * 0.998795456205172 / 2.384e-06,
			4.912684976946725e-02, 1.990369453344394e+00,

			3.5780907e-02 * Util.SQRT2 * 0.5 / 2.384e-06,
			1.7876148e-02 * Util.SQRT2 * 0.5 / 2.384e-06,
			3.134727e-03 * Util.SQRT2 * 0.5 / 2.384e-06,
			2.457142e-03 * Util.SQRT2 * 0.5 / 2.384e-06,
			9.71317e-04 * Util.SQRT2 * 0.5 / 2.384e-06,
			2.18868e-04 * Util.SQRT2 * 0.5 / 2.384e-06,
			1.01566e-04 * Util.SQRT2 * 0.5 / 2.384e-06,
			1.3828e-05 * Util.SQRT2 * 0.5 / 2.384e-06,

			3.0526638e-02 / 2.384e-06, 4.638195e-03 / 2.384e-06,
			7.47204e-04 / 2.384e-06, 4.9591e-05 / 2.384e-06,
			4.756451e-03 / 2.384e-06, 2.1458e-05 / 2.384e-06,
			-6.9618e-05 / 2.384e-06, /* 2.384e-06/2.384e-06 */
	];

	var NS = 12;
	var NL = 36;

	var win = [
	    [
	     2.382191739347913e-13,
	     6.423305872147834e-13,
	     9.400849094049688e-13,
	     1.122435026096556e-12,
	     1.183840321267481e-12,
	     1.122435026096556e-12,
	     9.400849094049690e-13,
	     6.423305872147839e-13,
	     2.382191739347918e-13,

	     5.456116108943412e-12,
	     4.878985199565852e-12,
	     4.240448995017367e-12,
	     3.559909094758252e-12,
	     2.858043359288075e-12,
	     2.156177623817898e-12,
	     1.475637723558783e-12,
	     8.371015190102974e-13,
	     2.599706096327376e-13,

	     -5.456116108943412e-12,
	     -4.878985199565852e-12,
	     -4.240448995017367e-12,
	     -3.559909094758252e-12,
	     -2.858043359288076e-12,
	     -2.156177623817898e-12,
	     -1.475637723558783e-12,
	     -8.371015190102975e-13,
	     -2.599706096327376e-13,

	     -2.382191739347923e-13,
	     -6.423305872147843e-13,
	     -9.400849094049696e-13,
	     -1.122435026096556e-12,
	     -1.183840321267481e-12,
	     -1.122435026096556e-12,
	     -9.400849094049694e-13,
	     -6.423305872147840e-13,
	     -2.382191739347918e-13,
	     ],
	    [
	     2.382191739347913e-13,
	     6.423305872147834e-13,
	     9.400849094049688e-13,
	     1.122435026096556e-12,
	     1.183840321267481e-12,
	     1.122435026096556e-12,
	     9.400849094049688e-13,
	     6.423305872147841e-13,
	     2.382191739347918e-13,

	     5.456116108943413e-12,
	     4.878985199565852e-12,
	     4.240448995017367e-12,
	     3.559909094758253e-12,
	     2.858043359288075e-12,
	     2.156177623817898e-12,
	     1.475637723558782e-12,
	     8.371015190102975e-13,
	     2.599706096327376e-13,

	     -5.461314069809755e-12,
	     -4.921085770524055e-12,
	     -4.343405037091838e-12,
	     -3.732668368707687e-12,
	     -3.093523840190885e-12,
	     -2.430835727329465e-12,
	     -1.734679010007751e-12,
	     -9.748253656609281e-13,
	     -2.797435120168326e-13,

	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     -2.283748241799531e-13,
	     -4.037858874020686e-13,
	     -2.146547464825323e-13,
	     ],
	    [
	     1.316524975873958e-01, /* win[SHORT_TYPE] */
	     4.142135623730950e-01,
	     7.673269879789602e-01,

	     1.091308501069271e+00, /* tantab_l */
	     1.303225372841206e+00,
	     1.569685577117490e+00,
	     1.920982126971166e+00,
	     2.414213562373094e+00,
	     3.171594802363212e+00,
	     4.510708503662055e+00,
	     7.595754112725146e+00,
	     2.290376554843115e+01,

	     0.98480775301220802032, /* cx */
	     0.64278760968653936292,
	     0.34202014332566882393,
	     0.93969262078590842791,
	     -0.17364817766693030343,
	     -0.76604444311897790243,
	     0.86602540378443870761,
	     0.500000000000000e+00,

	     -5.144957554275265e-01, /* ca */
	     -4.717319685649723e-01,
	     -3.133774542039019e-01,
	     -1.819131996109812e-01,
	     -9.457419252642064e-02,
	     -4.096558288530405e-02,
	     -1.419856857247115e-02,
	     -3.699974673760037e-03,

	     8.574929257125442e-01, /* cs */
	     8.817419973177052e-01,
	     9.496286491027329e-01,
	     9.833145924917901e-01,
	     9.955178160675857e-01,
	     9.991605581781475e-01,
	     9.998991952444470e-01,
	     9.999931550702802e-01,
	     ],
	    [
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     2.283748241799531e-13,
	     4.037858874020686e-13,
	     2.146547464825323e-13,

	     5.461314069809755e-12,
	     4.921085770524055e-12,
	     4.343405037091838e-12,
	     3.732668368707687e-12,
	     3.093523840190885e-12,
	     2.430835727329466e-12,
	     1.734679010007751e-12,
	     9.748253656609281e-13,
	     2.797435120168326e-13,

	     -5.456116108943413e-12,
	     -4.878985199565852e-12,
	     -4.240448995017367e-12,
	     -3.559909094758253e-12,
	     -2.858043359288075e-12,
	     -2.156177623817898e-12,
	     -1.475637723558782e-12,
	     -8.371015190102975e-13,
	     -2.599706096327376e-13,

	     -2.382191739347913e-13,
	     -6.423305872147834e-13,
	     -9.400849094049688e-13,
	     -1.122435026096556e-12,
	     -1.183840321267481e-12,
	     -1.122435026096556e-12,
	     -9.400849094049688e-13,
	     -6.423305872147841e-13,
	     -2.382191739347918e-13,
	     ]
	];

	var tantab_l = win[Encoder.SHORT_TYPE];
	var cx = win[Encoder.SHORT_TYPE];
	var ca = win[Encoder.SHORT_TYPE];
	var cs = win[Encoder.SHORT_TYPE];

	/**
	 * new IDCT routine written by Takehiro TOMINAGA
	 *
	 * PURPOSE: Overlapping window on PCM samples<BR>
	 *
	 * SEMANTICS:<BR>
	 * 32 16-bit pcm samples are scaled to fractional 2's complement and
	 * concatenated to the end of the window buffer #x#. The updated window
	 * buffer #x# is then windowed by the analysis window #c# to produce the
	 * windowed sample #z#
	 */
	var order = [
	    0, 1, 16, 17, 8, 9, 24, 25, 4, 5, 20, 21, 12, 13, 28, 29,
	    2, 3, 18, 19, 10, 11, 26, 27, 6, 7, 22, 23, 14, 15, 30, 31
	];

	/**
	 * returns sum_j=0^31 a[j]*cos(PI*j*(k+1/2)/32), 0<=k<32
	 */
	function window_subband(x1, x1Pos, a) {
		var wp = 10;

		var x2 = x1Pos + 238 - 14 - 286;

		for (var i = -15; i < 0; i++) {
			var w, s, t;

			w = enwindow[wp + -10];
			s = x1[x2 + -224] * w;
			t = x1[x1Pos + 224] * w;
			w = enwindow[wp + -9];
			s += x1[x2 + -160] * w;
			t += x1[x1Pos + 160] * w;
			w = enwindow[wp + -8];
			s += x1[x2 + -96] * w;
			t += x1[x1Pos + 96] * w;
			w = enwindow[wp + -7];
			s += x1[x2 + -32] * w;
			t += x1[x1Pos + 32] * w;
			w = enwindow[wp + -6];
			s += x1[x2 + 32] * w;
			t += x1[x1Pos + -32] * w;
			w = enwindow[wp + -5];
			s += x1[x2 + 96] * w;
			t += x1[x1Pos + -96] * w;
			w = enwindow[wp + -4];
			s += x1[x2 + 160] * w;
			t += x1[x1Pos + -160] * w;
			w = enwindow[wp + -3];
			s += x1[x2 + 224] * w;
			t += x1[x1Pos + -224] * w;

			w = enwindow[wp + -2];
			s += x1[x1Pos + -256] * w;
			t -= x1[x2 + 256] * w;
			w = enwindow[wp + -1];
			s += x1[x1Pos + -192] * w;
			t -= x1[x2 + 192] * w;
			w = enwindow[wp + 0];
			s += x1[x1Pos + -128] * w;
			t -= x1[x2 + 128] * w;
			w = enwindow[wp + 1];
			s += x1[x1Pos + -64] * w;
			t -= x1[x2 + 64] * w;
			w = enwindow[wp + 2];
			s += x1[x1Pos + 0] * w;
			t -= x1[x2 + 0] * w;
			w = enwindow[wp + 3];
			s += x1[x1Pos + 64] * w;
			t -= x1[x2 + -64] * w;
			w = enwindow[wp + 4];
			s += x1[x1Pos + 128] * w;
			t -= x1[x2 + -128] * w;
			w = enwindow[wp + 5];
			s += x1[x1Pos + 192] * w;
			t -= x1[x2 + -192] * w;

			/*
			 * this multiplyer could be removed, but it needs more 256 FLOAT
			 * data. thinking about the data cache performance, I think we
			 * should not use such a huge table. tt 2000/Oct/25
			 */
			s *= enwindow[wp + 6];
			w = t - s;
			a[30 + i * 2] = t + s;
			a[31 + i * 2] = enwindow[wp + 7] * w;
			wp += 18;
			x1Pos--;
			x2++;
		}
		{
			var s, t, u, v;
			t = x1[x1Pos + -16] * enwindow[wp + -10];
			s = x1[x1Pos + -32] * enwindow[wp + -2];
			t += (x1[x1Pos + -48] - x1[x1Pos + 16]) * enwindow[wp + -9];
			s += x1[x1Pos + -96] * enwindow[wp + -1];
			t += (x1[x1Pos + -80] + x1[x1Pos + 48]) * enwindow[wp + -8];
			s += x1[x1Pos + -160] * enwindow[wp + 0];
			t += (x1[x1Pos + -112] - x1[x1Pos + 80]) * enwindow[wp + -7];
			s += x1[x1Pos + -224] * enwindow[wp + 1];
			t += (x1[x1Pos + -144] + x1[x1Pos + 112]) * enwindow[wp + -6];
			s -= x1[x1Pos + 32] * enwindow[wp + 2];
			t += (x1[x1Pos + -176] - x1[x1Pos + 144]) * enwindow[wp + -5];
			s -= x1[x1Pos + 96] * enwindow[wp + 3];
			t += (x1[x1Pos + -208] + x1[x1Pos + 176]) * enwindow[wp + -4];
			s -= x1[x1Pos + 160] * enwindow[wp + 4];
			t += (x1[x1Pos + -240] - x1[x1Pos + 208]) * enwindow[wp + -3];
			s -= x1[x1Pos + 224];

			u = s - t;
			v = s + t;

			t = a[14];
			s = a[15] - t;

			a[31] = v + t; /* A0 */
			a[30] = u + s; /* A1 */
			a[15] = u - s; /* A2 */
			a[14] = v - t; /* A3 */
		}
		{
			var xr;
			xr = a[28] - a[0];
			a[0] += a[28];
			a[28] = xr * enwindow[wp + -2 * 18 + 7];
			xr = a[29] - a[1];
			a[1] += a[29];
			a[29] = xr * enwindow[wp + -2 * 18 + 7];

			xr = a[26] - a[2];
			a[2] += a[26];
			a[26] = xr * enwindow[wp + -4 * 18 + 7];
			xr = a[27] - a[3];
			a[3] += a[27];
			a[27] = xr * enwindow[wp + -4 * 18 + 7];

			xr = a[24] - a[4];
			a[4] += a[24];
			a[24] = xr * enwindow[wp + -6 * 18 + 7];
			xr = a[25] - a[5];
			a[5] += a[25];
			a[25] = xr * enwindow[wp + -6 * 18 + 7];

			xr = a[22] - a[6];
			a[6] += a[22];
			a[22] = xr * Util.SQRT2;
			xr = a[23] - a[7];
			a[7] += a[23];
			a[23] = xr * Util.SQRT2 - a[7];
			a[7] -= a[6];
			a[22] -= a[7];
			a[23] -= a[22];

			xr = a[6];
			a[6] = a[31] - xr;
			a[31] = a[31] + xr;
			xr = a[7];
			a[7] = a[30] - xr;
			a[30] = a[30] + xr;
			xr = a[22];
			a[22] = a[15] - xr;
			a[15] = a[15] + xr;
			xr = a[23];
			a[23] = a[14] - xr;
			a[14] = a[14] + xr;

			xr = a[20] - a[8];
			a[8] += a[20];
			a[20] = xr * enwindow[wp + -10 * 18 + 7];
			xr = a[21] - a[9];
			a[9] += a[21];
			a[21] = xr * enwindow[wp + -10 * 18 + 7];

			xr = a[18] - a[10];
			a[10] += a[18];
			a[18] = xr * enwindow[wp + -12 * 18 + 7];
			xr = a[19] - a[11];
			a[11] += a[19];
			a[19] = xr * enwindow[wp + -12 * 18 + 7];

			xr = a[16] - a[12];
			a[12] += a[16];
			a[16] = xr * enwindow[wp + -14 * 18 + 7];
			xr = a[17] - a[13];
			a[13] += a[17];
			a[17] = xr * enwindow[wp + -14 * 18 + 7];

			xr = -a[20] + a[24];
			a[20] += a[24];
			a[24] = xr * enwindow[wp + -12 * 18 + 7];
			xr = -a[21] + a[25];
			a[21] += a[25];
			a[25] = xr * enwindow[wp + -12 * 18 + 7];

			xr = a[4] - a[8];
			a[4] += a[8];
			a[8] = xr * enwindow[wp + -12 * 18 + 7];
			xr = a[5] - a[9];
			a[5] += a[9];
			a[9] = xr * enwindow[wp + -12 * 18 + 7];

			xr = a[0] - a[12];
			a[0] += a[12];
			a[12] = xr * enwindow[wp + -4 * 18 + 7];
			xr = a[1] - a[13];
			a[1] += a[13];
			a[13] = xr * enwindow[wp + -4 * 18 + 7];
			xr = a[16] - a[28];
			a[16] += a[28];
			a[28] = xr * enwindow[wp + -4 * 18 + 7];
			xr = -a[17] + a[29];
			a[17] += a[29];
			a[29] = xr * enwindow[wp + -4 * 18 + 7];

			xr = Util.SQRT2 * (a[2] - a[10]);
			a[2] += a[10];
			a[10] = xr;
			xr = Util.SQRT2 * (a[3] - a[11]);
			a[3] += a[11];
			a[11] = xr;
			xr = Util.SQRT2 * (-a[18] + a[26]);
			a[18] += a[26];
			a[26] = xr - a[18];
			xr = Util.SQRT2 * (-a[19] + a[27]);
			a[19] += a[27];
			a[27] = xr - a[19];

			xr = a[2];
			a[19] -= a[3];
			a[3] -= xr;
			a[2] = a[31] - xr;
			a[31] += xr;
			xr = a[3];
			a[11] -= a[19];
			a[18] -= xr;
			a[3] = a[30] - xr;
			a[30] += xr;
			xr = a[18];
			a[27] -= a[11];
			a[19] -= xr;
			a[18] = a[15] - xr;
			a[15] += xr;

			xr = a[19];
			a[10] -= xr;
			a[19] = a[14] - xr;
			a[14] += xr;
			xr = a[10];
			a[11] -= xr;
			a[10] = a[23] - xr;
			a[23] += xr;
			xr = a[11];
			a[26] -= xr;
			a[11] = a[22] - xr;
			a[22] += xr;
			xr = a[26];
			a[27] -= xr;
			a[26] = a[7] - xr;
			a[7] += xr;

			xr = a[27];
			a[27] = a[6] - xr;
			a[6] += xr;

			xr = Util.SQRT2 * (a[0] - a[4]);
			a[0] += a[4];
			a[4] = xr;
			xr = Util.SQRT2 * (a[1] - a[5]);
			a[1] += a[5];
			a[5] = xr;
			xr = Util.SQRT2 * (a[16] - a[20]);
			a[16] += a[20];
			a[20] = xr;
			xr = Util.SQRT2 * (a[17] - a[21]);
			a[17] += a[21];
			a[21] = xr;

			xr = -Util.SQRT2 * (a[8] - a[12]);
			a[8] += a[12];
			a[12] = xr - a[8];
			xr = -Util.SQRT2 * (a[9] - a[13]);
			a[9] += a[13];
			a[13] = xr - a[9];
			xr = -Util.SQRT2 * (a[25] - a[29]);
			a[25] += a[29];
			a[29] = xr - a[25];
			xr = -Util.SQRT2 * (a[24] + a[28]);
			a[24] -= a[28];
			a[28] = xr - a[24];

			xr = a[24] - a[16];
			a[24] = xr;
			xr = a[20] - xr;
			a[20] = xr;
			xr = a[28] - xr;
			a[28] = xr;

			xr = a[25] - a[17];
			a[25] = xr;
			xr = a[21] - xr;
			a[21] = xr;
			xr = a[29] - xr;
			a[29] = xr;

			xr = a[17] - a[1];
			a[17] = xr;
			xr = a[9] - xr;
			a[9] = xr;
			xr = a[25] - xr;
			a[25] = xr;
			xr = a[5] - xr;
			a[5] = xr;
			xr = a[21] - xr;
			a[21] = xr;
			xr = a[13] - xr;
			a[13] = xr;
			xr = a[29] - xr;
			a[29] = xr;

			xr = a[1] - a[0];
			a[1] = xr;
			xr = a[16] - xr;
			a[16] = xr;
			xr = a[17] - xr;
			a[17] = xr;
			xr = a[8] - xr;
			a[8] = xr;
			xr = a[9] - xr;
			a[9] = xr;
			xr = a[24] - xr;
			a[24] = xr;
			xr = a[25] - xr;
			a[25] = xr;
			xr = a[4] - xr;
			a[4] = xr;
			xr = a[5] - xr;
			a[5] = xr;
			xr = a[20] - xr;
			a[20] = xr;
			xr = a[21] - xr;
			a[21] = xr;
			xr = a[12] - xr;
			a[12] = xr;
			xr = a[13] - xr;
			a[13] = xr;
			xr = a[28] - xr;
			a[28] = xr;
			xr = a[29] - xr;
			a[29] = xr;

			xr = a[0];
			a[0] += a[31];
			a[31] -= xr;
			xr = a[1];
			a[1] += a[30];
			a[30] -= xr;
			xr = a[16];
			a[16] += a[15];
			a[15] -= xr;
			xr = a[17];
			a[17] += a[14];
			a[14] -= xr;
			xr = a[8];
			a[8] += a[23];
			a[23] -= xr;
			xr = a[9];
			a[9] += a[22];
			a[22] -= xr;
			xr = a[24];
			a[24] += a[7];
			a[7] -= xr;
			xr = a[25];
			a[25] += a[6];
			a[6] -= xr;
			xr = a[4];
			a[4] += a[27];
			a[27] -= xr;
			xr = a[5];
			a[5] += a[26];
			a[26] -= xr;
			xr = a[20];
			a[20] += a[11];
			a[11] -= xr;
			xr = a[21];
			a[21] += a[10];
			a[10] -= xr;
			xr = a[12];
			a[12] += a[19];
			a[19] -= xr;
			xr = a[13];
			a[13] += a[18];
			a[18] -= xr;
			xr = a[28];
			a[28] += a[3];
			a[3] -= xr;
			xr = a[29];
			a[29] += a[2];
			a[2] -= xr;
		}
	}

	/**
	 * Function: Calculation of the MDCT In the case of long blocks (type 0,1,3)
	 * there are 36 coefficents in the time domain and 18 in the frequency
	 * domain.<BR>
	 * In the case of short blocks (type 2) there are 3 transformations with
	 * short length. This leads to 12 coefficents in the time and 6 in the
	 * frequency domain. In this case the results are stored side by side in the
	 * vector out[].
	 *
	 * New layer3
	 */
	function mdct_short(inout, inoutPos) {
		for (var l = 0; l < 3; l++) {
			var tc0, tc1, tc2, ts0, ts1, ts2;

			ts0 = inout[inoutPos + 2 * 3] * win[Encoder.SHORT_TYPE][0]
					- inout[inoutPos + 5 * 3];
			tc0 = inout[inoutPos + 0 * 3] * win[Encoder.SHORT_TYPE][2]
					- inout[inoutPos + 3 * 3];
			tc1 = ts0 + tc0;
			tc2 = ts0 - tc0;

			ts0 = inout[inoutPos + 5 * 3] * win[Encoder.SHORT_TYPE][0]
					+ inout[inoutPos + 2 * 3];
			tc0 = inout[inoutPos + 3 * 3] * win[Encoder.SHORT_TYPE][2]
					+ inout[inoutPos + 0 * 3];
			ts1 = ts0 + tc0;
			ts2 = -ts0 + tc0;

			tc0 = (inout[inoutPos + 1 * 3] * win[Encoder.SHORT_TYPE][1] - inout[inoutPos + 4 * 3]) * 2.069978111953089e-11;
			/*
			 * tritab_s [ 1 ]
			 */
			ts0 = (inout[inoutPos + 4 * 3] * win[Encoder.SHORT_TYPE][1] + inout[inoutPos + 1 * 3]) * 2.069978111953089e-11;
			/*
			 * tritab_s [ 1 ]
			 */
			inout[inoutPos + 3 * 0] = tc1 * 1.907525191737280e-11 + tc0;
			/*
			 * tritab_s[ 2 ]
			 */
			inout[inoutPos + 3 * 5] = -ts1 * 1.907525191737280e-11 + ts0;
			/*
			 * tritab_s[0 ]
			 */
			tc2 = tc2 * 0.86602540378443870761 * 1.907525191737281e-11;
			/*
			 * tritab_s[ 2]
			 */
			ts1 = ts1 * 0.5 * 1.907525191737281e-11 + ts0;
			inout[inoutPos + 3 * 1] = tc2 - ts1;
			inout[inoutPos + 3 * 2] = tc2 + ts1;

			tc1 = tc1 * 0.5 * 1.907525191737281e-11 - tc0;
			ts2 = ts2 * 0.86602540378443870761 * 1.907525191737281e-11;
			/*
			 * tritab_s[ 0]
			 */
			inout[inoutPos + 3 * 3] = tc1 + ts2;
			inout[inoutPos + 3 * 4] = tc1 - ts2;

			inoutPos++;
		}
	}

	function mdct_long(out, outPos, _in) {
		var ct, st;
		{
			var tc1, tc2, tc3, tc4, ts5, ts6, ts7, ts8;
			/* 1,2, 5,6, 9,10, 13,14, 17 */
			tc1 = _in[17] - _in[9];
			tc3 = _in[15] - _in[11];
			tc4 = _in[14] - _in[12];
			ts5 = _in[0] + _in[8];
			ts6 = _in[1] + _in[7];
			ts7 = _in[2] + _in[6];
			ts8 = _in[3] + _in[5];

			out[outPos + 17] = (ts5 + ts7 - ts8) - (ts6 - _in[4]);
			st = (ts5 + ts7 - ts8) * cx[12 + 7] + (ts6 - _in[4]);
			ct = (tc1 - tc3 - tc4) * cx[12 + 6];
			out[outPos + 5] = ct + st;
			out[outPos + 6] = ct - st;

			tc2 = (_in[16] - _in[10]) * cx[12 + 6];
			ts6 = ts6 * cx[12 + 7] + _in[4];
			ct = tc1 * cx[12 + 0] + tc2 + tc3 * cx[12 + 1] + tc4 * cx[12 + 2];
			st = -ts5 * cx[12 + 4] + ts6 - ts7 * cx[12 + 5] + ts8 * cx[12 + 3];
			out[outPos + 1] = ct + st;
			out[outPos + 2] = ct - st;

			ct = tc1 * cx[12 + 1] - tc2 - tc3 * cx[12 + 2] + tc4 * cx[12 + 0];
			st = -ts5 * cx[12 + 5] + ts6 - ts7 * cx[12 + 3] + ts8 * cx[12 + 4];
			out[outPos + 9] = ct + st;
			out[outPos + 10] = ct - st;

			ct = tc1 * cx[12 + 2] - tc2 + tc3 * cx[12 + 0] - tc4 * cx[12 + 1];
			st = ts5 * cx[12 + 3] - ts6 + ts7 * cx[12 + 4] - ts8 * cx[12 + 5];
			out[outPos + 13] = ct + st;
			out[outPos + 14] = ct - st;
		}
		{
			var ts1, ts2, ts3, ts4, tc5, tc6, tc7, tc8;

			ts1 = _in[8] - _in[0];
			ts3 = _in[6] - _in[2];
			ts4 = _in[5] - _in[3];
			tc5 = _in[17] + _in[9];
			tc6 = _in[16] + _in[10];
			tc7 = _in[15] + _in[11];
			tc8 = _in[14] + _in[12];

			out[outPos + 0] = (tc5 + tc7 + tc8) + (tc6 + _in[13]);
			ct = (tc5 + tc7 + tc8) * cx[12 + 7] - (tc6 + _in[13]);
			st = (ts1 - ts3 + ts4) * cx[12 + 6];
			out[outPos + 11] = ct + st;
			out[outPos + 12] = ct - st;

			ts2 = (_in[7] - _in[1]) * cx[12 + 6];
			tc6 = _in[13] - tc6 * cx[12 + 7];
			ct = tc5 * cx[12 + 3] - tc6 + tc7 * cx[12 + 4] + tc8 * cx[12 + 5];
			st = ts1 * cx[12 + 2] + ts2 + ts3 * cx[12 + 0] + ts4 * cx[12 + 1];
			out[outPos + 3] = ct + st;
			out[outPos + 4] = ct - st;

			ct = -tc5 * cx[12 + 5] + tc6 - tc7 * cx[12 + 3] - tc8 * cx[12 + 4];
			st = ts1 * cx[12 + 1] + ts2 - ts3 * cx[12 + 2] - ts4 * cx[12 + 0];
			out[outPos + 7] = ct + st;
			out[outPos + 8] = ct - st;

			ct = -tc5 * cx[12 + 4] + tc6 - tc7 * cx[12 + 5] - tc8 * cx[12 + 3];
			st = ts1 * cx[12 + 0] - ts2 + ts3 * cx[12 + 1] - ts4 * cx[12 + 2];
			out[outPos + 15] = ct + st;
			out[outPos + 16] = ct - st;
		}
	}

	this.mdct_sub48 = function(gfc, w0, w1) {
		var wk = w0;
		var wkPos = 286;
		/* thinking cache performance, ch->gr loop is better than gr->ch loop */
		for (var ch = 0; ch < gfc.channels_out; ch++) {
			for (var gr = 0; gr < gfc.mode_gr; gr++) {
				var band;
				var gi = (gfc.l3_side.tt[gr][ch]);
				var mdct_enc = gi.xr;
				var mdct_encPos = 0;
				var samp = gfc.sb_sample[ch][1 - gr];
				var sampPos = 0;

				for (var k = 0; k < 18 / 2; k++) {
					window_subband(wk, wkPos, samp[sampPos]);
					window_subband(wk, wkPos + 32, samp[sampPos + 1]);
					sampPos += 2;
					wkPos += 64;
					/*
					 * Compensate for inversion in the analysis filter
					 */
					for (band = 1; band < 32; band += 2) {
						samp[sampPos - 1][band] *= -1;
					}
				}

				/*
				 * Perform imdct of 18 previous subband samples + 18 current
				 * subband samples
				 */
				for (band = 0; band < 32; band++, mdct_encPos += 18) {
					var type = gi.block_type;
					var band0 = gfc.sb_sample[ch][gr];
					var band1 = gfc.sb_sample[ch][1 - gr];
					if (gi.mixed_block_flag != 0 && band < 2)
						type = 0;
					if (gfc.amp_filter[band] < 1e-12) {
						Arrays.fill(mdct_enc, mdct_encPos + 0,
								mdct_encPos + 18, 0);
					} else {
						if (gfc.amp_filter[band] < 1.0) {
							for (var k = 0; k < 18; k++)
								band1[k][order[band]] *= gfc.amp_filter[band];
						}
						if (type == Encoder.SHORT_TYPE) {
							for (var k = -NS / 4; k < 0; k++) {
								var w = win[Encoder.SHORT_TYPE][k + 3];
								mdct_enc[mdct_encPos + k * 3 + 9] = band0[9 + k][order[band]]
										* w - band0[8 - k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 18] = band0[14 - k][order[band]]
										* w + band0[15 + k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 10] = band0[15 + k][order[band]]
										* w - band0[14 - k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 19] = band1[2 - k][order[band]]
										* w + band1[3 + k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 11] = band1[3 + k][order[band]]
										* w - band1[2 - k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 20] = band1[8 - k][order[band]]
										* w + band1[9 + k][order[band]];
							}
							mdct_short(mdct_enc, mdct_encPos);
						} else {
							var work = new_float(18);
							for (var k = -NL / 4; k < 0; k++) {
								var a, b;
								a = win[type][k + 27]
										* band1[k + 9][order[band]]
										+ win[type][k + 36]
										* band1[8 - k][order[band]];
								b = win[type][k + 9]
										* band0[k + 9][order[band]]
										- win[type][k + 18]
										* band0[8 - k][order[band]];
								work[k + 9] = a - b * tantab_l[3 + k + 9];
								work[k + 18] = a * tantab_l[3 + k + 9] + b;
							}

							mdct_long(mdct_enc, mdct_encPos, work);
						}
					}
					/*
					 * Perform aliasing reduction butterfly
					 */
					if (type != Encoder.SHORT_TYPE && band != 0) {
						for (var k = 7; k >= 0; --k) {
							var bu, bd;
							bu = mdct_enc[mdct_encPos + k] * ca[20 + k]
									+ mdct_enc[mdct_encPos + -1 - k]
									* cs[28 + k];
							bd = mdct_enc[mdct_encPos + k] * cs[28 + k]
									- mdct_enc[mdct_encPos + -1 - k]
									* ca[20 + k];

							mdct_enc[mdct_encPos + -1 - k] = bu;
							mdct_enc[mdct_encPos + k] = bd;
						}
					}
				}
			}
			wk = w1;
			wkPos = 286;
			if (gfc.mode_gr == 1) {
				for (var i = 0; i < 18; i++) {
					System.arraycopy(gfc.sb_sample[ch][1][i], 0,
							gfc.sb_sample[ch][0][i], 0, 32);
				}
			}
		}
	}
}

module.exports = NewMDCT;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

//package mp3;

var III_psy_xmin = __webpack_require__(362);

function III_psy_ratio() {
	this.thm = new III_psy_xmin();
	this.en = new III_psy_xmin();
}

module.exports = III_psy_ratio;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var MPEGMode = __webpack_require__(363);

function LameGlobalFlags() {

    this.class_id = 0;

    /* input description */

    /**
     * number of samples. default=-1
     */
    this.num_samples = 0;
    /**
     * input number of channels. default=2
     */
    this.num_channels = 0;
    /**
     * input_samp_rate in Hz. default=44.1 kHz
     */
    this.in_samplerate = 0;
    /**
     * output_samp_rate. default: LAME picks best value at least not used for
     * MP3 decoding: Remember 44.1 kHz MP3s and AC97
     */
    this.out_samplerate = 0;
    /**
     * scale input by this amount before encoding at least not used for MP3
     * decoding
     */
    this.scale = 0.;
    /**
     * scale input of channel 0 (left) by this amount before encoding
     */
    this.scale_left = 0.;
    /**
     * scale input of channel 1 (right) by this amount before encoding
     */
    this.scale_right = 0.;

    /* general control params */
    /**
     * collect data for a MP3 frame analyzer?
     */
    this.analysis = false;
    /**
     * add Xing VBR tag?
     */
    this.bWriteVbrTag = false;

    /**
     * use lame/mpglib to convert mp3 to wav
     */
    this.decode_only = false;
    /**
     * quality setting 0=best, 9=worst default=5
     */
    this.quality = 0;
    /**
     * see enum default = LAME picks best value
     */
    this.mode = MPEGMode.STEREO;
    /**
     * force M/S mode. requires mode=1
     */
    this.force_ms = false;
    /**
     * use free format? default=0
     */
    this.free_format = false;
    /**
     * find the RG value? default=0
     */
    this.findReplayGain = false;
    /**
     * decode on the fly? default=0
     */
    this.decode_on_the_fly = false;
    /**
     * 1 (default) writes ID3 tags, 0 not
     */
    this.write_id3tag_automatic = false;

    /*
     * set either brate>0 or compression_ratio>0, LAME will compute the value of
     * the variable not set. Default is compression_ratio = 11.025
     */
    /**
     * bitrate
     */
    this.brate = 0;
    /**
     * sizeof(wav file)/sizeof(mp3 file)
     */
    this.compression_ratio = 0.;

    /* frame params */
    /**
     * mark as copyright. default=0
     */
    this.copyright = 0;
    /**
     * mark as original. default=1
     */
    this.original = 0;
    /**
     * the MP3 'private extension' bit. Meaningless
     */
    this.extension = 0;
    /**
     * Input PCM is emphased PCM (for instance from one of the rarely emphased
     * CDs), it is STRONGLY not recommended to use this, because psycho does not
     * take it into account, and last but not least many decoders don't care
     * about these bits
     */
    this.emphasis = 0;
    /**
     * use 2 bytes per frame for a CRC checksum. default=0
     */
    this.error_protection = 0;
    /**
     * enforce ISO spec as much as possible
     */
    this.strict_ISO = false;

    /**
     * use bit reservoir?
     */
    this.disable_reservoir = false;

    /* quantization/noise shaping */
    this.quant_comp = 0;
    this.quant_comp_short = 0;
    this.experimentalY = false;
    this.experimentalZ = 0;
    this.exp_nspsytune = 0;

    this.preset = 0;

    /* VBR control */
    this.VBR = null;
    /**
     * Range [0,...,1[
     */
    this.VBR_q_frac = 0.;
    /**
     * Range [0,...,9]
     */
    this.VBR_q = 0;
    this.VBR_mean_bitrate_kbps = 0;
    this.VBR_min_bitrate_kbps = 0;
    this.VBR_max_bitrate_kbps = 0;
    /**
     * strictly enforce VBR_min_bitrate normaly, it will be violated for analog
     * silence
     */
    this.VBR_hard_min = 0;

    /* resampling and filtering */

    /**
     * freq in Hz. 0=lame choses. -1=no filter
     */
    this.lowpassfreq = 0;
    /**
     * freq in Hz. 0=lame choses. -1=no filter
     */
    this.highpassfreq = 0;
    /**
     * freq width of filter, in Hz (default=15%)
     */
    this.lowpasswidth = 0;
    /**
     * freq width of filter, in Hz (default=15%)
     */
    this.highpasswidth = 0;

    /*
     * psycho acoustics and other arguments which you should not change unless
     * you know what you are doing
     */

    this.maskingadjust = 0.;
    this.maskingadjust_short = 0.;
    /**
     * only use ATH
     */
    this.ATHonly = false;
    /**
     * only use ATH for short blocks
     */
    this.ATHshort = false;
    /**
     * disable ATH
     */
    this.noATH = false;
    /**
     * select ATH formula
     */
    this.ATHtype = 0;
    /**
     * change ATH formula 4 shape
     */
    this.ATHcurve = 0.;
    /**
     * lower ATH by this many db
     */
    this.ATHlower = 0.;
    /**
     * select ATH auto-adjust scheme
     */
    this.athaa_type = 0;
    /**
     * select ATH auto-adjust loudness calc
     */
    this.athaa_loudapprox = 0;
    /**
     * dB, tune active region of auto-level
     */
    this.athaa_sensitivity = 0.;
    this.short_blocks = null;
    /**
     * use temporal masking effect
     */
    this.useTemporal = false;
    this.interChRatio = 0.;
    /**
     * Naoki's adjustment of Mid/Side maskings
     */
    this.msfix = 0.;

    /**
     * 0 off, 1 on
     */
    this.tune = false;
    /**
     * used to pass values for debugging and stuff
     */
    this.tune_value_a = 0.;

    /************************************************************************/
    /* internal variables, do not set... */
    /* provided because they may be of use to calling application */
    /************************************************************************/

    /**
     * 0=MPEG-2/2.5 1=MPEG-1
     */
    this.version = 0;
    this.encoder_delay = 0;
    /**
     * number of samples of padding appended to input
     */
    this.encoder_padding = 0;
    this.framesize = 0;
    /**
     * number of frames encoded
     */
    this.frameNum = 0;
    /**
     * is this struct owned by calling program or lame?
     */
    this.lame_allocated_gfp = 0;
    /**************************************************************************/
    /* more internal variables are stored in this structure: */
    /**************************************************************************/
    this.internal_flags = null;
}

module.exports = LameGlobalFlags;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var GrInfo = __webpack_require__(204);

function IIISideInfo() {
    this.tt = [[null, null], [null, null]];
    this.main_data_begin = 0;
    this.private_bits = 0;
    this.resvDrain_pre = 0;
    this.resvDrain_post = 0;
    this.scfsi = [new_int(4), new_int(4)];

    for (var gr = 0; gr < 2; gr++) {
        for (var ch = 0; ch < 2; ch++) {
            this.tt[gr][ch] = new GrInfo();
        }
    }
}

module.exports = IIISideInfo;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var Encoder = __webpack_require__(35);

//package mp3;

/**
 * Variables used for --nspsytune
 *
 * @author Ken
 *
 */
function NsPsy() {
    this.last_en_subshort = new_float_n([4, 9]);
    this.lastAttacks = new_int(4);
    this.pefirbuf = new_float(19);
    this.longfact = new_float(Encoder.SBMAX_l);
    this.shortfact = new_float(Encoder.SBMAX_s);

    /**
     * short block tuning
     */
    this.attackthre = 0.;
    this.attackthre_s = 0.;
}

module.exports = NsPsy;


/***/ }),
/* 811 */
/***/ (function(module, exports) {

//package mp3;

function VBRSeekInfo() {
    /**
     * What we have seen so far.
     */
    this.sum = 0;
    /**
     * How many frames we have seen in this chunk.
     */
    this.seen = 0;
    /**
     * How many frames we want to collect into one chunk.
     */
    this.want = 0;
    /**
     * Actual position in our bag.
     */
    this.pos = 0;
    /**
     * Size of our bag.
     */
    this.size = 0;
    /**
     * Pointer to our bag.
     */
    this.bag = null;
    this.nVbrNumFrames = 0;
    this.nBytesWritten = 0;
    /* VBR tag data */
    this.TotalFrameSize = 0;
}

module.exports = VBRSeekInfo;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var Encoder = __webpack_require__(35);

/**
 * ATH related stuff, if something new ATH related has to be added, please plug
 * it here into the ATH.
 */
function ATH() {
    /**
     * Method for the auto adjustment.
     */
    this.useAdjust = 0;
    /**
     * factor for tuning the (sample power) point below which adaptive threshold
     * of hearing adjustment occurs
     */
    this.aaSensitivityP = 0.;
    /**
     * Lowering based on peak volume, 1 = no lowering.
     */
    this.adjust = 0.;
    /**
     * Limit for dynamic ATH adjust.
     */
    this.adjustLimit = 0.;
    /**
     * Determined to lower x dB each second.
     */
    this.decay = 0.;
    /**
     * Lowest ATH value.
     */
    this.floor = 0.;
    /**
     * ATH for sfbs in long blocks.
     */
    this.l = new_float(Encoder.SBMAX_l);
    /**
     * ATH for sfbs in short blocks.
     */
    this.s = new_float(Encoder.SBMAX_s);
    /**
     * ATH for partitioned sfb21 in long blocks.
     */
    this.psfb21 = new_float(Encoder.PSFB21);
    /**
     * ATH for partitioned sfb12 in short blocks.
     */
    this.psfb12 = new_float(Encoder.PSFB12);
    /**
     * ATH for long block convolution bands.
     */
    this.cb_l = new_float(Encoder.CBANDS);
    /**
     * ATH for short block convolution bands.
     */
    this.cb_s = new_float(Encoder.CBANDS);
    /**
     * Equal loudness weights (based on ATH).
     */
    this.eql_w = new_float(Encoder.BLKSIZE / 2);
}

module.exports = ATH;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var GainAnalysis = __webpack_require__(365);

function ReplayGain() {
    this.linprebuf = new_float(GainAnalysis.MAX_ORDER * 2);
    /**
     * left input samples, with pre-buffer
     */
    this.linpre = 0;
    this.lstepbuf = new_float(GainAnalysis.MAX_SAMPLES_PER_WINDOW + GainAnalysis.MAX_ORDER);
    /**
     * left "first step" (i.e. post first filter) samples
     */
    this.lstep = 0;
    this.loutbuf = new_float(GainAnalysis.MAX_SAMPLES_PER_WINDOW + GainAnalysis.MAX_ORDER);
    /**
     * left "out" (i.e. post second filter) samples
     */
    this.lout = 0;
    this.rinprebuf = new_float(GainAnalysis.MAX_ORDER * 2);
    /**
     * right input samples ...
     */
    this.rinpre = 0;
    this.rstepbuf = new_float(GainAnalysis.MAX_SAMPLES_PER_WINDOW + GainAnalysis.MAX_ORDER);
    this.rstep = 0;
    this.routbuf = new_float(GainAnalysis.MAX_SAMPLES_PER_WINDOW + GainAnalysis.MAX_ORDER);
    this.rout = 0;
    /**
     * number of samples required to reach number of milliseconds required
     * for RMS window
     */
    this.sampleWindow = 0;
    this.totsamp = 0;
    this.lsum = 0.;
    this.rsum = 0.;
    this.freqindex = 0;
    this.first = 0;
    this.A = new_int(0 | (GainAnalysis.STEPS_per_dB * GainAnalysis.MAX_dB));
    this.B = new_int(0 | (GainAnalysis.STEPS_per_dB * GainAnalysis.MAX_dB));

}

module.exports = ReplayGain;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var MeanBits = __webpack_require__(366);
var Encoder = __webpack_require__(35);
var L3Side = __webpack_require__(149);
var LameInternalFlags = __webpack_require__(148);

function CBRNewIterationLoop(_quantize)  {
    var quantize = _quantize;
    this.quantize = quantize;
	this.iteration_loop = function(gfp, pe, ms_ener_ratio, ratio) {
		var gfc = gfp.internal_flags;
        var l3_xmin = new_float(L3Side.SFBMAX);
		var xrpow = new_float(576);
		var targ_bits = new_int(2);
		var mean_bits = 0, max_bits;
		var l3_side = gfc.l3_side;

		var mb = new MeanBits(mean_bits);
		this.quantize.rv.ResvFrameBegin(gfp, mb);
		mean_bits = mb.bits;

		/* quantize! */
		for (var gr = 0; gr < gfc.mode_gr; gr++) {

			/*
			 * calculate needed bits
			 */
			max_bits = this.quantize.qupvt.on_pe(gfp, pe, targ_bits, mean_bits,
					gr, gr);

			if (gfc.mode_ext == Encoder.MPG_MD_MS_LR) {
				this.quantize.ms_convert(gfc.l3_side, gr);
				this.quantize.qupvt.reduce_side(targ_bits, ms_ener_ratio[gr],
						mean_bits, max_bits);
			}

			for (var ch = 0; ch < gfc.channels_out; ch++) {
				var adjust, masking_lower_db;
				var cod_info = l3_side.tt[gr][ch];

				if (cod_info.block_type != Encoder.SHORT_TYPE) {
					// NORM, START or STOP type
					adjust = 0;
					masking_lower_db = gfc.PSY.mask_adjust - adjust;
				} else {
					adjust = 0;
					masking_lower_db = gfc.PSY.mask_adjust_short - adjust;
				}
				gfc.masking_lower =  Math.pow(10.0,
						masking_lower_db * 0.1);

				/*
				 * init_outer_loop sets up cod_info, scalefac and xrpow
				 */
				this.quantize.init_outer_loop(gfc, cod_info);
				if (this.quantize.init_xrpow(gfc, cod_info, xrpow)) {
					/*
					 * xr contains energy we will have to encode calculate the
					 * masking abilities find some good quantization in
					 * outer_loop
					 */
					this.quantize.qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info,
							l3_xmin);
					this.quantize.outer_loop(gfp, cod_info, l3_xmin, xrpow, ch,
							targ_bits[ch]);
				}

				this.quantize.iteration_finish_one(gfc, gr, ch);
				assert (cod_info.part2_3_length <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
				assert (cod_info.part2_3_length <= targ_bits[ch]);
			} /* for ch */
		} /* for gr */

		this.quantize.rv.ResvFrameEnd(gfc, mean_bits);
	}
}
module.exports = CBRNewIterationLoop;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

function Presets() {
    function VBRPresets(qual, comp, compS,
                        y, shThreshold, shThresholdS,
                        adj, adjShort, lower,
                        curve, sens, inter,
                        joint, mod, fix) {
        this.vbr_q = qual;
        this.quant_comp = comp;
        this.quant_comp_s = compS;
        this.expY = y;
        this.st_lrm = shThreshold;
        this.st_s = shThresholdS;
        this.masking_adj = adj;
        this.masking_adj_short = adjShort;
        this.ath_lower = lower;
        this.ath_curve = curve;
        this.ath_sensitivity = sens;
        this.interch = inter;
        this.safejoint = joint;
        this.sfb21mod = mod;
        this.msfix = fix;
    }

    function ABRPresets(kbps, comp, compS,
                        joint, fix, shThreshold,
                        shThresholdS, bass, sc,
                        mask, lower, curve,
                        interCh, sfScale) {
        this.quant_comp = comp;
        this.quant_comp_s = compS;
        this.safejoint = joint;
        this.nsmsfix = fix;
        this.st_lrm = shThreshold;
        this.st_s = shThresholdS;
        this.nsbass = bass;
        this.scale = sc;
        this.masking_adj = mask;
        this.ath_lower = lower;
        this.ath_curve = curve;
        this.interch = interCh;
        this.sfscale = sfScale;
    }

    var lame;

    this.setModules = function (_lame) {
        lame = _lame;
    };

    /**
     * <PRE>
     * Switch mappings for VBR mode VBR_RH
     *             vbr_q  qcomp_l  qcomp_s  expY  st_lrm   st_s  mask adj_l  adj_s  ath_lower  ath_curve  ath_sens  interChR  safejoint sfb21mod  msfix
     * </PRE>
     */
    var vbr_old_switch_map = [
        new VBRPresets(0, 9, 9, 0, 5.20, 125.0, -4.2, -6.3, 4.8, 1, 0, 0, 2, 21, 0.97),
        new VBRPresets(1, 9, 9, 0, 5.30, 125.0, -3.6, -5.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
        new VBRPresets(2, 9, 9, 0, 5.60, 125.0, -2.2, -3.5, 2.8, 2, 0, 0, 2, 21, 1.49),
        new VBRPresets(3, 9, 9, 1, 5.80, 130.0, -1.8, -2.8, 2.6, 3, -4, 0, 2, 20, 1.64),
        new VBRPresets(4, 9, 9, 1, 6.00, 135.0, -0.7, -1.1, 1.1, 3.5, -8, 0, 2, 0, 1.79),
        new VBRPresets(5, 9, 9, 1, 6.40, 140.0, 0.5, 0.4, -7.5, 4, -12, 0.0002, 0, 0, 1.95),
        new VBRPresets(6, 9, 9, 1, 6.60, 145.0, 0.67, 0.65, -14.7, 6.5, -19, 0.0004, 0, 0, 2.30),
        new VBRPresets(7, 9, 9, 1, 6.60, 145.0, 0.8, 0.75, -19.7, 8, -22, 0.0006, 0, 0, 2.70),
        new VBRPresets(8, 9, 9, 1, 6.60, 145.0, 1.2, 1.15, -27.5, 10, -23, 0.0007, 0, 0, 0),
        new VBRPresets(9, 9, 9, 1, 6.60, 145.0, 1.6, 1.6, -36, 11, -25, 0.0008, 0, 0, 0),
        new VBRPresets(10, 9, 9, 1, 6.60, 145.0, 2.0, 2.0, -36, 12, -25, 0.0008, 0, 0, 0)
    ];

    /**
     * <PRE>
     *                 vbr_q  qcomp_l  qcomp_s  expY  st_lrm   st_s  mask adj_l  adj_s  ath_lower  ath_curve  ath_sens  interChR  safejoint sfb21mod  msfix
     * </PRE>
     */
    var vbr_psy_switch_map = [
        new VBRPresets(0, 9, 9, 0, 4.20, 25.0, -7.0, -4.0, 7.5, 1, 0, 0, 2, 26, 0.97),
        new VBRPresets(1, 9, 9, 0, 4.20, 25.0, -5.6, -3.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
        new VBRPresets(2, 9, 9, 0, 4.20, 25.0, -4.4, -1.8, 2, 2, 0, 0, 2, 18, 1.49),
        new VBRPresets(3, 9, 9, 1, 4.20, 25.0, -3.4, -1.25, 1.1, 3, -4, 0, 2, 15, 1.64),
        new VBRPresets(4, 9, 9, 1, 4.20, 25.0, -2.2, 0.1, 0, 3.5, -8, 0, 2, 0, 1.79),
        new VBRPresets(5, 9, 9, 1, 4.20, 25.0, -1.0, 1.65, -7.7, 4, -12, 0.0002, 0, 0, 1.95),
        new VBRPresets(6, 9, 9, 1, 4.20, 25.0, -0.0, 2.47, -7.7, 6.5, -19, 0.0004, 0, 0, 2),
        new VBRPresets(7, 9, 9, 1, 4.20, 25.0, 0.5, 2.0, -14.5, 8, -22, 0.0006, 0, 0, 2),
        new VBRPresets(8, 9, 9, 1, 4.20, 25.0, 1.0, 2.4, -22.0, 10, -23, 0.0007, 0, 0, 2),
        new VBRPresets(9, 9, 9, 1, 4.20, 25.0, 1.5, 2.95, -30.0, 11, -25, 0.0008, 0, 0, 2),
        new VBRPresets(10, 9, 9, 1, 4.20, 25.0, 2.0, 2.95, -36.0, 12, -30, 0.0008, 0, 0, 2)
    ];

    function apply_vbr_preset(gfp, a, enforce) {
        var vbr_preset = gfp.VBR == VbrMode.vbr_rh ? vbr_old_switch_map
            : vbr_psy_switch_map;

        var x = gfp.VBR_q_frac;
        var p = vbr_preset[a];
        var q = vbr_preset[a + 1];
        var set = p;

        // NOOP(vbr_q);
        // NOOP(quant_comp);
        // NOOP(quant_comp_s);
        // NOOP(expY);
        p.st_lrm = p.st_lrm + x * (q.st_lrm - p.st_lrm);
        // LERP(st_lrm);
        p.st_s = p.st_s + x * (q.st_s - p.st_s);
        // LERP(st_s);
        p.masking_adj = p.masking_adj + x * (q.masking_adj - p.masking_adj);
        // LERP(masking_adj);
        p.masking_adj_short = p.masking_adj_short + x
            * (q.masking_adj_short - p.masking_adj_short);
        // LERP(masking_adj_short);
        p.ath_lower = p.ath_lower + x * (q.ath_lower - p.ath_lower);
        // LERP(ath_lower);
        p.ath_curve = p.ath_curve + x * (q.ath_curve - p.ath_curve);
        // LERP(ath_curve);
        p.ath_sensitivity = p.ath_sensitivity + x
            * (q.ath_sensitivity - p.ath_sensitivity);
        // LERP(ath_sensitivity);
        p.interch = p.interch + x * (q.interch - p.interch);
        // LERP(interch);
        // NOOP(safejoint);
        // NOOP(sfb21mod);
        p.msfix = p.msfix + x * (q.msfix - p.msfix);
        // LERP(msfix);

        lame_set_VBR_q(gfp, set.vbr_q);

        if (enforce != 0)
            gfp.quant_comp = set.quant_comp;
        else if (!(Math.abs(gfp.quant_comp - -1) > 0))
            gfp.quant_comp = set.quant_comp;
        // SET_OPTION(quant_comp, set.quant_comp, -1);
        if (enforce != 0)
            gfp.quant_comp_short = set.quant_comp_s;
        else if (!(Math.abs(gfp.quant_comp_short - -1) > 0))
            gfp.quant_comp_short = set.quant_comp_s;
        // SET_OPTION(quant_comp_short, set.quant_comp_s, -1);
        if (set.expY != 0) {
            gfp.experimentalY = set.expY != 0;
        }
        if (enforce != 0)
            gfp.internal_flags.nsPsy.attackthre = set.st_lrm;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre - -1) > 0))
            gfp.internal_flags.nsPsy.attackthre = set.st_lrm;
        // SET_OPTION(short_threshold_lrm, set.st_lrm, -1);
        if (enforce != 0)
            gfp.internal_flags.nsPsy.attackthre_s = set.st_s;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre_s - -1) > 0))
            gfp.internal_flags.nsPsy.attackthre_s = set.st_s;
        // SET_OPTION(short_threshold_s, set.st_s, -1);
        if (enforce != 0)
            gfp.maskingadjust = set.masking_adj;
        else if (!(Math.abs(gfp.maskingadjust - 0) > 0))
            gfp.maskingadjust = set.masking_adj;
        // SET_OPTION(maskingadjust, set.masking_adj, 0);
        if (enforce != 0)
            gfp.maskingadjust_short = set.masking_adj_short;
        else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
            gfp.maskingadjust_short = set.masking_adj_short;
        // SET_OPTION(maskingadjust_short, set.masking_adj_short, 0);
        if (enforce != 0)
            gfp.ATHlower = -set.ath_lower / 10.0;
        else if (!(Math.abs((-gfp.ATHlower * 10.0) - 0) > 0))
            gfp.ATHlower = -set.ath_lower / 10.0;
        // SET_OPTION(ATHlower, set.ath_lower, 0);
        if (enforce != 0)
            gfp.ATHcurve = set.ath_curve;
        else if (!(Math.abs(gfp.ATHcurve - -1) > 0))
            gfp.ATHcurve = set.ath_curve;
        // SET_OPTION(ATHcurve, set.ath_curve, -1);
        if (enforce != 0)
            gfp.athaa_sensitivity = set.ath_sensitivity;
        else if (!(Math.abs(gfp.athaa_sensitivity - -1) > 0))
            gfp.athaa_sensitivity = set.ath_sensitivity;
        // SET_OPTION(athaa_sensitivity, set.ath_sensitivity, 0);
        if (set.interch > 0) {
            if (enforce != 0)
                gfp.interChRatio = set.interch;
            else if (!(Math.abs(gfp.interChRatio - -1) > 0))
                gfp.interChRatio = set.interch;
            // SET_OPTION(interChRatio, set.interch, -1);
        }

        /* parameters for which there is no proper set/get interface */
        if (set.safejoint > 0) {
            gfp.exp_nspsytune = gfp.exp_nspsytune | set.safejoint;
        }
        if (set.sfb21mod > 0) {
            gfp.exp_nspsytune = gfp.exp_nspsytune | (set.sfb21mod << 20);
        }
        if (enforce != 0)
            gfp.msfix = set.msfix;
        else if (!(Math.abs(gfp.msfix - -1) > 0))
            gfp.msfix = set.msfix;
        // SET_OPTION(msfix, set.msfix, -1);

        if (enforce == 0) {
            gfp.VBR_q = a;
            gfp.VBR_q_frac = x;
        }
    }

    /**
     * <PRE>
     *  Switch mappings for ABR mode
     *
     *              kbps  quant q_s safejoint nsmsfix st_lrm  st_s  ns-bass scale   msk ath_lwr ath_curve  interch , sfscale
     * </PRE>
     */
    var abr_switch_map = [
        new ABRPresets(8, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -30.0, 11, 0.0012, 1), /*   8, impossible to use in stereo */
        new ABRPresets(16, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -25.0, 11, 0.0010, 1), /*  16 */
        new ABRPresets(24, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -20.0, 11, 0.0010, 1), /*  24 */
        new ABRPresets(32, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -15.0, 11, 0.0010, 1), /*  32 */
        new ABRPresets(40, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -10.0, 11, 0.0009, 1), /*  40 */
        new ABRPresets(48, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -10.0, 11, 0.0009, 1), /*  48 */
        new ABRPresets(56, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -6.0, 11, 0.0008, 1), /*  56 */
        new ABRPresets(64, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -2.0, 11, 0.0008, 1), /*  64 */
        new ABRPresets(80, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, .0, 8, 0.0007, 1), /*  80 */
        new ABRPresets(96, 9, 9, 0, 2.50, 6.60, 145, 0, 0.95, 0, 1.0, 5.5, 0.0006, 1), /*  96 */
        new ABRPresets(112, 9, 9, 0, 2.25, 6.60, 145, 0, 0.95, 0, 2.0, 4.5, 0.0005, 1), /* 112 */
        new ABRPresets(128, 9, 9, 0, 1.95, 6.40, 140, 0, 0.95, 0, 3.0, 4, 0.0002, 1), /* 128 */
        new ABRPresets(160, 9, 9, 1, 1.79, 6.00, 135, 0, 0.95, -2, 5.0, 3.5, 0, 1), /* 160 */
        new ABRPresets(192, 9, 9, 1, 1.49, 5.60, 125, 0, 0.97, -4, 7.0, 3, 0, 0), /* 192 */
        new ABRPresets(224, 9, 9, 1, 1.25, 5.20, 125, 0, 0.98, -6, 9.0, 2, 0, 0), /* 224 */
        new ABRPresets(256, 9, 9, 1, 0.97, 5.20, 125, 0, 1.00, -8, 10.0, 1, 0, 0), /* 256 */
        new ABRPresets(320, 9, 9, 1, 0.90, 5.20, 125, 0, 1.00, -10, 12.0, 0, 0, 0)  /* 320 */
    ];

    function apply_abr_preset(gfp, preset, enforce) {
        /* Variables for the ABR stuff */
        var actual_bitrate = preset;

        var r = lame.nearestBitrateFullIndex(preset);

        gfp.VBR = VbrMode.vbr_abr;
        gfp.VBR_mean_bitrate_kbps = actual_bitrate;
        gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 320);
        gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 8);
        gfp.brate = gfp.VBR_mean_bitrate_kbps;
        if (gfp.VBR_mean_bitrate_kbps > 320) {
            gfp.disable_reservoir = true;
        }

        /* parameters for which there is no proper set/get interface */
        if (abr_switch_map[r].safejoint > 0)
            gfp.exp_nspsytune = gfp.exp_nspsytune | 2;
        /* safejoint */

        if (abr_switch_map[r].sfscale > 0) {
            gfp.internal_flags.noise_shaping = 2;
        }
        /* ns-bass tweaks */
        if (Math.abs(abr_switch_map[r].nsbass) > 0) {
            var k = (int)(abr_switch_map[r].nsbass * 4);
            if (k < 0)
                k += 64;
            gfp.exp_nspsytune = gfp.exp_nspsytune | (k << 2);
        }

        if (enforce != 0)
            gfp.quant_comp = abr_switch_map[r].quant_comp;
        else if (!(Math.abs(gfp.quant_comp - -1) > 0))
            gfp.quant_comp = abr_switch_map[r].quant_comp;
        // SET_OPTION(quant_comp, abr_switch_map[r].quant_comp, -1);
        if (enforce != 0)
            gfp.quant_comp_short = abr_switch_map[r].quant_comp_s;
        else if (!(Math.abs(gfp.quant_comp_short - -1) > 0))
            gfp.quant_comp_short = abr_switch_map[r].quant_comp_s;
        // SET_OPTION(quant_comp_short, abr_switch_map[r].quant_comp_s, -1);

        if (enforce != 0)
            gfp.msfix = abr_switch_map[r].nsmsfix;
        else if (!(Math.abs(gfp.msfix - -1) > 0))
            gfp.msfix = abr_switch_map[r].nsmsfix;
        // SET_OPTION(msfix, abr_switch_map[r].nsmsfix, -1);

        if (enforce != 0)
            gfp.internal_flags.nsPsy.attackthre = abr_switch_map[r].st_lrm;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre - -1) > 0))
            gfp.internal_flags.nsPsy.attackthre = abr_switch_map[r].st_lrm;
        // SET_OPTION(short_threshold_lrm, abr_switch_map[r].st_lrm, -1);
        if (enforce != 0)
            gfp.internal_flags.nsPsy.attackthre_s = abr_switch_map[r].st_s;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre_s - -1) > 0))
            gfp.internal_flags.nsPsy.attackthre_s = abr_switch_map[r].st_s;
        // SET_OPTION(short_threshold_s, abr_switch_map[r].st_s, -1);

        /*
         * ABR seems to have big problems with clipping, especially at low
         * bitrates
         */
        /*
         * so we compensate for that here by using a scale value depending on
         * bitrate
         */
        if (enforce != 0)
            gfp.scale = abr_switch_map[r].scale;
        else if (!(Math.abs(gfp.scale - -1) > 0))
            gfp.scale = abr_switch_map[r].scale;
        // SET_OPTION(scale, abr_switch_map[r].scale, -1);

        if (enforce != 0)
            gfp.maskingadjust = abr_switch_map[r].masking_adj;
        else if (!(Math.abs(gfp.maskingadjust - 0) > 0))
            gfp.maskingadjust = abr_switch_map[r].masking_adj;
        // SET_OPTION(maskingadjust, abr_switch_map[r].masking_adj, 0);
        if (abr_switch_map[r].masking_adj > 0) {
            if (enforce != 0)
                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * .9);
            else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * .9);
            // SET_OPTION(maskingadjust_short, abr_switch_map[r].masking_adj *
            // .9, 0);
        } else {
            if (enforce != 0)
                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * 1.1);
            else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * 1.1);
            // SET_OPTION(maskingadjust_short, abr_switch_map[r].masking_adj *
            // 1.1, 0);
        }

        if (enforce != 0)
            gfp.ATHlower = -abr_switch_map[r].ath_lower / 10.;
        else if (!(Math.abs((-gfp.ATHlower * 10.) - 0) > 0))
            gfp.ATHlower = -abr_switch_map[r].ath_lower / 10.;
        // SET_OPTION(ATHlower, abr_switch_map[r].ath_lower, 0);
        if (enforce != 0)
            gfp.ATHcurve = abr_switch_map[r].ath_curve;
        else if (!(Math.abs(gfp.ATHcurve - -1) > 0))
            gfp.ATHcurve = abr_switch_map[r].ath_curve;
        // SET_OPTION(ATHcurve, abr_switch_map[r].ath_curve, -1);

        if (enforce != 0)
            gfp.interChRatio = abr_switch_map[r].interch;
        else if (!(Math.abs(gfp.interChRatio - -1) > 0))
            gfp.interChRatio = abr_switch_map[r].interch;
        // SET_OPTION(interChRatio, abr_switch_map[r].interch, -1);

        return preset;
    }

    this.apply_preset = function(gfp, preset, enforce) {
        /* translate legacy presets */
        switch (preset) {
            case Lame.R3MIX:
            {
                preset = Lame.V3;
                gfp.VBR = VbrMode.vbr_mtrh;
                break;
            }
            case Lame.MEDIUM:
            {
                preset = Lame.V4;
                gfp.VBR = VbrMode.vbr_rh;
                break;
            }
            case Lame.MEDIUM_FAST:
            {
                preset = Lame.V4;
                gfp.VBR = VbrMode.vbr_mtrh;
                break;
            }
            case Lame.STANDARD:
            {
                preset = Lame.V2;
                gfp.VBR = VbrMode.vbr_rh;
                break;
            }
            case Lame.STANDARD_FAST:
            {
                preset = Lame.V2;
                gfp.VBR = VbrMode.vbr_mtrh;
                break;
            }
            case Lame.EXTREME:
            {
                preset = Lame.V0;
                gfp.VBR = VbrMode.vbr_rh;
                break;
            }
            case Lame.EXTREME_FAST:
            {
                preset = Lame.V0;
                gfp.VBR = VbrMode.vbr_mtrh;
                break;
            }
            case Lame.INSANE:
            {
                preset = 320;
                gfp.preset = preset;
                apply_abr_preset(gfp, preset, enforce);
                gfp.VBR = VbrMode.vbr_off;
                return preset;
            }
        }

        gfp.preset = preset;
        {
            switch (preset) {
                case Lame.V9:
                    apply_vbr_preset(gfp, 9, enforce);
                    return preset;
                case Lame.V8:
                    apply_vbr_preset(gfp, 8, enforce);
                    return preset;
                case Lame.V7:
                    apply_vbr_preset(gfp, 7, enforce);
                    return preset;
                case Lame.V6:
                    apply_vbr_preset(gfp, 6, enforce);
                    return preset;
                case Lame.V5:
                    apply_vbr_preset(gfp, 5, enforce);
                    return preset;
                case Lame.V4:
                    apply_vbr_preset(gfp, 4, enforce);
                    return preset;
                case Lame.V3:
                    apply_vbr_preset(gfp, 3, enforce);
                    return preset;
                case Lame.V2:
                    apply_vbr_preset(gfp, 2, enforce);
                    return preset;
                case Lame.V1:
                    apply_vbr_preset(gfp, 1, enforce);
                    return preset;
                case Lame.V0:
                    apply_vbr_preset(gfp, 0, enforce);
                    return preset;
                default:
                    break;
            }
        }
        if (8 <= preset && preset <= 320) {
            return apply_abr_preset(gfp, preset, enforce);
        }

        /* no corresponding preset found */
        gfp.preset = 0;
        return preset;
    }

    // Rest from getset.c:

    /**
     * VBR quality level.<BR>
     * 0 = highest<BR>
     * 9 = lowest
     */
    function lame_set_VBR_q(gfp, VBR_q) {
        var ret = 0;

        if (0 > VBR_q) {
            /* Unknown VBR quality level! */
            ret = -1;
            VBR_q = 0;
        }
        if (9 < VBR_q) {
            ret = -1;
            VBR_q = 9;
        }

        gfp.VBR_q = VBR_q;
        gfp.VBR_q_frac = 0;
        return ret;
    }

}

module.exports = Presets;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * MP3 quantization
 *
 *      Copyright (c) 1999-2000 Mark Taylor
 *      Copyright (c) 1999-2003 Takehiro Tominaga
 *      Copyright (c) 2000-2007 Robert Hegemann
 *      Copyright (c) 2001-2005 Gabriel Bouvigne
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.     See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

/* $Id: Quantize.java,v 1.24 2011/05/24 20:48:06 kenchis Exp $ */

//package mp3;

//import java.util.Arrays;
var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

var VBRQuantize = __webpack_require__(817);
var CalcNoiseResult = __webpack_require__(818);
var CalcNoiseData = __webpack_require__(819);
var Encoder = __webpack_require__(35);
var GrInfo = __webpack_require__(204);
var L3Side = __webpack_require__(149);

function Quantize() {
    var bs;
    this.rv = null;
    var rv;
    this.qupvt = null;
    var qupvt;

    var vbr = new VBRQuantize();
    var tk;

    this.setModules = function (_bs, _rv, _qupvt, _tk) {
        bs = _bs;
        rv = _rv;
        this.rv = _rv;
        qupvt = _qupvt;
        this.qupvt = _qupvt;
        tk = _tk;
        vbr.setModules(qupvt, tk);
    }

    /**
     * convert from L/R <. Mid/Side
     */
    this.ms_convert = function (l3_side, gr) {
        for (var i = 0; i < 576; ++i) {
            var l = l3_side.tt[gr][0].xr[i];
            var r = l3_side.tt[gr][1].xr[i];
            l3_side.tt[gr][0].xr[i] = (l + r) * (Util.SQRT2 * 0.5);
            l3_side.tt[gr][1].xr[i] = (l - r) * (Util.SQRT2 * 0.5);
        }
    };

    /**
     * mt 6/99
     *
     * initializes cod_info, scalefac and xrpow
     *
     * returns 0 if all energies in xr are zero, else 1
     */
    function init_xrpow_core(cod_info, xrpow, upper, sum) {
        sum = 0;
        for (var i = 0; i <= upper; ++i) {
            var tmp = Math.abs(cod_info.xr[i]);
            sum += tmp;
            xrpow[i] = Math.sqrt(tmp * Math.sqrt(tmp));

            if (xrpow[i] > cod_info.xrpow_max)
                cod_info.xrpow_max = xrpow[i];
        }
        return sum;
    }

    this.init_xrpow = function (gfc, cod_info, xrpow) {
        var sum = 0;
        var upper = 0 | cod_info.max_nonzero_coeff;

        assert(xrpow != null);
        cod_info.xrpow_max = 0;

        /*
         * check if there is some energy we have to quantize and calculate xrpow
         * matching our fresh scalefactors
         */
        assert(0 <= upper && upper <= 575);

        Arrays.fill(xrpow, upper, 576, 0);

        sum = init_xrpow_core(cod_info, xrpow, upper, sum);

        /*
         * return 1 if we have something to quantize, else 0
         */
        if (sum > 1E-20) {
            var j = 0;
            if ((gfc.substep_shaping & 2) != 0)
                j = 1;

            for (var i = 0; i < cod_info.psymax; i++)
                gfc.pseudohalf[i] = j;

            return true;
        }

        Arrays.fill(cod_info.l3_enc, 0, 576, 0);
        return false;
    }

    /**
     * Gabriel Bouvigne feb/apr 2003<BR>
     * Analog silence detection in partitionned sfb21 or sfb12 for short blocks
     *
     * From top to bottom of sfb, changes to 0 coeffs which are below ath. It
     * stops on the first coeff higher than ath.
     */
    function psfb21_analogsilence(gfc, cod_info) {
        var ath = gfc.ATH;
        var xr = cod_info.xr;

        if (cod_info.block_type != Encoder.SHORT_TYPE) {
            /* NORM, START or STOP type, but not SHORT blocks */
            var stop = false;
            for (var gsfb = Encoder.PSFB21 - 1; gsfb >= 0 && !stop; gsfb--) {
                var start = gfc.scalefac_band.psfb21[gsfb];
                var end = gfc.scalefac_band.psfb21[gsfb + 1];
                var ath21 = qupvt.athAdjust(ath.adjust, ath.psfb21[gsfb],
                    ath.floor);

                if (gfc.nsPsy.longfact[21] > 1e-12)
                    ath21 *= gfc.nsPsy.longfact[21];

                for (var j = end - 1; j >= start; j--) {
                    if (Math.abs(xr[j]) < ath21)
                        xr[j] = 0;
                    else {
                        stop = true;
                        break;
                    }
                }
            }
        } else {
            /* note: short blocks coeffs are reordered */
            for (var block = 0; block < 3; block++) {
                var stop = false;
                for (var gsfb = Encoder.PSFB12 - 1; gsfb >= 0 && !stop; gsfb--) {
                    var start = gfc.scalefac_band.s[12]
                        * 3
                        + (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12])
                        * block
                        + (gfc.scalefac_band.psfb12[gsfb] - gfc.scalefac_band.psfb12[0]);
                    var end = start
                        + (gfc.scalefac_band.psfb12[gsfb + 1] - gfc.scalefac_band.psfb12[gsfb]);
                    var ath12 = qupvt.athAdjust(ath.adjust, ath.psfb12[gsfb],
                        ath.floor);

                    if (gfc.nsPsy.shortfact[12] > 1e-12)
                        ath12 *= gfc.nsPsy.shortfact[12];

                    for (var j = end - 1; j >= start; j--) {
                        if (Math.abs(xr[j]) < ath12)
                            xr[j] = 0;
                        else {
                            stop = true;
                            break;
                        }
                    }
                }
            }
        }

    }

    this.init_outer_loop = function (gfc, cod_info) {
        /*
         * initialize fresh cod_info
         */
        cod_info.part2_3_length = 0;
        cod_info.big_values = 0;
        cod_info.count1 = 0;
        cod_info.global_gain = 210;
        cod_info.scalefac_compress = 0;
        /* mixed_block_flag, block_type was set in psymodel.c */
        cod_info.table_select[0] = 0;
        cod_info.table_select[1] = 0;
        cod_info.table_select[2] = 0;
        cod_info.subblock_gain[0] = 0;
        cod_info.subblock_gain[1] = 0;
        cod_info.subblock_gain[2] = 0;
        cod_info.subblock_gain[3] = 0;
        /* this one is always 0 */
        cod_info.region0_count = 0;
        cod_info.region1_count = 0;
        cod_info.preflag = 0;
        cod_info.scalefac_scale = 0;
        cod_info.count1table_select = 0;
        cod_info.part2_length = 0;
        cod_info.sfb_lmax = Encoder.SBPSY_l;
        cod_info.sfb_smin = Encoder.SBPSY_s;
        cod_info.psy_lmax = gfc.sfb21_extra ? Encoder.SBMAX_l : Encoder.SBPSY_l;
        cod_info.psymax = cod_info.psy_lmax;
        cod_info.sfbmax = cod_info.sfb_lmax;
        cod_info.sfbdivide = 11;
        for (var sfb = 0; sfb < Encoder.SBMAX_l; sfb++) {
            cod_info.width[sfb] = gfc.scalefac_band.l[sfb + 1]
                - gfc.scalefac_band.l[sfb];
            /* which is always 0. */
            cod_info.window[sfb] = 3;
        }
        if (cod_info.block_type == Encoder.SHORT_TYPE) {
            var ixwork = new_float(576);

            cod_info.sfb_smin = 0;
            cod_info.sfb_lmax = 0;
            if (cod_info.mixed_block_flag != 0) {
                /*
                 * MPEG-1: sfbs 0-7 long block, 3-12 short blocks MPEG-2(.5):
                 * sfbs 0-5 long block, 3-12 short blocks
                 */
                cod_info.sfb_smin = 3;
                cod_info.sfb_lmax = gfc.mode_gr * 2 + 4;
            }
            cod_info.psymax = cod_info.sfb_lmax
                + 3
                * ((gfc.sfb21_extra ? Encoder.SBMAX_s : Encoder.SBPSY_s) - cod_info.sfb_smin);
            cod_info.sfbmax = cod_info.sfb_lmax + 3
                * (Encoder.SBPSY_s - cod_info.sfb_smin);
            cod_info.sfbdivide = cod_info.sfbmax - 18;
            cod_info.psy_lmax = cod_info.sfb_lmax;
            /* re-order the short blocks, for more efficient encoding below */
            /* By Takehiro TOMINAGA */
            /*
             * Within each scalefactor band, data is given for successive time
             * windows, beginning with window 0 and ending with window 2. Within
             * each window, the quantized values are then arranged in order of
             * increasing frequency...
             */
            var ix = gfc.scalefac_band.l[cod_info.sfb_lmax];
            System.arraycopy(cod_info.xr, 0, ixwork, 0, 576);
            for (var sfb = cod_info.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
                var start = gfc.scalefac_band.s[sfb];
                var end = gfc.scalefac_band.s[sfb + 1];
                for (var window = 0; window < 3; window++) {
                    for (var l = start; l < end; l++) {
                        cod_info.xr[ix++] = ixwork[3 * l + window];
                    }
                }
            }

            var j = cod_info.sfb_lmax;
            for (var sfb = cod_info.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
                cod_info.width[j] = cod_info.width[j + 1] = cod_info.width[j + 2] = gfc.scalefac_band.s[sfb + 1]
                    - gfc.scalefac_band.s[sfb];
                cod_info.window[j] = 0;
                cod_info.window[j + 1] = 1;
                cod_info.window[j + 2] = 2;
                j += 3;
            }
        }

        cod_info.count1bits = 0;
        cod_info.sfb_partition_table = qupvt.nr_of_sfb_block[0][0];
        cod_info.slen[0] = 0;
        cod_info.slen[1] = 0;
        cod_info.slen[2] = 0;
        cod_info.slen[3] = 0;

        cod_info.max_nonzero_coeff = 575;

        /*
         * fresh scalefactors are all zero
         */
        Arrays.fill(cod_info.scalefac, 0);

        psfb21_analogsilence(gfc, cod_info);
    };

    function BinSearchDirection(ordinal) {
        this.ordinal = ordinal;
    }

    BinSearchDirection.BINSEARCH_NONE = new BinSearchDirection(0);
    BinSearchDirection.BINSEARCH_UP = new BinSearchDirection(1);
    BinSearchDirection.BINSEARCH_DOWN = new BinSearchDirection(2);

    /**
     * author/date??
     *
     * binary step size search used by outer_loop to get a quantizer step size
     * to start with
     */
    function bin_search_StepSize(gfc, cod_info, desired_rate, ch, xrpow) {
        var nBits;
        var CurrentStep = gfc.CurrentStep[ch];
        var flagGoneOver = false;
        var start = gfc.OldValue[ch];
        var Direction = BinSearchDirection.BINSEARCH_NONE;
        cod_info.global_gain = start;
        desired_rate -= cod_info.part2_length;

        assert(CurrentStep != 0);
        for (; ;) {
            var step;
            nBits = tk.count_bits(gfc, xrpow, cod_info, null);

            if (CurrentStep == 1 || nBits == desired_rate)
                break;
            /* nothing to adjust anymore */

            if (nBits > desired_rate) {
                /* increase Quantize_StepSize */
                if (Direction == BinSearchDirection.BINSEARCH_DOWN)
                    flagGoneOver = true;

                if (flagGoneOver)
                    CurrentStep /= 2;
                Direction = BinSearchDirection.BINSEARCH_UP;
                step = CurrentStep;
            } else {
                /* decrease Quantize_StepSize */
                if (Direction == BinSearchDirection.BINSEARCH_UP)
                    flagGoneOver = true;

                if (flagGoneOver)
                    CurrentStep /= 2;
                Direction = BinSearchDirection.BINSEARCH_DOWN;
                step = -CurrentStep;
            }
            cod_info.global_gain += step;
            if (cod_info.global_gain < 0) {
                cod_info.global_gain = 0;
                flagGoneOver = true;
            }
            if (cod_info.global_gain > 255) {
                cod_info.global_gain = 255;
                flagGoneOver = true;
            }
        }

        assert(cod_info.global_gain >= 0);
        assert(cod_info.global_gain < 256);

        while (nBits > desired_rate && cod_info.global_gain < 255) {
            cod_info.global_gain++;
            nBits = tk.count_bits(gfc, xrpow, cod_info, null);
        }
        gfc.CurrentStep[ch] = (start - cod_info.global_gain >= 4) ? 4 : 2;
        gfc.OldValue[ch] = cod_info.global_gain;
        cod_info.part2_3_length = nBits;
        return nBits;
    }

    this.trancate_smallspectrums = function (gfc, gi, l3_xmin, work) {
        var distort = new_float(L3Side.SFBMAX);

        if ((0 == (gfc.substep_shaping & 4) && gi.block_type == Encoder.SHORT_TYPE)
            || (gfc.substep_shaping & 0x80) != 0)
            return;
        qupvt.calc_noise(gi, l3_xmin, distort, new CalcNoiseResult(), null);
        for (var j = 0; j < 576; j++) {
            var xr = 0.0;
            if (gi.l3_enc[j] != 0)
                xr = Math.abs(gi.xr[j]);
            work[j] = xr;
        }

        var j = 0;
        var sfb = 8;
        if (gi.block_type == Encoder.SHORT_TYPE)
            sfb = 6;
        do {
            var allowedNoise, trancateThreshold;
            var nsame, start;

            var width = gi.width[sfb];
            j += width;
            if (distort[sfb] >= 1.0)
                continue;

            Arrays.sort(work, j - width, width);
            if (BitStream.EQ(work[j - 1], 0.0))
                continue;
            /* all zero sfb */

            allowedNoise = (1.0 - distort[sfb]) * l3_xmin[sfb];
            trancateThreshold = 0.0;
            start = 0;
            do {
                var noise;
                for (nsame = 1; start + nsame < width; nsame++)
                    if (BitStream.NEQ(work[start + j - width], work[start + j
                        + nsame - width]))
                        break;

                noise = work[start + j - width] * work[start + j - width]
                    * nsame;
                if (allowedNoise < noise) {
                    if (start != 0)
                        trancateThreshold = work[start + j - width - 1];
                    break;
                }
                allowedNoise -= noise;
                start += nsame;
            } while (start < width);
            if (BitStream.EQ(trancateThreshold, 0.0))
                continue;

            do {
                if (Math.abs(gi.xr[j - width]) <= trancateThreshold)
                    gi.l3_enc[j - width] = 0;
            } while (--width > 0);
        } while (++sfb < gi.psymax);

        gi.part2_3_length = tk.noquant_count_bits(gfc, gi, null);
    };

    /**
     * author/date??
     *
     * Function: Returns zero if there is a scalefac which has not been
     * amplified. Otherwise it returns one.
     */
    function loop_break(cod_info) {
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++)
            if (cod_info.scalefac[sfb]
                + cod_info.subblock_gain[cod_info.window[sfb]] == 0)
                return false;

        return true;
    }

    /* mt 5/99: Function: Improved calc_noise for a single channel */

    function penalties(noise) {
        return Util.FAST_LOG10((0.368 + 0.632 * noise * noise * noise));
    }

    /**
     * author/date??
     *
     * several different codes to decide which quantization is better
     */
    function get_klemm_noise(distort, gi) {
        var klemm_noise = 1E-37;
        for (var sfb = 0; sfb < gi.psymax; sfb++)
            klemm_noise += penalties(distort[sfb]);

        return Math.max(1e-20, klemm_noise);
    }

    function quant_compare(quant_comp, best, calc, gi, distort) {
        /**
         * noise is given in decibels (dB) relative to masking thesholds.<BR>
         *
         * over_noise: ??? (the previous comment is fully wrong)<BR>
         * tot_noise: ??? (the previous comment is fully wrong)<BR>
         * max_noise: max quantization noise
         */
        var better;

        switch (quant_comp) {
            default:
            case 9:
            {
                if (best.over_count > 0) {
                    /* there are distorted sfb */
                    better = calc.over_SSD <= best.over_SSD;
                    if (calc.over_SSD == best.over_SSD)
                        better = calc.bits < best.bits;
                } else {
                    /* no distorted sfb */
                    better = ((calc.max_noise < 0) && ((calc.max_noise * 10 + calc.bits) <= (best.max_noise * 10 + best.bits)));
                }
                break;
            }

            case 0:
                better = calc.over_count < best.over_count
                    || (calc.over_count == best.over_count && calc.over_noise < best.over_noise)
                    || (calc.over_count == best.over_count
                    && BitStream.EQ(calc.over_noise, best.over_noise) && calc.tot_noise < best.tot_noise);
                break;

            case 8:
                calc.max_noise = get_klemm_noise(distort, gi);
            //$FALL-THROUGH$
            case 1:
                better = calc.max_noise < best.max_noise;
                break;
            case 2:
                better = calc.tot_noise < best.tot_noise;
                break;
            case 3:
                better = (calc.tot_noise < best.tot_noise)
                    && (calc.max_noise < best.max_noise);
                break;
            case 4:
                better = (calc.max_noise <= 0.0 && best.max_noise > 0.2)
                    || (calc.max_noise <= 0.0 && best.max_noise < 0.0
                    && best.max_noise > calc.max_noise - 0.2 && calc.tot_noise < best.tot_noise)
                    || (calc.max_noise <= 0.0 && best.max_noise > 0.0
                    && best.max_noise > calc.max_noise - 0.2 && calc.tot_noise < best.tot_noise
                    + best.over_noise)
                    || (calc.max_noise > 0.0 && best.max_noise > -0.05
                    && best.max_noise > calc.max_noise - 0.1 && calc.tot_noise
                    + calc.over_noise < best.tot_noise
                    + best.over_noise)
                    || (calc.max_noise > 0.0 && best.max_noise > -0.1
                    && best.max_noise > calc.max_noise - 0.15 && calc.tot_noise
                    + calc.over_noise + calc.over_noise < best.tot_noise
                    + best.over_noise + best.over_noise);
                break;
            case 5:
                better = calc.over_noise < best.over_noise
                    || (BitStream.EQ(calc.over_noise, best.over_noise) && calc.tot_noise < best.tot_noise);
                break;
            case 6:
                better = calc.over_noise < best.over_noise
                    || (BitStream.EQ(calc.over_noise, best.over_noise) && (calc.max_noise < best.max_noise || (BitStream
                        .EQ(calc.max_noise, best.max_noise) && calc.tot_noise <= best.tot_noise)));
                break;
            case 7:
                better = calc.over_count < best.over_count
                    || calc.over_noise < best.over_noise;
                break;
        }

        if (best.over_count == 0) {
            /*
             * If no distorted bands, only use this quantization if it is
             * better, and if it uses less bits. Unfortunately, part2_3_length
             * is sometimes a poor estimator of the final size at low bitrates.
             */
            better = better && calc.bits < best.bits;
        }

        return better;
    }

    /**
     * author/date??
     *
     * <PRE>
     *  Amplify the scalefactor bands that violate the masking threshold.
     *  See ISO 11172-3 Section C.1.5.4.3.5
     *
     *  distort[] = noise/masking
     *  distort[] > 1   ==> noise is not masked
     *  distort[] < 1   ==> noise is masked
     *  max_dist = maximum value of distort[]
     *
     *  Three algorithms:
     *  noise_shaping_amp
     *        0             Amplify all bands with distort[]>1.
     *
     *        1             Amplify all bands with distort[] >= max_dist^(.5);
     *                     ( 50% in the db scale)
     *
     *        2             Amplify first band with distort[] >= max_dist;
     *
     *
     *  For algorithms 0 and 1, if max_dist < 1, then amplify all bands
     *  with distort[] >= .95*max_dist.  This is to make sure we always
     *  amplify at least one band.
     * </PRE>
     */
    function amp_scalefac_bands(gfp, cod_info, distort, xrpow, bRefine) {
        var gfc = gfp.internal_flags;
        var ifqstep34;

        if (cod_info.scalefac_scale == 0) {
            ifqstep34 = 1.29683955465100964055;
            /* 2**(.75*.5) */
        } else {
            ifqstep34 = 1.68179283050742922612;
            /* 2**(.75*1) */
        }

        /* compute maximum value of distort[] */
        var trigger = 0;
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
            if (trigger < distort[sfb])
                trigger = distort[sfb];
        }

        var noise_shaping_amp = gfc.noise_shaping_amp;
        if (noise_shaping_amp == 3) {
            if (bRefine)
                noise_shaping_amp = 2;
            else
                noise_shaping_amp = 1;
        }
        switch (noise_shaping_amp) {
            case 2:
                /* amplify exactly 1 band */
                break;

            case 1:
                /* amplify bands within 50% of max (on db scale) */
                if (trigger > 1.0)
                    trigger = Math.pow(trigger, .5);
                else
                    trigger *= .95;
                break;

            case 0:
            default:
                /* ISO algorithm. amplify all bands with distort>1 */
                if (trigger > 1.0)
                    trigger = 1.0;
                else
                    trigger *= .95;
                break;
        }

        var j = 0;
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
            var width = cod_info.width[sfb];
            var l;
            j += width;
            if (distort[sfb] < trigger)
                continue;

            if ((gfc.substep_shaping & 2) != 0) {
                gfc.pseudohalf[sfb] = (0 == gfc.pseudohalf[sfb]) ? 1 : 0;
                if (0 == gfc.pseudohalf[sfb] && gfc.noise_shaping_amp == 2)
                    return;
            }
            cod_info.scalefac[sfb]++;
            for (l = -width; l < 0; l++) {
                xrpow[j + l] *= ifqstep34;
                if (xrpow[j + l] > cod_info.xrpow_max)
                    cod_info.xrpow_max = xrpow[j + l];
            }

            if (gfc.noise_shaping_amp == 2)
                return;
        }
    }

    /**
     * Takehiro Tominaga 2000-xx-xx
     *
     * turns on scalefac scale and adjusts scalefactors
     */
    function inc_scalefac_scale(cod_info, xrpow) {
        var ifqstep34 = 1.29683955465100964055;

        var j = 0;
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
            var width = cod_info.width[sfb];
            var s = cod_info.scalefac[sfb];
            if (cod_info.preflag != 0)
                s += qupvt.pretab[sfb];
            j += width;
            if ((s & 1) != 0) {
                s++;
                for (var l = -width; l < 0; l++) {
                    xrpow[j + l] *= ifqstep34;
                    if (xrpow[j + l] > cod_info.xrpow_max)
                        cod_info.xrpow_max = xrpow[j + l];
                }
            }
            cod_info.scalefac[sfb] = s >> 1;
        }
        cod_info.preflag = 0;
        cod_info.scalefac_scale = 1;
    }

    /**
     * Takehiro Tominaga 2000-xx-xx
     *
     * increases the subblock gain and adjusts scalefactors
     */
    function inc_subblock_gain(gfc, cod_info, xrpow) {
        var sfb;
        var scalefac = cod_info.scalefac;

        /* subbloc_gain can't do anything in the long block region */
        for (sfb = 0; sfb < cod_info.sfb_lmax; sfb++) {
            if (scalefac[sfb] >= 16)
                return true;
        }

        for (var window = 0; window < 3; window++) {
            var s1 = 0;
            var s2 = 0;

            for (sfb = cod_info.sfb_lmax + window; sfb < cod_info.sfbdivide; sfb += 3) {
                if (s1 < scalefac[sfb])
                    s1 = scalefac[sfb];
            }
            for (; sfb < cod_info.sfbmax; sfb += 3) {
                if (s2 < scalefac[sfb])
                    s2 = scalefac[sfb];
            }

            if (s1 < 16 && s2 < 8)
                continue;

            if (cod_info.subblock_gain[window] >= 7)
                return true;

            /*
             * even though there is no scalefactor for sfb12 subblock gain
             * affects upper frequencies too, that's why we have to go up to
             * SBMAX_s
             */
            cod_info.subblock_gain[window]++;
            var j = gfc.scalefac_band.l[cod_info.sfb_lmax];
            for (sfb = cod_info.sfb_lmax + window; sfb < cod_info.sfbmax; sfb += 3) {
                var amp;
                var width = cod_info.width[sfb];
                var s = scalefac[sfb];
                assert(s >= 0);
                s = s - (4 >> cod_info.scalefac_scale);
                if (s >= 0) {
                    scalefac[sfb] = s;
                    j += width * 3;
                    continue;
                }

                scalefac[sfb] = 0;
                {
                    var gain = 210 + (s << (cod_info.scalefac_scale + 1));
                    amp = qupvt.IPOW20(gain);
                }
                j += width * (window + 1);
                for (var l = -width; l < 0; l++) {
                    xrpow[j + l] *= amp;
                    if (xrpow[j + l] > cod_info.xrpow_max)
                        cod_info.xrpow_max = xrpow[j + l];
                }
                j += width * (3 - window - 1);
            }

            {
                var amp = qupvt.IPOW20(202);
                j += cod_info.width[sfb] * (window + 1);
                for (var l = -cod_info.width[sfb]; l < 0; l++) {
                    xrpow[j + l] *= amp;
                    if (xrpow[j + l] > cod_info.xrpow_max)
                        cod_info.xrpow_max = xrpow[j + l];
                }
            }
        }
        return false;
    }

    /**
     * <PRE>
     *  Takehiro Tominaga /date??
     *  Robert Hegemann 2000-09-06: made a function of it
     *
     *  amplifies scalefactor bands,
     *   - if all are already amplified returns 0
     *   - if some bands are amplified too much:
     *      * try to increase scalefac_scale
     *      * if already scalefac_scale was set
     *          try on short blocks to increase subblock gain
     * </PRE>
     */
    function balance_noise(gfp, cod_info, distort, xrpow, bRefine) {
        var gfc = gfp.internal_flags;

        amp_scalefac_bands(gfp, cod_info, distort, xrpow, bRefine);

        /*
         * check to make sure we have not amplified too much loop_break returns
         * 0 if there is an unamplified scalefac scale_bitcount returns 0 if no
         * scalefactors are too large
         */

        var status = loop_break(cod_info);

        if (status)
            return false;
        /* all bands amplified */

        /*
         * not all scalefactors have been amplified. so these scalefacs are
         * possibly valid. encode them:
         */
        if (gfc.mode_gr == 2)
            status = tk.scale_bitcount(cod_info);
        else
            status = tk.scale_bitcount_lsf(gfc, cod_info);

        if (!status)
            return true;
        /* amplified some bands not exceeding limits */

        /*
         * some scalefactors are too large. lets try setting scalefac_scale=1
         */
        if (gfc.noise_shaping > 1) {
            Arrays.fill(gfc.pseudohalf, 0);
            if (0 == cod_info.scalefac_scale) {
                inc_scalefac_scale(cod_info, xrpow);
                status = false;
            } else {
                if (cod_info.block_type == Encoder.SHORT_TYPE
                    && gfc.subblock_gain > 0) {
                    status = (inc_subblock_gain(gfc, cod_info, xrpow) || loop_break(cod_info));
                }
            }
        }

        if (!status) {
            if (gfc.mode_gr == 2)
                status = tk.scale_bitcount(cod_info);
            else
                status = tk.scale_bitcount_lsf(gfc, cod_info);
        }
        return !status;
    }

    /**
     * <PRE>
     *  Function: The outer iteration loop controls the masking conditions
     *  of all scalefactorbands. It computes the best scalefac and
     *  global gain. This module calls the inner iteration loop
     *
     *  mt 5/99 completely rewritten to allow for bit reservoir control,
     *  mid/side channels with L/R or mid/side masking thresholds,
     *  and chooses best quantization instead of last quantization when
     *  no distortion free quantization can be found.
     *
     *  added VBR support mt 5/99
     *
     *  some code shuffle rh 9/00
     * </PRE>
     *
     * @param l3_xmin
     *            allowed distortion
     * @param xrpow
     *            coloured magnitudes of spectral
     * @param targ_bits
     *            maximum allowed bits
     */
    this.outer_loop = function (gfp, cod_info, l3_xmin, xrpow, ch, targ_bits) {
        var gfc = gfp.internal_flags;
        var cod_info_w = new GrInfo();
        var save_xrpow = new_float(576);
        var distort = new_float(L3Side.SFBMAX);
        var best_noise_info = new CalcNoiseResult();
        var better;
        var prev_noise = new CalcNoiseData();
        var best_part2_3_length = 9999999;
        var bEndOfSearch = false;
        var bRefine = false;
        var best_ggain_pass1 = 0;

        bin_search_StepSize(gfc, cod_info, targ_bits, ch, xrpow);

        if (0 == gfc.noise_shaping)
        /* fast mode, no noise shaping, we are ready */
            return 100;
        /* default noise_info.over_count */

        /* compute the distortion in this quantization */
        /* coefficients and thresholds both l/r (or both mid/side) */
        qupvt.calc_noise(cod_info, l3_xmin, distort, best_noise_info,
            prev_noise);
        best_noise_info.bits = cod_info.part2_3_length;

        cod_info_w.assign(cod_info);
        var age = 0;
        System.arraycopy(xrpow, 0, save_xrpow, 0, 576);

        while (!bEndOfSearch) {
            /* BEGIN MAIN LOOP */
            do {
                var noise_info = new CalcNoiseResult();
                var search_limit;
                var maxggain = 255;

                /*
                 * When quantization with no distorted bands is found, allow up
                 * to X new unsuccesful tries in serial. This gives us more
                 * possibilities for different quant_compare modes. Much more
                 * than 3 makes not a big difference, it is only slower.
                 */

                if ((gfc.substep_shaping & 2) != 0) {
                    search_limit = 20;
                } else {
                    search_limit = 3;
                }

                /*
                 * Check if the last scalefactor band is distorted. in VBR mode
                 * we can't get rid of the distortion, so quit now and VBR mode
                 * will try again with more bits. (makes a 10% speed increase,
                 * the files I tested were binary identical, 2000/05/20 Robert
                 * Hegemann) distort[] > 1 means noise > allowed noise
                 */
                if (gfc.sfb21_extra) {
                    if (distort[cod_info_w.sfbmax] > 1.0)
                        break;
                    if (cod_info_w.block_type == Encoder.SHORT_TYPE
                        && (distort[cod_info_w.sfbmax + 1] > 1.0 || distort[cod_info_w.sfbmax + 2] > 1.0))
                        break;
                }

                /* try a new scalefactor conbination on cod_info_w */
                if (!balance_noise(gfp, cod_info_w, distort, xrpow, bRefine))
                    break;
                if (cod_info_w.scalefac_scale != 0)
                    maxggain = 254;

                /*
                 * inner_loop starts with the initial quantization step computed
                 * above and slowly increases until the bits < huff_bits. Thus
                 * it is important not to start with too large of an inital
                 * quantization step. Too small is ok, but inner_loop will take
                 * longer
                 */
                var huff_bits = targ_bits - cod_info_w.part2_length;
                if (huff_bits <= 0)
                    break;

                /*
                 * increase quantizer stepsize until needed bits are below
                 * maximum
                 */
                while ((cod_info_w.part2_3_length = tk.count_bits(gfc, xrpow,
                    cod_info_w, prev_noise)) > huff_bits
                && cod_info_w.global_gain <= maxggain)
                    cod_info_w.global_gain++;

                if (cod_info_w.global_gain > maxggain)
                    break;

                if (best_noise_info.over_count == 0) {

                    while ((cod_info_w.part2_3_length = tk.count_bits(gfc,
                        xrpow, cod_info_w, prev_noise)) > best_part2_3_length
                    && cod_info_w.global_gain <= maxggain)
                        cod_info_w.global_gain++;

                    if (cod_info_w.global_gain > maxggain)
                        break;
                }

                /* compute the distortion in this quantization */
                qupvt.calc_noise(cod_info_w, l3_xmin, distort, noise_info,
                    prev_noise);
                noise_info.bits = cod_info_w.part2_3_length;

                /*
                 * check if this quantization is better than our saved
                 * quantization
                 */
                if (cod_info.block_type != Encoder.SHORT_TYPE) {
                    // NORM, START or STOP type
                    better = gfp.quant_comp;
                } else
                    better = gfp.quant_comp_short;

                better = quant_compare(better, best_noise_info, noise_info,
                    cod_info_w, distort) ? 1 : 0;

                /* save data so we can restore this quantization later */
                if (better != 0) {
                    best_part2_3_length = cod_info.part2_3_length;
                    best_noise_info = noise_info;
                    cod_info.assign(cod_info_w);
                    age = 0;
                    /* save data so we can restore this quantization later */
                    /* store for later reuse */
                    System.arraycopy(xrpow, 0, save_xrpow, 0, 576);
                } else {
                    /* early stop? */
                    if (gfc.full_outer_loop == 0) {
                        if (++age > search_limit
                            && best_noise_info.over_count == 0)
                            break;
                        if ((gfc.noise_shaping_amp == 3) && bRefine && age > 30)
                            break;
                        if ((gfc.noise_shaping_amp == 3)
                            && bRefine
                            && (cod_info_w.global_gain - best_ggain_pass1) > 15)
                            break;
                    }
                }
            } while ((cod_info_w.global_gain + cod_info_w.scalefac_scale) < 255);

            if (gfc.noise_shaping_amp == 3) {
                if (!bRefine) {
                    /* refine search */
                    cod_info_w.assign(cod_info);
                    System.arraycopy(save_xrpow, 0, xrpow, 0, 576);
                    age = 0;
                    best_ggain_pass1 = cod_info_w.global_gain;

                    bRefine = true;
                } else {
                    /* search already refined, stop */
                    bEndOfSearch = true;
                }

            } else {
                bEndOfSearch = true;
            }
        }

        assert((cod_info.global_gain + cod_info.scalefac_scale) <= 255);
        /*
         * finish up
         */
        if (gfp.VBR == VbrMode.vbr_rh || gfp.VBR == VbrMode.vbr_mtrh)
        /* restore for reuse on next try */
            System.arraycopy(save_xrpow, 0, xrpow, 0, 576);
        /*
         * do the 'substep shaping'
         */
        else if ((gfc.substep_shaping & 1) != 0)
            trancate_smallspectrums(gfc, cod_info, l3_xmin, xrpow);

        return best_noise_info.over_count;
    }

    /**
     * Robert Hegemann 2000-09-06
     *
     * update reservoir status after FINAL quantization/bitrate
     */
    this.iteration_finish_one = function (gfc, gr, ch) {
        var l3_side = gfc.l3_side;
        var cod_info = l3_side.tt[gr][ch];

        /*
         * try some better scalefac storage
         */
        tk.best_scalefac_store(gfc, gr, ch, l3_side);

        /*
         * best huffman_divide may save some bits too
         */
        if (gfc.use_best_huffman == 1)
            tk.best_huffman_divide(gfc, cod_info);

        /*
         * update reservoir status after FINAL quantization/bitrate
         */
        rv.ResvAdjust(gfc, cod_info);
    };

    /**
     *
     * 2000-09-04 Robert Hegemann
     *
     * @param l3_xmin
     *            allowed distortion of the scalefactor
     * @param xrpow
     *            coloured magnitudes of spectral values
     */
    this.VBR_encode_granule = function (gfp, cod_info, l3_xmin, xrpow, ch, min_bits, max_bits) {
        var gfc = gfp.internal_flags;
        var bst_cod_info = new GrInfo();
        var bst_xrpow = new_float(576);
        var Max_bits = max_bits;
        var real_bits = max_bits + 1;
        var this_bits = (max_bits + min_bits) / 2;
        var dbits, over, found = 0;
        var sfb21_extra = gfc.sfb21_extra;

        assert(Max_bits <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
        Arrays.fill(bst_cod_info.l3_enc, 0);

        /*
         * search within round about 40 bits of optimal
         */
        do {
            assert(this_bits >= min_bits);
            assert(this_bits <= max_bits);
            assert(min_bits <= max_bits);

            if (this_bits > Max_bits - 42)
                gfc.sfb21_extra = false;
            else
                gfc.sfb21_extra = sfb21_extra;

            over = outer_loop(gfp, cod_info, l3_xmin, xrpow, ch, this_bits);

            /*
             * is quantization as good as we are looking for ? in this case: is
             * no scalefactor band distorted?
             */
            if (over <= 0) {
                found = 1;
                /*
                 * now we know it can be done with "real_bits" and maybe we can
                 * skip some iterations
                 */
                real_bits = cod_info.part2_3_length;

                /*
                 * store best quantization so far
                 */
                bst_cod_info.assign(cod_info);
                System.arraycopy(xrpow, 0, bst_xrpow, 0, 576);

                /*
                 * try with fewer bits
                 */
                max_bits = real_bits - 32;
                dbits = max_bits - min_bits;
                this_bits = (max_bits + min_bits) / 2;
            } else {
                /*
                 * try with more bits
                 */
                min_bits = this_bits + 32;
                dbits = max_bits - min_bits;
                this_bits = (max_bits + min_bits) / 2;

                if (found != 0) {
                    found = 2;
                    /*
                     * start again with best quantization so far
                     */
                    cod_info.assign(bst_cod_info);
                    System.arraycopy(bst_xrpow, 0, xrpow, 0, 576);
                }
            }
        } while (dbits > 12);

        gfc.sfb21_extra = sfb21_extra;

        /*
         * found=0 => nothing found, use last one found=1 => we just found the
         * best and left the loop found=2 => we restored a good one and have now
         * l3_enc to restore too
         */
        if (found == 2) {
            System.arraycopy(bst_cod_info.l3_enc, 0, cod_info.l3_enc, 0, 576);
        }
        assert(cod_info.part2_3_length <= Max_bits);
    }

    /**
     * Robert Hegemann 2000-09-05
     *
     * calculates * how many bits are available for analog silent granules * how
     * many bits to use for the lowest allowed bitrate * how many bits each
     * bitrate would provide
     */
    this.get_framebits = function (gfp, frameBits) {
        var gfc = gfp.internal_flags;

        /*
         * always use at least this many bits per granule per channel unless we
         * detect analog silence, see below
         */
        gfc.bitrate_index = gfc.VBR_min_bitrate;
        var bitsPerFrame = bs.getframebits(gfp);

        /*
         * bits for analog silence
         */
        gfc.bitrate_index = 1;
        bitsPerFrame = bs.getframebits(gfp);

        for (var i = 1; i <= gfc.VBR_max_bitrate; i++) {
            gfc.bitrate_index = i;
            var mb = new MeanBits(bitsPerFrame);
            frameBits[i] = rv.ResvFrameBegin(gfp, mb);
            bitsPerFrame = mb.bits;
        }
    };

    /* RH: this one needs to be overhauled sometime */

    /**
     * <PRE>
     *  2000-09-04 Robert Hegemann
     *
     *  * converts LR to MS coding when necessary
     *  * calculates allowed/adjusted quantization noise amounts
     *  * detects analog silent frames
     *
     *  some remarks:
     *  - lower masking depending on Quality setting
     *  - quality control together with adjusted ATH MDCT scaling
     *    on lower quality setting allocate more noise from
     *    ATH masking, and on higher quality setting allocate
     *    less noise from ATH masking.
     *  - experiments show that going more than 2dB over GPSYCHO's
     *    limits ends up in very annoying artefacts
     * </PRE>
     */
    this.VBR_old_prepare = function (gfp, pe, ms_ener_ratio, ratio, l3_xmin, frameBits, min_bits,
                                     max_bits, bands) {
        var gfc = gfp.internal_flags;

        var masking_lower_db, adjust = 0.0;
        var analog_silence = 1;
        var bits = 0;

        gfc.bitrate_index = gfc.VBR_max_bitrate;
        var avg = rv.ResvFrameBegin(gfp, new MeanBits(0)) / gfc.mode_gr;

        get_framebits(gfp, frameBits);

        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            var mxb = qupvt.on_pe(gfp, pe, max_bits[gr], avg, gr, 0);
            if (gfc.mode_ext == Encoder.MPG_MD_MS_LR) {
                ms_convert(gfc.l3_side, gr);
                qupvt.reduce_side(max_bits[gr], ms_ener_ratio[gr], avg, mxb);
            }
            for (var ch = 0; ch < gfc.channels_out; ++ch) {
                var cod_info = gfc.l3_side.tt[gr][ch];

                if (cod_info.block_type != Encoder.SHORT_TYPE) {
                    // NORM, START or STOP type
                    adjust = 1.28 / (1 + Math
                            .exp(3.5 - pe[gr][ch] / 300.)) - 0.05;
                    masking_lower_db = gfc.PSY.mask_adjust - adjust;
                } else {
                    adjust = 2.56 / (1 + Math
                            .exp(3.5 - pe[gr][ch] / 300.)) - 0.14;
                    masking_lower_db = gfc.PSY.mask_adjust_short - adjust;
                }
                gfc.masking_lower = Math.pow(10.0,
                    masking_lower_db * 0.1);

                init_outer_loop(gfc, cod_info);
                bands[gr][ch] = qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info,
                    l3_xmin[gr][ch]);
                if (bands[gr][ch] != 0)
                    analog_silence = 0;

                min_bits[gr][ch] = 126;

                bits += max_bits[gr][ch];
            }
        }
        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            for (var ch = 0; ch < gfc.channels_out; ch++) {
                if (bits > frameBits[gfc.VBR_max_bitrate]) {
                    max_bits[gr][ch] *= frameBits[gfc.VBR_max_bitrate];
                    max_bits[gr][ch] /= bits;
                }
                if (min_bits[gr][ch] > max_bits[gr][ch])
                    min_bits[gr][ch] = max_bits[gr][ch];

            }
            /* for ch */
        }
        /* for gr */

        return analog_silence;
    };

    this.bitpressure_strategy = function (gfc, l3_xmin, min_bits, max_bits) {
        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            for (var ch = 0; ch < gfc.channels_out; ch++) {
                var gi = gfc.l3_side.tt[gr][ch];
                var pxmin = l3_xmin[gr][ch];
                var pxminPos = 0;
                for (var sfb = 0; sfb < gi.psy_lmax; sfb++)
                    pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
                        / Encoder.SBMAX_l / Encoder.SBMAX_l;

                if (gi.block_type == Encoder.SHORT_TYPE) {
                    for (var sfb = gi.sfb_smin; sfb < Encoder.SBMAX_s; sfb++) {
                        pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
                            / Encoder.SBMAX_s / Encoder.SBMAX_s;
                        pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
                            / Encoder.SBMAX_s / Encoder.SBMAX_s;
                        pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
                            / Encoder.SBMAX_s / Encoder.SBMAX_s;
                    }
                }
                max_bits[gr][ch] = 0 | Math.max(min_bits[gr][ch],
                        0.9 * max_bits[gr][ch]);
            }
        }
    };

    this.VBR_new_prepare = function (gfp, pe, ratio, l3_xmin, frameBits, max_bits) {
        var gfc = gfp.internal_flags;

        var analog_silence = 1;
        var avg = 0, bits = 0;
        var maximum_framebits;

        if (!gfp.free_format) {
            gfc.bitrate_index = gfc.VBR_max_bitrate;

            var mb = new MeanBits(avg);
            rv.ResvFrameBegin(gfp, mb);
            avg = mb.bits;

            get_framebits(gfp, frameBits);
            maximum_framebits = frameBits[gfc.VBR_max_bitrate];
        } else {
            gfc.bitrate_index = 0;
            var mb = new MeanBits(avg);
            maximum_framebits = rv.ResvFrameBegin(gfp, mb);
            avg = mb.bits;
            frameBits[0] = maximum_framebits;
        }

        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            qupvt.on_pe(gfp, pe, max_bits[gr], avg, gr, 0);
            if (gfc.mode_ext == Encoder.MPG_MD_MS_LR) {
                ms_convert(gfc.l3_side, gr);
            }
            for (var ch = 0; ch < gfc.channels_out; ++ch) {
                var cod_info = gfc.l3_side.tt[gr][ch];

                gfc.masking_lower = Math.pow(10.0,
                    gfc.PSY.mask_adjust * 0.1);

                init_outer_loop(gfc, cod_info);
                if (0 != qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info,
                        l3_xmin[gr][ch]))
                    analog_silence = 0;

                bits += max_bits[gr][ch];
            }
        }
        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            for (var ch = 0; ch < gfc.channels_out; ch++) {
                if (bits > maximum_framebits) {
                    max_bits[gr][ch] *= maximum_framebits;
                    max_bits[gr][ch] /= bits;
                }

            }
            /* for ch */
        }
        /* for gr */

        return analog_silence;
    };

    /**
     * calculates target bits for ABR encoding
     *
     * mt 2000/05/31
     */
    this.calc_target_bits = function (gfp, pe, ms_ener_ratio, targ_bits, analog_silence_bits, max_frame_bits) {
        var gfc = gfp.internal_flags;
        var l3_side = gfc.l3_side;
        var res_factor;
        var gr, ch, totbits, mean_bits = 0;

        gfc.bitrate_index = gfc.VBR_max_bitrate;
        var mb = new MeanBits(mean_bits);
        max_frame_bits[0] = rv.ResvFrameBegin(gfp, mb);
        mean_bits = mb.bits;

        gfc.bitrate_index = 1;
        mean_bits = bs.getframebits(gfp) - gfc.sideinfo_len * 8;
        analog_silence_bits[0] = mean_bits / (gfc.mode_gr * gfc.channels_out);

        mean_bits = gfp.VBR_mean_bitrate_kbps * gfp.framesize * 1000;
        if ((gfc.substep_shaping & 1) != 0)
            mean_bits *= 1.09;
        mean_bits /= gfp.out_samplerate;
        mean_bits -= gfc.sideinfo_len * 8;
        mean_bits /= (gfc.mode_gr * gfc.channels_out);

        /**
         * <PRE>
         *           res_factor is the percentage of the target bitrate that should
         *           be used on average.  the remaining bits are added to the
         *           bitreservoir and used for difficult to encode frames.
         *
         *           Since we are tracking the average bitrate, we should adjust
         *           res_factor "on the fly", increasing it if the average bitrate
         *           is greater than the requested bitrate, and decreasing it
         *           otherwise.  Reasonable ranges are from .9 to 1.0
         *
         *           Until we get the above suggestion working, we use the following
         *           tuning:
         *           compression ratio    res_factor
         *           5.5  (256kbps)         1.0      no need for bitreservoir
         *           11   (128kbps)         .93      7% held for reservoir
         *
         *           with linear interpolation for other values.
         * </PRE>
         */
        res_factor = .93 + .07 * (11.0 - gfp.compression_ratio)
            / (11.0 - 5.5);
        if (res_factor < .90)
            res_factor = .90;
        if (res_factor > 1.00)
            res_factor = 1.00;

        for (gr = 0; gr < gfc.mode_gr; gr++) {
            var sum = 0;
            for (ch = 0; ch < gfc.channels_out; ch++) {
                targ_bits[gr][ch] = (int)(res_factor * mean_bits);

                if (pe[gr][ch] > 700) {
                    var add_bits = (int)((pe[gr][ch] - 700) / 1.4);

                    var cod_info = l3_side.tt[gr][ch];
                    targ_bits[gr][ch] = (int)(res_factor * mean_bits);

                    /* short blocks use a little extra, no matter what the pe */
                    if (cod_info.block_type == Encoder.SHORT_TYPE) {
                        if (add_bits < mean_bits / 2)
                            add_bits = mean_bits / 2;
                    }
                    /* at most increase bits by 1.5*average */
                    if (add_bits > mean_bits * 3 / 2)
                        add_bits = mean_bits * 3 / 2;
                    else if (add_bits < 0)
                        add_bits = 0;

                    targ_bits[gr][ch] += add_bits;
                }
                if (targ_bits[gr][ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL) {
                    targ_bits[gr][ch] = LameInternalFlags.MAX_BITS_PER_CHANNEL;
                }
                sum += targ_bits[gr][ch];
            }
            /* for ch */
            if (sum > LameInternalFlags.MAX_BITS_PER_GRANULE) {
                for (ch = 0; ch < gfc.channels_out; ++ch) {
                    targ_bits[gr][ch] *= LameInternalFlags.MAX_BITS_PER_GRANULE;
                    targ_bits[gr][ch] /= sum;
                }
            }
        }
        /* for gr */

        if (gfc.mode_ext == Encoder.MPG_MD_MS_LR)
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                qupvt.reduce_side(targ_bits[gr], ms_ener_ratio[gr], mean_bits
                    * gfc.channels_out,
                    LameInternalFlags.MAX_BITS_PER_GRANULE);
            }

        /*
         * sum target bits
         */
        totbits = 0;
        for (gr = 0; gr < gfc.mode_gr; gr++) {
            for (ch = 0; ch < gfc.channels_out; ch++) {
                if (targ_bits[gr][ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL)
                    targ_bits[gr][ch] = LameInternalFlags.MAX_BITS_PER_CHANNEL;
                totbits += targ_bits[gr][ch];
            }
        }

        /*
         * repartion target bits if needed
         */
        if (totbits > max_frame_bits[0]) {
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    targ_bits[gr][ch] *= max_frame_bits[0];
                    targ_bits[gr][ch] /= totbits;
                }
            }
        }
    }

}

module.exports = Quantize;


/***/ }),
/* 817 */
/***/ (function(module, exports) {

function VBRQuantize() {
    var qupvt;
    var tak;

    this.setModules = function (_qupvt, _tk) {
        qupvt = _qupvt;
        tak = _tk;
    }
    //TODO

}

module.exports = VBRQuantize;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

//package mp3;

function CalcNoiseResult() {
    /**
     * sum of quantization noise > masking
     */
    this.over_noise = 0.;
    /**
     * sum of all quantization noise
     */
    this.tot_noise = 0.;
    /**
     * max quantization noise
     */
    this.max_noise = 0.;
    /**
     * number of quantization noise > masking
     */
    this.over_count = 0;
    /**
     * SSD-like cost of distorted bands
     */
    this.over_SSD = 0;
    this.bits = 0;
}

module.exports = CalcNoiseResult;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var new_float = common.new_float;
var new_int = common.new_int;
var assert = common.assert;

function CalcNoiseData() {
    this.global_gain = 0;
    this.sfb_count1 = 0;
    this.step = new_int(39);
    this.noise = new_float(39);
    this.noise_log = new_float(39);
}

module.exports = CalcNoiseData;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *      bit reservoir source file
 *
 *      Copyright (c) 1999-2000 Mark Taylor
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

/* $Id: Reservoir.java,v 1.9 2011/05/24 20:48:06 kenchis Exp $ */

//package mp3;

/**
 * ResvFrameBegin:<BR>
 * Called (repeatedly) at the beginning of a frame. Updates the maximum size of
 * the reservoir, and checks to make sure main_data_begin was set properly by
 * the formatter<BR>
 * Background information:
 * 
 * This is the original text from the ISO standard. Because of sooo many bugs
 * and irritations correcting comments are added in brackets []. A '^W' means
 * you should remove the last word.
 * 
 * <PRE>
 *  1. The following rule can be used to calculate the maximum
 *     number of bits used for one granule [^W frame]:<BR>
 *     At the highest possible bitrate of Layer III (320 kbps
 *     per stereo signal [^W^W^W], 48 kHz) the frames must be of
 *     [^W^W^W are designed to have] constant length, i.e.
 *     one buffer [^W^W the frame] length is:<BR>
 * 
 *         320 kbps * 1152/48 kHz = 7680 bit = 960 byte
 * 
 *     This value is used as the maximum buffer per channel [^W^W] at
 *     lower bitrates [than 320 kbps]. At 64 kbps mono or 128 kbps
 *     stereo the main granule length is 64 kbps * 576/48 kHz = 768 bit
 *     [per granule and channel] at 48 kHz sampling frequency.
 *     This means that there is a maximum deviation (short time buffer
 *     [= reservoir]) of 7680 - 2*2*768 = 4608 bits is allowed at 64 kbps.
 *     The actual deviation is equal to the number of bytes [with the
 *     meaning of octets] denoted by the main_data_end offset pointer.
 *     The actual maximum deviation is (2^9-1)*8 bit = 4088 bits
 *     [for MPEG-1 and (2^8-1)*8 bit for MPEG-2, both are hard limits].
 *     ... The xchange of buffer bits between the left and right channel
 *     is allowed without restrictions [exception: dual channel].
 *     Because of the [constructed] constraint on the buffer size
 *     main_data_end is always set to 0 in the case of bit_rate_index==14,
 *     i.e. data rate 320 kbps per stereo signal [^W^W^W]. In this case
 *     all data are allocated between adjacent header [^W sync] words
 *     [, i.e. there is no buffering at all].
 * </PRE>
 */

var common = __webpack_require__(19);
var assert = common.assert;

function Reservoir() {
	var bs;

	this.setModules  = function(_bs) {
		bs = _bs;
	}

	this.ResvFrameBegin = function(gfp, mean_bits) {
		var gfc = gfp.internal_flags;
		var maxmp3buf;
		var l3_side = gfc.l3_side;

		var frameLength = bs.getframebits(gfp);
		mean_bits.bits = (frameLength - gfc.sideinfo_len * 8) / gfc.mode_gr;

		/**
		 * <PRE>
		 *  Meaning of the variables:
		 *      resvLimit: (0, 8, ..., 8*255 (MPEG-2), 8*511 (MPEG-1))
		 *          Number of bits can be stored in previous frame(s) due to
		 *          counter size constaints
		 *      maxmp3buf: ( ??? ... 8*1951 (MPEG-1 and 2), 8*2047 (MPEG-2.5))
		 *          Number of bits allowed to encode one frame (you can take 8*511 bit
		 *          from the bit reservoir and at most 8*1440 bit from the current
		 *          frame (320 kbps, 32 kHz), so 8*1951 bit is the largest possible
		 *          value for MPEG-1 and -2)
		 * 
		 *          maximum allowed granule/channel size times 4 = 8*2047 bits.,
		 *          so this is the absolute maximum supported by the format.
		 * 
		 * 
		 *      fullFrameBits:  maximum number of bits available for encoding
		 *                      the current frame.
		 * 
		 *      mean_bits:      target number of bits per granule.
		 * 
		 *      frameLength:
		 * 
		 *      gfc.ResvMax:   maximum allowed reservoir
		 * 
		 *      gfc.ResvSize:  current reservoir size
		 * 
		 *      l3_side.resvDrain_pre:
		 *         ancillary data to be added to previous frame:
		 *         (only usefull in VBR modes if it is possible to have
		 *         maxmp3buf < fullFrameBits)).  Currently disabled,
		 *         see #define NEW_DRAIN
		 *         2010-02-13: RH now enabled, it seems to be needed for CBR too,
		 *                     as there exists one example, where the FhG decoder
		 *                     can't decode a -b320 CBR file anymore.
		 * 
		 *      l3_side.resvDrain_post:
		 *         ancillary data to be added to this frame:
		 * 
		 * </PRE>
		 */

		/* main_data_begin has 9 bits in MPEG-1, 8 bits MPEG-2 */
		var resvLimit = (8 * 256) * gfc.mode_gr - 8;

		/*
		 * maximum allowed frame size. dont use more than this number of bits,
		 * even if the frame has the space for them:
		 */
		if (gfp.brate > 320) {
			/* in freeformat the buffer is constant */
			maxmp3buf = 8 * ((int) ((gfp.brate * 1000)
					/ (gfp.out_samplerate / 1152) / 8 + .5));
		} else {
			/*
			 * all mp3 decoders should have enough buffer to handle this value:
			 * size of a 320kbps 32kHz frame
			 */
			maxmp3buf = 8 * 1440;

			/*
			 * Bouvigne suggests this more lax interpretation of the ISO doc
			 * instead of using 8*960.
			 */

			if (gfp.strict_ISO) {
				maxmp3buf = 8 * ((int) (320000 / (gfp.out_samplerate / 1152) / 8 + .5));
			}
		}

		gfc.ResvMax = maxmp3buf - frameLength;
		if (gfc.ResvMax > resvLimit)
			gfc.ResvMax = resvLimit;
		if (gfc.ResvMax < 0 || gfp.disable_reservoir)
			gfc.ResvMax = 0;

		var fullFrameBits = mean_bits.bits * gfc.mode_gr
				+ Math.min(gfc.ResvSize, gfc.ResvMax);

		if (fullFrameBits > maxmp3buf)
			fullFrameBits = maxmp3buf;

		assert (0 == gfc.ResvMax % 8);
		assert (gfc.ResvMax >= 0);

		l3_side.resvDrain_pre = 0;

		// frame analyzer code
		if (gfc.pinfo != null) {
			/*
			 * expected bits per channel per granule [is this also right for
			 * mono/stereo, MPEG-1/2 ?]
			 */
			gfc.pinfo.mean_bits = mean_bits.bits / 2;
			gfc.pinfo.resvsize = gfc.ResvSize;
		}

		return fullFrameBits;
	}

	/**
	 * returns targ_bits: target number of bits to use for 1 granule<BR>
	 * extra_bits: amount extra available from reservoir<BR>
	 * Mark Taylor 4/99
	 */
	this.ResvMaxBits = function(gfp, mean_bits, targ_bits, cbr) {
		var gfc = gfp.internal_flags;
		var add_bits;
        var ResvSize = gfc.ResvSize, ResvMax = gfc.ResvMax;

		/* compensate the saved bits used in the 1st granule */
		if (cbr != 0)
			ResvSize += mean_bits;

		if ((gfc.substep_shaping & 1) != 0)
			ResvMax *= 0.9;

		targ_bits.bits = mean_bits;

		/* extra bits if the reservoir is almost full */
		if (ResvSize * 10 > ResvMax * 9) {
			add_bits = ResvSize - (ResvMax * 9) / 10;
			targ_bits.bits += add_bits;
			gfc.substep_shaping |= 0x80;
		} else {
			add_bits = 0;
			gfc.substep_shaping &= 0x7f;
			/*
			 * build up reservoir. this builds the reservoir a little slower
			 * than FhG. It could simple be mean_bits/15, but this was rigged to
			 * always produce 100 (the old value) at 128kbs
			 */
			if (!gfp.disable_reservoir && 0 == (gfc.substep_shaping & 1))
				targ_bits.bits -= .1 * mean_bits;
		}

		/* amount from the reservoir we are allowed to use. ISO says 6/10 */
		var extra_bits = (ResvSize < (gfc.ResvMax * 6) / 10 ? ResvSize
				: (gfc.ResvMax * 6) / 10);
		extra_bits -= add_bits;

		if (extra_bits < 0)
			extra_bits = 0;
		return extra_bits;
	}

	/**
	 * Called after a granule's bit allocation. Readjusts the size of the
	 * reservoir to reflect the granule's usage.
	 */
	this.ResvAdjust = function(gfc, gi) {
		gfc.ResvSize -= gi.part2_3_length + gi.part2_length;
	}

	/**
	 * Called after all granules in a frame have been allocated. Makes sure that
	 * the reservoir size is within limits, possibly by adding stuffing bits.
	 */
	this.ResvFrameEnd = function(gfc, mean_bits) {
		var over_bits;
		var l3_side = gfc.l3_side;

		gfc.ResvSize += mean_bits * gfc.mode_gr;
		var stuffingBits = 0;
		l3_side.resvDrain_post = 0;
		l3_side.resvDrain_pre = 0;

		/* we must be byte aligned */
		if ((over_bits = gfc.ResvSize % 8) != 0)
			stuffingBits += over_bits;

		over_bits = (gfc.ResvSize - stuffingBits) - gfc.ResvMax;
		if (over_bits > 0) {
			assert (0 == over_bits % 8);
			assert (over_bits >= 0);
			stuffingBits += over_bits;
		}

		/*
		 * NOTE: enabling the NEW_DRAIN code fixes some problems with FhG
		 * decoder shipped with MS Windows operating systems. Using this, it is
		 * even possible to use Gabriel's lax buffer consideration again, which
		 * assumes, any decoder should have a buffer large enough for a 320 kbps
		 * frame at 32 kHz sample rate.
		 * 
		 * old drain code: lame -b320 BlackBird.wav --. does not play with
		 * GraphEdit.exe using FhG decoder V1.5 Build 50
		 * 
		 * new drain code: lame -b320 BlackBird.wav --. plays fine with
		 * GraphEdit.exe using FhG decoder V1.5 Build 50
		 * 
		 * Robert Hegemann, 2010-02-13.
		 */
		/*
		 * drain as many bits as possible into previous frame ancillary data In
		 * particular, in VBR mode ResvMax may have changed, and we have to make
		 * sure main_data_begin does not create a reservoir bigger than ResvMax
		 * mt 4/00
		 */
		{
			var mdb_bytes = Math.min(l3_side.main_data_begin * 8, stuffingBits) / 8;
			l3_side.resvDrain_pre += 8 * mdb_bytes;
			stuffingBits -= 8 * mdb_bytes;
			gfc.ResvSize -= 8 * mdb_bytes;
			l3_side.main_data_begin -= mdb_bytes;
		}
		/* drain the rest into this frames ancillary data */
		l3_side.resvDrain_post += stuffingBits;
		gfc.ResvSize -= stuffingBits;
	}
}

module.exports = Reservoir;


/***/ }),
/* 821 */
/***/ (function(module, exports) {

function Version() {

    /**
     * URL for the LAME website.
     */
    var LAME_URL = "http://www.mp3dev.org/";

    /**
     * Major version number.
     */
    var LAME_MAJOR_VERSION = 3;
    /**
     * Minor version number.
     */
    var LAME_MINOR_VERSION = 98;
    /**
     * Patch level.
     */
    var LAME_PATCH_VERSION = 4;

    /**
     * Major version number.
     */
    var PSY_MAJOR_VERSION = 0;
    /**
     * Minor version number.
     */
    var PSY_MINOR_VERSION = 93;

    /**
     * A string which describes the version of LAME.
     *
     * @return string which describes the version of LAME
     */
    this.getLameVersion = function () {
        // primary to write screen reports
        return (LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "." + LAME_PATCH_VERSION);
    }

    /**
     * The short version of the LAME version string.
     *
     * @return short version of the LAME version string
     */
    this.getLameShortVersion = function () {
        // Adding date and time to version string makes it harder for output
        // validation
        return (LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "." + LAME_PATCH_VERSION);
    }

    /**
     * The shortest version of the LAME version string.
     *
     * @return shortest version of the LAME version string
     */
    this.getLameVeryShortVersion = function () {
        // Adding date and time to version string makes it harder for output
        return ("LAME" + LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "r");
    }

    /**
     * String which describes the version of GPSYCHO
     *
     * @return string which describes the version of GPSYCHO
     */
    this.getPsyVersion = function () {
        return (PSY_MAJOR_VERSION + "." + PSY_MINOR_VERSION);
    }

    /**
     * String which is a URL for the LAME website.
     *
     * @return string which is a URL for the LAME website
     */
    this.getLameUrl = function () {
        return LAME_URL;
    }

    /**
     * Quite useless for a java version, however we are compatible ;-)
     *
     * @return "32bits"
     */
    this.getLameOsBitness = function () {
        return "32bits";
    }

}

module.exports = Version;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var common = __webpack_require__(19);
var System = common.System;
var VbrMode = common.VbrMode;
var Float = common.Float;
var ShortBlock = common.ShortBlock;
var Util = common.Util;
var Arrays = common.Arrays;
var new_array_n = common.new_array_n;
var new_byte = common.new_byte;
var new_double = common.new_double;
var new_float = common.new_float;
var new_float_n = common.new_float_n;
var new_int = common.new_int;
var new_int_n = common.new_int_n;
var assert = common.assert;

/**
 * A Vbr header may be present in the ancillary data field of the first frame of
 * an mp3 bitstream<BR>
 * The Vbr header (optionally) contains
 * <UL>
 * <LI>frames total number of audio frames in the bitstream
 * <LI>bytes total number of bytes in the bitstream
 * <LI>toc table of contents
 * </UL>
 *
 * toc (table of contents) gives seek points for random access.<BR>
 * The ith entry determines the seek point for i-percent duration.<BR>
 * seek point in bytes = (toc[i]/256.0) * total_bitstream_bytes<BR>
 * e.g. half duration seek point = (toc[50]/256.0) * total_bitstream_bytes
 */
VBRTag.NUMTOCENTRIES = 100;
VBRTag.MAXFRAMESIZE = 2880;

function VBRTag() {

    var lame;
    var bs;
    var v;

    this.setModules = function (_lame, _bs, _v) {
        lame = _lame;
        bs = _bs;
        v = _v;
    };

    var FRAMES_FLAG = 0x0001;
    var BYTES_FLAG = 0x0002;
    var TOC_FLAG = 0x0004;
    var VBR_SCALE_FLAG = 0x0008;

    var NUMTOCENTRIES = VBRTag.NUMTOCENTRIES;

    /**
     * (0xB40) the max freeformat 640 32kHz framesize.
     */
    var MAXFRAMESIZE = VBRTag.MAXFRAMESIZE;

    /**
     * <PRE>
     *    4 bytes for Header Tag
     *    4 bytes for Header Flags
     *  100 bytes for entry (toc)
     *    4 bytes for frame size
     *    4 bytes for stream size
     *    4 bytes for VBR scale. a VBR quality indicator: 0=best 100=worst
     *   20 bytes for LAME tag.  for example, "LAME3.12 (beta 6)"
     * ___________
     *  140 bytes
     * </PRE>
     */
    var VBRHEADERSIZE = (NUMTOCENTRIES + 4 + 4 + 4 + 4 + 4);

    var LAMEHEADERSIZE = (VBRHEADERSIZE + 9 + 1 + 1 + 8
    + 1 + 1 + 3 + 1 + 1 + 2 + 4 + 2 + 2);

    /**
     * The size of the Xing header MPEG-1, bit rate in kbps.
     */
    var XING_BITRATE1 = 128;
    /**
     * The size of the Xing header MPEG-2, bit rate in kbps.
     */
    var XING_BITRATE2 = 64;
    /**
     * The size of the Xing header MPEG-2.5, bit rate in kbps.
     */
    var XING_BITRATE25 = 32;

    /**
     * ISO-8859-1 charset for byte to string operations.
     */
    var ISO_8859_1 = null; //Charset.forName("ISO-8859-1");

    /**
     * VBR header magic string.
     */
    var VBRTag0 = "Xing";
    /**
     * VBR header magic string (VBR == VBRMode.vbr_off).
     */
    var VBRTag1 = "Info";

    /**
     * Lookup table for fast CRC-16 computation. Uses the polynomial
     * x^16+x^15+x^2+1
     */
    var crc16Lookup = [0x0000, 0xC0C1, 0xC181, 0x0140,
        0xC301, 0x03C0, 0x0280, 0xC241, 0xC601, 0x06C0, 0x0780, 0xC741,
        0x0500, 0xC5C1, 0xC481, 0x0440, 0xCC01, 0x0CC0, 0x0D80, 0xCD41,
        0x0F00, 0xCFC1, 0xCE81, 0x0E40, 0x0A00, 0xCAC1, 0xCB81, 0x0B40,
        0xC901, 0x09C0, 0x0880, 0xC841, 0xD801, 0x18C0, 0x1980, 0xD941,
        0x1B00, 0xDBC1, 0xDA81, 0x1A40, 0x1E00, 0xDEC1, 0xDF81, 0x1F40,
        0xDD01, 0x1DC0, 0x1C80, 0xDC41, 0x1400, 0xD4C1, 0xD581, 0x1540,
        0xD701, 0x17C0, 0x1680, 0xD641, 0xD201, 0x12C0, 0x1380, 0xD341,
        0x1100, 0xD1C1, 0xD081, 0x1040, 0xF001, 0x30C0, 0x3180, 0xF141,
        0x3300, 0xF3C1, 0xF281, 0x3240, 0x3600, 0xF6C1, 0xF781, 0x3740,
        0xF501, 0x35C0, 0x3480, 0xF441, 0x3C00, 0xFCC1, 0xFD81, 0x3D40,
        0xFF01, 0x3FC0, 0x3E80, 0xFE41, 0xFA01, 0x3AC0, 0x3B80, 0xFB41,
        0x3900, 0xF9C1, 0xF881, 0x3840, 0x2800, 0xE8C1, 0xE981, 0x2940,
        0xEB01, 0x2BC0, 0x2A80, 0xEA41, 0xEE01, 0x2EC0, 0x2F80, 0xEF41,
        0x2D00, 0xEDC1, 0xEC81, 0x2C40, 0xE401, 0x24C0, 0x2580, 0xE541,
        0x2700, 0xE7C1, 0xE681, 0x2640, 0x2200, 0xE2C1, 0xE381, 0x2340,
        0xE101, 0x21C0, 0x2080, 0xE041, 0xA001, 0x60C0, 0x6180, 0xA141,
        0x6300, 0xA3C1, 0xA281, 0x6240, 0x6600, 0xA6C1, 0xA781, 0x6740,
        0xA501, 0x65C0, 0x6480, 0xA441, 0x6C00, 0xACC1, 0xAD81, 0x6D40,
        0xAF01, 0x6FC0, 0x6E80, 0xAE41, 0xAA01, 0x6AC0, 0x6B80, 0xAB41,
        0x6900, 0xA9C1, 0xA881, 0x6840, 0x7800, 0xB8C1, 0xB981, 0x7940,
        0xBB01, 0x7BC0, 0x7A80, 0xBA41, 0xBE01, 0x7EC0, 0x7F80, 0xBF41,
        0x7D00, 0xBDC1, 0xBC81, 0x7C40, 0xB401, 0x74C0, 0x7580, 0xB541,
        0x7700, 0xB7C1, 0xB681, 0x7640, 0x7200, 0xB2C1, 0xB381, 0x7340,
        0xB101, 0x71C0, 0x7080, 0xB041, 0x5000, 0x90C1, 0x9181, 0x5140,
        0x9301, 0x53C0, 0x5280, 0x9241, 0x9601, 0x56C0, 0x5780, 0x9741,
        0x5500, 0x95C1, 0x9481, 0x5440, 0x9C01, 0x5CC0, 0x5D80, 0x9D41,
        0x5F00, 0x9FC1, 0x9E81, 0x5E40, 0x5A00, 0x9AC1, 0x9B81, 0x5B40,
        0x9901, 0x59C0, 0x5880, 0x9841, 0x8801, 0x48C0, 0x4980, 0x8941,
        0x4B00, 0x8BC1, 0x8A81, 0x4A40, 0x4E00, 0x8EC1, 0x8F81, 0x4F40,
        0x8D01, 0x4DC0, 0x4C80, 0x8C41, 0x4400, 0x84C1, 0x8581, 0x4540,
        0x8701, 0x47C0, 0x4680, 0x8641, 0x8201, 0x42C0, 0x4380, 0x8341,
        0x4100, 0x81C1, 0x8081, 0x4040];

    /***********************************************************************
     * Robert Hegemann 2001-01-17
     ***********************************************************************/

    function addVbr(v, bitrate) {
        v.nVbrNumFrames++;
        v.sum += bitrate;
        v.seen++;

        if (v.seen < v.want) {
            return;
        }

        if (v.pos < v.size) {
            v.bag[v.pos] = v.sum;
            v.pos++;
            v.seen = 0;
        }
        if (v.pos == v.size) {
            for (var i = 1; i < v.size; i += 2) {
                v.bag[i / 2] = v.bag[i];
            }
            v.want *= 2;
            v.pos /= 2;
        }
    }

    function xingSeekTable(v, t) {
        if (v.pos <= 0)
            return;

        for (var i = 1; i < NUMTOCENTRIES; ++i) {
            var j = i / NUMTOCENTRIES, act, sum;
            var indx = 0 | (Math.floor(j * v.pos));
            if (indx > v.pos - 1)
                indx = v.pos - 1;
            act = v.bag[indx];
            sum = v.sum;
            var seek_point = 0 | (256. * act / sum);
            if (seek_point > 255)
                seek_point = 255;
            t[i] = 0xff & seek_point;
        }
    }

    /**
     * Add VBR entry, used to fill the VBR TOC entries.
     *
     * @param gfp
     *            global flags
     */
    this.addVbrFrame = function (gfp) {
        var gfc = gfp.internal_flags;
        var kbps = Tables.bitrate_table[gfp.version][gfc.bitrate_index];
        assert(gfc.VBR_seek_table.bag != null);
        addVbr(gfc.VBR_seek_table, kbps);
    }

    /**
     * Read big endian integer (4-bytes) from header.
     *
     * @param buf
     *            header containing the integer
     * @param bufPos
     *            offset into the header
     * @return extracted integer
     */
    function extractInteger(buf, bufPos) {
        var x = buf[bufPos + 0] & 0xff;
        x <<= 8;
        x |= buf[bufPos + 1] & 0xff;
        x <<= 8;
        x |= buf[bufPos + 2] & 0xff;
        x <<= 8;
        x |= buf[bufPos + 3] & 0xff;
        return x;
    }

    /**
     * Write big endian integer (4-bytes) in the header.
     *
     * @param buf
     *            header to write the integer into
     * @param bufPos
     *            offset into the header
     * @param value
     *            integer value to write
     */
    function createInteger(buf, bufPos, value) {
        buf[bufPos + 0] = 0xff & ((value >> 24) & 0xff);
        buf[bufPos + 1] = 0xff & ((value >> 16) & 0xff);
        buf[bufPos + 2] = 0xff & ((value >> 8) & 0xff);
        buf[bufPos + 3] = 0xff & (value & 0xff);
    }

    /**
     * Write big endian short (2-bytes) in the header.
     *
     * @param buf
     *            header to write the integer into
     * @param bufPos
     *            offset into the header
     * @param value
     *            integer value to write
     */
    function createShort(buf, bufPos, value) {
        buf[bufPos + 0] = 0xff & ((value >> 8) & 0xff);
        buf[bufPos + 1] = 0xff & (value & 0xff);
    }

    /**
     * Check for magic strings (Xing/Info).
     *
     * @param buf
     *            header to check
     * @param bufPos
     *            header offset to check
     * @return magic string found
     */
    function isVbrTag(buf, bufPos) {
        return new String(buf, bufPos, VBRTag0.length(), ISO_8859_1)
                .equals(VBRTag0)
            || new String(buf, bufPos, VBRTag1.length(), ISO_8859_1)
                .equals(VBRTag1);
    }

    function shiftInBitsValue(x, n, v) {
        return 0xff & ((x << n) | (v & ~(-1 << n)));
    }

    /**
     * Construct the MP3 header using the settings of the global flags.
     *
     * <img src="1000px-Mp3filestructure.svg.png">
     *
     * @param gfp
     *            global flags
     * @param buffer
     *            header
     */
    function setLameTagFrameHeader(gfp, buffer) {
        var gfc = gfp.internal_flags;

        // MP3 Sync Word
        buffer[0] = shiftInBitsValue(buffer[0], 8, 0xff);

        buffer[1] = shiftInBitsValue(buffer[1], 3, 7);
        buffer[1] = shiftInBitsValue(buffer[1], 1,
            (gfp.out_samplerate < 16000) ? 0 : 1);
        // Version
        buffer[1] = shiftInBitsValue(buffer[1], 1, gfp.version);
        // 01 == Layer 3
        buffer[1] = shiftInBitsValue(buffer[1], 2, 4 - 3);
        // Error protection
        buffer[1] = shiftInBitsValue(buffer[1], 1, (!gfp.error_protection) ? 1
            : 0);

        // Bit rate
        buffer[2] = shiftInBitsValue(buffer[2], 4, gfc.bitrate_index);
        // Frequency
        buffer[2] = shiftInBitsValue(buffer[2], 2, gfc.samplerate_index);
        // Pad. Bit
        buffer[2] = shiftInBitsValue(buffer[2], 1, 0);
        // Priv. Bit
        buffer[2] = shiftInBitsValue(buffer[2], 1, gfp.extension);

        // Mode
        buffer[3] = shiftInBitsValue(buffer[3], 2, gfp.mode.ordinal());
        // Mode extension (Used with Joint Stereo)
        buffer[3] = shiftInBitsValue(buffer[3], 2, gfc.mode_ext);
        // Copy
        buffer[3] = shiftInBitsValue(buffer[3], 1, gfp.copyright);
        // Original
        buffer[3] = shiftInBitsValue(buffer[3], 1, gfp.original);
        // Emphasis
        buffer[3] = shiftInBitsValue(buffer[3], 2, gfp.emphasis);

        /* the default VBR header. 48 kbps layer III, no padding, no crc */
        /* but sampling freq, mode and copyright/copy protection taken */
        /* from first valid frame */
        buffer[0] = 0xff;
        var abyte = 0xff & (buffer[1] & 0xf1);
        var bitrate;
        if (1 == gfp.version) {
            bitrate = XING_BITRATE1;
        } else {
            if (gfp.out_samplerate < 16000)
                bitrate = XING_BITRATE25;
            else
                bitrate = XING_BITRATE2;
        }

        if (gfp.VBR == VbrMode.vbr_off)
            bitrate = gfp.brate;

        var bbyte;
        if (gfp.free_format)
            bbyte = 0x00;
        else
            bbyte = 0xff & (16 * lame.BitrateIndex(bitrate, gfp.version,
                    gfp.out_samplerate));

        /*
         * Use as much of the info from the real frames in the Xing header:
         * samplerate, channels, crc, etc...
         */
        if (gfp.version == 1) {
            /* MPEG1 */
            buffer[1] = 0xff & (abyte | 0x0a);
            /* was 0x0b; */
            abyte = 0xff & (buffer[2] & 0x0d);
            /* AF keep also private bit */
            buffer[2] = 0xff & (bbyte | abyte);
            /* 64kbs MPEG1 frame */
        } else {
            /* MPEG2 */
            buffer[1] = 0xff & (abyte | 0x02);
            /* was 0x03; */
            abyte = 0xff & (buffer[2] & 0x0d);
            /* AF keep also private bit */
            buffer[2] = 0xff & (bbyte | abyte);
            /* 64kbs MPEG2 frame */
        }
    }

    /**
     * Get VBR tag information
     *
     * @param buf
     *            header to analyze
     * @param bufPos
     *            offset into the header
     * @return VBR tag data
     */
    this.getVbrTag = function (buf) {
        var pTagData = new VBRTagData();
        var bufPos = 0;

        /* get Vbr header data */
        pTagData.flags = 0;

        /* get selected MPEG header data */
        var hId = (buf[bufPos + 1] >> 3) & 1;
        var hSrIndex = (buf[bufPos + 2] >> 2) & 3;
        var hMode = (buf[bufPos + 3] >> 6) & 3;
        var hBitrate = ((buf[bufPos + 2] >> 4) & 0xf);
        hBitrate = Tables.bitrate_table[hId][hBitrate];

        /* check for FFE syncword */
        if ((buf[bufPos + 1] >> 4) == 0xE)
            pTagData.samprate = Tables.samplerate_table[2][hSrIndex];
        else
            pTagData.samprate = Tables.samplerate_table[hId][hSrIndex];

        /* determine offset of header */
        if (hId != 0) {
            /* mpeg1 */
            if (hMode != 3)
                bufPos += (32 + 4);
            else
                bufPos += (17 + 4);
        } else {
            /* mpeg2 */
            if (hMode != 3)
                bufPos += (17 + 4);
            else
                bufPos += (9 + 4);
        }

        if (!isVbrTag(buf, bufPos))
            return null;

        bufPos += 4;

        pTagData.hId = hId;

        /* get flags */
        var head_flags = pTagData.flags = extractInteger(buf, bufPos);
        bufPos += 4;

        if ((head_flags & FRAMES_FLAG) != 0) {
            pTagData.frames = extractInteger(buf, bufPos);
            bufPos += 4;
        }

        if ((head_flags & BYTES_FLAG) != 0) {
            pTagData.bytes = extractInteger(buf, bufPos);
            bufPos += 4;
        }

        if ((head_flags & TOC_FLAG) != 0) {
            if (pTagData.toc != null) {
                for (var i = 0; i < NUMTOCENTRIES; i++)
                    pTagData.toc[i] = buf[bufPos + i];
            }
            bufPos += NUMTOCENTRIES;
        }

        pTagData.vbrScale = -1;

        if ((head_flags & VBR_SCALE_FLAG) != 0) {
            pTagData.vbrScale = extractInteger(buf, bufPos);
            bufPos += 4;
        }

        pTagData.headersize = ((hId + 1) * 72000 * hBitrate)
            / pTagData.samprate;

        bufPos += 21;
        var encDelay = buf[bufPos + 0] << 4;
        encDelay += buf[bufPos + 1] >> 4;
        var encPadding = (buf[bufPos + 1] & 0x0F) << 8;
        encPadding += buf[bufPos + 2] & 0xff;
        /* check for reasonable values (this may be an old Xing header, */
        /* not a INFO tag) */
        if (encDelay < 0 || encDelay > 3000)
            encDelay = -1;
        if (encPadding < 0 || encPadding > 3000)
            encPadding = -1;

        pTagData.encDelay = encDelay;
        pTagData.encPadding = encPadding;

        /* success */
        return pTagData;
    }

    /**
     * Initializes the header
     *
     * @param gfp
     *            global flags
     */
    this.InitVbrTag = function (gfp) {
        var gfc = gfp.internal_flags;

        /**
         * <PRE>
         * Xing VBR pretends to be a 48kbs layer III frame.  (at 44.1kHz).
         * (at 48kHz they use 56kbs since 48kbs frame not big enough for
         * table of contents)
         * let's always embed Xing header inside a 64kbs layer III frame.
         * this gives us enough room for a LAME version string too.
         * size determined by sampling frequency (MPEG1)
         * 32kHz:    216 bytes@48kbs    288bytes@ 64kbs
         * 44.1kHz:  156 bytes          208bytes@64kbs     (+1 if padding = 1)
         * 48kHz:    144 bytes          192
         *
         * MPEG 2 values are the same since the framesize and samplerate
         * are each reduced by a factor of 2.
         * </PRE>
         */
        var kbps_header;
        if (1 == gfp.version) {
            kbps_header = XING_BITRATE1;
        } else {
            if (gfp.out_samplerate < 16000)
                kbps_header = XING_BITRATE25;
            else
                kbps_header = XING_BITRATE2;
        }

        if (gfp.VBR == VbrMode.vbr_off)
            kbps_header = gfp.brate;

        // make sure LAME Header fits into Frame
        var totalFrameSize = ((gfp.version + 1) * 72000 * kbps_header)
            / gfp.out_samplerate;
        var headerSize = (gfc.sideinfo_len + LAMEHEADERSIZE);
        gfc.VBR_seek_table.TotalFrameSize = totalFrameSize;
        if (totalFrameSize < headerSize || totalFrameSize > MAXFRAMESIZE) {
            /* disable tag, it wont fit */
            gfp.bWriteVbrTag = false;
            return;
        }

        gfc.VBR_seek_table.nVbrNumFrames = 0;
        gfc.VBR_seek_table.nBytesWritten = 0;
        gfc.VBR_seek_table.sum = 0;

        gfc.VBR_seek_table.seen = 0;
        gfc.VBR_seek_table.want = 1;
        gfc.VBR_seek_table.pos = 0;

        if (gfc.VBR_seek_table.bag == null) {
            gfc.VBR_seek_table.bag = new int[400];
            gfc.VBR_seek_table.size = 400;
        }

        // write dummy VBR tag of all 0's into bitstream
        var buffer = new_byte(MAXFRAMESIZE);

        setLameTagFrameHeader(gfp, buffer);
        var n = gfc.VBR_seek_table.TotalFrameSize;
        for (var i = 0; i < n; ++i) {
            bs.add_dummy_byte(gfp, buffer[i] & 0xff, 1);
        }
    }

    /**
     * Fast CRC-16 computation (uses table crc16Lookup).
     *
     * @param value
     * @param crc
     * @return
     */
    function crcUpdateLookup(value, crc) {
        var tmp = crc ^ value;
        crc = (crc >> 8) ^ crc16Lookup[tmp & 0xff];
        return crc;
    }

    this.updateMusicCRC = function (crc, buffer, bufferPos, size) {
        for (var i = 0; i < size; ++i)
            crc[0] = crcUpdateLookup(buffer[bufferPos + i], crc[0]);
    }

    /**
     * Write LAME info: mini version + info on various switches used (Jonathan
     * Dee 2001/08/31).
     *
     * @param gfp
     *            global flags
     * @param musicLength
     *            music length
     * @param streamBuffer
     *            pointer to output buffer
     * @param streamBufferPos
     *            offset into the output buffer
     * @param crc
     *            computation of CRC-16 of Lame Tag so far (starting at frame
     *            sync)
     * @return number of bytes written to the stream
     */
    function putLameVBR(gfp, musicLength, streamBuffer, streamBufferPos, crc) {
        var gfc = gfp.internal_flags;
        var bytesWritten = 0;

        /* encoder delay */
        var encDelay = gfp.encoder_delay;
        /* encoder padding */
        var encPadding = gfp.encoder_padding;

        /* recall: gfp.VBR_q is for example set by the switch -V */
        /* gfp.quality by -q, -h, -f, etc */
        var quality = (100 - 10 * gfp.VBR_q - gfp.quality);

        var version = v.getLameVeryShortVersion();
        var vbr;
        var revision = 0x00;
        var revMethod;
        // numbering different in vbr_mode vs. Lame tag
        var vbrTypeTranslator = [1, 5, 3, 2, 4, 0, 3];
        var lowpass = 0 | (((gfp.lowpassfreq / 100.0) + .5) > 255 ? 255
                : (gfp.lowpassfreq / 100.0) + .5);
        var peakSignalAmplitude = 0;
        var radioReplayGain = 0;
        var audiophileReplayGain = 0;
        var noiseShaping = gfp.internal_flags.noise_shaping;
        var stereoMode = 0;
        var nonOptimal = 0;
        var sourceFreq = 0;
        var misc = 0;
        var musicCRC = 0;

        // psy model type: Gpsycho or NsPsytune
        var expNPsyTune = (gfp.exp_nspsytune & 1) != 0;
        var safeJoint = (gfp.exp_nspsytune & 2) != 0;
        var noGapMore = false;
        var noGapPrevious = false;
        var noGapCount = gfp.internal_flags.nogap_total;
        var noGapCurr = gfp.internal_flags.nogap_current;

        // 4 bits
        var athType = gfp.ATHtype;
        var flags = 0;

        // vbr modes
        var abrBitrate;
        switch (gfp.VBR) {
            case vbr_abr:
                abrBitrate = gfp.VBR_mean_bitrate_kbps;
                break;
            case vbr_off:
                abrBitrate = gfp.brate;
                break;
            default:
                abrBitrate = gfp.VBR_min_bitrate_kbps;
        }

        // revision and vbr method
        if (gfp.VBR.ordinal() < vbrTypeTranslator.length)
            vbr = vbrTypeTranslator[gfp.VBR.ordinal()];
        else
            vbr = 0x00; // unknown

        revMethod = 0x10 * revision + vbr;

        // ReplayGain
        if (gfc.findReplayGain) {
            if (gfc.RadioGain > 0x1FE)
                gfc.RadioGain = 0x1FE;
            if (gfc.RadioGain < -0x1FE)
                gfc.RadioGain = -0x1FE;

            // set name code
            radioReplayGain = 0x2000;
            // set originator code to `determined automatically'
            radioReplayGain |= 0xC00;

            if (gfc.RadioGain >= 0) {
                // set gain adjustment
                radioReplayGain |= gfc.RadioGain;
            } else {
                // set the sign bit
                radioReplayGain |= 0x200;
                // set gain adjustment
                radioReplayGain |= -gfc.RadioGain;
            }
        }

        // peak sample
        if (gfc.findPeakSample)
            peakSignalAmplitude = Math
                .abs(0 | ((( gfc.PeakSample) / 32767.0) * Math.pow(2, 23) + .5));

        // nogap
        if (noGapCount != -1) {
            if (noGapCurr > 0)
                noGapPrevious = true;

            if (noGapCurr < noGapCount - 1)
                noGapMore = true;
        }

        // flags
        flags = athType + ((expNPsyTune ? 1 : 0) << 4)
            + ((safeJoint ? 1 : 0) << 5) + ((noGapMore ? 1 : 0) << 6)
            + ((noGapPrevious ? 1 : 0) << 7);

        if (quality < 0)
            quality = 0;

        // stereo mode field (Intensity stereo is not implemented)
        switch (gfp.mode) {
            case MONO:
                stereoMode = 0;
                break;
            case STEREO:
                stereoMode = 1;
                break;
            case DUAL_CHANNEL:
                stereoMode = 2;
                break;
            case JOINT_STEREO:
                if (gfp.force_ms)
                    stereoMode = 4;
                else
                    stereoMode = 3;
                break;
            case NOT_SET:
            //$FALL-THROUGH$
            default:
                stereoMode = 7;
                break;
        }

        if (gfp.in_samplerate <= 32000)
            sourceFreq = 0x00;
        else if (gfp.in_samplerate == 48000)
            sourceFreq = 0x02;
        else if (gfp.in_samplerate > 48000)
            sourceFreq = 0x03;
        else {
            // default is 44100Hz
            sourceFreq = 0x01;
        }

        // Check if the user overrided the default LAME behavior with some
        // nasty options
        if (gfp.short_blocks == ShortBlock.short_block_forced
            || gfp.short_blocks == ShortBlock.short_block_dispensed
            || ((gfp.lowpassfreq == -1) && (gfp.highpassfreq == -1)) || /* "-k" */
            (gfp.scale_left < gfp.scale_right)
            || (gfp.scale_left > gfp.scale_right)
            || (gfp.disable_reservoir && gfp.brate < 320) || gfp.noATH
            || gfp.ATHonly || (athType == 0) || gfp.in_samplerate <= 32000)
            nonOptimal = 1;

        misc = noiseShaping + (stereoMode << 2) + (nonOptimal << 5)
            + (sourceFreq << 6);

        musicCRC = gfc.nMusicCRC;

        // Write all this information into the stream

        createInteger(streamBuffer, streamBufferPos + bytesWritten, quality);
        bytesWritten += 4;

        for (var j = 0; j < 9; j++) {
            streamBuffer[streamBufferPos + bytesWritten + j] = 0xff & version .charAt(j);
        }
        bytesWritten += 9;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & revMethod;
        bytesWritten++;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & lowpass;
        bytesWritten++;

        createInteger(streamBuffer, streamBufferPos + bytesWritten,
            peakSignalAmplitude);
        bytesWritten += 4;

        createShort(streamBuffer, streamBufferPos + bytesWritten,
            radioReplayGain);
        bytesWritten += 2;

        createShort(streamBuffer, streamBufferPos + bytesWritten,
            audiophileReplayGain);
        bytesWritten += 2;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & flags;
        bytesWritten++;

        if (abrBitrate >= 255)
            streamBuffer[streamBufferPos + bytesWritten] = 0xFF;
        else
            streamBuffer[streamBufferPos + bytesWritten] = 0xff & abrBitrate;
        bytesWritten++;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & (encDelay >> 4);
        streamBuffer[streamBufferPos + bytesWritten + 1] = 0xff & ((encDelay << 4) + (encPadding >> 8));
        streamBuffer[streamBufferPos + bytesWritten + 2] = 0xff & encPadding;

        bytesWritten += 3;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & misc;
        bytesWritten++;

        // unused in rev0
        streamBuffer[streamBufferPos + bytesWritten++] = 0;

        createShort(streamBuffer, streamBufferPos + bytesWritten, gfp.preset);
        bytesWritten += 2;

        createInteger(streamBuffer, streamBufferPos + bytesWritten, musicLength);
        bytesWritten += 4;

        createShort(streamBuffer, streamBufferPos + bytesWritten, musicCRC);
        bytesWritten += 2;

        // Calculate tag CRC.... must be done here, since it includes previous
        // information

        for (var i = 0; i < bytesWritten; i++)
            crc = crcUpdateLookup(streamBuffer[streamBufferPos + i], crc);

        createShort(streamBuffer, streamBufferPos + bytesWritten, crc);
        bytesWritten += 2;

        return bytesWritten;
    }

    function skipId3v2(fpStream) {
        // seek to the beginning of the stream
        fpStream.seek(0);
        // read 10 bytes in case there's an ID3 version 2 header here
        var id3v2Header = new_byte(10);
        fpStream.readFully(id3v2Header);
        /* does the stream begin with the ID3 version 2 file identifier? */
        var id3v2TagSize;
        if (!new String(id3v2Header, "ISO-8859-1").startsWith("ID3")) {
            /*
             * the tag size (minus the 10-byte header) is encoded into four
             * bytes where the most significant bit is clear in each byte
             */
            id3v2TagSize = (((id3v2Header[6] & 0x7f) << 21)
                | ((id3v2Header[7] & 0x7f) << 14)
                | ((id3v2Header[8] & 0x7f) << 7) | (id3v2Header[9] & 0x7f))
                + id3v2Header.length;
        } else {
            /* no ID3 version 2 tag in this stream */
            id3v2TagSize = 0;
        }
        return id3v2TagSize;
    }

    this.getLameTagFrame = function (gfp, buffer) {
        var gfc = gfp.internal_flags;

        if (!gfp.bWriteVbrTag) {
            return 0;
        }
        if (gfc.Class_ID != Lame.LAME_ID) {
            return 0;
        }
        if (gfc.VBR_seek_table.pos <= 0) {
            return 0;
        }
        if (buffer.length < gfc.VBR_seek_table.TotalFrameSize) {
            return gfc.VBR_seek_table.TotalFrameSize;
        }

        Arrays.fill(buffer, 0, gfc.VBR_seek_table.TotalFrameSize, 0);

        // 4 bytes frame header
        setLameTagFrameHeader(gfp, buffer);

        // Create TOC entries
        var toc = new_byte(NUMTOCENTRIES);

        if (gfp.free_format) {
            for (var i = 1; i < NUMTOCENTRIES; ++i)
                toc[i] = 0xff & (255 * i / 100);
        } else {
            xingSeekTable(gfc.VBR_seek_table, toc);
        }

        // Start writing the tag after the zero frame
        var streamIndex = gfc.sideinfo_len;
        /**
         * Note: Xing header specifies that Xing data goes in the ancillary data
         * with NO ERROR PROTECTION. If error protecton in enabled, the Xing
         * data still starts at the same offset, and now it is in sideinfo data
         * block, and thus will not decode correctly by non-Xing tag aware
         * players
         */
        if (gfp.error_protection)
            streamIndex -= 2;

        // Put Vbr tag
        if (gfp.VBR == VbrMode.vbr_off) {
            buffer[streamIndex++] = 0xff & VBRTag1.charAt(0);
            buffer[streamIndex++] = 0xff & VBRTag1.charAt(1);
            buffer[streamIndex++] = 0xff & VBRTag1.charAt(2);
            buffer[streamIndex++] = 0xff & VBRTag1.charAt(3);

        } else {
            buffer[streamIndex++] = 0xff & VBRTag0.charAt(0);
            buffer[streamIndex++] = 0xff & VBRTag0.charAt(1);
            buffer[streamIndex++] = 0xff & VBRTag0.charAt(2);
            buffer[streamIndex++] = 0xff & VBRTag0.charAt(3);
        }

        // Put header flags
        createInteger(buffer, streamIndex, FRAMES_FLAG + BYTES_FLAG + TOC_FLAG
            + VBR_SCALE_FLAG);
        streamIndex += 4;

        // Put Total Number of frames
        createInteger(buffer, streamIndex, gfc.VBR_seek_table.nVbrNumFrames);
        streamIndex += 4;

        // Put total audio stream size, including Xing/LAME Header
        var streamSize = (gfc.VBR_seek_table.nBytesWritten + gfc.VBR_seek_table.TotalFrameSize);
        createInteger(buffer, streamIndex, 0 | streamSize);
        streamIndex += 4;

        /* Put TOC */
        System.arraycopy(toc, 0, buffer, streamIndex, toc.length);
        streamIndex += toc.length;

        if (gfp.error_protection) {
            // (jo) error_protection: add crc16 information to header
            bs.CRC_writeheader(gfc, buffer);
        }

        // work out CRC so far: initially crc = 0
        var crc = 0x00;
        for (var i = 0; i < streamIndex; i++)
            crc = crcUpdateLookup(buffer[i], crc);
        // Put LAME VBR info
        streamIndex += putLameVBR(gfp, streamSize, buffer, streamIndex, crc);

        return gfc.VBR_seek_table.TotalFrameSize;
    }

    /**
     * Write final VBR tag to the file.
     *
     * @param gfp
     *            global flags
     * @param stream
     *            stream to add the VBR tag to
     * @return 0 (OK), -1 else
     * @throws IOException
     *             I/O error
     */
    this.putVbrTag = function (gfp, stream) {
        var gfc = gfp.internal_flags;

        if (gfc.VBR_seek_table.pos <= 0)
            return -1;

        // Seek to end of file
        stream.seek(stream.length());

        // Get file size, abort if file has zero length.
        if (stream.length() == 0)
            return -1;

        // The VBR tag may NOT be located at the beginning of the stream. If an
        // ID3 version 2 tag was added, then it must be skipped to write the VBR
        // tag data.
        var id3v2TagSize = skipId3v2(stream);

        // Seek to the beginning of the stream
        stream.seek(id3v2TagSize);

        var buffer = new_byte(MAXFRAMESIZE);
        var bytes = getLameTagFrame(gfp, buffer);
        if (bytes > buffer.length) {
            return -1;
        }

        if (bytes < 1) {
            return 0;
        }

        // Put it all to disk again
        stream.write(buffer, 0, bytes);
        // success
        return 0;
    }

}

module.exports = VBRTag;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loading.1899d705.gif";

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loading-sandwatch.463c3f82.gif";

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/read_instructions.7dfc54ed.png";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sign_say_instructions.fe133497.png";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/countdown_instructions.7ffa97ab.png";

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sign_instructions.a37cb7f8.png";

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recordrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_SafariWorker__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lamejs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lamejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lamejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_WordSignSay_css__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_WordSignSay_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_students_WordSignSay_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LoadingModalComponent_LoadingModal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_video_instructions_png__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_video_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_video_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_video_mask_png__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_video_mask_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_video_mask_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_device_detect__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Shared_InstructionModals__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__ = __webpack_require__(17);
var _this15=this;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var hasGetUserMedia=false;try{hasGetUserMedia=!!navigator.getUserMedia||!!navigator.mediaDevices.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}catch(err){hasGetUserMedia=!!navigator.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}var newSes='{\n\t"AV_FileName": "",\n\t"wssDolceWords": [{\n\t\t"id": 35,\n\t\t"createdAt": "2018-10-17T17:34:33.423Z",\n\t\t"updatedAt": "2018-10-17T17:34:33.423Z",\n\t\t"word": "many",\n\t\t"deletedAt": null\n\t}, {\n\t\t"id": 8,\n\t\t"createdAt": "2018-10-17T17:34:33.423Z",\n\t\t"updatedAt": "2018-10-17T17:34:33.423Z",\n\t\t"word": "buy",\n\t\t"deletedAt": null\n\t}, {\n\t\t"id": 70,\n\t\t"createdAt": "2018-10-17T17:34:33.423Z",\n\t\t"updatedAt": "2018-10-17T17:34:33.423Z",\n\t\t"word": "want",\n\t\t"deletedAt": null\n\t}],\n\t"startLevel": 1,\n\t"startProgress": 1,\n\t"assessmentType": 0,\n\t"guid": "644f9ece-da89-4f93-bd6a-8292520b7973"\n}';var bestScor='{\n\t"success": true,\n\t"body": {\n\t\t"id": 4430,\n\t\t"userId": 6974,\n\t\t"createdAt": "2018-10-16T18:36:55.759Z",\n\t\t"updatedAt": "2018-12-24T09:27:26.541Z",\n\t\t"mazeLevel": 3,\n\t\t"mazeScore": 2,\n\t\t"slashLevel": 4,\n\t\t"slashScore": 2,\n\t\t"ksLevel": 4,\n\t\t"ksScore": 1,\n\t\t"pnLevel": 2,\n\t\t"pnScore": 1,\n\t\t"crLevel": 2,\n\t\t"crScore": 1,\n\t\t"wssLevel": 1,\n\t\t"wssScore": 1,\n\t\t"kssLevel": 3,\n\t\t"kssScore": 2,\n\t\t"deletedAt": null\n\t},\n\t"msg": ""\n}';var testWSS='[{\n\t"id": 35,\n\t"createdAt": "2018-10-17T17:34:33.423Z",\n\t"updatedAt": "2018-10-17T17:34:33.423Z",\n\t"word": "many",\n\t"deletedAt": null\n}, {\n\t"id": 8,\n\t"createdAt": "2018-10-17T17:34:33.423Z",\n\t"updatedAt": "2018-10-17T17:34:33.423Z",\n\t"word": "buy",\n\t"deletedAt": null\n}, {\n\t"id": 70,\n\t"createdAt": "2018-10-17T17:34:33.423Z",\n\t"updatedAt": "2018-10-17T17:34:33.423Z",\n\t"word": "want",\n\t"deletedAt": null\n}]';var recordedSession=true;var params=null;var WordSignSayComponent=function(_Component){_inherits(WordSignSayComponent,_Component);function WordSignSayComponent(props){_classCallCheck(this,WordSignSayComponent);var _this=_possibleConstructorReturn(this,(WordSignSayComponent.__proto__||Object.getPrototypeOf(WordSignSayComponent)).call(this,props));_this.handleSurveyBack=function(modalActive){};_this.handleModalBack=function(modalActive){_this.setState({modalActive:modalActive});};_this.handleActive=function(active){_this.setState({active:active});};_this.handleBeginTest=function(){_this.setState({active:3});};_this.state={active:0,modalActive:true,loadedScores:false,bestScores:{wssScore:1,wssLevel:1}};return _this;}_createClass(WordSignSayComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);case 2:_context3.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!response.success){_context.next=3;break;}_context.next=3;return _this2.setState({loadedScores:true,bestScores:response.body});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 4:_context3.next=6;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentAppStatus().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var _Helpers$filterApps,allowedApps,filteredApps,finishedApps;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this2.props.updateStudentAppStatus(res.body);case 2:_Helpers$filterApps=__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].filterApps(_this2.props.studentUser,_this2.props.apps),allowedApps=_Helpers$filterApps.allowedApps,filteredApps=_Helpers$filterApps.filteredApps,finishedApps=_Helpers$filterApps.finishedApps;_context2.next=5;return _this2.props.updateAppStates({allowedApps:allowedApps,filteredApps:filteredApps,finishedApps:finishedApps});case 5:_context2.next=7;return _this2.setState({bestScores:res.body.bestScores});case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}());case 6:if(this.props.apps.wordSignSayScores.filter(function(x){return x.gradingDate==null;}).length>3){this.props.history.goBack();}case 7:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.state.active!==2?"bgGrey WordSignSay":"bgYellow WordSignSay"},this.state.active===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Shared_DialogBox__["a" /* default */],{surveyModal:true,userId:this.props.studentUser.id,app:'Word Sign/Say',active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer progressBox1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'Word Sign/Say'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 text-center"},this.state.loadedScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProgressModalComponent_ProgressBox__["a" /* default */],{appName:"wordsignsay",speed:true,level:this.state.bestScores.wssLevel,step:this.state.bestScores.wssScore,steps:3,maxLevel:1,noDescription:true}):null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"wordsignsay",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{demo:true,appName:"wordsignsay",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer wordsignsay'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'Word Sign/Say: Show Me'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["g" /* VideoComponent */],{url:"https://s3.us-east-2.amazonaws.com/uploaddev/video/picturenaming/WSS.mp4"})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{demo:true,appName:"wordsignsay",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{practice:true,appName:"wordsignsay",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tutorial,{studentUser:this.props.studentUser,buttonClick:this.handleActive,beginTest:this.handleBeginTest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"wordsignsay",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{appName:"wordsignsay",recordedSession:this.state.modalActive,buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WordSignSay,{studentUser:this.props.studentUser,buttonClick:this.handleActive,backBtn:this.handleModalBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"wordsignsay",buttonClick:this.handleActive,currentTabActive:this.state.active})):null);}}]);return WordSignSayComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var WordSignSay=function(_Component2){_inherits(WordSignSay,_Component2);function WordSignSay(props){var _this4=this;_classCallCheck(this,WordSignSay);var _this3=_possibleConstructorReturn(this,(WordSignSay.__proto__||Object.getPrototypeOf(WordSignSay)).call(this,props));_this3.handleToggleInstruction=function(toggleInstruction){localStorage.setItem('WSSInstruction',toggleInstruction);};_this3.captureUserMedia=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(callback,options){var params;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:params=null;_context4.next=3;return _this3.getMediaParam(options);case 3:params=_context4.sent;navigator.mediaDevices.getUserMedia(params).then(callback).catch(function(error){_this3.setState({modalDialog:true,responseContent:error});});case 5:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x3,_x4){return _ref4.apply(this,arguments);};}();_this3.rotateWords=function(words){var i=0;var time=_this3.state.timeInterval;_this3.setState({countdown:time});var countDownTimer=Object(__WEBPACK_IMPORTED_MODULE_19_timers__["setInterval"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return _this3.setState({countdown:_this3.state.countdown-1});case 2:if(_this3.state.countdown<0){Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(countDownTimer);}if(!(_this3.state.countdown===0)){_context5.next=7;break;}_context5.next=6;return _this3.setState({isCounting:false});case 6:_this3.startRecord();case 7:case'end':return _context5.stop();}}},_callee5,_this4);})),1000);var timer=Object(__WEBPACK_IMPORTED_MODULE_19_timers__["setInterval"])(function(){if(i===words.length){_this3.setState({dolceWord:"",wordIndex:-1});_this3.stopRecord();Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(timer);}else{var word=words[i];_this3.setState({dolceWord:word.word,wordIndex:i});i++;}},1000*time);_this3.setState({countDownTimer:countDownTimer,rotateTimer:timer});};_this3.handleStartWordSignSay=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return _this3.setState({isCounting:true});case 2:if(_this3.props.practice){_context7.next=7;break;}_this3.props.backBtn(false);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getWSSRandom().then(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(res){var wssDolceWords,bestScores,newSesh;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:wssDolceWords=res.body;_context6.next=3;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores();case 3:bestScores=_context6.sent;newSesh=_this3.state.sessionData;newSesh.startLevel=bestScores.body.wssLevel;newSesh.startProgress=bestScores.body.wssScore;newSesh.wssDolceWords=wssDolceWords;_context6.next=10;return _this3.setState({bestScores:bestScores.body,timeInterval:3,sessionData:newSesh});case 10:_this3.rotateWords(wssDolceWords);case 11:case'end':return _context6.stop();}}},_callee6,_this4);}));return function(_x5){return _ref7.apply(this,arguments);};}()).catch(function(error){});_context7.next=22;break;case 7:if(!((typeof newSes==='undefined'?'undefined':_typeof(newSes))!=='object'&&newSes!==null)){_context7.next=11;break;}_context7.next=10;return JSON.parse(newSes);case 10:newSes=_context7.sent;case 11:if(!((typeof bestScor==='undefined'?'undefined':_typeof(bestScor))!=='object'&&bestScor!==null)){_context7.next=15;break;}_context7.next=14;return JSON.parse(bestScor);case 14:bestScor=_context7.sent;case 15:if(!((typeof testWSS==='undefined'?'undefined':_typeof(testWSS))!=='object'&&testWSS!==null)){_context7.next=19;break;}_context7.next=18;return JSON.parse(testWSS);case 18:testWSS=_context7.sent;case 19:_context7.next=21;return _this3.setState({bestScores:bestScor.body,timeInterval:3,sessionData:newSes});case 21:_this3.rotateWords(testWSS);case 22:case'end':return _context7.stop();}}},_callee7,_this4);}));_this3.state={showVideo:true,isUploading:false,timeInterval:3,isCounting:false,countdown:-1,countDownTimer:null,rotateTimer:null,bestScores:null,recordVideo:null,rejectedReason:'',recording:false,dolceWord:"",wordIndex:-1,videoSrc:false,audioSrc:false,audioBlob:false,recordAudio:null,audioVideoSwitch:"video",modalDialog:false,modalInstruction:false,responseContent:'',recordedSession:false,upTime:null,sessionData:{AV_FileName:"",wssDolceWords:[],startLevel:1,startProgress:1,assessmentType:0,guid:__webpack_require__(68)()}};_this3.handleStartWordSignSay=_this3.handleStartWordSignSay.bind(_this3);_this3.handleStart=_this3.handleStart.bind(_this3);_this3.handleShowVideo=_this3.handleShowVideo.bind(_this3);_this3.handleStop=_this3.handleStop.bind(_this3);_this3.setStreamToVideo=_this3.setStreamToVideo.bind(_this3);_this3.releaseStreamFromVideo=_this3.releaseStreamFromVideo.bind(_this3);_this3.uploadVideo=_this3.uploadVideo.bind(_this3);_this3.requestUserMedia=_this3.requestUserMedia.bind(_this3);_this3.startRecord=_this3.startRecord.bind(_this3);_this3.stopRecord=_this3.stopRecord.bind(_this3);_this3.handleBackToMenu=_this3.handleBackToMenu.bind(_this3);_this3.toggleAudioVideo=_this3.toggleAudioVideo.bind(_this3);_this3.onUnload=_this3.onUnload.bind(_this3);_this3.handleToggleInstruction=_this3.handleToggleInstruction.bind(_this3);_this3.handleCloseModal=_this3.handleCloseModal.bind(_this3);_this3.startTimer=_this3.startTimer.bind(_this3);_this3.countDown=_this3.countDown.bind(_this3);_this3.handleAnalytics=_this3.handleAnalytics.bind(_this3);return _this3;}_createClass(WordSignSay,[{key:'onUnload',value:function onUnload(event){// the method that will be used for both add and remove event
event.returnValue="By leaving or reloading the page you will lose your app progress";}},{key:'componentDidMount',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:window.addEventListener("beforeunload",this.onUnload);if(!/firefox/i.test(navigator.userAgent)){_context8.next=4;break;}this.setState({modalDialog:true,responseContent:'Please use Safari or Chrome browser for this task'});return _context8.abrupt('return');case 4:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);if(hasGetUserMedia){_context8.next=8;break;}this.setState({modalDialog:true,responseContent:!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform)&&(navigator.userAgent.match('CriOS')||navigator.userAgent.match('Mozilla'))?'Please use Safari (above version 11) for this task.':'Your browser cannot stream from your webcam. Please switch to Chrome.'});return _context8.abrupt('return');case 8:this.requestUserMedia();_context8.next=11;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__["b" /* default */].STUDENT_WSS_START,metadata:{platform:navigator.platform,userAgent:navigator.userAgent}}});case 11:this.handleAnalytics();case 12:case'end':return _context8.stop();}}},_callee8,this);}));function componentDidMount(){return _ref8.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("beforeunload",this.onUnload);if(this.state.recording){if(this.state.audioVideoSwitch==="video"){this.state.recordVideo.stop(function(res){});}else{this.state.recordAudio.stop(function(res){});}Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.state.countDownTimer);Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.state.rotateTimer);this.captureUserMedia(function(stream){stream.stop();});}if(this.video&&this.video.srcObject){this.video.srcObject.stop();}}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleShowVideo',value:function handleShowVideo(){this.setState({showVideo:!this.state.showVideo});}},{key:'handleCloseModal',value:function handleCloseModal(active){window.removeEventListener("beforeunload",this.onUnload);this.setState({modalDialog:active});window.location.reload();// this.props.buttonClick(0);
}},{key:'handleBackToMenu',value:function handleBackToMenu(e){this.props.history.goBack();}},{key:'requestUserMedia',value:function requestUserMedia(){var _this5=this;this.captureUserMedia(function(stream){_this5.setStreamToVideo(stream);});}},{key:'handleStart',value:function handleStart(stream){this.setState({recording:true});this.setStreamToVideo(stream);}},{key:'handleStop',value:function handleStop(blob){this.setState({recording:false});if(this.state.audioVideoSwitch==="video"){this.releaseStreamFromVideo();}else{this.releaseStreamFromAudio();}this.uploadVideo(blob instanceof Blob,blob);}},{key:'setStreamToVideo',value:function setStreamToVideo(stream){this.video.srcObject=stream;}},{key:'releaseStreamFromVideo',value:function releaseStreamFromVideo(){this.video.srcObject=null;}},{key:'encodeMono',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(channels,sampleRate,samples){var kbps,mp3encoder,sampleBlockSize,mp3Data,i,sampleChunk,_mp3buf,mp3buf,blob;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:kbps=256;//encode 128kbps mp3
mp3encoder=new __WEBPACK_IMPORTED_MODULE_9_lamejs___default.a.Mp3Encoder(channels,sampleRate,kbps);sampleBlockSize=1152;//can be anything but make it a multiple of 576 to make encoders life easier
mp3Data=[];for(i=0;i<samples.length;i+=sampleBlockSize){sampleChunk=samples.subarray(i,i+sampleBlockSize);_mp3buf=mp3encoder.encodeBuffer(sampleChunk);if(_mp3buf.length>0){mp3Data.push(_mp3buf);}}mp3buf=mp3encoder.flush();//finish writing mp3
if(mp3buf.length>0){mp3Data.push(new Int8Array(mp3buf));}blob=new Blob(mp3Data,{type:'audio/mp3'});_context9.next=10;return this.setState({audioBlob:blob});case 10:this.handleStop(blob);case 11:case'end':return _context9.stop();}}},_callee9,this);}));function encodeMono(_x6,_x7,_x8){return _ref9.apply(this,arguments);}return encodeMono;}()},{key:'setStreamToAudio',value:function setStreamToAudio(stream){this.audio.srcObject=stream;}},{key:'releaseStreamFromAudio',value:function releaseStreamFromAudio(){this.audio.pause();this.audio.srcObject=null;this.audio.src="";this.audio.load();}},{key:'startRecordAudio',value:function startRecordAudio(){var _this6=this;this.captureUserMedia(function(stream){var options={type:'audio',audio:_this6.audio,sampleRate:44100,bufferSize:4096,numberOfAudioChannels:1,recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder};_this6.setState({recordAudio:new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder(stream,options)});_this6.state.recordAudio.record();_this6.handleStartAudio(stream);},{audio:true,video:false});}},{key:'handleStopAudio',value:function handleStopAudio(wavBlob){var _this7=this;this.setState({recording:false});var fileReader=new FileReader();fileReader.onload=function(event){var arrayBuffer=event.target.result;var wav=__WEBPACK_IMPORTED_MODULE_9_lamejs___default.a.WavHeader.readHeader(new DataView(arrayBuffer));var samples=new Int16Array(arrayBuffer,wav.dataOffset,wav.dataLen/2);_this7.encodeMono(wav.channels,wav.sampleRate,samples);_this7.releaseStreamFromAudio();};fileReader.readAsArrayBuffer(wavBlob);}},{key:'handleStartAudio',value:function handleStartAudio(stream){this.setState({recording:true});this.setStreamToAudio(stream);}},{key:'stopRecordAudio',value:function stopRecordAudio(){var _this8=this;this.state.recordAudio.stop(function(wavBlob){_this8.handleStopAudio(wavBlob);});}},{key:'getMediaParam',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(options){var userAgent;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return navigator.userAgent;case 2:userAgent=_context10.sent;if(!options){_context10.next=7;break;}params=options;_context10.next=15;break;case 7:if(!(/Chrome/i.test(userAgent)&&/Windows/i.test(userAgent))){_context10.next=11;break;}params={audio:true,video:true};_context10.next=15;break;case 11:_context10.next=13;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].getVideoSizes();case 13:_context10.t0=_context10.sent;params={audio:true,video:_context10.t0};case 15:return _context10.abrupt('return',params);case 16:case'end':return _context10.stop();}}},_callee10,this);}));function getMediaParam(_x9){return _ref10.apply(this,arguments);}return getMediaParam;}()},{key:'uploadVideo',value:function uploadVideo(isBlob,blob){var _this9=this;console.log('start to upload');__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].uploadWSSVideo(isBlob,blob).then(function(res){if(_this9.state.audioVideoSwitch==="video"){_this9.video.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_this9.setState({videoSrc:_this9.video.src});}else{_this9.audio2.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_this9.audio2.load();_this9.audio2.play();}var seshData=_this9.state.sessionData;seshData.AV_FileName=res.body.filepath;_this9.setState({isUploading:false,recordedSession:true});if(!_this9.props.practice){window.removeEventListener("beforeunload",_this9.onUnload);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].insertWSSSession(seshData).then(function(res){_this9.setState({modalDialog:true,responseContent:'Video saved'});});}else{_this9.setState({modalDialog:true,responseContent:'Practice Finished'});}}).catch(function(error){console.log(error);_this9.setState({modalDialog:true,responseContent:'Failed to save video.'});});}},{key:'noWebM',value:function noWebM(){return __WEBPACK_IMPORTED_MODULE_17_react_device_detect__["isIOS"]||__WEBPACK_IMPORTED_MODULE_17_react_device_detect__["isSafari"];}},{key:'startRecordVideo',value:function startRecordVideo(){var _this10=this;this.captureUserMedia(function(stream){var audio_options={type:'audio',audio:_this10.audio,sampleRate:44100,bufferSize:4096,numberOfAudioChannels:1,recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder};var video_options=void 0;var videoRecorderClass=void 0;if(_this10.noWebM()){video_options={type:'video',recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.WhammyRecorder,frameInterval:50,video:_this10.video,width:320,height:240};videoRecorderClass=new __WEBPACK_IMPORTED_MODULE_7__Shared_SafariWorker__["a" /* default */]().WhammyRecorder(stream,video_options);}else{video_options={mimeType:'video/webm',recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.MediaStreamRecorder,width:320,height:240};videoRecorderClass=new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.MediaStreamRecorder(stream,video_options);}_this10.setState({recordAudio:new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder(stream,audio_options),recordVideo:videoRecorderClass},function(){if(_this10.noWebM()){_this10.state.recordVideo.record(_this10.state.recordAudio.record());}else{_this10.state.recordVideo.record();}_this10.handleStart(stream);});},{audio:true,video:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].getVideoSizes()});}},{key:'handleStopWrapper',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(vidResult,wavBlob){var _this11=this;var vidETA;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:this.setState({recording:false});_context11.next=3;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].calculateETA(vidResult,wavBlob);case 3:vidETA=_context11.sent;this.setState({upTime:vidETA});_context11.next=7;return this.startTimer();case 7:if(this.props.practice){_context11.next=13;break;}if(this.state.audioVideoSwitch==="video"){this.releaseStreamFromVideo();if(this.noWebM()){this.releaseStreamFromAudio();}}_context11.next=11;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].uploadWSSVideo(true,vidResult,wavBlob).then(function(res){if(_this11.state.audioVideoSwitch==="video"){_this11.video.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_this11.setState({videoSrc:_this11.video.src});}var seshData=_this11.state.sessionData;seshData.AV_FileName=res.body.filepath;_this11.setState({isUploading:false,recordedSession:true});if(!_this11.props.practice){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].insertWSSSession(seshData).then(function(res){_this11.setState({modalDialog:true,responseContent:'Video saved'});});}window.removeEventListener("beforeunload",_this11.onUnload);return false;}).catch(function(error){});case 11:_context11.next=14;break;case 13:this.setState({modalDialog:true,responseContent:'Practice Finished'});case 14:case'end':return _context11.stop();}}},_callee11,this);}));function handleStopWrapper(_x10,_x11){return _ref11.apply(this,arguments);}return handleStopWrapper;}()},{key:'stopRecordVideo',value:function stopRecordVideo(){var _this12=this;if(this.noWebM()){var promise1=function promise1(){return new Promise(function(resolve,reject){_this12.state.recordAudio.stop(function(wavBlob){resolve(wavBlob);});});};var promise2=function promise2(){return new Promise(function(resolve,reject){_this12.state.recordVideo.stop(function(result){resolve(result);});});};Promise.all([promise1(),promise2()]).then(function(values){if(values[0]instanceof Array){_this12.handleStopWrapper(values[0],values[1]);}else{_this12.handleStopWrapper(values[1],values[0]);}});}else{this.state.recordVideo.stop(function(result){_this12.handleStopWrapper([],result);});}}},{key:'stopRecord',value:function stopRecord(){if(this.state.audioVideoSwitch==="video"){this.stopRecordVideo();}else{this.stopRecordAudio();}this.setState({recording:false,isUploading:true,recordedSession:true});if(!this.props.practice){this.props.backBtn(this.state.recordedSession);}}},{key:'startRecord',value:function startRecord(){if(this.state.audioVideoSwitch==="video"){this.startRecordVideo();}else{this.startRecordAudio();}this.setState({recording:true});}},{key:'toggleAudioVideo',value:function toggleAudioVideo(){if(this.state.audioVideoSwitch==="video"){this.setState({audioVideoSwitch:"audio"});this.releaseStreamFromVideo();}else{this.setState({audioVideoSwitch:"video"});this.releaseStreamFromAudio();this.requestUserMedia();}}},{key:'startTimer',value:function startTimer(){this.timer=Object(__WEBPACK_IMPORTED_MODULE_19_timers__["setInterval"])(this.countDown,1000);}},{key:'countDown',value:function countDown(){var seconds=this.state.upTime-1;this.setState({upTime:seconds});if(seconds<=0){Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.timer);}}},{key:'render',value:function render(){var _this13=this;var imageNumerical=this.state.sessionData.wssDolceWords.map(function(wssWord,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:index<=_this13.state.wordIndex?"item_done":""},(index+1).toString());});var countDown=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.wordIndex>-1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:"fontCountdown",hidden:this.state.countdown<=0},this.state.countdown),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{hidden:this.state.wordIndex>-1||this.state.countdown!==-1||this.state.recordedSession,src:__WEBPACK_IMPORTED_MODULE_14__assets_images_video_instructions_png___default.a,style:{marginTop:'15%'}}));var wordsSlideshow=this.state.sessionData.wssDolceWords.map(function(wssWord,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"WssFontSize",style:{marginTop:"20%",textTransform:'lowercase'},hidden:_this13.state.wordIndex!==index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textTransform:'lowercase'}},wssWord.word));});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.practice?"appSection bgGrey":"appSection bgYellow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},!this.props.practice?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Shared_InstructionModals__["a" /* default */],{WSS:true,modalOpen:this.state.modalInstruction,instructionMask:__WEBPACK_IMPORTED_MODULE_14__assets_images_video_instructions_png___default.a,toggleInstruction:this.handleToggleInstruction,closeClick:function closeClick(active){_this13.setState({modalInstruction:active});}}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:this.handleCloseModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer wordsignsay'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-md-6 col-sm-6'},countDown,wordsSlideshow,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{hidden:this.state.isUploading||this.state.recordedSession,className:'list_items'},imageNumerical)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-md-6 col-sm-6',style:this.state.showVideo?{}:{display:'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.audioVideoSwitch==="video",style:{paddingTop:"35%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{ref:function ref(audio){_this13.audio=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{controls:true,ref:function ref(audio2){_this13.audio2=audio2;}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.isUploading||this.state.recording||this.state.recordedSession,style:{position:'absolute',margin:'auto',zIndex:1,top:65,left:0,bottom:0,right:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15__assets_images_video_mask_png___default.a,style:{minWidth:200,width:'65%'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"WordSignSayVidPlay",hidden:this.state.audioVideoSwitch==="audio"||this.state.recordedSession,playsInline:true,ref:function ref(video){_this13.video=video;},style:{position:'relative',top:65},width:'100%',autoPlay:true,controls:!this.state.recording&&this.state.videoSrc&&this.state.videoSrc!=="",className:this.state.recording||!this.state.videoSrc||this.state.videoSrc===""?"flippedVideo":"",muted:this.state.recording||!this.state.videoSrc||this.state.recordedSession?"muted":""})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:720,marginTop:450}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",width:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',defaultChecked:true,onChange:this.handleShowVideo,id:'checkHideDeleted',className:'form-control'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",marginTop:9,marginLeft:10}},'Show my video'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},!this.state.recording&&!this.state.isUploading&&!this.state.isCounting?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.recordedSession?"hidden":"handBtn",onClick:this.handleStartWordSignSay},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Start'))):null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LoadingModalComponent_LoadingModal__["a" /* default */],{timer:true,upTime:this.state.upTime,isUploading:this.state.isUploading}));}}]);return WordSignSay;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Tutorial=function(_Component3){_inherits(Tutorial,_Component3);function Tutorial(props){_classCallCheck(this,Tutorial);return _possibleConstructorReturn(this,(Tutorial.__proto__||Object.getPrototypeOf(Tutorial)).call(this,props));}_createClass(Tutorial,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WordSignSay,{studentUser:this.props.studentUser,buttonClick:this.props.buttonClick,practice:true});}}]);return Tutorial;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context12.abrupt('return',_context12.sent);case 3:case'end':return _context12.stop();}}},_callee12,_this15);}));function updateStudentAppStatus(_x12){return _ref12.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context13.abrupt('return',_context13.sent);case 3:case'end':return _context13.stop();}}},_callee13,_this15);}));function updateStudentAccountTab(_x13){return _ref13.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["a" /* updateAppStates */])(appStates));case 2:return _context14.abrupt('return',_context14.sent);case 3:case'end':return _context14.stop();}}},_callee14,_this15);}));function updateAppStates(_x14){return _ref14.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(WordSignSayComponent)));

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TeachersComponent_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_correct_png__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_correct_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_correct_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_wrong_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_wrong_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_wrong_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StudentsComponent_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(23);
var _this4=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PN1On1Teacher=function(_Component){_inherits(PN1On1Teacher,_Component);function PN1On1Teacher(props){var _this2=this;_classCallCheck(this,PN1On1Teacher);var _this=_possibleConstructorReturn(this,(PN1On1Teacher.__proto__||Object.getPrototypeOf(PN1On1Teacher)).call(this,props));_this.wait=function(ms){return new Promise(function(resolve){setTimeout(resolve,ms);});};_this.submitPNSessionGrade=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.state.sessionData.testId=_this.state.testId;console.log("Submitting session data: ",_this.state.sessionData);_context.next=4;return __WEBPACK_IMPORTED_MODULE_4__Shared_REST__["a" /* default */].gradePNSession(_this.state.sessionData);case 4:alert("The 1-1 computer task has been successfully and saved.");_this.setState({saved:true});case 6:case'end':return _context.stop();}}},_callee,_this2);}));_this.rotatePictures=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(pnPictures,websocket){var time,timer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:time=3.0;console.log("Starting assessment interval.",pnPictures);timer=setInterval(function(){var i=_this.state.currentIndex;if(!_this.state.paused){if(_this.state.pnPicture&&_this.state.pnPicture.pn_assessments_picture.grade===0){_this.gradePNPicture(2);}if(i<pnPictures.length){var ap=pnPictures[i];_this.setState({pnPicture:ap,imageSrc:ap.url,currentWord:ap.word});websocket.send(JSON.stringify({url:ap.url,currentIndex:i}));}else{clearInterval(timer);_this.setState({imageSrc:"",currentWord:"",currentIndex:-1,finished:true});websocket.send(JSON.stringify({url:"",currentIndex:-1}));//this.submitPNSessionGrade();
}_this.setState({currentIndex:_this.state.currentIndex+1});}},time*1000);_this.setState({timer:timer});case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}();_this.handleStartPNManual=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(websocket){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_4__Shared_REST__["a" /* default */].getPNManualSession(_this.state.testId).then(function(res){var manualPNSession=res.body;if(manualPNSession){_this.state.pnPictures=manualPNSession.pn_pictures;_this.setState({pnPictures:manualPNSession.pn_pictures,saved:false});_this.rotatePictures(manualPNSession.pn_pictures,websocket);}else{alert("An Invalid Assessment ID has been provided.");}}).catch(function(error){alert("An Invalid Assessment ID has been provided.");});case 2:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref3.apply(this,arguments);};}();_this.openWebSocket=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var authToken,data,pnAsst,socket;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.setState({testId:null,paused:true,started:false,studentJoin:false,finished:false,saved:false});case 2:if(!(_this.state.userId!=null)){_context4.next=15;break;}authToken=localStorage.getItem('token');data={userId:_this.state.userId,assessmentType:1//1-1 computer session
};_context4.next=7;return __WEBPACK_IMPORTED_MODULE_4__Shared_REST__["a" /* default */].createPN1On1Session(data);case 7:pnAsst=_context4.sent;_context4.next=10;return _this.setState({testId:pnAsst.body.id});case 10:socket=new WebSocket(__WEBPACK_IMPORTED_MODULE_7__Shared_Consts__["c" /* MAIN */].API.START_PICTURENAMING_WEBSOCKET+"?token="+authToken+"&testId="+_this.state.testId);socket.addEventListener('open',function(event){_this.setState({websocket:socket});_this.handleStartPNManual(socket);});socket.addEventListener('message',function(event){var studentMessage=JSON.parse(event.data);_this.setState({studentJoined:studentMessage.status});console.log('Message from server ');});_context4.next=16;break;case 15:alert("Please enter the student username in order to start the session.");case 16:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.state={testId:null,userId:null,paused:true,started:false,finished:false,saved:false,timer:null,websocket:null,bestScores:null,startLevel:0,endLevel:0,startProgress:0,endProgress:0,rejectedReason:'',recording:false,imageSrc:"",pnPicture:null,studentJoined:false,currentWord:"",currentIndex:0,pnPictures:[],sessionData:{testId:null,gradingTime:60,numberCorrect:0,numberIncorrect:0,numberSkipped:20,endLevel:1,startLevel:1,endProgress:1,pnPictures:[],assessmentType:1,startProgress:1,guid:__webpack_require__(68)()}};_this.handleStartPNManual=_this.handleStartPNManual.bind(_this);_this.gradePNPicture=_this.gradePNPicture.bind(_this);_this.submitPNSessionGrade=_this.submitPNSessionGrade.bind(_this);_this.changeImage=_this.changeImage.bind(_this);_this.pause=_this.pause.bind(_this);_this.handleGoBack=_this.handleGoBack.bind(_this);return _this;}_createClass(PN1On1Teacher,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__["a" /* default */].authorize(this);var parsed=__WEBPACK_IMPORTED_MODULE_8_query_string___default.a.parse(this.props.location.search);this.setState({userId:parsed.userId});}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.state.timer);}},{key:'gradePNPicture',value:function gradePNPicture(grade){var oldGrade=this.state.pnPicture.pn_assessments_picture.grade;this.state.pnPicture.pn_assessments_picture.grade=grade;this.state.sessionData.pnPictures.push(this.state.pnPicture);if(oldGrade!==grade){if(oldGrade===1){this.state.sessionData.numberCorrect=this.state.sessionData.numberCorrect-1;}else if(oldGrade===2){this.state.sessionData.numberIncorrect=this.state.sessionData.numberIncorrect-1;}else if(oldGrade===0){this.state.sessionData.numberSkipped=this.state.sessionData.numberSkipped-1;}if(grade===1){this.state.sessionData.numberCorrect=this.state.sessionData.numberCorrect+1;}else if(grade===2){this.state.sessionData.numberIncorrect=this.state.sessionData.numberIncorrect+1;}else if(grade===0){this.state.sessionData.numberSkipped=this.state.sessionData.numberSkipped+1;}}this.forceUpdate();}},{key:'pause',value:function pause(_pause){this.setState({paused:_pause,started:true});}},{key:'changeImage',value:function changeImage(index){var ap=this.state.pnPictures[index];this.setState({pnPicture:ap,imageSrc:ap.url,currentIndex:index,currentWord:ap.word});this.state.websocket.send(JSON.stringify({url:ap.url}));this.pause(true);}},{key:'handleGoBack',value:function handleGoBack(){this.props.updateStudent(null);this.props.history.push("/teacher");}},{key:'render',value:function render(){var _this3=this;var imageThumbnails=this.state.pnPictures.map(function(pnPic,index){var gradeSrc="";if(pnPic.pn_assessments_picture.grade===1){gradeSrc=__WEBPACK_IMPORTED_MODULE_11__assets_images_correct_png___default.a;}else if(pnPic.pn_assessments_picture.grade===2){gradeSrc=__WEBPACK_IMPORTED_MODULE_12__assets_images_wrong_png___default.a;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:index,style:{display:"inline-block",paddingTop:"20px",paddingLeft:"20px",paddingBottom:"20px",paddingRight:"20px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{position:"relative",top:"-10px",left:"0px",zIndex:2},src:gradeSrc,alt:""}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{position:"relative",top:"0px",left:"0px",zIndex:1,cursor:"pointer"},key:index,onClick:function onClick(){return _this3.changeImage(index);},src:pnPic.url,width:'50',height:'43',alt:pnPic.word}));});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_Header__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"section bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 noPadding mobileCenter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-8'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Picture Naming 1-1 Computer Task')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4 tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://docs.google.com/document/d/1b5QXeINPTbOQ5j74CVXieeCWXMf-xsX62pZkEjuNUdw",className:'handBtn',style:{textDecoration:'none',marginTop:-10},target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Help Doc'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},this.state.testId||this.state.saved?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.openWebSocket,className:'handBtn',style:{marginRight:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'New Task'))),this.state.testId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Task ID : #',this.state.testId),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),this.state.saved?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Status: Session saved.'):this.state.studentJoined?this.state.started?this.state.finished?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Status: Completed ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' Press "Save" button to save this session.'):this.state.paused?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Status: Paused',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' Press "Start" button when both of you are ready.'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Status: In progress',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' Press "Pause" button when you want to pause.'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Status: Student has joined this task session.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' Press "Start" button when both of you are ready.'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Status: Waiting for student to join.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'(Ask student to join using Task ID # above)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.paused||!this.state.studentJoined||this.state.finished,className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){return _this3.pause(true);},className:'handBtn',style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'PAUSE'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.paused||!this.state.studentJoined||this.state.saved,className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){return _this3.pause(false);},className:'handBtn',style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'START'))),this.state.saved?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.openWebSocket,className:'handBtn',style:{marginRight:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'New Task'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleGoBack,style:{marginRight:0}},'To select another student,',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'go to Student list.'))):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{fontSize:"18pt",textAlign:"center"}},this.state.currentWord)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{height:256,className:this.state.imageSrc===""?"":"center-block",hidden:this.state.imageSrc==="",src:this.state.imageSrc,alt:'PNPicture'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.imageSrc==="",className:'row text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn2 btn-success',onClick:function onClick(){return _this3.gradePNPicture(1);}},'Correct'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn2 btn-danger',onClick:function onClick(){return _this3.gradePNPicture(2);}},'Incorrect'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn2 btn-info',onClick:function onClick(){return _this3.gradePNPicture(0);}},'Skip')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},imageThumbnails)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 paddingTop'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){return _this3.props.history.goBack();},className:'handBtn fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Exit')),this.state.testId&&this.state.studentJoined?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitPNSessionGrade,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')):null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_Footer__["a" /* default */],null));}}]);return PN1On1Teacher;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudent:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__TeachersComponent_actions__["h" /* updateStudent */])(student));case 2:return _context5.abrupt('return',_context5.sent);case 3:case'end':return _context5.stop();}}},_callee5,_this4);}));function updateStudent(_x4){return _ref5.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{student:state.teacherReducer.student};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(PN1On1Teacher)));

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_DialogBox__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PNManual=function(_Component){_inherits(PNManual,_Component);function PNManual(props){var _this2=this;_classCallCheck(this,PNManual);var _this=_possibleConstructorReturn(this,(PNManual.__proto__||Object.getPrototypeOf(PNManual)).call(this,props));_this.componentDidMount=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(_this);parsed=__WEBPACK_IMPORTED_MODULE_11_query_string___default.a.parse(_this.props.location.search);if(!parsed.testId){_context.next=7;break;}_context.next=5;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getPNManualScore(parsed.testId).then(function(response){_this.setState({testId:parsed.testId,userId:parsed.userId,numberCorrect:response.body.numberCorrect});});case 5:_context.next=8;break;case 7:_this.setState({userId:parsed.userId});case 8:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleDelete=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].deletePictureNamingScore(_this.state.testId);case 2:_context2.next=4;return _this.setState({modalDialog:true,responseContent:"The score has been removed."});case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.submitPNManualSessionGrade=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(_this.state.numberCorrect>=0&&_this.state.numberCorrect<=20)){_context3.next=7;break;}_context3.next=3;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].gradePNManualSession({testId:_this.state.testId,userId:_this.state.userId,numberCorrect:_this.state.numberCorrect});case 3:_context3.next=5;return _this.setState({return:true,modalDialog:true,responseContent:"The Manual Session has been successfully saved."});case 5:_context3.next=9;break;case 7:_context3.next=9;return _this.setState({return:false,modalDialog:true,responseContent:"The number of correct answers needs to be between 0 and 20."});case 9:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.state={testId:null,userId:null,numberCorrect:null,guid:__webpack_require__(68)(),responseContent:null,modalDialog:false,return:false};_this.submitPNManualSessionGrade=_this.submitPNManualSessionGrade.bind(_this);_this.handleNumberCorrect=_this.handleNumberCorrect.bind(_this);_this.handleDelete=_this.handleDelete.bind(_this);_this.handleCloseModal=_this.handleCloseModal.bind(_this);return _this;}_createClass(PNManual,[{key:'handleNumberCorrect',value:function handleNumberCorrect(event){this.setState({numberCorrect:event.target.value});}},{key:'handleCloseModal',value:function handleCloseModal(){this.setState({modalDialog:false});if(this.state.return){this.props.history.goBack();}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_Header__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"section bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:this.handleCloseModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 noPadding mobileCenter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-8'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Picture Cards')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4 tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://docs.google.com/document/d/1WfKun_KlpgXcU63LaRN73gKIpBt5IeLKZSLmwmLKOjA",className:'handBtn',style:{textDecoration:'none',marginTop:-10},target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Help Doc'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-4'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"form-group"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:"https://uploadbeta.s3.us-east-2.amazonaws.com/documents/PN_Manual_images.pdf",target:'_blank',download:'PNManualTask.pdf',className:'handBtn',style:{marginRight:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Download Picture Cards'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Number of correct answers'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.handleNumberCorrect,value:this.state.numberCorrect?this.state.numberCorrect:null,id:'inputCorrects',className:'form-control ',placeholder:'',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-4'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 paddingTop'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){return _this3.props.history.goBack();},className:'handBtn fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Exit')),this.state.testId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleDelete,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete')):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitPNManualSessionGrade,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_Footer__["a" /* default */],null));}}]);return PNManual;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(PNManual));

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_app_picturenaming_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_app_picturenaming_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_app_picturenaming_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Shared_DropDownNotifications__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalFormComponents_ReportBugForm__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_ico_pause_white_png__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_ico_pause_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_images_ico_pause_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_ico_play_white_png__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_ico_play_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_images_ico_play_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_ico_prev_white_png__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_ico_prev_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_images_ico_prev_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_ico_next_white_png__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_ico_next_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_images_ico_next_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_images_ico_restart_white_png__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_images_ico_restart_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_images_ico_restart_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_modal_x_png__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_modal_x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_images_modal_x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_images_hint_arrow_png__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_images_hint_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_images_hint_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Shared_DataTrackingPoints__ = __webpack_require__(17);
var _this7=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PNGrading=function(_Component){_inherits(PNGrading,_Component);function PNGrading(props){var _this2=this;_classCallCheck(this,PNGrading);var _this=_possibleConstructorReturn(this,(PNGrading.__proto__||Object.getPrototypeOf(PNGrading)).call(this,props));_this.submitPNSessionGrade=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.state.sessionData.testId=_this.state.testId;_context2.next=3;return _this.setState({sessionData:Object.assign({},_this.state.sessionData,{testId:_this.state.testId,gradingTime:Math.ceil((Date.now()-_this.state.gradeStart)/1000)})});case 3:_context2.next=5;return _this.getGradeCounts();case 5:console.log("Submitting session data: ",_this.state.sessionData);_context2.next=8;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].gradePNSession(_this.state.sessionData).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(_this.state.pnSession&&_this.state.pnSession.assessmentType===0)){_context.next=3;break;}_context.next=3;return _this.updatePNBestScore();case 3:_this.setState({modalDialog:true,responseContent:'Score task saved.',analytics:{type:__WEBPACK_IMPORTED_MODULE_29__Shared_DataTrackingPoints__["b" /* default */].PN_SCORE_SAVE,metadata:{testId:_this.state.testId}}});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 8:_this.handleAnalytics();case 9:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.startGrading=function(testId){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getPNManualSession(testId).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res){var pnSession,bestScores;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:pnSession=res.body;if(!pnSession){_context3.next=10;break;}_context3.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentBestScores(pnSession.userId);case 4:bestScores=_context3.sent;_this.setState({pnSession:pnSession,bestScores:bestScores.body,noteContent:pnSession.note,pnPictures:pnSession.pn_pictures,videoSrc:__WEBPACK_IMPORTED_MODULE_6__Shared_Consts__["b" /* BUCKET_URL */]+pnSession.AV_FileName});_this.video.src=__WEBPACK_IMPORTED_MODULE_6__Shared_Consts__["b" /* BUCKET_URL */]+pnSession.AV_FileName;_this.startPictureGrading(pnSession.pn_pictures);_context3.next=12;break;case 10:_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 12:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}()).catch(function(error){_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);});};_this.deleteScoreConfirm=function(confirm){if(confirm){_this.deleteScore();}_this.setState({modalDialogDelete:false});};_this.handleStudentClick=function(student,classId){_this.props.updateStudent(student);_this.props.history.push('/teacher/student');};_this.state={testId:null,gradeStart:null,paused:true,timerInterval:null,bestScores:null,rejectedReason:'',recording:false,imageSrc:"",videoSrc:"",currentWord:"",currentIndex:-1,pnPicture:null,studentJoined:false,pnPictures:[],pnSession:null,modalDialog:false,responseContent:'',modalDialogDelete:false,modalDialogNote:false,noteContent:'',handleNext:false,taskID:null,showStartHint:false,showReScoreHint:false,showSaveHint:false,play:false,sessionData:{testId:null,gradingTime:60,numberCorrect:0,numberIncorrect:0,numberSkipped:0,endLevel:1,endProgress:20,pnPictures:[]// guid: require('uuid/v4')()
},analytics:{type:null,metadata:null}};_this.startGrading=_this.startGrading.bind(_this);_this.startPictureGrading=_this.startPictureGrading.bind(_this);_this.handleReset=_this.handleReset.bind(_this);_this.gradePNPicture=_this.gradePNPicture.bind(_this);_this.submitPNSessionGrade=_this.submitPNSessionGrade.bind(_this);_this.pause=_this.pause.bind(_this);_this.changeImage=_this.changeImage.bind(_this);_this.prev=_this.prev.bind(_this);_this.next=_this.next.bind(_this);_this.updatePNBestScore=_this.updatePNBestScore.bind(_this);_this.getGradeCounts=_this.getGradeCounts.bind(_this);_this.deleteScore=_this.deleteScore.bind(_this);_this.handleTakeANote=_this.handleTakeANote.bind(_this);_this.saveNote=_this.saveNote.bind(_this);_this.deleteNote=_this.deleteNote.bind(_this);_this.handleNoteClose=_this.handleNoteClose.bind(_this);_this.handleNoteContentChange=_this.handleNoteContentChange.bind(_this);_this.handleStudentClick=_this.handleStudentClick.bind(_this);_this.handleNextTask=_this.handleNextTask.bind(_this);_this.getTarget=_this.getTarget.bind(_this);_this.getTarget1=_this.getTarget1.bind(_this);_this.handleShowHints=_this.handleShowHints.bind(_this);_this.handlePlay=_this.handlePlay.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(PNGrading,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this3=this;var parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);parsed=__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.parse(this.props.location.search);console.log(parsed);_context4.next=5;return this.setState({testId:parsed.testId,gradeStart:Date.now(),analytics:{type:__WEBPACK_IMPORTED_MODULE_29__Shared_DataTrackingPoints__["b" /* default */].PN_SCORE_VIEW,metadata:{testId:parsed.testId}}});case 5:this.startGrading(parsed.testId);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentNotifications().then(function(res){for(var i=0;i<res.body.length;i++){for(var j=0;j<res.body[i].apps.pictureNamingScores.length;j++){var pictureNamingScores=res.body[i].apps.pictureNamingScores[j];if(pictureNamingScores&&pictureNamingScores.userId===_this3.props.lastStudent.user.id&&pictureNamingScores.id!=parsed.testId){_this3.setState({handleNext:true,taskID:pictureNamingScores.id});}}}});this.handleAnalytics();case 8:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.state.timerInterval);}},{key:'handleNextTask',value:function handleNextTask(){window.location.href='/teacher/apps/pn-grading?testId='+this.state.taskID;}},{key:'getGradeCounts',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var result,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,pnPic;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:result={numberCorrect:0,numberIncorrect:0,numberSkipped:0};_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context5.prev=4;for(_iterator=this.state.pnPictures[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){pnPic=_step.value;if(pnPic.pn_assessments_picture.grade===1){result.numberCorrect=result.numberCorrect+1;}else if(pnPic.pn_assessments_picture.grade===2){result.numberIncorrect=result.numberIncorrect+1;}else{result.numberSkipped=result.numberSkipped+1;}}_context5.next=12;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](4);_didIteratorError=true;_iteratorError=_context5.t0;case 12:_context5.prev=12;_context5.prev=13;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 15:_context5.prev=15;if(!_didIteratorError){_context5.next=18;break;}throw _iteratorError;case 18:return _context5.finish(15);case 19:return _context5.finish(12);case 20:_context5.next=22;return this.setState({sessionData:Object.assign({},this.state.sessionData,result)});case 22:return _context5.abrupt('return',result);case 23:case'end':return _context5.stop();}}},_callee5,this,[[4,8,12,20],[13,,15,19]]);}));function getGradeCounts(){return _ref5.apply(this,arguments);}return getGradeCounts;}()},{key:'updatePNBestScore',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var newProgress,newLevel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:console.log('bestScores');console.log(this.state.bestScores);console.log('pnSession');console.log(this.state.pnSession);if(!(this.state.bestScores.pnLevel===this.state.pnSession.startLevel)){_context6.next=13;break;}//not clear
//if(this.state.bestScores.pnLevel === this.state.pnSession.startLevel && this.state.bestScores.pnScore === this.state.pnSession.startProgress{
newProgress=this.state.bestScores.pnScore;newLevel=this.state.bestScores.pnLevel;if(this.state.pnSession.startLevel===1){if(this.state.sessionData.numberCorrect===12){newProgress++;}else{newProgress--;}}else if(this.state.pnSession.startLevel===2){if(this.state.sessionData.numberCorrect===15){newProgress++;}else{newProgress--;}}else if(this.state.pnSession.startLevel===3){if(this.state.sessionData.numberCorrect>=18){newProgress++;}else{newProgress--;}}if(newProgress>=4&&newLevel<=3){newLevel++;newProgress=1;}else if(newProgress===0){//newLevel--;
newProgress=1;}_context6.next=11;return this.setState({bestScores:Object.assign({},this.state.bestScores,{pnLevel:newLevel,pnScore:newProgress})});case 11:_context6.next=13;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updatePNBestScore(this.state.bestScores);case 13:case'end':return _context6.stop();}}},_callee6,this);}));function updatePNBestScore(){return _ref6.apply(this,arguments);}return updatePNBestScore;}()},{key:'gradePNPicture',value:function gradePNPicture(grade){this.state.pnPicture.pn_assessments_picture.grade=grade;this.state.sessionData.pnPictures.push(this.state.pnPicture);if(grade===1){this.state.sessionData.numberCorrect=this.state.sessionData.numberCorrect+1;}else if(grade===2){this.state.sessionData.numberIncorrect=this.state.sessionData.numberIncorrect+1;}else{this.state.sessionData.numberSkipped=this.state.sessionData.numberSkipped+1;}this.next();}},{key:'handleReset',value:function handleReset(){for(var i=0;i<this.state.pnPictures.length;i++){this.state.pnPictures[i].pn_assessments_picture.grade=0;this.state.sessionData.pnPictures.push(this.state.pnPictures[i]);}this.setState({sessionData:Object.assign({},this.state.sessionData,{numberCorrect:0,numberIncorrect:0,numberSkipped:0})});}},{key:'startPictureGrading',value:function startPictureGrading(pnPictures){var _this4=this;var i=0;var prev=-1;var timer=setInterval(function(){if(!_this4.state.paused){if(_this4.video.currentTime>=0.0&&_this4.video.currentTime<_this4.video.duration){var timeInterval=_this4.video.duration/pnPictures.length;i=Math.floor(_this4.video.currentTime/timeInterval);if(prev!==i){_this4.setState({pnPicture:pnPictures[i],imageSrc:pnPictures[i].url,currentWord:pnPictures[i].word,currentIndex:i});}prev=i;}else{_this4.setState({pnPicture:null,imageSrc:"",currentWord:"",currentIndex:-1});}}},100);this.setState({timerInterval:timer});}},{key:'pause',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_pause){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:this.setState({paused:_pause});if(!_pause){_context7.next=6;break;}this.video.pause();this.setState({play:false});_context7.next=9;break;case 6:this.video.play();_context7.next=9;return this.setState({play:true});case 9:case'end':return _context7.stop();}}},_callee7,this);}));function pause(_x3){return _ref7.apply(this,arguments);}return pause;}()},{key:'changeImage',value:function changeImage(index){if(this.state.pnSession.assessmentType===0){var timeInterval=this.video.duration/this.state.pnPictures.length;this.video.currentTime=Math.ceil(index*timeInterval);this.pause(false);}else if(this.state.pnSession.assessmentType===1){var ap=this.state.pnPictures[index];this.setState({pnPicture:ap,imageSrc:ap.url,currentIndex:index,currentWord:ap.word});this.pause(true);}}},{key:'prev',value:function prev(){if(this.state.currentIndex>0){this.changeImage(this.state.currentIndex-1);}}},{key:'next',value:function next(){if(this.state.currentIndex<this.state.pnPictures.length-1){this.changeImage(this.state.currentIndex+1);}else{if(this.state.pnSession.assessmentType===0){this.video.currentTime=this.video.duration;}this.pause(true);}}},{key:'deleteScore',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_29__Shared_DataTrackingPoints__["b" /* default */].PN_SCORE_DELETE,metadata:{testId:this.state.testId}}});case 2:_context8.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].deletePictureNamingScore(this.state.testId).then(function(res){_this5.handleAnalytics();_this5.props.history.goBack();});case 4:case'end':return _context8.stop();}}},_callee8,this);}));function deleteScore(){return _ref8.apply(this,arguments);}return deleteScore;}()},{key:'handleTakeANote',value:function handleTakeANote(){console.log("take a note");this.setState({modalDialogNote:true});}},{key:'handleNoteContentChange',value:function handleNoteContentChange(event){this.setState({noteContent:event.target.value});event.preventDefault();}},{key:'saveNote',value:function saveNote(){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updatePNNote({testId:this.state.testId,note:this.state.noteContent});this.setState({modalDialogNote:false});}},{key:'deleteNote',value:function deleteNote(){this.setState({noteContent:''});__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updatePNNote({testId:this.state.testId,note:''});}},{key:'handleNoteClose',value:function handleNoteClose(){this.setState({modalDialogNote:false});}},{key:'getTarget',value:function getTarget(){this.setState({showStartHint:false});}},{key:'getTarget1',value:function getTarget1(){this.setState({showReScoreHint:false});}},{key:'handleShowHints',value:function handleShowHints(){this.setState({showStartHint:true,showReScoreHint:true,showSaveHint:true});}},{key:'handlePlay',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(!this.state.play){_context9.next=5;break;}this.video.pause();this.setState({play:false});_context9.next=8;break;case 5:this.video.play();_context9.next=8;return this.setState({play:true});case 8:case'end':return _context9.stop();}}},_callee9,this);}));function handlePlay(){return _ref9.apply(this,arguments);}return handlePlay;}()},{key:'handleSurveyBack',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:case'end':return _context10.stop();}}},_callee10,this);}));function handleSurveyBack(){return _ref10.apply(this,arguments);}return handleSurveyBack;}()},{key:'render',value:function render(){var _this6=this;var imageThumbnails=this.state.pnPictures.map(function(pnPic,index){var gradeSrc="";if(pnPic.pn_assessments_picture.grade===1){gradeSrc=__WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png___default.a;}else if(pnPic.pn_assessments_picture.grade===2){gradeSrc=__WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png___default.a;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:index,style:{position:'relative',display:"inline-block",paddingTop:"20px",paddingLeft:"20px",paddingBottom:"20px",paddingRight:"20px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{position:"absolute",top:"10px",width:15,left:"0px",zIndex:2},src:gradeSrc,alt:""}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{position:"relative",top:"0px",left:"0px",zIndex:1,cursor:'pointer'},key:index,onClick:function onClick(){return _this6.changeImage(index);},src:pnPic.url,width:'50',height:'43',alt:pnPic.word}));});console.log(this.props.lastStudent.user);var hideVideo=this.state.pnSession&&this.state.pnSession.assessmentType===1;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Shared_DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:'PNGrading',userId:this.props.user.id,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteScoreConfirm,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["a" /* Modal */],{id:'dialogBox',show:this.state.modalDialogNote},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{paddingTop:0,marginTop:-10,marginBottom:15}},'Make a Note'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{style:{width:500},onChange:this.handleNoteContentChange,value:this.state.noteContent,placeholder:"please enter your note here"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section',style:{marginTop:-40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.deleteNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.saveNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"section bgGrey",style:{paddingTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 noPadding mobileCenter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-5',style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_app_picturenaming_png___default.a,alt:"Picture Naming",style:{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}),' ',this.props.lastStudent.user.firstname,' ',this.props.lastStudent.user.lastname)),hideVideo?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:5,marginTop:9}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,' (1-1 computer task)')):null,hideVideo?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:-220,marginTop:40}},'No Video in the scoring chart'):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-7 tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'descp'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar"},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ModalFormComponents_ReportBugForm__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Shared_DropDownNotifications__["a" /* default */],Object.assign({studentClick:this.handleStudentClick},this.props)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleShowHints,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Show Hints')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{minHeight:"405px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:hideVideo,className:'col-lg-6 col-xs-6 col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"wrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"PictureNamingVidPlay",controls:true,onClick:this.handlePlay,onPause:function onPause(){return _this6.pause(true);},onPlay:function onPlay(){return _this6.pause(false);},playsinline:true,ref:function ref(video){_this6.video=video;},width:'100%',height:'100%'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.state.play?"playpause":"",style:{cursor:'pointer'},onClick:this.handlePlay})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-success btn-controls',hidden:!this.state.paused,onClick:function onClick(){return _this6.pause(false);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_23__assets_images_ico_play_white_png___default.a,height:'20',width:'20',alt:'Play'}),' Play'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-xs btn-blue btn-controls',hidden:this.state.paused,onClick:function onClick(){return _this6.pause(true);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_22__assets_images_ico_pause_white_png___default.a,height:'20',width:'20',alt:'Pause'}),' Pause '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-info btn-controls',onClick:function onClick(){return _this6.prev();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_24__assets_images_ico_prev_white_png___default.a,height:'20',width:'30',alt:'Prev'}),' Prev'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-info btn-controls',onClick:function onClick(){return _this6.next();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_25__assets_images_ico_next_white_png___default.a,height:'20',width:'30',alt:'Next'}),' Next'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-orange btn-controls',onClick:function onClick(){return _this6.changeImage(-1);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_26__assets_images_ico_restart_white_png___default.a,height:'20',width:'20',alt:'Restart'}),' Restart')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:hideVideo?"col-lg-12 tc":"col-lg-6 col-xs-6 col-md-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginBottom:10,position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{height:100,className:this.state.imageSrc===""?"":"",hidden:this.state.imageSrc==="",src:this.state.imageSrc,alt:'PNPicture'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{fontSize:"18pt",textAlign:"left",position:'relative',paddingLeft:10}},this.state.currentWord))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.imageSrc==="",className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-success',onClick:function onClick(){return _this6.gradePNPicture(1);}},'Correct'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-danger',style:{marginLeft:5},onClick:function onClick(){return _this6.gradePNPicture(2);}},'Incorrect'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-info2',style:{marginLeft:5},onClick:function onClick(){return _this6.gradePNPicture(0);}},'Skip')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative',display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showReScoreHint,className:"popoverCustom"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_27__assets_images_modal_x_png___default.a,onClick:this.getTarget1,style:{width:35,paddingRight:5,cursor:"pointer"}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint'))),'                                                        Click an icon to re-score'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showReScoreHint,className:"arrowPointer"})),imageThumbnails)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 paddingTop'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return _this6.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_29__Shared_DataTrackingPoints__["b" /* default */].PN_SCORE_EXIT,metadata:{testId:_this6.state.testId}}});case 2:_this6.handleAnalytics();_this6.props.history.push('../student');case 4:case'end':return _context11.stop();}}},_callee11,_this6);})),className:'handBtn fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Exit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNextTask,className:'handBtn',style:{display:this.state.handleNext?'inline-block':'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Next Task')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleTakeANote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Make a Note')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitPNSessionGrade,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleReset,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Reset')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this6.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TASK?'});},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_Footer__["a" /* default */],null));}}]);return PNGrading;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var actionToProps=function actionToProps(dispatch){return{updateStudent:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["h" /* updateStudent */])(student));case 2:return _context12.abrupt('return',_context12.sent);case 3:case'end':return _context12.stop();}}},_callee12,_this7);}));function updateStudent(_x4){return _ref12.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{lastStudent:state.teacherReducer.student};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,actionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(PNGrading)));

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recordrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lamejs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lamejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lamejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_students_KidSpeak_css__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_students_KidSpeak_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_students_KidSpeak_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LoadingModalComponent_LoadingModal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_rec_gif__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_rec_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_rec_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_video_instructions_png__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_video_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_video_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_InstructionModals__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_device_detect__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Shared_DataTrackingPoints__ = __webpack_require__(17);
var _this16=this;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var sampleRateHz=48000;//44100;
var hasGetUserMedia=false;try{hasGetUserMedia=!!navigator.getUserMedia||!!navigator.mediaDevices.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}catch(err){hasGetUserMedia=!!navigator.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}var kidspeakTest='[{\n\t"id": 371,\n\t"createdAt": "2018-10-29T09:54:43.471Z",\n\t"updatedAt": "2018-10-29T09:54:43.471Z",\n\t"storyStarter": "Frogs live near ponds. They swim in the water. In winter the frogs sleep in the soft mud in the pond. ",\n\t"title": "Frogs in the Pond",\n\t"level": 1,\n\t"version": 21,\n\t"passageType": "E",\n\t"deletedAt": null,\n\t"kidspeak_scores": []\n}]';var bestScor='{\n\t"success": true,\n\t"body": {\n\t\t"id": 6479,\n\t\t"userId": 10020,\n\t\t"createdAt": "2018-12-26T15:02:15.338Z",\n\t\t"updatedAt": "2018-12-26T15:20:52.996Z",\n\t\t"mazeLevel": 1,\n\t\t"mazeScore": 1,\n\t\t"slashLevel": 1,\n\t\t"slashScore": 1,\n\t\t"ksLevel": 1,\n\t\t"ksScore": 1,\n\t\t"pnLevel": 1,\n\t\t"pnScore": 1,\n\t\t"crLevel": 1,\n\t\t"crScore": 1,\n\t\t"wssLevel": 1,\n\t\t"wssScore": 1,\n\t\t"kssLevel": 1,\n\t\t"kssScore": 1,\n\t\t"deletedAt": null\n\t},\n\t"msg": ""\n}';var newSes='{\n\t"passageId": 371,\n\t"AV_FileName": "",\n\t"sessionTime": 0,\n\t"startLevel": 1,\n\t"endLevel": 0,\n\t"startProgress": 1,\n\t"endProgress": 0,\n\t"guid": "5d821dbe-2a2c-43a4-b963-2ec73cc7f735"\n}';var KidSpeakComponent=function(_Component){_inherits(KidSpeakComponent,_Component);function KidSpeakComponent(props){_classCallCheck(this,KidSpeakComponent);var _this=_possibleConstructorReturn(this,(KidSpeakComponent.__proto__||Object.getPrototypeOf(KidSpeakComponent)).call(this,props));_this.handleActive=function(active){_this.setState({active:active});};_this.handleBeginTest=function(){_this.setState({active:3});};_this.state={active:0,loadedScores:false,bestScores:{ksScore:1,ksLevel:1}};return _this;}_createClass(KidSpeakComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);case 2:_context3.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!response.success){_context.next=3;break;}_context.next=3;return _this2.setState({loadedScores:true,bestScores:response.body});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 4:_context3.next=6;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentAppStatus().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var _Helpers$filterApps,allowedApps,filteredApps,finishedApps;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this2.props.updateStudentAppStatus(res.body);case 2:_Helpers$filterApps=__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].filterApps(_this2.props.studentUser,_this2.props.apps),allowedApps=_Helpers$filterApps.allowedApps,filteredApps=_Helpers$filterApps.filteredApps,finishedApps=_Helpers$filterApps.finishedApps;_context2.next=5;return _this2.props.updateAppStates({allowedApps:allowedApps,filteredApps:filteredApps,finishedApps:finishedApps});case 5:_context2.next=7;return _this2.setState({bestScores:res.body.bestScores});case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}());case 6:if(this.props.apps.kidSpeakScores.filter(function(x){return x.gradingDate==null;}).length>3){this.props.history.goBack();}case 7:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.state.active!==2?"bgGrey KidSpeak":"bgYellow KidSpeak"},this.state.active===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer kidspeak'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'KidSpeak'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 text-center"},this.state.loadedScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ProgressModalComponent_ProgressBox__["a" /* default */],{appName:"kidspeak",level:this.state.bestScores.ksLevel,step:this.state.bestScores.ksScore,steps:3,maxLevel:12,noDescription:true}):null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["a" /* Buttons */],{appName:"kidspeak",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["b" /* Buttons1 */],{demo:true,appName:"kidspeak",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer kidspeak'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'KidSpeak: Show Me'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["g" /* VideoComponent */],{appName:"kidspeak",url:"https://s3.us-east-2.amazonaws.com/uploaddev/video/kidspeak/Kidspeakgirl2.mp4"})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["a" /* Buttons */],{appName:"kidspeak",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["b" /* Buttons1 */],{practice:true,appName:"kidspeak",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tutorial,{studentUser:this.props.studentUser,buttonClick:this.handleActive,beginTest:this.handleBeginTest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["a" /* Buttons */],{appName:"kidspeak",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["b" /* Buttons1 */],{appName:"kidspeak",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(KidSpeak,{studentUser:this.props.studentUser,buttonClick:this.handleActive,practice:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["a" /* Buttons */],{appName:"kidspeak",buttonClick:this.handleActive,currentTabActive:this.state.active})):null);}}]);return KidSpeakComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var KidSpeak=function(_Component2){_inherits(KidSpeak,_Component2);function KidSpeak(props){var _this4=this;_classCallCheck(this,KidSpeak);var _this3=_possibleConstructorReturn(this,(KidSpeak.__proto__||Object.getPrototypeOf(KidSpeak)).call(this,props));_this3.handleToggleInstruction=function(toggleInstruction){localStorage.setItem('KidspeakInstruction',toggleInstruction);};_this3.captureUserMedia=function(callback,options){var params=null;if(options){params=options;}else{params={audio:true,video:false};}navigator.mediaDevices.getUserMedia(params).then(callback).catch(function(error){console.log(error);_this3.setState({modalDialog:true,responseContent:'No microphone has been found!',noMicroPhone:true});});};_this3.handleStartKidSpeak=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!_this3.props.practice){_context5.next=17;break;}if(!((typeof newSes==='undefined'?'undefined':_typeof(newSes))!=='object'&&newSes!==null)){_context5.next=5;break;}_context5.next=4;return JSON.parse(newSes);case 4:newSes=_context5.sent;case 5:if(!((typeof bestScor==='undefined'?'undefined':_typeof(bestScor))!=='object'&&bestScor!==null)){_context5.next=9;break;}_context5.next=8;return JSON.parse(bestScor);case 8:bestScor=_context5.sent;case 9:if(!((typeof kidspeakTest==='undefined'?'undefined':_typeof(kidspeakTest))!=='object'&&kidspeakTest!==null)){_context5.next=13;break;}_context5.next=12;return JSON.parse(kidspeakTest);case 12:kidspeakTest=_context5.sent;case 13:_context5.next=15;return _this3.setState({bestScores:bestScor.body,sessionData:newSes,ksPassageSrc:kidspeakTest[0].storyStarter,ksPassageTitle:kidspeakTest[0].title,currentStoryStarter:kidspeakTest[0]});case 15:_context5.next=19;break;case 17:_context5.next=19;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getKSRandom().then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(res){var storyStarters,bestScores,newSesh;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:storyStarters=res.body;_context4.next=3;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores();case 3:bestScores=_context4.sent;newSesh=_this3.state.sessionData;newSesh.startLevel=bestScores.body.ksLevel;newSesh.startProgress=bestScores.body.ksScore;newSesh.passageId=storyStarters[0].id;_this3.setState({bestScores:bestScores.body,sessionData:newSesh,ksPassageSrc:storyStarters[0].storyStarter,ksPassageTitle:storyStarters[0].title,currentStoryStarter:storyStarters[0]});case 9:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x3){return _ref5.apply(this,arguments);};}()).catch(function(err){console.log(err);});case 19:case'end':return _context5.stop();}}},_callee5,_this4);}));_this3.state={popupSurvey:false,isUploading:false,timerInterval:null,timerTime:60,countdown:-1,bestScores:null,countDownTimer:null,audioTimeout:null,rejectedReason:'',recording:false,ksPassageSrc:"",recordingAudioPlayCount:0,recordingsCount:0,audioSrc:false,audioBlob:false,recordAudio:null,modalDialog:false,modalInstruction:false,responseContent:'',upTime:null,disableSubmit:false,noMicroPhone:false,analytics:{type:null,metadata:null},testMode:false,osName:"",sampleRateHz:0,sessionData:{passageId:0,AV_FileName:"",sessionTime:0,startLevel:0,endLevel:0,startProgress:0,endProgress:0,guid:__webpack_require__(68)()}};_this3.handleSurveyBack=_this3.handleSurveyBack.bind(_this3);_this3.handleStartKidSpeak=_this3.handleStartKidSpeak.bind(_this3);_this3.handleStop=_this3.handleStop.bind(_this3);_this3.uploadAudio=_this3.uploadAudio.bind(_this3);_this3.requestUserMedia=_this3.requestUserMedia.bind(_this3);_this3.startRecord=_this3.startRecord.bind(_this3);_this3.stopRecord=_this3.stopRecord.bind(_this3);_this3.handleBackToMenu=_this3.handleBackToMenu.bind(_this3);_this3.submitSession=_this3.submitSession.bind(_this3);_this3.handleRecordStart=_this3.handleRecordStart.bind(_this3);_this3.recordingAudioPlay=_this3.recordingAudioPlay.bind(_this3);_this3.onUnload=_this3.onUnload.bind(_this3);_this3.handleToggleInstruction=_this3.handleToggleInstruction.bind(_this3);_this3.startTimer=_this3.startTimer.bind(_this3);_this3.countDown=_this3.countDown.bind(_this3);_this3.handleAnalytics=_this3.handleAnalytics.bind(_this3);return _this3;}_createClass(KidSpeak,[{key:'onUnload',value:function onUnload(event){// the method that will be used for both add and remove event
event.returnValue="By leaving or reloading the page you will lose your app progress";}},{key:'componentDidMount',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:window.addEventListener("beforeunload",this.onUnload);__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);__WEBPACK_IMPORTED_MODULE_20_react_device_detect__["osName"]==="Mac OS"||__WEBPACK_IMPORTED_MODULE_20_react_device_detect__["osName"]==="iOS"?sampleRateHz=48000:sampleRateHz=44100;console.log("OS NAME: "+__WEBPACK_IMPORTED_MODULE_20_react_device_detect__["osName"]);console.log("sampel rate HZ: "+sampleRateHz);this.setState({osName:__WEBPACK_IMPORTED_MODULE_20_react_device_detect__["osName"]});if(hasGetUserMedia){_context6.next=9;break;}this.setState({modalDialog:true,responseContent:!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform)&&(navigator.userAgent.match('CriOS')||navigator.userAgent.match('Mozilla'))?'Please use Safari (above version 11) for this task.':'Your browser cannot stream from your webcam. Please switch to Chrome or FireFox.'});return _context6.abrupt('return');case 9:this.requestUserMedia();this.handleStartKidSpeak();_context6.next=13;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_21__Shared_DataTrackingPoints__["b" /* default */].STUDENT_KS_START,metadata:{platform:navigator.platform,userAgent:navigator.userAgent}}});case 13:this.handleAnalytics();case 14:case'end':return _context6.stop();}}},_callee6,this);}));function componentDidMount(){return _ref6.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("beforeunload",this.onUnload);if(this.state.recording){this.state.recordAudio.stop();Object(__WEBPACK_IMPORTED_MODULE_17_timers__["clearInterval"])(this.state.countDownTimer);clearTimeout(this.state.audioTimeout);Object(__WEBPACK_IMPORTED_MODULE_17_timers__["clearInterval"])(this.state.timerInterval);this.captureUserMedia(function(stream){stream.stop();});}}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleBackToMenu',value:function handleBackToMenu(e){this.props.history.goBack();}},{key:'requestUserMedia',value:function requestUserMedia(){var _this5=this;this.captureUserMedia(function(stream){_this5.setStreamToAudio(stream);});}},{key:'handleStop',value:function handleStop(blob){this.setState({recording:false,audioTimeout:null});this.releaseStreamFromAudio();this.uploadAudio(blob instanceof Blob,blob);}},{key:'encodeMono',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(channels,sampleRate,samples){var kbps,mp3encoder,sampleBlockSize,mp3Data,i,sampleChunk,_mp3buf,mp3buf,blob;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:kbps=256;//encode 128kbps mp3
mp3encoder=new __WEBPACK_IMPORTED_MODULE_8_lamejs___default.a.Mp3Encoder(channels,sampleRate,kbps);sampleBlockSize=1152;//can be anything but make it a multiple of 576 to make encoders life easier
mp3Data=[];for(i=0;i<samples.length;i+=sampleBlockSize){sampleChunk=samples.subarray(i,i+sampleBlockSize);_mp3buf=mp3encoder.encodeBuffer(sampleChunk);if(_mp3buf.length>0){mp3Data.push(_mp3buf);}}mp3buf=mp3encoder.flush();//finish writing mp3
if(mp3buf.length>0){mp3Data.push(new Int8Array(mp3buf));}blob=new Blob(mp3Data,{type:'audio/mp3'});_context7.next=10;return this.setState({audioBlob:blob});case 10:this.handleStop(blob);case 11:case'end':return _context7.stop();}}},_callee7,this);}));function encodeMono(_x4,_x5,_x6){return _ref7.apply(this,arguments);}return encodeMono;}()},{key:'setStreamToAudio',value:function setStreamToAudio(stream){this.audio.srcObject=stream;}},{key:'releaseStreamFromAudio',value:function releaseStreamFromAudio(){this.audio.pause();this.audio.srcObject=null;this.audio.src="";this.audio.load();}},{key:'startRecordAudio',value:function startRecordAudio(){var _this6=this;this.captureUserMedia(function(stream){console.log("start record sample rate HZ:"+sampleRateHz);_this6.setState({sampleRateHz:sampleRateHz});var options={type:'audio',audio:_this6.audio,sampleRate:sampleRateHz,bufferSize:4096,numberOfAudioChannels:1,recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder};_this6.setState({recordAudio:new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder(stream,options)});_this6.state.recordAudio.record();_this6.handleStartAudio(stream);},{audio:true,video:false});}},{key:'handleStopAudio',value:function handleStopAudio(wavBlob){var _this7=this;this.setState({recording:false});var fileReader=new FileReader();fileReader.onload=function(event){var arrayBuffer=event.target.result;var wav=__WEBPACK_IMPORTED_MODULE_8_lamejs___default.a.WavHeader.readHeader(new DataView(arrayBuffer));var samples=new Int16Array(arrayBuffer,wav.dataOffset,wav.dataLen/2);_this7.encodeMono(wav.channels,wav.sampleRate,samples);_this7.releaseStreamFromAudio();};fileReader.readAsArrayBuffer(wavBlob);}},{key:'handleStartAudio',value:function handleStartAudio(stream){var _this8=this;var timerInterval=Object(__WEBPACK_IMPORTED_MODULE_17_timers__["setInterval"])(function(){if(_this8.state.timerTime>0){_this8.setState({timerTime:_this8.state.timerTime-1});}else{Object(__WEBPACK_IMPORTED_MODULE_17_timers__["clearInterval"])(_this8.state.timerInterval);_this8.setState({timerInterval:null});}},1000);var timeoutTimer=setTimeout(function(){_this8.stopRecord();},1000*60);this.setStreamToAudio(stream);this.setState({recording:true,audioTimeout:timeoutTimer,timerInterval:timerInterval,timerTime:60});}},{key:'stopRecordAudio',value:function stopRecordAudio(){var _this9=this;this.state.recordAudio.stop(function(wavBlob){_this9.handleStopAudio(wavBlob);});}},{key:'uploadAudio',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(isBlob,blob){var _this10=this;var vidETA;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].calculateETA(null,blob);case 2:vidETA=_context9.sent;this.setState({upTime:vidETA});_context9.next=6;return this.startTimer();case 6:_context9.next=8;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].uploadKSAudio(blob).then(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_this10.audio2.src=__WEBPACK_IMPORTED_MODULE_7__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_context8.next=3;return _this10.setState({audioSrc:_this10.audio2.src,recordingsCount:_this10.state.recordingsCount+1,isUploading:false});case 3:_this10.audio2.load();if(_this10.state.recordingsCount>1){_this10.submitSession();}window.removeEventListener("beforeunload",_this10.onUnload);case 6:case'end':return _context8.stop();}}},_callee8,_this10);}));return function(_x9){return _ref9.apply(this,arguments);};}()).catch(function(error){console.log(error);});case 8:case'end':return _context9.stop();}}},_callee9,this);}));function uploadAudio(_x7,_x8){return _ref8.apply(this,arguments);}return uploadAudio;}()},{key:'submitSession',value:function submitSession(){var _this11=this;this.setState({disableSubmit:true});var seshData=this.state.sessionData;seshData.AV_FileName=this.state.audioSrc.replace(__WEBPACK_IMPORTED_MODULE_7__Shared_Consts__["b" /* BUCKET_URL */],"");seshData.sessionTime=60-this.state.timerTime;if(!this.props.practice){window.removeEventListener("beforeunload",this.onUnload);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].insertKSSession(seshData).then(function(res){_this11.setState({modalDialog:true,responseContent:'Data Successfully Saved and Submitted'});//setTimeout(()=>{this.setState({modalDialog:false, popupSurvey: true}); },2500);
});}}},{key:'handleSurveyBack',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0://window.location.reload();
this.props.buttonClick(0);case 1:case'end':return _context10.stop();}}},_callee10,this);}));function handleSurveyBack(){return _ref10.apply(this,arguments);}return handleSurveyBack;}()},{key:'startTimer',value:function startTimer(){this.timer=Object(__WEBPACK_IMPORTED_MODULE_17_timers__["setInterval"])(this.countDown,1000);}},{key:'countDown',value:function countDown(){var seconds=this.state.upTime-1;this.setState({upTime:seconds});if(seconds<=0){Object(__WEBPACK_IMPORTED_MODULE_17_timers__["clearInterval"])(this.timer);}}},{key:'handleRecordStart',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){var _this12=this;var countDownTimer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:if(!(this.state.recordingsCount<=1)){_context12.next=6;break;}_context12.next=3;return this.setState({countdown:3});case 3:countDownTimer=Object(__WEBPACK_IMPORTED_MODULE_17_timers__["setInterval"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return _this12.setState({countdown:_this12.state.countdown-1});case 2:if(_this12.state.countdown<0){Object(__WEBPACK_IMPORTED_MODULE_17_timers__["clearInterval"])(countDownTimer);_this12.startRecord();}case 3:case'end':return _context11.stop();}}},_callee11,_this12);})),1000);_context12.next=6;return this.setState({countDownTimer:countDownTimer});case 6:case'end':return _context12.stop();}}},_callee12,this);}));function handleRecordStart(){return _ref11.apply(this,arguments);}return handleRecordStart;}()},{key:'stopRecord',value:function stopRecord(){var _this13=this;if(this.props.practice){this.setState({modalDialog:true,responseContent:'Practice Finished'});setTimeout(function(){_this13.setState({modalDialog:false});_this13.props.buttonClick(0);},2500);}else{clearTimeout(this.state.audioTimeout);Object(__WEBPACK_IMPORTED_MODULE_17_timers__["clearInterval"])(this.state.timerInterval);this.stopRecordAudio();this.setState({recording:false,isUploading:true});}}},{key:'startRecord',value:function startRecord(){this.startRecordAudio();this.setState({recording:true});}},{key:'recordingAudioPlay',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return this.setState({recordingAudioPlayCount:this.state.recordingAudioPlayCount+1});case 2:this.audio2.play();case 3:case'end':return _context13.stop();}}},_callee13,this);}));function recordingAudioPlay(){return _ref13.apply(this,arguments);}return recordingAudioPlay;}()},{key:'render',value:function render(){var _this14=this;var countDown=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.countdown<=0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{fontSize:"128pt"}},this.state.countdown));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.practice?"appSection bgGrey":"appSection bgYellow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},!this.props.practice?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Shared_InstructionModals__["a" /* default */],{Kidspeak:true,modalOpen:this.state.modalInstruction,instructionMask:__WEBPACK_IMPORTED_MODULE_15__assets_images_video_instructions_png___default.a,toggleInstruction:this.handleToggleInstruction,closeClick:function closeClick(active){_this14.setState({modalInstruction:active});}}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){if(_this14.state.noMicroPhone){window.location.reload();}else{_this14.setState({modalDialog:active,popupSurvey:true});}}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer kidspeak'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shared_DialogBox__["a" /* default */],{surveyModal:true,app:'KidSpeak',userId:this.props.studentUser.id,active:this.state.popupSurvey,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:"text-center"},this.state.ksPassageTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer kidspeak passage'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.ksPassageSrc),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row text-center",style:{paddingTop:"30px"}},countDown,this.state.recording?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rec',style:{position:'relative',top:-20,fontSize:24}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_rec_gif___default.a,className:'ico-xs'}),' RECORDING '):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{ref:function ref(audio){_this14.audio=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{hidden:this.state.recording,controls:true,ref:function ref(audio2){_this14.audio2=audio2;},onPlay:function onPlay(){return _this14.recordingAudioPlay();}})),this.state.testMode?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row text-center"},'OS Name: ',this.state.osName,' | Sample Rate HZ: ',this.state.sampleRateHz):null)))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-6 col-sm-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.recordingsCount<1&&!this.state.recording?"handBtn ":"hidden",onClick:this.handleRecordStart},this.state.recordingsCount===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Record'):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.recording?"handBtn ":"hidden",onClick:this.stopRecord},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Stop')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.audioSrc?"handBtn ":"hidden",onClick:!this.state.disableSubmit?this.submitSession:null},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Finish')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3 col-sm-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fr',style:{display:'-webkit-box'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Common__["c" /* CountDownComponent */],{time:this.state.timerTime,sessionTime:60,showTime:10}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LoadingModalComponent_LoadingModal__["a" /* default */],{timer:true,upTime:this.state.upTime,isUploading:this.state.isUploading}));}}]);return KidSpeak;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Tutorial=function(_Component3){_inherits(Tutorial,_Component3);function Tutorial(props){_classCallCheck(this,Tutorial);return _possibleConstructorReturn(this,(Tutorial.__proto__||Object.getPrototypeOf(Tutorial)).call(this,props));}_createClass(Tutorial,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(KidSpeak,{studentUser:this.props.studentUser,buttonClick:this.props.buttonClick,practice:true});}}]);return Tutorial;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context14.abrupt('return',_context14.sent);case 3:case'end':return _context14.stop();}}},_callee14,_this16);}));function updateStudentAppStatus(_x10){return _ref14.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context15.abrupt('return',_context15.sent);case 3:case'end':return _context15.stop();}}},_callee15,_this16);}));function updateStudentAccountTab(_x11){return _ref15.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["a" /* updateAppStates */])(appStates));case 2:return _context16.abrupt('return',_context16.sent);case 3:case'end':return _context16.stop();}}},_callee16,_this16);}));function updateAppStates(_x12){return _ref16.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_19_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(KidSpeakComponent)));

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_style_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_DropDownNotifications__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ModalFormComponents_ReportBugForm__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_modal_x_png__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_modal_x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_modal_x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__ = __webpack_require__(20);
var _this7=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KSGrading=function(_Component){_inherits(KSGrading,_Component);function KSGrading(props){var _this2=this;_classCallCheck(this,KSGrading);var _this=_possibleConstructorReturn(this,(KSGrading.__proto__||Object.getPrototypeOf(KSGrading)).call(this,props));_this.keypress=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(e.which===32){_this.pausePlay();}e.stopImmediatePropagation();case 2:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.submitKSSessionGrade=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var gradingData,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:gradingData="";for(i=0;i<_this.state.paragraphs.length;i++){if(_this.state.paragraphs[i].alt===""){gradingData=gradingData+"0";}else if(_this.state.paragraphs[i].alt==="wrong"){gradingData=gradingData+"2";}else{gradingData=gradingData+"1";}if(i!==_this.state.paragraphs.length-1){gradingData=gradingData+",";}}_context3.next=4;return _this.setState({sessionData:{testId:_this.state.testId,gradingData:gradingData,gradingTime:Math.ceil((Date.now()-_this.state.gradeStart)/1000),numberCorrect:_this.state.correct,numberIncorrect:_this.state.incorrect}});case 4:console.log("Submitting session data: ",_this.state.sessionData);_context3.next=7;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].gradeKSSession(_this.state.sessionData).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.updateKSBestScore();case 2:_this.setState({modalDialog:true,responseContent:'Score task saved.',analytics:{type:__WEBPACK_IMPORTED_MODULE_17__Shared_DataTrackingPoints__["b" /* default */].KS_SCORE_SAVE,metadata:{testId:_this.state.testId}}});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}()).catch(function(err){console.log(err);});case 7:_this.handleAnalytics();case 8:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.startGrading=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(testId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getKSSession(testId).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(res){var ksSession,bestScores,fileurl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:ksSession=res.body;if(!ksSession){_context4.next=15;break;}_context4.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentBestScores(ksSession.userId);case 4:bestScores=_context4.sent;fileurl=ksSession.AV_FileName.indexOf("kidspeak")>-1?__WEBPACK_IMPORTED_MODULE_5__Shared_Consts__["b" /* BUCKET_URL */]+ksSession.AV_FileName:__WEBPACK_IMPORTED_MODULE_5__Shared_Consts__["b" /* BUCKET_URL */]+"audio/kidspeak/"+ksSession.AV_FileName;_context4.next=8;return _this.setState({bestScores:bestScores.body,ksSession:ksSession,storyStarter:ksSession.kidspeak_content,noteContent:ksSession.note,audioSrc:fileurl,sessionData:{gradingData:ksSession.gradingData}});case 8:_context4.next=10;return _this.initializeData(ksSession.gradingData);case 10:_this.audio.src=fileurl;_this.audio.load();_this.audio.addEventListener('loadedmetadata',function(){console.log(_this);var mins=parseInt(_this.audio.duration/60);var secs=parseInt(_this.audio.duration%60);if(secs<=9){secs="0"+secs;}_this.setState({duration:mins+':'+secs});});_context4.next=17;break;case 15:_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 17:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref5.apply(this,arguments);};}()).catch(function(error){console.log(error);});case 2:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x3){return _ref4.apply(this,arguments);};}();_this.deleteScoreConfirm=function(confirm){if(confirm){_this.deleteScore();}_this.setState({modalDialogDelete:false});};_this.handleStudentClick=function(student,classId){_this.props.updateStudent(student);_this.props.history.push('/teacher/student');};_this.state={bestScores:null,gradeStart:null,audioSrc:"",audioBlob:false,storyStarter:{},currentTime:"0.00",duration:"0.00",endIndex:0,score:0,correct:0,incorrect:0,paragraphs:[],highlighted:-1,timer:null,progressBar:{width:null},playButton:{backgroundImage:null},playButtonHover:null,playButtonLeave:null,ksSession:null,modalDialog:false,responseContent:'',modalDialogDelete:false,modalDialogNote:false,noteContent:'',handleNext:false,taskID:null,showPlayHint:false,showClickWrongHint:false,showClickLastHint:false,showClickSingleHint:false,showClickDoubleHint:false,showSaveHint:false,sessionData:{testId:0,gradingData:"",gradingTime:0,numberCorrect:0,numberIncorrect:0},analytics:{type:null,metadata:null}};_this.startGrading=_this.startGrading.bind(_this);_this.submitKSSessionGrade=_this.submitKSSessionGrade.bind(_this);_this.initializeData=_this.initializeData.bind(_this);_this.calculateScore=_this.calculateScore.bind(_this);_this.mouseClick=_this.mouseClick.bind(_this);_this.mouseDblClick=_this.mouseDblClick.bind(_this);_this.wrongTickMark=_this.wrongTickMark.bind(_this);_this.correctTickMark=_this.correctTickMark.bind(_this);_this.fillWithChecks=_this.fillWithChecks.bind(_this);_this.clearCounters=_this.clearCounters.bind(_this);_this.pausePlay=_this.pausePlay.bind(_this);_this.clickedBar=_this.clickedBar.bind(_this);_this.update=_this.update.bind(_this);_this.updateKSBestScore=_this.updateKSBestScore.bind(_this);_this.deleteScore=_this.deleteScore.bind(_this);_this.handleTakeANote=_this.handleTakeANote.bind(_this);_this.saveNote=_this.saveNote.bind(_this);_this.deleteNote=_this.deleteNote.bind(_this);_this.handleNoteClose=_this.handleNoteClose.bind(_this);_this.handleNoteContentChange=_this.handleNoteContentChange.bind(_this);_this.keyDownListener=_this.keypress.bind(_this);_this.handleStudentClick=_this.handleStudentClick.bind(_this);_this.handleNextTask=_this.handleNextTask.bind(_this);_this.getTarget=_this.getTarget.bind(_this);_this.getTarget1=_this.getTarget1.bind(_this);_this.getTarget2=_this.getTarget2.bind(_this);_this.getTarget3=_this.getTarget3.bind(_this);_this.getTarget4=_this.getTarget4.bind(_this);_this.getTarget5=_this.getTarget5.bind(_this);_this.handleShowHints=_this.handleShowHints.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(KSGrading,[{key:'componentDidMount',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _this3=this;var parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:__WEBPACK_IMPORTED_MODULE_4__Shared_Helpers__["a" /* default */].authorize(this);parsed=__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.parse(this.props.location.search);_context6.next=4;return this.setState({testId:parsed.testId,gradeStart:Date.now(),analytics:{type:__WEBPACK_IMPORTED_MODULE_17__Shared_DataTrackingPoints__["b" /* default */].KS_SCORE_VIEW,metadata:{testId:parsed.testId}}});case 4:this.startGrading(parsed.testId);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentNotifications().then(function(res){for(var i=0;i<res.body.length;i++){for(var j=0;j<res.body[i].apps.kidSpeakScores.length;j++){var kidSpeakScores=res.body[i].apps.kidSpeakScores[j];if(kidSpeakScores&&kidSpeakScores.userId===_this3.props.lastStudent.user.id&&kidSpeakScores.id!=parsed.testId){_this3.setState({handleNext:true,taskID:kidSpeakScores.id});}}}});this.handleAnalytics();document.addEventListener("keydown",this.keyDownListener);case 8:case'end':return _context6.stop();}}},_callee6,this);}));function componentDidMount(){return _ref6.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.state.timer);document.removeEventListener("keydown",this.keyDownListener);}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleNextTask',value:function handleNextTask(){window.location.href='/teacher/apps/ks-grading?testId='+this.state.taskID;}// Event handler for keypress events
},{key:'updateKSBestScore',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var newProgress,newLevel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!(this.state.bestScores.ksLevel===this.state.ksSession.startLevel// && this.state.bestScores.ksScore === this.state.ksSession.startProgress
)){_context7.next=9;break;}newProgress=this.state.bestScores.ksScore;newLevel=this.state.bestScores.ksLevel;if(this.state.bestScores.ksLevel===1){if(this.state.sessionData.numberCorrect>=1){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===2){if(this.state.sessionData.numberCorrect>=29){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===3){if(this.state.sessionData.numberCorrect>=50){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===4){if(this.state.sessionData.numberCorrect>=84){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===5){if(this.state.sessionData.numberCorrect>=100){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===6){if(this.state.sessionData.numberCorrect>=103){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===7){if(this.state.sessionData.numberCorrect>=112){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===8){if(this.state.sessionData.numberCorrect>=120){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===9){if(this.state.sessionData.numberCorrect>=132){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===10){if(this.state.sessionData.numberCorrect>=133){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===11){if(this.state.sessionData.numberCorrect>=140){newProgress++;}else{newProgress--;}}else if(this.state.bestScores.ksLevel===12){if(this.state.sessionData.numberCorrect>=142){newProgress++;}else{newProgress--;}}if(newProgress>3&&newLevel<=12){newLevel++;newProgress=1;}else if(newProgress===0){newProgress=1;}_context7.next=7;return this.setState({bestScores:Object.assign({},this.state.bestScores,{ksLevel:newLevel,ksScore:newProgress})});case 7:_context7.next=9;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateKSBestScore(this.state.bestScores);case 9:case'end':return _context7.stop();}}},_callee7,this);}));function updateKSBestScore(){return _ref7.apply(this,arguments);}return updateKSBestScore;}()},{key:'wrongTickMark',// functions to add tick icons
value:function wrongTickMark(index){this.state.paragraphs[index].src=__webpack_require__(207);this.state.paragraphs[index].alt="wrong";this.state.incorrect=this.state.incorrect+1;this.forceUpdate();}},{key:'correctTickMark',value:function correctTickMark(index){this.state.paragraphs[index].src=__webpack_require__(93);this.state.paragraphs[index].alt="correct";this.state.correct=this.state.correct+1;this.forceUpdate();}},{key:'removeMark',value:function removeMark(index){var imgAlt=this.state.paragraphs[index].alt;if(imgAlt==="correct"){this.state.correct=this.state.correct-1;this.state.paragraphs[index].src="";this.state.paragraphs[index].alt="";}else if(imgAlt==="wrong"){this.state.incorrect=this.state.incorrect-1;this.state.paragraphs[index].src="";this.state.paragraphs[index].alt="";}this.forceUpdate();return imgAlt;}},{key:'swapMark',value:function swapMark(index){var oldImgAlt=this.removeMark(index);if(oldImgAlt==="correct"){this.wrongTickMark(index);}else if(oldImgAlt==="wrong"){this.correctTickMark(index);}}},{key:'calculateScore',value:function calculateScore(){var newScore=parseInt(this.state.correct,10)-parseInt(this.state.incorrect,10);if(newScore<=0){this.state.score=0;}else{this.state.score=newScore;}this.forceUpdate();}},{key:'clearCounters',value:function clearCounters(){//$("#data img").remove();
this.setState({endIndex:0,score:0,correct:0,incorrect:0,highlighted:-1});this.state.paragraphs.map(function(paragraph,i){paragraph.src="";paragraph.alt="";paragraph.highlighted=false;});this.forceUpdate();}},{key:'mouseClick',value:function mouseClick(i){this.state.paragraphs[i].highlighted=false;var imgAlt=this.state.paragraphs[i].alt;if(imgAlt===""){this.wrongTickMark(i);if(i>this.state.endIndex){this.state.endIndex=i;}}else{this.swapMark(i);}this.calculateScore();}},{key:'mouseDblClick',value:function mouseDblClick(i){var oldImgAlt=this.removeMark(i);if(oldImgAlt!==""&&i===this.state.endIndex){var o=this.state.endIndex;var imgAlt=void 0;while(o>0&&imgAlt===undefined){o--;imgAlt=this.state.paragraphs[o].alt;}this.state.endIndex=i;}this.forceUpdate();this.calculateScore();}},{key:'fillWithChecks',value:function fillWithChecks(){var imgAlt=void 0;for(var i=0;i<this.state.endIndex;i++){imgAlt=this.state.paragraphs[i].alt;if(imgAlt===""){this.correctTickMark(i);}}this.calculateScore();}},{key:'initializeData',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var csv,tickArr,text,wordArr,i,word,newPar;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:csv=this.state.sessionData.gradingData;tickArr=[];if(csv){tickArr=csv.split(",");}text=this.state.storyStarter.storyStarter;// Trim out new lines
text=text.trim();// Convert text to word array by splitting at spaces
wordArr=text.split(/\s+/);// Ensures the tick array has its
// length equal to the word count
while(tickArr.length>wordArr.length){tickArr.pop();}while(tickArr.length<wordArr.length){tickArr.push("0");}// Create elements for each word and appends to container in order
i=0;case 9:if(!(i<wordArr.length)){_context8.next=27;break;}word=wordArr[i];newPar={index:i,word:word,src:"",alt:"",highlighted:false};_context8.next=14;return this.setState({paragraphs:[].concat(_toConsumableArray(this.state.paragraphs),[newPar])});case 14:if(!(tickArr[i]==="1")){_context8.next=20;break;}_context8.next=17;return this.correctTickMark(i);case 17:this.state.endIndex=i;_context8.next=24;break;case 20:if(!(tickArr[i]==="2")){_context8.next=24;break;}_context8.next=23;return this.wrongTickMark(i);case 23:this.state.endIndex=i;case 24:i++;_context8.next=9;break;case 27:// Calculates initial score
this.forceUpdate();this.calculateScore();// Display the total word count
this.state.totalWords=wordArr.length;this.forceUpdate();case 31:case'end':return _context8.stop();}}},_callee8,this);}));function initializeData(){return _ref8.apply(this,arguments);}return initializeData;}()},{key:'pausePlay',//function to pause and play
value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var _this4=this;var playButtonHover,playButtonLeave,_playButtonHover,_playButtonLeave,timer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(!(!this.audio.paused&&!this.audio.ended)){_context9.next=8;break;}this.audio.pause();playButtonHover=function playButtonHover(){_this4.setState({playButton:{backgroundImage:'url('+__webpack_require__(382)+')'}});};playButtonLeave=function playButtonLeave(){_this4.setState({playButton:{backgroundImage:'url('+__webpack_require__(381)+')'}});};//stop timer
window.clearInterval(this.state.timer);this.setState({timer:null,playButton:{backgroundImage:'url('+__webpack_require__(382)+')'},playButtonHover:playButtonHover,playButtonLeave:playButtonLeave});_context9.next=16;break;case 8://this.audio.playbackRate = 1;
this.audio.play();_context9.next=11;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_17__Shared_DataTrackingPoints__["b" /* default */].KS_SCORE_PLAY,metadata:{testId:this.state.testId}}});case 11:this.handleAnalytics();_playButtonHover=function _playButtonHover(){_this4.setState({playButton:{backgroundImage:'url('+__webpack_require__(383)+')'}});};_playButtonLeave=function _playButtonLeave(){_this4.setState({playButton:{backgroundImage:'url('+__webpack_require__(847)+')'}});};//timer to update the current time
timer=setInterval(this.update,500);this.setState({timer:timer,playButton:{backgroundImage:'url('+__webpack_require__(383)+')'},playButtonHover:_playButtonHover,playButtonLeave:_playButtonLeave});case 16:case'end':return _context9.stop();}}},_callee9,this);}));function pausePlay(){return _ref9.apply(this,arguments);}return pausePlay;}()},{key:'update',//function update currentTime
value:function update(){if(!this.audio.ended){var playedMins=parseInt(this.audio.currentTime/60);var playedSecs=parseInt(this.audio.currentTime%60);var barSize=this.defaultBar.offsetWidth;//ensure secs is in double digits
if(playedSecs<=9){playedSecs="0"+playedSecs;}var size=parseInt(this.audio.currentTime*barSize/this.audio.duration);this.setState({currentTime:playedMins+':'+playedSecs,progressBar:{width:size.toString()+"px"}});}else{//reset the current time and change pause to play button
window.clearInterval(this.state.timer);//stop timer
this.setState({currentTime:"0:00",playButton:{backgroundImage:'url('+__webpack_require__(381)+')'},progressBar:{width:"0px"}});}}},{key:'clickedBar',value:function clickedBar(e){if(!this.audio.ended){var parentX=this.defaultBar.getBoundingClientRect().left;var width=e.pageX-parentX;var newtime=width/this.defaultBar.offsetWidth*this.audio.duration;console.log(newtime);this.audio.currentTime=newtime;//progressBar.style.width = width+"px";
this.update();}}},{key:'deleteScore',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_17__Shared_DataTrackingPoints__["b" /* default */].KS_SCORE_DELETE,metadata:{testId:this.state.testId}}});case 2:_context10.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].deleteKidSpeakScore(this.state.testId).then(function(res){_this5.handleAnalytics();_this5.props.history.goBack();});case 4:case'end':return _context10.stop();}}},_callee10,this);}));function deleteScore(){return _ref10.apply(this,arguments);}return deleteScore;}()},{key:'handleTakeANote',value:function handleTakeANote(){console.log("take a note");this.setState({modalDialogNote:true});}},{key:'handleNoteContentChange',value:function handleNoteContentChange(event){this.setState({noteContent:event.target.value});event.preventDefault();}},{key:'saveNote',value:function saveNote(){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateKidSpeakNote({testId:this.state.testId,note:this.state.noteContent});this.setState({modalDialogNote:false});}},{key:'deleteNote',value:function deleteNote(){this.setState({noteContent:''});__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateKidSpeakNote({testId:this.state.testId,note:''});}},{key:'handleNoteClose',value:function handleNoteClose(){this.setState({modalDialogNote:false});}},{key:'getTarget',value:function getTarget(){this.setState({showPlayHint:false});}},{key:'getTarget1',value:function getTarget1(){this.setState({showClickWrongHint:false});}},{key:'getTarget2',value:function getTarget2(){this.setState({showClickLastHint:false});}},{key:'getTarget3',value:function getTarget3(){this.setState({showClickSingleHint:false});}},{key:'getTarget4',value:function getTarget4(){this.setState({showClickDoubleHint:false});}},{key:'getTarget5',value:function getTarget5(){this.setState({showSaveHint:false});}},{key:'handleShowHints',value:function handleShowHints(){this.setState({showPlayHint:true,showClickWrongHint:true,showClickLastHint:true,showClickSingleHint:true,showClickDoubleHint:true,showSaveHint:true});}},{key:'handleSurveyBack',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:case'end':return _context11.stop();}}},_callee11,this);}));function handleSurveyBack(){return _ref11.apply(this,arguments);}return handleSurveyBack;}()},{key:'render',value:function render(){var _this6=this;var paragraphs=this.state.paragraphs.map(function(paragraph,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{key:i,className:paragraph.highlighted?"highlightSelect":"",onClick:function onClick(){return _this6.mouseClick(i);},onDoubleClick:function onDoubleClick(){return _this6.mouseDblClick(i);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{hidden:paragraph.alt==="",src:paragraph.src,alt:paragraph.alt}),paragraph.word);});var progressBar="";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container-fluid bgGrey",style:{paddingLeft:0,paddingRight:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:'KSGrading',userId:this.props.user.id,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteScoreConfirm,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["a" /* Modal */],{id:'dialogBox',show:this.state.modalDialogNote},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{paddingTop:0,marginTop:-10,marginBottom:15}},'Make a Note'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{style:{width:500},onChange:this.handleNoteContentChange,value:this.state.noteContent,placeholder:"please enter your note here"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section',style:{marginTop:-40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.deleteNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.saveNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block",style:{maxWidth:'100%',marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-4"},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_logo_kidspeak_png___default.a,alt:"Kid Speak",style:{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}),'  ',this.props.lastStudent.user.firstname,' ',this.props.lastStudent.user.lastname)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-8 tr"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar"},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ModalFormComponents_ReportBugForm__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Shared_DropDownNotifications__["a" /* default */],Object.assign({studentClick:this.handleStudentClick},this.props)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleShowHints,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Show Hints')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12 noPaddingLR'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container",style:{position:'relative',minHeight:'calc(100vh - 88px)',height:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'appContainer',className:"ksGradingContainer col-md-12 newGradingClass",style:{backgroundColor:'#FFF',backgroundImage:'initial'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:"newGradingClass",style:{marginTop:5,fontFamily:'Neucha',letterSpacing:'1px'}},this.state.storyStarter.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'whitebox',className:"newGradingClass"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showClickWrongHint,className:"popoverCustom"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_modal_x_png___default.a,onClick:this.getTarget1,style:{width:35,paddingRight:5,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint:'))),'Click on incorrect words to mark \u2018Wrong\u2019',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showClickWrongHint,className:"arrowPointer arrowPointerInner"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showClickLastHint,className:"popoverCustom popoverCustomRight"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_modal_x_png___default.a,onClick:this.getTarget2,style:{width:35,paddingRight:5,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint:'))),'Click the last word spoken'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showClickSingleHint,className:"popoverCustom popoverCustomRightBot"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_modal_x_png___default.a,onClick:this.getTarget3,style:{width:35,paddingRight:5,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint:'))),'Single click for Correct/ Wrong.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showClickDoubleHint,className:"popoverCustom popoverCustomLeftBot"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_modal_x_png___default.a,onClick:this.getTarget4,style:{width:35,paddingRight:5,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint:'))),'Double click to remove scoring'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'data',className:"col-md-12 newGradingClass",style:{paddingTop:5,overflowY:'auto',maxHeight:350}},paragraphs),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 text-center"},'Use the spacebar to pause/ play the audio. Click/ double-click words to toggle Correct/ Incorrect/ Ungraded.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'wrapper',className:"newGradingClass col-md-12",style:{backgroundColor:'initial'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{id:'track',ref:function ref(audio){return _this6.audio=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative',textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showPlayHint,className:"popoverCustom"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_modal_x_png___default.a,onClick:this.getTarget,style:{width:35,paddingRight:5,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint:'))),'Press Play icon to hear student'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showPlayHint,className:"arrowPointer"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('nav',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onMouseOver:this.state.playButtonHover,onMouseLeave:this.state.playButtonLeave,onClick:function onClick(){return _this6.pausePlay();},type:'button',id:'playbutton',style:this.state.playButton.backgroundImage?{backgroundImage:this.state.playButton.backgroundImage}:{}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{id:'currentTime'},this.state.currentTime),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{ref:function ref(defaultBar){return _this6.defaultBar=defaultBar;},id:'defaultBar',onClick:this.clickedBar},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'progressBar',style:this.state.progressBar.width?{width:this.state.progressBar.width}:{}},progressBar)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{id:'fullDuration'},this.state.duration)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'options',className:"newGradingClass col-md-12",style:{marginBottom:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 bgGrey",style:{padding:15}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{alt:'correct',src:__webpack_require__(93),style:{position:'relative',top:-25,left:50}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Correct'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'correct',className:'backgroundGradeCountBox'},this.state.correct)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{alt:'incorrect',src:__webpack_require__(208),style:{position:'relative',top:-25,left:60}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Incorrect'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'',className:"backgroundGradeCountBox"},this.state.incorrect)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Total Words'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'',className:"backgroundGradeCountBox"},this.state.totalWords))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{marginTop:30,marginBottom:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-lg-3 col-xs-3 col-md-3 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return _this6.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_17__Shared_DataTrackingPoints__["b" /* default */].KS_SCORE_EXIT,metadata:{testId:_this6.state.testId}}});case 2:_this6.handleAnalytics();_this6.props.history.push('../student');case 4:case'end':return _context12.stop();}}},_callee12,_this6);})),className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Exit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-lg-9 col-xs-9 col-md-9 noPaddingLR",style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNextTask,className:'handBtn',style:{display:this.state.handleNext?'inline-block':'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Next Task')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleTakeANote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Make a Note')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitKSSessionGrade,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.fillWithChecks,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Auto Correct')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.clearCounters,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Reset Grading')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this6.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TASK?'});},className:'handBtn',style:{marginRight:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete'))))));}}]);return KSGrading;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var actionToProps=function actionToProps(dispatch){return{updateStudent:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["h" /* updateStudent */])(student));case 2:return _context13.abrupt('return',_context13.sent);case 3:case'end':return _context13.stop();}}},_callee13,_this7);}));function updateStudent(_x5){return _ref13.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{lastStudent:state.teacherReducer.student};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,actionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(KSGrading)));

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_teachers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_teachers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_apps_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_apps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_apps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_students_Slash_css__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_students_Slash_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_students_Slash_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_tappable__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_tappable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_tappable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ProgressModalComponent_ScoreBox__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_video_instructions_png__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_video_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_video_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Shared_InstructionModals__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_modal_correct_png__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_modal_correct_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_modal_correct_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_modal_incorrect_png__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_modal_incorrect_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_modal_incorrect_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_redux_es_connect_connect__ = __webpack_require__(28);
var _this17=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var usedPassages=[];var MaxSessionTime=60;//60 seconds, for testing: 6000 seconds
var SlashTestComponent=function(_Component){_inherits(SlashTestComponent,_Component);function SlashTestComponent(props){var _this2=this;_classCallCheck(this,SlashTestComponent);var _this=_possibleConstructorReturn(this,(SlashTestComponent.__proto__||Object.getPrototypeOf(SlashTestComponent)).call(this,props));_this.handleModalBack=function(modalActive){_this.setState({modalActive:modalActive});};_this.handleBack=function(){console.log('HandleBack-Slash');window.location.reload();_this.setState({active:0});};_this.handleActive=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(active){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(active===3)){_context.next=3;break;}_context.next=3;return __WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getSlashTestRandom().then(function(response){if(response.success){this.setState({passages:response.body.passages});}else{console.log('Error',response.msg);}}.bind(_this),function(error){console.log('Error',error.msg);});case 3:_this.setState({active:active});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleBeginTest=function(){_this.setState({active:3});};_this.changeLevelScore=function(newLevel,newScore){_this.state.bestScores.slashLevel=newLevel;_this.state.bestScores.slashScore=newScore;};_this.state={active:0,passages:[],modalActive:true,loadedScores:false,startDisabled:true,bestScores:{slashLevel:1,slashScore:1}};return _this;}_createClass(SlashTestComponent,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:__WEBPACK_IMPORTED_MODULE_6__Shared_Helpers__["a" /* default */].authorize(this);_context3.next=3;return __WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!response.success){_context2.next=3;break;}_context2.next=3;return _this3.setState({loadedScores:true,bestScores:response.body});case 3:case'end':return _context2.stop();}}},_callee2,_this3);}));return function(_x2){return _ref3.apply(this,arguments);};}());case 3:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.state.active!==2?"bgGrey SlashContainer":"SlashContainer bgYellow"},this.state.active===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer slash'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:42}},'Slash'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 text-center"},this.state.loadedScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ProgressModalComponent_ProgressBox__["a" /* default */],{appName:"slash",slashProgress:true,level:this.state.bestScores.slashLevel,step:this.state.bestScores.slashScore,steps:6,maxLevel:8}):null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["a" /* Buttons */],{appName:"slash",level:this.state.bestScores.slashLevel,maxLevel:8,buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["b" /* Buttons1 */],{demo:true,appName:"slash",practice:true,buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer slash'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:42}},'Slash: Show Me'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["g" /* VideoComponent */],{url:"https://s3.us-east-2.amazonaws.com/uploadbeta/video/slash/new_slash_video.mp4"})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["a" /* Buttons */],{demo:true,appName:"slash",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["b" /* Buttons1 */],{appName:"slash",practice:true,buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tutorial,{studentUser:this.props.studentUser,buttonClick:this.handleActive,passage:this.state.passages[0],beginTest:this.handleBeginTest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["a" /* Buttons */],{appName:"slash",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["b" /* Buttons1 */],{appName:"slash",buttonClick:this.handleActive,clickBack:this.handleBack,recordedSession:this.state.modalActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Content,{studentUser:this.props.studentUser,buttonClick:this.handleActive,backBtn:this.handleModalBack,changeLevelScore:this.changeLevelScore,passages:this.state.passages}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["a" /* Buttons */],{appName:"slash",buttonClick:this.handleActive,currentTabActive:this.state.active})):null);}}]);return SlashTestComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var style={display:'-webkit-box'};var ContentComponent=function(_Component2){_inherits(ContentComponent,_Component2);function ContentComponent(props){var _this5=this;_classCallCheck(this,ContentComponent);var _this4=_possibleConstructorReturn(this,(ContentComponent.__proto__||Object.getPrototypeOf(ContentComponent)).call(this,props));_this4.windowResizeListener=function(e){if(!(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isTablet"]||__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isMobile"]||__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isIOS"]||__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isIOS13"])){_this4.setState({modalDialog:true,responseContent:'Resizing the browser window while in a test is not allowed.'});}};_this4.handleClick=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(index,isBreak){var response,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:response=_this4.state.response;console.log("handle click at parent level");console.log(index);console.log(isBreak);console.log(response);if(isBreak){response.push(index);}else{i=response.indexOf(index);if(i>-1){response.splice(i,1);}}console.log(response);response.sort(function(a,b){return a-b;});console.log(response);_context4.next=11;return _this4.setState({response:response},function(){_this4.generatedText(index,isBreak);console.log("handle click - expectedToPop");console.log(_this4.state.expectedToPop);});case 11:case'end':return _context4.stop();}}},_callee4,_this5);}));return function(_x3,_x4){return _ref4.apply(this,arguments);};}();_this4.setLastOffset=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(offsetTop){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return _this4.setState({lastOffset:offsetTop});case 2:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x5){return _ref5.apply(this,arguments);};}();_this4.popExpected=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(index){var newexp;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:newexp=_this4.state.expectedToPop;newexp.push(index);_context6.next=4;return _this4.setState({expectedToPop:newexp});case 4:console.log('popExpected');console.log(_this4.state.expectedToPop);case 6:case'end':return _context6.stop();}}},_callee6,_this5);}));return function(_x6){return _ref6.apply(this,arguments);};}();_this4.state={popupSurvey:false,passages:_this4.props.passages,passage:_this4.props.passages[0],expected:[],expectedToPop:[],level:1,score:3,testScore:0,time:MaxSessionTime,sessionTime:MaxSessionTime,response:[],generatedResponse:'',errors:[],correct:0,error:0,skipped:0,isNewLevel:true,finished:false,showNext:false,errorType:'',lastOffset:-1,levelCal:null,scoreCalc:null,isNewLevelCalc:null,animateLevel:false,levelType:'',stepType:'',modalDialog:false,responseContent:'',randomCorrect:['Great Job','Well Done','Fantastic','You got it','Perfect','Way to go','Terrific','Excellent','Super','Nice work','Wonderful','Outstanding','Congratulations','That’s right'],randomTitle:'',stepDir:'UP',stepDirNow:null,firstScore:false,lastScore:false,tooFast:false,modalInstruction:false};_this4.timer=0;_this4.handleSurveyBack=_this4.handleSurveyBack.bind(_this4);_this4.handleFinished=_this4.handleFinished.bind(_this4);_this4.handleNext=_this4.handleNext.bind(_this4);_this4.handleLevelAnimationClose=_this4.handleLevelAnimationClose.bind(_this4);_this4.startTimer=_this4.startTimer.bind(_this4);_this4.countDown=_this4.countDown.bind(_this4);_this4.handleClose=_this4.handleClose.bind(_this4);_this4.theEventListener=_this4.windowResizeListener.bind(_this4);_this4.handleAnalytics=_this4.handleAnalytics.bind(_this4);return _this4;}_createClass(ContentComponent,[{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.theEventListener,true);Object(__WEBPACK_IMPORTED_MODULE_11_timers__["clearInterval"])(this.timer);}},{key:'componentDidMount',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(window.innerWidth<window.innerHeight){this.setState({modalInstruction:true});}else{this.setState({modalInstruction:false});__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getBestScores().then(function(response){if(response.success){_this6.setState({level:response.body.slashLevel,score:response.body.slashScore,expected:_this6.calculateExpected(),//?
expectedToPop:[],lineWidth:null,//?
generatedResponse:_this6.removeSpaces(_this6.state.passage.slashcontent),randomTitle:_this6.state.randomCorrect[Math.floor(Math.random()*_this6.state.randomCorrect.length)]});_this6.startTimer();window.addEventListener('resize',_this6.theEventListener,true);}},function(error){_this6.props.history.push('/student/tasks/slashtest');console.log('ResponseError',error);});}_context7.next=3;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__["b" /* default */].STUDENT_SLASH_START,metadata:{}}});case 3:this.handleAnalytics();case 4:case'end':return _context7.stop();}}},_callee7,this);}));function componentDidMount(){return _ref7.apply(this,arguments);}return componentDidMount;}()},{key:'calculateExpected',value:function calculateExpected(){//expected: list of indices of space characters, started from 0
var passage=this.state.passage.slashcontent,expected=[];passage.split('').map(function(item,index){if(item===' '){expected.push(index);}});console.log('Expected',expected);return expected;}},{key:'handleSurveyBack',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:case'end':return _context8.stop();}}},_callee8,this);}));function handleSurveyBack(){return _ref8.apply(this,arguments);}return handleSurveyBack;}()},{key:'startTimer',value:function startTimer(){if(!this.props.practice){this.props.backBtn(false);}this.timer=Object(__WEBPACK_IMPORTED_MODULE_11_timers__["setInterval"])(this.countDown,1000);}},{key:'countDown',value:function countDown(){var seconds=this.state.time-1;this.setState({time:seconds,sessionTime:MaxSessionTime});if(seconds===0){Object(__WEBPACK_IMPORTED_MODULE_11_timers__["clearInterval"])(this.timer);this.handleFinished();}}},{key:'removeSpaces',value:function removeSpaces(target){var regex=/\s/g;return target.replace(regex,'');}//assign value to response
},{key:'generatedText',// add space to in between breaks of words, save to generatedResponse
// the initial status of generated response is the slash content without spaces
// however, generated response is not used in the other part of the code
value:function generatedText(index,isBreak){var _this7=this;String.prototype.splice=function(idx,rem,str){return this.slice(0,idx)+str+this.slice(idx+Math.abs(rem));};var content=this.state.generatedResponse;if(isBreak){content=content.splice(index,0,' ');}else{content=content.slice(index);}this.setState({generatedResponse:content},function(){console.log('S(p)liced ('+index+'): ',_this7.state.generatedResponse);console.log(isBreak);console.log(content);});}// calculated correct, error, skipped based on nolinebreak (item - 1);
},{key:'handleFinished',value:function handleFinished(e){var _this8=this;console.log('finish expected to pop:');console.log(this.state.expectedToPop);var timeStart=MaxSessionTime;Object(__WEBPACK_IMPORTED_MODULE_11_timers__["clearInterval"])(this.timer);if(!this.props.practice){this.props.backBtn(true);}if(this.state.time>timeStart-5&&!this.props.practice&&this.state.passage.slashcontent.length>30){this.setState({tooFast:true,finished:true,showNext:true});}else{var _state=this.state,response=_state.response,expected=_state.expected,correct=_state.correct,error=_state.error,skipped=_state.skipped,expectedToPop=_state.expectedToPop;console.log('finish response:');console.log(response);console.log(this.state.expected);//expected start from 0
console.log(this.state.expectedToPop);response.map(function(item){console.log('expectedToPop: '+expectedToPop);var notLineBreak=!_this8.state.expectedToPop.includes(item-1);//?
if(_this8.state.expected.includes(item)&&notLineBreak){console.log('correct item: '+item);correct+=1;}else if(notLineBreak){console.log('error item: '+item);error+=1;}});this.state.expected.map(function(item){if(!response.includes(item)){skipped+=1;}});var scoreFalse=error;this.setState({correct:correct,error:scoreFalse,skipped:skipped,tooFast:false,finished:true,showNext:true,testScore:correct},function(){if(_this8.validateSession()){if(!_this8.props.practice){_this8.calculateAndUpdateScore();}}});}}},{key:'validateSession',value:function validateSession(){var _state2=this.state,response=_state2.response,time=_state2.time;return response.length>0&&time<MaxSessionTime;}},{key:'calculateAndUpdateScore',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var _this9=this;var _state3,error,correct,skipped,level,score,isNewLevel,stepType,testsAmount;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_state3=this.state,error=_state3.error,correct=_state3.correct,skipped=_state3.skipped,level=_state3.level,score=_state3.score,isNewLevel=_state3.isNewLevel,stepType=_state3.stepType;if(!(correct!==0&&error===0&&skipped===0)){_context9.next=7;break;}score=score+1;this.setState({stepDir:'UP'});if(score>6){level=level+1;score=1;isNewLevel=true;stepType="UP";this.setState({lastScore:true});}_context9.next=27;break;case 7:if(!(skipped!==0&&error===0&&correct===0)){_context9.next=13;break;}score=score;level=level;this.setState({stepDir:null});_context9.next=27;break;case 13:score=score-1;if(!(score<1)){_context9.next=26;break;}if(!(level>=2)){_context9.next=21;break;}testsAmount=0;_context9.next=19;return __WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getSlashScoreCount().then(function(response){//only allow level up in the first 15 tests
if(response.success){testsAmount=response.body;if(testsAmount<20){//only allow level down in the first 20 tests
level=level-1;score=2;_this9.setState({stepDir:'DOWN'});_this9.setState({levelType:'LEVEL DOWN'});isNewLevel=true;}else{score=1;_this9.setState({stepDir:null});}console.log('Success',response);}else{console.log('Error',response.msg);}},function(error){console.log('Error',error.msg);});case 19:_context9.next=24;break;case 21:score=1;level=1;this.setState({stepDir:null});case 24:_context9.next=27;break;case 26:this.setState({stepDir:'DOWN'});case 27:this.props.changeLevelScore(level,score);this.setState({scoreCalc:score,levelCalc:level,isNewLevelCalc:isNewLevel,stepType:stepType},function(){_this9.updateScores();_this9.postSession();});case 29:case'end':return _context9.stop();}}},_callee9,this);}));function calculateAndUpdateScore(){return _ref9.apply(this,arguments);}return calculateAndUpdateScore;}()},{key:'updateScores',value:function updateScores(){var body={slashLevel:this.state.levelCalc,slashScore:this.state.scoreCalc};__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].updateSlashScores(body).then(function(response){},function(error){console.log('Error',error);});}},{key:'postSession',value:function postSession(){var body={passageId:this.state.passage.passageId,sessionTime:MaxSessionTime-this.state.time,startLevel:this.state.level,testScore:this.state.testScore,totalWrong:this.state.error+this.state.skipped,newLevel:0,endLevel:this.state.level,time:MaxSessionTime-this.state.time};__WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].postSlashSession(body).then(function(response){console.log('Slash Response',response);},function(error){console.log('Slash Error',error);});}},{key:'handleLevelAnimationClose',value:function handleLevelAnimationClose(){this.setState({animateLevel:false});this.state.level==13?window.location.reload():null;}},{key:'handleNext',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(e){var _this10=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(this.state.firstScore){this.setState({firstScore:false});}if(this.state.lastScore){this.setState({lastScore:false});}if(!(this.state.level>this.state.levelCalc)){_context10.next=7;break;}_context10.next=5;return this.setState({levelType:'LEVEL DOWN'});case 5:_context10.next=17;break;case 7:if(!(this.state.level<this.state.levelCalc)){_context10.next=15;break;}_context10.next=10;return this.setState({levelType:'LEVEL UP'});case 10:if(!(this.state.levelCalc==9)){_context10.next=13;break;}_context10.next=13;return this.setState({levelType:''});case 13:_context10.next=17;break;case 15:_context10.next=17;return this.setState({levelType:'STAY'});case 17:_context10.next=19;return this.setState({popupSurvey:false,score:this.state.scoreCalc!=null?this.state.scoreCalc:this.state.score,level:this.state.levelCalc!=null?this.state.levelCalc:this.state.level,isNewLevel:false,animateLevel:this.state.levelType==="STAY"?false:true});case 19:_context10.next=21;return __WEBPACK_IMPORTED_MODULE_5__Shared_REST__["a" /* default */].getSlashTestRandom().then(function(response){if(response.success){_this10.setState({passages:response.body.passages});}else{console.log('Error',response.msg);}},function(error){console.log('Error',error.msg);});case 21:_context10.next=23;return this.setState({passage:this.state.passages[0],showNext:false,response:[],expectedToPop:[],correct:0,error:0,skipped:0,time:MaxSessionTime},function(){_this10.setState({expected:_this10.calculateExpected()});});case 23:this.startTimer();case 24:case'end':return _context10.stop();}}},_callee10,this);}));function handleNext(_x7){return _ref10.apply(this,arguments);}return handleNext;}()},{key:'handleClose',value:function handleClose(e){var _this11=this;if(this.state.level===this.state.levelCalc){this.setState({score:this.state.scoreCalc!=null?this.state.scoreCalc:this.state.score,level:this.state.levelCalc!=null?this.state.levelCalc:this.state.level,stepDirNow:this.state.stepDir,isNewLevel:false},function(){_this11.updateScores();});}this.setState({finished:false,popupSurvey:true});if(this.props.practice){this.props.buttonClick(0);}}},{key:'render',value:function render(){var _this12=this;var _state4=this.state,correct=_state4.correct,error=_state4.error,skipped=_state4.skipped;var score=correct-error-skipped;if(score<0){score=0;}var title=void 0;var iconSrc=void 0;if(correct===0&&error===0){if(this.state.tooFast){title='Try Again!';iconSrc=null;}else{title='Nothing to score!';iconSrc=null;}}else if(error!==0||skipped!==0){title='Oops! You made a mistake';iconSrc=__WEBPACK_IMPORTED_MODULE_21__assets_images_modal_incorrect_png___default.a;}else{title=this.state.randomTitle;iconSrc=__WEBPACK_IMPORTED_MODULE_20__assets_images_modal_correct_png___default.a;}var passageContent=[];var passageWords=this.state.passage.slashcontent.split(" ");//let slashcontent = 'THE BIRD SINGS A SONG';
//let passageWords = slashcontent.split(" ");
var wordIndex=0;var wordLengths=0;var totalWidths=0;var minWidths=0;var moreWidthIndexes=[];var pwls=0;var lastMinWidth=0;var lastMaxWidth=0;var lastLength=0;var lineNumber=0;var lastLenIndex=0;for(var i=0;i<passageWords.length;i++){var passageWord=passageWords[i];pwls=pwls+passageWord.length;//let maxWidth = 66*passageWord.length;
var maxWidth=66*passageWord.length;var minWidth=56*passageWord.length;minWidths=minWidths+minWidth;totalWidths=totalWidths+maxWidth;if(lastMaxWidth>0){totalWidths=totalWidths+lastMaxWidth;lastMaxWidth=0;}if(lastMinWidth>0){minWidths=minWidths+lastMinWidth;lastMinWidth=0;}if(this.state.lineWidth&&this.state.lineWidth.width-120<totalWidths){(function(){//60
//console.log("line width:" + this.state.lineWidth.width);
var screenMargin=_this12.state.lineWidth.width-120;var theLenIndex=lastLength+pwls-passageWord.length+i-1;var responsesUnique=_this12.state.response;responsesUnique=responsesUnique.filter(function(item,pos){return responsesUnique.indexOf(item)===pos;});var before=responsesUnique.filter(function(o,ln){return lastLenIndex<o&&o<=theLenIndex;}).length;lastLenIndex=theLenIndex;var newWidth=56*passageWords[i-1].length+minWidth+(screenMargin-minWidths)-before*10;moreWidthIndexes.push({wordIndex:i-1,width:newWidth});lastLength=lastLength+pwls-passageWord.length;pwls=passageWord.length;totalWidths=0;minWidths=0;lastMaxWidth=maxWidth;lastMinWidth=minWidth;lineNumber++;})();}}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=passageWords[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _passageWord=_step.value;var toSendContent=_passageWord+" ";var expected=[0,_passageWord.length];var lastWord=passageWords.length===wordIndex+1;if(lastWord){toSendContent=_passageWord;expected=[0,0];}var widthAdd=moreWidthIndexes.find(function(e){return e.wordIndex===wordIndex;});var cont=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:this.state.passage.passageId+"passage"+wordIndex,style:{display:"inline-block",width:widthAdd&&!this.state.showNext?widthAdd.width:widthAdd}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ChildComponent,{key:this.state.passage.passageId+"passage"+wordIndex,passageId:this.state.passage.passageId,content:_passageWord,lastWord:lastWord,handleChildClick:this.handleClick,setChildLastOffset:this.setLastOffset,handlePopExpected:this.popExpected,expected:this.state.expected,expectedToPop:this.state.expectedToPop,finished:this.state.showNext,response:this.state.response,wordLengths:wordLengths,lastOffset:this.state.lastOffset}));passageContent.push(cont);wordLengths=wordLengths+_passageWord.length+1;wordIndex++;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Shared_InstructionModals__["a" /* default */],{Slash:true,modalOpen:this.state.modalInstruction,closeClick:function closeClick(active){_this12.setState({modalInstruction:active});_this12.props.buttonClick(0);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.practice?" appSection bgGr"+"ey":"appSection bgYellow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Shared_DialogBox__["a" /* default */],{surveyModal:true,app:'Slash',userId:this.props.studentUser.id,active:this.state.popupSurvey,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Shared_DialogBox__["a" /* default */],{slash:true,warning:__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isTablet"]?true:false,notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this12.setState({modalDialog:active});_this12.props.buttonClick(0);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"",style:{marginRight:50,marginLeft:50}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{ref:function ref(_ref11){_this12.theLine=_ref11;!_this12.state.lineWidth&&_ref11?_this12.setState({lineWidth:_ref11.getBoundingClientRect()}):null;},className:"appContainer slashTest",style:{paddingBottom:"75px"}},passageContent))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tc'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row tc"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-12 hidden-md hidden-xs hidden-lg"},this.state.showNext?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNext,className:'handBtn',style:{width:150}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Try Another')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleFinished,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Finished'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-5 col-sm-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.props.practice},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["e" /* LevelTrackerComponent */],{appName:"slash",firstScore:this.state.firstScore,lastScore:this.state.lastScore,stepDir:this.state.stepDirNow,level:this.state.level,maxLevel:8,step:this.state.score,stepType:this.state.stepType,steps:6}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-2 hidden-sm"},this.state.showNext?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNext,className:'handBtn',style:{width:150}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Try Another')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleFinished,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Finished'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-5 col-sm-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row pull-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["c" /* CountDownComponent */],{time:this.state.time,sessionTime:MaxSessionTime,showTime:10})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["a" /* Modal */],{id:"resultBox",show:this.state.finished},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},iconSrc?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:iconSrc,style:{width:150}}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,title)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},title!=='Nothing to score!'&&!this.state.tooFast?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ProgressModalComponent_ScoreBox__["a" /* default */],{score:score,correct:correct,incorrect:error+skipped,skipped:skipped,app:"slash"}):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'handBtn',onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["a" /* Modal */],{id:'animateModal',show:this.state.animateLevel},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["d" /* LevelAnimation */],{appName:"slash",level:this.state.level,maxLevel:8,typeLevel:this.state.levelType,closeAnimation:this.handleLevelAnimationClose})))));}}]);return ContentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Tutorial=function(_Component3){_inherits(Tutorial,_Component3);function Tutorial(props){_classCallCheck(this,Tutorial);var _this13=_possibleConstructorReturn(this,(Tutorial.__proto__||Object.getPrototypeOf(Tutorial)).call(this,props));_this13.state={passage:_this13.props.passage};return _this13;}_createClass(Tutorial,[{key:'render',value:function render(){var passages=[];passages.push({slashcontent:"I HAVE A BIG BROWN DOG"});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Content,{studentUser:this.props.studentUser,buttonClick:this.props.buttonClick,passages:passages,practice:true});}}]);return Tutorial;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Content=Object(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["e" /* withRouter */])(ContentComponent);var ChildComponent=function(_Component4){_inherits(ChildComponent,_Component4);function ChildComponent(props){_classCallCheck(this,ChildComponent);var _this14=_possibleConstructorReturn(this,(ChildComponent.__proto__||Object.getPrototypeOf(ChildComponent)).call(this,props));_this14.state={response:[],timeout:null,reloaded:true};return _this14;}_createClass(ChildComponent,[{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.state.timeout);}},{key:'componentDidMount',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){var _this15=this;var timeout;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:console.log('expected to pop 1');console.log(this.props.expected);console.log(this.props.expectedToPop);if(this.state.reloaded){//only run once
timeout=setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(){var offsetTop,lastOffset,wl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return __WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(_this15).getBoundingClientRect().top;case 2:offsetTop=_context11.sent;lastOffset=_this15.props.lastOffset;wl=_this15.props.wordLengths;_context11.next=7;return _this15.props.setChildLastOffset(offsetTop);case 7:console.log('handel pop expected: '+_this15.props.content);console.log(wl);console.log(lastOffset);console.log(offsetTop);if(!(lastOffset!==-1&&offsetTop>lastOffset)){_context11.next=17;break;}//remove the last one if current one's offset > last one's
_this15.handleClick(wl-2);//wl - 2
_context11.next=15;return _this15.props.handlePopExpected(wl-2);case 15://wl - 2
console.log('expected to pop 2');console.log(_this15.props.expectedToPop);case 17:case'end':return _context11.stop();}}},_callee11,_this15);})),500);this.setState({timeout:timeout,reloaded:false});}case 4:case'end':return _context12.stop();}}},_callee12,this);}));function componentDidMount(){return _ref12.apply(this,arguments);}return componentDidMount;}()},{key:'handleClick',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(index){var response,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:response=this.state.response;console.log('parent handle click: response 1');console.log(response);if(!response.includes(index)){_context13.next=10;break;}i=response.indexOf(index);if(i>-1)response.splice(i,1);_context13.next=8;return this.props.handleChildClick(index+1,false);case 8:_context13.next=13;break;case 10:response.push(index);_context13.next=13;return this.props.handleChildClick(index+1,true);case 13:console.log('response 2');console.log(response);_context13.next=17;return this.setState({response:response});case 17:case'end':return _context13.stop();}}},_callee13,this);}));function handleClick(_x8){return _ref14.apply(this,arguments);}return handleClick;}()},{key:'prepareContent',value:function prepareContent(){var _this16=this;var content=this.props.content;var items=content.split('');var array=[];var wordsIndex=this.props.wordLengths;var middleGroup=null;var lastWord=this.props.lastWord;items.map(function(item,index){var correct=false,skipped=false,error=false,spacing=false;var lastCharacter=content.length===index+1;var isLineBreak=_this16.props.expectedToPop.includes(wordsIndex+index);//handle line break
if(_this16.props.finished){if(_this16.props.expected.includes(wordsIndex+index+1)&&_this16.props.response.includes(wordsIndex+index+1)&&!isLineBreak){correct=true;}else if(_this16.props.expected.includes(wordsIndex+index+1)&&!_this16.props.response.includes(wordsIndex+index+1)&&!isLineBreak){skipped=true;}else if(!_this16.props.expected.includes(wordsIndex+index+1)&&_this16.props.response.includes(wordsIndex+index+1)&&!isLineBreak){error=true;}else{spacing=true;}if(_this16.state.response.length>0){_this16.setState({response:[],reloaded:true});}}else{var sClass="";if(_this16.state.response.includes(wordsIndex+index)&&!_this16.props.finished&&!_this16.state.lastIndex&&!isLineBreak){sClass="show";}var hoverEnabled=sClass===""&&!isLineBreak?"hoverEnabled":"";middleGroup=!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform)?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_tappable___default.a,{onTap:function onTap(){if(!isLineBreak){_this16.handleClick(wordsIndex+index);}else{return null;}}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{cursor:!isLineBreak?"pointer":"default"},key:wordsIndex+index,className:"slashOptions "+hoverEnabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"vll "+sClass}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{cursor:!isLineBreak?"pointer":"default"},key:wordsIndex+index,className:"slashOptions "+hoverEnabled,onClick:function onClick(){if(!isLineBreak){_this16.handleClick(wordsIndex+index);}else{return null;}}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"vll "+sClass}));}if(item===' '){return;}var theItem=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'slashOptions',style:{position:'relative'},key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,item),lastWord&&lastCharacter?null:middleGroup,_this16.props.finished&&correct?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:wordsIndex+index,className:"slashCorrect slashOptions"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"fdbkPlus"})):null,_this16.props.finished&&spacing?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:wordsIndex+index,className:"slashOptions"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"vll"})):null,_this16.props.finished&&error?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:wordsIndex+index,className:'slashError slashOptions'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"fdbkMinus"})):null,_this16.props.finished&&skipped?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:wordsIndex+index,className:'slashSkipped slashOptions'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"dashedSkip"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"fdbkMinus"})):null);array.push(theItem);});return array;}},{key:'render',value:function render(){var items=this.prepareContent();if(this.props.finished){//console.log('Finished', this.props.response);
}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'slashOptions'},items);}}]);return ChildComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context14.abrupt('return',_context14.sent);case 3:case'end':return _context14.stop();}}},_callee14,_this17);}));function updateStudentAppStatus(_x9){return _ref15.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context15.abrupt('return',_context15.sent);case 3:case'end':return _context15.stop();}}},_callee15,_this17);}));function updateStudentAccountTab(_x10){return _ref16.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__actions__["a" /* updateAppStates */])(appStates));case 2:return _context16.abrupt('return',_context16.sent);case 3:case'end':return _context16.stop();}}},_callee16,_this17);}));function updateAppStates(_x11){return _ref17.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_24_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["e" /* withRouter */])(SlashTestComponent)));

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TappableMixin = __webpack_require__(851);
var PinchableMixin = __webpack_require__(852);
var getComponent = __webpack_require__(853);
var touchStyles = __webpack_require__(384);

var Component = getComponent([TappableMixin, PinchableMixin]);

module.exports = Component;
module.exports.touchStyles = touchStyles;
module.exports.Mixin = Object.assign({}, TappableMixin, {
  onPinchStart: PinchableMixin.onPinchStart,
  onPinchMove: PinchableMixin.onPinchMove,
  onPinchEnd: PinchableMixin.onPinchEnd
});

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PropTypes = __webpack_require__(1);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(18);

var SPACE_KEY = 32;
var ENTER_KEY = 13;

function getTouchProps(touch) {
	if (!touch) return {};
	return {
		pageX: touch.pageX,
		pageY: touch.pageY,
		clientX: touch.clientX,
		clientY: touch.clientY
	};
}

var Mixin = {
	propTypes: {
		moveThreshold: PropTypes.number, // pixels to move before cancelling tap
		moveXThreshold: PropTypes.number, // pixels on the x axis to move before cancelling tap (overrides moveThreshold)
		moveYThreshold: PropTypes.number, // pixels on the y axis to move before cancelling tap (overrides moveThreshold)
		allowReactivation: PropTypes.bool, // after moving outside of the moveThreshold will you allow
		// reactivation by moving back within the moveThreshold?
		activeDelay: PropTypes.number, // ms to wait before adding the `-active` class
		pressDelay: PropTypes.number, // ms to wait before detecting a press
		pressMoveThreshold: PropTypes.number, // pixels to move before cancelling press
		preventDefault: PropTypes.bool, // whether to preventDefault on all events
		stopPropagation: PropTypes.bool, // whether to stopPropagation on all events

		onTap: PropTypes.func, // fires when a tap is detected
		onPress: PropTypes.func, // fires when a press is detected
		onTouchStart: PropTypes.func, // pass-through touch event
		onTouchMove: PropTypes.func, // pass-through touch event
		onTouchEnd: PropTypes.func, // pass-through touch event
		onMouseDown: PropTypes.func, // pass-through mouse event
		onMouseUp: PropTypes.func, // pass-through mouse event
		onMouseMove: PropTypes.func, // pass-through mouse event
		onMouseOut: PropTypes.func, // pass-through mouse event
		onKeyDown: PropTypes.func, // pass-through key event
		onKeyUp: PropTypes.func // pass-through key event
	},

	getDefaultProps: function getDefaultProps() {
		return {
			activeDelay: 0,
			allowReactivation: true,
			moveThreshold: 100,
			pressDelay: 1000,
			pressMoveThreshold: 5
		};
	},

	getInitialState: function getInitialState() {
		return {
			isActive: false,
			touchActive: false,
			pinchActive: false
		};
	},

	componentDidMount: function componentDidMount() {
		this.isMounted = true;
	},

	componentWillUnmount: function componentWillUnmount() {
		this.isMounted = false;
		this.cleanupScrollDetection();
		this.cancelPressDetection();
		this.clearActiveTimeout();
	},

	componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
		if (this.state.isActive && !nextState.isActive) {
			this.props.onDeactivate && this.props.onDeactivate();
		} else if (!this.state.isActive && nextState.isActive) {
			this.props.onReactivate && this.props.onReactivate();
		}
	},

	processEvent: function processEvent(event) {
		if (this.props.preventDefault) event.preventDefault();
		if (this.props.stopPropagation) event.stopPropagation();
	},

	onTouchStart: function onTouchStart(event) {
		if (this.props.onTouchStart && this.props.onTouchStart(event) === false) return;
		this.processEvent(event);
		window._blockMouseEvents = true;
		if (event.touches.length === 1) {
			this._initialTouch = this._lastTouch = getTouchProps(event.touches[0]);
			this.initScrollDetection();
			this.initPressDetection(event, this.endTouch);
			this.initTouchmoveDetection();
			if (this.props.activeDelay > 0) {
				this._activeTimeout = setTimeout(this.makeActive, this.props.activeDelay);
			} else {
				this.makeActive();
			}
		} else if (this.onPinchStart && (this.props.onPinchStart || this.props.onPinchMove || this.props.onPinchEnd) && event.touches.length === 2) {
			this.onPinchStart(event);
		}
	},

	makeActive: function makeActive() {
		if (!this.isMounted) return;
		this.clearActiveTimeout();
		this.setState({
			isActive: true
		});
	},

	clearActiveTimeout: function clearActiveTimeout() {
		clearTimeout(this._activeTimeout);
		this._activeTimeout = false;
	},

	initScrollDetection: function initScrollDetection() {
		this._scrollPos = { top: 0, left: 0 };
		this._scrollParents = [];
		this._scrollParentPos = [];
		var node = ReactDOM.findDOMNode(this);

		while (node) {
			if (node.scrollHeight > node.offsetHeight || node.scrollWidth > node.offsetWidth) {
				this._scrollParents.push(node);
				this._scrollParentPos.push(node.scrollTop + node.scrollLeft);
				this._scrollPos.top += node.scrollTop;
				this._scrollPos.left += node.scrollLeft;
			}

			node = node.parentNode;
		}
	},

	initTouchmoveDetection: function initTouchmoveDetection() {
		this._touchmoveTriggeredTimes = 0;
	},

	cancelTouchmoveDetection: function cancelTouchmoveDetection() {
		if (this._touchmoveDetectionTimeout) {
			clearTimeout(this._touchmoveDetectionTimeout);
			this._touchmoveDetectionTimeout = null;
			this._touchmoveTriggeredTimes = 0;
		}
	},

	calculateMovement: function calculateMovement(touch) {
		return {
			x: Math.abs(touch.clientX - this._initialTouch.clientX),
			y: Math.abs(touch.clientY - this._initialTouch.clientY)
		};
	},

	detectScroll: function detectScroll() {
		var currentScrollPos = { top: 0, left: 0 };
		for (var i = 0; i < this._scrollParents.length; i++) {
			currentScrollPos.top += this._scrollParents[i].scrollTop;
			currentScrollPos.left += this._scrollParents[i].scrollLeft;
		}
		return !(currentScrollPos.top === this._scrollPos.top && currentScrollPos.left === this._scrollPos.left);
	},

	cleanupScrollDetection: function cleanupScrollDetection() {
		this._scrollParents = undefined;
		this._scrollPos = undefined;
	},

	initPressDetection: function initPressDetection(event, callback) {
		if (!this.props.onPress) return;

		// SyntheticEvent objects are pooled, so persist the event so it can be referenced asynchronously
		event.persist();

		this._pressTimeout = setTimeout(function () {
			this.props.onPress(event);
			callback();
		}.bind(this), this.props.pressDelay);
	},

	cancelPressDetection: function cancelPressDetection() {
		clearTimeout(this._pressTimeout);
	},

	onTouchMove: function onTouchMove(event) {
		if (this._initialTouch) {
			this.processEvent(event);

			if (this.detectScroll()) {
				return this.endTouch(event);
			} else {
				if (this._touchmoveTriggeredTimes++ === 0) {
					this._touchmoveDetectionTimeout = setTimeout(function () {
						if (this._touchmoveTriggeredTimes === 1) {
							this.endTouch(event);
						}
					}.bind(this), 64);
				}
			}

			this.props.onTouchMove && this.props.onTouchMove(event);
			this._lastTouch = getTouchProps(event.touches[0]);
			var movement = this.calculateMovement(this._lastTouch);
			if (movement.x > this.props.pressMoveThreshold || movement.y > this.props.pressMoveThreshold) {
				this.cancelPressDetection();
			}
			if (movement.x > (this.props.moveXThreshold || this.props.moveThreshold) || movement.y > (this.props.moveYThreshold || this.props.moveThreshold)) {
				if (this.state.isActive) {
					if (this.props.allowReactivation) {
						this.setState({
							isActive: false
						});
					} else {
						return this.endTouch(event);
					}
				} else if (this._activeTimeout) {
					this.clearActiveTimeout();
				}
			} else {
				if (!this.state.isActive && !this._activeTimeout) {
					this.setState({
						isActive: true
					});
				}
			}
		} else if (this._initialPinch && event.touches.length === 2 && this.onPinchMove) {
			this.onPinchMove(event);
			event.preventDefault();
		}
	},

	onTouchEnd: function onTouchEnd(event) {
		var _this = this;

		if (this._initialTouch) {
			this.processEvent(event);
			var afterEndTouch;
			var movement = this.calculateMovement(this._lastTouch);
			if (movement.x <= (this.props.moveXThreshold || this.props.moveThreshold) && movement.y <= (this.props.moveYThreshold || this.props.moveThreshold) && this.props.onTap) {
				event.preventDefault();
				afterEndTouch = function afterEndTouch() {
					var finalParentScrollPos = _this._scrollParents.map(function (node) {
						return node.scrollTop + node.scrollLeft;
					});
					var stoppedMomentumScroll = _this._scrollParentPos.some(function (end, i) {
						return end !== finalParentScrollPos[i];
					});
					if (!stoppedMomentumScroll) {
						_this.props.onTap(event);
					}
				};
			}
			this.endTouch(event, afterEndTouch);
		} else if (this.onPinchEnd && this._initialPinch && event.touches.length + event.changedTouches.length === 2) {
			this.onPinchEnd(event);
			event.preventDefault();
		}
	},

	endTouch: function endTouch(event, callback) {
		this.cancelTouchmoveDetection();
		this.cancelPressDetection();
		this.clearActiveTimeout();
		if (event && this.props.onTouchEnd) {
			this.props.onTouchEnd(event);
		}
		this._initialTouch = null;
		this._lastTouch = null;
		if (callback) {
			callback();
		}
		if (this.state.isActive) {
			this.setState({
				isActive: false
			});
		}
	},

	onMouseDown: function onMouseDown(event) {
		if (window._blockMouseEvents) {
			window._blockMouseEvents = false;
			return;
		}
		if (this.props.onMouseDown && this.props.onMouseDown(event) === false) return;
		this.processEvent(event);
		this.initPressDetection(event, this.endMouseEvent);
		this._mouseDown = true;
		this.setState({
			isActive: true
		});
	},

	onMouseMove: function onMouseMove(event) {
		if (window._blockMouseEvents || !this._mouseDown) return;
		this.processEvent(event);
		this.props.onMouseMove && this.props.onMouseMove(event);
	},

	onMouseUp: function onMouseUp(event) {
		if (window._blockMouseEvents || !this._mouseDown) return;
		this.processEvent(event);
		this.props.onMouseUp && this.props.onMouseUp(event);
		this.props.onTap && this.props.onTap(event);
		this.endMouseEvent();
	},

	onMouseOut: function onMouseOut(event) {
		if (window._blockMouseEvents || !this._mouseDown) return;
		this.processEvent(event);
		this.props.onMouseOut && this.props.onMouseOut(event);
		this.endMouseEvent();
	},

	endMouseEvent: function endMouseEvent() {
		this.cancelPressDetection();
		this._mouseDown = false;
		this.setState({
			isActive: false
		});
	},

	onKeyUp: function onKeyUp(event) {
		if (!this._keyDown) return;
		this.processEvent(event);
		this.props.onKeyUp && this.props.onKeyUp(event);
		this.props.onTap && this.props.onTap(event);
		this._keyDown = false;
		this.cancelPressDetection();
		this.setState({
			isActive: false
		});
	},

	onKeyDown: function onKeyDown(event) {
		if (this.props.onKeyDown && this.props.onKeyDown(event) === false) return;
		if (event.which !== SPACE_KEY && event.which !== ENTER_KEY) return;
		if (this._keyDown) return;
		this.initPressDetection(event, this.endKeyEvent);
		this.processEvent(event);
		this._keyDown = true;
		this.setState({
			isActive: true
		});
	},

	endKeyEvent: function endKeyEvent() {
		this.cancelPressDetection();
		this._keyDown = false;
		this.setState({
			isActive: false
		});
	},

	cancelTap: function cancelTap() {
		this.endTouch();
		this._mouseDown = false;
	},

	handlers: function handlers() {
		return {
			onTouchStart: this.onTouchStart,
			onTouchMove: this.onTouchMove,
			onTouchEnd: this.onTouchEnd,
			onMouseDown: this.onMouseDown,
			onMouseUp: this.onMouseUp,
			onMouseMove: this.onMouseMove,
			onMouseOut: this.onMouseOut,
			onKeyDown: this.onKeyDown,
			onKeyUp: this.onKeyUp
		};
	}
};

module.exports = Mixin;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PropTypes = __webpack_require__(1);
var React = __webpack_require__(0);

function getPinchProps(touches) {
	return {
		touches: Array.prototype.map.call(touches, function copyTouch(touch) {
			return { identifier: touch.identifier, pageX: touch.pageX, pageY: touch.pageY };
		}),
		center: { x: (touches[0].pageX + touches[1].pageX) / 2, y: (touches[0].pageY + touches[1].pageY) / 2 },
		angle: Math.atan() * (touches[1].pageY - touches[0].pageY) / (touches[1].pageX - touches[0].pageX) * 180 / Math.PI,
		distance: Math.sqrt(Math.pow(Math.abs(touches[1].pageX - touches[0].pageX), 2) + Math.pow(Math.abs(touches[1].pageY - touches[0].pageY), 2))
	};
}

var Mixin = {
	propTypes: {
		onPinchStart: PropTypes.func, // fires when a pinch gesture is started
		onPinchMove: PropTypes.func, // fires on every touch-move when a pinch action is active
		onPinchEnd: PropTypes.func // fires when a pinch action ends
	},

	onPinchStart: function onPinchStart(event) {
		// in case the two touches didn't start exactly at the same time
		if (this._initialTouch) {
			this.endTouch();
		}
		var touches = event.touches;
		this._initialPinch = getPinchProps(touches);
		this._initialPinch = Object.assign(this._initialPinch, {
			displacement: { x: 0, y: 0 },
			displacementVelocity: { x: 0, y: 0 },
			rotation: 0,
			rotationVelocity: 0,
			zoom: 1,
			zoomVelocity: 0,
			time: Date.now()
		});
		this._lastPinch = this._initialPinch;
		this.props.onPinchStart && this.props.onPinchStart(this._initialPinch, event);
	},

	onPinchMove: function onPinchMove(event) {
		if (this._initialTouch) {
			this.endTouch();
		}
		var touches = event.touches;
		if (touches.length !== 2) {
			return this.onPinchEnd(event); // bail out before disaster
		}

		var currentPinch = touches[0].identifier === this._initialPinch.touches[0].identifier && touches[1].identifier === this._initialPinch.touches[1].identifier ? getPinchProps(touches) // the touches are in the correct order
		: touches[1].identifier === this._initialPinch.touches[0].identifier && touches[0].identifier === this._initialPinch.touches[1].identifier ? getPinchProps(touches.reverse()) // the touches have somehow changed order
		: getPinchProps(touches); // something is wrong, but we still have two touch-points, so we try not to fail

		currentPinch.displacement = {
			x: currentPinch.center.x - this._initialPinch.center.x,
			y: currentPinch.center.y - this._initialPinch.center.y
		};

		currentPinch.time = Date.now();
		var timeSinceLastPinch = currentPinch.time - this._lastPinch.time;

		currentPinch.displacementVelocity = {
			x: (currentPinch.displacement.x - this._lastPinch.displacement.x) / timeSinceLastPinch,
			y: (currentPinch.displacement.y - this._lastPinch.displacement.y) / timeSinceLastPinch
		};

		currentPinch.rotation = currentPinch.angle - this._initialPinch.angle;
		currentPinch.rotationVelocity = currentPinch.rotation - this._lastPinch.rotation / timeSinceLastPinch;

		currentPinch.zoom = currentPinch.distance / this._initialPinch.distance;
		currentPinch.zoomVelocity = (currentPinch.zoom - this._lastPinch.zoom) / timeSinceLastPinch;

		this.props.onPinchMove && this.props.onPinchMove(currentPinch, event);

		this._lastPinch = currentPinch;
	},

	onPinchEnd: function onPinchEnd(event) {
		// TODO use helper to order touches by identifier and use actual values on touchEnd.
		var currentPinch = Object.assign({}, this._lastPinch);
		currentPinch.time = Date.now();

		if (currentPinch.time - this._lastPinch.time > 16) {
			currentPinch.displacementVelocity = 0;
			currentPinch.rotationVelocity = 0;
			currentPinch.zoomVelocity = 0;
		}

		this.props.onPinchEnd && this.props.onPinchEnd(currentPinch, event);

		this._initialPinch = this._lastPinch = null;

		// If one finger is still on screen, it should start a new touch event for swiping etc
		// But it should never fire an onTap or onPress event.
		// Since there is no support swipes yet, this should be disregarded for now
		// if (event.touches.length === 1) {
		// 	this.onTouchStart(event);
		// }
	}
};

module.exports = Mixin;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createReactClass = __webpack_require__(361);
var PropTypes = __webpack_require__(1);
var React = __webpack_require__(0);
var touchStyles = __webpack_require__(384);

/**
 * Tappable Component
 * ==================
 */
module.exports = function (mixins) {
	return createReactClass({
		displayName: 'Tappable',

		mixins: mixins,

		propTypes: {
			component: PropTypes.any, // component to create
			className: PropTypes.string, // optional className
			classBase: PropTypes.string, // base for generated classNames
			classes: PropTypes.object, // object containing the active and inactive class names
			style: PropTypes.object, // additional style properties for the component
			disabled: PropTypes.bool // only applies to buttons
		},

		getDefaultProps: function getDefaultProps() {
			return {
				component: 'span',
				classBase: 'Tappable'
			};
		},

		render: function render() {
			var props = this.props;
			var className = props.classBase + (this.state.isActive ? '-active' : '-inactive');

			if (props.className) {
				className += ' ' + props.className;
			}

			if (props.classes) {
				className += ' ' + (this.state.isActive ? props.classes.active : props.classes.inactive);
			}

			var style = {};
			Object.assign(style, touchStyles, props.style);

			var newComponentProps = Object.assign({}, props, {
				style: style,
				className: className,
				disabled: props.disabled,
				handlers: this.handlers
			}, this.handlers());

			delete newComponentProps.activeDelay;
			delete newComponentProps.allowReactivation;
			delete newComponentProps.classBase;
			delete newComponentProps.classes;
			delete newComponentProps.handlers;
			delete newComponentProps.onTap;
			delete newComponentProps.onPress;
			delete newComponentProps.onPinchStart;
			delete newComponentProps.onPinchMove;
			delete newComponentProps.onPinchEnd;
			delete newComponentProps.onDeactivate;
			delete newComponentProps.onReactivate;
			delete newComponentProps.moveThreshold;
			delete newComponentProps.moveXThreshold;
			delete newComponentProps.moveYThreshold;
			delete newComponentProps.pressDelay;
			delete newComponentProps.pressMoveThreshold;
			delete newComponentProps.preventDefault;
			delete newComponentProps.stopPropagation;
			delete newComponentProps.component;

			return React.createElement(props.component, newComponentProps, props.children);
		}
	});
};

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_apps_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_apps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_apps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_WordMark_css__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_WordMark_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_students_WordMark_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_video_instructions_png__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_video_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_video_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_InstructionModals__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux_es_connect_connect__ = __webpack_require__(28);
var _this9=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var seconds=0;var minutes=0;var secs=0;var resultTime='';var tooltipStartTyping=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["i" /* Tooltip */],{id:'tooltipStartTyping'},'Start Typing!');var WordMarkComponent=function(_Component){_inherits(WordMarkComponent,_Component);function WordMarkComponent(props){_classCallCheck(this,WordMarkComponent);var _this=_possibleConstructorReturn(this,(WordMarkComponent.__proto__||Object.getPrototypeOf(WordMarkComponent)).call(this,props));_this.handleActive=function(active){_this.setState({active:active});};_this.state={active:0,passages:[],loadedScores:false,bestScores:{wordmarkScore:1,wordmarkLevel:1}};_this.handleActive=_this.handleActive.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(WordMarkComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_Helpers__["a" /* default */].authorize(this);case 2:_context3.next=4;return __WEBPACK_IMPORTED_MODULE_4__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!response.success){_context.next=3;break;}_context.next=3;return _this2.setState({loadedScores:true,bestScores:response.body});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 4:_context3.next=6;return __WEBPACK_IMPORTED_MODULE_4__Shared_REST__["a" /* default */].getWordMarkRandom().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!response.success){_context2.next=5;break;}_context2.next=3;return _this2.setState({passages:response.body});case 3:_context2.next=6;break;case 5:console.log('WordMark Error',response);case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}(),function(error){console.log('WordMark Error',error);});case 6:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'handleSurveyBack',value:function handleSurveyBack(){this.props.history.goBack();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.state.active!==2?"bgGrey WordMarkContainer":"bgYellow WordMarkContainer"},this.state.active===-1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer wordmark'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'WordMark'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 text-center"},this.state.loadedScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ProgressModalComponent_ProgressBox__["a" /* default */],{level:this.state.bestScores.wordmarkLevel,step:this.state.bestScores.wordmarkScore,steps:6,maxLevel:12}):null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["a" /* Buttons */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null,this.state.active===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer wordmark'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'WordMark'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["a" /* Buttons */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null,this.state.active===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["b" /* Buttons1 */],{demo:true,appName:"wordmark",practice:true,buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer wordmark'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'WordMark: Show Me'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["g" /* VideoComponent */],{url:"https://s3.us-east-2.amazonaws.com/uploaddev/video/wordmark/wordmark_trimmed.mp4"})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["a" /* Buttons */],{demo:true,appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null,this.state.active===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["b" /* Buttons1 */],{practice:true,appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tutorial,{studentUser:this.props.studentUser,buttonClick:this.handleActive,passage:this.state.passages[0],beginTest:this.handleBeginTest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["a" /* Buttons */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null,this.state.active===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["b" /* Buttons1 */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WordMarkContent,{studentUser:this.props.studentUser,handleSurveyBack:this.handleSurveyBack,buttonClick:this.handleActive,passages:this.state.passages}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["a" /* Buttons */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null);}}]);return WordMarkComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Tutorial=function(_Component2){_inherits(Tutorial,_Component2);function Tutorial(props){_classCallCheck(this,Tutorial);var _this3=_possibleConstructorReturn(this,(Tutorial.__proto__||Object.getPrototypeOf(Tutorial)).call(this,props));_this3.state={passage:_this3.props.passage};return _this3;}_createClass(Tutorial,[{key:'render',value:function render(){var passages=[];passages.push(this.props.passage);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WordMarkContent,{studentUser:this.props.studentUser,buttonClick:this.props.buttonClick,passages:passages,practice:true});}}]);return Tutorial;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var WordMarkContent=function(_Component3){_inherits(WordMarkContent,_Component3);function WordMarkContent(props){_classCallCheck(this,WordMarkContent);var _this4=_possibleConstructorReturn(this,(WordMarkContent.__proto__||Object.getPrototypeOf(WordMarkContent)).call(this,props));_this4.handleToggleInstruction=function(toggleInstruction){localStorage.setItem('WordmarkInstruction',toggleInstruction);};_this4.random=_this4.random.bind(_this4);_this4.state={popupSurvey:false,passages:_this4.props.passages,passage:_this4.props.passages[_this4.random()],hint:'Read the story starter above. \nIf you like it click \'Begin\'.\nIf you do not like it click \'Change\'\nYou have one minute to think about your story.\nYou will have three minutes to type your story.',started:false,story:'',time:60,finished:false,sessionTime:60,modalInstruction:false};_this4.timer=0;_this4.handleSurveyBack=_this4.handleSurveyBack.bind(_this4);_this4.startTimer=_this4.startTimer.bind(_this4);_this4.countDown=_this4.countDown.bind(_this4);_this4.handleSave=_this4.handleSave.bind(_this4);_this4.handleTextChange=_this4.handleTextChange.bind(_this4);_this4.handleChangeStory=_this4.handleChangeStory.bind(_this4);_this4.handleBegin=_this4.handleBegin.bind(_this4);_this4.handleClose=_this4.handleClose.bind(_this4);_this4.handleToggleInstruction=_this4.handleToggleInstruction.bind(_this4);_this4.onUnload=_this4.onUnload.bind(_this4);_this4.handleAnalytics=_this4.handleAnalytics.bind(_this4);return _this4;}_createClass(WordMarkContent,[{key:'onUnload',value:function onUnload(event){// the method that will be used for both add and remove event
event.returnValue="By leaving or reloading the page you will lose your app progress";}},{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:window.addEventListener("beforeunload",this.onUnload);_context4.next=3;return this.setState({modalInstruction:true});case 3:if(!this.state.modalInstruction){_context4.next=6;break;}_context4.next=6;return this.setState({story:this.state.passage.storyStarter.replace('...',' ')},function(){_this5.startTimer();});case 6:_context4.next=8;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_13__Shared_DataTrackingPoints__["b" /* default */].STUDENT_WM_START,metadata:{}}});case 8:this.handleAnalytics();case 9:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("beforeunload",this.onUnload);}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_4__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'startTimer',value:function startTimer(){this.timer=Object(__WEBPACK_IMPORTED_MODULE_6_timers__["setInterval"])(this.countDown,1000);}},{key:'countDown',value:function countDown(){seconds=this.state.time-1;minutes=parseInt(seconds/60,10);secs=parseInt(seconds%60,10);if(minutes>0){if(minutes===2&&secs===59){resultTime='3 minutes left';if(resultTime!==''){setTimeout(function(){resultTime='';}.bind(this),5000);}}if(minutes===1&&secs===59){resultTime='2 minutes left';if(resultTime!==''){setTimeout(function(){resultTime='';}.bind(this),5000);}}}else{if(minutes===0&&secs===59){resultTime='1 minute left';if(resultTime!==''){setTimeout(function(){resultTime='';}.bind(this),5000);}}if(secs===30){resultTime='30 seconds left';if(resultTime!==''){setTimeout(function(){resultTime='';}.bind(this),5000);}}if(secs<=15){resultTime=secs+' seconds left';}}this.setState({time:seconds});if(seconds===0){if(!this.state.started){this.setState({time:180,sessionTime:180,started:true,modalInstruction:false});}else{Object(__WEBPACK_IMPORTED_MODULE_6_timers__["clearInterval"])(this.timer);this.handleSave();}}}},{key:'random',value:function random(){var min=1;var max=this.props.passages.length;return Math.floor(min+Math.random()*(max-min)-1);}},{key:'handleTextChange',value:function handleTextChange(e){var _this6=this;this.setState({story:e.target.value},function(){console.log(_this6.state.story);});}},{key:'handleChangeStory',value:function handleChangeStory(e){var _this7=this;this.setState({passage:this.state.passages[this.random()],time:60},function(){_this7.setState({story:_this7.state.passage.storyStarter.replace('...','')});});}},{key:'handleBegin',value:function handleBegin(e){this.setState({started:true,time:180,sessionTime:180});}},{key:'handleSave',value:function handleSave(e){this.setState({started:false,finished:true});if(!this.props.practice){window.removeEventListener("beforeunload",this.onUnload);this.saveStory();}if(this.props.practice){this.props.buttonClick(0);}// e.preventDefault();
}},{key:'saveStory',value:function saveStory(){var storyStarter=this.state.passage.storyStarter.replace('...','');var fullStory=this.state.story;var savedStory=fullStory.replace(storyStarter,"");var body={storyStarterId:this.state.passage.id,studentResponse:savedStory,guid:""};__WEBPACK_IMPORTED_MODULE_4__Shared_REST__["a" /* default */].postWordMarkSession(body).then(function(response){console.log('Response',response);},function(error){console.log('Response Error',error);});}},{key:'handleClose',value:function handleClose(e){this.setState({finished:false,popupSurvey:true});}},{key:'handleSurveyBack',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:this.props.handleSurveyBack();case 1:case'end':return _context5.stop();}}},_callee5,this);}));function handleSurveyBack(){return _ref5.apply(this,arguments);}return handleSurveyBack;}()},{key:'prepareHint',value:function prepareHint(){var _state=this.state,time=_state.time,hint=_state.hint;var regex=/\n/g;var h=hint.split(regex);var t='';if(time<=60&&time>=57){t=h[0];}else if(time<57&&time>=54){t=t.concat(h[0]).concat('\n').concat(h[1]);}else if(time<54&&time>=51){t=t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]);}else if(time<51&&time>=48){t=t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]).concat('\n').concat(h[3]);}else{t=t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]).concat('\n').concat(h[3]).concat('\n').concat(h[4]);}return t;}},{key:'render',value:function render(){var _this8=this;var hint=this.prepareHint();var response='';if(this.state.story.length<=this.state.passage.storyStarter.length){response='There is nothing to score';}else{response='Your story was sent to your teacher';}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.practice?"appSection bgGrey":"appSection bgYellow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shared_DialogBox__["a" /* default */],{surveyModal:true,app:'WordMark',userId:this.props.studentUser.id,active:this.state.popupSurvey,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_InstructionModals__["a" /* default */],{WordMark:true,modalOpen:this.state.modalInstruction,instructionMask:__WEBPACK_IMPORTED_MODULE_11__assets_images_video_instructions_png___default.a,toggleInstruction:this.handleToggleInstruction,starterTitle:this.state.passage.storyStarter,time:this.state.time,sessionTime:this.state.sessionTime,beginClick:function beginClick(active){_this8.setState({modalInstruction:false,story:_this8.state.passage.storyStarter.replace('...',' ')});_this8.handleBegin();},buttonClick:this.props.buttonClick,changeClick:function changeClick(active){_this8.handleChangeStory();console.log('Change Story!');},closeClick:function closeClick(active){_this8.setState({modalInstruction:active,story:_this8.state.passage.storyStarter.replace('...',' ')});_this8.startTimer();}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'passage tc'},this.state.started?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* OverlayTrigger */],{placement:'top',overlay:tooltipStartTyping},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{ref:function ref(input){return input&&input.focus();},style:{marginTop:15},className:"wordmark1",spellCheck:false,value:this.state.story,onChange:this.handleTextChange})):null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tc'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row tc"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},this.state.started?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn hidden'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row pull-right"},this.state.started?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'inline-block',position:'relative',fontFamily:'mainFont',fontStyle:'sans-serif',fontSize:'1.5em',top:-60}},resultTime),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:resultTime===''?"hidden":"",style:{display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Common__["c" /* CountDownComponent */],{time:this.state.time,sessionTime:this.state.sessionTime,showTime:this.state.sessionTime}))):null))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["a" /* Modal */],{id:"resultBox",show:this.state.finished&&!this.props.practice},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{marginBottom:25,fontSize:35}},'Finished'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'handBtn',style:{marginTop:15},onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close')))))));}}]);return WordMarkContent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context6.abrupt('return',_context6.sent);case 3:case'end':return _context6.stop();}}},_callee6,_this9);}));function updateStudentAppStatus(_x3){return _ref6.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context7.abrupt('return',_context7.sent);case 3:case'end':return _context7.stop();}}},_callee7,_this9);}));function updateStudentAccountTab(_x4){return _ref7.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["a" /* updateAppStates */])(appStates));case 2:return _context8.abrupt('return',_context8.sent);case 3:case'end':return _context8.stop();}}},_callee8,_this9);}));function updateAppStates(_x5){return _ref8.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* withRouter */])(WordMarkComponent)));

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_radio_group__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_apps_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_apps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_apps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_students_WordMark_css__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_students_WordMark_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_students_WordMark_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_video_instructions_png__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_video_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_video_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_InstructionModals__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_rotate_device_fff_bg_png__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_rotate_device_fff_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_rotate_device_fff_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_videoInstructionFull_png__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_videoInstructionFull_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_videoInstructionFull_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_startButton_png__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_startButton_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_startButton_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_wordMark2_Whiteboard_png__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_wordMark2_Whiteboard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_images_wordMark2_Whiteboard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_wordMark2_Hedgehog_png__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_wordMark2_Hedgehog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_images_wordMark2_Hedgehog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_wordMark2_Pig_png__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_wordMark2_Pig_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_images_wordMark2_Pig_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_wordMark2_Rainbow_spinner_png__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_wordMark2_Rainbow_spinner_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_images_wordMark2_Rainbow_spinner_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_images_wordMark2_Wheel_png__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_images_wordMark2_Wheel_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_images_wordMark2_Wheel_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_wordMark2_Spinner_pick_arrow_png__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_images_wordMark2_Spinner_pick_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_images_wordMark2_Spinner_pick_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_images_wordMark2_Speech_bubble_right_adjusted_png__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_images_wordMark2_Speech_bubble_right_adjusted_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_images_wordMark2_Speech_bubble_right_adjusted_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_images_wordMark2_Yellow_arrow_png__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_images_wordMark2_Yellow_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_images_wordMark2_Yellow_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_images_wordMark2_Yellow_arrow_rotate_png__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_images_wordMark2_Yellow_arrow_rotate_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_images_wordMark2_Yellow_arrow_rotate_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_images_wordMark2_Yellow_arrow_2_png__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_images_wordMark2_Yellow_arrow_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_images_wordMark2_Yellow_arrow_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_images_wordMark2_Speech_bubble_left_adjusted_png__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_images_wordMark2_Speech_bubble_left_adjusted_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_images_wordMark2_Speech_bubble_left_adjusted_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_images_wordMark2_Cow_png__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_images_wordMark2_Cow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__assets_images_wordMark2_Cow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_images_wordMark2_LineRight_png__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_images_wordMark2_LineRight_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__assets_images_wordMark2_LineRight_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_images_wordMark2_LineLeft_png__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_images_wordMark2_LineLeft_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__assets_images_wordMark2_LineLeft_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_images_modal_x_red_png__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_images_modal_x_red_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__assets_images_modal_x_red_png__);
var _this15=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var seconds=0;var minutes=0;var secs=0;var resultTime='';var TaskTime=180;var tooltipStartTyping=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["i" /* Tooltip */],{id:'tooltipStartTyping'},'Start Typing!');var WordMark2Component=function(_Component){_inherits(WordMark2Component,_Component);function WordMark2Component(props){_classCallCheck(this,WordMark2Component);var _this=_possibleConstructorReturn(this,(WordMark2Component.__proto__||Object.getPrototypeOf(WordMark2Component)).call(this,props));_this.handleActive=function(active){_this.setState({active:active});};_this.state={active:0,passages:[],loadedScores:false,bestScores:{wordmarkScore:1,wordmarkLevel:1}};_this.handleActive=_this.handleActive.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(WordMark2Component,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);case 2:_context2.next=4;return __WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!response.success){_context.next=3;break;}_context.next=3;return _this2.setState({loadedScores:true,bestScores:response.body});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 4:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'handleSurveyBack',value:function handleSurveyBack(){this.props.history.goBack();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.state.active!==2?"bgGrey WordMarkContainer":"bgYellow WordMarkContainer"},this.state.active===-1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer wordmark'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'WordMark2'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 text-center"},this.state.loadedScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ProgressModalComponent_ProgressBox__["a" /* default */],{level:this.state.bestScores.wordmarkLevel,step:this.state.bestScores.wordmarkScore,steps:6,maxLevel:12}):null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["a" /* Buttons */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null,this.state.active===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer wordmark'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'WordMark2'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:800,marginTop:10,marginLeft:100,textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:"20px",fontFamily:'Neucha',letterSpacing:'4px',fontWeight:"bold"}},'You have 3 minutes to write a story.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:80,marginLeft:'auto',marginRight:'auto',marginTop:150}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_33__assets_images_wordMark2_Cow_png___default.a,style:{width:80}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3",style:{}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_34__assets_images_wordMark2_LineRight_png___default.a,style:{width:20,marginTop:-250,marginLeft:550}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3",style:{marginLeft:560,marginTop:-240}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Spin a wheel.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' Pick your ideas.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Write a story \uFF01')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:800,marginTop:10,marginLeft:100,textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:"20px",fontFamily:'Neucha',letterSpacing:'4px',fontWeight:"bold"}},'Your story will be saved automatically after 3 minutes.'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["a" /* Buttons */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null,this.state.active===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["b" /* Buttons1 */],{demo:true,appName:"wordmark",practice:true,buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer wordmark'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'WordMark2: Show Me'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{marginLeft:'auto',marginRight:'auto',width:830}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["h" /* YouTubeVideoComponent */],{width:800,height:600,url:"https://www.youtube.com/embed/xpX8pIwkWmc?rel=0"})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["a" /* Buttons */],{demo:true,appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null,this.state.active===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["b" /* Buttons1 */],{practice:true,appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tutorial,{studentUser:this.props.studentUser,buttonClick:this.handleActive,passage:this.state.passages[0],beginTest:this.handleBeginTest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["a" /* Buttons */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null,this.state.active===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["b" /* Buttons1 */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WordMarkContent,{studentUser:this.props.studentUser,handleSurveyBack:this.handleSurveyBack,buttonClick:this.handleActive,passages:this.state.passages}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["a" /* Buttons */],{appName:"wordmark",buttonClick:this.handleActive,currentTabActive:this.state.active,noScore:true})):null);}}]);return WordMark2Component;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Tutorial=function(_Component2){_inherits(Tutorial,_Component2);function Tutorial(props){_classCallCheck(this,Tutorial);var _this3=_possibleConstructorReturn(this,(Tutorial.__proto__||Object.getPrototypeOf(Tutorial)).call(this,props));_this3.state={passage:_this3.props.passage};return _this3;}_createClass(Tutorial,[{key:'render',value:function render(){var passages=[];passages.push(this.props.passage);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WordMarkContent,{studentUser:this.props.studentUser,buttonClick:this.props.buttonClick,passages:passages,practice:true});}}]);return Tutorial;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var WordMarkContent=function(_Component3){_inherits(WordMarkContent,_Component3);function WordMarkContent(props){var _this5=this;_classCallCheck(this,WordMarkContent);var _this4=_possibleConstructorReturn(this,(WordMarkContent.__proto__||Object.getPrototypeOf(WordMarkContent)).call(this,props));_this4.detect=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this4.setState({device:!!navigator.maxTouchPoints?'mobile':'computer',orientation:!navigator.maxTouchPoints?'desktop':navigator.platform.includes('Linux')?'ChromeBook':!window.screen.orientation.angle?'portrait':'landscape'});case 2:case'end':return _context3.stop();}}},_callee3,_this5);}));_this4.handleToggleInstruction=function(toggleInstruction){localStorage.setItem('WordmarkInstruction',toggleInstruction);};_this4.random=_this4.random.bind(_this4);_this4.state={popupSurvey:false,device:!!navigator.maxTouchPoints?'mobile':'computer',orientation:!navigator.maxTouchPoints?'desktop':navigator.platform.includes('Linux')?'ChromeBook':!(window.screen.orientation&&window.screen.orientation.angle)?'portrait':'landscape',passages:_this4.props.passages,passage:_this4.props.passages[_this4.random()],hint:'Read the story starter above. \nIf you like it click \'Begin\'.\nIf you do not like it click \'Change\'\nYou have one minute to think about your story.\nYou will have three minutes to type your story.',started:false,story:'',time:60,thinkTime:60,finished:false,sessionTime:60,modalInstruction:false,showNotice:false,chosenWord1:'',chosenWord1Id:-1,chosenWord2:'',chosenWord2Id:-1,startNowClicked:false,practiceFinished:false};_this4.timer=0;_this4.thinkTimer=0;_this4.hideInstruction=_this4.hideInstruction.bind(_this4);_this4.handleSurveyBack=_this4.handleSurveyBack.bind(_this4);_this4.startTimer=_this4.startTimer.bind(_this4);_this4.countDown=_this4.countDown.bind(_this4);_this4.handleSave=_this4.handleSave.bind(_this4);_this4.handleTextChange=_this4.handleTextChange.bind(_this4);_this4.handleChangeStory=_this4.handleChangeStory.bind(_this4);_this4.handleBegin=_this4.handleBegin.bind(_this4);_this4.handleClose=_this4.handleClose.bind(_this4);_this4.handleToggleInstruction=_this4.handleToggleInstruction.bind(_this4);_this4.onUnload=_this4.onUnload.bind(_this4);_this4.handleAnalytics=_this4.handleAnalytics.bind(_this4);_this4.updateChosenWords=_this4.updateChosenWords.bind(_this4);_this4.thinkCountDown=_this4.thinkCountDown.bind(_this4);_this4.startThinkTimer=_this4.startThinkTimer.bind(_this4);_this4.handleStartNow=_this4.handleStartNow.bind(_this4);return _this4;}_createClass(WordMarkContent,[{key:'onUnload',value:function onUnload(event){// the method that will be used for both add and remove event
event.returnValue="By leaving or reloading the page you will lose your app progress";}},{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:window.addEventListener("resize",this.detect);window.addEventListener("beforeunload",this.onUnload);_context4.next=4;return this.setState({modalInstruction:true});case 4:_context4.next=6;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__["b" /* default */].STUDENT_WM_START,metadata:{}}});case 6:this.handleAnalytics();case 7:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("beforeunload",this.onUnload);}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'startTimer',value:function startTimer(){this.timer=Object(__WEBPACK_IMPORTED_MODULE_8_timers__["setInterval"])(this.countDown,1000);}},{key:'countDown',value:function countDown(){seconds=this.state.time-1;minutes=parseInt(seconds/60,10);secs=parseInt(seconds%60,10);if(minutes>0){if(minutes===2&&secs===59){resultTime='3 minutes left';if(resultTime!==''){setTimeout(function(){resultTime='';}.bind(this),5000);}}if(minutes===1&&secs===59){resultTime='2 minutes left';if(resultTime!==''){setTimeout(function(){resultTime='';}.bind(this),5000);}}}else{if(minutes===0&&secs===59){resultTime='1 minute left';if(resultTime!==''){setTimeout(function(){resultTime='';}.bind(this),5000);}}if(secs===30){resultTime='30 seconds left';if(resultTime!==''){setTimeout(function(){resultTime='';}.bind(this),5000);}}if(secs<=15){resultTime=secs+' seconds left';}}this.setState({time:seconds});if(seconds===0){if(!this.state.started){this.setState({time:TaskTime,sessionTime:TaskTime,started:true,modalInstruction:false});}else if(!this.props.practice){Object(__WEBPACK_IMPORTED_MODULE_8_timers__["clearInterval"])(this.timer);this.handleSave();}else if(this.props.practice){Object(__WEBPACK_IMPORTED_MODULE_8_timers__["clearInterval"])(this.timer);this.setState({practiceFinished:true});}}}},{key:'startThinkTimer',value:function startThinkTimer(){this.thinkTimer=Object(__WEBPACK_IMPORTED_MODULE_8_timers__["setInterval"])(this.thinkCountDown,1000);}},{key:'thinkCountDown',value:function thinkCountDown(){seconds=this.state.thinkTime-1;minutes=parseInt(seconds/60,10);secs=parseInt(seconds%60,10);this.setState({thinkTime:seconds});if(seconds===0){this.setState({time:TaskTime,sessionTime:TaskTime,started:true,modalInstruction:false});Object(__WEBPACK_IMPORTED_MODULE_8_timers__["clearInterval"])(this.thinkTimer);this.startTimer();}}},{key:'handleStartNow',value:function handleStartNow(){this.setState({time:TaskTime,sessionTime:TaskTime,started:true,modalInstruction:false});Object(__WEBPACK_IMPORTED_MODULE_8_timers__["clearInterval"])(this.thinkTimer);this.startTimer();}},{key:'random',value:function random(){var min=1;var max=this.props.passages.length;return Math.floor(min+Math.random()*(max-min)-1);}},{key:'handleTextChange',value:function handleTextChange(e){var _this6=this;this.setState({story:e.target.value},function(){console.log(_this6.state.story);});}},{key:'handleChangeStory',value:function handleChangeStory(e){var _this7=this;this.setState({passage:this.state.passages[this.random()],time:60},function(){_this7.setState({story:_this7.state.passage.storyStarter.replace('...','')});});}},{key:'handleBegin',value:function handleBegin(e){this.setState({started:true,time:TaskTime,sessionTime:TaskTime});}},{key:'handleSave',value:function handleSave(e){this.setState({started:false,finished:true});if(!this.props.practice){window.removeEventListener("beforeunload",this.onUnload);this.saveStory();}if(this.props.practice){this.props.buttonClick(0);}// e.preventDefault();
}},{key:'saveStory',value:function saveStory(){var body={storyPrompt1:this.state.chosenWord1,storyPrompt1Id:this.state.chosenWord1Id,storyPrompt2:this.state.chosenWord2,storyPrompt2Id:this.state.chosenWord2Id,studentResponse:this.state.story,guid:""};__WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].postWordMark2Session(body).then(function(response){console.log('Response',response);},function(error){console.log('Response Error',error);});}},{key:'handleShowNotice',value:function handleShowNotice(){this.setState({showNotice:true});}},{key:'handleClose',value:function handleClose(e){this.setState({finished:false,popupSurvey:true});}},{key:'hideInstruction',value:function hideInstruction(){console.log('timeout003');this.setState({modalInstruction:false});this.startThinkTimer();}},{key:'updateChosenWords',value:function updateChosenWords(chosenWord1,chosenWord1Id,chosenWord2,chosenWord2Id){console.log('updateChosenWords');this.setState({chosenWord1:chosenWord1,chosenWord1Id:chosenWord1Id,chosenWord2:chosenWord2,chosenWord2Id:chosenWord2Id});}},{key:'handleSurveyBack',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:this.props.handleSurveyBack();case 1:case'end':return _context5.stop();}}},_callee5,this);}));function handleSurveyBack(){return _ref5.apply(this,arguments);}return handleSurveyBack;}()},{key:'prepareHint',value:function prepareHint(){var _state=this.state,time=_state.time,hint=_state.hint;var regex=/\n/g;var h=hint.split(regex);var t='';if(time<=60&&time>=57){t=h[0];}else if(time<57&&time>=54){t=t.concat(h[0]).concat('\n').concat(h[1]);}else if(time<54&&time>=51){t=t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]);}else if(time<51&&time>=48){t=t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]).concat('\n').concat(h[3]);}else{t=t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]).concat('\n').concat(h[3]).concat('\n').concat(h[4]);}return t;}},{key:'render',value:function render(){var _this8=this;var hint=this.prepareHint();var response='';if(this.state.passage&&this.state.passage.storyStarter&&this.state.story.length<=this.state.passage.storyStarter.length){response='There is nothing to score';}else{response='Your story was sent to your teacher';}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.practice?"appSection bgGrey":"appSection bgYellow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Shared_DialogBox__["a" /* default */],{surveyModal:true,app:'WordMark',userId:this.props.studentUser.id,active:this.state.popupSurvey,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WordMark2Modal,{modalOpen:this.state.modalInstruction,instructionMask:__WEBPACK_IMPORTED_MODULE_13__assets_images_video_instructions_png___default.a,toggleInstruction:this.handleToggleInstruction,time:this.state.time,sessionTime:this.state.sessionTime,buttonClick:this.props.buttonClick,changeClick:function changeClick(active){_this8.handleChangeStory();console.log('Change Story!');},hideInstruction:this.hideInstruction,updateChosenWords:this.updateChosenWords}),this.state.started?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontStyle:"bold",fontSize:"30px",textAlign:"center"}},'Write a Story With'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontStyle:"normal",fontSize:"30px",textTransform:'uppercase',textAlign:"center"}},'"',this.state.chosenWord1,'" And "',this.state.chosenWord2,'"'))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'passage tc'},this.state.started?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* OverlayTrigger */],{placement:'top',overlay:tooltipStartTyping},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{ref:function ref(input){return input&&input.focus();},style:{marginTop:50},className:"wordmark1",spellCheck:false,value:this.state.story,onChange:this.handleTextChange})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:400,marginTop:200}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:-200,marginTop:-100,width:800}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontStyle:"normal",fontSize:"40px"}},'You have 3 Minutes to Write a Story With'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontStyle:"normal",fontSize:"30",textTransform:'uppercase'}},'"',this.state.chosenWord1,'" And "',this.state.chosenWord2,'"'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:-400,marginTop:-50}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_23__assets_images_wordMark2_Hedgehog_png___default.a,style:{width:150,marginTop:200}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{marginTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:400,marginTop:10,width:300}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontStyle:"normal",fontSize:28}},'ONE MINUTE TO THINK')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:500,marginTop:-80}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:-250}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["c" /* CountDownComponent */],{time:this.state.thinkTime,sessionTime:this.state.sessionTime})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontStyle:"normal",fontSize:28,marginLeft:120,marginTop:-90}},'Or'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-1",style:{marginTop:-60,marginLeft:780}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleStartNow,className:'handBtn active',style:{width:150,fontSize:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Start Now')))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tc'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row tc"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},this.state.started?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleSave,className:'handBtn hidden'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row pull-right"},this.state.started?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'inline-block',position:'relative',fontFamily:'mainFont',fontStyle:'sans-serif',fontSize:'1.5em',top:-60}},resultTime),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:resultTime===''?"hidden":"",style:{display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["c" /* CountDownComponent */],{time:this.state.time,sessionTime:this.state.sessionTime}))):null))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["a" /* Modal */],{id:"resultBox",show:this.state.finished&&!this.props.practice},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{marginBottom:25,fontSize:35}},'Finished'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'handBtn',style:{marginTop:15},onClick:this.handleClose},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["a" /* Modal */],{id:"resultBox",show:this.state.practiceFinished&&this.props.practice},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{marginBottom:25,fontSize:35}},'Finished'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginBottom:25,fontSize:25}},'This will not be sent to your teacher.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'handBtn',style:{marginTop:15},onClick:this.handleSave},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close')))))));}}]);return WordMarkContent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var WordMark2Modal=function(_Component4){_inherits(DialogBoxComponent,_Component4);function DialogBoxComponent(props){_classCallCheck(this,DialogBoxComponent);var _this9=_possibleConstructorReturn(this,(DialogBoxComponent.__proto__||Object.getPrototypeOf(DialogBoxComponent)).call(this,props));_this9.state={isModalOpen:_this9.props.modalOpen?_this9.props.modalOpen:false};_this9.closeModal=_this9.closeModal.bind(_this9);_this9.instructionToggle=_this9.instructionToggle.bind(_this9);_this9.hideInstruction=_this9.hideInstruction.bind(_this9);return _this9;}_createClass(DialogBoxComponent,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'openModal',value:function openModal(){this.setState({isModalOpen:true});}},{key:'instructionToggle',value:function instructionToggle(event){this.props.toggleInstruction(event.target.checked);}},{key:'closeModal',value:function closeModal(){this.props.closeClick(false);this.setState({isModalOpen:false});}},{key:'hideInstruction',value:function hideInstruction(){console.log('timeout002');this.props.hideInstruction();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["a" /* Modal */],{id:'WordMark2Box',show:this.props.modalOpen},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:1200,height:1000,maxHeight:"100%",marginLeft:"auto",marginRight:"auto",marginTop:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wordmark2Instruction,{buttonClick:this.props.buttonClick,hideInstruction:this.hideInstruction,updateChosenWords:this.props.updateChosenWords,beginClick:this.props.beginClick,changeClick:this.props.changeClick,time:this.props.time,sessionTime:this.props.sessionTime,starterTitle:this.props.starterTitle,instructionMask:__WEBPACK_IMPORTED_MODULE_20__assets_images_videoInstructionFull_png___default.a,startButton:__WEBPACK_IMPORTED_MODULE_21__assets_images_startButton_png___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12"}))))));}}]);return DialogBoxComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Wordmark2Instruction=function(_Component5){_inherits(Wordmark2Instruction,_Component5);function Wordmark2Instruction(props){_classCallCheck(this,Wordmark2Instruction);var _this10=_possibleConstructorReturn(this,(Wordmark2Instruction.__proto__||Object.getPrototypeOf(Wordmark2Instruction)).call(this,props));_this10.state={key:1,wordList:['','','','','',''],wordIdList:[-1,-1,-1,-1,-1,-1],word1:'',word2:'',word3:'',word4:'',word5:'',word6:'',chosenWord1:'',chosenWord1Id:-1,chosenWord2:'',chosenWord2Id:-1,arrowShowed:'',timer:null,timer1:null,timer2:null,time:5000,previousSpinNumber1:0,previousSpinNumber2:0,spinStyle1:{width:220,cursor:'pointer'},spinStyle2:{width:220,cursor:'pointer'},spinning2:false,checkAllow1:false,checkAllow2:false,progress:'start0',selectedValue1:'',selectedValue2:'',bothWordChosen:false};_this10.handleSelect=_this10.handleSelect.bind(_this10);_this10.beginStory=_this10.beginStory.bind(_this10);_this10.changeStory=_this10.changeStory.bind(_this10);_this10.handleBack=_this10.handleBack.bind(_this10);_this10.shuffleWords=_this10.shuffleWords.bind(_this10);_this10.handleRainbowSpin1=_this10.handleRainbowSpin1.bind(_this10);_this10.handleRainbowSpin2=_this10.handleRainbowSpin2.bind(_this10);_this10.handleWordChecked1=_this10.handleWordChecked1.bind(_this10);_this10.handleWordChecked2=_this10.handleWordChecked2.bind(_this10);_this10.handleStartWriting=_this10.handleStartWriting.bind(_this10);return _this10;}_createClass(Wordmark2Instruction,[{key:'componentDidMount',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var _this11=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return __WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].getWordMark2Random1().then(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(response){var wordList,wordIdList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!response.success){_context6.next=13;break;}wordList=[];wordIdList=[];wordList[0]=response.body[0].storyStarter;wordList[1]=response.body[1].storyStarter;wordList[2]=response.body[2].storyStarter;wordIdList[0]=response.body[0].id;wordIdList[1]=response.body[1].id;wordIdList[2]=response.body[2].id;_context6.next=11;return _this11.setState({wordList:wordList,wordIdList:wordIdList});case 11:_context6.next=14;break;case 13:console.log('WordMark Error',response);case 14:case'end':return _context6.stop();}}},_callee6,_this11);}));return function(_x2){return _ref7.apply(this,arguments);};}(),function(error){console.log('WordMark Error',error);});case 2:_context8.next=4;return __WEBPACK_IMPORTED_MODULE_6__Shared_REST__["a" /* default */].getWordMark2Random2().then(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response){var wordList,wordIdList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!response.success){_context7.next=19;break;}wordList=[];wordIdList=[];wordList[0]=_this11.state.wordList[0];wordList[1]=_this11.state.wordList[1];wordList[2]=_this11.state.wordList[2];wordList[3]=response.body[0].storyStarter;wordList[4]=response.body[1].storyStarter;wordList[5]=response.body[2].storyStarter;wordIdList[0]=_this11.state.wordIdList[0];wordIdList[1]=_this11.state.wordIdList[1];wordIdList[2]=_this11.state.wordIdList[2];wordIdList[3]=response.body[0].id;wordIdList[4]=response.body[1].id;wordIdList[5]=response.body[2].id;_context7.next=17;return _this11.setState({wordList:wordList,wordIdList:wordIdList});case 17:_context7.next=20;break;case 19:console.log('WordMark Error',response);case 20:case'end':return _context7.stop();}}},_callee7,_this11);}));return function(_x3){return _ref8.apply(this,arguments);};}(),function(error){console.log('WordMark Error',error);});case 4:case'end':return _context8.stop();}}},_callee8,this);}));function componentDidMount(){return _ref6.apply(this,arguments);}return componentDidMount;}()},{key:'handleSelect',value:function handleSelect(key){this.setState({key:key});}},{key:'beginStory',value:function beginStory(){this.props.beginClick(true);}},{key:'changeStory',value:function changeStory(){this.props.changeClick(true);}},{key:'handleBack',value:function handleBack(){this.props.buttonClick(0);}},{key:'shuffleWords',value:function shuffleWords(){var currentIndex=this.state.wordList.length,randomIndex;// While there remain elements to shuffle...
while(currentIndex!=0){// Pick a remaining element...
randomIndex=Math.floor(Math.random()*currentIndex);currentIndex--;// And swap it with the current element.
var _ref9=[this.state.wordList[randomIndex],this.state.wordList[currentIndex]];this.state.wordList[currentIndex]=_ref9[0];this.state.wordList[randomIndex]=_ref9[1];}}},{key:'handleWordChecked1',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(wordNo){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:console.log("chosen001-0");console.log(this.state.progress);if(!(this.state.progress=='spinWord6'||this.state.progress=='choseWord1'||this.state.progress=='choseWord2')){_context9.next=15;break;}console.log("chosen001-1");console.log(this.state.arrowShowed);if(!(this.state.arrowShowed=='')){_context9.next=9;break;}console.log("chosen001-2");_context9.next=9;return this.setState({chosenWord1:this.state.wordList[wordNo],chosenWord1Id:this.state.wordIdList[wordNo],progress:'choseWord1',checkAllow2:true,selectedValue1:wordNo+""});case 9:if(!(this.state.arrowShowed=='1')){_context9.next=15;break;}console.log("chosen001-3");console.log(this.state.selectedValue1);_context9.next=14;return this.setState({chosenWord1:this.state.wordList[wordNo],chosenWord1Id:this.state.wordIdList[wordNo],progress:'choseWord2',checkAllow2:true,selectedValue1:wordNo+""});case 14:console.log(this.state.selectedValue1);case 15:case'end':return _context9.stop();}}},_callee9,this);}));function handleWordChecked1(_x4){return _ref10.apply(this,arguments);}return handleWordChecked1;}()},{key:'handleWordChecked2',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(wordNo){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(!this.state.checkAllow2){_context10.next=4;break;}if(!(this.state.progress=='choseWord1'||this.state.progress=='choseWord2')){_context10.next=4;break;}_context10.next=4;return this.setState({chosenWord2:this.state.wordList[wordNo],chosenWord2Id:this.state.wordIdList[wordNo],progress:'choseWord2',selectedValue2:wordNo+""});case 4:if(!(this.state.arrowShowed==''&&this.state.checkAllow2)){_context10.next=7;break;}_context10.next=7;return this.setState({arrowShowed:'1'});case 7:if(!(this.state.checkAllow2==true&&this.state.progress=='choseWord2')){_context10.next=10;break;}_context10.next=10;return this.setState({bothWordChosen:true});case 10:case'end':return _context10.stop();}}},_callee10,this);}));function handleWordChecked2(_x5){return _ref11.apply(this,arguments);}return handleWordChecked2;}()},{key:'handleStartWriting',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:if(this.state.progress=='choseWord2'||this.state.progress=='choseWord1'){this.props.updateChosenWords(this.state.chosenWord1,this.state.chosenWord1Id,this.state.chosenWord2,this.state.chosenWord2Id);this.props.hideInstruction();}case 1:case'end':return _context11.stop();}}},_callee11,this);}));function handleStartWriting(){return _ref12.apply(this,arguments);}return handleStartWriting;}()},{key:'handleRainbowSpin1',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(){var _this12=this;var randomNum,timer1,timer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:if(!this.state.wordList[0]){_context14.next=7;break;}randomNum=Number((Math.random()*8+4).toFixed());timer1=Object(__WEBPACK_IMPORTED_MODULE_8_timers__["setInterval"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:if(!(_this12.state.progress=='start0')){_context12.next=5;break;}_context12.next=3;return _this12.setState({progress:'spinWord1',word1:_this12.state.wordList[0]});case 3:_context12.next=16;break;case 5:if(!(_this12.state.progress=='spinWord1')){_context12.next=10;break;}_context12.next=8;return _this12.setState({progress:'spinWord2',word2:_this12.state.wordList[1]});case 8:_context12.next=16;break;case 10:if(!(_this12.state.progress=='spinWord2')){_context12.next=15;break;}_context12.next=13;return _this12.setState({progress:'spinWord3',word3:_this12.state.wordList[2]});case 13:_context12.next=16;break;case 15:if(_this12.state.progress=='spinWord3'){_this12.setState({progress:'spinWord4',word4:_this12.state.wordList[3]});}else if(_this12.state.progress=='spinWord4'){_this12.setState({progress:'spinWord5',word5:_this12.state.wordList[4]});}else if(_this12.state.progress=='spinWord5'){_this12.setState({progress:'spinWord6',checkAllow1:true,word6:_this12.state.wordList[5]});}case 16:Object(__WEBPACK_IMPORTED_MODULE_8_timers__["clearInterval"])(timer1);case 17:case'end':return _context12.stop();}}},_callee12,_this12);})),this.state.previousSpinNumber1==0?randomNum*83:(12-this.state.previousSpinNumber1+randomNum)*83);if(!(this.state.previousSpinNumber1>0)){_context14.next=6;break;}_context14.next=6;return this.setState({spinStyle1:{cursor:'pointer',width:220,animation:'backSpin'+this.state.previousSpinNumber1+' '+(1-this.state.previousSpinNumber1/12)+'s linear 1'// 'spin'+ randomNum + ` 3s linear 1`
}});case 6:timer=Object(__WEBPACK_IMPORTED_MODULE_8_timers__["setInterval"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return _this12.setState({spinStyle1:{cursor:'pointer',width:220,transform:'rotate(0deg)'}});case 2:_context13.next=4;return _this12.setState({previousSpinNumber1:randomNum,spinStyle1:{cursor:'pointer',width:220,animation:'spin'+randomNum+' '+randomNum/12+'s linear 1',// 'spin'+ randomNum + ` 3s linear 1`
transform:'rotate('+randomNum*30+'deg)'}});case 4:Object(__WEBPACK_IMPORTED_MODULE_8_timers__["clearInterval"])(timer);case 5:case'end':return _context13.stop();}}},_callee13,_this12);})),this.state.previousSpinNumber1==0?1:(12-this.state.previousSpinNumber1)*83);case 7:case'end':return _context14.stop();}}},_callee14,this);}));function handleRainbowSpin1(){return _ref13.apply(this,arguments);}return handleRainbowSpin1;}()},{key:'handleRainbowSpin2',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(){var _this13=this;var randomNum,timer1,timer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:randomNum=Number((Math.random()*8+4).toFixed());timer1=Object(__WEBPACK_IMPORTED_MODULE_8_timers__["setInterval"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:if(_this13.state.progress=='spinWord3'){_this13.setState({progress:'spinWord4',word4:_this13.state.wordList[3]});}else if(_this13.state.progress=='spinWord4'){_this13.setState({progress:'spinWord5',word5:_this13.state.wordList[4]});}else if(_this13.state.progress=='spinWord5'){_this13.setState({progress:'spinWord6',checkAllow1:true,word6:_this13.state.wordList[5]});}Object(__WEBPACK_IMPORTED_MODULE_8_timers__["clearInterval"])(timer1);case 2:case'end':return _context15.stop();}}},_callee15,_this13);})),this.state.previousSpinNumber2==0?randomNum*83:(12-this.state.previousSpinNumber2+randomNum)*83);if(!(this.state.previousSpinNumber2>0)){_context17.next=5;break;}_context17.next=5;return this.setState({spinStyle2:{width:220,animation:'backSpin'+this.state.previousSpinNumber2+' '+(1-this.state.previousSpinNumber2/12)+'s linear 1'}});case 5:timer=Object(__WEBPACK_IMPORTED_MODULE_8_timers__["setInterval"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return _this13.setState({spinStyle2:{width:220,transform:'rotate(0deg)'}});case 2:_context16.next=4;return _this13.setState({previousSpinNumber2:randomNum,spinStyle2:{width:220,animation:'spin'+randomNum+' '+randomNum/12+'s linear 1',// 'spin'+ randomNum + ` 3s linear 1`
transform:'rotate('+randomNum*30+'deg)'}});case 4:Object(__WEBPACK_IMPORTED_MODULE_8_timers__["clearInterval"])(timer);case 5:case'end':return _context16.stop();}}},_callee16,_this13);})),this.state.previousSpinNumber2==0?1:(12-this.state.previousSpinNumber2)*83);case 6:case'end':return _context17.stop();}}},_callee17,this);}));function handleRainbowSpin2(){return _ref16.apply(this,arguments);}return handleRainbowSpin2;}()},{key:'render',value:function render(){var _this14=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12",style:{textAlign:'center',marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Common__["b" /* Buttons1 */],{appName:"wordmark",buttonClick:this.handleBack,noScore:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:-100}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'WordMark2')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["h" /* Tabs */],{activeKey:this.state.key,onSelect:this.handleSelect,id:'wordmarkTab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["g" /* Tab */],{eventKey:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-6",style:{marginTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"wordMarkWhiteBoard",style:{marginTop:-150}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'IDEA 1')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_radio_group__["RadioGroup"],{name:'radio-group1',selectedValue:this.state.selectedValue1,onChange:this.handleWordChecked1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:80,marginTop:-140,cursor:"pointer",width:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_radio_group__["Radio"],{value:'0'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:80,marginTop:20,cursor:"pointer",width:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_radio_group__["Radio"],{value:'1'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:80,marginTop:20,cursor:"pointer",width:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_radio_group__["Radio"],{value:'2'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{marginTop:-130,textAlign:"left",marginLeft:115,width:360}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:20,fontWeight:"bold",cursor:"pointer",zIndex:11,userSelect:"none",display:"inline-block",position:'absolute'},onClick:function onClick(){_this14.handleWordChecked1(0);}},this.state.word1?this.state.word1.toLowerCase():'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:8,marginLeft:0,zIndex:1,userSelect:"none"}},' _______________________________________________________')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{marginTop:20,textAlign:"left",marginLeft:115,width:360}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:20,fontWeight:"bold",cursor:"pointer",zIndex:11,userSelect:"none",display:"inline-block",position:'absolute'},onClick:function onClick(){_this14.handleWordChecked1(1);}},this.state.word2?this.state.word2.toLowerCase():'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:8,marginLeft:0,zIndex:1,userSelect:"none"}},' _______________________________________________________')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{marginTop:20,textAlign:"left",marginLeft:115,width:360}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:20,fontWeight:"bold",cursor:"pointer",zIndex:11,userSelect:"none",display:"inline-block",position:'absolute'},onClick:function onClick(){_this14.handleWordChecked1(2);}},this.state.word3?this.state.word3.toLowerCase():'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:8,marginLeft:0,zIndex:1,userSelect:"none"}},' _______________________________________________________'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-6",style:{marginTop:-185,marginLeft:575}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"wordMarkWhiteBoard",style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'IDEA 2')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_radio_group__["RadioGroup"],{name:'radio-group2',selectedValue:this.state.selectedValue2,onChange:this.handleWordChecked2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:80,marginTop:-140,cursor:"pointer",width:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_radio_group__["Radio"],{value:'3'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:80,marginTop:20,cursor:"pointer",width:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_radio_group__["Radio"],{value:'4'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:80,marginTop:20,cursor:"pointer",width:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_radio_group__["Radio"],{value:'5'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{marginTop:-130,textAlign:"left",marginLeft:115,width:360}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:20,fontWeight:"bold",cursor:"pointer",zIndex:11,userSelect:"none",display:"inline-block",position:'absolute'},onClick:function onClick(){_this14.handleWordChecked2(3);}},this.state.word4?this.state.word4.toLowerCase():'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:0,marginTop:8,zIndex:1,userSelect:"none"}},' _______________________________________________________')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{marginTop:20,textAlign:"left",marginLeft:115,width:360}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:20,fontWeight:"bold",cursor:"pointer",zIndex:11,userSelect:"none",display:"inline-block",position:'absolute'},onClick:function onClick(){_this14.handleWordChecked2(4);}},this.state.word5?this.state.word5.toLowerCase():'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:8,marginLeft:0,zIndex:1,userSelect:"none"}},' _______________________________________________________')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{marginTop:20,textAlign:"left",marginLeft:115,width:360}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:20,fontWeight:"bold",cursor:"pointer",zIndex:11,userSelect:"none",display:"inline-block",position:'absolute'},onClick:function onClick(){_this14.handleWordChecked2(5);}},this.state.word6?this.state.word6.toLowerCase():'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:8,marginLeft:0,zIndex:1,userSelect:"none"}},' _______________________________________________________')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-6",style:{marginLeft:300,zIndex:11,marginRight:'auto',marginTop:80,visibility:this.state.progress!=='choseWord2'?"visible":"hidden"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_26__assets_images_wordMark2_Wheel_png___default.a,style:this.state.spinStyle1,onClick:this.handleRainbowSpin1}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-6",style:{marginLeft:300,zIndex:12,marginRight:'auto',marginTop:-230,visibility:this.state.progress!=='choseWord2'?"visible":"hidden"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_27__assets_images_wordMark2_Spinner_pick_arrow_png___default.a,style:{width:80,cursor:'pointer'},onClick:this.handleRainbowSpin1}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-3"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-3",style:{marginLeft:-110,marginTop:-140}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_23__assets_images_wordMark2_Hedgehog_png___default.a,style:{width:150}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-3",style:{marginLeft:240,marginTop:-150}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_24__assets_images_wordMark2_Pig_png___default.a,style:{width:120}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{width:1200}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.progress==='start0'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-1",style:{marginLeft:400,marginTop:-240}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_30__assets_images_wordMark2_Yellow_arrow_rotate_png___default.a,style:{width:60}})):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.progress==='spinWord6'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-1",style:{marginLeft:320,marginTop:-300,rotate:'345deg'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_31__assets_images_wordMark2_Yellow_arrow_2_png___default.a,style:{width:100}})):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.progress==='spinWord3'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-1",style:{marginLeft:700,marginTop:-240}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_29__assets_images_wordMark2_Yellow_arrow_png___default.a,style:{width:60}})):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.progress=='choseWord1'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-1",style:{marginLeft:700,marginTop:-300,rotate:'0deg'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_31__assets_images_wordMark2_Yellow_arrow_2_png___default.a,style:{width:100}})):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.progress==='start0'||this.state.progress==='spinWord1'||this.state.progress==='spinWord2'||this.state.progress==='spinWord6'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-3",style:{marginLeft:50,marginTop:-210}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_35__assets_images_wordMark2_LineLeft_png___default.a,style:{width:30,marginTop:40}})):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-3",style:{marginLeft:5,marginTop:-240}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:170,marginLeft:75}},this.state.progress=='start0'?'Spin my wheel 3 times！':null,this.state.progress=='spinWord1'?'You have 2  more spins！':null,this.state.progress=='spinWord2'?'You have 1 more spin！':null,this.state.progress=='spinWord6'?'Chose one idea！':null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.progress==='spinWord3'||this.state.progress==='spinWord4'||this.state.progress==='spinWord5'||this.state.progress==='choseWord1'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-3",style:{marginLeft:800,marginTop:-210}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_34__assets_images_wordMark2_LineRight_png___default.a,style:{width:30,marginTop:40}})):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-3",style:{marginLeft:890,marginTop:-225}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:170,marginLeft:47}},this.state.progress=='spinWord3'?'Spin my wheel 3 times！':null,this.state.progress=='spinWord4'?'You have 2 more spins！':null,this.state.progress=='spinWord5'?'You have 1 more spin！':null,this.state.progress=='choseWord1'?'Chose one idea！':null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-3",style:{width:200,marginLeft:490,marginTop:-200}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,this.state.bothWordChosen?'Write a story using your ideas！':null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:30}},this.state.bothWordChosen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleStartWriting,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Start')):null)))))));}}]);return Wordmark2Instruction;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context18.abrupt('return',_context18.sent);case 3:case'end':return _context18.stop();}}},_callee18,_this15);}));function updateStudentAppStatus(_x6){return _ref19.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context19.abrupt('return',_context19.sent);case 3:case'end':return _context19.stop();}}},_callee19,_this15);}));function updateStudentAccountTab(_x7){return _ref20.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* updateAppStates */])(appStates));case 2:return _context20.abrupt('return',_context20.sent);case 3:case'end':return _context20.stop();}}},_callee20,_this15);}));function updateAppStates(_x8){return _ref21.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* withRouter */])(WordMark2Component)));

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var Radio = (function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    _classCallCheck(this, Radio);

    _get(Object.getPrototypeOf(Radio.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(Radio, [{
    key: 'render',
    value: function render() {
      var _context$radioGroup = this.context.radioGroup;
      var name = _context$radioGroup.name;
      var selectedValue = _context$radioGroup.selectedValue;
      var onChange = _context$radioGroup.onChange;

      var optional = {};
      if (selectedValue !== undefined) {
        optional.checked = this.props.value === selectedValue;
      }
      if (typeof onChange === 'function') {
        optional.onChange = onChange.bind(null, this.props.value);
      }

      return _react2['default'].createElement('input', _extends({}, this.props, {
        type: 'radio',
        name: name
      }, optional));
    }
  }]);

  return Radio;
})(_react2['default'].Component);

exports.Radio = Radio;
;

Radio.contextTypes = {
  radioGroup: _propTypes2['default'].object
};

var RadioGroup = (function (_React$Component2) {
  _inherits(RadioGroup, _React$Component2);

  function RadioGroup() {
    _classCallCheck(this, RadioGroup);

    _get(Object.getPrototypeOf(RadioGroup.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(RadioGroup, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props;
      var name = _props.name;
      var selectedValue = _props.selectedValue;
      var onChange = _props.onChange;

      return {
        radioGroup: {
          name: name, selectedValue: selectedValue, onChange: onChange
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var Component = _props2.Component;
      var name = _props2.name;
      var selectedValue = _props2.selectedValue;
      var onChange = _props2.onChange;
      var children = _props2.children;

      var rest = _objectWithoutProperties(_props2, ['Component', 'name', 'selectedValue', 'onChange', 'children']);

      return _react2['default'].createElement(
        Component,
        rest,
        children
      );
    }
  }]);

  return RadioGroup;
})(_react2['default'].Component);

exports.RadioGroup = RadioGroup;
;

RadioGroup.defaultProps = {
  Component: "div"
};

RadioGroup.propTypes = {
  name: _propTypes2['default'].string,
  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].bool]),
  onChange: _propTypes2['default'].func,
  children: _propTypes2['default'].node.isRequired,
  Component: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].object])
};

RadioGroup.childContextTypes = {
  radioGroup: _propTypes2['default'].object
};

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Hedgehog.887ddd0f.png";

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Pig.080f4731.png";

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Rainbow spinner.372cb37a.png";

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Wheel.13316dee.png";

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Spinner pick_arrow.ce1deea7.png";

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Speech bubble (right adjusted).5b2ffad8.png";

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Yellow arrow.4a0deb63.png";

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Yellow arrow rotate.28b5c380.png";

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Yellow arrow 2.c671dc1e.png";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Speech bubble (left adjusted).fb5ad88a.png";

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Cow.bb64a282.png";

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recordrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_SafariWorker__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lamejs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lamejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lamejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_CopyRight_css__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_CopyRight_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_students_CopyRight_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LoadingModalComponent_LoadingModal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_rec_gif__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_rec_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_rec_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_video_instructions_png__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_video_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_video_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_video_mask_png__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_video_mask_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_video_mask_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Shared_InstructionModals__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__ = __webpack_require__(17);
var _this17=this;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var hasGetUserMedia=false;try{hasGetUserMedia=!!navigator.getUserMedia||!!navigator.mediaDevices.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}catch(err){hasGetUserMedia=!!navigator.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}var instructionVideo=document.getElementById("copyrightInstruction");var newSes='{\n\t"crVideoId": 2,\n\t"AV_FileName": "",\n\t"startLevel": 1,\n\t"endLevel": 0,\n\t"startProgress": 1,\n\t"endProgress": 0,\n\t"guid": "5d1db0ae-f4a7-498f-a445-a2397d99fae2"\n}';var bestScor='{\n\t"success": true,\n\t"body": {\n\t\t"id": 6479,\n\t\t"userId": 10020,\n\t\t"createdAt": "2018-12-26T15:02:15.338Z",\n\t\t"updatedAt": "2018-12-26T15:20:52.996Z",\n\t\t"mazeLevel": 1,\n\t\t"mazeScore": 1,\n\t\t"slashLevel": 1,\n\t\t"slashScore": 1,\n\t\t"ksLevel": 1,\n\t\t"ksScore": 1,\n\t\t"pnLevel": 1,\n\t\t"pnScore": 1,\n\t\t"crLevel": 1,\n\t\t"crScore": 1,\n\t\t"wssLevel": 1,\n\t\t"wssScore": 1,\n\t\t"kssLevel": 1,\n\t\t"kssScore": 1,\n\t\t"deletedAt": null\n\t},\n\t"msg": ""\n}';var copyrightTest='[{\n\t"id": 2,\n\t"createdAt": "2018-10-29T09:54:43.727Z",\n\t"updatedAt": "2018-10-29T09:54:43.727Z",\n\t"englishSentence": "I like baseball.",\n\t"aslSequence": "BASEBALL ME LIKE",\n\t"aslSigns": "BASEBALL,LIKE",\n\t"actor": "Regina",\n\t"x2": null,\n\t"level": 1,\n\t"signCount": 2,\n\t"url": "https://s3.us-east-2.amazonaws.com/uploadbeta/content/copyright/2.mp4",\n\t"deletedAt": null,\n\t"cr_assessments": []\n}]';var objectConstructor={}.constructor;var CopyRightComponent=function(_Component){_inherits(CopyRightComponent,_Component);function CopyRightComponent(props){_classCallCheck(this,CopyRightComponent);var _this=_possibleConstructorReturn(this,(CopyRightComponent.__proto__||Object.getPrototypeOf(CopyRightComponent)).call(this,props));_this.handleActive=function(active){console.log("handle active");console.log(active);_this.setState({active:active});};_this.handleBeginTest=function(){_this.setState({active:3});};_this.state={active:0,loadedScores:false,bestScores:{crScore:1,crLevel:1}};return _this;}_createClass(CopyRightComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);case 2:_context3.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!response.success){_context.next=3;break;}_context.next=3;return _this2.setState({loadedScores:true,bestScores:response.body});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 4:_context3.next=6;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentAppStatus().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var _Helpers$filterApps,allowedApps,filteredApps,finishedApps;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this2.props.updateStudentAppStatus(res.body);case 2:_Helpers$filterApps=__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].filterApps(_this2.props.studentUser,_this2.props.apps),allowedApps=_Helpers$filterApps.allowedApps,filteredApps=_Helpers$filterApps.filteredApps,finishedApps=_Helpers$filterApps.finishedApps;_context2.next=5;return _this2.props.updateAppStates({allowedApps:allowedApps,filteredApps:filteredApps,finishedApps:finishedApps});case 5:_context2.next=7;return _this2.setState({bestScores:res.body.bestScores});case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}());case 6:if(this.props.apps.copyRightScores.filter(function(x){return x.gradingDate==null;}).length>3){this.props.history.goBack();}case 7:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.state.active!==2?"bgGrey CopyRight":"bgYellow Copyright"},this.state.active===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer progressBox1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'CopyRight'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 text-center"},this.state.loadedScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProgressModalComponent_ProgressBox__["a" /* default */],{appName:"copyright",level:this.state.bestScores.crLevel,step:this.state.bestScores.crScore,steps:3,maxLevel:6,noDescription:true}):null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"copyright",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{demo:true,appName:"copyright",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer copyright'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'CopyRight: Show Me'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["g" /* VideoComponent */],{url:"https://s3.us-east-2.amazonaws.com/uploaddev/video/copyright/Copyright_sh.mp4"})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{demo:true,appName:"copyright",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{practice:true,appName:"copyright",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tutorial,{studentUser:this.props.studentUser,beginTest:this.handleBeginTest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"copyright",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{appName:"copyright",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CopyRight,{studentUser:this.props.studentUser,buttonClick:this.handleActive}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"copyright",buttonClick:this.handleActive,currentTabActive:this.state.active})):null);}}]);return CopyRightComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var CopyRight=function(_Component2){_inherits(CopyRight,_Component2);function CopyRight(props){var _this4=this;_classCallCheck(this,CopyRight);var _this3=_possibleConstructorReturn(this,(CopyRight.__proto__||Object.getPrototypeOf(CopyRight)).call(this,props));_this3.handleToggleInstruction=function(toggleInstruction){localStorage.setItem('CopyrightInstruction',toggleInstruction);};_this3.captureUserMedia=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(callback,options){var params;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:params=null;_context4.next=3;return _this3.getMediaParam(options);case 3:params=_context4.sent;navigator.mediaDevices.getUserMedia(params).then(callback).catch(function(error){_this3.setState({modalDialog:true,responseContent:error});});case 5:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x3,_x4){return _ref4.apply(this,arguments);};}();_this3.handleStartCopyRight=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!_this3.props.practice){_context6.next=17;break;}if(!((typeof newSes==='undefined'?'undefined':_typeof(newSes))!=='object'&&newSes!==null)){_context6.next=5;break;}_context6.next=4;return JSON.parse(newSes);case 4:newSes=_context6.sent;case 5:if(!((typeof bestScor==='undefined'?'undefined':_typeof(bestScor))!=='object'&&bestScor!==null)){_context6.next=9;break;}_context6.next=8;return JSON.parse(bestScor);case 8:bestScor=_context6.sent;case 9:if(!((typeof copyrightTest==='undefined'?'undefined':_typeof(copyrightTest))!=='object'&&copyrightTest!==null)){_context6.next=13;break;}_context6.next=12;return JSON.parse(copyrightTest);case 12:copyrightTest=_context6.sent;case 13:_context6.next=15;return _this3.setState({bestScores:bestScor.body,sessionData:newSes,crVideoSrc:copyrightTest[0].url,crVideoPlayCount:0});case 15:_context6.next=18;break;case 17:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getCRRandom().then(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(res){var crVideos,bestScores,newSesh;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:crVideos=res.body;_context5.next=3;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores();case 3:bestScores=_context5.sent;newSesh=_this3.state.sessionData;newSesh.startLevel=bestScores.body.crLevel;newSesh.startProgress=bestScores.body.crScore;newSesh.crVideoId=crVideos[0].id;console.log('Sesh: '+JSON.stringify(newSesh));console.log('Best: '+JSON.stringify(bestScores));console.log('Src: '+JSON.stringify(crVideos));_context5.next=13;return _this3.setState({bestScores:bestScores.body,sessionData:newSesh,crVideoSrc:crVideos[0].url,crVideoPlayCount:0});case 13:case'end':return _context5.stop();}}},_callee5,_this4);}));return function(_x5){return _ref6.apply(this,arguments);};}()).catch(function(error){console.log(error);});case 18:case'end':return _context6.stop();}}},_callee6,_this4);}));_this3.state={showVideo:true,popupSurvey:false,timerInterval:null,timerTime:60,sessionTime:60,isUploading:false,countdown:-1,isCounting:false,bestScores:null,countDownTimer:null,videoTimeout:null,recordVideo:null,rejectedReason:'',recording:false,crVideoSrc:"",crVideoPlayCount:0,recordingVideoPlayCount:0,recordingAudioPlayCount:0,videoSrc:false,crPaused:false,recordingsCount:0,recClick:0,audioSrc:false,audioBlob:false,recordAudio:null,audioVideoSwitch:"video",modalDialog:false,modalInstruction:false,responseContent:'',upTime:null,disableSubmit:false,sessionData:{crVideoId:0,AV_FileName:"",startLevel:0,endLevel:0,startProgress:0,endProgress:0,guid:__webpack_require__(68)()}};_this3.handleSurveyBack=_this3.handleSurveyBack.bind(_this3);_this3.handleStartCopyRight=_this3.handleStartCopyRight.bind(_this3);_this3.handleShowVideo=_this3.handleShowVideo.bind(_this3);_this3.handleStart=_this3.handleStart.bind(_this3);_this3.handleStop=_this3.handleStop.bind(_this3);_this3.setStreamToVideo=_this3.setStreamToVideo.bind(_this3);_this3.releaseStreamFromVideo=_this3.releaseStreamFromVideo.bind(_this3);_this3.uploadVideo=_this3.uploadVideo.bind(_this3);_this3.requestUserMedia=_this3.requestUserMedia.bind(_this3);_this3.startRecord=_this3.startRecord.bind(_this3);_this3.stopRecord=_this3.stopRecord.bind(_this3);_this3.handleBackToMenu=_this3.handleBackToMenu.bind(_this3);_this3.submitSession=_this3.submitSession.bind(_this3);_this3.crVideoPause=_this3.crVideoPause.bind(_this3);_this3.handlePlay=_this3.handlePlay.bind(_this3);_this3.handleSeek=_this3.handleSeek.bind(_this3);_this3.handleRecordVideo=_this3.handleRecordVideo.bind(_this3);_this3.recordingPlay=_this3.recordingPlay.bind(_this3);_this3.toggleAudioVideo=_this3.toggleAudioVideo.bind(_this3);_this3.onUnload=_this3.onUnload.bind(_this3);_this3.handleToggleInstruction=_this3.handleToggleInstruction.bind(_this3);_this3.startTimer=_this3.startTimer.bind(_this3);_this3.countDown=_this3.countDown.bind(_this3);_this3.handleAnalytics=_this3.handleAnalytics.bind(_this3);return _this3;}_createClass(CopyRight,[{key:'onUnload',value:function onUnload(event){// the method that will be used for both add and remove event
event.returnValue="By leaving or reloading the page you will lose your app progress";}},{key:'componentDidMount',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:window.addEventListener("beforeunload",this.onUnload);if(!/firefox/i.test(navigator.userAgent)){_context7.next=4;break;}this.setState({modalDialog:true,responseContent:'Please use Safari or Chrome browser for this task'});return _context7.abrupt('return');case 4:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);if(hasGetUserMedia){_context7.next=8;break;}this.setState({modalDialog:true,responseContent:!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform)&&(navigator.userAgent.match('CriOS')||navigator.userAgent.match('Mozilla'))?'Please use Safari (above version 11) for this task.':'Your browser cannot stream from your webcam. Please switch to Chrome.'});return _context7.abrupt('return');case 8:this.requestUserMedia();this.handleStartCopyRight();_context7.next=12;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__["b" /* default */].STUDENT_CR_START,metadata:{platform:navigator.platform,userAgent:navigator.userAgent}}});case 12:this.handleAnalytics();case 13:case'end':return _context7.stop();}}},_callee7,this);}));function componentDidMount(){return _ref7.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("beforeunload",this.onUnload);if(this.state.recording){if(this.state.audioVideoSwitch==="video"){this.state.recordVideo.stop(function(res){console.log("Component unmount");});}else{this.state.recordAudio.stop(function(res){console.log("Component unmount");});}Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.state.countDownTimer);clearTimeout(this.state.videoTimeout);Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.state.timerInterval);this.captureUserMedia(function(stream){stream.stop();});}if(this.video&&this.video.srcObject){this.video.srcObject.stop();}}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleShowVideo',value:function handleShowVideo(){this.setState({showVideo:!this.state.showVideo});}},{key:'handleBackToMenu',value:function handleBackToMenu(e){this.props.history.goBack();}},{key:'requestUserMedia',value:function requestUserMedia(){var _this5=this;console.log('requestUserMedia');this.captureUserMedia(function(stream){_this5.setStreamToVideo(stream);console.log('setting state',_this5.state);});}},{key:'handleStart',value:function handleStart(stream){var _this6=this;if(this.state.audioVideoSwitch==="video"){this.setStreamToVideo(stream);}console.log('Recording Started.');var durationAllowed=3*this.crVideo.duration;var timerInterval=Object(__WEBPACK_IMPORTED_MODULE_19_timers__["setInterval"])(function(){if(durationAllowed>0){_this6.setState({timerTime:_this6.state.timerTime-1});}else{Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(_this6.state.timerInterval);_this6.setState({timerInterval:null});}},1000);var timeoutTimer=setTimeout(function(){_this6.stopRecord();},1000*3*this.crVideo.duration);this.setState({recording:true,videoTimeout:timeoutTimer,timerInterval:timerInterval,timerTime:durationAllowed,sessionTime:durationAllowed});}},{key:'handleStop',value:function handleStop(blob){this.setState({recording:false,videoTimeout:null,timerInterval:null});if(this.state.audioVideoSwitch==="video"){this.releaseStreamFromVideo();}else{this.releaseStreamFromAudio();}console.log('Recording Stopped.');this.uploadVideo(blob instanceof Blob,blob);}},{key:'setStreamToVideo',value:function setStreamToVideo(stream){this.video.srcObject=stream;}},{key:'releaseStreamFromVideo',value:function releaseStreamFromVideo(){this.video.srcObject=null;}},{key:'encodeMono',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(channels,sampleRate,samples){var kbps,mp3encoder,sampleBlockSize,mp3Data,i,sampleChunk,_mp3buf,mp3buf,blob;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:kbps=256;//encode 128kbps mp3
mp3encoder=new __WEBPACK_IMPORTED_MODULE_9_lamejs___default.a.Mp3Encoder(channels,sampleRate,kbps);sampleBlockSize=1152;//can be anything but make it a multiple of 576 to make encoders life easier
mp3Data=[];for(i=0;i<samples.length;i+=sampleBlockSize){sampleChunk=samples.subarray(i,i+sampleBlockSize);_mp3buf=mp3encoder.encodeBuffer(sampleChunk);if(_mp3buf.length>0){mp3Data.push(_mp3buf);}}mp3buf=mp3encoder.flush();//finish writing mp3
if(mp3buf.length>0){mp3Data.push(new Int8Array(mp3buf));}blob=new Blob(mp3Data,{type:'audio/mp3'});_context8.next=10;return this.setState({audioBlob:blob});case 10:this.handleStop(blob);case 11:case'end':return _context8.stop();}}},_callee8,this);}));function encodeMono(_x6,_x7,_x8){return _ref8.apply(this,arguments);}return encodeMono;}()},{key:'setStreamToAudio',value:function setStreamToAudio(stream){console.log(stream);this.audio.srcObject=stream;}},{key:'releaseStreamFromAudio',value:function releaseStreamFromAudio(){this.audio.pause();this.audio.srcObject=null;this.audio.src="";this.audio.load();}},{key:'startRecordAudio',value:function startRecordAudio(){var _this7=this;this.captureUserMedia(function(stream){var options={type:'audio',audio:_this7.audio,sampleRate:44100,bufferSize:4096,numberOfAudioChannels:1,recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder};_this7.setState({recordAudio:new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder(stream,options)});_this7.state.recordAudio.record();_this7.handleStartAudio(stream);},{audio:true,video:false});}},{key:'handleStopAudio',value:function handleStopAudio(wavBlob){var _this8=this;this.setState({recording:false});console.log('Recording Stopped.');console.log(wavBlob);var fileReader=new FileReader();fileReader.onload=function(event){console.log(event);var arrayBuffer=event.target.result;var wav=__WEBPACK_IMPORTED_MODULE_9_lamejs___default.a.WavHeader.readHeader(new DataView(arrayBuffer));var samples=new Int16Array(arrayBuffer,wav.dataOffset,wav.dataLen/2);_this8.encodeMono(wav.channels,wav.sampleRate,samples);_this8.releaseStreamFromAudio();};fileReader.readAsArrayBuffer(wavBlob);}},{key:'handleStartAudio',value:function handleStartAudio(stream){this.setState({recording:true});this.setStreamToAudio(stream);this.handleStart(stream);console.log('Recording Audio Started.');}},{key:'stopRecordAudio',value:function stopRecordAudio(){var _this9=this;this.state.recordAudio.stop(function(wavBlob){_this9.handleStopAudio(wavBlob);});}},{key:'getMediaParam',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(options){var params,userAgent;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:params=null;_context9.next=3;return navigator.userAgent;case 3:userAgent=_context9.sent;if(!options){_context9.next=8;break;}params=options;_context9.next=16;break;case 8:if(!(/Chrome/i.test(userAgent)&&/Windows/i.test(userAgent))){_context9.next=12;break;}params={video:true};_context9.next=16;break;case 12:_context9.next=14;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].getVideoSizes();case 14:_context9.t0=_context9.sent;params={audio:true,video:_context9.t0};case 16:return _context9.abrupt('return',params);case 17:case'end':return _context9.stop();}}},_callee9,this);}));function getMediaParam(_x9){return _ref9.apply(this,arguments);}return getMediaParam;}()},{key:'uploadVideo',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(isBlob,blob){var _this10=this;var vidETA;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].calculateETA(null,blob);case 2:vidETA=_context11.sent;_context11.next=5;return this.setState({upTime:vidETA});case 5:_context11.next=7;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__["b" /* default */].STUDENT_CR_UPLOAD_START,metadata:{platform:navigator.platform,userAgent:navigator.userAgent,upTime:vidETA}}});case 7:this.handleAnalytics();_context11.next=10;return this.startTimer();case 10:_context11.next=12;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].uploadCRVideo(isBlob,blob).then(function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(!(_this10.state.audioVideoSwitch==="video")){_context10.next=6;break;}_this10.video.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_context10.next=4;return _this10.setState({videoSrc:_this10.video.src,recordingsCount:_this10.state.recordingsCount+1,crVideoPlayCount:1,isUploading:false});case 4:_context10.next=10;break;case 6:_this10.audio2.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_context10.next=9;return _this10.setState({audioSrc:_this10.audio2.src,recordingsCount:_this10.state.recordingsCount+1,isUploading:false});case 9:_this10.audio2.load();case 10:window.removeEventListener("beforeunload",_this10.onUnload);if(_this10.state.recordingsCount>1){_this10.submitSession();}case 12:case'end':return _context10.stop();}}},_callee10,_this10);}));return function(_x12){return _ref11.apply(this,arguments);};}()).catch(function(error){console.log(error);});case 12:case'end':return _context11.stop();}}},_callee11,this);}));function uploadVideo(_x10,_x11){return _ref10.apply(this,arguments);}return uploadVideo;}()},{key:'submitSession',value:function submitSession(){var _this11=this;this.setState({disableSubmit:true});var seshData=this.state.sessionData;if(this.state.audioVideoSwitch==="video"){seshData.AV_FileName=this.state.videoSrc.replace(__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */],"");}else{seshData.AV_FileName=this.state.audioSrc.replace(__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */],"");}console.log(seshData);if(!this.props.practice){window.removeEventListener("beforeunload",this.onUnload);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].insertCRSession(seshData).then(function(res){_this11.setState({modalDialog:true,responseContent:'Data Successfully Saved and Submitted'});setTimeout(function(){_this11.setState({modalDialog:false,popupSurvey:true});},2500);console.log("session created");console.log(res);});}}},{key:'handleSurveyBack',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0://window.location.reload();
this.props.buttonClick(0);case 1:case'end':return _context12.stop();}}},_callee12,this);}));function handleSurveyBack(){return _ref12.apply(this,arguments);}return handleSurveyBack;}()},{key:'handleRecordVideo',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(){var _this12=this;var countDownTimer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return this.setState({isCounting:true});case 2:if(!(this.state.recordingsCount<=1)){_context14.next=8;break;}_context14.next=5;return this.setState({countdown:3,recClick:this.state.recClick+1});case 5:countDownTimer=Object(__WEBPACK_IMPORTED_MODULE_19_timers__["setInterval"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return _this12.setState({countdown:_this12.state.countdown-1});case 2:if(!(_this12.state.countdown<0)){_context13.next=7;break;}_context13.next=5;return _this12.setState({isCounting:false});case 5:Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(countDownTimer);_this12.startRecord();case 7:case'end':return _context13.stop();}}},_callee13,_this12);})),1000);_context14.next=8;return this.setState({countDownTimer:countDownTimer});case 8:case'end':return _context14.stop();}}},_callee14,this);}));function handleRecordVideo(){return _ref13.apply(this,arguments);}return handleRecordVideo;}()},{key:'startRecordVideo',value:function startRecordVideo(){var _this13=this;this.captureUserMedia(function(stream){var options={type:'video',recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.WhammyRecorder,frameInterval:50,video:_this13.video,width:320,height:240};_this13.setState({recordVideo:new __WEBPACK_IMPORTED_MODULE_7__Shared_SafariWorker__["a" /* default */]().WhammyRecorder(stream,options)});_this13.state.recordVideo.record();_this13.handleStart(stream);});}},{key:'stopRecordVideo',value:function stopRecordVideo(){var _this14=this;this.state.recordVideo.stop(function(result){_this14.handleStop(result);});}},{key:'stopRecord',value:function stopRecord(){if(this.state.audioVideoSwitch==="video"){this.stopRecordVideo();}else{this.stopRecordAudio();}clearTimeout(this.state.videoTimeout);Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.state.timerInterval);this.setState({recording:false,isUploading:true});}},{key:'startRecord',value:function startRecord(){if(this.state.audioVideoSwitch==="video"){this.startRecordVideo();}else{this.startRecordAudio();}this.setState({recording:true});}},{key:'crVideoPause',value:function crVideoPause(pause){this.setState({crPaused:pause});if(pause){this.crVideo.pause();}else{this.crVideo.play();}}},{key:'handlePlay',value:function handlePlay(){var replay=this.state.crPaused===false||this.crVideo.currentTime===0;var vid=document.getElementById("copyrightInstruction");vid.playbackRate=0.7;if(!replay){this.crVideoPause(false);}else{this.setState({crVideoPlayCount:this.state.crVideoPlayCount+1});this.crVideo.play();}console.log("VIDEO DATA",this.crVideo.currentTime,this.crVideo.duration);console.log("VIDEO STATE",this.state.crVideoPlayCount);}},{key:'recordingPlay',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return this.setState({recordingVideoPlayCount:this.state.recordingVideoPlayCount+1});case 2:this.video.play();console.log("RECORDING PLAY COUNT",this.state.recordingVideoPlayCount,this.video);case 4:case'end':return _context15.stop();}}},_callee15,this);}));function recordingPlay(){return _ref15.apply(this,arguments);}return recordingPlay;}()},{key:'recordingAudioPlay',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return this.setState({recordingAudioPlayCount:this.state.recordingAudioPlayCount+1});case 2:this.audio2.play();console.log("RECORDING PLAY COUNT",this.state.recordingAudioPlayCount,this.audio);case 4:case'end':return _context16.stop();}}},_callee16,this);}));function recordingAudioPlay(){return _ref16.apply(this,arguments);}return recordingAudioPlay;}()},{key:'handleSeek',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:if(this.crVideo.currentTime!==0){this.crVideo.currentTime=0;this.handlePlay();}case 1:case'end':return _context17.stop();}}},_callee17,this);}));function handleSeek(){return _ref17.apply(this,arguments);}return handleSeek;}()},{key:'toggleAudioVideo',value:function toggleAudioVideo(){if(this.state.audioVideoSwitch==="video"){this.setState({audioVideoSwitch:"audio"});this.releaseStreamFromVideo();}else{this.setState({audioVideoSwitch:"video"});this.releaseStreamFromAudio();this.requestUserMedia();}}},{key:'startTimer',value:function startTimer(){this.timer=Object(__WEBPACK_IMPORTED_MODULE_19_timers__["setInterval"])(this.countDown,1000);}},{key:'countDown',value:function countDown(){var seconds=this.state.upTime-1;this.setState({upTime:seconds});if(seconds<=0){Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.timer);}}},{key:'render',value:function render(){var _this15=this;var countDown=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.countdown<=0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:"fontCountdown"},this.state.countdown));var allowedPlayback=2;if(this.state.recordingsCount===1){allowedPlayback=1;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.practice?"appSection bgGrey":"appSection bgYellow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},!this.props.practice?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Shared_InstructionModals__["a" /* default */],{Copyright:true,modalOpen:this.state.modalInstruction,instructionMask:__WEBPACK_IMPORTED_MODULE_15__assets_images_video_instructions_png___default.a,toggleInstruction:this.handleToggleInstruction,closeClick:function closeClick(active){_this15.setState({modalInstruction:active});}}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this15.setState({modalDialog:active,popupSurvey:true});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Shared_DialogBox__["a" /* default */],{surveyModal:true,app:'CopyRight',userId:this.props.studentUser.id,active:this.state.popupSurvey,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer copyright'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6 col-sm-6 text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:60}},countDown,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:'copyrightInstruction',hidden:this.state.recording||this.state.crVideoSrc===""||this.state.countdown>0,ref:function ref(crVideo){return _this15.crVideo=crVideo;},src:this.state.crVideoSrc!==""?this.state.crVideoSrc:undefined,width:'100%',height:'auto',playsInline:true,muted:true,autoPlay:false,controls:this.state.crVideoPlayCount<=allowedPlayback,onPause:function onPause(){return _this15.crVideoPause(true);},onPlay:function onPlay(){return _this15.handlePlay();},onSeeked:function onSeeked(){return _this15.handleSeek();}}),this.state.recording?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'handBtn',style:{marginTop:25,display:this.state.crVideoPlayCount<=allowedPlayback?"inline-block":"none"},onClick:function onClick(){return _this15.handlePlay();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Play Video')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-6 col-sm-6',style:this.state.showVideo?{}:{display:'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.audioVideoSwitch==="video",style:{paddingTop:"35%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{ref:function ref(audio){_this15.audio=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{controls:this.state.recordingAudioPlayCount<4,ref:function ref(audio2){_this15.audio2=audio2;},onPlay:function onPlay(){return _this15.recordingAudioPlay();}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.isUploading||this.state.recording||this.state.recordingsCount===1,style:{position:'absolute',margin:'auto',zIndex:1,top:65,left:0,bottom:0,right:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_video_mask_png___default.a,alt:"Outline to Align Yourself in Video",style:{minWidth:200,width:'65%'}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"copyrightVidPlayback",hidden:this.state.audioVideoSwitch==="audio",playsInline:true,ref:function ref(video){_this15.video=video;},style:{position:'relative',top:65},width:'100%',autoPlay:true,muted:true,onPlay:function onPlay(){return _this15.recordingPlay();},controls:!this.state.recording&&this.state.videoSrc&&this.state.videoSrc!=="",className:this.state.recording||!this.state.videoSrc||this.state.videoSrc===""?"flippedVideo":""}),this.state.recording?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rec',style:{fontSize:24,position:'absolute',bottom:-100,textAlign:'center',display:'block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{width:'auto',height:'22px'},src:__WEBPACK_IMPORTED_MODULE_14__assets_images_rec_gif___default.a,className:'ico-xs'}),' RECORDING '):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:720,marginTop:450}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",width:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',defaultChecked:true,onChange:this.handleShowVideo,id:'checkHideDeleted',className:'form-control'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",marginTop:8,marginLeft:10}},'Show my video'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-6 col-sm-4 text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.recordingsCount<=1&&!this.state.recording&&this.state.crVideoPlayCount>0?"handBtn ":"hidden",onClick:this.handleRecordVideo},this.state.recordingsCount===0&&!this.state.isCounting?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Start'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.isCounting?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Redo'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.recording?"handBtn ":"hidden",onClick:this.stopRecord},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Stop')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.videoSrc||this.state.audioSrc?"handBtn ":"hidden",onClick:!this.state.disableSubmit?this.submitSession:null},this.state.recClick!=2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Finish'):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fr',style:{display:'-webkit-box'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["c" /* CountDownComponent */],{time:this.state.timerTime,sessionTime:this.state.sessionTime,showTime:10})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LoadingModalComponent_LoadingModal__["a" /* default */],{timer:true,upTime:this.state.upTime,isUploading:this.state.isUploading})));}}]);return CopyRight;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Tutorial=function(_Component3){_inherits(Tutorial,_Component3);function Tutorial(props){_classCallCheck(this,Tutorial);return _possibleConstructorReturn(this,(Tutorial.__proto__||Object.getPrototypeOf(Tutorial)).call(this,props));}_createClass(Tutorial,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CopyRight,{studentUser:this.props.studentUser,practice:true});}}]);return Tutorial;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context18.abrupt('return',_context18.sent);case 3:case'end':return _context18.stop();}}},_callee18,_this17);}));function updateStudentAppStatus(_x13){return _ref18.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context19.abrupt('return',_context19.sent);case 3:case'end':return _context19.stop();}}},_callee19,_this17);}));function updateStudentAccountTab(_x14){return _ref19.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions__["a" /* updateAppStates */])(appStates));case 2:return _context20.abrupt('return',_context20.sent);case 3:case'end':return _context20.stop();}}},_callee20,_this17);}));function updateAppStates(_x15){return _ref20.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,bindActionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(CopyRightComponent)));

/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TeachersComponent_actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_correct_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_wrong_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_app_copyright_png__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_app_copyright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_app_copyright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Shared_DropDownNotifications__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalFormComponents_ReportBugForm__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_modal_x_png__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_modal_x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_modal_x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_ico_warning_png__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_ico_warning_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_images_ico_warning_png__);
var _this6=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CRGrading=function(_Component){_inherits(CRGrading,_Component);function CRGrading(props){var _this2=this;_classCallCheck(this,CRGrading);var _this=_possibleConstructorReturn(this,(CRGrading.__proto__||Object.getPrototypeOf(CRGrading)).call(this,props));_this.submitCRSessionGrade=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var grades,correct,incorrect,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,grade;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:grades=_this.state.crSession.gradeSequence.split(",");correct=0;incorrect=0;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=6;for(_iterator=grades[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){grade=_step.value;if(grade==="1"){correct++;}else{incorrect++;}}_context2.next=14;break;case 10:_context2.prev=10;_context2.t0=_context2['catch'](6);_didIteratorError=true;_iteratorError=_context2.t0;case 14:_context2.prev=14;_context2.prev=15;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 17:_context2.prev=17;if(!_didIteratorError){_context2.next=20;break;}throw _iteratorError;case 20:return _context2.finish(17);case 21:return _context2.finish(14);case 22:_context2.next=24;return _this.setState({sessionData:{testId:_this.state.testId,gradeSequence:_this.state.crSession.gradeSequence,gradingTime:Math.ceil((Date.now()-_this.state.gradeStart)/1000),numberCorrect:correct,numberIncorrect:incorrect}});case 24:console.log("Submitting session data: ",_this.state.sessionData);_context2.next=27;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].gradeCRSession(_this.state.sessionData).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.updateCRBestScore();case 2:_this.setState({modalDialog:true,responseContent:'Score task saved.',analytics:{type:__WEBPACK_IMPORTED_MODULE_21__Shared_DataTrackingPoints__["b" /* default */].CR_SCORE_SAVE,metadata:{testId:_this.state.testId}}});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 27:_this.handleAnalytics();case 28:case'end':return _context2.stop();}}},_callee2,_this2,[[6,10,14,22],[15,,17,21]]);}));_this.startGrading=function(testId){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getCRSession(testId).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res){var crSession,bestScores;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:crSession=res.body;if(!crSession){_context3.next=13;break;}console.log("CR SESSION GET",crSession);_context3.next=5;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentBestScores(crSession.userId);case 5:bestScores=_context3.sent;_context3.next=8;return _this.setState({crSession:crSession,bestScores:bestScores.body,noteContent:crSession.note,crVideo:crSession.cr_video,videoSrc:__WEBPACK_IMPORTED_MODULE_6__Shared_Consts__["b" /* BUCKET_URL */]+crSession.AV_FileName});case 8:_this.video.src=__WEBPACK_IMPORTED_MODULE_6__Shared_Consts__["b" /* BUCKET_URL */]+crSession.AV_FileName;_this.crVideo.src=crSession.cr_video.url;_this.setupGradingData();_context3.next=16;break;case 13:console.log("ERROR");_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 16:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}()).catch(function(error){console.log("ERROR",error);_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);});};_this.deleteScoreConfirm=function(confirm){if(confirm){_this.deleteScore();}_this.setState({modalDialogDelete:false});};_this.handleStudentClick=function(student,classId){_this.props.updateStudent(student);_this.props.history.push('/teacher/student');};_this.state={testId:null,paused:true,bestScores:null,rejectedReason:'',recording:false,imageSrc:"",videoSrc:"",currentWord:"",currentIndex:-1,crVideo:null,studentJoined:false,crWords:[],crSession:null,gradeStart:null,modalDialog:false,responseContent:'',modalDialogDelete:false,modalDialogNote:false,noteContent:'',handleNext:false,taskID:null,showPlayInstructorHint:false,showPlayVideoHint:false,showKeywordHint:false,showDeleteHint:false,showSaveHint:false,play:false,play1:false,sessionData:{testId:0,gradeSequence:"",gradingTime:0,numberCorrect:0,numberIncorrect:0},analytics:{type:null,metadata:null}};_this.startGrading=_this.startGrading.bind(_this);_this.gradeToggle=_this.gradeToggle.bind(_this);_this.handleReset=_this.handleReset.bind(_this);_this.submitCRSessionGrade=_this.submitCRSessionGrade.bind(_this);_this.updateCRBestScore=_this.updateCRBestScore.bind(_this);_this.setupGradingData=_this.setupGradingData.bind(_this);_this.deleteScore=_this.deleteScore.bind(_this);_this.handleTakeANote=_this.handleTakeANote.bind(_this);_this.saveNote=_this.saveNote.bind(_this);_this.deleteNote=_this.deleteNote.bind(_this);_this.handleNoteClose=_this.handleNoteClose.bind(_this);_this.handleNoteContentChange=_this.handleNoteContentChange.bind(_this);_this.handleStudentClick=_this.handleStudentClick.bind(_this);_this.handleNextTask=_this.handleNextTask.bind(_this);_this.getTarget=_this.getTarget.bind(_this);_this.getTarget1=_this.getTarget1.bind(_this);_this.getTarget2=_this.getTarget2.bind(_this);_this.getTarget3=_this.getTarget3.bind(_this);_this.getTarget4=_this.getTarget4.bind(_this);_this.handleShowHints=_this.handleShowHints.bind(_this);_this.handlePlay=_this.handlePlay.bind(_this);_this.handlePlay1=_this.handlePlay1.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(CRGrading,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this3=this;var parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);parsed=__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.parse(this.props.location.search);_context4.next=4;return this.setState({testId:parsed.testId,gradeStart:Date.now(),analytics:{type:__WEBPACK_IMPORTED_MODULE_21__Shared_DataTrackingPoints__["b" /* default */].CR_SCORE_VIEW,metadata:{testId:parsed.testId}}});case 4:this.startGrading(parsed.testId);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentNotifications().then(function(res){for(var i=0;i<res.body.length;i++){for(var j=0;j<res.body[i].apps.copyRightScores.length;j++){var copyRightScores=res.body[i].apps.copyRightScores[j];if(copyRightScores&&copyRightScores.userId===_this3.props.lastStudent.user.id&&copyRightScores.id!=parsed.testId){_this3.setState({handleNext:true,taskID:copyRightScores.id});}}}});this.handleAnalytics();case 7:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleNextTask',value:function handleNextTask(){window.location.href='/teacher/apps/cr-grading?testId='+this.state.taskID;}},{key:'updateCRBestScore',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var newProgress,newLevel,goalScore;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!(this.state.bestScores.crLevel===this.state.crSession.startLevel)){_context5.next=25;break;}newProgress=this.state.bestScores.crScore;_context5.next=4;return this.state.bestScores.crLevel;case 4:newLevel=_context5.sent;goalScore=0;if(newLevel==1){goalScore=1;}else if(newLevel==2){goalScore=2;}else if(newLevel==3){goalScore=3;}else if(newLevel==4){goalScore=4;}else if(newLevel==5){goalScore=5;}else if(newLevel==6){goalScore=5;}if(!(this.state.sessionData.numberCorrect>=goalScore)){_context5.next=12;break;}_context5.next=10;return newProgress++;case 10:_context5.next=14;break;case 12:_context5.next=14;return newProgress--;case 14:if(!(newProgress>3&&newLevel<=6)){_context5.next=20;break;}_context5.next=17;return newLevel++;case 17:newProgress=1;_context5.next=21;break;case 20:if(newProgress===0){newProgress=1;}case 21:_context5.next=23;return this.setState({bestScores:Object.assign({},this.state.bestScores,{crLevel:newLevel,crScore:newProgress})});case 23:_context5.next=25;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateCRBestScore(this.state.bestScores);case 25:case'end':return _context5.stop();}}},_callee5,this);}));function updateCRBestScore(){return _ref5.apply(this,arguments);}return updateCRBestScore;}()},{key:'setupGradingData',value:function setupGradingData(){if(this.state.crSession.gradeSequence==null||this.state.gradeSequence===""){var grades=[];var words=this.state.crVideo.aslSigns.split(",");for(var i=0;i<words.length;i++){grades[i]="0";}this.setState({crSession:Object.assign({},this.state.crSession,{gradeSequence:grades.join(",")})});}}},{key:'handleReset',value:function handleReset(){var gradeSequence=this.state.crSession.gradeSequence;var grades=gradeSequence.split(",");for(var i=0;i<gradeSequence.length;i++){grades[i]="0";}this.setState({crSession:Object.assign({},this.state.crSession,{gradeSequence:grades.join(",")})});}},{key:'gradeToggle',value:function gradeToggle(index,currentGrade){currentGrade=parseInt(currentGrade);var gradeSequence=this.state.crSession.gradeSequence;var grades=gradeSequence.split(",");if(currentGrade===0){currentGrade=1;}else{currentGrade=0;}grades[index]=currentGrade.toString();this.setState({crSession:Object.assign({},this.state.crSession,{gradeSequence:grades.join(",")})});}},{key:'deleteScore',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_21__Shared_DataTrackingPoints__["b" /* default */].CR_SCORE_DELETE,metadata:{testId:this.state.testId}}});case 2:_context6.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].deleteCopyRightScore(this.state.testId).then(function(res){_this4.handleAnalytics();_this4.props.history.goBack();});case 4:case'end':return _context6.stop();}}},_callee6,this);}));function deleteScore(){return _ref6.apply(this,arguments);}return deleteScore;}()},{key:'handleTakeANote',value:function handleTakeANote(){console.log("take a note");this.setState({modalDialogNote:true});}},{key:'handleNoteContentChange',value:function handleNoteContentChange(event){this.setState({noteContent:event.target.value});event.preventDefault();}},{key:'saveNote',value:function saveNote(){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateCopyRightNote({testId:this.state.testId,note:this.state.noteContent});this.setState({modalDialogNote:false});}},{key:'deleteNote',value:function deleteNote(){this.setState({noteContent:''});__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateCopyRightNote({testId:this.state.testId,note:''});}},{key:'handleNoteClose',value:function handleNoteClose(){this.setState({modalDialogNote:false});}},{key:'getTarget',value:function getTarget(){this.setState({showPlayInstructorHint:false});}},{key:'getTarget1',value:function getTarget1(){this.setState({showPlayVideoHint:false});}},{key:'getTarget2',value:function getTarget2(){this.setState({showKeywordHint:false});}},{key:'getTarget3',value:function getTarget3(){this.setState({showDeleteHint:false});}},{key:'getTarget4',value:function getTarget4(){this.setState({showSaveHint:false});}},{key:'handleShowHints',value:function handleShowHints(){this.setState({showPlayInstructorHint:true,showPlayVideoHint:true,showKeywordHint:true,showDeleteHint:true,showSaveHint:true});}},{key:'handlePlay',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!this.state.play){_context7.next=5;break;}this.video.pause();this.setState({play:false});_context7.next=9;break;case 5:this.video.play();_context7.next=8;return this.setState({play:true,analytics:{type:__WEBPACK_IMPORTED_MODULE_21__Shared_DataTrackingPoints__["b" /* default */].CR_SCORE_PLAY,metadata:{testId:this.state.testId}}});case 8:this.handleAnalytics();case 9:case'end':return _context7.stop();}}},_callee7,this);}));function handlePlay(){return _ref7.apply(this,arguments);}return handlePlay;}()},{key:'handlePlay1',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:if(this.state.play1){this.crVideo.pause();this.setState({play1:false});}else{this.crVideo.play();this.setState({play1:true});}case 1:case'end':return _context8.stop();}}},_callee8,this);}));function handlePlay1(){return _ref8.apply(this,arguments);}return handlePlay1;}()},{key:'handleSurveyBack',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:case'end':return _context9.stop();}}},_callee9,this);}));function handleSurveyBack(){return _ref9.apply(this,arguments);}return handleSurveyBack;}()},{key:'render',value:function render(){var _this5=this;var wordThumbnails=null;if(this.state.crVideo&&this.state.crVideo.aslSigns&&this.state.crSession.gradeSequence){wordThumbnails=this.state.crVideo.aslSigns.split(",").map(function(crWord,index){var currentGrade=_this5.state.crSession.gradeSequence.split(",")[index];var gradeSrc="btn-info2";if(crWord.toString().startsWith("IX")){gradeSrc="btn-warning";}if(currentGrade==="1"){gradeSrc="btn-success";}// else if (currentGrade === "2") {
//     gradeSrc = "btn-danger"
// }
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{key:index,onClick:function onClick(){return _this5.gradeToggle(index,currentGrade);},style:{margin:"5px"},className:"btn "+gradeSrc,type:'button'},crWord);});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey',style:{paddingTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this5.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:'CRGrading',userId:this.props.user.id,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteScoreConfirm,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this5.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["a" /* Modal */],{id:'dialogBox',show:this.state.modalDialogNote},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{paddingTop:0,marginTop:-10,marginBottom:15}},'Make a Note'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{style:{width:500},onChange:this.handleNoteContentChange,value:this.state.noteContent,placeholder:"Please enter your note here"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section',style:{marginTop:-40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.deleteNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.saveNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 noPadding mobileCenter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__assets_images_app_copyright_png___default.a,alt:"Copy Right",style:{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}),' ',this.props.lastStudent.user.firstname,' ',this.props.lastStudent.user.lastname)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-8 tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'descp'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar"},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ModalFormComponents_ReportBugForm__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Shared_DropDownNotifications__["a" /* default */],Object.assign({studentClick:this.handleStudentClick},this.props)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleShowHints,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Show Hints')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-xs-6 col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"wrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"copyrightVidPlayback",onClick:this.handlePlay,controls:true,playsinline:true,ref:function ref(video){_this5.video=video;},width:'100%',height:'100%'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.state.play?"playpause":"",style:{cursor:'pointer'},onClick:this.handlePlay}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-xs-6 col-md-6 hasVideo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"wrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"copyrightInstruction",onClick:this.handlePlay1,ref:function ref(crVideo){return _this5.crVideo=crVideo;},src:this.state.crVideoSrc!==""?this.state.crVideoSrc:undefined,playsinline:true,autoPlay:false,controls:true,width:'100%',height:'100%'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.state.play1?"playpause":"",style:{cursor:'pointer'},onClick:this.handlePlay1})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{fontFamily:'Open Sans',fontSize:15}},this.state.crVideo?this.state.crVideo.englishSentence:""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative',display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showKeywordHint,className:"popoverCustom"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_modal_x_png___default.a,onClick:this.getTarget2,style:{width:35,paddingRight:5,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint:'))),'Click a word to score'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showKeywordHint,className:"arrowPointer"}),wordThumbnails))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 paddingTop'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return _this5.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_21__Shared_DataTrackingPoints__["b" /* default */].CR_SCORE_EXIT,metadata:{testId:_this5.state.testId}}});case 2:_this5.handleAnalytics();_this5.props.history.push('../student');case 4:case'end':return _context10.stop();}}},_callee10,_this5);})),className:'handBtn fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Exit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNextTask,className:'handBtn',style:{display:this.state.handleNext?'inline-block':'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Next Task')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleTakeANote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Make a Note')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitCRSessionGrade,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleReset,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Reset')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative',display:'inline-block',textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showDeleteHint,className:"popoverCustom"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_modal_x_png___default.a,onClick:this.getTarget3,style:{width:35,paddingRight:5,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint:'))),'Delete to remove this video from scoring'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showDeleteHint,className:"arrowPointer"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this5.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS Task?'});},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete')))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_Footer__["a" /* default */],null));}}]);return CRGrading;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var actionToProps=function actionToProps(dispatch){return{updateStudent:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__TeachersComponent_actions__["h" /* updateStudent */])(student));case 2:return _context11.abrupt('return',_context11.sent);case 3:case'end':return _context11.stop();}}},_callee11,_this6);}));function updateStudent(_x3){return _ref11.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{lastStudent:state.teacherReducer.student};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,actionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(CRGrading)));

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_correct_png__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_correct_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_correct_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_wrong_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_wrong_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_wrong_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_app_wordsignsay_png__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_app_wordsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_app_wordsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Shared_DropDownNotifications__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalFormComponents_ReportBugForm__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_modal_x_png__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_modal_x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_modal_x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_ico_play_white_png__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_ico_play_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_ico_play_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_ico_pause_white_png__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_ico_pause_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_images_ico_pause_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_ico_prev_white_png__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_ico_prev_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_images_ico_prev_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_ico_next_white_png__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_images_ico_next_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_images_ico_next_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_ico_restart_white_png__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_images_ico_restart_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_images_ico_restart_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_bootstrap__ = __webpack_require__(20);
var _this7=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WSSGrading=function(_Component){_inherits(WSSGrading,_Component);function WSSGrading(props){var _this2=this;_classCallCheck(this,WSSGrading);var _this=_possibleConstructorReturn(this,(WSSGrading.__proto__||Object.getPrototypeOf(WSSGrading)).call(this,props));_this.submitWSSSessionGrade=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.setState({sessionData:Object.assign({},_this.state.sessionData,{testId:_this.state.testId,gradingTime:Math.ceil((Date.now()-_this.state.gradeStart)/1000)})});case 2:_context2.next=4;return _this.getGradeCounts();case 4:console.log("Submitting session data: ",_this.state.sessionData);_context2.next=7;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].gradeWSSSession(_this.state.sessionData).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.updateWSSBestScore();case 2:_this.setState({modalDialog:true,responseContent:'Score task saved.',analytics:{type:__WEBPACK_IMPORTED_MODULE_26__Shared_DataTrackingPoints__["b" /* default */].WSS_SCORE_SAVE,metadata:{testId:_this.state.testId}}});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 7:_this.handleAnalytics();case 8:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.startGrading=function(testId){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getWSSSession(testId).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res){var wssSession,bestScores;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:wssSession=res.body;if(!wssSession){_context3.next=10;break;}_context3.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentBestScores(wssSession.userId);case 4:bestScores=_context3.sent;_this.setState({wssSession:wssSession,bestScores:bestScores.body,noteContent:wssSession.note,wssDolceWords:wssSession.dolcewords,videoSrc:__WEBPACK_IMPORTED_MODULE_6__Shared_Consts__["b" /* BUCKET_URL */]+wssSession.AV_FileName});_this.video.src=__WEBPACK_IMPORTED_MODULE_6__Shared_Consts__["b" /* BUCKET_URL */]+wssSession.AV_FileName;_this.startDolceWordGrading(wssSession.dolcewords);_context3.next=12;break;case 10:_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 12:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}()).catch(function(error){_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);});};_this.deleteScoreConfirm=function(confirm){if(confirm){_this.deleteScore();}_this.setState({modalDialogDelete:false});};_this.handleStudentClick=function(student,classId){_this.props.updateStudent(student);_this.props.history.push('/teacher/student');};_this.state={testId:null,gradeStart:null,paused:true,timerInterval:null,bestScores:null,rejectedReason:'',recording:false,videoSrc:"",currentWord:"",currentIndex:-1,dolceWord:null,studentJoined:false,wssDolceWords:[],wssSession:null,modalDialog:false,responseContent:'',modalDialogDelete:false,modalDialogNote:false,noteContent:'',handleNext:false,taskID:null,showStartHint:false,showReScoreHint:false,showSaveHint:false,play:false,sessionData:{testId:null,gradingTime:60,numberCorrect:0,numberIncorrect:0,numberSkipped:0,endLevel:1,endProgress:1,wssDolceWords:[]},analytics:{type:null,metadata:null}};_this.startGrading=_this.startGrading.bind(_this);_this.startDolceWordGrading=_this.startDolceWordGrading.bind(_this);_this.handleReset=_this.handleReset.bind(_this);_this.gradeDolceWord=_this.gradeDolceWord.bind(_this);_this.submitWSSSessionGrade=_this.submitWSSSessionGrade.bind(_this);_this.pause=_this.pause.bind(_this);_this.changeImage=_this.changeImage.bind(_this);_this.prev=_this.prev.bind(_this);_this.next=_this.next.bind(_this);_this.updateWSSBestScore=_this.updateWSSBestScore.bind(_this);_this.getGradeCounts=_this.getGradeCounts.bind(_this);_this.deleteScore=_this.deleteScore.bind(_this);_this.handleTakeANote=_this.handleTakeANote.bind(_this);_this.saveNote=_this.saveNote.bind(_this);_this.deleteNote=_this.deleteNote.bind(_this);_this.handleNoteClose=_this.handleNoteClose.bind(_this);_this.handleNoteContentChange=_this.handleNoteContentChange.bind(_this);_this.handleStudentClick=_this.handleStudentClick.bind(_this);_this.handleNextTask=_this.handleNextTask.bind(_this);_this.getTarget=_this.getTarget.bind(_this);_this.getTarget1=_this.getTarget1.bind(_this);_this.handleShowHints=_this.handleShowHints.bind(_this);_this.handlePlay=_this.handlePlay.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(WSSGrading,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this3=this;var parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);parsed=__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.parse(this.props.location.search);console.log(parsed);_context4.next=5;return this.setState({testId:parsed.testId,gradeStart:Date.now(),analytics:{type:__WEBPACK_IMPORTED_MODULE_26__Shared_DataTrackingPoints__["b" /* default */].WSS_SCORE_VIEW,metadata:{testId:parsed.testId}}});case 5:this.startGrading(parsed.testId);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentNotifications().then(function(res){for(var i=0;i<res.body.length;i++){for(var j=0;j<res.body[i].apps.wordSignSayScores.length;j++){var wordSignSayScores=res.body[i].apps.wordSignSayScores[j];if(wordSignSayScores&&wordSignSayScores.userId===_this3.props.lastStudent.user.id&&wordSignSayScores.id!=parsed.testId){_this3.setState({handleNext:true,taskID:wordSignSayScores.id});}}}});this.handleAnalytics();case 8:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.state.timerInterval);}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){return false;});}},{key:'handleNextTask',value:function handleNextTask(){window.location.href='/teacher/apps/wss-grading?testId='+this.state.taskID;}},{key:'getGradeCounts',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var result,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,dolceWord;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:result={numberCorrect:0,numberIncorrect:0,numberSkipped:0};_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context5.prev=4;for(_iterator=this.state.wssDolceWords[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){dolceWord=_step.value;if(dolceWord.wss_assessments_dolceword.grade===1){result.numberCorrect=result.numberCorrect+1;}else if(dolceWord.wss_assessments_dolceword.grade===2){result.numberIncorrect=result.numberIncorrect+1;}else{result.numberSkipped=result.numberSkipped+1;}}_context5.next=12;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](4);_didIteratorError=true;_iteratorError=_context5.t0;case 12:_context5.prev=12;_context5.prev=13;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 15:_context5.prev=15;if(!_didIteratorError){_context5.next=18;break;}throw _iteratorError;case 18:return _context5.finish(15);case 19:return _context5.finish(12);case 20:_context5.next=22;return this.setState({sessionData:Object.assign({},this.state.sessionData,result)});case 22:return _context5.abrupt('return',result);case 23:case'end':return _context5.stop();}}},_callee5,this,[[4,8,12,20],[13,,15,19]]);}));function getGradeCounts(){return _ref5.apply(this,arguments);}return getGradeCounts;}()},{key:'updateWSSBestScore',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var newProgress,newLevel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:newProgress=this.state.bestScores.wssScore;newLevel=this.state.bestScores.wssLevel;if(this.state.sessionData.numberCorrect>=18){newProgress++;if(newProgress>=4){newProgress=3;}}else{newProgress--;}if(newProgress<=0){newProgress=1;}_context6.next=6;return this.setState({bestScores:Object.assign({},this.state.bestScores,{wssLevel:newLevel,wssScore:newProgress})});case 6:_context6.next=8;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWSSBestScore(this.state.bestScores);case 8:case'end':return _context6.stop();}}},_callee6,this);}));function updateWSSBestScore(){return _ref6.apply(this,arguments);}return updateWSSBestScore;}()},{key:'handleReset',value:function handleReset(){for(var i=0;i<this.state.wssDolceWords.length;i++){this.state.wssDolceWords[i].wss_assessments_dolceword.grade=0;this.state.sessionData.wssDolceWords.push(this.state.wssDolceWords[i]);}this.setState({sessionData:Object.assign({},this.state.sessionData,{numberCorrect:0,numberIncorrect:0,numberSkipped:0})});}},{key:'gradeDolceWord',value:function gradeDolceWord(grade){this.state.dolceWord.wss_assessments_dolceword.grade=grade;this.state.sessionData.wssDolceWords.push(this.state.dolceWord);if(grade===1){this.state.sessionData.numberCorrect=this.state.sessionData.numberCorrect+1;}else if(grade===2){this.state.sessionData.numberIncorrect=this.state.sessionData.numberIncorrect+1;}else{this.state.sessionData.numberSkipped=this.state.sessionData.numberSkipped+1;}this.next();}},{key:'startDolceWordGrading',value:function startDolceWordGrading(wssDolceWords){var _this4=this;var i=0;var prev=-1;var timer=setInterval(function(){if(!_this4.state.paused){if(_this4.video.currentTime>=0.0&&_this4.video.currentTime<_this4.video.duration){var timeInterval=_this4.video.duration/wssDolceWords.length;i=Math.floor(_this4.video.currentTime/timeInterval);if(prev!==i){_this4.setState({dolceWord:wssDolceWords[i],currentWord:wssDolceWords[i].word,currentIndex:i});}prev=i;}else{_this4.setState({dolceWord:null,currentWord:"",currentIndex:-1});}}},100);this.setState({timerInterval:timer});}},{key:'pause',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_pause){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:this.setState({paused:_pause});if(!_pause){_context7.next=6;break;}this.video.pause();this.setState({play:false});_context7.next=9;break;case 6:this.video.play();_context7.next=9;return this.setState({play:true});case 9:return _context7.abrupt('return',false);case 10:case'end':return _context7.stop();}}},_callee7,this);}));function pause(_x3){return _ref7.apply(this,arguments);}return pause;}()},{key:'changeImage',value:function changeImage(index){var timeInterval=this.video.duration/this.state.wssDolceWords.length;this.video.currentTime=Math.ceil(index*timeInterval);this.pause(false);}},{key:'prev',value:function prev(){if(this.state.currentIndex>0){this.changeImage(this.state.currentIndex-1);}}},{key:'next',value:function next(){if(this.state.currentIndex<this.state.wssDolceWords.length-1){this.changeImage(this.state.currentIndex+1);}else{this.video.currentTime=this.video.duration;this.pause(true);}}},{key:'deleteScore',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_26__Shared_DataTrackingPoints__["b" /* default */].WSS_SCORE_DELETE,metadata:{testId:this.state.testId}}});case 2:_context8.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].deleteWordSignSayScore(this.state.testId).then(function(res){_this5.handleAnalytics();_this5.props.history.goBack();});case 4:case'end':return _context8.stop();}}},_callee8,this);}));function deleteScore(){return _ref8.apply(this,arguments);}return deleteScore;}()},{key:'handleTakeANote',value:function handleTakeANote(){console.log("take a note");this.setState({modalDialogNote:true});}},{key:'handleNoteContentChange',value:function handleNoteContentChange(event){this.setState({noteContent:event.target.value});event.preventDefault();}},{key:'saveNote',value:function saveNote(){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWordSignSayNote({testId:this.state.testId,note:this.state.noteContent});this.setState({modalDialogNote:false});}},{key:'deleteNote',value:function deleteNote(){this.setState({noteContent:''});__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWordSignSayNote({testId:this.state.testId,note:''});}},{key:'handleNoteClose',value:function handleNoteClose(){this.setState({modalDialogNote:false});}},{key:'getTarget',value:function getTarget(){this.setState({showStartHint:false});}},{key:'getTarget1',value:function getTarget1(){this.setState({showReScoreHint:false});}},{key:'handleShowHints',value:function handleShowHints(){this.setState({showStartHint:true,showReScoreHint:true,showSaveHint:true});}},{key:'handlePlay',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(!this.state.play){_context9.next=5;break;}this.video.pause();this.setState({play:false});_context9.next=8;break;case 5:this.video.play();_context9.next=8;return this.setState({play:true});case 8:case'end':return _context9.stop();}}},_callee9,this);}));function handlePlay(){return _ref9.apply(this,arguments);}return handlePlay;}()},{key:'handleSurveyBack',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:case'end':return _context10.stop();}}},_callee10,this);}));function handleSurveyBack(){return _ref10.apply(this,arguments);}return handleSurveyBack;}()},{key:'render',value:function render(){var _this6=this;var imageThumbnails=this.state.wssDolceWords.map(function(dolceWord,index){var gradeSrc="";if(dolceWord.wss_assessments_dolceword.grade===1){gradeSrc=__WEBPACK_IMPORTED_MODULE_8__assets_images_correct_png___default.a;}else if(dolceWord.wss_assessments_dolceword.grade===2){gradeSrc=__WEBPACK_IMPORTED_MODULE_9__assets_images_wrong_png___default.a;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:index,style:{position:"relative",display:"inline-block",paddingTop:"20px",paddingLeft:"20px",paddingBottom:"20px",paddingRight:"20px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{position:"absolute",top:"10px",width:15,left:"5px",zIndex:2},src:gradeSrc,alt:""}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{position:"relative",top:"0px",left:"0px",zIndex:1,cursor:'pointer'},key:index,onClick:function onClick(){return _this6.changeImage(index);},width:'50',height:'43'},dolceWord.word));});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"section bgGrey",style:{paddingTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:'WSSGrading',userId:this.props.user.id,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteScoreConfirm,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react_bootstrap__["a" /* Modal */],{id:'dialogBox',show:this.state.modalDialogNote},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{paddingTop:0,marginTop:-10,marginBottom:15}},'Make a Note'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{style:{width:500},onChange:this.handleNoteContentChange,value:this.state.noteContent,placeholder:"please enter your note here"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section',style:{marginTop:-40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.deleteNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.saveNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 noPadding mobileCenter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_app_wordsignsay_png___default.a,alt:"Word Sign/ Say",style:{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}),' ',this.props.lastStudent.user.firstname,' ',this.props.lastStudent.user.lastname)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-8 tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'descp'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar"},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ModalFormComponents_ReportBugForm__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Shared_DropDownNotifications__["a" /* default */],Object.assign({studentClick:this.handleStudentClick},this.props)),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleShowHints,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Show Hints')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{minHeight:"405px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-xs-6 col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"wrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"WordSignSayVidPlay",onClick:this.handlePlay,controls:true,onPause:function onPause(){return _this6.pause(true);},onPlay:function onPlay(){return _this6.pause(false);},playsinline:true,ref:function ref(video){_this6.video=video;},width:'100%',height:'100%'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.state.play?"playpause":"",style:{cursor:'pointer'},onClick:this.handlePlay})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-success btn-controls',hidden:!this.state.paused,onClick:function onClick(){return _this6.pause(false);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_21__assets_images_ico_play_white_png___default.a,height:'20',width:'20',alt:''}),' Play'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-xs btn-blue btn-controls',hidden:this.state.paused,onClick:function onClick(){return _this6.pause(true);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_22__assets_images_ico_pause_white_png___default.a,height:'20',width:'20',alt:''}),' Pause '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-info btn-controls',onClick:function onClick(){return _this6.prev();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_23__assets_images_ico_prev_white_png___default.a,height:'20',width:'30',alt:''}),' Prev'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-info btn-controls',onClick:function onClick(){return _this6.next();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_24__assets_images_ico_next_white_png___default.a,height:'20',width:'30',alt:''}),' Next'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'btn btn-orange btn-controls',onClick:function onClick(){return _this6.changeImage(-1);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_25__assets_images_ico_restart_white_png___default.a,height:'20',width:'20',alt:''}),' Restart')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-xs-6 col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{fontSize:"56pt",textAlign:"left",textTransform:'lowercase'}},this.state.currentWord),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.currentWord==="",className:'row '},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-success',onClick:function onClick(){return _this6.gradeDolceWord(1);}},'Correct'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-danger',style:{marginLeft:5},onClick:function onClick(){return _this6.gradeDolceWord(2);}},'Incorrect'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-info2',style:{marginLeft:5},onClick:function onClick(){return _this6.gradeDolceWord(0);}},'Skip')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative',display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showReScoreHint,className:"popoverCustom"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_images_modal_x_png___default.a,onClick:this.getTarget1,style:{width:35,paddingRight:5,cursor:"pointer"}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint:'))),'                                                        Click a word to re-score'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showReScoreHint,className:"arrowPointer"})),imageThumbnails)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 paddingTop'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return _this6.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_26__Shared_DataTrackingPoints__["b" /* default */].WSS_SCORE_EXIT,metadata:{testId:_this6.state.testId}}});case 2:_this6.handleAnalytics();_this6.props.history.push('../student');case 4:case'end':return _context11.stop();}}},_callee11,_this6);})),className:'handBtn fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Exit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNextTask,className:'handBtn',style:{display:this.state.handleNext?'inline-block':'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Next Task')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleTakeANote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Make a Note')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitWSSSessionGrade,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleReset,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Reset')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this6.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TASK?'});},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_Footer__["a" /* default */],null));}}]);return WSSGrading;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var actionToProps=function actionToProps(dispatch){return{updateStudent:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__actions__["h" /* updateStudent */])(student));case 2:return _context12.abrupt('return',_context12.sent);case 3:case'end':return _context12.stop();}}},_callee12,_this7);}));function updateStudent(_x4){return _ref12.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{lastStudent:state.teacherReducer.student};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,actionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(WSSGrading)));

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recordrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recordrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_SafariWorker__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lamejs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lamejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lamejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_KidSign_css__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_students_KidSign_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_students_KidSign_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LoadingModalComponent_LoadingModal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Common__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ProgressModalComponent_ProgressBox__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_rec_gif__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_rec_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_rec_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_video_mask_png__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_video_mask_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_video_mask_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_video_instructions_png__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_video_instructions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_video_instructions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Shared_InstructionModals__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_timers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_device_detect__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_device_detect__);
var _this19=this;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var hasGetUserMedia=false;try{hasGetUserMedia=!!navigator.getUserMedia||!!navigator.mediaDevices.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}catch(err){hasGetUserMedia=!!navigator.getUserMedia||!!navigator.webkitGetUserMedia||!!navigator.mozGetUserMedia||!!navigator.msGetUserMedia;}var bestScor='{\n\t"success": true,\n\t"body": {\n\t\t"id": 4430,\n\t\t"userId": 6974,\n\t\t"createdAt": "2018-10-16T18:36:55.759Z",\n\t\t"updatedAt": "2018-12-24T09:27:26.541Z",\n\t\t"mazeLevel": 3,\n\t\t"mazeScore": 2,\n\t\t"slashLevel": 4,\n\t\t"slashScore": 2,\n\t\t"ksLevel": 4,\n\t\t"ksScore": 1,\n\t\t"pnLevel": 2,\n\t\t"pnScore": 1,\n\t\t"crLevel": 2,\n\t\t"crScore": 1,\n\t\t"wssLevel": 1,\n\t\t"wssScore": 1,\n\t\t"kssLevel": 3,\n\t\t"kssScore": 2,\n\t\t"deletedAt": null\n\t},\n\t"msg": ""\n}';var newSes='{\n\t"kssPassageId": 12,\n\t"AV_FileName": "",\n\t"startLevel": 3,\n\t"endLevel": 0,\n\t"startProgress": 2,\n\t"endProgress": 0,\n\t"guid": "c2dee4e8-cf78-4ed8-84e2-2f5bba9b8720"\n}';var kidSignTest='[{\n\t"id": 12,\n\t"createdAt": "2018-10-17T17:34:33.863Z",\n\t"updatedAt": "2018-10-17T17:34:33.863Z",\n\t"title": "SATURDAY",\n\t"passage": "My frog\'s name is Bert. He is big, green, and wet. I like to take Bert with me everywhere I go.",\n\t"tUnits": "My frog\'s name is Bert. He is big, green, and wet. I like to take Bert with me everywhere I go.",\n\t"level": 3,\n\t"goal": 3,\n\t"deletedAt": null,\n\t"kidsign_assessments": []\n}]';var params=null;var KidSignComponent=function(_Component){_inherits(KidSignComponent,_Component);function KidSignComponent(props){_classCallCheck(this,KidSignComponent);var _this=_possibleConstructorReturn(this,(KidSignComponent.__proto__||Object.getPrototypeOf(KidSignComponent)).call(this,props));_this.handleActive=function(active){_this.setState({active:active});};_this.handleBeginTest=function(){_this.setState({active:3});};_this.state={active:0,loadedScores:false,bestScores:{kssScore:1,kssLevel:1}};return _this;}_createClass(KidSignComponent,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);case 2:_context3.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!response.success){_context.next=3;break;}_context.next=3;return _this2.setState({loadedScores:true,bestScores:response.body});case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 4:_context3.next=6;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentAppStatus().then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var _Helpers$filterApps,allowedApps,filteredApps,finishedApps;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this2.props.updateStudentAppStatus(res.body);case 2:_Helpers$filterApps=__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].filterApps(_this2.props.studentUser,_this2.props.apps),allowedApps=_Helpers$filterApps.allowedApps,filteredApps=_Helpers$filterApps.filteredApps,finishedApps=_Helpers$filterApps.finishedApps;_context2.next=5;return _this2.props.updateAppStates({allowedApps:allowedApps,filteredApps:filteredApps,finishedApps:finishedApps});case 5:_context2.next=7;return _this2.setState({bestScores:res.body.bestScores});case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}());case 6:if(this.props.apps.kidSignScores.filter(function(x){return x.gradingDate==null;}).length>3){this.props.history.goBack();}case 7:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.state.active!==2?"bgGrey KidSign":"bgYellow KidSign"},this.state.active===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section appSection bgGrey'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer progressBox1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'Kid Sign/Say'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 text-center"},this.state.loadedScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProgressModalComponent_ProgressBox__["a" /* default */],{appName:"kidsign",level:this.state.bestScores.kssLevel,step:this.state.bestScores.kssScore,steps:3,maxLevel:12,noDescription:true}):null))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"kidsign",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{demo:true,appName:"kidsign",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer progressBox1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{textAlign:"center",fontSize:'42px'}},'Kid Sign/Say: Show Me'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row",style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-xs-12 centerBlock"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["g" /* VideoComponent */],{url:"https://s3.us-east-2.amazonaws.com/uploaddev/video/kidsign/Kidsigngirl.mp4"})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{demo:true,appName:"kidsign",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{practice:true,appName:"kidsign",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tutorial,{studentUser:this.props.studentUser,buttonClick:this.handleActive,beginTest:this.handleBeginTest}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"kidsign",buttonClick:this.handleActive,currentTabActive:this.state.active})):null,this.state.active===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["b" /* Buttons1 */],{appName:"kidsign",buttonClick:this.handleActive,currentTabActive:this.state.active}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(KidSign,{studentUser:this.props.studentUser,buttonClick:this.handleActive,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["a" /* Buttons */],{appName:"kidsign",buttonClick:this.handleActive,currentTabActive:this.state.active})):null);}}]);return KidSignComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var KidSign=function(_Component2){_inherits(KidSign,_Component2);function KidSign(props){var _this4=this;_classCallCheck(this,KidSign);var _this3=_possibleConstructorReturn(this,(KidSign.__proto__||Object.getPrototypeOf(KidSign)).call(this,props));_this3.handleToggleInstruction=function(toggleInstruction){localStorage.setItem('KidsignInstruction',toggleInstruction);};_this3.captureUserMedia=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(callback,options){var params;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:params=null;_context4.next=3;return _this3.getMediaParam(options);case 3:params=_context4.sent;navigator.mediaDevices.getUserMedia(params).then(callback).catch(function(error){_this3.setState({modalDialog:true,responseContent:error});});case 5:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x3,_x4){return _ref4.apply(this,arguments);};}();_this3.handleStartKidSign=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!_this3.props.practice){_context6.next=17;break;}if(!((typeof newSes==='undefined'?'undefined':_typeof(newSes))!=='object'&&newSes!==null)){_context6.next=5;break;}_context6.next=4;return JSON.parse(newSes);case 4:newSes=_context6.sent;case 5:if(!((typeof bestScor==='undefined'?'undefined':_typeof(bestScor))!=='object'&&bestScor!==null)){_context6.next=9;break;}_context6.next=8;return JSON.parse(bestScor);case 8:bestScor=_context6.sent;case 9:if(!((typeof kidSignTest==='undefined'?'undefined':_typeof(kidSignTest))!=='object'&&kidSignTest!==null)){_context6.next=13;break;}_context6.next=12;return JSON.parse(kidSignTest);case 12:kidSignTest=_context6.sent;case 13:_context6.next=15;return _this3.setState({bestScores:bestScor.body,sessionData:newSes,kssPassageSrc:kidSignTest[0].passage});case 15:_context6.next=18;break;case 17:__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getKSSRandom().then(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(res){var kssPassages,bestScores,newSesh;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:kssPassages=res.body;if(!(kssPassages.length===0)){_context5.next=7;break;}window.removeEventListener("beforeunload",_this3.onUnload);_this3.setState({modalDialog:true,responseContent:'No new passages were found.'});setTimeout(function(){_this3.setState({modalDialog:false});window.location.reload();},2500);_this3.props.history.goBack();return _context5.abrupt('return');case 7:_context5.next=9;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getBestScores();case 9:bestScores=_context5.sent;newSesh=_this3.state.sessionData;newSesh.startLevel=bestScores.body.kssLevel;newSesh.startProgress=bestScores.body.kssScore;newSesh.kssPassageId=kssPassages[0].id;_context5.next=16;return _this3.setState({bestScores:bestScores.body,sessionData:newSesh,kssPassageSrc:kssPassages[0].passage});case 16:case'end':return _context5.stop();}}},_callee5,_this4);}));return function(_x5){return _ref6.apply(this,arguments);};}()).catch(function(error){console.log(error);});case 18:case'end':return _context6.stop();}}},_callee6,_this4);}));_this3.state={showVideo:true,popupSurvey:false,timerInterval:null,timerTime:60,isUploading:false,isCounting:false,countdown:-1,bestScores:null,countDownTimer:null,videoTimeout:null,recordVideo:null,rejectedReason:'',recording:false,kssPassageSrc:"",recordingVideoPlayCount:0,recordingAudioPlayCount:0,videoSrc:false,recordingsCount:0,audioSrc:false,audioBlob:false,recordAudio:null,audioVideoSwitch:"video",modalDialog:false,modalInstruction:false,responseContent:'',upTime:null,disableSubmit:false,analytics:{type:null,metadata:null},sessionData:{kssPassageId:0,AV_FileName:"",startLevel:0,endLevel:0,startProgress:0,endProgress:0,guid:__webpack_require__(68)()}};_this3.handleSurveyBack=_this3.handleSurveyBack.bind(_this3);_this3.handleStartKidSign=_this3.handleStartKidSign.bind(_this3);_this3.handleShowVideo=_this3.handleShowVideo.bind(_this3);_this3.handleStart=_this3.handleStart.bind(_this3);_this3.handleStop=_this3.handleStop.bind(_this3);_this3.setStreamToVideo=_this3.setStreamToVideo.bind(_this3);_this3.releaseStreamFromVideo=_this3.releaseStreamFromVideo.bind(_this3);_this3.uploadVideo=_this3.uploadVideo.bind(_this3);_this3.requestUserMedia=_this3.requestUserMedia.bind(_this3);_this3.startRecord=_this3.startRecord.bind(_this3);_this3.stopRecord=_this3.stopRecord.bind(_this3);_this3.handleBackToMenu=_this3.handleBackToMenu.bind(_this3);_this3.submitSession=_this3.submitSession.bind(_this3);_this3.handleRecordVideo=_this3.handleRecordVideo.bind(_this3);_this3.recordingPlay=_this3.recordingPlay.bind(_this3);_this3.toggleAudioVideo=_this3.toggleAudioVideo.bind(_this3);_this3.onUnload=_this3.onUnload.bind(_this3);_this3.handleToggleInstruction=_this3.handleToggleInstruction.bind(_this3);_this3.startTimer=_this3.startTimer.bind(_this3);_this3.countDown=_this3.countDown.bind(_this3);_this3.handleAnalytics=_this3.handleAnalytics.bind(_this3);return _this3;}_createClass(KidSign,[{key:'onUnload',value:function onUnload(event){// the method that will be used for both add and remove event
event.returnValue="By leaving or reloading the page you will lose your app progress";}},{key:'componentDidMount',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:window.addEventListener("beforeunload",this.onUnload);if(!/firefox/i.test(navigator.userAgent)){_context7.next=4;break;}this.setState({modalDialog:true,responseContent:'Please use Safari or Chrome browser for this task'});return _context7.abrupt('return');case 4:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);if(hasGetUserMedia){_context7.next=8;break;}this.setState({modalDialog:true,responseContent:!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform)&&(navigator.userAgent.match('CriOS')||navigator.userAgent.match('Mozilla'))?'Please use Safari (above version 11) for this task.':'Your browser cannot stream from your webcam. Please switch to Chrome.'});return _context7.abrupt('return');case 8:this.requestUserMedia();this.handleStartKidSign();_context7.next=12;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_22__Shared_DataTrackingPoints__["b" /* default */].STUDENT_KSS_START,metadata:{platform:navigator.platform,userAgent:navigator.userAgent}}});case 12:this.handleAnalytics();case 13:case'end':return _context7.stop();}}},_callee7,this);}));function componentDidMount(){return _ref7.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("beforeunload",this.onUnload);if(this.state.recording){if(this.state.audioVideoSwitch==="video"){this.state.recordVideo.stop(function(res){});}else{this.state.recordAudio.stop(function(res){});}Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.state.countDownTimer);clearTimeout(this.state.videoTimeout);Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.state.timerInterval);this.captureUserMedia(function(stream){stream.stop();});}if(this.video&&this.video.srcObject){this.video.srcObject.stop();}}},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleShowVideo',value:function handleShowVideo(){this.setState({showVideo:!this.state.showVideo});}},{key:'handleBackToMenu',value:function handleBackToMenu(e){this.props.history.goBack();}},{key:'requestUserMedia',value:function requestUserMedia(){var _this5=this;this.captureUserMedia(function(stream){_this5.setStreamToVideo(stream);});}},{key:'handleStart',value:function handleStart(stream){var _this6=this;if(this.state.audioVideoSwitch==="video"){this.setStreamToVideo(stream);}var timerInterval=Object(__WEBPACK_IMPORTED_MODULE_19_timers__["setInterval"])(function(){if(_this6.state.timerTime>0){_this6.setState({timerTime:_this6.state.timerTime-1});}else{Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(_this6.state.timerInterval);_this6.setState({timerInterval:null});}},1000);var timeoutTimer=setTimeout(function(){_this6.stopRecord();},1000*60);this.setState({recording:true,videoTimeout:timeoutTimer,timerInterval:timerInterval,timerTime:60});}},{key:'handleStop',value:function handleStop(blob){this.setState({recording:false,videoTimeout:null});if(this.state.audioVideoSwitch==="video"){this.releaseStreamFromVideo();}else{this.releaseStreamFromAudio();}this.uploadVideo(blob instanceof Blob,blob);}},{key:'setStreamToVideo',value:function setStreamToVideo(stream){this.video.srcObject=stream;}},{key:'releaseStreamFromVideo',value:function releaseStreamFromVideo(){this.video.srcObject=null;}},{key:'encodeMono',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(channels,sampleRate,samples){var kbps,mp3encoder,sampleBlockSize,mp3Data,i,sampleChunk,_mp3buf,mp3buf,blob;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:kbps=256;//encode 128kbps mp3
mp3encoder=new __WEBPACK_IMPORTED_MODULE_9_lamejs___default.a.Mp3Encoder(channels,sampleRate,kbps);sampleBlockSize=1152;//can be anything but make it a multiple of 576 to make encoders life easier
mp3Data=[];for(i=0;i<samples.length;i+=sampleBlockSize){sampleChunk=samples.subarray(i,i+sampleBlockSize);_mp3buf=mp3encoder.encodeBuffer(sampleChunk);if(_mp3buf.length>0){mp3Data.push(_mp3buf);}}mp3buf=mp3encoder.flush();//finish writing mp3
if(mp3buf.length>0){mp3Data.push(new Int8Array(mp3buf));}blob=new Blob(mp3Data,{type:'audio/mp3'});_context8.next=10;return this.setState({audioBlob:blob});case 10:this.handleStop(blob);case 11:case'end':return _context8.stop();}}},_callee8,this);}));function encodeMono(_x6,_x7,_x8){return _ref8.apply(this,arguments);}return encodeMono;}()},{key:'setStreamToAudio',value:function setStreamToAudio(stream){this.audio.srcObject=stream;}},{key:'releaseStreamFromAudio',value:function releaseStreamFromAudio(){this.audio.pause();this.audio.srcObject=null;this.audio.src="";this.audio.load();}},{key:'startRecordAudio',value:function startRecordAudio(){var _this7=this;this.captureUserMedia(function(stream){var options={type:'audio',audio:_this7.audio,sampleRate:44100,bufferSize:4096,numberOfAudioChannels:1,recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder};_this7.setState({recordAudio:new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder(stream,options)});_this7.state.recordAudio.record();_this7.handleStartAudio(stream);},{audio:true,video:false});}},{key:'handleStopAudio',value:function handleStopAudio(wavBlob){var _this8=this;this.setState({recording:false});var fileReader=new FileReader();fileReader.onload=function(event){var arrayBuffer=event.target.result;var wav=__WEBPACK_IMPORTED_MODULE_9_lamejs___default.a.WavHeader.readHeader(new DataView(arrayBuffer));var samples=new Int16Array(arrayBuffer,wav.dataOffset,wav.dataLen/2);_this8.encodeMono(wav.channels,wav.sampleRate,samples);_this8.releaseStreamFromAudio();};fileReader.readAsArrayBuffer(wavBlob);}},{key:'handleStartAudio',value:function handleStartAudio(stream){this.setState({recording:true});this.setStreamToAudio(stream);}},{key:'stopRecordAudio',value:function stopRecordAudio(){var _this9=this;this.state.recordAudio.stop(function(wavBlob){_this9.handleStopAudio(wavBlob);});}},{key:'getMediaParam',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(options){var userAgent;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return navigator.userAgent;case 2:userAgent=_context9.sent;if(!options){_context9.next=7;break;}params=options;_context9.next=15;break;case 7:if(!(/Chrome/i.test(userAgent)&&/Windows/i.test(userAgent))){_context9.next=11;break;}params={audio:true,video:true};_context9.next=15;break;case 11:_context9.next=13;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].getVideoSizes();case 13:_context9.t0=_context9.sent;params={audio:true,video:_context9.t0};case 15:return _context9.abrupt('return',params);case 16:case'end':return _context9.stop();}}},_callee9,this);}));function getMediaParam(_x9){return _ref9.apply(this,arguments);}return getMediaParam;}()},{key:'uploadVideo',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(isBlob,blob){var _this10=this;var vidETA;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].calculateETA(null,blob);case 2:vidETA=_context11.sent;this.setState({upTime:vidETA});_context11.next=6;return this.startTimer();case 6:_context11.next=8;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].uploadKSSVideo(isBlob,blob).then(function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(!(_this10.state.audioVideoSwitch==="video")){_context10.next=6;break;}_this10.video.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_context10.next=4;return _this10.setState({videoSrc:_this10.video.src,recordingsCount:_this10.state.recordingsCount+1,isUploading:false});case 4:_context10.next=10;break;case 6:_this10.audio2.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_context10.next=9;return _this10.setState({audioSrc:_this10.audio2.src,recordingsCount:_this10.state.recordingsCount+1,isUploading:false});case 9:_this10.audio2.load();case 10:if(_this10.state.recordingsCount>1){_this10.submitSession();}window.removeEventListener("beforeunload",_this10.onUnload);case 12:case'end':return _context10.stop();}}},_callee10,_this10);}));return function(_x12){return _ref11.apply(this,arguments);};}()).catch(function(error){console.log(error);});case 8:case'end':return _context11.stop();}}},_callee11,this);}));function uploadVideo(_x10,_x11){return _ref10.apply(this,arguments);}return uploadVideo;}()},{key:'submitSession',value:function submitSession(){var _this11=this;this.setState({disableSubmit:true});var seshData=this.state.sessionData;if(this.state.audioVideoSwitch==="video"){seshData.AV_FileName=this.state.videoSrc.replace(__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */],"");}else{seshData.AV_FileName=this.state.audioSrc.replace(__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */],"");}if(!this.props.practice){window.removeEventListener("beforeunload",this.onUnload);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].insertKSSSession(seshData).then(function(res){_this11.setState({modalDialog:true,responseContent:'Data Successfully Saved and Submitted'});});}}},{key:'handleSurveyBack',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0://window.location.reload();
this.props.history.push("/student");//this.props.buttonClick(0);
case 1:case'end':return _context12.stop();}}},_callee12,this);}));function handleSurveyBack(){return _ref12.apply(this,arguments);}return handleSurveyBack;}()},{key:'handleRecordVideo',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(){var _this12=this;var countDownTimer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return this.setState({isCounting:true});case 2:if(!(this.state.recordingsCount<=1)){_context14.next=8;break;}_context14.next=5;return this.setState({countdown:3});case 5:countDownTimer=Object(__WEBPACK_IMPORTED_MODULE_19_timers__["setInterval"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return _this12.setState({countdown:_this12.state.countdown-1});case 2:if(!(_this12.state.countdown<0)){_context13.next=7;break;}Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(countDownTimer);_context13.next=6;return _this12.setState({isCounting:false});case 6:_this12.startRecord();case 7:case'end':return _context13.stop();}}},_callee13,_this12);})),1000);_context14.next=8;return this.setState({countDownTimer:countDownTimer});case 8:case'end':return _context14.stop();}}},_callee14,this);}));function handleRecordVideo(){return _ref13.apply(this,arguments);}return handleRecordVideo;}()},{key:'noWebM',value:function noWebM(){return __WEBPACK_IMPORTED_MODULE_23_react_device_detect__["isIOS"]||__WEBPACK_IMPORTED_MODULE_23_react_device_detect__["isSafari"];}},{key:'startRecordVideo',value:function startRecordVideo(){var _this13=this;this.captureUserMedia(function(stream){var audio_options={type:'audio',audio:_this13.audio,sampleRate:44100,bufferSize:4096,numberOfAudioChannels:1,recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder};var video_options=void 0;var videoRecorderClass=void 0;if(_this13.noWebM()){video_options={type:'video',recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.WhammyRecorder,frameInterval:50,video:_this13.video,width:320,height:240};videoRecorderClass=new __WEBPACK_IMPORTED_MODULE_7__Shared_SafariWorker__["a" /* default */]().WhammyRecorder(stream,video_options);}else{video_options={mimeType:'video/webm',recorderType:__WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.MediaStreamRecorder,width:320,height:240};videoRecorderClass=new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.MediaStreamRecorder(stream,video_options);}_this13.setState({recordAudio:new __WEBPACK_IMPORTED_MODULE_6_recordrtc___default.a.StereoAudioRecorder(stream,audio_options),recordVideo:videoRecorderClass},function(){if(_this13.noWebM()){_this13.state.recordVideo.record(_this13.state.recordAudio.record());}else{_this13.state.recordVideo.record();}_this13.handleStart(stream);});},{audio:true,video:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].getVideoSizes()});}},{key:'handleStopWrapper',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(vidResult,wavBlob){var _this14=this;var vidETA;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:this.setState({recording:false});if(this.props.practice){_context15.next=13;break;}if(this.state.audioVideoSwitch==="video"){this.releaseStreamFromVideo();if(this.noWebM()){this.releaseStreamFromAudio();}}_context15.next=5;return __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].calculateETA(vidResult,wavBlob);case 5:vidETA=_context15.sent;this.setState({upTime:vidETA});_context15.next=9;return this.startTimer();case 9:_context15.next=11;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].uploadKSSVideo(true,vidResult,wavBlob).then(function(res){if(_this14.state.audioVideoSwitch==="video"){_this14.video.src=__WEBPACK_IMPORTED_MODULE_8__Shared_Consts__["b" /* BUCKET_URL */]+res.body.filepath;_this14.setState({videoSrc:_this14.video.src});}var seshData=_this14.state.sessionData;seshData.AV_FileName=res.body.filepath;_this14.setState({isUploading:false,recordedSession:true});}).catch(function(error){});case 11:_context15.next=14;break;case 13:this.setState({modalDialog:true,responseContent:'Practice Finished'});case 14:case'end':return _context15.stop();}}},_callee15,this);}));function handleStopWrapper(_x13,_x14){return _ref15.apply(this,arguments);}return handleStopWrapper;}()},{key:'stopRecordVideo',value:function stopRecordVideo(){var _this15=this;if(this.noWebM()){var promise1=function promise1(){return new Promise(function(resolve,reject){_this15.state.recordAudio.stop(function(wavBlob){resolve(wavBlob);});});};var promise2=function promise2(){return new Promise(function(resolve,reject){_this15.state.recordVideo.stop(function(result){resolve(result);});});};Promise.all([promise1(),promise2()]).then(function(values){if(values[0]instanceof Array){_this15.handleStopWrapper(values[0],values[1]);}else{_this15.handleStopWrapper(values[1],values[0]);}});}else{this.state.recordVideo.stop(function(result){_this15.handleStopWrapper([],result);});}}},{key:'stopRecord',value:function stopRecord(){var _this16=this;if(this.props.practice){this.setState({modalDialog:true,responseContent:'Practice Finished'});setTimeout(function(){_this16.setState({modalDialog:false});_this16.props.buttonClick(0);},2500);}else{clearTimeout(this.state.videoTimeout);if(this.state.audioVideoSwitch==="video"){this.stopRecordVideo();}else{this.stopRecordAudio();}Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.state.timerInterval);this.setState({recording:false,isUploading:true});}}},{key:'startRecord',value:function startRecord(){if(this.state.audioVideoSwitch==="video"){this.startRecordVideo();}else{this.startRecordAudio();}this.setState({recording:true});}},{key:'recordingPlay',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return this.setState({recordingVideoPlayCount:this.state.recordingVideoPlayCount+1});case 2:this.video.play();case 3:case'end':return _context16.stop();}}},_callee16,this);}));function recordingPlay(){return _ref16.apply(this,arguments);}return recordingPlay;}()},{key:'recordingAudioPlay',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return this.setState({recordingAudioPlayCount:this.state.recordingAudioPlayCount+1});case 2:this.audio2.play();case 3:case'end':return _context17.stop();}}},_callee17,this);}));function recordingAudioPlay(){return _ref17.apply(this,arguments);}return recordingAudioPlay;}()},{key:'toggleAudioVideo',value:function toggleAudioVideo(){if(this.state.audioVideoSwitch==="video"){this.setState({audioVideoSwitch:"audio"});this.releaseStreamFromVideo();}else{this.setState({audioVideoSwitch:"video"});this.releaseStreamFromAudio();this.requestUserMedia();}}},{key:'startTimer',value:function startTimer(){this.timer=Object(__WEBPACK_IMPORTED_MODULE_19_timers__["setInterval"])(this.countDown,1000);}},{key:'countDown',value:function countDown(){var seconds=this.state.upTime-1;this.setState({upTime:seconds});if(seconds<=0){Object(__WEBPACK_IMPORTED_MODULE_19_timers__["clearInterval"])(this.timer);}}},{key:'render',value:function render(){var _this17=this;var countDown=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.countdown<=0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:"fontCountdown"},this.state.countdown));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.practice?"appSection bgGrey":"appSection bgYellow"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},!this.props.practice?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Shared_InstructionModals__["a" /* default */],{KidSign:true,modalOpen:this.state.modalInstruction,instructionMask:__WEBPACK_IMPORTED_MODULE_17__assets_images_video_instructions_png___default.a,toggleInstruction:this.handleToggleInstruction,closeClick:function closeClick(active){_this17.setState({modalInstruction:active});}}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this17.setState({modalDialog:active,popupSurvey:true});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_DialogBox__["a" /* default */],{surveyModal:true,app:'KidSign',userId:this.props.studentUser.id,active:this.state.popupSurvey,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'appContainer kidsign'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-sm-6 col-md-6',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'center'}},countDown),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{overflowY:'auto',maxHeight:472},hidden:this.state.countdown>0||this.state.kssPassageSrc===""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{hidden:this.state.recording},this.state.kssPassageSrc))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-sm-6 col-md-6',style:this.state.showVideo?{}:{display:'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.audioVideoSwitch==="video",style:{paddingTop:"35%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{ref:function ref(audio){_this17.audio=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{controls:this.state.recordingAudioPlayCount<4,ref:function ref(audio2){_this17.audio2=audio2;},onPlay:function onPlay(){return _this17.recordingAudioPlay();}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:this.state.isUploading||this.state.recording||this.state.recordingsCount===1,style:{position:'absolute',margin:'auto',zIndex:1,top:65,left:0,bottom:0,right:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__assets_images_video_mask_png___default.a,alt:"Outline to Align Yourself in Video",style:{minWidth:200,width:'65%'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"KidSignVidPlay",hidden:this.state.audioVideoSwitch==="audio",playsInline:true,ref:function ref(video){_this17.video=video;},style:{position:'relative',top:65},width:'100%',autoPlay:true,muted:true,onPlay:function onPlay(){return _this17.recordingPlay();},controls:!this.state.recording&&this.state.videoSrc&&this.state.videoSrc!=="",className:this.state.recording||!this.state.videoSrc||this.state.videoSrc===""?"flippedVideo":""}),this.state.recording?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rec',style:{fontSize:24,position:'absolute',bottom:-100,textAlign:'center',display:'block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{style:{width:'auto',height:'22px'},src:__WEBPACK_IMPORTED_MODULE_14__assets_images_rec_gif___default.a,className:'ico-xs'}),' RECORDING '):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:720,marginTop:450}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",width:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',defaultChecked:true,onChange:this.handleShowVideo,id:'checkHideDeleted',className:'form-control'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:"left",marginTop:5,marginLeft:10}},'Show my video'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3 col-sm-4'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-6 col-sm-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block text-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.recordingsCount<1&&!this.state.recording?"handBtn ":"hidden",onClick:this.handleRecordVideo},' ',this.state.recordingsCount===0&&!this.state.isCounting?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Record Video'):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.recording?"handBtn ":"hidden",onClick:this.stopRecord},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Stop')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:this.state.videoSrc||this.state.audioSrc?"handBtn ":"hidden",onClick:!this.state.disableSubmit?this.submitSession:null},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Finish'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-3 col-sm-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fr',style:{display:'-webkit-box'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Common__["c" /* CountDownComponent */],{time:this.state.timerTime,sessionTime:60,showTime:10})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LoadingModalComponent_LoadingModal__["a" /* default */],{timer:true,upTime:this.state.upTime,isUploading:this.state.isUploading}));}}]);return KidSign;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Tutorial=function(_Component3){_inherits(Tutorial,_Component3);function Tutorial(props){_classCallCheck(this,Tutorial);return _possibleConstructorReturn(this,(Tutorial.__proto__||Object.getPrototypeOf(Tutorial)).call(this,props));}_createClass(Tutorial,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(KidSign,{studentUser:this.props.studentUser,buttonClick:this.props.buttonClick,practice:true});}}]);return Tutorial;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var bindActionToProps=function bindActionToProps(dispatch){return{updateStudentAppStatus:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(results){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["e" /* updateStudentAppsStatus */])(results));case 2:return _context18.abrupt('return',_context18.sent);case 3:case'end':return _context18.stop();}}},_callee18,_this19);}));function updateStudentAppStatus(_x15){return _ref18.apply(this,arguments);}return updateStudentAppStatus;}(),updateStudentAccountTab:function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(tabNum){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["d" /* updateStudentAccountTab */])(tabNum));case 2:return _context19.abrupt('return',_context19.sent);case 3:case'end':return _context19.stop();}}},_callee19,_this19);}));function updateStudentAccountTab(_x16){return _ref19.apply(this,arguments);}return updateStudentAccountTab;}(),updateAppStates:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(appStates){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions__["a" /* updateAppStates */])(appStates));case 2:return _context20.abrupt('return',_context20.sent);case 3:case'end':return _context20.stop();}}},_callee20,_this19);}));function updateAppStates(_x17){return _ref20.apply(this,arguments);}return updateAppStates;}()};};var mapStateToProps=function mapStateToProps(state){return{apps:state.studentReducer.apps,tabNum:state.studentReducer.tabNum,studentUser:state.studentReducer.studentUser,appStates:state.studentReducer.appStates};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_21_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,bindActionToProps)(KidSignComponent)));

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Consts__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_correct_png__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_correct_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_correct_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_wrong_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_wrong_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_wrong_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Footer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_app_kidsignsay_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_app_kidsignsay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_app_kidsignsay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_DropDownNotifications__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalFormComponents_ReportBugForm__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_modal_x_png__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_modal_x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_modal_x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_bootstrap__ = __webpack_require__(20);
var _this6=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KidSignGrading=function(_Component){_inherits(KidSignGrading,_Component);function KidSignGrading(props){var _this2=this;_classCallCheck(this,KidSignGrading);var _this=_possibleConstructorReturn(this,(KidSignGrading.__proto__||Object.getPrototypeOf(KidSignGrading)).call(this,props));_this.submitKSSSessionGrade=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var grades,correct,incorrect,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,grade;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:grades=_this.state.kssSession.gradeSequence.split(",");correct=0;incorrect=0;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=6;for(_iterator=grades[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){grade=_step.value;if(grade==="1"){correct++;}else{incorrect++;}}_context2.next=14;break;case 10:_context2.prev=10;_context2.t0=_context2['catch'](6);_didIteratorError=true;_iteratorError=_context2.t0;case 14:_context2.prev=14;_context2.prev=15;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 17:_context2.prev=17;if(!_didIteratorError){_context2.next=20;break;}throw _iteratorError;case 20:return _context2.finish(17);case 21:return _context2.finish(14);case 22:_context2.next=24;return _this.setState({sessionData:{testId:_this.state.testId,gradeSequence:_this.state.kssSession.gradeSequence,gradingTime:Math.ceil((Date.now()-_this.state.gradeStart)/1000),numberCorrect:correct,numberIncorrect:incorrect}});case 24:_context2.next=26;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].gradeKSSSession(_this.state.sessionData).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.updateKSSBestScore();case 2:_this.setState({modalDialog:true,responseContent:'Score task saved.',analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].KSS_SCORE_SAVE,metadata:{testId:_this.state.testId}}});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}());case 26:_this.handleAnalytics();case 27:case'end':return _context2.stop();}}},_callee2,_this2,[[6,10,14,22],[15,,17,21]]);}));_this.startGrading=function(testId){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getKSSSession(testId).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res){var kssSession,bestScores;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:kssSession=res.body;if(!kssSession){_context3.next=11;break;}_context3.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentBestScores(kssSession.userId);case 4:bestScores=_context3.sent;_context3.next=7;return _this.setState({kssSession:kssSession,bestScores:bestScores.body,noteContent:kssSession.note,kssPassage:kssSession.kidsign_passage,videoSrc:__WEBPACK_IMPORTED_MODULE_6__Shared_Consts__["b" /* BUCKET_URL */]+kssSession.AV_FileName});case 7:_this.video.src=__WEBPACK_IMPORTED_MODULE_6__Shared_Consts__["b" /* BUCKET_URL */]+kssSession.AV_FileName;_this.setupGradingData();_context3.next=14;break;case 11:console.log("ERROR");_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);case 14:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}()).catch(function(error){console.log("ERROR",error);_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);});};_this.deleteScoreConfirm=function(confirm){if(confirm){_this.deleteScore();}_this.setState({modalDialogDelete:false});};_this.handleStudentClick=function(student,classId){_this.props.updateStudent(student);_this.props.history.push('/teacher/student');};_this.state={testId:null,paused:true,bestScores:null,rejectedReason:'',recording:false,imageSrc:"",videoSrc:"",currentWord:"",currentIndex:-1,kssPassage:null,kssTUnits:[],kssSession:null,gradeStart:null,modalDialog:false,responseContent:'',modalDialogDelete:false,modalDialogNote:false,noteContent:'',handleNext:false,taskID:null,showPlayHint:false,showClickWrongHint:false,showClickLastHint:false,showClickSingleHint:false,showClickDoubleHint:false,showSaveHint:false,play:false,sessionData:{testId:0,gradeSequence:"",gradingTime:0,numberCorrect:0,numberIncorrect:0,endLevel:1,endProgress:1},analytics:{type:null,metadata:null}};_this.startGrading=_this.startGrading.bind(_this);_this.gradeToggle=_this.gradeToggle.bind(_this);_this.handleReset=_this.handleReset.bind(_this);_this.submitKSSSessionGrade=_this.submitKSSSessionGrade.bind(_this);_this.updateKSSBestScore=_this.updateKSSBestScore.bind(_this);_this.setupGradingData=_this.setupGradingData.bind(_this);_this.deleteScore=_this.deleteScore.bind(_this);_this.handleTakeANote=_this.handleTakeANote.bind(_this);_this.saveNote=_this.saveNote.bind(_this);_this.deleteNote=_this.deleteNote.bind(_this);_this.handleNoteClose=_this.handleNoteClose.bind(_this);_this.handleNoteContentChange=_this.handleNoteContentChange.bind(_this);_this.handleStudentClick=_this.handleStudentClick.bind(_this);_this.handleNextTask=_this.handleNextTask.bind(_this);_this.getTarget=_this.getTarget.bind(_this);_this.getTarget1=_this.getTarget1.bind(_this);_this.getTarget2=_this.getTarget2.bind(_this);_this.getTarget3=_this.getTarget3.bind(_this);_this.getTarget4=_this.getTarget4.bind(_this);_this.getTarget5=_this.getTarget5.bind(_this);_this.handleShowHints=_this.handleShowHints.bind(_this);_this.handlePlay=_this.handlePlay.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(KidSignGrading,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this3=this;var parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:__WEBPACK_IMPORTED_MODULE_5__Shared_Helpers__["a" /* default */].authorize(this);parsed=__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.parse(this.props.location.search);_context4.next=4;return this.setState({testId:parsed.testId,gradeStart:Date.now(),analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].KSS_SCORE_VIEW,metadata:{testId:parsed.testId}}});case 4:this.startGrading(parsed.testId);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentNotifications().then(function(res){for(var i=0;i<res.body.length;i++){for(var j=0;j<res.body[i].apps.kidSignScores.length;j++){var kidSignScores=res.body[i].apps.kidSignScores[j];if(kidSignScores&&kidSignScores.userId===_this3.props.lastStudent.user.id&&kidSignScores.id!=parsed.testId){_this3.setState({handleNext:true,taskID:kidSignScores.id});}}}});this.handleAnalytics();case 7:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleNextTask',value:function handleNextTask(){window.location.href='/teacher/apps/kss-grading?testId='+this.state.taskID;}},{key:'updateKSSBestScore',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var newProgress,newLevel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!(this.state.bestScores.kssLevel===this.state.kssSession.startLevel)){_context5.next=9;break;}newProgress=this.state.bestScores.kssScore;newLevel=this.state.bestScores.kssLevel;if(this.state.sessionData.numberCorrect>=this.state.kssPassage.goal){newProgress++;}else{newProgress--;}if(newProgress>3&&newLevel<=12){newLevel++;newProgress=1;}else if(newProgress===0){newProgress=1;}_context5.next=7;return this.setState({bestScores:Object.assign({},this.state.bestScores,{kssLevel:newLevel,kssScore:newProgress})});case 7:_context5.next=9;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateKSSBestScore(this.state.bestScores);case 9:case'end':return _context5.stop();}}},_callee5,this);}));function updateKSSBestScore(){return _ref5.apply(this,arguments);}return updateKSSBestScore;}()},{key:'setupGradingData',value:function setupGradingData(){if(this.state.kssSession.gradeSequence==null||this.state.gradeSequence===""){var grades=[];var words=this.state.kssPassage.tUnits.split("@@@");for(var i=0;i<words.length;i++){grades[i]="0";}this.setState({kssSession:Object.assign({},this.state.kssSession,{gradeSequence:grades.join(",")})});}}},{key:'gradeToggle',value:function gradeToggle(index,currentGrade){currentGrade=parseInt(currentGrade);var gradeSequence=this.state.kssSession.gradeSequence;var grades=gradeSequence.split(",");if(currentGrade===0){currentGrade=1;}else{currentGrade=0;}grades[index]=currentGrade.toString();this.setState({kssSession:Object.assign({},this.state.kssSession,{gradeSequence:grades.join(",")})});}},{key:'handleReset',value:function handleReset(){var gradeSequence=this.state.kssSession.gradeSequence;var grades=gradeSequence.split(",");for(var i=0;i<gradeSequence.length;i++){grades[i]="0";}this.setState({kssSession:Object.assign({},this.state.kssSession,{gradeSequence:grades.join(",")})});}},{key:'deleteScore',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].KSS_SCORE_DELETE,metadata:{testId:this.state.testId}}});case 2:_context6.next=4;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].deleteKidSignScore(this.state.testId).then(function(res){_this4.handleAnalytics();_this4.props.history.goBack();});case 4:case'end':return _context6.stop();}}},_callee6,this);}));function deleteScore(){return _ref6.apply(this,arguments);}return deleteScore;}()},{key:'handleTakeANote',value:function handleTakeANote(){console.log("take a note");this.setState({modalDialogNote:true});}},{key:'handleNoteContentChange',value:function handleNoteContentChange(event){this.setState({noteContent:event.target.value});event.preventDefault();}},{key:'saveNote',value:function saveNote(){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateKidSignNote({testId:this.state.testId,note:this.state.noteContent});this.setState({modalDialogNote:false});}},{key:'deleteNote',value:function deleteNote(){this.setState({noteContent:''});__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateKidSignNote({testId:this.state.testId,note:''});}},{key:'handleNoteClose',value:function handleNoteClose(){this.setState({modalDialogNote:false});}},{key:'getTarget',value:function getTarget(){this.setState({showPlayHint:false});}},{key:'getTarget1',value:function getTarget1(){this.setState({showClickWrongHint:false});}},{key:'getTarget2',value:function getTarget2(){this.setState({showClickLastHint:false});}},{key:'getTarget3',value:function getTarget3(){this.setState({showClickSingleHint:false});}},{key:'getTarget4',value:function getTarget4(){this.setState({showClickDoubleHint:false});}},{key:'getTarget5',value:function getTarget5(){this.setState({showSaveHint:false});}},{key:'handleShowHints',value:function handleShowHints(){this.setState({showPlayHint:true,showClickWrongHint:true,showClickLastHint:true,showClickSingleHint:true,showClickDoubleHint:true,showSaveHint:true});}},{key:'handlePlay',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!this.state.play){_context7.next=5;break;}this.video.pause();this.setState({play:false});_context7.next=9;break;case 5:this.video.play();_context7.next=8;return this.setState({play:true,analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].KSS_SCORE_PLAY,metadata:{testId:this.state.testId}}});case 8:this.handleAnalytics();case 9:case'end':return _context7.stop();}}},_callee7,this);}));function handlePlay(){return _ref7.apply(this,arguments);}return handlePlay;}()},{key:'handleSurveyBack',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:case'end':return _context8.stop();}}},_callee8,this);}));function handleSurveyBack(){return _ref8.apply(this,arguments);}return handleSurveyBack;}()},{key:'render',value:function render(){var _this5=this;var wordThumbnails=null;if(this.state.kssPassage&&this.state.kssPassage.tUnits&&this.state.kssSession.gradeSequence){wordThumbnails=this.state.kssPassage.tUnits.split("@@@").map(function(kssTUnit,index){var currentGrade=_this5.state.kssSession.gradeSequence.split(",")[index];var gradeSrc="btn-info2";if(kssTUnit.toString().startsWith("IX")){gradeSrc="btn-warning";}if(currentGrade==="1"){gradeSrc="btn-success";}// else if (currentGrade === "2") {
//     gradeSrc = "btn-danger"
// }
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{key:index,onClick:function onClick(){return _this5.gradeToggle(index,currentGrade);},style:{margin:"2px 2px 2px 2px",fontSize:'1.4em',padding:'0px 10px 0px'},className:"btn "+gradeSrc,type:'button'},kssTUnit));});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section bgGrey',style:{paddingTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this5.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shared_DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:'KidSignGrading',userId:this.props.user.id,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteScoreConfirm,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this5.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_bootstrap__["a" /* Modal */],{id:'dialogBox',show:this.state.modalDialogNote},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{paddingTop:0,marginTop:-10,marginBottom:15}},'Make a Note'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{style:{width:500},onChange:this.handleNoteContentChange,value:this.state.noteContent,placeholder:"please enter your note here"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section',style:{marginTop:-40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.deleteNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.saveNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 noPadding mobileCenter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_images_app_kidsignsay_png___default.a,alt:"Kid Sign",style:{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}),' ',this.props.lastStudent.user.firstname,' ',this.props.lastStudent.user.lastname)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-8 tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'descp'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar"},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ModalFormComponents_ReportBugForm__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Shared_DropDownNotifications__["a" /* default */],Object.assign({studentClick:this.handleStudentClick},this.props)),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleShowHints,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Show Hints')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row hasVideo',style:{minHeight:"415px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 solidBorder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-xs-6 col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"wrapper"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('video',{id:"KidSignVidPlay",controls:true,onClick:this.handlePlay,playsInline:true,ref:function ref(video){_this5.video=video;},width:'100%',height:'100%'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.state.play?"playpause":"",style:{cursor:'pointer'},onClick:this.handlePlay}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-6 col-xs-6 col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'list-unstyled'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'relative',display:'inline-block',textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showClickWrongHint,className:"popoverCustom"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block",float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_images_modal_x_png___default.a,onClick:this.getTarget1,style:{width:35,paddingRight:5,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:'20px',fontFamily:'mainfont, sans-serif',letterSpacing:'1px'}},'Hint:'))),'Click on a sentence to score correct'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showClickWrongHint,className:"arrowPointer"}),wordThumbnails))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 bgGrey',style:{padding:15}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Original Passage'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{fontFamily:'mainfont, sans-serif',fontSize:18}},this.state.kssPassage?this.state.kssPassage.passage:"")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-lg-12 paddingTop'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divBottomRelative tr'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return _this5.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_20__Shared_DataTrackingPoints__["b" /* default */].KSS_SCORE_EXIT,metadata:{testId:_this5.state.testId}}});case 2:_this5.handleAnalytics();_this5.props.history.push('../student');case 4:case'end':return _context9.stop();}}},_callee9,_this5);})),className:'handBtn fl'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Exit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNextTask,className:'handBtn',style:{display:this.state.handleNext?'inline-block':'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Next Task')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleTakeANote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Make a Note')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitKSSSessionGrade,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleReset,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Reset')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this5.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TASK?'});},className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_Footer__["a" /* default */],null));}}]);return KidSignGrading;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var actionToProps=function actionToProps(dispatch){return{updateStudent:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["h" /* updateStudent */])(student));case 2:return _context10.abrupt('return',_context10.sent);case 3:case'end':return _context10.stop();}}},_callee10,_this6);}));function updateStudent(_x3){return _ref10.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{lastStudent:state.teacherReducer.student};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,actionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(KidSignGrading)));

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_ico_person_png__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_ico_person_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_ico_person_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_microphone_png__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_microphone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_microphone_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_trafficlight_yellow_png__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_trafficlight_yellow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_trafficlight_yellow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_trafficlight_green_png__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_trafficlight_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_trafficlight_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_rec_gif__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_rec_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_rec_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recordrtc__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recordrtc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recordrtc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_device_detect__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_REST__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NetworkSpeed=__webpack_require__(310);var testNetworkSpeed=new NetworkSpeed();var sampleRateHz=44100;__WEBPACK_IMPORTED_MODULE_12_react_device_detect__["osName"]==="Mac OS"?sampleRateHz=44100:sampleRateHz=48000;var STEP={HAS_CAMERA:1,HAS_MICROPHONE:2,CHECK_NETWORK:3,CHECKING_NETWORK:4,NETWORK_RESULT:5,FINAL_RESULT:6,CHECK_VIDEO:7,CHECK_AUDIO:8,VIDEO_AUDIO_RESULT:9};var NETWORK_SPEED={EXCELLENT:1,GOOD:0.5,ACCEPTABLE:0.1,POOR:0};var NETWORK_STATUS={EXCELLENT:3,GOOD:2,ACCEPTABLE:1,POOR:0,CHECKING:-1,UNKNOWN:-2};var NETWORK_STATUS_STRING={EXCELLENT:"excellent",GOOD:"good",ACCEPTABLE:"acceptable",POOR:"poor",UNKNOWN:"unknown"};var CheckVideoComponent=function(_Component){_inherits(CheckVideoComponent,_Component);function CheckVideoComponent(props){_classCallCheck(this,CheckVideoComponent);var _this=_possibleConstructorReturn(this,(CheckVideoComponent.__proto__||Object.getPrototypeOf(CheckVideoComponent)).call(this,props));_this.captureUserMedia=function(callback,options){var params=null;if(options){params=options;}else{params={audio:false,video:__WEBPACK_IMPORTED_MODULE_10__Shared_Helpers__["a" /* default */].getVideoSizes()};}navigator.mediaDevices.getUserMedia(params).then(callback).catch(function(error){_this.setState({result:false});console.log(error);});};_this.state={checking:false,result:false};_this.handleClickCheck=_this.handleClickCheck.bind(_this);_this.handleStop=_this.handleStop.bind(_this);return _this;}_createClass(CheckVideoComponent,[{key:"handleClickCheck",value:function handleClickCheck(){this.setState({checking:true});this.requestUserMedia();}},{key:"handleStop",value:function handleStop(){this.releaseStreamFromVideo();if(this.state.result){this.props.handleStopSuccess();}else{this.props.handleStopFailure();}}},{key:"setStreamToVideo",value:function setStreamToVideo(stream){this.video.srcObject=stream;}},{key:"releaseStreamFromVideo",value:function releaseStreamFromVideo(){this.video.srcObject=null;}},{key:"requestUserMedia",value:function requestUserMedia(){var _this2=this;console.log('requestUserMedia');this.captureUserMedia(function(stream){_this2.setStreamToVideo(stream);_this2.setState({result:true});});}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{width:250,marginLeft:'auto',marginRight:'auto',display:'flex'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_ico_person_png___default.a,style:{position:'relative',marginBottom:-5,width:65,height:70}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:18,marginLeft:5}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"Check Webcam")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 col-sm-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:100,marginLeft:50}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"1. Click the 'Check' button."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"2. Click 'Allow' if you see a question ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),"in a dialog box"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"3. Your video should show in a few seconds.",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),"If you can see yourself, your video camera is working."))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 col-sm-6"},this.state.checking===false?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:140,marginLeft:'auto',marginRight:'auto',width:80}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleClickCheck},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Check"))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:-30,marginLeft:'auto',marginRight:'auto',width:320,height:220}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("video",{id:"copyrightVidPlayback",playsInline:true,ref:function ref(video){_this3.video=video;},style:{position:'relative',top:65},width:"100%",autoPlay:true,controls:false,className:"flippedVideo"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:100,marginLeft:'auto',marginRight:'auto',width:80}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleStop},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Stop")))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"}));}}]);return CheckVideoComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var CheckAudioComponent=function(_Component2){_inherits(CheckAudioComponent,_Component2);function CheckAudioComponent(props){_classCallCheck(this,CheckAudioComponent);var _this4=_possibleConstructorReturn(this,(CheckAudioComponent.__proto__||Object.getPrototypeOf(CheckAudioComponent)).call(this,props));_this4.captureUserMedia=function(callback,options){var params=null;if(options){params=options;}else{params={audio:true,video:false};}navigator.mediaDevices.getUserMedia(params).then(callback).catch(function(error){_this4.setState({result:false});console.log(error);});};_this4.state={recordAudio:null,audioState:0,//0: none, 1:requesting media, 2: recording, 3: recorded, 5. playing, 6. played.
result:false};_this4.handleClickCheck=_this4.handleClickCheck.bind(_this4);_this4.handleStop=_this4.handleStop.bind(_this4);_this4.handlePlay=_this4.handlePlay.bind(_this4);_this4.handleNext=_this4.handleNext.bind(_this4);return _this4;}_createClass(CheckAudioComponent,[{key:"handleClickCheck",value:function handleClickCheck(){this.setState({audioState:1});this.requestUserMedia();}},{key:"handleStop",value:function handleStop(){var _this5=this;this.state.recordAudio.stop(function(wavBlob){_this5.audio2.src=URL.createObjectURL(wavBlob);});this.setState({audioState:3});}},{key:"handlePlay",value:function handlePlay(){this.audio2.play();}},{key:"handleNext",value:function handleNext(){this.releaseStreamFromAudio();if(this.state.result){this.props.handleStopSuccess();}else{this.props.handleStopFailure();}}},{key:"releaseStreamFromAudio",value:function releaseStreamFromAudio(){this.audio.pause();this.audio.srcObject=null;this.audio.src="";this.audio.load();}},{key:"requestUserMedia",value:function requestUserMedia(){var _this6=this;this.captureUserMedia(function(stream){var options={type:'audio',audio:_this6.audio,sampleRate:sampleRateHz,bufferSize:4096,numberOfAudioChannels:1,recorderType:__WEBPACK_IMPORTED_MODULE_11_recordrtc___default.a.StereoAudioRecorder};_this6.setState({recordAudio:new __WEBPACK_IMPORTED_MODULE_11_recordrtc___default.a.StereoAudioRecorder(stream,options),result:true,audioState:2});_this6.state.recordAudio.record();_this6.setState({result:true});},{audio:true,video:false});}},{key:"render",value:function render(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{width:300,marginLeft:'auto',marginRight:'auto',display:'flex'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_microphone_png___default.a,style:{position:'relative',marginBottom:-5,width:65,height:70}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:18,marginLeft:5}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"Check Microphone")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 col-sm-6"},this.state.audioState!=3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:100,marginLeft:50}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"1. Click the 'Check' button."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"2. Click 'Allow' if you see a question ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),"in a dialog box."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"3. Recording will start in a few seconds.",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),"You can Stop anytime.")):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:100,marginLeft:50}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Press the Play button  to hear yourself."))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 col-sm-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:100,marginLeft:'auto',marginRight:'auto',width:290}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("audio",{ref:function ref(audio){_this7.audio=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("audio",{hidden:this.state.audioState!==3,controls:true,ref:function ref(audio2){_this7.audio2=audio2;}})),this.state.audioState===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:185,marginLeft:'auto',marginRight:'auto',width:80}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleClickCheck},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Check"))):null,this.state.audioState===2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:140,marginLeft:'auto',marginRight:'auto',width:320,height:220}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"rec",style:{position:'relative',top:-20,fontSize:24,marginLeft:90}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__assets_images_rec_gif___default.a,className:"ico-xs"})," RECORDING "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:20,marginLeft:'auto',marginRight:'auto',width:80}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleStop},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Stop"))))):null,this.state.audioState===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:160}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:-135,marginLeft:'auto',marginRight:'auto',width:80}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleNext},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Next")))):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"}));}}]);return CheckAudioComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var TrafficLightComponent=function(_Component3){_inherits(TrafficLightComponent,_Component3);function TrafficLightComponent(props){_classCallCheck(this,TrafficLightComponent);return _possibleConstructorReturn(this,(TrafficLightComponent.__proto__||Object.getPrototypeOf(TrafficLightComponent)).call(this,props));}_createClass(TrafficLightComponent,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,this.props.networkStatus===NETWORK_STATUS.UNKNOWN?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}})):null,this.props.networkStatus===NETWORK_STATUS.CHECKING?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_trafficlight_yellow_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_trafficlight_yellow_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_trafficlight_yellow_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}})):null,this.props.networkStatus===NETWORK_STATUS.POOR?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}})):null,this.props.networkStatus===NETWORK_STATUS.ACCEPTABLE?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_trafficlight_green_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}})):null,this.props.networkStatus===NETWORK_STATUS.GOOD?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_trafficlight_green_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_trafficlight_green_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_trafficlight_empty_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}})):null,this.props.networkStatus===NETWORK_STATUS.EXCELLENT?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_trafficlight_green_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_trafficlight_green_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__assets_images_trafficlight_green_png___default.a,style:{position:'relative',width:45,height:50,marginTop:20,marginLeft:3,marginRight:3}})):null);}}]);return TrafficLightComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var NeedsAssessmentComponent=function(_Component4){_inherits(NeedsAssessmentComponent,_Component4);function NeedsAssessmentComponent(props){_classCallCheck(this,NeedsAssessmentComponent);var _this9=_possibleConstructorReturn(this,(NeedsAssessmentComponent.__proto__||Object.getPrototypeOf(NeedsAssessmentComponent)).call(this,props));_this9.state={currentStep:STEP.HAS_CAMERA,hasWebCamera:false,passedWebCameraTest:false,hasMicrophone:false,passedMicrophoneTest:false,networkStatus:-2,//-2: unknown, -1: checking, 0: poor, 1: acceptable, 2: good, 3: excellent
networkSpeed:0,networkResult:"",availableApps:"",analytics:{type:null,metadata:null}};_this9.handleBack=_this9.handleBack.bind(_this9);_this9.handleHasWebCamera=_this9.handleHasWebCamera.bind(_this9);_this9.handleHasNotWebCamera=_this9.handleHasNotWebCamera.bind(_this9);_this9.handleHasMicrophone=_this9.handleHasMicrophone.bind(_this9);_this9.handleHasNotMicrophone=_this9.handleHasNotMicrophone.bind(_this9);_this9.handleStartTestNetwork=_this9.handleStartTestNetwork.bind(_this9);_this9.handleDoneTestNetwork=_this9.handleDoneTestNetwork.bind(_this9);_this9.handleCreateAccount=_this9.handleCreateAccount.bind(_this9);_this9.getAvailableApps=_this9.getAvailableApps.bind(_this9);_this9.handleCheckVideo=_this9.handleCheckVideo.bind(_this9);_this9.handleStopVideoSuccess=_this9.handleStopVideoSuccess.bind(_this9);_this9.handleStopVideoFailure=_this9.handleStopVideoFailure.bind(_this9);_this9.handleCheckAudio=_this9.handleCheckAudio.bind(_this9);_this9.handleStopAudioSuccess=_this9.handleStopAudioSuccess.bind(_this9);_this9.handleStopAudioFailure=_this9.handleStopAudioFailure.bind(_this9);_this9.handleAnalytics=_this9.handleAnalytics.bind(_this9);return _this9;}_createClass(NeedsAssessmentComponent,[{key:"componentDidMount",value:function componentDidMount(){//this.setState({currentStep: STEP.CHECK_AUDIO});
}},{key:"handleAnalytics",value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_13__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:"handleBack",value:function handleBack(){this.props.history.push("/resources");}},{key:"handleHasWebCamera",value:function handleHasWebCamera(){this.setState({hasWebCamera:true,currentStep:STEP.HAS_MICROPHONE});}},{key:"handleHasNotWebCamera",value:function handleHasNotWebCamera(){this.setState({hasWebCamera:false,currentStep:STEP.HAS_MICROPHONE});}},{key:"handleHasMicrophone",value:function handleHasMicrophone(){this.setState({hasMicrophone:true,currentStep:STEP.CHECK_NETWORK});}},{key:"handleHasNotMicrophone",value:function handleHasNotMicrophone(){this.setState({hasMicrophone:false,currentStep:STEP.CHECK_NETWORK});}},{key:"handleStartTestNetwork",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this10=this;var currentSpeed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_10__Shared_Helpers__["a" /* default */].getNetworkUploadSpeed();case 2:currentSpeed=_context2.sent;this.setState({currentStep:STEP.CHECKING_NETWORK});setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var baseUrl,fileSizeInBytes,networkSpeed,networkStatus,networkResult;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:baseUrl='https://cors-anywhere.herokuapp.com/https://uploaddev.s3.us-east-2.amazonaws.com/content/network/50000000?version='+Math.random();fileSizeInBytes=50000000;//const speed = await testNetworkSpeed.checkDownloadSpeed(baseUrl, fileSizeInBytes);
//let networkSpeed = Math.round(speed.mbps/25)/10;
networkSpeed=currentSpeed.mbps;networkStatus=void 0;networkResult=void 0;if(networkSpeed>=NETWORK_SPEED.POOR&&networkSpeed<NETWORK_SPEED.ACCEPTABLE){networkStatus=NETWORK_STATUS.POOR;networkResult=NETWORK_STATUS_STRING.POOR;}else if(networkSpeed>=NETWORK_SPEED.ACCEPTABLE&&networkSpeed<NETWORK_SPEED.GOOD){networkStatus=NETWORK_STATUS.ACCEPTABLE;networkResult=NETWORK_STATUS_STRING.ACCEPTABLE;}else if(networkSpeed>=NETWORK_SPEED.GOOD&&networkSpeed<NETWORK_SPEED.EXCELLENT){networkStatus=NETWORK_STATUS.GOOD;networkResult=NETWORK_STATUS_STRING.GOOD;}else if(networkSpeed>=NETWORK_SPEED.EXCELLENT){networkStatus=NETWORK_STATUS.EXCELLENT;networkResult=NETWORK_STATUS_STRING.EXCELLENT;}else{networkStatus=NETWORK_STATUS.UNKNOWN;networkResult=NETWORK_STATUS_STRING.UNKNOWN;}_this10.setState({currentStep:STEP.NETWORK_RESULT,networkSpeed:networkSpeed,networkStatus:networkStatus,networkResult:networkResult});case 7:case"end":return _context.stop();}}},_callee,_this10);})),10);case 5:case"end":return _context2.stop();}}},_callee2,this);}));function handleStartTestNetwork(){return _ref.apply(this,arguments);}return handleStartTestNetwork;}()},{key:"handleDoneTestNetwork",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:this.getAvailableApps();_context3.next=3;return this.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_9__Shared_DataTrackingPoints__["b" /* default */].TECH_CHECK,metadata:{hasWebCamera:this.state.hasWebCamera,hasMicrophone:this.state.hasMicrophone,networkSpeed:this.state.networkSpeed+'MBPS',availableApps:this.state.available}}});case 3:this.handleAnalytics();this.setState({currentStep:STEP.FINAL_RESULT});case 5:case"end":return _context3.stop();}}},_callee3,this);}));function handleDoneTestNetwork(){return _ref3.apply(this,arguments);}return handleDoneTestNetwork;}()},{key:"handleCreateAccount",value:function handleCreateAccount(){this.props.history.push("/request-account");}},{key:"getAvailableApps",value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var availableApps,appsNo;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:availableApps="1.Slash 2.Maze 3.WordMark ";appsNo=4;if(this.state.hasMicrophone&&this.state.networkStatus>=NETWORK_STATUS.ACCEPTABLE){availableApps=availableApps+appsNo+".KidSpeak ";appsNo++;}if(this.state.hasWebCamera&&this.state.networkStatus>=NETWORK_STATUS.ACCEPTABLE){availableApps=availableApps+appsNo+".CopyRight ";appsNo++;availableApps=availableApps+appsNo+".KidSign ";appsNo++;availableApps=availableApps+appsNo+".PictureNaming ";appsNo++;availableApps=availableApps+appsNo+".WordSign/Say ";}_context4.next=6;return this.setState({availableApps:availableApps});case 6:case"end":return _context4.stop();}}},_callee4,this);}));function getAvailableApps(){return _ref4.apply(this,arguments);}return getAvailableApps;}()},{key:"handleCheckVideo",value:function handleCheckVideo(){this.setState({currentStep:STEP.CHECK_VIDEO});}},{key:"handleStopVideoSuccess",value:function handleStopVideoSuccess(){this.setState({currentStep:STEP.CHECK_AUDIO,passedWebCameraTest:true});}},{key:"handleStopVideoFailure",value:function handleStopVideoFailure(){this.setState({currentStep:STEP.CHECK_AUDIO,passedWebCameraTest:false});}},{key:"handleCheckAudio",value:function handleCheckAudio(){this.setState({currentStep:STEP.CHECK_VIDEO});}},{key:"handleStopAudioSuccess",value:function handleStopAudioSuccess(){this.setState({currentStep:STEP.VIDEO_AUDIO_RESULT,passedMicrophoneTest:true});}},{key:"handleStopAudioFailure",value:function handleStopAudioFailure(){this.setState({currentStep:STEP.VIDEO_AUDIO_RESULT,passedMicrophoneTest:false});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bgGrey CopyRight"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"appSection bgGrey"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"appContainer copyright"},this.state.currentStep>=STEP.HAS_CAMERA&&this.state.currentStep<=STEP.FINAL_RESULT?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-3 col-sm-3"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-6 col-sm-6 text-center"},this.state.currentStep>=STEP.HAS_CAMERA&&this.state.currentStep<=STEP.FINAL_RESULT?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:60}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,"Check your devices")):null,this.state.currentStep===STEP.HAS_CAMERA?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_ico_person_png___default.a,style:{position:'relative',marginBottom:-5,width:65,height:70}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,"Do you have a webcam?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Some apps use videos")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleHasWebCamera},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Yes")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleHasNotWebCamera},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"No")))):null,this.state.currentStep===STEP.HAS_MICROPHONE?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_microphone_png___default.a,style:{position:'relative',marginBottom:-5,width:65,height:70}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,"Do you have a microphone?"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Some apps use audios")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleHasMicrophone},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Yes")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleHasNotMicrophone},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"No")))):null,this.state.currentStep===STEP.CHECK_NETWORK?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TrafficLightComponent,{networkStatus:NETWORK_STATUS.UNKNOWN})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,"Check Internet Speed"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Click \"Start\" to start test.")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleStartTestNetwork},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Start")))):null,this.state.currentStep===STEP.CHECKING_NETWORK?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TrafficLightComponent,{networkStatus:NETWORK_STATUS.CHECKING})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,"Checking Internet Speed"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Wait..."))):null,this.state.currentStep===STEP.NETWORK_RESULT?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:20}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TrafficLightComponent,{networkStatus:this.state.networkStatus})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,this.state.networkSpeed=='Infinity'?"":this.state.networkSpeed+" Mbps"," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Your Internet speed is ",this.state.networkResult,"!")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleDoneTestNetwork},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Done")))):null,this.state.currentStep===STEP.FINAL_RESULT?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,"Congratulations."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"You can use the following AvenuePM tasks:"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,this.state.availableApps)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleCreateAccount},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Create an Account")))):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-3 col-sm-3"})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},this.state.currentStep===STEP.CHECK_VIDEO?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CheckVideoComponent,{handleStopSuccess:this.handleStopVideoSuccess,handleStopFailure:this.handleStopVideoFailure}):null,this.state.currentStep===STEP.CHECK_AUDIO?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CheckAudioComponent,{handleStopSuccess:this.handleStopAudioSuccess,handleStopFailure:this.handleStopAudioFailure}):null,this.state.currentStep===STEP.VIDEO_AUDIO_RESULT?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row",style:{marginTop:140,marginLeft:'auto',marginRight:'auto',width:300}},this.state.passedWebCameraTest?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"Video is working."):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"Video is not working.")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row",style:{marginTop:0,marginLeft:'auto',marginRight:'auto',width:300}},this.state.passedMicrophoneTest?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"Audio is working."):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"Audio is not working.")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row",style:{marginTop:40,marginLeft:'auto',marginRight:'auto',width:500}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"If there are any problems, you can ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{onClick:this.handleCheckVideo},"check video/audio again")))):null)))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"section",style:{position:'relative',top:-40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"divBottomRelative tr"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-3 col-sm-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"backArrow fl",onClick:this.handleBack,style:{width:60,height:60}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{position:'relative',fontSize:32,marginLeft:20,top:17}},"Back"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-md-9 col-sm-8"},this.state.currentStep===STEP.FINAL_RESULT?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:10,marginRight:0,float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:"handBtn",onClick:this.handleCheckVideo},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Check video/audio"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginTop:16,marginRight:10,float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"To use all apps, check video/audio is okay."))):null)))))));}}]);return NeedsAssessmentComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(NeedsAssessmentComponent));

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABTCAYAAAAx4jFYAAAMSGlDQ1BJQ0MgUHJvZmlsZQAASImVVwdYU8kWnltSSWiBCEgJvYlSpEsJoUUQkCrYCEkgocSQEETsLssquHYRAXVFV0VcdC2ArBW7sgj2/lAWlZV1sWBD5U0KrOt+773vne+be/+cOec/JXPvnQFAp4YnleaiugDkSQpk8REhrCmpaSxSN0CADtADnsCMx5dL2XFx0QDK8P3v8uYGtIZy1UXJ9c/5/yp6AqGcDwASB3GGQM7Pg/ggAHgJXyorAIDoA/XWswukSjwNYgMZTBBiqRJnqXGJEmeocaXKJjGeA/EeAMg0Hk+WBYB2M9SzCvlZkEf7FsSuEoFYAoAOGeJAvogngDgS4jF5ebOUGNoBh4wveLL+xpkxwsnjZY1gdS0qIYeK5dJc3pz/sx3/W/JyFcMx7OCgiWSR8cqaYd9u5cyKUmIaxH2SjJhYiPUhficWqOwhRqkiRWSS2h415cs5sGeACbGrgBcaBbEpxOGS3JhojT4jUxzOhRiuELRIXMBN1PguFcrDEjScNbJZ8bHDOFPGYWt8G3gyVVyl/WlFThJbw39LJOQO878uFiWmqHPGqIXi5BiItSFmynMSotQ2mE2xiBMzbCNTxCvzt4HYTyiJCFHzYzMyZeHxGntZnny4XmypSMyN0eCqAlFipIZnD5+nyt8I4mahhJ00zCOUT4kerkUgDA1T1451CCVJmnqxLmlBSLzG96U0N05jj1OFuRFKvRXEpvLCBI0vHlgAF6SaH4+RFsQlqvPEM7J5E+PU+eBFIBpwQChgAQUcGWAWyAbi9r6mPvhLPRMOeEAGsoAQuGg0wx4pqhkJvCaAYvAHREIgH/ELUc0KQSHUfxrRqq8uIFM1W6jyyAGPIc4DUSAX/laovCQj0ZLBb1Aj/kd0Psw1Fw7l3D91bKiJ1mgUw7wsnWFLYhgxlBhJDCc64iZ4IO6PR8NrMBzuuA/uO5ztX/aEx4ROwiPCdUIX4fZM8RLZV/WwwCTQBSOEa2rO+LJm3A6yeuIheADkh9w4EzcBLvh4GImNB8HYnlDL0WSurP5r7r/V8EXXNXYUVwpKGUUJpjh87antpO05wqLs6ZcdUueaMdJXzsjM1/E5X3RaAO9RX1tiS7ED2DnsJHYBO4I1ARZ2HGvG2rCjSjyyin5TraLhaPGqfHIgj/gf8XiamMpOyl3rXXtdP6rnCoRFyvcj4MySzpGJs0QFLDZ88wtZXAl/7BiWu6ubLwDK74j6NfWKqfo+IMyLf+nyTwDgWwaVWX/peNYAHH4MAOPNXzrrl/DxWAXA0Q6+Qlao1uHKCwFQ4RfKABgDc2ANHGA97sAL+INgEAYmgliQCFLBDNhlEVzPMjAbzAOLQSkoB6vAelAFtoBtYBf4CewHTeAIOAnOgkugA1wHd+Hq6QHPQD94AwYRBCEhdISBGCMWiC3ijLgjPkggEoZEI/FIKpKOZCESRIHMQ75BypE1SBWyFalDfkYOIyeRC0gncht5iPQiL5EPKIbSUAPUDLVDx6E+KBuNQhPR6WgWmo8WoyXoCrQSrUX3oI3oSfQSeh3tQp+hAxjAtDAmZom5YD4YB4vF0rBMTIYtwMqwCqwWa8Ba4P98FevC+rD3OBFn4CzcBa7gSDwJ5+P5+AJ8OV6F78Ib8dP4Vfwh3o9/JtAJpgRngh+BS5hCyCLMJpQSKgg7CIcIZ+DT1EN4QyQSmUR7ojd8GlOJ2cS5xOXETcS9xBPETmI3cYBEIhmTnEkBpFgSj1RAKiVtJO0hHSddIfWQ3pG1yBZkd3I4OY0sIS8hV5B3k4+Rr5CfkAcpuhRbih8lliKgzKGspGyntFAuU3oog1Q9qj01gJpIzaYuplZSG6hnqPeor7S0tKy0fLUma4m1FmlVau3TOq/1UOs9TZ/mROPQptEUtBW0nbQTtNu0V3Q63Y4eTE+jF9BX0Ovop+gP6O+0GdpjtbnaAu2F2tXajdpXtJ/rUHRsddg6M3SKdSp0Duhc1unTpeja6XJ0eboLdKt1D+ve1B3QY+i56cXq5ekt19utd0HvqT5J304/TF+gX6K/Tf+UfjcDY1gzOAw+4xvGdsYZRo8B0cDegGuQbVBu8JNBu0G/ob7heMNkwyLDasOjhl1MjGnH5DJzmSuZ+5k3mB9GmY1ijxKOWjaqYdSVUW+NRhsFGwmNyoz2Gl03+mDMMg4zzjFebdxkfN8EN3EymWwy22SzyRmTvtEGo/1H80eXjd4/+o4paupkGm8613SbaZvpgJm5WYSZ1Gyj2SmzPnOmebB5tvk682PmvRYMi0ALscU6i+MWv7MMWWxWLquSdZrVb2lqGWmpsNxq2W45aGVvlWS1xGqv1X1rqrWPdab1OutW634bC5tJNvNs6m3u2FJsfWxFthtsz9m+tbO3S7H7zq7J7qm9kT3Xvti+3v6eA90hyCHfodbhmiPR0ccxx3GTY4cT6uTpJHKqdrrsjDp7OYudNzl3jiGM8R0jGVM75qYLzYXtUuhS7/JwLHNs9NglY5vGPh9nMy5t3Opx58Z9dvV0zXXd7nrXTd9totsStxa3l+5O7nz3avdrHnSPcI+FHs0eL8Y7jxeO3zz+lifDc5Lnd56tnp+8vL1kXg1evd423uneNd43fQx84nyW+5z3JfiG+C70PeL73s/Lr8Bvv9+f/i7+Of67/Z9OsJ8gnLB9QneAVQAvYGtAVyArMD3wh8CuIMsgXlBt0KNg62BB8I7gJ2xHdjZ7D/t5iGuILORQyFuOH2c+50QoFhoRWhbaHqYflhRWFfYg3Co8K7w+vD/CM2JuxIlIQmRU5OrIm1wzLp9bx+2f6D1x/sTTUbSohKiqqEfRTtGy6JZJ6KSJk9ZOuhdjGyOJaYoFsdzYtbH34+zj8uN+mUycHDe5evLjeLf4efHnEhgJMxN2J7xJDElcmXg3ySFJkdSarJM8Lbku+W1KaMqalK4p46bMn3Ip1SRVnNqcRkpLTtuRNjA1bOr6qT3TPKeVTrsx3X560fQLM0xm5M44OlNnJm/mgXRCekr67vSPvFheLW8gg5tRk9HP5/A38J8JggXrBL3CAOEa4ZPMgMw1mU+zArLWZvWKgkQVoj4xR1wlfpEdmb0l+21ObM7OnKHclNy9eeS89LzDEn1JjuT0LPNZRbM6pc7SUmlXvl/++vx+WZRshxyRT5c3FxjADXubwkHxreJhYWBhdeG72cmzDxTpFUmK2uY4zVk250lxePGPc/G5/Lmt8yznLZ73cD57/tYFyIKMBa0LrReWLOxZFLFo12Lq4pzFvy5xXbJmyetvUr5pKTErWVTS/W3Et/Wl2qWy0pvf+X+3ZSm+VLy0fZnHso3LPpcJyi6Wu5ZXlH9czl9+8Xu37yu/H1qRuaJ9pdfKzauIqySrbqwOWr1rjd6a4jXdayetbVzHWle27vX6mesvVIyv2LKBukGxoasyurJ5o83GVRs/VomqrleHVO+tMa1ZVvN2k2DTlc3Bmxu2mG0p3/LhB/EPt7ZGbG2staut2EbcVrjt8fbk7ed+9PmxbofJjvIdn3ZKdnbtit91us67rm636e6V9Wi9or53z7Q9HT+F/tTc4NKwdS9zb/k+sE+x7/ef03++sT9qf+sBnwMNB20P1hxiHCprRBrnNPY3iZq6mlObOw9PPNza4t9y6Jexv+w8Ynmk+qjh0ZXHqMdKjg0dLz4+cEJ6ou9k1snu1pmtd09NOXXt9OTT7Weizpw/G3721Dn2uePnA84fueB34fBFn4tNl7wuNbZ5th361fPXQ+1e7Y2XvS83d/h2tHRO6Dx2JejKyauhV89e4167dD3meueNpBu3bk672XVLcOvp7dzbL+4U3hm8u+ge4V7Zfd37FQ9MH9T+y/Ffe7u8uo4+DH3Y9ijh0d1ufvez3+S/fewpeUx/XPHE4kndU/enR3rDezt+n/p7zzPps8G+0j/0/qh57vD84J/Bf7b1T+nveSF7MfRy+SvjVztfj3/dOhA38OBN3pvBt2XvjN/teu/z/tyHlA9PBmd/JH2s/OT4qeVz1Od7Q3lDQ1KejKfaCmBwoJmZALzcCQA9Fe4dOgCgTlWf81SCqM+mKgT+E1afBVXiBcDOYACSFgEQDfcom+GwhZgG78qtemIwQD08RoZG5Jke7mouGjzxEN4NDb0yA4DUAsAn2dDQ4KahoU/bYbK3ATiRrz5fKoUIzwY/GCtR201d8LX8G6gkfnxoxCvgAAAACXBIWXMAABYlAAAWJQFJUiTwAAACA2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8ZXhpZjpQaXhlbFlEaW1lbnNpb24+MTAyPC9leGlmOlBpeGVsWURpbWVuc2lvbj4KICAgICAgICAgPGV4aWY6UGl4ZWxYRGltZW5zaW9uPjk0PC9leGlmOlBpeGVsWERpbWVuc2lvbj4KICAgICAgICAgPHRpZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CsPnYQMAAAlPSURBVHgB7VxpcBRFFDawQCAcVRRqghwJBIESCIdQnAFRBDQUt2AQqsSEUznFmFK5JEaRKgWUy4OrACEiBEHQKJQiciSoQEmQI4BAqVBAwhWOgDpfzzc7Mzuz2dlNIImdH/P1e6/7dffbL9Pd0z0T9M9/f/fJP8cRKOW4hCyACMjA+UkEl5/l/CqWk5ODcnt27wbuzcgAZh48CDyedRx49uxZYF5eHpCXypUrI/lgaCiwbmRdYPPmzYHtO0QDH67/MLAwL5JxfkY3qDAGh+vXr6M5X6amAjekbgDu3rULeOfOHWBhXeo3qA/XgwYPBvZ/5hlgmTJlCqxKyTg/Q1kgjLt16xaqX750KXDeh/OA2Rcv+tmsgi1WvXp1OJw8bSrwiS5dAq5AMs7PEAbEuMzMTFQ7Yew44JHDh702IzwiHPbWbdoAH2nUCBgWFgYsV64ccHDsIKC/l9KlS6Po7du3LV307dcP+ulJM4Cs1zKzjVIyziYw+an9YtzmTV/B76SJE4EcRc2VtW3XDqqx4wUjWzz6qDmLQebqL+vYMegPHToEzDwomM15389790Jvx6gKIRVgb9FC1Hfwt98gnz9/HshLVNOmSC5ZvgxYqVIlmvJFybh8Q2SdwRHjUtevh5dJEwTTzPOxihUrwj51+nRgrz69rWsNUHvp0iV4WLViJXDJp58Cz507Z+k5blg89KdPnQZu2bzZkK9hw4aQV6WsAbIfhkwmQTLOFBBfRZ8Yt23rVvgbHid+OTPT6kZGwr7o44+BtcNr+1p/geS7evUq/MydPRu4WGXg7TzjqPpsbKyhvlUrBWOpfLJrVyTnLVxAlS1KxtmGxrvBK+NOnzqF0jHdnwJeuXLF4K1JVBPIi5ctA1apUsVgv1fC4d/FfHLi+PFoAp++sD1cw579+2+o0r75hibg+3PnAGN69DDo9YJknD4aDtIejONcSvERO2AgXKXv2WNwGRERAXn12s+BVatWNdiLisA1dGJCApq0/ot1hqYlJCZCXvPZZ8Djx8XzwGrVqkFO2ybu7VbzO8k4Qyh9FzwYx1WB4uKl0aMNnhj51I1fQl+r9t0dPQ2NcSBwFjB6xEiU4j2ttEusaSdPmQL99KnTgFyRjBk3FvKYcWLlA0G9SMbpo+EgrTGO97Ye6giq+OBakf44v+F8h/riglxxdOvyJJrMUbVOnTqQm6l7F2s/F/fukJAQ6HfsFk+u9SsKyTg/f3Vtl+vbtDS4MLNMUfbp2xe24so0NP6/C3fJkpLfgip+6AvArKwsYIeO0UDuTXBFsnnTJuj7DxgAVC6ScVoonCW0e9xzz4p13K6dOzUPfK61/aefoCsqKwOtgQEmOMp+vWULPHHW0KhxY8g71X63adsW8vKVK7QaJeO0UDhLuDjHyUhP9yjZRR19ShrT2NGExFeR5P398uXLkM27c3zyfOPGDdiVPQrJOEbRIbo4cpjPaSh+OkSLUcahz2KTnSufbt27o82bNm4EnjhxwtCHmzdvQt6/bx+wZatWknGGCDkQXNfUp6dWZZo0jbJSlzhdz1690CcyLjc317KP3G2TjLMMj29KF0cKZi9Vyj1e1KpVi+oSjW3bi/1f7uibY8LOc4WhyO4o0SrRpwh4ME7/BMDl0payPjkrrpmCg4PRdJ5l4UkBc3/+OHlSU0nGaaFwlvCgFNdrztyUjNyR9cT+sB3jLl68oHVUMk4LhbOEq5R6lozF7EYU2ksyhqqn2e36mHfLfQpeMs4uSvnoXWVNJ7EvXHD/H/PsBXeD8vFV7M3BweW99iG4vNsuGec1VPZGVzl1DsMsfD6nyEeOHoG6QYMGNJdozM295rV/IepJTyWTZJzXUNkbXdw7tMqyY/t2qP8vjDtz+oxVGDTdQzVqaGnJOC0UzhKuChXECW3uaF276v4/T1mTAm9D4+KAQUFBzrwXs9x8b8Ou2RERdTSTZJwWCmcJF1kUFSXO/HMvUXFz9IgYVX/4/nt47dipE7CkXbKzs9GlQ+qbQnb9a9xE7Lcqdsk4uyjlo9eejkR37Iisesax7Oz33kOSechS2os7bvlKvPfAE1vm/pQtWxaqps2aaSbJOC0UzhIa4x7r/BhKvpOc7OFh/7790KWuWw8srDdmPCouZAUZtmTxYq81tY/uADv3JBRBMs5ryOyNGuMi69VDLv0qwXxWLjkpCXmiO4n7YVE9bW7fXaOFZ0Y4ezBa3RL3Xd0ayTh9LByltfNxLPXJRx8xeV9ykji5qCnUBN9pn79oITTFbZTl6qhnTAzaz/cbzP3km9tbfxDzWJ7UVPLJe5w5Wj7KHozjyWylfLvWbeAm95p7/ar3+/IrkyCOGDVKry6yaY6iL40S72+Y31s1N/ztd2dC1a9/f7NJMs4jIj4qtFGV+XkyW5FjBw2CWn/fYz4FZ818F2JYWHVgz97i1A+EInhZuEC8h5of07hC4NcirLoi73FWUfFB53GP05fh17c6R4t5G2V9HiXN73zM+fADmLp262bOck/l79K+Rf0jhw8H6vdV9A1jP75IFSskniXR52FaMo6RcIheGUdfKatXI5mYIE5pU29Gnq2bPHUKTM8NGWLOclflH9U9k7jnh6Jeq3PO+gY9/4J40+a1N17Xqy3TknGWYclf6RPj6GZE/DAkucaj3g45Kk2b8Say8ByaXf6C0mekZ8BV/FDBNL6/YOefX7xZvkK8OcP9F7v8il4yzlt0vNgcMY6/XL/efeDy2NGjXly7TfwuyYy3xNq3ZauWbmMBpLj2XDB/PrwtXCCQZ1/squj8xOMwzZ47F1hedzbErgz1knGMhEN0xDj6/uvPv5CMHTgQqD8byzze8KmYp2GOHybmVfrdI2/laOPXw/ilmkXzxYrA7ttKLEfk87WZs2ZB5c9pLMk4RtMh+sU41sHvsb04ciRU6XvSaXKE/JoW922bq9+Zq1lTnNXIzb0Ofzt+FGdZli1ZCtlXhpFR49Qv3/BpTiDPESXjHP3E7swBMY5uOHotUr+C9cEcMUrdq/PEZBKfVE+c9DKayn0VtjsQlIzzM3oFwjhz3fxWOb8kuDZFfMeD90Rz/kBlMulxdV7Wu4+YZ1IfqH+r8pJxVlHxQVcojDPXy+dfBw4cgOnXn38Bnjx5ApiTnQPkhWf2atSsCdX9D9wP5Fs/oaFhkMMjwg16CHfpIhnnZ6D/BdRd0/6J1oO9AAAAAElFTkSuQmCC"

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABUCAYAAAARdWCGAAAMSGlDQ1BJQ0MgUHJvZmlsZQAASImVVwdYU8kWnltSSWiBCEgJvYlSpEsJoUUQkCrYCEkgocSQEETsLssquHYRAXVFV0VcdC2ArBW7sgj2/lAWlZV1sWBD5U0KrOt+773vne+be/+cOec/JXPvnQFAp4YnleaiugDkSQpk8REhrCmpaSxSN0CADtADnsCMx5dL2XFx0QDK8P3v8uYGtIZy1UXJ9c/5/yp6AqGcDwASB3GGQM7Pg/ggAHgJXyorAIDoA/XWswukSjwNYgMZTBBiqRJnqXGJEmeocaXKJjGeA/EeAMg0Hk+WBYB2M9SzCvlZkEf7FsSuEoFYAoAOGeJAvogngDgS4jF5ebOUGNoBh4wveLL+xpkxwsnjZY1gdS0qIYeK5dJc3pz/sx3/W/JyFcMx7OCgiWSR8cqaYd9u5cyKUmIaxH2SjJhYiPUhficWqOwhRqkiRWSS2h415cs5sGeACbGrgBcaBbEpxOGS3JhojT4jUxzOhRiuELRIXMBN1PguFcrDEjScNbJZ8bHDOFPGYWt8G3gyVVyl/WlFThJbw39LJOQO878uFiWmqHPGqIXi5BiItSFmynMSotQ2mE2xiBMzbCNTxCvzt4HYTyiJCFHzYzMyZeHxGntZnny4XmypSMyN0eCqAlFipIZnD5+nyt8I4mahhJ00zCOUT4kerkUgDA1T1451CCVJmnqxLmlBSLzG96U0N05jj1OFuRFKvRXEpvLCBI0vHlgAF6SaH4+RFsQlqvPEM7J5E+PU+eBFIBpwQChgAQUcGWAWyAbi9r6mPvhLPRMOeEAGsoAQuGg0wx4pqhkJvCaAYvAHREIgH/ELUc0KQSHUfxrRqq8uIFM1W6jyyAGPIc4DUSAX/laovCQj0ZLBb1Aj/kd0Psw1Fw7l3D91bKiJ1mgUw7wsnWFLYhgxlBhJDCc64iZ4IO6PR8NrMBzuuA/uO5ztX/aEx4ROwiPCdUIX4fZM8RLZV/WwwCTQBSOEa2rO+LJm3A6yeuIheADkh9w4EzcBLvh4GImNB8HYnlDL0WSurP5r7r/V8EXXNXYUVwpKGUUJpjh87antpO05wqLs6ZcdUueaMdJXzsjM1/E5X3RaAO9RX1tiS7ED2DnsJHYBO4I1ARZ2HGvG2rCjSjyyin5TraLhaPGqfHIgj/gf8XiamMpOyl3rXXtdP6rnCoRFyvcj4MySzpGJs0QFLDZ88wtZXAl/7BiWu6ubLwDK74j6NfWKqfo+IMyLf+nyTwDgWwaVWX/peNYAHH4MAOPNXzrrl/DxWAXA0Q6+Qlao1uHKCwFQ4RfKABgDc2ANHGA97sAL+INgEAYmgliQCFLBDNhlEVzPMjAbzAOLQSkoB6vAelAFtoBtYBf4CewHTeAIOAnOgkugA1wHd+Hq6QHPQD94AwYRBCEhdISBGCMWiC3ijLgjPkggEoZEI/FIKpKOZCESRIHMQ75BypE1SBWyFalDfkYOIyeRC0gncht5iPQiL5EPKIbSUAPUDLVDx6E+KBuNQhPR6WgWmo8WoyXoCrQSrUX3oI3oSfQSeh3tQp+hAxjAtDAmZom5YD4YB4vF0rBMTIYtwMqwCqwWa8Ba4P98FevC+rD3OBFn4CzcBa7gSDwJ5+P5+AJ8OV6F78Ib8dP4Vfwh3o9/JtAJpgRngh+BS5hCyCLMJpQSKgg7CIcIZ+DT1EN4QyQSmUR7ojd8GlOJ2cS5xOXETcS9xBPETmI3cYBEIhmTnEkBpFgSj1RAKiVtJO0hHSddIfWQ3pG1yBZkd3I4OY0sIS8hV5B3k4+Rr5CfkAcpuhRbih8lliKgzKGspGyntFAuU3oog1Q9qj01gJpIzaYuplZSG6hnqPeor7S0tKy0fLUma4m1FmlVau3TOq/1UOs9TZ/mROPQptEUtBW0nbQTtNu0V3Q63Y4eTE+jF9BX0Ovop+gP6O+0GdpjtbnaAu2F2tXajdpXtJ/rUHRsddg6M3SKdSp0Duhc1unTpeja6XJ0eboLdKt1D+ve1B3QY+i56cXq5ekt19utd0HvqT5J304/TF+gX6K/Tf+UfjcDY1gzOAw+4xvGdsYZRo8B0cDegGuQbVBu8JNBu0G/ob7heMNkwyLDasOjhl1MjGnH5DJzmSuZ+5k3mB9GmY1ijxKOWjaqYdSVUW+NRhsFGwmNyoz2Gl03+mDMMg4zzjFebdxkfN8EN3EymWwy22SzyRmTvtEGo/1H80eXjd4/+o4paupkGm8613SbaZvpgJm5WYSZ1Gyj2SmzPnOmebB5tvk682PmvRYMi0ALscU6i+MWv7MMWWxWLquSdZrVb2lqGWmpsNxq2W45aGVvlWS1xGqv1X1rqrWPdab1OutW634bC5tJNvNs6m3u2FJsfWxFthtsz9m+tbO3S7H7zq7J7qm9kT3Xvti+3v6eA90hyCHfodbhmiPR0ccxx3GTY4cT6uTpJHKqdrrsjDp7OYudNzl3jiGM8R0jGVM75qYLzYXtUuhS7/JwLHNs9NglY5vGPh9nMy5t3Opx58Z9dvV0zXXd7nrXTd9totsStxa3l+5O7nz3avdrHnSPcI+FHs0eL8Y7jxeO3zz+lifDc5Lnd56tnp+8vL1kXg1evd423uneNd43fQx84nyW+5z3JfiG+C70PeL73s/Lr8Bvv9+f/i7+Of67/Z9OsJ8gnLB9QneAVQAvYGtAVyArMD3wh8CuIMsgXlBt0KNg62BB8I7gJ2xHdjZ7D/t5iGuILORQyFuOH2c+50QoFhoRWhbaHqYflhRWFfYg3Co8K7w+vD/CM2JuxIlIQmRU5OrIm1wzLp9bx+2f6D1x/sTTUbSohKiqqEfRTtGy6JZJ6KSJk9ZOuhdjGyOJaYoFsdzYtbH34+zj8uN+mUycHDe5evLjeLf4efHnEhgJMxN2J7xJDElcmXg3ySFJkdSarJM8Lbku+W1KaMqalK4p46bMn3Ip1SRVnNqcRkpLTtuRNjA1bOr6qT3TPKeVTrsx3X560fQLM0xm5M44OlNnJm/mgXRCekr67vSPvFheLW8gg5tRk9HP5/A38J8JggXrBL3CAOEa4ZPMgMw1mU+zArLWZvWKgkQVoj4xR1wlfpEdmb0l+21ObM7OnKHclNy9eeS89LzDEn1JjuT0LPNZRbM6pc7SUmlXvl/++vx+WZRshxyRT5c3FxjADXubwkHxreJhYWBhdeG72cmzDxTpFUmK2uY4zVk250lxePGPc/G5/Lmt8yznLZ73cD57/tYFyIKMBa0LrReWLOxZFLFo12Lq4pzFvy5xXbJmyetvUr5pKTErWVTS/W3Et/Wl2qWy0pvf+X+3ZSm+VLy0fZnHso3LPpcJyi6Wu5ZXlH9czl9+8Xu37yu/H1qRuaJ9pdfKzauIqySrbqwOWr1rjd6a4jXdayetbVzHWle27vX6mesvVIyv2LKBukGxoasyurJ5o83GVRs/VomqrleHVO+tMa1ZVvN2k2DTlc3Bmxu2mG0p3/LhB/EPt7ZGbG2staut2EbcVrjt8fbk7ed+9PmxbofJjvIdn3ZKdnbtit91us67rm636e6V9Wi9or53z7Q9HT+F/tTc4NKwdS9zb/k+sE+x7/ef03++sT9qf+sBnwMNB20P1hxiHCprRBrnNPY3iZq6mlObOw9PPNza4t9y6Jexv+w8Ynmk+qjh0ZXHqMdKjg0dLz4+cEJ6ou9k1snu1pmtd09NOXXt9OTT7Weizpw/G3721Dn2uePnA84fueB34fBFn4tNl7wuNbZ5th361fPXQ+1e7Y2XvS83d/h2tHRO6Dx2JejKyauhV89e4167dD3meueNpBu3bk672XVLcOvp7dzbL+4U3hm8u+ge4V7Zfd37FQ9MH9T+y/Ffe7u8uo4+DH3Y9ijh0d1ufvez3+S/fewpeUx/XPHE4kndU/enR3rDezt+n/p7zzPps8G+0j/0/qh57vD84J/Bf7b1T+nveSF7MfRy+SvjVztfj3/dOhA38OBN3pvBt2XvjN/teu/z/tyHlA9PBmd/JH2s/OT4qeVz1Od7Q3lDQ1KejKfaCmBwoJmZALzcCQA9Fe4dOgCgTlWf81SCqM+mKgT+E1afBVXiBcDOYACSFgEQDfcom+GwhZgG78qtemIwQD08RoZG5Jke7mouGjzxEN4NDb0yA4DUAsAn2dDQ4KahoU/bYbK3ATiRrz5fKoUIzwY/GCtR201d8LX8G6gkfnxoxCvgAAAACXBIWXMAABYlAAAWJQFJUiTwAAACAmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8ZXhpZjpQaXhlbFlEaW1lbnNpb24+OTY8L2V4aWY6UGl4ZWxZRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpQaXhlbFhEaW1lbnNpb24+OTQ8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KhddjMwAACXhJREFUeAHtXHlQVlUU/9g3UVEwUGEEFUmixrXUxMxS1LTRyW10UHEP1zSNHJtJs0bHqXGUdNJxwf4wGdEmzQVRa8BcwMyZEFwAc8cUSGUTMDnnnedb7vu+j/eewKeXPzjnnnvuufee9/vufq/Tk6d/Fv5n2APOhi1wA+AB14bwQ05ODmS7bu1aoFmZWUCLi4qAVlVVAbX1z8nJCVQ8PDyABgcHAx01dgzQuClTgNbHP45Ik7zs9DzbyMI7d6CYc+JnA/3r3Dmg9iLOaB0JsVGvR4GprUlJQJs1a2bUtCo9R6TKJfoEpiKypKQESjFuNLZRF3Nz9ZXqOacaFBMDOSRu3GBaThyRJrnSFERu3rQJirPq62+A2hqahgTi0LUXNl2WyDAcPAT6u0B6H0/8vuOXlRuqpjN26pYajZGyj48P2E89dhRoq1atdOfHEanbdfKEhhA5Y+pUsJZ2JE1uVRHqFVUDkrljvYF2i/BSaMiDhOiCm48h4kJBBdDcqzi+zMpBe1k5iIPqanl6CvkI2XQNR/3sAoTovRIBqoKiszPa2bvvF5B07tyZTNhNOSLtdpV1RV2InDhhAljNSM9gWvf2xEbpi6luED+yvy9Tz6jwQSlCcdeRh2Bqy88YvlssRxzlM3kYcrfvIUIPnJDjiMadBw4fAsUOHTtSUptUbsmmOlfQ8kCdELl44SKwk7J7N9NeWBv80hsTEIHtgtyZes9LWFqO+Scm43h2CzZ5FmUbOuZ9/MUIU3XLzsNyBNPc/e9cXBOwp7wckfZ4yQ4duxB56CC2GfEzZzJNRoYhErYsaw7xfk1xPMhUrkfh5WvY2y9ai21odr4cN+NjEJmFRUhTT8nj3+7bF0q7bUeSzVLLU9pU5wpaHtBEJI3lahO+2jEc0itXbWiGsuubphDfommDLG9C3tb+VVUj4pZuwPXOPcfkbeKiCRjecxx7/SvX5fj6VejFw8PRD6y85ClYGlxmlwc0ETlrxgzRQOqhwyJfy9CMIWU1zlVDW9dv7ywrTB0C9Cubs+Y+pDp8EnHkIsBpaRwyK7dgm1+NxNK6TWvQ/z2DPW6ujeSIBBcZ/6dCZLUw6IoQ2sXaLJ7UCJ9GyG/tQpyxDO7dxHgJGsDCQ2FGNHRBMeR+61/EU2hrrGfPSGwzf0qVt6UHU/GXyZrxcESa9CFV3ez8OXPBtBKFtcJhffGLOSoSyWdNvHGcu3IWLg/FrcDxZv5NxFWfN7CXdxWGw1XYmVsSFi8BE8l7UsiUSDkiRVcYY1RtZEQHXPGQjhm9PPALHd+Iu2+NZeZirOrPUs9dcw8CB/9AXHkJq1ddw7HeGedR7uKCEM29cvlZYoHjiFS5RJ9AbCMJgUSl5vp3w9CLhkSq45JYnJmlnsI5eVk59tZFDxCRpEcjmtu3b4MoMDCQovg4UvSEQUZE5LV/rmmaiu4iqmnqOHJEm1Y0LkYE7ktHRObdkI8jqY4bEr8H9ssVy0nEESl6wiAjQu36dW1ERnXE014G82r0yYf3w3ruS6+EspZXshGZlZmpqgvvtVUu0ScQEVlchPNOlpmQQMdY3WGVvS6yXlG47+7pjjMdLUTeunlTZZYjUuUSfQIRkSXFckT64scBqx5u7LZCX5aNNxXV87UO2HtnZrPrXVpaqqoER6TKJfoEIiJrLPJRvIe7PKzPvGOmat8GkZiZzS4/zXCksRyRUm8Y4EVEenp6ysxUaIyhZEovaCDAj/DF/lXS3o+0+pRCKuO8Dg+IiPTxlnTTTw09kHRMlY/xy7i/JL23rzf11mxE0qk1qb85IqXeMMCLiPRr2VLTzCXhDE1kmLwd1Uzg4BGPythIpGrRCV8K11KOSKk3DPAiIoPbttU0k34Obxe8LIi8cZf28amtlLvGy0t9Bp4jUu4j3SERkW2Fm6V0ilV6iztFOKU1fQS2HaxeS3cJGmHC3KvURrIRGcC4j8MRadKHFBFJKHN1xf2Lx4/xjkttPvk30N9pZx5Btu/1dMwzP7Z8RrcksvOs46tPnz4qU9ZTqNS5QMsDIiJJoV1oO2AvXbxEIpGu24UrxwN64LlIQrGo4ODMwRP4i9O6u0jVm/HxLGJFyhEpusIYo0LkpLg4sLj0swSV5QvCrYDdRx9A3EcD8ISCStHBBLSas30/9QtsfLm7496V9IQFVZWdgmI5tdsDqtNolDI8rD2xlhrFiV2/pjjO2v8dItK/uQrYYlpHYOjMT/xqQiS71H2joyFia9J2lQJHpMol+gSaiBwaM1i0mCu80yMKBKZfF5yT/rC0BUgcrRcvE+4ujlyC92+U92uU9T2ZeQZE/v7+yii++qPyiE6BJiLz8vJEkwPfHSDyLGbeWJyTxo/Cu4gsncYko156/rf3oVjKe9vKsnbv0R1EO5OTlVFimLeRoiuMMZqIlJrt/eZbEKSXpaRxUn7VHOy9R7yD97WlcY2J37wXT5Ws3kGrPOzS0Uo43dt2c8N1CJY2RyTLKzpkdg0AtwnjpiGDYqxmkbAeX0FxccaZz/DoxoXM42dxLr3mR+tIpErOWzAfWGtIJF2OSPKEQWpXG0l50JtnZ06fJhGT0gtQn0/G7xQ71PzX8ZgZawhPnMdN+qlf4eoV3eTSULe0EHZUT2epT+ZqpeGI1PJMHeV1QiTZjuwUAWxFBX5hkmvRD6NxBrR8ph+oeHnUz/f7M7cM8pu2Eul/j9h7MFRu6qUPpR0BUWhoKEXZpPVTI5vFcHwFXYjMz8uHmg8cgDMeminYcge9C7RiJp4z6tFZvT9sy4a1+LIKRP7GFHz3Z9Me1LbVJtI6Y9pvxyFBUFCQtWyYcRyRTLfUXagLkZTNsaPHgJ0uvK5sLzIpfUwvRNC0EbgHFNW+bmeLKoRTcrvTcNyamIzjWK230Shfol7CCbwTp06CyNdX/7iXI5K8apAaQiTlfTbrLLDjRo8GyjpjTbrWaEQ7RGh0F/y+3SJwjyT4FZyAlVXijITOIiXtR33le5DW8qiNCwkJAZUDwhsV9BaarXTW4jkirXmnDnGmIJLyKyvF8doHQ4aA6GpBAUU1KCXELUnAndHYSRNNLw9HpEkuNRWRyjJlpKeD6NNPFgItLCxUqpgapj2jgIAAsBs/Ox7o+NhYU/NhGeOIZHlFh+y5IlJZnspKvAeduD4RotJSU4HeEd6IUM7dXV2xt24prMb4C0hr0RJ3LTsJc/6BMYPATkQErgEo862PMEekSV6uV0SaVOZGaYYj0qTP8j8aQaB0az+q/wAAAABJRU5ErkJggg=="

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_animals_test_Full_jpg__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_animals_test_Full_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_animals_test_Full_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_animals_test_Half_jpg__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_animals_test_Half_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_animals_test_Half_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_animals_test_OneFourth_jpg__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_animals_test_OneFourth_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_animals_test_OneFourth_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_animals_test_OneEighth_jpg__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_animals_test_OneEighth_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_animals_test_OneEighth_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnimalsComponent=function(_Component){_inherits(AnimalsComponent,_Component);function AnimalsComponent(){_classCallCheck(this,AnimalsComponent);return _possibleConstructorReturn(this,(AnimalsComponent.__proto__||Object.getPrototypeOf(AnimalsComponent)).apply(this,arguments));}_createClass(AnimalsComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{overFlowX:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:20}},'Small Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_animals_test_OneEighth_jpg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:20}},'Middle Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_animals_test_OneFourth_jpg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:20}},'Big Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_images_animals_test_Half_jpg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:20}},'Full Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_images_animals_test_Full_jpg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)));}}]);return AnimalsComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AnimalsComponent);

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Full.6e62e707.jpg";

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Half.df1cff93.jpg";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OneFourth.c2e8f321.jpg";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OneEighth.66bbad41.jpg";

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomeHeaderComponent_HomeHeader__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Twitter_Social_Icon_png__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Twitter_Social_Icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_Twitter_Social_Icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_Facebook_logo_png__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_Facebook_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_Facebook_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var logoIdeasThatWork=__webpack_require__(198);var HelpComponent=function(_Component){_inherits(HelpComponent,_Component);function HelpComponent(props){_classCallCheck(this,HelpComponent);var _this=_possibleConstructorReturn(this,(HelpComponent.__proto__||Object.getPrototypeOf(HelpComponent)).call(this,props));_this.state={firstName:'',lastName:'',eMail:'',reason:'',done:false,warning:'',errorEmail:'',confirmEmail:'',errorConfirmEmail:'',emailMatch:false,modalDialog:false,responseContent:''};_this.handleFirstName=_this.handleFirstName.bind(_this);_this.handleLastName=_this.handleLastName.bind(_this);_this.handleEmail=_this.handleEmail.bind(_this);_this.handleReason=_this.handleReason.bind(_this);_this.handleHelp=_this.handleHelp.bind(_this);_this.handleEmailConfirmChange=_this.handleEmailConfirmChange.bind(_this);return _this;}_createClass(HelpComponent,[{key:'handleFirstName',value:function handleFirstName(event){this.setState({firstName:event.target.value});}},{key:'handleLastName',value:function handleLastName(event){this.setState({lastName:event.target.value});}},{key:'handleEmail',value:function handleEmail(event){this.setState({eMail:event.target.value});if(!this.validateEmail(event.target.value)){this.setState({eMail:'',errorEmail:'validationRed',warning:'Email address format is invalid'});}else{this.setState({eMail:event.target.value,warning:'',errorEmail:''});}}},{key:'handleEmailConfirmChange',value:function handleEmailConfirmChange(event){this.setState({confirmEmail:event.target.value});if(this.validateEmail(event.target.value)&&this.validateEmail(this.state.eMail)){if(event.target.value===this.state.eMail){this.setState({confirmEmail:event.target.value,errorEmail:'',errorConfirmEmail:'',warning:'',emailMatch:true});}else{this.setState({confirmEmail:event.target.value,errorEmail:'validationRed',errorConfirmEmail:'validationRed',warning:'Emails Do Not Match!',emailMatch:false});}}else{this.setState({confirmEmail:'',errorEmail:'validationRed',errorConfirmEmail:'validationRed',warning:'Email address format is invalid',emailMatch:false});}}},{key:'handleReason',value:function handleReason(event){this.setState({reason:event.target.value});}},{key:'handleHelp',value:function handleHelp(event){var _this2=this;__WEBPACK_IMPORTED_MODULE_2__Shared_REST__["a" /* default */].helpRequest(this.state).then(function(response){_this2.setState({modalDialog:true,responseContent:'Help request sent. You will receive a response once an admin has reviewed the application.'});//setTimeout(()=>{this.setState({modalDialog:false})},5000);
_this2.setState({done:true});}).catch(function(error){console.log('Error Request Account',error);_this2.setState({modalDialog:true,responseContent:'Error Request Account'});//setTimeout(()=>{this.setState({modalDialog:false})},3500);
});event.preventDefault();}},{key:'validateEmail',value:function validateEmail(email){var re=/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;return re.test(email);}},{key:'validate',value:function validate(){var valid=true;var fields=this.state;if(fields.firstName===''||fields.lastName===''||fields.reason===''||!this.validateEmail(this.state.eMail)){valid=false;}return valid;}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__HomeHeaderComponent_HomeHeader__["a" /* default */],{currentItem:"Help"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section bgGreen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Having a problem?'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 bgGrey roundCorners'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{style:{marginTop:15}},'FILL OUT THE FORM. We\u2019ll get back to you ASAP.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'formHelp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputFirstName',className:'sr-only'},'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onChange:this.handleFirstName,type:'text',id:'inputFirstName',className:'form-control w100',placeholder:'First Name',required:true,autoFocus:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputLastName',className:'sr-only'},'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'inputLastName',onChange:this.handleLastName,className:'form-control w100',placeholder:'Last Name',required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"validWarning",style:{color:'red'}},this.state.warning),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputEmail',className:'sr-only'},'Email Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onBlur:this.handleEmail,type:'email',id:'inputEmail',className:this.state.errorEmail+' form-control w100',placeholder:'Email Address',required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',id:'inputConfirmEmail',className:this.state.errorConfirmEmail+' form-control w100',onBlur:this.handleEmailConfirmChange,placeholder:'Confirm Email Address',required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{onChange:this.handleReason,placeholder:'Tell us what\'s going on.',required:true,className:'form-control w100'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!this.validate()||this.state.done,onClick:this.handleHelp,className:'btn btn-primary btn-block',type:'submit',style:{textAlign:'center'}},'Submit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this3.setState({modalDialog:active});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'bgGrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:25}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-2',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Follow us: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-10',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:1,marginLeft:-30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://twitter.com/AvenuePM",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_Twitter_Social_Icon_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Twitter')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:95,marginTop:-28}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://www.facebook.com/profile.php?id=100009224578527&lst=100006500830477%3A100009224578527%3A1587693428&sk=timeline",style:{textDecoration:'none'},target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_images_Facebook_logo_png___default.a,style:{width:28,height:28},alt:'',border:'0'}),' Facebook')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This document was produced under U.S. Department of Education, Office of Special Education Programs Grant No. H327S170012. The views  expressed herein do not necessarily represent the positions or polices of the Department of Education. No official endorsement by the U.S. Department of Education of any product, commodity, service or enterprise mentioned in this publication is intended or should be inferred. This product is public domain.  Authorization to reproduce it in whole or in part is granted. While permission to reprint this publication is not necessary, the citation should be.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xA9 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',null,'new Date().getFullYear()>2010&&document.write(new Date().getFullYear());'),' Designed and developed by researchers at the University of Minnesota and Penn State University.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logoIdeasThatWork,alt:'Logo - Ideas That Work. U.S. Office of Special Education Programs',border:'0'}))))));}}]);return HelpComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HelpComponent);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KSGrading_style_style_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KSGrading_style_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__KSGrading_style_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_DropDownNotifications__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ModalFormComponents_ReportBugForm__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__ = __webpack_require__(20);
var _this7=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WordMarkGrading=function(_Component){_inherits(WordMarkGrading,_Component);function WordMarkGrading(props){var _this2=this;_classCallCheck(this,WordMarkGrading);var _this=_possibleConstructorReturn(this,(WordMarkGrading.__proto__||Object.getPrototypeOf(WordMarkGrading)).call(this,props));_this.startGrading=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(testId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getWordMarkSession(testId).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){var wmSession;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:wmSession=res.body;if(wmSession){_this.setState({storyStarter:wmSession.wordmark_content,sessionData:{gradingData:wmSession.gradingData},studentResponse:wmSession.studentResponse,noteContent:wmSession.note,spelling:wmSession.spelling?wmSession.spelling:[]},function(){_this.initializeData(wmSession.gradingData).then(function(){_this.checkSpelling();});});}else{_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);}case 2:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}()).catch(function(error){console.log(error);});case 2:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.keypress=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(e){var wordIndex,img;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:wordIndex=_this.state.wordIndex;img=_this.state.paragraphs[wordIndex];if(!(e.which===38)){_context3.next=22;break;}// up arrow
// console.log("up arrow");
e.preventDefault();if(!(wordIndex<_this.state.paragraphs.length)){_context3.next=20;break;}if(!(img.alt===undefined||img.alt==="")){_context3.next=10;break;}_context3.next=8;return _this.correctTickMark(wordIndex,false);case 8:_context3.next=15;break;case 10:if(!(img.alt==="wrong")){_context3.next=15;break;}_context3.next=13;return _this.removeMark(wordIndex);case 13:_context3.next=15;return _this.correctTickMark(wordIndex,false);case 15:_context3.next=17;return _this.highlightRight(wordIndex);case 17:wordIndex+=1;_context3.next=20;return _this.playSound("correct");case 20:_context3.next=60;break;case 22:if(!(e.which===40)){_context3.next=42;break;}// down arrow
// console.log("down arrow");
e.preventDefault();if(!(wordIndex<_this.state.paragraphs.length)){_context3.next=40;break;}if(!(img.alt===undefined||img.alt==="")){_context3.next=30;break;}_context3.next=28;return _this.wrongTickMark(wordIndex,false);case 28:_context3.next=35;break;case 30:if(!(img.alt==="correct")){_context3.next=35;break;}_context3.next=33;return _this.removeMark(wordIndex);case 33:_context3.next=35;return _this.wrongTickMark(wordIndex,false);case 35:_context3.next=37;return _this.highlightRight(wordIndex);case 37:wordIndex+=1;_context3.next=40;return _this.playSound("wrong");case 40:_context3.next=60;break;case 42:if(!(e.which===37)){_context3.next=52;break;}// left arrow
// console.log("left arrow");
e.preventDefault();if(!(wordIndex>0)){_context3.next=50;break;}wordIndex-=1;_context3.next=48;return _this.highlightLeft(wordIndex);case 48:_context3.next=50;return _this.playSound("click");case 50:_context3.next=60;break;case 52:if(!(e.which===39)){_context3.next=60;break;}// right arrow
//console.log("right arrow");
e.preventDefault();if(!(wordIndex<_this.state.paragraphs.length)){_context3.next=60;break;}_context3.next=57;return _this.highlightRight(wordIndex);case 57:wordIndex+=1;_context3.next=60;return _this.playSound("click");case 60:e.stopImmediatePropagation();_context3.next=63;return _this.calculateScore();case 63:_context3.next=65;return _this.setState({wordIndex:wordIndex});case 65:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref3.apply(this,arguments);};}();_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].logout().then(function(response){localStorage.removeItem('token');localStorage.clear();_this.props.history.push("/login");},function(error){console.log('Error',error);localStorage.removeItem('token');localStorage.clear();_this.props.history.push("/login");});};_this.deleteScoreConfirm=function(confirm){if(confirm){_this.deleteScore();}_this.setState({modalDialogDelete:false});};_this.handleStudentClick=function(student,classId){_this.props.updateStudent(student);_this.props.history.push('/teacher/student');};_this.state={bestScores:null,gradeStart:null,storyStarter:{},studentResponse:'',score:0,correct:0,incorrect:0,paragraphs:[],wordIndex:0,highlighted:-1,timer:null,progressBar:{width:null},modalDialog:false,responseContent:'',modalDialogDelete:false,modalDialogNote:false,noteContent:'',handleNext:false,taskID:null,sessionData:{testId:0,gradingData:"",gradingTime:0,numberCorrect:0,numberIncorrect:0},analytics:{type:null,metadata:null},spelling:[]};_this.startGrading=_this.startGrading.bind(_this);_this.submitWordMarkSessionGrade=_this.submitWordMarkSessionGrade.bind(_this);_this.initializeData=_this.initializeData.bind(_this);_this.calculateScore=_this.calculateScore.bind(_this);_this.mouseClick=_this.mouseClick.bind(_this);_this.wrongTickMark=_this.wrongTickMark.bind(_this);_this.correctTickMark=_this.correctTickMark.bind(_this);_this.showCurrentMark=_this.showCurrentMark.bind(_this);_this.fillWithChecks=_this.fillWithChecks.bind(_this);_this.clearCounters=_this.clearCounters.bind(_this);_this.keyDownListener=_this.keypress.bind(_this);_this.highlightLeft=_this.highlightLeft.bind(_this);_this.highlightRight=_this.highlightRight.bind(_this);_this.deleteScore=_this.deleteScore.bind(_this);_this.handleTakeANote=_this.handleTakeANote.bind(_this);_this.saveNote=_this.saveNote.bind(_this);_this.deleteNote=_this.deleteNote.bind(_this);_this.handleNoteClose=_this.handleNoteClose.bind(_this);_this.handleNoteContentChange=_this.handleNoteContentChange.bind(_this);_this.checkSpelling=_this.checkSpelling.bind(_this);_this.handleStudentClick=_this.handleStudentClick.bind(_this);_this.handleNextTask=_this.handleNextTask.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(WordMarkGrading,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener("keydown",this.keyDownListener);}},{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this3=this;var parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:__WEBPACK_IMPORTED_MODULE_4__Shared_Helpers__["a" /* default */].authorize(this);parsed=__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.parse(this.props.location.search);_context4.next=4;return this.setState({testId:parsed.testId,gradeStart:Date.now(),analytics:{type:__WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__["a" /* TRACKING */].WM_SCORE_VIEW,metadata:{testId:parsed.testId}}});case 4:this.startGrading(parsed.testId);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentNotifications().then(function(res){console.log(parsed.testId);console.log(res.body);for(var i=0;i<res.body.length;i++){for(var j=0;j<res.body[i].apps.wordMarkScores.length;j++){var wordMarkScores=res.body[i].apps.wordMarkScores[j];if(wordMarkScores&&wordMarkScores.userId===_this3.props.lastStudent.user.id&&wordMarkScores.id!=parsed.testId){_this3.setState({handleNext:true,taskID:wordMarkScores.id});}}}});this.handleAnalytics();document.addEventListener("keydown",this.keyDownListener);case 8:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleNextTask',value:function handleNextTask(){window.location.href='/teacher/apps/wm-grading?testId='+this.state.taskID;}},{key:'submitWordMarkSessionGrade',value:function submitWordMarkSessionGrade(event){var _this4=this;var gradingData="";for(var i=0;i<this.state.paragraphs.length;i++){if(this.state.paragraphs[i].alt===""){gradingData=gradingData+"0";}else if(this.state.paragraphs[i].alt==="wrong"){gradingData=gradingData+"2";}else{gradingData=gradingData+"1";}if(i!==this.state.paragraphs.length-1){gradingData=gradingData+",";}}this.setState({sessionData:{testId:this.state.testId,gradingData:gradingData,gradingTime:Math.ceil((Date.now()-this.state.gradeStart)/1000),numberCorrect:this.state.correct,numberIncorrect:this.state.incorrect}},function(){console.log("Submitting session data: ",_this4.state.sessionData);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].gradeWordMarkSession(_this4.state.sessionData).then(function(res){if(res.success){_this4.setState({modalDialog:true,responseContent:'Score task saved.',analytics:{type:__WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__["a" /* TRACKING */].WM_SCORE_SAVE,metadata:{testId:_this4.state.testId}}});_this4.handleAnalytics();setTimeout(function(){_this4.setState({modalDialog:false});},3500);}else{_this4.setState({modalDialog:true,responseContent:'Grading Failed to update'});setTimeout(function(){_this4.setState({modalDialog:false});},3500);}}).catch(function(err){console.log(err);_this4.setState({modalDialog:true,responseContent:'Grading Failed to update'});setTimeout(function(){_this4.setState({modalDialog:false});},3500);});});}},{key:'wrongTickMark',// functions to add tick icons
value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(index,current){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(current){this.state.paragraphs[index].src=__webpack_require__(386);}else{this.state.paragraphs[index].src=__webpack_require__(207);}this.state.paragraphs[index].alt="wrong";this.state.incorrect=this.state.incorrect+1;_context5.next=5;return this.forceUpdate();case 5:case'end':return _context5.stop();}}},_callee5,this);}));function wrongTickMark(_x4,_x5){return _ref5.apply(this,arguments);}return wrongTickMark;}()},{key:'correctTickMark',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(index,current){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(current){this.state.paragraphs[index].src=__webpack_require__(387);}else{this.state.paragraphs[index].src=__webpack_require__(93);}this.state.paragraphs[index].alt="correct";this.state.correct=this.state.correct+1;_context6.next=5;return this.forceUpdate();case 5:case'end':return _context6.stop();}}},_callee6,this);}));function correctTickMark(_x6,_x7){return _ref6.apply(this,arguments);}return correctTickMark;}()},{key:'showCurrentMark',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(index,current){var imgAlt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:imgAlt=this.state.paragraphs[index].alt;console.log('showCurrentMark');console.log(index);console.log(this.state.paragraphs[index].alt);console.log(current);if(imgAlt==="correct"){if(current){this.state.paragraphs[index].src=__webpack_require__(387);}else{this.state.paragraphs[index].src=__webpack_require__(93);}}else if(imgAlt==="wrong"){if(current){this.state.paragraphs[index].src=__webpack_require__(386);}else{this.state.paragraphs[index].src=__webpack_require__(207);}}else{if(current){this.state.paragraphs[index].src=__webpack_require__(889);}else{this.state.paragraphs[index].src="";}}_context7.next=8;return this.forceUpdate();case 8:return _context7.abrupt('return',imgAlt);case 9:case'end':return _context7.stop();}}},_callee7,this);}));function showCurrentMark(_x8,_x9){return _ref7.apply(this,arguments);}return showCurrentMark;}()},{key:'removeMark',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(index){var imgAlt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:imgAlt=this.state.paragraphs[index].alt;if(imgAlt==="correct"){this.state.correct=this.state.correct-1;this.state.paragraphs[index].src="";this.state.paragraphs[index].alt="";}else if(imgAlt==="wrong"){this.state.incorrect=this.state.incorrect-1;this.state.paragraphs[index].src="";this.state.paragraphs[index].alt="";}_context8.next=4;return this.forceUpdate();case 4:return _context8.abrupt('return',imgAlt);case 5:case'end':return _context8.stop();}}},_callee8,this);}));function removeMark(_x10){return _ref8.apply(this,arguments);}return removeMark;}()},{key:'swapMark',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(index){var oldImgAlt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:oldImgAlt=this.removeMark(index);if(!(oldImgAlt==="correct")){_context9.next=6;break;}_context9.next=4;return this.wrongTickMark(index,false);case 4:_context9.next=9;break;case 6:if(!(oldImgAlt==="wrong")){_context9.next=9;break;}_context9.next=9;return this.correctTickMark(index,false);case 9:case'end':return _context9.stop();}}},_callee9,this);}));function swapMark(_x11){return _ref9.apply(this,arguments);}return swapMark;}()},{key:'calculateScore',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){var newScore;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:newScore=parseInt(this.state.correct,10)-parseInt(this.state.incorrect,10);if(newScore<=0){this.state.score=0;}else{this.state.score=newScore;}_context10.next=4;return this.forceUpdate();case 4:case'end':return _context10.stop();}}},_callee10,this);}));function calculateScore(){return _ref10.apply(this,arguments);}return calculateScore;}()},{key:'clearCounters',value:function clearCounters(){//$("#data img").remove();
this.setState({endIndex:0,score:0,correct:0,incorrect:0,highlighted:-1});this.state.paragraphs.map(function(paragraph,i){paragraph.src="";paragraph.alt="";paragraph.highlighted=false;});this.forceUpdate();}},{key:'mouseClick',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(i,e){var c,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,p;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:c=0;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context11.prev=4;for(_iterator=this.state.paragraphs[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){p=_step.value;p.highlighted=c===i;this.showCurrentMark(c,false);c++;}_context11.next=12;break;case 8:_context11.prev=8;_context11.t0=_context11['catch'](4);_didIteratorError=true;_iteratorError=_context11.t0;case 12:_context11.prev=12;_context11.prev=13;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 15:_context11.prev=15;if(!_didIteratorError){_context11.next=18;break;}throw _iteratorError;case 18:return _context11.finish(15);case 19:return _context11.finish(12);case 20:_context11.next=22;return this.forceUpdate();case 22:if(!e){_context11.next=27;break;}_context11.next=25;return this.removeMark(i);case 25:_context11.next=27;return this.calculateScore();case 27:_context11.next=29;return this.highlightLeft(i);case 29:case'end':return _context11.stop();}}},_callee11,this,[[4,8,12,20],[13,,15,19]]);}));function mouseClick(_x12,_x13){return _ref11.apply(this,arguments);}return mouseClick;}()},{key:'fillWithChecks',value:function fillWithChecks(){var imgAlt=void 0;for(var i=0;i<this.state.endIndex;i++){imgAlt=this.state.paragraphs[i].alt;if(imgAlt===""){this.correctTickMark(i);}}this.calculateScore();}},{key:'checkSpelling',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){var newParagraphs,i,test;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:newParagraphs=[];for(i=0;i<this.state.paragraphs.length;i++){test=this.state.spelling.includes(this.state.paragraphs[i].word);this.state.paragraphs[i].spellCheck=test;newParagraphs.push(this.state.paragraphs[i]);}this.setState({paragraphs:newParagraphs});case 3:case'end':return _context12.stop();}}},_callee12,this);}));function checkSpelling(){return _ref12.apply(this,arguments);}return checkSpelling;}()},{key:'initializeData',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){var csv,tickArr,text,wordArr,i,word,newPar,regxPunctuation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:csv=this.state.sessionData.gradingData;tickArr=[];if(csv){tickArr=csv.split(",");}text=this.state.studentResponse;// Trim out new lines
text=text.trim();// Add space for certain characters and trim out new lines
text=text.replace(/\./g," . ").replace(/\?/g," ?").replace(/!/g," !").trim();// Convert text to word array by splitting at spaces
text=text.replace(/\s+([])\s+|\s+([])|([])+\s|([])/gm," $1$2$3$4 ");if(text[text.length-1]===" "){text=text.substr(0,text.length-1);}wordArr=text.split(/\s+/);// Ensures the tick array has its
// length equal to the word count
while(tickArr.length>wordArr.length){tickArr.pop();}while(tickArr.length<wordArr.length){tickArr.push("0");}// Create elements for each word and appends to container in order
i=0;case 12:if(!(i<wordArr.length)){_context13.next=30;break;}word=wordArr[i];newPar={index:i,word:word,src:"",alt:"",highlighted:false};_context13.next=17;return this.setState({paragraphs:[].concat(_toConsumableArray(this.state.paragraphs),[newPar])});case 17:if(!(tickArr[i]==="1")){_context13.next=23;break;}_context13.next=20;return this.correctTickMark(i,false);case 20:this.state.endIndex=i;_context13.next=27;break;case 23:if(!(tickArr[i]==="2")){_context13.next=27;break;}_context13.next=26;return this.wrongTickMark(i,false);case 26:this.state.endIndex=i;case 27:i++;_context13.next=12;break;case 30:// Calculates initial score
this.forceUpdate();this.calculateScore();// Display the total word count
regxPunctuation=/[]/g;this.state.totalWords=wordArr.filter(function(value){return!value.match(regxPunctuation);}).length;_context13.next=36;return this.forceUpdate();case 36:this.mouseClick(0);case 37:case'end':return _context13.stop();}}},_callee13,this);}));function initializeData(){return _ref13.apply(this,arguments);}return initializeData;}()},{key:'playSound',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(type){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:if(!(this.audioCorrect.muted===false)){_context14.next=4;break;}_context14.next=3;return this.audioCorrect.pause();case 3:this.audioCorrect.currentTime=0;case 4:if(!(this.audioSwipe.muted===false)){_context14.next=8;break;}_context14.next=7;return this.audioSwipe.pause();case 7:this.audioSwipe.currentTime=0;case 8:if(!(this.audioWrong.muted===false)){_context14.next=12;break;}_context14.next=11;return this.audioWrong.pause();case 11:this.audioWrong.currentTime=0;case 12:if(!(this.audioCorrect.muted===false||this.audioWrong.muted===false||this.audioSwipe===false)){_context14.next=25;break;}_context14.t0=type;_context14.next=_context14.t0==="correct"?16:_context14.t0==="wrong"?19:_context14.t0==="click"?22:25;break;case 16:_context14.next=18;return this.audioCorrect.play();case 18:return _context14.abrupt('break',25);case 19:_context14.next=21;return this.audioWrong.play();case 21:return _context14.abrupt('break',25);case 22:_context14.next=24;return this.audioSwipe.play();case 24:return _context14.abrupt('break',25);case 25:case'end':return _context14.stop();}}},_callee14,this);}));function playSound(_x14){return _ref14.apply(this,arguments);}return playSound;}()},{key:'highlightRight',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(i){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:this.state.wordIndex=i;if(this.state.paragraphs[i-1]){this.state.paragraphs[i-1].highlighted=false;}if(this.state.paragraphs[i+1]){this.state.paragraphs[i+1].highlighted=true;}if(i===this.state.paragraphs.length-1){this.state.paragraphs[i].highlighted=false;}_context15.next=6;return this.showCurrentMark(i,false);case 6:if(!this.state.paragraphs[i+1]){_context15.next=9;break;}_context15.next=9;return this.showCurrentMark(i+1,true);case 9:_context15.next=11;return this.forceUpdate();case 11:case'end':return _context15.stop();}}},_callee15,this);}));function highlightRight(_x15){return _ref15.apply(this,arguments);}return highlightRight;}()},{key:'highlightLeft',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(i){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:this.state.wordIndex=i;if(i===this.state.paragraphs.length-1){this.state.paragraphs[i].highlighted=true;}if(this.state.paragraphs[i-1]){this.state.wordIndex=i-1;this.state.paragraphs[i-1].highlighted=true;}if(this.state.paragraphs[i+1]){this.state.paragraphs[i+1].highlighted=false;}console.log('mark i');console.log(i);_context16.next=8;return this.showCurrentMark(i,true);case 8:if(!this.state.paragraphs[i+1]){_context16.next=11;break;}_context16.next=11;return this.showCurrentMark(i+1,false);case 11:_context16.next=13;return this.forceUpdate();case 13:case'end':return _context16.stop();}}},_callee16,this);}));function highlightLeft(_x16){return _ref16.apply(this,arguments);}return highlightLeft;}()// Event handler for keypress events
},{key:'deleteScore',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].deleteWordMarkScore(this.state.testId).then(function(res){_this5.props.history.goBack();});case 2:case'end':return _context17.stop();}}},_callee17,this);}));function deleteScore(){return _ref17.apply(this,arguments);}return deleteScore;}()},{key:'handleTakeANote',value:function handleTakeANote(){console.log("take a note");this.setState({modalDialogNote:true});}},{key:'handleNoteContentChange',value:function handleNoteContentChange(event){this.setState({noteContent:event.target.value});event.preventDefault();}},{key:'saveNote',value:function saveNote(){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWordMarkNote({testId:this.state.testId,note:this.state.noteContent});this.setState({modalDialogNote:false});}},{key:'deleteNote',value:function deleteNote(){this.setState({noteContent:''});__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWordMarkNote({testId:this.state.testId,note:''});}},{key:'handleNoteClose',value:function handleNoteClose(){this.setState({modalDialogNote:false});}},{key:'handleSurveyBack',value:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:case'end':return _context18.stop();}}},_callee18,this);}));function handleSurveyBack(){return _ref18.apply(this,arguments);}return handleSurveyBack;}()},{key:'render',value:function render(){var _this6=this;var paragraphs=this.state.paragraphs.map(function(paragraph,i){var spellCheck=paragraph.spellCheck?" spellcheck ":"";var highLightSelect=paragraph.highlighted?" highlightSelect":"";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{key:i,className:spellCheck+highLightSelect,onClick:function onClick(e){return _this6.mouseClick(i,e);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{hidden:paragraph.alt==="",style:{left:"-5px"},src:paragraph.src,alt:paragraph.alt}),paragraph.word);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container-fluid bgGrey",style:{paddingLeft:0,paddingRight:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:'WMGrading',userId:this.props.user.id,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteScoreConfirm,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["a" /* Modal */],{id:'dialogBox',show:this.state.modalDialogNote},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{paddingTop:0,marginTop:-10,marginBottom:15}},'Make a Note'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{style:{width:500},onChange:this.handleNoteContentChange,value:this.state.noteContent,placeholder:"please enter your note here"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section',style:{marginTop:-40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.deleteNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.saveNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block",style:{maxWidth:'100%',marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark_png___default.a,alt:"Word Mark",style:{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}),' ',this.props.lastStudent.user.firstname,' ',this.props.lastStudent.user.lastname)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-8"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar"},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ModalFormComponents_ReportBugForm__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_DropDownNotifications__["a" /* default */],Object.assign({studentClick:this.handleStudentClick},this.props)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12 noPaddingLR'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container",style:{position:'relative',minHeight:'calc(100vh - 88px)',height:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block",style:{maxWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'appContainer',className:"col-md-12 ksGradingContainer newGradingClass",style:{backgroundColor:'#FFF',backgroundImage:'initial'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'whitebox',className:"newGradingClass"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'data',className:"col-md-12 newGradingClass",style:{overflowY:'auto',maxHeight:350}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:"bolderFont"},this.state.storyStarter.storyStarter),paragraphs),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'options',className:"newGradingClass col-md-12",style:{marginBottom:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 bgGrey",style:{padding:15}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{alt:'correct',src:__webpack_require__(93),style:{position:'relative',top:-25,left:50}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Correct'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'correct',className:'backgroundGradeCountBox'},this.state.correct)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{alt:'incorrect',src:__webpack_require__(208),style:{position:'relative',top:-25,left:60}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Incorrect'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'',className:"backgroundGradeCountBox"},this.state.incorrect)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Total Words'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'',className:"backgroundGradeCountBox"},this.state.totalWords)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Score'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'score',className:'backgroundGradeCountBox'},this.state.score)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'spelling',className:'fontSizeCalculationGrading',style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{borderBottom:'2px solid #fc0',position:'relative',top:3}},'Possible Spelling Error'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{hidden:true,onClick:this.fillWithChecks,type:'image',id:'auto_correct',src:__webpack_require__(388)})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{src:"/sounds/correct.mp3",ref:function ref(audio){return _this6.audioCorrect=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{src:"/sounds/correct.mp3",ref:function ref(audio){return _this6.audioWrong=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{src:"/sounds/swipe2.mp3",ref:function ref(audio){return _this6.audioSwipe=audio;}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-lg-4 col-xs-3 col-md-3 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return _this6.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__["a" /* TRACKING */].WM_SCORE_EXIT,metadata:{testId:_this6.state.testId}}});case 2:_this6.handleAnalytics();_this6.props.history.push('../student');case 4:case'end':return _context19.stop();}}},_callee19,_this6);})),className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Exit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-lg-8 col-xs-9 col-md-9 noPaddingLR",style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNextTask,className:'handBtn',style:{display:this.state.handleNext?'inline-block':'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Next Task')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleTakeANote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Make a Note')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitWordMarkSessionGrade,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.clearCounters,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Reset Grading')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this6.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TASK?'});},className:'handBtn',style:{marginRight:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete')))))));}}]);return WordMarkGrading;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var actionToProps=function actionToProps(dispatch){return{updateStudent:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["h" /* updateStudent */])(student));case 2:return _context20.abrupt('return',_context20.sent);case 3:case'end':return _context20.stop();}}},_callee20,_this7);}));function updateStudent(_x17){return _ref20.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{lastStudent:state.teacherReducer.student};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,actionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(WordMarkGrading)));

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAhGVYSWZNTQAqAAAACAAFARIAAwAAAAEAAQAAARoABQAAAAEAAABKARsABQAAAAEAAABSASgAAwAAAAEAAgAAh2kABAAAAAEAAABaAAAAAAAAAEgAAAABAAAASAAAAAEAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAADwAAAABzqn1JAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgICAgICAgICAgeG1sbnM6ZXhpZj0iaHR0cDovL25zLmFkb2JlLmNvbS9leGlmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICAgICA8dGlmZjpSZXNvbHV0aW9uVW5pdD4yPC90aWZmOlJlc29sdXRpb25Vbml0PgogICAgICAgICA8ZXhpZjpDb2xvclNwYWNlPjE8L2V4aWY6Q29sb3JTcGFjZT4KICAgICAgICAgPGV4aWY6UGl4ZWxYRGltZW5zaW9uPjE0PC9leGlmOlBpeGVsWERpbWVuc2lvbj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjE1PC9leGlmOlBpeGVsWURpbWVuc2lvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CrBVAIkAAAAgSURBVCgVY7x8+fJ/BjIAExl6wFpGNeIJudHAGR6BAwDC7wOWQp/q9AAAAABJRU5ErkJggg=="

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_REST__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Helpers__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KSGrading_style_style_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KSGrading_style_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__KSGrading_style_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark2_png__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_DeleteDialogBox__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_DropDownNotifications__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ModalFormComponents_ReportBugForm__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__ = __webpack_require__(20);
var _this7=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WordMark2Grading=function(_Component){_inherits(WordMark2Grading,_Component);function WordMark2Grading(props){var _this2=this;_classCallCheck(this,WordMark2Grading);var _this=_possibleConstructorReturn(this,(WordMark2Grading.__proto__||Object.getPrototypeOf(WordMark2Grading)).call(this,props));_this.startGrading=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(testId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getWordMark2Session(testId).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){var wmSession;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:wmSession=res.body;console.log('res.body');console.log(res.body);if(wmSession){_this.setState({storyPrompt1:wmSession.storyPrompt1,storyPrompt2:wmSession.storyPrompt2,sessionData:{gradingData:wmSession.gradingData},studentResponse:wmSession.studentResponse,noteContent:wmSession.note,spelling:wmSession.spelling?wmSession.spelling:[]},function(){_this.initializeData(wmSession.gradingData).then(function(){_this.checkSpelling();});});}else{_this.setState({modalDialog:true,responseContent:'An Invalid Assessment ID has been provided.'});setTimeout(function(){_this.setState({modalDialog:false});},3500);}case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}()).catch(function(error){console.log(error);});case 2:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.keypress=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(e){var wordIndex,img;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:wordIndex=_this.state.wordIndex;img=_this.state.paragraphs[wordIndex];if(!(e.which===38)){_context3.next=22;break;}// up arrow
// console.log("up arrow");
e.preventDefault();if(!(wordIndex<_this.state.paragraphs.length)){_context3.next=20;break;}if(!(img.alt===undefined||img.alt==="")){_context3.next=10;break;}_context3.next=8;return _this.correctTickMark(wordIndex,false);case 8:_context3.next=15;break;case 10:if(!(img.alt==="wrong")){_context3.next=15;break;}_context3.next=13;return _this.removeMark(wordIndex);case 13:_context3.next=15;return _this.correctTickMark(wordIndex,false);case 15:_context3.next=17;return _this.highlightRight(wordIndex);case 17:wordIndex+=1;_context3.next=20;return _this.playSound("correct");case 20:_context3.next=60;break;case 22:if(!(e.which===40)){_context3.next=42;break;}// down arrow
// console.log("down arrow");
e.preventDefault();if(!(wordIndex<_this.state.paragraphs.length)){_context3.next=40;break;}if(!(img.alt===undefined||img.alt==="")){_context3.next=30;break;}_context3.next=28;return _this.wrongTickMark(wordIndex,false);case 28:_context3.next=35;break;case 30:if(!(img.alt==="correct")){_context3.next=35;break;}_context3.next=33;return _this.removeMark(wordIndex);case 33:_context3.next=35;return _this.wrongTickMark(wordIndex,false);case 35:_context3.next=37;return _this.highlightRight(wordIndex);case 37:wordIndex+=1;_context3.next=40;return _this.playSound("wrong");case 40:_context3.next=60;break;case 42:if(!(e.which===37)){_context3.next=52;break;}// left arrow
// console.log("left arrow");
e.preventDefault();if(!(wordIndex>0)){_context3.next=50;break;}wordIndex-=1;_context3.next=48;return _this.highlightLeft(wordIndex);case 48:_context3.next=50;return _this.playSound("click");case 50:_context3.next=60;break;case 52:if(!(e.which===39)){_context3.next=60;break;}// right arrow
//console.log("right arrow");
e.preventDefault();if(!(wordIndex<_this.state.paragraphs.length)){_context3.next=60;break;}_context3.next=57;return _this.highlightRight(wordIndex);case 57:wordIndex+=1;_context3.next=60;return _this.playSound("click");case 60:e.stopImmediatePropagation();_context3.next=63;return _this.calculateScore();case 63:_context3.next=65;return _this.setState({wordIndex:wordIndex});case 65:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref3.apply(this,arguments);};}();_this.handleLogout=function(){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].logout().then(function(response){localStorage.removeItem('token');localStorage.clear();_this.props.history.push("/login");},function(error){console.log('Error',error);localStorage.removeItem('token');localStorage.clear();_this.props.history.push("/login");});};_this.deleteScoreConfirm=function(confirm){if(confirm){_this.deleteScore();}_this.setState({modalDialogDelete:false});};_this.handleStudentClick=function(student,classId){_this.props.updateStudent(student);_this.props.history.push('/teacher/student');};_this.state={bestScores:null,gradeStart:null,storyPrompt1:'',storyPrompt2:'',storyStarter:{},studentResponse:'',score:0,correct:0,incorrect:0,paragraphs:[],wordIndex:0,highlighted:-1,timer:null,progressBar:{width:null},modalDialog:false,responseContent:'',modalDialogDelete:false,modalDialogNote:false,noteContent:'',handleNext:false,taskID:null,sessionData:{testId:0,gradingData:"",gradingTime:0,numberCorrect:0,numberIncorrect:0},analytics:{type:null,metadata:null},spelling:[]};_this.startGrading=_this.startGrading.bind(_this);_this.submitWordMark2SessionGrade=_this.submitWordMark2SessionGrade.bind(_this);_this.initializeData=_this.initializeData.bind(_this);_this.calculateScore=_this.calculateScore.bind(_this);_this.mouseClick=_this.mouseClick.bind(_this);_this.wrongTickMark=_this.wrongTickMark.bind(_this);_this.correctTickMark=_this.correctTickMark.bind(_this);_this.showCurrentMark=_this.showCurrentMark.bind(_this);_this.fillWithChecks=_this.fillWithChecks.bind(_this);_this.clearCounters=_this.clearCounters.bind(_this);_this.keyDownListener=_this.keypress.bind(_this);_this.highlightLeft=_this.highlightLeft.bind(_this);_this.highlightRight=_this.highlightRight.bind(_this);_this.deleteScore=_this.deleteScore.bind(_this);_this.handleTakeANote=_this.handleTakeANote.bind(_this);_this.saveNote=_this.saveNote.bind(_this);_this.deleteNote=_this.deleteNote.bind(_this);_this.handleNoteClose=_this.handleNoteClose.bind(_this);_this.handleNoteContentChange=_this.handleNoteContentChange.bind(_this);_this.checkSpelling=_this.checkSpelling.bind(_this);_this.handleStudentClick=_this.handleStudentClick.bind(_this);_this.handleNextTask=_this.handleNextTask.bind(_this);_this.handleAnalytics=_this.handleAnalytics.bind(_this);_this.handleSurveyBack=_this.handleSurveyBack.bind(_this);return _this;}_createClass(WordMark2Grading,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener("keydown",this.keyDownListener);}},{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _this3=this;var parsed;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:__WEBPACK_IMPORTED_MODULE_4__Shared_Helpers__["a" /* default */].authorize(this);parsed=__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.parse(this.props.location.search);_context4.next=4;return this.setState({testId:parsed.testId,gradeStart:Date.now(),analytics:{type:__WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__["a" /* TRACKING */].WM_SCORE_VIEW,metadata:{testId:parsed.testId}}});case 4:this.startGrading(parsed.testId);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].getStudentNotifications().then(function(res){for(var i=0;i<res.body.length;i++){for(var j=0;j<res.body[i].apps.wordMark2Scores.length;j++){var wordMark2Scores=res.body[i].apps.wordMark2Scores[j];if(wordMark2Scores&&wordMark2Scores.userId===_this3.props.lastStudent.user.id&&wordMark2Scores.id!=parsed.testId){_this3.setState({handleNext:true,taskID:wordMark2Scores.id});}}}});this.handleAnalytics();document.addEventListener("keydown",this.keyDownListener);case 8:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'handleAnalytics',value:function handleAnalytics(){var analytics=this.state.analytics;__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].addAnalytics(analytics).then(function(res){});}},{key:'handleNextTask',value:function handleNextTask(){window.location.href='/teacher/apps/wm2-grading?testId='+this.state.taskID;}},{key:'submitWordMark2SessionGrade',value:function submitWordMark2SessionGrade(event){var _this4=this;var gradingData="";for(var i=0;i<this.state.paragraphs.length;i++){if(this.state.paragraphs[i].alt===""){gradingData=gradingData+"0";}else if(this.state.paragraphs[i].alt==="wrong"){gradingData=gradingData+"2";}else{gradingData=gradingData+"1";}if(i!==this.state.paragraphs.length-1){gradingData=gradingData+",";}}this.setState({sessionData:{testId:this.state.testId,gradingData:gradingData,gradingTime:Math.ceil((Date.now()-this.state.gradeStart)/1000),numberCorrect:this.state.correct,numberIncorrect:this.state.incorrect}},function(){console.log("Submitting session data: ",_this4.state.sessionData);__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].gradeWordMark2Session(_this4.state.sessionData).then(function(res){if(res.success){_this4.setState({modalDialog:true,responseContent:'Score task saved.',analytics:{type:__WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__["a" /* TRACKING */].WM_SCORE_SAVE,metadata:{testId:_this4.state.testId}}});_this4.handleAnalytics();setTimeout(function(){_this4.setState({modalDialog:false});},3500);}else{_this4.setState({modalDialog:true,responseContent:'Grading Failed to update'});setTimeout(function(){_this4.setState({modalDialog:false});},3500);}}).catch(function(err){console.log(err);_this4.setState({modalDialog:true,responseContent:'Grading Failed to update'});setTimeout(function(){_this4.setState({modalDialog:false});},3500);});});}},{key:'wrongTickMark',// functions to add tick icons
value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(index,current){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(current){this.state.paragraphs[index].src=__webpack_require__(389);}else{this.state.paragraphs[index].src=__webpack_require__(390);}this.state.paragraphs[index].alt="wrong";this.state.incorrect=this.state.incorrect+1;_context5.next=5;return this.forceUpdate();case 5:case'end':return _context5.stop();}}},_callee5,this);}));function wrongTickMark(_x4,_x5){return _ref5.apply(this,arguments);}return wrongTickMark;}()},{key:'correctTickMark',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(index,current){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(current){this.state.paragraphs[index].src=__webpack_require__(391);}else{this.state.paragraphs[index].src=__webpack_require__(392);}this.state.paragraphs[index].alt="correct";this.state.correct=this.state.correct+1;_context6.next=5;return this.forceUpdate();case 5:case'end':return _context6.stop();}}},_callee6,this);}));function correctTickMark(_x6,_x7){return _ref6.apply(this,arguments);}return correctTickMark;}()},{key:'showCurrentMark',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(index,current){var imgAlt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:imgAlt=this.state.paragraphs[index].alt;console.log('showCurrentMark');console.log(index);console.log(this.state.paragraphs[index].alt);console.log(current);if(imgAlt==="correct"){if(current){this.state.paragraphs[index].src=__webpack_require__(391);}else{this.state.paragraphs[index].src=__webpack_require__(392);}}else if(imgAlt==="wrong"){if(current){this.state.paragraphs[index].src=__webpack_require__(389);}else{this.state.paragraphs[index].src=__webpack_require__(390);}}else{if(current){this.state.paragraphs[index].src=__webpack_require__(891);}else{this.state.paragraphs[index].src="";}}_context7.next=8;return this.forceUpdate();case 8:return _context7.abrupt('return',imgAlt);case 9:case'end':return _context7.stop();}}},_callee7,this);}));function showCurrentMark(_x8,_x9){return _ref7.apply(this,arguments);}return showCurrentMark;}()},{key:'removeMark',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(index){var imgAlt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:imgAlt=this.state.paragraphs[index].alt;if(imgAlt==="correct"){this.state.correct=this.state.correct-1;this.state.paragraphs[index].src="";this.state.paragraphs[index].alt="";}else if(imgAlt==="wrong"){this.state.incorrect=this.state.incorrect-1;this.state.paragraphs[index].src="";this.state.paragraphs[index].alt="";}_context8.next=4;return this.forceUpdate();case 4:return _context8.abrupt('return',imgAlt);case 5:case'end':return _context8.stop();}}},_callee8,this);}));function removeMark(_x10){return _ref8.apply(this,arguments);}return removeMark;}()},{key:'swapMark',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(index){var oldImgAlt;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:oldImgAlt=this.removeMark(index);if(!(oldImgAlt==="correct")){_context9.next=6;break;}_context9.next=4;return this.wrongTickMark(index,false);case 4:_context9.next=9;break;case 6:if(!(oldImgAlt==="wrong")){_context9.next=9;break;}_context9.next=9;return this.correctTickMark(index,false);case 9:case'end':return _context9.stop();}}},_callee9,this);}));function swapMark(_x11){return _ref9.apply(this,arguments);}return swapMark;}()},{key:'calculateScore',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){var newScore;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:newScore=parseInt(this.state.correct,10)-parseInt(this.state.incorrect,10);if(newScore<=0){this.state.score=0;}else{this.state.score=newScore;}_context10.next=4;return this.forceUpdate();case 4:case'end':return _context10.stop();}}},_callee10,this);}));function calculateScore(){return _ref10.apply(this,arguments);}return calculateScore;}()},{key:'clearCounters',value:function clearCounters(){//$("#data img").remove();
this.setState({endIndex:0,score:0,correct:0,incorrect:0,highlighted:-1});this.state.paragraphs.map(function(paragraph,i){paragraph.src="";paragraph.alt="";paragraph.highlighted=false;});this.forceUpdate();}},{key:'mouseClick',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(i,e){var c,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,p;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:c=0;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context11.prev=4;for(_iterator=this.state.paragraphs[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){p=_step.value;p.highlighted=c===i;this.showCurrentMark(c,false);c++;}_context11.next=12;break;case 8:_context11.prev=8;_context11.t0=_context11['catch'](4);_didIteratorError=true;_iteratorError=_context11.t0;case 12:_context11.prev=12;_context11.prev=13;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 15:_context11.prev=15;if(!_didIteratorError){_context11.next=18;break;}throw _iteratorError;case 18:return _context11.finish(15);case 19:return _context11.finish(12);case 20:_context11.next=22;return this.forceUpdate();case 22:if(!e){_context11.next=27;break;}_context11.next=25;return this.removeMark(i);case 25:_context11.next=27;return this.calculateScore();case 27:_context11.next=29;return this.highlightLeft(i);case 29:case'end':return _context11.stop();}}},_callee11,this,[[4,8,12,20],[13,,15,19]]);}));function mouseClick(_x12,_x13){return _ref11.apply(this,arguments);}return mouseClick;}()},{key:'fillWithChecks',value:function fillWithChecks(){var imgAlt=void 0;for(var i=0;i<this.state.endIndex;i++){imgAlt=this.state.paragraphs[i].alt;if(imgAlt===""){this.correctTickMark(i);}}this.calculateScore();}},{key:'checkSpelling',value:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){var newParagraphs,i,test;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:newParagraphs=[];for(i=0;i<this.state.paragraphs.length;i++){test=this.state.spelling.includes(this.state.paragraphs[i].word);this.state.paragraphs[i].spellCheck=test;newParagraphs.push(this.state.paragraphs[i]);}this.setState({paragraphs:newParagraphs});case 3:case'end':return _context12.stop();}}},_callee12,this);}));function checkSpelling(){return _ref12.apply(this,arguments);}return checkSpelling;}()},{key:'initializeData',value:function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){var csv,tickArr,text,wordArr,i,word,newPar,regxPunctuation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:csv=this.state.sessionData.gradingData;tickArr=[];if(csv){tickArr=csv.split(",");}text=this.state.studentResponse;// Trim out new lines
text=text.trim();// Add space for certain characters and trim out new lines
text=text.replace(/\./g," . ").replace(/\?/g," ?").replace(/!/g," !").trim();// Convert text to word array by splitting at spaces
text=text.replace(/\s+([])\s+|\s+([])|([])+\s|([])/gm," $1$2$3$4 ");if(text[text.length-1]===" "){text=text.substr(0,text.length-1);}wordArr=text.split(/\s+/);// Ensures the tick array has its
// length equal to the word count
while(tickArr.length>wordArr.length){tickArr.pop();}while(tickArr.length<wordArr.length){tickArr.push("0");}// Create elements for each word and appends to container in order
i=0;case 12:if(!(i<wordArr.length)){_context13.next=30;break;}word=wordArr[i];newPar={index:i,word:word,src:"",alt:"",highlighted:false};_context13.next=17;return this.setState({paragraphs:[].concat(_toConsumableArray(this.state.paragraphs),[newPar])});case 17:if(!(tickArr[i]==="1")){_context13.next=23;break;}_context13.next=20;return this.correctTickMark(i,false);case 20:this.state.endIndex=i;_context13.next=27;break;case 23:if(!(tickArr[i]==="2")){_context13.next=27;break;}_context13.next=26;return this.wrongTickMark(i,false);case 26:this.state.endIndex=i;case 27:i++;_context13.next=12;break;case 30:// Calculates initial score
this.forceUpdate();this.calculateScore();// Display the total word count
regxPunctuation=/[]/g;this.state.totalWords=wordArr.filter(function(value){return!value.match(regxPunctuation);}).length;_context13.next=36;return this.forceUpdate();case 36:this.mouseClick(0);case 37:case'end':return _context13.stop();}}},_callee13,this);}));function initializeData(){return _ref13.apply(this,arguments);}return initializeData;}()},{key:'playSound',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(type){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:if(!(this.audioCorrect.muted===false)){_context14.next=4;break;}_context14.next=3;return this.audioCorrect.pause();case 3:this.audioCorrect.currentTime=0;case 4:if(!(this.audioSwipe.muted===false)){_context14.next=8;break;}_context14.next=7;return this.audioSwipe.pause();case 7:this.audioSwipe.currentTime=0;case 8:if(!(this.audioWrong.muted===false)){_context14.next=12;break;}_context14.next=11;return this.audioWrong.pause();case 11:this.audioWrong.currentTime=0;case 12:if(!(this.audioCorrect.muted===false||this.audioWrong.muted===false||this.audioSwipe===false)){_context14.next=25;break;}_context14.t0=type;_context14.next=_context14.t0==="correct"?16:_context14.t0==="wrong"?19:_context14.t0==="click"?22:25;break;case 16:_context14.next=18;return this.audioCorrect.play();case 18:return _context14.abrupt('break',25);case 19:_context14.next=21;return this.audioWrong.play();case 21:return _context14.abrupt('break',25);case 22:_context14.next=24;return this.audioSwipe.play();case 24:return _context14.abrupt('break',25);case 25:case'end':return _context14.stop();}}},_callee14,this);}));function playSound(_x14){return _ref14.apply(this,arguments);}return playSound;}()},{key:'highlightRight',value:function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(i){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:this.state.wordIndex=i;if(this.state.paragraphs[i-1]){this.state.paragraphs[i-1].highlighted=false;}if(this.state.paragraphs[i+1]){this.state.paragraphs[i+1].highlighted=true;}if(i===this.state.paragraphs.length-1){this.state.paragraphs[i].highlighted=false;}_context15.next=6;return this.showCurrentMark(i,false);case 6:if(!this.state.paragraphs[i+1]){_context15.next=9;break;}_context15.next=9;return this.showCurrentMark(i+1,true);case 9:_context15.next=11;return this.forceUpdate();case 11:case'end':return _context15.stop();}}},_callee15,this);}));function highlightRight(_x15){return _ref15.apply(this,arguments);}return highlightRight;}()},{key:'highlightLeft',value:function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(i){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:this.state.wordIndex=i;if(i===this.state.paragraphs.length-1){this.state.paragraphs[i].highlighted=true;}if(this.state.paragraphs[i-1]){this.state.wordIndex=i-1;this.state.paragraphs[i-1].highlighted=true;}if(this.state.paragraphs[i+1]){this.state.paragraphs[i+1].highlighted=false;}console.log('mark i');console.log(i);_context16.next=8;return this.showCurrentMark(i,true);case 8:if(!this.state.paragraphs[i+1]){_context16.next=11;break;}_context16.next=11;return this.showCurrentMark(i+1,false);case 11:_context16.next=13;return this.forceUpdate();case 13:case'end':return _context16.stop();}}},_callee16,this);}));function highlightLeft(_x16){return _ref16.apply(this,arguments);}return highlightLeft;}()// Event handler for keypress events
},{key:'deleteScore',value:function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return __WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].deleteWordMark2Score(this.state.testId).then(function(res){_this5.props.history.goBack();});case 2:case'end':return _context17.stop();}}},_callee17,this);}));function deleteScore(){return _ref17.apply(this,arguments);}return deleteScore;}()},{key:'handleTakeANote',value:function handleTakeANote(){console.log("take a note");this.setState({modalDialogNote:true});}},{key:'handleNoteContentChange',value:function handleNoteContentChange(event){this.setState({noteContent:event.target.value});event.preventDefault();}},{key:'saveNote',value:function saveNote(){__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWordMark2Note({testId:this.state.testId,note:this.state.noteContent});this.setState({modalDialogNote:false});}},{key:'deleteNote',value:function deleteNote(){this.setState({noteContent:''});__WEBPACK_IMPORTED_MODULE_3__Shared_REST__["a" /* default */].updateWordMark2Note({testId:this.state.testId,note:''});}},{key:'handleNoteClose',value:function handleNoteClose(){this.setState({modalDialogNote:false});}},{key:'handleSurveyBack',value:function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:case'end':return _context18.stop();}}},_callee18,this);}));function handleSurveyBack(){return _ref18.apply(this,arguments);}return handleSurveyBack;}()},{key:'render',value:function render(){var _this6=this;var paragraphs=this.state.paragraphs.map(function(paragraph,i){var spellCheck=paragraph.spellCheck?" spellcheck ":"";var highLightSelect=paragraph.highlighted?" highlightSelect":"";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{key:i,className:spellCheck+highLightSelect,onClick:function onClick(e){return _this6.mouseClick(i,e);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{hidden:paragraph.alt==="",style:{left:"-5px"},src:paragraph.src,alt:paragraph.alt}),paragraph.word);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container-fluid bgGrey",style:{paddingLeft:0,paddingRight:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__["a" /* default */],{notificationModal:true,modalOpen:this.state.modalDialog,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_DialogBox__["a" /* default */],{surveyModal:true,role:'teacher',app:'WMGrading',userId:this.props.user.id,active:true,surveyBack:this.handleSurveyBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_DeleteDialogBox__["a" /* default */],{confirmDelete:this.deleteScoreConfirm,modalOpen:this.state.modalDialogDelete,sectionContent:this.state.responseContent,closeClick:function closeClick(active){_this6.setState({modalDialog:active});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["a" /* Modal */],{id:'dialogBox',show:this.state.modalDialogNote},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"row modal-body"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{style:{paddingTop:0,marginTop:-10,marginBottom:15}},'Make a Note'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{style:{width:500},onChange:this.handleNoteContentChange,value:this.state.noteContent,placeholder:"please enter your note here"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section',style:{marginTop:-40}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.deleteNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{style:{float:'left'},onClick:this.saveNote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Close'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block",style:{maxWidth:'100%',marginTop:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-4"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_images_logo_wordmark2_png___default.a,alt:"Word Mark",style:{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}),' ',this.props.lastStudent.user.firstname,' ',this.props.lastStudent.user.lastname)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-sm-8"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"navbar"},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ModalFormComponents_ReportBugForm__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_DropDownNotifications__["a" /* default */],Object.assign({studentClick:this.handleStudentClick},this.props)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12 noPaddingLR'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"container",style:{position:'relative',minHeight:'calc(100vh - 88px)',height:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'center',marginTop:0,width:1000}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row',style:{fontFamily:'Open Sans',fontSize:'1.50em',fontWeight:'bold',textTransform:'uppercase'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'"',this.state.storyPrompt1,'" And "',this.state.storyPrompt2,'"'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"center-block",style:{maxWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'appContainer',className:"col-md-12 ksGradingContainer newGradingClass",style:{backgroundColor:'#FFF',backgroundImage:'initial'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'whitebox',className:"newGradingClass"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'data',className:"col-md-12 newGradingClass",style:{overflowY:'auto',maxHeight:350}},paragraphs),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'options',className:"newGradingClass col-md-12",style:{marginBottom:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 bgGrey",style:{padding:15}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{alt:'correct',src:__webpack_require__(93),style:{position:'relative',top:-25,left:50}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Correct'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'correct',className:'backgroundGradeCountBox'},this.state.correct)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{alt:'incorrect',src:__webpack_require__(208),style:{position:'relative',top:-25,left:60}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Incorrect'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'',className:"backgroundGradeCountBox"},this.state.incorrect)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Total Words'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'',className:"backgroundGradeCountBox"},this.state.totalWords)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fontSizeCalculationGrading calculationLabelPosition'},'Score'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'score',className:'backgroundGradeCountBox'},this.state.score)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'spelling',className:'fontSizeCalculationGrading',style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{borderBottom:'2px solid #fc0',position:'relative',top:3}},'Possible Spelling Error'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{hidden:true,onClick:this.fillWithChecks,type:'image',id:'auto_correct',src:__webpack_require__(388)})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{src:"/sounds/correct.mp3",ref:function ref(audio){return _this6.audioCorrect=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{src:"/sounds/correct.mp3",ref:function ref(audio){return _this6.audioWrong=audio;}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{src:"/sounds/swipe2.mp3",ref:function ref(audio){return _this6.audioSwipe=audio;}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-md-12 noPaddingLR",style:{marginTop:30}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-lg-4 col-xs-3 col-md-3 noPaddingLR"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return _this6.setState({analytics:{type:__WEBPACK_IMPORTED_MODULE_15__Shared_DataTrackingPoints__["a" /* TRACKING */].WM_SCORE_EXIT,metadata:{testId:_this6.state.testId}}});case 2:_this6.handleAnalytics();_this6.props.history.push('../student');case 4:case'end':return _context19.stop();}}},_callee19,_this6);})),className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Exit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"col-lg-8 col-xs-9 col-md-9 noPaddingLR",style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleNextTask,className:'handBtn',style:{display:this.state.handleNext?'inline-block':'none'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Next Task')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.handleTakeANote,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Make a Note')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.submitWordMark2SessionGrade,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:this.clearCounters,className:'handBtn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Reset Grading')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onClick:function onClick(){_this6.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TASK?'});},className:'handBtn',style:{marginRight:0}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Delete')))))));}}]);return WordMark2Grading;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var actionToProps=function actionToProps(dispatch){return{updateStudent:function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(student){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["h" /* updateStudent */])(student));case 2:return _context20.abrupt('return',_context20.sent);case 3:case'end':return _context20.stop();}}},_callee20,_this7);}));function updateStudent(_x17){return _ref20.apply(this,arguments);}return updateStudent;}()};};var mapStateToProps=function mapStateToProps(state){return{lastStudent:state.teacherReducer.student};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps,actionToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(WordMark2Grading)));

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAhGVYSWZNTQAqAAAACAAFARIAAwAAAAEAAQAAARoABQAAAAEAAABKARsABQAAAAEAAABSASgAAwAAAAEAAgAAh2kABAAAAAEAAABaAAAAAAAAAEgAAAABAAAASAAAAAEAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAADwAAAABzqn1JAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgICAgICAgICAgeG1sbnM6ZXhpZj0iaHR0cDovL25zLmFkb2JlLmNvbS9leGlmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICAgICA8dGlmZjpSZXNvbHV0aW9uVW5pdD4yPC90aWZmOlJlc29sdXRpb25Vbml0PgogICAgICAgICA8ZXhpZjpDb2xvclNwYWNlPjE8L2V4aWY6Q29sb3JTcGFjZT4KICAgICAgICAgPGV4aWY6UGl4ZWxYRGltZW5zaW9uPjE0PC9leGlmOlBpeGVsWERpbWVuc2lvbj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjE1PC9leGlmOlBpeGVsWURpbWVuc2lvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CrBVAIkAAAAgSURBVCgVY7x8+fJ/BjIAExl6wFpGNeIJudHAGR6BAwDC7wOWQp/q9AAAAABJRU5ErkJggg=="

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_persist__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_thunk__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__(904);
var migrations={0:function _(state){window.localStorage.clear();}};var persistConfig={key:'root',version:0,storage:__WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_storage___default.a,migrate:Object(__WEBPACK_IMPORTED_MODULE_1_redux_persist__["a" /* createMigrate */])(migrations)};var persistedReducer=Object(__WEBPACK_IMPORTED_MODULE_1_redux_persist__["b" /* persistReducer */])(persistConfig,__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (function(){var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(persistedReducer,{},Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_3_redux_thunk__["a" /* default */]));var persistor=Object(__WEBPACK_IMPORTED_MODULE_1_redux_persist__["c" /* persistStore */])(store);return{store:store,persistor:persistor};});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__persistReducer__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__persistReducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistCombineReducers__ = __webpack_require__(895);
/* unused harmony reexport persistCombineReducers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__persistStore__ = __webpack_require__(897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__persistStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createMigrate__ = __webpack_require__(898);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__createMigrate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransform__ = __webpack_require__(899);
/* unused harmony reexport createTransform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getStoredState__ = __webpack_require__(394);
/* unused harmony reexport getStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createPersistoid__ = __webpack_require__(393);
/* unused harmony reexport createPersistoid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__purgeStoredState__ = __webpack_require__(395);
/* unused harmony reexport purgeStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(77);
/* unused harmony namespace reexport */











/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel1;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      // otherwise hard set the new value
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__ = __webpack_require__(896);




// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__["a" /* default */] : config.stateReconciler;
  return Object(__WEBPACK_IMPORTED_MODULE_1__persistReducer__["a" /* default */])(config, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(reducers));
}

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel2;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _extends({}, newState[key], inboundState[key]);
        return;
      }
      // otherwise hard set
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
}

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(77);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */]:
      return _extends({}, state, { registry: [].concat(_toConsumableArray(state.registry), [action.key]) });
    case __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */]:
      var firstIndex = state.registry.indexOf(action.key);
      var registry = [].concat(_toConsumableArray(state.registry));
      registry.splice(firstIndex, 1);
      return _extends({}, state, { registry: registry, bootstrapped: registry.length === 0 });
    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) {
    var optionsToTest = options || {};
    var bannedKeys = ['blacklist', 'whitelist', 'transforms', 'storage', 'keyPrefix', 'migrate'];
    bannedKeys.forEach(function (k) {
      if (!!optionsToTest[k]) console.error('redux-persist: invalid option passed to persistStore: "' + k + '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.');
    });
  }
  var boostrappedCb = cb || false;

  var _pStore = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(persistorReducer, initialState, options ? options.enhancer : undefined);
  var register = function register(key) {
    _pStore.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */],
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */],
      payload: payload,
      err: err,
      key: key
      // dispatch to `store` to rehydrate and `persistor` to track result
    };store.dispatch(rehydrateAction);
    _pStore.dispatch(rehydrateAction);
    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = _extends({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* PURGE */],
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* FLUSH */],
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* PAUSE */]
      });
    },
    persist: function persist() {
      store.dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PERSIST */], register: register, rehydrate: rehydrate });
    }
  });

  persistor.persist();

  return persistor;
}

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMigrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(77);


function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) console.log('redux-persist: no inbound state, skipping migration');
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
    if (inboundVersion === currentVersion) {
      if (false) console.log('redux-persist: versions match, noop migration');
      return Promise.resolve(state);
    }
    if (inboundVersion > currentVersion) {
      if (false) console.error('redux-persist: downgrading version is not supported');
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });

    if (false) console.log('redux-persist: migrationKeys', migrationKeys);
    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) console.log('redux-persist: running migration for versionKey', versionKey);
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */


function createTransform(
// @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound,
// @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createWebStorage = __webpack_require__(901);

var _createWebStorage2 = _interopRequireDefault(_createWebStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createWebStorage2.default)('local');

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createWebStorage;

var _getStorage = __webpack_require__(902);

var _getStorage2 = _interopRequireDefault(_getStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage2.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getStorage;


function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === 'undefined' ? 'undefined' : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function getStorage(type) {
  var storageType = type + 'Storage';
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {
      console.error('redux-persist failed to create sync storage. falling back to memory storage.');
    }
    return noopStorage;
  }
}

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TeachersComponent_reducers__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StudentsComponent_reducers__ = __webpack_require__(906);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({teacherReducer:__WEBPACK_IMPORTED_MODULE_1__TeachersComponent_reducers__["a" /* default */],studentReducer:__WEBPACK_IMPORTED_MODULE_2__StudentsComponent_reducers__["a" /* default */]}));

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState={student:null,teacher:null,schoolAdmin:null,chartData:null,chartRules:{growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],maxLevel:12,showScore:false,isTeacher:true},xLabel:"Weeks",yLabel:"Levels",updateNote:null,lastClass:null,lastTeacher:null,lastSchool:null,studentTab:1,studentScoreListTab:0,appName:""};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case"UPDATE_STUDENT":return Object.assign({},state,{student:action.student});case"UPDATE_TEACHER":return Object.assign({},state,{teacher:action.teacher});case"UPDATE_SCHOOL_ADMIN":return Object.assign({},state,{schoolAdmin:action.schoolAdmin});case"UPDATE_CHART_DATA":return Object.assign({},state,{chartData:action.chartData,chartRules:action.chartRules,xLabel:action.xLabel,yLabel:action.yLabel});case"UPDATE_FUNCTION_UPDATE_NOTE":return Object.assign({},state,{updateNote:action.updateNote});case"UPDATE_APPNAME":return Object.assign({},state,{appName:action.appName});case"SELECT_CLASS":return Object.assign({},state,{lastClass:action.lastClass});case"SELECT_TEACHER":return Object.assign({},state,{lastTeacher:action.lastTeacher});case"SELECT_SCHOOL":return Object.assign({},state,{lastSchool:action.lastSchool});case"SELECT_STUDENT_TAB":return Object.assign({},state,{studentTab:action.studentTab});case"SELECT_SCORELIST_TAB":return Object.assign({},state,{studentScoreListTab:action.studentScoreListTab});case"LOGOUT":return Object.assign({},state,initialState);default:return state;}});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState={student:null,parent:null,studentUser:null,chartData:null,chartRules:{growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],maxLevel:12,showScore:false,isTeacher:false},xLabel:"Weeks",yLabel:"Levels",appName:"",tabNum:1,firstLogin:false,apps:{bestScores:null,pictureNamingScores:[],kidSpeakScores:[],kidSignScores:[],wordSignSayScores:[],copyRightScores:[],wordMarkScores:[]},appStates:{allowedApps:[],filteredApps:[],finishedApps:[]}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case"UPDATE_STUDENT":return Object.assign({},state,{student:action.student});case"UPDATE_PARENT":return Object.assign({},state,{parent:action.parent});case"UPDATE_STUDENT_USER":return Object.assign({},state,{studentUser:action.studentUser});case"UPDATE_TEACHER":return Object.assign({},state,{teacher:action.teacher});case"UPDATE_FIRST_LOGIN":return Object.assign({},state,{firstLogin:action.firstLogin});case"UPDATE_CHART_DATA":return Object.assign({},state,{chartData:action.chartData,chartRules:action.chartRules,xLabel:action.xLabel,yLabel:action.yLabel});case"UPDATE_FUNCTION_UPDATE_NOTE":return Object.assign({},state,{updateNote:action.updateNote});case"UPDATE_APPNAME":return Object.assign({},state,{appName:action.appName});case"SELECT_CLASS":return Object.assign({},state,{lastClass:action.lastClass});case"SELECT_STUDENT_TAB":return Object.assign({},state,{studentTab:action.studentTab});case"SELECT_SCORELIST_TAB":return Object.assign({},state,{studentScoreListTab:action.studentScoreListTab});case"LOGOUT":return Object.assign({},state,initialState);case"UPDATE_STUDENT_APPS_STATUS":return Object.assign({},state,{apps:action.apps});case"UPDATE_STUDENT_ACCOUNT_TAB":return Object.assign({},state,{tabNum:action.tabNum});case"UPDATE_STUDENT_APP_STATES":return Object.assign({},state,{appStates:action.appStates});default:return state;}});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersistGate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

 // eslint-disable-line import/no-unresolved
// eslint-disable-line import/no-unresolved


var PersistGate = function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      bootstrapped: false
    }, _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).then(function () {
            return _this.setState({ bootstrapped: true });
          }).catch(function () {
            return _this.setState({ bootstrapped: true });
          });
        } else {
          _this.setState({ bootstrapped: true });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PersistGate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      if (false) {
        if (typeof this.props.children === 'function' && this.props.loading) console.error('redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.');
      }
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
PersistGate.defaultProps = {
  loading: null
};

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');window.location.reload();}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.57b6acb9.js